/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["__diyeditor__webpackJsonp"];
/******/ 	window["__diyeditor__webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/ 			script.crossOrigin = 'anonymous';
/******/ 			script.src = __webpack_require__.p + "" + ({"2":"layoutSelector","3":"theming","6":"guidance","7":"phoneRequest"}[chunkId]||chunkId) + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
// This is a webpack preprocessing instruction, it is not a real variable
__webpack_require__.p = diy.editor.jsBaseUrl;
var App_1 = __webpack_require__(1);
(new App_1.App()).init();


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var integration_1 = __webpack_require__(2);
var AutoLayerManager_1 = __webpack_require__(678);
var ImportProcedure_1 = __webpack_require__(680);
var webcomponentUpsell_1 = __webpack_require__(557);
var webcomponentPageNotification_1 = __webpack_require__(705);
var features = __webpack_require__(25);
var StoreProvider_1 = __webpack_require__(231);
var MomentsToCelebrate_1 = __webpack_require__(710);
var websiteData = __webpack_require__(4);
var AppRegistry_1 = __webpack_require__(190);
var ModuleActionBar = __webpack_require__(536);
var SiteAdmin = __webpack_require__(714);
var Overlay = __webpack_require__(198);
var ModuleSectionApp = __webpack_require__(499);
var Module = __webpack_require__(494);
var $ = __webpack_require__(3);
var Api_1 = __webpack_require__(715);
var App_1 = __webpack_require__(842);
var App_2 = __webpack_require__(645);
var App_3 = __webpack_require__(857);
var App_4 = __webpack_require__(858);
var App_5 = __webpack_require__(859);
var App_6 = __webpack_require__(860);
var Manager_1 = __webpack_require__(861);
var Factory_1 = __webpack_require__(862);
var moduleSelector_1 = __webpack_require__(10);
var Api_2 = __webpack_require__(537);
var Poller_1 = __webpack_require__(558);
var Type_1 = __webpack_require__(540);
var bsaEvents = __webpack_require__(838);
var injectTapEventPlugin = __webpack_require__(864);
var SiteAdminApi = __webpack_require__(19);
var App = (function () {
    function App() {
    }
    App.prototype.init = function () {
        var _this = this;
        // This uses the history manager to react to a certain location hash.
        // The history manager will use hashes in the form #hm:<element>:<event>
        // to trigger the indicated event on the indicated element id. Therefore
        // we create a dummy element by the name of our choice and a bogus event
        // to set up a desired reaction.
        // FIXME: move this to its own component.
        $(function () {
            $('<div/>')
                .attr('id', 'cc-og-step')
                .on('online-business-card', function () {
                // open the onboarding guide siteadmin entry with a parameter
                // that will override the default step selected when it opens
                SiteAdminApi.triggerMenuItem('cc-sa-item-onboardingguide', { jumpToStep: "vcard" });
            })
                .on('click', function () {
                // open the onboarding guide siteadmin entry without parameters,
                // meaning that the onboarding guide app will decide which step
                // to select based on its current internal logic
                SiteAdminApi.triggerMenuItem('cc-sa-item-onboardingguide');
            })
                .appendTo($(document.body));
        });
        bsaEvents.attachEvents();
        injectTapEventPlugin();
        var storeProvider = new StoreProvider_1.default();
        var resourceManager = new Manager_1.default(new Factory_1.default);
        AppRegistry_1.default
            .setStoreProvider(storeProvider)
            .setResourceManager(resourceManager);
        this.api = new Api_1.Api(this);
        this.api.init();
        this.vCardEditor = new integration_1.default;
        __webpack_require__(870);
        __webpack_require__(878);
        __webpack_require__(883);
        if (jimdoData.personaTrackingEnabled) {
            __webpack_require__(885);
        }
        // Site-admin
        var siteAdmin = __webpack_require__(20);
        $(function () {
            siteAdmin.init();
            // initialize site admin redux state management
            SiteAdmin.init(storeProvider);
        });
        // Auto Layer Manager
        var WAITING_TIME_AFTER_PAGELOAD = 5000;
        this.layerManager = new AutoLayerManager_1.default();
        $(document).ready(function () {
            setTimeout(function () { return _this.layerManager.unblockAndProcessQueue(); }, WAITING_TIME_AFTER_PAGELOAD);
        });
        // Notification center
        var notificationApp = new App_2.App();
        if (!features('notificationsNG')) {
            notificationApp.initApi();
        }
        // Toolbar
        var toolbarApp = new App_1.App(this.vCardEditor);
        $(document).ready(function () {
            toolbarApp.init();
            $(document).bind('diy-maintenance-mode-show', function () { return toolbarApp.showPublishDialog(); });
            _this.vCardEditor.setToolbar(toolbarApp.getToolbar());
            _this.vCardEditor.init();
            $(document).bind('diy-maintenance-mode-edit', function () {
                _this.vCardEditor.open({ context: "onboardingGuide" });
            });
            if (features('notificationsNG')) {
                Api_2.default.init(storeProvider, toolbarApp);
                Poller_1.default.init(storeProvider);
                // Notification launching the "No Domain" module
                var domainPromoApp = new App_3.App();
                domainPromoApp.init();
                // Notification launching the Chat
                var chatApp = new App_4.App();
                chatApp.init();
                // Browser Upgrade Notification
                var browserUpgradeApp = new App_5.App();
                browserUpgradeApp.init();
                // Not Published Notification
                var notPublishedApp = new App_6.App();
                notPublishedApp.init();
            }
            else {
                notificationApp.setToolbar(toolbarApp.getToolbar());
                notificationApp.setLayerManager(_this.layerManager);
                notificationApp.init();
            }
        });
        // Undo redo
        var UndoRedo = __webpack_require__(887);
        this.api.initUndoRedoApi(UndoRedo.startApi());
        $(document).ready(function () {
            UndoRedo.onReady(jimdoData.features, toolbarApp.getToolbar());
        });
        // XXX Chat is also used in help iframe with global namespace
        if (features('chat1and1')) {
            __webpack_require__(926);
        }
        if (features('chatYalst')) {
            __webpack_require__(927);
        }
        $(document).ready(function () {
            __webpack_require__(928);
        });
        //TODO: AIONDEBUG
        var momentsToCelebrate = new MomentsToCelebrate_1.default();
        $(document).bind('diy-maintenance-mode-vcard-publish', function () {
            return momentsToCelebrate.show(MomentsToCelebrate_1.CelebrationTypes.Vcard);
        });
        $(document).bind('diy-maintenance-mode-publish', function () {
            return momentsToCelebrate.show(MomentsToCelebrate_1.CelebrationTypes.Publish);
        });
        // Landscape mode
        if ((features('showTabletLandscapeInfo') && diy.editor.uiPreference.isPointerModeTouch())) {
            var landscapeMode_1 = __webpack_require__(929);
            $(function () {
                landscapeMode_1.showTabletLandscapeNotification();
            });
        }
        // Tariff Update
        var tariffUpdate = __webpack_require__(730);
        if (features('updateTariffNewRibbons') || features('orderFinalized') || features('updateTariff')) {
            tariffUpdate.setLayerManager(this.layerManager);
            tariffUpdate.init();
        }
        // Website Import (WSB / WSC)
        if (features('externalWebsiteMigration')) {
            var websiteImport_1 = new ImportProcedure_1.default();
            $(document).ready(function () {
                if (features('notificationsNG')) {
                    websiteImport_1.init(websiteData.getId());
                }
                else {
                    websiteImport_1.init(websiteData.getId(), notificationApp.getApi());
                }
            });
        }
        // Upsell
        $(document).ready(function () {
            if (!features('notificationsNG')) {
                var webcomponentUpsell = new webcomponentUpsell_1.default();
                webcomponentUpsell.setApi(notificationApp.getApi());
                for (var _i = 0, _a = jimdoData.webComponentUpsell; _i < _a.length; _i++) {
                    var webComponent = _a[_i];
                    if (webComponent['status-code'] === "INITIAL" || webComponent['status-code'] === "PROCESSING") {
                        webcomponentUpsell.startPolling(webComponent.webComponentId);
                    }
                    else if (webComponent['status-code'] === "SUCCESS") {
                        webcomponentUpsell.showNotification(webComponent);
                    }
                }
            }
        });
        // Aviary Notification
        $(document).ready(function () {
            if (features('notificationsNG')) {
                if (features('aviaryShutdown')) {
                    Api_2.default.schedule(function () {
                        Api_2.default.pushOne({
                            type: Type_1.default.AVIARY_SHUTDOWN
                        });
                    });
                }
                else {
                    Api_2.default.schedule(function () {
                        Api_2.default.deleteOne(Type_1.default.AVIARY_SHUTDOWN);
                    });
                }
            }
        });
        // File Manager
        var fileManager = __webpack_require__(930);
        fileManager.init();
        $(document).ready(function () {
            ModuleActionBar.init(storeProvider);
            Overlay.init(storeProvider);
            Module.init(storeProvider);
            ModuleSectionApp.render(storeProvider.getStore());
        });
        ModuleSectionApp.init(storeProvider);
        // Material UI initialization (for legacy code)
        // uncomment when framework really needed in legacy code
        // require('./material-ui/legacy.js');
        $(function () {
            moduleSelector_1.default.init();
        });
        var appsCatalog = __webpack_require__(11);
        appsCatalog.init();
        // Local modules (elements)
        __webpack_require__(985);
        // Use case feature (not sure if it's still used or not)
        var useCase = __webpack_require__(1141);
        $(document).ready(function () {
            useCase.init();
        });
        if (features('wbcPageNotification')) {
            var webComponentId = features
                .getPayload('wbcPageNotification')
                .webComponentId;
            if (webComponentId) {
                webcomponentPageNotification_1.showNotification(webComponentId);
            }
        }
        $(document).ready(function () {
            resourceManager.init();
        });
        // Detects a bug on IE9-11 that breaks the sitebuidler and notifies users
        __webpack_require__(1143);
    };
    return App;
}());
exports.App = App;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by gpopescu on 18.08.2015.
 */
var $ = __webpack_require__(3);
var websiteData = __webpack_require__(4);
var model_1 = __webpack_require__(6);
var deeplinking = __webpack_require__(9);
var l10n_1 = __webpack_require__(18);
var features = __webpack_require__(25);
//import {mockData} from './mockData';
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var RaisedButton_1 = __webpack_require__(482);
var CircularProgress_1 = __webpack_require__(382);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var FeedbackButton_1 = __webpack_require__(461);
var DiyFeedbackSubmit_1 = __webpack_require__(495);
var App_1 = __webpack_require__(645);
var Api_1 = __webpack_require__(537);
var Notice_1 = __webpack_require__(27);
var VCardEditor = (function () {
    function VCardEditor() {
        this.config = {
            resourcesUrl: websiteData.getData('vcard').resourcesUrl
        };
    }
    VCardEditor.prototype.init = function () {
        var _this = this;
        this.createEditorWrapper();
        this.editorContent = this.editorWrapper.find('.vcard-editor-content');
        if (!features('notificationsNG')) {
            var notificationCenter_1 = diy.editor.notifications;
            var notificationCenterApi_1 = notificationCenter_1.api;
            notificationCenterApi_1.ready(function () {
                var empNotification = notificationCenterApi_1.getNotificationsByType(notificationCenter_1.Notifications.TYPE_EMP);
                if (empNotification.length === 1) {
                    empNotification[0].setVCardEditor(_this);
                }
            });
        }
    };
    VCardEditor.prototype.setToolbar = function (toolbar) {
        this.toolbar = toolbar;
    };
    VCardEditor.prototype.createTriggerElement = function (trigger) {
        var _this = this;
        trigger.element.click(function () { return _this.open(trigger); });
    };
    VCardEditor.prototype.loadScript = function () {
        return Promise.resolve($.getScript(this.config.resourcesUrl + 'vcard.bundle.js'));
    };
    VCardEditor.prototype.startVCardClient = function () {
        var _this = this;
        this.showLoader();
        this.initClient()
            .then(function (vCardClient) {
            return _this.dataModel.load();
        })
            .then(function (data) {
            _this.vCardClient.start(_this.editorContent[0], data, {
                save: function (vCardData) { return _this.save(vCardData); },
                saveSemanticData: function (data) { return _this.saveSemanticData(data); },
                close: function () { return _this.close(); },
                error: function (reason) {
                    _this.showError('Failed to start vcard');
                },
                handleEvent: function (event) {
                    switch (event.type) {
                        case "action":
                            if (event.name === "editMyData") {
                                _this.vCardClient.save().then(function () {
                                    deeplinking.requestPath([
                                        { label: 'siteadmin', params: 'settings' },
                                        { label: 'SAC.Settings', params: 'personal-data' }
                                    ]);
                                });
                            }
                            break;
                        case "kpi":
                            var context = (_this.openTrigger && _this.openTrigger.context)
                                ? _this.openTrigger.context : undefined;
                            var instanceName = (event.data["instance"] !== undefined) ?
                                "-" + event.data["instance"] : "";
                            var visibility = (event.data["visibility"] !== undefined) ?
                                "-" + ((event.data["visibility"]) ? "true" : "false") : "";
                            _this.trackLinkEvent("" + event.name + instanceName + visibility, context);
                            break;
                        default:
                            break;
                    }
                },
                onLoad: function () {
                    var vCardActionBar = _this.editorWrapper.find('.v-action-bar')[0];
                    var vcardFeedbackButton = $('<div id="vcard-feedback-button"></div>');
                    if (vCardActionBar && !$('#vcard-feedback-button')[0]) {
                        vcardFeedbackButton.css({
                            position: 'absolute',
                            bottom: 24,
                            left: 24,
                        });
                        _this.editorWrapper.append(vcardFeedbackButton);
                        ReactDOM.render(_this.renderFeedbackButton(), vcardFeedbackButton[0]);
                    }
                    if (vCardActionBar && features('privacyNotice')) {
                        var vCardNoticeWrapper = $('<div id="vcard-privacy-policy-notice"></div>');
                        vCardNoticeWrapper.css({
                            position: 'absolute',
                            padding: '24px 16px',
                            bottom: 0,
                            left: 0,
                            fontSize: '12px'
                        });
                        _this.editorWrapper.find('.v-editor').append(vCardNoticeWrapper);
                        ReactDOM.render(_this.renderPrivacyNotice(), vCardNoticeWrapper[0]);
                    }
                    _this.hideLoader();
                    if (_this.openTrigger && _this.openTrigger.context) {
                        $(document).trigger('diy-editor-vcard-open', { source: _this.openTrigger.context });
                    }
                    if (_this.openTrigger && _this.openTrigger.openCallback) {
                        _this.openTrigger.openCallback();
                    }
                }
            }, _this.getOptions());
        })
            .catch(function (reason) {
            console.error('Failed starting vcard:', reason);
            _this.hideLoader();
            _this.showError('Failed to start vcard');
        });
    };
    VCardEditor.prototype.renderFeedbackButton = function () {
        return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(FeedbackButton_1.default, { feedbackFeatureName: "", feedbackContext: "vCard", onFeedbackSubmit: DiyFeedbackSubmit_1.DiyFeedbackSubmit, useAlternativeColors: true, anchorOrigin: { vertical: 'top', horizontal: 'right' }, targetOrigin: { vertical: 'bottom', horizontal: 'right' } })));
    };
    VCardEditor.prototype.renderPrivacyNotice = function () {
        return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(Notice_1.Notice, null)));
    };
    VCardEditor.prototype.getOptions = function () {
        return {
            locale: websiteData.getLanguageCode(),
            baseResourceUrl: this.config.resourcesUrl,
            baseUserUrl: function (uuid, format) {
                format = format || "preview";
                return '/rest/websites/' + websiteData.getId() + '/storage-files/' + uuid + '/' + format;
            }
        };
    };
    VCardEditor.prototype.open = function (trigger) {
        var _this = this;
        $(top.document.body).trigger('MaintenanceModeOpened.BSA');
        if (trigger) {
            this.openTrigger = trigger;
        }
        this.startVCardClient();
        this.positionArrow();
        if (features('notificationsNG')) {
            Api_1.default.schedule(function () {
                Api_1.default.pause();
            });
        }
        else {
            App_1.App.getNotificationApi().pause();
        }
        this.editorWrapper.css({
            'z-index': diy.editor.getNewTopZIndex(undefined, 'blockingModals')
        })
            .show();
        setTimeout(function () {
            _this.editorWrapper
                .addClass('opened');
        }, 1); //add delay between show jquery function and addClass opened for transition to take effect
    };
    VCardEditor.prototype.close = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.editorWrapper
                .removeClass('opened')
                .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function (e) {
                if (_this.vCardClient !== undefined) {
                    _this.vCardClient.destroy();
                }
                _this.editorWrapper
                    .off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend')
                    .hide();
                $('#vcard-feedback-button').remove();
                if (features('notificationsNG')) {
                    Api_1.default.schedule(function () {
                        Api_1.default.resume();
                    });
                }
                else {
                    App_1.App.getNotificationApi().resume();
                }
                resolve();
            });
        });
    };
    VCardEditor.prototype.save = function (vCardData) {
        var _this = this;
        this.editorContent.children().hide();
        $('#vcard-feedback-button').remove();
        this.showLoader();
        this.dataModel.save(vCardData)
            .then(function () {
            $(top.document.body).trigger('MaintenanceModeSaved.BSA');
            _this.hideLoader();
            _this.showAfterSaveConfirmation()
                .then(function () {
                _this.close();
                if (features('vcardFirstPublish')) {
                    features.disableFeature('vcardFirstPublish');
                    $(top.document.body).trigger('diy-maintenance-mode-vcard-publish');
                }
            });
        })
            .catch(function (reason) {
            console.error('Could not save vcard', reason);
            _this.hideLoader();
            _this.showError('Could not save vcard');
        });
    };
    VCardEditor.prototype.saveSemanticData = function (data) {
        return this.dataModel.saveSemanticData(data);
    };
    VCardEditor.prototype.initClient = function () {
        var _this = this;
        if (this.vCardClient !== undefined) {
            return Promise.resolve(this.vCardClient);
        }
        return this.loadScript()
            .then(function () {
            _this.vCardClient = vCard;
            _this.dataModel = new model_1.default(_this.vCardClient.getLatestVersion());
            return _this.vCardClient;
        });
    };
    /**
     * Displays a loading indicator.
     */
    VCardEditor.prototype.showLoader = function () {
        var loaderEl = $('<div class="vcard-editor-loader"></div>').appendTo(this.editorWrapper.find('.vcard-editor-wrapper'));
        ReactDOM.render(React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(CircularProgress_1.default, { mode: "indeterminate" })), loaderEl[0]);
    };
    /**
     * Hide a loading indicator.
     */
    VCardEditor.prototype.hideLoader = function () {
        this.editorWrapper.find('.vcard-editor-loader').remove();
    };
    VCardEditor.prototype.showError = function (errorMessage) {
        var _this = this;
        var closeLabel = l10n_1.default('toolbar.maintenance.offline.vcard.edit.close');
        console.warn(errorMessage);
        var messageEl = $("<div class=\"vcard-editor-message-container\">\n                <div class=\"vcard-editor-error-box\">\n                    <div class=\"vcard-editor-error-box-section-heading\">\n                        <div class=\"vcard-editor-error-box-icon\"></div>\n                        <div class=\"vcard-editor-error-box-heading\">\n                            " + l10n_1.default('toolbar.maintenance.offline.vcard.edit.error.heading') + "\n                        </div>\n                    </div>\n                    <div class=\"vcard-editor-error-box-section-details\">\n                        <div class=\"vcard-editor-error-box-description\">\n                            " + l10n_1.default('toolbar.maintenance.offline.vcard.edit.error.description') + "\n                        </div>\n                        <div class=\"vcard-editor-button\"></div>\n                    </div>\n                </div>\n            </div>");
        this.editorWrapper.addClass('vcard-editor-message-showed');
        messageEl
            .appendTo(this.editorWrapper.find('.vcard-editor-wrapper'));
        ReactDOM.render(React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(RaisedButton_1.default, { onClick: function () {
                    _this.close()
                        .then(function () {
                        messageEl.remove();
                        _this.editorWrapper.removeClass('vcard-editor-message-showed');
                    });
                }, label: closeLabel })), messageEl.find('.vcard-editor-button')[0]);
    };
    VCardEditor.prototype.createEditorWrapper = function () {
        this.editorWrapper = $("<div id=\"vCardEditor\" class=\"vcard-editor\">\n                <div class=\"vcard-editor-overlay\"></div>\n                <div class=\"vcard-editor-wrapper\">\n                    <div class=\"vcard-editor-anchor-arrow\"></div>\n                    <div class=\"vcard-editor-content\"></div>\n                    <div class=\"vcard-editor-loader\" style=\"display:none\"></div>\n                </div>\n            </div>");
        this.editorWrapper
            .css('padding-top', this.toolbar.element.outerHeight())
            .hide()
            .appendTo('body')
            .wrap('<div class="diy-external"></div>');
    };
    VCardEditor.prototype.positionArrow = function () {
        var websiteStatusIcon = $('.maintenanceModeContainer .icon');
        var arrowIcon = this.editorWrapper.find('.vcard-editor-anchor-arrow');
        arrowIcon.css({
            left: websiteStatusIcon.offset().left + (websiteStatusIcon.outerWidth() - arrowIcon.outerWidth()) / 2
        });
    };
    VCardEditor.prototype.showAfterSaveConfirmation = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var confirmationElement = $("<div class=\"save-confirmation\">\n                    <div class=\"disc\">\n                        <span class=\"checkmark\"></span>\n                    </div>\n                    <span class=\"confirmation\">\n                        " + l10n_1.default('toolbar.maintenance.offline.vcard.edit.save.message') + "\n                    </span>\n                </div>");
            confirmationElement.appendTo(_this.editorWrapper);
            setTimeout(function () {
                confirmationElement.addClass('done');
                setTimeout(function () {
                    confirmationElement
                        .fadeOut(1000, function () {
                        confirmationElement.remove();
                        resolve();
                    });
                }, 1500);
            }, 500);
        });
    };
    VCardEditor.prototype.trackPageEvent = function () {
        $(top.document).trigger('diy-editor-generic-sectionAccessed', {
            'sectionCodeName': 'v-card'
        });
    };
    ;
    VCardEditor.prototype.trackLinkEvent = function (section, context) {
        var pageNames = {
            'toolbar': "Toolbar maintenance flyout",
            'settings': "Settings Homepage",
            'onboardingGuide': "OnboardingGuide"
        };
        $(top.document).trigger('diy-editor-generic-linkInteraction', {
            'actionName': 'v-card.' + section,
            'pageName': pageNames[context]
        });
    };
    ;
    return VCardEditor;
}());
exports.default = VCardEditor;
;


/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = jQuery;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require. Use 'diy.editor.util.websiteData' instead");
}
var Data = (function () {
    function Data(data) {
        this.data = data;
    }
    Data.prototype.getId = function () {
        var websiteId;
        if ('undefined' !== typeof script_basisID) {
            websiteId = script_basisID;
        }
        else if (/^\/app\/[0-9]+\//.test(location.pathname)) {
            websiteId = location.pathname.match(/^\/app\/([0-9]+)\//)[1];
        }
        return websiteId;
    };
    Data.prototype.getData = function (section) {
        return this.data[section];
    };
    Data.prototype.getLanguageCode = function () {
        return (this.data.cmsLanguage) ? this.data.cmsLanguage.toString() : '';
    };
    Data.prototype.getLanguage = function () {
        return this.getLanguageCode().split('_')[0].toString();
    };
    Data.prototype.getMarket = function () {
        return this.getLanguageCode().split('_')[1].toString().toLowerCase();
    };
    Data.prototype.getCdnUrl = function () {
        return this.data.cdnUrl;
    };
    Data.prototype.getWebUrl = function () {
        return this.data.webUrl;
    };
    Data.prototype.getWebDomain = function () {
        return webDomain;
    };
    Data.prototype.getNotificationData = function (section) {
        if (this.data.notificationData[section]) {
            return this.data.notificationData[section];
        }
        else {
            return this.data.notification[section];
        }
    };
    Data.prototype.getCmsUrl = function () {
        return cc_.properties.cmsUrl;
    };
    Data.prototype.getCpContactUrl = function () {
        return this.data.cpContactUrl;
    };
    return Data;
}());
module.exports = new Data(jimdoData);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 5 */
/***/ function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

(function () {
    try {
        cachedSetTimeout = setTimeout;
    } catch (e) {
        cachedSetTimeout = function () {
            throw new Error('setTimeout is not defined');
        }
    }
    try {
        cachedClearTimeout = clearTimeout;
    } catch (e) {
        cachedClearTimeout = function () {
            throw new Error('clearTimeout is not defined');
        }
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var websiteData = __webpack_require__(4);
var semanticDataRefresher = __webpack_require__(7);
var semanticDataApi = __webpack_require__(8);
var VCardDataModel = (function () {
    function VCardDataModel(version) {
        this.config = {
            vCardPayload: {
                load: {
                    url: '/rest/websites/' + websiteData.getId() + '/vcard',
                    parameters: {
                        contentType: 'application/vnd.oneandone.diy.website.vcard+json'
                    }
                },
                save: {
                    url: '/rest/websites/' + websiteData.getId() + '/vcard',
                    parameters: {
                        contentType: 'application/vnd.oneandone.diy.website.vcard+json',
                        dataType: 'json'
                    }
                },
                applyLogo: {
                    url: '/rest/websites/' + websiteData.getId() + '/vcard',
                    parameters: {
                        headers: { Accept: 'application/vnd.oneandone.diy.website.logo+json' },
                        contentType: 'application/vnd.oneandone.diy.website.logo+json',
                        dataType: 'json'
                    }
                },
                saveResource: {
                    url: '/rest/websites/' + websiteData.getId() + '/storage-files',
                    parameters: {
                        contentType: 'application/vnd.oneandone.diy.website.storage.file+json',
                        dataType: 'json'
                    }
                },
                upgrade: {
                    url: '/rest/websites/' + websiteData.getId() + '/vcard',
                    parameters: {
                        'contentType': 'application/vnd.oneandone.diy.website.vcard+json',
                        data: {
                            upgradeData: true
                        }
                    }
                },
                version: 0
            },
            semanticData: {
                load: {
                    url: '/rest/websites/' + websiteData.getId() + '/semantic-data',
                    parameters: {
                        'contentType': 'application/vnd.oneandone.diy.website.semantic-data+json'
                    }
                },
                save: {
                    url: '/rest/websites/' + websiteData.getId() + '/semantic-data',
                    parameters: {
                        'contentType': 'application/vnd.oneandone.diy.website.semantic-data+json'
                    }
                }
            }
        };
        this.config.vCardPayload.version = version;
    }
    /**
     * @return array of promises
     */
    VCardDataModel.prototype.load = function () {
        return Promise.all([
            this.getVCardPayload(),
            this.getSemanticData()
        ]).then(function (_a) {
            var vCardPayload = _a[0], semanticData = _a[1];
            return {
                payload: vCardPayload,
                semanticData: semanticData
            };
        });
    };
    VCardDataModel.prototype.save = function (data) {
        var _this = this;
        var logoImageId = data.logoImageId;
        var saveData = function () {
            return Promise.all([
                _this.saveSemanticData(data.semanticData),
                _this.saveDataByConfig(_this.config.vCardPayload.save, data.payload)
            ].concat(logoImageId ? [
                _this.saveDataByConfig(_this.config.vCardPayload.applyLogo, {
                    imageId: logoImageId
                }).then(function (logoData) {
                    if (typeof diy !== 'undefined' &&
                        typeof diy.module !== 'undefined' &&
                        typeof diy.module.logo !== 'undefined' &&
                        typeof diy.module.logo.logo !== 'undefined' &&
                        typeof diy.module.logo.logo.logoExists === 'function' &&
                        typeof diy.module.logo.logo.loadData === 'function' &&
                        diy.module.logo.logo.logoExists()) {
                        diy.module.logo.logo.loadData(logoData);
                    }
                    else {
                        if (typeof CC !== 'undefined' &&
                            typeof CC.EmotionHeader !== 'undefined' &&
                            typeof CC.EmotionHeader.reload === 'function') {
                            CC.EmotionHeader.reload();
                        }
                    }
                })
            ] : []));
        };
        if (data["resources"] && data["resources"].length) {
            return Promise.all(data["resources"].map(function (resourceData) {
                return _this.saveResource(_this.config.vCardPayload.saveResource, resourceData);
            })).then(function () {
                return saveData();
            });
        }
        else {
            return saveData();
        }
    };
    // destroy siteadmin cache window for settings and updates the in page modules with the updated data
    VCardDataModel.prototype.refreshSemanticData = function (data) {
        try {
            if (diy && diy.editor && diy.editor.siteadmin && diy.editor.siteadmin.api) {
                diy.editor.siteadmin.api.close();
                diy.editor.siteadmin.api.destroyController('cc-sa-item-settings');
                semanticDataApi.deleteCache();
                semanticDataRefresher.update(data);
            }
        }
        catch (error) {
            // ignore error due to the fact that save action can also be triggered when there is no site admin window
        }
    };
    VCardDataModel.prototype.saveSemanticData = function (data) {
        var config = this.config.semanticData.save;
        var refreshSemanticData = this.refreshSemanticData;
        var saveData = function () {
            return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                /* register successful event */
                xhr.addEventListener("load", function (e) {
                    var target = e.target;
                    if (target.status >= 200 && target.status < 300) {
                        refreshSemanticData(data);
                        resolve([]);
                    }
                    else if (target.status === 422) {
                        resolve(JSON.parse(target.response));
                    }
                    else {
                        reject({ code: target.status });
                    }
                });
                /* register error event */
                xhr.addEventListener("error", function (e) {
                    reject(e);
                });
                xhr.open('POST', config.url, true);
                xhr.setRequestHeader('X-DiyCSRFToken', jimdoData.cstok);
                xhr.setRequestHeader('Content-Type', config.parameters['contentType']);
                if (config.parameters['accepts']) {
                    xhr.setRequestHeader('Accept', config.parameters['accepts']);
                }
                xhr.send(JSON.stringify(data));
            });
        };
        return saveData();
    };
    VCardDataModel.prototype.getVCardPayload = function () {
        var _this = this;
        return this.getDataByConfig(this.config.vCardPayload.load)
            .then(function (payload) {
            if (payload.version !== _this.config.vCardPayload.version) {
                return _this.getDataByConfig(_this.config.vCardPayload.upgrade);
            }
            return payload;
        });
    };
    VCardDataModel.prototype.getSemanticData = function () {
        return this.getDataByConfig(this.config.semanticData.load);
    };
    VCardDataModel.prototype.saveResource = function (config, data) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            /* register successful event */
            xhr.addEventListener("load", function (e) {
                var target = e.target;
                if (target.status >= 200 && target.status < 300) {
                    resolve();
                }
                else {
                    reject({ code: target.status });
                }
            });
            /* register error event */
            xhr.addEventListener("error", function (e) {
                reject("error");
            });
            var formData = new FormData();
            formData.append("data", JSON.stringify({
                "publicName": data.filename,
                "folderId": null,
                "uuid": data.id
            }));
            formData.append("file", data.file);
            xhr.open('POST', config.url, true);
            xhr.setRequestHeader('X-DiyCSRFToken', jimdoData.cstok);
            xhr.send(formData);
        });
    };
    VCardDataModel.prototype.saveDataByConfig = function (config, data) {
        var settings = $.extend(true, {
            url: config.url,
            type: 'POST',
            data: JSON.stringify(data)
        }, config.parameters);
        return Promise.resolve($.ajax(settings));
    };
    VCardDataModel.prototype.getDataByConfig = function (config) {
        return Promise.resolve($.ajax($.extend({
            url: config.url,
            type: 'GET'
        }, config.parameters)));
    };
    return VCardDataModel;
}());
exports.default = VCardDataModel;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var selectors = {
    module: '.modulelt.n',
    moduleType: '[data-moduletype="text"], [data-moduletype="header"]',
    placeholder: 'span.diysemanticplaceholder',
    semanticDataName: '[data-semantic-data-key="{name}"]'
};

/** @public */
var refresher = {

    /**
     * Updates DOM placeholders with new data.
     * @param {object} data
     * @public
     */
    update: function(data) {
        var i, len, items, $placeholders;

        $placeholders = $(selectors.module)
            .filter(selectors.moduleType)
            .find(selectors.placeholder);

        items = data.entities;

        len = items.length;

        for (i = 0; i < len; i++) {
            $placeholders
                .filter(selectors.semanticDataName.replace('{name}', items[i].name))
                .each(function () {
                    var newvalue, check = '';
                    newvalue = items[i].localizedValue || items[i].value;
                    newvalue = newvalue || '&nbsp;';

                    if (typeof newvalue === 'object') {
                        for (var key in newvalue) {
                            if (newvalue.hasOwnProperty(key)) {
                                check += (newvalue[key] || '');
                            }
                        }
                        if (!check) {
                            newvalue = '&nbsp;';
                        }
                    }
                    $(this).html(newvalue);
                });
        }
    }
};

module.exports = refresher;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var websiteData = __webpack_require__(4);

var config = {
    rest: {
        url: '/rest/websites/' + websiteData.getId() + '/semantic-data',
        mime: 'application/vnd.oneandone.diy.website.semantic-data+json',
        mimeValidation: 'application/vnd.oneandone.diy.website.semantic-data-validation+json',
        mimeConfiguration: 'application/vnd.oneandone.diy.website.semantic-data-configuration+json'
    },
    tr: {
        titles: ['honorificprefix', 'honorificsuffix'],
        phones: ['telephone', 'faxnumber']
    }
};

var cache, promiseCache;

var handlers = [];

var tr = jimdoData.messages.semanticdata;

/**
 * Executes all registered callbacks with the passed data.
 * @param {object} data
 * @private
 */
var callHandlers = function (data) {
    var i, len = handlers.length;
    for (i = 0; i < len; i++) {
        handlers[i](data);
    }
};

/**
 * Helper for phone number formatting.
 * @param {object|null} complex - Phone number parts or null if no data
 * @returns {string|null} - Formatted number or null if no data
 * @private
 */
var formatTelephoneNumber = function (complex) {
    if (complex === null || typeof complex !== 'object') {
        return null;
    }
    var bits = [];
    if (complex['countryPrefix']) {
        bits.push(complex['countryPrefix']);
    }
    if (complex['prefix']) {
        bits.push(complex['prefix']);
    }
    if (complex['number']) {
        bits.push(complex['number']);
    }
    return bits.join(' ');
};

/**
 * Helper for retrieving a translated label name, if available.
 * @private
 */
var trName = function (name) {
    var base = tr[name];
    if (!base) {
        return null;
    }
    if (base.label) {
        return base.label;
    }
    return null;
};

/**
 * Helper for retrieving a translated value, if available.
 * @private
 */
var trValue = function (name, value) {
    var base;

    base = config.tr.titles.indexOf(name) >= 0 ? tr.title : tr[name];
    if (!base) {
        return null;
    }
    if (!value) {
        return value;
    }
    if (base.value && base.value[value]) {
        return base.value[value];
    }
    return null;
};

/**
 * @param {object} data - Original data from server
 * @returns {object} - Processed data containing l10n
 * @private
 */
var localize = function (data) {
    var i, len, name, value, lname, lvalue;

    len = data.entities.length;

    for (i = 0; i < len; i++) {
        name = data.entities[i].name.replace('/', '').toLowerCase();
        value = data.entities[i].value;

        lvalue = lname = null;

        switch (value) {
            case 'dr':
                value = 'doctor_once';
                break;
            case 'prof':
                value = 'professor';
                break;
            case 'drdr':
                value = 'doctor_twice';
                break;
            case 'profdr':
                value = 'professor_combined';
                break;
        }

        lname = trName(name);

        if (config.tr.phones.indexOf(name) >= 0) {
            lvalue = formatTelephoneNumber(value);
        }
        else {
            lvalue = trValue(name, value);
        }

        data.entities[i].localizedName = lname;
        data.entities[i].localizedValue = lvalue;
    }
    return data;
};

/** @public */
var api = {

    /**
     * Delete the cache in order to force the API to refresh all data.
     */
    deleteCache: function () {
        cache = null;
        promiseCache = null;
    },

    /**
     * Fetches all data and returns one of:
     * - a resolved promise with the cache data if the cache is not empty;
     * - a promise of the ajax request with the response data if the cache is empty.
     * @returns {Promise}
     * @public
     */
    getAll: function () {
        if (cache) {
            var dfd = $.Deferred();
            setTimeout(function () {
                // resolve with a clone of the cache
                dfd.resolve($.extend(true, {}, cache));
            }, 0);
            return $.when(dfd);
        }

        promiseCache = promiseCache || $.when($.ajax({
            url: config.rest.url,
            type: 'GET',
            headers: {
                'Accept': config.rest.mimeConfiguration
            }
        }).done (function (data) {
            data = localize(data);
            cache = $.extend(true, {}, data);
            promiseCache = null;
        }));

        return promiseCache;
    },

    /**
     * Saves passed data and returns a promise of the ajax request.
     * On success, it calls all registered handlers.
     * @param {object}
     * @returns {promise}
     * @public
     */
    save: function (data) {
        // PLEASE NOTE that the backend is a REST interface; it will signal
        // errors as HTTP errors, so there is no need to explicitly check
        // return status
        return $.when($.ajax({
            url: config.rest.url,
            type: 'POST',
            contentType: config.rest.mime,
            headers: {
                'Accept': config.rest.mimeValidation
            },
            data: JSON.stringify(data),
            dataType: 'text'
        }).done(function () {
            // we use the given data because the REST endpoint does not provide it
            callHandlers(localize(data));
            // invalidate the data cache
            cache = null;
        }).fail(function (xhrResponse) {
            //XXX:DHDIY-26365: do not show black error for non-200 HTTP responses
            //FIXME: proper fix is to replace jQuery ajax() with a REST client which handles it properly
            xhrResponse.skipBlackError = true;
        }));
    },

    /**
     * Adds a function to be called upon save completion.
     * @param {function} callback
     * @returns {boolean}
     * @public
     */
    registerSaveHandler: function (callback) {
        var i, len;

        if (typeof callback !== 'function') {
            return false;
        }

        len = handlers.length;
        for (i = 0; i < len; i++) {
            if (handlers[i] === callback) {
                return false;
            }
        }
        handlers.push(callback);
        return true;
    }
};

module.exports = api;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var moduleSelector = __webpack_require__(10);
var siteAdminApi = __webpack_require__(19);

/**
 * @see DeepLinking.php for info about deeplinking
 */

;(function() {

    var data = null;

    var init = function(dt) {
        data = dt;

        if (data) {
            var cat = data.deepLinkCategory,
                item = data.deepLinkItem,
                params = data.deepLinkParams;

            /* if the main section is admin (SiteAdmin) */
            if (cat === 'admin') {
                if (item === 'elements') {
                    /* when Module Selector is opened, it triggers this event, which we catch only once */
                    $(document).one('moduleSelectorInitialized', function(e) {
                        if (params && params.scrollTo) {
                            moduleSelector.default.focusItem('module', params.scrollTo, params.category);
                        } else if (params && params.category) {
                            moduleSelector.default.openCategory(params.category);
                        }
                    });
                    siteAdminApi.triggerMenuItem('cc-sa-item-elements');
                } else if(item === 'fbpb-settings') {
                    /* the deepLinkParams coming with this query make sense for the FBPB, not for DIY */
                    siteAdminApi.triggerMenuItem('cc-sa-item-fbpb-settings');
                } else if(item === 'fbpb') {
                    siteAdminApi.triggerMenuItem('cc-sa-item-fbpb');
                }
            }

            /* if the main section is module (any module on the page) */
            if (cat === 'module') {
                var it = parseInt(item);
                if (!isNaN(it) && it in mm) {
                    if (params && params.action === 'open') {
                        /* we delay this task with 300 ms, as this also performs scrolling
                         * to this module and it's best that things have arranged fine in the page */
                        /* also works WITHOUT the timeout, but it's like this for a visual effect */
                        setTimeout(function() {
                            mm[it].open();
                        }, 300);
                    }
                }
            }
        }
    };

    var getData = function() {
        return data;
    };

    var path = [];
    var currentStep = 0;
    var handlers = {};
    var demoMode = false;

    var requestPath = function (newPath, useDemoMode, scrollToTop) {
        path = newPath;
        currentStep = 0;
        demoMode = useDemoMode ? true : false;
        processPath(demoMode);
        if (scrollToTop) $.scrollTo(0);
    };

    var cancelPath = function () {
        path = [];
        currentStep = 0;
        demoMode = false;
    };

    var processPath = function () {
        var label;
        for (var i = currentStep; i < path.length; i ++) {
            label = path[i].label;
            if (typeof handlers[label] === 'function') {
                try {
                    handlers[label](path[i].params, demoMode);
                    currentStep++;
                } catch (e) {
                    cancelPath();
                    break;
                }
            } else {
                // we don't have any handler yet
                // for the currentStep, so we stop
                break;
            }
        }
    };

    var registerHandler = function (handler, label) {
        handlers[label] = handler;
        processPath();
    };

    var unregisterHandler = function (label) {
        delete handlers[label];
    };

    return $.extend(this, {
        init: init,
        getData: getData,
        requestPath: requestPath,
        registerHandler: registerHandler,
        unregisterHandler: unregisterHandler
    });

}).call(exports);


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:member-ordering */
var $ = __webpack_require__(3);
var appsCatalog = __webpack_require__(11);
var BlankModuleHelper = __webpack_require__(14);
var l10n_1 = __webpack_require__(18);
var siteadminApi = __webpack_require__(19);
var AppRegistry_1 = __webpack_require__(190);
var ModuleSelector = (function () {
    function ModuleSelector() {
        this.mouseDownOnModule = false;
        this.uninstallRequestTimeout = 5000;
        this.limitationsCallout = false;
        this.limitationsMsg = '';
        this.loaded = false;
    }
    ModuleSelector.prototype.init = function () {
        var _this = this;
        $(document).on('diy-siteadmin-window-resize-completed', function (e) {
            //do this just for the module Selector window
            if (siteadminApi.getWindow().getContentElement().find('.adminModuleSelector').length) {
                _this.resizeModulesContainer();
                _this.setInactive();
            }
        });
    };
    ;
    ModuleSelector.prototype.reset = function () {
        this.loaded = false;
    };
    ;
    ModuleSelector.prototype.setLimitCallout = function () {
        var msgClass = '';
        if ($("#cc-sa-sidebar").hasClass('modules-maximum')) {
            this.limitationsCallout = true;
            this.limitationsMsg = l10n_1.default('limitations.maxAmountModulesPerPage');
            msgClass = 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip';
            this.disableModuleSelector(true);
        }
        else if ($("#cc-sa-sidebar").hasClass('modules-critical')) {
            this.limitationsCallout = true;
            msgClass = 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip limitation-warning';
            this.limitationsMsg = l10n_1.default('limitations.warningAmountModulesPerPage');
            this.disableModuleSelector(false);
        }
        else {
            this.limitationsCallout = false;
            this.disableModuleSelector(false);
        }
        if (this.limitationsCallout) {
            this.showCallout(this.limitationsMsg, msgClass);
            $(".adminModuleSelector .sections-callout").empty();
        }
        else {
            $(".adminModuleSelector .limitations-callout").empty();
            this.showSectionTeaser(l10n_1.default('limitations.crossLinkToSections'), 'diy-info-tooltip diy-sections-icon');
        }
        this.resizeModulesContainer();
    };
    ;
    ModuleSelector.prototype.getModulesContainer = function () {
        return $('div.cc-sa-controller-moduleSelector main #adminAddlist');
    };
    ;
    ModuleSelector.prototype.showSectionTeaser = function (message, className) {
        $(".adminModuleSelector .sections-callout").diy_simpleTooltip({
            positionMode: 'static',
            content: message,
            triggerMode: 'none',
            appendTo: ".adminModuleSelector .sections-callout",
            'cls': className
        });
        $(".adminModuleSelector .sections-callout").diy_simpleTooltip('show');
    };
    /**
     * Show warning callout at the top of the modules list
     */
    ModuleSelector.prototype.showCallout = function (limitationsMsg, msgClass) {
        $(".adminModuleSelector .limitations-callout").diy_simpleTooltip({
            positionMode: 'static',
            content: limitationsMsg,
            triggerMode: 'none',
            appendTo: ".adminModuleSelector .limitations-callout",
            'cls': msgClass,
            'contentIcon': 'ui-icon-alert'
        });
        $(".adminModuleSelector .limitations-callout").diy_simpleTooltip('show');
    };
    ;
    ModuleSelector.prototype.disableModuleSelector = function (disable) {
        if (disable) {
            $('div.cc-sa-controller-moduleSelector main .adminModuleSelector').loadingBox({
                useOverlay: true,
                hideLoader: true
            }).show();
            if ($('.loadingBox-overlay').length > 0) {
                $(".adminModuleSelector .limitations-callout")
                    .css('z-index', $('.loadingBox-overlay').css('z-index') + 1);
                $(".adminModuleSelector .limitations-callout").css('position', "relative");
            }
        }
        else {
            $('div.cc-sa-controller-moduleSelector main .adminModuleSelector').loadingBox().remove();
        }
    };
    ;
    ModuleSelector.prototype.resizeModulesContainer = function () {
        if (this.getModulesContainer().length) {
            var totalH = $('div.cc-sa-controller-moduleSelector').find('main').height();
            var topH_1 = 0;
            $('.adminModuleSelector .inline-tooltip.infoBox').each(function () { topH_1 += $(this).outerHeight(); });
            if ((totalH - topH_1) !== 0) {
                this.getModulesContainer().height(totalH - topH_1);
            }
        }
    };
    ModuleSelector.prototype.toggleActive = function (el) {
        var _this = this;
        if (!el.hasClass('active') && !el.hasClass('disabled')) {
            this.setInactive(null, true);
            el.addClass('active');
            $(window).bind('scroll.moduleSelector resize.moduleSelector', function () {
                _this.setInactive();
                $(window).unbind('.moduleSelector');
            });
            var $adminAddList = this.getModulesContainer();
            var extraOptions = el.data('tt_extraOptions');
            el.data('tt_extraOptions', null);
            var baseOptions = {
                cls: 'module_selector_tooltip',
                content: !diy.editor.uiPreference.isPointerModeTouch() ?
                    l10n_1.default('moduleSelector.moduleTooltip') :
                    l10n_1.default('moduleSelector.moduleTooltipMobile')
            };
            $.extend(baseOptions, extraOptions);
            $adminAddList.diy_tooltip('option', baseOptions);
            $adminAddList.diy_tooltip('show', el);
        }
    };
    ModuleSelector.prototype.setInactive = function (el, noAnim) {
        if (!el) {
            el = $('div.module-selector-item.active');
        }
        el.removeClass('active');
        this.getModulesContainer().diy_tooltip('hide');
    };
    ModuleSelector.prototype.load = function (url, container) {
        $.get(url, function (data) {
            //add data
            container.html(data);
        });
    };
    ModuleSelector.prototype.createDraggables = function (items) {
        var _this = this;
        var dragHelper = new BlankModuleHelper();
        items.each(function (index, elem) {
            // Breaks cyclic dependencies
            // TODO: move module selector instance to Registry so we don't have cyclic deps anymore
            var DragSourceClass = __webpack_require__(191);
            var dragSource = new DragSourceClass($(elem));
            dragSource.setHelper(dragHelper);
            AppRegistry_1.default.getModuleDragDrop().addDragSource(dragSource);
        })
            .on('ddstart ddstop', function () {
            _this.setInactive();
        })
            .on('ddstart', function () {
            // hide the site admin window
            // do a siteadmin close call without destroying the controller
            // the controller and module selector html are required during the drag drop process
            siteadminApi.close(false, true);
        })
            .on('ddcancel', function () {
            // Show the module selector again because we cancelled the drop
            $('#cc-sa-item-elements').click();
        });
        this.trialItems(items);
    };
    ;
    ModuleSelector.prototype.clearSelection = function () {
        this.setInactive();
    };
    ModuleSelector.prototype.trialItems = function (items) {
        items.each(function (index, item) {
            var $item = $(item);
            if ($item.attr('data-oao-trial') === 'true') {
                $item.addClass('isTrial');
            }
            if ($item.attr('data-oao-inactive') === 'true') {
                $item.draggable('disable');
                $item.addClass('isTrial');
            }
        });
    };
    ;
    /**
     * Init the Module Selector: sizes, styles, behaviors, event handlers, etc.
     */
    ModuleSelector.prototype.afterFillContent = function (el, data, container) {
        //make the draggables
        var items = this.getModulesContainer().find('div.module-selector-item');
        var lastActiveCategory = $.cookie('diy.editor.moduleSelectorCategory');
        var lastActiveCategoryHeading;
        var firstCategory = this.getModulesContainer()
            .find('.diye-collapsible-category-header').attr('data-categoryid');
        this.createDraggables(items);
        function showUpgrade(event) {
            event.data.el.trigger('mouseup');
            event.data.el.trigger('click');
        }
        if (!diy.editor.uiPreference.isPointerModeTouch()) {
            var self_1 = this;
            $('.module-selector-item').mousedown(function () {
                if ($(this).hasClass('active')) {
                    self_1.mouseDownOnModule = true;
                }
                if (diy.editor.upgradeLayer.isElementUpgradable(this)) {
                    $(document).bind('mousemove', { el: $(this) }, showUpgrade);
                }
            });
            $('.module-selector-item').not('.isTrial').mouseup(function (event) {
                self_1.mouseDownOnModule = false;
                var $this = $(this);
                $this.addClass('hover');
                var $originalTarget = $(event.originalTarget || event.srcElement);
                $this.find('a.full_title').addClass('focus');
                if (!diy.editor.upgradeLayer.isElementUpgradable($this)
                    && ($originalTarget.length === 0 || !$originalTarget.hasClass('js-apps-open-catalog'))) {
                    self_1.toggleActive($this);
                }
                else {
                    //remove mouse down
                    $(document).unbind('mousemove', showUpgrade);
                }
            });
        }
        else {
            var self_2 = this;
            $('.module-selector-item').each(function () {
                Hammer(this).on('tap', function (e) {
                    var event = e.gesture.srcEvent;
                    if (diy.editor.upgradeLayer.isElementUpgradable(this)) {
                        showUpgrade(event);
                    }
                    else {
                        var $originalTarget = $(event.originalTarget || event.srcElement);
                        if ($originalTarget.length === 0 || !$originalTarget.hasClass('js-apps-open-catalog')) {
                            self_2.toggleActive($(this));
                        }
                    }
                });
            });
        }
        this.getModulesContainer().diy_tooltip({
            anchorOffset: -13,
            delegate: 'div.module-selector-item',
            triggerMode: 'none',
            zIndex: 100110,
            fadeOutDelay: 400,
            fadeInDelay: 400
        });
        var self = this;
        $('a.short_title, a.full_title').blur(function () {
            //this is for ie8, dont let setting inactive if
            //is mouse down on the element
            if (self.mouseDownOnModule !== true) {
                //do not set inactive, it another link is active, this is for ie9
                var activeLink = $('.module-selector-item a.focus');
                if (activeLink.length === 0) {
                    self.setInactive();
                }
            }
        });
        self.getModulesContainer().scroll(function () {
            self.setInactive();
        });
        $(window).resize(function () {
            self.resizeModulesContainer();
        });
        //resize the modules container
        self.resizeModulesContainer();
        // init squeeze box (scroll handle + always in view) //
        self.getModulesContainer().diy_scrollHandle();
        self.getModulesContainer().diy_alwaysInViewBehavior({
            clickToOpen: true,
            fixableSelector: '.diye-collapsible-category-header',
            fixedClassName: 'fixed',
            activeClassName: 'active'
        });
        // listed to opened sections //
        self.getModulesContainer()
            .find('.diye-collapsible-category-header')
            .bind('alwaysInViewBehavior-activated', function (event) {
            var categoryId = $(event.target).attr('data-categoryid');
            // remember the last active category //
            $.cookie('diy.editor.moduleSelectorCategory', categoryId, { path: '/' });
            $(document).trigger('diy-editor-generic-sectionAccessed', {
                sectionCodeName: 'elements.' + categoryId
            });
        });
        // auto-open last know category //
        lastActiveCategoryHeading = $('.diye-collapsible-category-header[data-categoryId="' +
            lastActiveCategory + '"]');
        if (lastActiveCategory && lastActiveCategory !== firstCategory && lastActiveCategoryHeading.length) {
            self.getModulesContainer().diy_alwaysInViewBehavior('scrollToItem', lastActiveCategoryHeading.get(0), function () {
                $(document).trigger('moduleSelectorInitialized');
            }, 0 // scroll instantly
            );
            // if no category is auto-opened then the first one is by default open //
        }
        else {
            $(document).trigger('diy-editor-generic-sectionAccessed', {
                sectionCodeName: 'elements.' + firstCategory
            });
            $(document).trigger('moduleSelectorInitialized');
        }
        // catalog events
        self.attachCatalogEvents();
        //check the limitations and set the callout
        self.setLimitCallout();
        // initialize help link
        cms.help.GuidedAssistant._instance._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
        $(document.body).trigger('ModuleSelectorOpened.BSA');
        self.loaded = true;
    };
    ;
    /**
     * Create apps related behaviors
     */
    ModuleSelector.prototype.attachCatalogEvents = function () {
        // open catalog buttons
        this.getModulesContainer().find('.js-apps-open-catalog').each(function (index, element) {
            var $element = $(element);
            if ($element.hasClass('apps-catalog-button')) {
                $element.button({
                    icons: {
                        primary: "ui-icon-1and1-external"
                    }
                });
            }
            $element.bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                $('#cc-sa-item-appscatalog').data('customHref', $(this).attr('href'));
                $('#cc-sa-item-appscatalog').click();
            });
        });
        var self = this;
        // delete buttons
        $('.has-catalog-data .delete-button').click(function (event) {
            event.preventDefault();
            var $this = $(this);
            //ask the user for a confirmation
            var dialog = $('<div>'
                + l10n_1.default('moduleSelector.windowMain.delete.confirmation.message')
                + '</div>').diy_confirmationDialog({
                position: {
                    my: 'center',
                    at: 'center',
                    of: self.getModulesContainer()
                },
                dialogClass: "confirmation-dialog deleteWebComponentDialog",
                buttons: [
                    {
                        text: l10n_1.default('moduleSelector.windowMain.delete.confirmation.accept'),
                        click: function () {
                            var moduleSelectorItem = $this.parents('.module-selector-item');
                            var wcId = moduleSelectorItem.attr('data-webcomponentid');
                            //set the error to be triggered unless success or error
                            //callbacks cancel this
                            var to = setTimeout(function () {
                                self.showErrorMessageOnItem($this, 'timeout');
                            }, self.uninstallRequestTimeout);
                            appsCatalog.uninstallWebComponent(wcId, {
                                success: function (data) {
                                    clearTimeout(to);
                                    //remove the element
                                    moduleSelectorItem.remove();
                                    siteadminApi.destroyController('cc-sa-item-appscatalog');
                                    // update the scrolling element
                                    self.getModulesContainer().trigger('contentchanged');
                                },
                                error: function () {
                                    clearTimeout(to);
                                    self.showErrorMessageOnItem(moduleSelectorItem, l10n_1.default('moduleSelector.windowMain.delete.error.message'));
                                }
                            });
                            dialog.diy_confirmationDialog('destroy');
                        }
                    },
                    {
                        text: l10n_1.default('moduleSelector.windowMain.delete.confirmation.cancel'),
                        click: function () {
                            dialog.diy_confirmationDialog('destroy');
                        },
                        "class": "button-cancel"
                    }
                ],
                create: function () {
                    self.setInactive();
                },
                modal: true,
                zIndex: 100201
            });
        });
    };
    ;
    ModuleSelector.prototype.show = function () {
        if (this.loaded === true) {
            this.resizeModulesContainer();
            var lastActiveCategoryHeading = this.getModulesContainer()
                .find('div.diye-collapsible-category-header.active');
            if (lastActiveCategoryHeading.length) {
                this.getModulesContainer().diy_alwaysInViewBehavior('scrollToItem', lastActiveCategoryHeading.get(0), function () {
                    $(document).trigger('moduleSelectorInitialized');
                }, 0 // scroll instantly
                );
            }
            else {
                $(document).trigger('moduleSelectorInitialized');
            }
        }
    };
    ModuleSelector.prototype.showErrorMessageOnItem = function (item, message) {
        var _this = this;
        var wcId = item.attr('data-webcomponentid');
        var catId = item.attr('data-categoryid');
        setTimeout(function () {
            item.data('tt_extraOptions', {
                cls: 'diy-alert-tooltip module_selector_tooltip',
                content: message
            });
            _this.focusItem('webcomponent', wcId, catId);
        }, 40);
    };
    ;
    /**
     * Opens a category
     */
    ModuleSelector.prototype.openCategory = function (categoryIdentifier) {
        if (!categoryIdentifier) {
            return false;
        }
        this.getModulesContainer().diy_alwaysInViewBehavior('scrollToItem', $('.diye-collapsible-category-header[data-categoryId="' + categoryIdentifier + '"]').get(0));
        return false;
    };
    ;
    /**
     * Scrolls to a webcomponent or module and shows its callout.
     */
    ModuleSelector.prototype.focusItem = function (type, id, cat) {
        var element;
        var callback;
        if (type === 'webcomponent') {
            element = this.getModulesContainer().find('[data-webcomponentid="' + id + '"]');
        }
        else if (type === 'module') {
            element = this.getModulesContainer().find('[data-modulename="' + id + '"]');
        }
        // filter by category
        if (cat) {
            element = element.filter('[data-categoryid="' + cat + '"]');
        }
        // if no element matched then stop //
        if (!element.length) {
            return;
        }
        // limit to the first found element //
        element = element.first();
        callback = function () {
            setTimeout(function () {
                element.mousedown().mouseup();
            }, 30);
        };
        this.getModulesContainer().diy_alwaysInViewBehavior('scrollToItem', element.get(0), callback);
    };
    ;
    /**
     * Opens the Module Selector and then...
     * Scrolls to a webcomponent or module and shows its callout.
     */
    ModuleSelector.prototype.jumpToItem = function (type, id, cat) {
        var _this = this;
        if ($('#cc-sa-item-elements').hasClass('cc-sa-active')) {
            this.focusItem(type, id, cat);
        }
        else {
            $(document).one('moduleSelectorInitialized', function () {
                _this.focusItem(type, id, cat);
            });
            $('#cc-sa-item-elements').click();
        }
    };
    ;
    /**
     * Jumps to a web component
     */
    ModuleSelector.prototype.jumpToWebComponent = function (wcId, cat) {
        this.jumpToItem('webcomponent', wcId, cat);
    };
    ;
    /**
     * Jumps to a module
     */
    ModuleSelector.prototype.jumpToModule = function (modId, cat) {
        this.jumpToItem('module', modId, cat);
    };
    ;
    return ModuleSelector;
}());
var moduleSelector = new ModuleSelector();
exports.default = moduleSelector;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var crossDomain = __webpack_require__(12);
var appsApiConstants = __webpack_require__(13);
var moduleSelector = __webpack_require__(10);

(function () {
    var controllerUrl = '/app/siteadmin/appscatalog/';

    var SIZE_STANDARD = 860;
    var SIZE_WIDE = 1164;

    this.windowWidth = window.screen.width < 1280 ? SIZE_STANDARD : SIZE_WIDE;
    this.windowHeight = $(window).height();

    this.customOpen = function(url) {

        if (url) {
            $('#cc-sa-item-appscatalog').data('customHref', url);
        }

        /* if opened close it so we can force open with new url */
        if ($('#cc-sa-item-appscatalog').hasClass('cc-sa-active')) {
            diy.editor.siteadmin.api.close();
            setTimeout(function(){
                $('#cc-sa-item-appscatalog').click();
            }, 350);
        } else {
            $('#cc-sa-item-appscatalog').click();
        }
    };

    this.open = function(url, fromModuleSelector) {
        // add event to open the module selector window
        var buttons = {
            close: {
                event: {
                    type: 'diy-siteadmin-apps-catalog-closed',
                    openModuleSelector: fromModuleSelector
                }
            }
        };

        var self = this;

        // fixed width for the catalog
        var windowBehavior = {
                size: {
                    width: self.windowWidth,
                    height: self.windowHeight,
                    persistentId: ''
                },
                resizable: false,
                footer: {}
        };
        var contentType = 'inline';
        var controllerName = 'appsCatalog';

        var controllerOpenUrl = controllerUrl + 'open/';
        if (url){
            controllerOpenUrl += '?url=' + encodeURIComponent(url);
        }

        diy.editor.siteadmin.api.showWindow(controllerOpenUrl, windowBehavior, contentType, controllerName, 'cc-sa-item-appscatalog');
        diy.editor.siteadmin.api.setSidebarActiveItem('cc-sa-item-appscatalog');
        diy.editor.siteadmin.api.updateTitle(jimdoData.messages.moduleSelector.appsCatalogWindow.title);
        diy.editor.siteadmin.api.updateDescr(jimdoData.messages.moduleSelector.appsCatalogWindow.description);
        diy.editor.siteadmin.api.updateButtons(buttons);
        diy.editor.siteadmin.api.updateHelpTopic('');
    };

    this.updateTopicCategory = function (categoryId) {
        var appsCatalogButton = $('#cc-sa-item-appscatalog');
        appsCatalogButton.attr('href', appsCatalogButton.attr('href').replace(/topicCategory=\d+/, 'topicCategory=' + categoryId));
    };

    this.getDetailPageNoBackLinkUrl = function(webComponentId) {
        var templateUrl = jimdoData.appsCatalogTemplateUrl;
        var url = templateUrl.replace("*WEBCOMPONENT_ID*", webComponentId);
        return url;
    };

    /**
     * this responds to apps catalog request for focus on one web component
     *
     * -it responds back to apps catalog when error encountered
     * -params must contain wc_id and category_id
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param params //TODO: fill this in
     * @param responderObject //TODO: fill this in
     */
    this.cb_handleFocus = function(params, responderObject){
        if(params === undefined
            || params.wc_id === undefined
        ){
            responderObject.error(appsApiConstants.errors.BAD_REQUEST);
        }

        //get the category
        $.ajax(
            {
                url: controllerUrl + 'webapps-get-main-category',
                type: 'POST',
                dataType: 'json',
                data: {wc_id: params.wc_id},
                success: function(msg){

                    if (!msg.data.main_category) {
                        responderObject.error(appsApiConstants.errors.BAD_REQUEST);
                    } else {
                        moduleSelector.default.jumpToWebComponent(params.wc_id, msg.data.main_category);
                    }
                },
                error: function () {
                    responderObject.error(
                        appsApiConstants.errors.INTERNAL_SERVER_ERROR
                    );
                }
            }
        );
    };

    /**
     * this responds to apps catalog request for installation of a web component
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param params //TODO: fill this in
     * @param responderObject //TODO: fill this in
     */
    this.cb_installWebComponent = function (params, responderObject) {
        var wc_id = params.wc_id;

        $.ajax(
            {
                url: controllerUrl + 'webapps-install',
                type: "post",
                dataType: "json",
                data: {wc_id: wc_id},
                success: function(msg){
                    //the response came, get the response
                    if (msg.success === true ) {
                        // Update status cache
                        if ($.inArray(wc_id, jimdoData.installedWebcomponents) === -1) {
                            jimdoData.installedWebcomponents.push(wc_id);
                        }

                        /**
                         * Make some SiteCatalyst tracking
                         */
                        $(document).trigger('diy-editor-makeWebsiteFit', {
                            'condition': 'Tried',
                            'name': 'Web Apps'
                        });

                        $(document.body).trigger('WebAppInstalled.BSA');
                        $(document).trigger('diy-editor-appscatalog-wc-installed', [wc_id]);
                        diy.editor.siteadmin.api.destroyController('cc-sa-item-elements');
                        diy.editor.siteadmin.api.destroyController('cc-sa-item-appscatalog');
                        moduleSelector.default.jumpToWebComponent(wc_id, msg.data.main_category);
                    } else {
                        if (msg.errors.code_0
                            && appsApiConstants.errors[msg.errors.code_0]
                        ) {
                            responderObject.error(
                                appsApiConstants.errors[msg.errors.code_0]
                            );
                        } else {
                            //something unexpected
                            responderObject.error(
                                appsApiConstants.errors.INTERNAL_SERVER_ERROR
                            );
                        }
                    }
                }
            }
        );
        return;
    };
    /**
     * this responds to AppsCatalog request for installation status
     *
     * this method always responds back to the catalog;
     * does not send back an error (responderObject.error)
     * cuz it includes in normal response
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param params //TODO: fill this in
     * @param responderObject //TODO: fill this in
     *
     */
    this.cb_getWebComponentStatus = function(params, responderObject){
        $.ajax(
            {
                url: controllerUrl + 'webapps-status-check',
                type: "post",
                dataType: "json",
                data: {wc_id_list: params.wc_id},
                success: function (msg) {
                    //the response came, get the response
                    if (msg.success === true ) {
                        var statuses = {};
                        for (var k in msg.data.status) {
                            if (msg.data.status.hasOwnProperty(k)) {
                                statuses[k] = {
                                    wc_id: k,
                                    status: appsApiConstants[msg.data.status[k]]
                                };
                            }
                        }
                        //all good
                        responderObject.respond(statuses);
                    } else {
                        //something unexpected
                        responderObject.error(
                            appsApiConstants.errors.INTERNAL_SERVER_ERROR
                        );
                    }
                }
            }
        );
    };

    /**
     * Checks if a webcomponent is installed or not
     *
     * @param wc_id webcomponent id
     * @returns {boolean}
     */
    this.isWebcomponentInstalled = function(wc_id) {
        return $.inArray(wc_id, jimdoData.installedWebcomponents) !== -1;
    };

    /**
     * this uninstalls the web component
     *
     * this is not a callback, this gets called directly by the module selector
     * when the delete button click is handled
     *
     * @author marian.cojoc@1and1.ro
     *
     * @param wc_id the web component id
     *
     */
    this.uninstallWebComponent = function(wc_id, params){
        var appIdToTrack = wc_id;
        $.ajax(
            {
                url: controllerUrl + 'webapps-uninstall',
                type: 'POST',
                dataType: 'json',
                data: {wc_id: wc_id},
                success: function (msg) {
                    if (msg.success === true) {
                        // Update status cache
                        var wcIndexInCache = $.inArray(wc_id, jimdoData.installedWebcomponents);
                        if (wcIndexInCache !== -1) {
                            jimdoData.installedWebcomponents.splice(wcIndexInCache, 1);
                        }

                        /**
                         * Make some SiteCatalyst tracking
                         */
                        $(document).trigger('diy-editor-appCatalog-uninstallWebApp', {
                            'appIdToTrack': appIdToTrack
                        });
                        $(document).trigger('diy-editor-appscatalog-wc-uninstalled', [wc_id]);
                        if (params.success) {
                            params.success(msg.data);
                        }
                    } else {
                        if (params.error) {
                            params.error();
                        }
                    }
                },
                error: function () {
                    if (params.error) {
                        params.error();
                    }
                }
            }
        );
    };

    this.cb_CNIFeatureIsAvailable = function (params, responderObject) {
        var time = new Date().getTime();
        $.ajax(
            {
                url: controllerUrl + 'webapps-feature-available?r=' + time,
                type: "GET",
                dataType: "json",
                success: function(msg){
                    //the response came, get the response
                    if (msg.success === true) {
                        //all good
                        responderObject.respond({
                            feature_is_available: msg.data.featureIsAvailable
                        });
                    } else {
                        //could not decide if the feature is avalable or not
                        responderObject.error(
                            appsApiConstants.errors.INTERNAL_SERVER_ERROR
                        );
                    }
                }
            }
        );
    };

    this.init = function (){

        // this event is triggered when closing the apps catalog siteadmin window if
        // it was opened form a link inside the module selector
        $(document).bind('diy-siteadmin-apps-catalog-closed', function(event) {
            //TODO: this gets logged twice INVESTIGATE
            // console.log(event.openModuleSelector);

            if(event.openModuleSelector){
                // use click instead of diy.editor.siteadmin.api.triggerSidebarItem() because
                // history changes are needed for the close button to work properly
                $('#cc-sa-item-elements').click();
            }
        });

        //register a receiver for when appsCatalog wants to know if CnI feature is available
        crossDomain.receiver.registerReceiver(
            appsApiConstants.REQUEST_FEATURE_IS_AVAILABLE,
            this.cb_CNIFeatureIsAvailable,
            jimdoData.messages.moduleSelector.catalog_url_prefix
        );

        //register a receiver for when appsCatalog wants statuses
        crossDomain.receiver.registerReceiver(
                appsApiConstants.REQUEST_STATUS,
                this.cb_getWebComponentStatus,
                jimdoData.messages.moduleSelector.catalog_url_prefix
        );
        //register for doFocus
        crossDomain.receiver.registerReceiver(
                appsApiConstants.REQUEST_FOCUS,
                this.cb_handleFocus,
                jimdoData.messages.moduleSelector.catalog_url_prefix
        );
        //register for install
        crossDomain.receiver.registerReceiver(
                appsApiConstants.REQUEST_INSTALL,
                this.cb_installWebComponent,
                jimdoData.messages.moduleSelector.catalog_url_prefix
        );
    };
}).call(exports);


/***/ },
/* 12 */
/***/ function(module, exports) {

/**
 * Cross domain communication library over sendMessage
 *
 * provides functionality for proper communication
 * (2 way communication - sending messages and receiving responses)
 *
 *
 * @author marian.cojoc@1and1.ro
 * @author ciprian.popovici@1and1.ro
 */
var utils, sender, receiver, responder;

/**
 * Utils name space to hold utilities functions
 */
utils = {
    //parseUri 1.2.2
    //(c) Steven Levithan <stevenlevithan.com>
    //MIT License
    //http://blog.stevenlevithan.com/archives/parseuri
    /**
     * this function splits any well-formated URI into it's parts
     * @param {string} str Well formated URI
     * @returns {Object} the parts of the URI
     */
    parseUri: function(str) {
        var o   = {
            strictMode: false,
            key: [
                "source",
                "protocol",
                "authority",
                "userInfo",
                "user",
                "password",
                "host",
                "port",
                "relative",
                "path",
                "directory",
                "file",
                "query",
                "anchor"
            ],
            q: {
                name: "queryKey",
                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
            },
            parser: {
                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
            }
        },
        m = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
        uri = {},
        i = 14;

        while (i--) uri[o.key[i]] = m[i] || "";

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    },

    postMessage: function (target, message) {
        //serialize
        if (typeof message !== "string") {
            message = JSON.stringify(message);
        }

        target.postMessage(message, "*");
    },

    /**
     * common point for registering message event listeners
     *
     * @param {function} handleMessage callback function
     */
    registerMessageEventListeners: function (handleMessage) {
        var preHandle = function (event) {

            if (typeof event.data === "string") {
                try {
                    event.realData = JSON.parse(event.data);
                } catch(e) {
                    //parsing failed, continue as it is ment as a string
                    event.readData = event.data;
                }
            }
            handleMessage(event);
        };
        //jQuery may not be available, so native event handling
        if (window.addEventListener) { //normal browser style
            window.addEventListener('message', preHandle, false);
        } else { //IE style
            window.attachEvent('onmessage', preHandle);
        }
    }
};


/**
 * the sender initiates the 2-way communication;
 * sends the message and optionally waits for a response
 */
sender = {};
(function () {
    //holds the message ids
    var messages = {};
    //default timeout to 5 seconds
    var timeout = 5000;
    var timeouts = {};
    /**
     * params structure: {
     *  success:<callback_function>,
     *  error:<callback_function>,
     *  timeout:<callback_function>,
     *  setTimeout: <number of miliseconds>
     * }
     */
    /**
     * used to initiate a communication
     *
     * @param {object} msg the message to send
     * @param {object} params callbacks and other options
     */
    this.sendMessage = function (msg, params) {
        msg = msg || {};
        //have a random id
        var messageId = 'm' + (Math.random() * (1 << 30)).toString(16);
        //if the sender expects a response back, it provides the callback
        if (params !== undefined ){

            if (params.timeout !== undefined) {
                if (params.setTimeout!==undefined) {
                    timeout = params.setTimeout;
                }
                var to = setTimeout(function() {
                    delete timeouts[messageId];
                    delete messages[messageId];
                    params.timeout();
                }, timeout);
                timeouts[messageId] = to;
            }
            messages[messageId] = params;
            msg.messageId = messageId;
        }
        //TODO: handle the targetOrigin
        utils.postMessage(window.top, msg); //send the message

    };
    /**
     * Handledresponses for sent messages
     * @param {object} e the message event
     */
    var handleMessage = function (e) {
        //do not handle own messages
        if (e.realData === undefined || e.realData.responseData === undefined) {
            return;
        }
        var messageId = e.realData.messageId;

        //clear the timeout
        if (timeouts[messageId] !== undefined) {
            clearTimeout(timeouts[messageId]);
            delete timeouts[messageId];
        }

        var params = messages[messageId];
        if (e.realData.success == true) {
            if (params.success !== undefined) {
                params.success(e.realData.responseData);
            }
        } else {
            if(params.error !== undefined){
                params.error(e.realData.responseData);
            }
        }
        delete messages[messageId];
    };
    /**
     * init function
     */
    this.init = function () {
        utils.registerMessageEventListeners(handleMessage);
    };

    this.init();

}).call(sender);

/**
 * the receiver waits for a message and optionally responds back..
 * ..by passing a responder object to the callback; letting the callback..
 * ..to do the actual responding
 * also handles the receiver callbacks function registration
 */
receiver = {};
(function () {

    var receiverCallbacks = {};
    /**
     * waits for messages and calls the registered callback for..
     * ..that message type
     * @param {object} e the message event
     */
    var handleMessage = function (e) {
        //do not handle own messages
        if (e.realData === undefined || e.realData.type === undefined) {
            return;
        }

        var payload = e.realData;
        if (receiverCallbacks[payload.type] !== undefined) {
            var rObj = new responder(payload, e.source);

            //accepts only from known sources
            var url_details = utils.parseUri(
                receiverCallbacks[payload.type].expectedOrigin
            );
            var expectedOriginUrl = url_details.protocol + '://' + url_details.host;
            if(url_details.port !== undefined && url_details.port !== ''){
                expectedOriginUrl = expectedOriginUrl + ':' + url_details.port;
            }
            //if the handler does not expect and origin, it handles all the messages
            if (receiverCallbacks[payload.type].expectedOrigin !== undefined
                && e.origin !== expectedOriginUrl) {
                return;
            }

            receiverCallbacks[payload.type].callback(payload.params, rObj);
            return;
        }
    };
    /**
     * register callback for a message type
     * @param {string} type
     * @param {function} callback
     * @param {string} exectedOrigin handle messages originating from here
     */
    this.registerReceiver = function (type, callback, expectedOrigin) {
        receiverCallbacks[type]={
            callback: callback,
            expectedOrigin: expectedOrigin
        };
    };
    /**
     * removes a callback for a message type
     *
     * @param {string} type the type of message
     * @returns {bool} true on successful removal, false otherwise
     */
    this.unregisterReceiver = function (type) {
        if (receiverCallbacks[type] === undefined) {
            return false;
        }
        return delete receiverCallbacks[type];
    };

    utils.registerMessageEventListeners(handleMessage);
}).call(receiver);
/**
 * this object gets passed to message handlers on the receiving part
 * to be used to trigger success or failure
 * @param payload
 * @param source
 * @returns {window.diy.crossDomain.responder}
 */
responder = function (payload, source) {
    this.payload = payload;
    this.source = source;
    /**
     * respond in case of success
     *
     * @param {string} response
     */
    this.respond = function (response) {
        var message={
            responseData: response,
            success: true,
            messageId: payload.messageId
        };

        //TODO: get the iframe to send to, for now send back to where it came from
        utils.postMessage(this.source, message);
    };
    /**
     * respond in case of error
     * @param {string} errorCode see: diy.appsApiConstants.errors
     */
    this.error = function (errorCode){
        var message = {};
        message.messageId = payload.messageId;
        message.success = false;
        message.responseData = {errorId: errorCode};
        //TODO: get the iframe to send to, for now send back to where it came from
        utils.postMessage(this.source, message);
    };
};

module.exports = {
    utils: utils,
    sender: sender,
    receiver: receiver,
    responder: responder
};

/***/ },
/* 13 */
/***/ function(module, exports) {

module.exports = {
    errors: {
        WEB_COMPONENT_ID_NOT_FOUND: 'web_component_not_found',
        WEB_COMPONENT_ID_NOT_INSTALLED: 'web_component_not_installed',
        WEB_COMPONENT_ID_NOT_IN_CATEGORY: 'requested_web_component_not_in_category',
        WEB_COMPONENT_ALREADY_INSTALLED: 'web_component_already_instaled',
        WEB_COMPONENT_NOT_INSTALLABLE: 'web_component_not_installable',
        MODULE_MAIN_CATEGORY_NOT_FOUND: 'main category module not found for web component',
        MODULE_SELECTOR_OPENING_EVENT: 'could not open module selector for web component',
        BAD_REQUEST: 'bad_request',
        //could not connect to server, or the server did not respond properly
        INTERNAL_SERVER_ERROR: 505
    },
    pageCreationSteps: {
        STEP_PREPARATION: 'step_preparation',
        STEP_PAGE_CREATION: 'page_creation',
        STEP_WEBCOMPONENT_CREATION: 'webcomponent_creation'
    },
    //used to request all web components statuses
    ALL_WEB_COMPONENTS: 'allWebComponents',
    INSTALLED_STATUS_INSTALLED: 'status_installed',
    INSTALLED_STATUS_NOT_INSTALLED: 'status_not_installed',
    INSTALLED_STATUS_NOT_INSTALLABLE: 'status_not_installable',
    INSTALLED_STATUS_NOT_FOUND: 'status_not_found',
    INSTALLED_STATUS_ERROR: 'status_error',
    REQUEST_FEATURE_IS_AVAILABLE: 'featureIsAvailable',
    REQUEST_STATUS: 'getStatus',
    REQUEST_FOCUS: 'doFocus',
    REQUEST_INSTALL: 'doInstall'
};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var ModuleHelper = __webpack_require__(16);
/**
 * Drag helper for new modules (from module selector)
 */
var BlankModuleHelper = (function (_super) {
    tslib_1.__extends(BlankModuleHelper, _super);
    function BlankModuleHelper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.restrictedTooltipOptions = {
            anchorOffset: -12
        };
        return _this;
    }
    BlankModuleHelper.prototype.create = function (sourceElem) {
        var item = sourceElem;
        var itemIcon = item.find('.image');
        // webcomponents use the background-image css property for the icon
        // in the style attribute
        var itemStyle = itemIcon.attr('style');
        if (typeof (itemStyle) !== 'undefined') {
            itemStyle = itemStyle.replace('"', '\'');
        }
        else {
            itemStyle = "";
        }
        var dragElement = $('<div class="drag-container"><div class="diye">' +
            '<div class="drag-placeholder">' +
            '<div class="opaque"></div>' +
            '<span class="' + itemIcon.attr('class') +
            '" style="' + itemStyle + '"></span><br />' +
            '<span class="label">' + item.attr('data-moduleLabel') + '</span>' +
            '</div>' +
            '</div></div>');
        // if the item icon is a sprite, set it to the dragging position
        if (item.attr('data-iconissprite') === "1" && itemIcon.hasClass('icon')) {
            dragElement.find('.icon').addClass('drag');
        }
        dragElement.appendTo('body');
        //need to set correct dimensions, because the draggable doesn't do that right
        var placeholder = dragElement.find('.drag-placeholder');
        dragElement.css('height', placeholder.height()).css('width', placeholder.width());
        return dragElement;
    };
    return BlankModuleHelper;
}(ModuleHelper));
module.exports = BlankModuleHelper;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global global, define, System, Reflect, Promise */
var __extends;
var __assign;
var __rest;
var __decorate;
var __param;
var __metadata;
var __awaiter;
var __generator;
(function (factory) {
    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
    }
    else {
        factory(createExporter(root));
    }
    function createExporter(exports, previous) {
        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
    }
})
(function (exporter) {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

    __extends = function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };

    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    __rest = function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };

    __decorate = function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    __param = function (paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    };

    __metadata = function (metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    };

    __awaiter = function (thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    __generator = function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
        return { next: verb(0), "throw": verb(1), "return": verb(2) };
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };

    exporter("__extends", __extends);
    exporter("__assign", __assign);
    exporter("__rest", __rest);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
});

/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var DragHelper = __webpack_require__(17);
/**
 * @depends diy.tooltip.js
 */
var ModuleHelper = (function (_super) {
    tslib_1.__extends(ModuleHelper, _super);
    function ModuleHelper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.restrictedTooltipOptions = {};
        // How much room to leave at the top before flipping the tooltip
        _this.tooltipFlipThresh = 50;
        return _this;
    }
    ModuleHelper.prototype.setError = function (error) {
        if (error === null) {
            if (this.element.is(':diy-tooltip')) {
                this.element.diy_tooltip('hide');
            }
            return;
        }
        if (!this.element.is(":diy-tooltip")) {
            this.element.diy_tooltip($.extend({
                cls: 'restrictedAreaTooltip diy-alert-tooltip',
                triggerMode: 'none',
                fadeInDelay: 300,
                fadeOutDelay: 100,
                appendTo: this.element
            }, this.restrictedTooltipOptions));
        }
        this.element.diy_tooltip('option', 'content', error);
        this.element.diy_tooltip('option', 'anchor', 'top');
        this.element.diy_tooltip('show');
        var flip = this.element.diy_tooltip('widget').offset().top < this.tooltipFlipThresh;
        this.element.diy_tooltip('option', 'anchor', flip ? 'bottom' : 'top');
    };
    return ModuleHelper;
}(DragHelper));
module.exports = ModuleHelper;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 * Class for the draggable helper
 *
 */
var DragHelper = (function () {
    function DragHelper() {
        this.element = null;
        this.originalElement = null;
    }
    /**
     * Method responsible for fabricating the helper element based on
     * the original element
     * @abstract
     */
    DragHelper.prototype.create = function (originalEl) {
        return $();
    };
    /**
     * Creates and sets the helper element
     */
    DragHelper.prototype.createHelper = function (originalEl) {
        this.originalElement = originalEl;
        this.element = this.create(originalEl);
        return this.element;
    };
    /**
     * Shows feedback when the item can't be dropped
     * @abstract
     */
    DragHelper.prototype.disable = function () {
        // abstract
    };
    /**
     * Shows feedback when the item can be dropped
     * @abstract
     */
    DragHelper.prototype.enable = function () {
        // abstract
    };
    /**
     * Sets an error message when the item can't be dropped
     * @abstract
     */
    DragHelper.prototype.setError = function (error) {
        // abstract
    };
    /**
     * Updates the visual feedback of the helper whether
     * it can or not be dropped in the current location
     */
    DragHelper.prototype.updateInvitation = function (canDrop, errorMsg) {
        if (canDrop) {
            this.enable();
            this.setError(null);
        }
        else {
            this.disable();
            this.setError(errorMsg);
        }
    };
    return DragHelper;
}());
module.exports = DragHelper;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {Object.defineProperty(exports, "__esModule", { value: true });
// Siteadmin iframe hack, except when run in test env (nodejs) where top !== window
if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require. Use 'diy.editor.util.l10n' instead");
}
function tr(msgId, htmlDecode) {
    if (htmlDecode === void 0) { htmlDecode = false; }
    if ('string' !== typeof msgId) {
        return undefined;
    }
    var msg = jimdoData.messages;
    var pieces = msgId.split(".");
    for (var _i = 0, pieces_1 = pieces; _i < pieces_1.length; _i++) {
        var piece = pieces_1[_i];
        if (undefined === msg) {
            break;
        }
        msg = msg[piece];
    }
    if (typeof msg === 'string' && msg.length && htmlDecode) {
        msg = diy.editor.htmlDecode(msg);
    }
    if (!msg) {
        // Use translation key when translation is unset
        msg = msgId;
    }
    return msg;
}
;
function getString(msgId, htmlDecode) {
    if (htmlDecode === void 0) { htmlDecode = false; }
    return tr(msgId, htmlDecode);
}
exports.getString = getString;
function getMessages(key) {
    return tr(key);
}
exports.getMessages = getMessages;
exports.default = getString;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var siteadmin = __webpack_require__(20);

(function() {

    /** reference to the site admin */
    var getSiteAdmin = function() {
        return siteadmin;
    };

    /**
     * Retrieves current window object
     *
     * @returns {*|CKEDITOR.dom.window}
     */
    this.getWindow = function () {
        return getSiteAdmin().getController().getWindow();
    };

    /**
     * Modifies window behavior settings of current window with provided data
     *
     * @param {Object} windowBehavior
     */
    this.updateWindowBehavior = function(windowBehavior) {
        this.getWindow().setBehavior(windowBehavior);
    };

    /**
     * updates the content's id from the siteadmin
     *
     * @param {String} title the title to set
     */
    this.updateID = function (id) {
        getSiteAdmin().getController().updateID(id);
    };

    /**
     * updates the content's title from the header area
     *
     * @param {String} title the title to set
     */
    this.updateTitle = function(title) {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.updateTitle(title);
        }
//        getSiteAdmin().getController().updateTitle(title);
    };

    /**
     * updates the content's description from the header area
     *
     * @param {String} descr the description to set
     */
    this.updateDescr = function(descr) {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.updateDescr(descr);
        }
//        getSiteAdmin().getController().updateDescr(descr);
    };

    /**
     * updates the content's navigation tabs
     *
     * @param {Array} navi the html structure of the tabs
     *      Array should be an array of objects with the following parameters:
     *      {
     *          id:    'mytabid',
     *          text:  'Click this tab',
     *          url:   'http://my.absolute.url/my.page'
     *      }
     */
    this.updateNavi = function (navi) {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.updateNavi(navi);
        }
    };

    /**
     * Shows the navigation including tabs
     */
    this.showNavi = function () {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.showNavi();
        }
    };

    /**
     * Hides the navigation including tabs
     */
    this.hideNavi = function () {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.hideNavi();
        }
    };

    this.openActiveController = function() {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.show();
        }
    };

    /**
     * updates the buttons of the window with an object containing desired buttons
     *
     * @param {Object} buttons the buttons properties
     *              {
     *                  close: {
     *                      text: 'Close',
     *                      event: 'closeButtonClicked'
     *                  },
     *                  secondary: {
     *                      text: 'Secondary',
     *                      event: 'secondaryButtonClicked',
     *                  },
     *                  primary: {
     *                      text: 'Primary',
     *                      event: 'primaryButtonClicked',
     *                  },
     *                  checkbox: {
     *                      text: 'Checkbox',
     *                      event: 'checkboxClicked',
     *                  }
     *              }
     */
    this.updateButtons = function(buttons) {
        var activeController = getSiteAdmin().getController();
        if (activeController != null) {
            activeController.updateButtons(buttons);
        }
    };

    /**
     * triggers a menu item action, just as if clicked by the user
     *
     * @param {String} id the id of the DOM element of that button from the site admin
     */
    this.triggerMenuItem = function(id, params) {
        var elem = $('#' + id);
        if (!elem.length) {
            return;
        }
        var specificController = (elem.attr('data-params') || "").split(',')[0].trim();

        getSiteAdmin().sidebarItemClick.call(elem.get(0), 'apiEvent', specificController, params);
    };

    /**
     * internal helper method for set visual active item
     */
    var internalSetSidebarActiveItem = function(id) {
        if ('string' === typeof id) {
            id = $('#' + id).get(0);
        }

        getSiteAdmin().setSidebarActiveItem(id);
        return id;
    };

    /**
     * updates the site admin's active item and record item in history without triggering its action
     *
     * @param {String} id the id of the DOM element of that button from the site admin
     */
    this.setSidebarActiveItem = function(id) {
        id = internalSetSidebarActiveItem(id);
        $(id).historyManager("addRecordOnly");
    };

    /**
     * updates the site admin's active item visual
     *
     * @param {String} id the id of the DOM element of that button from the site admin
     */
    this.setSidebarVisualActiveItem = function(id) {
        internalSetSidebarActiveItem(id);
    };

    /**
     * updates the site admin's window navigation (tabs) active state
     *
     * @param id {String|Number} if it's a string, it will use the "identifier" parameter
     *                           of the navigation link, if it's a number it will be that index
     */
    this.setNaviActiveItem = function(id) {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.setNaviActiveItem(id);
        }
    };

    /**
     * Collapses/expands the siteadmin sidebar
     *
     * @param {boolean} show whether should be shown
     * @param {boolean} noAnimation whether should use animation or not
     */
    this.toggleSidebar = function(show, noAnimation) {
        getSiteAdmin().toggleSidebar(show, noAnimation);
    };

    this.isSidebarMinimized = function() {
        return getSiteAdmin().isSidebarMinimized();
    };

    this.disableCache = function()
    {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.disableCache();
        }
    };

    /**
     * updates the content's save button
     *
     * @param {String} str the string to update the save button with
     */
    this.updateSaveBtn = function(str, callback) {
        getSiteAdmin().getController().updateSaveBtn(str, callback);
    };

    /**
     * shows/hide the loading indicator
     *
     * @param {String} str hide or show
     */
    this.loading = function(str) {
        getSiteAdmin().getController().loading(str);
    };
    /**
     * shows/hide the smaller loading indicator (under the close button)
     *
     * @param {boolean} status hide or show
     * @param {int} bottomDistance Optionally override the distance to the bottom of the container.
     * @param {int} rightDistance Optionally override the distance to the right of the container.
     */
    this.smallLoading = function(status, bottomDistance, rightDistance) {
        var controller = getSiteAdmin().getController();
        if (controller !== null) {
            getSiteAdmin().getController().smallLoading(status, bottomDistance, rightDistance);
        }
    };

    this.saveBtnClicked = function(a,b,c) {
        getSiteAdmin().getController().saveBtnClicked(a,b,c);
    };

    this.showWindow = function(src, windowBehavior, contentType, controller, controllerId) {
        getSiteAdmin().showWindow(src, windowBehavior, contentType, controller, controllerId);
    };

    this.getHeaderData = function(src) {
        var a = getSiteAdmin();
        if (a) {
            var c = a.getController();
            if (c) {
                return c.getHeaderData();
            }
        }
    };

    this.close = function(preventDefault, skipCacheCheck) {
        var activeController = getSiteAdmin().getController();
        if (activeController !== null) {
            activeController.close(preventDefault, skipCacheCheck);
        }
    };

    this.show = function() {
        getSiteAdmin().show();
    }

    this.hide = function() {
        getSiteAdmin().hide();
    }

    this.destroyController = function(controllerID, withClose) {
        getSiteAdmin().destroyController(controllerID, withClose);
    };

    this.updateHelpTopic = function(topic) {
        getSiteAdmin().getController().updateHelpTopic(topic);
    };

    this.updateFeatureGuidanceHelp = function(stepId) {
        getSiteAdmin().getController().updateFeatureGuidanceHelp(stepId);
    };

    this.activateCallout = function(elementId, calloutData) {
        getSiteAdmin().activateCallout(elementId, calloutData);
    };
    this.closeCallout = function(elementId) {
        getSiteAdmin().closeCallout(elementId);
    };
    /**
     * shows THE callout for THE new feature
     */
    this.activateNewFeatureCallout = function(){
        getSiteAdmin().activateNewFeatureCallout();
    };
    this.getMinMaxState = function(){
        return getSiteAdmin().getMinMaxState();
    };
    this.disableCalloutFeature = function(featureId) {
        getSiteAdmin().disableCalloutFeature(featureId);
    };

    this.buttonEnable = function (buttonId){
        return getSiteAdmin().buttonEnable(buttonId);
    };

    this.buttonDisable = function (buttonId){
        return getSiteAdmin().buttonDisable(buttonId);
    };

    this.setParams = function (params) {
        return getSiteAdmin().setParams(params);
    };

    this.getParams = function () {
        return getSiteAdmin().getParams();
    };

    return this;

}).call(exports);


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Site Admin Main Class
 *
 * @class siteadmin
 * @depends on jquery.actionController.js
 * @author Mihai Curelea
 *
 */

var $ = __webpack_require__(3);
var Modernizr = __webpack_require__(21);
var domUtils = __webpack_require__(22);
var Controller = __webpack_require__(23);
var appsCatalog = __webpack_require__(11);
var api = __webpack_require__(19);
var features = __webpack_require__(25);

(function () {

    var self = this,
        $siteAdmin,
        $sidebar,
        $sidebarPlaceholder,
        animSpeed = 300, /* animation speed in Site Admin */
        sidebarActiveElem = null, /* reference to the active element in Site Admin */
        minimized = 0, /* whether the SiteAdmin bar is minimized */
        initialized = false, /* whether init was called and SiteAdmin is available */
        controller, /* reference to the site admin controller */
        params = null, /* params sent when opening a siteAdmin window */
        offsetMemory = null,
    //remember if we have an callout instance, so we don't call
    //methods or set options with no instance
        calloutInitFlag = false,
        controllers,
        activeControllerId,

        /** Was siteadmin window open when we collapsed the sidebar last time? */
        wasWindowOpenBeforeCollapse = false,

        initAccordion = function () {
            var expand = 'cc-sa-item-diy';

            $sidebar.find('#' + expand).addClass('cc-sa-open');
            $sidebar.find('>ul>li>a:not(#' + expand + ')').parent().find('>ul>li').hide();
        },

        buttonDisable = function (elementId, $element) {
            if (typeof $element !== "object") {
                $element = $sidebar.find('#' + elementId);
            }
            if ($element.size() > 0) {
                var $parent = $element.parent();
                $parent.addClass('cc-sa-disabled');
                $element.addClass('cc-sa-disabled').removeClass('cc-sa-active');
                $parent.children('div.eventBlocker').remove();
                $parent.append('<div class="eventBlocker" style="width:' + $parent.width() + 'px; height:' + $parent.height() + 'px;"></div>');
                return true;
            }
            return false;
        },

        buttonEnable = function (elementId, $element) {
            if (typeof $element !== "object") {
                $element = $sidebar.find('#' + elementId);
            }
            if ($element.size() > 0) {
                var $parent = $element.parent();
                $parent.removeClass('cc-sa-disabled');
                $parent.children('div.eventBlocker').remove();
                $element.removeClass('cc-sa-disabled');
                return true;
            }
            return false;
        };

    this.buttonDisable = buttonDisable;
    this.buttonEnable = buttonEnable;


    var expandGroup = function (el) {
        /* hide all children */
        $sidebar.find('>ul>li').find('>ul>li').hide();

        /* is the element we want to ensure is expanded a group or a button ? */
        var isGroup = $('#' + el.id).hasClass('cc-sa-sidebar-primary');

        /* if it is a group, ensure all his children are visible */
        if (isGroup) {

            /* as soon as you expand another group, the current window should close */
            if ($('#' + el.id).hasClass('noSiteAdminAction') && !$('#' + el.id).hasClass('cc-sa-open')) {
//                controller.close();
            }

            $sidebar.find('.cc-sa-sidebar-primary.cc-sa-open').removeClass('cc-sa-open');

            $sidebar.find('>ul>li>a#' + el.id).parent().find('>ul>li').show();
            $sidebar.find('#' + el.id).addClass('cc-sa-open');
        } else {
            /* when building the fbpb bar, the following line will be modified to support
             the desired facelift behavior */
            //$sidebar.find('.cc-sa-sidebar-primary.cc-sa-active').removeClass('cc-sa-active');
            $sidebar.find('>ul>li>ul>li>a#' + el.id).closest('ul').find('li').show();
        }
        $sidebar.find('>ul>li>ul>li>a.cc-sa-disabled').each(function () {
            buttonDisable(null, $(this));
        });
    };

    /**
     * checks if the window height is smaller/bigger than the sideadmin's height
     * and positions the siteadmin absolute or fixed
     * also triggers the diy-siteadmin-position-scheme-set in order for other
     * components (such as the simpleCallout) to be notified of the position changed
     */
    var lastScroll = $(window).scrollTop();
    var lastScrollIsDown = true;
    var checkPosition = function () {
        if (self._isHidden === true) {
            return;
        }

        var scrollTop = $(window).scrollTop();

        if (diy.editor.uiPreference.isPointerModeTouch()) {
            if (scrollTop < 0 || scrollTop >= document.documentElement.scrollHeight - window.innerHeight) {
                return;
            }
        }

        var scrollIsDown = null;
        var positionCSS = null;
        var currentPosition = $siteAdmin.css('position');

        //consider known top elements that push the site-admin down
        var considerOffset = diy.editor.positioning.calculateTopOffset();
        var winHeight = window.innerHeight;
        var siteAdminHeight = $siteAdmin.height();

        $('.diyw').css('min-height', siteAdminHeight + 'px');

        var lowestOffsetPosition = diy.editor.positioning.calculateLowestOffsetPosition();

        if ((winHeight - lowestOffsetPosition + scrollTop) < siteAdminHeight && scrollTop > 0) {
            positionCSS = {
                position: 'absolute',
                right: 'auto',
                left: $(window).width() + $(window).scrollLeft() - $sidebar.width(),
                top: considerOffset
            };

            // When page get refreshed with scroll, or siteadmin gets minimized / maximized
            // position the siteadmin with the top part visible, but beware not to get over bottom of the page
            if (scrollTop > 0) {
                if ($(document).height() - siteAdminHeight < scrollTop) {
                    positionCSS.top = $(document).height() - siteAdminHeight;
                } else {
                    positionCSS.top = lowestOffsetPosition;
                }

                if (arguments.length > 0 && arguments[0] instanceof jQuery.Event) {
                    var siteAdminTopOffset;
                    if (!/webkit.*mobile/i.test(navigator.userAgent)) {
                        siteAdminTopOffset = $siteAdmin.offset().top;
                    } else {
                        siteAdminTopOffset = diy.editor.positioning.calculateAbsoluteOffset($siteAdmin.get(0)).top;
                        if (domUtils.isFixedPosition($siteAdmin)) {
                            siteAdminTopOffset += window.scrollY;
                        }
                    }

                    if (scrollTop > lastScroll) {
                        scrollIsDown = true;
                    } else if (scrollTop < lastScroll) {
                        scrollIsDown = false;
                    } else {
                        scrollIsDown = lastScrollIsDown;
                    }
                    //Determines up-or-down scrolling
                    if (scrollIsDown) {
                        if (scrollTop + winHeight >= siteAdminHeight + siteAdminTopOffset) {
                            positionCSS.position = 'fixed';
                            positionCSS.right = '0';
                            positionCSS.left = 'auto';
                            //positionCSS.top = scrollTop + winHeight - siteAdminHeight;
                            positionCSS.top = winHeight - siteAdminHeight;
                        } else {
                            positionCSS.top = siteAdminTopOffset;
                        }
                    } else {
                        if (siteAdminTopOffset >= lowestOffsetPosition) {
                            positionCSS.position = 'fixed';
                            positionCSS.right = '0';
                            positionCSS.left = 'auto';
                            //positionCSS.top = lowestOffsetPosition;
                            positionCSS.top = lowestOffsetPosition - scrollTop;
                        } else {
                            positionCSS.top = siteAdminTopOffset;
                        }
                    }
                    if (scrollTop == lastScroll) {
                        return;
                    }
                    //Updates scroll position
                    lastScroll = scrollTop;
                    lastScrollIsDown = scrollIsDown;
                }
            }
        } else {
            //calculate the top
            var newPositionTop = diy.editor.positioning.calculateTopFixedOffset();

            positionCSS = {
                position: 'fixed',
                right: '0px',
                left: 'auto',
                top: newPositionTop
            };
        }
        $siteAdmin.css(positionCSS);

        /* Trigger an event telling the SiteAdmin bar
         has decided what position scheme to use.
         Will be useful to position stuff relative to it. */
        if (currentPosition !== positionCSS.position) {
            $siteAdmin.trigger('diy-siteadmin-position-scheme-set');
        }
    };

    /**
     * SiteAdmin init method,
     * gets called upon creating the global constructor
     */
    this.init = function () {

        controllers = {};

        /* instantiate the controller */
//        controller = new Controller();
//        controller.init();

        /* init site admin help button */
        try {
            cms.help.GuidedAssistant.getInstance()._initSiteAdminButton(cms.help.GuidedAssistant.options.siteAdminButtonId);
            cms.help.GuidedAssistant.getInstance()._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
        } catch (e) {
        }


        $('#cc-sa-item-privateTariffUpgrade').click(function (e){
            e.preventDefault();
            if (!features('upsellDirectLink')) {
                diy.editor.upgradeLayer.showUpgradeWindow();
            } else {
                diy.editor.upgradeLayer.openUpgradePopup();
            }
        });

        /* set the variables to their dom elements */
        $siteAdmin = $('#cc-sa');
        $sidebar = $('#cc-sa-sidebar');
        $sidebarPlaceholder = $('#cc-sa-sidebar-minimized');

        /* initializing the action controller */
        $siteAdmin.actionController(this, {history: true});

        /* which groups should be opened */
        initAccordion();

        /* show the siteadmin bar */
        $siteAdmin.show();

        /* load minimized status from the cookie */
        minimized = parseInt($.cookie('diy-siteadmin-sidebar-minimized'), 10) || 0;

        /* if is a device with touch (tablets or mobiles) we minimize the sitebar */
        if (diy.editor.uiPreference.isPointerModeTouch() && minimized !== 1) {
            minimized = 1;
        }

        if (minimized) {
            toggleSidebar(false, true);
        }

        /* if the window height is smaller than the siteadmin's
         height, then the siteadmin will scroll with the window */
        /*
         * Siteadmin-Fix for small resolutions:
         * If browser-height is less than siteadmin-height we will set it position:absolute
         * to ensure the option to close the siteadmin. Otherwise we will set it to position:fixed.
         */
        $(window).bind('resize', checkPosition);
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            $(window).bind('scroll', $.throttle(300, checkPosition));
        } else {
            $(window).bind('scroll', checkPosition);
        }
        $(document).bind('diy-editor-toolbar-repositioned', checkPosition);
        setTimeout(checkPosition, 20);

        initialized = true;
        $siteAdmin.trigger('diy-siteadmin-initialized');

        /* Trigger an event telling the SiteAdmin bar
         has decided what position scheme to use.
         Will be useful to position stuff relative to it. */
        $siteAdmin.trigger('diy-siteadmin-position-scheme-set');

        /* listen for the active sidebar item event
         this event can be triggered to change the display state of a site admin button */
        $sidebar.bind("diy-siteadmin-active-sidebar-item", function (ev, itemId, setActive, resetCurrentActive) {
            self.toggleSidebarItem($sidebar.find("#" + itemId), setActive, resetCurrentActive);
        });

        /* what to do when a site admin window has been closed */
        $(document).bind('diy-siteadmin-window-closed', function (e, controller) {
            $(sidebarActiveElem).removeClass('cc-sa-active');
        });

        diy.editor.deeplinking.registerHandler(function (item) {
            var itemButton = $sidebar.find("#cc-sa-item-" + item);
            if (itemButton.length === 0) {
                throw new Error('Siteadmin item ' + item + 'not found');
            }
            itemButton.click();
        }, 'siteadmin');
    };

    this.isInitialized = function () {
        return initialized;
    };

    this.beforeSidebarItemClick = function (e, specificController) {
        var activeController = self.getController(),
            controllerName = null,
            allow = true,
            controller = null,
            newControllerName = specificController,
            newController = null;

        Modul.abortEditingModules();

        //get from the current controller if it allows the switch
        if (activeController) {
            controllerName = activeController.getControllerName();
        }

        //if the prev controller allows swithcing away
        if (controllerName) {
            controller = diy.editor.siteadmin.controllers[controllerName];
            if (controller &&
                controller.hasOwnProperty('allowSwitch')
            ) {
                allow = controller.allowSwitch();
            }
        }

        //if the new controller allows opening
        if (allow === true) {
            newController = diy.editor.siteadmin.controllers[newControllerName];
            if (newController &&
                newController.hasOwnProperty('allowOpen')
            ) {
                allow = newController.allowOpen();
            }
        }
        return allow;

    };

    this.getMinMaxState = function () {
        var state = 'max',
            currentllyOpenedController = self.getController();
        if (currentllyOpenedController) {
            state = currentllyOpenedController.getMinMaxState();
        }
        return state;
    };

    /*
     * Display the navigation right after the siteadmin content is loaded. This is necessary because on the sidebarItemClick()
     * call we hide the navigation, title and description of the current loaded window in order to prevent displaying
     * the previous window header information while the new content is being loaded. So, when the client opens a new
     * window we hide the previous opened window metadata: title, description and navigation. The new metadata is
     * currently available only after the content is fully loaded so this is why we have to bind to the
     * "diy-siteadmin-content-loaded" event.
     *
     * @see: DHDIYED-265
     */
//    $(document).bind('diy-siteadmin-content-loaded', function(){
//        controller.showNavi();
//    });

    /**
     * Action taken when a click is performed on a SiteAdmin item
     *
     * @param {Event} e the event received
     * @param {string} controller the name of the controller
     * @param {object} params send params to the site admin section that will open
     */
    this.sidebarItemClick = function (e, specificController, params) {
        if ($(this).hasClass('cc-sa-active')) {
            return false;
        }

        var currentlyOpenController = self.getController();
        if (currentlyOpenController && currentlyOpenController.isOpened()) {
            currentlyOpenController.close(true);
        }


        /*
         * Hide the navigation, title and description of the current loaded window so that it won't
         * be visible until the new content has been loaded; When the new content is loaded the new [navigation], title and
         * description will be rendered.
         *
         * @see: DHDIYED-265
         */
//        controller.hideNavi();
//        controller.updateTitle('');
//        controller.updateDescr('');

        /* track that the sidebar item has been clicked */
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: $(this).attr('id').replace('cc-sa-item-', ''),
            trackingParams: params
        });
        /* save the timestamp for other tracking points */
        $(document).trigger('diy-editor-saveUserClickTimestamp', {
            sectionCodeName: $(this).attr('id').replace('cc-sa-item-', '')
        });

        $(document).trigger('diy-editor-siteadmin-sectionOpened');

        /* make sure the group of the item or the group itself is expanded */
        expandGroup(this);

        var isGroup = $(this).hasClass('cc-sa-sidebar-primary');
        if (isGroup) {
            $sidebar.find(".cc-sa-sidebar-primary").removeClass('cc-sa-active');
            $(this).addClass('cc-sa-active');
            $(document).trigger('diy-siteadmin-window-closed');
            if (activeControllerId && controllers[activeControllerId]) {
                controllers[activeControllerId].close();
            }
        }

        /* if the action should not be handled by SiteAdmin controller */
        if ($(this).hasClass('noSiteAdminAction')) {
            if (! $(this).hasClass('noActiveState')) {
                $(this).addClass('cc-sa-active');
            }
            return false;
        }

        /* set any params sent when opening the window */
        self.setParams(params);

        if (specificController === 'appsCatalog') {
            if ($(this).data('customHref') || params) {
                self.destroyController('cc-sa-item-appscatalog');
            }
        }

        if (specificController === 'sectionSelector') {
            self.destroyController('cc-sa-item-sections');
        }

        if (!controllers[$(this).attr('id')]) {
            if (specificController === 'appsCatalog') {
                /* when call made with actual event*/
                if ($.isPlainObject(e)) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                var url = $(this).attr('href');
                var customUrl = $(this).data('customHref');
                $(this).data('customHref', null);
                if (customUrl) {
                    url = customUrl;
                }
                if (url) {
                    appsCatalog.open(url, false);
                }
            } else {

                activeControllerId = $(this).attr('id');

                controllers[activeControllerId] = new Controller();
                controllers[activeControllerId].init();

                /* set window behavior and content type */
                controllers[activeControllerId].load({
                    element: this,
                    controller: specificController,
                    windowBehavior: $(this).attr('data-window-behavior'),
                    contentType: $(this).attr('data-content-type'),
                    originalWindowBehavior: $(this).attr('data-window-behavior')
                });

                /* show the controller */
                controllers[activeControllerId].show();

            }
        } else {
            activeControllerId = $(this).attr('id');
            /* show the controller */
            controllers[activeControllerId].show(true);

        }

        /* make the SiteAdmin item look active */
        self.setSidebarActiveItem(this);

        if (minimized) {
            toggleSidebar(true, true);
        }

        return false;
    };

    /**
     * Slide the SiteAdmin up
     */
    this.sidebarSlideUpClick = function () {
        toggleSidebar(false);
        return false;
    };

    /**
     * Slide the SiteAdmin down
     */
    this.sidebarSlideDownClick = function () {
        toggleSidebar(true);
        return false;
    };

    /**
     * Show the window and eventually load a src
     *
     */
    this.showWindow = function (src, windowBehavior, contentType, customController, controllerId) {
        activeControllerId = controllerId;

        if (!controllers[activeControllerId]) {
            controllers[activeControllerId] = new Controller();
            controllers[activeControllerId].init();

            /* load the controller */
            controllers[activeControllerId].load({
                element: {
                    href: src
                },
                controller: customController || null,
                windowBehavior: windowBehavior || $(this).attr('data-window-behavior'),
                contentType: contentType || $(this).attr('data-content-type'),
                originalWindowBehavior: $(this).attr('data-window-behavior')
            });
            controllers[activeControllerId].show();
        } else {
            /* shows the window */
            controllers[activeControllerId].show(true);
        }

        /* set active Site Admin item */
        self.setSidebarActiveItem(sidebarActiveElem);

        /* if the Site Admin is minimized, show the Site Admin */
        if (minimized) {
            toggleSidebar(true, true);
        }
    };

    /**
     * Sets the current Site Admin item
     *
     * @param elem the element
     */
    this.setSidebarActiveItem = function (elem) {
        /* window must be opened and element must exist */
        if (!controllers[activeControllerId].isOpened() || !elem) {
            return;
        }

        /* remove active class from the active element */
        $(sidebarActiveElem).removeClass('cc-sa-active');

        /* remove any styles added to pointer elements */
        $(sidebarActiveElem).find('.cc-sa-sidebar-selected-pointer').attr('style', '');

        /* set the current Site Admin element */
        sidebarActiveElem = elem;

        /* make it active */
        $(elem).addClass('cc-sa-active');

        /* update the id made active and */
        api.updateID(elem.id);
    };

    /**
     * Toggles a Site Admin item
     *
     * @param $elem the element it should toggle
     * @param setActive whether to set it active
     * @param resetCurrentActive whether it should reset the current active one
     */
    this.toggleSidebarItem = function ($elem, setActive, resetCurrentActive) {
        if (setActive) {
            if (resetCurrentActive) {
                $(sidebarActiveElem).removeClass('cc-sa-active');
                sidebarActiveElem = elem;
            }
            $elem.addClass('cc-sa-active');
        } else {
            $elem.removeClass('cc-sa-active');
        }
    };

    /**
     * Toggle Site Admin
     *
     * @param {boolean} show whether should be shown
     * @param {boolean} noAnimation whether should use animation or not
     */
    function toggleSidebar(show, noAnimation) {
        if ($sidebar.is(":visible") === !!show) {
            return false;
        }

        var activeController = self.getController();
        var siteAdminWindow = activeController ? activeController.getWindow() : null;
        if (!show && noAnimation) {
            $sidebar.hide();
            if (siteAdminWindow) {
                wasWindowOpenBeforeCollapse = siteAdminWindow.isOpened();
                siteAdminWindow.hide();
            }
            if (diy.editor.uiPreference.isPointerModeTouch()) {
                $('#cc-sa-sidebar-header').addClass('toggledOff');
            }
            $sidebarPlaceholder.show();
            ready();
            checkPosition();
        } else if (show) {
            if (diy.editor.uiPreference.isPointerModeTouch()) {
                $('#cc-sa-sidebar-header').removeClass('toggledOff');
            }
            $sidebarPlaceholder.slideUp(animSpeed, function () {
                $sidebar.slideDown(animSpeed, function () {
                    ready();
                    checkPosition();
                });
                if (wasWindowOpenBeforeCollapse) {
                    siteAdminWindow && siteAdminWindow.show();
                }
            });
        } else if (!show) {
            wasWindowOpenBeforeCollapse = siteAdminWindow && siteAdminWindow.isOpened();
            ready();
            $sidebar.slideUp(animSpeed, function () {
                if (diy.editor.uiPreference.isPointerModeTouch()) {
                    $('#cc-sa-sidebar-header').addClass('toggledOff');
                }

                $sidebarPlaceholder.slideDown(animSpeed, function () {
                    checkPosition();
                });
            });
            siteAdminWindow && siteAdminWindow.hide();
        }

        function ready() {
            $(document).trigger('diy-siteadmin-sidebar-toggled', [show, noAnimation]);
            minimized = show ? 0 : 1;
            $.cookie('diy-siteadmin-sidebar-minimized', minimized, {
                expires: 300,
                path: '/'
            });
            $('#cc-sa-sidebar-header').css('cursor', show ? 'auto' : 'pointer');
        }
    }

    this.toggleSidebar = toggleSidebar;

    this.hide = function() {
      // this flag is used to disable
      // resposition on window scroll/resize (see checkPosition)
      self._isHidden = true;
      $('#cc-sa').addClass('is-hidden is-transition-enabled');
    };

    this.show = function() {
      var $sa = $('#cc-sa');
      $sa.removeClass('is-hidden');
      setTimeout(function() {
        $sa.removeClass('is-transition-enabled');
        self._isHidden = false;
        checkPosition();
      }, 300); // the same as `transition-duration`
    };

    this.isSidebarMinimized = function () {
        return minimized ? true : false;
    };

    this.getSidebarContainer = function () {
        return $sidebar;
    };

    this.getSidebarActiveElem = function () {
        return sidebarActiveElem;
    };

    this.destroyController = function (controllerId, withClose) {
        if (controllers[controllerId]) {
            if (withClose === true) {
                controllers[controllerId].close(true, true);
            }
            controllers[controllerId].destroy();
            delete controllers[controllerId];
        }
    };

    this.getActiveControllerId = function () {
        return activeControllerId;
    };

    this.getController = function (controllerId) {

        if ('string' === typeof controllerId) {
            if ('object' === typeof controllers && 'object' === typeof controllers[controllerId]) {
                return controllers[controllerId];
            }
        } else if ('string' === typeof activeControllerId) {
            if ('object' === typeof controllers && 'object' === typeof controllers[activeControllerId]) {
                return controllers[activeControllerId];
            }
        }
        return null;
    };
    /**
     * this is mainly dictated by: cms_Element_TemplateBuilderCMS::newFeatureProperties()
     */
    this.activateNewFeatureCallout = function () {
        //this time showing the callout for layouts
        var calloutData = {
            cls: 'wt-reinvoke-callout', //used in the past: 'diy-simple-callout-apps-catalog', 'module-selector-callout', 'wt-reinvoke-callout'
            featureId: jimdoData.newFeatureCallout.featureId,
            hideDelay: 20000, //NOTE: autohide also disables it
            hideLeftButton: true,
            hideRightButton: true,
            text: {
                title: jimdoData.messages.newFeatureCallout.title,
                content: jimdoData.messages.newFeatureCallout.content
            }
        };
        var saId = jimdoData.newFeatureCallout.siteAdminId;
        this.activateCallout(saId, calloutData);
        //never show callout again (user can refresh in the 20 seconds period)
        this.disableCalloutFeature(jimdoData.newFeatureCallout.featureId);
    };

    this.closeCallout = function (elementId) {
        if (!this.isInitialized()) {
            $(document).one('diy-siteadmin-initialized', '#cc-sa', function () {
                self.closeCallout(elementId);
            });
            return;
        }
        var $target = $('#' + elementId).first();
        if (!$target.length) {
            return;
        }

        if (!$target.is(':diy-simpleCallout')) {
            return
        }
        if (calloutInitFlag == true) {
            $target.diy_simpleCallout('close');
        }
    };

    this.activateCallout = function (elementId, calloutData) {
        if (!this.isInitialized()) {
            $(document).one('diy-siteadmin-initialized', '#cc-sa', function () {
                self.activateCallout(elementId, calloutData);
            });
            return;
        }

        var $target = $('#' + elementId).first();
        if (!$target.length) {
            return;
        }

        if (!$target.is(':diy-simpleCallout')) {
            _initCallout($target, calloutData);
        }

        showCallout($target);
    };

    /**
     * returns object type variable representing parameters sent when opening the SA window
     * @return {Object|null}
     */
    this.getParams = function () {
        return this.params;
    };

    /**
     * @param object params sent when opening a siteadmin window
     * @example when we try to open layout selector window to the recommended tab
     */
    this.setParams = function (params) {
        if (jQuery.isPlainObject(params)) {
            this.params = params;
        } else {
            this.params = null;
        }
    };

    var disableCalloutFeature = function (featureId) {
        $.ajax({
            url: '/app/help/service/disable-sidebar-callout/?id=' + featureId
        });
    };

    this.disableCalloutFeature = disableCalloutFeature;

    var showCallout = function ($target) {
        if (!calloutInitFlag) {
            return;
        }
        $target.diy_simpleCallout('show');
    };

    var hideCallout = function ($target) {
        if (!calloutInitFlag) {
            return;
        }
        $target.diy_simpleCallout('hide');
    };

    var _initCallout = function ($target, calloutData) {

        var refreshPosition = function () {
            if (calloutInitFlag == true) {
                $target.diy_simpleCallout('option', 'positionMode',
                    $siteAdmin.css('position') == 'fixed' ? 'fixed' : 'absolute');
            }
        };

        // code to run when the callback is disabled //
        var disableCallout = function () {
            if (!calloutInitFlag) {
                return;
            }

            if (calloutData.featureId) {
                disableCalloutFeature(calloutData.featureId);
            }
            $target.diy_simpleCallout('destroy');
            calloutInitFlag = false;
            jQuery(document).unbind('.diy-simple-callout');
            $siteAdmin.unbind('diy-siteadmin-position-scheme-set', refreshPosition);
        };

        // add the callout to the page //
        var calloutSettings = {
            positionMode: calloutData.positionMode ? calloutData.positionMode :
                ($siteAdmin.css('position') == 'fixed' ? 'fixed' : 'absolute'),
            anchor: calloutData.anchor ? calloutData.anchor : 'left',
            cls: calloutData.cls || null,
            zIndex: calloutData.zIndex > 0 ? calloutData.zIndex : 100100, // this is the same z-index like the Side Bar

            title: calloutData.text.title,
            content: calloutData.text.content,
            close: $.isFunction(calloutData.close) ? function () {
                calloutData.close();
                disableCallout();
            } : disableCallout,
            show: $.isFunction(calloutData.show) ? calloutData.show : null,
            footer: !(calloutData.hideLeftButton && calloutData.hideRightButton),
            triggerMode: calloutData.triggerMode,
            buttons: {
                left: !calloutData.hideLeftButton && {
                    text: calloutData.text.close,
                    handler: disableCallout
                },
                right: !calloutData.hideRightButton && {
                    text: calloutData.text.show,
                    handler: function () {
                        disableCallout();
                        if (typeof calloutData.callback == "function") {
                            calloutData.callback.call();
                        } else {
                            $target.click();
                        }
                    }
                }
            }
        };
        if (calloutData.triggerMode) {
            calloutSettings.triggerMode = calloutData.triggerMode;
        }

        if (calloutData.fadeInDelay) {
            calloutSettings.fadeInDelay = calloutData.fadeInDelay;
        }

        $target.diy_simpleCallout(calloutSettings);
        calloutInitFlag = true;

        if (calloutData.hideDelay) {
            setTimeout(disableCallout, calloutData.hideDelay);
        }

        $siteAdmin.bind('diy-siteadmin-position-scheme-set', refreshPosition);

        // register a handler for when clicking on menu items //
        $('div#cc-sa div#cc-sa-sidebar a[data-action=sidebarItem]')
            .bind('click.diy-simple-callout', function () {

                // the specified item is clicked //
                if (this == $target[0]) {
                    disableCallout($target, calloutData);
                    // something else is clicked //
                } else {
                    if ($(this).attr('id') == "cc-sa-item-assistant") {
                        return;
                    }

                    hideCallout($target);
                }
            });

        // register handlers for when minimizing and maximizing the SA side bar //
        $('div#cc-sa *[data-action=sidebarSlideUp]').click(function () {
            hideCallout($target);
        });
        $('div#cc-sa *[data-action=sidebarSlideDown]').click(function () {
            // allow for animation //
            setTimeout(function () {
                // the SA bar can open back the window in some situations//
                if (!$('div#cc-sa div.sa-window').is(':visible')) {
                    showCallout($target);
                }
            }, 1000);
        });

        // register a handler for when closing the SA //
        $(document).bind('diy-siteadmin-window-closed.diy-simple-callout', function () {
            showCallout($target);
        });
    };

    return this;

}).call(exports);


/***/ },
/* 21 */
/***/ function(module, exports) {

module.exports = Modernizr;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
module.exports = {
    /**
     * Checks recursively if the passed element or one of its parents has fixed position
     * @param {jQuery|String|HTMLElement} selector
     * @returns {boolean}
     */
    isFixedPosition: function (selector) {
        var $elem = $(selector);
        var targetIsFixed = $elem.parents().add($elem).filter(function (i, elem) {
            return $(elem).css('position') === 'fixed';
        }).length;
        return targetIsFixed > 0;
    }
};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Default controller for Site Admin
 *
 * @class Controller
 * @depends jquery.actionController.js
 * @author Mihai Curelea
 */

var $ = __webpack_require__(3);
var Modernizr = __webpack_require__(21);
var Window = __webpack_require__(24);
var siteadmin = __webpack_require__(20);

var Controller = function () {

    var self = this;

    this.disabledCache = false;

    var saWindow = null;
    /* Site Admin window */
    var params = null;
    /* params received when loading this controller */
    var SAC = null;
    /* Site Admin Content for the opened IFrame content */

    /* the cache store is used to store json payloads
     coming from the server, so that the second times won't be
     fetched */
    var cacheStore = {};
    /* which controllers should be cached. usually the ones with static data */
    var cacheControllers = ['layoutSelector', 'theming'];

    /* removes a controller from the cache */
    this.clearCache = function (controllerName) {
        if (controllerName in cacheStore) {
            delete cacheStore[controllerName];
        }
    };

    this.getControllerName = function () {
        if (params) {
            return params.controller;
        }
        return null;
    };

    this.getWindow = function () {
        return saWindow;
    };

    this.destroy = function () {
        saWindow.destroy();
    };

    this.disableCache = function () {
        this.disabledCache = true;
    };

    this.init = function () {
        /* init the Site Admin Window */
        saWindow = new Window(this);
        saWindow.init();

        /* init site admin help button */
        try {
            parseHelpLinks();
        } catch (e) {
        }

        $(document).bind('diy-siteadmin-external-ready', function (e, callback) {
            saWindow.loadingBox.hide();
            self.keepalive.refresh();

            if ('function' === typeof callback) {
                try {
                    callback(diy.editor.siteadmin.api);
                }
                catch (exception) {
                    // ...
                }
            }
        });
    };

    this.updateHelpTopic = function (topic) {
        saWindow.updateHelpTopic(topic);
    };

    this.updateFeatureGuidanceHelp = function (stepId) {
        saWindow.updateFeatureGuidanceHelp(stepId);
    };

    /**
     * sends unload event to the SAC inside the iframe
     */
    this.unloadSAC = function () {
        try {
            if (SAC) {
                SAC.$wnd.trigger('unload');
                SAC = null;
            }
        } catch (e) {
        }
        // clear all content
        //$('#cc-sa-window-content').empty();
    };

    /**
     * resize the SAC inside the iframe based on the window size
     */
    this.resizeSAC = function () {
        try {
            var cw = saWindow.getContentWrapper();
            if (SAC && cw.width() > 0 && cw.height() > 0) {
                SAC.resize({
                    height: cw.height(),
                    width: cw.width()
                });
            }
        } catch (e) {
        }
    };

    /**
     * close whatever this controller opened
     */
    this.close = function (preventDefaultCloseAll, skipCacheCheck) {
        if (jQuery.browser.msie) {
            // Bugfix #DHDIYW-874 - On IE11, when switching between two siteadmin
            // sections, if the previous one had a focused input, you can no longer
            // focus/edit anything in the new one. The cause is unknown, but this
            // hack seems so fix the problem, by manually "resetting" the focus
            // We use a dummy text input (it doesn't work with other types of
            // elements) and we put it with position fixed, otherwise the browser
            // will scroll the page when focusing
            jQuery('<input type="text" style="position:fixed;top:0;left:0"/>')
                .appendTo('body')
                .focus()
                .remove();
        }
        saWindow.close();
        this.unloadSAC();
        if (skipCacheCheck !== true && this.disabledCache === true) {
            // destroy the controller without calling the close method on it *again*
            siteadmin.destroyController(
                siteadmin.getActiveControllerId(),
                false
            );
        }
        if (preventDefaultCloseAll !== true) {
            /* also add close hash */
            var currentHash = window.top.location.hash;
            if ('#close-all' !== currentHash) {
                var loc = window.top.location,
                    href = loc.protocol + '//';
                href += loc.host;
                href += loc.pathname;
                href += loc.search;
                href += '#hm:cc-sa-window-close';
                window.top.location.href = href;
            }

            if (diy.editor.uiPreference.isPointerModeTouch()) {
                diy.editor.siteadmin.api.toggleSidebar(false);
            }
        }
    };

    this.load = function (o) {
        /* make sure SAC is unloaded before */
        this.unloadSAC();

        saWindow.headerData = {};
        saWindow.footerData = {};

        params = o;

        params.contentType = params.contentType || 'iframe-local';

        if (params.hasOwnProperty('windowBehavior')) {
            this.attachWindowBehavior(params.windowBehavior);
        }

        if (params.hasOwnProperty('originalWindowBehavior')) {
            try {
                var originalWindowBehavior = $.parseJSON(params.originalWindowBehavior);
                saWindow.originalWindowBehavior = originalWindowBehavior;
            } catch (e) {
            }
        }

        saWindow.setContentType(params.contentType);

        /* set the controller name to the window */
        saWindow.setAttribute(params.controller);
    };

    /**
     * extracted method from this.load
     * @param behavior
     */
    this.attachWindowBehavior = function (behavior) {
        var windowBehaviorObj = null;
        try {
            windowBehaviorObj = $.parseJSON(behavior || 'null');
        } catch (e) {
        }


        if (windowBehaviorObj !== null && windowBehaviorObj.hasOwnProperty('size')) {
            var view_port = $(window).height();
            windowBehaviorObj.size.height = Math.min(windowBehaviorObj.size.height, view_port);
            params.windowBehavior = JSON.stringify(windowBehaviorObj);
        }

        if (windowBehaviorObj !== null &&
            windowBehaviorObj.hasOwnProperty('cacheWindow') &&
            windowBehaviorObj.cacheWindow === false) {
            this.disabledCache = true;
        }
        saWindow.setBehavior(params.windowBehavior);
    };

    this.unload = function (obj, data) {
        if (params && params.controller && diy.editor.siteadmin.controllers[params.controller] && 'function' === typeof diy.editor.siteadmin.controllers[params.controller].unload) {
            diy.editor.siteadmin.controllers[params.controller].unload(obj, data);
        }

        params = null;
    };

    this.onSacReady = function (e, wnd) {
        if (siteadmin.getActiveControllerId() !== saWindow.getID() && !saWindow.isOpened()) {
            //ready event triggered when another window is opened
            //@todo: figure another way to do this without braking SA tab switching
            //return;
        }

        /* copy needed data inside the iframe */
        $.extend(wnd, {
            CC: CC,
            jimdoData: jimdoData
        });

        /* add history plugins */
        wnd.jQuery.fn.historyManager = $.fn.historyManager;
        wnd.jQuery.fn.history = $.fn.history;

        /* init constructors inside the iframe */
        wnd.jQuery.construct('*', 'create');

        /* set local SAC variable to the current controller inside the iframe */
        SAC = wnd.SAC;

        /* resize the SAC */
        self.resizeSAC();

        /* initialize help system */
        SAC.bindHelpLinkClick();

        /* resize the window */
        saWindow.resize();
    };

    this.show = function (dst) {
        saWindow.show();
        if (!dst) {
            this.setContent(params.element);
        }
    };

    this.allowHide = function () {
        var activeController = siteadmin.getController(),
            controllerName = null, controller, allowHide = true;
        //get from the current controller if it allows the switch
        if (activeController) {
            controllerName = activeController.getControllerName();
        }
        //if the prev controller allows swithcing away
        if (controllerName) {
            controller = diy.editor.siteadmin.controllers[controllerName];
            if (controller &&
                controller.hasOwnProperty('allowSwitch')
            ) {
                allowHide = controller.allowSwitch();
            }
        }
        return allowHide;
    };

    this.hide = function () {
        saWindow.hide();
    };

    this.unbindEvent = function() {
        $(document).unbind('diy-siteadmin-sac-ready', this.onSacReady);
    };

    this.bindEvent = function() {
        this.unbindEvent();
        $(document).bind('diy-siteadmin-sac-ready', this.onSacReady);
    };

    this.setContent = function (el) {
//        clearContent();
        fillContent(el);
    };

    this.isOpened = function () {
        return saWindow.isOpened();
    };

    this.getWindow = function () {
        return saWindow;
    };
    this.getMinMaxState = function () {
        var state = 'max';
        if (this.isOpened()) {
            state = saWindow.getMinMaxState();
        }
        return state;
    };

    this.loading = function (sw) {
        saWindow.loading(sw);
    };
    this.smallLoading = function (sw, bottomDistance, rightDistance) {
        saWindow.smallLoading(sw, bottomDistance, rightDistance);
    };

    var fillContent = function (el) {
        saWindow.clearContent();
        var contentElement = saWindow.getContentElement();

        // show either the loadingBox or the regular loader, to prevent loader stacking/overlapping
        if (saWindow.loadingBox && saWindow.loadingBox.isUsed) {
            saWindow.loadingBox.show();
        }
        else {
            self.loading('show');
        }

        var readyHandler = function () {
            $(document).trigger('diy-siteadmin-content-loaded', [params]);
            parseHelpLinks();
            self.loading('hide');
        };

        /**
         * initializes inline content
         * @param data
         */
        var loadInline = function (data) {
            /* fill the content element with the received data */
            if ('string' === typeof data) {
                html = data;
            } else if ('object' === typeof data && data.html) {
                html = data.html;
            } else if ('object' === typeof data && 'object' === typeof data.data && data.data.html) {
                html = data.data.html;
            }
            contentElement.html(html);

            /* if there are further actions to be taken, take them */
            if (params.controller && diy.editor.siteadmin.controllers[params.controller]) {
                diy.editor.siteadmin.api.updateFeatureGuidanceHelp();
                diy.editor.siteadmin.controllers[params.controller].afterFillContent(el, data, contentElement);

                /*
                 * Trigger the ready handler only when the final content has fully loaded
                 */
                if ("theming" === params.controller) {

                    $(document).bind("diy-editor-theming-styleWindowLoaded", readyHandler);

                    /*
                     * Resize and hide loading indicator; hidding the loading indicator is necessary due to the fact
                     * that in some cases (like for the styles panel) the readyHandler call is deferred until the final
                     * paylod is delivered.
                     */
                    saWindow.resize();
                    self.loading('hide');

                    //early return: readyHandler has been deferred asynchronously
                    return;

                }
            }

            saWindow.resize();
            readyHandler();
        };

        if ('iframe-local' === params.contentType) {
            /* notify iframe content loaded */
            contentElement.one('load', function (e) {
                readyHandler();
            });

            /* set the url to the iframe */
            contentElement.attr('src', el.href);
        } else if ('inline' === params.contentType) {
            /* ajax request to the url */
            var html = '';
            var data;
            /* if cached content is in store, load it from there */
            if (self.getControllerName() && cacheStore[self.getControllerName()]) {
                /* keep reference, so any modified data in a previous session is still available */
                data = cacheStore[self.getControllerName()];
                loadInline(data);
            } else {
                /* if content not cached, request from server */
                $.get(el.href, function (data) {
                    /* only cache if we are allowed to cache the current controller */
                    if (cacheControllers.indexOf(self.getControllerName()) > -1) {
                        /* keep reference, so any modified data in a previous session is still available */
                        cacheStore[self.getControllerName()] = data;
                    }
                    loadInline(data);
                });
            }
        } else if ('iframe-external' === params.contentType) {
            /* notify iframe content loaded */
            contentElement.one('load', function (e) {
                $(document).trigger('diy-siteadmin-content-loaded', [params]);
                self.loading('hide');
            });
            /* set the url to the iframe */
            contentElement.attr('src', el.href);
        } else if ('delegated' === params.contentType) {
            if (params.controller && diy.editor.siteadmin.controllers[params.controller]) {
                diy.editor.siteadmin.controllers[params.controller]
                    .fillContent(contentElement, readyHandler);
            }
        }

    };

    var parseHelpLinks = function () {
        // @TODO: These methods will throw an exception when accessing iframes with external content. Fix this by
        // first clearing the content of each area before loading new content.
        cms.help.GuidedAssistant.getInstance()._initSiteAdminButton(cms.help.GuidedAssistant.options.siteAdminButtonId);
        cms.help.GuidedAssistant.getInstance()._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
    };

    this.updateID = function (id) {
        saWindow.updateID(id);
    };
    this.updateTitle = function (title) {
        saWindow.updateTitle(title);
        saWindow.resize();
    };
    this.updateDescr = function (descr) {
        saWindow.updateDescr(descr);
        saWindow.resize();
    };
    // they should be here //
    /*
     * id
     * text
     * url
     * icon
     * disabled
     * windowBehavior
     * contentType
     */
    this.updateNavi = function (navi) {
        saWindow.updateNavi(navi);
        saWindow.resize();
    };

    /**
     * Shows the top navigation including tabs
     */
    this.showNavi = function () {
        saWindow.showNavi();
        saWindow.resize();
    };

    /**
     * Hides the top navigation including tabs
     */
    this.hideNavi = function () {
        saWindow.hideNavi();
    };

    this.setNaviActiveItem = function (id) {
        saWindow.setNaviActiveItem(id);
    };

    this.updateSaveBtn = function (btn, callback) {
        saWindow.updateSaveBtn(btn, callback);
    };

    this.saveBtnClicked = function (a, b, c) {
        saWindow.saveBtnClicked(a, b, c);
    };

    var clearContent = function () {
        saWindow.clearContent();
    };

    this.getHeaderData = function () {
        return saWindow.headerData;
    };

    this.updateButtons = function (buttons) {
        saWindow.updateButtons(buttons);
    };

    this.keepalive = (function () {
        var settings = {
            refreshInterval: 1800, // refresh time in seconds
            callbackUrl: '/app/default/index/keepalive'
        };
        return {
            lastCalled: null,
            getTime: function () {
                var d = new Date();
                return Math.round(d.getTime() / 1000); // time in seconds
            },
            callback: function () {
                this.lastCalled = this.getTime();
                $.ajax({url: settings.callbackUrl, method: "POST"});
            },
            reset: function () {
                this.lastCalled = null;
            },
            refresh: function () {
                var now = this.getTime();
                if (this.lastCalled === null) {
                    this.lastCalled = now;
                    return;
                }
                if (now - this.lastCalled >= settings.refreshInterval) {
                    return this.callback();
                }
            }
        };
    }());

    return this;

};

module.exports = Controller;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

/*global diy, jimdoData*/

var $ = __webpack_require__(3);
var features = __webpack_require__(25);
var siteadmin = __webpack_require__(20);
var renderPrivacyNotice = __webpack_require__(27).renderNotice;

module.exports = function(controller) {
    'use strict';

    /* the default window behavior will be used in case of un-specified behavior */
    var defaultWindowBehavior = {
        header : {
            small : false
        },
        resizable : {
            minWidth : 550,
            minHeight : 712
        },
        size : { /* they start with a predefined width height */
            width : 600,
            height : 700,
            /* and save their window size in a common place */
            persistentId : 'basic'
        },
        footer : {}
    /* by default, they have footer */
    };

    var speed = 400, /* animation speed in Site Admin Window */
    sidebarWidth = 86, /* the Site Admin bar width */
    windowMargin = 50, /* the margin of the site window untill the window edge*/
    windowFooterHeight = 50, /* the footer's height */
    windowHeaderHeight = 0, /* the header's height */
    windowHeaderHeights = {
        small : 34,
        normal : 87
    },

    /*
     * these are the default resizable options and also some resize-logic used
     * if the window has resizable behavior
     */
    resizableOptions = {
        minWidth : 350,
        maxWidth : null,
        minHeight : 400,
        maxHeight : null,
        containment : 'document',
        helper : 'cc-window-resizable-proxy',
        handles : {
            sw : '.sa-resizable'
        },
        start : function(e, ui) {
            /*
             * put an invisible overlay just bellow the resized window to
             * prevent interaction with iframes or other elements in the page
             */
            var windowZIndex = parseInt(ui.element.parent().css('z-index'), 10);
            if (windowZIndex) {
                $('<div id="cc-resizable-window-overlay">').css({
                    zIndex : windowZIndex + 1
                // changed from - to +, it was not working properly
                }).appendTo($(document.body));
            }
        },
        stop : function(e, ui) {
            /*
             * we resize the header's width first, as we may have a subheading
             * text that extends on two or more lines. at this point, the header
             * is not itself resized, so when computing it's height, the old one
             * will be used and an incorrect height will be used. So we force it
             * to resize, to gain the new height needed for the window size
             * calculations
             */
            $siteAdminWinHeader.width(ui.size.width);
            /* resize it to the new size */
            self.resize({
                width : ui.size.width,
                height : ui.size.height
            });
            $win.css($.extend(ui.originalPosition, {
                left : 'auto',
                top : 0
            }));

            /* trigger finishing the resizeComleted (for ex. for moduleSelector) */
            $(document).trigger('diy-siteadmin-window-resize-completed',
                    ui.size);

            /* remove the resize overlay */
            $('#cc-resizable-window-overlay').remove();
        }
    };

    var $win,
        $iframe,
        $contentWrapper,
        $contentContainer,
        $navi,
        $title,
        $descr,
        $saveBtn,
        $siteAdminWinHeader,
        $smallLoader,
        $resizeHandle,
        $footer,
        $closeBtn;

    var ini = function() {
        $win = $($('#sa-template').html()).insertAfter('#sa-template');
        $contentWrapper = $win.find('main');
        $contentContainer = $win.find('.sa-main-content');
        $navi = $win.find('nav .sa-navigation');
        $title = $win.find('header h1');
        $descr = $win.find('header h2');
        $saveBtn = $win.find('footer .sa-footer-save');
        $closeBtn = $win.find('footer .sa-footer-close');
        $siteAdminWinHeader = $win.find('header');
        $smallLoader = $('.sa-header-buttons .loading-placeholder');
        $resizeHandle = $win.find('.sa-resizable');
        $footer = $win.find('footer');
    };

    ini();

    var self = this,
        windowOpened = false,
        behavior = [], /* the current behaviors of the window */
        contentType = "iframe-local";

    var behaviors = {

        /* resizable behavior: makes the window resizable */
        resizable : {
            hide : function(opts) {
                $resizeHandle.hide();
                // HACK: hide behavior is called even if it's never been activated
                if ($win.is('.ui-resizable')) {
                    $win.resizable('disable');
                }
            },
            show : function(opts) {
                var effectiveOptions = $.extend({}, resizableOptions, opts);
                $resizeHandle.show();
                if (!$win.is('.ui-resizable')) {
                    $win.resizable(effectiveOptions);
                } else {
                    $win.resizable('enable');
                    $win.resizable('option', effectiveOptions);
                }
            }
        },

        /*
         * size behavior: sizes the window and makes it save it's size in a
         * persistent storage
         */
        size : {
            hide : function(opts) {
                $(window).off('.saWindowSizeBehavior');
            },
            show : function(opts) {
                var sizeobj;

                var controllerName = siteadmin.getController().getControllerName(),
                    controller = diy.editor.siteadmin.controllers[controllerName];
                if (controller && typeof controller['getWindowSize'] === 'function') {
                    $(window).on('resize.saWindowSizeBehavior', function() {
                        var responsiveSize = controller.getWindowSize();
                        self.resize(responsiveSize);
                    });
                    var responsiveSize = controller.getWindowSize();
                    self.resize(responsiveSize);
                    return;
                }

                /*
                 * try and get the persistent size cookie for this type of
                 * window
                 */
                try {
                    sizeobj = $.parseJSON($.cookie('diy-siteadmin-window-size-persistentId-' + opts.persistentId));
                } catch (e) {
                    sizeobj = null;
                }
                /*
                 * if cookie was previously set, use it. if not, just use the
                 * width and height
                 */
                if (sizeobj && sizeobj.width && sizeobj.height) {
                    self.resize(sizeobj);
                } else {
                    self.resize({
                        width : opts.width || resizableOptions.minWidth,
                        height : opts.height || resizableOptions.minHeight
                    });
                }
            }
        },
        closeButton : {
            hide : function(opts) {
                $contentWrapper.find('.closeButton').hide();
            },
            show : function(opts) {
                // create and show a button
                var $button = $contentWrapper.find('.closeButton');
                if (!$button.length) {
                    $button = $('<button class="closeButton">X</button>')
                            .appendTo($contentWrapper);
                    $button
                            .click(function() {
                                var controllerName = siteadmin
                                        .getController().getControllerName(),
                                controller = diy.editor.siteadmin.controllers[controllerName];
                                if (typeof controller['minimizeButtonClick'] === 'function') {
                                    controller.minimizeButtonClick(opts);
                                }

                            });
                }
                $button.show();
            }
        },
        header : {
            hide : function(opts) {
                if (opts.small) {
                    $siteAdminWinHeader.removeClass('cc-window-header-small');
                }
                windowHeaderHeight = 0;
                $siteAdminWinHeader.hide();
            },
            show : function(opts) {
                if (opts.small) {
                    $siteAdminWinHeader.addClass('cc-window-header-small');
                    windowHeaderHeight = windowHeaderHeights.small;
                } else {
                    windowHeaderHeight = windowHeaderHeights.normal;
                }
                $siteAdminWinHeader.show();
                $win.css('margin-top', null);
            }
        },

        /* footer behavior: adds a footer to the window */
        footer : {
            hide : function(opts) {
                $footer.hide();
            },
            show : function(opts) {
                $footer.show();
            }
        },

        overlay : {
            hide : function(opts) {
                $('#siteadmin-window-overlay').hide();
            },
            show : function(opts) {

                // grab a hold of the overlay container
                var $overlay = $('#siteadmin-window-overlay');

                // create overlay element if it hasn't yet
                if ($overlay.length === 0) {

                    // create the container
                    $overlay = $(
                        '<div id="siteadmin-window-overlay" class="diye ui-overlay">' +
                            '<div class="ui-widget-overlay"></div>' +
                        '</div>'
                    ).hide().appendTo('body');

                    // z-index needs to be on top of any web-app overlay
                    $overlay.find('.ui-widget-overlay').css('z-index', 50010);

                    // bind or unbind the alert on click, depending on options
                    if (typeof opts.alertOnClick !== 'undefined') {
                        $overlay
                            .bind(
                            'click.overlayAlertOnClick',
                            function() {
                                var controllerName = siteadmin
                                    .getController()
                                    .getControllerName();
                                var controller = diy.editor.siteadmin.controllers[controllerName];

                                if (typeof controller['showAlertOnClickAway'] === 'function') {
                                    controller.showAlertOnClickAway(opts);
                                }
                            });
                    }
                    else {
                        $overlay.unbind('click.overlayAlertOnClick');
                    }

                } // end of create container if not exist

                // set full transparency or semi-opaque, depending on options
                if (opts.transparent === true) {
                    $overlay.find('.ui-widget-overlay').addClass('transparent');
                }
                else {
                    $overlay.find('.ui-widget-overlay').removeClass('transparent');
                }

                // done, ready to show
                $overlay.show();
            }
        },

        /* loadingBox behavior: adds a loading screen to the window */
        loadingBox : {
            hide : function(opts) {
                self.loadingBox.destroy(opts);
            },
            show : function(opts) {
                self.loadingBox.init(opts);
            }
        },

        contentScrollable : {
            hide : function(opts) {
                $contentContainer.css('overflow', 'hidden');
            },
            show : function(opts) {
                $contentContainer.css('overflow', 'auto');
            }
        },

        minimizable : {
            hide: function(opts) {
                var miniMaxiButton = $win.find('.cc-sa-window-content-minimize_maximize');
                miniMaxiButton.hide();
                miniMaxiButton.removeClass('maximize');
                miniMaxiButton.addClass('minimize');
                miniMaxiButton.find('.does-minimize').show();
                miniMaxiButton.find('.does-maximize').hide();

            },
            show: function(opts) {
                var controllerName = siteadmin
                        .getController().getControllerName();
                var controller = diy.editor.siteadmin.controllers[controllerName];
                var tplMin, tplMax;

                if (typeof controller['minimizableButtonTemplate'] !== 'undefined') {
                    tplMin = controller.minimizableButtonTemplate('minimize');
                    tplMax = controller.minimizableButtonTemplate('maximize');
                } else {
                    tplMin = '<div>-</div>';
                    tplMax = '<div>+</div>';
                }

                var positionButton = function(button) {
                    setTimeout(
                            function() {
                                var width = button.outerWidth();
                                var height = button.outerHeight();
                                button.css('left', (width > height) ? -height
                                        : -width);
                                button.css('top', (width > height) ? width : 0);
                            }, 0);
                };

                var miniMaxiButton = $win.find('.cc-sa-window-content-minimize_maximize');
                if (!miniMaxiButton.length) {
                    // create the button
                    miniMaxiButton = $('<div class="cc-sa-window-content-minimize_maximize"></div>');
                    // it's a minimize by default
                    $(tplMin).addClass('does-minimize')
                            .appendTo(miniMaxiButton);
                    $(tplMax).addClass('does-maximize').hide().appendTo(
                            miniMaxiButton);
                    miniMaxiButton.addClass('minimize');
                    $contentWrapper.prepend(miniMaxiButton);

                    var oldBh = $.extend(true, {}, behavior);
                    var newBh = opts.dataWindowBehavior;
                    miniMaxiButton.bind('click', function() {

                        var $this = $(this);
                        var action;
                        if ($this.hasClass('minimize')) {
                            action = 'minimize';
                            newBh.minimizable = {};
                            self.setBehavior(newBh);
                            self.resize();

                            $this.removeClass('minimize');
                            $this.addClass('maximize');
                            $this.find('.does-minimize').hide();
                            $this.find('.does-maximize').show();
                        } else {
                            action = 'maximize';
                            self.setBehavior(oldBh);
                            self.resize();

                            $this.removeClass('maximize');
                            $this.addClass('minimize');
                            $this.find('.does-maximize').hide();
                            $this.find('.does-minimize').show();
                        }
                        positionButton($this);
                        $(document).trigger(
                                'diy-siteadmin-window-minimizable-state', [ {
                                    state : action
                                } ]);
                    });
                }

                miniMaxiButton.show();
                positionButton(miniMaxiButton);

            }
        }
    }; // end behaviors

    this.headerData = {};
    this.footerData = {};
    this.windowSize = {};
    this.originalWindowBehavior = {};

    /**
     * retrieves current window size
     *
     * @returns {*}
     */
    this.getWindowSize = function() {
      return this.windowSize;
    };

    this.getMinMaxState = function() {
        var button = $win.find('.cc-sa-window-content-minimize_maximize');
        if($(button[0]).hasClass('maximize')){
            return 'min';
        } else if ($(button[0]).hasClass('minimize')) {
            return 'max';
        }
    };

    this.isOpened = function() {
        return windowOpened;
    };

    this.init = function() {
        /* creating the content iframe */
        $iframe = $('<iframe frameborder="0" name="cc-sa-iframe" src="about:blank"></iframe>');
        $iframe.appendTo($contentWrapper);

        /* add privacy notice in footer */
        if (features('privacyNotice')) {
            var noticeWrapper = $('<div class="privacy-policy-notice-wrapper">');
            $contentWrapper.prepend(renderPrivacyNotice(noticeWrapper[0]));
        }

        /* react on window resize */
        $(window).bind('resize', function() {
            if (self.isOpened()) {
                self.resize(self.windowSize);
                self.checkSelectedPointerPosition();
            }
        });

        /*
         * hide site admin window to hide styleless html after classes were
         * removed
         */
        $(window).bind('unload', self.close);

        /* bind siteadmin window close and show events */
        $(document).bind('diy-siteadmin-window-close', $.proxy(self.close, this));
        $(document).bind('diy-siteadmin-window-show', $.proxy(self.show, this));

        $win.actionController(this, {
            history : true
        });

        $closeBtn.find('button').button().click($.proxy(self.closeWindowClick, this));
    };

    /**
     * Sets the window behavior to a new one Hides the previous one and shows
     * the new one
     *
     * @param {string|object} bh the new behavior
     */
    this.setBehavior = function(bh) {
        var b;
        /* in case no behavior, use the default one */
        if (!bh) {
            bh = defaultWindowBehavior;
        }

        /* the behavior may come as a string or as an object */
        if ('string' === typeof bh) {
            bh = $.parseJSON(bh);
        }
        bh = $.extend(true, {}, defaultWindowBehavior, bh);

        /* remove old behaviors from the window */
        for (b in behaviors) {
            if (behaviors.hasOwnProperty(b) && behaviors[b] !== false) {
                behaviors[b].hide(behaviors[b]);
            }
        }

        /* the new behavior */
        behavior = bh;

        /* add new behaviors to the window */
        for (b in behavior) {
            if (behavior.hasOwnProperty(b) && behavior[b] !== false) {
                behaviors[b].show(behavior[b]);
            }
        }
    };

    this.show = function() {
        /* the window is now opened */
        // TODO perhaps there is a better way to do this
        windowOpened = true;

        var openedControllerName = siteadmin
                .getController()
                .getControllerName(),
            openedController = diy.editor.siteadmin.controllers[openedControllerName];

        controller.bindEvent();

        /* stop any animations on the Site Admin and restore it visible */
        // TODO: check if show changes visibility as well so we can remove the css property
        if ($win.hasClass('ui-helper-hidden-accessible')) {
            $win.removeClass('ui-helper-hidden-accessible');
        }
		$win.stop(true).show().css('visibility', 'visible').css('opacity', null);
        /* add new behaviors to the window */
        var b;
        for (b in behavior) {
            if (behavior.hasOwnProperty(b) && behavior[b] !== false) {
                behaviors[b].show(behavior[b]);
            }
        }
        if (typeof openedController !== 'undefined' &&
            typeof openedController['show'] === 'function') {
            openedController.show();
        }
    };

    this.hide = function() {
        /* the window is now opened */
        // TODO perhaps there is a better way to do this
        windowOpened = false;
        var openedControllerName = siteadmin
            .getController(),
            openedController = '';

        controller.unbindEvent();

        if (openedControllerName !== null) {
            openedControllerName = openedControllerName.getControllerName();
            openedController = diy.editor.siteadmin.controllers[openedControllerName];
        }

        if (typeof openedController !== 'undefined' &&
            typeof openedController['hide'] === 'function') {
            openedController.hide();
        }
        /* add new behaviors to the window */
        var b;
        for (b in behavior) {
            if (behavior.hasOwnProperty(b) && behavior[b] !== false) {
                behaviors[b].hide(behavior[b]);
            }
        }
        /* stop any animations on the Site Admin and restore it visible */
        if (!$win.hasClass('ui-helper-hidden-accessible')) {
            $win.addClass('ui-helper-hidden-accessible');
        }
        $win.stop(true).css('opacity', null);
    };

    /**
     * Shows or hides the loading indicator
     *
     * @param {string}
     *            sw can take values like 'show' and 'hide'
     */
    this.loading = function(sw) {
        if (sw === 'show') {
            $contentWrapper.prepend('<div class="cc-window-loading"><div class="rotate-animation"></div></div>');
        } else {
            $contentWrapper.find('.cc-window-loading').remove();
        }
    };
    this.smallLoading = function (sw, bottomDistance, rightDistance) {
        if (sw === true) {
            if (!isNaN(parseInt(bottomDistance))) {
                $smallLoader.css({bottom: bottomDistance + 'px'});
            }
            if (!isNaN(parseInt(rightDistance))) {
                $smallLoader.css({right: rightDistance + 'px'});
            }
            $smallLoader.show();
        } else {
            $smallLoader.hide();
        }
    };

    /**
     * currently used for making custom CSS rules ex: override header, footer,
     * any other elemnets in the site admin ex:
     * [data-controller-name="myController"] { }
     */
    this.setAttribute = function(v) {

        var attrFn = function(val) {
            var oldControllerName = $win.attr('data-controller-name');
            if (oldControllerName) {
                $win.removeClass('cc-sa-controller-' + oldControllerName);
                $win.removeAttr('data-controller-name');
            }
            if (val) {
                $win.attr('data-controller-name', val);
                $win.addClass('cc-sa-controller-' + val);
            }
        };

        attrFn(v);
    };

    this.destroy = function() {
        var controllerName = controller.getControllerName(),
            currentController = diy.editor.siteadmin.controllers[controllerName];
        if (typeof currentController !== 'undefined' &&
            typeof currentController['reset'] === 'function') {
            currentController.reset();
        }

        $win.remove();
    };


    /**
     * Sets the window title
     *
     * @param {string}
     *            title the title to be set
     */
    this.updateID = function (id) {
        self.headerData.id = id;
    };

    this.getID = function() {
        return self.headerData.id;
    };

    /**
     * Sets the window title
     *
     * @param {string} title the title to be set
     */
    this.updateTitle = function(title) {
        $title.html(title);
        self.headerData.title = title;
    };

    /**
     * Sets the window description
     *
     * @param {string}
     *            descr the description to be set
     */
    this.updateDescr = function(descr) {
        $descr.html(descr);
        self.headerData.descr = descr;
    };

    this.setContentType = function(ct) {
        contentType = ct;
        if (ct === 'iframe-local' || ct === 'iframe-external') {
            $contentContainer.hide();
            $iframe.show();
        } else {
            $contentContainer.show();
            $iframe.hide();

            /*
             * ==============================================================
             * fixes bug 217862 (IE8 bug)
             * ============================================================== On
             * Internet Explorer 8 (of course), after clicking anywhere in
             * "Style" and switching to Module Selector, the scrollbars and
             * clicks don't work at all and all the interface looks frozen. This
             * was because of the click remained focused in the iframe
             * containing "Style" The only way to lose focus of that iframe was
             * to set it's source to about:blank, wait a bit, and then hide the
             * loading indicator (the top right of the panel) In this way the
             * iframe will lose focus and will allow normal events trigger on
             * the main window rather than inside the iframe. The following fix
             * is only executed on IE8
             */
            if ($.isBrowser.ie8) {
                controller.unloadSAC();
                $iframe.attr('src', 'about:blank');
            }
        }
    };

    /**
     * gets the content element depending on the content type
     *
     * @return {jQuery} the content element
     */
    this.getContentElement = function() {
        if ('iframe-local' === contentType || 'iframe-external' === contentType) {
            return $iframe;
        } else {
            //any other contentType, return the element
            //curently: inline, delegated
            return $contentContainer;
        }
    };

    /**
     * Click event on navigation tabs in the window
     */
    this.naviItemClick = function(e, specificController) {
        /* remove active class from all the navigation tabs */
        $('a', $navi).removeClass('cc-sa-active');

        /* sets behavior and content type */
        var windowBehavior = $(this).attr('data-window-behavior');
        self.setBehavior(windowBehavior);
        self.setContentType($(this).attr('data-content-type') || 'iframe-local');
        specificController = specificController || $(this).attr('data-identifier');
        /* make current tab active */
        $(this).addClass('cc-sa-active');

        /* set window behavior and content type */
        controller.load({
            element : this,
            controller : specificController,
            windowBehavior : windowBehavior,
            contentType : $(this).attr('data-content-type')
        });

        /* show the controller */
        controller.show();

        return false;
    };

    this.updateHelpTopic = function(topic) {
        var helpButton = $siteAdminWinHeader.find('.cc-sa-button-help'), isVideo = window.guidedAssistant &&
                window.guidedAssistant.isVideoHelpTopic(topic);

        helpButton.attr('data', topic);
        if (isVideo) {
            helpButton.addClass('cc-sa-button-help-video');
        } else {
            helpButton.removeClass('cc-sa-button-help-video');
        }
        if (topic) {
            helpButton.show();
        } else {
            helpButton.hide();
        }
    };

    this.updateFeatureGuidanceHelp = function(stepId) {
        var bubbleButton = $siteAdminWinHeader.find('.feature-guidance-help-button');
        if (stepId) {
            bubbleButton.attr('data', stepId).show();
        } else {
            bubbleButton.hide();
        }
    };

    /**
     * updates the site admin's window navigation (tabs) active state
     *
     * @param id {String|Number} if it's a string, it will use the "identifier" parameter
     *                           of the navigation link, if it's a number it will be that index
     */
    this.setNaviActiveItem = function(id) {
        if (!isNaN(parseInt(id))) {
            $navi.find('ul li').eq(id).find('a').trigger('click');
        } else {
            $navi.find('ul li a[data-identifier=' + id + ']').trigger('click');
        }
    };

    /**
     * This function updates the navigation zone (the tabs) with a given content
     *
     * @param {Array}
     *            navigation the content for the tabs
     */
    this.updateNavi = function(navigation) {
        /*
         * extra space to add to the navi for the new minimum width an window
         * can have
         */
        var extraSpace = 10, navi = '', i = 0, item, wb;
        if (behavior.header && behavior.header.small) {
            extraSpace = 110;
        }
        if (navigation && $.isArray(navigation)) {
            navi += '<div id="cc-sa-navi-tabs" class="ui-tabs ui-widget ui-widget-content ui-corner-all">';
            navi += '<ul class="ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all">';
            for (i = 0; i < navigation.length; i = i + 1) {
                item = navigation[i];
                navi += '<li class="ui-state-default ui-corner-top' +
                        (item.active ? ' ui-tabs-selected ui-state-active'
                                : '') + '">';
                if(item.url === undefined) {
                    navi += '<a href="#" ';
                } else {
                    navi += '<a href="' + item.url +
                        '" target="cc-sa-iframe" ';
                }

                navi += ' class="' + (item.active ? 'active' : '') + '" ';

                if (item.identifier) {
                    navi += ' data-identifier="' + item.identifier + '" ';
                }

                if (item.windowBehavior) {
                    wb = "";
                    try {
                        wb = $.toJSON(item.windowBehavior).replace(/&/g,
                                "&amp;").replace(/</g, "&lt;").replace(/>/g,
                                "&gt;").replace(/"/g, "&quot;").replace(/'/g,
                                "&#039;");
                    } catch (e) {
                    }
                    navi += ' data-window-behavior="' + wb + '"';
                }
                if (item.contentType) {
                    navi += ' data-content-type="' + item.contentType + '"';
                }
                navi += ' data-action="naviItem">' + item.title + '</a></li>';
            }
            navi += '</ul>';
            navi += '</div>';
        }

        /* set the navi content */
        $navi.html(navi);

        /* apply custom callbacks */
        $navi.find('#cc-sa-navi-tabs ul li a').each(
                function(index) {
                    $(this).click(
                            function(e) {
                                var res = navigation[index].callback;

                                /* save the timestamp for other tracking points */
                                $(document).trigger('diy-editor-saveUserClickTimestamp', {
                                    sectionCodeName: navigation[index].id
                                });

                                if (e.originalEvent !== undefined) { // if a monkey clicked on it...
                                    $(document).trigger('diy-editor-generic-sectionAccessed', {
                                        'sectionCodeName': 'sa-window-navigation.' + navigation[index].id
                                    });
                                }

                                /* if the callback's result is true, proceed */
                                if (typeof res === 'function' && res(e)) {
                                    $('#cc-sa-navi-tabs ul li').removeClass(
                                            'ui-tabs-selected').removeClass(
                                            'ui-state-active').find('a')
                                            .removeClass('active');
                                    $(this).parent().addClass(
                                            'ui-tabs-selected').addClass(
                                            'ui-state-active');
                                    $(this).addClass('active');
                                    return false;
                                }
                            });
                });

        /*
         * due to the fact that the tabs are not jQuery based, we will hover
         * them manually
         */
        $navi.find('.ui-state-default').hover(function() {
            $(this).addClass('ui-state-hover');
        }, function() {
            $(this).removeClass('ui-state-hover');
        });

        self.headerData.navi = navigation;

        /*
         * get it's width and compute a new width based on it's current one and
         * extraSpace
         */
        var naviWidth = $navi.width(), newMinWidth = parseInt($navi.width(), 10) + extraSpace;

        /* perform operations for resizable hehavior */
        if (behavior.resizable &&
                naviWidth > 0 &&
                newMinWidth > (behavior.resizable.minWidth || resizableOptions.minWidth)) {
            behaviors.resizable.hide(behavior.resizable);
            behaviors.resizable.show({
                minWidth : newMinWidth
            });
        }

        /* perform operations for size hehavior */
        if (behavior.size && naviWidth > 0) {
            var persistentWidth = 0; /*
                                         * first, suppose there is no saved
                                         * width for this window
                                         */

            if (behavior.resizable) {
                try { /*
                         * try and get it. whether the cause of the failure, it
                         * will still remain 0
                         */
                    persistentWidth = $.parseJSON($
                            .cookie('diy-siteadmin-window-size-persistentId-' +
                                    behavior.size.persistentId)).width;
                } catch (ee) {
                }
            }
            /*
             * the new width will be either persistentWidth or size width
             * (whichever is larger
             */
            var currentWidth = Math.max(persistentWidth, behavior.size.width ||
                    resizableOptions.minWidth);
            if (newMinWidth > currentWidth) { /*
                                                 * if there is the need, resize
                                                 * the window
                                                 */
                behaviors.size.show({
                    width : newMinWidth,
                    height : $win.height()
                });
            } else {
                behaviors.size.show({
                    width : currentWidth,
                    height : $win.height()
                });
            }
        }

        return self;
    };

    /**
     * hides the navigation (with tabs)
     */
    this.hideNavi = function () {
        $navi.hide();
    };

    /**
     * shows the navigation (with tabs)
     */
    this.showNavi = function () {
        $navi.show();
    };

    /**
     * resize the window to a certain size
     *
     * @param {object}
     *            newSize the new size, object with width and height values
     * @param {boolean}
     *            animate whether to animate
     */
    this.resize = function(newSize, animate) {

        /* in case it is ran without any sizes, just use the window's ones */
        if (!newSize) {
            newSize = {
                width : $win.width(),
                height : $win.height()
            };
        }

        /* attempt resizing upon window resize only if resizable */
        if (behavior.resizable) {
            if (!newSize.width) { /* fill with window width if missing */
                newSize.width = self.windowSize.width;
            }
            if (!newSize.height) { /* fill with window height if missing */
                newSize.height = self.windowSize.height;
            }
            /*
             * if width exceeds maximum window width, use the maximum window
             * size
             */
            if (newSize.width + windowMargin + sidebarWidth > $(window).width()) {
                newSize.width = getMaxWindowSize().maxWidth;
            }
            /* if the new height is bigger than the window height */
            if (newSize.height + windowMargin > $(window).height()) {
                newSize.height = getMaxWindowSize().maxHeight;
            }

            var minHeight = behavior.resizable.minHeight || resizableOptions.minHeight,
                maxHeight = behavior.resizable.maxHeight || resizableOptions.maxHeight,
                minWidth = behavior.resizable.minWidth || resizableOptions.minWidth,
                maxWidth = behavior.resizable.maxWidth || resizableOptions.maxWidth;

            /*
             * if trying to resize the window less than the minimum resizable
             * height
             */
            if ((newSize.height < minHeight) ||
                    (maxHeight != null && newSize.height > maxHeight)) {
                newSize.height = minHeight;
            }

            /* if bigger size than minimum width comes, use minimum width */
            if ((minWidth > newSize.width) ||
                    (maxWidth != null && newSize.width > maxWidth)) {
                newSize.width = behavior.resizable.minWidth;
            }
        }

        if (animate) { /* perform the resize by animating or not */
            $win.add($siteAdminWinHeader).animate({
                width : newSize.width
            }, speed, resizeContent);
        } else {
            $win.css($.extend(true, {}, newSize, {
                height : newSize.height
            }));
            resizeContent();
        }

        /**
         * resize the content within the window
         */
        function resizeContent() {
            /* finding and setting the content height */
            var headerOuterHeight = 0;
            if ($siteAdminWinHeader.is(':visible')) {
                headerOuterHeight = $('header').outerHeight();
            }
            var contentWrapperHeight = newSize.height -
                    (headerOuterHeight || windowHeaderHeight);

            if (behavior.footer) {
                contentWrapperHeight -= ($footer.outerHeight() || windowFooterHeight);
            }

            $contentWrapper.css({
                width : newSize.width,
                height : contentWrapperHeight
            });

            /* resize window header */
            $siteAdminWinHeader.width(newSize.width);

            /* store the new window size */
            $.extend(self.windowSize, newSize);

            /* wait until css is ready */
            setTimeout(controller.resizeSAC, 10);

            /* trigger the resize completed event */
            $(document).trigger('diy-siteadmin-window-resize-completed');

            /*
             * check if window contains a persistent size Id behavior, and if
             * so, save the size
             */
            if (behavior.size && behavior.size.persistentId) {
                $.cookie('diy-siteadmin-window-size-persistentId-' +
                        behavior.size.persistentId, JSON.stringify({
                    width : $win.width(),
                    height : $win.height()
                }), {
                    expires : 100,
                    path : '/'
                });
            }

            /* make sure that the pointer position is set correctly */
            self.checkSelectedPointerPosition();
        }
    };

    /**
     * Updates the save button with the given content
     *
     * @param btn
     *            the button
     */
    this.updateSaveBtn = function(btn, callback) {
        if (typeof btn === 'object') {
            btn = $(btn).get(0);
        }
        $saveBtn.html(btn);
        var buttonObj = $saveBtn.find('button');
        buttonObj.button();

        // allow a custom callback //
        buttonObj.unbind('click.customCallback');
        if ($.isFunction(callback)) {
            buttonObj.bind('click.customCallback', callback);
        }

        self.footerData.saveBtn = btn;
        return self;
    };

    var extButtonCallback = function(which) {
        try {
            var item = self.footerData.buttons[which], win = self
                    .getContentElement().get(0).contentWindow;
            if (win && typeof win.jQuery === 'function' &&
                    typeof item.event !== 'undefined' && item.event) {
                win.jQuery(win.document).trigger(item.event, null);
            } else if (typeof item.callback === 'function') {
                item.callback();
            }
        } catch (exception) {
            // ...
        }
    };

    var extCloseCallback = function() {
        extButtonCallback('close');
        $(document).unbind('diy-siteadmin-window-closed', extCloseCallback);
    };

    this.updateButtons = function(buttons) {

        /* buttons should have correct format */
        if (!buttons || typeof buttons !== 'object') {
            return;
        }

        self.footerData.buttons = buttons;

        /* prevent double close callback calls */
        $(document).unbind('diy-siteadmin-window-closed', extCloseCallback);

        /* if we have close button */
        if (buttons.hasOwnProperty('close')) {
            // TODO: is there a proper way of setting the close button text ?
            $('footer button[data-action="closeWindow"] span.ui-button-text').html(
                    buttons.close.text);
            $(document).bind('diy-siteadmin-window-closed', extCloseCallback);
        }

        var html = '';

        if (buttons.hasOwnProperty('primary') && buttons.primary) {
            html += '<button class="siteadmin-savebtn" id="cc-sa-window-savebtn" data-external-event="primary">';
            html += buttons.primary.text + '</button>';

        }
        if (buttons.hasOwnProperty('secondary') && buttons.secondary) {
            html += '<button style="margin-right: 10px;" class="button button-cancel"  data-external-event="secondary">';
            html += buttons.secondary.text + '</button>';
        }
        if (buttons.hasOwnProperty('checkbox') && buttons.checkbox) {
            var checkedType = buttons.checkbox.checked ? ' checked="checked" ' : ' ';
            html += '<input type="checkbox" id="cc-sa-window-checkbox"' + checkedType + 'data-external-event="checkbox">';
        }

        $saveBtn.html(html);
        if (buttons.hasOwnProperty('checkbox') && buttons.checkbox) {
            $saveBtn.find('input[type=checkbox]').diy_checkbox({
                boxLabel: buttons.checkbox.text,
                change: $.proxy(buttons.checkbox.callback)

//                checked: buttons.checkbox.checked
            });
//            $saveBtn.find('input[type=checkbox][data-external-event]').unbind().bind(
//                'change',
//                function(e) {
//                    extButtonCallback($(e.currentTarget).attr(
//                        'data-external-event'));
//                });
        }

        $saveBtn.find('button').button();
        $saveBtn.find('button[data-external-event]').unbind().bind(
                'click',
                function(e) {
                    extButtonCallback($(e.currentTarget).attr(
                            'data-external-event'));
                });
    };

    this.getContentWrapper = function() {
        return $contentWrapper;
    };

    this.checkSelectedPointerPosition = function() {
        /*
         * check that the cc-sa-sidebar-selected-pointer element is properly
         * positioned. On low resolutions the min height of the window will be
         * significantly lower than the bottom elements in the sidebar
         */
        var $sidebar = $('#cc-sa-sidebar'); // TODO surely there is a better way
                                            // to do this */
        var pointer = $sidebar
                .find('a.cc-sa-active span.cc-sa-sidebar-selected-pointer');
        if (pointer.length === 1) {
            /*
             * only specifically add display:block to the element if it was
             * previously hidden (had the style attribute modified by
             * jQuery.hide())
             */
            // TODO can we do this in some other way?
            if (pointer.attr('style')) {
                pointer.show();
            }

        }
    };

    /**
     * Close window click action
     *
     * @param obj
     * @param data
     */
    this.closeWindowClick = function(obj, data) {
        controller.close();
//        self.close(obj, data);
    };

    this.close = function(obj, data) {
//        controller.unload(obj, data);
        /*
         * do not close, animate the fading out except for ie8 which is doing
         * the animation choppy
         */
        if (data && data.fade && !$.isBrowser.ie8) {
            $win.animate({
                opacity : 0.05
            }, 600, function() {
                $(this).css('visibility', 'hidden').css('opacity', null);
            });
        }

        self.hide();

        if (behavior.overlay) {
            behaviors.overlay.hide();
        }

        /* deactivate the current SiteAdmin item */
        $(document).trigger('diy-siteadmin-window-closed');

        /* trigger close event inside the iframe, if event bind to it */
        if (self.footerData && self.footerData.buttons &&
                self.footerData.buttons.close &&
                self.footerData.buttons.close.event) {
            var target;
            if (self.contentType === 'iframe-local') {
                target = $iframe.contents();
            } else {
                target = $(document);
            }

            target.trigger(self.footerData.buttons.close.event);
        }

        return false;
    };

    /**
     * Click action on the save button
     *
     * @param action
     * @param data
     * @param switchMode
     */
    this.saveBtnClicked = function(action, data, switchMode) {
        /*
         * we check for mode here, because there are two buttons in FE, preview
         * and save directly
         */
        if (true == switchMode) {
            switchMode = 'save';
        } else {
            switchMode = 'preview';
        }

        switch (data) {
            case 'siteadmin-bg-form':
            case 'siteadmin-colors-form':
            case 'siteadmin-owncolor-form':
            case 'style_bg_userupload':
            case 'fontformattingform':
            case 'settingsstyleaction':
                if ('save' === switchMode) {
                    $(document.body).trigger('StylingSaved.BSA');
                } else {
                    $(document.body).trigger('StylingTried.BSA');
                }
                break;
        }

        /* the content iframe */
        var ifr = $iframe;

        /*
         * now we set a hidden input-field to check in BE for action(save or
         * preview)
         */
        var formDat = ifr.contents().find('#' + data).closest('form');
        var existingSwitchInput = formDat.find('input[name="switch_mode"]');
        if (existingSwitchInput.length) {
            existingSwitchInput.val(switchMode);
        }
        else {
            formDat.prepend($("<input>")
                .attr('name', 'switch_mode')
                .attr('type', 'hidden').attr('class', 'hidden')
                .val(switchMode)
            );
        }

        var iframeWindow = ifr.get(0).contentWindow;

        /* check the action and take appropiate action */
        switch (action) {
        case 'submit':
            try {
                var targetForm = iframeWindow.jQuery('#' + data);
                if (targetForm.length) {
                    /**
                     * XXX: see #DHDIY-12266
                     * xWebForms disables all form inputs on submit and re-enables them
                     * after the request is over. This can be used as a crude form of
                     * flagging so that we can avoid submitting twice if the user
                     * presses Save while another request is already in progress.
                     * We don't know what inputs will be there but we can reasonably
                     * assume there will be at least one, so grab the first.
                     */
                    var maySubmit = true;
                    var firstFormInput = targetForm.children(':input').first();
                    if (firstFormInput.length && firstFormInput.is(':disabled')) {
                        maySubmit = false;
                    }
                    if (maySubmit) {
                        // SiteCatalyst tracking
                        $(document).trigger('diy-editor-siteAdminWindow-submit', {
                            'formName': data,
                            'switchMode': switchMode,
                            'ifr': ifr
                        });
                        // submit the form
                        targetForm.submit();
                    }
                }
            } catch (e) {
            }
            break;

        case 'protection':
        case 'ui-interaction':
            try {
                iframeWindow.document.getElementById(data).click();
            } catch (e) {
            }
            break;

        default:
            break;
        }
    };

    /**
     * gets the maximum allowed window size
     */
    function getMaxWindowSize() {
        return {
            maxWidth : $(window).width() - windowMargin - sidebarWidth,
            maxHeight : $(window).height() - windowMargin
        };
    }

    /**
     * clears the content from the content div and from the iframe
     */
    this.clearContent = function() {
        /* hide the window content div */
//        $('#cc-sa-window-content').empty();
//        $win.remove();

        try {
            /* remove iframe contents before filling up */
//            $($iframe.contents().get(0).documentElement).remove();
        } catch (e) {
        }
    };

    this.loadingBox = (function() {
        var selectorId = 'loadingBox';
        var createBox = '<div id="' + selectorId + '" class="' + selectorId +
                '-loading"></div>';
        var errorWindow = '<div id="window-errorMessage">';
        errorWindow += '<div class="window-errorMessage-title">%title%</div><br/>';
        errorWindow += '<div class="window-errorMessage-description">%desc%</div>';
        errorWindow += '</div>';
        return {
            isUsed : false,
            options : {},
            timeout : null,
            init : function(opts) {
                this.options = opts;
                var keys = new Array('timeout', 'errorMessageTitle', 'errorMessageDescription');
                for ( var i = 0; i < keys.length; i++) {
                    if (typeof this.options[keys[i]] === 'undefined') {
                        this.options[keys[i]] = jimdoData.messages.siteAdminLoadingBox[keys[i]];
                    }
                }
                this.isUsed = true;
            },
            destroy : function(opts) {
                var $me = this.get();
                if ($me) {
                    $me.remove();
                }
                this.isUsed = false;
            },
            get : function(createIfNotExists) {
                var $me = $contentWrapper.find('#' + selectorId);
                if (!$me.length) {
                    if (createIfNotExists == true) {
                        $contentWrapper.prepend(createBox);
                        $me = $contentWrapper.find('#' + selectorId);
                    } else {
                        $me = false;
                    }
                }
                return $me;
            },
            clearTimeout : function() {
                if (this.timeout !== null) {
                    clearTimeout(this.timeout);
                }
            },
            resize : function() {
                if (!this.isUsed) {
                    return;
                }
                this.hide(true);
                this.show(true);
            },
            show : function(ignoreTimeout) {
                if (!this.isUsed) {
                    return;
                }
                var $me = this.get(true);
                $me.css({
                    width : $contentWrapper.width(),
                    height : $contentWrapper.height()
                }).show();
                // use visibility property instead of display so css gets rendered and size is calculated by the browser
                self.getContentElement().css('visibility', 'hidden');
                if (ignoreTimeout !== true) {
                    this.clearTimeout();
                    var me = this;
                    this.timeout = setTimeout(function() {
                        me.error.call(me);
                    }, this.options.timeout);
                }
            },
            hide : function(ignoreTimeout) {
                if (!this.isUsed) {
                    return;
                }
                var $me = this.get();
                if ($me) {
                    $me.hide();
                    // use visibility property instead of display so css gets rendered and size is calculated by the browser
                    self.getContentElement().css('visibility', 'visible');
                }
                if (ignoreTimeout !== true) {
                    this.clearTimeout();
                }
            },
            error : function() {
                this.clearTimeout();

                var $me = this.get();
                if ($me) {
                    errorWindow = errorWindow.replace('%title%',
                            this.options.errorMessageTitle);
                    errorWindow = errorWindow.replace('%desc%',
                            this.options.errorMessageDescription);
                    $me.prepend(errorWindow);
                    $me.removeClass('loadingBox-loading').addClass(
                            'loadingBox-error');
                }
                self.getContentElement().css('visibility', 'visible');
            }
        };
    }());

    return this;
};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

var featureIds_1 = __webpack_require__(26);
var $ = __webpack_require__(3);
function getFeature(featureLabel) {
    if (typeof jimdoData === 'undefined'
        || typeof jimdoData.features === 'undefined'
        || typeof jimdoData.features[featureLabel] === 'undefined') {
        return null;
    }
    return jimdoData.features[featureLabel];
}
var isEnabled = function (featureLabel) {
    var feature = getFeature(featureLabel);
    if (feature === null) {
        // feature not found, but I won't throw an Error for the sake of backward compatibility
        return null;
    }
    if (typeof feature === 'number') {
        return (feature === 1);
    }
    else {
        return feature.enabled === 1;
    }
};
var getPayload = function (featureLabel) {
    var feature = getFeature(featureLabel);
    if (feature === null) {
        throw new Error('Feature ' + featureLabel + ' not found');
    }
    if (typeof feature === 'number') {
        return null;
    }
    else {
        return feature.payload;
    }
};
var disableFeature = function (featureLabel) {
    if (isEnabled(featureLabel)) {
        var featureId = featureIds_1.featureIds[featureLabel];
        if (!featureId) {
            throw new Error("Invalid feature label '" + featureLabel + "'");
        }
        return Promise.resolve($.ajax({
            url: '/app/help/service/disable-feature/?id=' + featureId
        })).then(function () {
            jimdoData.features[featureLabel] = 0;
        });
    }
    // Already disabled
    return Promise.resolve();
};
var enableFeature = function (featureLabel) {
    if (!isEnabled(featureLabel)) {
        var featureId = featureIds_1.featureIds[featureLabel];
        if (!featureId) {
            throw new Error("Invalid feature label '" + featureLabel + "'");
        }
        return Promise.resolve($.ajax({
            url: '/app/help/service/enable-feature/?id=' + featureId
        })).then(function () {
            if (featureLabel === 'cipDisclaimer') {
                jimdoData.features[featureLabel] = { enabled: 1, payload: { acknowleged_at: 1 } };
            }
            else {
                jimdoData.features[featureLabel] = 1;
            }
        });
    }
    // Already enabled
    return Promise.resolve();
};
// exporting by default isEnabled for backward compatibility
var features = isEnabled;
// then adding new functions to it statically
features.getPayload = getPayload;
features.disableFeature = disableFeature;
features.enableFeature = enableFeature;
features.isEnabled = isEnabled;
module.exports = features;


/***/ },
/* 26 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.featureIds = {
    showSectionsGuidanceFlyout: 5601,
    vcardFirstPublish: 5110,
    EHInPristineCondition: 5760,
    businessCardShow: 5802,
    cipDisclaimer: 6117,
};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var l10n = __webpack_require__(18);
var MwsColors = __webpack_require__(189);
var Notice = (function (_super) {
    tslib_1.__extends(Notice, _super);
    function Notice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Notice.prototype.render = function () {
        var style = this.getStyle();
        return (React.createElement("p", { className: "privacy-policy-notice", style: style.root, dangerouslySetInnerHTML: { __html: l10n.getString('privacyPolicy.notice') } }));
    };
    Notice.prototype.getStyle = function () {
        return {
            root: {
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                textAlign: 'inherit',
                color: MwsColors.mwsGrey900
            }
        };
    };
    return Notice;
}(React.Component));
exports.Notice = Notice;
function renderNotice(container) {
    ReactDOM.render(React.createElement(Notice, null), container);
    return container;
}
exports.renderNotice = renderNotice;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

module.exports = __webpack_require__(29);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */

'use strict';

var _assign = __webpack_require__(30);

var ReactChildren = __webpack_require__(31);
var ReactComponent = __webpack_require__(43);
var ReactPureComponent = __webpack_require__(46);
var ReactClass = __webpack_require__(47);
var ReactDOMFactories = __webpack_require__(52);
var ReactElement = __webpack_require__(35);
var ReactPropTypes = __webpack_require__(53);
var ReactVersion = __webpack_require__(55);

var onlyChild = __webpack_require__(56);
var warning = __webpack_require__(37);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

module.exports = React;

/***/ },
/* 30 */
/***/ function(module, exports) {

'use strict';
/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (e) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (Object.getOwnPropertySymbols) {
			symbols = Object.getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildren
 */

'use strict';

var PooledClass = __webpack_require__(32);
var ReactElement = __webpack_require__(35);

var emptyFunction = __webpack_require__(38);
var traverseAllChildren = __webpack_require__(40);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PooledClass
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4, a5);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4, a5);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler,
  fiveArgumentPooler: fiveArgumentPooler
};

module.exports = PooledClass;

/***/ },
/* 33 */
/***/ function(module, exports) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule reactProdInvariant
 * 
 */
'use strict';

/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElement
 */

'use strict';

var _assign = __webpack_require__(30);

var ReactCurrentOwner = __webpack_require__(36);

var warning = __webpack_require__(37);
var canDefineProperty = __webpack_require__(39);
var hasOwnProperty = Object.prototype.hasOwnProperty;

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};
    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      Object.defineProperty(element, '_shadowChildren', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: shadowChildren
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._shadowChildren = shadowChildren;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;

module.exports = ReactElement;

/***/ },
/* 36 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCurrentOwner
 */

'use strict';

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */

var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var emptyFunction = __webpack_require__(38);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ },
/* 38 */
/***/ function(module, exports) {

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule canDefineProperty
 */

'use strict';

var canDefineProperty = false;
if (false) {
  try {
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule traverseAllChildren
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(36);
var ReactElement = __webpack_require__(35);

var getIteratorFn = __webpack_require__(41);
var invariant = __webpack_require__(34);
var KeyEscapeUtils = __webpack_require__(42);
var warning = __webpack_require__(37);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ },
/* 41 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getIteratorFn
 * 
 */

'use strict';

/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ },
/* 42 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyEscapeUtils
 * 
 */

'use strict';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponent
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactNoopUpdateQueue = __webpack_require__(44);

var canDefineProperty = __webpack_require__(39);
var emptyObject = __webpack_require__(45);
var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNoopUpdateQueue
 */

'use strict';

var warning = __webpack_require__(37);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPureComponent
 */

'use strict';

var _assign = __webpack_require__(30);

var ReactComponent = __webpack_require__(43);
var ReactNoopUpdateQueue = __webpack_require__(44);

var emptyObject = __webpack_require__(45);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactClass
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var ReactComponent = __webpack_require__(43);
var ReactElement = __webpack_require__(35);
var ReactPropTypeLocations = __webpack_require__(48);
var ReactPropTypeLocationNames = __webpack_require__(50);
var ReactNoopUpdateQueue = __webpack_require__(44);

var emptyObject = __webpack_require__(45);
var invariant = __webpack_require__(34);
var keyMirror = __webpack_require__(49);
var keyOf = __webpack_require__(51);
var warning = __webpack_require__(37);

var MIXINS_KEY = keyOf({ mixins: null });

/**
 * Policies that describe methods in `ReactClassInterface`.
 */
var SpecPolicy = keyMirror({
  /**
   * These methods may be defined only once by the class specification or mixin.
   */
  DEFINE_ONCE: null,
  /**
   * These methods may be defined by both the class specification and mixins.
   * Subsequent definitions will be chained. These methods must return void.
   */
  DEFINE_MANY: null,
  /**
   * These methods are overriding the base class.
   */
  OVERRIDE_BASE: null,
  /**
   * These methods are similar to DEFINE_MANY, except we assume they return
   * objects. We try to merge the keys of the return values of all the mixed in
   * functions. If there is a key conflict we throw.
   */
  DEFINE_MANY_MERGED: null
});

var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: SpecPolicy.DEFINE_MANY,

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: SpecPolicy.DEFINE_MANY,

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * @return {object}
   * @optional
   */
  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: SpecPolicy.DEFINE_ONCE,

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: SpecPolicy.DEFINE_MANY,

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: SpecPolicy.OVERRIDE_BASE

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

// noop
function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    var Constructor = function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    };
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocations
 */

'use strict';

var keyMirror = __webpack_require__(49);

var ReactPropTypeLocations = keyMirror({
  prop: null,
  context: null,
  childContext: null
});

module.exports = ReactPropTypeLocations;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks static-only
 */

'use strict';

var invariant = __webpack_require__(34);

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;
  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocationNames
 */

'use strict';

var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ },
/* 51 */
/***/ function(module, exports) {

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
var keyOf = function keyOf(oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFactories
 */

'use strict';

var ReactElement = __webpack_require__(35);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypes
 */

'use strict';

var ReactElement = __webpack_require__(35);
var ReactPropTypeLocationNames = __webpack_require__(50);
var ReactPropTypesSecret = __webpack_require__(54);

var emptyFunction = __webpack_require__(38);
var getIteratorFn = __webpack_require__(41);
var warning = __webpack_require__(37);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),
  symbol: createPrimitiveTypeChecker('symbol'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
/*eslint-disable no-self-compare*/
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/*eslint-enable no-self-compare*/

/**
 * We use an Error-like object for backward compatibility as people may call
 * PropTypes directly and inspect their output. However we don't use real
 * Errors anymore. We don't inspect their stack anyway, and creating them
 * is prohibitively expensive if they are created too often, such as what
 * happens in oneOfType() for any type before the one that matched.
 */
function PropTypeError(message) {
  this.message = message;
  this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;

function createChainableTypeChecker(validate) {
  if (false) {
    var manualPropTypeCallCache = {};
  }
  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (false) {
      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
        var cacheKey = componentName + ':' + propName;
        if (!manualPropTypeCallCache[cacheKey]) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
          manualPropTypeCallCache[cacheKey] = true;
        }
      }
    }
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName, secret) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
    }
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!ReactElement.isValidElement(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (is(propValue, expectedValues[i])) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
    }
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return ANONYMOUS;
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ },
/* 54 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypesSecret
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ },
/* 55 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactVersion
 */

'use strict';

module.exports = '15.3.2';

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule onlyChild
 */
'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactElement = __webpack_require__(35);

var invariant = __webpack_require__(34);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

module.exports = __webpack_require__(58);


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

'use strict';

var ReactDOMComponentTree = __webpack_require__(59);
var ReactDefaultInjection = __webpack_require__(62);
var ReactMount = __webpack_require__(181);
var ReactReconciler = __webpack_require__(82);
var ReactUpdates = __webpack_require__(79);
var ReactVersion = __webpack_require__(55);

var findDOMNode = __webpack_require__(186);
var getHostComponentFromComposite = __webpack_require__(187);
var renderSubtreeIntoContainer = __webpack_require__(188);
var warning = __webpack_require__(37);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
/* eslint-enable camelcase */
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
}

module.exports = ReactDOM;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponentTree
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var DOMProperty = __webpack_require__(60);
var ReactDOMComponentFlags = __webpack_require__(61);

var invariant = __webpack_require__(34);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMProperty
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   * @type {Object}
   */
  getPossibleStandardName:  false ? {} : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ },
/* 61 */
/***/ function(module, exports) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponentFlags
 */

'use strict';

var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultInjection
 */

'use strict';

var BeforeInputEventPlugin = __webpack_require__(63);
var ChangeEventPlugin = __webpack_require__(78);
var DefaultEventPluginOrder = __webpack_require__(90);
var EnterLeaveEventPlugin = __webpack_require__(91);
var HTMLDOMPropertyConfig = __webpack_require__(96);
var ReactComponentBrowserEnvironment = __webpack_require__(97);
var ReactDOMComponent = __webpack_require__(111);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactDOMEmptyComponent = __webpack_require__(152);
var ReactDOMTreeTraversal = __webpack_require__(153);
var ReactDOMTextComponent = __webpack_require__(154);
var ReactDefaultBatchingStrategy = __webpack_require__(155);
var ReactEventListener = __webpack_require__(156);
var ReactInjection = __webpack_require__(159);
var ReactReconcileTransaction = __webpack_require__(160);
var SVGDOMPropertyConfig = __webpack_require__(168);
var SelectEventPlugin = __webpack_require__(169);
var SimpleEventPlugin = __webpack_require__(170);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BeforeInputEventPlugin
 */

'use strict';

var EventConstants = __webpack_require__(64);
var EventPropagators = __webpack_require__(65);
var ExecutionEnvironment = __webpack_require__(72);
var FallbackCompositionState = __webpack_require__(73);
var SyntheticCompositionEvent = __webpack_require__(75);
var SyntheticInputEvent = __webpack_require__(77);

var keyOf = __webpack_require__(51);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

var topLevelTypes = EventConstants.topLevelTypes;

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBeforeInput: null }),
      captured: keyOf({ onBeforeInputCapture: null })
    },
    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionEnd: null }),
      captured: keyOf({ onCompositionEndCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionStart: null }),
      captured: keyOf({ onCompositionStartCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionUpdate: null }),
      captured: keyOf({ onCompositionUpdateCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionStart:
      return eventTypes.compositionStart;
    case topLevelTypes.topCompositionEnd:
      return eventTypes.compositionEnd;
    case topLevelTypes.topCompositionUpdate:
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topKeyUp:
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case topLevelTypes.topKeyDown:
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case topLevelTypes.topKeyPress:
    case topLevelTypes.topMouseDown:
    case topLevelTypes.topBlur:
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionEnd:
      return getDataFromCustomEvent(nativeEvent);
    case topLevelTypes.topKeyPress:
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case topLevelTypes.topTextInput:
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === topLevelTypes.topCompositionEnd || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case topLevelTypes.topPaste:
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case topLevelTypes.topKeyPress:
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case topLevelTypes.topCompositionEnd:
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventConstants
 */

'use strict';

var keyMirror = __webpack_require__(49);

var PropagationPhases = keyMirror({ bubbled: null, captured: null });

/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = keyMirror({
  topAbort: null,
  topAnimationEnd: null,
  topAnimationIteration: null,
  topAnimationStart: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topInvalid: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topTransitionEnd: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
});

var EventConstants = {
  topLevelTypes: topLevelTypes,
  PropagationPhases: PropagationPhases
};

module.exports = EventConstants;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPropagators
 */

'use strict';

var EventConstants = __webpack_require__(64);
var EventPluginHub = __webpack_require__(66);
var EventPluginUtils = __webpack_require__(68);

var accumulateInto = __webpack_require__(70);
var forEachAccumulated = __webpack_require__(71);
var warning = __webpack_require__(37);

var PropagationPhases = EventConstants.PropagationPhases;
var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, upwards, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginHub
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var EventPluginRegistry = __webpack_require__(67);
var EventPluginUtils = __webpack_require__(68);
var ReactErrorUtils = __webpack_require__(69);

var accumulateInto = __webpack_require__(70);
var forEachAccumulated = __webpack_require__(71);
var invariant = __webpack_require__(34);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    var bankForRegistrationName = listenerBank[registrationName];
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginRegistry
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

/**
 * Injectable ordering of event plugins.
 */
var EventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!EventPluginOrder) {
    // Wait until an `EventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var PluginModule = namesToPlugins[pluginName];
    var pluginIndex = EventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
    var publishedEvents = PluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, PluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (InjectedEventPluginOrder) {
    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var PluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = PluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    for (var phase in dispatchConfig.phasedRegistrationNames) {
      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
        continue;
      }
      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
      if (PluginModule) {
        return PluginModule;
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    EventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginUtils
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var EventConstants = __webpack_require__(64);
var ReactErrorUtils = __webpack_require__(69);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

var topLevelTypes = EventConstants.topLevelTypes;

function isEndish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
}

function isMoveish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
}
function isStartish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactErrorUtils
 */

'use strict';

var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {?String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a, b) {
  try {
    return func(a, b);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
    return undefined;
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
      var boundFunc = func.bind(null, a, b);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule accumulateInto
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ },
/* 71 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule forEachAccumulated
 * 
 */

'use strict';

/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ },
/* 72 */
/***/ function(module, exports) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FallbackCompositionState
 */

'use strict';

var _assign = __webpack_require__(30);

var PooledClass = __webpack_require__(32);

var getTextContentAccessor = __webpack_require__(74);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentAccessor
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(72);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticCompositionEvent
 */

'use strict';

var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticEvent
 */

'use strict';

var _assign = __webpack_require__(30);

var PooledClass = __webpack_require__(32);

var emptyFunction = __webpack_require__(38);
var warning = __webpack_require__(37);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticInputEvent
 */

'use strict';

var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ChangeEventPlugin
 */

'use strict';

var EventConstants = __webpack_require__(64);
var EventPluginHub = __webpack_require__(66);
var EventPropagators = __webpack_require__(65);
var ExecutionEnvironment = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactUpdates = __webpack_require__(79);
var SyntheticEvent = __webpack_require__(76);

var getEventTarget = __webpack_require__(87);
var isEventSupported = __webpack_require__(88);
var isTextInputElement = __webpack_require__(89);
var keyOf = __webpack_require__(51);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onChange: null }),
      captured: keyOf({ onChangeCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topChange) {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === topLevelTypes.topFocus) {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topInput) {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === topLevelTypes.topFocus) {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topClick) {
    return targetInst;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdates
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var CallbackQueue = __webpack_require__(80);
var PooledClass = __webpack_require__(32);
var ReactFeatureFlags = __webpack_require__(81);
var ReactReconciler = __webpack_require__(82);
var Transaction = __webpack_require__(86);

var invariant = __webpack_require__(34);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.props === component._renderedComponent._currentElement) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CallbackQueue
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var PooledClass = __webpack_require__(32);

var invariant = __webpack_require__(34);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */
function CallbackQueue() {
  this._callbacks = null;
  this._contexts = null;
}

_assign(CallbackQueue.prototype, {

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */
  enqueue: function (callback, context) {
    this._callbacks = this._callbacks || [];
    this._contexts = this._contexts || [];
    this._callbacks.push(callback);
    this._contexts.push(context);
  },

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */
  notifyAll: function () {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    if (callbacks) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i]);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  },

  checkpoint: function () {
    return this._callbacks ? this._callbacks.length : 0;
  },

  rollback: function (len) {
    if (this._callbacks) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  },

  /**
   * Resets the internal queue.
   *
   * @internal
   */
  reset: function () {
    this._callbacks = null;
    this._contexts = null;
  },

  /**
   * `PooledClass` looks for this.
   */
  destructor: function () {
    this.reset();
  }

});

PooledClass.addPoolingTo(CallbackQueue);

module.exports = CallbackQueue;

/***/ },
/* 81 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactFeatureFlags
 * 
 */

'use strict';

var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconciler
 */

'use strict';

var ReactRef = __webpack_require__(83);
var ReactInstrumentation = __webpack_require__(85);

var warning = __webpack_require__(37);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRef
 */

'use strict';

var ReactOwner = __webpack_require__(84);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;

  return (
    // This has a few false positives w/r/t empty components.
    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
    // If owner changes but we have an unchanged function ref, don't update refs
    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
  );
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactOwner
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {

  /**
   * @param {?object} object
   * @return {boolean} True if `object` is a valid owner.
   * @final
   */
  isValidOwner: function (object) {
    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
  },

  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstrumentation
 */

'use strict';

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Transaction
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var Mixin = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

var Transaction = {

  Mixin: Mixin,

  /**
   * Token to look for to determine if an error occurred.
   */
  OBSERVED_ERROR: {}

};

module.exports = Transaction;

/***/ },
/* 87 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventTarget
 */

'use strict';

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(72);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ },
/* 89 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextInputElement
 * 
 */

'use strict';

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultEventPluginOrder
 */

'use strict';

var keyOf = __webpack_require__(51);

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */
var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];

module.exports = DefaultEventPluginOrder;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EnterLeaveEventPlugin
 */

'use strict';

var EventConstants = __webpack_require__(64);
var EventPropagators = __webpack_require__(65);
var ReactDOMComponentTree = __webpack_require__(59);
var SyntheticMouseEvent = __webpack_require__(92);

var keyOf = __webpack_require__(51);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  mouseEnter: {
    registrationName: keyOf({ onMouseEnter: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  },
  mouseLeave: {
    registrationName: keyOf({ onMouseLeave: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === topLevelTypes.topMouseOut) {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticMouseEvent
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(93);
var ViewportMetrics = __webpack_require__(94);

var getEventModifierState = __webpack_require__(95);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticUIEvent
 */

'use strict';

var SyntheticEvent = __webpack_require__(76);

var getEventTarget = __webpack_require__(87);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ },
/* 94 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ViewportMetrics
 */

'use strict';

var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ },
/* 95 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventModifierState
 */

'use strict';

/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule HTMLDOMPropertyConfig
 */

'use strict';

var DOMProperty = __webpack_require__(60);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {}
};

module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentBrowserEnvironment
 */

'use strict';

var DOMChildrenOperations = __webpack_require__(98);
var ReactDOMIDOperations = __webpack_require__(110);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMChildrenOperations
 */

'use strict';

var DOMLazyTree = __webpack_require__(99);
var Danger = __webpack_require__(105);
var ReactMultiChildUpdateTypes = __webpack_require__(109);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactInstrumentation = __webpack_require__(85);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(102);
var setInnerHTML = __webpack_require__(101);
var setTextContent = __webpack_require__(103);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
          }
          break;
        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
          }
          break;
        case ReactMultiChildUpdateTypes.SET_MARKUP:
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
          }
          break;
        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
          }
          break;
        case ReactMultiChildUpdateTypes.REMOVE_NODE:
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMLazyTree
 */

'use strict';

var DOMNamespaces = __webpack_require__(100);
var setInnerHTML = __webpack_require__(101);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(102);
var setTextContent = __webpack_require__(103);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ },
/* 100 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMNamespaces
 */

'use strict';

var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setInnerHTML
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(72);
var DOMNamespaces = __webpack_require__(100);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(102);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ },
/* 102 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createMicrosoftUnsafeLocalFunction
 */

/* globals MSApp */

'use strict';

/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setTextContent
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(72);
var escapeTextContentForBrowser = __webpack_require__(104);
var setInnerHTML = __webpack_require__(101);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ },
/* 104 */
/***/ function(module, exports) {

/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * @providesModule escapeTextContentForBrowser
 */

'use strict';

// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Danger
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var DOMLazyTree = __webpack_require__(99);
var ExecutionEnvironment = __webpack_require__(72);

var createNodesFromMarkup = __webpack_require__(106);
var emptyFunction = __webpack_require__(38);
var invariant = __webpack_require__(34);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(72);

var createArrayFromMixed = __webpack_require__(107);
var getMarkupWrap = __webpack_require__(108);
var invariant = __webpack_require__(34);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(34);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(72);

var invariant = __webpack_require__(34);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChildUpdateTypes
 */

'use strict';

var keyMirror = __webpack_require__(49);

/**
 * When a component's children are updated, a series of update configuration
 * objects are created in order to batch and serialize the required changes.
 *
 * Enumerates all the possible types of update configurations.
 *
 * @internal
 */
var ReactMultiChildUpdateTypes = keyMirror({
  INSERT_MARKUP: null,
  MOVE_EXISTING: null,
  REMOVE_NODE: null,
  SET_MARKUP: null,
  TEXT_CONTENT: null
});

module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMIDOperations
 */

'use strict';

var DOMChildrenOperations = __webpack_require__(98);
var ReactDOMComponentTree = __webpack_require__(59);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponent
 */

/* global hasOwnProperty:true */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var AutoFocusUtils = __webpack_require__(112);
var CSSPropertyOperations = __webpack_require__(114);
var DOMLazyTree = __webpack_require__(99);
var DOMNamespaces = __webpack_require__(100);
var DOMProperty = __webpack_require__(60);
var DOMPropertyOperations = __webpack_require__(122);
var EventConstants = __webpack_require__(64);
var EventPluginHub = __webpack_require__(66);
var EventPluginRegistry = __webpack_require__(67);
var ReactBrowserEventEmitter = __webpack_require__(124);
var ReactDOMButton = __webpack_require__(127);
var ReactDOMComponentFlags = __webpack_require__(61);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactDOMInput = __webpack_require__(129);
var ReactDOMOption = __webpack_require__(131);
var ReactDOMSelect = __webpack_require__(132);
var ReactDOMTextarea = __webpack_require__(133);
var ReactInstrumentation = __webpack_require__(85);
var ReactMultiChild = __webpack_require__(134);
var ReactServerRenderingTransaction = __webpack_require__(148);

var emptyFunction = __webpack_require__(38);
var escapeTextContentForBrowser = __webpack_require__(104);
var invariant = __webpack_require__(34);
var isEventSupported = __webpack_require__(88);
var keyOf = __webpack_require__(51);
var shallowEqual = __webpack_require__(143);
var validateDOMNesting = __webpack_require__(151);
var warning = __webpack_require__(37);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = keyOf({ style: null });
var HTML = keyOf({ __html: null });
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

// NOTE: menuitem's close tag should be omitted, but that causes problems.
var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'button':
        props = ReactDOMButton.getHostProps(this, props, hostParent);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
        DOMLazyTree.queueText(lazyTree, contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'button':
        lastProps = ReactDOMButton.getHostProps(this, lastProps);
        nextProps = ReactDOMButton.getHostProps(this, nextProps);
        break;
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AutoFocusUtils
 */

'use strict';

var ReactDOMComponentTree = __webpack_require__(59);

var focusNode = __webpack_require__(113);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ },
/* 113 */
/***/ function(module, exports) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSPropertyOperations
 */

'use strict';

var CSSProperty = __webpack_require__(115);
var ExecutionEnvironment = __webpack_require__(72);
var ReactInstrumentation = __webpack_require__(85);

var camelizeStyleName = __webpack_require__(116);
var dangerousStyleValue = __webpack_require__(118);
var hyphenateStyleName = __webpack_require__(119);
var memoizeStringOnly = __webpack_require__(121);
var warning = __webpack_require__(37);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ },
/* 115 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

'use strict';

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

'use strict';

var camelize = __webpack_require__(117);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ },
/* 117 */
/***/ function(module, exports) {

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

'use strict';

var CSSProperty = __webpack_require__(115);
var warning = __webpack_require__(37);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

'use strict';

var hyphenate = __webpack_require__(120);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ },
/* 120 */
/***/ function(module, exports) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ },
/* 121 */
/***/ function(module, exports) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */

'use strict';

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMPropertyOperations
 */

'use strict';

var DOMProperty = __webpack_require__(60);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactInstrumentation = __webpack_require__(85);

var quoteAttributeValueForBrowser = __webpack_require__(123);
var warning = __webpack_require__(37);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule quoteAttributeValueForBrowser
 */

'use strict';

var escapeTextContentForBrowser = __webpack_require__(104);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserEventEmitter
 */

'use strict';

var _assign = __webpack_require__(30);

var EventConstants = __webpack_require__(64);
var EventPluginRegistry = __webpack_require__(67);
var ReactEventEmitterMixin = __webpack_require__(125);
var ViewportMetrics = __webpack_require__(94);

var getVendorPrefixedEventName = __webpack_require__(126);
var isEventSupported = __webpack_require__(88);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    var topLevelTypes = EventConstants.topLevelTypes;
    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === topLevelTypes.topWheel) {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === topLevelTypes.topScroll) {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening[topLevelTypes.topBlur] = true;
          isListening[topLevelTypes.topFocus] = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventEmitterMixin
 */

'use strict';

var EventPluginHub = __webpack_require__(66);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVendorPrefixedEventName
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(72);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMButton
 */

'use strict';

var DisabledInputUtils = __webpack_require__(128);

/**
 * Implements a <button> host component that does not receive mouse events
 * when `disabled` is set.
 */
var ReactDOMButton = {
  getHostProps: DisabledInputUtils.getHostProps
};

module.exports = ReactDOMButton;

/***/ },
/* 128 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DisabledInputUtils
 */

'use strict';

var disableableMouseListenerNames = {
  onClick: true,
  onDoubleClick: true,
  onMouseDown: true,
  onMouseMove: true,
  onMouseUp: true,

  onClickCapture: true,
  onDoubleClickCapture: true,
  onMouseDownCapture: true,
  onMouseMoveCapture: true,
  onMouseUpCapture: true
};

/**
 * Implements a host component that does not receive mouse events
 * when `disabled` is set.
 */
var DisabledInputUtils = {
  getHostProps: function (inst, props) {
    if (!props.disabled) {
      return props;
    }

    // Copy the props, except the mouse listeners
    var hostProps = {};
    for (var key in props) {
      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
        hostProps[key] = props[key];
      }
    }

    return hostProps;
  }
};

module.exports = DisabledInputUtils;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMInput
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var DisabledInputUtils = __webpack_require__(128);
var DOMPropertyOperations = __webpack_require__(122);
var LinkedValueUtils = __webpack_require__(130);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactUpdates = __webpack_require__(79);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, DisabledInputUtils.getHostProps(inst, props), {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };

    if (false) {
      inst._wrapperState.controlled = isControlled(props);
    }
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {

      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        node.defaultValue = '' + props.defaultValue;
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule LinkedValueUtils
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactPropTypes = __webpack_require__(53);
var ReactPropTypeLocations = __webpack_require__(48);
var ReactPropTypesSecret = __webpack_require__(54);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: ReactPropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMOption
 */

'use strict';

var _assign = __webpack_require__(30);

var ReactChildren = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactDOMSelect = __webpack_require__(132);

var warning = __webpack_require__(37);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  ReactChildren.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelect
 */

'use strict';

var _assign = __webpack_require__(30);

var DisabledInputUtils = __webpack_require__(128);
var LinkedValueUtils = __webpack_require__(130);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactUpdates = __webpack_require__(79);

var warning = __webpack_require__(37);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextarea
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var DisabledInputUtils = __webpack_require__(128);
var LinkedValueUtils = __webpack_require__(130);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactUpdates = __webpack_require__(79);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
    node.value = node.textContent; // Detach value from defaultValue
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChild
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactComponentEnvironment = __webpack_require__(135);
var ReactInstanceMap = __webpack_require__(136);
var ReactInstrumentation = __webpack_require__(85);
var ReactMultiChildUpdateTypes = __webpack_require__(109);

var ReactCurrentOwner = __webpack_require__(36);
var ReactReconciler = __webpack_require__(82);
var ReactChildReconciler = __webpack_require__(137);

var emptyFunction = __webpack_require__(38);
var flattenChildren = __webpack_require__(147);
var invariant = __webpack_require__(34);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.SET_MARKUP,
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentEnvironment
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ },
/* 136 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceMap
 */

'use strict';

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildReconciler
 */

'use strict';

var ReactReconciler = __webpack_require__(82);

var instantiateReactComponent = __webpack_require__(138);
var KeyEscapeUtils = __webpack_require__(42);
var shouldUpdateReactComponent = __webpack_require__(144);
var traverseAllChildren = __webpack_require__(40);
var warning = __webpack_require__(37);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(142);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('./ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule instantiateReactComponent
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var ReactCompositeComponent = __webpack_require__(139);
var ReactEmptyComponent = __webpack_require__(145);
var ReactHostComponent = __webpack_require__(146);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};
_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

var nextDebugID = 1;

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCompositeComponent
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var ReactComponentEnvironment = __webpack_require__(135);
var ReactCurrentOwner = __webpack_require__(36);
var ReactElement = __webpack_require__(35);
var ReactErrorUtils = __webpack_require__(69);
var ReactInstanceMap = __webpack_require__(136);
var ReactInstrumentation = __webpack_require__(85);
var ReactNodeTypes = __webpack_require__(140);
var ReactPropTypeLocations = __webpack_require__(48);
var ReactReconciler = __webpack_require__(82);

var checkReactTypeSpec = __webpack_require__(141);
var emptyObject = __webpack_require__(45);
var invariant = __webpack_require__(34);
var shallowEqual = __webpack_require__(143);
var shouldUpdateReactComponent = __webpack_require__(144);
var warning = __webpack_require__(37);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponentMixin = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedComponent;

    if (false) {
      renderedComponent = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedComponent = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedComponent === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedComponent = null;
      }
    }

    return renderedComponent;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedComponent;
    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedComponent;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

var ReactCompositeComponent = {

  Mixin: ReactCompositeComponentMixin

};

module.exports = ReactCompositeComponent;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNodeTypes
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactElement = __webpack_require__(35);

var invariant = __webpack_require__(34);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (ReactElement.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule checkReactTypeSpec
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactPropTypeLocationNames = __webpack_require__(50);
var ReactPropTypesSecret = __webpack_require__(54);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(142);
}

var loggedTypeFailures = {};

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?object} element The React element that is being type-checked
 * @param {?number} debugID The React component instance that is being type-checked
 * @private
 */
function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
  for (var typeSpecName in typeSpecs) {
    if (typeSpecs.hasOwnProperty(typeSpecName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
      } catch (ex) {
        error = ex;
      }
       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var componentStackInfo = '';

        if (false) {
          if (!ReactComponentTreeHook) {
            ReactComponentTreeHook = require('./ReactComponentTreeHook');
          }
          if (debugID !== null) {
            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
          } else if (element !== null) {
            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
          }
        }

         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
      }
    }
  }
}

module.exports = checkReactTypeSpec;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentTreeHook
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(36);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var itemMap;
var rootIDSet;

var itemByKey;
var rootByKey;

if (canUseCollections) {
  itemMap = new Map();
  rootIDSet = new Set();
} else {
  itemByKey = {};
  rootByKey = {};
}

var unmountedIDs = [];

// Use non-numeric keys to prevent V8 performance issues:
// https://github.com/facebook/react/pull/7232
function getKeyFromID(id) {
  return '.' + id;
}
function getIDFromKey(key) {
  return parseInt(key.substr(1), 10);
}

function get(id) {
  if (canUseCollections) {
    return itemMap.get(id);
  } else {
    var key = getKeyFromID(id);
    return itemByKey[key];
  }
}

function remove(id) {
  if (canUseCollections) {
    itemMap['delete'](id);
  } else {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  }
}

function create(id, element, parentID) {
  var item = {
    element: element,
    parentID: parentID,
    text: null,
    childIDs: [],
    isMounted: false,
    updateCount: 0
  };

  if (canUseCollections) {
    itemMap.set(id, item);
  } else {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  }
}

function addRoot(id) {
  if (canUseCollections) {
    rootIDSet.add(id);
  } else {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  }
}

function removeRoot(id) {
  if (canUseCollections) {
    rootIDSet['delete'](id);
  } else {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  }
}

function getRegisteredIDs() {
  if (canUseCollections) {
    return Array.from(itemMap.keys());
  } else {
    return Object.keys(itemByKey).map(getIDFromKey);
  }
}

function getRootIDs() {
  if (canUseCollections) {
    return Array.from(rootIDSet.keys());
  } else {
    return Object.keys(rootByKey).map(getIDFromKey);
  }
}

function purgeDeep(id) {
  var item = get(id);
  if (item) {
    var childIDs = item.childIDs;

    remove(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = get(id);
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = get(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent ID is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    create(id, element, parentID);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = get(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = get(id);
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = get(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = get(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = get(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var type = topElement.type;
      var name = typeof type === 'function' ? type.displayName || type.name : type;
      var owner = topElement._owner;
      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = get(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = get(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = get(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = get(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = get(id);
    return item ? item.updateCount : 0;
  },


  getRegisteredIDs: getRegisteredIDs,

  getRootIDs: getRootIDs
};

module.exports = ReactComponentTreeHook;

/***/ },
/* 143 */
/***/ function(module, exports) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */

'use strict';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ },
/* 144 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shouldUpdateReactComponent
 */

'use strict';

/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ },
/* 145 */
/***/ function(module, exports) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponent
 */

'use strict';

var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactHostComponent
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var invariant = __webpack_require__(34);

var genericComponentClass = null;
// This registry keeps track of wrapper classes around host tags.
var tagToComponentClass = {};
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  },
  // This accepts a keyed object with classes as values. Each key represents a
  // tag. That particular tag will use this class instead of the generic one.
  injectComponentClasses: function (componentClasses) {
    _assign(tagToComponentClass, componentClasses);
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule flattenChildren
 * 
 */

'use strict';

var KeyEscapeUtils = __webpack_require__(42);
var traverseAllChildren = __webpack_require__(40);
var warning = __webpack_require__(37);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(142);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('./ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerRenderingTransaction
 */

'use strict';

var _assign = __webpack_require__(30);

var PooledClass = __webpack_require__(32);
var Transaction = __webpack_require__(86);
var ReactInstrumentation = __webpack_require__(85);
var ReactServerUpdateQueue = __webpack_require__(149);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerUpdateQueue
 * 
 */

'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(150);
var Transaction = __webpack_require__(86);
var warning = __webpack_require__(37);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  /* :: transaction: Transaction; */

  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdateQueue
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(36);
var ReactInstanceMap = __webpack_require__(136);
var ReactInstrumentation = __webpack_require__(85);
var ReactUpdates = __webpack_require__(79);

var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule validateDOMNesting
 */

'use strict';

var _assign = __webpack_require__(30);

var emptyFunction = __webpack_require__(38);
var warning = __webpack_require__(37);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMEmptyComponent
 */

'use strict';

var _assign = __webpack_require__(30);

var DOMLazyTree = __webpack_require__(99);
var ReactDOMComponentTree = __webpack_require__(59);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTreeTraversal
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(34);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], false, arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], true, arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], true, argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], false, argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextComponent
 */

'use strict';

var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(30);

var DOMChildrenOperations = __webpack_require__(98);
var DOMLazyTree = __webpack_require__(99);
var ReactDOMComponentTree = __webpack_require__(59);

var escapeTextContentForBrowser = __webpack_require__(104);
var invariant = __webpack_require__(34);
var validateDOMNesting = __webpack_require__(151);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultBatchingStrategy
 */

'use strict';

var _assign = __webpack_require__(30);

var ReactUpdates = __webpack_require__(79);
var Transaction = __webpack_require__(86);

var emptyFunction = __webpack_require__(38);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      callback(a, b, c, d, e);
    } else {
      transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventListener
 */

'use strict';

var _assign = __webpack_require__(30);

var EventListener = __webpack_require__(157);
var ExecutionEnvironment = __webpack_require__(72);
var PooledClass = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactUpdates = __webpack_require__(79);

var getEventTarget = __webpack_require__(87);
var getUnboundedScrollPosition = __webpack_require__(158);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(38);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ },
/* 158 */
/***/ function(module, exports) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

'use strict';

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable === window) {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft,
      y: window.pageYOffset || document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInjection
 */

'use strict';

var DOMProperty = __webpack_require__(60);
var EventPluginHub = __webpack_require__(66);
var EventPluginUtils = __webpack_require__(68);
var ReactComponentEnvironment = __webpack_require__(135);
var ReactClass = __webpack_require__(47);
var ReactEmptyComponent = __webpack_require__(145);
var ReactBrowserEventEmitter = __webpack_require__(124);
var ReactHostComponent = __webpack_require__(146);
var ReactUpdates = __webpack_require__(79);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  Class: ReactClass.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconcileTransaction
 */

'use strict';

var _assign = __webpack_require__(30);

var CallbackQueue = __webpack_require__(80);
var PooledClass = __webpack_require__(32);
var ReactBrowserEventEmitter = __webpack_require__(124);
var ReactInputSelection = __webpack_require__(161);
var ReactInstrumentation = __webpack_require__(85);
var Transaction = __webpack_require__(86);
var ReactUpdateQueue = __webpack_require__(150);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInputSelection
 */

'use strict';

var ReactDOMSelection = __webpack_require__(162);

var containsNode = __webpack_require__(164);
var focusNode = __webpack_require__(113);
var getActiveElement = __webpack_require__(167);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelection
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(72);

var getNodeForCharacterOffset = __webpack_require__(163);
var getTextContentAccessor = __webpack_require__(74);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ },
/* 163 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNodeForCharacterOffset
 */

'use strict';

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(165);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(166);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ },
/* 166 */
/***/ function(module, exports) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ },
/* 167 */
/***/ function(module, exports) {

'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 */
function getActiveElement() /*?DOMElement*/{
  if (typeof document === 'undefined') {
    return null;
  }
  try {
    return document.activeElement || document.body;
  } catch (e) {
    return document.body;
  }
}

module.exports = getActiveElement;

/***/ },
/* 168 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SVGDOMPropertyConfig
 */

'use strict';

var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectEventPlugin
 */

'use strict';

var EventConstants = __webpack_require__(64);
var EventPropagators = __webpack_require__(65);
var ExecutionEnvironment = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactInputSelection = __webpack_require__(161);
var SyntheticEvent = __webpack_require__(76);

var getActiveElement = __webpack_require__(167);
var isTextInputElement = __webpack_require__(89);
var keyOf = __webpack_require__(51);
var shallowEqual = __webpack_require__(143);

var topLevelTypes = EventConstants.topLevelTypes;

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSelect: null }),
      captured: keyOf({ onSelectCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;
var ON_SELECT_KEY = keyOf({ onSelect: null });

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case topLevelTypes.topFocus:
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case topLevelTypes.topBlur:
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case topLevelTypes.topMouseDown:
        mouseDown = true;
        break;
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topMouseUp:
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case topLevelTypes.topSelectionChange:
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === ON_SELECT_KEY) {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SimpleEventPlugin
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var EventConstants = __webpack_require__(64);
var EventListener = __webpack_require__(157);
var EventPropagators = __webpack_require__(65);
var ReactDOMComponentTree = __webpack_require__(59);
var SyntheticAnimationEvent = __webpack_require__(171);
var SyntheticClipboardEvent = __webpack_require__(172);
var SyntheticEvent = __webpack_require__(76);
var SyntheticFocusEvent = __webpack_require__(173);
var SyntheticKeyboardEvent = __webpack_require__(174);
var SyntheticMouseEvent = __webpack_require__(92);
var SyntheticDragEvent = __webpack_require__(177);
var SyntheticTouchEvent = __webpack_require__(178);
var SyntheticTransitionEvent = __webpack_require__(179);
var SyntheticUIEvent = __webpack_require__(93);
var SyntheticWheelEvent = __webpack_require__(180);

var emptyFunction = __webpack_require__(38);
var getEventCharCode = __webpack_require__(175);
var invariant = __webpack_require__(34);
var keyOf = __webpack_require__(51);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  abort: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAbort: true }),
      captured: keyOf({ onAbortCapture: true })
    }
  },
  animationEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAnimationEnd: true }),
      captured: keyOf({ onAnimationEndCapture: true })
    }
  },
  animationIteration: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAnimationIteration: true }),
      captured: keyOf({ onAnimationIterationCapture: true })
    }
  },
  animationStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAnimationStart: true }),
      captured: keyOf({ onAnimationStartCapture: true })
    }
  },
  blur: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBlur: true }),
      captured: keyOf({ onBlurCapture: true })
    }
  },
  canPlay: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlay: true }),
      captured: keyOf({ onCanPlayCapture: true })
    }
  },
  canPlayThrough: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlayThrough: true }),
      captured: keyOf({ onCanPlayThroughCapture: true })
    }
  },
  click: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onClick: true }),
      captured: keyOf({ onClickCapture: true })
    }
  },
  contextMenu: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onContextMenu: true }),
      captured: keyOf({ onContextMenuCapture: true })
    }
  },
  copy: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCopy: true }),
      captured: keyOf({ onCopyCapture: true })
    }
  },
  cut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCut: true }),
      captured: keyOf({ onCutCapture: true })
    }
  },
  doubleClick: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDoubleClick: true }),
      captured: keyOf({ onDoubleClickCapture: true })
    }
  },
  drag: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrag: true }),
      captured: keyOf({ onDragCapture: true })
    }
  },
  dragEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnd: true }),
      captured: keyOf({ onDragEndCapture: true })
    }
  },
  dragEnter: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnter: true }),
      captured: keyOf({ onDragEnterCapture: true })
    }
  },
  dragExit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragExit: true }),
      captured: keyOf({ onDragExitCapture: true })
    }
  },
  dragLeave: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragLeave: true }),
      captured: keyOf({ onDragLeaveCapture: true })
    }
  },
  dragOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragOver: true }),
      captured: keyOf({ onDragOverCapture: true })
    }
  },
  dragStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragStart: true }),
      captured: keyOf({ onDragStartCapture: true })
    }
  },
  drop: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrop: true }),
      captured: keyOf({ onDropCapture: true })
    }
  },
  durationChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDurationChange: true }),
      captured: keyOf({ onDurationChangeCapture: true })
    }
  },
  emptied: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEmptied: true }),
      captured: keyOf({ onEmptiedCapture: true })
    }
  },
  encrypted: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEncrypted: true }),
      captured: keyOf({ onEncryptedCapture: true })
    }
  },
  ended: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEnded: true }),
      captured: keyOf({ onEndedCapture: true })
    }
  },
  error: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onError: true }),
      captured: keyOf({ onErrorCapture: true })
    }
  },
  focus: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onFocus: true }),
      captured: keyOf({ onFocusCapture: true })
    }
  },
  input: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInput: true }),
      captured: keyOf({ onInputCapture: true })
    }
  },
  invalid: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInvalid: true }),
      captured: keyOf({ onInvalidCapture: true })
    }
  },
  keyDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyDown: true }),
      captured: keyOf({ onKeyDownCapture: true })
    }
  },
  keyPress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyPress: true }),
      captured: keyOf({ onKeyPressCapture: true })
    }
  },
  keyUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyUp: true }),
      captured: keyOf({ onKeyUpCapture: true })
    }
  },
  load: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoad: true }),
      captured: keyOf({ onLoadCapture: true })
    }
  },
  loadedData: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedData: true }),
      captured: keyOf({ onLoadedDataCapture: true })
    }
  },
  loadedMetadata: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedMetadata: true }),
      captured: keyOf({ onLoadedMetadataCapture: true })
    }
  },
  loadStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadStart: true }),
      captured: keyOf({ onLoadStartCapture: true })
    }
  },
  // Note: We do not allow listening to mouseOver events. Instead, use the
  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
  mouseDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseDown: true }),
      captured: keyOf({ onMouseDownCapture: true })
    }
  },
  mouseMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseMove: true }),
      captured: keyOf({ onMouseMoveCapture: true })
    }
  },
  mouseOut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOut: true }),
      captured: keyOf({ onMouseOutCapture: true })
    }
  },
  mouseOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOver: true }),
      captured: keyOf({ onMouseOverCapture: true })
    }
  },
  mouseUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseUp: true }),
      captured: keyOf({ onMouseUpCapture: true })
    }
  },
  paste: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPaste: true }),
      captured: keyOf({ onPasteCapture: true })
    }
  },
  pause: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPause: true }),
      captured: keyOf({ onPauseCapture: true })
    }
  },
  play: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlay: true }),
      captured: keyOf({ onPlayCapture: true })
    }
  },
  playing: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlaying: true }),
      captured: keyOf({ onPlayingCapture: true })
    }
  },
  progress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onProgress: true }),
      captured: keyOf({ onProgressCapture: true })
    }
  },
  rateChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onRateChange: true }),
      captured: keyOf({ onRateChangeCapture: true })
    }
  },
  reset: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onReset: true }),
      captured: keyOf({ onResetCapture: true })
    }
  },
  scroll: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onScroll: true }),
      captured: keyOf({ onScrollCapture: true })
    }
  },
  seeked: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeked: true }),
      captured: keyOf({ onSeekedCapture: true })
    }
  },
  seeking: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeking: true }),
      captured: keyOf({ onSeekingCapture: true })
    }
  },
  stalled: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onStalled: true }),
      captured: keyOf({ onStalledCapture: true })
    }
  },
  submit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSubmit: true }),
      captured: keyOf({ onSubmitCapture: true })
    }
  },
  suspend: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSuspend: true }),
      captured: keyOf({ onSuspendCapture: true })
    }
  },
  timeUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTimeUpdate: true }),
      captured: keyOf({ onTimeUpdateCapture: true })
    }
  },
  touchCancel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchCancel: true }),
      captured: keyOf({ onTouchCancelCapture: true })
    }
  },
  touchEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchEnd: true }),
      captured: keyOf({ onTouchEndCapture: true })
    }
  },
  touchMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchMove: true }),
      captured: keyOf({ onTouchMoveCapture: true })
    }
  },
  touchStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchStart: true }),
      captured: keyOf({ onTouchStartCapture: true })
    }
  },
  transitionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTransitionEnd: true }),
      captured: keyOf({ onTransitionEndCapture: true })
    }
  },
  volumeChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onVolumeChange: true }),
      captured: keyOf({ onVolumeChangeCapture: true })
    }
  },
  waiting: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWaiting: true }),
      captured: keyOf({ onWaitingCapture: true })
    }
  },
  wheel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWheel: true }),
      captured: keyOf({ onWheelCapture: true })
    }
  }
};

var topLevelEventsToDispatchConfig = {
  topAbort: eventTypes.abort,
  topAnimationEnd: eventTypes.animationEnd,
  topAnimationIteration: eventTypes.animationIteration,
  topAnimationStart: eventTypes.animationStart,
  topBlur: eventTypes.blur,
  topCanPlay: eventTypes.canPlay,
  topCanPlayThrough: eventTypes.canPlayThrough,
  topClick: eventTypes.click,
  topContextMenu: eventTypes.contextMenu,
  topCopy: eventTypes.copy,
  topCut: eventTypes.cut,
  topDoubleClick: eventTypes.doubleClick,
  topDrag: eventTypes.drag,
  topDragEnd: eventTypes.dragEnd,
  topDragEnter: eventTypes.dragEnter,
  topDragExit: eventTypes.dragExit,
  topDragLeave: eventTypes.dragLeave,
  topDragOver: eventTypes.dragOver,
  topDragStart: eventTypes.dragStart,
  topDrop: eventTypes.drop,
  topDurationChange: eventTypes.durationChange,
  topEmptied: eventTypes.emptied,
  topEncrypted: eventTypes.encrypted,
  topEnded: eventTypes.ended,
  topError: eventTypes.error,
  topFocus: eventTypes.focus,
  topInput: eventTypes.input,
  topInvalid: eventTypes.invalid,
  topKeyDown: eventTypes.keyDown,
  topKeyPress: eventTypes.keyPress,
  topKeyUp: eventTypes.keyUp,
  topLoad: eventTypes.load,
  topLoadedData: eventTypes.loadedData,
  topLoadedMetadata: eventTypes.loadedMetadata,
  topLoadStart: eventTypes.loadStart,
  topMouseDown: eventTypes.mouseDown,
  topMouseMove: eventTypes.mouseMove,
  topMouseOut: eventTypes.mouseOut,
  topMouseOver: eventTypes.mouseOver,
  topMouseUp: eventTypes.mouseUp,
  topPaste: eventTypes.paste,
  topPause: eventTypes.pause,
  topPlay: eventTypes.play,
  topPlaying: eventTypes.playing,
  topProgress: eventTypes.progress,
  topRateChange: eventTypes.rateChange,
  topReset: eventTypes.reset,
  topScroll: eventTypes.scroll,
  topSeeked: eventTypes.seeked,
  topSeeking: eventTypes.seeking,
  topStalled: eventTypes.stalled,
  topSubmit: eventTypes.submit,
  topSuspend: eventTypes.suspend,
  topTimeUpdate: eventTypes.timeUpdate,
  topTouchCancel: eventTypes.touchCancel,
  topTouchEnd: eventTypes.touchEnd,
  topTouchMove: eventTypes.touchMove,
  topTouchStart: eventTypes.touchStart,
  topTransitionEnd: eventTypes.transitionEnd,
  topVolumeChange: eventTypes.volumeChange,
  topWaiting: eventTypes.waiting,
  topWheel: eventTypes.wheel
};

for (var type in topLevelEventsToDispatchConfig) {
  topLevelEventsToDispatchConfig[type].dependencies = [type];
}

var ON_CLICK_KEY = keyOf({ onClick: null });
var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case topLevelTypes.topAbort:
      case topLevelTypes.topCanPlay:
      case topLevelTypes.topCanPlayThrough:
      case topLevelTypes.topDurationChange:
      case topLevelTypes.topEmptied:
      case topLevelTypes.topEncrypted:
      case topLevelTypes.topEnded:
      case topLevelTypes.topError:
      case topLevelTypes.topInput:
      case topLevelTypes.topInvalid:
      case topLevelTypes.topLoad:
      case topLevelTypes.topLoadedData:
      case topLevelTypes.topLoadedMetadata:
      case topLevelTypes.topLoadStart:
      case topLevelTypes.topPause:
      case topLevelTypes.topPlay:
      case topLevelTypes.topPlaying:
      case topLevelTypes.topProgress:
      case topLevelTypes.topRateChange:
      case topLevelTypes.topReset:
      case topLevelTypes.topSeeked:
      case topLevelTypes.topSeeking:
      case topLevelTypes.topStalled:
      case topLevelTypes.topSubmit:
      case topLevelTypes.topSuspend:
      case topLevelTypes.topTimeUpdate:
      case topLevelTypes.topVolumeChange:
      case topLevelTypes.topWaiting:
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case topLevelTypes.topKeyPress:
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case topLevelTypes.topBlur:
      case topLevelTypes.topFocus:
        EventConstructor = SyntheticFocusEvent;
        break;
      case topLevelTypes.topClick:
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topDoubleClick:
      case topLevelTypes.topMouseDown:
      case topLevelTypes.topMouseMove:
      case topLevelTypes.topMouseOut:
      case topLevelTypes.topMouseOver:
      case topLevelTypes.topMouseUp:
        EventConstructor = SyntheticMouseEvent;
        break;
      case topLevelTypes.topDrag:
      case topLevelTypes.topDragEnd:
      case topLevelTypes.topDragEnter:
      case topLevelTypes.topDragExit:
      case topLevelTypes.topDragLeave:
      case topLevelTypes.topDragOver:
      case topLevelTypes.topDragStart:
      case topLevelTypes.topDrop:
        EventConstructor = SyntheticDragEvent;
        break;
      case topLevelTypes.topTouchCancel:
      case topLevelTypes.topTouchEnd:
      case topLevelTypes.topTouchMove:
      case topLevelTypes.topTouchStart:
        EventConstructor = SyntheticTouchEvent;
        break;
      case topLevelTypes.topAnimationEnd:
      case topLevelTypes.topAnimationIteration:
      case topLevelTypes.topAnimationStart:
        EventConstructor = SyntheticAnimationEvent;
        break;
      case topLevelTypes.topTransitionEnd:
        EventConstructor = SyntheticTransitionEvent;
        break;
      case topLevelTypes.topScroll:
        EventConstructor = SyntheticUIEvent;
        break;
      case topLevelTypes.topWheel:
        EventConstructor = SyntheticWheelEvent;
        break;
      case topLevelTypes.topCopy:
      case topLevelTypes.topCut:
      case topLevelTypes.topPaste:
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    if (registrationName === ON_CLICK_KEY) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === ON_CLICK_KEY) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticAnimationEvent
 */

'use strict';

var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticClipboardEvent
 */

'use strict';

var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticFocusEvent
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(93);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticKeyboardEvent
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(93);

var getEventCharCode = __webpack_require__(175);
var getEventKey = __webpack_require__(176);
var getEventModifierState = __webpack_require__(95);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ },
/* 175 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventCharCode
 */

'use strict';

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventKey
 */

'use strict';

var getEventCharCode = __webpack_require__(175);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticDragEvent
 */

'use strict';

var SyntheticMouseEvent = __webpack_require__(92);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTouchEvent
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(93);

var getEventModifierState = __webpack_require__(95);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTransitionEvent
 */

'use strict';

var SyntheticEvent = __webpack_require__(76);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticWheelEvent
 */

'use strict';

var SyntheticMouseEvent = __webpack_require__(92);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMount
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var DOMLazyTree = __webpack_require__(99);
var DOMProperty = __webpack_require__(60);
var ReactBrowserEventEmitter = __webpack_require__(124);
var ReactCurrentOwner = __webpack_require__(36);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactDOMContainerInfo = __webpack_require__(182);
var ReactDOMFeatureFlags = __webpack_require__(183);
var ReactElement = __webpack_require__(35);
var ReactFeatureFlags = __webpack_require__(81);
var ReactInstanceMap = __webpack_require__(136);
var ReactInstrumentation = __webpack_require__(85);
var ReactMarkupChecksum = __webpack_require__(184);
var ReactReconciler = __webpack_require__(82);
var ReactUpdateQueue = __webpack_require__(150);
var ReactUpdates = __webpack_require__(79);

var emptyObject = __webpack_require__(45);
var instantiateReactComponent = __webpack_require__(138);
var invariant = __webpack_require__(34);
var setInnerHTML = __webpack_require__(101);
var shouldUpdateReactComponent = __webpack_require__(144);
var warning = __webpack_require__(37);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  // this.props is actually a ReactElement
  return this.props;
};

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
      }
    }
  }
};

module.exports = ReactMount;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMContainerInfo
 */

'use strict';

var validateDOMNesting = __webpack_require__(151);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ },
/* 183 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFeatureFlags
 */

'use strict';

var ReactDOMFeatureFlags = {
  useCreateElement: true
};

module.exports = ReactDOMFeatureFlags;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMarkupChecksum
 */

'use strict';

var adler32 = __webpack_require__(185);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ },
/* 185 */
/***/ function(module, exports) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adler32
 * 
 */

'use strict';

var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findDOMNode
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(36);
var ReactDOMComponentTree = __webpack_require__(59);
var ReactInstanceMap = __webpack_require__(136);

var getHostComponentFromComposite = __webpack_require__(187);
var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getHostComponentFromComposite
 */

'use strict';

var ReactNodeTypes = __webpack_require__(140);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule renderSubtreeIntoContainer
*/

'use strict';

var ReactMount = __webpack_require__(181);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 189 */
/***/ function(module, exports) {

// To include this file in your project:
// let mui = require('mui');
// let Colors = mui.Styles.Colors;
var colors = {
    mwsGrey50: '#eceef1',
    mwsGrey100: '#cfd5dc',
    mwsGrey200: '#b0bac5',
    mwsGrey300: '#909eae',
    mwsGrey400: '#78899c',
    mwsGrey500: '#60748b',
    mwsGrey600: '#54667a',
    mwsGrey700: '#455464',
    mwsGrey800: '#37424f',
    mwsGrey900: '#262e38'
};
module.exports = colors;


/***/ },
/* 190 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var AppRegistry = (function () {
    function AppRegistry() {
    }
    AppRegistry.prototype.setStoreProvider = function (storeProvider) {
        this.storeProvider = storeProvider;
        return this;
    };
    AppRegistry.prototype.getStoreProvider = function () {
        return this.storeProvider;
    };
    AppRegistry.prototype.getResourceManager = function () {
        return this.resourceManager;
    };
    AppRegistry.prototype.setResourceManager = function (resourceManager) {
        this.resourceManager = resourceManager;
        return this;
    };
    AppRegistry.prototype.setModuleDragDrop = function (dragDrop) {
        this.moduleDragDrop = dragDrop;
    };
    AppRegistry.prototype.getModuleDragDrop = function () {
        return this.moduleDragDrop;
    };
    return AppRegistry;
}());
exports.default = new AppRegistry();


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var l10n_1 = __webpack_require__(18);
var ModuleDragSource = __webpack_require__(192);
var NavDropZone = __webpack_require__(195);
var Modul_1 = __webpack_require__(197);
/**
 * Drag source for new modules (from module selector)
 */
var BlankModuleDragSource = (function (_super) {
    tslib_1.__extends(BlankModuleDragSource, _super);
    function BlankModuleDragSource(element) {
        var _this = _super.call(this, element) || this;
        _this.setModelData();
        return _this;
    }
    BlankModuleDragSource.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setDraggableOptions({
            cursorAt: { top: 0, left: 15 },
            cancel: diy.editor.upgradeLayer.getSelector()
        });
    };
    BlankModuleDragSource.prototype.setModelData = function () {
        _super.prototype.setModelData.call(this);
        var dataSourceEl = this.getDataSourceEl();
        this.moduleLabel = dataSourceEl.attr('data-moduleLabel');
        this.moduleType = dataSourceEl.attr('data-moduleType');
        this.moduleName = dataSourceEl.attr('data-moduleName');
        this.sectionName = dataSourceEl.attr('data-sectionName');
    };
    BlankModuleDragSource.prototype.getLabel = function () {
        return this.moduleLabel;
    };
    BlankModuleDragSource.prototype.getErrorMessage = function (error, dropZone) {
        if (dropZone instanceof NavDropZone) {
            switch (error) {
                case 'module_singleton_in_page': //nobreak
                case 'module_singleton_in_other_pages':
                    return l10n_1.default('module.warningSingleton');
                case 'module_too_wide':
                    return l10n_1.default('module.addToPageWarningTooWide');
                default:
                    break;
            }
        }
        return _super.prototype.getErrorMessage.call(this, error, dropZone);
    };
    BlankModuleDragSource.prototype.doDrop = function (dropZone) {
        Modul_1.default.add(Modul_1.default.getInsertParams(this), dropZone.getDestinationParams());
    };
    return BlankModuleDragSource;
}(ModuleDragSource));
module.exports = BlankModuleDragSource;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var l10n_1 = __webpack_require__(18);
var DragSource = __webpack_require__(193);
/**
 * @depends moduleSelector.js
 * @depends ui.moduleDraggable.js
 */
var triggerFakeTouchEvent = function (event, target, eventType) {
    var offset = $(target).offset();
    var newevent = $.Event(eventType);
    newevent.which = 1;
    newevent.target = target;
    newevent.pageX = event.pageX ? event.pageX : offset.left;
    newevent.pageY = event.pageY ? event.pageX : offset.top;
    newevent.originalEvent = event;
    $(target).trigger(newevent);
};
var ModuleDragSource = (function (_super) {
    tslib_1.__extends(ModuleDragSource, _super);
    function ModuleDragSource(element) {
        var _this = _super.call(this, element) || this;
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            _this._toggleDraggableDisabledState(true);
            _this.hammerInst = new Hammer(element.get(0), {
                hold: true,
                hold_threshold: 50,
                stop_browser_behavior: {}
            });
            var self_1 = _this;
            _this.hammerHandler = function (e) {
                var event = e.gesture.srcEvent;
                // Enable the draggable and simulate a drag start
                self_1._toggleDraggableDisabledState(false);
                triggerFakeTouchEvent(event, this, 'touchstart');
                triggerFakeTouchEvent(event, this, 'touchmove');
            };
            _this.hammerInst.on('hold', _this.hammerHandler);
            element.addClass('disable-touch-defaults');
            _this.element.on('touchcancel', function (event) {
                $('body').one('touchstart', function () {
                    triggerFakeTouchEvent(event, self_1.element, 'mouseup');
                });
            });
        }
        return _this;
    }
    ModuleDragSource.prototype.getDraggableWidgetName = function () {
        return ModuleDragSource.draggableWidgetName;
    };
    ModuleDragSource.prototype._toggleDraggableDisabledState = function (disabled) {
        disabled = !!disabled;
        // Disable the draggable because we will trigger it programatically
        // after catching the press&hold event
        this.element[this.getDraggableWidgetName()]('option', 'disabled', disabled);
        // HACK: Disabling the widget also adds this unwanted class so we have
        // to get rid of it manually.
        if (disabled) {
            this.element.removeClass('ui-state-disabled');
        }
    };
    ModuleDragSource.prototype.destroy = function () {
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            this.element.removeClass('disable-touch-defaults');
            this.hammerInst.off('hold', this.hammerHandler);
            this.hammerHandler = null;
            this.hammerInst = null;
        }
        _super.prototype.destroy.call(this);
    };
    ModuleDragSource.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setDraggableOptions({
            connectToSortable: "div.sortable-matrix",
            scroll: !diy.editor.uiPreference.isPointerModeTouch()
        });
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            // On touch device we simulate touchstart/touchmove from a press&hold event
            // so it is necessary to set these values
            this.setDraggableOptions({
                distance: 0,
                delay: 0
            });
        }
    };
    ModuleDragSource.prototype.onDragStop = function (e, ui) {
        _super.prototype.onDragStop.call(this, e, ui);
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            // Disable the draggable again after a drag
            this._toggleDraggableDisabledState(true);
        }
    };
    ModuleDragSource.prototype.moduleReachedMaxInstancesPerPage = function (pageId, matrixId, reachedInPages) {
        reachedInPages = reachedInPages || [];
        if (this.maxInstancesPerPage === undefined || this.webcomponentId === undefined) {
            return false;
        }
        else {
            var pages = jimdoData.navigation.pages;
            var pagesWithMatrix = [];
            for (var i = 0; i < pages.length; i++) {
                /* tslint:disable:triple-equals */
                if (
                // the page contain drop matrix
                pages[i].matrixes[matrixId] !== undefined
                    && !(pages[i].hidden && pages[i].pageId != pageId)) {
                    pagesWithMatrix.push(pages[i]);
                }
                /* tslint:enable:triple-equals */
            }
            // validate each page didn't reach the limit
            var wpm = jimdoData.webcomponentsPerMatrix;
            for (var i = 0; i < pagesWithMatrix.length; i++) {
                var count = 0;
                var pMatrixes = pagesWithMatrix[i].matrixes;
                for (var pMatrixId in pMatrixes) {
                    // skip too narrow matrixes from counting
                    // because there this type of webcomponent is not rendered
                    if (pMatrixes[pMatrixId].width < this.moduleMinWidth) {
                        continue;
                    }
                    if (wpm[pMatrixId] && wpm[pMatrixId][this.webcomponentId]) {
                        count += parseInt(wpm[pMatrixId][this.webcomponentId], 10);
                    }
                    // if this module is in this matrix, exclude it from counting
                    // but only if it will be moved
                    /* tslint:disable:triple-equals */
                    if (this.matrixId && this.matrixId == parseInt(pMatrixId, 10) &&
                        this.dragMode !== 'duplicate') {
                        count--;
                    }
                    /* tslint:enable:triple-equals */
                }
                if (count >= parseInt(this.maxInstancesPerPage, 10)) {
                    reachedInPages.push(pagesWithMatrix[i].pageId);
                }
            }
            return reachedInPages.length > 0;
        }
    };
    ModuleDragSource.prototype.moduleFitsInMatrix = function (pageId, matrixId) {
        if (isNaN(this.moduleMinWidth) || null == this.moduleMinWidth) {
            return true;
        }
        var pages = jimdoData.navigation.pages;
        var matrixWidth;
        for (var i = 0; i < pages.length; i++) {
            /* tslint:disable:triple-equals */
            if (pages[i].pageId == pageId) {
                matrixWidth = pages[i].matrixes[matrixId].width;
                if (isNaN(matrixWidth) || null == matrixWidth) {
                    return true;
                }
                return matrixWidth >= this.moduleMinWidth;
            }
            /* tslint:enable:triple-equals */
        }
        // no matching pageId/matrixId
        return false;
    };
    ModuleDragSource.prototype.moduleAllowedInMatrix = function (pageId, matrixId) {
        if (this.allowedInSidebar) {
            return true;
        }
        var pages = jimdoData.navigation.pages;
        for (var i = 0; i < pages.length; i++) {
            /* tslint:disable:triple-equals */
            if (pages[i].pageId == pageId) {
                var isSidebar = pages[i].matrixes[matrixId].isSidebar;
                if (isSidebar && !this.allowedInSidebar) {
                    return false;
                }
            }
            /* tslint:enable:triple-equals */
        }
        return true;
    };
    ModuleDragSource.prototype.canBeDropped = function (dropZone) {
        if (!dropZone) {
            return false;
        }
        var pageId = dropZone.getPageId();
        var matrixId = dropZone.getMatrixId();
        var reachedInPages = [];
        if (this.moduleReachedMaxInstancesPerPage(pageId, matrixId, reachedInPages)) {
            if (reachedInPages.indexOf(pageId) !== -1) {
                return this.getErrorMessage('module_singleton_in_page', dropZone);
            }
            else {
                return this.getErrorMessage('module_singleton_in_other_pages', dropZone);
            }
        }
        if (!this.moduleAllowedInMatrix(pageId, matrixId)) {
            return this.getErrorMessage('module_not_allowed_sidebar', dropZone);
        }
        if (!this.moduleFitsInMatrix(pageId, matrixId)) {
            return this.getErrorMessage('module_too_wide', dropZone);
        }
        return true;
    };
    ModuleDragSource.prototype.getErrorMessage = function (error, dropZone) {
        if (error === 'module_singleton_in_page') {
            return l10n_1.default('moduleSelector.restrictedAllSingletonAreaToolTip');
        }
        if (error === 'module_singleton_in_other_pages') {
            return l10n_1.default('moduleSelector.restrictedSidebarSingletonAreaToolTip');
        }
        if (error === 'module_too_wide') {
            return l10n_1.default('moduleSelector.restrictedAreaToolTip');
        }
        if (error === 'module_not_allowed_sidebar') {
            return l10n_1.default('moduleSelector.moduleNotAllowedSidebar');
        }
        throw new Error("Unhandled error type " + error);
    };
    ModuleDragSource.prototype.setModelData = function () {
        var dataSourceEl = this.getDataSourceEl();
        this.webcomponentId = dataSourceEl.attr('data-webcomponentId');
        this.maxInstancesPerPage = dataSourceEl.attr('data-maxInstancesPerPage');
        this.moduleMinWidth = parseInt(dataSourceEl.attr('data-moduleMinwidth'), 10);
        this.allowedInSidebar = dataSourceEl.attr('data-allowedInSidebar') !== 'false';
    };
    ModuleDragSource.prototype.getDataSourceEl = function () {
        return this.element;
    };
    //abstract
    ModuleDragSource.prototype.getLabel = function () {
        return '';
    };
    return ModuleDragSource;
}(DragSource));
ModuleDragSource.draggableWidgetName = 'moduleDraggable';
module.exports = ModuleDragSource;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var DD = __webpack_require__(194);
var DragHelper = __webpack_require__(17);
/**
 * DragSource class
 *
 * Class for making an element a valid source for a drag and drop operation.
 * Uses an extended jquery ui draggable widget
 */
var DragSource = (function (_super) {
    tslib_1.__extends(DragSource, _super);
    function DragSource(element) {
        var _this = _super.call(this, element) || this;
        /**
         * CSS cursor to use when dragging over a valid drop zone
         */
        _this.allowedCursor = 'move';
        /**
         * CSS cursor to use when the drop is not allowed
         */
        _this.notAllowedCursor = 'not-allowed';
        //create the draggable here cause we need it to exist when we call setHelper
        _this.element[_this.getDraggableWidgetName()]();
        return _this;
    }
    DragSource.prototype.getDraggableWidgetName = function () {
        return DragSource.draggableWidgetName;
    };
    DragSource.prototype.setDraggableOptions = function (o) {
        this.element[this.getDraggableWidgetName()]('option', o);
    };
    /**
     * An initialization method that we call only when this instance
     * is added to the drag'n'drop manager. No need to bind all events
     * when we instantiate the class
     */
    DragSource.prototype.init = function () {
        this.setDraggableOptions({
            appendTo: 'body',
            containment: 'document',
            distance: 5,
            // IE doesn't behave correctly when delay is used and the draggable is left hanging sometimes
            delay: $.browser.msie ? 0 : 50,
            refreshPositions: false,
            cursor: null,
            scroll: true,
            start: $.proxy(this.onDragStart, this),
            drag: $.proxy(this.onDrag, this),
            stop: $.proxy(this.onDragStop, this)
        });
    };
    /**
     * Tests if the source can be dropped over the given drop zone
     * @returns True if possible, and error message string or false if not
     */
    DragSource.prototype.canBeDropped = function (dropZone) {
        if (!dropZone) {
            return false;
        }
        return true;
    };
    /**
     * Updates the visual feedback based on the zone being hovered
     */
    DragSource.prototype.updateView = function (dropZone) {
        var canBeDropped = this.canBeDropped(dropZone);
        if (this.helper) {
            if (canBeDropped !== true) {
                this.getHelper().updateInvitation(false, dropZone && typeof canBeDropped === 'string' ? canBeDropped : null);
            }
            else {
                this.getHelper().updateInvitation(true);
            }
        }
        this.setCursor(canBeDropped === true ? this.allowedCursor : this.notAllowedCursor);
    };
    /**
     * Sets the cursor while dragging or resets the cursor when dragging ends
     * @param cursor a CSS cursor or null value
     */
    DragSource.prototype.setCursor = function (cursor) {
        $('body').css('cursor', cursor ? cursor : '');
    };
    /**
     * Tries to drop onto a drop zone
     *
     * @returns whether the drop was made or cancelled
     */
    DragSource.prototype.drop = function (dropZone) {
        if (this.canBeDropped(dropZone) === true) {
            this.doDrop(dropZone);
            this.trigger('dddropped');
            return true;
        }
        else {
            this.cancelDrop(dropZone);
            this.trigger('ddcancel');
            return false;
        }
    };
    /**
     * Override this method to provide an actual action to be executed
     * when dropped
     * @abstract
     */
    DragSource.prototype.doDrop = function (dropZone) {
        // abstract
    };
    /**
     * Override this method to provide an action when the drop has been cancelled
     * @abstract
     */
    DragSource.prototype.cancelDrop = function (dropZone) {
        // abstract
    };
    /**
     * Callback method for creating the draggable helper element
     */
    DragSource.prototype.createHelper = function () {
        return this.helper.createHelper(this.element);
    };
    DragSource.prototype.setHelper = function (helper) {
        var _this = this;
        var optHelper = null;
        if (helper instanceof DragHelper) {
            this.helper = helper;
            optHelper = function () { return _this.createHelper(); };
        }
        else {
            this.helper = null;
        }
        if (this.element.is(":ui-" + this.getDraggableWidgetName())) {
            this.setDraggableOptions({ 'helper': optHelper });
        }
    };
    DragSource.prototype.getHelper = function () {
        return this.helper;
    };
    DragSource.prototype.onDragStart = function (e, ui) {
        this.trigger('ddstart', e, [ui, this]);
    };
    DragSource.prototype.onDrag = function (e, ui) {
        this.trigger('dddrag', e, [ui, this]);
    };
    DragSource.prototype.onDragStop = function (e, ui) {
        this.setCursor(null);
        this.trigger('ddstop', e, [ui, this]);
    };
    DragSource.prototype.destroy = function () {
        this.setHelper(null);
        if (this.element.is(":ui-" + this.getDraggableWidgetName())) {
            this.element[this.getDraggableWidgetName()]('destroy');
        }
        _super.prototype.destroy.call(this);
    };
    return DragSource;
}(DD));
/**
 * @event ddstart
 * @event dddrag
 * @event ddstop
 *
 * @param {$.Event} original event
 * @param {Object} the original ui hash (usually coming from a jquery ui draggable)
 * @param {DragSource} the source that was dragged
 */
/**
 * Name of the widget to use (a jquery ui draggable or extension)
 */
DragSource.draggableWidgetName = 'draggable';
module.exports = DragSource;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 * Base Drag & Drop class
 *
 * Just some plumbing work so we don't have to rely on the jquery ui widget factory,
 * but still have some of that functionality
 */
var DD = (function () {
    /**
     * @param selector, element or jQuery object
     */
    function DD(selector) {
        this.element = $(selector);
    }
    //a stripped-down version of the _trigger in jquery ui
    DD.prototype.trigger = function (type, ev, data) {
        var prop;
        var orig;
        data = data || {};
        var event = $.Event(ev);
        event.type = type.toLowerCase();
        // the original event may come from any element
        // so we need to reset the target on the new event
        event.target = this.element[0];
        // copy original event properties over to the new event
        orig = event.originalEvent;
        if (orig) {
            for (prop in orig) {
                if (!(prop in event)) {
                    event[prop] = orig[prop];
                }
            }
        }
        this.element.trigger(event, data);
        return !event.isDefaultPrevented();
    };
    DD.prototype.destroy = function () {
        this.element = null;
    };
    return DD;
}());
module.exports = DD;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var DropZone = __webpack_require__(196);
/**
 * Drop zone using a jquery ui droppable widget, for the navigation items
 *
 * @depends jquery.ui.position.js
 * @depends jquery.ui.droppable.js
 * @depends jquery.expr.position.js
 */
var NavDropZone = (function (_super) {
    tslib_1.__extends(NavDropZone, _super);
    function NavDropZone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavDropZone.prototype.activate = function () {
        _super.prototype.activate.call(this);
        this.element.droppable({
            greedy: true,
            tolerance: 'pointer',
            over: $.proxy(this.onDragOver, this),
            out: $.proxy(this.onDragOut, this),
            drop: $.proxy(this.onDrop, this)
        });
    };
    NavDropZone.prototype.getDestinationParams = function () {
        return {
            pageId: this.getPageId()
        };
    };
    NavDropZone.prototype.getPageId = function () {
        return parseInt(this.getTargetEl().attr('data-page-id'), 10);
    };
    NavDropZone.prototype.getMatrixId = function () {
        var pages = jimdoData.navigation.pages;
        var pageId = this.getPageId();
        for (var i = 0; i < pages.length; i++) {
            /* tslint:disable:triple-equals */
            if (pages[i].pageId == pageId) {
                var pMatrixes = pages[i].matrixes;
                for (var matrixId in pMatrixes) {
                    if (pMatrixes[matrixId].defaultDrop) {
                        return matrixId;
                    }
                }
            }
            /* tslint:enable:triple-equals */
        }
        throw new Error("No matrix found with defaultDrop flag");
    };
    NavDropZone.prototype.deactivate = function () {
        _super.prototype.deactivate.call(this);
        if (this.element.is(":ui-droppable")) {
            this.element
                .droppable('destroy');
        }
    };
    return NavDropZone;
}(DropZone));
module.exports = NavDropZone;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var DD = __webpack_require__(194);
var DragSource = __webpack_require__(193);
/**
 * Base class for a drop zone
 */
var DropZone = (function (_super) {
    tslib_1.__extends(DropZone, _super);
    function DropZone(element, targetEl) {
        var _this = _super.call(this, element) || this;
        /**
         * @event ddover
         * @event ddout
         * @event dddrop
         *
         * @param {$.Event} original event
         * @param {Object} the original ui hash (usually coming from a jquery ui droppable/sortable)
         * @param {DropZone} this instance of DropZone
         */
        /**
         * The calculated zIndex of the element
         */
        _this.zIndex = null;
        _this.targetEl = targetEl;
        return _this;
    }
    DropZone.prototype.getTargetEl = function () {
        return this.targetEl;
    };
    /**
     * Called when the drop zone is activated (usually when
     * the dragging starts). This method should enable the drop zone
     * so that it catches over/out/drop events
     */
    DropZone.prototype.activate = function () {
        this.zIndex = this.element.diy_zIndex();
    };
    /**
     * The opposite action of activate
     * @abstract
     */
    DropZone.prototype.deactivate = function () {
        // abstract
    };
    /**
     * Shows visual feedback that the zone accepts/rejects
     * the drag source that is currently over it
     * @abstract
     */
    DropZone.prototype.showInvitation = function (canDrop) {
        // abstract
    };
    /**
     * Hides the visual feedback when no drag source is over
     * the drop zone
     * @abstract
     */
    DropZone.prototype.hideInvitation = function () {
        // abstract
    };
    /**
     * Updates the visual feedback based on what's being dropped
     */
    DropZone.prototype.updateView = function (dragSource) {
        if (dragSource instanceof DragSource) {
            this.showInvitation(dragSource.canBeDropped(this) === true);
        }
        else {
            this.hideInvitation();
        }
    };
    DropZone.prototype.onDragOver = function (e, ui) {
        this.trigger('ddover', e, [ui, this]);
    };
    DropZone.prototype.onDragOut = function (e, ui) {
        this.trigger('ddout', e, [ui, this]);
    };
    DropZone.prototype.onDrop = function (e, ui) {
        this.trigger('dddrop', e, [ui, this]);
    };
    DropZone.prototype.getZIndex = function () {
        return this.zIndex;
    };
    DropZone.prototype.getDestinationParams = function () {
        return {};
    };
    return DropZone;
}(DD));
module.exports = DropZone;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var $ = __webpack_require__(3);
var AppRegistry_1 = __webpack_require__(190);
var index_1 = __webpack_require__(198);
var index_2 = __webpack_require__(536);
var ModuleActionBarContent_1 = __webpack_require__(640);
var l10n = __webpack_require__(18);
var help = __webpack_require__(622);
var siteadminApi = __webpack_require__(19);
var Matrix_1 = __webpack_require__(641);
var ModuleFitsInContent_1 = __webpack_require__(642);
var ModuleOverlay_1 = __webpack_require__(643);
var Resource_1 = __webpack_require__(644);
/**
 * module object that is in open state
 */
var activeModule = null;
/**
 * Element used for the error dialog for the insert method
 * Need this to avoid multiple error dialogs stacking
 */
var msgEl = $('<div></div>');
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
exports.ModuleType = {
    GALLERY: 'gallery',
    IMAGE_SUBTITLE: 'imageSubtitle',
    MATRIX: 'matrix',
    SECTION: 'section',
    SECTION_CONTAINER: 'sectionContainer',
    TEXT_WITH_IMAGE: 'textWithImage',
    WEBCOMPONENT: 'webcomponent'
};
var Modul = (function () {
    function Modul(moduleId) {
        this.CONFIG_MIN_WIDTH = 550;
        this.modul = null;
        this.moduleId = null;
        this.moduleType = null;
        /* tslint:enable:variable-name */
        this.saveAction = null;
        this.hasConfigView = true;
        this.hasActionBar = false;
        this.textLabel = '';
        this.overlay = null;
        this.overlayMarginTopScrollback = 0;
        this.hasSpotlightBorder = true;
        this.saveTimeout = 60000;
        /**
         * whether to stop hide/show overlay methods from being run
         */
        this.overlayFrozen = false;
        this.modul = $('#modul_' + moduleId);
        this.moduleElement = document.getElementById("modul_" + moduleId);
        this.moduleId = moduleId;
        // accessing matrixId directly is still used, so I will
        // initialize it here
        this.matrixId = this.getMatrixId();
        this.saveAction = this.save;
        this.init();
        $('.mod-bar-primary').click(function (ev) {
            var t = $(ev.target);
            if (t.is('a') && t.hasClass('mod-bar-primary-section-tab') && !t.hasClass('edit-image-aviary')) {
                $(this).find('a').each(function (i) {
                    $(this).removeClass('mod-bar-primary-selected');
                });
                t.addClass('mod-bar-primary-selected');
            }
        });
        //in this order
        this.initOverlay();
        if (!this.hasActionBar) {
            this.initButtons();
        }
        $(document).trigger('diy.editor.moduleInitialized', [this]);
    }
    Modul.prototype.init = function () {
        // override this
    };
    Modul.prototype.getData = function () {
        return this.data;
    };
    Modul.prototype.getAlias = function () {
        return this.data.alias;
    };
    Modul.prototype.isInSectionLoop = function () {
        return this.data.isInSectionLoop;
    };
    // Called from PHP
    Modul.prototype.loadData = function (data) {
        this.data = data;
    };
    Modul.prototype.initButtons = function () {
        var _this = this;
        this.getCancelBtn().button().click(function () {
            _this.close(true, true, false, true);
        });
        this.getSaveBtn().button().click($.proxy(this.onSaveBtnClick, this));
        this.getToolbox().hide();
    };
    Modul.prototype.onSaveBtnClick = function () {
        getStore().dispatch(index_1.moduleOverlayHide({ moduleId: this.moduleId }));
        var isNew = this.getIsNew();
        this.runSaveAction.apply(this, arguments);
        if (isNew && this.getModuleType() !== exports.ModuleType.SECTION) {
            $(document.body).trigger('NewModuleSaved.BSA');
        }
    };
    Modul.prototype.deleteAction = function () {
        this.getMatrix().del(this.getChildId(), this.moduleId);
    };
    Modul.prototype.getModuleType = function () {
        return this.modul.attr('data-moduletype');
    };
    Modul.prototype.needsCover = function () {
        return this.module_name === 'facebook' ||
            this.module_name === 'twitter' ||
            this.module_name === 'product_search';
    };
    Modul.prototype.startHoverObserver = function () {
        var _this = this;
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            (new Hammer($('.diyw').get(0), {
                stop_browser_behavior: {}
            })).on('touchstart', function () {
                if (Modul.getActiveModule()) {
                    return;
                }
                if (Modul.hoverModule) {
                    Modul.hoverModule.obsHoverOut();
                }
                Modul.hoverModule = null;
            });
            (new Hammer(this.modul[0], {
                stop_browser_behavior: {}
            })).on('tap', function () {
                if (_this.moduleType === 'matrix' && Modul.hoverModule &&
                    Modul.hoverModule.moduleType !== 'matrix' &&
                    _this.modul.find('.matrix-module-configuration').is(":visible")) {
                    return;
                }
                if (Modul.hoverModule === _this) {
                    return;
                }
                if (Modul.hoverModule) {
                    Modul.hoverModule.obsHoverOut();
                }
                Modul.hoverModule = _this;
                _this.obsHover();
            });
        }
        else {
            this.modul.bind('mouseenter', this.obsHover);
        }
    };
    Modul.prototype.startHoverOutObserver = function () {
        if (!diy.editor.uiPreference.isPointerModeTouch()) {
            this.getOverlayWrapper().bind('mouseleave', this.obsHoverOut);
            this.modul.bind('mouseleave', this.obsHoverOut);
        }
    };
    Modul.prototype.getIsNew = function () {
        return this.isNew;
    };
    Modul.prototype.setIsNew = function (v) {
        this.isNew = v;
        return this.isNew;
    };
    Modul.prototype.getChildId = function () {
        return parseInt(this.modul.attr('data-matrixChildId'), 10);
    };
    Modul.prototype.getAfterChildId = function () {
        var prevModuleEl = this.getPrevModul(0);
        var afterChildId = 0;
        if (prevModuleEl.length) {
            afterChildId = parseInt(prevModuleEl.attr('data-matrixchildid'), 10);
        }
        return afterChildId;
    };
    Modul.prototype.getMatrixId = function () {
        return parseInt(this.modul.attr('data-matrixId'), 10);
    };
    Modul.prototype.getMatrix = function () {
        return Matrix_1.default.getInstance(this.getMatrixId());
    };
    Modul.prototype.getMatrixModuleParent = function () {
        var matrix = this.getParentModules()
            .filter(function (m) { return m.getModuleType() === exports.ModuleType.MATRIX; })
            .shift();
        return matrix || null;
    };
    Modul.prototype.getParentSection = function () {
        var section = this.getParentModules()
            .filter(function (m) { return m.getModuleType() === exports.ModuleType.SECTION; })
            .shift();
        return section || null;
    };
    Modul.prototype.getParentModules = function () {
        return this.modul.parents('[data-moduleid]').toArray()
            .map(function (element) {
            var moduleId = element.getAttribute('data-moduleid');
            return Modul.getInstance(moduleId);
        });
    };
    Modul.prototype.getChildModules = function () {
        return this.modul.find("[data-moduleid]").toArray()
            .map(function (elem) { return Modul.getInstance(elem.getAttribute('data-moduleid')); })
            .filter(function (m) { return m !== undefined; });
    };
    Modul.prototype.getPageId = function () {
        return this.getMatrix().pageId;
    };
    Modul.prototype.getPrevModul = function (index) {
        index = index || 0;
        return this.modul.prevAll('.modulelt').eq(index);
    };
    Modul.prototype.getNextModul = function (index) {
        index = index || 0;
        return this.modul.nextAll('.modulelt').eq(index);
    };
    /**
     * @return {jQuery} wrapper for module overlay/toolbox and editor elements
     */
    Modul.prototype.getOverlayGroup = function () {
        return $("#module-overlay-group-" + this.moduleId);
    };
    Modul.prototype.remove = function () {
        var children = this.getChildModules();
        children.forEach(function (childModule) {
            childModule.remove();
        });
        // remove with .diye parent
        this.getOverlayGroup().parent().remove();
        this.getModuleElement().remove();
        if (activeModule === this) {
            activeModule = null;
        }
    };
    /**
     * @return {jQuery} with the toolbox (all buttons container)
     */
    Modul.prototype.getToolbox = function () {
        return this.overlay.getToolbox();
    };
    Modul.prototype.getMoveBtn = function () {
        return this.getToolbox().find('.toolmove');
    };
    Modul.prototype.getSaveBtn = function () {
        return this.getEditorContainer().find('#modul_' + this.moduleId + '_save_button');
    };
    Modul.prototype.getCancelBtn = function () {
        return this.getEditorContainer().find('#modul_' + this.moduleId + '_cancel_button');
    };
    Modul.prototype.getDeleteBtn = function () {
        return this.getToolbox().find('.tooldelete');
    };
    Modul.prototype.getContentContainer = function () {
        return this.getModuleElement();
    };
    Modul.prototype.getModuleElement = function () {
        return this.modul;
    };
    Modul.prototype.getEditorContainer = function () {
        return $("#modul_" + this.moduleId + "_formdiv");
    };
    Modul.prototype.getEditorPositionedContainer = function () {
        return this.getEditorContainer().find('.module-config-outer-container');
    };
    /**
     * @return {jQuery} overlay and toolbox wrapper
     */
    Modul.prototype.getOverlayWrapper = function () {
        return this.overlay.getOverlayElement();
    };
    Modul.prototype.getIsInEditMode = function () {
        return this.modul.hasClass('open');
    };
    Modul.prototype.showLoading = function ($elem) {
        getStore().dispatch(index_1.moduleLoadingStarted({ moduleId: this.moduleId }));
    };
    Modul.prototype.hideLoading = function ($elem) {
        getStore().dispatch(index_1.moduleLoadingFinished({ moduleId: this.moduleId }));
    };
    Modul.prototype.hideConfigLoading = function () {
        this.getEditorPositionedContainer().loadingBox().remove();
    };
    Modul.prototype.showConfigLoading = function () {
        this.getEditorPositionedContainer().loadingBox({ useOverlay: true }).show();
    };
    Modul.prototype.getSaveData = function () {
        var data = $('#formular_' + this.moduleId).serializeArray();
        data.push({
            name: '_diyNewlyAdded',
            value: this.getIsNew() ? '1' : '0'
        });
        return data;
    };
    Modul.prototype.save = function () {
        var self = this;
        if (self.form) {
            self.form.diy_form('clearErrors');
        }
        if (!this.hasActionBar) {
            this.getSaveBtn().button("disable");
        }
        $.ajax({
            url: systemurl + 'app/module/module/update',
            data: self.getSaveData(),
            dataType: 'json',
            type: 'POST',
            timeout: this.saveTimeout,
            success: function (r) {
                if (self.$iframe) {
                    self.$iframe.remove();
                    delete self.$iframe;
                }
                if (r.error) {
                    if (r.refresh) {
                        mm[r.moduleId].doAfterSave(r);
                    }
                    else {
                        mm[r.moduleId].getModuleElement().removeClass('hover_loading');
                    }
                    if (r.message) {
                        // actually show the error over the opened module
                        self.open();
                        if (self.form) {
                            self.form.diy_form('addError', r.message);
                        }
                        else {
                            self.getEditorContainer().message({
                                message: r.message,
                                status: 'error'
                            });
                        }
                    }
                }
                else {
                    mm[r.moduleId].doAfterSave(r);
                }
                // fixes bug DHDIY-19637 - do not clear cookies if previous module
                // was saved by going to another module
                if (!activeModule) {
                    self.clearEditCookies();
                }
                self.hideLoading();
                $(document).trigger('diy-editor-module-saved', r.moduleId);
            },
            complete: function () {
                if (!self.hasActionBar) {
                    self.getSaveBtn().button("enable");
                }
            }
        });
        self.wait(true);
        self.getModuleElement().addClass('hover_loading');
    };
    Modul.prototype.doAfterSave = function (r) {
        this.removeHoverLoading();
        this.updateModul(r.cmsView, r.editView, r.resources);
    };
    Modul.prototype.cancelEdit = function () {
        var self = this;
        $.ajax({
            url: systemurl + 'app/module/module/canceledit',
            data: { moduleId: self.moduleId },
            dataType: 'json',
            type: 'POST',
            success: function (r) {
                if (self.$iframe) {
                    self.$iframe.remove();
                    delete self.$iframe;
                }
                if (r.error) {
                    // TODO what if there was an error on cancelling???
                }
                mm[r.moduleId].doAfterCancelEdit(r);
                mm[r.moduleId].hideLoading();
            }
        });
        self.wait(true);
        self.getModuleElement().addClass('hover_loading');
    };
    Modul.prototype.doAfterCancelEdit = function (r) {
        //moved here due to IE8 asynchronous problems
        $.cookie('cancelEdit', null, { path: '/' });
        this.updateModul(r.cmsView, r.editView, r.resources);
    };
    Modul.prototype.updateModulContent = function (html) {
        var htmlFixed = html.indexOf('<embed') === -1 &&
            html.indexOf('wmode') === -1 ? html.replace('<embed', '<embed wmode="transparent"') : html;
        this.getContentContainer().html(htmlFixed);
    };
    Modul.prototype.updateModul = function (cmsView, editView, resources) {
        var _this = this;
        var moduleId = this.moduleId;
        var modulEl = this.modul;
        var insertAfterEl = modulEl.prev();
        var parent = modulEl.parent();
        var isNew = this.getIsNew();
        // Take a snapshot of getIsInEditMode() because calling remove() will change its state
        var wasInEditMode = this.getIsInEditMode();
        this.remove();
        mm[moduleId] = null;
        // jQuery doesn't like HTML strings that don't start with <
        // trim any leading whitespaces
        cmsView = $.trim(cmsView);
        editView = $.trim(editView);
        var addElementInPage = function () {
            if (insertAfterEl.length > 0) {
                $(cmsView).insertAfter(insertAfterEl);
            }
            else {
                $(cmsView).prependTo(parent);
            }
            $(editView).appendTo('body');
            mm[moduleId].setIsNew(isNew);
            if (wasInEditMode) {
                mm[moduleId].modul.addClass('open');
            }
            $(document).trigger('diy-editor-module-rerendered', [_this]);
        };
        if (resources) {
            Modul.handleResources(resources, addElementInPage);
        }
        else {
            addElementInPage();
        }
    };
    Modul.prototype.removeHoverLoading = function () {
        this.getModuleElement().removeClass('hover_loading');
    };
    Modul.prototype.wait = function (isSaving) {
        var isUserAction = true;
        this.close(false, false, isSaving, isUserAction);
        this.showLoading();
        return true;
    };
    Modul.prototype.scrollToActiveView = function () {
        var $element;
        var positionedContainer = this.getEditorPositionedContainer();
        $element = (activeModule === this && positionedContainer.is(':visible')) ?
            positionedContainer :
            this.getContentContainer();
        $element.scrollIntoView();
    };
    Modul.prototype.replaceInternalLinksForEditor = function (content) {
        // hier werden die internen links für den editor aufbereitet
        // $1 = website_id, $2 = page_id, $3 = alles weitere wie
        // parameter oder ankerlinks
        // /app/5861/50562375/
        return content.replace(/href="\/app\/([0-9]+)\/([0-9]+)\/(.*?)"/g, 'href="' + cc_.internalLinkPrefix + '$2/$3"');
    };
    Modul.prototype.update = function (content) {
        this.getContentContainer().html(content);
    };
    Modul.prototype.sizeHoverContentOverlay = function () {
        var content = this.getContentContainer();
        var contentHeight = content.outerHeight(true);
        var widthWarning = this.modul.find('.width-warning-text-wrapper');
        if (widthWarning.length > 0 && contentHeight < widthWarning.outerHeight(true)) {
            contentHeight = widthWarning.outerHeight(true);
            content.height(contentHeight);
        }
    };
    Modul.prototype.adjustConfigView = function (hasConfigView) {
        var bottomPieceWidth;
        if (hasConfigView === true) {
            var configContainer = this.getEditorContainer();
            //re-dimension it according needed width
            if (this.CONFIG_MIN_WIDTH && configContainer.width() < this.CONFIG_MIN_WIDTH) {
                configContainer.width(this.CONFIG_MIN_WIDTH);
            }
            bottomPieceWidth = this.overlay.getPiece('bottom').width();
            if (configContainer.width() > bottomPieceWidth && bottomPieceWidth > this.CONFIG_MIN_WIDTH) {
                configContainer.width(bottomPieceWidth);
            }
            this.overlay.glueElementToBottom(configContainer);
        }
        this.repositionOverlay();
    };
    Modul.prototype.setOpenStyle = function (hasConfigView) {
        var _this = this;
        // do it after adjusting the config view
        // when for right sidebar the overlay bottom piece
        // is extended to make room for the toolbox buttons
        this.adjustConfigView(hasConfigView);
        // adjust module style //
        this.modul.addClass('open');
        // add an event to adjust margin for the config window on resize
        // depends on the query resize plugin
        this.modul
            .bind('resize.moduleContent', function () {
            _this.overlay.resize();
            _this.adjustConfigView(hasConfigView);
        });
        if (hasConfigView === true) {
            //readjust editor
            this.getEditorContainer()
                .bind('resize.moduleEditor', function () {
                _this.adjustConfigView(hasConfigView);
            });
            $('.diywebMainGutter').bind('resize.diywebMainGutter', function () {
                _this.adjustConfigView(hasConfigView);
            });
        }
        this.getOverlayGroup().addClass('open');
    };
    Modul.prototype.clearOpenStyle = function () {
        this.modul
            .removeClass('open')
            .unbind('resize.moduleContent');
        this.getEditorContainer()
            .unbind('resize.moduleEditor');
        $('.diywebMainGutter').unbind('resize.diywebMainGutter');
        this.getOverlayGroup().removeClass('open');
        if (!this.hasActionBar) {
            $(document).scrollTop($(document).scrollTop() - this.overlayMarginTopScrollback);
        }
        this.overlayMarginTopScrollback = 0;
        this.overlay.removeElementFromBottom(this.getEditorContainer());
    };
    Modul.prototype.open = function (openConfig) {
        if (activeModule) {
            var hasParentModuleInEditing = this.getParentModules()
                .filter(function (m) { return m.moduleId === activeModule.moduleId; }).length;
            if (!hasParentModuleInEditing) {
                Modul.abortEditingModules();
            }
        }
        getStore().dispatch(index_1.moduleOverlayShow({ moduleId: this.moduleId, status: index_1.OverlayStatusMap.ACTIVE }));
        openConfig = $.extend({
            'tracking': true
        }, openConfig);
        if (openConfig.tracking) {
            this.onOpenTracking();
            /* tslint:disable:triple-equals */
            if (this.getIsNew() != true) {
                $(document.body).trigger('ModuleEditorOpened.BSA');
            }
            /* tslint:enable:triple-equals */
        }
        /* track that a module was opened for editing
         * used for sitecatalyst to track module opening */
        $(document).trigger('diy-editor-module-opened-for-editing', {
            'module': this,
            'openConfig': openConfig
        });
        activeModule = this;
        if (this.hasActionBar) {
            // TODO check if 'open' class is neede anymore
            this.modul.addClass('open');
            getStore().dispatch(index_2.open({ moduleId: this.moduleId }));
        }
        else {
            // make sure this module has a config view
            if (!this.hasConfigView) {
                return;
            }
            if (this.getIsInEditMode()) {
                return;
            }
            this.showEditView();
            // initialize help link
            cms.help.GuidedAssistant._instance
                ._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
            $.cookie('beginEdit', 1, { path: '/' });
            $.cookie('editMode', 1, { path: '/' });
            // scroll to the edit view
            this.scrollToActiveView();
        }
    };
    Modul.prototype.onOpenTracking = function () {
        //override me
    };
    Modul.prototype.clearEditCookies = function () {
        $.cookie('beginEdit', null, { path: '/' });
        $.cookie('editMode', null, { path: '/' });
    };
    Modul.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        var _this = this;
        getStore().dispatch(index_1.moduleOverlayHide({ moduleId: this.moduleId }));
        if (!this.getIsInEditMode()) {
            return;
        }
        /* tslint:disable:triple-equals */
        if (isSaving != true) {
            this.clearEditCookies();
        }
        /* tslint:enable:triple-equals */
        this.clearOpenStyle();
        this.hideEditView();
        if (isUserAction && activeModule === this) {
            // scroll to module if the close action originated from
            // a user action (cancel or save)
            if (!this.hasActionBar) {
                this.getContentContainer().scrollIntoView();
            }
        }
        // if this is a brand new module (editor open first time)
        // and this is an user action (userClose)
        // then we should delete module (without confirmation)
        if (this.getIsNew() && userClose === true) {
            this.clearEditCookies();
            Matrix_1.default.getInstance(this.matrixId).del(this.getChildId(), this.moduleId);
        }
        else {
            // cancelEdit is an optional parameter, so it could be undefined
            // you should explicitly send false in order to not perform
            // a cancelEdit action
            if ((typeof cancelEdit === 'undefined') || (cancelEdit !== false)) {
                // sending a cancel request
                // modules have to implement server side cancel action
                // for this to have effect
                // here we only update the modul html
                $.cookie('cancelEdit', 1, { path: '/' });
                mm[this.moduleId].cancelEdit();
            }
            if (userClose || cancelEdit) {
                this.clearEditCookies();
            }
            this.setIsNew(false);
        }
        if (activeModule === this) {
            activeModule = null;
        }
        else if (activeModule instanceof Modul) {
            setTimeout(function () {
                // there is another module opened, the page will change after this close, so reposition is required
                activeModule.repositionOverlay();
                if (!_this.hasActionBar) {
                    activeModule.scrollToActiveView();
                }
            }, 500);
        }
    };
    Modul.prototype.showUploadStatus = function () {
        this.getContentContainer().html('<div class="wait"><img src="' + cc_.cdnServer +
            '/s/img/cms/loading/timeline.gif" width="220" height="19" alt="" /><p>' +
            translation[4] + '</p></div>');
    };
    Modul.prototype.setSaveAction = function (action) {
        this.saveAction = action;
    };
    Modul.prototype.runSaveAction = function () {
        if (this.getIsNew()) {
            /**
             * Make some SiteCatalyst tracking
             */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                'condition': 'Applied',
                'name': 'Insert Elements'
            });
        }
        if (this.saveAction) {
            this.saveAction();
        }
        else {
            this.save();
        }
    };
    /**
     * this is used by the old jimdo Form module
     * which is not available in the MS but might be present
     * in older clients website - this should be removed once
     * the old jimdo modules are cleaned up
     * @deprecated
     */
    Modul.prototype.noSendCmsMode = function () {
        $('#noSendCmsMode' + this.moduleId).show();
    };
    /**
     * Usually, we wouldn't be needing moduleId parameter in this function
     * and we could just use this instead of mm[moduleId]
     * However, some modules are re-created and the "this" after re-creation
     * is not the same as the old one (sometimes becomes null)
     * TODO - So, until a general flow refactoring, we will keep using mm[moduleId]
     * and the moduleId parameter
     * @param moduleId
     */
    Modul.prototype.viewUpdateCallback = function (moduleId) {
        mm[moduleId].showLoading();
        $.post('/app/module/module/updateview', {
            moduleId: moduleId
        }, function (r) {
            mm[moduleId].updateModulContent(r.webView);
            mm[moduleId].hideLoading();
            if (mm[moduleId].afterViewUpdate) {
                mm[moduleId].afterViewUpdate(r);
            }
        }, 'json');
    };
    Modul.prototype.afterViewUpdate = function (r) {
        // override this
    };
    Modul.prototype.postAction = function (data) {
        //override this
    };
    Modul.prototype.onDelete = function () {
        //override this
    };
    Modul.prototype.getInsertParams = function () {
        return {
            childId: this.getChildId()
        };
    };
    Modul.prototype.getInsertPlaceholder = function () {
        var placeholder = $('<div></div>');
        placeholder.attr('class', this.getModuleElement().attr('class'));
        this.getContentContainer().clone().appendTo(placeholder);
        return placeholder;
    };
    Modul.prototype.move = function (destinationParams) {
        return Modul.insert('move', this, destinationParams);
    };
    Modul.prototype.duplicate = function (destinationParams) {
        return Modul.insert('duplicate', this, destinationParams);
    };
    Modul.prototype.hide = function () {
        this.getOverlayGroup().hide();
        this.hideOverlay();
        this.getModuleElement().hide();
        this.getModuleElement().trigger('moduleHide');
    };
    Modul.prototype.show = function () {
        this.getModuleElement().show();
        this.getOverlayGroup().show();
        if (this.getIsInEditMode()) {
            this.showEditView();
        }
        //don't show the overlay; it will be triggered by mouse over
    };
    Modul.prototype.supportsDuplication = function () {
        return this.getData().supports.moduleDuplicate;
    };
    Modul.prototype.supportsMove = function () {
        return this.getData().supports.moduleMove;
    };
    /**
     * Makes this module not draggable.
     * This is useful when opening modules with inline editing, to allow
     * mouse actions on the module content without triggering drag-drop responses.
     */
    Modul.prototype.disableDragging = function () {
        var _this = this;
        var matrixModuleParent = this.getMatrixModuleParent();
        AppRegistry_1.default.getModuleDragDrop().removeDragSources(function (dragSource) {
            if (dragSource.hasOwnProperty('moduleId') && (dragSource.moduleId === _this.moduleId ||
                (matrixModuleParent &&
                    dragSource.moduleId === matrixModuleParent.moduleId))) {
                return true;
            }
            return false;
        });
    };
    Modul.prototype.showModuleTooltip = function (message) {
        var _this = this;
        message = message || l10n.getString('module.saveFirstWarning');
        this.getModuleElement().diy_tooltip({
            content: message,
            cls: 'diye-module-tooltip diy-alert-tooltip',
            triggerMode: 'none',
            anchor: 'top',
            anchorOffset: -10,
            alignment: 'left',
            alignmentOffset: 135 / 2
        });
        this.getModuleElement().diy_tooltip('show');
        this.getModuleElement().diy_tooltip('widget').scrollIntoView();
        this.getModuleElement().diy_tooltip('delayHide', 5000);
        var hideTooltip = function () {
            _this.getModuleElement().diy_tooltip('hide');
            _this.getModuleElement().add(_this.getOverlayGroup())
                .unbind('.moduleTooltip');
        };
        this.getModuleElement().add(this.getOverlayGroup()).bind('hideOverlay.moduleTooltip mousedown.moduleTooltip modulEditClosed.moduleTooltip', hideTooltip);
    };
    Modul.prototype.onToolUp = function () {
        var antePrevModuleEl = this.getPrevModul(1);
        var antePrevChildId = 0;
        if (antePrevModuleEl.length) {
            antePrevChildId = parseInt(antePrevModuleEl.attr('data-matrixchildid'), 10);
        }
        this.move({
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: antePrevChildId
        });
    };
    Modul.prototype.onToolDown = function () {
        var nextModuleEl = this.getNextModul();
        var nextChildId = 0;
        if (nextModuleEl.length) {
            nextChildId = parseInt(nextModuleEl.attr('data-matrixchildid'), 10);
        }
        this.move({
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: nextChildId
        });
    };
    Modul.prototype.onDuplicate = function () {
        this.duplicate({
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: this.getChildId()
        });
    };
    Modul.prototype.initOverlay = function () {
        var addClass = '';
        var self = this;
        if (!this.needsCover()) {
            addClass += ' noCover';
        }
        //resize content if needed, before initializing the overlay
        this.sizeHoverContentOverlay();
        this.overlay = new ModuleOverlay_1.default(this.modul, {
            appendTo: '#module-overlay-group-' + this.moduleId
        });
        this.overlay.getOverlayElement().bind('click', function () {
            $(document).trigger('diy-editor-module-overlay-clicked', self);
        });
        this.overlay.getOverlayElement().addClass(addClass)
            .attr('data-moduleId', this.moduleId);
        //then start/define the hover observers after the overlay
        //the hover events are bound to them
        this.obsHover = $.proxy(this.showOverlay, this);
        this.obsHoverOut = $.proxy(this.hideOverlay, this);
        this.startHoverObserver();
        this.startHoverOutObserver();
    };
    Modul.prototype.isUpdating = function () {
        return this.modul.hasClass('hover_loading');
    };
    Modul.prototype.showOverlay = function (e) {
        var parentSection = this.getParentSection();
        var state = getStore().getState();
        if (parentSection &&
            state.moduleSection &&
            parentSection.moduleId === state.moduleSection.moduleId &&
            state.moduleSection.manageGroupsActive) {
            return;
        }
        if (this.overlayFrozen) {
            return;
        }
        /* if somehow we may trigger an opening of overlay over a module
        inside a Matrix Module */
        /*
        TODO this is an extreme measure taken against the possibility
        of a small bug becoming a big one. We try to make sure that the small
        elements are not hoverable and therefore not openable in case
        they are in a matrix that should be selected as a whole.
        Of course, this should be tackled at a higher level.
        However, in case this provokes bad results, adding
            window.matrixModuleAvoidEnforcingSelection = true;
        in the user scripts section will fix this
         */
        if (typeof matrixModuleAvoidEnforcingSelection !== 'undefined' &&
            matrixModuleAvoidEnforcingSelection) {
            if (!this.getMatrix().supportsDragging()) {
                var matrixModule = this.modul.parents('[data-moduletype="matrix"]');
                if (matrixModule.length) {
                    if (!mm[matrixModule.attr('data-moduleid')].overlayFrozen) {
                        return;
                    }
                }
            }
        }
        //if this is event generated
        if (e && this.getIsInEditMode() || this.isUpdating()) {
            return;
        }
        getStore().dispatch(index_1.moduleOverlayShow({ moduleId: this.moduleId }));
    };
    Modul.prototype.repositionOverlay = function () {
        if (!this.hasActionBar) {
            this.overlay.position();
        }
    };
    /**
     * @desc given an event and a list of elements it will check
     * if the event was triggered on any of those elements or their children
     * @param {Event} e
     * @param {Array} list
     * @return {Boolean}
     * @private
     */
    Modul.prototype._isEventTriggeredOnElementList = function (e, list) {
        if (!e) {
            return false;
        }
        var eventTarget = $(e.relatedTarget || e.toElement).get(0);
        if (!eventTarget) {
            return false;
        }
        for (var i = 0; i < list.length; i++) {
            var listItem = list[i];
            if (eventTarget === listItem) {
                return true;
            }
            if ($.contains(listItem, eventTarget)) {
                return true;
            }
        }
        return false;
    };
    Modul.prototype.hideOverlay = function (e) {
        if (this.overlayFrozen) {
            return;
        }
        //if event triggered
        if (e && (this.isUpdating() || this.getIsInEditMode())) {
            return;
        }
        //the overlay is shown on mouse enter on the module element
        // when showing the overlay a leave event is generated on the module having as
        // event target the module overlay; this should be ignored
        var ignoreLeaveList = this.getOverlayWrapper();
        if (this._isEventTriggeredOnElementList(e, ignoreLeaveList)) {
            return;
        }
        var self = this;
        setTimeout(function () {
            self.overlay.hide();
        }, 0);
    };
    Modul.prototype.hideEditView = function () {
        if (!this.hasActionBar) {
            this.getEditorContainer().fadeOut(300);
            this.hideOverlay();
            if (this.getParentSection()) {
                getStore().dispatch(index_2.close(void 0));
            }
        }
        else {
            var parent_1 = this.getParentSection();
            if (parent_1) {
                getStore().dispatch(index_2.open({ moduleId: parent_1.moduleId }));
            }
            else {
                getStore().dispatch(index_2.close(void 0));
            }
        }
    };
    /**
     * Opens the module in editing mode.
     *
     * @param Boolean hasConfigView - default true
     */
    Modul.prototype.showEditView = function (hasConfigView) {
        this.overlay.show();
        this.getOverlayGroup().css('position', 'absolute');
        this.getOverlayGroup().find('.moduleEditorContainer').css('position', 'absolute');
        // default param values //
        if (typeof hasConfigView === 'undefined') {
            hasConfigView = true;
        }
        if (hasConfigView) {
            this.getEditorContainer().fadeIn(300);
        }
        this.setOpenStyle(hasConfigView);
    };
    Modul.prototype.getContentElement = function () {
        return document.getElementById('modul_' + this.moduleId);
    };
    Modul.prototype.openHelpArticle = function () {
        var helpArticleId = this.getEditorContainer().find('.moduleHelpLink').attr('data');
        help.openTopic(this.helpArticleId ? this.helpArticleId : helpArticleId);
    };
    Modul.prototype.freezeOverlay = function (state) {
        this.overlayFrozen = state === true ? state : false;
    };
    /**
     * Checks whether a target position (usually generated during a move operation)
     * is different than the current position of the element
     * The default assumption is that the position is different and it's negated if everything matches.
     * @param targetPosition
     * @returns {boolean}
     */
    Modul.prototype.isPositionChanged = function (targetPosition) {
        var positionIsDifferent = true;
        if (targetPosition.matrixId === this.getMatrixId()
            && (targetPosition.pageId === 0 || targetPosition.pageId === this.getPageId())
            && (targetPosition.afterChildId === this.getChildId() ||
                targetPosition.afterChildId === mm[this.moduleId].getAfterChildId())) {
            positionIsDifferent = false;
        }
        return positionIsDifferent;
    };
    Modul.prototype.refresh = function (scrollToIt) {
        var self = this;
        this.showLoading();
        $.ajax({
            url: systemurl + 'app/module/module/get-data',
            data: { moduleId: this.moduleId },
            dataType: 'json',
            type: 'POST',
            success: function (response) {
                self.updateModul(response.data.cmsView, response.data.editView, response.data.resources);
                if (scrollToIt) {
                    mm[self.moduleId].getContentContainer().scrollIntoView();
                }
                self.hideLoading();
                $(document).trigger('diy-editor-module-refreshFinished');
            }
        });
    };
    Modul.prototype.onClickOutside = function () {
        this.onSaveBtnClick();
    };
    Modul.prototype.inPage = function () {
        var $content = this.getContentContainer();
        return $content.length > 0;
    };
    Modul.prototype.highlight = function () {
        var self = this;
        this.modul.addClass('highlight');
        setTimeout(function () {
            self.modul.removeClass('highlight');
        }, 3000);
    };
    Modul.prototype.getActionBarTabs = function () {
        var children;
        children = this.getEditViewComponent();
        if (!children) {
            children = React.createElement(ModuleActionBarContent_1.default, {
                configView: this.getEditorContainer().closest('.diye')[0]
            });
        }
        return [{ label: this.textLabel, content: children }];
    };
    Modul.prototype.onActionBarTabChange = function (v) {
        // override this
    };
    Modul.prototype.getEditViewComponent = function () {
        return null;
    };
    Modul.prototype.getFitsInContent = function () {
        return this.getData().fitsInContent;
    };
    Modul.prototype.addDoNotFitMask = function () {
        ModuleFitsInContent_1.updateAll();
    };
    /* tslint:disable:member-ordering */
    Modul.getActiveModule = function () {
        return activeModule;
    };
    Modul.getInstance = function (moduleId) {
        return mm[moduleId];
    };
    Modul.deleteInstance = function (moduleId) {
        delete mm[moduleId];
    };
    /**
     * exits the edit mode by saving the active module,
     * unless the user clicked on the delete icon, when we SHOULD NOT SAVE
     * but rather perform the desired action
     * @param deletedModuleId the module currently being deleted
     */
    Modul.abortEditingModules = function (deletedModuleId) {
        var activeModule = Modul.getActiveModule();
        if (activeModule && (!deletedModuleId || (deletedModuleId && activeModule.moduleId !== deletedModuleId))) {
            /* web component has a different save method */
            if (activeModule.getModuleType() === exports.ModuleType.WEBCOMPONENT) {
                activeModule.runSaveAction();
            }
            else {
                activeModule.save();
            }
        }
    };
    /**
     * This method converts parameters usually found in the data-* attributes of the
     * module to parameters that can be used with Modul.insert
     *
     * @param {Object} data hash map with at least moduleName, moduleType and webcomponentId if applicable
     */
    Modul.getInsertParams = function (data) {
        var insertParams = {};
        if (data.moduleType === 'local') {
            insertParams.moduleName = data.moduleName;
            /** @toDo section hack */
            if (data.moduleName.indexOf(exports.ModuleType.SECTION) > -1) {
                var additionalData = {
                    'type': data.sectionName
                };
                insertParams.additionalParam = JSON.stringify(additionalData);
            }
        }
        else {
            insertParams.moduleName = data.moduleType === 'remote' ? 'remoteModule' : data.moduleType;
            var additionalData = {
                'module': data.moduleName
            };
            if (data.moduleType === 'webcomponent') {
                additionalData.webcomponentId = data.webcomponentId;
            }
            insertParams.additionalParam = JSON.stringify(additionalData);
        }
        return insertParams;
    };
    Modul.add = function (moduleParams, destinationParams) {
        return Modul.insert('add', {
            getInsertPlaceholder: function () { return $('<div class="diye-new-module-placeholder"></div>'); },
            getInsertParams: function () { return moduleParams; }
        }, destinationParams);
    };
    Modul.handleLimitationsResponse = function (limitations) {
        var $sidebar = $("#cc-sa-sidebar");
        var critical = "modules-critical";
        var maximum = "modules-maximum";
        var closeControllers = function () {
            siteadminApi.close();
            siteadminApi.destroyController('cc-sa-item-pages');
            siteadminApi.destroyController('cc-sa-item-elements');
            siteadminApi.destroyController('cc-sa-item-appscatalog');
            siteadminApi.destroyController('cc-sa-item-sections');
        };
        if (limitations &&
            typeof limitations.hasReachedCriticalLimit !== 'undefined' &&
            typeof limitations.hasReachedMaximumLimit !== 'undefined') {
            switch (true) {
                case limitations.hasReachedCriticalLimit && !$sidebar.hasClass(critical):
                    closeControllers();
                    $sidebar.addClass(critical);
                    break;
                case !limitations.hasReachedCriticalLimit && $sidebar.hasClass(critical):
                    closeControllers();
                    $sidebar.removeClass(critical);
                    break;
                default: break;
            }
            switch (true) {
                case limitations.hasReachedMaximumLimit && !$sidebar.hasClass(maximum):
                    closeControllers();
                    $sidebar.addClass(maximum);
                    break;
                case !limitations.hasReachedMaximumLimit && $sidebar.hasClass(maximum):
                    closeControllers();
                    $sidebar.removeClass(maximum);
                    break;
                default: break;
            }
        }
        if (limitations && typeof limitations.renderWeight !== 'undefined') {
            renderWeight += limitations.renderWeight;
        }
    };
    Modul.insert = function (action, moduleObj, destinationParams) {
        var pageId = destinationParams.pageId;
        var matrixId = destinationParams.matrixId;
        var afterChildId = destinationParams.afterChildId;
        var currentPageId = parseInt($("body").attr("data-pageid"), 10);
        if (!pageId) {
            destinationParams.pageId = pageId = currentPageId;
        }
        var fromMatrixId;
        if (action === 'move') {
            fromMatrixId = moduleObj.getMatrixId();
        }
        /* tslint:disable:triple-equals */
        var loaderEl;
        var placeholder;
        // we need all that to insert in the same page
        var isSamePage = currentPageId == pageId;
        var isExactPosition = typeof matrixId !== 'undefined' &&
            typeof afterChildId !== 'undefined';
        /* tslint:enable:triple-equals */
        if (isSamePage && isExactPosition) {
            placeholder = moduleObj.getInsertPlaceholder();
            if (afterChildId) {
                var afterModuleEl = Matrix_1.default.getInstance(matrixId).getChildModuleEl(afterChildId);
                placeholder.insertAfter(afterModuleEl);
            }
            else {
                placeholder.prependTo(Matrix_1.default.getInstance(matrixId).matrix);
            }
            loaderEl = placeholder;
        }
        else {
            loaderEl = $('body');
        }
        var loaderCfg = {
            useOverlay: true,
            zIndex: 1000000
        };
        if (!(isSamePage && isExactPosition)) {
            loaderCfg.loadingText = l10n.getString('module.addToPageWaitText');
        }
        loaderEl.loadingBox(loaderCfg).show();
        if (action === 'move') {
            moduleObj.hide();
        }
        // make request
        var data = {};
        var moduleData = moduleObj.getInsertParams();
        $.extend(data, moduleData, destinationParams);
        data.fromPageId = currentPageId;
        data.action = action;
        var errorHandler = function (message) {
            loaderEl.loadingBox().remove();
            msgEl.diy_messageDialog({
                zIndex: 100100 + 1 // bigger thant the siteadmin
            });
            msgEl.diy_messageDialog('showErrorMessage', message);
            // attach behavior for the help link inside the message
            msgEl.find('a.moduleHelpLink').click(function (e) {
                $.proxy(guidedAssistant._onModuleHelpLinkClick, guidedAssistant)(e);
            });
            if (placeholder) {
                placeholder.remove();
            }
            if (action === 'move') {
                moduleObj.show();
            }
        };
        var successHandler = function (response) {
            Modul.handleLimitationsResponse(response);
            if (!(isSamePage && isExactPosition)) {
                // we do a refresh if we have no exact position
                // even if we add on the same page
                // because the logic of automatic positioning is on server
                window.location.href = response.pageUrl;
                return;
            }
            loaderEl.loadingBox().remove();
            if (action === 'move' || action === 'duplicate') {
                /**
                 * @todo is this needed?
                 */
                if (action === 'move') {
                    moduleObj.remove();
                }
            }
            placeholder.replaceWith(response.cmsView);
            $(response.editView).appendTo('body');
            // update counting of webcomponents
            var module = mm[response.moduleId];
            // if it's a matrix module, hide the busy mask - #DHDIY-20542
            if (module.getMatrixModuleParent()) {
                module.getMatrixModuleParent().hideBusyMask();
            }
            var moduleEl = module.getModuleElement();
            var webcomponentId = moduleEl.attr('data-webcomponentId');
            if (webcomponentId !== undefined) {
                var wpm = jimdoData.webcomponentsPerMatrix;
                if (fromMatrixId) {
                    wpm[fromMatrixId][webcomponentId] = parseInt(wpm[fromMatrixId][webcomponentId], 10) - 1;
                }
                if (!wpm[matrixId]) {
                    wpm[matrixId] = {};
                }
                if (!wpm[matrixId][webcomponentId]) {
                    wpm[matrixId][webcomponentId] = 0;
                }
                wpm[matrixId][webcomponentId] = parseInt(wpm[matrixId][webcomponentId], 10) + 1;
            }
            if (action === 'add' || action === 'duplicate') {
                // for callout listener
                if (Matrix_1.default.getInstance(matrixId).trigger instanceof Function) {
                    Matrix_1.default.getInstance(matrixId).trigger('onload', Matrix_1.default.getInstance(matrixId));
                }
                $(document).trigger('diy.editor.moduleSelector.moduleAdded', [response.moduleId, response.childId, response.matrixID]);
            }
            if (action === 'add') {
                // mark module as new, so that we could delete it
                // if user press cancel, immediately after it is added
                if (moduleData.moduleName !== exports.ModuleType.SECTION) {
                    mm[response.moduleId].setIsNew(true);
                }
                mm[response.moduleId].open();
            }
            else if (action === 'move' || action === 'duplicate') {
                // scroll to just moved/duplicated module
                mm[response.moduleId].scrollToActiveView();
            }
            if (action === 'add') {
                // for callout listener
                var matrixInstance = Matrix_1.default.getInstance(matrixId);
                if (matrixInstance.trigger instanceof Function) {
                    matrixInstance.trigger('onload', matrixInstance);
                }
                $(document).trigger('diy.editor.moduleSelector.moduleAdded', [response.moduleId, response.childId, response.matrixID]);
                if (Modul.getInstance(response.moduleId).getModuleType() === exports.ModuleType.SECTION) {
                    $(document.body).trigger('NewSectionAdded.BSA');
                }
                else {
                    $(document.body).trigger('NewModuleAdded.BSA');
                }
            }
            /* trigger event that a module was added/moved/duplicated
            * used for sitecatalyst to track module opening */
            $(document).trigger('diy-editor-module-inserted-in-page', {
                'module': mm[response.moduleId],
                'action': action,
                'isSamePage': isSamePage
            });
        };
        $.ajax({
            url: systemurl + 'app/module/module/insert',
            data: data,
            dataType: 'json',
            type: 'POST',
            error: function (a) {
                errorHandler(l10n.getString('moduleErrorCurrent'));
            },
            success: function (response) {
                if (response.status === 'error') {
                    errorHandler(response.message);
                }
                else {
                    if (response.resources) {
                        Modul.handleResources(response.resources, function () {
                            successHandler(response);
                        });
                    }
                    else {
                        successHandler(response);
                    }
                }
            }
        });
    };
    Modul.handleResources = function (resources, callback) {
        var executedCallback = false;
        if (resources.css && resources.css.length) {
            executedCallback = true;
            AppRegistry_1.default.getResourceManager().add(Resource_1.ResourceType.Css, resources.css, callback);
        }
        if (!executedCallback && callback) {
            callback(false);
        }
    };
    Modul.getAllInstances = function () {
        return Object.keys(mm).map(Number).filter(function (n) { return !Number.isNaN(n); }).map(function (n) { return Modul.getInstance(n); });
    };
    return Modul;
}());
exports.default = Modul;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var redux_1 = __webpack_require__(199);
var react_redux_1 = __webpack_require__(220);
var typedActions_1 = __webpack_require__(229);
var actionCreator = typedActions_1.actionCreatorFactory('diy/Overlays/');
var helper_1 = __webpack_require__(230);
var Modul_1 = __webpack_require__(197);
var ModuleOverlay_1 = __webpack_require__(236);
var ModuleLoadingMasks_1 = __webpack_require__(639);
var Overlay_1 = __webpack_require__(237);
exports.OverlayStatus = Overlay_1.OverlayStatus;
// OverlayStatusMap to be used from JS, where Typescript enums are unavailable
exports.OverlayStatusMap = {
    HOVER: Overlay_1.OverlayStatus.HOVER,
    ACTIVE: Overlay_1.OverlayStatus.ACTIVE,
};
var initialState = {
    moduleOverlay: null,
    moduleOverlayDeep: null,
    loadingModuleIds: []
};
exports.moduleOverlayShow = actionCreator('MODULE_OVERLAY_SHOW');
exports.moduleOverlayChangeStatus = actionCreator('MODULE_OVERLAY_CHANGE_STATUS');
exports.moduleOverlayHide = actionCreator('MODULE_OVERLAY_HIDE');
exports.moduleLoadingStarted = actionCreator('MODULE_LOADING_STARTED');
exports.moduleLoadingFinished = actionCreator('MODULE_LOADING_FINISHED');
exports.moduleOverlayMenuToggle = actionCreator('MODULE_OVERLAY_MENU_TOGGLE');
exports.moduleOverlayDragStarted = actionCreator('MODULE_OVERLAY_DRAG_STARTED');
exports.moduleOverlayDragStopped = actionCreator('MODULE_OVERLAY_DRAG_STOPPED');
function moduleOverlayClickOutside() {
    return function (dispatch, getState) {
        Modul_1.default.getInstance(getState().overlays.moduleOverlay.moduleId).onClickOutside();
    };
}
exports.moduleOverlayClickOutside = moduleOverlayClickOutside;
// =======
// REDUCER
// =======
function moduleOverlayReducer(state, action) {
    if (state === void 0) { state = initialState.moduleOverlay; }
    // don't handle other actions if it's in a dragging state
    if (state === null || !state.dragging) {
        if (typedActions_1.isType(action, exports.moduleOverlayShow)) {
            if (state === null ||
                (state.status !== Overlay_1.OverlayStatus.ACTIVE)) {
                return {
                    status: action.payload.status,
                    moduleId: action.payload.moduleId,
                    menuOpen: false,
                    dragging: false,
                    renderSpotlight: true
                };
            }
        }
        if (typedActions_1.isType(action, exports.moduleOverlayChangeStatus)) {
            var newState = Object.assign({}, state);
            newState.status = action.payload.status;
            return newState;
        }
        if (typedActions_1.isType(action, exports.moduleOverlayHide)) {
            if (state && action.payload.moduleId === state.moduleId) {
                return initialState.moduleOverlay;
            }
        }
        if (typedActions_1.isType(action, exports.moduleOverlayMenuToggle)) {
            var newState = Object.assign({}, state);
            newState.menuOpen = action.payload.open;
            return newState;
        }
    }
    if (typedActions_1.isType(action, exports.moduleOverlayDragStarted)) {
        var newState = Object.assign({}, state);
        newState.dragging = true;
        return newState;
    }
    if (typedActions_1.isType(action, exports.moduleOverlayDragStopped)) {
        return initialState.moduleOverlay;
    }
    return state;
}
function loadingModulesReducer(state, action) {
    if (state === void 0) { state = initialState.loadingModuleIds; }
    if (typedActions_1.isType(action, exports.moduleLoadingStarted)) {
        if (state.indexOf(action.payload.moduleId) === -1) {
            return state.concat([action.payload.moduleId]);
        }
    }
    if (typedActions_1.isType(action, exports.moduleLoadingFinished)) {
        var index = state.indexOf(action.payload.moduleId);
        if (index !== -1) {
            return state.slice(0, index).concat(state.slice(index + 1));
        }
    }
    return state;
}
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var moduleId = state.moduleOverlay ? state.moduleOverlay.moduleId : null;
    if (moduleId) {
        var moduleType = Modul_1.default.getInstance(moduleId).getModuleType();
        // If we have a section module in active state, we freeze the top level overlays
        // until we get a hide action on the section itself and route all actions
        // to the nested overlays reducer
        if (moduleType === Modul_1.ModuleType.SECTION &&
            state.moduleOverlay.status === Overlay_1.OverlayStatus.ACTIVE) {
            if (typedActions_1.isType(action, exports.moduleOverlayShow) && action.payload.moduleId === moduleId) {
                return state;
            }
            if (!(typedActions_1.isType(action, exports.moduleOverlayHide) && action.payload.moduleId === moduleId)) {
                return helper_1.objectOverride(state, {
                    moduleOverlay: state.moduleOverlay,
                    moduleOverlayDeep: moduleOverlayReducer(state.moduleOverlayDeep, action),
                    loadingModuleIds: loadingModulesReducer(state.loadingModuleIds, action)
                });
            }
        }
    }
    return helper_1.objectOverride(state, {
        moduleOverlay: moduleOverlayReducer(state.moduleOverlay, action),
        moduleOverlayDeep: initialState.moduleOverlayDeep,
        loadingModuleIds: loadingModulesReducer(state.loadingModuleIds, action)
    });
}
// ======================
// CONNECT REACT TO REDUX
// ======================
function getMapStateToProps(selector) {
    return function mapStateToProps(state) {
        var ownState = selector(state);
        if (ownState === null) {
            return {
                status: null,
                moduleId: null,
                menuOpen: null,
                dragging: null
            };
        }
        return {
            status: ownState.status,
            moduleId: ownState.moduleId,
            menuOpen: ownState.menuOpen,
            dragging: ownState.dragging
        };
    };
}
;
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        onHideRequested: exports.moduleOverlayHide,
        onMenuToggleRequested: exports.moduleOverlayMenuToggle,
        onDragStarted: exports.moduleOverlayDragStarted,
        onDragStopped: exports.moduleOverlayDragStopped,
        onClickOutside: moduleOverlayClickOutside
    }, dispatch);
}
function render(store) {
    var overlaysContainer = document.createElement('div');
    overlaysContainer.setAttribute('id', 'diy-overlays');
    document.body.appendChild(overlaysContainer);
    var ConnectedModuleOverlay = react_redux_1.connect(getMapStateToProps(function (state) { return state.overlays.moduleOverlay; }), mapDispatchToProps)(ModuleOverlay_1.default);
    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(ConnectedModuleOverlay, null)), overlaysContainer);
}
function renderDeep(store) {
    var overlaysContainer = document.createElement('div');
    overlaysContainer.setAttribute('id', 'diy-overlays-deep');
    document.body.appendChild(overlaysContainer);
    var ConnectedModuleOverlayDeep = react_redux_1.connect(getMapStateToProps(function (state) { return state.overlays.moduleOverlayDeep; }), mapDispatchToProps)(ModuleOverlay_1.default);
    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(ConnectedModuleOverlayDeep, null)), overlaysContainer);
}
function renderLoadingMasks(store) {
    var loadingMasksContainer = document.createElement('div');
    loadingMasksContainer.setAttribute('id', 'diy-module-loading-masks');
    document.body.appendChild(loadingMasksContainer);
    var ConnectedModuleLoadingMasks = react_redux_1.connect(function (state) { return ({ moduleIds: state.overlays.loadingModuleIds }); })(ModuleLoadingMasks_1.ModuleLoadingMasks);
    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(ConnectedModuleLoadingMasks, null)), loadingMasksContainer);
}
// ==============
// INITIALIZATION
// ==============
var initialized = false;
function init(storeProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, "overlays");
        render(storeProvider.getStore());
        renderDeep(storeProvider.getStore());
        renderLoadingMasks(storeProvider.getStore());
        initialized = true;
    }
}
exports.init = init;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;

var _createStore = __webpack_require__(200);

var _createStore2 = _interopRequireDefault(_createStore);

var _combineReducers = __webpack_require__(215);

var _combineReducers2 = _interopRequireDefault(_combineReducers);

var _bindActionCreators = __webpack_require__(217);

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

var _applyMiddleware = __webpack_require__(218);

var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);

var _compose = __webpack_require__(219);

var _compose2 = _interopRequireDefault(_compose);

var _warning = __webpack_require__(216);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}

exports.createStore = _createStore2['default'];
exports.combineReducers = _combineReducers2['default'];
exports.bindActionCreators = _bindActionCreators2['default'];
exports.applyMiddleware = _applyMiddleware2['default'];
exports.compose = _compose2['default'];

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;

var _isPlainObject = __webpack_require__(201);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(211);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2['default'])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2['default']] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(202),
    getPrototype = __webpack_require__(208),
    isObjectLike = __webpack_require__(210);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(203),
    getRawTag = __webpack_require__(206),
    objectToString = __webpack_require__(207);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  value = Object(value);
  return (symToStringTag && symToStringTag in value)
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

var root = __webpack_require__(204);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(205);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ },
/* 205 */
/***/ function(module, exports) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(203);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ },
/* 207 */
/***/ function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(209);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ },
/* 209 */
/***/ function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ },
/* 210 */
/***/ function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(212);


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(214);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(213)(module)))

/***/ },
/* 213 */
/***/ function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		module.children = [];
		module.webpackPolyfill = 1;
	}
	return module;
}


/***/ },
/* 214 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
exports['default'] = combineReducers;

var _createStore = __webpack_require__(200);

var _isPlainObject = __webpack_require__(201);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warning = __webpack_require__(216);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!(0, _isPlainObject2['default'])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        (0, _warning2['default'])(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ },
/* 216 */
/***/ function(module, exports) {

'use strict';

exports.__esModule = true;
exports['default'] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ },
/* 217 */
/***/ function(module, exports) {

'use strict';

exports.__esModule = true;
exports['default'] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = applyMiddleware;

var _compose = __webpack_require__(219);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ },
/* 219 */
/***/ function(module, exports) {

"use strict";

exports.__esModule = true;
exports["default"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(221);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(224);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(28);

var _storeShape = __webpack_require__(222);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(223);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    var children = this.props.children;

    return _react.Children.only(children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;

if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;

    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _react.PropTypes.element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _react = __webpack_require__(28);

exports["default"] = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired
});

/***/ },
/* 223 */
/***/ function(module, exports) {

'use strict';

exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;
exports["default"] = connect;

var _react = __webpack_require__(28);

var _storeShape = __webpack_require__(222);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(225);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(226);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(223);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(201);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(227);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(228);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = undefined;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure;
  var pure = _options$pure === undefined ? true : _options$pure;
  var _options$withRef = options.withRef;
  var withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged;
        var hasStoreStateChanged = this.hasStoreStateChanged;
        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
        var statePropsPrecalculationError = this.statePropsPrecalculationError;
        var renderedElement = this.renderedElement;

        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ },
/* 225 */
/***/ function(module, exports) {

"use strict";

exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(199);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ },
/* 227 */
/***/ function(module, exports) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ },
/* 229 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var actionTypes = {};
function actionCreator(type) {
    if (actionTypes[type]) {
        throw new Error("Duplicate action type: " + type);
    }
    actionTypes[type] = true;
    return Object.assign(function (payload) { return ({ type: type, payload: payload }); }, { type: type });
}
exports.actionCreator = actionCreator;
function actionCreatorFactory(typePrefix) {
    return function (type) {
        return actionCreator(typePrefix + type);
    };
}
exports.actionCreatorFactory = actionCreatorFactory;
function isType(action, actionCreator) {
    return action.type === actionCreator.type;
}
exports.isType = isType;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var typedActions_1 = __webpack_require__(229);
exports.isType = typedActions_1.isType;
exports.actionCreatorFactory = typedActions_1.actionCreatorFactory;
var StoreProvider_1 = __webpack_require__(231);
exports.StoreProvider = StoreProvider_1.default;
/**
 * Wrapper for Object.assign that returns a new object.
 * Type checks ensure only existing properties are overriden and no new
 * properties are added. It also checks (shallow) if overriden properties
 * are the same and returns the old object if so.
 */
function objectOverride(first, override) {
    // Optimization: when the override has identical values, return the old object
    if (typeof first === 'object' && typeof override === 'object') {
        var isDifferent = Object.keys(override).some(function (key) { return first[key] !== override[key]; });
        if (!isDifferent) {
            return first;
        }
    }
    return Object.assign({}, first, override);
}
exports.objectOverride = objectOverride;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(199);
var createStore = __webpack_require__(232);
var StoreProvider = (function () {
    function StoreProvider() {
        this.reducers = {};
        // use just an identity reducer for the start
        this.reducer = function (state) { return state; };
        this.store = createStore(this.reducer);
    }
    StoreProvider.prototype.addReducer = function (reducer, namespace) {
        if (this.reducers.hasOwnProperty(namespace)) {
            throw new Error("reducer for " + namespace + " already defined");
        }
        else {
            this.reducers[namespace] = reducer;
        }
        this._recomposeReducer();
    };
    StoreProvider.prototype.removeReducer = function (reducer, namespace) {
        if (!this.reducers.hasOwnProperty(namespace)) {
            throw new Error("reducer for " + namespace + " not found");
        }
        else if (this.reducers[namespace] !== reducer) {
            throw new Error("reducer for " + namespace + " is different than the one provided");
        }
        else {
            delete this.reducers[namespace];
        }
        this._recomposeReducer();
    };
    StoreProvider.prototype.getStore = function () {
        return this.store;
    };
    // TODO extract this from class and make it separate
    StoreProvider.prototype.watchStore = function (selector, handler) {
        var _this = this;
        var currentState = selector(this.store.getState());
        var stateChangeHandler = function () {
            var previousState = currentState;
            currentState = selector(_this.store.getState());
            if (previousState !== currentState) {
                handler(currentState, previousState);
            }
        };
        this.store.subscribe(stateChangeHandler);
    };
    StoreProvider.prototype._recomposeReducer = function () {
        this.reducer = redux_1.combineReducers(this.reducers);
        this.store.replaceReducer(this.reducer);
    };
    return StoreProvider;
}());
exports.default = StoreProvider;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

// Use DefinePlugin (Webpack) or loose-envify (Browserify)
// together with Uglify to strip the dev branch in prod build.
if (true) {
  module.exports = __webpack_require__(233).default;
} else {
  module.exports = require('./createStore.dev').default;
}


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(199);
var redux_thunk_1 = __webpack_require__(234);
var typedToPlain_1 = __webpack_require__(235);
var finalCreateStore = redux_1.applyMiddleware(redux_thunk_1.default, typedToPlain_1.default)(redux_1.createStore);
exports.default = finalCreateStore;


/***/ },
/* 234 */
/***/ function(module, exports) {

'use strict';

exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ },
/* 235 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
// middleware for transforming Typed Actions into plain actions
var typedToPlain = function (store) { return function (next) { return function (action) {
    next(Object.assign({}, action));
}; }; };
exports.default = typedToPlain;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var l10n_1 = __webpack_require__(18);
var Overlay_1 = __webpack_require__(237);
var index_1 = __webpack_require__(198);
var Modul_1 = __webpack_require__(197);
var AppRegistry_1 = __webpack_require__(190);
var SyncPosition_1 = __webpack_require__(440);
var Spotlight_1 = __webpack_require__(443);
var Animation_1 = __webpack_require__(444);
var ModuleActionBar_1 = __webpack_require__(445);
var jquery = __webpack_require__(3);
var index_2 = __webpack_require__(499);
var mode_edit_1 = __webpack_require__(637);
var keyboard_arrow_up_1 = __webpack_require__(571);
var keyboard_arrow_down_1 = __webpack_require__(463);
var content_copy_1 = __webpack_require__(638);
var delete_1 = __webpack_require__(532);
var visibility_1 = __webpack_require__(612);
var ModuleOverlay = (function (_super) {
    tslib_1.__extends(ModuleOverlay, _super);
    function ModuleOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cursor = 'move';
        _this.registerOverlayRef = function (overlay) {
            var overlayEl = ReactDOM.findDOMNode(overlay);
            if (overlayEl) {
                _this.dragEl = overlayEl;
                var ddm = AppRegistry_1.default.getModuleDragDrop();
                if (_this.supportsDragging()) {
                    _this.dragEl.setAttribute('data-moduleid', _this.props.moduleId + '');
                    ddm.addDragSourceEl(jquery(_this.dragEl));
                    jquery(_this.dragEl)
                        .on('ddstart', _this.onDragStarted)
                        .on('ddstop', _this.onDragStopped);
                    _this.cursor = 'move';
                }
                else {
                    _this.cursor = 'pointer';
                }
            }
        };
        _this.onDragStarted = function () {
            _this.props.onDragStarted(void 0);
        };
        _this.onDragStopped = function () {
            _this.props.onDragStopped(void 0);
        };
        _this.onMouseLeave = function () {
            if (!_this.props.menuOpen) {
                _this.hide(_this.props.moduleId);
            }
        };
        _this.onMenuToggleRequest = function (open) {
            _this.props.onMenuToggleRequested({ open: open });
            if (open) {
                document.body.addEventListener('mousemove', _this.syncMouse);
            }
            else {
                var moduleRect = _this.getModuleEl()[0].getBoundingClientRect();
                if (_this.mouseClientX > moduleRect.left && _this.mouseClientX < moduleRect.left + moduleRect.width
                    && _this.mouseClientY > moduleRect.top && _this.mouseClientY < moduleRect.top + moduleRect.height) {
                    // do nothing;
                }
                else {
                    _this.onMouseLeave();
                }
                document.body.removeEventListener('mousemove', _this.syncMouse);
            }
        };
        _this.syncMouse = function (e) {
            _this.mouseClientX = e.clientX;
            _this.mouseClientY = e.clientY;
        };
        return _this;
    }
    ModuleOverlay.prototype.getModule = function () {
        return Modul_1.default.getInstance(this.props.moduleId);
    };
    ModuleOverlay.prototype.getModuleEl = function () {
        if (this.getModule()) {
            return this.getModule().modul;
        }
        return undefined;
    };
    ModuleOverlay.prototype.getMenuConfig = function () {
        var _this = this;
        var modul = this.getModule();
        var openHandler = function () {
            modul.open();
        };
        var moduleData = modul.getData();
        var section = modul.getParentSection();
        var isInSection = !!section;
        var isToggleableElement = false;
        if (isInSection) {
            if (section.hasToggleableElement(modul.getAlias())) {
                isToggleableElement = true;
            }
        }
        var inSectionMenuItems = [
            {
                isPrimary: true,
                name: "edit",
                primaryText: l10n_1.default('moduleOverlay.edit'),
                leftIcon: mode_edit_1.default,
                onSelect: openHandler
            }
        ];
        if (isToggleableElement) {
            inSectionMenuItems.push({
                name: "toggleElements",
                primaryText: l10n_1.default('section.actionBar.buttons.contentToggles.label'),
                leftIcon: visibility_1.default,
                onSelect: function () {
                    AppRegistry_1.default.getStoreProvider().getStore().dispatch(index_2.toggleElementsMenu({ visible: true }));
                }
            });
        }
        return {
            moduleId: this.props.moduleId,
            rightOffset: 0,
            defaultAction: openHandler,
            menuItems: isInSection ? inSectionMenuItems : [
                {
                    isPrimary: true,
                    name: "edit",
                    primaryText: l10n_1.default('moduleOverlay.edit'),
                    leftIcon: mode_edit_1.default,
                    onSelect: openHandler
                },
                {
                    isDivider: true
                },
                {
                    name: "moveup",
                    primaryText: l10n_1.default('moduleOverlay.moveup'),
                    leftIcon: keyboard_arrow_up_1.default,
                    onSelect: function () {
                        modul.onToolUp();
                        _this.hide(_this.props.moduleId);
                    },
                    disabled: !modul.getPrevModul().length || !moduleData.supports.moduleMove
                },
                {
                    name: "movedown",
                    primaryText: l10n_1.default('moduleOverlay.movedown'),
                    leftIcon: keyboard_arrow_down_1.default,
                    onSelect: function () {
                        modul.onToolDown();
                        _this.hide(_this.props.moduleId);
                    },
                    disabled: !modul.getNextModul().length || !moduleData.supports.moduleMove
                },
                {
                    name: "duplicate",
                    primaryText: l10n_1.default('moduleOverlay.duplicate'),
                    leftIcon: content_copy_1.default,
                    onSelect: function () {
                        modul.onDuplicate();
                        _this.hide(_this.props.moduleId);
                    },
                    disabled: !moduleData.supports.moduleDuplicate
                },
                {
                    isDivider: true
                },
                {
                    name: "delete",
                    primaryText: l10n_1.default('moduleOverlay.delete'),
                    leftIcon: delete_1.default,
                    onSelect: function () {
                        modul.deleteAction();
                        _this.hide(_this.props.moduleId);
                    },
                    disabled: !moduleData.supports.moduleDelete
                }
            ]
        };
    };
    ModuleOverlay.prototype.render = function () {
        var _this = this;
        if (this.props.moduleId
            && (this.props.status !== index_1.OverlayStatus.ACTIVE
                ||
                    (this.props.status === index_1.OverlayStatus.ACTIVE
                        && this.getModule().getModuleType() !== "matrix"))) {
            return (React.createElement(SyncPosition_1.default, { element: this.getModuleEl()[0], key: "overlaySync" }, function (box) {
                if (_this.props.status !== index_1.OverlayStatus.ACTIVE) {
                    return _this.renderOverlay(box);
                }
                else {
                    return _this.renderSpotlight(box);
                }
            }));
        }
        else {
            return null;
        }
    };
    ModuleOverlay.prototype.renderOverlay = function (box) {
        var _this = this;
        return (React.createElement(Animation_1.OpacityAnimation, { duration: 0.1, key: "overlayAnimation" },
            React.createElement(SyncPosition_1.default, { element: document.getElementById('cc-sa') }, function (saBox) {
                var overlapHorizontal = box.right - saBox.right;
                var overlapVertical = saBox.top + saBox.height - box.top;
                var overlayMenuOffset = 0;
                if (overlapHorizontal < saBox.width && overlapVertical > 0) {
                    overlayMenuOffset = saBox.width - overlapHorizontal;
                }
                var menuConfig = _this.getMenuConfig();
                menuConfig.rightOffset = overlayMenuOffset;
                return (React.createElement(Overlay_1.default, { key: _this.props.moduleId, onMouseLeave: _this.onMouseLeave, width: box.width, height: box.height, left: box.left, top: box.top, zIndex: ModuleOverlay.ZINDEX, overlayMenuConfig: menuConfig, status: _this.props.status, ref: _this.registerOverlayRef, menuOpen: _this.props.menuOpen, onMenuToggleRequest: _this.onMenuToggleRequest, cursor: _this.cursor, touchMode: diy.editor.uiPreference.isPointerModeTouch(), menuText: _this.getModule().getParentSection() === null
                        ? l10n_1.default("moduleOverlay.menuText")
                        : l10n_1.default("moduleOverlay.sectionMenuText") }));
            })));
    };
    ModuleOverlay.prototype.renderSpotlight = function (box) {
        var _this = this;
        var spotlightBottom;
        if (this.spotlight) {
            // back up the bottom offset
            spotlightBottom = this.spotlight.style.bottom;
            // make the spotlight not contribute to the total height
            // needed before calling getDocHeight
            this.spotlight.style.bottom = '0px';
        }
        var docHeight = this.getDocHeight();
        var delta = Math.round(document.documentElement.getBoundingClientRect().height - docHeight);
        if (this.spotlight) {
            // restore the spotlight bottom offset after we got the doc height
            this.spotlight.style.bottom = spotlightBottom;
        }
        var maskBox = {
            top: 0,
            left: 0,
            bottom: delta > 0 ? 0 : delta,
            right: 0,
            width: document.body.scrollWidth,
            height: docHeight
        };
        var actionBarEl = document.getElementById(ModuleActionBar_1.MODULE_ACTION_BAR_ELEMENT_ID);
        var isInSection = !!this.getModule().getParentSection();
        var topBarEl = document.getElementById("diyToolbar");
        var siteAdminEl = document.getElementById("cc-sa");
        var maskExtra = function (box) {
            var boxStyle = {
                position: "fixed",
                width: box.width,
                height: box.height,
                left: box.left,
                top: box.top,
                zIndex: 102000,
                background: "rgba(0,0,0,0.3)",
                cursor: 'pointer'
            };
            return (React.createElement("div", { onTouchTap: function () { _this.getModule().onClickOutside(); }, style: boxStyle }));
        };
        return (React.createElement("div", null,
            React.createElement(Animation_1.OpacityAnimation, { duration: 0.4, key: "spotlightAnimation" },
                React.createElement(Spotlight_1.default, { ref: function (spotlight) {
                        _this.spotlight = ReactDOM.findDOMNode(spotlight);
                    }, onTouchTap: function () { _this.getModule().onClickOutside(); }, maskBox: maskBox, highlightBox: box, zIndex: ModuleOverlay.ZINDEX, showBorder: this.getModule().hasActionBar && this.getModule().hasSpotlightBorder })),
            /* This is temporary solution for modules not migrated to action-bar that puts a mask
             over the action-bar of the section for auto-saving the module. This should be removed
             after all modules in sections are migrated to the action-bar.  */
            (!this.getModule().hasActionBar && actionBarEl && isInSection) ?
                React.createElement(Animation_1.OpacityAnimation, { duration: 0.4, key: "actionBarMaskAnimation" },
                    React.createElement(SyncPosition_1.default, { element: actionBarEl }, function (box) {
                        var boxStyle = {
                            position: "absolute",
                            width: box.width,
                            height: box.height,
                            left: box.left,
                            top: box.top,
                            zIndex: 102000,
                            background: "rgba(0,0,0,0.3)",
                            cursor: 'pointer'
                        };
                        return (React.createElement("div", { onTouchTap: function () { _this.getModule().onClickOutside(); }, style: boxStyle }));
                    }))
                :
                    null,
            /* bugfix DHDIY-33507 modules not migrated to action-bar
            must have autosave mask over topBar & siteAdmin */
            (!this.getModule().hasActionBar && topBarEl && !isInSection) ?
                React.createElement(Animation_1.OpacityAnimation, { duration: 0.4, key: "topBarMaskAnimation" },
                    React.createElement(SyncPosition_1.default, { element: topBarEl, position: "fixed" }, maskExtra))
                :
                    null,
            (!this.getModule().hasActionBar && siteAdminEl && !isInSection) ?
                React.createElement(Animation_1.OpacityAnimation, { duration: 0.4, key: "siteAdminMaskAnimation" },
                    React.createElement(SyncPosition_1.default, { element: siteAdminEl, position: "fixed" }, maskExtra))
                :
                    null));
    };
    ModuleOverlay.prototype.componentDidMount = function () {
        var _this = this;
        jquery(document).on('diy-editor-module-rerendered.moduleOverlayReact', function (e, module) {
            if (module.moduleId === _this.props.moduleId) {
                _this.forceUpdate();
            }
        });
    };
    ModuleOverlay.prototype.componentWillUnmount = function () {
        this.removeListeners();
        jquery(document).off('.moduleOverlayReact');
    };
    ModuleOverlay.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.moduleId !== this.props.moduleId) {
            this.removeListeners();
        }
    };
    ModuleOverlay.prototype.supportsDragging = function () {
        /* don't allow modules inside matrix modules to be draggable */
        return !(this.getModule().getMatrix() && !this.getModule().getMatrix().supportsDragging());
    };
    ModuleOverlay.prototype.removeListeners = function () {
        var _this = this;
        if (this.props.moduleId) {
            jquery(this.dragEl)
                .off('ddstart', this.onDragStarted)
                .off('ddstop', this.onDragStopped);
            var ddm = AppRegistry_1.default.getModuleDragDrop();
            ddm.removeDragSources(function (dragSource) {
                return dragSource.moduleId === _this.props.moduleId;
            });
        }
    };
    ModuleOverlay.prototype.hide = function (moduleId) {
        this.props.onHideRequested({ moduleId: moduleId });
    };
    ModuleOverlay.prototype.getDocHeight = function () {
        var html = document.documentElement;
        var body = document.body;
        return Math.max(body.scrollHeight, html.scrollHeight, body.offsetHeight, html.offsetHeight, body.clientHeight, html.clientHeight);
    };
    return ModuleOverlay;
}(React.Component));
ModuleOverlay.ZINDEX = 113;
exports.default = ModuleOverlay;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactTransitionGroup = __webpack_require__(238);
var diyLightTheme = __webpack_require__(241);
var TouchRipple_1 = __webpack_require__(376);
var CircularProgress_1 = __webpack_require__(382);
var OverlayMenu_1 = __webpack_require__(384);
var OverlayStatus;
(function (OverlayStatus) {
    OverlayStatus[OverlayStatus["HOVER"] = 0] = "HOVER";
    OverlayStatus[OverlayStatus["LOADING"] = 1] = "LOADING";
    OverlayStatus[OverlayStatus["ACTIVE"] = 2] = "ACTIVE";
})(OverlayStatus = exports.OverlayStatus || (exports.OverlayStatus = {}));
var Overlay = (function (_super) {
    tslib_1.__extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            if (!_this.props.touchMode) {
                _this.props.overlayMenuConfig.defaultAction();
            }
        };
        _this.handleTouchTap = function (event) {
            if (_this.props.touchMode) {
                _this.props.overlayMenuConfig.defaultAction();
            }
        };
        _this.handleRightClick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (!_this.props.menuOpen && _this.props.onMenuToggleRequest) {
                // XXX: Need the timeout to avoid an accidental menu option selection
                setTimeout(function () { return _this.props.onMenuToggleRequest(true); }, 200);
            }
        };
        return _this;
    }
    Overlay.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    Overlay.prototype.getStyles = function () {
        return {
            root: {
                position: "absolute",
                zIndex: this.props.zIndex,
                cursor: this.props.cursor,
                left: this.props.left,
                top: this.props.top,
                width: this.props.width,
                height: this.props.height,
                background: 'rgba(33, 150, 243, 0.3)',
                boxSizing: 'border-box',
                border: '1px solid rgba(33, 150, 243, 1)',
            },
            border: {
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                boxSizing: 'border-box',
                border: '1px solid rgba(255, 255, 255, 1)'
            }
        };
    };
    Overlay.prototype.render = function () {
        var styles = this.getStyles();
        var showMenuLabel = true;
        if ((this.props.width < 130)
            || ((this.props.width / 2) < 130 && this.props.height < 100)) {
            showMenuLabel = false;
        }
        var menuLabelMaxWidth = this.props.height > 100 ? this.props.width : (this.props.width * 75 / 100);
        return (React.createElement("div", { className: "wrapper", style: styles.root, onClick: this.handleClick, onTouchTap: this.handleTouchTap, onMouseLeave: this.props.onMouseLeave, onContextMenu: this.handleRightClick },
            React.createElement(TouchRipple_1.default, null,
                React.createElement("div", { style: styles.border },
                    this.props.status === OverlayStatus.LOADING ?
                        React.createElement("div", null,
                            React.createElement(CircularProgress_1.default, { mode: "indeterminate", size: 1.5 }))
                        :
                            null,
                    React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, onMouseDown: function (e) { return e.stopPropagation(); }, onTouchTap: function (e) { return e.stopPropagation(); } },
                        React.createElement(ReactTransitionGroup, null,
                            React.createElement(OverlayMenu_1.default, { showMenuLabel: showMenuLabel, menuLabelMaxWidth: menuLabelMaxWidth, overlayMenuConfig: this.props.overlayMenuConfig, open: this.props.menuOpen, onToggleRequest: this.props.onMenuToggleRequest, menuText: this.props.menuText })))))));
    };
    return Overlay;
}(React.Component));
Overlay.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = Overlay;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(239);

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactTransitionGroup
 */

'use strict';

var _assign = __webpack_require__(30);

var React = __webpack_require__(29);
var ReactInstanceMap = __webpack_require__(136);
var ReactTransitionChildMapping = __webpack_require__(240);

var emptyFunction = __webpack_require__(38);

/**
 * A basis for animations. When children are declaratively added or removed,
 * special lifecycle hooks are called.
 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
 */
var ReactTransitionGroup = React.createClass({
  displayName: 'ReactTransitionGroup',

  propTypes: {
    component: React.PropTypes.any,
    childFactory: React.PropTypes.func
  },

  getDefaultProps: function () {
    return {
      component: 'span',
      childFactory: emptyFunction.thatReturnsArgument
    };
  },

  getInitialState: function () {
    return {
      // TODO: can we get useful debug information to show at this point?
      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
    };
  },

  componentWillMount: function () {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  },

  componentDidMount: function () {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  },

  componentWillReceiveProps: function (nextProps) {
    var nextChildMapping;
    if (false) {
      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactInstanceMap.get(this)._debugID);
    } else {
      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
    }
    var prevChildMapping = this.state.children;

    this.setState({
      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
    });

    var key;

    for (key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
        this.keysToLeave.push(key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  },

  componentDidUpdate: function () {
    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  },

  performAppear: function (key) {
    this.currentlyTransitioningKeys[key] = true;

    var component = this.refs[key];

    if (component.componentWillAppear) {
      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
    } else {
      this._handleDoneAppearing(key);
    }
  },

  _handleDoneAppearing: function (key) {
    var component = this.refs[key];
    if (component.componentDidAppear) {
      component.componentDidAppear();
    }

    delete this.currentlyTransitioningKeys[key];

    var currentChildMapping;
    if (false) {
      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
    } else {
      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
    }

    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      // This was removed before it had fully appeared. Remove it.
      this.performLeave(key);
    }
  },

  performEnter: function (key) {
    this.currentlyTransitioningKeys[key] = true;

    var component = this.refs[key];

    if (component.componentWillEnter) {
      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
    } else {
      this._handleDoneEntering(key);
    }
  },

  _handleDoneEntering: function (key) {
    var component = this.refs[key];
    if (component.componentDidEnter) {
      component.componentDidEnter();
    }

    delete this.currentlyTransitioningKeys[key];

    var currentChildMapping;
    if (false) {
      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
    } else {
      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
    }

    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      // This was removed before it had fully entered. Remove it.
      this.performLeave(key);
    }
  },

  performLeave: function (key) {
    this.currentlyTransitioningKeys[key] = true;

    var component = this.refs[key];
    if (component.componentWillLeave) {
      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
    } else {
      // Note that this is somewhat dangerous b/c it calls setState()
      // again, effectively mutating the component before all the work
      // is done.
      this._handleDoneLeaving(key);
    }
  },

  _handleDoneLeaving: function (key) {
    var component = this.refs[key];

    if (component.componentDidLeave) {
      component.componentDidLeave();
    }

    delete this.currentlyTransitioningKeys[key];

    var currentChildMapping;
    if (false) {
      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
    } else {
      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
    }

    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
      // This entered again before it fully left. Add it again.
      this.performEnter(key);
    } else {
      this.setState(function (state) {
        var newChildren = _assign({}, state.children);
        delete newChildren[key];
        return { children: newChildren };
      });
    }
  },

  render: function () {
    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];
    for (var key in this.state.children) {
      var child = this.state.children[key];
      if (child) {
        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
      }
    }

    // Do not forward ReactTransitionGroup props to primitive DOM nodes
    var props = _assign({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return React.createElement(this.props.component, props, childrenToRender);
  }
});

module.exports = ReactTransitionGroup;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactTransitionChildMapping
 */

'use strict';

var flattenChildren = __webpack_require__(147);

var ReactTransitionChildMapping = {
  /**
   * Given `this.props.children`, return an object mapping key to child. Just
   * simple syntactic sugar around flattenChildren().
   *
   * @param {*} children `this.props.children`
   * @param {number=} selfDebugID Optional debugID of the current internal instance.
   * @return {object} Mapping of key to child
   */
  getChildMapping: function (children, selfDebugID) {
    if (!children) {
      return children;
    }

    if (false) {
      return flattenChildren(children, selfDebugID);
    }

    return flattenChildren(children);
  },

  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */
  mergeChildMappings: function (prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      if (next.hasOwnProperty(key)) {
        return next[key];
      } else {
        return prev[key];
      }
    }

    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = {};

    var pendingKeys = [];
    for (var prevKey in prev) {
      if (next.hasOwnProperty(prevKey)) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i;
    var childMapping = {};
    for (var nextKey in next) {
      if (nextKeysPending.hasOwnProperty(nextKey)) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }
      childMapping[nextKey] = getValueForKey(nextKey);
    }

    // Finally, add the keys which didn't appear before any key in `next`
    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }
};

module.exports = ReactTransitionChildMapping;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

var MwsColors = __webpack_require__(189);
var styles_1 = __webpack_require__(242);
var getMuiTheme_1 = __webpack_require__(244);
var zIndex_1 = __webpack_require__(334);
var diyLightRawTheme_1 = __webpack_require__(375);
var palette = diyLightRawTheme_1.default.palette;
var lightTheme = {
    zIndex: Object.assign({}, zIndex_1.default, {
        layer: 1000003,
        popover: 1000003,
        dialogOverlay: 1000001,
        dialog: 1000002
    }),
    checkbox: {
        checkedColor: palette.accent1Color
    },
    flatButton: {
        color: styles_1.colors.transparent,
        textColor: palette.primary2Color,
        primaryTextColor: palette.accent1Color,
        secondaryTextColor: palette.primary3Color
    },
    floatingActionButton: {
        secondaryColor: palette.primary2Color
    },
    paper: {
        backgroundColor: palette.canvasColor
    },
    radioButton: {
        checkedColor: palette.accent1Color
    },
    raisedButton: {
        secondaryColor: palette.primary2Color,
        disabledColor: palette.accent2Color,
        disabledTextColor: styles_1.colors.white
    },
    slider: {
        trackColorSelected: palette.primary3Color,
        selectionColor: palette.accent1Color,
        rippleColor: palette.accent1Color
    },
    snackbar: {
        backgroundColor: palette.primary2Color,
        actionColor: palette.accent3Color
    },
    toggle: {
        thumbOnColor: palette.accent1Color
    },
    toolbar: {
        backgroundColor: MwsColors.mwsGrey50,
        iconColor: MwsColors.mwsGrey800,
        separatorColor: palette.primary2Color,
        menuHoverColor: styles_1.colors.white
    },
    tabs: {
        backgroundColor: palette.primary2Color
    },
    textField: {
        focusColor: palette.accent1Color
    }
};
module.exports = getMuiTheme_1.default(diyLightRawTheme_1.default, lightTheme);


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndex = exports.typography = exports.transitions = exports.themeManager = exports.spacing = exports.getMuiTheme = exports.LightRawTheme = exports.lightBaseTheme = exports.DarkRawTheme = exports.darkBaseTheme = exports.colors = exports.MuiThemeProvider = undefined;

var _MuiThemeProvider2 = __webpack_require__(243);

var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);

var _colors2 = __webpack_require__(332);

var _colors = _interopRequireWildcard(_colors2);

var _darkBaseTheme2 = __webpack_require__(372);

var _darkBaseTheme3 = _interopRequireDefault(_darkBaseTheme2);

var _lightBaseTheme2 = __webpack_require__(331);

var _lightBaseTheme3 = _interopRequireDefault(_lightBaseTheme2);

var _getMuiTheme2 = __webpack_require__(244);

var _getMuiTheme3 = _interopRequireDefault(_getMuiTheme2);

var _spacing2 = __webpack_require__(333);

var _spacing3 = _interopRequireDefault(_spacing2);

var _themeManager2 = __webpack_require__(373);

var _themeManager3 = _interopRequireDefault(_themeManager2);

var _transitions2 = __webpack_require__(374);

var _transitions3 = _interopRequireDefault(_transitions2);

var _typography2 = __webpack_require__(371);

var _typography3 = _interopRequireDefault(_typography2);

var _zIndex2 = __webpack_require__(334);

var _zIndex3 = _interopRequireDefault(_zIndex2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MuiThemeProvider = _MuiThemeProvider3.default;
exports.colors = _colors;
exports.darkBaseTheme = _darkBaseTheme3.default;
exports.DarkRawTheme = _darkBaseTheme3.default;
exports.lightBaseTheme = _lightBaseTheme3.default;
exports.LightRawTheme = _lightBaseTheme3.default;
exports.getMuiTheme = _getMuiTheme3.default;
exports.spacing = _spacing3.default;
exports.themeManager = _themeManager3.default;
exports.transitions = _transitions3.default;
exports.typography = _typography3.default;
exports.zIndex = _zIndex3.default;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

var _getMuiTheme = __webpack_require__(244);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MuiThemeProvider = function (_Component) {
  _inherits(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    _classCallCheck(this, MuiThemeProvider);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(MuiThemeProvider).apply(this, arguments));
  }

  _createClass(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.propTypes = {
  children: _react.PropTypes.element,
  muiTheme: _react.PropTypes.object
};
MuiThemeProvider.childContextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = MuiThemeProvider;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMuiTheme;

var _merge = __webpack_require__(245);

var _merge2 = _interopRequireDefault(_merge);

var _colorManipulator = __webpack_require__(330);

var _lightBaseTheme = __webpack_require__(331);

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__(334);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__(335);

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__(368);

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__(369);

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__(370);

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__(371);

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__(332);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _merge2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme;
  var spacing = _muiTheme.spacing;
  var fontFamily = _muiTheme.fontFamily;
  var palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _merge2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.accent1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.primary1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: _colors.white
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.035),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.textColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.accent3Color,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });
  muiTheme.prepareStyles = _compose2.default.apply(undefined, _toConsumableArray(transformers));

  return muiTheme;
}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(246),
    createAssigner = __webpack_require__(320);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(247),
    assignMergeValue = __webpack_require__(285),
    baseFor = __webpack_require__(288),
    baseMergeDeep = __webpack_require__(290),
    isObject = __webpack_require__(265),
    keysIn = __webpack_require__(314);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(248),
    stackClear = __webpack_require__(256),
    stackDelete = __webpack_require__(257),
    stackGet = __webpack_require__(258),
    stackHas = __webpack_require__(259),
    stackSet = __webpack_require__(260);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(249),
    listCacheDelete = __webpack_require__(250),
    listCacheGet = __webpack_require__(253),
    listCacheHas = __webpack_require__(254),
    listCacheSet = __webpack_require__(255);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ },
/* 249 */
/***/ function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

var eq = __webpack_require__(252);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ },
/* 252 */
/***/ function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(248);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ },
/* 257 */
/***/ function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ },
/* 258 */
/***/ function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ },
/* 259 */
/***/ function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(248),
    Map = __webpack_require__(261),
    MapCache = __webpack_require__(270);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(262),
    root = __webpack_require__(204);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(263),
    getValue = __webpack_require__(269);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(264),
    isMasked = __webpack_require__(266),
    isObject = __webpack_require__(265),
    toSource = __webpack_require__(268);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(202),
    isObject = __webpack_require__(265);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ },
/* 265 */
/***/ function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(267);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

var root = __webpack_require__(204);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ },
/* 268 */
/***/ function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ },
/* 269 */
/***/ function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(271),
    mapCacheDelete = __webpack_require__(279),
    mapCacheGet = __webpack_require__(282),
    mapCacheHas = __webpack_require__(283),
    mapCacheSet = __webpack_require__(284);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(272),
    ListCache = __webpack_require__(248),
    Map = __webpack_require__(261);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(273),
    hashDelete = __webpack_require__(275),
    hashGet = __webpack_require__(276),
    hashHas = __webpack_require__(277),
    hashSet = __webpack_require__(278);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(274);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(262);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ },
/* 275 */
/***/ function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(274);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(274);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(274);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(280);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(281);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ },
/* 281 */
/***/ function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(280);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(280);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(280);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(286),
    eq = __webpack_require__(252);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(287);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(262);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(289);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ },
/* 289 */
/***/ function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(285),
    cloneBuffer = __webpack_require__(291),
    cloneTypedArray = __webpack_require__(292),
    copyArray = __webpack_require__(295),
    initCloneObject = __webpack_require__(296),
    isArguments = __webpack_require__(299),
    isArray = __webpack_require__(301),
    isArrayLikeObject = __webpack_require__(302),
    isBuffer = __webpack_require__(305),
    isFunction = __webpack_require__(264),
    isObject = __webpack_require__(265),
    isPlainObject = __webpack_require__(201),
    isTypedArray = __webpack_require__(307),
    toPlainObject = __webpack_require__(311);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(204);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213)(module)))

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(293);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(294);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

var root = __webpack_require__(204);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ },
/* 295 */
/***/ function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(297),
    getPrototype = __webpack_require__(208),
    isPrototype = __webpack_require__(298);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(265);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ },
/* 298 */
/***/ function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(300),
    isObjectLike = __webpack_require__(210);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(202),
    isObjectLike = __webpack_require__(210);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ },
/* 301 */
/***/ function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(303),
    isObjectLike = __webpack_require__(210);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(264),
    isLength = __webpack_require__(304);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ },
/* 304 */
/***/ function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(204),
    stubFalse = __webpack_require__(306);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213)(module)))

/***/ },
/* 306 */
/***/ function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(308),
    baseUnary = __webpack_require__(309),
    nodeUtil = __webpack_require__(310);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(202),
    isLength = __webpack_require__(304),
    isObjectLike = __webpack_require__(210);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ },
/* 309 */
/***/ function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(205);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213)(module)))

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(312),
    keysIn = __webpack_require__(314);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(313),
    baseAssignValue = __webpack_require__(286);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(286),
    eq = __webpack_require__(252);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(315),
    baseKeysIn = __webpack_require__(318),
    isArrayLike = __webpack_require__(303);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(316),
    isArguments = __webpack_require__(299),
    isArray = __webpack_require__(301),
    isBuffer = __webpack_require__(305),
    isIndex = __webpack_require__(317),
    isTypedArray = __webpack_require__(307);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ },
/* 316 */
/***/ function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ },
/* 317 */
/***/ function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(265),
    isPrototype = __webpack_require__(298),
    nativeKeysIn = __webpack_require__(319);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ },
/* 319 */
/***/ function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(321),
    isIterateeCall = __webpack_require__(329);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

var identity = __webpack_require__(322),
    overRest = __webpack_require__(323),
    setToString = __webpack_require__(325);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ },
/* 322 */
/***/ function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

var apply = __webpack_require__(324);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ },
/* 324 */
/***/ function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(326),
    shortOut = __webpack_require__(328);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

var constant = __webpack_require__(327),
    defineProperty = __webpack_require__(287),
    identity = __webpack_require__(322);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ },
/* 327 */
/***/ function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ },
/* 328 */
/***/ function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

var eq = __webpack_require__(252),
    isArrayLike = __webpack_require__(303),
    isIndex = __webpack_require__(317),
    isObject = __webpack_require__(265);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ },
/* 330 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;
/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type;
  var values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length <= 1 || arguments[1] === undefined ? 0.15 : arguments[1];

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(332);

var _colorManipulator = __webpack_require__(330);

var _spacing = __webpack_require__(333);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ },
/* 332 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 333 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ },
/* 334 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = function (muiTheme) {
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && typeof navigator !== 'undefined') {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      return _inlineStylePrefixer2.default.prefixAll(style);
    };
  } else {
    var _ret = function () {
      var prefixer = new _inlineStylePrefixer2.default({
        userAgent: userAgent
      });

      return {
        v: function v(style) {
          return prefixer.prefix(style);
        }
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
};

var _inlineStylePrefixer = __webpack_require__(336);

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// special flexbox specifications


var _prefixAll2 = __webpack_require__(337);

var _prefixAll3 = _interopRequireDefault(_prefixAll2);

var _getBrowserInformation = __webpack_require__(351);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(354);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(339);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _prefixProps = __webpack_require__(355);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _calc = __webpack_require__(356);

var _calc2 = _interopRequireDefault(_calc);

var _zoomCursor = __webpack_require__(358);

var _zoomCursor2 = _interopRequireDefault(_zoomCursor);

var _grabCursor = __webpack_require__(359);

var _grabCursor2 = _interopRequireDefault(_grabCursor);

var _flex = __webpack_require__(360);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(361);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(362);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(363);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(365);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(366);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var plugins = [_calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
// this must be run AFTER the flexbox specs
_flex2.default];

var Prefixer = function () {
  /**
   * Instantiante a new prefixer
   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
   * @param {string} keepUnprefixed - keeps unprefixed properties and values
   */

  function Prefixer() {
    var _this = this;

    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Prefixer);

    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

    this._userAgent = options.userAgent || defaultUserAgent;
    this._keepUnprefixed = options.keepUnprefixed || false;

    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);

    // Checks if the userAgent was resolved correctly
    if (this._browserInfo && this._browserInfo.prefix) {
      // set additional prefix information
      this.cssPrefix = this._browserInfo.prefix.css;
      this.jsPrefix = this._browserInfo.prefix.inline;
      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
    } else {
      this._usePrefixAllFallback = true;
      return false;
    }

    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
    if (data) {
      this._requiresPrefix = Object.keys(data).filter(function (key) {
        return data[key] >= _this._browserInfo.version;
      }).reduce(function (result, name) {
        result[name] = true;
        return result;
      }, {});
      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
    } else {
      this._usePrefixAllFallback = true;
    }
  }

  /**
   * Returns a prefixed version of the style object
   * @param {Object} styles - Style object that gets prefixed properties added
   * @returns {Object} - Style object with prefixed properties and values
   */


  _createClass(Prefixer, [{
    key: 'prefix',
    value: function prefix(styles) {
      var _this2 = this;

      // use prefixAll as fallback if userAgent can not be resolved
      if (this._usePrefixAllFallback) {
        return (0, _prefixAll3.default)(styles);
      }

      // only add prefixes if needed
      if (!this._hasPropsRequiringPrefix) {
        return styles;
      }

      Object.keys(styles).forEach(function (property) {
        var value = styles[property];
        if (value instanceof Object && !Array.isArray(value)) {
          // recurse through nested style objects
          styles[property] = _this2.prefix(value);
        } else {
          // add prefixes if needed
          if (_this2._requiresPrefix[property]) {
            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
            if (!_this2._keepUnprefixed) {
              delete styles[property];
            }
          }
        }
      });

      Object.keys(styles).forEach(function (property) {
        [].concat(styles[property]).forEach(function (value) {
          // resolve plugins
          plugins.forEach(function (plugin) {
            // generates a new plugin interface with current data
            assignStyles(styles, plugin({
              property: property,
              value: value,
              styles: styles,
              browserInfo: _this2._browserInfo,
              prefix: {
                js: _this2.jsPrefix,
                css: _this2.cssPrefix,
                keyframes: _this2.prefixedKeyframes
              },
              keepUnprefixed: _this2._keepUnprefixed,
              requiresPrefix: _this2._requiresPrefix
            }), value, _this2._keepUnprefixed);
          });
        });
      });

      return styles;
    }

    /**
     * Returns a prefixed version of the style object using all vendor prefixes
     * @param {Object} styles - Style object that gets prefixed properties added
     * @returns {Object} - Style object with prefixed properties and values
     */

  }], [{
    key: 'prefixAll',
    value: function prefixAll(styles) {
      return (0, _prefixAll3.default)(styles);
    }
  }]);

  return Prefixer;
}();

exports.default = Prefixer;


function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var value = arguments[2];
  var keepUnprefixed = arguments[3];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (val) {
        if (base[property].indexOf(val) === -1) {
          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
        }
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixAll;

var _prefixProps = __webpack_require__(338);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _capitalizeString = __webpack_require__(339);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _calc = __webpack_require__(340);

var _calc2 = _interopRequireDefault(_calc);

var _cursor = __webpack_require__(343);

var _cursor2 = _interopRequireDefault(_cursor);

var _flex = __webpack_require__(344);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(345);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(346);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(347);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(349);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(350);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// special flexbox specifications


var plugins = [_calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */
function prefixAll(styles) {
  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      styles[property] = prefixAll(value);
    } else {
      Object.keys(_prefixProps2.default).forEach(function (prefix) {
        var properties = _prefixProps2.default[prefix];
        // add prefixes if needed
        if (properties[property]) {
          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
        }
      });
    }
  });

  Object.keys(styles).forEach(function (property) {
    [].concat(styles[property]).forEach(function (value, index) {
      // resolve every special plugins
      plugins.forEach(function (plugin) {
        return assignStyles(styles, plugin(property, value));
      });
    });
  });

  return styles;
}

function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (value) {
        var valueIndex = baseValue.indexOf(value);
        if (valueIndex > -1) {
          base[property].splice(valueIndex, 1);
        }
        base[property].push(value);
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
module.exports = exports["default"];

/***/ },
/* 339 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _joinPrefixedValue = __webpack_require__(341);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(342);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// returns a style object with a single concated prefixed value string

exports.default = function (property, value) {
  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
    return prefix + value;
  } : arguments[2];
  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
    return replacer(prefix, value);
  }));
};

module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;

var _joinPrefixedValue = __webpack_require__(341);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}
module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _joinPrefixedValue = __webpack_require__(341);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties[property] && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _joinPrefixedValue = __webpack_require__(341);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(342);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateStyleName = __webpack_require__(348);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _capitalizeString = __webpack_require__(339);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _isPrefixedValue = __webpack_require__(342);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _prefixProps = __webpack_require__(338);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true
};

function transition(property, value) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties[property]) {
    var _ref2;

    var outputValue = prefixValue(value);
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
      return value.match(/-moz-|-ms-/) === null;
    }).join(',');

    // if the property is already prefixed
    if (property.indexOf('Webkit') > -1) {
      return _defineProperty({}, property, webkitOutput);
    }

    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
  }
}

function prefixValue(value) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  // iterate each single value and check for transitioned properties
  // that need to be prefixed as well
  multipleValues.forEach(function (val, index) {
    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';

      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);

        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
          // join all prefixes and create a new value
          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
        }
      });
      return out;
    }, val);
  });

  return multipleValues.join(',');
}
module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports) {

'use strict';

var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ },
/* 349 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(property, value) {
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value) {
  if (property === 'flexDirection' && typeof value === 'string') {
    return {
      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
    };
  }
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bowser = __webpack_require__(352);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendorPrefixes = {
  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
  Moz: ['firefox', 'seamonkey', 'sailfish'],
  ms: ['msie', 'msedge']
};
var browsers = {
  chrome: [['chrome'], ['chromium']],
  safari: [['safari']],
  firefox: [['firefox']],
  edge: [['msedge']],
  opera: [['opera'], ['vivaldi']],
  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
  ie: [['msie']],
  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
  and_uc: [['android', 'mobile'], ['android', 'tablet']],
  android: [['android', 'mobile'], ['android', 'tablet']]
};

var browserByInfo = function browserByInfo(info) {
  if (info.firefox) {
    return 'firefox';
  }
  var name = '';

  Object.keys(browsers).forEach(function (browser) {
    browsers[browser].forEach(function (condition) {
      var match = 0;
      condition.forEach(function (single) {
        if (info[single]) {
          match += 1;
        }
      });
      if (condition.length === match) {
        name = browser;
      }
    });
  });

  return name;
};

/**
 * Uses bowser to get default browser information such as version and name
 * Evaluates bowser info and adds vendorPrefix information
 * @param {string} userAgent - userAgent that gets evaluated
 */

exports.default = function (userAgent) {
  if (!userAgent) {
    return false;
  }
  var info = _bowser2.default._detect(userAgent);

  Object.keys(vendorPrefixes).forEach(function (prefix) {
    vendorPrefixes[prefix].forEach(function (browser) {
      if (info[browser]) {
        info.prefix = {
          inline: prefix,
          css: '-' + prefix.toLowerCase() + '-'
        };
      }
    });
  });

  info.browser = browserByInfo(info);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
  info.osversion = parseFloat(info.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (info.browser === 'ios_saf' && info.version > info.osversion) {
    info.version = info.osversion;
    info.safari = true;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (info.browser === 'android' && info.chrome && info.version > 37) {
    info.browser = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (info.browser === 'android' && info.osversion < 5) {
    info.version = info.osversion;
  }

  return info;
};

module.exports = exports['default'];

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(353)(name, definition)
  else this[name] = definition()
}('bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
      result.android = t
    } else if (!result.windowsphone && !result.msedge && iosdevice) {
      result[iosdevice] = t
      result.ios = t
    } else if (mac) {
      result.mac = t
    } else if (xbox) {
      result.xbox = t
    } else if (windows) {
      result.windows = t
    } else if (linux) {
      result.linux = t
    }

    // OS version extraction
    var osVersion = '';
    if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ },
/* 353 */
/***/ function(module, exports) {

module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 354 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var browser = _ref.browser;
  var version = _ref.version;
  var prefix = _ref.prefix;

  var prefixedKeyframes = 'keyframes';

  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
    prefixedKeyframes = prefix.css + prefixedKeyframes;
  }
  return prefixedKeyframes;
};

module.exports = exports['default'];

/***/ },
/* 355 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
module.exports = exports["default"];

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calc(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ },
/* 357 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (prefixedValue, value, keepUnprefixed) {
  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
};

module.exports = exports["default"];

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = zoomCursor;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { 'zoom-in': true, 'zoom-out': true };

function zoomCursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
    return {
      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = grabCursor;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { grab: true, grabbing: true };

function grabCursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var browser = _ref.browserInfo.browser;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
    return {
      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { flex: true, 'inline-flex': true };

function flex(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
    return {
      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties[property] && values[value]) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = transition;

var _hyphenateStyleName = __webpack_require__(348);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _unprefixProperty = __webpack_require__(364);

var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = { transition: true, transitionProperty: true };

function transition(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var css = _ref.prefix.css;
  var requiresPrefix = _ref.requiresPrefix;
  var keepUnprefixed = _ref.keepUnprefixed;

  // also check for already prefixed transitions
  var unprefixedProperty = (0, _unprefixProperty2.default)(property);

  if (typeof value === 'string' && properties[unprefixedProperty]) {
    var _ret = function () {
      // TODO: memoize this array
      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateStyleName2.default)(prop);
      });

      // only split multi values, not cubic beziers
      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

      requiresPrefixDashCased.forEach(function (prop) {
        multipleValues.forEach(function (val, index) {
          if (val.indexOf(prop) > -1 && prop !== 'order') {
            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
          }
        });
      });

      return {
        v: _defineProperty({}, property, multipleValues.join(','))
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
}
module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
};

module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var styles = _ref.styles;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
    if (!keepUnprefixed && !Array.isArray(styles[property])) {
      delete styles[property];
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}
module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(357);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var styles = _ref.styles;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    if (!keepUnprefixed && !Array.isArray(styles[property])) {
      delete styles[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      return {
        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
      };
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}
module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ },
/* 369 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rtl;
var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      Object.keys(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ },
/* 370 */
/***/ function(module, exports) {

"use strict";

exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  return function () {
    var result = last.apply(undefined, arguments);
    for (var i = funcs.length - 2; i >= 0; i--) {
      var f = funcs[i];
      result = f(result);
    }
    return result;
  };
}

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(332);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Typography = function Typography() {
  _classCallCheck(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(332);

var _colorManipulator = __webpack_require__(330);

var _spacing = __webpack_require__(333);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: _colors.cyan700,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey600,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.pinkA400,
    accent3Color: _colors.pinkA100,
    textColor: _colors.fullWhite,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.7),
    alternateTextColor: '#303030',
    canvasColor: '#303030',
    borderColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.3),
    disabledColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.3),
    pickerHeaderColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.12),
    clockCircleColor: (0, _colorManipulator.fade)(_colors.fullWhite, 0.12)
  }
};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = __webpack_require__(245);

var _merge2 = _interopRequireDefault(_merge);

var _getMuiTheme2 = __webpack_require__(244);

var _getMuiTheme3 = _interopRequireDefault(_getMuiTheme2);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getMuiTheme: function getMuiTheme(baseTheme, muiTheme) {
     false ? (0, _warning2.default)(false, 'ThemeManager is deprecated. please import getMuiTheme\n        directly from "material-ui/styles/getMuiTheme".\n        It will be removed with v0.16.0.') : void 0;
    return (0, _getMuiTheme3.default)(baseTheme, muiTheme);
  },
  modifyRawThemeSpacing: function modifyRawThemeSpacing(muiTheme, spacing) {
     false ? (0, _warning2.default)(false, 'modifyRawThemeSpacing is deprecated. please use getMuiTheme\n        to modify your theme directly. http://www.material-ui.com/#/customization/themes.\n        It will be removed with v0.16.0.') : void 0;
    return (0, _getMuiTheme3.default)((0, _merge2.default)({}, muiTheme.baseTheme, { spacing: spacing }));
  },
  modifyRawThemePalette: function modifyRawThemePalette(muiTheme, palette) {
     false ? (0, _warning2.default)(false, 'modifyRawThemePalette is deprecated. please use getMuiTheme\n        to modify your theme directly. http://www.material-ui.com/#/customization/themes.\n        It will be removed with v0.16.0.') : void 0;
    return (0, _getMuiTheme3.default)((0, _merge2.default)({}, muiTheme.baseTheme, { baseTheme: { palette: palette } }));
  },
  modifyRawThemeFontFamily: function modifyRawThemeFontFamily(muiTheme, fontFamily) {
     false ? (0, _warning2.default)(false, 'modifyRawThemeFontFamily is deprecated. please use getMuiTheme\n        to modify your theme directly. http://www.material-ui.com/#/customization/themes.\n        It will be removed with v0.16.0.') : void 0;
    return (0, _getMuiTheme3.default)((0, _merge2.default)({}, muiTheme.baseTheme, { fontFamily: fontFamily }));
  }
};

/***/ },
/* 374 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var MwsColors = __webpack_require__(189);
var styles_1 = __webpack_require__(242);
var colorManipulator_1 = __webpack_require__(330);
var spacing_1 = __webpack_require__(333);
exports.default = {
    spacing: spacing_1.default,
    fontFamily: '"Open Sans", sans-serif',
    palette: {
        primary1Color: styles_1.colors.blue500,
        primary2Color: MwsColors.mwsGrey600,
        primary3Color: MwsColors.mwsGrey400,
        accent1Color: styles_1.colors.blue500,
        accent2Color: styles_1.colors.blue200,
        accent3Color: styles_1.colors.blue100,
        textColor: MwsColors.mwsGrey900,
        alternateTextColor: MwsColors.mwsGrey50,
        canvasColor: styles_1.colors.white,
        borderColor: MwsColors.mwsGrey300,
        disabledColor: colorManipulator_1.fade(MwsColors.mwsGrey900, 0.3),
        iconPositiveColor: '#4896f3',
        iconNegativeColor: '#db2412'
    }
};


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsTransitionGroup = __webpack_require__(238);

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _dom = __webpack_require__(378);

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__(379);

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = _toArray(_ref);

  var newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  _inherits(TouchRipple, _Component);

  function TouchRipple(props, context) {
    _classCallCheck(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TouchRipple).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat(_toConsumableArray(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  _createClass(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat(_toConsumableArray(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var style = {};
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      style.height = rippleSize + 'px';
      style.width = rippleSize + 'px';
      style.top = top + 'px';
      style.left = left + 'px';

      return style;
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var style = _props.style;
      var _state = this.state;
      var hasRipples = _state.hasRipples;
      var ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden'
        }, style);

        rippleGroup = _react2.default.createElement(
          _reactAddonsTransitionGroup2.default,
          { style: prepareStyles(mergedStyles) },
          ripples
        );
      }

      return _react2.default.createElement(
        'div',
        {
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        },
        rippleGroup,
        children
      );
    }
  }]);

  return TouchRipple;
}(_react.Component);

TouchRipple.propTypes = {
  abortOnScroll: _react.PropTypes.bool,
  centerRipple: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  color: _react.PropTypes.string,
  opacity: _react.PropTypes.number,
  style: _react.PropTypes.object
};
TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = TouchRipple;

/***/ },
/* 377 */
/***/ function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


/***/ },
/* 378 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(381);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CircleRipple = function (_Component) {
  _inherits(CircleRipple, _Component);

  function CircleRipple() {
    _classCallCheck(this, CircleRipple);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CircleRipple).apply(this, arguments));
  }

  _createClass(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var aborted = _props.aborted;
      var color = _props.color;
      var opacity = _props.opacity;
      var style = _props.style;
      var touchGenerated = _props.touchGenerated;

      var other = _objectWithoutProperties(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);

      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', _extends({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);

  return CircleRipple;
}(_react.Component);

CircleRipple.propTypes = {
  aborted: _react.PropTypes.bool,
  color: _react.PropTypes.string,
  opacity: _react.PropTypes.number,
  style: _react.PropTypes.object,
  touchGenerated: _react.PropTypes.bool
};
CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CircleRipple;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _shallowEqual = __webpack_require__(143);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ },
/* 381 */
/***/ function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CircularProgress = __webpack_require__(383);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CircularProgress2.default;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _autoPrefix = __webpack_require__(381);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
  return relValue * 100;
}

function getStyles(props, context) {
  var max = props.max;
  var min = props.min;
  var size = props.size;
  var value = props.value;
  var palette = context.muiTheme.baseTheme.palette;

  var zoom = size * 1.4;
  var baseSize = 50;
  var margin = Math.round((50 * zoom - 50) / 2);

  if (margin < 0) margin = 0;

  var styles = {
    root: {
      position: 'relative',
      margin: margin,
      display: 'inline-block',
      width: baseSize,
      height: baseSize
    },
    wrapper: {
      width: baseSize,
      height: baseSize,
      display: 'inline-block',
      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
      transitionTimingFunction: 'linear'
    },
    svg: {
      height: baseSize,
      position: 'relative',
      transform: 'scale(' + zoom + ')',
      width: baseSize
    },
    path: {
      strokeDasharray: '89, 200',
      strokeDashoffset: 0,
      stroke: props.color || palette.primary1Color,
      strokeLinecap: 'round',
      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
    }
  };

  if (props.mode === 'determinate') {
    var relVal = getRelativeValue(value, min, max);
    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
    styles.path.strokeDasharray = Math.round(relVal * 1.25) + ', 200';
  }

  return styles;
}

var CircularProgress = function (_Component) {
  _inherits(CircularProgress, _Component);

  function CircularProgress() {
    _classCallCheck(this, CircularProgress);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CircularProgress).apply(this, arguments));
  }

  _createClass(CircularProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scalePath(this.refs.path);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
    }
  }, {
    key: 'scalePath',
    value: function scalePath(path, step) {
      var _this2 = this;

      if (this.props.mode !== 'indeterminate') return;

      step = step || 0;
      step %= 3;

      if (step === 0) {
        path.style.strokeDasharray = '1, 200';
        path.style.strokeDashoffset = 0;
        path.style.transitionDuration = '0ms';
      } else if (step === 1) {
        path.style.strokeDasharray = '89, 200';
        path.style.strokeDashoffset = -35;
        path.style.transitionDuration = '750ms';
      } else {
        path.style.strokeDasharray = '89, 200';
        path.style.strokeDashoffset = -124;
        path.style.transitionDuration = '850ms';
      }

      this.scalePathTimer = setTimeout(function () {
        return _this2.scalePath(path, step + 1);
      }, step ? 750 : 250);
    }
  }, {
    key: 'rotateWrapper',
    value: function rotateWrapper(wrapper) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');

      setTimeout(function () {
        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
      }, 50);

      this.rotateWrapperTimer = setTimeout(function () {
        return _this3.rotateWrapper(wrapper);
      }, 10050);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var style = _props.style;
      var innerStyle = _props.innerStyle;
      var size = _props.size;

      var other = _objectWithoutProperties(_props, ['style', 'innerStyle', 'size']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
          _react2.default.createElement(
            'svg',
            { style: prepareStyles(styles.svg) },
            _react2.default.createElement('circle', {
              ref: 'path',
              style: prepareStyles(styles.path),
              cx: '25',
              cy: '25',
              r: '20',
              fill: 'none',
              strokeWidth: '2.5',
              strokeMiterlimit: '20'
            })
          )
        )
      );
    }
  }]);

  return CircularProgress;
}(_react.Component);

CircularProgress.propTypes = {
  /**
   * Override the progress's color.
   */
  color: _react.PropTypes.string,
  /**
   * Style for inner wrapper div.
   */
  innerStyle: _react.PropTypes.object,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _react.PropTypes.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _react.PropTypes.number,
  /**
   * The mode of show your progress, indeterminate
   * for when there is no value for progress.
   */
  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
  /**
   * The size of the progress.
   */
  size: _react.PropTypes.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _react.PropTypes.number
};
CircularProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100,
  size: 1
};
CircularProgress.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CircularProgress;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var diyLightTheme = __webpack_require__(241);
var MenuItem_1 = __webpack_require__(385);
var Divider_1 = __webpack_require__(434);
var IconMenu_1 = __webpack_require__(436);
var IconButton_1 = __webpack_require__(420);
var styles_1 = __webpack_require__(242);
var autoprefixer_1 = __webpack_require__(438);
var more_vert_1 = __webpack_require__(439);
var OverlayMenu = (function (_super) {
    tslib_1.__extends(OverlayMenu, _super);
    function OverlayMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRequestChange = function (open, reason) {
            if (open) {
                // XXX prevent opening and immediate closing on touch devices
                // TODO fix this in material-ui and do a pull request
                // by sending the original event so we can fileter
                // here based on the event type
                setTimeout(function () {
                    _this.props.onToggleRequest(open);
                }, 50);
            }
            else {
                _this.props.onToggleRequest(open);
            }
        };
        _this.onMenuClick = function (e) {
            e.preventDefault();
            _this.props.onToggleRequest(true);
        };
        return _this;
    }
    OverlayMenu.prototype.getStyles = function () {
        return {
            menu: autoprefixer_1.autoprefixer({
                marginRight: this.props.overlayMenuConfig ? (this.props.overlayMenuConfig.rightOffset) : 0,
                float: 'right',
                height: 36,
                background: styles_1.colors.grey700,
                alignItems: 'center',
                display: 'flex',
                transform: 'translate3d(18px, 0, 0)',
                opacity: 0,
                transition: '',
                maxWidth: (this.props.menuLabelMaxWidth - 4)
            }),
            menuButton: {
                margin: -6,
            },
            menuLabelContainer: autoprefixer_1.autoprefixer({
                paddingLeft: 12,
                paddingRight: 12,
                borderRight: "1px solid rgba(255,255,255,0.3)",
                minWidth: 67,
                display: "flex",
                height: "100%",
                alignItems: "center",
            }),
            menuLabel: {
                color: 'white',
                fontFamily: diyLightTheme.rawTheme.fontFamily,
                fontSize: 12,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        };
    };
    OverlayMenu.prototype.render = function () {
        var styles = this.getStyles();
        var disabledColor = diyLightTheme.rawTheme.palette.disabledColor;
        return (React.createElement("div", { style: styles.menu, "data-test-id": "module-options-button", onTouchTap: this.onMenuClick },
            this.props.showMenuLabel
                ?
                    React.createElement("div", { style: styles.menuLabelContainer },
                        React.createElement("span", { style: styles.menuLabel }, this.props.menuText))
                :
                    null,
            React.createElement(IconMenu_1.default, { style: styles.menuButton, anchorOrigin: { vertical: "top", horizontal: "right" }, targetOrigin: { vertical: "top", horizontal: "right" }, onChange: this.onChange.bind(this), onRequestChange: this.onRequestChange, open: this.props.open, iconButtonElement: React.createElement(IconButton_1.default, null,
                    React.createElement(more_vert_1.default, { color: "white" })), useLayerForClickAway: true }, this.props.overlayMenuConfig ?
                this.props.overlayMenuConfig.menuItems.map(function (menuItem, index) {
                    if (menuItem.isDivider) {
                        return (React.createElement(Divider_1.default, { key: index }));
                    }
                    var LeftIcon = menuItem.leftIcon;
                    return (React.createElement(MenuItem_1.default, { "data-test-id": "module-menu-option-" + menuItem.name, key: index, value: "" + index, primaryText: menuItem.primaryText, leftIcon: menuItem.disabled ?
                            React.createElement(LeftIcon, { color: disabledColor, hoverColor: disabledColor })
                            :
                                React.createElement(LeftIcon, null), disabled: menuItem.disabled }));
                })
                :
                    null)));
    };
    OverlayMenu.prototype.componentDidAppear = function () {
        var rootEl = ReactDOM.findDOMNode(this);
        this.transitionTimeout = setTimeout(function () {
            rootEl.style.opacity = "1";
            rootEl.style.transition = "all cubic-bezier(0.62, 0.28, 0.23, 0.99) 0.2s 0.2s";
            rootEl.style.transform = 'translate3d(0, 0, 0)';
        }, 0);
    };
    OverlayMenu.prototype.componentWillUnmount = function () {
        clearTimeout(this.transitionTimeout);
    };
    OverlayMenu.prototype.onChange = function (event, value) {
        var menuItemConfig = this.props.overlayMenuConfig.menuItems[Number(value)];
        menuItemConfig.onSelect.call(this, event.nativeEvent);
    };
    return OverlayMenu;
}(React.Component));
exports.default = OverlayMenu;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MenuItem = __webpack_require__(386);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItem2.default;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Popover = __webpack_require__(387);

var _Popover2 = _interopRequireDefault(_Popover);

var _check = __webpack_require__(399);

var _check2 = _interopRequireDefault(_check);

var _ListItem = __webpack_require__(409);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Menu = __webpack_require__(431);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nestedMenuStyle = {
  position: 'relative'
};

function getStyles(props, context) {
  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
  var textColor = context.muiTheme.baseTheme.palette.textColor;
  var leftIndent = props.desktop ? 64 : 72;
  var sidePadding = props.desktop ? 24 : 16;

  var styles = {
    root: {
      color: props.disabled ? disabledColor : textColor,
      cursor: props.disabled ? 'not-allowed' : 'inherit',
      lineHeight: props.desktop ? '32px' : '48px',
      fontSize: props.desktop ? 15 : 16,
      whiteSpace: 'nowrap'
    },

    innerDivStyle: {
      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? leftIndent : sidePadding,
      paddingRight: sidePadding,
      paddingBottom: 0,
      paddingTop: 0
    },

    secondaryText: {
      float: 'right'
    },

    leftIconDesktop: {
      margin: 0,
      left: 24,
      top: 4
    },

    rightIconDesktop: {
      margin: 0,
      right: 24,
      top: 4,
      fill: context.muiTheme.menuItem.rightIconDesktopFill
    }
  };

  return styles;
}

var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(MenuItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.cloneMenuItem = function (item) {
      return _react2.default.cloneElement(item, {
        onTouchTap: function onTouchTap(event) {
          if (!item.props.menuItems) {
            _this.handleRequestClose();
          }

          if (item.props.onTouchTap) {
            item.props.onTouchTap(event);
          }
        },
        onRequestClose: _this.handleRequestClose
      });
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();

      _this.setState({
        open: true,
        anchorEl: _reactDom2.default.findDOMNode(_this)
      });

      if (_this.props.onTouchTap) {
        _this.props.onTouchTap(event);
      }
    }, _this.handleRequestClose = function () {
      _this.setState({
        open: false,
        anchorEl: null
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.open && nextProps.focusState === 'none') {
        this.handleRequestClose();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'applyFocusState',
    value: function applyFocusState() {
      this.refs.listItem.applyFocusState(this.props.focusState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var checked = _props.checked;
      var children = _props.children;
      var desktop = _props.desktop;
      var disabled = _props.disabled;
      var focusState = _props.focusState;
      var innerDivStyle = _props.innerDivStyle;
      var insetChildren = _props.insetChildren;
      var leftIcon = _props.leftIcon;
      var menuItems = _props.menuItems;
      var rightIcon = _props.rightIcon;
      var secondaryText = _props.secondaryText;
      var style = _props.style;
      var value = _props.value;

      var other = _objectWithoutProperties(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'value']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);

      // Left Icon
      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
      if (leftIconElement) {
        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
      }

      // Right Icon
      var rightIconElement = void 0;
      if (rightIcon) {
        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
      }

      // Secondary Text
      var secondaryTextElement = void 0;
      if (secondaryText) {
        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;

        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.secondaryText) },
          secondaryText
        );
      }
      var childMenuPopover = void 0;
      if (menuItems) {
        childMenuPopover = _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: { horizontal: 'right', vertical: 'top' },
            anchorEl: this.state.anchorEl,
            open: this.state.open,
            useLayerForClickAway: false,
            onRequestClose: this.handleRequestClose
          },
          _react2.default.createElement(
            _Menu2.default,
            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
            _react2.default.Children.map(menuItems, this.cloneMenuItem)
          )
        );
        other.onTouchTap = this.handleTouchTap;
      }

      return _react2.default.createElement(
        _ListItem2.default,
        _extends({}, other, {
          disabled: disabled,
          innerDivStyle: mergedInnerDivStyles,
          insetChildren: insetChildren,
          leftIcon: leftIconElement,
          ref: 'listItem',
          rightIcon: rightIconElement,
          style: mergedRootStyles
        }),
        children,
        secondaryTextElement,
        childMenuPopover
      );
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.muiName = 'MenuItem';
MenuItem.propTypes = {
  /**
   * If true, a left check mark will be rendered.
   */
  checked: _react.PropTypes.bool,
  /**
   * Elements passed as children to the underlying `ListItem`.
   */
  children: _react.PropTypes.node,
  /**
   * @ignore
   * If true, the menu item will render with compact desktop
   * styles.
   */
  desktop: _react.PropTypes.bool,
  /**
   * If true, the menu item will be disabled.
   */
  disabled: _react.PropTypes.bool,
  /**
   * The focus state of the menu item. This prop is used to set the focus
   * state of the underlying `ListItem`.
   */
  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
  /**
   * Override the inline-styles of the inner div.
   */
  innerDivStyle: _react.PropTypes.object,
  /**
   * If true, the children will be indented.
   * This is only needed when there is no `leftIcon`.
   */
  insetChildren: _react.PropTypes.bool,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _react.PropTypes.element,
  /**
   * `MenuItem` elements to nest within the menu item.
   */
  menuItems: _react.PropTypes.node,
  /**
   * Callback function fired when the menu item is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the menu item.
   */
  onTouchTap: _react.PropTypes.func,
  /**
   * Can be used to render primary text within the menu item.
   */
  primaryText: _react.PropTypes.node,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _react.PropTypes.element,
  /**
   * Can be used to render secondary text within the menu item.
   */
  secondaryText: _react.PropTypes.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The value of the menu item.
   */
  value: _react.PropTypes.any
};
MenuItem.defaultProps = {
  checked: false,
  desktop: false,
  disabled: false,
  focusState: 'none',
  insetChildren: false
};
MenuItem.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = MenuItem;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(388);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _RenderToLayer = __webpack_require__(389);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

var _throttle = __webpack_require__(393);

var _throttle2 = _interopRequireDefault(_throttle);

var _PopoverAnimationDefault = __webpack_require__(398);

var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover(props, context) {
    _classCallCheck(this, Popover);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Popover).call(this, props, context));

    _this.renderLayer = function () {
      var _this$props = _this.props;
      var animated = _this$props.animated;
      var animation = _this$props.animation;
      var children = _this$props.children;
      var style = _this$props.style;

      var other = _objectWithoutProperties(_this$props, ['animated', 'animation', 'children', 'style']);

      var Animation = animation || _PopoverAnimationDefault2.default;
      var styleRoot = style;

      if (!Animation) {
        Animation = _Paper2.default;
        styleRoot = {
          position: 'fixed'
        };
        if (!_this.state.open) {
          return null;
        }
      }

      return _react2.default.createElement(
        Animation,
        _extends({}, other, { style: styleRoot, open: _this.state.open && !_this.state.closing }),
        children
      );
    };

    _this.componentClickAway = function () {
      _this.requestClose('clickAway');
    };

    _this.setPlacement = function (scrolling) {
      if (!_this.state.open) {
        return;
      }

      var anchorEl = _this.props.anchorEl || _this.anchorEl;

      if (!_this.refs.layer.getLayer()) {
        return;
      }

      var targetEl = _this.refs.layer.getLayer().children[0];
      if (!targetEl) {
        return;
      }

      var _this$props2 = _this.props;
      var targetOrigin = _this$props2.targetOrigin;
      var anchorOrigin = _this$props2.anchorOrigin;


      var anchor = _this.getAnchorPosition(anchorEl);
      var target = _this.getTargetPosition(targetEl);

      var targetPosition = {
        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
      };

      if (scrolling && _this.props.autoCloseWhenOffScreen) {
        _this.autoCloseWhenOffScreen(anchor);
      }

      if (_this.props.canAutoPosition) {
        target = _this.getTargetPosition(targetEl); // update as height may have changed
        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
      }

      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
      targetEl.style.maxHeight = window.innerHeight + 'px';
    };

    _this.handleResize = (0, _throttle2.default)(_this.setPlacement, 100);
    _this.handleScroll = (0, _throttle2.default)(_this.setPlacement.bind(_this, true), 50);

    _this.state = {
      open: props.open,
      closing: false
    };
    return _this;
  }

  _createClass(Popover, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open !== this.state.open) {
        if (nextProps.open) {
          this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
          this.setState({
            open: true,
            closing: false
          });
        } else {
          if (nextProps.animated) {
            this.setState({ closing: true });
            this.timeout = setTimeout(function () {
              _this2.setState({
                open: false
              });
            }, 500);
          } else {
            this.setState({
              open: false
            });
          }
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setPlacement();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'requestClose',
    value: function requestClose(reason) {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(reason);
      }
    }
  }, {
    key: '_resizeAutoPosition',
    value: function _resizeAutoPosition() {
      this.setPlacement();
    }
  }, {
    key: 'getAnchorPosition',
    value: function getAnchorPosition(el) {
      if (!el) {
        el = _reactDom2.default.findDOMNode(this);
      }

      var rect = el.getBoundingClientRect();
      var a = {
        top: rect.top,
        left: rect.left,
        width: el.offsetWidth,
        height: el.offsetHeight
      };

      a.right = rect.right || a.left + a.width;
      a.bottom = rect.bottom || a.top + a.height;
      a.middle = a.left + (a.right - a.left) / 2;
      a.center = a.top + (a.bottom - a.top) / 2;

      return a;
    }
  }, {
    key: 'getTargetPosition',
    value: function getTargetPosition(targetEl) {
      return {
        top: 0,
        center: targetEl.offsetHeight / 2,
        bottom: targetEl.offsetHeight,
        left: 0,
        middle: targetEl.offsetWidth / 2,
        right: targetEl.offsetWidth
      };
    }
  }, {
    key: 'autoCloseWhenOffScreen',
    value: function autoCloseWhenOffScreen(anchorPosition) {
      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
        this.requestClose('offScreen');
      }
    }
  }, {
    key: 'getOverlapMode',
    value: function getOverlapMode(anchor, target, median) {
      if ([anchor, target].indexOf(median) >= 0) return 'auto';
      if (anchor === target) return 'inclusive';
      return 'exclusive';
    }
  }, {
    key: 'getPositions',
    value: function getPositions(anchor, target) {
      var a = _extends({}, anchor);
      var t = _extends({}, target);

      var positions = {
        x: ['left', 'right'].filter(function (p) {
          return p !== t.horizontal;
        }),
        y: ['top', 'bottom'].filter(function (p) {
          return p !== t.vertical;
        })
      };

      var overlap = {
        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
      };

      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

      if (overlap.y !== 'auto') {
        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
        if (overlap.y === 'inclusive') {
          t.vertical = t.vertical;
        }
      }

      if (overlap.x !== 'auto') {
        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
        if (overlap.y === 'inclusive') {
          t.horizontal = t.horizontal;
        }
      }

      return {
        positions: positions,
        anchorPos: a
      };
    }
  }, {
    key: 'applyAutoPositionIfNeeded',
    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
      var _getPositions = this.getPositions(anchorOrigin, targetOrigin);

      var positions = _getPositions.positions;
      var anchorPos = _getPositions.anchorPos;


      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
        if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);else {
          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
          if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);
        }
      }
      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);
        }
      }
      return targetPosition;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: 'none' } },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onScroll: this.handleScroll,
          onResize: this.handleResize
        }),
        _react2.default.createElement(_RenderToLayer2.default, {
          ref: 'layer',
          open: this.state.open,
          componentClickAway: this.componentClickAway,
          useLayerForClickAway: this.props.useLayerForClickAway,
          render: this.renderLayer
        })
      );
    }
  }]);

  return Popover;
}(_react.Component);

Popover.propTypes = {
  /**
   * This is the DOM element that will be used to set the position of the
   * popover.
   */
  anchorEl: _react.PropTypes.object,
  /**
   * This is the point on the anchor where the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, middle, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes2.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it is added to the DOM.
   */
  animated: _react.PropTypes.bool,
  /**
   * Override the default animation component used.
   */
  animation: _react.PropTypes.func,
  /**
   * If true, the popover will hide when the anchor is scrolled off the screen.
   */
  autoCloseWhenOffScreen: _react.PropTypes.bool,
  /**
   * If true, the popover (potentially) ignores `targetOrigin`
   * and `anchorOrigin` to make itself fit on screen,
   * which is useful for mobile devices.
   */
  canAutoPosition: _react.PropTypes.bool,
  /**
   * The content of the popover.
   */
  children: _react.PropTypes.node,
  /**
   * The CSS class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {string} reason The reason for the close request. Possibles values
   * are 'clickAway' and 'offScreen'.
   */
  onRequestClose: _react.PropTypes.func,
  /**
   * If true, the popover is visible.
   */
  open: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, middle, bottom];
   * horizontal: [left, center, right].
   */
  targetOrigin: _propTypes2.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying
   * elements, and trigger an `onRequestClose('clickAway')` call.
   */
  useLayerForClickAway: _react.PropTypes.bool,
  /**
   * The zDepth of the popover.
   */
  zDepth: _propTypes2.default.zDepth
};
Popover.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  animated: true,
  autoCloseWhenOffScreen: true,
  canAutoPosition: true,
  onRequestClose: function onRequestClose() {},
  open: false,
  style: {
    overflowY: 'auto'
  },
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  useLayerForClickAway: true,
  zDepth: 1
};
Popover.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Popover;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _shallowEqual = __webpack_require__(143);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function on(target, eventName, callback, capture) {
  if (target.addEventListener) {
    target.addEventListener(eventName, callback, capture);
  } else if (target.attachEvent) {
    // IE8+ Support
    target.attachEvent('on' + eventName, function () {
      callback.call(target);
    });
  }
}
function off(target, eventName, callback, capture) {
  if (target.removeEventListener) {
    target.removeEventListener(eventName, callback, capture);
  } else if (target.detachEvent) {
    // IE8+ Support
    target.detachEvent('on' + eventName, callback);
  }
}

function forEachListener(props, iteratee) {
  for (var name in props) {
    if (name.substring(0, 2) === 'on' && props[name] instanceof Function) {
      var _eventName = name.substring(2).toLowerCase();
      iteratee(_eventName, props[name]);
    }
  }
}

var EventListener = function (_Component) {
  _inherits(EventListener, _Component);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _this2 = this;

      var _props = this.props;
      var capture = _props.capture;
      var target = _props.target;


      if (target) {
        (function () {
          var element = target;

          if (typeof target === 'string') {
            element = window[target];
          }

          forEachListener(_this2.props, function (eventName, listener) {
            return on(element, eventName, listener, capture);
          });
        })();
      }
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      var _this3 = this;

      var _props2 = this.props;
      var capture = _props2.capture;
      var target = _props2.target;


      if (target) {
        (function () {
          var element = target;

          if (typeof target === 'string') {
            element = window[target];
          }

          forEachListener(_this3.props, function (eventName, listener) {
            return off(element, eventName, listener, capture);
          });
        })();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(_react.Component);

EventListener.propTypes = {
  /**
   * Whether to use capturing listeners.
   */
  capture: _react.PropTypes.bool.isRequired,
  /**
   * You can provide a children too.
   */
  children: _react.PropTypes.node,
  /**
   * The DOM target to listen to.
   */
  target: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string])
};
EventListener.defaultProps = {
  capture: false
};
exports.default = EventListener;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _dom = __webpack_require__(378);

var _dom2 = _interopRequireDefault(_dom);

var _MuiThemeProvider = __webpack_require__(243);

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx

var RenderToLayer = function (_Component) {
  _inherits(RenderToLayer, _Component);

  function RenderToLayer() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, RenderToLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RenderToLayer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.onClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      if (!_this.props.componentClickAway) {
        return;
      }

      if (!_this.props.open) {
        return;
      }

      var el = _this.layer;
      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
        _this.props.componentClickAway(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RenderToLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unrenderLayer();
    }
  }, {
    key: 'getLayer',
    value: function getLayer() {
      return this.layer;
    }
  }, {
    key: 'unrenderLayer',
    value: function unrenderLayer() {
      if (!this.layer) {
        return;
      }

      if (this.props.useLayerForClickAway) {
        this.layer.style.position = 'relative';
        this.layer.removeEventListener('touchstart', this.onClickAway);
        this.layer.removeEventListener('click', this.onClickAway);
      } else {
        window.removeEventListener('touchstart', this.onClickAway);
        window.removeEventListener('click', this.onClickAway);
      }

      (0, _reactDom.unmountComponentAtNode)(this.layer);
      document.body.removeChild(this.layer);
      this.layer = null;
    }

    /**
     * By calling this method in componentDidMount() and
     * componentDidUpdate(), you're effectively creating a "wormhole" that
     * funnels React's hierarchical updates through to a DOM node on an
     * entirely different part of the page.
     */

  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      var _this2 = this;

      var _props = this.props;
      var open = _props.open;
      var render = _props.render;


      if (open) {
        if (!this.layer) {
          this.layer = document.createElement('div');
          document.body.appendChild(this.layer);

          if (this.props.useLayerForClickAway) {
            this.layer.addEventListener('touchstart', this.onClickAway);
            this.layer.addEventListener('click', this.onClickAway);
            this.layer.style.position = 'fixed';
            this.layer.style.top = 0;
            this.layer.style.bottom = 0;
            this.layer.style.left = 0;
            this.layer.style.right = 0;
            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
          } else {
            setTimeout(function () {
              window.addEventListener('touchstart', _this2.onClickAway);
              window.addEventListener('click', _this2.onClickAway);
            }, 0);
          }
        }

        /**
         * We use the <MuiThemeProvider /> component as a work around for
         * https://github.com/facebook/react/issues/6599.
         */
        var layerElement = _react2.default.createElement(
          _MuiThemeProvider2.default,
          { muiTheme: this.context.muiTheme },
          render()
        );
        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
      } else {
        this.unrenderLayer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return RenderToLayer;
}(_react.Component);

RenderToLayer.propTypes = {
  componentClickAway: _react.PropTypes.func,
  open: _react.PropTypes.bool.isRequired,
  render: _react.PropTypes.func.isRequired,
  useLayerForClickAway: _react.PropTypes.bool
};
RenderToLayer.defaultProps = {
  useLayerForClickAway: true
};
RenderToLayer.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = RenderToLayer;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);

exports.default = {

  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),

  horizontal: horizontal,

  vertical: vertical,

  origin: _react.PropTypes.shape({
    horizontal: horizontal,
    vertical: vertical
  }),

  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),

  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),

  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])

};

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Paper = __webpack_require__(392);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paper2.default;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var rounded = props.rounded;
  var circle = props.circle;
  var transitionEnabled = props.transitionEnabled;
  var zDepth = props.zDepth;
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var paper = _context$muiTheme.paper;


  return {
    root: {
      color: paper.color,
      backgroundColor: paper.backgroundColor,
      transition: transitionEnabled && _transitions2.default.easeOut(),
      boxSizing: 'border-box',
      fontFamily: baseTheme.fontFamily,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
    }
  };
}

var Paper = function (_Component) {
  _inherits(Paper, _Component);

  function Paper() {
    _classCallCheck(this, Paper);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Paper).apply(this, arguments));
  }

  _createClass(Paper, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var circle = _props.circle;
      var rounded = _props.rounded;
      var style = _props.style;
      var transitionEnabled = _props.transitionEnabled;
      var zDepth = _props.zDepth;

      var other = _objectWithoutProperties(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);

  return Paper;
}(_react.Component);

Paper.propTypes = {
  /**
   * Children passed into the paper element.
   */
  children: _react.PropTypes.node,
  /**
   * Set to true to generate a circlular paper container.
   */
  circle: _react.PropTypes.bool,
  /**
   * By default, the paper container will have a border radius.
   * Set this to false to generate a container with sharp corners.
   */
  rounded: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Set to false to disable CSS transitions for the paper element.
   */
  transitionEnabled: _react.PropTypes.bool,
  /**
   * This number represents the zDepth of the paper shadow.
   */
  zDepth: _propTypes2.default.zDepth
};
Paper.defaultProps = {
  circle: false,
  rounded: true,
  transitionEnabled: true,
  zDepth: 1
};
Paper.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Paper;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(394),
    isObject = __webpack_require__(265);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(265),
    now = __webpack_require__(395),
    toNumber = __webpack_require__(396);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

var root = __webpack_require__(204);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(265),
    isSymbol = __webpack_require__(397);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(202),
    isObjectLike = __webpack_require__(210);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');

  return {
    root: {
      opacity: open ? 1 : 0,
      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
      maxHeight: '100%'
    },
    horizontal: {
      maxHeight: '100%',
      overflowY: 'auto',
      transform: open ? 'scaleX(1)' : 'scaleX(0)',
      opacity: open ? 1 : 0,
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
    },
    vertical: {
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
    }
  };
}

var PopoverDefaultAnimation = function (_Component) {
  _inherits(PopoverDefaultAnimation, _Component);

  function PopoverDefaultAnimation() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, PopoverDefaultAnimation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PopoverDefaultAnimation)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopoverDefaultAnimation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var className = _props.className;
      var style = _props.style;
      var zDepth = _props.zDepth;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.horizontal) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.vertical) },
            this.props.children
          )
        )
      );
    }
  }]);

  return PopoverDefaultAnimation;
}(_react.Component);

PopoverDefaultAnimation.propTypes = {
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  open: _react.PropTypes.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  targetOrigin: _propTypes2.default.origin,
  zDepth: _propTypes2.default.zDepth
};
PopoverDefaultAnimation.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverDefaultAnimation.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = PopoverDefaultAnimation;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCheck = function NavigationCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
  );
};
NavigationCheck = (0, _pure2.default)(NavigationCheck);
NavigationCheck.displayName = 'NavigationCheck';
NavigationCheck.muiName = 'SvgIcon';

exports.default = NavigationCheck;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _shouldUpdate = __webpack_require__(401);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _createHelper = __webpack_require__(402);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
  return !(0, _shallowEqual2.default)(props, nextProps);
});

exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _react = __webpack_require__(28);

var _createHelper = __webpack_require__(402);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(403);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _class.prototype.render = function render() {
        return factory(this.props);
      };

      return _class;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;
var createHelper = function createHelper(func, helperName) {
  var setDisplayName = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
  var noArgs = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

  if (false) {
    var _ret = function () {
      /* eslint-disable global-require */
      var wrapDisplayName = require('./wrapDisplayName').default;
      /* eslint-enable global-require */

      if (noArgs) {
        return {
          v: function v(BaseComponent) {
            var Component = func(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          }
        };
      }

      return {
        v: function v() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (args.length > func.length) {
            /* eslint-disable */
            console.error(
            /* eslint-enable */
            'Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
          }

          return function (BaseComponent) {
            var Component = func.apply(undefined, args)(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          };
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  return func;
};

exports.default = createHelper;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(404);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(405);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

exports.__esModule = true;

var _isClassComponent = __webpack_require__(406);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && !Component.propTypes);
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 406 */
/***/ function(module, exports) {

'use strict';

exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = __webpack_require__(408);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SvgIcon = function (_Component) {
  _inherits(SvgIcon, _Component);

  function SvgIcon() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, SvgIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SvgIcon)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseEnter = function (event) {
      _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var color = _props.color;
      var hoverColor = _props.hoverColor;
      var onMouseEnter = _props.onMouseEnter;
      var onMouseLeave = _props.onMouseLeave;
      var style = _props.style;
      var viewBox = _props.viewBox;

      var other = _objectWithoutProperties(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);

      var _context$muiTheme = this.context.muiTheme;
      var svgIcon = _context$muiTheme.svgIcon;
      var prepareStyles = _context$muiTheme.prepareStyles;


      var offColor = color ? color : 'currentColor';
      var onColor = hoverColor ? hoverColor : offColor;

      var mergedStyles = (0, _simpleAssign2.default)({
        display: 'inline-block',
        color: svgIcon.color,
        fill: this.state.hovered ? onColor : offColor,
        height: 24,
        width: 24,
        userSelect: 'none',
        transition: _transitions2.default.easeOut()
      }, style);

      return _react2.default.createElement(
        'svg',
        _extends({}, other, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          style: prepareStyles(mergedStyles),
          viewBox: viewBox
        }),
        children
      );
    }
  }]);

  return SvgIcon;
}(_react.Component);

SvgIcon.muiName = 'SvgIcon';
SvgIcon.propTypes = {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _react.PropTypes.node,
  /**
   * This is the fill color of the svg icon.
   * If not specified, this component will default
   * to muiTheme.palette.textColor.
   */
  color: _react.PropTypes.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _react.PropTypes.string,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Allows you to redefine what the coordinates
   * without units mean inside an svg element. For example,
   * if the SVG element is 500 (width) by 200 (height), and you
   * pass viewBox="0 0 50 20", this means that the coordinates inside
   * the svg will go from the top left corner (0,0) to bottom right (50,20)
   * and each unit will be worth 10px.
   */
  viewBox: _react.PropTypes.string
};
SvgIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  viewBox: '0 0 24 24'
};
SvgIcon.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = SvgIcon;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _colorManipulator = __webpack_require__(330);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedButton = __webpack_require__(410);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _IconButton = __webpack_require__(420);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _expandLess = __webpack_require__(425);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _expandMore = __webpack_require__(426);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _NestedList = __webpack_require__(427);

var _NestedList2 = _interopRequireDefault(_NestedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context, state) {
  var insetChildren = props.insetChildren;
  var leftAvatar = props.leftAvatar;
  var leftCheckbox = props.leftCheckbox;
  var leftIcon = props.leftIcon;
  var nestedLevel = props.nestedLevel;
  var rightAvatar = props.rightAvatar;
  var rightIcon = props.rightIcon;
  var rightIconButton = props.rightIconButton;
  var rightToggle = props.rightToggle;
  var secondaryText = props.secondaryText;
  var secondaryTextLines = props.secondaryTextLines;
  var muiTheme = context.muiTheme;
  var listItem = muiTheme.listItem;


  var textColor = muiTheme.baseTheme.palette.textColor;
  var hoverColor = (0, _colorManipulator.fade)(textColor, 0.1);
  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
  var twoLine = secondaryText && secondaryTextLines === 1;
  var threeLine = secondaryText && secondaryTextLines > 1;

  var styles = {
    root: {
      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
      color: textColor,
      display: 'block',
      fontSize: 16,
      lineHeight: '16px',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },

    // This inner div is needed so that ripples will span the entire container
    innerDiv: {
      marginLeft: nestedLevel * listItem.nestedLevelDepth,
      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
      paddingBottom: singleAvatar ? 20 : 16,
      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
      position: 'relative'
    },

    icons: {
      height: 24,
      width: 24,
      display: 'block',
      position: 'absolute',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      margin: 12
    },

    leftIcon: {
      left: 4
    },

    rightIcon: {
      right: 4
    },

    avatars: {
      position: 'absolute',
      top: singleAvatar ? 8 : 16
    },

    label: {
      cursor: 'pointer'
    },

    leftAvatar: {
      left: 16
    },

    rightAvatar: {
      right: 16
    },

    leftCheckbox: {
      position: 'absolute',
      display: 'block',
      width: 24,
      top: twoLine ? 24 : singleAvatar ? 16 : 12,
      left: 16
    },

    primaryText: {},

    rightIconButton: {
      position: 'absolute',
      display: 'block',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      right: 4
    },

    rightToggle: {
      position: 'absolute',
      display: 'block',
      width: 54,
      top: twoLine ? 25 : singleAvatar ? 17 : 13,
      right: 8
    },

    secondaryText: {
      fontSize: 14,
      lineHeight: threeLine ? '18px' : '16px',
      height: threeLine ? 36 : 16,
      margin: 0,
      marginTop: 4,
      color: listItem.secondaryTextColor,

      // needed for 2 and 3 line ellipsis
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: threeLine ? null : 'nowrap',
      display: threeLine ? '-webkit-box' : null,
      WebkitLineClamp: threeLine ? 2 : null,
      WebkitBoxOrient: threeLine ? 'vertical' : null
    }
  };

  return styles;
}

var ListItem = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ListItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      open: false,
      rightIconButtonHovered: false,
      rightIconButtonKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleNestedListToggle = function (event) {
      event.stopPropagation();
      _this.setState({ open: !_this.state.open });
      _this.props.onNestedListToggle(_this);
    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
      if (isKeyboardFocused) {
        _this.setState({
          isKeyboardFocused: false,
          rightIconButtonKeyboardFocused: isKeyboardFocused
        });
      }

      var iconButton = _this.props.rightIconButton;

      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleRightIconButtonMouseLeave = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: false });
      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
    }, _this.handleRightIconButtonMouseEnter = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: true });
      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
    }, _this.handleRightIconButtonMouseUp = function (event) {
      var iconButton = _this.props.rightIconButton;
      event.stopPropagation();
      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
    }, _this.handleRightIconButtonTouchTap = function (event) {
      var iconButton = _this.props.rightIconButton;

      // Stop the event from bubbling up to the list-item
      event.stopPropagation();
      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.initiallyOpen) {
        this.setState({ open: true });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }

    // This method is needed by the `MenuItem` component.

  }, {
    key: 'applyFocusState',
    value: function applyFocusState(focusState) {
      var button = this.refs.enhancedButton;

      if (button) {
        var buttonEl = _reactDom2.default.findDOMNode(button);

        switch (focusState) {
          case 'none':
            buttonEl.blur();
            break;
          case 'focused':
            buttonEl.focus();
            break;
          case 'keyboard-focused':
            button.setKeyboardFocus();
            buttonEl.focus();
            break;
        }
      }
    }
  }, {
    key: 'createDisabledElement',
    value: function createDisabledElement(styles, contentChildren, additionalProps) {
      var _props = this.props;
      var innerDivStyle = _props.innerDivStyle;
      var style = _props.style;


      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);

      return _react2.default.createElement(
        'div',
        _extends({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createLabelElement',
    value: function createLabelElement(styles, contentChildren, additionalProps) {
      var _props2 = this.props;
      var innerDivStyle = _props2.innerDivStyle;
      var style = _props2.style;


      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);

      return _react2.default.createElement(
        'label',
        _extends({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createTextElement',
    value: function createTextElement(styles, data, key) {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      if (_react2.default.isValidElement(data)) {
        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
        if (typeof data.type === 'string') {
          // if element is a native dom node
          style = prepareStyles(style);
        }
        return _react2.default.cloneElement(data, {
          key: key,
          style: style
        });
      }

      return _react2.default.createElement(
        'div',
        { key: key, style: prepareStyles(styles) },
        data
      );
    }
  }, {
    key: 'pushElement',
    value: function pushElement(children, element, baseStyles, additionalProps) {
      if (element) {
        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
        children.push(_react2.default.cloneElement(element, _extends({
          key: children.length,
          style: styles
        }, additionalProps)));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator;
      var children = _props3.children;
      var disabled = _props3.disabled;
      var disableKeyboardFocus = _props3.disableKeyboardFocus;
      var initiallyOpen = _props3.initiallyOpen;
      var innerDivStyle = _props3.innerDivStyle;
      var insetChildren = _props3.insetChildren;
      var leftAvatar = _props3.leftAvatar;
      var leftCheckbox = _props3.leftCheckbox;
      var leftIcon = _props3.leftIcon;
      var nestedItems = _props3.nestedItems;
      var nestedLevel = _props3.nestedLevel;
      var nestedListStyle = _props3.nestedListStyle;
      var onKeyboardFocus = _props3.onKeyboardFocus;
      var onMouseEnter = _props3.onMouseEnter;
      var onMouseLeave = _props3.onMouseLeave;
      var onNestedListToggle = _props3.onNestedListToggle;
      var onTouchStart = _props3.onTouchStart;
      var onTouchTap = _props3.onTouchTap;
      var rightAvatar = _props3.rightAvatar;
      var rightIcon = _props3.rightIcon;
      var rightIconButton = _props3.rightIconButton;
      var rightToggle = _props3.rightToggle;
      var primaryText = _props3.primaryText;
      var primaryTogglesNestedList = _props3.primaryTogglesNestedList;
      var secondaryText = _props3.secondaryText;
      var secondaryTextLines = _props3.secondaryTextLines;
      var style = _props3.style;

      var other = _objectWithoutProperties(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var contentChildren = [children];

      if (leftIcon) {
        var additionalProps = {
          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
        };
        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
      }

      if (rightIcon) {
        var _additionalProps = {
          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
        };
        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
      }

      if (leftAvatar) {
        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
      }

      if (rightAvatar) {
        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
      }

      if (leftCheckbox) {
        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
      }

      // RightIconButtonElement
      var hasNestListItems = nestedItems.length;
      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;

      if (rightIconButton || needsNestedIndicator) {
        var rightIconButtonElement = rightIconButton;
        var rightIconButtonHandlers = {
          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
          onMouseEnter: this.handleRightIconButtonMouseEnter,
          onMouseLeave: this.handleRightIconButtonMouseLeave,
          onTouchTap: this.handleRightIconButtonTouchTap,
          onMouseDown: this.handleRightIconButtonMouseUp,
          onMouseUp: this.handleRightIconButtonMouseUp
        };

        // Create a nested list indicator icon if we don't have an icon on the right
        if (needsNestedIndicator) {
          rightIconButtonElement = this.state.open ? _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandLess2.default, null)
          ) : _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandMore2.default, null)
          );
          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
        }

        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
      }

      if (rightToggle) {
        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
      }

      if (primaryText) {
        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
        contentChildren.push(primaryTextElement);
      }

      if (secondaryText) {
        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
        contentChildren.push(secondaryTextElement);
      }

      var nestedList = nestedItems.length ? _react2.default.createElement(
        _NestedList2.default,
        { nestedLevel: nestedLevel + 1, open: this.state.open, style: nestedListStyle },
        nestedItems
      ) : undefined;

      var hasCheckbox = leftCheckbox || rightToggle;

      return _react2.default.createElement(
        'div',
        null,
        hasCheckbox ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
          _EnhancedButton2.default,
          _extends({
            containerElement: 'span'
          }, other, {
            disabled: disabled,
            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
            onKeyboardFocus: this.handleKeyboardFocus,
            onMouseLeave: this.handleMouseLeave,
            onMouseEnter: this.handleMouseEnter,
            onTouchStart: this.handleTouchStart,
            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
            ref: 'enhancedButton',
            style: (0, _simpleAssign2.default)({}, styles.root, style)
          }),
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
            contentChildren
          )
        ),
        nestedList
      );
    }
  }]);

  return ListItem;
}(_react.Component);

ListItem.muiName = 'ListItem';
ListItem.propTypes = {
  /**
   * If true, generate a nested-list-indicator icon when nested list
   * items are detected. Note that an indicator will not be created
   * if a `rightIcon` or `rightIconButton` has been provided to
   * the element.
   */
  autoGenerateNestedIndicator: _react.PropTypes.bool,
  /**
   * Children passed into the `ListItem`.
   */
  children: _react.PropTypes.node,
  /**
   * If true, the element will not be able to be focused by the keyboard.
   */
  disableKeyboardFocus: _react.PropTypes.bool,
  /**
   * If true, the element will not be clickable
   * and will not display hover effects.
   * This is automatically disabled if either `leftCheckbox`
   * or `rightToggle` is set.
   */
  disabled: _react.PropTypes.bool,
  /**
   * If true, the nested `ListItem`s are initially displayed.
   */
  initiallyOpen: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the inner div element.
   */
  innerDivStyle: _react.PropTypes.object,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  insetChildren: _react.PropTypes.bool,
  /**
   * This is the `Avatar` element to be displayed on the left side.
   */
  leftAvatar: _react.PropTypes.element,
  /**
   * This is the `Checkbox` element to be displayed on the left side.
   */
  leftCheckbox: _react.PropTypes.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _react.PropTypes.element,
  /**
   * An array of `ListItem`s to nest underneath the current `ListItem`.
   */
  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
  /**
   * Controls how deep a `ListItem` appears.
   * This property is automatically managed, so modify at your own risk.
   */
  nestedLevel: _react.PropTypes.number,
  /**
   * Override the inline-styles of the nested items' `NestedList`.
   */
  nestedListStyle: _react.PropTypes.object,
  /**
   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
   */
  onKeyboardFocus: _react.PropTypes.func,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /**
   * Callbak function fired when the `ListItem` toggles its nested list.
   *
   * @param {object} listItem The `ListItem`.
   */
  onNestedListToggle: _react.PropTypes.func,
  /** @ignore */
  onTouchStart: _react.PropTypes.func,
  /** @ignore */
  onTouchTap: _react.PropTypes.func,
  /**
   * This is the block element that contains the primary text.
   * If a string is passed in, a div tag will be rendered.
   */
  primaryText: _react.PropTypes.node,
  /**
   * If true, clicking or tapping the primary text of the `ListItem`
   * toggles the nested list.
   */
  primaryTogglesNestedList: _react.PropTypes.bool,
  /**
   * This is the `Avatar` element to be displayed on the right side.
   */
  rightAvatar: _react.PropTypes.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _react.PropTypes.element,
  /**
   * This is the `IconButton` to be displayed on the right side.
   * Hovering over this button will remove the `ListItem` hover.
   * Also, clicking on this button will not trigger a
   * ripple on the `ListItem`; the event will be stopped and prevented
   * from bubbling up to cause a `ListItem` click.
   */
  rightIconButton: _react.PropTypes.element,
  /**
   * This is the `Toggle` element to display on the right side.
   */
  rightToggle: _react.PropTypes.element,
  /**
   * This is the block element that contains the secondary text.
   * If a string is passed in, a div tag will be rendered.
   */
  secondaryText: _react.PropTypes.node,
  /**
   * Can be 1 or 2. This is the number of secondary
   * text lines before ellipsis will show.
   */
  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
ListItem.defaultProps = {
  autoGenerateNestedIndicator: true,
  disableKeyboardFocus: false,
  disabled: false,
  initiallyOpen: false,
  insetChildren: false,
  nestedItems: [],
  nestedLevel: 0,
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onNestedListToggle: function onNestedListToggle() {},
  onTouchStart: function onTouchStart() {},
  primaryTogglesNestedList: false,
  secondaryTextLines: 1
};
ListItem.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = ListItem;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _childUtils = __webpack_require__(411);

var _events = __webpack_require__(414);

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__(415);

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__(416);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(376);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _deprecatedPropType = __webpack_require__(419);

var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  _inherits(EnhancedButton, _Component);

  function EnhancedButton() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = { isKeyboardFocused: false }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
          _this.handleTouchTap(event);
        }
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
          _this.handleTouchTap(event);
        }
      }
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.props.onClick(event);
      }
    }, _this.handleTouchTap = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onTouchTap(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props;
      var disabled = _props.disabled;
      var disableKeyboardFocus = _props.disableKeyboardFocus;
      var keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.refs.enhancedButton.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.focusTimeout);
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props;
      var centerRipple = _props2.centerRipple;
      var children = _props2.children;
      var disabled = _props2.disabled;
      var disableFocusRipple = _props2.disableFocusRipple;
      var disableKeyboardFocus = _props2.disableKeyboardFocus;
      var disableTouchRipple = _props2.disableTouchRipple;
      var focusRippleColor = _props2.focusRippleColor;
      var focusRippleOpacity = _props2.focusRippleOpacity;
      var touchRippleColor = _props2.touchRippleColor;
      var touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
        _TouchRipple2.default,
        {
          centerRipple: centerRipple,
          color: touchRippleColor,
          opacity: touchRippleOpacity
        },
        children
      ) : undefined;

      return (0, _childUtils.createChildFragment)({
        focusRipple: focusRipple,
        touchRipple: touchRipple,
        children: touchRipple ? undefined : children
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var centerRipple = _props3.centerRipple;
      var children = _props3.children;
      var containerElement = _props3.containerElement;
      var disabled = _props3.disabled;
      var disableFocusRipple = _props3.disableFocusRipple;
      var disableKeyboardFocus = _props3.disableKeyboardFocus;
      var disableTouchRipple = _props3.disableTouchRipple;
      var focusRippleColor = _props3.focusRippleColor;
      var focusRippleOpacity = _props3.focusRippleOpacity;
      var href = _props3.href;
      var keyboardFocused = _props3.keyboardFocused;
      var linkButton = _props3.linkButton;
      var touchRippleColor = _props3.touchRippleColor;
      var touchRippleOpacity = _props3.touchRippleOpacity;
      var onBlur = _props3.onBlur;
      var onClick = _props3.onClick;
      var onFocus = _props3.onFocus;
      var onKeyUp = _props3.onKeyUp;
      var onKeyDown = _props3.onKeyDown;
      var onKeyboardFocus = _props3.onKeyboardFocus;
      var onTouchTap = _props3.onTouchTap;
      var style = _props3.style;
      var tabIndex = _props3.tabIndex;
      var type = _props3.type;

      var other = _objectWithoutProperties(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'linkButton', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);

      var _context$muiTheme = this.context.muiTheme;
      var prepareStyles = _context$muiTheme.prepareStyles;
      var enhancedButton = _context$muiTheme.enhancedButton;


      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        /**
         * This is needed so that ripples do not bleed
         * past border radius.
         * See: http://stackoverflow.com/questions/17298739/
         * css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
         */
        transform: disableTouchRipple && disableFocusRipple ? null : 'translate3d(0, 0, 0)',
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement(
          'span',
          _extends({}, other, {
            style: mergedStyles
          }),
          children
        );
      }

      var buttonProps = _extends({}, other, {
        style: prepareStyles(mergedStyles),
        ref: 'enhancedButton',
        disabled: disabled,
        href: href,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onTouchTap: this.handleTouchTap,
        tabIndex: tabIndex,
        type: type
      });
      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);

  return EnhancedButton;
}(_react.Component);

EnhancedButton.propTypes = {
  centerRipple: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  disableFocusRipple: _react.PropTypes.bool,
  disableKeyboardFocus: _react.PropTypes.bool,
  disableTouchRipple: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  focusRippleColor: _react.PropTypes.string,
  focusRippleOpacity: _react.PropTypes.number,
  href: _react.PropTypes.string,
  keyboardFocused: _react.PropTypes.bool,
  linkButton: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'LinkButton is no longer required when the `href` property is provided.\n      It will be removed with v0.16.0.'),
  onBlur: _react.PropTypes.func,
  onClick: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  onKeyDown: _react.PropTypes.func,
  onKeyUp: _react.PropTypes.func,
  onKeyboardFocus: _react.PropTypes.func,
  onMouseDown: _react.PropTypes.func,
  onMouseEnter: _react.PropTypes.func,
  onMouseLeave: _react.PropTypes.func,
  onMouseUp: _react.PropTypes.func,
  onTouchEnd: _react.PropTypes.func,
  onTouchStart: _react.PropTypes.func,
  onTouchTap: _react.PropTypes.func,
  style: _react.PropTypes.object,
  tabIndex: _react.PropTypes.number,
  touchRippleColor: _react.PropTypes.string,
  touchRippleOpacity: _react.PropTypes.number,
  type: _react.PropTypes.string
};
EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseDown: function onMouseDown() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseUp: function onMouseUp() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchStart: function onTouchStart() {},
  onTouchTap: function onTouchTap() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = EnhancedButton;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createChildFragment = createChildFragment;
exports.extendChildren = extendChildren;

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCreateFragment = __webpack_require__(412);

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createChildFragment(fragments) {
  var newFragments = {};
  var validChildrenCount = 0;
  var firstKey = void 0;

  // Only create non-empty key fragments
  for (var key in fragments) {
    var currentChild = fragments[key];

    if (currentChild) {
      if (validChildrenCount === 0) firstKey = key;
      newFragments[key] = currentChild;
      validChildrenCount++;
    }
  }

  if (validChildrenCount === 0) return undefined;
  if (validChildrenCount === 1) return newFragments[firstKey];
  return (0, _reactAddonsCreateFragment2.default)(newFragments);
}

function extendChildren(children, extendedProps, extendedChildren) {
  return _react2.default.isValidElement(children) ? _react2.default.Children.map(children, function (child) {
    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;

    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;

    return _react2.default.cloneElement(child, newProps, newChildren);
  }) : children;
}

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(413).create;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactFragment
 */

'use strict';

var _prodInvariant = __webpack_require__(33);

var ReactChildren = __webpack_require__(31);
var ReactElement = __webpack_require__(35);

var emptyFunction = __webpack_require__(38);
var invariant = __webpack_require__(34);
var warning = __webpack_require__(37);

/**
 * We used to allow keyed objects to serve as a collection of ReactElements,
 * or nested sets. This allowed us a way to explicitly key a set or fragment of
 * components. This is now being replaced with an opaque data structure.
 * The upgrade path is to call React.addons.createFragment({ key: value }) to
 * create a keyed fragment. The resulting data structure is an array.
 */

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

var ReactFragment = {
  /**
   * Wrap a keyed object in an opaque proxy that warns you if you access any
   * of its properties.
   * See https://facebook.github.io/react/docs/create-fragment.html
   */
  create: function (object) {
    if (typeof object !== 'object' || !object || Array.isArray(object)) {
       false ? warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object) : void 0;
      return object;
    }
    if (ReactElement.isValidElement(object)) {
       false ? warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.') : void 0;
      return object;
    }

    !(object.nodeType !== 1) ?  false ? invariant(false, 'React.addons.createFragment(...): Encountered an invalid child; DOM elements are not valid children of React components.') : _prodInvariant('0') : void 0;

    var result = [];

    for (var key in object) {
      if (false) {
        if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.') : void 0;
          warnedAboutNumeric = true;
        }
      }
      ReactChildren.mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
    }

    return result;
  }
};

module.exports = ReactFragment;

/***/ },
/* 414 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ },
/* 415 */
/***/ function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(381);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__(417);

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  _inherits(FocusRipple, _Component);

  function FocusRipple() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FocusRipple)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color;
      var innerStyle = props.innerStyle;
      var opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme;
      var prepareStyles = _context$muiTheme.prepareStyles;
      var ripple = _context$muiTheme.ripple;


      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var show = _props.show;
      var style = _props.style;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(
        _ScaleIn2.default,
        {
          maxScale: 0.85,
          style: mergedRootStyles
        },
        ripple
      );
    }
  }]);

  return FocusRipple;
}(_react.Component);

FocusRipple.propTypes = {
  color: _react.PropTypes.string,
  innerStyle: _react.PropTypes.object,
  opacity: _react.PropTypes.number,
  show: _react.PropTypes.bool,
  style: _react.PropTypes.object
};
FocusRipple.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = FocusRipple;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsTransitionGroup = __webpack_require__(238);

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _ScaleInChild = __webpack_require__(418);

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScaleIn = function (_Component) {
  _inherits(ScaleIn, _Component);

  function ScaleIn() {
    _classCallCheck(this, ScaleIn);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ScaleIn).apply(this, arguments));
  }

  _createClass(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var childStyle = _props.childStyle;
      var enterDelay = _props.enterDelay;
      var maxScale = _props.maxScale;
      var minScale = _props.minScale;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        overflow: 'hidden',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ScaleInChild2.default,
          {
            key: child.key,
            enterDelay: enterDelay,
            maxScale: maxScale,
            minScale: minScale,
            style: childStyle
          },
          child
        );
      });

      return _react2.default.createElement(
        _reactAddonsTransitionGroup2.default,
        _extends({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);

  return ScaleIn;
}(_react.Component);

ScaleIn.propTypes = {
  childStyle: _react.PropTypes.object,
  children: _react.PropTypes.node,
  enterDelay: _react.PropTypes.number,
  maxScale: _react.PropTypes.number,
  minScale: _react.PropTypes.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = ScaleIn;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(381);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScaleInChild = function (_Component) {
  _inherits(ScaleInChild, _Component);

  function ScaleInChild() {
    _classCallCheck(this, ScaleInChild);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ScaleInChild).apply(this, arguments));
  }

  _createClass(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var enterDelay = _props.enterDelay;
      var maxScale = _props.maxScale;
      var minScale = _props.minScale;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);

  return ScaleInChild;
}(_react.Component);

ScaleInChild.propTypes = {
  children: _react.PropTypes.node,
  enterDelay: _react.PropTypes.number,
  maxScale: _react.PropTypes.number,
  minScale: _react.PropTypes.number,
  style: _react.PropTypes.object
};
ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = ScaleInChild;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] != null) {
       false ? (0, _warning2.default)(false, '"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation) : void 0;
    }

    return propType(props, propName, componentName);
  };
}

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IconButton = __webpack_require__(421);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(410);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(422);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Tooltip = __webpack_require__(424);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _childUtils = __webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      boxSizing: 'border-box',
      overflow: 'visible',
      transition: _transitions2.default.easeOut(),
      padding: baseTheme.spacing.iconSize / 2,
      width: baseTheme.spacing.iconSize * 2,
      height: baseTheme.spacing.iconSize * 2,
      fontSize: 0
    },
    tooltip: {
      boxSizing: 'border-box'
    },
    overlay: {
      position: 'relative',
      top: 0,
      width: '100%',
      height: '100%',
      background: baseTheme.palette.disabledColor
    },
    disabled: {
      color: baseTheme.palette.disabledColor,
      fill: baseTheme.palette.disabledColor,
      cursor: 'not-allowed'
    }
  };
}

var IconButton = function (_Component) {
  _inherits(IconButton, _Component);

  function IconButton() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(IconButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      tooltipShown: false
    }, _this.handleBlur = function (event) {
      _this.hideTooltip();
      if (_this.props.onBlur) _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      _this.showTooltip();
      if (_this.props.onFocus) _this.props.onFocus(event);
    }, _this.handleMouseLeave = function (event) {
      if (!_this.refs.button.isKeyboardFocused()) _this.hideTooltip();
      if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
    }, _this.handleMouseOut = function (event) {
      if (_this.props.disabled) _this.hideTooltip();
      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
    }, _this.handleMouseEnter = function (event) {
      _this.showTooltip();
      if (_this.props.onMouseEnter) _this.props.onMouseEnter(event);
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      if (keyboardFocused && !_this.props.disabled) {
        _this.showTooltip();
        if (_this.props.onFocus) _this.props.onFocus(event);
      } else if (!_this.state.hovered) {
        _this.hideTooltip();
        if (_this.props.onBlur) _this.props.onBlur(event);
      }

      if (_this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event, keyboardFocused);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconButton, [{
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus() {
      this.refs.button.setKeyboardFocus();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      if (this.props.tooltip) {
        this.setState({ tooltipShown: true });
      }
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      if (this.props.tooltip) this.setState({ tooltipShown: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var disabled = _props.disabled;
      var disableTouchRipple = _props.disableTouchRipple;
      var children = _props.children;
      var iconClassName = _props.iconClassName;
      var onKeyboardFocus = _props.onKeyboardFocus;
      var tooltip = _props.tooltip;
      var tooltipPositionProp = _props.tooltipPosition;
      var touch = _props.touch;
      var iconStyle = _props.iconStyle;

      var other = _objectWithoutProperties(_props, ['disabled', 'disableTouchRipple', 'children', 'iconClassName', 'onKeyboardFocus', 'tooltip', 'tooltipPosition', 'touch', 'iconStyle']);

      var fonticon = void 0;

      var styles = getStyles(this.props, this.context);
      var tooltipPosition = tooltipPositionProp.split('-');

      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
        ref: 'tooltip',
        label: tooltip,
        show: this.state.tooltipShown,
        touch: touch,
        style: (0, _simpleAssign2.default)(styles.tooltip, this.props.tooltipStyles),
        verticalPosition: tooltipPosition[0],
        horizontalPosition: tooltipPosition[1]
      }) : null;

      if (iconClassName) {
        var iconHoverColor = iconStyle.iconHoverColor;

        var iconStyleFontIcon = _objectWithoutProperties(iconStyle, ['iconHoverColor']);

        fonticon = _react2.default.createElement(
          _FontIcon2.default,
          {
            className: iconClassName,
            hoverColor: disabled ? null : iconHoverColor,
            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
            color: this.context.muiTheme.baseTheme.palette.textColor
          },
          children
        );
      }

      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        _extends({}, other, {
          ref: 'button',
          centerRipple: true,
          disabled: disabled,
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          disableTouchRipple: disableTouchRipple,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onMouseOut: this.handleMouseOut,
          onKeyboardFocus: this.handleKeyboardFocus
        }),
        tooltipElement,
        fonticon,
        (0, _childUtils.extendChildren)(children, {
          style: childrenStyle
        })
      );
    }
  }]);

  return IconButton;
}(_react.Component);

IconButton.muiName = 'IconButton';
IconButton.propTypes = {
  /**
   * Can be used to pass a `FontIcon` element as the icon for the button.
   */
  children: _react.PropTypes.node,
  /**
   * The CSS class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _react.PropTypes.bool,
  /**
   * If true, the element will be disabled.
   */
  disabled: _react.PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _react.PropTypes.string,
  /**
   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
   */
  iconClassName: _react.PropTypes.string,
  /**
   * Override the inline-styles of the icon element.
   */
  iconStyle: _react.PropTypes.object,
  /** @ignore */
  onBlur: _react.PropTypes.func,
  /** @ignore */
  onFocus: _react.PropTypes.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} keyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _react.PropTypes.func,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /** @ignore */
  onMouseOut: _react.PropTypes.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The text to supply to the element's tooltip.
   */
  tooltip: _react.PropTypes.node,
  /**
   * The vertical and horizontal positions, respectively, of the element's tooltip.
   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
   * "bottom-left", and "top-left".
   */
  tooltipPosition: _propTypes2.default.cornersAndCenter,
  /**
   * Override the inline-styles of the tooltip element.
   */
  tooltipStyles: _react.PropTypes.object,
  /**
   * If true, increase the tooltip element's size.  Useful for increasing tooltip
   * readability on mobile devices.
   */
  touch: _react.PropTypes.bool
};
IconButton.defaultProps = {
  disabled: false,
  disableTouchRipple: false,
  iconStyle: {},
  tooltipPosition: 'bottom-center',
  touch: false
};
IconButton.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = IconButton;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FontIcon = __webpack_require__(423);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context, state) {
  var color = props.color;
  var hoverColor = props.hoverColor;
  var baseTheme = context.muiTheme.baseTheme;

  var offColor = color || baseTheme.palette.textColor;
  var onColor = hoverColor || offColor;

  return {
    root: {
      color: state.hovered ? onColor : offColor,
      position: 'relative',
      fontSize: baseTheme.spacing.iconSize,
      display: 'inline-block',
      userSelect: 'none',
      transition: _transitions2.default.easeOut()
    }
  };
}

var FontIcon = function (_Component) {
  _inherits(FontIcon, _Component);

  function FontIcon() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, FontIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FontIcon)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FontIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var hoverColor = _props.hoverColor;
      var onMouseLeave = _props.onMouseLeave;
      var onMouseEnter = _props.onMouseEnter;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement('span', _extends({}, other, {
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
      }));
    }
  }]);

  return FontIcon;
}(_react.Component);

FontIcon.muiName = 'FontIcon';
FontIcon.propTypes = {
  /**
   * This is the font color of the font icon. If not specified,
   * this component will default to muiTheme.palette.textColor.
   */
  color: _react.PropTypes.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _react.PropTypes.string,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
FontIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
FontIcon.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = FontIcon;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context, state) {
  var verticalPosition = props.verticalPosition;
  var horizontalPosition = props.horizontalPosition;
  var touchMarginOffset = props.touch ? 10 : 0;
  var touchOffsetTop = props.touch ? -20 : -10;
  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;

  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var zIndex = _context$muiTheme.zIndex;
  var tooltip = _context$muiTheme.tooltip;


  var styles = {
    root: {
      position: 'absolute',
      fontFamily: baseTheme.fontFamily,
      fontSize: '10px',
      lineHeight: '22px',
      padding: '0 8px',
      zIndex: zIndex.tooltip,
      color: tooltip.color,
      overflow: 'hidden',
      top: -10000,
      borderRadius: 2,
      userSelect: 'none',
      opacity: 0,
      right: horizontalPosition === 'left' ? 12 : null,
      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : null,
      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    label: {
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    ripple: {
      position: 'absolute',
      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
      top: verticalPosition === 'bottom' ? 0 : '100%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    },
    rootWhenShown: {
      top: verticalPosition === 'top' ? touchOffsetTop : 36,
      opacity: 0.9,
      transform: 'translate3d(0px, ' + offset + 'px, 0px)',
      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    rootWhenTouched: {
      fontSize: '14px',
      lineHeight: '32px',
      padding: '0 16px'
    },
    rippleWhenShown: {
      backgroundColor: tooltip.rippleBackgroundColor,
      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    }
  };

  return styles;
}

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tooltip)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      offsetWidth: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setRippleSize();
      this.setTooltipPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setTooltipPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setRippleSize();
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var ripple = this.refs.ripple;
      var tooltip = this.refs.tooltip;
      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);

      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
      if (this.props.show) {
        ripple.style.height = rippleDiameter + 'px';
        ripple.style.width = rippleDiameter + 'px';
      } else {
        ripple.style.width = '0px';
        ripple.style.height = '0px';
      }
    }
  }, {
    key: 'setTooltipPosition',
    value: function setTooltipPosition() {
      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var horizontalPosition = _props.horizontalPosition;
      var label = _props.label;
      var show = _props.show;
      var touch = _props.touch;
      var verticalPosition = _props.verticalPosition;

      var other = _objectWithoutProperties(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        'div',
        _extends({}, other, {
          ref: 'tooltip',
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
        }),
        _react2.default.createElement('div', {
          ref: 'ripple',
          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          label
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
  label: _react.PropTypes.node.isRequired,
  show: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  touch: _react.PropTypes.bool,
  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
};
Tooltip.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Tooltip;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandLess = function NavigationExpandLess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
  );
};
NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
NavigationExpandLess.displayName = 'NavigationExpandLess';
NavigationExpandLess.muiName = 'SvgIcon';

exports.default = NavigationExpandLess;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandMore = function NavigationExpandMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
  );
};
NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
NavigationExpandMore.displayName = 'NavigationExpandMore';
NavigationExpandMore.muiName = 'SvgIcon';

exports.default = NavigationExpandMore;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(428);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NestedList = function (_Component) {
  _inherits(NestedList, _Component);

  function NestedList() {
    _classCallCheck(this, NestedList);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NestedList).apply(this, arguments));
  }

  _createClass(NestedList, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var open = _props.open;
      var nestedLevel = _props.nestedLevel;
      var style = _props.style;


      var styles = {
        root: {
          display: open ? null : 'none'
        }
      };

      return _react2.default.createElement(
        _List2.default,
        { style: (0, _simpleAssign2.default)({}, styles.root, style) },
        _react2.default.Children.map(children, function (child) {
          return _react2.default.isValidElement(child) ? _react2.default.cloneElement(child, {
            nestedLevel: nestedLevel + 1
          }) : child;
        })
      );
    }
  }]);

  return NestedList;
}(_react.Component);

NestedList.propTypes = {
  children: _react.PropTypes.node,
  nestedLevel: _react.PropTypes.number,
  open: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
NestedList.defaultProps = {
  nestedLevel: 1,
  open: false
};
exports.default = NestedList;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Subheader = __webpack_require__(429);

var _Subheader2 = _interopRequireDefault(_Subheader);

var _deprecatedPropType = __webpack_require__(419);

var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(List).apply(this, arguments));
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var _props$insetSubheader = _props.insetSubheader;
      var insetSubheader = _props$insetSubheader === undefined ? false : _props$insetSubheader;
      var style = _props.style;
      var subheader = _props.subheader;
      var subheaderStyle = _props.subheaderStyle;
      var zDepth = _props.zDepth;

      var other = _objectWithoutProperties(_props, ['children', 'insetSubheader', 'style', 'subheader', 'subheaderStyle', 'zDepth']);

       false ? (0, _warning2.default)(typeof zDepth === 'undefined', 'List no longer supports `zDepth`. Instead, wrap it in `Paper` ' + 'or another component that provides zDepth. It will be removed with v0.16.0.') : void 0;

      var hasSubheader = false;

      if (subheader) {
        hasSubheader = true;
      } else {
        var firstChild = _react2.default.Children.toArray(children)[0];
        if (_react2.default.isValidElement(firstChild) && firstChild.type === _Subheader2.default) {
          hasSubheader = true;
        }
      }

      var styles = {
        root: {
          padding: 0,
          paddingBottom: 8,
          paddingTop: hasSubheader ? 0 : 8
        }
      };

      return _react2.default.createElement(
        'div',
        _extends({}, other, {
          style: (0, _simpleAssign2.default)(styles.root, style)
        }),
        subheader && _react2.default.createElement(
          _Subheader2.default,
          { inset: insetSubheader, style: subheaderStyle },
          subheader
        ),
        children
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  /**
   * These are usually `ListItem`s that are passed to
   * be part of the list.
   */
  children: _react.PropTypes.node,
  /**
   * If true, the subheader will be indented by 72px.
   */
  insetSubheader: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Refer to the `subheader` property. It will be removed with v0.16.0.'),
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The subheader string that will be displayed at the top of the list.
   */
  subheader: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Instead, nest the `Subheader` component directly inside the `List`. It will be removed with v0.16.0.'),
  /**
   * Override the inline-styles of the subheader element.
   */
  subheaderStyle: (0, _deprecatedPropType2.default)(_react.PropTypes.object, 'Refer to the `subheader` property. It will be removed with v0.16.0.'),
  /**
   * @ignore
   * ** Breaking change ** List no longer supports `zDepth`. Instead, wrap it in `Paper`
   * or another component that provides zDepth.
   */
  zDepth: _propTypes2.default.zDepth
};
List.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = List;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Subheader = __webpack_require__(430);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader2.default;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  /**
   * Node that will be placed inside the `Subheader`.
   */
  children: _react.PropTypes.node,
  /**
   * If true, the `Subheader` will be indented by `72px`.
   */
  inset: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};

var defaultProps = {
  inset: false
};

var contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};

var Subheader = function Subheader(props, context) {
  var children = props.children;
  var inset = props.inset;
  var style = props.style;

  var other = _objectWithoutProperties(props, ['children', 'inset', 'style']);

  var _context$muiTheme = context.muiTheme;
  var prepareStyles = _context$muiTheme.prepareStyles;
  var subheader = _context$muiTheme.subheader;


  var styles = {
    root: {
      boxSizing: 'border-box',
      color: subheader.color,
      fontSize: 14,
      fontWeight: subheader.fontWeight,
      lineHeight: '48px',
      paddingLeft: inset ? 72 : 16,
      width: '100%'
    }
  };

  return _react2.default.createElement(
    'div',
    _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
    children
  );
};

Subheader.muiName = 'Subheader';
Subheader.propTypes = propTypes;
Subheader.defaultProps = defaultProps;
Subheader.contextTypes = contextTypes;

exports.default = Subheader;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _ClickAwayListener = __webpack_require__(432);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _autoPrefix = __webpack_require__(381);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _keycode = __webpack_require__(415);

var _keycode2 = _interopRequireDefault(_keycode);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(428);

var _List2 = _interopRequireDefault(_List);

var _deprecatedPropType = __webpack_require__(419);

var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

var _menuUtils = __webpack_require__(433);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var animated = props.animated;
  var desktop = props.desktop;
  var maxHeight = props.maxHeight;
  var _props$openDirection = props.openDirection;
  var openDirection = _props$openDirection === undefined ? 'bottom-left' : _props$openDirection;
  var width = props.width;


  var openDown = openDirection.split('-')[0] === 'bottom';
  var openLeft = openDirection.split('-')[1] === 'left';

  var muiTheme = context.muiTheme;


  var styles = {
    root: {
      // Nested div bacause the List scales x faster than it scales y
      transition: animated ? _transitions2.default.easeOut('250ms', 'transform') : null,
      zIndex: muiTheme.zIndex.menu,
      top: openDown ? 0 : null,
      bottom: !openDown ? 0 : null,
      left: !openLeft ? 0 : null,
      right: openLeft ? 0 : null,
      transform: animated ? 'scaleX(0)' : null,
      transformOrigin: openLeft ? 'right' : 'left',
      opacity: 0,
      maxHeight: maxHeight,
      overflowY: maxHeight ? 'auto' : null
    },
    divider: {
      marginTop: 7,
      marginBottom: 8
    },
    list: {
      display: 'table-cell',
      paddingBottom: desktop ? 16 : 8,
      paddingTop: desktop ? 16 : 8,
      userSelect: 'none',
      width: width
    },
    menuItemContainer: {
      transition: animated ? _transitions2.default.easeOut(null, 'opacity') : null,
      opacity: 0
    },
    selectedMenuItem: {
      color: muiTheme.baseTheme.palette.accent1Color
    }
  };

  return styles;
}

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu(props, context) {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).call(this, props, context));

    _initialiseProps.call(_this);

    var filteredChildren = _this.getFilteredChildren(props.children);
    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);

    _this.state = {
      focusIndex: props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0,
      isKeyboardFocused: props.initiallyKeyboardFocused,
      keyWidth: props.desktop ? 64 : 56
    };

    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
    return _this;
  }

  _createClass(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
      if (!this.props.animated) {
        this.animateOpen();
      }
      this.setScollPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var filteredChildren = this.getFilteredChildren(nextProps.children);
      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);

      this.setState({
        focusIndex: nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0,
        keyWidth: nextProps.desktop ? 64 : 56
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoWidth) this.setWidth();
    }
  }, {
    key: 'getValueLink',


    // Do not use outside of this component, it will be removed once valueLink is deprecated
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'setKeyboardFocused',
    value: function setKeyboardFocused(keyboardFocused) {
      this.setState({
        isKeyboardFocused: keyboardFocused
      });
    }
  }, {
    key: 'getFilteredChildren',
    value: function getFilteredChildren(children) {
      var filteredChildren = [];
      _react2.default.Children.forEach(children, function (child) {
        if (child) {
          filteredChildren.push(child);
        }
      });
      return filteredChildren;
    }
  }, {
    key: 'animateOpen',
    value: function animateOpen() {
      var rootStyle = _reactDom2.default.findDOMNode(this).style;
      var scrollContainerStyle = _reactDom2.default.findDOMNode(this.refs.scrollContainer).style;
      var menuContainers = _reactDom2.default.findDOMNode(this.refs.list).childNodes;

      _autoPrefix2.default.set(rootStyle, 'transform', 'scaleX(1)');
      _autoPrefix2.default.set(scrollContainerStyle, 'transform', 'scaleY(1)');
      scrollContainerStyle.opacity = 1;

      for (var i = 0; i < menuContainers.length; ++i) {
        menuContainers[i].style.opacity = 1;
      }
    }
  }, {
    key: 'cloneMenuItem',
    value: function cloneMenuItem(child, childIndex, styles, index) {
      var _this2 = this;

      var _props = this.props;
      var desktop = _props.desktop;
      var selectedMenuItemStyle = _props.selectedMenuItemStyle;


      var selected = this.isChildSelected(child, this.props);
      var selectedChildrenStyles = {};

      if (selected) {
        selectedChildrenStyles = (0, _simpleAssign2.default)(styles.selectedMenuItem, selectedMenuItemStyle);
      }

      var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);

      var isFocused = childIndex === this.state.focusIndex;
      var focusState = 'none';
      if (isFocused) {
        focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
      }

      return _react2.default.cloneElement(child, {
        desktop: desktop,
        focusState: focusState,
        onTouchTap: function onTouchTap(event) {
          _this2.handleMenuItemTouchTap(event, child, index);
          if (child.props.onTouchTap) child.props.onTouchTap(event);
        },
        ref: isFocused ? 'focusedMenuItem' : null,
        style: mergedChildrenStyles
      });
    }
  }, {
    key: 'decrementKeyboardFocusIndex',
    value: function decrementKeyboardFocusIndex() {
      var index = this.state.focusIndex;

      index--;
      if (index < 0) index = 0;

      this.setFocusIndex(index, true);
    }
  }, {
    key: 'getCascadeChildrenCount',
    value: function getCascadeChildrenCount(filteredChildren) {
      var _props2 = this.props;
      var desktop = _props2.desktop;
      var maxHeight = _props2.maxHeight;

      var count = 1;
      var currentHeight = desktop ? 16 : 8;
      var menuItemHeight = desktop ? 32 : 48;

      // MaxHeight isn't set - cascade all of the children
      if (!maxHeight) return filteredChildren.length;

      // Count all the children that will fit inside the max menu height
      filteredChildren.forEach(function (child) {
        if (currentHeight < maxHeight) {
          var childIsADivider = child.type && child.type.muiName === 'Divider';

          currentHeight += childIsADivider ? 16 : menuItemHeight;
          count++;
        }
      });

      return count;
    }
  }, {
    key: 'getMenuItemCount',
    value: function getMenuItemCount(filteredChildren) {
      var menuItemCount = 0;
      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';
        var childIsDisabled = child.props.disabled;
        if (!childIsADivider && !childIsDisabled) menuItemCount++;
      });
      return menuItemCount;
    }
  }, {
    key: 'getSelectedIndex',
    value: function getSelectedIndex(props, filteredChildren) {
      var _this3 = this;

      var selectedIndex = -1;
      var menuItemIndex = 0;

      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';

        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
        if (!childIsADivider) menuItemIndex++;
      });

      return selectedIndex;
    }
  }, {
    key: 'setFocusIndexStartsWith',
    value: function setFocusIndexStartsWith(keys) {
      var foundIndex = -1;
      _react2.default.Children.forEach(this.props.children, function (child, index) {
        if (foundIndex >= 0) {
          return;
        }
        var primaryText = child.props.primaryText;

        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
          foundIndex = index;
        }
      });
      if (foundIndex >= 0) {
        this.setFocusIndex(foundIndex, true);
        return true;
      }
      return false;
    }
  }, {
    key: 'handleMenuItemTouchTap',
    value: function handleMenuItemTouchTap(event, item, index) {
      var children = this.props.children;
      var multiple = this.props.multiple;
      var valueLink = this.getValueLink(this.props);
      var menuValue = valueLink.value;
      var itemValue = item.props.value;
      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);

      this.setFocusIndex(focusIndex, false);

      if (multiple) {
        var itemIndex = menuValue.indexOf(itemValue);

        var _menuValue = _toArray(menuValue);

        var newMenuValue = _menuValue;

        if (itemIndex === -1) {
          newMenuValue.push(itemValue);
        } else {
          newMenuValue.splice(itemIndex, 1);
        }

        valueLink.requestChange(event, newMenuValue);
      } else if (!multiple && itemValue !== menuValue) {
        valueLink.requestChange(event, itemValue);
      }

      this.props.onItemTouchTap(event, item, index);
    }
  }, {
    key: 'incrementKeyboardFocusIndex',
    value: function incrementKeyboardFocusIndex(filteredChildren) {
      var index = this.state.focusIndex;
      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;

      index++;
      if (index > maxIndex) index = maxIndex;

      this.setFocusIndex(index, true);
    }
  }, {
    key: 'isChildSelected',
    value: function isChildSelected(child, props) {
      var menuValue = this.getValueLink(props).value;
      var childValue = child.props.value;

      if (props.multiple) {
        return menuValue.length && menuValue.indexOf(childValue) !== -1;
      } else {
        return child.props.hasOwnProperty('value') && menuValue === childValue;
      }
    }
  }, {
    key: 'setFocusIndex',
    value: function setFocusIndex(newIndex, isKeyboardFocused) {
      this.setState({
        focusIndex: newIndex,
        isKeyboardFocused: isKeyboardFocused
      });
    }
  }, {
    key: 'setScollPosition',
    value: function setScollPosition() {
      var desktop = this.props.desktop;
      var focusedMenuItem = this.refs.focusedMenuItem;
      var menuItemHeight = desktop ? 32 : 48;

      if (focusedMenuItem) {
        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;

        // Make the focused item be the 2nd item in the list the user sees
        var scrollTop = selectedOffSet - menuItemHeight;
        if (scrollTop < menuItemHeight) scrollTop = 0;

        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
      }
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = _reactDom2.default.findDOMNode(this);
      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
      var elWidth = el.offsetWidth;
      var keyWidth = this.state.keyWidth;
      var minWidth = keyWidth * 1.5;
      var keyIncrements = elWidth / keyWidth;
      var newWidth = void 0;

      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
      newWidth = keyIncrements * keyWidth;

      if (newWidth < minWidth) newWidth = minWidth;

      el.style.width = newWidth + 'px';
      listEl.style.width = newWidth + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props3 = this.props;
      var animated = _props3.animated;
      var autoWidth = _props3.autoWidth;
      var children = _props3.children;
      var desktop = _props3.desktop;
      var disableAutoFocus = _props3.disableAutoFocus;
      var initiallyKeyboardFocused = _props3.initiallyKeyboardFocused;
      var listStyle = _props3.listStyle;
      var maxHeight = _props3.maxHeight;
      var multiple = _props3.multiple;
      var _props3$openDirection = _props3.openDirection;
      var openDirection = _props3$openDirection === undefined ? 'bottom-left' : _props3$openDirection;
      var onItemTouchTap = _props3.onItemTouchTap;
      var onEscKeyDown = _props3.onEscKeyDown;
      var selectedMenuItemStyle = _props3.selectedMenuItemStyle;
      var style = _props3.style;
      var value = _props3.value;
      var valueLink = _props3.valueLink;
      var width = _props3.width;
      var zDepth = _props3.zDepth;

      var other = _objectWithoutProperties(_props3, ['animated', 'autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'openDirection', 'onItemTouchTap', 'onEscKeyDown', 'selectedMenuItemStyle', 'style', 'value', 'valueLink', 'width', 'zDepth']);

       false ? (0, _warning2.default)(typeof zDepth === 'undefined', 'Menu no longer supports `zDepth`. Instead, wrap it in `Paper` ' + 'or another component that provides `zDepth`. It will be removed with v0.16.0.') : void 0;

      var focusIndex = this.state.focusIndex;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);

      var openDown = openDirection.split('-')[0] === 'bottom';
      var filteredChildren = this.getFilteredChildren(children);

      // Cascade children opacity
      var cumulativeDelay = openDown ? 175 : 325;
      var cascadeChildrenCount = this.getCascadeChildrenCount(filteredChildren);
      var cumulativeDelayIncrement = Math.ceil(150 / cascadeChildrenCount);

      var menuItemIndex = 0;
      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';
        var childIsDisabled = child.props.disabled;
        var childrenContainerStyles = {};

        if (animated) {
          var transitionDelay = 0;

          // Only cascade the visible menu items
          if (menuItemIndex >= focusIndex - 1 && menuItemIndex <= focusIndex + cascadeChildrenCount - 1) {
            cumulativeDelay = openDown ? cumulativeDelay + cumulativeDelayIncrement : cumulativeDelay - cumulativeDelayIncrement;
            transitionDelay = cumulativeDelay;
          }

          childrenContainerStyles = (0, _simpleAssign2.default)({}, styles.menuItemContainer, {
            transitionDelay: transitionDelay + 'ms'
          });
        }

        var clonedChild = childIsADivider ? _react2.default.cloneElement(child, { style: styles.divider }) : childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this4.cloneMenuItem(child, menuItemIndex, styles, index);

        if (!childIsADivider && !childIsDisabled) menuItemIndex++;

        return animated ? _react2.default.createElement(
          'div',
          { style: prepareStyles(childrenContainerStyles) },
          clonedChild
        ) : clonedChild;
      });

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'div',
          {
            onKeyDown: this.handleKeyDown,
            style: prepareStyles(mergedRootStyles),
            ref: 'scrollContainer'
          },
          _react2.default.createElement(
            _List2.default,
            _extends({}, other, {
              ref: 'list',
              style: mergedListStyles
            }),
            newChildren
          )
        )
      );
    }
  }]);

  return Menu;
}(_react.Component);

Menu.propTypes = {
  /**
   * If true, the menu will apply transitions when it
   * is added to the DOM. In order for transitions to
   * work, wrap the menu inside a `ReactTransitionGroup`.
   */
  animated: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Instead, use a [Popover](/#/components/popover).\n      It will be removed with v0.16.0.'),
  /**
   * If true, the width of the menu will be set automatically
   * according to the widths of its children,
   * using proper keyline increments (64px for desktop,
   * 56px otherwise).
   */
  autoWidth: _react.PropTypes.bool,
  /**
   * The content of the menu. This is usually used to pass `MenuItem`
   * elements.
   */
  children: _react.PropTypes.node,
  /**
   * If true, the menu item will render with compact desktop styles.
   */
  desktop: _react.PropTypes.bool,
  /**
   * If true, the menu will not be auto-focused.
   */
  disableAutoFocus: _react.PropTypes.bool,
  /**
   * If true, the menu will be keyboard-focused initially.
   */
  initiallyKeyboardFocused: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _react.PropTypes.object,
  /**
   * The maximum height of the menu in pixels. If specified,
   * the menu will be scrollable if it is taller than the provided
   * height.
   */
  maxHeight: _react.PropTypes.number,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _react.PropTypes.bool,
  /**
   * Callback function fired when a menu item with `value` not
   * equal to the current `value` of the menu is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the menu item.
   * @param {any}  value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _react.PropTypes.func,
  /**
   * Callback function fired when the menu is focused and the *Esc* key
   * is pressed.
   *
   * @param {object} event `keydown` event targeting the menu.
   */
  onEscKeyDown: _react.PropTypes.func,
  /**
   * Callback function fired when a menu item is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the menu item.
   * @param {object} menuItem The menu item.
   * @param {number} index The index of the menu item.
   */
  onItemTouchTap: _react.PropTypes.func,
  /** @ignore */
  onKeyDown: _react.PropTypes.func,
  /**
   * This is the placement of the menu relative to the `IconButton`.
   */
  openDirection: (0, _deprecatedPropType2.default)(_propTypes2.default.corners, 'Instead, use a [Popover](/#/components/popover).\n      It will be removed with v0.16.0.'),
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   * This component also supports valueLink.
   */
  value: _react.PropTypes.any,
  /**
   * ValueLink for the menu's `value`.
   */
  valueLink: _react.PropTypes.object,
  /**
   * The width of the menu. If not specified, the menu's width
   * will be set according to the widths of its children, using
   * proper keyline increments (64px for desktop, 56px otherwise).
   */
  width: _propTypes2.default.stringOrNumber,
  /**
   * @ignore
   * Menu no longer supports `zDepth`. Instead, wrap it in `Paper`
   * or another component that provides zDepth.
   */
  zDepth: _propTypes2.default.zDepth
};
Menu.defaultProps = {
  autoWidth: true,
  desktop: false,
  disableAutoFocus: false,
  initiallyKeyboardFocused: false,
  maxHeight: null,
  multiple: false,
  onChange: function onChange() {},
  onEscKeyDown: function onEscKeyDown() {},
  onItemTouchTap: function onItemTouchTap() {},
  onKeyDown: function onKeyDown() {}
};
Menu.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleClickAway = function (event) {
    if (event.defaultPrevented) {
      return;
    }

    _this5.setFocusIndex(-1, false);
  };

  this.handleKeyDown = function (event) {
    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var key = (0, _keycode2.default)(event);
    switch (key) {
      case 'down':
        event.preventDefault();
        _this5.incrementKeyboardFocusIndex(filteredChildren);
        break;
      case 'esc':
        _this5.props.onEscKeyDown(event);
        break;
      case 'tab':
        event.preventDefault();
        if (event.shiftKey) {
          _this5.decrementKeyboardFocusIndex();
        } else {
          _this5.incrementKeyboardFocusIndex(filteredChildren);
        }
        break;
      case 'up':
        event.preventDefault();
        _this5.decrementKeyboardFocusIndex();
        break;
      default:
        if (key.length === 1) {
          var hotKeys = _this5.hotKeyHolder.append(key);
          if (_this5.setFocusIndexStartsWith(hotKeys)) {
            event.preventDefault();
          }
        }
    }
    _this5.props.onKeyDown(event);
  };
};

exports.default = Menu;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(414);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var clickAwayEvents = ['mouseup', 'touchend'];
var bind = function bind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.on(document, event, callback);
  });
};
var unbind = function unbind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.off(document, event, callback);
  });
};

var ClickAwayListener = function (_Component) {
  _inherits(ClickAwayListener, _Component);

  function ClickAwayListener() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ClickAwayListener)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.isCurrentlyMounted) {
        var el = _reactDom2.default.findDOMNode(_this);

        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isCurrentlyMounted = true;
      if (this.props.onClickAway) {
        bind(this.handleClickAway);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onClickAway !== this.props.onClickAway) {
        unbind(this.handleClickAway);
        if (this.props.onClickAway) {
          bind(this.handleClickAway);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isCurrentlyMounted = false;
      unbind(this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return ClickAwayListener;
}(_react.Component);

ClickAwayListener.propTypes = {
  children: _react.PropTypes.node,
  onClickAway: _react.PropTypes.any
};
exports.default = ClickAwayListener;

/***/ },
/* 433 */
/***/ function(module, exports) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HotKeyHolder = exports.HotKeyHolder = function () {
  function HotKeyHolder() {
    var _this = this;

    _classCallCheck(this, HotKeyHolder);

    this.clear = function () {
      _this.timerId = null;
      _this.lastKeys = null;
    };
  }

  _createClass(HotKeyHolder, [{
    key: 'append',
    value: function append(key) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(this.clear, 500);
      return this.lastKeys = (this.lastKeys || '') + key;
    }
  }]);

  return HotKeyHolder;
}();

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Divider = __webpack_require__(435);

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Divider2.default;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * If true, the `Divider` will be indented `72px`.
   */
  inset: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};

var defaultProps = {
  inset: false
};

var contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};

var Divider = function Divider(props, context) {
  var inset = props.inset;
  var style = props.style;

  var other = _objectWithoutProperties(props, ['inset', 'style']);

  var muiTheme = context.muiTheme;
  var prepareStyles = muiTheme.prepareStyles;


  var styles = {
    root: {
      margin: 0,
      marginTop: -1,
      marginLeft: inset ? 72 : 0,
      height: 1,
      border: 'none',
      backgroundColor: muiTheme.baseTheme.palette.borderColor
    }
  };

  return _react2.default.createElement('hr', _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
};

Divider.muiName = 'Divider';
Divider.propTypes = propTypes;
Divider.defaultProps = defaultProps;
Divider.contextTypes = contextTypes;

exports.default = Divider;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.IconMenu = undefined;

var _IconMenu2 = __webpack_require__(437);

var _IconMenu3 = _interopRequireDefault(_IconMenu2);

var _MenuItem2 = __webpack_require__(386);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IconMenu = _IconMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _IconMenu3.default;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(414);

var _events2 = _interopRequireDefault(_events);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Menu = __webpack_require__(431);

var _Menu2 = _interopRequireDefault(_Menu);

var _Popover = __webpack_require__(387);

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconMenu = function (_Component) {
  _inherits(IconMenu, _Component);

  function IconMenu() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, IconMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(IconMenu)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      menuInitiallyKeyboardFocused: false,
      open: false
    }, _this.handleItemTouchTap = function (event, child) {
      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
        (function () {
          var isKeyboard = _events2.default.isKeyboard(event);
          _this.timerCloseId = setTimeout(function () {
            _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
          }, _this.props.touchTapCloseDelay);
        })();
      }

      _this.props.onItemTouchTap(event, child);
    }, _this.handleRequestClose = function (reason) {
      _this.close(reason);
    }, _this.handleEscKeyDownMenu = function (event) {
      _this.close('escape', event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open != null) {
        this.setState({
          open: nextProps.open,
          anchorEl: this.refs.iconMenuContainer
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerCloseId);
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.state.open;
    }
  }, {
    key: 'close',
    value: function close(reason, isKeyboard) {
      var _this2 = this;

      if (!this.state.open) {
        return;
      }

      if (this.props.open !== null) {
        this.props.onRequestChange(false, reason);
      }

      this.setState({ open: false }, function () {
        // Set focus on the icon button when the menu close
        if (isKeyboard) {
          var iconButton = _this2.refs.iconButton;
          _reactDom2.default.findDOMNode(iconButton).focus();
          iconButton.setKeyboardFocus();
        }
      });
    }
  }, {
    key: 'open',
    value: function open(reason, event) {
      if (this.props.open !== null) {
        this.props.onRequestChange(true, reason);

        return this.setState({
          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
          anchorEl: event.currentTarget
        });
      }

      this.setState({
        open: true,
        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
        anchorEl: event.currentTarget
      });

      event.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props;
      var anchorOrigin = _props.anchorOrigin;
      var className = _props.className;
      var animated = _props.animated;
      var iconButtonElement = _props.iconButtonElement;
      var iconStyle = _props.iconStyle;
      var onItemTouchTap = _props.onItemTouchTap;
      var onKeyboardFocus = _props.onKeyboardFocus;
      var onMouseDown = _props.onMouseDown;
      var onMouseLeave = _props.onMouseLeave;
      var onMouseEnter = _props.onMouseEnter;
      var onMouseUp = _props.onMouseUp;
      var onRequestChange = _props.onRequestChange;
      var onTouchTap = _props.onTouchTap;
      var menuStyle = _props.menuStyle;
      var style = _props.style;
      var targetOrigin = _props.targetOrigin;
      var touchTapCloseDelay = _props.touchTapCloseDelay;
      var useLayerForClickAway = _props.useLayerForClickAway;

      var other = _objectWithoutProperties(_props, ['anchorOrigin', 'className', 'animated', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);

      var prepareStyles = this.context.muiTheme.prepareStyles;
      var _state = this.state;
      var open = _state.open;
      var anchorEl = _state.anchorEl;


      var styles = {
        root: {
          display: 'inline-block',
          position: 'relative'
        },
        menu: {
          position: 'relative'
        }
      };

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);

      var iconButton = _react2.default.cloneElement(iconButtonElement, {
        onKeyboardFocus: onKeyboardFocus,
        iconStyle: (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle),
        onTouchTap: function onTouchTap(event) {
          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
          if (iconButtonElement.props.onTouchTap) iconButtonElement.props.onTouchTap(event);
        },
        ref: 'iconButton'
      });

      var menu = _react2.default.createElement(
        _Menu2.default,
        _extends({}, other, {
          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
          onEscKeyDown: this.handleEscKeyDownMenu,
          onItemTouchTap: this.handleItemTouchTap,
          style: mergedMenuStyles
        }),
        this.props.children
      );

      return _react2.default.createElement(
        'div',
        {
          ref: 'iconMenuContainer',
          className: className,
          onMouseDown: onMouseDown,
          onMouseLeave: onMouseLeave,
          onMouseEnter: onMouseEnter,
          onMouseUp: onMouseUp,
          onTouchTap: onTouchTap,
          style: prepareStyles(mergedRootStyles)
        },
        iconButton,
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            open: open,
            anchorEl: anchorEl,
            childContextTypes: this.constructor.childContextTypes,
            useLayerForClickAway: useLayerForClickAway,
            onRequestClose: this.handleRequestClose,
            animated: animated,
            context: this.context
          },
          menu
        )
      );
    }
  }]);

  return IconMenu;
}(_react.Component);

IconMenu.muiName = 'IconMenu';
IconMenu.propTypes = {
  /**
   * This is the point on the icon where the menu
   * `targetOrigin` will attach.
   * Options:
   * vertical: [top, middle, bottom]
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes2.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _react.PropTypes.bool,
  /**
   * Should be used to pass `MenuItem` components.
   */
  children: _react.PropTypes.node,
  /**
   * The CSS class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * This is the `IconButton` to render. This button will open the menu.
   */
  iconButtonElement: _react.PropTypes.element.isRequired,
  /**
   * Override the inline-styles of the underlying icon element.
   */
  iconStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the menu element.
   */
  menuStyle: _react.PropTypes.object,
  /**
   * If true, the value can an be array and allow the menu to be a multi-select.
   */
  multiple: _react.PropTypes.bool,
  /**
   * Callback function fired when a menu item is selected with a touch-tap.
   *
   * @param {object} event TouchTap event targeting the selected menu item element.
   * @param {object} child The selected element.
   */
  onItemTouchTap: _react.PropTypes.func,
  /**
   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
   */
  onKeyboardFocus: _react.PropTypes.func,
  /** @ignore */
  onMouseDown: _react.PropTypes.func,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /** @ignore */
  onMouseUp: _react.PropTypes.func,
  /**
   * Callback function fired when the `open` state of the menu is requested to be changed.
   *
   * @param {boolean} open If true, the menu was requested to be opened.
   * @param {string} reason The reason for the open or close request. Possible values are
   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
   * for close requests.
   */
  onRequestChange: _react.PropTypes.func,
  /**
   * Callback function fired when the `IconButton` element is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the `IconButton` element.
   */
  onTouchTap: _react.PropTypes.func,
  /**
   * If true, the `IconMenu` is opened.
   */
  open: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * This is the point on the menu which will stick to the menu
   * origin.
   * Options:
   * vertical: [top, middle, bottom]
   * horizontal: [left, center, right].
   */
  targetOrigin: _propTypes2.default.origin,
  /**
   * Sets the delay in milliseconds before closing the
   * menu when an item is clicked.
   * If set to 0 then the auto close functionality
   * will be disabled.
   */
  touchTapCloseDelay: _react.PropTypes.number,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying elements.
   */
  useLayerForClickAway: _react.PropTypes.bool
};
IconMenu.defaultProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  animated: true,
  multiple: false,
  open: null,
  onItemTouchTap: function onItemTouchTap() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseDown: function onMouseDown() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseUp: function onMouseUp() {},
  onRequestChange: function onRequestChange() {},
  onTouchTap: function onTouchTap() {},
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  touchTapCloseDelay: 200,
  useLayerForClickAway: false
};
IconMenu.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = IconMenu;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var diyLightTheme = __webpack_require__(241);
var muiAutoprefixer = __webpack_require__(335).default;
exports.autoprefixer = muiAutoprefixer(diyLightTheme);


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMoreVert = function NavigationMoreVert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
NavigationMoreVert.displayName = 'NavigationMoreVert';
NavigationMoreVert.muiName = 'SvgIcon';

exports.default = NavigationMoreVert;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var shallowCompare = __webpack_require__(441);
var SyncPosition = (function (_super) {
    tslib_1.__extends(SyncPosition, _super);
    function SyncPosition(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getBox();
        return _this;
    }
    SyncPosition.prototype.render = function () {
        return this.props.children(this.state);
    };
    SyncPosition.prototype.componentDidMount = function () {
        this.monitorElement();
    };
    SyncPosition.prototype.componentWillUnmount = function () {
        this.stopMonitorElement();
    };
    SyncPosition.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.props.useShallowCompare) {
            return shallowCompare(this, nextProps, nextState);
        }
        else {
            return true;
        }
    };
    SyncPosition.prototype.getBox = function () {
        var rect = this.props.element.getBoundingClientRect();
        var docRect;
        // Bugfix BUG-4124 overlays are out of sync with content when body has relative position
        // and first element has top margin
        if (document.body.style.position === 'relative') {
            docRect = document.body.getBoundingClientRect();
        }
        else {
            docRect = document.documentElement.getBoundingClientRect();
        }
        var deltaY = 0;
        var deltaX = 0;
        if (this.props.position === 'absolute') {
            deltaY = -docRect.top;
            deltaX = -docRect.left;
        }
        return {
            top: rect.top + deltaY,
            left: rect.left + deltaX,
            bottom: document.body.offsetHeight - deltaY - rect.bottom,
            right: document.body.offsetWidth - deltaX - rect.right,
            width: rect.width,
            height: rect.height
        };
    };
    SyncPosition.prototype.setStateFromElement = function () {
        var box = this.getBox();
        var stateBox = this.state;
        // Because we call this in a RAF we don't want to do setState
        // unless we are sure something changed
        // TODO compare using general util shallow-compare
        if (stateBox.width !== box.width
            || stateBox.height !== box.height
            || stateBox.top !== box.top
            || stateBox.left !== box.left
            || stateBox.right !== box.right
            || stateBox.bottom !== box.bottom) {
            this.setState(box);
        }
    };
    SyncPosition.prototype.monitorElement = function () {
        var _this = this;
        this.monitorElementRaf = requestAnimationFrame(function () {
            _this.setStateFromElement();
            _this.monitorElement();
        });
    };
    SyncPosition.prototype.stopMonitorElement = function () {
        cancelAnimationFrame(this.monitorElementRaf);
    };
    return SyncPosition;
}(React.Component));
SyncPosition.defaultProps = {
    position: 'absolute'
};
exports.default = SyncPosition;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(442);

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule shallowCompare
*/

'use strict';

var shallowEqual = __webpack_require__(143);

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}

module.exports = shallowCompare;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var Spotlight = (function (_super) {
    tslib_1.__extends(Spotlight, _super);
    function Spotlight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spotlight.prototype.render = function () {
        var styles = this.getStyles();
        var _a = this.props, maskBox = _a.maskBox, highlightBox = _a.highlightBox;
        // relative Highlight Box
        var relHighlightBox = {
            top: highlightBox.top - maskBox.top,
            left: highlightBox.left - maskBox.left,
            right: highlightBox.right - maskBox.right,
            bottom: highlightBox.bottom - maskBox.bottom,
            height: highlightBox.height,
            width: highlightBox.width
        };
        var topStyle = Object.assign({}, styles.mask, {
            height: relHighlightBox.top,
        });
        var leftStyle = Object.assign({}, styles.mask, {
            top: relHighlightBox.top,
            height: relHighlightBox.height,
            right: relHighlightBox.right + relHighlightBox.width
        });
        var bottomStyle = Object.assign({}, styles.mask, {
            top: relHighlightBox.top + relHighlightBox.height,
            bottom: 0
        });
        var rightStyle = Object.assign({}, styles.mask, {
            top: relHighlightBox.top,
            left: relHighlightBox.left + relHighlightBox.width,
            height: relHighlightBox.height
        });
        var centerStyle = Object.assign({}, styles.center, {
            top: relHighlightBox.top,
            left: relHighlightBox.left,
            height: relHighlightBox.height,
            right: relHighlightBox.right
        });
        var rootStyle = Object.assign({}, styles.root, {
            top: maskBox.top,
            left: maskBox.left,
            bottom: maskBox.bottom,
            right: maskBox.right
        });
        return (React.createElement("div", { onTouchTap: this.props.onTouchTap, style: rootStyle },
            React.createElement("div", { style: centerStyle }),
            React.createElement("div", { style: topStyle }),
            React.createElement("div", { style: leftStyle }),
            React.createElement("div", { style: bottomStyle }),
            React.createElement("div", { style: rightStyle })));
    };
    Spotlight.prototype.getStyles = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                zIndex: this.props.zIndex,
                position: "absolute",
                userSelect: 'none',
                pointerEvents: "none"
            }),
            mask: {
                position: "absolute",
                background: "rgba(0,0,0,0.72)",
                cursor: 'pointer',
                zIndex: 1,
                top: 0,
                left: 0,
                right: 0,
                pointerEvents: "all"
            },
            center: {
                position: "absolute",
                pointerEvents: "none",
                border: this.props.showBorder ? "1px solid rgba(30,150,243,1)" : null,
                boxShadow: this.props.showBorder ? "0 0 7px 2px rgba(30,150,243,.3), inset 0 0 0px 1px #fff" : null,
                zIndex: 2
            }
        };
    };
    return Spotlight;
}(React.Component));
Spotlight.defaultProps = {
    showBorder: true
};
exports.default = Spotlight;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var ReactTransitionGroup = __webpack_require__(238);
var Animation = (function (_super) {
    tslib_1.__extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Animation.prototype.render = function () {
        return (React.createElement(ReactTransitionGroup, null,
            React.createElement(AnimationChild, { enter: this.props.enter, enterActive: this.props.enterActive, leave: this.props.leave, leaveActive: this.props.leaveActive, appear: this.props.appear, appearActive: this.props.appearActive }, this.props.children)));
    };
    return Animation;
}(React.Component));
exports.default = Animation;
var AnimationChild = (function (_super) {
    tslib_1.__extends(AnimationChild, _super);
    function AnimationChild() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationChild.prototype.render = function () {
        return this.props.children;
    };
    AnimationChild.prototype.componentWillAppear = function (callback) {
        this.applyStyles(this.props.appear);
        setTimeout(callback, 0);
    };
    AnimationChild.prototype.componentDidAppear = function () {
        this.applyStyles(this.props.appearActive);
    };
    AnimationChild.prototype.componentWillEnter = function (callback) {
        this.applyStyles(this.props.enter);
        setTimeout(callback, 0);
    };
    AnimationChild.prototype.componentDidEnter = function () {
        this.applyStyles(this.props.enterActive);
    };
    AnimationChild.prototype.componentWillLeave = function (callback) {
        this.applyStyles(this.props.leave);
        setTimeout(callback, 0);
    };
    AnimationChild.prototype.componentDidLeave = function () {
        this.applyStyles(this.props.leaveActive);
    };
    AnimationChild.prototype.applyStyles = function (styles) {
        var rootEl = ReactDOM.findDOMNode(this);
        var x;
        for (x in styles) {
            if (styles.hasOwnProperty(x)) {
                // Dynamically copying styles, cannot be type safe
                rootEl.style[x] = styles[x];
            }
        }
    };
    return AnimationChild;
}(React.Component));
var OpacityAnimation = (function (_super) {
    tslib_1.__extends(OpacityAnimation, _super);
    function OpacityAnimation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpacityAnimation.prototype.render = function () {
        return (React.createElement(Animation, { appear: this.props.fadeIn ? {
                opacity: 0,
                transition: ""
            } : {}, appearActive: this.props.fadeIn ? {
                opacity: 1,
                transition: "opacity " + this.props.duration + "s cubic-bezier(0.62, 0.28, 0.23, 0.99)"
            } : {}, leave: this.props.fadeOut ? {
                opacity: 1,
                transition: "opacity " + this.props.duration + "s cubic-bezier(0.62, 0.28, 0.23, 0.99)"
            } : {}, leaveActive: this.props.fadeOut ? {
                opacity: 0,
                transition: "opacity " + this.props.duration + "s cubic-bezier(0.62, 0.28, 0.23, 0.99)"
            } : {} }, this.props.children));
    };
    return OpacityAnimation;
}(React.Component));
OpacityAnimation.defaultProps = {
    fadeIn: true,
    fadeOut: false
};
exports.OpacityAnimation = OpacityAnimation;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ActionBar_1 = __webpack_require__(446);
var Modul_1 = __webpack_require__(197);
var ModulWithRedux_1 = __webpack_require__(493);
var DiyFeedbackSubmit_1 = __webpack_require__(495);
var l10n_1 = __webpack_require__(18);
var clear_1 = __webpack_require__(496);
var save_1 = __webpack_require__(497);
var autoprefixer_1 = __webpack_require__(438);
var IconTextButton_1 = __webpack_require__(459);
var ModulSection_1 = __webpack_require__(498);
/* tslint:disable:no-empty */
var NOOP = function () { };
exports.MODULE_ACTION_BAR_ELEMENT_ID = "diy-module-action-bar";
var ModuleActionBar = (function (_super) {
    tslib_1.__extends(ModuleActionBar, _super);
    function ModuleActionBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModuleActionBar.prototype.render = function () {
        var actionBarProps = this.props.open
            ? this.getOpenActionBarProps()
            : this.getClosedActionBarProps();
        return (React.createElement("div", null,
            React.createElement(ActionBar_1.default, tslib_1.__assign({ elementId: exports.MODULE_ACTION_BAR_ELEMENT_ID }, actionBarProps))));
    };
    ModuleActionBar.prototype.getButtons = function (cancelHandler, saveHandler) {
        var _this = this;
        var styles = this.getStyles();
        var module = Modul_1.default.getInstance(this.props.moduleId);
        if (module instanceof ModulSection_1.default) {
            return (React.createElement("div", { style: styles.buttons },
                React.createElement(IconTextButton_1.default, { Icon: React.createElement(save_1.default, null), text: l10n_1.default("section.actionBar.buttons.done.label"), style: styles.saveButton, isPrimary: true, onTouchTap: function () {
                        // Not using "this" because module is re-rendered and it will replace
                        // the module instance
                        var module = Modul_1.default.getInstance(_this.props.moduleId);
                        module.close(true, false, true, false);
                        module.emitCloseKpi();
                    }, dataTestId: "section-edit-done", isDisabled: saveHandler === NOOP })));
        }
        else {
            return (React.createElement("div", { style: styles.buttons },
                React.createElement(IconTextButton_1.default, { Icon: React.createElement(clear_1.default, null), text: l10n_1.default('cancel'), style: styles.cancelButton, onTouchTap: cancelHandler, dataTestId: "action-bar-btn-cancel", isDisabled: cancelHandler === NOOP, isSecondary: true }),
                React.createElement(IconTextButton_1.default, { Icon: React.createElement(save_1.default, null), text: l10n_1.default('save'), style: styles.saveButton, isPrimary: true, onTouchTap: saveHandler, dataTestId: "action-bar-btn-save", isDisabled: saveHandler === NOOP })));
        }
    };
    ModuleActionBar.prototype.getFeedbackContext = function (module) {
        if (module.getModuleType() === Modul_1.ModuleType.SECTION) {
            var data = module.getData();
            return "module.section." + data.base + "." + data.variant;
        }
        else {
            var parentSection = module.getParentSection();
            if (parentSection) {
                var data = parentSection.getData();
                return "module.section." + data.base + "." + data.variant + "/module." + module.getModuleType();
            }
            else {
                return "module." + module.getModuleType();
            }
        }
    };
    ModuleActionBar.prototype.getOpenActionBarProps = function () {
        var _this = this;
        var module = Modul_1.default.getInstance(this.props.moduleId);
        var tabs = null;
        // XXX in some scenarios (modules that use CKEditor, if first operation is paste on Firefox)
        // re-rendering with a
        // new tabOptions got from module will break
        // due to some weird bug, but using a cached tabOptions fixes the issue
        if (this.lastModule === module && this.lastTabs) {
            tabs = this.lastTabs;
        }
        else {
            tabs = module.getActionBarTabs();
            this.lastTabs = tabs;
        }
        var undoHandler = null;
        var redoHandler = null;
        if (module instanceof ModulWithRedux_1.default && module.hasUndoRedo) {
            undoHandler = module.undoHandler;
            redoHandler = module.redoHandler;
        }
        this.lastModule = module;
        return {
            open: true,
            onHelpClick: module.openHelpArticle.bind(module),
            buttons: this.getButtons(function () { return module.close(true, true, false, true); }, function () { return module.onSaveBtnClick(); }),
            autoScrollElement: module.getContentElement(),
            tabs: tabs,
            currentTab: this.props.currentTab,
            hasFeedbackbutton: true,
            feedbackFeatureName: module.textLabel,
            feedbackContext: this.getFeedbackContext(module),
            onFeedbackSubmit: DiyFeedbackSubmit_1.DiyFeedbackSubmit,
            onUndoClick: undoHandler,
            onRedoClick: redoHandler,
            undoEnabled: this.props.undoEnabled,
            redoEnabled: this.props.redoEnabled,
            onTabChange: function (v) {
                _this.props.onTabChange({ nextTab: v });
                module.onActionBarTabChange(v);
            }
        };
    };
    ModuleActionBar.prototype.getClosedActionBarProps = function () {
        return {
            open: false,
            onHelpClick: NOOP,
            buttons: this.getButtons(NOOP, NOOP),
            autoScrollElement: null,
            tabs: null,
            hasFeedbackbutton: true,
            feedbackFeatureName: null,
            feedbackContext: null,
            onFeedbackSubmit: DiyFeedbackSubmit_1.DiyFeedbackSubmit,
            onUndoClick: null,
            onRedoClick: null,
            undoEnabled: false,
            redoEnabled: false
        };
    };
    ModuleActionBar.prototype.getStyles = function () {
        return {
            buttons: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex'
            }), {
                marginLeft: 12
            }),
            cancelButton: {
                marginRight: 4
            },
            saveButton: {
                minWidth: 72
            }
        };
    };
    return ModuleActionBar;
}(React.Component));
exports.default = ModuleActionBar;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var diyLightTheme = __webpack_require__(241);
var styles_1 = __webpack_require__(242);
var ActionBarToolbar_1 = __webpack_require__(447);
var autoprefixer_1 = __webpack_require__(438);
var Paper_1 = __webpack_require__(391);
var IOSFixFixed_1 = __webpack_require__(487);
var watchSize_1 = __webpack_require__(488);
var animatedScroll_1 = __webpack_require__(489);
var page_1 = __webpack_require__(492);
var ActionBar = (function (_super) {
    tslib_1.__extends(ActionBar, _super);
    function ActionBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionBar.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    ActionBar.prototype.getStyles = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                position: "fixed",
                zIndex: 101000,
                top: 0,
                left: 0,
                right: 0,
                transform: "translate3d(0, " + (this.props.open ? 0 : -100) + "%, 0)",
                transition: "transform .6s ease-in-out"
            }),
            gradient: {
                left: 0,
                bottom: '-70px',
                position: 'absolute',
                pointerEvents: 'none',
                height: '70px',
                width: '100%',
                opacity: this.props.open ? 1 : 0,
                transition: 'opacity .6s ease-in-out',
                background: 'linear-gradient(to top, ' +
                    'rgba(0, 0, 0, 0) 0%, ' +
                    'rgba(0, 0, 0, 0.01) 40%, ' +
                    'rgba(0, 0, 0, 0.05) 70%, ' +
                    'rgba(0, 0, 0, 0.15) 88%, ' +
                    'rgba(0, 0, 0, 0.3) 100%' +
                    ')'
            },
            content: {
                position: "relative",
                zIndex: 1,
                background: styles_1.colors.white,
                padding: "4px 8px"
            }
        };
    };
    ActionBar.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var TOOLBAR_HEIGHT = 56;
        var CONTENT_HEIGHT = 56;
        var ACTIONBAR_MIN_HEIGHT = TOOLBAR_HEIGHT + CONTENT_HEIGHT;
        if (prevProps.open !== this.props.open) {
            var handleHeightChange_1 = function (height) {
                page_1.makeTopSpace(Math.max(height, ACTIONBAR_MIN_HEIGHT), true);
            };
            if (this.props.open) {
                this.topSpaceWhenClosed = page_1.getTopSpace();
                var actionBarEl = ReactDOM.findDOMNode(this);
                this.actionBarSizeUnwatch = watchSize_1.watchSize(actionBarEl, function (w, h) {
                    handleHeightChange_1(h);
                });
                handleHeightChange_1(actionBarEl.offsetHeight);
            }
            else {
                this.actionBarSizeUnwatch();
                page_1.makeTopSpace(this.topSpaceWhenClosed, true);
            }
        }
        if (this.props.open && !this.props.autoScrollElement) {
            return;
        }
        var newHeight = 0;
        var actionBarRect;
        if (this.props.open) {
            actionBarRect = ReactDOM.findDOMNode(this).getBoundingClientRect();
            newHeight = actionBarRect.height;
        }
        if (prevProps.open !== this.props.open) {
            this.autoScroll();
        }
        if (this.props.currentTab !== prevProps.currentTab) {
            this.content.style.transition = "";
            this.content.style.opacity = "0";
            setTimeout(function () {
                _this.content.style.transition = "all 0.5s";
                _this.content.style.opacity = "1";
            }, 0);
        }
    };
    ActionBar.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var content = this.props.tabs
            ? this.props.tabs[this.props.currentTab].content
            : this.props.children;
        return (React.createElement(IOSFixFixed_1.IOSFixFixed, null,
            React.createElement(Paper_1.default, { style: styles.root, id: this.props.elementId },
                React.createElement(ActionBarToolbar_1.default, { titleText: this.props.titleText, onHelpClick: this.props.onHelpClick, onUndoClick: this.props.onUndoClick, onRedoClick: this.props.onRedoClick, buttons: this.props.buttons, undoEnabled: this.props.undoEnabled, redoEnabled: this.props.redoEnabled, tabs: this.props.tabs, currentTab: this.props.currentTab, onTabChange: this.props.onTabChange, hasFeedbackbutton: this.props.hasFeedbackbutton, feedbackContext: this.props.feedbackContext, onFeedbackSubmit: this.props.onFeedbackSubmit }),
                React.createElement("div", { style: styles.content },
                    React.createElement("div", { ref: function (ref) { return _this.content = ref; } }, content)),
                React.createElement("div", { style: styles.gradient }))));
    };
    ActionBar.prototype.autoScroll = function () {
        var AUTO_SCROLL_DURATION = 500; // ms
        var AUTO_SCROLL_TOP_OFFSET = 50; // px
        var actionBarRect = ReactDOM.findDOMNode(this).getBoundingClientRect();
        if (this.props.autoScrollElement) {
            var autoScrollElementRect = this.props.autoScrollElement.getBoundingClientRect();
            var scrollDelta = actionBarRect.height + AUTO_SCROLL_TOP_OFFSET - autoScrollElementRect.top;
            if (scrollDelta > 0) {
                animatedScroll_1.animatedScrollByY(-scrollDelta, AUTO_SCROLL_DURATION);
            }
        }
    };
    return ActionBar;
}(React.Component));
ActionBar.defaultProps = {
    hasFeedbackbutton: false
};
ActionBar.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = ActionBar;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Toolbar_1 = __webpack_require__(448);
var ToolbarTitle_1 = __webpack_require__(449);
var help_outline_1 = __webpack_require__(450);
var undo_1 = __webpack_require__(451);
var redo_1 = __webpack_require__(452);
var Logo_1 = __webpack_require__(453);
var Tabs_1 = __webpack_require__(454);
var Tab_1 = __webpack_require__(458);
var IconTextButton_1 = __webpack_require__(459);
var FeedbackButton_1 = __webpack_require__(461);
var l10n_1 = __webpack_require__(18);
var autoprefixer_1 = __webpack_require__(438);
var ActionBarToolbar = (function (_super) {
    tslib_1.__extends(ActionBarToolbar, _super);
    function ActionBarToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionBarToolbar.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement(Toolbar_1.default, { style: styles.root },
            React.createElement("div", { key: "logo", style: styles.logoToolbarGroup },
                React.createElement("div", { style: styles.logoWrapper },
                    React.createElement(Logo_1.default, { style: styles.logo })),
                this.props.titleText
                    ? (React.createElement(ToolbarTitle_1.default, { text: this.props.titleText, style: styles.title }))
                    : null,
                this.props.tabs
                    ? this.renderTabs()
                    : null),
            React.createElement("div", { key: "spacer1", style: styles.spacerToolbarGroup }),
            React.createElement("div", { key: "undoRedo", style: styles.undoRedoToolbarGroup },
                this.props.onUndoClick
                    ?
                        React.createElement(IconTextButton_1.default, { style: styles.undoRedoIcon, Icon: React.createElement(undo_1.default, null), text: l10n_1.default("actionBar.undo"), onTouchTap: this.props.onUndoClick, dataTestId: "action-bar-btn-undo", isDisabled: !this.props.undoEnabled, isSecondary: true })
                    :
                        null,
                this.props.onRedoClick
                    ?
                        React.createElement(IconTextButton_1.default, { style: styles.undoRedoIcon, Icon: React.createElement(redo_1.default, null), text: l10n_1.default("actionBar.redo"), onTouchTap: this.props.onRedoClick, dataTestId: "action-bar-btn-redo", isDisabled: !this.props.redoEnabled, isSecondary: true })
                    :
                        null),
            React.createElement("div", { key: "spacer2", style: styles.spacerToolbarGroup }),
            this.props.hasFeedbackbutton
                ? (React.createElement("div", { key: "feedback", style: styles.feedbackToolbarGroup },
                    React.createElement(FeedbackButton_1.default, { feedbackFeatureName: this.props.feedbackFeatureName, feedbackContext: this.props.feedbackContext, onFeedbackSubmit: this.props.onFeedbackSubmit })))
                : null,
            this.props.onHelpClick
                ? (React.createElement("div", { key: "help", style: styles.helpToolbarGroup },
                    React.createElement(IconTextButton_1.default, { Icon: React.createElement(help_outline_1.default, null), text: l10n_1.default("helptoolbar.title"), dataTestId: "action-bar-btn-help", onTouchTap: this.props.onHelpClick, isSecondary: true })))
                : null,
            React.createElement("div", { key: "buttons", style: styles.buttonsToolbarGroup }, this.props.buttons)));
    };
    ActionBarToolbar.prototype.renderTabs = function () {
        return (React.createElement(Tabs_1.default, { onChange: this.props.onTabChange, value: this.props.currentTab }, this.props.tabs.map(function (tab, index) {
            return (React.createElement(Tab_1.default, { key: index, label: tab.label }));
        })));
    };
    ActionBarToolbar.prototype.getStyles = function () {
        return {
            root: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex',
                alignItems: 'center'
            }), {
                paddingLeft: 0,
                paddingRight: 4,
                background: '#003d8f'
            }),
            logoToolbarGroup: autoprefixer_1.autoprefixer({
                display: 'flex'
            }),
            logoWrapper: {
                backgroundColor: 'transparent',
                padding: 11,
                marginRight: 8
            },
            logo: {
                height: 34
            },
            title: {
                fontSize: 14,
                paddingLeft: 12,
            },
            spacerToolbarGroup: autoprefixer_1.autoprefixer({
                flexGrow: 1
            }),
            undoRedoToolbarGroup: autoprefixer_1.autoprefixer({
                display: 'flex'
            }),
            undoRedoIcon: {
                marginRight: 12
            },
            feedbackToolbarGroup: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex'
            }), {
                marginRight: 4
            }),
            helpToolbarGroup: autoprefixer_1.autoprefixer({
                display: 'flex'
            }),
            buttonsToolbarGroup: autoprefixer_1.autoprefixer({
                display: 'flex'
            })
        };
    };
    return ActionBarToolbar;
}(React.Component));
exports.default = ActionBarToolbar;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var noGutter = props.noGutter;
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      backgroundColor: toolbar.backgroundColor,
      height: toolbar.height,
      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
}

var Toolbar = function (_Component) {
  _inherits(Toolbar, _Component);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Toolbar).apply(this, arguments));
  }

  _createClass(Toolbar, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var className = _props.className;
      var noGutter = _props.noGutter;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['children', 'className', 'noGutter', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        children
      );
    }
  }]);

  return Toolbar;
}(_react.Component);

Toolbar.propTypes = {
  /**
   * Can be a `ToolbarGroup` to render a group of related items.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Do not apply `desktopGutter` to the `Toolbar`.
   */
  noGutter: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
Toolbar.defaultProps = {
  noGutter: false
};
Toolbar.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Toolbar;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      paddingRight: baseTheme.spacing.desktopGutterLess,
      lineHeight: toolbar.height + 'px',
      fontSize: toolbar.titleFontSize,
      position: 'relative',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  };
}

var ToolbarTitle = function (_Component) {
  _inherits(ToolbarTitle, _Component);

  function ToolbarTitle() {
    _classCallCheck(this, ToolbarTitle);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ToolbarTitle).apply(this, arguments));
  }

  _createClass(ToolbarTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var className = _props.className;
      var style = _props.style;
      var text = _props.text;

      var other = _objectWithoutProperties(_props, ['className', 'style', 'text']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        text
      );
    }
  }]);

  return ToolbarTitle;
}(_react.Component);

ToolbarTitle.muiName = 'ToolbarTitle';
ToolbarTitle.propTypes = {
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The text to be displayed.
   */
  text: _react.PropTypes.string
};
ToolbarTitle.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = ToolbarTitle;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHelpOutline = function ActionHelpOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
  );
};
ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
ActionHelpOutline.displayName = 'ActionHelpOutline';
ActionHelpOutline.muiName = 'SvgIcon';

exports.default = ActionHelpOutline;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentUndo = function ContentUndo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z' })
  );
};
ContentUndo = (0, _pure2.default)(ContentUndo);
ContentUndo.displayName = 'ContentUndo';
ContentUndo.muiName = 'SvgIcon';

exports.default = ContentUndo;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRedo = function ContentRedo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z' })
  );
};
ContentRedo = (0, _pure2.default)(ContentRedo);
ContentRedo.displayName = 'ContentRedo';
ContentRedo.muiName = 'SvgIcon';

exports.default = ContentRedo;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var features = __webpack_require__(25);
var Logo = (function (_super) {
    tslib_1.__extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Logo.prototype.render = function () {
        // tslint:disable:max-line-length
        return this.getMarkup();
        // tslint:enable:max-line-length
    };
    Logo.prototype.getStyle = function () {
        var style = (features('isNonDefaultLogoInMarket')) ? "enable-background:new 0 0 254.25 74.13;" : "block";
        return Object.assign({}, this.props.style || {}, { display: style });
    };
    Logo.prototype.getMarkup = function () {
        if (features('isNonDefaultLogoInMarket')) {
            return (React.createElement("svg", { id: "_1_1_IONOS", "data-name": "IONOS", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 254.25 74.13", style: this.getStyle() },
                React.createElement("defs", null,
                    React.createElement("style", null, ".cls-1{fill:#fff;}")),
                React.createElement("title", null, "LOGO_IONOS_White_RGB"),
                React.createElement("path", { className: "cls-1", d: "M242.51,79.58a18.12,18.12,0,0,1-3.74-.38A19.37,19.37,0,0,1,226,70.06l-.07-.13A5.75,5.75,0,0,1,228,62.35a5.52,5.52,0,0,1,2.85-.79,5.64,5.64,0,0,1,4.91,2.88l.19.32.6.81.8.81A7.84,7.84,0,0,0,241,68.15a8,8,0,0,0,6.3-1.44A7.63,7.63,0,0,0,250.49,61a7.86,7.86,0,0,0-2.19-6.12s-18.44-19-18.84-19.53L228.55,34a18,18,0,0,1-2.77-11.34,18.41,18.41,0,0,1,2.39-7.84l.8-1.4a17,17,0,0,1,5.57-5.06l.91-.65a18.54,18.54,0,0,1,25,7,5.51,5.51,0,0,1,.58,4.26,5.63,5.63,0,0,1-2.67,3.46,5.36,5.36,0,0,1-2.75.75,5.61,5.61,0,0,1-4.88-2.87,7.35,7.35,0,0,0-4.93-3.49,7.65,7.65,0,0,0-6,1.35A7.3,7.3,0,0,0,237,23.5a7.44,7.44,0,0,0,2,5.72l17.33,17.87a19.18,19.18,0,0,1-13.85,32.49Z", transform: "translate(-7.52 -5.46)" }),
                React.createElement("path", { className: "cls-1", d: "M187.69,79.57a18.65,18.65,0,0,1-18.63-18.63V24.09a18.63,18.63,0,1,1,37.26,0V60.94A18.65,18.65,0,0,1,187.69,79.57Zm0-62.86a7.39,7.39,0,0,0-7.38,7.38V60.94a7.3,7.3,0,0,0,7.38,7.38,7.39,7.39,0,0,0,7.38-7.38V24.09A7.48,7.48,0,0,0,187.69,16.71Z", transform: "translate(-7.52 -5.46)" }),
                React.createElement("path", { className: "cls-1", d: "M115.33,43.47V74a5.62,5.62,0,0,1-11.24,0V20.13Zm30.35,21.46V11.08a5.63,5.63,0,0,0-11.25,0v30.5ZM114.8,8.65l0-.11a5.86,5.86,0,0,0-5.09-3,5.15,5.15,0,0,0-1.13.12,5.49,5.49,0,0,0-4.44,5.47v1.29L135,76.49a5.8,5.8,0,0,0,5,3.08,5.18,5.18,0,0,0,1.29-.16A5.52,5.52,0,0,0,145.68,74V72.73S115.63,10.36,114.8,8.65Z", transform: "translate(-7.52 -5.46)" }),
                React.createElement("path", { className: "cls-1", d: "M61.92,79.57A18.64,18.64,0,0,1,43.29,60.94V24.09a18.63,18.63,0,0,1,37.26,0V60.94A18.64,18.64,0,0,1,61.92,79.57Zm0-62.86a7.37,7.37,0,0,0-7.38,7.38V60.94a7.38,7.38,0,1,0,14.76,0V24.09a7.48,7.48,0,0,0-7.38-7.38Z", transform: "translate(-7.52 -5.46)" }),
                React.createElement("path", { className: "cls-1", d: "M13.63,79.54a6.08,6.08,0,0,1-6.11-6.18V11.49a6.11,6.11,0,0,1,6.15-6A6,6,0,0,1,19.57,10a4,4,0,0,1,.1.43l0,.27a5.47,5.47,0,0,1,.08,1s0,61,0,61.7A6.1,6.1,0,0,1,13.63,79.54Z", transform: "translate(-7.52 -5.46)" })));
        }
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 394.59 113.39", style: this.getStyle() },
            React.createElement("defs", null,
                React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-5{fill:#fff;}\
                    .cls-4{fill:#003d8f;}.cls-5{fill-rule:evenodd;}"),
                React.createElement("clipPath", { id: "clip-path" },
                    React.createElement("path", { className: "cls-1", d: "M0,0H422.05V113.39H0V0Z" }))),
            React.createElement("g", { className: "cls-2" },
                React.createElement("g", { id: "IONOS" },
                    React.createElement("path", { className: "cls-3", d: "M375.33,93.56a18.86,18.86,0,0,1-3.75-.38A19.42,19.42,0,0,1,358.78,84l-.07-.12a5.74,5.74,0,0,1,2.12-7.59,5.49,5.49,0,0,1,2.85-.79,5.65,5.65,0,0,1,4.9,2.88c.06.11.13.21.2.32l.59.81.8.81a7.75,7.75,0,0,0,3.66,1.77,8.07,8.07,0,0,0,6.31-1.44A7.61,7.61,0,0,0,383.3,75a7.86,7.86,0,0,0-2.19-6.12s-18.44-19-18.83-19.52L361.37,48a17.94,17.94,0,0,1-2.77-11.34A18.36,18.36,0,0,1,361,28.84l.81-1.41a16.92,16.92,0,0,1,5.57-5.05l.91-.66a18.52,18.52,0,0,1,25,7,5.46,5.46,0,0,1,.59,4.26,5.61,5.61,0,0,1-2.68,3.46,5.41,5.41,0,0,1-2.74.74,5.59,5.59,0,0,1-4.88-2.87,7.36,7.36,0,0,0-4.93-3.48,7.63,7.63,0,0,0-6,1.34,7.29,7.29,0,0,0-2.83,5.28,7.39,7.39,0,0,0,2,5.72l17.32,17.86A19.09,19.09,0,0,1,387,89.65,19.55,19.55,0,0,1,375.33,93.56Z" }),
                    React.createElement("path", { className: "cls-3", d: "M320.51,93.55a18.66,18.66,0,0,1-18.64-18.63V38.06a18.64,18.64,0,0,1,37.27,0V74.92A18.65,18.65,0,0,1,320.51,93.55Zm0-62.87a7.4,7.4,0,0,0-7.39,7.38V74.92a7.31,7.31,0,0,0,7.39,7.38,7.39,7.39,0,0,0,7.38-7.38V38.06A7.48,7.48,0,0,0,320.51,30.68Z" }),
                    React.createElement("path", { className: "cls-3", d: "M248.15,57.44V87.92a5.63,5.63,0,0,1-11.25,0V34.1ZM278.5,78.9V25.06a5.63,5.63,0,1,0-11.25,0v30.5ZM247.62,22.62l-.05-.1a5.86,5.86,0,0,0-5.09-3.06,6,6,0,0,0-1.14.12,5.51,5.51,0,0,0-4.44,5.48v1.28l30.93,64.12a5.79,5.79,0,0,0,5,3.09,4.72,4.72,0,0,0,1.28-.17,5.51,5.51,0,0,0,4.39-5.46V86.71S248.44,24.34,247.62,22.62Z" }),
                    React.createElement("path", { className: "cls-3", d: "M194.74,93.55A18.68,18.68,0,0,1,176.1,74.92V38.06a18.64,18.64,0,0,1,37.27,0V74.92a18.68,18.68,0,0,1-18.63,18.63Zm0-62.87a7.41,7.41,0,0,0-7.39,7.38V74.92a7.39,7.39,0,0,0,14.77,0V38.06a7.52,7.52,0,0,0-7.38-7.38Z" }),
                    React.createElement("path", { className: "cls-3", d: "M146.45,93.52a6.08,6.08,0,0,1-6.11-6.19V25.47a6.09,6.09,0,0,1,6.14-6,6,6,0,0,1,5.89,4.51,2.33,2.33,0,0,1,.11.44l0,.26a6.58,6.58,0,0,1,.08,1s0,61,0,61.7A6.11,6.11,0,0,1,146.45,93.52Z" })),
                React.createElement("g", { id: "_1_1" },
                    React.createElement("polygon", { className: "cls-3", points: "0 0 113.39 0 113.39 113.39 0 113.39 0 0 0 0" }),
                    React.createElement("polygon", { className: "cls-4", points: "1.91 1.91 111.57 1.91 111.57 111.56 1.91 111.56 1.91 1.91 1.91 1.91" }),
                    React.createElement("path", { className: "cls-5", d: "M69.66,55.82c.08,1.27.16,2.43.18,2.83.13,3.33-.51,7.45-1.25,8.12l-8.92-12.1c6-5,8-8.55,8-13.32,0-6.52-5.06-11.28-12.21-11.28-7.71,0-13.15,4.68-13.15,11,0,3.73,1,5.8,5.62,11.76-7.24,4.18-11,10-10.61,15.63.68,9.44,7.86,14.74,18.3,14.8,5.33,0,8.64-1.1,12.4-4.11l2.3,3.1H80.5l-6.6-8.75c3.13-4,4.15-8.09,4.15-14.61,0-.4-.1-2-.1-3.11ZM54.75,48.49c-3-3.82-3.61-5-3.61-7.14a3.94,3.94,0,0,1,4.26-3.86c2.57,0,4.18,1.48,4.18,3.78s-1.3,4.67-4.83,7.22Zm8.07,24A10.66,10.66,0,0,1,55.6,75.2c-5.22,0-8.77-2.72-8.9-7-.08-2.78,1.75-5.74,6.33-8.77l9.79,13ZM31,82.3H20.64V39H12.38V30.68H31V82.3Zm66,0H86.67V39H78.41V30.68H97V82.3Z" })))));
    };
    return Logo;
}(React.Component));
exports.default = Logo;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Tabs_1 = __webpack_require__(455);
var Tab_1 = __webpack_require__(458);
var autoprefixer_1 = __webpack_require__(438);
var Tabs = (function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tabs.prototype.render = function () {
        var _this = this;
        var style = this.getStyle();
        return (React.createElement(Tabs_1.default, { onChange: this.props.onChange, tabItemContainerStyle: style.root, inkBarStyle: { display: "none" }, value: this.props.value }, this.props.children.map(function (tab, i) {
            return React.createElement(Tab_1.default, tslib_1.__assign({}, tab.props, { style: _this.props.value === i ? style.selected : style.normal, value: i, key: i }));
        })));
    };
    Tabs.prototype.getStyle = function () {
        var normal = {
            display: 'block',
            fontSize: 14,
            color: "#fff",
            paddingLeft: 12,
            paddingRight: 12,
            width: "auto",
            textTransform: "none",
            fontWeight: 600
        };
        return {
            root: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex'
            }), {
                background: "transparent",
                padding: "8px 0 0 0"
            }),
            normal: normal,
            selected: Object.assign({}, normal, {
                background: "#fff",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                boxShadow: "0 0 1px rgba(0, 0, 0, 0.24), 0 1px 6px rgba(0, 0, 0, 0.12)",
                cursor: "default",
                color: "#3c7bc7"
            })
        };
    };
    return Tabs;
}(React.Component));
exports.default = Tabs;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TabTemplate = __webpack_require__(456);

var _TabTemplate2 = _interopRequireDefault(_TabTemplate);

var _InkBar = __webpack_require__(457);

var _InkBar2 = _interopRequireDefault(_InkBar);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    tabItemContainer: {
      width: '100%',
      backgroundColor: tabs.backgroundColor,
      whiteSpace: 'nowrap'
    }
  };
}

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tabs)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
      var valueLink = _this.getValueLink(_this.props);
      var index = tab.props.index;

      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
        valueLink.requestChange(value, event, tab);
      }

      _this.setState({ selectedIndex: index });

      if (tab.props.onActive) {
        tab.props.onActive(tab);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tabs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var valueLink = this.getValueLink(this.props);
      var initialIndex = this.props.initialSelectedIndex;

      this.setState({
        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps, nextContext) {
      var valueLink = this.getValueLink(newProps);
      var newState = {
        muiTheme: nextContext.muiTheme || this.context.muiTheme
      };

      if (valueLink.value !== undefined) {
        newState.selectedIndex = this.getSelectedIndex(newProps);
      }

      this.setState(newState);
    }
  }, {
    key: 'getEvenWidth',
    value: function getEvenWidth() {
      return parseInt(window.getComputedStyle(_reactDom2.default.findDOMNode(this)).getPropertyValue('width'), 10);
    }
  }, {
    key: 'getTabs',
    value: function getTabs() {
      var tabs = [];
      _react2.default.Children.forEach(this.props.children, function (tab) {
        if (_react2.default.isValidElement(tab)) {
          tabs.push(tab);
        }
      });
      return tabs;
    }
  }, {
    key: 'getTabCount',
    value: function getTabCount() {
      return this.getTabs().length;
    }

    // Do not use outside of this component, it will be removed once valueLink is deprecated

  }, {
    key: 'getValueLink',
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'getSelectedIndex',
    value: function getSelectedIndex(props) {
      var valueLink = this.getValueLink(props);
      var selectedIndex = -1;

      this.getTabs().forEach(function (tab, index) {
        if (valueLink.value === tab.props.value) {
          selectedIndex = index;
        }
      });

      return selectedIndex;
    }
  }, {
    key: 'getSelected',
    value: function getSelected(tab, index) {
      var valueLink = this.getValueLink(this.props);
      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var contentContainerClassName = _props.contentContainerClassName;
      var contentContainerStyle = _props.contentContainerStyle;
      var initialSelectedIndex = _props.initialSelectedIndex;
      var inkBarStyle = _props.inkBarStyle;
      var style = _props.style;
      var tabItemContainerStyle = _props.tabItemContainerStyle;
      var tabTemplate = _props.tabTemplate;

      var other = _objectWithoutProperties(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'style', 'tabItemContainerStyle', 'tabTemplate']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var valueLink = this.getValueLink(this.props);
      var tabValue = valueLink.value;
      var tabContent = [];
      var width = 100 / this.getTabCount();

      var tabs = this.getTabs().map(function (tab, index) {
         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;

         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;

        tabContent.push(tab.props.children ? _react2.default.createElement(tabTemplate || _TabTemplate2.default, {
          key: index,
          selected: _this2.getSelected(tab, index)
        }, tab.props.children) : undefined);

        return _react2.default.cloneElement(tab, {
          key: index,
          index: index,
          selected: _this2.getSelected(tab, index),
          width: width + '%',
          onTouchTap: _this2.handleTabTouchTap
        });
      });

      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
        left: width * this.state.selectedIndex + '%',
        width: width + '%',
        style: inkBarStyle
      }) : null;

      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';

      return _react2.default.createElement(
        'div',
        _extends({}, other, {
          style: prepareStyles((0, _simpleAssign2.default)({}, style))
        }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
          tabs
        ),
        _react2.default.createElement(
          'div',
          { style: { width: inkBarContainerWidth } },
          inkBar
        ),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
            className: contentContainerClassName
          },
          tabContent
        )
      );
    }
  }]);

  return Tabs;
}(_react.Component);

Tabs.propTypes = {
  /**
   * Should be used to pass `Tab` components.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * The css class name of the content's container.
   */
  contentContainerClassName: _react.PropTypes.string,
  /**
   * Override the inline-styles of the content's container.
   */
  contentContainerStyle: _react.PropTypes.object,
  /**
   * Specify initial visible tab index.
   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
   * `initialSelectedIndex` will revert back to default.
   * If `initialSlectedIndex` is set to any negative value, no tab will be selected intially.
   */
  initialSelectedIndex: _react.PropTypes.number,
  /**
   * Override the inline-styles of the InkBar.
   */
  inkBarStyle: _react.PropTypes.object,
  /**
   * Called when the selected value change.
   */
  onChange: _react.PropTypes.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Override the inline-styles of the tab-labels container.
   */
  tabItemContainerStyle: _react.PropTypes.object,
  /**
   * Override the default tab template used to wrap the content of each tab element.
   */
  tabTemplate: _react.PropTypes.func,
  /**
   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
   */
  value: _react.PropTypes.any
};
Tabs.defaultProps = {
  initialSelectedIndex: 0,
  onChange: function onChange() {}
};
Tabs.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Tabs;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabTemplate = function (_Component) {
  _inherits(TabTemplate, _Component);

  function TabTemplate() {
    _classCallCheck(this, TabTemplate);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(TabTemplate).apply(this, arguments));
  }

  _createClass(TabTemplate, [{
    key: 'render',
    value: function render() {
      var styles = {
        width: '100%',
        position: 'relative',
        textAlign: 'initial'
      };

      if (!this.props.selected) {
        styles.height = 0;
        styles.overflow = 'hidden';
      }

      return _react2.default.createElement(
        'div',
        { style: styles },
        this.props.children
      );
    }
  }]);

  return TabTemplate;
}(_react.Component);

TabTemplate.propTypes = {
  children: _react.PropTypes.node,
  selected: _react.PropTypes.bool
};
exports.default = TabTemplate;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var inkBar = context.muiTheme.inkBar;


  return {
    root: {
      left: props.left,
      width: props.width,
      bottom: 0,
      display: 'block',
      backgroundColor: props.color || inkBar.backgroundColor,
      height: 2,
      marginTop: -2,
      position: 'relative',
      transition: _transitions2.default.easeOut('1s', 'left')
    }
  };
}

var InkBar = function (_Component) {
  _inherits(InkBar, _Component);

  function InkBar() {
    _classCallCheck(this, InkBar);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(InkBar).apply(this, arguments));
  }

  _createClass(InkBar, [{
    key: 'render',
    value: function render() {
      var style = this.props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
    }
  }]);

  return InkBar;
}(_react.Component);

InkBar.propTypes = {
  color: _react.PropTypes.string,
  left: _react.PropTypes.string.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  width: _react.PropTypes.string.isRequired
};
InkBar.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = InkBar;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _EnhancedButton = __webpack_require__(410);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    root: {
      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
      fontWeight: 500,
      fontSize: 14,
      width: props.width,
      textTransform: 'uppercase',
      padding: 0
    },
    button: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: props.label && props.icon ? 72 : 48
    }
  };
}

var Tab = function (_Component) {
  _inherits(Tab, _Component);

  function Tab() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tab)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
      if (_this.props.onTouchTap) {
        _this.props.onTouchTap(_this.props.value, event, _this);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tab, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var icon = _props.icon;
      var index = _props.index;
      var onActive = _props.onActive;
      var onTouchTap = _props.onTouchTap;
      var selected = _props.selected;
      var label = _props.label;
      var style = _props.style;
      var value = _props.value;
      var width = _props.width;

      var other = _objectWithoutProperties(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'style', 'value', 'width']);

      var styles = getStyles(this.props, this.context);

      var iconElement = void 0;
      if (icon && _react2.default.isValidElement(icon)) {
        var iconProps = {
          style: {
            fontSize: 24,
            color: styles.root.color,
            marginBottom: label ? 5 : 0
          }
        };
        // If it's svg icon set color via props
        if (icon.type.muiName !== 'FontIcon') {
          iconProps.color = styles.root.color;
        }
        iconElement = _react2.default.cloneElement(icon, iconProps);
      }

      var rippleOpacity = 0.3;
      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        _extends({}, other, {
          style: (0, _simpleAssign2.default)(styles.root, style),
          focusRippleColor: rippleColor,
          touchRippleColor: rippleColor,
          focusRippleOpacity: rippleOpacity,
          touchRippleOpacity: rippleOpacity,
          onTouchTap: this.handleTouchTap
        }),
        _react2.default.createElement(
          'div',
          { style: styles.button },
          iconElement,
          label
        )
      );
    }
  }]);

  return Tab;
}(_react.Component);

Tab.muiName = 'Tab';
Tab.propTypes = {
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
   */
  icon: _react.PropTypes.node,
  /**
   * @ignore
   */
  index: _react.PropTypes.any,
  /**
   * Sets the text value of the tab item to the string specified.
   */
  label: _react.PropTypes.node,
  /**
   * Fired when the active tab changes by touch or tap.
   * Use this event to specify any functionality when an active tab changes.
   * For example - we are using this to route to home when the third tab becomes active.
   * This function will always recieve the active tab as it\'s first argument.
   */
  onActive: _react.PropTypes.func,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  onTouchTap: _react.PropTypes.func,
  /**
   * @ignore
   * Defines if the current tab is selected or not.
   * The Tabs component is responsible for setting this property.
   */
  selected: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * If value prop passed to Tabs component, this value prop is also required.
   * It assigns a value to the tab so that it can be selected by the Tabs.
   */
  value: _react.PropTypes.any,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  width: _react.PropTypes.string
};
Tab.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Tab;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var TouchRipple_1 = __webpack_require__(376);
var autoprefixer_1 = __webpack_require__(438);
var colors_1 = __webpack_require__(460);
var IconTextButton = (function (_super) {
    tslib_1.__extends(IconTextButton, _super);
    function IconTextButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onTouchTap = function (event) {
            // prevent ghost click events on touch devices
            event.preventDefault();
            if (_this.props.isDisabled) {
                return;
            }
            if (_this.props.isPressable) {
                var newState = {};
                newState.isPressed = !_this.state.isPressed;
                _this.setState(newState);
                if (_this.props.onTouchTap) {
                    _this.props.onTouchTap(event, newState.isPressed);
                }
            }
            else {
                if (_this.props.onTouchTap) {
                    _this.props.onTouchTap(event);
                }
            }
        };
        _this.onMouseDown = function (event) {
            if (_this.props.isDisabled) {
                return;
            }
            if (!_this.state.isActive) {
                var newState = {};
                newState.isActive = true;
                _this.setState(newState);
            }
        };
        _this.onMouseUp = function (event) {
            if (_this.props.isDisabled) {
                return;
            }
            if (_this.state.isActive) {
                var newState = {};
                newState.isActive = false;
                _this.setState(newState);
            }
        };
        _this.onMouseOver = function (event) {
            if (_this.props.isDisabled) {
                return;
            }
            if (!_this.isTouched && !_this.state.isHover) {
                var newState = {};
                newState.isHover = true;
                _this.setState(newState);
            }
        };
        _this.onMouseOut = function (event) {
            if (_this.props.isDisabled) {
                return;
            }
            if (_this.state.isActive || _this.state.isHover) {
                var newState = {};
                newState.isActive = false;
                newState.isHover = false;
                _this.setState(newState);
            }
        };
        _this.state = {
            isActive: false,
            isHover: false,
            isPressed: props.isPressed || false
        };
        _this.isTouched = false;
        return _this;
    }
    IconTextButton.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.isDisabled !== this.props.isDisabled) {
            this.setState({
                isActive: false,
                isHover: false
            });
        }
    };
    IconTextButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, Icon = _a.Icon, AdditionalIcon = _a.AdditionalIcon;
        var styles = this.getStyles();
        var colorsRoot = this.props.useLightColors ?
            colors_1.default.light() :
            this.props.useAlternativeColors
                ? colors_1.default.alternative(this.props.isPrimary)
                : colors_1.default.default(this.props.isPrimary, this.props.isSecondary);
        var iconColor = (function () {
            if (_this.props.isDisabled) {
                return colorsRoot.iconColorDisabled;
            }
            if (!_this.props.AdditionalIcon) {
                if (_this.props.isPressable ? _this.state.isPressed : _this.props.isPressed) {
                    return colorsRoot.iconColorPressed;
                }
            }
            return colorsRoot.iconColor;
        })();
        var icon = React.cloneElement(Icon, {
            color: iconColor,
            style: Object.assign({}, styles.icon, Icon.props.style),
            key: 0
        });
        var content = (React.createElement("div", { style: styles.content },
            AdditionalIcon
                ? (React.createElement("div", { style: styles.iconWrapper },
                    icon,
                    React.createElement(AdditionalIcon, { color: iconColor, style: styles.additionalIcon })))
                : icon,
            React.createElement("div", { style: styles.text }, this.props.text)));
        return (React.createElement("div", { style: Object.assign({}, styles.root, this.props.style), "data-test-id": this.props.dataTestId, onTouchTap: this.onTouchTap, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut, onTouchStart: function () { return _this.isTouched = true; } },
            React.createElement("button", { style: Object.assign({}, styles.button, this.props.buttonStyle) }, this.props.isDisabled ?
                content :
                React.createElement(TouchRipple_1.default, { color: colorsRoot.rippleColor, style: styles.ripple }, content))));
    };
    IconTextButton.prototype.getStyles = function () {
        var _this = this;
        var buttonHeight = 48;
        var colorsRoot = this.props.useLightColors ?
            colors_1.default.light() :
            this.props.useAlternativeColors
                ? colors_1.default.alternative(this.props.isPrimary)
                : colors_1.default.default(this.props.isPrimary, this.props.isSecondary);
        var transitionType = 'cubic-bezier(0.62, 0.28, 0.23, 0.99) 0.3s';
        var textColor = (function () {
            if (_this.props.isDisabled) {
                return colorsRoot.textColorDisabled;
            }
            if (!_this.props.AdditionalIcon) {
                if (_this.props.isPressable ? _this.state.isPressed : _this.props.isPressed) {
                    return colorsRoot.textColorPressed;
                }
            }
            return colorsRoot.textColor;
        })();
        var backgroundColor = (function () {
            if (_this.props.isPressable ? _this.state.isPressed : _this.props.isPressed) {
                if (_this.props.AdditionalIcon) {
                    return colorsRoot.backgroundColorActive;
                }
                if (_this.props.isDisabled) {
                    return colorsRoot.backgroundColorPressedDisabled;
                }
                return colorsRoot.backgroundColorPressed;
            }
            if (_this.state.isActive) {
                return colorsRoot.backgroundColorActive;
            }
            if (_this.state.isHover) {
                return colorsRoot.backgroundColorHover;
            }
            return colorsRoot.backgroundColor;
        })();
        var shadowColor = (function () {
            if (_this.props.isDisabled) {
                return colorsRoot.shadowColorDisabled;
            }
            return colorsRoot.shadowColor;
        })();
        var pressed = this.props.isPressable ? this.state.isPressed : this.props.isPressed;
        var isLabelWrapped = this.props.isLabelWrapped;
        return {
            root: autoprefixer_1.autoprefixer({
                display: 'inline-block',
                userSelect: 'none'
            }),
            button: Object.assign({
                display: 'block',
                margin: 0,
                border: 0,
                outline: 0,
                padding: 0,
                backgroundColor: backgroundColor,
                position: 'relative',
                cursor: this.props.isDisabled ? 'not-allowed' : 'pointer',
                borderRadius: 3,
                overflow: 'hidden',
                zIndex: 10,
                transition: "background-color " + transitionType + ", box-shadow " + transitionType,
            }, (!this.props.AdditionalIcon && pressed)
                ? { boxShadow: "inset 0 0 1px " + shadowColor + ", inset 0 0 7px " + shadowColor }
                : {}),
            ripple: {
                pointerEvents: 'none'
            },
            content: autoprefixer_1.autoprefixer({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: isLabelWrapped ? 'flex-start' : 'center',
                // maybe switching minHeight/height/maxHeight between the flag is not necessary
                minHeight: isLabelWrapped ? buttonHeight : '',
                maxHeight: isLabelWrapped ? '' : buttonHeight,
                height: isLabelWrapped ? '' : buttonHeight,
                pointerEvents: 'none',
                marginLeft: 12,
                marginRight: 12
            }),
            icon: {},
            iconWrapper: autoprefixer_1.autoprefixer({
                lineHeight: '1px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }),
            additionalIcon: {
                height: 16,
                width: 16,
                marginLeft: 4,
                marginRight: -2
            },
            text: {
                color: textColor,
                fontFamily: '"Open Sans", sans-serif',
                fontSize: 12,
                maxWidth: (isLabelWrapped ? 100 : 200) - 2 * 12,
                overflow: 'hidden',
                textOverflow: isLabelWrapped ? '' : 'ellipsis',
                whiteSpace: isLabelWrapped ? 'normal' : 'nowrap',
                fontWeight: 600,
                paddingTop: 1
            }
        };
    };
    return IconTextButton;
}(React.Component));
exports.default = IconTextButton;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = __webpack_require__(242);
var primaryButtonColors = {
    iconColor: '#FFFFFF',
    iconColorDisabled: 'rgba(0, 0, 0, 0.25)',
    iconColorPressed: '#FFFFFF',
    textColor: '#FFFFFF',
    textColorDisabled: 'rgba(0, 0, 0, 0.25)',
    textColorPressed: '#FFFFFF',
    backgroundColor: styles_1.colors.blue500,
    backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
    backgroundColorPressed: styles_1.colors.blue500,
    backgroundColorActive: styles_1.colors.blue500,
    backgroundColorHover: 'rgb(114, 185, 242)',
    shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
    shadowColor: 'rgba(0, 0, 0, 0.15)',
    rippleColor: 'rgb(236, 238, 241)'
};
var secondaryButtonColors = {
    iconColor: '#FFFFFF',
    iconColorDisabled: 'rgba(255, 255, 255, 0.25)',
    iconColorPressed: '#FFFFFF',
    textColor: '#FFFFFF',
    textColorDisabled: 'rgba(255, 255, 255, 0.25)',
    textColorPressed: '#FFFFFF',
    backgroundColor: 'transparent',
    backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
    backgroundColorPressed: 'rgba(0, 0, 0, 0.25)',
    backgroundColorActive: styles_1.colors.blue500,
    backgroundColorHover: 'rgb(114, 185, 242)',
    shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
    shadowColor: 'rgba(0, 0, 0, 0.15)',
    rippleColor: 'rgb(236, 238, 241)'
};
exports.default = {
    default: function (isPrimary, isSecondary) {
        if (isSecondary === void 0) { isSecondary = false; }
        if (isPrimary) {
            return primaryButtonColors;
        }
        if (isSecondary) {
            return secondaryButtonColors;
        }
        return {
            iconColor: 'rgba(0, 0, 0, 0.54)',
            iconColorDisabled: 'rgba(0, 0, 0, 0.25)',
            iconColorPressed: 'rgba(0, 0, 0, 0.54)',
            textColor: 'rgba(0, 0, 0, 0.54)',
            textColorDisabled: 'rgba(0, 0, 0, 0.25)',
            textColorPressed: 'rgba(0, 0, 0, 0.54)',
            backgroundColor: 'transparent',
            backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
            backgroundColorPressed: 'rgba(0, 0, 0, 0.05)',
            backgroundColorActive: '#FFFFFF',
            backgroundColorHover: 'rgba(255, 255, 255, 0.5)',
            shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            rippleColor: styles_1.colors.blue500 // rgb(33, 150, 243)
        };
    },
    alternative: function (isPrimary) {
        if (isPrimary) {
            return primaryButtonColors;
        }
        return {
            iconColor: 'rgba(0, 0, 0, 0.54)',
            iconColorDisabled: 'rgba(0, 0, 0, 0.25)',
            iconColorPressed: 'rgba(0, 0, 0, 0.54)',
            textColor: 'rgba(0, 0, 0, 0.54)',
            textColorDisabled: 'rgba(0, 0, 0, 0.25)',
            textColorPressed: 'rgba(0, 0, 0, 0.54)',
            backgroundColor: 'transparent',
            backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
            backgroundColorPressed: 'rgba(0, 0, 0, 0.05)',
            backgroundColorActive: 'rgba(227, 242, 253, 1)',
            backgroundColorHover: 'rgba(227, 242, 253, 0.5)',
            shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            rippleColor: styles_1.colors.blue500 // rgb(33, 150, 243)
        };
    },
    light: function () {
        return {
            iconColor: 'rgba(255, 255, 255, 1)',
            iconColorDisabled: 'rgba(255, 255, 255, 0.25)',
            iconColorPressed: 'rgba(255, 255, 255, 1)',
            textColor: 'rgba(255, 255, 255, 1)',
            textColorDisabled: 'rgba(255, 255, 255, 0.25)',
            textColorPressed: 'rgba(255, 255, 255, 1)',
            backgroundColor: 'transparent',
            backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
            backgroundColorPressed: 'rgba(0, 0, 0, 0.05)',
            backgroundColorActive: '#000',
            backgroundColorHover: 'rgba(0, 0, 0, 0.5)',
            shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            rippleColor: styles_1.colors.blue500 // rgb(33, 150, 243)
        };
    }
};


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dropdown_1 = __webpack_require__(462);
var Menu_1 = __webpack_require__(464);
var MenuItem_1 = __webpack_require__(385);
var FeedbackFormDialog_1 = __webpack_require__(465);
var l10n_1 = __webpack_require__(18);
var mood_1 = __webpack_require__(484);
var mood_bad_1 = __webpack_require__(485);
var FeedbackType;
(function (FeedbackType) {
    FeedbackType[FeedbackType["POSITIVE"] = 0] = "POSITIVE";
    FeedbackType[FeedbackType["NEGATIVE"] = 1] = "NEGATIVE";
})(FeedbackType = exports.FeedbackType || (exports.FeedbackType = {}));
var FeedbackButton = (function (_super) {
    tslib_1.__extends(FeedbackButton, _super);
    function FeedbackButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onDone = function () {
            _this.setState({
                isExpanded: false,
                isFeedbackFormOpen: false,
                feedbackType: null
            });
        };
        _this.onOpen = function () {
            if (!_this.state.isExpanded) {
                _this.setState({
                    isExpanded: true,
                    isFeedbackFormOpen: false,
                    feedbackType: null
                });
            }
        };
        _this.onClose = function () {
            if (_this.state.isExpanded) {
                _this.setState({
                    isExpanded: false,
                    isFeedbackFormOpen: false,
                    feedbackType: null
                });
            }
        };
        _this.onFeedbackTypeSelect = function (event, value) {
            _this.setState({
                isExpanded: false,
                isFeedbackFormOpen: true,
                feedbackType: parseInt(value, 10)
            });
        };
        _this.state = {
            isExpanded: false,
            isFeedbackFormOpen: false,
            feedbackType: null
        };
        return _this;
    }
    FeedbackButton.prototype.getStyles = function () {
        return {
            root: Object.assign({}, {
                display: 'inline-block'
            }, this.props.style),
            dropdown: {
                display: 'block'
            },
            container: {
                padding: 0
            }
        };
    };
    ;
    FeedbackButton.prototype.render = function () {
        var styles = this.getStyles();
        var btnDropdownText = l10n_1.default("feedback.dropdown.button");
        var menuGoodFeedback = l10n_1.default("feedback.menu.positive");
        var menuBadFeedback = l10n_1.default("feedback.menu.negative");
        return (React.createElement("div", { "data-test-id": "feedback-button", style: styles.root },
            React.createElement(Dropdown_1.default, { isExpanded: this.state.isExpanded, Icon: React.createElement(mood_1.default, null), text: btnDropdownText, onOpen: this.onOpen, onClose: this.onClose, style: styles.dropdown, popoverChildrenStyle: styles.container, useAlternativeColors: this.props.useAlternativeColors, showArrow: false, anchorOrigin: this.props.anchorOrigin, targetOrigin: this.props.targetOrigin, isSecondary: true },
                React.createElement(Menu_1.default, { onChange: this.onFeedbackTypeSelect },
                    React.createElement(MenuItem_1.default, { "data-test-id": "feedback-menu-positive", key: 1, value: FeedbackType.POSITIVE + '', primaryText: menuGoodFeedback, leftIcon: React.createElement(mood_1.default, null) }),
                    React.createElement(MenuItem_1.default, { "data-test-id": "feedback-menu-negative", key: 2, value: FeedbackType.NEGATIVE + '', primaryText: menuBadFeedback, leftIcon: React.createElement(mood_bad_1.default, null) }))),
            this.state.isFeedbackFormOpen
                ? (React.createElement(FeedbackFormDialog_1.default, { feedbackFeatureName: this.props.feedbackFeatureName, feedbackType: this.state.feedbackType, feedbackContext: this.props.feedbackContext, onFeedbackSubmit: this.props.onFeedbackSubmit, onDone: this.onDone }))
                : null));
    };
    return FeedbackButton;
}(React.Component));
FeedbackButton.defaultProps = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    targetOrigin: { vertical: 'top', horizontal: 'right' }
};
exports.default = FeedbackButton;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var Popover_1 = __webpack_require__(387);
var keyboard_arrow_down_1 = __webpack_require__(463);
var IconTextButton_1 = __webpack_require__(459);
var Dropdown = (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.onOpen = function (event) {
            if (_this.props.isSmart) {
                if (_this.state.isExpanded) {
                    return;
                }
                var newState = {};
                newState.isExpanded = true;
                _this.setState(newState, function () {
                    if (_this.props.onOpen) {
                        _this.props.onOpen(event);
                    }
                });
            }
            else {
                if (_this.props.onOpen) {
                    _this.props.onOpen(event);
                }
            }
        };
        _this.onClose = function (reason) {
            if (_this.props.isSmart) {
                if (!_this.state.isExpanded) {
                    return;
                }
                var newState = {};
                newState.isExpanded = false;
                _this.setState(newState, function () {
                    if (_this.props.onClose) {
                        _this.props.onClose(reason);
                    }
                });
            }
            else {
                if (_this.props.onClose) {
                    _this.props.onClose(reason);
                }
            }
        };
        _this.state = { isExpanded: props.isExpanded, anchor: null };
        return _this;
    }
    Dropdown.prototype.componentDidMount = function () {
        var state = {};
        state.anchor = ReactDOM.findDOMNode(this.button);
        this.setState(state);
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var _a = this.props, Icon = _a.Icon, text = _a.text, isSmart = _a.isSmart, showArrow = _a.showArrow;
        return (React.createElement("div", { style: Object.assign({}, styles.root, this.props.style) },
            React.createElement(IconTextButton_1.default, { style: styles.button, ref: function (ref) { return _this.button = ref; }, Icon: Icon, AdditionalIcon: showArrow && keyboard_arrow_down_1.default, text: text, dataTestId: this.props.dataTestId, isPressed: isSmart ? this.state.isExpanded : this.props.isExpanded, onTouchTap: this.onOpen, useAlternativeColors: !!this.props.useAlternativeColors, isSecondary: this.props.isSecondary }),
            React.createElement(Popover_1.default, { open: this.props.isSmart ? this.state.isExpanded : this.props.isExpanded, anchorEl: this.state.anchor, onRequestClose: this.onClose, style: styles.popover, canAutoPosition: false, autoCloseWhenOffScreen: false, anchorOrigin: this.props.anchorOrigin, targetOrigin: this.props.targetOrigin, zDepth: 5 },
                React.createElement("div", { style: Object.assign({}, styles.popoverChildren, this.props.popoverChildrenStyle) }, this.props.children))));
    };
    Dropdown.prototype.getStyles = function () {
        return {
            root: {
                display: 'inline-block',
                margin: '0 2px'
            },
            button: {
                display: 'block'
            },
            popover: {
                marginTop: 3,
            },
            popoverChildren: {
                padding: '4px 8px'
            }
        };
    };
    return Dropdown;
}(React.Component));
Dropdown.defaultProps = {
    showArrow: true,
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    targetOrigin: { vertical: 'top', horizontal: 'left' }
};
exports.default = Dropdown;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
  );
};
HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
HardwareKeyboardArrowDown.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowDown;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.Menu = undefined;

var _Menu2 = __webpack_require__(431);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(385);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _Menu3.default;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var FeedbackButton_1 = __webpack_require__(461);
var Mask_1 = __webpack_require__(466);
var Delayed_1 = __webpack_require__(467);
var Dialog_1 = __webpack_require__(468);
var TextField_1 = __webpack_require__(472);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var CircularProgress_1 = __webpack_require__(382);
var styles_1 = __webpack_require__(242);
var features = __webpack_require__(25);
var diyLightTheme = __webpack_require__(241);
var autoprefixer_1 = __webpack_require__(438);
var Notice_1 = __webpack_require__(27);
var mood_1 = __webpack_require__(484);
var mood_bad_1 = __webpack_require__(485);
var check_circle_1 = __webpack_require__(486);
var DYN_STYLE_ID = 'feedback-form-dialog-dynamic-style';
var FeedbackFormDialog = (function (_super) {
    tslib_1.__extends(FeedbackFormDialog, _super);
    function FeedbackFormDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onTextFieldChange = function (event) {
            var message = event.target.value.trim();
            var newState = {};
            newState.submitBtnDisabled = message.length === 0;
            newState.message = message;
            _this.setState(newState);
        };
        _this.btnCancelAction = function () {
            _this.props.onDone();
        };
        _this.btnSubmitAction = function () {
            var newState = {};
            newState.isWaiting = true;
            _this.setState(newState);
            var promise = _this.props.onFeedbackSubmit(_this.props.feedbackContext, _this.props.feedbackType, _this.state.message);
            promise.then(function () {
                var newState = {};
                newState.isWaiting = false;
                newState.isSuccess = true;
                _this.setState(newState);
                setTimeout(function () {
                    var newState = {};
                    newState.isFading = true;
                    _this.setState(newState);
                    // after same duration as the fading animation close the dialog
                    setTimeout(function () {
                        _this.props.onDone();
                    }, 500);
                }, 2000);
            }).catch(function () {
                // in case of error
                var newState = {};
                newState.isWaiting = false;
                _this.setState(newState);
            });
        };
        _this.state = {
            isWaiting: false,
            isSuccess: false,
            isFading: false,
            submitBtnDisabled: true,
            message: ''
        };
        return _this;
    }
    // https://issue.tool.1and1.com/browse/DHDIYRED-1547
    // {
    FeedbackFormDialog.prototype.componentDidMount = function () {
        // http://stackoverflow.com/a/524721
        var css = 'html { overflow-y: visible; }';
        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.id = DYN_STYLE_ID;
        style.type = 'text/css';
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        }
        else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
    };
    FeedbackFormDialog.prototype.componentWillUnmount = function () {
        var style = document.getElementById(DYN_STYLE_ID);
        style.parentElement.removeChild(style);
    };
    // }
    FeedbackFormDialog.prototype.getStyles = function () {
        return {
            dialog: {
                opacity: 1,
            },
            dialogContent: {
                maxWidth: 505,
                marginBottom: 64
            },
            dialogBody: {
                padding: "24px 24px 0px 24px"
            },
            actions: {
                paddingRight: 24,
                visibility: "visible"
            },
            title: autoprefixer_1.autoprefixer({
                fontWeight: 500,
                fontSize: 16,
                display: "flex"
            }),
            titleText: {
                padding: "0px 5px 0px 5px"
            },
            moduleName: {
                fontWeight: 700
            },
            paragraph: autoprefixer_1.autoprefixer({
                fontSize: 13,
                margin: "24px 0px",
                display: "flex"
            }),
            paragraphNote: autoprefixer_1.autoprefixer({
                fontSize: 12,
                margin: "24px 0px",
                display: "flex",
                color: "rgba(0,0,0,.9)"
            }),
            success: autoprefixer_1.autoprefixer({
                display: "flex",
                flexDirection: "column",
                width: 425
            }),
            successText: autoprefixer_1.autoprefixer({
                display: "flex",
                justifyContent: "center"
            }),
            checkCircleContainer: autoprefixer_1.autoprefixer({
                display: "flex",
                justifyContent: "center",
                paddingBottom: 20
            }),
            checkCircle: {
                width: 60,
                height: 60
            },
            fading: {
                opacity: 0,
                transition: "opacity 0.5s ease-in-out"
            },
        };
    };
    ;
    FeedbackFormDialog.prototype.render = function () {
        var styles = this.getStyles();
        var formTitlePositive = l10n_1.default("feedback.form.title.positive");
        var formTitleNegative = l10n_1.default("feedback.form.title.negative");
        var formBody = l10n_1.default("feedback.form.body");
        var formQuestion = l10n_1.default("feedback.form.question");
        var formNote = l10n_1.default("feedback.form.note");
        var btnCancelText = l10n_1.default("feedback.form.button.cancel");
        var btnSubmitText = l10n_1.default("feedback.form.button.submit");
        var successText = l10n_1.default("feedback.form.success");
        var actions = [
            React.createElement(FlatButton_1.default, { style: styles, label: btnCancelText, primary: true, onTouchTap: this.btnCancelAction, "data-test-id": "feedbackform-cancel-btn" }),
            React.createElement(RaisedButton_1.default, { disabled: this.state.submitBtnDisabled, label: btnSubmitText, primary: true, onTouchTap: this.btnSubmitAction, "data-test-id": "feedbackform-submit-btn" })
        ];
        return (React.createElement(Dialog_1.default, { actionsContainerStyle: styles.actions, actions: actions, modal: true, open: true, style: this.state.isFading ? styles.fading : styles.dialog, contentStyle: styles.dialogContent, bodyStyle: styles.dialogBody },
            React.createElement("div", { style: styles.title },
                this.props.feedbackType === FeedbackButton_1.FeedbackType.POSITIVE ? React.createElement(mood_1.default, null) : React.createElement(mood_bad_1.default, null),
                React.createElement("p", { style: styles.titleText }, this.props.feedbackType === FeedbackButton_1.FeedbackType.POSITIVE ? formTitlePositive : formTitleNegative),
                React.createElement("p", { style: styles.moduleName }, this.props.feedbackFeatureName)),
            React.createElement("div", { style: styles.paragraph }, formBody),
            React.createElement("div", { style: styles.paragraph }, formQuestion),
            React.createElement("div", { style: styles.paragraph },
                React.createElement(TextField_1.default, { "data-test-id": "feedbackform-textarea", focusOnMount: true, onChange: this.onTextFieldChange, multiLine: true, rows: 5, rowsMax: 10, name: "feedbackform-textarea" })),
            React.createElement("div", { style: styles.paragraphNote }, formNote),
            features('privacyNotice')
                ?
                    React.createElement("div", { style: styles.paragraphNote },
                        React.createElement(Notice_1.Notice, null))
                :
                    null,
            this.state.isWaiting
                ?
                    React.createElement(Delayed_1.default, { delay: 300 },
                        React.createElement(Mask_1.default, { backgroundColor: diyLightTheme.paper.backgroundColor },
                            React.createElement(CircularProgress_1.default, { mode: "indeterminate" })))
                :
                    null,
            this.state.isSuccess
                ?
                    React.createElement("div", null,
                        React.createElement(Mask_1.default, { backgroundColor: diyLightTheme.paper.backgroundColor },
                            React.createElement("div", { style: styles.success },
                                React.createElement("div", { style: styles.checkCircleContainer },
                                    React.createElement(check_circle_1.default, { style: styles.checkCircle, color: styles_1.colors.blue500 })),
                                React.createElement("div", { style: styles.successText }, successText))))
                :
                    null));
    };
    return FeedbackFormDialog;
}(React.Component));
exports.default = FeedbackFormDialog;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Mask = (function (_super) {
    tslib_1.__extends(Mask, _super);
    function Mask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Mask.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            React.createElement("div", { style: styles.center }, this.props.children)));
    };
    Mask.prototype.getStyles = function () {
        return {
            root: {
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                backgroundColor: this.props.backgroundColor,
                zIndex: this.props.zIndex
            },
            center: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate3d(-50%, -50%, 0)'
            }
        };
    };
    return Mask;
}(React.Component));
Mask.defaultProps = {
    zIndex: 2,
    backgroundColor: 'rgba(0,0,0,0.3)'
};
exports.default = Mask;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Delayed = (function (_super) {
    tslib_1.__extends(Delayed, _super);
    function Delayed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            renderChildren: false
        };
        return _this;
    }
    Delayed.prototype.render = function () {
        if (this.state.renderChildren) {
            return this.props.children;
        }
        else {
            return null;
        }
    };
    Delayed.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.delay > 0) {
            this.renderTimeout = setTimeout(function () {
                _this.setState({ renderChildren: true });
            }, this.props.delay);
        }
    };
    Delayed.prototype.componentWillUnmount = function () {
        clearTimeout(this.renderTimeout);
    };
    return Delayed;
}(React.Component));
exports.default = Delayed;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dialog = __webpack_require__(469);

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dialog2.default;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(388);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(415);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _Overlay = __webpack_require__(470);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _RenderToLayer = __webpack_require__(389);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

var _reactAddonsTransitionGroup = __webpack_require__(238);

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransitionItem = function (_Component) {
  _inherits(TransitionItem, _Component);

  function TransitionItem() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, TransitionItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TransitionItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      style: {}
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TransitionItem, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimeout);
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.componentWillAppear(callback);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      var spacing = this.context.muiTheme.baseTheme.spacing;

      this.setState({
        style: {
          opacity: 1,
          transform: 'translate3d(0, ' + spacing.desktopKeylineIncrement + 'px, 0)'
        }
      });

      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      this.setState({
        style: {
          opacity: 0,
          transform: 'translate3d(0, 0, 0)'
        }
      });

      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var style = _props.style;
      var children = _props.children;

      var other = _objectWithoutProperties(_props, ['style', 'children']);

      var prepareStyles = this.context.muiTheme.prepareStyles;


      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
        children
      );
    }
  }]);

  return TransitionItem;
}(_react.Component);

TransitionItem.propTypes = {
  children: _react.PropTypes.node,
  style: _react.PropTypes.object
};
TransitionItem.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};


function getStyles(props, context) {
  var autoScrollBodyContent = props.autoScrollBodyContent;
  var open = props.open;
  var _context$muiTheme = context.muiTheme;
  var _context$muiTheme$bas = _context$muiTheme.baseTheme;
  var spacing = _context$muiTheme$bas.spacing;
  var palette = _context$muiTheme$bas.palette;
  var dialog = _context$muiTheme.dialog;
  var zIndex = _context$muiTheme.zIndex;


  var gutter = spacing.desktopGutter;
  var borderScroll = '1px solid ' + palette.borderColor;

  return {
    root: {
      position: 'fixed',
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      zIndex: zIndex.dialog,
      top: 0,
      left: open ? 0 : -10000,
      width: '100%',
      height: '100%',
      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
    },
    content: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      transition: _transitions2.default.easeOut(),
      position: 'relative',
      width: '75%',
      maxWidth: spacing.desktopKeylineIncrement * 12,
      margin: '0 auto',
      zIndex: zIndex.dialog
    },
    actionsContainer: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      padding: 8,
      width: '100%',
      textAlign: 'right',
      marginTop: autoScrollBodyContent ? -1 : 0,
      borderTop: autoScrollBodyContent ? borderScroll : 'none'
    },
    overlay: {
      zIndex: zIndex.dialogOverlay
    },
    title: {
      margin: 0,
      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
      color: palette.textColor,
      fontSize: dialog.titleFontSize,
      lineHeight: '32px',
      fontWeight: 400,
      marginBottom: autoScrollBodyContent ? -1 : 0,
      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
    },
    body: {
      fontSize: dialog.bodyFontSize,
      color: dialog.bodyColor,
      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
      boxSizing: 'border-box',
      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
    }
  };
}

var DialogInline = function (_Component2) {
  _inherits(DialogInline, _Component2);

  function DialogInline() {
    var _Object$getPrototypeO2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, DialogInline);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_Object$getPrototypeO2 = Object.getPrototypeOf(DialogInline)).call.apply(_Object$getPrototypeO2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
      _this2.requestClose(false);
    }, _this2.handleKeyUp = function (event) {
      if ((0, _keycode2.default)(event) === 'esc') {
        _this2.requestClose(false);
      }
    }, _this2.handleResize = function () {
      _this2.positionDialog();
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(DialogInline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.positionDialog();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.positionDialog();
    }
  }, {
    key: 'positionDialog',
    value: function positionDialog() {
      var _props2 = this.props;
      var actions = _props2.actions;
      var autoDetectWindowHeight = _props2.autoDetectWindowHeight;
      var autoScrollBodyContent = _props2.autoScrollBodyContent;
      var bodyStyle = _props2.bodyStyle;
      var open = _props2.open;
      var repositionOnUpdate = _props2.repositionOnUpdate;
      var title = _props2.title;


      if (!open) {
        return;
      }

      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var container = _reactDom2.default.findDOMNode(this);
      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
      var minPaddingTop = 16;

      // Reset the height in case the window was resized.
      dialogWindow.style.height = '';
      dialogContent.style.height = '';

      var dialogWindowHeight = dialogWindow.offsetHeight;
      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;

      // Vertically center the dialog window, but make sure it doesn't
      // transition to that position.
      if (repositionOnUpdate || !container.style.paddingTop) {
        container.style.paddingTop = paddingTop + 'px';
      }

      // Force a height if the dialog is taller than clientHeight
      if (autoDetectWindowHeight || autoScrollBodyContent) {
        var styles = getStyles(this.props, this.context);
        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
        var maxDialogContentHeight = clientHeight - 2 * 64;

        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;

        if (_react2.default.Children.count(actions)) {
          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
        }

        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(buttonClicked) {
      if (!buttonClicked && this.props.modal) {
        return;
      }

      if (this.props.onRequestClose) {
        this.props.onRequestClose(!!buttonClicked);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var actions = _props3.actions;
      var actionsContainerClassName = _props3.actionsContainerClassName;
      var actionsContainerStyle = _props3.actionsContainerStyle;
      var bodyClassName = _props3.bodyClassName;
      var bodyStyle = _props3.bodyStyle;
      var children = _props3.children;
      var className = _props3.className;
      var contentClassName = _props3.contentClassName;
      var contentStyle = _props3.contentStyle;
      var overlayClassName = _props3.overlayClassName;
      var overlayStyle = _props3.overlayStyle;
      var open = _props3.open;
      var titleClassName = _props3.titleClassName;
      var titleStyle = _props3.titleStyle;
      var title = _props3.title;
      var style = _props3.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      styles.root = (0, _simpleAssign2.default)(styles.root, style);
      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);

      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
        'div',
        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
        _react2.default.Children.toArray(actions)
      );

      var titleElement = title;
      if (_react2.default.isValidElement(title)) {
        titleElement = _react2.default.cloneElement(title, {
          className: title.props.className || titleClassName,
          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
        });
      } else if (typeof title === 'string') {
        titleElement = _react2.default.createElement(
          'h3',
          { className: titleClassName, style: prepareStyles(styles.title) },
          title
        );
      }

      return _react2.default.createElement(
        'div',
        { className: className, style: prepareStyles(styles.root) },
        open && _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyUp: this.handleKeyUp,
          onResize: this.handleResize
        }),
        _react2.default.createElement(
          _reactAddonsTransitionGroup2.default,
          {
            component: 'div',
            ref: 'dialogWindow',
            transitionAppear: true,
            transitionAppearTimeout: 450,
            transitionEnter: true,
            transitionEnterTimeout: 450
          },
          open && _react2.default.createElement(
            TransitionItem,
            {
              className: contentClassName,
              style: styles.content
            },
            _react2.default.createElement(
              _Paper2.default,
              { zDepth: 4 },
              titleElement,
              _react2.default.createElement(
                'div',
                {
                  ref: 'dialogContent',
                  className: bodyClassName,
                  style: prepareStyles(styles.body)
                },
                children
              ),
              actionsContainer
            )
          )
        ),
        _react2.default.createElement(_Overlay2.default, {
          show: open,
          className: overlayClassName,
          style: styles.overlay,
          onTouchTap: this.handleTouchTapOverlay
        })
      );
    }
  }]);

  return DialogInline;
}(_react.Component);

DialogInline.propTypes = {
  actions: _react.PropTypes.node,
  actionsContainerClassName: _react.PropTypes.string,
  actionsContainerStyle: _react.PropTypes.object,
  autoDetectWindowHeight: _react.PropTypes.bool,
  autoScrollBodyContent: _react.PropTypes.bool,
  bodyClassName: _react.PropTypes.string,
  bodyStyle: _react.PropTypes.object,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  contentClassName: _react.PropTypes.string,
  contentStyle: _react.PropTypes.object,
  modal: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  open: _react.PropTypes.bool.isRequired,
  overlayClassName: _react.PropTypes.string,
  overlayStyle: _react.PropTypes.object,
  repositionOnUpdate: _react.PropTypes.bool,
  style: _react.PropTypes.object,
  title: _react.PropTypes.node,
  titleClassName: _react.PropTypes.string,
  titleStyle: _react.PropTypes.object
};
DialogInline.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};

var Dialog = function (_Component3) {
  _inherits(Dialog, _Component3);

  function Dialog() {
    var _Object$getPrototypeO3;

    var _temp3, _this3, _ret3;

    _classCallCheck(this, Dialog);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_Object$getPrototypeO3 = Object.getPrototypeOf(Dialog)).call.apply(_Object$getPrototypeO3, [this].concat(args))), _this3), _this3.renderLayer = function () {
      return _react2.default.createElement(DialogInline, _this3.props);
    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
  }

  _createClass(Dialog, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
    }
  }]);

  return Dialog;
}(_react.Component);

Dialog.propTypes = {
  /**
   * Action buttons to display below the Dialog content (`children`).
   * This property accepts either a React element, or an array of React elements.
   */
  actions: _react.PropTypes.node,
  /**
   * The `className` to add to the actions container's root element.
   */
  actionsContainerClassName: _react.PropTypes.string,
  /**
   * Overrides the inline-styles of the actions container's root element.
   */
  actionsContainerStyle: _react.PropTypes.object,
  /**
   * If set to true, the height of the `Dialog` will be auto detected. A max height
   * will be enforced so that the content does not extend beyond the viewport.
   */
  autoDetectWindowHeight: _react.PropTypes.bool,
  /**
   * If set to true, the body content of the `Dialog` will be scrollable.
   */
  autoScrollBodyContent: _react.PropTypes.bool,
  /**
   * The `className` to add to the content's root element under the title.
   */
  bodyClassName: _react.PropTypes.string,
  /**
   * Overrides the inline-styles of the content's root element under the title.
   */
  bodyStyle: _react.PropTypes.object,
  /**
   * The contents of the `Dialog`.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * The `className` to add to the content container.
   */
  contentClassName: _react.PropTypes.string,
  /**
   * Overrides the inline-styles of the content container.
   */
  contentStyle: _react.PropTypes.object,
  /**
   * Force the user to use one of the actions in the `Dialog`.
   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
   */
  modal: _react.PropTypes.bool,
  /**
   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
   *
   * @param {bool} buttonClicked Determines whether a button click triggered this request.
   */
  onRequestClose: _react.PropTypes.func,
  /**
   * Controls whether the Dialog is opened or not.
   */
  open: _react.PropTypes.bool.isRequired,
  /**
   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
   */
  overlayClassName: _react.PropTypes.string,
  /**
   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
   */
  overlayStyle: _react.PropTypes.object,
  /**
   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
   */
  repositionOnUpdate: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
   */
  title: _react.PropTypes.node,
  /**
   * The `className` to add to the title's root container element.
   */
  titleClassName: _react.PropTypes.string,
  /**
   * Overrides the inline-styles of the title's root container element.
   */
  titleStyle: _react.PropTypes.object
};
Dialog.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
Dialog.defaultProps = {
  autoDetectWindowHeight: true,
  autoScrollBodyContent: false,
  modal: false,
  repositionOnUpdate: true
};
exports.default = Dialog;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _AutoLockScrolling = __webpack_require__(471);

var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var overlay = context.muiTheme.overlay;


  var style = {
    root: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      top: 0,
      left: '-100%',
      opacity: 0,
      backgroundColor: overlay.backgroundColor,
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)

      // Two ways to promote overlay to its own render layer
      willChange: 'opacity',
      transform: 'translateZ(0)',

      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    }
  };

  if (props.show) {
    (0, _simpleAssign2.default)(style.root, {
      left: 0,
      opacity: 1,
      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    });
  }

  return style;
}

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Overlay).apply(this, arguments));
  }

  _createClass(Overlay, [{
    key: 'setOpacity',
    value: function setOpacity(opacity) {
      this.refs.overlay.style.opacity = opacity;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var autoLockScrolling = _props.autoLockScrolling;
      var show = _props.show;
      var style = _props.style;
      var transitionEnabled = _props.transitionEnabled;

      var other = _objectWithoutProperties(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
      );
    }
  }]);

  return Overlay;
}(_react.Component);

Overlay.propTypes = {
  autoLockScrolling: _react.PropTypes.bool,
  show: _react.PropTypes.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  transitionEnabled: _react.PropTypes.bool
};
Overlay.defaultProps = {
  autoLockScrolling: true,
  style: {},
  transitionEnabled: true
};
Overlay.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Overlay;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var originalBodyOverflow = null;
var lockingCounter = 0;

var AutoLockScrolling = function (_Component) {
  _inherits(AutoLockScrolling, _Component);

  function AutoLockScrolling() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, AutoLockScrolling);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(AutoLockScrolling)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.locked = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutoLockScrolling, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.lock === true) this.preventScrolling();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.lock !== nextProps.lock) {
        if (nextProps.lock) {
          this.preventScrolling();
        } else {
          this.allowScrolling();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.allowScrolling();
    }

    // force to only lock/unlock once

  }, {
    key: 'preventScrolling',
    value: function preventScrolling() {
      if (this.locked === true) return;
      lockingCounter = lockingCounter + 1;
      this.locked = true;

      // only lock the first time the component is mounted.
      if (lockingCounter === 1) {
        var body = document.getElementsByTagName('body')[0];
        originalBodyOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'allowScrolling',
    value: function allowScrolling() {
      if (this.locked === true) {
        lockingCounter = lockingCounter - 1;
        this.locked = false;
      }

      if (lockingCounter === 0 && originalBodyOverflow !== null) {
        var body = document.getElementsByTagName('body')[0];
        body.style.overflow = originalBodyOverflow || '';
        originalBodyOverflow = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return AutoLockScrolling;
}(_react.Component);

AutoLockScrolling.propTypes = {
  lock: _react.PropTypes.bool.isRequired
};
exports.default = AutoLockScrolling;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var TextField_1 = __webpack_require__(473);
var TextField = (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextField.prototype.getStyles = function () {
        return {
            textField: {
                border: "1px solid",
                width: "100%",
                padding: "0 15px 0 15px"
            },
            underline: {
                display: "none"
            },
        };
    };
    TextField.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var props = tslib_1.__assign({}, this.props);
        delete props.focusOnMount;
        if (this.props.multiLine) {
            props.style = Object.assign({}, styles.textField, this.props.style);
            props.underlineStyle = Object.assign({}, styles.underline, this.props.underlineStyle);
        }
        return (React.createElement(TextField_1.default, tslib_1.__assign({ ref: function (textField) { _this.textField = textField; } }, props)));
    };
    TextField.prototype.componentDidMount = function () {
        if (this.props.focusOnMount) {
            // XXX because we may be in an event loop
            // we need to schedule focus afterwards
            // so that focus would not be stolen by another event
            setTimeout(this.textField.focus, 0);
        }
    };
    return TextField;
}(React.Component));
exports.default = TextField;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TextField = __webpack_require__(474);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextField2.default;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _keycode = __webpack_require__(415);

var _keycode2 = _interopRequireDefault(_keycode);

var _shallowEqual = __webpack_require__(380);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _colorManipulator = __webpack_require__(330);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _deprecatedPropType = __webpack_require__(419);

var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);

var _EnhancedTextarea = __webpack_require__(475);

var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);

var _TextFieldHint = __webpack_require__(476);

var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);

var _TextFieldLabel = __webpack_require__(477);

var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);

var _TextFieldUnderline = __webpack_require__(478);

var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getStyles = function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var _context$muiTheme$tex = _context$muiTheme.textField;
  var floatingLabelColor = _context$muiTheme$tex.floatingLabelColor;
  var focusColor = _context$muiTheme$tex.focusColor;
  var textColor = _context$muiTheme$tex.textColor;
  var disabledTextColor = _context$muiTheme$tex.disabledTextColor;
  var backgroundColor = _context$muiTheme$tex.backgroundColor;
  var hintColor = _context$muiTheme$tex.hintColor;
  var errorColor = _context$muiTheme$tex.errorColor;


  var styles = {
    root: {
      fontSize: 16,
      lineHeight: '24px',
      width: props.fullWidth ? '100%' : 256,
      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
      display: 'inline-block',
      position: 'relative',
      backgroundColor: backgroundColor,
      fontFamily: baseTheme.fontFamily,
      transition: _transitions2.default.easeOut('200ms', 'height')
    },
    error: {
      position: 'relative',
      bottom: 2,
      fontSize: 12,
      lineHeight: '12px',
      color: errorColor,
      transition: _transitions2.default.easeOut()
    },
    floatingLabel: {
      color: hintColor,
      pointerEvents: 'none'
    },
    input: {
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated style)
      padding: 0,
      position: 'relative',
      width: '100%',
      border: 'none',
      outline: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
      color: props.disabled ? disabledTextColor : textColor,
      cursor: props.disabled ? 'not-allowed' : 'initial',
      font: 'inherit'
    },
    textarea: {}
  };

  (0, _simpleAssign2.default)(styles.error, props.errorStyle);

  (0, _simpleAssign2.default)(styles.textarea, styles.input, {
    marginTop: props.floatingLabelText ? 36 : 12,
    marginBottom: props.floatingLabelText ? -36 : -12,
    boxSizing: 'border-box',
    font: 'inherit'
  });

  // Do not assign a height to the textarea as he handles it on his own.
  styles.input.height = '100%';

  if (state.hasValue) {
    styles.floatingLabel.color = (0, _colorManipulator.fade)(props.disabled ? disabledTextColor : floatingLabelColor, 0.5);
  }

  if (state.isFocused) {
    styles.floatingLabel.color = focusColor;
  }

  if (props.floatingLabelText) {
    styles.input.boxSizing = 'border-box';

    if (!props.multiLine) {
      styles.input.marginTop = 14;
    }

    if (state.errorText) {
      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
    }
  }

  if (state.errorText) {
    if (state.isFocused) {
      styles.floatingLabel.color = styles.error.color;
    }
  }

  return styles;
};

/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
  return Boolean(value || value === 0);
}

var TextField = function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TextField)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      isFocused: false,
      errorText: undefined,
      hasValue: false,
      isClean: true
    }, _this.handleInputBlur = function (event) {
      _this.setState({ isFocused: false });
      if (_this.props.onBlur) _this.props.onBlur(event);
    }, _this.handleInputChange = function (event) {
      _this.setState({ hasValue: isValid(event.target.value), isClean: false });
      if (_this.props.onChange) _this.props.onChange(event, event.target.value);
    }, _this.handleInputFocus = function (event) {
      if (_this.props.disabled) return;
      _this.setState({ isFocused: true });
      if (_this.props.onFocus) _this.props.onFocus(event);
    }, _this.handleInputKeyDown = function (event) {
      if ((0, _keycode2.default)(event) === 'enter' && _this.props.onEnterKeyDown) _this.props.onEnterKeyDown(event);
      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
    }, _this.handleHeightChange = function (event, height) {
      var newHeight = height + 24;
      if (_this.props.floatingLabelText) {
        newHeight += 24;
      }
      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextField, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props;
      var children = _props.children;
      var name = _props.name;
      var hintText = _props.hintText;
      var floatingLabelText = _props.floatingLabelText;
      var id = _props.id;


      var propsLeaf = children ? children.props : this.props;

      this.setState({
        errorText: this.props.errorText,
        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
      });

       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;

      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.errorText !== this.props.errorText) {
        this.setState({
          errorText: nextProps.errorText
        });
      }

      if (nextProps.children && nextProps.children.props) {
        nextProps = nextProps.children.props;
      }

      if (nextProps.hasOwnProperty('value')) {
        var hasValue = isValid(nextProps.value) || this.state.isClean && isValid(nextProps.defaultValue);

        if (hasValue !== this.state.hasValue) {
          this.setState({
            hasValue: hasValue
          });
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'blur',
    value: function blur() {
      if (this.input) this.getInputNode().blur();
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.input) this.getInputNode().focus();
    }
  }, {
    key: 'select',
    value: function select() {
      if (this.input) this.getInputNode().select();
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input ? this.getInputNode().value : undefined;
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
    }
  }, {
    key: '_isControlled',
    value: function _isControlled() {
      return this.props.hasOwnProperty('value');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props;
      var children = _props2.children;
      var className = _props2.className;
      var disabled = _props2.disabled;
      var errorStyle = _props2.errorStyle;
      var errorText = _props2.errorText;
      var floatingLabelFixed = _props2.floatingLabelFixed;
      var floatingLabelFocusStyle = _props2.floatingLabelFocusStyle;
      var floatingLabelStyle = _props2.floatingLabelStyle;
      var floatingLabelText = _props2.floatingLabelText;
      var fullWidth = _props2.fullWidth;
      var hintText = _props2.hintText;
      var hintStyle = _props2.hintStyle;
      var id = _props2.id;
      var inputStyle = _props2.inputStyle;
      var multiLine = _props2.multiLine;
      var onBlur = _props2.onBlur;
      var onChange = _props2.onChange;
      var onFocus = _props2.onFocus;
      var style = _props2.style;
      var type = _props2.type;
      var underlineDisabledStyle = _props2.underlineDisabledStyle;
      var underlineFocusStyle = _props2.underlineFocusStyle;
      var underlineShow = _props2.underlineShow;
      var underlineStyle = _props2.underlineStyle;
      var rows = _props2.rows;
      var rowsMax = _props2.rowsMax;
      var textareaStyle = _props2.textareaStyle;

      var other = _objectWithoutProperties(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var inputId = id || this.uniqueId;

      var errorTextElement = this.state.errorText && _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.error) },
        this.state.errorText
      );

      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
        _TextFieldLabel2.default,
        {
          muiTheme: this.context.muiTheme,
          style: (0, _simpleAssign2.default)(styles.floatingLabel, this.props.floatingLabelStyle),
          shrinkStyle: this.props.floatingLabelFocusStyle,
          htmlFor: inputId,
          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
          disabled: disabled
        },
        floatingLabelText
      );

      var inputProps = {
        id: inputId,
        ref: function ref(elem) {
          return _this2.input = elem;
        },
        disabled: this.props.disabled,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onKeyDown: this.handleInputKeyDown
      };

      var inputStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);

      var inputElement = void 0;
      if (children) {
        inputElement = _react2.default.cloneElement(children, _extends({}, inputProps, children.props, {
          style: (0, _simpleAssign2.default)(inputStyleMerged, children.props.style)
        }));
      } else {
        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, _extends({}, other, inputProps, {
          style: inputStyleMerged,
          rows: rows,
          rowsMax: rowsMax,
          onHeightChange: this.handleHeightChange,
          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, textareaStyle)
        })) : _react2.default.createElement('input', _extends({}, other, inputProps, {
          style: prepareStyles(inputStyleMerged),
          type: type
        }));
      }

      var rootProps = {};

      if (children) {
        rootProps = other;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, rootProps, {
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }),
        floatingLabelTextElement,
        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
          muiTheme: this.context.muiTheme,
          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
          style: hintStyle,
          text: hintText
        }) : null,
        inputElement,
        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
          disabled: disabled,
          disabledStyle: underlineDisabledStyle,
          error: !!this.state.errorText,
          errorStyle: errorStyle,
          focus: this.state.isFocused,
          focusStyle: underlineFocusStyle,
          muiTheme: this.context.muiTheme,
          style: underlineStyle
        }) : null,
        errorTextElement
      );
    }
  }]);

  return TextField;
}(_react.Component);

TextField.propTypes = {
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * The text string to use for the default value.
   */
  defaultValue: _react.PropTypes.any,
  /**
   * Disables the text field if set to true.
   */
  disabled: _react.PropTypes.bool,
  /**
   * The style object to use to override error styles.
   */
  errorStyle: _react.PropTypes.object,
  /**
   * The error content to display.
   */
  errorText: _react.PropTypes.node,
  /**
   * If true, the floating label will float even when there is no value.
   */
  floatingLabelFixed: _react.PropTypes.bool,
  /**
   * The style object to use to override floating label styles when focused.
   */
  floatingLabelFocusStyle: _react.PropTypes.object,
  /**
   * The style object to use to override floating label styles.
   */
  floatingLabelStyle: _react.PropTypes.object,
  /**
   * The content to use for the floating label element.
   */
  floatingLabelText: _react.PropTypes.node,
  /**
   * If true, the field receives the property width 100%.
   */
  fullWidth: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the TextField's hint text element.
   */
  hintStyle: _react.PropTypes.object,
  /**
   * The hint content to display.
   */
  hintText: _react.PropTypes.node,
  /**
   * The id prop for the text field.
   */
  id: _react.PropTypes.string,
  /**
   * Override the inline-styles of the TextField's input element.
   * When multiLine is false: define the style of the input element.
   * When multiLine is true: define the style of the container of the textarea.
   */
  inputStyle: _react.PropTypes.object,
  /**
   * If true, a textarea element will be rendered.
   * The textarea also grows and shrinks according to the number of lines.
   */
  multiLine: _react.PropTypes.bool,
  /**
   * Name applied to the input.
   */
  name: _react.PropTypes.string,
  /** @ignore */
  onBlur: _react.PropTypes.func,
  /**
   * Callback function that is fired when the textfield's value changes.
   */
  onChange: _react.PropTypes.func,
  /**
   * The function to call when the user presses the Enter key.
   */
  onEnterKeyDown: (0, _deprecatedPropType2.default)(_react.PropTypes.func, 'Use onKeyDown and check for keycode instead. It will be removed with v0.16.0.'),
  /** @ignore */
  onFocus: _react.PropTypes.func,
  /** @ignore */
  onKeyDown: _react.PropTypes.func,
  /**
   * Number of rows to display when multiLine option is set to true.
   */
  rows: _react.PropTypes.number,
  /**
   * Maximum number of rows to display when
   * multiLine option is set to true.
   */
  rowsMax: _react.PropTypes.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Override the inline-styles of the TextField's textarea element.
   * The TextField use either a textarea or an input,
   * this property has effects only when multiLine is true.
   */
  textareaStyle: _react.PropTypes.object,
  /**
   * Specifies the type of input to display
   * such as "password" or "text".
   */
  type: _react.PropTypes.string,
  /**
   * Override the inline-styles of the
   * TextField's underline element when disabled.
   */
  underlineDisabledStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the TextField's
   * underline element when focussed.
   */
  underlineFocusStyle: _react.PropTypes.object,
  /**
   * If true, shows the underline for the text field.
   */
  underlineShow: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the TextField's underline element.
   */
  underlineStyle: _react.PropTypes.object,
  /**
   * The value of the text field.
   */
  value: _react.PropTypes.any
};
TextField.defaultProps = {
  disabled: false,
  floatingLabelFixed: false,
  multiLine: false,
  fullWidth: false,
  type: 'text',
  underlineShow: true,
  rows: 1
};
TextField.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = TextField;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__(388);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rowsHeight = 24;

function getStyles(props, context, state) {
  return {
    root: {
      position: 'relative' },
    textarea: {
      height: state.height,
      width: '100%',
      resize: 'none',
      font: 'inherit',
      padding: 0,
      cursor: props.disabled ? 'not-allowed' : 'initial'
    },
    shadow: {
      resize: 'none',
      // Overflow also needed to here to remove the extra row
      // added to textareas in Firefox.
      overflow: 'hidden',
      // Visibility needed to hide the extra text area on ipads
      visibility: 'hidden',
      position: 'absolute',
      height: 'initial'
    }
  };
}

var EnhancedTextarea = function (_Component) {
  _inherits(EnhancedTextarea, _Component);

  function EnhancedTextarea() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, EnhancedTextarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedTextarea)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      height: null
    }, _this.handleResize = function (event) {
      _this.syncHeightWithShadow(undefined, event);
    }, _this.handleChange = function (event) {
      _this.syncHeightWithShadow(event.target.value);

      if (_this.props.hasOwnProperty('valueLink')) {
        _this.props.valueLink.requestChange(event.target.value);
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnhancedTextarea, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        height: this.props.rows * rowsHeight
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.syncHeightWithShadow(nextProps.value);
      }
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.refs.input;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.getInputNode().value = value;
      this.syncHeightWithShadow(value);
    }
  }, {
    key: 'syncHeightWithShadow',
    value: function syncHeightWithShadow(newValue, event) {
      var shadow = this.refs.shadow;

      if (newValue !== undefined) {
        shadow.value = newValue;
      }

      var newHeight = shadow.scrollHeight;

      if (this.props.rowsMax >= this.props.rows) {
        newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
      }

      newHeight = Math.max(newHeight, rowsHeight);

      if (this.state.height !== newHeight) {
        this.setState({
          height: newHeight
        });

        if (this.props.onHeightChange) {
          this.props.onHeightChange(event, newHeight);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var onChange = _props.onChange;
      var onHeightChange = _props.onHeightChange;
      var rows = _props.rows;
      var rowsMax = _props.rowsMax;
      var shadowStyle = _props.shadowStyle;
      var style = _props.style;
      var textareaStyle = _props.textareaStyle;
      var valueLink = _props.valueLink;

      var other = _objectWithoutProperties(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);

      if (this.props.hasOwnProperty('valueLink')) {
        other.value = this.props.valueLink.value;
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(rootStyles) },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', {
          ref: 'shadow',
          style: prepareStyles(shadowStyles),
          tabIndex: '-1',
          rows: this.props.rows,
          defaultValue: this.props.defaultValue,
          readOnly: true,
          value: this.props.value,
          valueLink: this.props.valueLink
        }),
        _react2.default.createElement('textarea', _extends({}, other, {
          ref: 'input',
          rows: this.props.rows,
          style: prepareStyles(textareaStyles),
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return EnhancedTextarea;
}(_react.Component);

EnhancedTextarea.propTypes = {
  defaultValue: _react.PropTypes.any,
  disabled: _react.PropTypes.bool,
  onChange: _react.PropTypes.func,
  onHeightChange: _react.PropTypes.func,
  rows: _react.PropTypes.number,
  rowsMax: _react.PropTypes.number,
  shadowStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  textareaStyle: _react.PropTypes.object,
  value: _react.PropTypes.string,
  valueLink: _react.PropTypes.object
};
EnhancedTextarea.defaultProps = {
  rows: 1
};
EnhancedTextarea.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = EnhancedTextarea;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var hintColor = props.muiTheme.textField.hintColor;
  var show = props.show;


  return {
    root: {
      position: 'absolute',
      opacity: show ? 1 : 0,
      color: hintColor,
      transition: _transitions2.default.easeOut(),
      bottom: 12
    }
  };
}

var TextFieldHint = function TextFieldHint(props) {
  var prepareStyles = props.muiTheme.prepareStyles;
  var style = props.style;
  var text = props.text;


  var styles = getStyles(props);

  return _react2.default.createElement(
    'div',
    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
    text
  );
};

TextFieldHint.propTypes = {
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _react.PropTypes.object.isRequired,
  /**
   * True if the hint text should be visible.
   */
  show: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The hint text displayed.
   */
  text: _react.PropTypes.node
};

TextFieldHint.defaultProps = {
  show: true
};

exports.default = TextFieldHint;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var defaultStyles = {
    position: 'absolute',
    lineHeight: '22px',
    top: 38,
    transition: _transitions2.default.easeOut(),
    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
    cursor: props.disabled ? 'not-allowed' : 'text',
    transform: 'scale(1) translate3d(0, 0, 0)',
    transformOrigin: 'left top',
    pointerEvents: 'auto',
    userSelect: 'none'
  };

  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
    transform: 'perspective(1px) scale(0.75) translate3d(0, -28px, 0)',
    pointerEvents: 'none'
  }, props.shrinkStyle) : null;

  return {
    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
  };
}

var TextFieldLabel = function TextFieldLabel(props) {
  var muiTheme = props.muiTheme;
  var className = props.className;
  var children = props.children;
  var htmlFor = props.htmlFor;
  var onTouchTap = props.onTouchTap;
  var prepareStyles = muiTheme.prepareStyles;

  var styles = getStyles(props);

  return _react2.default.createElement(
    'label',
    {
      className: className,
      style: prepareStyles(styles.root),
      htmlFor: htmlFor,
      onTouchTap: onTouchTap
    },
    children
  );
};

TextFieldLabel.propTypes = {
  /**
   * The label contents.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Disables the label if set to true.
   */
  disabled: _react.PropTypes.bool,
  /**
   * The id of the target element that this label should refer to.
   */
  htmlFor: _react.PropTypes.string,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _react.PropTypes.object.isRequired,
  /**
   * Callback function for when the label is selected via a touch tap.
   */
  onTouchTap: _react.PropTypes.func,
  /**
   * True if the floating label should shrink.
   */
  shrink: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element when focused.
   */
  shrinkStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};

TextFieldLabel.defaultProps = {
  disabled: false,
  shrink: false
};

exports.default = TextFieldLabel;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * True if the parent `TextField` is disabled.
   */
  disabled: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is disabled.
   */
  disabledStyle: _react.PropTypes.object,
  /**
   * True if the parent `TextField` has an error.
   */
  error: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` has an error.
   */
  errorStyle: _react.PropTypes.object,
  /**
   * True if the parent `TextField` is focused.
   */
  focus: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is focused.
   */
  focusStyle: _react.PropTypes.object,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _react.PropTypes.object.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};

var defaultProps = {
  disabled: false,
  disabledStyle: {},
  error: false,
  errorStyle: {},
  focus: false,
  focusStyle: {},
  style: {}
};

var TextFieldUnderline = function TextFieldUnderline(props) {
  var disabled = props.disabled;
  var disabledStyle = props.disabledStyle;
  var error = props.error;
  var errorStyle = props.errorStyle;
  var focus = props.focus;
  var focusStyle = props.focusStyle;
  var muiTheme = props.muiTheme;
  var style = props.style;
  var errorStyleColor = errorStyle.color;
  var prepareStyles = muiTheme.prepareStyles;
  var _muiTheme$textField = muiTheme.textField;
  var borderColor = _muiTheme$textField.borderColor;
  var disabledTextColor = _muiTheme$textField.disabledTextColor;
  var errorColor = _muiTheme$textField.errorColor;
  var focusColor = _muiTheme$textField.focusColor;


  var styles = {
    root: {
      border: 'none',
      borderBottom: 'solid 1px',
      borderColor: borderColor,
      bottom: 8,
      boxSizing: 'content-box',
      margin: 0,
      position: 'absolute',
      width: '100%'
    },
    disabled: {
      borderBottom: 'dotted 2px',
      borderColor: disabledTextColor,
      cursor: 'not-allowed'
    },
    focus: {
      borderBottom: 'solid 2px',
      borderColor: focusColor,
      transform: 'scaleX(0)',
      transition: _transitions2.default.easeOut()
    },
    error: {
      borderColor: errorStyleColor ? errorStyleColor : errorColor,
      transform: 'scaleX(1)'
    }
  };

  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);

  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
  );
};

TextFieldUnderline.propTypes = propTypes;
TextFieldUnderline.defaultProps = defaultProps;

exports.default = TextFieldUnderline;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = __webpack_require__(480);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlatButton2.default;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _childUtils = __webpack_require__(411);

var _colorManipulator = __webpack_require__(330);

var _EnhancedButton = __webpack_require__(410);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FlatButtonLabel = __webpack_require__(481);

var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

var FlatButton = function (_Component) {
  _inherits(FlatButton, _Component);

  function FlatButton() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, FlatButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FlatButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      // Cancel hover styles for touch devices
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FlatButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled && this.state.hovered) {
        this.setState({
          hovered: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var disabled = _props.disabled;
      var hoverColor = _props.hoverColor;
      var backgroundColor = _props.backgroundColor;
      var icon = _props.icon;
      var label = _props.label;
      var labelStyle = _props.labelStyle;
      var labelPosition = _props.labelPosition;
      var primary = _props.primary;
      var rippleColor = _props.rippleColor;
      var secondary = _props.secondary;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);

      var _context$muiTheme = this.context.muiTheme;
      var _context$muiTheme$but = _context$muiTheme.button;
      var buttonHeight = _context$muiTheme$but.height;
      var buttonMinWidth = _context$muiTheme$but.minWidth;
      var buttonTextTransform = _context$muiTheme$but.textTransform;
      var _context$muiTheme$fla = _context$muiTheme.flatButton;
      var buttonFilterColor = _context$muiTheme$fla.buttonFilterColor;
      var buttonColor = _context$muiTheme$fla.color;
      var disabledTextColor = _context$muiTheme$fla.disabledTextColor;
      var fontSize = _context$muiTheme$fla.fontSize;
      var fontWeight = _context$muiTheme$fla.fontWeight;
      var primaryTextColor = _context$muiTheme$fla.primaryTextColor;
      var secondaryTextColor = _context$muiTheme$fla.secondaryTextColor;
      var textColor = _context$muiTheme$fla.textColor;
      var _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform;
      var textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;

      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
      var defaultRippleColor = buttonFilterColor;
      var buttonHoverColor = hoverColor || defaultHoverColor;
      var buttonRippleColor = rippleColor || defaultRippleColor;
      var buttonBackgroundColor = backgroundColor || buttonColor;
      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        height: buttonHeight,
        lineHeight: buttonHeight + 'px',
        minWidth: buttonMinWidth,
        color: defaultTextColor,
        transition: _transitions2.default.easeOut(),
        borderRadius: 2,
        userSelect: 'none',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }, style);

      var iconCloned = void 0;
      var labelStyleIcon = {};

      if (icon) {
        iconCloned = _react2.default.cloneElement(icon, {
          color: icon.props.color || mergedRootStyles.color,
          style: {
            verticalAlign: 'middle',
            marginLeft: label && labelPosition !== 'before' ? 12 : 0,
            marginRight: label && labelPosition === 'before' ? 12 : 0
          }
        });

        if (labelPosition === 'before') {
          labelStyleIcon.paddingRight = 8;
        } else {
          labelStyleIcon.paddingLeft = 8;
        }
      }

      var mergedLabelStyles = (0, _simpleAssign2.default)({
        letterSpacing: 0,
        textTransform: textTransform,
        fontWeight: fontWeight,
        fontSize: fontSize
      }, labelStyleIcon, labelStyle);

      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;

      // Place label before or after children.
      var childrenFragment = labelPosition === 'before' ? {
        labelElement: labelElement,
        iconCloned: iconCloned,
        children: children
      } : {
        children: children,
        iconCloned: iconCloned,
        labelElement: labelElement
      };

      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);

      return _react2.default.createElement(
        _EnhancedButton2.default,
        _extends({}, other, {
          disabled: disabled,
          focusRippleColor: buttonRippleColor,
          focusRippleOpacity: 0.3,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          touchRippleColor: buttonRippleColor,
          touchRippleOpacity: 0.3
        }),
        enhancedButtonChildren
      );
    }
  }]);

  return FlatButton;
}(_react.Component);

FlatButton.muiName = 'FlatButton';
FlatButton.propTypes = {
  /**
   * Color of button when mouse is not hovering over it.
   */
  backgroundColor: _react.PropTypes.string,
  /**
   * This is what will be displayed inside the button.
   * If a label is specified, the text within the label prop will
   * be displayed. Otherwise, the component will expect children
   * which will then be displayed. (In our example,
   * we are nesting an `<input type="file" />` and a `span`
   * that acts as our label to be displayed.) This only
   * applies to flat and raised buttons.
   */
  children: _react.PropTypes.node,
  /**
   * Disables the button if set to true.
   */
  disabled: _react.PropTypes.bool,
  /**
   * Color of button when mouse hovers over.
   */
  hoverColor: _react.PropTypes.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _react.PropTypes.string,
  /**
   * Use this property to display an icon.
   */
  icon: _react.PropTypes.node,
  /**
   * Label for the button.
   */
  label: validateLabel,
  /**
   * Place label before or after the passed children.
   */
  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _react.PropTypes.object,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _react.PropTypes.func,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /** @ignore */
  onTouchStart: _react.PropTypes.func,
  /**
   * If true, colors button according to
   * primaryTextColor from the Theme.
   */
  primary: _react.PropTypes.bool,
  /**
   * Color for the ripple after button is clicked.
   */
  rippleColor: _react.PropTypes.string,
  /**
   * If true, colors button according to secondaryTextColor from the theme.
   * The primary prop has precendent if set to true.
   */
  secondary: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
FlatButton.defaultProps = {
  disabled: false,
  labelStyle: {},
  labelPosition: 'after',
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onTouchStart: function onTouchStart() {},
  primary: false,
  secondary: false
};
FlatButton.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = FlatButton;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      paddingLeft: baseTheme.spacing.desktopGutterLess,
      paddingRight: baseTheme.spacing.desktopGutterLess,
      verticalAlign: 'middle'
    }
  };
}

var FlatButtonLabel = function (_Component) {
  _inherits(FlatButtonLabel, _Component);

  function FlatButtonLabel() {
    _classCallCheck(this, FlatButtonLabel);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(FlatButtonLabel).apply(this, arguments));
  }

  _createClass(FlatButtonLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var label = _props.label;
      var style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        label
      );
    }
  }]);

  return FlatButtonLabel;
}(_react.Component);

FlatButtonLabel.propTypes = {
  label: _react.PropTypes.node,
  style: _react.PropTypes.object
};
FlatButtonLabel.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = FlatButtonLabel;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RaisedButton = __webpack_require__(483);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RaisedButton2.default;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(330);

var _childUtils = __webpack_require__(411);

var _EnhancedButton = __webpack_require__(410);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var button = _context$muiTheme.button;
  var raisedButton = _context$muiTheme.raisedButton;
  var disabled = props.disabled;
  var disabledBackgroundColor = props.disabledBackgroundColor;
  var disabledLabelColor = props.disabledLabelColor;
  var fullWidth = props.fullWidth;
  var icon = props.icon;
  var label = props.label;
  var labelPosition = props.labelPosition;
  var primary = props.primary;
  var secondary = props.secondary;
  var style = props.style;


  var amount = primary || secondary ? 0.4 : 0.08;

  var backgroundColor = raisedButton.color;
  var labelColor = raisedButton.textColor;

  if (disabled) {
    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
  } else if (primary) {
    backgroundColor = raisedButton.primaryColor;
    labelColor = raisedButton.primaryTextColor;
  } else if (secondary) {
    backgroundColor = raisedButton.secondaryColor;
    labelColor = raisedButton.secondaryTextColor;
  } else {
    if (props.backgroundColor) {
      backgroundColor = props.backgroundColor;
    }
    if (props.labelColor) {
      labelColor = props.labelColor;
    }
  }

  var buttonHeight = style && style.height || button.height;
  var borderRadius = 2;

  return {
    root: {
      display: 'inline-block',
      transition: _transitions2.default.easeOut(),
      minWidth: fullWidth ? '100%' : button.minWidth
    },
    button: {
      position: 'relative',
      height: buttonHeight,
      lineHeight: buttonHeight + 'px',
      width: '100%',
      padding: 0,
      borderRadius: borderRadius,
      transition: _transitions2.default.easeOut(),
      backgroundColor: backgroundColor,
      // That's the default value for a button but not a link
      textAlign: 'center'
    },
    label: {
      position: 'relative',
      opacity: 1,
      fontSize: raisedButton.fontSize,
      letterSpacing: 0,
      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
      fontWeight: raisedButton.fontWeight,
      margin: 0,
      userSelect: 'none',
      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      color: labelColor
    },
    icon: {
      verticalAlign: 'middle',
      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
      marginRight: label && labelPosition === 'before' ? 12 : 0
    },
    overlay: {
      height: buttonHeight,
      borderRadius: borderRadius,
      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
      transition: _transitions2.default.easeOut(),
      top: 0
    },
    ripple: {
      color: labelColor,
      opacity: !(primary || secondary) ? 0.1 : 0.16
    }
  };
}

var RaisedButton = function (_Component) {
  _inherits(RaisedButton, _Component);

  function RaisedButton() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, RaisedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RaisedButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      hovered: false,
      keyboardFocused: false,
      touched: false,
      initialZDepth: 0,
      zDepth: 0
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.setState({
          zDepth: _this.state.initialZDepth + 1
        });
      }
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
    }, _this.handleMouseUp = function (event) {
      _this.setState({
        zDepth: _this.state.initialZDepth
      });
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.state.keyboardFocused) {
        _this.setState({
          zDepth: _this.state.initialZDepth,
          hovered: false
        });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.keyboardFocused && !_this.state.touched) {
        _this.setState({
          hovered: true
        });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth + 1
      });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleTouchEnd = function (event) {
      _this.setState({
        zDepth: _this.state.initialZDepth
      });

      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;

      _this.setState({
        zDepth: zDepth,
        keyboardFocused: keyboardFocused
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RaisedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var zDepth = this.props.disabled ? 0 : 1;
      this.setState({
        zDepth: zDepth,
        initialZDepth: zDepth
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var zDepth = nextProps.disabled ? 0 : 1;
      var nextState = {
        zDepth: zDepth,
        initialZDepth: zDepth
      };

      if (nextProps.disabled && this.state.hovered) {
        nextState.hovered = false;
      }

      this.setState(nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var backgroundColor = _props.backgroundColor;
      var children = _props.children;
      var className = _props.className;
      var disabled = _props.disabled;
      var fullWidth = _props.fullWidth;
      var icon = _props.icon;
      var label = _props.label;
      var labelPosition = _props.labelPosition;
      var labelStyle = _props.labelStyle;
      var primary = _props.primary;
      var rippleStyle = _props.rippleStyle;
      var secondary = _props.secondary;

      var other = _objectWithoutProperties(_props, ['backgroundColor', 'children', 'className', 'disabled', 'fullWidth', 'icon', 'label', 'labelPosition', 'labelStyle', 'primary', 'rippleStyle', 'secondary']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);

      var buttonEventHandlers = disabled ? {} : {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      var labelElement = label && _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
        label
      );

      var iconCloned = icon && _react2.default.cloneElement(icon, {
        color: icon.props.color || styles.label.color,
        style: styles.icon
      });

      // Place label before or after children.
      var childrenFragment = labelPosition === 'before' ? {
        labelElement: labelElement,
        iconCloned: iconCloned,
        children: children
      } : {
        children: children,
        iconCloned: iconCloned,
        labelElement: labelElement
      };

      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);

      return _react2.default.createElement(
        _Paper2.default,
        {
          className: className,
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          zDepth: this.state.zDepth
        },
        _react2.default.createElement(
          _EnhancedButton2.default,
          _extends({}, other, buttonEventHandlers, {
            ref: 'container',
            disabled: disabled,
            style: styles.button,
            focusRippleColor: mergedRippleStyles.color,
            touchRippleColor: mergedRippleStyles.color,
            focusRippleOpacity: mergedRippleStyles.opacity,
            touchRippleOpacity: mergedRippleStyles.opacity
          }),
          _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              style: prepareStyles(styles.overlay)
            },
            enhancedButtonChildren
          )
        )
      );
    }
  }]);

  return RaisedButton;
}(_react.Component);

RaisedButton.muiName = 'RaisedButton';
RaisedButton.propTypes = {
  /**
   * Override the default background color for the button,
   * but not the default disabled background color
   * (use `disabledBackgroundColor` for this).
   */
  backgroundColor: _react.PropTypes.string,
  /**
   * The content of the button.
   * If a label is provided via the `label` prop, the text within the label
   * will be displayed in addition to the content provided here.
   */
  children: _react.PropTypes.node,
  /**
   * The CSS class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * If true, the button will be disabled.
   */
  disabled: _react.PropTypes.bool,
  /**
   * Override the default background color for the button
   * when it is disabled.
   */
  disabledBackgroundColor: _react.PropTypes.string,
  /**
   * The color of the button's label when the button is disabled.
   */
  disabledLabelColor: _react.PropTypes.string,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _react.PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _react.PropTypes.string,
  /**
   * An icon to be displayed within the button.
   */
  icon: _react.PropTypes.node,
  /**
   * The label to be displayed within the button.
   * If content is provided via the `children` prop, that content will be
   * displayed in addition to the label provided here.
   */
  label: validateLabel,
  /**
   * The color of the button's label.
   */
  labelColor: _react.PropTypes.string,
  /**
   * The position of the button's label relative to the button's `children`.
   */
  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _react.PropTypes.object,
  /** @ignore */
  onMouseDown: _react.PropTypes.func,
  /** @ignore */
  onMouseEnter: _react.PropTypes.func,
  /** @ignore */
  onMouseLeave: _react.PropTypes.func,
  /** @ignore */
  onMouseUp: _react.PropTypes.func,
  /** @ignore */
  onTouchEnd: _react.PropTypes.func,
  /** @ignore */
  onTouchStart: _react.PropTypes.func,
  /**
   * If true, the button will use the theme's primary color.
   */
  primary: _react.PropTypes.bool,
  /**
   * Override the inline style of the ripple element.
   */
  rippleStyle: _react.PropTypes.object,
  /**
   * If true, the button will use the theme's secondary color.
   * If both `secondary` and `primary` are true, the button will use
   * the theme's primary color.
   */
  secondary: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
RaisedButton.defaultProps = {
  disabled: false,
  labelPosition: 'after',
  fullWidth: false,
  primary: false,
  secondary: false
};
RaisedButton.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = RaisedButton;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMood = function SocialMood(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
  );
};
SocialMood = (0, _pure2.default)(SocialMood);
SocialMood.displayName = 'SocialMood';
SocialMood.muiName = 'SvgIcon';

exports.default = SocialMood;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMoodBad = function SocialMoodBad(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
  );
};
SocialMoodBad = (0, _pure2.default)(SocialMoodBad);
SocialMoodBad.displayName = 'SocialMoodBad';
SocialMoodBad.muiName = 'SvgIcon';

exports.default = SocialMoodBad;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCheckCircle = function ActionCheckCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};
ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
ActionCheckCircle.displayName = 'ActionCheckCircle';
ActionCheckCircle.muiName = 'SvgIcon';

exports.default = ActionCheckCircle;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
/**
 * Higher Order Component to fix iOS fixed elements
 *
 * Use absolute positioning on iOS because
 * fixed elements are uncontrolabbly transformed in absolute
 * when virtual keyboard appear. So use it only when it make sense.
 */
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var IOSFixFixed = (function (_super) {
    tslib_1.__extends(IOSFixFixed, _super);
    function IOSFixFixed(props) {
        var _this = _super.call(this, props) || this;
        _this.isIOS = false;
        _this.topOffset = 0;
        _this.syncTop = function () {
            var rootEl = ReactDOM.findDOMNode(_this);
            var docRect = document.documentElement.getBoundingClientRect();
            rootEl.style.top = (_this.topOffset - docRect.top) + 'px';
        };
        _this.fixedToAbsolute = function () {
            var rootEl = ReactDOM.findDOMNode(_this);
            if (rootEl.style.position === 'fixed') {
                _this.topOffset = parseInt(rootEl.style.top, 10);
            }
            rootEl.style.position = 'absolute';
            _this.syncTop();
        };
        _this.absoluteToFixed = function () {
            var rootEl = ReactDOM.findDOMNode(_this);
            rootEl.style.position = 'fixed';
            rootEl.style.position = _this.topOffset + 'px';
        };
        _this.isIOS = /(iPad|iPhone|iPod)/.test(navigator.userAgent)
            && !/IEMobile/.test(navigator.userAgent);
        return _this;
    }
    IOSFixFixed.prototype.render = function () {
        return this.props.children;
    };
    IOSFixFixed.prototype.componentDidMount = function () {
        if (this.isIOS) {
            window.addEventListener('scroll', this.syncTop);
            window.addEventListener('resize', this.syncTop);
            this.fixedToAbsolute();
        }
    };
    IOSFixFixed.prototype.componentDidUpdate = function () {
        if (this.isIOS) {
            this.fixedToAbsolute();
        }
    };
    IOSFixFixed.prototype.componentWillUnmount = function () {
        if (this.isIOS) {
            window.removeEventListener('scroll', this.syncTop);
            window.removeEventListener('resize', this.syncTop);
            this.absoluteToFixed();
        }
    };
    return IOSFixFixed;
}(React.Component));
exports.IOSFixFixed = IOSFixFixed;


/***/ },
/* 488 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function watchSize(element, callback) {
    var monitorElementRaf;
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    var monitorElement = function () {
        var rafCallback = function () {
            if (width !== element.offsetWidth || height !== element.offsetHeight) {
                width = element.offsetWidth;
                height = element.offsetHeight;
                callback(width, height);
            }
            monitorElement();
        };
        monitorElementRaf = requestAnimationFrame(rafCallback);
    };
    var stopMonitorElement = function () {
        cancelAnimationFrame(monitorElementRaf);
    };
    monitorElement();
    return stopMonitorElement;
}
exports.watchSize = watchSize;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var cancellation_1 = __webpack_require__(490);
function animatedScrollByY(delta, durationInMs, animateEl) {
    if (animateEl === void 0) { animateEl = document.body; }
    if (delta !== 0) {
        var scrollYBefore = window.scrollY;
        window.scrollBy(0, delta);
        var possibleDelta_1 = window.scrollY - scrollYBefore;
        window.scrollBy(0, -possibleDelta_1);
        var animateElStyle_1 = animateEl.style;
        animateElStyle_1.transition = animateElStyle_1.transition =
            "transform " + durationInMs + "ms ease-in-out";
        animateElStyle_1.transform = animateElStyle_1.transform =
            "translateY(" + -possibleDelta_1 + "px)";
        var onEnd_1 = function () {
            animateElStyle_1.transition = animateElStyle_1.transition = '';
            animateElStyle_1.transform = animateElStyle_1.transform = '';
            window.scrollBy(0, possibleDelta_1);
            animateEl.removeEventListener('transitionend', onEnd_1);
        };
        animateEl.addEventListener('transitionend', onEnd_1);
    }
}
exports.animatedScrollByY = animatedScrollByY;
function scrollElementToY(container, offset, duration, cancellationToken) {
    return new Promise(function (resolve, reject) {
        $(container).animate({
            scrollTop: offset
        }, duration, function () {
            resolve();
        });
        if (cancellationToken) {
            cancellationToken.register(function () {
                $(container).stop();
                reject(new cancellation_1.OperationCanceledError(cancellationToken));
            });
        }
    });
}
exports.scrollElementToY = scrollElementToY;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

// See https://gist.github.com/danharper/ad6ca574184589dea28d
// Similar to the CancellationToken API from C#
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var event_1 = __webpack_require__(491);
// Computed method names to prevent them from being publicly accesible
var CANCEL = "_symbol_shim_cancel_"; //Symbol();
var REGISTER = "_symbol_shim_register_"; //Symbol();
var OperationCanceledError = (function (_super) {
    tslib_1.__extends(OperationCanceledError, _super);
    function OperationCanceledError(cancellationToken) {
        var _this = _super.call(this) || this;
        _this.cancellationToken = cancellationToken;
        // This fixes instanceof
        Object.setPrototypeOf(_this, OperationCanceledError.prototype);
        return _this;
    }
    return OperationCanceledError;
}(Error));
exports.OperationCanceledError = OperationCanceledError;
var CancellationToken = (function () {
    /**
     * Shouldn't be instantiated directly, but through a CancellationTokenSource
     */
    function CancellationToken(source) {
        this.source = source;
        this.cancelled = false;
    }
    /**
     * Throws an OperationCanceledError if the token is in cancelled state
     */
    CancellationToken.prototype.throwIfCancelled = function () {
        if (this.isCancelled()) {
            throw new OperationCanceledError(this);
        }
    };
    CancellationToken.prototype.isCancelled = function () {
        return this.cancelled === true;
    };
    /** Internal method callable only from CancellationTokenSource */
    CancellationToken.prototype[CANCEL] = function () {
        this.cancelled = true;
    };
    /**
     * Registers a callback to be called when the token is cancelled.
     * If the token is already in cancelled state, the callback is immediately invoked
     */
    CancellationToken.prototype.register = function (callback) {
        this.source[REGISTER](callback);
    };
    return CancellationToken;
}());
exports.CancellationToken = CancellationToken;
var CancellationTokenSource = (function () {
    function CancellationTokenSource() {
        this.onCancel = new event_1.EventDispatcher();
        this.token = new CancellationToken(this);
    }
    /**
     * Issues token cancellation and notifies any registered callbacks
     */
    CancellationTokenSource.prototype.cancel = function () {
        this.token[CANCEL]();
        this.onCancel.dispatch(this, void 0);
    };
    /**
     * Internal method only callable from CancellationToken
     */
    CancellationTokenSource.prototype[REGISTER] = function (callback) {
        this.onCancel.subscribe(function () { return callback(); });
        if (this.token.isCancelled()) {
            callback();
        }
    };
    /**
     * Free used resources for garbage collection
     */
    CancellationTokenSource.prototype.dispose = function () {
        this.token = void 0;
        this.onCancel = void 0;
    };
    return CancellationTokenSource;
}());
exports.CancellationTokenSource = CancellationTokenSource;


/***/ },
/* 491 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher = (function () {
    function EventDispatcher() {
        this.listeners = new Set();
    }
    EventDispatcher.prototype.subscribe = function (listener) {
        this.listeners.add(listener);
    };
    EventDispatcher.prototype.unsubscribe = function (listener) {
        this.listeners.delete(listener);
    };
    EventDispatcher.prototype.subscribeOnce = function (listener) {
        var _this = this;
        var wrapper = function (args, sender) {
            listener(args, sender);
            _this.unsubscribe(wrapper);
            wrapper = void 0;
        };
        this.subscribe(wrapper);
    };
    EventDispatcher.prototype.dispatch = function (sender, args) {
        this.listeners.forEach(function (listener) { return listener(args, sender); });
    };
    return EventDispatcher;
}());
exports.EventDispatcher = EventDispatcher;


/***/ },
/* 492 */
/***/ function(module, exports) {

/**
 * A collection of utilities to help with page related issues
 * like spacing for toolbars, autoscroll, keepScroll, etc
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getWebViewEl() {
    return document.querySelector('.diyw');
}
exports.getWebViewEl = getWebViewEl;
var currentTopSpace = 0;
function makeTopSpace(height, keepVisualPosition) {
    if (keepVisualPosition === void 0) { keepVisualPosition = false; }
    var webView = getWebViewEl();
    if (!webView) {
        return;
    }
    var translateRule = "translateY(" + height + "px)";
    var topBefore = webView.getBoundingClientRect().top;
    webView.style.transform = translateRule;
    webView.style.webkitTransform = translateRule;
    // in happy case when background is top aligned, we can make the magic to
    // remain visually aligned, best effort ...
    if (parseInt(getComputedStyle(document.body).backgroundPositionY, 10) === 0) {
        document.body.style.backgroundPositionY = height + 'px';
    }
    var topAfter = webView.getBoundingClientRect().top;
    currentTopSpace = height;
    if (keepVisualPosition) {
        // compensate the scroll so that things would stay visually in the same place
        var scrollDelta = topAfter - topBefore;
        window.scrollBy(0, scrollDelta);
        var topAfterScroll = webView.getBoundingClientRect().top;
        if (topAfterScroll > topBefore) {
            // then we probably didn't have enough scrollHeight to compensate the scroll
            var scrollCompensation = topAfterScroll - topBefore;
            document.body.style.paddingBottom = scrollCompensation + 'px';
            window.scrollBy(0, scrollCompensation);
        }
    }
}
exports.makeTopSpace = makeTopSpace;
function getTopSpace() {
    return currentTopSpace;
}
exports.getTopSpace = getTopSpace;
function clearTopSpace(keepVisualPosition) {
    if (keepVisualPosition === void 0) { keepVisualPosition = false; }
    makeTopSpace(0, keepVisualPosition);
    var webView = getWebViewEl();
    var translateRule = '';
    webView.style.transform = translateRule;
    webView.style.webkitTransform = translateRule;
    document.body.style.backgroundPositionY = '';
    document.body.style.paddingBottom = '';
}
exports.clearTopSpace = clearTopSpace;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var Modul_1 = __webpack_require__(197);
var index_1 = __webpack_require__(494);
var react_redux_1 = __webpack_require__(220);
var AppRegistry_1 = __webpack_require__(190);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulWithRedux = (function (_super) {
    tslib_1.__extends(ModulWithRedux, _super);
    function ModulWithRedux() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasActionBar = true;
        _this.hasUndoRedo = false;
        _this.undoHandler = function () {
            /**
             * If the module supports undo/redo
             * it should override these methods
             */
        };
        _this.redoHandler = function () {
            /**
             * If the module supports undo/redo
             * it should override these methods
             */
        };
        return _this;
    }
    ModulWithRedux.prototype.open = function (openConfig) {
        getStore().dispatch(index_1.load({
            moduleId: this.moduleId,
            moduleState: {
                moduleId: this.moduleId,
                payload: this.data
            }
        }));
        _super.prototype.open.call(this, openConfig);
        this.renderWebView();
        this.renderInPlaceEditView();
    };
    ModulWithRedux.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        if (this.inPlaceEditorWrapper) {
            ReactDOM.unmountComponentAtNode(this.inPlaceEditorWrapper);
            this.inPlaceEditorWrapper.parentElement.removeChild(this.inPlaceEditorWrapper);
            this.inPlaceEditorWrapper = null;
        }
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
    };
    ModulWithRedux.prototype.getConnectedComponent = function (componentClass) {
        var _this = this;
        var mapStateToProps = function (state) {
            return {
                moduleId: _this.moduleId,
                module: _this,
                payload: state.modules[_this.moduleId].payload
            };
        };
        var moduleId = this.moduleId;
        var mapDispatchToProps = function (dispatch) {
            return {
                onDataChange: function (data) {
                    _this.data = Object.assign({}, _this.data, data);
                    dispatch(index_1.update({ moduleId: moduleId, partialPayload: data }));
                }
            };
        };
        var ConnectedComponent = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(componentClass);
        return (React.createElement(react_redux_1.Provider, { store: getStore() },
            React.createElement(ConnectedComponent, null)));
    };
    ModulWithRedux.prototype.renderInPlaceEditView = function () {
        var inPlaceEditViewClass = this.getInPlaceEditViewClass();
        if (!inPlaceEditViewClass) {
            return;
        }
        this.inPlaceEditorWrapper = document.createElement("div");
        document.body.appendChild(this.inPlaceEditorWrapper);
        ReactDOM.render(this.getConnectedComponent(inPlaceEditViewClass), this.inPlaceEditorWrapper);
    };
    ModulWithRedux.prototype.renderWebView = function () {
        ReactDOM.render(this.getConnectedComponent(this.getWebViewClass()), this.getContentElement());
    };
    ModulWithRedux.prototype.updateModul = function (cmsView, editView) {
        // we need to unmount the component because in updateModul the content is replaced in DOM
        var contentEl = this.getContentElement();
        if (contentEl) {
            ReactDOM.unmountComponentAtNode(contentEl);
        }
        _super.prototype.updateModul.call(this, cmsView, editView);
    };
    ModulWithRedux.prototype.getSaveData = function () {
        return Object.assign(this.data, {
            moduleId: this.moduleId,
            _diyNewlyAdded: this.getIsNew() ? 1 : 0
        });
    };
    /**
     * If the module needs more than one tab
     * it should return here tabs options
     * By default null is returned.
     * @returns {null}
     */
    ModulWithRedux.prototype.getActionBarTabs = function () {
        return null;
    };
    return ModulWithRedux;
}(Modul_1.default));
exports.default = ModulWithRedux;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var typedActions_1 = __webpack_require__(229);
var actionCreator = typedActions_1.actionCreatorFactory('diy/module/');
var initialState = {};
exports.update = actionCreator('UPDATE');
exports.load = actionCreator('LOAD');
// =======
// REDUCER
// =======
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    if (typedActions_1.isType(action, exports.update)) {
        // TODO refactor to use an imutable lib or util
        var newState = Object.assign({}, state);
        newState[action.payload.moduleId] = Object.assign({}, newState[action.payload.moduleId]);
        var newModule = newState[action.payload.moduleId];
        var newPayload = Object.assign({}, newModule.payload, action.payload.partialPayload);
        newModule.payload = newPayload;
        return newState;
    }
    if (typedActions_1.isType(action, exports.load)) {
        var newState = Object.assign({}, state);
        newState[action.payload.moduleId] = action.payload.moduleState;
        return newState;
    }
    return state;
}
// ==============
// INITIALIZATION
// ==============
var initialized = false;
function init(storeProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, "modules");
        initialized = true;
    }
}
exports.init = init;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var websiteData = __webpack_require__(4);
var $ = __webpack_require__(3);
var FeedbackButton_1 = __webpack_require__(461);
function DiyFeedbackSubmit(feedbackContext, feedbackType, feedbackText) {
    var feedbackTypeString = feedbackType === FeedbackButton_1.FeedbackType.POSITIVE ? "positive" : "negative";
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: "/rest/websites/" + websiteData.getId() + "/feedback",
            type: "POST",
            contentType: "application/json; application/vnd.oneandone.diy.website.feedback+json",
            data: JSON.stringify({
                feedbackContext: feedbackContext,
                feedbackType: feedbackTypeString,
                feedbackText: feedbackText
            }),
            success: function () {
                resolve();
            },
            error: function () {
                reject();
            }
        });
    });
}
exports.DiyFeedbackSubmit = DiyFeedbackSubmit;
;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentClear = function ContentClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
ContentClear = (0, _pure2.default)(ContentClear);
ContentClear.displayName = 'ContentClear';
ContentClear.muiName = 'SvgIcon';

exports.default = ContentClear;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSave = function ContentSave(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
  );
};
ContentSave = (0, _pure2.default)(ContentSave);
ContentSave.displayName = 'ContentSave';
ContentSave.muiName = 'SvgIcon';

exports.default = ContentSave;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Modul_1 = __webpack_require__(197);
var l10n_1 = __webpack_require__(18);
var AppRegistry_1 = __webpack_require__(190);
var index_1 = __webpack_require__(499);
var tracking_1 = __webpack_require__(501);
var watchSize_1 = __webpack_require__(488);
var index_2 = __webpack_require__(636);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
function getState() {
    return AppRegistry_1.default.getStoreProvider().getStore().getState().moduleSection;
}
var ModulSection = (function (_super) {
    tslib_1.__extends(ModulSection, _super);
    function ModulSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.extraMarginToSetTop = 42;
        _this.hasActionBar = true;
        _this.justUpdateWithoutRefresh = false;
        _this.changeEventTriggered = false;
        _this.helpArticleId = "addsections";
        return _this;
    }
    ModulSection.prototype.save = function () {
        //save functionality is disabled
        //we do all changes/saving through redux-react component
        this.close(true, false, true, false);
    };
    ModulSection.prototype.open = function () {
        getStore().dispatch(index_1.load({ moduleId: this.moduleId, data: this.data }));
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.Open);
        _super.prototype.open.apply(this, arguments);
        this.parallaxStartListening();
    };
    ModulSection.prototype.hasToggleableElement = function (alias) {
        return index_1.isToggleableElement(alias, getState());
    };
    ModulSection.prototype.getActionBarTabs = function () {
        var tabs = _super.prototype.getActionBarTabs.call(this);
        if (index_1.supportsAddGroup(getState())) {
            tabs.push({
                label: l10n_1.default('section.actionBar.tabs.groups.label'),
                content: this.getGroupsViewComponent()
            });
        }
        tabs.push({
            label: l10n_1.default('section.actionBar.tabs.advanced.label'),
            content: this.getAdvancedViewComponent()
        });
        return tabs;
    };
    ModulSection.prototype.onActionBarTabChange = function (v) {
        switch (v) {
            case 0:
                tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.MainTab);
                getStore().dispatch(index_1.closeManageGroupsIfActive());
                break;
            case 1:
                if (index_1.supportsAddGroup(getState())) {
                    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.GroupsTab);
                    getStore().dispatch(index_1.toggleManageGroups(true));
                }
                else {
                    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.DesignTab);
                    getStore().dispatch(index_1.closeManageGroupsIfActive());
                }
                break;
            case 2:
                tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.DesignTab);
                getStore().dispatch(index_1.closeManageGroupsIfActive());
                break;
            default:
        }
    };
    ModulSection.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
        getStore().dispatch(index_1.stopEditing());
        if (this.parallaxStopListening) {
            this.parallaxStopListening();
        }
    };
    ModulSection.prototype.remove = function () {
        if (this.data.background.parallax) {
            index_2.destroyWeb(this.moduleId);
            if (this.parallaxStopListening) {
                this.parallaxStopListening();
            }
        }
        _super.prototype.remove.call(this);
    };
    ModulSection.prototype.updateModul = function () {
        var _this = this;
        _super.prototype.updateModul.apply(this, arguments);
        //HACK: We need the new module instance because this one is getting destroyed
        //HACK: we use setTimeout because the new module element is not yet appended
        setTimeout(function () {
            Modul_1.default.getInstance(_this.moduleId).parallaxStartListening();
        }, 100);
    };
    ModulSection.prototype.getEditViewComponent = function () {
        var ConnectedEditView = index_1.getEditViewComponent(getStore());
        return React.createElement(ConnectedEditView);
    };
    ModulSection.prototype.onClickOutside = function () {
        getStore().dispatch(index_1.clickOutside());
    };
    ModulSection.prototype.emitCloseKpi = function () {
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.Close, 'button');
    };
    ModulSection.prototype.getData = function () {
        return this.data;
    };
    ModulSection.prototype.parallaxStartListening = function () {
        var _this = this;
        if (!this.data.background.parallax) {
            return;
        }
        this.parallaxStopListening = watchSize_1.watchSize(this.moduleElement, function () {
            index_2.refreshWeb(_this.moduleId);
        });
    };
    ModulSection.prototype.getAdvancedViewComponent = function () {
        var ConnectedAdvancedView = index_1.getAdvancedViewComponent(getStore());
        return React.createElement(ConnectedAdvancedView);
    };
    ModulSection.prototype.getGroupsViewComponent = function () {
        var ConnectedGroupsView = index_1.getGroupsViewComponent(getStore());
        return React.createElement(ConnectedGroupsView);
    };
    return ModulSection;
}(Modul_1.default));
exports.default = ModulSection;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(230);
var actionCreator = helper_1.actionCreatorFactory('diy/module/section/');
var Modul_1 = __webpack_require__(197);
var features = __webpack_require__(25);
var $ = __webpack_require__(3);
var globalEvents = __webpack_require__(500);
var tracking_1 = __webpack_require__(501);
var loadingMask_1 = __webpack_require__(524);
var index_1 = __webpack_require__(528);
var service_1 = __webpack_require__(534);
var serialization_1 = __webpack_require__(535);
var index_2 = __webpack_require__(536);
var state_1 = __webpack_require__(533);
// ==========
// PUBLIC API
// ==========
var advancedTab_1 = __webpack_require__(594);
exports.getAdvancedViewComponent = advancedTab_1.getAdvancedViewComponent;
var basicTab_1 = __webpack_require__(603);
exports.getEditViewComponent = basicTab_1.getEditViewComponent;
var groupsTab_1 = __webpack_require__(628);
exports.getGroupsViewComponent = groupsTab_1.getGroupsViewComponent;
var serialization_2 = __webpack_require__(535);
exports.serializeBackgroundSettings = serialization_2.serializeBackgroundSettings;
exports.unserializeBackgroundSettings = serialization_2.unserializeBackgroundSettings;
var service_2 = __webpack_require__(534);
exports.updateData = service_2.updateData;
exports.addGroup = service_2.addGroup;
exports.delGroup = service_2.delGroup;
exports.updateBackgroundImage = service_2.updateBackgroundImage;
exports.saveTransformedBackgroundImage = service_2.saveTransformedBackgroundImage;
exports.load = actionCreator("MODULE_SECTION_LOAD");
var toggleManageGroupsRaw = actionCreator("MODULE_SECTION_TOGGLE_MANAGE_GROUPS");
exports.toggleElementsMenuRaw = actionCreator("MODULE_SECTION_TOGGLE_ELEMENTS_MENU");
function toggleElementsMenu(payload) {
    return function (dispatch, getState) {
        dispatch(index_2.setCurrentTab({ nextTab: 0 }));
        // We have to wait for the tab to render
        setTimeout(function () {
            dispatch(exports.toggleElementsMenuRaw(payload));
        }, 500);
    };
}
exports.toggleElementsMenu = toggleElementsMenu;
exports.toggleBackgroundMenu = actionCreator("MODULE_SECTION_TOGGLE_BACKGROUND_MENU");
exports.openAviary = actionCreator("MODULE_SECTION_OPEN_AVIARY");
exports.closeAviary = actionCreator("MODULE_SECTION_CLOSE_AVIARY");
function openAviarySection() {
    return function (dispatch, getState) {
        var ownState = getState().moduleSection;
        dispatch(exports.openAviary({
            moduleId: ownState.moduleId,
            transformedImageUrl: ownState.background.transformedImageUrl,
            origImageUrl: ownState.background.origImageUrl,
            imageMediaType: ownState.background.imageMediaType
        }));
    };
}
exports.openAviarySection = openAviarySection;
function stopEditing() {
    return function (dispatch, getState) {
        dispatch(closeManageGroupsIfActive());
    };
}
exports.stopEditing = stopEditing;
function clickOutside() {
    return function (dispatch, getState) {
        var currentState = getState().moduleSection;
        if (currentState.manageGroupsActive) {
            dispatch(toggleManageGroups(false));
            dispatch(index_2.setCurrentTab({ nextTab: 0 }));
        }
        else {
            tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.Close, 'outside');
            Modul_1.default.getInstance(currentState.moduleId).save();
        }
    };
}
exports.clickOutside = clickOutside;
function closeManageGroupsIfActive() {
    return function (dispatch, getState) {
        var currentState = getState().moduleSection;
        if (currentState.manageGroupsActive) {
            dispatch(toggleManageGroups(false));
        }
    };
}
exports.closeManageGroupsIfActive = closeManageGroupsIfActive;
function updatePayload(payload) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        service_1.updateData(state.moduleId, payload).then(function (data) {
            dispatch(exports.load({ moduleId: state.moduleId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        }).catch(function (reason) {
            globalEvents.trigger("error.diy-editor", { "message": JSON.stringify(reason) });
        });
    };
}
exports.updatePayload = updatePayload;
function addGroupAction() {
    return function (dispatch, getState) {
        var sectionId = getState().moduleSection.moduleId;
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.AddGroup);
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        service_1.addGroup(sectionId).then(function (data) {
            dispatch(exports.load({ moduleId: sectionId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        }).catch(function (reason) {
            globalEvents.trigger("error.diy-editor", { "message": JSON.stringify(reason) });
        });
    };
}
exports.addGroupAction = addGroupAction;
function deleteGroupAction(groupId) {
    return function (dispatch, getState) {
        var sectionId = getState().moduleSection.moduleId;
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.DeleteGroup);
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        service_1.delGroup(groupId).then(function (data) {
            dispatch(exports.load({ moduleId: sectionId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        }).catch(function (reason) {
            globalEvents.trigger("error.diy-editor", { "message": JSON.stringify(reason) });
        });
    };
}
exports.deleteGroupAction = deleteGroupAction;
function syncGroupsBackgroundTo(groupId) {
    return function (dispatch, getState) {
        var sectionId = getState().moduleSection.moduleId;
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.BackgroundApplyOnAll);
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        service_1.syncGroupsBackground(groupId).then(function (data) {
            dispatch(exports.load({ moduleId: sectionId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        }).catch(function (reason) {
            globalEvents.trigger("error.diy-editor", { "message": JSON.stringify(reason) });
        });
    };
}
exports.syncGroupsBackgroundTo = syncGroupsBackgroundTo;
function changeBackgroundImage(imageId, imageType, successCallback, errorCallback) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.BackgroundImage);
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        service_1.updateBackgroundImage(state.moduleId, imageId, imageType, successCallback, errorCallback).then(function (data) {
            dispatch(exports.load({ moduleId: state.moduleId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        }).catch(function (reason) {
            globalEvents.trigger("error.diy-editor", { "message": JSON.stringify(reason) });
        });
    };
}
exports.changeBackgroundImage = changeBackgroundImage;
function saveBackgroundImage(imageDataUrl) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        dispatch(exports.closeAviary({}));
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        service_1.saveTransformedBackgroundImage(state.aviaryOptions.moduleId, imageDataUrl).then(function (data) {
            dispatch(exports.load({ moduleId: state.aviaryOptions.moduleId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        }).catch(function (reason) {
            globalEvents.trigger("error.diy-editor", { "message": JSON.stringify(reason) });
        });
    };
}
exports.saveBackgroundImage = saveBackgroundImage;
function supportsAddGroup(state) {
    return features('sectionGroups') === true &&
        state.quantity.current > 0 &&
        state.configurableGroups.length > 0;
}
exports.supportsAddGroup = supportsAddGroup;
function isToggleableElement(alias, state) {
    if (!state.toggles) {
        return false;
    }
    return !!state.toggles.find(function (g) { return !!g.toggles.find(function (t) { return t.id === alias; }); });
}
exports.isToggleableElement = isToggleableElement;
function toggleManageGroups(active) {
    return function (dispatch, getState) {
        if (active) {
            tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.ManageGroupsOpen);
        }
        else {
            tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.ManageGroupsClose);
        }
        dispatch(toggleManageGroupsRaw({ active: active }));
    };
}
exports.toggleManageGroups = toggleManageGroups;
// =====
// STATE
// =====
var initialState = {};
// =======
// REDUCER
// =======
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    if (helper_1.isType(action, exports.load)) {
        return helper_1.objectOverride(state, serialization_1.unserializePayload(action.payload.moduleId, action.payload.data));
    }
    if (helper_1.isType(action, toggleManageGroupsRaw)) {
        return helper_1.objectOverride(state, {
            manageGroupsActive: action.payload.active
        });
    }
    if (helper_1.isType(action, exports.toggleElementsMenuRaw)) {
        return helper_1.objectOverride(state, {
            elementsMenuVisible: action.payload.visible
        });
    }
    if (helper_1.isType(action, exports.toggleBackgroundMenu)) {
        return helper_1.objectOverride(state, {
            backgroundMenuVisible: action.payload.visible
        });
    }
    if (helper_1.isType(action, exports.openAviary)) {
        return helper_1.objectOverride(state, {
            backgroundMenuVisible: false,
            aviaryOpen: true,
            aviaryOptions: {
                moduleId: action.payload.moduleId,
                origImageUrl: action.payload.origImageUrl,
                transformedImageUrl: action.payload.transformedImageUrl,
                imageMediaType: action.payload.imageMediaType
            }
        });
    }
    if (helper_1.isType(action, exports.closeAviary)) {
        return helper_1.objectOverride(state, {
            aviaryOpen: false,
            aviaryOptions: null
        });
    }
    return helper_1.objectOverride(state, {
        loadingMask: loadingMask_1.reducer(state.loadingMask, action)
    });
}
// ==============
// INITIALIZATION
// ==============
var initialized = false;
function init(storeProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, state_1.MODULE_SECTION_STATE_KEY);
        index_1.init(storeProvider);
        initialized = true;
    }
}
exports.init = init;
function render(store) {
    loadingMask_1.render(store);
    index_1.render(store);
}
exports.render = render;
function isModuleLimitReached() {
    return $("#cc-sa-sidebar").hasClass('modules-maximum');
}
exports.isModuleLimitReached = isModuleLimitReached;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// XXX use let instead of import because of siteadmin hack below
var $ = __webpack_require__(3);
if (top !== window && typeof process === 'undefined') {
    $ = diy.editor.jQuery;
}
var $document = $(document);
module.exports = {
    trigger: function (eventName, payload) {
        $document.trigger(eventName, payload);
    },
    one: function (eventName, handler) {
        $document.one(eventName, handler);
    },
    on: function (eventName, handler) {
        $document.bind(eventName, handler);
    },
    off: function (eventName, handler) {
        $document.unbind(eventName, handler);
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundSelectorView_1 = __webpack_require__(502);
var ColorSelectorView_1 = __webpack_require__(503);
var globalEvents = __webpack_require__(500);
var trackAsPage = 'diy-tracking-section-page';
var trackAsPageClosed = 'diy-tracking-section-page-closed';
var trackAsMenu = 'diy-tracking-section-menu';
var trackAsLink = 'diy-tracking-section-link';
var SectionKpiEventsTypes;
(function (SectionKpiEventsTypes) {
    SectionKpiEventsTypes[SectionKpiEventsTypes["Open"] = 0] = "Open";
    SectionKpiEventsTypes[SectionKpiEventsTypes["Close"] = 1] = "Close";
    SectionKpiEventsTypes[SectionKpiEventsTypes["MainTab"] = 2] = "MainTab";
    SectionKpiEventsTypes[SectionKpiEventsTypes["GroupsTab"] = 3] = "GroupsTab";
    SectionKpiEventsTypes[SectionKpiEventsTypes["DesignTab"] = 4] = "DesignTab";
    SectionKpiEventsTypes[SectionKpiEventsTypes["LayoutChanged"] = 5] = "LayoutChanged";
    SectionKpiEventsTypes[SectionKpiEventsTypes["ToggleContent"] = 6] = "ToggleContent";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundNone"] = 7] = "BackgroundNone";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundColor"] = 8] = "BackgroundColor";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundSwatch"] = 9] = "BackgroundSwatch";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundTheming"] = 10] = "BackgroundTheming";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundCustomColor"] = 11] = "BackgroundCustomColor";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundImage"] = 12] = "BackgroundImage";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundEditImage"] = 13] = "BackgroundEditImage";
    SectionKpiEventsTypes[SectionKpiEventsTypes["BackgroundApplyOnAll"] = 14] = "BackgroundApplyOnAll";
    SectionKpiEventsTypes[SectionKpiEventsTypes["ManageGroupsOpen"] = 15] = "ManageGroupsOpen";
    SectionKpiEventsTypes[SectionKpiEventsTypes["ManageGroupsClose"] = 16] = "ManageGroupsClose";
    SectionKpiEventsTypes[SectionKpiEventsTypes["ManageGroupsBackground"] = 17] = "ManageGroupsBackground";
    SectionKpiEventsTypes[SectionKpiEventsTypes["FullWidthChanged"] = 18] = "FullWidthChanged";
    SectionKpiEventsTypes[SectionKpiEventsTypes["StyleChanged"] = 19] = "StyleChanged";
    SectionKpiEventsTypes[SectionKpiEventsTypes["RoundnessChanged"] = 20] = "RoundnessChanged";
    SectionKpiEventsTypes[SectionKpiEventsTypes["ColumnsChanged"] = 21] = "ColumnsChanged";
    SectionKpiEventsTypes[SectionKpiEventsTypes["ColumnsFitChanged"] = 22] = "ColumnsFitChanged";
    SectionKpiEventsTypes[SectionKpiEventsTypes["AddGroup"] = 23] = "AddGroup";
    SectionKpiEventsTypes[SectionKpiEventsTypes["DeleteGroup"] = 24] = "DeleteGroup";
})(SectionKpiEventsTypes = exports.SectionKpiEventsTypes || (exports.SectionKpiEventsTypes = {}));
var eventList = [
    {
        type: SectionKpiEventsTypes.Open,
        trackingType: trackAsPage,
        data: {
            appendProps: "open"
        }
    },
    {
        type: SectionKpiEventsTypes.Close,
        trackingType: trackAsPageClosed,
        data: {
            appendProps: "close"
        }
    },
    {
        type: SectionKpiEventsTypes.MainTab,
        trackingType: trackAsMenu,
        data: {
            appendProps: "mainTab"
        }
    },
    {
        type: SectionKpiEventsTypes.DesignTab,
        trackingType: trackAsMenu,
        data: {
            appendProps: "designTab"
        }
    },
    {
        type: SectionKpiEventsTypes.GroupsTab,
        trackingType: trackAsMenu,
        data: {
            appendProps: "groupsTab"
        }
    },
    {
        type: SectionKpiEventsTypes.LayoutChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "layoutChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.ToggleContent,
        trackingType: trackAsLink,
        data: {
            appendProps: "toggleContent"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundNone,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToNone"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundColor,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToColor"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundSwatch,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToColorSwatch"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundTheming,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToTheming"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundCustomColor,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToCustomColor"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundImage,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundChangedToImage"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundEditImage,
        trackingType: trackAsLink,
        data: {
            appendProps: "backgroundEditedImage"
        }
    },
    {
        type: SectionKpiEventsTypes.ManageGroupsOpen,
        trackingType: trackAsMenu,
        data: {
            appendProps: "openManageGroups"
        }
    },
    {
        type: SectionKpiEventsTypes.ManageGroupsClose,
        trackingType: trackAsMenu,
        data: {
            appendProps: "mainTab"
        }
    },
    {
        type: SectionKpiEventsTypes.ManageGroupsBackground,
        trackingType: trackAsMenu,
        data: {
            appendProps: "manageGroupsBackground"
        }
    },
    {
        type: SectionKpiEventsTypes.FullWidthChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "fullWidthChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.StyleChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "styleChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.RoundnessChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "RoundnessChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.ColumnsChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "ColumnsChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.ColumnsFitChanged,
        trackingType: trackAsLink,
        data: {
            appendProps: "ColumnsFitChanged"
        }
    },
    {
        type: SectionKpiEventsTypes.AddGroup,
        trackingType: trackAsLink,
        data: {
            appendProps: "AddGroup"
        }
    },
    {
        type: SectionKpiEventsTypes.DeleteGroup,
        trackingType: trackAsLink,
        data: {
            appendProps: "DeleteGroup"
        }
    },
    {
        type: SectionKpiEventsTypes.BackgroundApplyOnAll,
        trackingType: trackAsLink,
        data: {
            appendProps: "BackgroundApplyOnAll"
        }
    }
];
var eventsByType = new Map();
eventList.forEach(function (event) { return eventsByType.set(event.type, event); });
exports.events = eventsByType;
function emitKpiEvent(eventType, appendProps) {
    var event = eventsByType.get(eventType);
    var data = Object.assign({}, event.data);
    if (appendProps && appendProps.length) {
        data.appendProps += ':' + appendProps;
    }
    globalEvents.trigger(event.trackingType, data);
}
exports.emitKpiEvent = emitKpiEvent;
function trackBackgroundColorClicked(colorType, value) {
    switch (colorType) {
        case ColorSelectorView_1.ColorType.Swatch:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundSwatch);
            break;
        case ColorSelectorView_1.ColorType.Custom:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundCustomColor);
            break;
        case ColorSelectorView_1.ColorType.Theming:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundTheming);
            break;
        default:
    }
}
exports.trackBackgroundColorClicked = trackBackgroundColorClicked;
function trackBackgroundTabClicked(tab) {
    switch (tab) {
        case BackgroundSelectorView_1.Tab.None:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundNone);
            break;
        case BackgroundSelectorView_1.Tab.Image:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundImage);
            break;
        case BackgroundSelectorView_1.Tab.Color:
            emitKpiEvent(SectionKpiEventsTypes.BackgroundColor);
            break;
        default:
    }
}
exports.trackBackgroundTabClicked = trackBackgroundTabClicked;
function trackManageGroupBackgroundClicked() {
    emitKpiEvent(SectionKpiEventsTypes.ManageGroupsBackground);
}
exports.trackManageGroupBackgroundClicked = trackManageGroupBackgroundClicked;
function trackBackgroundImageEdited() {
    emitKpiEvent(SectionKpiEventsTypes.BackgroundEditImage);
}
exports.trackBackgroundImageEdited = trackBackgroundImageEdited;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var ColorSelectorView_1 = __webpack_require__(503);
var ImageSelectorView_1 = __webpack_require__(512);
var state_1 = __webpack_require__(511);
var l10n = __webpack_require__(18);
var color_1 = __webpack_require__(504);
var autoprefixer_1 = __webpack_require__(438);
var not_interested_1 = __webpack_require__(520);
var palette_1 = __webpack_require__(521);
var image_1 = __webpack_require__(522);
var layoutData_1 = __webpack_require__(523);
var FlatButton_1 = __webpack_require__(479);
var Tab;
(function (Tab) {
    Tab[Tab["None"] = 0] = "None";
    Tab[Tab["Color"] = 1] = "Color";
    Tab[Tab["Image"] = 2] = "Image";
})(Tab = exports.Tab || (exports.Tab = {}));
;
var bgTypeToTabMap = new Map()
    .set(state_1.BackgroundType.None, Tab.None)
    .set(state_1.BackgroundType.Color, Tab.Color)
    .set(state_1.BackgroundType.Theming, Tab.Color)
    .set(state_1.BackgroundType.Image, Tab.Image);
;
var BackgroundSelectorView = (function (_super) {
    tslib_1.__extends(BackgroundSelectorView, _super);
    function BackgroundSelectorView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentTab: bgTypeToTabMap.get(props.background.type)
        };
        return _this;
    }
    BackgroundSelectorView.prototype.renderButton = function (type, label, Icon, onTouchTap) {
        var tab = bgTypeToTabMap.get(type);
        return React.createElement(IconTextButton_1.default, { text: label, Icon: React.createElement(Icon, null), style: autoprefixer_1.autoprefixer({ flexGrow: 1 }), buttonStyle: { width: "100%" }, onTouchTap: function () { onTouchTap(); }, useAlternativeColors: true, isPressed: this.state.currentTab === tab, dataTestId: "background-selector-type-" + tab });
    };
    BackgroundSelectorView.prototype.changeBackground = function (background) {
        if (this.props.background.type !== background.type) {
            this.props.onChange(background);
        }
    };
    BackgroundSelectorView.prototype.renderDivider = function () {
        return React.createElement("div", { style: { width: 3 } });
    };
    BackgroundSelectorView.prototype.renderApplyOnAllGroups = function () {
        var _this = this;
        if (this.props.onApplyOnAllGroups) {
            return React.createElement("div", { style: {
                    padding: 10,
                    textAlign: 'right'
                } },
                React.createElement(FlatButton_1.default, { label: l10n.getString('section.backgroundSettings.applyToAll'), primary: true, onTouchTap: function () { _this.props.onApplyOnAllGroups(); } }));
        }
        return null;
    };
    BackgroundSelectorView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { style: {
                    fontFamily: "open sans",
                    fontSize: '14px',
                    lineHeight: '14px',
                    padding: '10px 10px 0 10px',
                    /*put the padding here to could align the custom color box to the popover width */
                    color: '#666'
                } }, l10n.getString('section.backgroundSettings.title')),
            !this.props.onlyColor ?
                React.createElement("div", { style: autoprefixer_1.autoprefixer({
                        display: 'flex',
                        flexDirection: 'row',
                        padding: 10,
                    }) },
                    this.renderButton(state_1.BackgroundType.None, l10n.getString('section.backgroundSettings.types.none.label'), not_interested_1.default, function () {
                        _this.setState({ currentTab: Tab.None });
                        _this.changeBackground({
                            type: state_1.BackgroundType.None
                        });
                        if (_this.props.onTabClicked) {
                            _this.props.onTabClicked(Tab.None);
                        }
                    }),
                    this.renderDivider(),
                    this.renderButton(state_1.BackgroundType.Color, l10n.getString('section.backgroundSettings.types.color.label'), palette_1.default, function () {
                        _this.setState({ currentTab: Tab.Color });
                        _this.changeBackground(_this.getLastColorBackground());
                        if (_this.props.onTabClicked) {
                            _this.props.onTabClicked(Tab.Color);
                        }
                    }),
                    this.renderDivider(),
                    this.renderButton(state_1.BackgroundType.Image, l10n.getString('section.backgroundSettings.types.image.label'), image_1.default, function () {
                        _this.setState({ currentTab: Tab.Image });
                        if (_this.props.background.imageUrl && _this.props.background.imageUrl.length) {
                            _this.changeBackground({
                                type: state_1.BackgroundType.Image
                            });
                        }
                        if (_this.props.onTabClicked) {
                            _this.props.onTabClicked(Tab.Image);
                        }
                    })) :
                //separate the title from whatever follows
                React.createElement("div", { style: { height: 10 } }),
            this.state.currentTab === Tab.Color || this.props.onlyColor ?
                React.createElement(ColorSelectorView_1.default, { type: this.props.background.type, color: this.props.background.color ? this.props.background.color : null, themingZone: this.props.background.zone !== null ?
                        this.props.background.zone :
                        null, showThemingZones: layoutData_1.layoutData.hasTheming(), onColorSelected: function (value, colorType) {
                        if (_this.props.onColorClicked) {
                            _this.props.onColorClicked(colorType, color_1.default.rgb2hex(value));
                        }
                        _this.props.onChange({
                            type: state_1.BackgroundType.Color,
                            zone: null,
                            color: value
                        });
                    }, onThemingZoneSelected: function (v) {
                        if (_this.props.onColorClicked) {
                            _this.props.onColorClicked(ColorSelectorView_1.ColorType.Theming, v.toString());
                        }
                        _this.props.onChange({
                            type: state_1.BackgroundType.Theming,
                            zone: v,
                            color: null
                        });
                    } }) :
                (this.state.currentTab === Tab.Image ?
                    React.createElement("div", { style: { paddingTop: 10 } },
                        React.createElement(ImageSelectorView_1.default, { imageUrl: this.props.background.imageUrl, parallaxAvailable: this.props.parallaxAvailable, parallaxEnabled: this.props.parallaxAvailable ?
                                this.props.background.parallax : null, onImageChange: this.props.onImageChange, onEditImageClicked: this.props.onEditImageClicked, onSelectImageClicked: this.props.onSelectImageClicked, shading: this.props.background.shading, onShadingChange: function (shading) {
                                var newShaddingIsDifferent = shading.alpha !== _this.props.background.shading.alpha ||
                                    shading.color[0] !== _this.props.background.shading.color[0] ||
                                    shading.color[1] !== _this.props.background.shading.color[1] ||
                                    shading.color[2] !== _this.props.background.shading.color[2] ||
                                    shading.enabled !== _this.props.background.shading.enabled;
                                if (newShaddingIsDifferent) {
                                    _this.props.onChange({
                                        type: state_1.BackgroundType.Image,
                                        shading: shading
                                    });
                                }
                            }, onParallaxToggle: function () {
                                _this.props.onChange({
                                    type: void 0,
                                    parallax: !_this.props.background.parallax
                                });
                            } })) : null),
            this.state.currentTab !== Tab.Image ? this.renderApplyOnAllGroups() : null));
    };
    BackgroundSelectorView.prototype.getLastColorBackground = function () {
        var bg = this.props.background;
        var lastColor = bg.color;
        var lastZone = bg.zone;
        // Default checked is the first theming zone
        var type = state_1.BackgroundType.Theming;
        var zone = 0;
        var color = null;
        if (lastColor !== null) {
            type = state_1.BackgroundType.Color;
            zone = null;
            color = lastColor;
        }
        else {
            if (lastZone !== null) {
                zone = bg.zone;
            }
        }
        return {
            type: type,
            zone: zone,
            color: color
        };
    };
    return BackgroundSelectorView;
}(React.Component));
exports.default = BackgroundSelectorView;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var color_1 = __webpack_require__(504);
var TextField_1 = __webpack_require__(473);
var l10n = __webpack_require__(18);
var autoprefixer_1 = __webpack_require__(438);
var ColorSwatchItem_1 = __webpack_require__(505);
var arrow_drop_up_1 = __webpack_require__(508);
var arrow_drop_down_1 = __webpack_require__(509);
var ThemingZones_1 = __webpack_require__(510);
var state_1 = __webpack_require__(511);
var ColorType;
(function (ColorType) {
    ColorType[ColorType["Swatch"] = 0] = "Swatch";
    ColorType[ColorType["Theming"] = 1] = "Theming";
    ColorType[ColorType["Custom"] = 2] = "Custom";
})(ColorType = exports.ColorType || (exports.ColorType = {}));
var ColorSelectorView = (function (_super) {
    tslib_1.__extends(ColorSelectorView, _super);
    function ColorSelectorView(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultCustomColor = '';
        _this.predefinedColors = [
            '#b81c1c', '#32691e', '#00579a', '#f57f17', '#455a64', '#000000',
            '#f44336', '#61994d', '#2985cc', '#fbc02d', '#607d8b', '#c7c7c7',
            '#e67373', '#b5e6a3', '#66bdff', '#fff066', '#90a4ae', '#a9a8a8',
            '#ffe5e5', '#ecffe5', '#cce9ff', '#fffbd9', '#cfd8dc', '#ffffff'
        ];
        var hexValue = props.color ? color_1.default.rgb2hex(props.color) : _this.defaultCustomColor;
        _this.state = {
            customColorOpened: props.type === state_1.BackgroundType.Color && _this.predefinedColors.indexOf(hexValue) === -1,
            customColorValue: hexValue,
            customColorInputValue: hexValue,
            customColorValidationErrors: []
        };
        return _this;
    }
    ColorSelectorView.prototype.onColorSelected = function (colorHexValue, source, force) {
        if (force === void 0) { force = false; }
        //used the hex comparison because of the "number"<>number comparison fail
        var prevColor = this.props.color;
        if (force || !prevColor ||
            (prevColor && colorHexValue !== color_1.default.rgb2hex(prevColor))) {
            var rgbaValue = color_1.default.hex2rgb(colorHexValue);
            rgbaValue.alpha = 1;
            this.props.onColorSelected(rgbaValue, source);
        }
    };
    ColorSelectorView.prototype.getGroupedPredefinedColors = function (itemsPerLine) {
        if (itemsPerLine === void 0) { itemsPerLine = 6; }
        var noLines = this.predefinedColors.length / itemsPerLine;
        var groupedColors = [[]];
        for (var i = 0; i < noLines; i++) {
            var start = itemsPerLine * i;
            groupedColors[i] = this.predefinedColors.slice(start, start + itemsPerLine);
        }
        return groupedColors;
    };
    ColorSelectorView.prototype.onChangeCustomColor = function (value, force) {
        if (force === void 0) { force = false; }
        var correctedValue = value;
        var newState = {
            customColorValidationErrors: []
        };
        if (value.substr(0, 1) === '#') {
            correctedValue = correctedValue.substr(1, correctedValue.length - 1);
        } /* else {
            newState.customColorValidationErrors.push("A valid hex color begins with #");
        }*/
        if (correctedValue.length > 6) {
            correctedValue = correctedValue.substr(0, 6);
            //no error showed - just emulate a maxLength
        }
        var i = 0;
        var invalidCharsFound = false;
        while (i < correctedValue.length) {
            var char = correctedValue[i];
            if (!char.match(/[a-f0-9]/)) {
                correctedValue = correctedValue.replace(char, '');
                invalidCharsFound = true;
            }
            i++;
        }
        if (invalidCharsFound) {
            newState.customColorValidationErrors.push(l10n.getString('section.colorSelector.customColor.validation.invalidCharacters'));
        }
        correctedValue = '#' + correctedValue;
        newState.customColorInputValue = correctedValue;
        this.setState(newState);
        if (correctedValue.length === 7) {
            this.onColorSelected(correctedValue, ColorType.Custom, force);
        }
    };
    ColorSelectorView.prototype.renderCustomInput = function () {
        var _this = this;
        var hexPropColorValue = this.props.color ? color_1.default.rgb2hex(this.props.color) : this.defaultCustomColor;
        var isCustomColorInputUsed = this.props.type === state_1.BackgroundType.Color &&
            hexPropColorValue === this.state.customColorInputValue
            && this.predefinedColors.indexOf(hexPropColorValue) === -1;
        return React.createElement("div", { style: {
                backgroundColor: '#f2f2f2',
                minHeight: 20,
                color: 'lightgrey',
                padding: 10
            } },
            React.createElement("div", { style: autoprefixer_1.autoprefixer({
                    display: 'flex',
                    flexDirection: 'row',
                    cursor: 'pointer',
                    alignItems: 'center'
                }), onClick: function () {
                    _this.setState({
                        customColorOpened: !_this.state.customColorOpened,
                        customColorValue: hexPropColorValue,
                        customColorInputValue: hexPropColorValue
                    });
                }, "data-test-id": "custom-color-toggle" },
                React.createElement("div", { style: autoprefixer_1.autoprefixer({
                        flexGrow: 1,
                        fontSize: 14,
                        color: '#666',
                        display: 'flex',
                        alignItems: 'center'
                    }) },
                    l10n.getString('section.colorSelector.customColor.title'),
                    this.state.customColorOpened ? React.createElement(arrow_drop_up_1.default, null) : React.createElement(arrow_drop_down_1.default, null)),
                React.createElement("div", { style: Object.assign(autoprefixer_1.autoprefixer({ flexGrow: 0 }), this.state.customColorOpened || isCustomColorInputUsed ?
                        {} :
                        { visibility: 'hidden' } /* this keeps the height of the custom color expand box fixed */) },
                    React.createElement(ColorSwatchItem_1.ColorSwatchItem, { color: this.state.customColorInputValue, checked: isCustomColorInputUsed }))),
            this.state.customColorOpened ?
                React.createElement(TextField_1.default, { errorText: this.state.customColorValidationErrors.join("<br />"), value: this.state.customColorInputValue, floatingLabelText: l10n.getString('section.colorSelector.customColor.inputField.floatingLabelText'), onChange: function (e) {
                        _this.onChangeCustomColor(e.target.value);
                    }, onFocus: function (e) {
                        _this.onChangeCustomColor(e.target.value, true);
                    }, style: { maxWidth: 218 }, "data-test-id": "custom-color-input" }) : null);
    };
    ColorSelectorView.prototype.render = function () {
        var _this = this;
        var itemsPerLine = 6;
        return React.createElement("div", null,
            React.createElement("div", { style: {
                    padding: '0 10px 10px 10px',
                } },
                this.props.showThemingZones ? React.createElement("div", { style: {
                        fontFamily: "open sans",
                        fontSize: '14px',
                        lineHeight: '14px',
                        paddingBottom: 10,
                        color: '#666'
                    } }, l10n.getString('section.colorSelector.themingZones.title')) : null,
                this.props.showThemingZones ? React.createElement(ThemingZones_1.ThemingZones, { activeZone: this.props.type === state_1.BackgroundType.Theming ?
                        this.props.themingZone :
                        null, onZoneSelected: function (v) {
                        _this.setState({
                            customColorOpened: false,
                            customColorValue: null,
                            customColorInputValue: null,
                            customColorValidationErrors: []
                        });
                        _this.props.onThemingZoneSelected(v);
                    } }) : null,
                React.createElement("div", { style: {
                        fontFamily: "open sans",
                        fontSize: '14px',
                        lineHeight: '14px',
                        paddingBottom: 10,
                        color: '#666'
                    } }, l10n.getString('section.colorSelector.swatchList.title')),
                this.getGroupedPredefinedColors(itemsPerLine).map(function (colors, lineNumber) {
                    return React.createElement("div", { key: "color-line-" + lineNumber, style: autoprefixer_1.autoprefixer({
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginBottom: ((lineNumber + 1) * itemsPerLine) >= _this.predefinedColors.length ? 0 : 10
                        }) }, colors.map(function (colorValue, colorIndex) {
                        return React.createElement("div", { key: "swatch-" + lineNumber + "-" + colorIndex, style: {
                                display: 'inline-block',
                                marginRight: (colorIndex + 1) % itemsPerLine === 0 ? 0 : 8
                            }, onClick: function () {
                                _this.setState({
                                    customColorOpened: false,
                                    customColorValue: null,
                                    customColorInputValue: null,
                                    customColorValidationErrors: []
                                });
                                _this.onColorSelected(colorValue, ColorType.Swatch);
                            }, "data-test-id": "color-swatch-" + lineNumber + "-" + colorIndex },
                            React.createElement(ColorSwatchItem_1.ColorSwatchItem, { color: colorValue, checked: _this.props.type === state_1.BackgroundType.Color &&
                                    color_1.default.rgb2hex(_this.props.color) === colorValue }));
                    }));
                })),
            this.renderCustomInput());
    };
    return ColorSelectorView;
}(React.Component));
exports.default = ColorSelectorView;


/***/ },
/* 504 */
/***/ function(module, exports) {

/**
 * Utility functions related to color operations
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Color = (function () {
    function Color() {
    }
    /* convert colors of type "rgb(255,255,255)" to hex values like #ffffff */
    Color.number2hex = function (x) {
        return ("0" + parseInt(x, 10).toString(16)).slice(-2);
    };
    /**
     *
     * @param rgb ("rgb(2,255,40)"), for IE the format is "rgba(23,45,345,1)"
     * @returns {string}
     */
    Color.rgbString2hex = function (rgb) {
        if (rgb.startsWith('rgb')) {
            var _a = rgb.replace(/^rgba?\(/, "").replace(/\)$/, "").split(",").map(function (v) { return parseInt(v, 10); }), r = _a[0], g = _a[1], b = _a[2];
            return "#" + this.number2hex(r) + this.number2hex(g) + this.number2hex(b);
        }
        return rgb;
    };
    Color.rgb2hex = function (rgb) {
        return "#" + this.number2hex(rgb.red + "") + this.number2hex(rgb.green + "") + this.number2hex(rgb.blue + "");
    };
    /**
     * converts colors of type #abcd09 to array like [100, 50, 30] (rgb)
     * @param arr
     */
    Color.hex2array = function (hex) {
        hex = hex.replace('#', '');
        var r = hex[0] + hex[1];
        var g = hex[2] + hex[3];
        var b = hex[4] + hex[5];
        return [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16)];
    };
    Color.hex2rgb = function (hex) {
        var data = this.hex2array(hex);
        return {
            red: data[0],
            green: data[1],
            blue: data[2]
        };
    };
    /**
     * converts colors of type [100, 50, 30] (rgb) to #abcd09
     * @param arr
     */
    Color.array2hex = function (arr) {
        var r = parseInt(arr[0], 10).toString(16);
        var g = parseInt(arr[1], 10).toString(16);
        var b = parseInt(arr[2], 10).toString(16);
        r = r.length === 1 ? '0' + r : r;
        g = g.length === 1 ? '0' + g : g;
        b = b.length === 1 ? '0' + b : b;
        return '#' + r + g + b;
    };
    Color.rgb2hsb = function (rgb) {
        var hsb = { hue: 0, saturation: 0, brightness: 0 };
        var min = Math.min(rgb.red, rgb.green, rgb.blue);
        var max = Math.max(rgb.red, rgb.green, rgb.blue);
        var delta = max - min;
        hsb.brightness = max;
        hsb.saturation = max !== 0 ? 255 * delta / max : 0;
        if (hsb.saturation !== 0) {
            if (rgb.red === max) {
                hsb.hue = (rgb.green - rgb.blue) / delta;
            }
            else if (rgb.green === max) {
                hsb.hue = 2 + (rgb.blue - rgb.red) / delta;
            }
            else {
                hsb.hue = 4 + (rgb.red - rgb.green) / delta;
            }
        }
        else {
            hsb.hue = -1;
        }
        hsb.hue *= 60;
        if (hsb.hue < 0) {
            hsb.hue += 360;
        }
        hsb.saturation = hsb.saturation * 100 / 255;
        hsb.brightness = hsb.brightness * 100 / 255;
        return hsb;
    };
    Color.hsb2rgb = function (hsb) {
        var rgb = {};
        var h = Math.round(hsb.hue);
        var s = Math.round(hsb.saturation * 255 / 100);
        var v = Math.round(hsb.brightness * 255 / 100);
        if (s === 0) {
            rgb.red = rgb.green = rgb.blue = v;
        }
        else {
            var t1 = v;
            var t2 = (255 - s) * v / 255;
            var t3 = (t1 - t2) * (h % 60) / 60;
            if (h === 360) {
                h = 0;
            }
            if (h < 60) {
                rgb.red = t1;
                rgb.blue = t2;
                rgb.green = t2 + t3;
            }
            else if (h < 120) {
                rgb.green = t1;
                rgb.blue = t2;
                rgb.red = t1 - t3;
            }
            else if (h < 180) {
                rgb.green = t1;
                rgb.red = t2;
                rgb.blue = t2 + t3;
            }
            else if (h < 240) {
                rgb.blue = t1;
                rgb.red = t2;
                rgb.green = t1 - t3;
            }
            else if (h < 300) {
                rgb.blue = t1;
                rgb.green = t2;
                rgb.red = t2 + t3;
            }
            else if (h < 360) {
                rgb.red = t1;
                rgb.green = t2;
                rgb.blue = t1 - t3;
            }
            else {
                rgb.red = 0;
                rgb.green = 0;
                rgb.blue = 0;
            }
        }
        return {
            red: Math.round(rgb.red),
            green: Math.round(rgb.green),
            blue: Math.round(rgb.blue)
        };
    };
    /**
     * Computes if a color is perceived as dark or bright - between 0 (dark) and 1 (bright)
     */
    Color.computePerceivedLightness = function (color) {
        /*@see http://stackoverflow.com/questions/12043187/how-to-check-if-hex-color-is-too-black/12043228#12043228 */
        var lightness = (0.2126 * color.red + 0.7152 * color.green + 0.0722 * color.blue) / 255; // per ITU-R BT.709
        return lightness;
    };
    return Color;
}());
exports.default = Color;
;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Avatar_1 = __webpack_require__(506);
var color_1 = __webpack_require__(504);
var autoprefixer_1 = __webpack_require__(438);
var check_1 = __webpack_require__(399);
var ColorSwatchItem = (function (_super) {
    tslib_1.__extends(ColorSwatchItem, _super);
    function ColorSwatchItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorSwatchItem.prototype.render = function () {
        var color = this.props.color;
        var checkColor = this.props.checkColor;
        var isChecked = this.props.checked;
        if (!checkColor && isChecked) {
            var rgbValue = color_1.default.hex2rgb(color);
            if (color_1.default.computePerceivedLightness(rgbValue) > .686) {
                checkColor = "black";
            }
            else {
                checkColor = "white";
            }
        }
        return React.createElement(Avatar_1.default, { icon: isChecked ? React.createElement(check_1.default, { style: { margin: 0 } }) : null, backgroundColor: color, color: checkColor, style: autoprefixer_1.autoprefixer({
                boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden'
            }), size: this.props.size, className: this.props.className }, this.props.children);
    };
    return ColorSwatchItem;
}(React.Component));
ColorSwatchItem.defaultProps = {
    size: 30
};
exports.ColorSwatchItem = ColorSwatchItem;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Avatar = __webpack_require__(507);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var backgroundColor = props.backgroundColor;
  var color = props.color;
  var size = props.size;
  var avatar = context.muiTheme.avatar;


  var styles = {
    root: {
      color: color || avatar.color,
      backgroundColor: backgroundColor || avatar.backgroundColor,
      userSelect: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size / 2,
      borderRadius: '50%',
      height: size,
      width: size
    },
    icon: {
      color: color || avatar.color,
      width: size * 0.6,
      height: size * 0.6,
      fontSize: size * 0.6,
      margin: size * 0.2
    }
  };

  return styles;
}

var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Avatar).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var backgroundColor = _props.backgroundColor;
      var icon = _props.icon;
      var src = _props.src;
      var style = _props.style;
      var className = _props.className;

      var other = _objectWithoutProperties(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      if (src) {
        return _react2.default.createElement('img', _extends({
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other, {
          src: src,
          className: className
        }));
      } else {
        return _react2.default.createElement(
          'div',
          _extends({}, other, {
            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
            className: className
          }),
          icon && _react2.default.cloneElement(icon, {
            color: styles.icon.color,
            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
          }),
          this.props.children
        );
      }
    }
  }]);

  return Avatar;
}(_react.Component);

Avatar.muiName = 'Avatar';
Avatar.propTypes = {
  /**
   * The backgroundColor of the avatar. Does not apply to image avatars.
   */
  backgroundColor: _react.PropTypes.string,
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root `div` or `img` element.
   */
  className: _react.PropTypes.string,
  /**
   * The icon or letter's color.
   */
  color: _react.PropTypes.string,
  /**
   * This is the SvgIcon or FontIcon to be used inside the avatar.
   */
  icon: _react.PropTypes.element,
  /**
   * This is the size of the avatar in pixels.
   */
  size: _react.PropTypes.number,
  /**
   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
   */
  src: _react.PropTypes.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
Avatar.defaultProps = {
  size: 40
};
Avatar.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Avatar;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropUp = function NavigationArrowDropUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' })
  );
};
NavigationArrowDropUp = (0, _pure2.default)(NavigationArrowDropUp);
NavigationArrowDropUp.displayName = 'NavigationArrowDropUp';
NavigationArrowDropUp.muiName = 'SvgIcon';

exports.default = NavigationArrowDropUp;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
  );
};
NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
NavigationArrowDropDown.muiName = 'SvgIcon';

exports.default = NavigationArrowDropDown;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var ColorSwatchItem_1 = __webpack_require__(505);
/**
 * Harcoded number of theming zones. Most layouts have 5 zones. Layouts with fewer zones
 * will have default colors black/white for remaining undefined zones
 */
var ZONES_COUNT = 5;
var ZONE_CLASS_PREFIX = 'diyfeColor';
var SWATCH_ITEM_SIZE = 30;
var ThemingZones = (function (_super) {
    tslib_1.__extends(ThemingZones, _super);
    function ThemingZones() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemingZones.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.container }, this.renderZones()));
    };
    ThemingZones.prototype.getStyles = function () {
        return {
            container: autoprefixer_1.autoprefixer({
                display: 'flex',
                marginBottom: 10
            }),
            zone: {
                marginRight: 8
            },
            webReset: {
                height: 'auto',
                minHeight: 'auto'
            },
            liveArea: {
                borderRadius: SWATCH_ITEM_SIZE / 2
            }
        };
    };
    ThemingZones.prototype.renderZones = function () {
        var _this = this;
        var styles = this.getStyles();
        var zones = [];
        var _loop_1 = function (i, len) {
            var zoneClassName = ZONE_CLASS_PREFIX + i;
            var isActive = this_1.props.activeZone === i;
            var zone = (React.createElement("div", { style: styles.zone, key: i, onTouchTap: function () { return _this.props.onZoneSelected(i); } },
                React.createElement("div", { className: "diyw", style: styles.webReset },
                    React.createElement("div", { className: zoneClassName, style: styles.liveArea },
                        React.createElement(ColorSwatchItem_1.ColorSwatchItem
                        /* Uses color from theming live classes*/
                        , { 
                            /* Uses color from theming live classes*/
                            color: "transparent", checkColor: "currentColor", checked: isActive, size: SWATCH_ITEM_SIZE })))));
            zones.push(zone);
        };
        var this_1 = this;
        for (var i = 0, len = ZONES_COUNT; i < len; i++) {
            _loop_1(i, len);
        }
        return zones;
    };
    return ThemingZones;
}(React.Component));
exports.ThemingZones = ThemingZones;


/***/ },
/* 511 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundType;
(function (BackgroundType) {
    BackgroundType[BackgroundType["None"] = 0] = "None";
    BackgroundType[BackgroundType["Color"] = 1] = "Color";
    BackgroundType[BackgroundType["Image"] = 2] = "Image";
    BackgroundType[BackgroundType["Theming"] = 3] = "Theming";
})(BackgroundType = exports.BackgroundType || (exports.BackgroundType = {}));


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var Toggle_1 = __webpack_require__(513);
var l10n = __webpack_require__(18);
var autoprefixer_1 = __webpack_require__(438);
var collections_1 = __webpack_require__(516);
var add_circle_1 = __webpack_require__(517);
var Slider_1 = __webpack_require__(518);
var ImageSelectorView = (function (_super) {
    tslib_1.__extends(ImageSelectorView, _super);
    function ImageSelectorView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            shading: props.shading
        };
        return _this;
    }
    ImageSelectorView.prototype.componentWillReceiveProps = function (nextProps) {
        this.state = Object.assign({}, this.state, {
            shading: nextProps.shading
        });
    };
    ImageSelectorView.prototype.getImageChangeCallback = function (type) {
        var _this = this;
        return function (items, succClb, errClb) {
            _this.props.onImageChange(items[0].getId(), type, succClb, errClb);
        };
    };
    ImageSelectorView.prototype.selectImage = function () {
        var sources = {
            storage: {
                batchSize: 10,
                callback: this.getImageChangeCallback('storage')
            },
            cms: {
                batchSize: 1,
                callback: this.getImageChangeCallback('cms')
            },
            bigstock: {
                batchSize: 1,
                callback: this.getImageChangeCallback('storage')
            },
            '123rf': {
                batchSize: 1,
                callback: this.getImageChangeCallback('storage')
            }
        };
        diy.editor.filemanager = new diy.editor.Filemanager({
            appName: 'filemanager',
            mode: 'selection',
            maxSelection: 1,
            alreadyExisting: 0,
            sources: sources,
            callback: function () {
                //do nothing
            }
        });
        this.props.onSelectImageClicked();
    };
    ImageSelectorView.prototype.hasImage = function () {
        return this.props.imageUrl && this.props.imageUrl.length;
    };
    ImageSelectorView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { margin: '0 10px 10px 10px' } },
            React.createElement("div", { style: autoprefixer_1.autoprefixer({
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative'
                }) },
                this.hasImage() ?
                    React.createElement("div", { onTouchTap: function () { _this.selectImage(); }, style: autoprefixer_1.autoprefixer({
                            backgroundImage: "url(" + this.props.imageUrl + ")",
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            height: 110,
                            cursor: 'pointer',
                            border: '1px solid rgba(117, 117, 117, 0.4)',
                            borderRadius: '2px',
                            boxSizing: 'border-box',
                            flexGrow: 1
                        }), "data-test-id": "background-image-preview" },
                        React.createElement("div", { style: { backgroundColor: 'rgba(0, 0, 0, .45)', height: '100%' } })) : null,
                this.hasImage() ?
                    React.createElement("div", { style: {
                            position: 'absolute',
                            top: '50%',
                            left: 0,
                            width: '100%',
                            padding: '10px',
                            boxSizing: 'border-box',
                            transform: 'translateY(-50%)'
                        } },
                        React.createElement(IconTextButton_1.default, { style: autoprefixer_1.autoprefixer({
                                marginTop: 10,
                                flexGrow: 1,
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '50%'
                            }), buttonStyle: {
                                width: "100%"
                            }, Icon: React.createElement(collections_1.default, null), text: l10n.getString('section.imageSelector.buttons.changeImage.label'), onTouchTap: function () { return _this.selectImage(); }, dataTestId: "background-change-image", useLightColors: true, isLabelWrapped: true }),
                        React.createElement(IconTextButton_1.default, { style: autoprefixer_1.autoprefixer({
                                marginTop: 10,
                                flexGrow: 1,
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '50%'
                            }), buttonStyle: { width: "100%" }, Icon: React.createElement(collections_1.default, null), text: l10n.getString('section.imageSelector.buttons.editImage.label'), onTouchTap: function () { return _this.props.onEditImageClicked(); }, dataTestId: "background-edit-image", useLightColors: true, isLabelWrapped: true })) :
                    React.createElement(IconTextButton_1.default, { style: autoprefixer_1.autoprefixer({
                            marginTop: 10,
                            flexGrow: 1,
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '2px dashed #e1e1e1',
                            display: 'flex',
                            height: 112
                        }), Icon: React.createElement(add_circle_1.default, null), text: l10n.getString('section.imageSelector.buttons.selectImage.label'), onTouchTap: function () { return _this.selectImage(); }, dataTestId: "background-select-image", useAlternativeColors: true })),
            this.hasImage() && this.state.shading.enabled ?
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 10,
                        borderBottom: this.props.parallaxAvailable ? '1px #ccc solid' : void 0
                    } },
                    React.createElement("div", null,
                        l10n.getString('section.imageSelector.buttons.shading.label'),
                        " ",
                        this.state.shading.alpha),
                    React.createElement(Slider_1.default, { sliderStyle: {
                            marginTop: 10,
                            marginBottom: 10
                        }, value: this.state.shading.alpha, defaultValue: 0.5, step: 0.05, min: 0.1, max: 0.9, onChange: function (e, value) {
                            var newShading = Object.assign({}, _this.state.shading, {
                                alpha: value
                            });
                            //keyboard
                            if (e.type === 'keydown') {
                                _this.props.onShadingChange(newShading);
                            }
                            else {
                                _this.setState(Object.assign({}, _this.state, { shading: newShading }));
                            }
                        }, onDragStop: function () {
                            _this.props.onShadingChange(_this.state.shading);
                        } }))
                : null,
            this.hasImage() && this.props.parallaxAvailable ?
                React.createElement("div", { style: {
                        marginTop: 10
                    } },
                    React.createElement(Toggle_1.default, { label: l10n.getString('section.imageSelector.parallax.label'), toggled: this.props.parallaxEnabled, onToggle: this.props.onParallaxToggle })) :
                null));
    };
    return ImageSelectorView;
}(React.Component));
exports.default = ImageSelectorView;


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Toggle = __webpack_require__(514);

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toggle2.default;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

var _EnhancedSwitch = __webpack_require__(515);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context, state) {
  var disabled = props.disabled;
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var toggle = _context$muiTheme.toggle;


  var toggleSize = 20;
  var toggleTrackWidth = 36;
  var styles = {
    icon: {
      width: 36,
      padding: '4px 0px 6px 2px'
    },
    ripple: {
      top: -10,
      left: -10,
      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
    },
    toggleElement: {
      width: toggleTrackWidth
    },
    track: {
      transition: _transitions2.default.easeOut(),
      width: '100%',
      height: 14,
      borderRadius: 30,
      backgroundColor: toggle.trackOffColor
    },
    thumb: {
      transition: _transitions2.default.easeOut(),
      position: 'absolute',
      top: 1,
      left: 0,
      width: toggleSize,
      height: toggleSize,
      lineHeight: '24px',
      borderRadius: '50%',
      backgroundColor: toggle.thumbOffColor
    },
    trackWhenSwitched: {
      backgroundColor: toggle.trackOnColor
    },
    thumbWhenSwitched: {
      backgroundColor: toggle.thumbOnColor,
      left: '100%'
    },
    trackWhenDisabled: {
      backgroundColor: toggle.trackDisabledColor,
      cursor: 'not-allowed'
    },
    thumbWhenDisabled: {
      backgroundColor: toggle.thumbDisabledColor,
      cursor: 'not-allowed'
    },
    label: {
      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)',
      cursor: disabled ? 'not-allowed' : 'initial'
    }
  };

  return styles;
}

var Toggle = function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Toggle)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = { switched: false }, _this.handleToggle = function (event, isInputChecked) {
      if (_this.props.onToggle) _this.props.onToggle(event, isInputChecked);
    }, _this.handleStateChange = function (newSwitched) {
      _this.setState({ switched: newSwitched });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Toggle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props;
      var toggled = _props.toggled;
      var defaultToggled = _props.defaultToggled;
      var valueLink = _props.valueLink;


      if (toggled || defaultToggled || valueLink && valueLink.value) {
        this.setState({ switched: true });
      }
    }
  }, {
    key: 'isToggled',
    value: function isToggled() {
      return this.refs.enhancedSwitch.isSwitched();
    }
  }, {
    key: 'setToggled',
    value: function setToggled(newToggledValue) {
      this.refs.enhancedSwitch.setSwitched(newToggledValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var defaultToggled = _props2.defaultToggled;
      var onToggle = _props2.onToggle;
      var toggled = _props2.toggled;

      var other = _objectWithoutProperties(_props2, ['defaultToggled', 'onToggle', 'toggled']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var trackStyles = (0, _simpleAssign2.default)({}, styles.track, this.props.trackStyle, this.state.switched && styles.trackWhenSwitched, this.props.disabled && styles.trackWhenDisabled);

      var thumbStyles = (0, _simpleAssign2.default)({}, styles.thumb, this.props.thumbStyle, this.state.switched && styles.thumbWhenSwitched, this.props.disabled && styles.thumbWhenDisabled);

      if (this.state.switched) {
        thumbStyles.marginLeft = 0 - thumbStyles.width;
      }

      var toggleElementStyles = (0, _simpleAssign2.default)({}, styles.toggleElement, this.props.elementStyle);

      var toggleElement = _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)({}, toggleElementStyles)) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyles)) }),
        _react2.default.createElement(_Paper2.default, { style: thumbStyles, circle: true, zDepth: 1 })
      );

      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, this.props.rippleStyle);

      var iconStyle = (0, _simpleAssign2.default)({}, styles.icon, this.props.iconStyle);

      var labelStyle = (0, _simpleAssign2.default)({}, styles.label, this.props.labelStyle);

      var enhancedSwitchProps = {
        ref: 'enhancedSwitch',
        inputType: 'checkbox',
        switchElement: toggleElement,
        rippleStyle: rippleStyle,
        rippleColor: rippleStyle.color,
        iconStyle: iconStyle,
        trackStyle: trackStyles,
        thumbStyle: thumbStyles,
        labelStyle: labelStyle,
        switched: this.state.switched,
        onSwitch: this.handleToggle,
        onParentShouldUpdate: this.handleStateChange,
        labelPosition: this.props.labelPosition
      };

      if (this.props.hasOwnProperty('toggled')) {
        enhancedSwitchProps.checked = toggled;
      } else if (this.props.hasOwnProperty('defaultToggled')) {
        enhancedSwitchProps.defaultChecked = defaultToggled;
      }

      return _react2.default.createElement(_EnhancedSwitch2.default, _extends({}, other, enhancedSwitchProps));
    }
  }]);

  return Toggle;
}(_react.Component);

Toggle.propTypes = {
  /**
   * Determines whether the Toggle is initially turned on.
   * **Warning:** This cannot be used in conjunction with `toggled`.
   * Decide between using a controlled or uncontrolled input element and remove one of these props.
   * More info: https://fb.me/react-controlled-components
   */
  defaultToggled: _react.PropTypes.bool,
  /**
   * Will disable the toggle if true.
   */
  disabled: _react.PropTypes.bool,
  /**
   * Overrides the inline-styles of the Toggle element.
   */
  elementStyle: _react.PropTypes.object,
  /**
   * Overrides the inline-styles of the Icon element.
   */
  iconStyle: _react.PropTypes.object,
  /**
   * Overrides the inline-styles of the input element.
   */
  inputStyle: _react.PropTypes.object,
  /**
   * Label for toggle.
   */
  label: _react.PropTypes.string,
  /**
   * Where the label will be placed next to the toggle.
   */
  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
  /**
   * Overrides the inline-styles of the Toggle element label.
   */
  labelStyle: _react.PropTypes.object,
  /**
   * Callback function that is fired when the toggle switch is toggled.
   */
  onToggle: _react.PropTypes.func,
  /**
   * Override style of ripple.
   */
  rippleStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Override style for thumb.
   */
  thumbStyle: _react.PropTypes.object,
  /**
   * Toggled if set to true.
   */
  toggled: _react.PropTypes.bool,
  /**
   * Override style for track.
   */
  trackStyle: _react.PropTypes.object,
  /**
   * ValueLink prop for when using controlled toggle.
   */
  valueLink: _react.PropTypes.object
};
Toggle.defaultProps = {
  defaultToggled: false,
  disabled: false,
  labelPosition: 'left'
};
Toggle.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Toggle;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__(388);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(415);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(416);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(376);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

var _warning = __webpack_require__(367);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      cursor: props.disabled ? 'default' : 'pointer',
      overflow: 'visible',
      display: 'table',
      height: 'auto',
      width: '100%'
    },
    input: {
      position: 'absolute',
      cursor: props.disabled ? 'default' : 'pointer',
      pointerEvents: 'all',
      opacity: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      left: 0,
      boxSizing: 'border-box',
      padding: 0,
      margin: 0
    },
    controls: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    label: {
      float: 'left',
      position: 'relative',
      display: 'block',
      width: 'calc(100% - 60px)',
      lineHeight: '24px',
      color: baseTheme.palette.textColor,
      fontFamily: baseTheme.fontFamily
    },
    wrap: {
      transition: _transitions2.default.easeOut(),
      float: 'left',
      position: 'relative',
      display: 'block',
      flexShrink: 0,
      width: 60 - baseTheme.spacing.desktopGutterLess,
      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
    },
    ripple: {
      color: props.rippleColor || baseTheme.palette.primary1Color,
      height: '200%',
      width: '200%',
      top: -12,
      left: -12
    }
  };
}

var EnhancedSwitch = function (_Component) {
  _inherits(EnhancedSwitch, _Component);

  function EnhancedSwitch() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, EnhancedSwitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedSwitch)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleChange = function (event) {
      _this.tabPressed = false;
      _this.setState({
        isKeyboardFocused: false
      });

      var isInputChecked = _this.refs.checkbox.checked;

      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
        _this.props.onParentShouldUpdate(isInputChecked);
      }
      if (_this.props.onSwitch) {
        _this.props.onSwitch(event, isInputChecked);
      }
    }, _this.handleKeyDown = function (event) {
      var code = (0, _keycode2.default)(event);

      if (code === 'tab') {
        _this.tabPressed = true;
      }
      if (_this.state.isKeyboardFocused && code === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.refs.touchRipple.start(event);
      }
    }, _this.handleMouseUp = function () {
      _this.refs.touchRipple.end();
    }, _this.handleMouseLeave = function () {
      _this.refs.touchRipple.end();
    }, _this.handleTouchStart = function (event) {
      _this.refs.touchRipple.start(event);
    }, _this.handleTouchEnd = function () {
      _this.refs.touchRipple.end();
    }, _this.handleBlur = function (event) {
      _this.setState({
        isKeyboardFocused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      // setTimeout is needed becuase the focus event fires first
      // Wait so that we can capture if this was a keyboard focus
      // or touch focus
      setTimeout(function () {
        if (_this.tabPressed) {
          _this.setState({
            isKeyboardFocused: true
          });
        }
      }, 150);

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnhancedSwitch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inputNode = this.refs.checkbox;
      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
        this.props.onParentShouldUpdate(inputNode.checked);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hasCheckedProp = nextProps.hasOwnProperty('checked');
      var hasToggledProp = nextProps.hasOwnProperty('toggled');
      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;

      if (hasCheckedProp || hasToggledProp || hasNewDefaultProp) {
        var switched = nextProps.checked || nextProps.toggled || nextProps.defaultChecked || false;

        this.setState({
          switched: switched
        });

        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
          this.props.onParentShouldUpdate(switched);
        }
      }
    }
  }, {
    key: 'isSwitched',
    value: function isSwitched() {
      return this.refs.checkbox.checked;
    }

    // no callback here because there is no event

  }, {
    key: 'setSwitched',
    value: function setSwitched(newSwitchedValue) {
      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
        if (this.props.onParentShouldUpdate) {
          this.props.onParentShouldUpdate(newSwitchedValue);
        }
        this.refs.checkbox.checked = newSwitchedValue;
      } else {
         false ? (0, _warning2.default)(false, 'Cannot call set method while checked is defined as a property.') : void 0;
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.refs.checkbox.value;
    }

    // Checkbox inputs only use SPACE to change their state. Using ENTER will
    // update the ui but not the input.


    /**
     * Because both the ripples and the checkbox input cannot share pointer
     * events, the checkbox input takes control of pointer events and calls
     * ripple animations manually.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var name = _props.name;
      var value = _props.value;
      var iconStyle = _props.iconStyle;
      var inputStyle = _props.inputStyle;
      var inputType = _props.inputType;
      var label = _props.label;
      var labelStyle = _props.labelStyle;
      var labelPosition = _props.labelPosition;
      var onSwitch = _props.onSwitch;
      var onBlur = _props.onBlur;
      var onFocus = _props.onFocus;
      var onMouseUp = _props.onMouseUp;
      var onMouseDown = _props.onMouseDown;
      var onMouseLeave = _props.onMouseLeave;
      var onTouchStart = _props.onTouchStart;
      var onTouchEnd = _props.onTouchEnd;
      var onParentShouldUpdate = _props.onParentShouldUpdate;
      var disabled = _props.disabled;
      var disableTouchRipple = _props.disableTouchRipple;
      var disableFocusRipple = _props.disableFocusRipple;
      var className = _props.className;
      var rippleColor = _props.rippleColor;
      var rippleStyle = _props.rippleStyle;
      var style = _props.style;
      var switched = _props.switched;
      var switchElement = _props.switchElement;
      var thumbStyle = _props.thumbStyle;
      var trackStyle = _props.trackStyle;

      var other = _objectWithoutProperties(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);

      if (thumbStyle) {
        wrapStyles.marginLeft /= 2;
        wrapStyles.marginRight /= 2;
      }

      var labelElement = label && _react2.default.createElement(
        'label',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
        label
      );

      var showTouchRipple = !disabled && !disableTouchRipple;
      var showFocusRipple = !disabled && !disableFocusRipple;

      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
        ref: 'touchRipple',
        key: 'touchRipple',
        style: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        centerRipple: true
      });

      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
        key: 'focusRipple',
        innerStyle: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        show: this.state.isKeyboardFocused
      });

      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];

      var inputElement = _react2.default.createElement('input', _extends({}, other, {
        ref: 'checkbox',
        type: inputType,
        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
        name: name,
        value: value,
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        onMouseUp: showTouchRipple && this.handleMouseUp,
        onMouseDown: showTouchRipple && this.handleMouseDown,
        onMouseLeave: showTouchRipple && this.handleMouseLeave,
        onTouchStart: showTouchRipple && this.handleTouchStart,
        onTouchEnd: showTouchRipple && this.handleTouchEnd
      }));

      // If toggle component (indicated by whether the style includes thumb) manually lay out
      // elements in order to nest ripple elements
      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        switchElement,
        ripples
      ) : _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
        _react2.default.createElement(
          _Paper2.default,
          { style: thumbStyle, zDepth: 1, circle: true },
          ' ',
          ripples,
          ' '
        )
      );

      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
        'div',
        { style: styles.controls },
        switchOrThumbElement,
        labelElement
      ) : _react2.default.createElement(
        'div',
        { style: styles.controls },
        labelElement,
        switchOrThumbElement
      );

      return _react2.default.createElement(
        'div',
        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp
        }),
        inputElement,
        elementsInOrder
      );
    }
  }]);

  return EnhancedSwitch;
}(_react.Component);

EnhancedSwitch.propTypes = {
  checked: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  defaultChecked: _react.PropTypes.bool,
  disableFocusRipple: _react.PropTypes.bool,
  disableTouchRipple: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  iconStyle: _react.PropTypes.object,
  inputStyle: _react.PropTypes.object,
  inputType: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.node,
  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
  labelStyle: _react.PropTypes.object,
  name: _react.PropTypes.string,
  onBlur: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  onMouseDown: _react.PropTypes.func,
  onMouseLeave: _react.PropTypes.func,
  onMouseUp: _react.PropTypes.func,
  onParentShouldUpdate: _react.PropTypes.func,
  onSwitch: _react.PropTypes.func,
  onTouchEnd: _react.PropTypes.func,
  onTouchStart: _react.PropTypes.func,
  rippleColor: _react.PropTypes.string,
  rippleStyle: _react.PropTypes.object,
  style: _react.PropTypes.object,
  switchElement: _react.PropTypes.element.isRequired,
  switched: _react.PropTypes.bool.isRequired,
  thumbStyle: _react.PropTypes.object,
  trackStyle: _react.PropTypes.object,
  value: _react.PropTypes.any
};
EnhancedSwitch.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = EnhancedSwitch;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCollections = function ImageCollections(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
  );
};
ImageCollections = (0, _pure2.default)(ImageCollections);
ImageCollections.displayName = 'ImageCollections';
ImageCollections.muiName = 'SvgIcon';

exports.default = ImageCollections;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddCircle = function ContentAddCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
  );
};
ContentAddCircle = (0, _pure2.default)(ContentAddCircle);
ContentAddCircle.displayName = 'ContentAddCircle';
ContentAddCircle.muiName = 'SvgIcon';

exports.default = ContentAddCircle;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Slider = __webpack_require__(519);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Slider2.default;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _keycode = __webpack_require__(415);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(416);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Verifies min/max range.
 * @param   {Object} props         Properties of the React component.
 * @param   {String} propName      Name of the property to validate.
 * @param   {String} componentName Name of the component whose property is being validated.
 * @returns {Object} Returns an Error if min >= max otherwise null.
 */
var minMaxPropType = function minMaxPropType(props, propName, componentName) {
  var error = _react.PropTypes.number(props, propName, componentName);
  if (error !== null) return error;

  if (props.min >= props.max) {
    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
    return new Error(errorMsg);
  }
};

/**
 * Verifies value is within the min/max range.
 * @param   {Object} props         Properties of the React component.
 * @param   {String} propName      Name of the property to validate.
 * @param   {String} componentName Name of the component whose property is being validated.
 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
 */
var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
  var error = _react.PropTypes.number(props, propName, componentName);
  if (error !== null) return error;

  var value = props[propName];
  if (value < props.min || props.max < value) {
    return new Error(propName + ' should be within the range specified by min and max');
  }
};

var crossAxisProperty = {
  x: 'height',
  'x-reverse': 'height',
  y: 'width',
  'y-reverse': 'width'
};

var crossAxisOffsetProperty = {
  x: 'top',
  'x-reverse': 'top',
  y: 'left',
  'y-reverse': 'left'
};

var mainAxisProperty = {
  x: 'width',
  'x-reverse': 'width',
  y: 'height',
  'y-reverse': 'height'
};

var mainAxisMarginFromEnd = {
  x: 'marginRight',
  'x-reverse': 'marginLeft',
  y: 'marginTop',
  'y-reverse': 'marginBottom'
};

var mainAxisMarginFromStart = {
  x: 'marginLeft',
  'x-reverse': 'marginRight',
  y: 'marginBottom',
  'y-reverse': 'marginTop'
};

var mainAxisOffsetProperty = {
  x: 'left',
  'x-reverse': 'right',
  y: 'bottom',
  'y-reverse': 'top'
};

var mainAxisClientProperty = {
  x: 'clientWidth',
  'x-reverse': 'clientWidth',
  y: 'clientHeight',
  'y-reverse': 'clientHeight'
};

var mainAxisClientOffsetProperty = {
  x: 'clientX',
  'x-reverse': 'clientX',
  y: 'clientY',
  'y-reverse': 'clientY'
};

var reverseMainAxisOffsetProperty = {
  x: 'right',
  'x-reverse': 'left',
  y: 'top',
  'y-reverse': 'bottom'
};

var isMouseControlInverted = function isMouseControlInverted(axis) {
  return axis === 'x-reverse' || axis === 'y';
};

var getStyles = function getStyles(props, context, state) {
  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;

  var slider = context.muiTheme.slider;

  var fillGutter = slider.handleSize / 2;
  var disabledGutter = slider.trackSize + slider.handleSizeDisabled / 2;
  var calcDisabledSpacing = props.disabled ? ' - ' + disabledGutter + 'px' : '';
  var axis = props.axis;

  var styles = {
    slider: (_slider = {
      touchCallout: 'none',
      userSelect: 'none',
      cursor: 'default'
    }, _defineProperty(_slider, crossAxisProperty[axis], slider.handleSizeActive), _defineProperty(_slider, mainAxisProperty[axis], '100%'), _defineProperty(_slider, 'position', 'relative'), _defineProperty(_slider, 'marginTop', 24), _defineProperty(_slider, 'marginBottom', 48), _slider),
    track: (_track = {
      position: 'absolute'
    }, _defineProperty(_track, crossAxisOffsetProperty[axis], (slider.handleSizeActive - slider.trackSize) / 2), _defineProperty(_track, mainAxisOffsetProperty[axis], 0), _defineProperty(_track, mainAxisProperty[axis], '100%'), _defineProperty(_track, crossAxisProperty[axis], slider.trackSize), _track),
    filledAndRemaining: (_filledAndRemaining = {
      position: 'absolute'
    }, _defineProperty(_filledAndRemaining, crossAxisOffsetProperty, 0), _defineProperty(_filledAndRemaining, crossAxisProperty[axis], '100%'), _defineProperty(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
    handle: (_handle = {
      boxSizing: 'border-box',
      position: 'absolute',
      cursor: 'pointer',
      pointerEvents: 'inherit'
    }, _defineProperty(_handle, crossAxisOffsetProperty[axis], 0), _defineProperty(_handle, mainAxisOffsetProperty[axis], state.percent === 0 ? '0%' : state.percent * 100 + '%'), _defineProperty(_handle, 'zIndex', 1), _defineProperty(_handle, 'margin', {
      x: slider.trackSize / 2 + 'px 0 0 0',
      'x-reverse': slider.trackSize / 2 + 'px 0 0 0',
      y: '0 0 0 ' + slider.trackSize / 2 + 'px',
      'y-reverse': '0 0 0 ' + slider.trackSize / 2 + 'px'
    }[props.axis]), _defineProperty(_handle, 'width', slider.handleSize), _defineProperty(_handle, 'height', slider.handleSize), _defineProperty(_handle, 'backgroundColor', slider.selectionColor), _defineProperty(_handle, 'backgroundClip', 'padding-box'), _defineProperty(_handle, 'border', '0px solid transparent'), _defineProperty(_handle, 'borderRadius', '50%'), _defineProperty(_handle, 'transform', {
      x: 'translate(-50%, -50%)',
      'x-reverse': 'translate(50%, -50%)',
      y: 'translate(-50%, 50%)',
      'y-reverse': 'translate(-50%, -50%)'
    }[props.axis]), _defineProperty(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), _defineProperty(_handle, 'overflow', 'visible'), _defineProperty(_handle, 'outline', 'none'), _handle),
    handleWhenDisabled: {
      boxSizing: 'content-box',
      cursor: 'not-allowed',
      backgroundColor: slider.trackColor,
      width: slider.handleSizeDisabled,
      height: slider.handleSizeDisabled,
      border: 'none'
    },
    handleWhenPercentZero: {
      border: slider.trackSize + 'px solid ' + slider.handleColorZero,
      backgroundColor: slider.handleFillColor,
      boxShadow: 'none'
    },
    handleWhenPercentZeroAndDisabled: {
      cursor: 'not-allowed',
      width: slider.handleSizeDisabled,
      height: slider.handleSizeDisabled
    },
    handleWhenPercentZeroAndFocused: {
      border: slider.trackSize + 'px solid ' + slider.trackColorSelected
    },
    handleWhenActive: {
      width: slider.handleSizeActive,
      height: slider.handleSizeActive
    },
    ripple: {
      height: slider.handleSize,
      width: slider.handleSize,
      overflow: 'visible'
    },
    rippleWhenPercentZero: {
      top: -slider.trackSize,
      left: -slider.trackSize
    },
    rippleInner: {
      height: '300%',
      width: '300%',
      top: -slider.handleSize,
      left: -slider.handleSize
    },
    rippleColor: {
      fill: state.percent === 0 ? slider.handleColorZero : slider.rippleColor
    }
  };
  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, _defineProperty(_objectAssign2, mainAxisOffsetProperty[axis], 0), _defineProperty(_objectAssign2, 'backgroundColor', props.disabled ? slider.trackColor : slider.selectionColor), _defineProperty(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), _defineProperty(_objectAssign2, mainAxisProperty[axis], 'calc(' + state.percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, _defineProperty(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), _defineProperty(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !props.disabled ? slider.trackColorSelected : slider.trackColor), _defineProperty(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), _defineProperty(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - state.percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));

  return styles;
};

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Slider)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      active: false,
      dragging: false,
      focused: false,
      hovered: false,
      percent: 0,
      value: 0
    }, _this.onHandleTouchStart = function (event) {
      if (document) {
        document.addEventListener('touchmove', _this.dragTouchHandler, false);
        document.addEventListener('touchup', _this.dragTouchEndHandler, false);
        document.addEventListener('touchend', _this.dragTouchEndHandler, false);
        document.addEventListener('touchcancel', _this.dragTouchEndHandler, false);
      }
      _this.onDragStart(event);

      // Cancel scroll and context menu
      event.preventDefault();
    }, _this.onHandleMouseDown = function (event) {
      if (document) {
        document.addEventListener('mousemove', _this.dragHandler, false);
        document.addEventListener('mouseup', _this.dragEndHandler, false);

        // Cancel text selection
        event.preventDefault();

        // Set focus manually since we called preventDefault()
        _this.refs.handle.focus();
      }
      _this.onDragStart(event);
    }, _this.onHandleKeyDown = function (event) {
      var _this$props = _this.props;
      var axis = _this$props.axis;
      var min = _this$props.min;
      var max = _this$props.max;
      var step = _this$props.step;

      var action = void 0;

      switch ((0, _keycode2.default)(event)) {
        case 'page down':
        case 'down':
          if (axis === 'y-reverse') {
            action = 'increase';
          } else {
            action = 'decrease';
          }
          break;
        case 'left':
          if (axis === 'x-reverse') {
            action = 'increase';
          } else {
            action = 'decrease';
          }
          break;
        case 'page up':
        case 'up':
          if (axis === 'y-reverse') {
            action = 'decrease';
          } else {
            action = 'increase';
          }
          break;
        case 'right':
          if (axis === 'x-reverse') {
            action = 'decrease';
          } else {
            action = 'increase';
          }
          break;
        case 'home':
          action = 'home';
          break;
        case 'end':
          action = 'end';
          break;
      }

      if (action) {
        var newValue = void 0;
        var newPercent = void 0;

        // Cancel scroll
        event.preventDefault();

        // When pressing home or end the handle should be taken to the
        // beginning or end of the track respectively
        switch (action) {
          case 'decrease':
            newValue = Math.max(min, _this.state.value - step);
            newPercent = (newValue - min) / (max - min);
            break;
          case 'increase':
            newValue = Math.min(max, _this.state.value + step);
            newPercent = (newValue - min) / (max - min);
            break;
          case 'home':
            newValue = min;
            newPercent = 0;
            break;
          case 'end':
            newValue = max;
            newPercent = 1;
            break;
        }

        // We need to use toFixed() because of float point errors.
        // For example, 0.01 + 0.06 = 0.06999999999999999
        if (_this.state.value !== newValue) {
          _this.setState({
            percent: newPercent,
            value: parseFloat(newValue.toFixed(5))
          }, function () {
            if (_this.props.onChange) _this.props.onChange(event, _this.state.value);
          });
        }
      }
    }, _this.dragHandler = function (event) {
      if (_this.dragRunning) {
        return;
      }
      _this.dragRunning = true;
      requestAnimationFrame(function () {
        var pos = void 0;
        if (isMouseControlInverted(_this.props.axis)) {
          pos = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
        } else {
          pos = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
        }
        _this.onDragUpdate(event, pos);
        _this.dragRunning = false;
      });
    }, _this.dragTouchHandler = function (event) {
      if (_this.dragRunning) {
        return;
      }
      _this.dragRunning = true;
      requestAnimationFrame(function () {
        var pos = void 0;
        if (isMouseControlInverted(_this.props.axis)) {
          pos = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
        } else {
          pos = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
        }
        _this.onDragUpdate(event, pos);
        _this.dragRunning = false;
      });
    }, _this.dragEndHandler = function (event) {
      if (document) {
        document.removeEventListener('mousemove', _this.dragHandler, false);
        document.removeEventListener('mouseup', _this.dragEndHandler, false);
      }

      _this.onDragStop(event);
    }, _this.dragTouchEndHandler = function (event) {
      if (document) {
        document.removeEventListener('touchmove', _this.dragTouchHandler, false);
        document.removeEventListener('touchup', _this.dragTouchEndHandler, false);
        document.removeEventListener('touchend', _this.dragTouchEndHandler, false);
        document.removeEventListener('touchcancel', _this.dragTouchEndHandler, false);
      }

      _this.onDragStop(event);
    }, _this.handleTouchStart = function (event) {
      if (!_this.props.disabled && !_this.state.dragging) {
        var pos = void 0;
        if (isMouseControlInverted(_this.props.axis)) {
          pos = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
        } else {
          pos = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
        }
        _this.dragTo(event, pos);

        // Since the touch event fired for the track and handle is child of
        // track, we need to manually propagate the event to the handle.
        _this.onHandleTouchStart(event);
      }
    }, _this.handleFocus = function (event) {
      _this.setState({ focused: true });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function (event) {
      _this.setState({
        focused: false,
        active: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleMouseDown = function (event) {
      if (!_this.props.disabled && !_this.state.dragging) {
        var pos = void 0;
        if (isMouseControlInverted(_this.props.axis)) {
          pos = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
        } else {
          pos = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
        }
        _this.dragTo(event, pos);

        // Since the click event fired for the track and handle is child of
        // track, we need to manually propagate the event to the handle.
        _this.onHandleMouseDown(event);
      }
    }, _this.handleMouseUp = function () {
      if (!_this.props.disabled) {
        _this.setState({ active: false });
      }
    }, _this.handleMouseEnter = function () {
      _this.setState({ hovered: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hovered: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Slider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var value = this.props.value;
      if (value === undefined) {
        value = this.props.defaultValue !== undefined ? this.props.defaultValue : this.props.min;
      }
      var percent = (value - this.props.min) / (this.props.max - this.props.min);
      if (isNaN(percent)) {
        percent = 0;
      }

      this.setState({
        percent: percent,
        value: value
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== undefined && !this.state.dragging) {
        this.setValue(nextProps.value);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      // calculate percentage
      var percent = (value - this.props.min) / (this.props.max - this.props.min);
      if (isNaN(percent)) percent = 0;
      // update state
      this.setState({
        value: value,
        percent: percent
      });
    }
  }, {
    key: 'getPercent',
    value: function getPercent() {
      return this.state.percent;
    }
  }, {
    key: 'setPercent',
    value: function setPercent(percent, callback) {
      var value = this.alignValue(this.percentToValue(percent));
      var _props = this.props;
      var min = _props.min;
      var max = _props.max;

      var alignedPercent = (value - min) / (max - min);
      if (this.state.value !== value) {
        this.setState({ value: value, percent: alignedPercent }, callback);
      }
    }
  }, {
    key: 'clearValue',
    value: function clearValue() {
      this.setValue(this.props.min);
    }
  }, {
    key: 'alignValue',
    value: function alignValue(val) {
      var _props2 = this.props;
      var step = _props2.step;
      var min = _props2.min;

      var alignValue = Math.round((val - min) / step) * step + min;
      return parseFloat(alignValue.toFixed(5));
    }
  }, {
    key: 'getTrackOffset',
    value: function getTrackOffset() {
      return this.refs.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(event) {
      this.setState({
        dragging: true,
        active: true
      });

      if (this.props.onDragStart) {
        this.props.onDragStart(event);
      }
    }
  }, {
    key: 'onDragStop',
    value: function onDragStop(event) {
      this.setState({
        dragging: false,
        active: false
      });

      if (this.props.onDragStop) {
        this.props.onDragStop(event);
      }
    }
  }, {
    key: 'onDragUpdate',
    value: function onDragUpdate(event, pos) {
      if (!this.state.dragging) {
        return;
      }
      if (!this.props.disabled) {
        this.dragTo(event, pos);
      }
    }
  }, {
    key: 'dragTo',
    value: function dragTo(event, pos) {
      var max = this.refs.track[mainAxisClientProperty[this.props.axis]];
      if (pos < 0) {
        pos = 0;
      } else if (pos > max) {
        pos = max;
      }
      this.updateWithChangeEvent(event, pos / max);
    }
  }, {
    key: 'updateWithChangeEvent',
    value: function updateWithChangeEvent(event, percent) {
      var _this2 = this;

      this.setPercent(percent, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(event, _this2.state.value);
        }
      });
    }
  }, {
    key: 'percentToValue',
    value: function percentToValue(percent) {
      return percent * (this.props.max - this.props.min) + this.props.min;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var axis = _props3.axis;
      var description = _props3.description;
      var disabled = _props3.disabled;
      var disableFocusRipple = _props3.disableFocusRipple;
      var error = _props3.error;
      var max = _props3.max;
      var min = _props3.min;
      var name = _props3.name;
      var onBlur = _props3.onBlur;
      var onChange = _props3.onChange;
      var onDragStart = _props3.onDragStart;
      var onDragStop = _props3.onDragStop;
      var onFocus = _props3.onFocus;
      var required = _props3.required;
      var sliderStyle = _props3.sliderStyle;
      var step = _props3.step;
      var style = _props3.style;

      var other = _objectWithoutProperties(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var handleStyles = {};
      var percent = this.state.percent;
      if (percent > 1) {
        percent = 1;
      } else if (percent < 0) {
        percent = 0;
      }

      if (percent === 0) {
        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, this.state.active && styles.handleWhenActive, (this.state.hovered || this.state.focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
      } else {
        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, this.state.active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
      }

      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);

      var rippleShowCondition = (this.state.hovered || this.state.focused) && !this.state.active;

      var focusRipple = void 0;
      if (!disabled && !disableFocusRipple) {
        focusRipple = _react2.default.createElement(_FocusRipple2.default, {
          ref: 'focusRipple',
          key: 'focusRipple',
          style: rippleStyle,
          innerStyle: styles.rippleInner,
          show: rippleShowCondition,
          muiTheme: this.context.muiTheme,
          color: styles.rippleColor.fill
        });
      }

      var handleDragProps = void 0;
      if (!disabled) {
        handleDragProps = {
          onTouchStart: this.onHandleTouchStart,
          onMouseDown: this.onHandleMouseDown,
          onKeyDown: this.onHandleKeyDown
        };
      }

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
        _react2.default.createElement(
          'span',
          null,
          description
        ),
        _react2.default.createElement(
          'span',
          null,
          error
        ),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)(styles.slider, sliderStyle)),
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMouseDown: this.handleMouseDown,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onMouseUp: this.handleMouseUp,
            onTouchStart: this.handleTouchStart
          },
          _react2.default.createElement(
            'div',
            { ref: 'track', style: prepareStyles(styles.track) },
            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
            _react2.default.createElement(
              'div',
              _extends({
                ref: 'handle',
                style: prepareStyles(handleStyles),
                tabIndex: 0
              }, handleDragProps),
              focusRipple
            )
          )
        ),
        _react2.default.createElement('input', {
          ref: 'input',
          type: 'hidden',
          name: name,
          value: this.state.value,
          required: required,
          min: min,
          max: max,
          step: step
        })
      );
    }
  }]);

  return Slider;
}(_react.Component);

Slider.propTypes = {
  /**
   * The axis on which the slider will slide.
   */
  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  /**
   * The default value of the slider.
   */
  defaultValue: valueInRangePropType,
  /**
   * Describe the slider.
   */
  description: _react.PropTypes.string,
  /**
   * Disables focus ripple if set to true.
   */
  disableFocusRipple: _react.PropTypes.bool,
  /**
   * If true, the slider will not be interactable.
   */
  disabled: _react.PropTypes.bool,
  /**
   * An error message for the slider.
   */
  error: _react.PropTypes.string,
  /**
   * The maximum value the slider can slide to on
   * a scale from 0 to 1 inclusive. Cannot be equal to min.
   */
  max: minMaxPropType,
  /**
   * The minimum value the slider can slide to on a scale
   * from 0 to 1 inclusive. Cannot be equal to max.
   */
  min: minMaxPropType,
  /**
   * The name of the slider. Behaves like the name attribute
   * of an input element.
   */
  name: _react.PropTypes.string,
  /** @ignore */
  onBlur: _react.PropTypes.func,
  /**
   * Callback function that is fired when the user changes the slider's value.
   */
  onChange: _react.PropTypes.func,
  /**
   * Callback function that is fired when the slider has begun to move.
   */
  onDragStart: _react.PropTypes.func,
  /**
   * Callback function that is fried when the slide has stopped moving.
   */
  onDragStop: _react.PropTypes.func,
  /** @ignore */
  onFocus: _react.PropTypes.func,
  /**
   * Whether or not the slider is required in a form.
   */
  required: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the inner slider element.
   */
  sliderStyle: _react.PropTypes.object,
  /**
   * The granularity the slider can step through values.
   */
  step: _react.PropTypes.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The value of the slider.
   */
  value: valueInRangePropType
};
Slider.defaultProps = {
  axis: 'x',
  disabled: false,
  disableFocusRipple: false,
  max: 1,
  min: 0,
  required: true,
  step: 0.01,
  style: {}
};
Slider.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Slider;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvNotInterested = function AvNotInterested(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
  );
};
AvNotInterested = (0, _pure2.default)(AvNotInterested);
AvNotInterested.displayName = 'AvNotInterested';
AvNotInterested.muiName = 'SvgIcon';

exports.default = AvNotInterested;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePalette = function ImagePalette(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
ImagePalette = (0, _pure2.default)(ImagePalette);
ImagePalette.displayName = 'ImagePalette';
ImagePalette.muiName = 'SvgIcon';

exports.default = ImagePalette;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageImage = function ImageImage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
  );
};
ImageImage = (0, _pure2.default)(ImageImage);
ImageImage.displayName = 'ImageImage';
ImageImage.muiName = 'SvgIcon';

exports.default = ImageImage;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {Object.defineProperty(exports, "__esModule", { value: true });
if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require.");
}
var Data = (function () {
    function Data(data) {
        this.data = data;
    }
    Data.prototype.getId = function () {
        return this.data.id;
    };
    Data.prototype.hasTheming = function () {
        return this.data.theming;
    };
    return Data;
}());
exports.layoutData = new Data(diy.website.layout);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var helper_1 = __webpack_require__(230);
var actionCreator = helper_1.actionCreatorFactory('diy/module/section/loadingMask');
var react_redux_1 = __webpack_require__(220);
var LoadingMask_1 = __webpack_require__(525);
exports.toggleLoadingMask = actionCreator("MODULE_SECTION_LOADINGMASK_TOGGLE_LOADING_MASK");
function reducer(loadingMask, action) {
    if (loadingMask === void 0) { loadingMask = false; }
    if (helper_1.isType(action, exports.toggleLoadingMask)) {
        return action.payload.active;
    }
    return loadingMask;
}
exports.reducer = reducer;
var mapStateToProps = function (appState) { return ({
    visible: appState.moduleSection.loadingMask,
}); };
function render(store) {
    var maskContainer = document.createElement('div');
    maskContainer.setAttribute('id', 'diy-loading-mask');
    document.body.appendChild(maskContainer);
    var ConnectedLoadingMask = react_redux_1.connect(mapStateToProps)(LoadingMask_1.default);
    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(ConnectedLoadingMask, null)), maskContainer);
}
exports.render = render;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var RefreshIndicator_1 = __webpack_require__(526);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var LoadingMask = (function (_super) {
    tslib_1.__extends(LoadingMask, _super);
    function LoadingMask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingMask.prototype.render = function () {
        return this.props.visible ? (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement("div", { style: this.getStyle(), "data-test-id": "action-in-progress-indicator" },
                React.createElement("div", { style: this.getWrapperStyle() },
                    React.createElement(RefreshIndicator_1.default, { left: 0, top: 0, status: "loading" }))))) : null;
    };
    LoadingMask.prototype.getWrapperStyle = function () {
        return {
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-40px"
        };
    };
    LoadingMask.prototype.getStyle = function () {
        return {
            position: "fixed",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            background: "transparent",
            zIndex: 9999999,
            cursor: 'wait'
        };
    };
    return LoadingMask;
}(React.Component));
exports.default = LoadingMask;


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RefreshIndicator = __webpack_require__(527);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RefreshIndicator2.default;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _autoPrefix = __webpack_require__(381);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VIEWBOX_SIZE = 32;

function getStyles(props) {
  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
  return {
    root: {
      position: 'absolute',
      zIndex: 2,
      width: props.size,
      height: props.size,
      padding: padding,
      top: -10000,
      left: -10000,
      transform: 'translate3d(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px, 0)',
      opacity: props.status === 'hide' ? 0 : 1,
      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
    }
  };
}

var RefreshIndicator = function (_Component) {
  _inherits(RefreshIndicator, _Component);

  function RefreshIndicator() {
    _classCallCheck(this, RefreshIndicator);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RefreshIndicator).apply(this, arguments));
  }

  _createClass(RefreshIndicator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scalePath(this.refs.path, 0);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
      clearTimeout(this.rotateWrapperSecondTimer);

      this.scalePath(this.refs.path, 0);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
      clearTimeout(this.rotateWrapperSecondTimer);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var paperSize = this.getPaperSize();

      var childrenCmp = null;
      if (this.props.status !== 'ready') {
        var circleStyle = this.getCircleStyle(paperSize);
        childrenCmp = _react2.default.createElement(
          'div',
          {
            ref: 'wrapper',
            style: prepareStyles({
              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
              width: '100%',
              height: '100%'
            })
          },
          _react2.default.createElement(
            'svg',
            {
              style: {
                width: paperSize,
                height: paperSize
              },
              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
            },
            _react2.default.createElement('circle', _extends({
              ref: 'path',
              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
              }))
            }, circleStyle.attr))
          )
        );
      } else {
        var _circleStyle = this.getCircleStyle(paperSize);
        var polygonStyle = this.getPolygonStyle(paperSize);
        childrenCmp = _react2.default.createElement(
          'svg',
          {
            style: {
              width: paperSize,
              height: paperSize
            },
            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
          },
          _react2.default.createElement('circle', _extends({
            style: prepareStyles(_circleStyle.style)
          }, _circleStyle.attr)),
          _react2.default.createElement('polygon', _extends({
            style: prepareStyles(polygonStyle.style)
          }, polygonStyle.attr))
        );
      }

      return childrenCmp;
    }
  }, {
    key: 'getTheme',
    value: function getTheme() {
      return this.context.muiTheme.refreshIndicator;
    }
  }, {
    key: 'getPaddingSize',
    value: function getPaddingSize() {
      var padding = this.props.size * 0.1;
      return padding;
    }
  }, {
    key: 'getPaperSize',
    value: function getPaperSize() {
      return this.props.size - this.getPaddingSize() * 2;
    }
  }, {
    key: 'getCircleAttr',
    value: function getCircleAttr() {
      return {
        radiu: VIEWBOX_SIZE / 2 - 5,
        originX: VIEWBOX_SIZE / 2,
        originY: VIEWBOX_SIZE / 2,
        strokeWidth: 3
      };
    }
  }, {
    key: 'getArcDeg',
    value: function getArcDeg() {
      var p = this.props.percentage / 100;

      var beginDeg = p * 120;
      var endDeg = p * 410;
      return [beginDeg, endDeg];
    }
  }, {
    key: 'getFactor',
    value: function getFactor() {
      var p = this.props.percentage / 100;
      var p1 = Math.min(1, p / 0.4);

      return p1;
    }
  }, {
    key: 'getCircleStyle',
    value: function getCircleStyle() {
      var isLoading = this.props.status === 'loading';
      var p1 = isLoading ? 1 : this.getFactor();
      var circle = this.getCircleAttr();
      var perimeter = Math.PI * 2 * circle.radiu;

      var _getArcDeg = this.getArcDeg();

      var _getArcDeg2 = _slicedToArray(_getArcDeg, 2);

      var beginDeg = _getArcDeg2[0];
      var endDeg = _getArcDeg2[1];

      var arcLen = (endDeg - beginDeg) * perimeter / 360;
      var dashOffset = -beginDeg * perimeter / 360;

      var theme = this.getTheme();
      return {
        style: {
          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
          strokeDashoffset: dashOffset,
          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
          strokeLinecap: 'round',
          opacity: p1,
          strokeWidth: circle.strokeWidth * p1,
          fill: 'none'
        },
        attr: {
          cx: circle.originX,
          cy: circle.originY,
          r: circle.radiu
        }
      };
    }
  }, {
    key: 'getPolygonStyle',
    value: function getPolygonStyle() {
      var p1 = this.getFactor();
      var circle = this.getCircleAttr();

      var triangleCx = circle.originX + circle.radiu;
      var triangleCy = circle.originY;
      var dx = circle.strokeWidth * 7 / 4 * p1;
      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);

      var _getArcDeg3 = this.getArcDeg();

      var _getArcDeg4 = _slicedToArray(_getArcDeg3, 2);

      var endDeg = _getArcDeg4[1];


      var theme = this.getTheme();
      return {
        style: {
          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
          transform: 'rotate(' + endDeg + 'deg)',
          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
          opacity: p1
        },
        attr: {
          points: trianglePath
        }
      };
    }
  }, {
    key: 'scalePath',
    value: function scalePath(path, step) {
      var _this2 = this;

      if (this.props.status !== 'loading') return;

      var currStep = (step || 0) % 3;

      var circle = this.getCircleAttr();
      var perimeter = Math.PI * 2 * circle.radiu;
      var arcLen = perimeter * 0.64;

      var strokeDasharray = void 0;
      var strokeDashoffset = void 0;
      var transitionDuration = void 0;

      if (currStep === 0) {
        strokeDasharray = '1, 200';
        strokeDashoffset = 0;
        transitionDuration = '0ms';
      } else if (currStep === 1) {
        strokeDasharray = arcLen + ', 200';
        strokeDashoffset = -15;
        transitionDuration = '750ms';
      } else {
        strokeDasharray = arcLen + ', 200';
        strokeDashoffset = -(perimeter - 1);
        transitionDuration = '850ms';
      }

      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);

      this.scalePathTimer = setTimeout(function () {
        return _this2.scalePath(path, currStep + 1);
      }, currStep ? 750 : 250);
    }
  }, {
    key: 'rotateWrapper',
    value: function rotateWrapper(wrapper) {
      var _this3 = this;

      if (this.props.status !== 'loading') return;

      _autoPrefix2.default.set(wrapper.style, 'transform', null);
      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');

      this.rotateWrapperSecondTimer = setTimeout(function () {
        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
      }, 50);

      this.rotateWrapperTimer = setTimeout(function () {
        return _this3.rotateWrapper(wrapper);
      }, 10050);
    }
  }, {
    key: 'render',
    value: function render() {
      var style = this.props.style;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _Paper2.default,
        {
          circle: true,
          style: (0, _simpleAssign2.default)(styles.root, style),
          ref: 'indicatorCt'
        },
        this.renderChildren()
      );
    }
  }]);

  return RefreshIndicator;
}(_react.Component);

RefreshIndicator.propTypes = {
  /**
   * Override the theme's color of the indicator while it's status is
   * "ready" and it's percentage is less than 100.
   */
  color: _react.PropTypes.string,
  /**
   * The absolute left position of the indicator in pixels.
   */
  left: _react.PropTypes.number.isRequired,
  /**
   * Override the theme's color of the indicator while
   * it's status is "loading" or when it's percentage is 100.
   */
  loadingColor: _react.PropTypes.string,
  /**
   * The confirmation progress to fetch data. Max value is 100.
   */
  percentage: _react.PropTypes.number,
  /**
   * Size in pixels.
   */
  size: _react.PropTypes.number,
  /**
   * The display status of the indicator. If the status is
   * "ready", the indicator will display the ready state
   * arrow. If the status is "loading", it will display
   * the loading progress indicator. If the status is "hide",
   * the indicator will be hidden.
   */
  status: _react.PropTypes.oneOf(['ready', 'loading', 'hide']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The absolute top position of the indicator in pixels.
   */
  top: _react.PropTypes.number.isRequired
};
RefreshIndicator.defaultProps = {
  percentage: 0,
  size: 40,
  status: 'hide'
};
RefreshIndicator.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = RefreshIndicator;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var redux_1 = __webpack_require__(199);
var react_redux_1 = __webpack_require__(220);
var helper_1 = __webpack_require__(230);
var actionCreator = helper_1.actionCreatorFactory('diy/module/sectionContainer/');
var GroupOverlays_1 = __webpack_require__(529);
var index_1 = __webpack_require__(499);
var loadingMask_1 = __webpack_require__(524);
var index_2 = __webpack_require__(499);
var state_1 = __webpack_require__(533);
exports.loadData = actionCreator('MODULE_SECTION_CONTAINER_LOAD_STATE');
exports.toggleBackgroundMenu = actionCreator("MODULE_SECTION_CONTAINER_TOGGLE_BACKGROUND_MENU");
function openBackgroundMenu(groupId) {
    return function (dispatch, getState) {
        dispatch(exports.toggleBackgroundMenu({
            moduleId: groupId,
            visible: true
        }));
    };
}
function closeBackgroundMenu(groupId) {
    return function (dispatch, getState) {
        dispatch(exports.toggleBackgroundMenu({
            moduleId: groupId,
            visible: false
        }));
    };
}
function openAviaryGroup(moduleId) {
    return function (dispatch, getState) {
        var ownState = getState().moduleSectionContainer;
        dispatch(index_2.openAviary({
            moduleId: moduleId,
            transformedImageUrl: ownState.backgroundSettings[moduleId].transformedImageUrl,
            origImageUrl: ownState.backgroundSettings[moduleId].origImageUrl,
            imageMediaType: ownState.backgroundSettings[moduleId].imageMediaType
        }));
    };
}
function updatePayload(moduleId, payload) {
    return function (dispatch, getState) {
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        index_1.updateData(moduleId, payload).then(function (data) {
            dispatch(exports.loadData({ moduleId: moduleId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        });
    };
}
function changeBackgroundImage(moduleId, imageId, imageType, successCallback, errorCallback) {
    return function (dispatch, getState) {
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        index_1.updateBackgroundImage(moduleId, imageId, imageType, successCallback, errorCallback).then(function (data) {
            dispatch(exports.loadData({ moduleId: moduleId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        });
    };
}
exports.changeBackgroundImage = changeBackgroundImage;
function saveBackgroundImage(imageDataUrl) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        dispatch(index_2.closeAviary({}));
        dispatch(loadingMask_1.toggleLoadingMask({ active: true }));
        index_1.saveTransformedBackgroundImage(state.aviaryOptions.moduleId, imageDataUrl).then(function (data) {
            dispatch(exports.loadData({ moduleId: state.aviaryOptions.moduleId, data: data }));
            dispatch(loadingMask_1.toggleLoadingMask({ active: false }));
        });
    };
}
exports.saveBackgroundImage = saveBackgroundImage;
function changeBackgroundSettings(moduleId, background) {
    var newBackground = index_1.serializeBackgroundSettings(background);
    return updatePayload(moduleId, {
        background: newBackground
    });
}
exports.changeBackgroundSettings = changeBackgroundSettings;
var mapStateToProps = function (appState) { return ({
    visibleOverlays: appState.moduleSection.manageGroupsActive ? appState.moduleSection.configurableGroups : [],
    backgroundSettings: appState.moduleSectionContainer.backgroundSettings,
    backgroundMenuOpen: appState.moduleSectionContainer.backgroundMenuOpen,
    configurableGroups: appState.moduleSectionContainer.configurableGroups,
    rootSectionId: appState.moduleSection.moduleId,
    showDeleteButton: appState.moduleSection.quantity && index_2.supportsAddGroup(appState.moduleSection) ?
        appState.moduleSection.quantity.current > appState.moduleSection.quantity.min :
        false
}); };
var mapDispatchToProps = function (dispatch) { return redux_1.bindActionCreators({
    onChangeBackgroundImage: changeBackgroundImage,
    onChangeBackground: changeBackgroundSettings,
    onEditImageClicked: openAviaryGroup,
    onSelectImageClicked: closeBackgroundMenu,
    onDeleteGroup: index_2.deleteGroupAction,
    onClickOutside: index_1.clickOutside,
    onBackgroundMenuOpened: openBackgroundMenu,
    onBackgroundMenuClosed: closeBackgroundMenu,
    onSyncGroupsBackground: index_2.syncGroupsBackgroundTo
}, dispatch); };
function renderGroupOverlays(store) {
    var overlaysContainer = document.createElement('div');
    overlaysContainer.setAttribute('id', 'diy-group-overlays');
    document.body.appendChild(overlaysContainer);
    var ConnectedGroupOverlays = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GroupOverlays_1.default);
    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(ConnectedGroupOverlays, null)), overlaysContainer);
}
var initialState = {};
// =======
// REDUCER
// =======
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    if (helper_1.isType(action, exports.loadData)) {
        var bgPayload = action.payload.data.background;
        var newBgSettings = index_1.unserializeBackgroundSettings(bgPayload);
        var configurable = action.payload.data.configurable;
        return helper_1.objectOverride(state, {
            backgroundSettings: helper_1.objectOverride(state.backgroundSettings, (_a = {},
                _a[action.payload.moduleId] = newBgSettings,
                _a)),
            configurableGroups: helper_1.objectOverride(state.configurableGroups, (_b = {},
                _b[action.payload.moduleId] = configurable,
                _b))
        });
    }
    if (helper_1.isType(action, exports.toggleBackgroundMenu)) {
        return helper_1.objectOverride(state, {
            backgroundMenuOpen: helper_1.objectOverride(state.backgroundMenuOpen, (_c = {},
                _c[action.payload.moduleId] = action.payload.visible,
                _c))
        });
    }
    if (helper_1.isType(action, index_2.openAviary)) {
        var backgroundMenuOpen = Object.assign({}, state.backgroundMenuOpen);
        for (var groupId in backgroundMenuOpen) {
            if (backgroundMenuOpen.hasOwnProperty(groupId)) {
                backgroundMenuOpen[groupId] = false;
            }
        }
        return helper_1.objectOverride(state, {
            backgroundMenuOpen: backgroundMenuOpen
        });
    }
    return state;
    var _a, _b, _c;
}
// ==============
// INITIALIZATION
// ==============
var initialized = false;
function init(storeProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, state_1.MODULE_SECTION_CONTAINER_STATE_KEY);
        initialized = true;
    }
}
exports.init = init;
function render(store) {
    renderGroupOverlays(store);
}
exports.render = render;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var SyncPosition_1 = __webpack_require__(440);
var Modul_1 = __webpack_require__(197);
var GroupOverlay_1 = __webpack_require__(530);
var tracking_1 = __webpack_require__(501);
var GroupOverlays = (function (_super) {
    tslib_1.__extends(GroupOverlays, _super);
    function GroupOverlays() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBackgroundMenuOpened = function (groupId) {
            tracking_1.trackManageGroupBackgroundClicked();
            _this.props.onBackgroundMenuOpened(groupId);
        };
        _this.createChangeBgImgHandler = function (moduleId) { return function (imageId, imageType, successCallback, errorCallback) {
            _this.props.onChangeBackgroundImage(moduleId, imageId, imageType, successCallback, errorCallback);
        }; };
        _this.createChangeBgHandler = function (moduleId) { return function (background) {
            _this.props.onChangeBackground(moduleId, background);
        }; };
        return _this;
    }
    GroupOverlays.prototype.renderRootSubOverlay = function () {
        var _this = this;
        if (!this.props.rootSectionId) {
            return null;
        }
        var module = Modul_1.default.getInstance(this.props.rootSectionId);
        if (!module) {
            return null;
        }
        return this.props.rootSectionId > 0 ?
            React.createElement(SyncPosition_1.default, { element: module.modul[0], key: "rootGroupOverlay", position: "absolute" }, function (box) { return (React.createElement("div", { onClick: _this.props.onClickOutside, style: {
                    position: "absolute",
                    zIndex: GroupOverlay_1.default.ZINDEX,
                    left: box.left,
                    top: box.top,
                    width: box.width,
                    height: box.height,
                    boxSizing: 'border-box'
                } })); }) : null;
    };
    GroupOverlays.prototype.render = function () {
        var _this = this;
        var overlaysToRender = this.props.visibleOverlays &&
            Object.keys(this.props.visibleOverlays).length &&
            this.props.backgroundSettings;
        return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement("div", null,
                overlaysToRender ? this.renderRootSubOverlay() : null,
                overlaysToRender ?
                    this.props.visibleOverlays.map(function (groupId) {
                        var changeBackgroundImageHandler = _this.createChangeBgImgHandler(groupId);
                        var changeBackgroundHandler = _this.createChangeBgHandler(groupId);
                        return React.createElement(GroupOverlay_1.default, { moduleId: groupId, key: groupId, configurableGroup: _this.props.configurableGroups[groupId], backgroundSettings: _this.props.backgroundSettings[groupId], backgroundMenuOpen: _this.props.backgroundMenuOpen && _this.props.backgroundMenuOpen[groupId], onChangeBackgroundImage: changeBackgroundImageHandler, onChangeBackground: changeBackgroundHandler, onColorClicked: tracking_1.trackBackgroundColorClicked, onEditImageClicked: function () { return _this.props.onEditImageClicked(groupId); }, onSelectImageClicked: function () { return _this.props.onSelectImageClicked(groupId); }, onManageGroupBackgroundOpened: function () { return _this.onBackgroundMenuOpened(groupId); }, onManageGroupBackgroundClosed: function () { return _this.props.onBackgroundMenuClosed(groupId); }, onTabClicked: tracking_1.trackBackgroundTabClicked, onDelete: _this.props.onDeleteGroup, showDeleteButton: _this.props.showDeleteButton, onApplyOnAllGroups: _this.props.onSyncGroupsBackground });
                    }) : null)));
    };
    return GroupOverlays;
}(React.Component));
exports.default = GroupOverlays;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Modul_1 = __webpack_require__(197);
var SyncPosition_1 = __webpack_require__(440);
var Animation_1 = __webpack_require__(444);
var BackgroundSelectorView_1 = __webpack_require__(502);
var Dropdown_1 = __webpack_require__(531);
var autoprefixer_1 = __webpack_require__(438);
var image_1 = __webpack_require__(522);
var delete_1 = __webpack_require__(532);
var l10n = __webpack_require__(18);
var FlatButton_1 = __webpack_require__(479);
var GroupOverlay = (function (_super) {
    tslib_1.__extends(GroupOverlay, _super);
    function GroupOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupOverlay.prototype.getModule = function () {
        return Modul_1.default.getInstance(this.props.moduleId);
    };
    GroupOverlay.prototype.getModuleEl = function () {
        if (this.getModule()) {
            return this.getModule().modul;
        }
        return null;
    };
    GroupOverlay.prototype.render = function () {
        var _this = this;
        if (!this.props.moduleId) {
            return null;
        }
        return (React.createElement(SyncPosition_1.default, { element: this.getModuleEl()[0], key: "overlaySync" }, function (box) { return (React.createElement(Animation_1.OpacityAnimation, { duration: 0.1, key: "overlayAnimation" }, _this.renderOverlay(box))); }));
    };
    GroupOverlay.prototype.renderOverlay = function (box) {
        var _this = this;
        var styles = this.getStyles(box);
        var configurable = this.props.configurableGroup;
        var onlyColor = configurable.color && !configurable.image && !configurable.video;
        return (React.createElement("div", { className: "wrapper", style: styles.root },
            React.createElement("div", { style: styles.border },
                (configurable.color || configurable.image || configurable.theming || configurable.video) ?
                    React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, onMouseDown: function (e) { return e.stopPropagation(); }, onTouchTap: function (e) { return e.stopPropagation(); }, style: styles.menuWrapper },
                        React.createElement(Dropdown_1.Dropdown, { dataTestId: "section-group-overlay-" + this.props.moduleId, Icon: React.createElement(image_1.default, null), open: this.props.backgroundMenuOpen, buttonStyle: styles.menuButton, layerStyle: {
                                marginTop: 0,
                                padding: 0,
                                minWidth: 240
                            }, horizontalAlign: "left", onOpen: this.props.onManageGroupBackgroundOpened, onClose: this.props.onManageGroupBackgroundClosed },
                            React.createElement(BackgroundSelectorView_1.default, { onlyColor: onlyColor, onChange: this.props.onChangeBackground, onImageChange: this.props.onChangeBackgroundImage, onEditImageClicked: this.props.onEditImageClicked, onSelectImageClicked: this.props.onSelectImageClicked, background: this.props.backgroundSettings, onColorClicked: this.props.onColorClicked, onTabClicked: this.props.onTabClicked, parallaxAvailable: false, onApplyOnAllGroups: this.props.onApplyOnAllGroups ?
                                    function () { _this.props.onApplyOnAllGroups(_this.props.moduleId); }
                                    : undefined })))
                    : null,
                this.props.showDeleteButton ?
                    React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, onMouseDown: function (e) { return e.stopPropagation(); }, onTouchTap: function (e) { return e.stopPropagation(); }, style: styles.deleteWrapper },
                        React.createElement(Dropdown_1.Dropdown, { dataTestId: "delete-group-" + this.props.moduleId, Icon: React.createElement(delete_1.default, null), buttonStyle: styles.menuButton, layerStyle: {
                                marginTop: -36,
                                padding: 10,
                                maxWidth: 220
                            }, horizontalAlign: "left", ref: function (ref) { return _this.deleteDropDownRef = ref; } },
                            React.createElement("div", { style: autoprefixer_1.autoprefixer({
                                    display: "block"
                                }) },
                                React.createElement("p", { style: { fontSize: 15 } }, l10n.getString('section.actionBar.buttons.delGroup.label')),
                                React.createElement("p", { style: { textAlign: "right", paddingTop: 10 } },
                                    React.createElement(FlatButton_1.default, { label: l10n.getString('section.actionBar.buttons.delGroup.no'), secondary: true, style: styles.flatButton, onTouchTap: function () { _this.deleteDropDownRef.setState({ open: false }); } }),
                                    React.createElement(FlatButton_1.default, { label: l10n.getString('section.actionBar.buttons.delGroup.yes'), style: styles.flatButton, primary: true, onTouchTap: function () { _this.props.onDelete(_this.props.moduleId); } })))))
                    : null)));
    };
    GroupOverlay.prototype.getStyles = function (box) {
        return {
            root: {
                position: "absolute",
                zIndex: GroupOverlay.ZINDEX,
                left: box.left,
                top: box.top,
                width: box.width,
                height: box.height,
                boxSizing: 'border-box',
                border: '2px solid rgba(33, 150, 243, 1)'
            },
            border: {
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                background: "-moz-linear-gradient(top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 150px); " +
                    "background: -webkit-linear-gradient(top, rgba(0,0,0,0.6) 0%,rgba(0,0,0,0) 150px); " +
                    "background: linear-gradient(to bottom, rgba(0,0,0,0.6) 0%,rgba(0,0,0,0) 150px)"
            },
            menuWrapper: autoprefixer_1.autoprefixer({
                float: 'right',
                width: '36px',
                height: '36px',
                background: 'rgba(236, 238, 241, 0.8)',
                alignItems: 'center',
                display: 'flex',
            }),
            menuButton: {
                left: '-6px',
                width: 36,
                height: 36,
                border: 0,
                padding: 0,
                marginLeft: 6
            },
            deleteWrapper: autoprefixer_1.autoprefixer({
                float: 'left',
                width: '36px',
                height: '36px',
                background: 'rgba(236, 238, 241, 0.8)',
                alignItems: 'flex-start',
                display: 'flex'
            }),
            flatButton: {
                fontSize: 12
            }
        };
    };
    return GroupOverlay;
}(React.Component));
GroupOverlay.ZINDEX = 113;
exports.default = GroupOverlay;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var IconTextButton_1 = __webpack_require__(459);
var IconButton_1 = __webpack_require__(420);
var Popover_1 = __webpack_require__(387);
var keyboard_arrow_down_1 = __webpack_require__(463);
var Dropdown = (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            open: props.open || false
        };
        return _this;
    }
    Dropdown.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.open !== this.props.open) {
            this.setState({
                open: nextProps.open
            });
        }
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { marginRight: 12 } },
            this.renderButton(),
            React.createElement(Popover_1.default, { open: this.state.open, anchorEl: this.buttonEl, className: "diy-material-dropdown-popover", style: this.props.layerStyle, useLayerForClickAway: true, anchorOrigin: { "horizontal": this.props.horizontalAlign, "vertical": "bottom" }, targetOrigin: { "horizontal": this.props.horizontalAlign, "vertical": "top" }, onRequestClose: function () { return _this.onLayerClose(); } },
                React.createElement("div", { "data-test-id": this.props.dataTestId + "-flyout" }, this.props.children))));
    };
    Dropdown.prototype.renderButton = function () {
        var _this = this;
        var testId = this.props.dataTestId + "-button";
        var baseButtonProps = {
            style: Object.assign({
                display: 'block'
            }, this.props.buttonStyle)
        };
        if (!this.props.text) {
            return (React.createElement(IconButton_1.default, tslib_1.__assign({ onTouchTap: function () { return _this.onButtonClick(); }, ref: function (ref) { return _this.buttonEl = ReactDOM.findDOMNode(ref); }, "data-test-id": testId }, baseButtonProps), this.props.Icon));
        }
        return (React.createElement(IconTextButton_1.default, tslib_1.__assign({ text: this.props.text, Icon: this.props.Icon, ref: function (ref) { return _this.buttonEl = ReactDOM.findDOMNode(ref); }, onTouchTap: function () { return _this.onButtonClick(); }, useAlternativeColors: true, isPressed: this.state.open, isDisabled: this.props.disabled, AdditionalIcon: keyboard_arrow_down_1.default, dataTestId: testId }, baseButtonProps)));
    };
    Dropdown.prototype.onButtonClick = function () {
        // do not use a negation of the previous state -
        // this should only open the menu - the overlay will close it
        // the button is only accessible when the overaly is gone
        // material ui android issue: generates 2nd click on the layer
        // which closes the menu
        // https://github.com/callemall/material-ui/issues/3335
        this.setState({
            open: true
        });
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    };
    Dropdown.prototype.onLayerClose = function () {
        this.setState({
            open: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    };
    return Dropdown;
}(React.Component));
Dropdown.defaultProps = {
    horizontalAlign: 'left'
};
exports.Dropdown = Dropdown;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDelete = function ActionDelete(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDelete = (0, _pure2.default)(ActionDelete);
ActionDelete.displayName = 'ActionDelete';
ActionDelete.muiName = 'SvgIcon';

exports.default = ActionDelete;

/***/ },
/* 533 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_SECTION_STATE_KEY = "moduleSection";
exports.MODULE_SECTION_CONTAINER_STATE_KEY = "moduleSectionContainer";


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
function updateData(moduleId, data) {
    var moduleType = Modul_1.default.getInstance(moduleId).getModuleType();
    return Promise.resolve($.ajax({
        url: systemurl + 'app/module/section/change-payload',
        data: {
            payload: data,
            moduleId: moduleId,
            moduleType: moduleType
        },
        dataType: 'json',
        type: 'POST',
    }))
        .then(function (r) {
        Modul_1.default.getInstance(moduleId).doAfterSave(r.data);
        $(document).trigger('diy-editor-module-saved', moduleId);
        return r.data.payload;
    })
        .catch(function (r) { return handleServerError(r); });
}
exports.updateData = updateData;
function updateBackgroundImage(moduleId, imageId, imageType, successCallback, errorCallback) {
    var moduleType = Modul_1.default.getInstance(moduleId).getModuleType();
    return Promise.resolve($.ajax({
        type: 'POST',
        url: '/app/module/section/change-background-image',
        data: {
            moduleId: moduleId,
            imageId: imageId,
            imageType: imageType,
            moduleType: moduleType
        },
        success: function (response, status, jqXHR) {
            if (response.success) {
                successCallback();
            }
            else {
                errorCallback();
            }
        },
        error: function (jqXHR, status, errorThrown) {
            errorCallback(errorThrown);
        }
    }))
        .then(function (response) {
        Modul_1.default.getInstance(moduleId).doAfterSave(response.data);
        $(document).trigger('diy-editor-module-saved', moduleId);
        return response.data.payload;
    })
        .catch(function (r) { return handleServerError(r); });
}
exports.updateBackgroundImage = updateBackgroundImage;
function saveTransformedBackgroundImage(moduleId, imageDataUrl) {
    return Promise.resolve($.ajax({
        type: 'POST',
        url: '/app/module/section/edit-background-image',
        data: {
            moduleId: moduleId,
            transformedImageUrl: imageDataUrl
        }
    }))
        .then(function (response) {
        Modul_1.default.getInstance(moduleId).doAfterSave(response.data);
        $(document).trigger('diy-editor-module-saved', moduleId);
        return response.data.payload;
    })
        .catch(function (r) { return handleServerError(r); });
}
exports.saveTransformedBackgroundImage = saveTransformedBackgroundImage;
function addGroup(sectionModuleId) {
    return Promise.resolve($.ajax({
        url: systemurl + 'app/module/section/add-group',
        data: {
            moduleId: sectionModuleId
        },
        dataType: 'json',
        type: 'POST',
    }))
        .then(function (r) {
        Modul_1.default.handleLimitationsResponse(r.data);
        Modul_1.default.getInstance(sectionModuleId).doAfterSave(r.data);
        $(document).trigger('diy-editor-module-saved', sectionModuleId);
        return r.data.payload;
    })
        .catch(function (r) { return handleServerError(r); });
}
exports.addGroup = addGroup;
function delGroup(groupModuleId) {
    return Promise.resolve($.ajax({
        url: systemurl + 'app/module/section/remove-group',
        data: {
            moduleId: groupModuleId
        },
        dataType: 'json',
        type: 'POST',
    }))
        .then(function (r) {
        Modul_1.default.handleLimitationsResponse(r.data);
        var currentModule = Modul_1.default.getInstance(groupModuleId);
        var sectionModule = currentModule.getParentSection();
        currentModule.freezeOverlay(false);
        sectionModule.doAfterSave(r.data);
        currentModule.remove();
        $(document).trigger('diy-editor-module-deleted', groupModuleId);
        return r.data.payload;
    })
        .catch(function (r) { return handleServerError(r); });
}
exports.delGroup = delGroup;
function syncGroupsBackground(useBackroundFromModuleId) {
    return Promise.resolve($.ajax({
        url: systemurl + 'app/module/section/sync-group-background',
        data: {
            moduleId: useBackroundFromModuleId
        },
        dataType: 'json',
        type: 'POST',
    }))
        .then(function (r) {
        Modul_1.default.handleLimitationsResponse(r.data);
        var currentModule = Modul_1.default.getInstance(useBackroundFromModuleId);
        var sectionModule = currentModule.getParentSection();
        sectionModule.doAfterSave(r.data);
        $(document).trigger('diy-editor-module-saved', sectionModule.moduleId);
        return r.data.payload;
    })
        .catch(function (r) { return handleServerError(r); });
}
exports.syncGroupsBackground = syncGroupsBackground;
function handleServerError(reason) {
    return Promise.reject(reason);
}


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __webpack_require__(511);
var backgroundTypesMap = {
    'none': state_1.BackgroundType.None,
    'color': state_1.BackgroundType.Color,
    'image': state_1.BackgroundType.Image,
    'theming': state_1.BackgroundType.Theming
};
function serializeBackgroundType(type) {
    var result = Object.keys(backgroundTypesMap)
        .filter(function (key) { return type === backgroundTypesMap[key]; });
    return result.length ? result[0] : null;
}
function serializeBackgroundSettings(background) {
    var newBackground = {};
    newBackground.imageUrl = background.imageUrl;
    if (background.type !== undefined) {
        newBackground.type = serializeBackgroundType(background.type);
    }
    if (background.color !== undefined) {
        newBackground.color = background.color !== null ? [
            background.color.red, background.color.green, background.color.blue, background.color.alpha
        ] : null;
    }
    if (background.zone !== undefined) {
        newBackground.zone = background.zone;
    }
    if (background.shading !== undefined) {
        newBackground.shading = background.shading;
    }
    if (background.parallax !== undefined) {
        newBackground.parallax = background.parallax;
    }
    return newBackground;
}
exports.serializeBackgroundSettings = serializeBackgroundSettings;
function unserializeBackgroundSettings(bgSettings) {
    return {
        type: backgroundTypesMap[bgSettings.type],
        parallax: bgSettings.parallax,
        imageUrl: bgSettings.imageUrl,
        transformedImageUrl: bgSettings.transformedImageUrl,
        origImageUrl: bgSettings.origImageUrl,
        imageMediaType: bgSettings.imageMediaType ? bgSettings.imageMediaType.toLowerCase() : void 0,
        color: bgSettings.color ? {
            red: bgSettings.color[0],
            green: bgSettings.color[1],
            blue: bgSettings.color[2],
            alpha: bgSettings.color[3]
        } : null,
        zone: bgSettings.zone,
        shading: bgSettings.shading
    };
}
exports.unserializeBackgroundSettings = unserializeBackgroundSettings;
function serializeStyleSettings(style) {
    return {
        preset: style.preset.id,
        roundness: style.roundness.id,
        extras: style.extras.id
    };
}
exports.serializeStyleSettings = serializeStyleSettings;
function unserializeStyleSettings(style, availableStyles) {
    return {
        preset: availableStyles.presets.find(function (v) { return v.id === style.preset; }),
        roundness: availableStyles.roundness.find(function (v) { return v.id === style.roundness; }),
        extras: availableStyles.extras.find(function (v) { return v.id === style.extras; })
    };
}
exports.unserializeStyleSettings = unserializeStyleSettings;
function unserializePayload(moduleId, payload) {
    var state = {
        moduleId: moduleId,
        layout: payload.layout,
        availableLayouts: payload.availableLayouts,
        availableStyles: payload.availableStyles,
        fullWidth: Boolean(payload.fullWidth),
        isFullWidthAvailable: payload.isFullWidthAvailable,
        toggles: payload.toggles,
        configurableGroups: payload.configurableGroups,
        innerElementModuleIds: payload.innerElementModuleIds,
        background: unserializeBackgroundSettings(payload.background),
        style: unserializeStyleSettings(payload.style, payload.availableStyles),
        quantity: payload.quantity,
        columns: payload.columns
    };
    return state;
}
exports.unserializePayload = unserializePayload;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var react_redux_1 = __webpack_require__(220);
var redux_1 = __webpack_require__(199);
var typedActions_1 = __webpack_require__(229);
var actionCreator = typedActions_1.actionCreatorFactory('diy/ModuleActionBar/');
var ModuleActionBar_1 = __webpack_require__(445);
var Api_1 = __webpack_require__(537);
var initialState = {
    isOpen: false,
    undoEnabled: false,
    redoEnabled: false,
    currentTab: 0
};
exports.open = actionCreator('OPEN');
exports.close = actionCreator('CLOSE');
exports.setUndoState = actionCreator('SET_UNDO_STATE');
exports.setRedoState = actionCreator('SET_REDO_STATE');
exports.setCurrentTab = actionCreator('SET_CURRENT_TAB');
// =======
// REDUCER
// =======
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    if (typedActions_1.isType(action, exports.open)) {
        return Object.assign({}, state, {
            isOpen: true,
            moduleId: action.payload.moduleId,
            currentTab: 0
        });
    }
    if (typedActions_1.isType(action, exports.close)) {
        return Object.assign({}, state, {
            isOpen: false,
            moduleId: null,
            undoEnabled: false,
            redoEnabled: false
        });
    }
    if (typedActions_1.isType(action, exports.setUndoState)) {
        return Object.assign({}, state, {
            undoEnabled: action.payload.enabled
        });
    }
    if (typedActions_1.isType(action, exports.setRedoState)) {
        return Object.assign({}, state, {
            redoEnabled: action.payload.enabled
        });
    }
    if (typedActions_1.isType(action, exports.setCurrentTab)) {
        if (!action.payload.currentTabWhitelist
            || action.payload.currentTabWhitelist.indexOf(state.currentTab) !== -1) {
            return Object.assign({}, state, {
                currentTab: action.payload.nextTab
            });
        }
    }
    return state;
}
// ======================
// CONNECT REACT TO REDUX
// ======================
function mapStateToProps(state) {
    var ownState = state.moduleActionBar;
    return {
        open: ownState.isOpen,
        moduleId: ownState.moduleId,
        undoEnabled: ownState.undoEnabled,
        redoEnabled: ownState.redoEnabled,
        currentTab: ownState.currentTab
    };
}
;
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        onTabChange: exports.setCurrentTab
    }, dispatch);
}
function render(store) {
    var actionBarContainer = document.createElement('div');
    actionBarContainer.setAttribute('id', 'diy-action-bar');
    document.body.appendChild(actionBarContainer);
    var ConnectedActionBar = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ModuleActionBar_1.default);
    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(ConnectedActionBar, null)), actionBarContainer);
}
function watchStore(store) {
    var oldActionBarOpen = false;
    store.subscribe(function () {
        var state = store.getState();
        if (state.moduleActionBar.isOpen !== oldActionBarOpen) {
            oldActionBarOpen = state.moduleActionBar.isOpen;
            if (state.moduleActionBar.isOpen) {
                Api_1.default.schedule(function () {
                    Api_1.default.pause();
                });
            }
            else {
                Api_1.default.schedule(function () {
                    Api_1.default.resume();
                });
            }
        }
    });
}
// ==============
// INITIALIZATION
// ==============
var initialized = false;
function init(storeProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, "moduleActionBar");
        render(storeProvider.getStore());
        watchStore(storeProvider.getStore());
        initialized = true;
    }
}
exports.init = init;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var globalEvents = __webpack_require__(500);
var RestApi_1 = __webpack_require__(538);
var ReduxApi_1 = __webpack_require__(559);
var ConfigFactory_1 = __webpack_require__(539);
var StateListFactory_1 = __webpack_require__(560);
var Api = (function () {
    function Api() {
        this.listeners = [];
    }
    /**
     * API initialization:
     *    - initializes the Redux store
     *    - loads the initial notifications from the DB
     *    - marks the API as "ready"
     *    - renders React components
     *    - runs live API calls
     *
     * @param {StoreProvider} storeProvider
     * @param {ToolbarApp} toolbar
     */
    Api.prototype.init = function (storeProvider, toolbar) {
        var _this = this;
        if (!this.isReady()) {
            /** Registers the current Toolbar App */
            this.toolbar = toolbar;
            /** Initializes the Redux store */
            this.initStore(storeProvider);
            /** Loads the notifications from the DB */
            RestApi_1.default.getAllNotifications().then(function (notificationStateList) {
                /** Registers the notifications in the API */
                return _this.updateStateList(notificationStateList);
            }).then(function () {
                /** Renders the component through Redux */
                _this.render(toolbar);
                /** Informs the API that it's ready */
                _this.ready();
                /** Processes the scheduled functions */
                _this.process();
            }).catch(function (reason) {
                /** Error case: informs the API that its initialization has failed */
                _this.logError("Could not load Notifications: " + reason);
            });
        }
    };
    /**
     * Creates or updates a notification state
     * Makes a call to the REST API for same operation in the DB
     *
     * @param   {NotificationState} notificationState
     * @returns {Promise<Api>}
     */
    Api.prototype.pushOne = function (notificationState) {
        var _this = this;
        var isNew = true;
        var hasChanged = true;
        var type = notificationState.type;
        /** Does the Notification exists? */
        if (this.getState().notificationStateList.has(type)) {
            isNew = false;
            /** Does its state changed? */
            hasChanged = StateListFactory_1.default.hasStateChanged(this.getState().notificationStateList.get(type), notificationState);
            if (hasChanged) {
                notificationState = Object.assign({}, this.getState().notificationStateList.get(type), notificationState);
            }
        }
        if (hasChanged) {
            var notificationStateListUpdate = new Map();
            notificationStateListUpdate.set(type, notificationState);
            return (this.pushStateList(notificationStateListUpdate).then(function () {
                if (isNew) {
                    return RestApi_1.default.createNotification(notificationState);
                }
                else {
                    return RestApi_1.default.updateNotification(notificationState);
                }
            }).then(function () {
                return _this;
            }).catch(function (reason) {
                _this.logError("Could not push Notification: " + reason);
                return _this;
            }));
        }
        return Promise.resolve(this);
    };
    /**
     * "Deletes" a notification state (pushes with "deleted" flag)
     * Makes a call to the REST API for same operation in the DB
     *
     * @param   {number} notificationType
     * @returns {Promise<Api>}
     */
    Api.prototype.deleteOne = function (notificationType) {
        if (this.getState().notificationStateList.has(notificationType)) {
            return this.pushOne({
                type: notificationType,
                dismissed: true,
                deleted: true,
                read: true
            });
        }
        return void 0;
    };
    /**
     * Pushes a new state for all existing (or given) notifications
     * with (a) specific property(ies) - read / dismissed / deleted
     * Makes a call to the REST API for same operation in the DB
     * In error cases, informs the API that the operation has failed
     *
     * @params  {Array<string>} property
     * @params  {Array<number>} typesToMark
     * @returns {Promise<Api>}
     */
    Api.prototype.markAllAs = function (properties, typesToMark) {
        var _this = this;
        var notificationStateListUpdate = new Map();
        this.getState().notificationStateList.forEach(function (notificationState) {
            var hasChanged = false;
            var stateUpdate = {
                type: notificationState.type
            };
            var notificationConfig = ConfigFactory_1.default.getConfig(notificationState.type);
            /** If a restricted list of states to be marked were given, checks if the current states belongs to it */
            if (typeof typesToMark === "undefined"
                || typesToMark.indexOf(notificationState.type) !== -1) {
                /** Get the property to update */
                properties.forEach(function (property) {
                    switch (property) {
                        case "read":
                            if (!notificationState.read) {
                                stateUpdate.read = true;
                                hasChanged = true;
                            }
                            break;
                        case "dismissed":
                            if (!notificationState.dismissed && notificationConfig.bubbleOptions.closable) {
                                stateUpdate.dismissed = true;
                                hasChanged = true;
                            }
                            break;
                        case "deleted":
                            if (!notificationState.deleted && notificationConfig.cardOptions.closable) {
                                stateUpdate.deleted = true;
                                hasChanged = true;
                            }
                            break;
                        default:
                            break;
                    }
                });
                /** If the property isn't currently set to `true`, adds it to the update list */
                if (hasChanged) {
                    notificationStateListUpdate.set(notificationState.type, Object.assign({}, notificationState, stateUpdate));
                }
            }
        });
        if (notificationStateListUpdate.size > 0) {
            return (this.pushStateList(notificationStateListUpdate).then(function () {
                return RestApi_1.default.updateNotifications(notificationStateListUpdate);
            }).then(function () {
                return _this;
            }).catch(function (reason) {
                _this.logError("Could not mark Notifications as '" + properties.join(" / ") + "': " + reason);
                return _this;
            }));
        }
        return Promise.resolve(this);
    };
    /**
     * Updates the Notification Center state
     *    - Opens it if it's closed
     *    - Closes it if it's open
     *    - Or force the state if param `open` is given
     *
     * @param {boolean} open
     */
    Api.prototype.toggleCenter = function (open) {
        if (typeof open === "undefined") {
            open = !this.getState().isCenterOpen;
        }
        else {
            if ((open && this.getState().isCenterOpen) || (!open && !this.getState().isCenterOpen)) {
                return;
            }
        }
        if (open) {
            this.openCenter();
        }
        else {
            this.closeCenter();
        }
    };
    /**
     * READY hook that registers API calls before initialization
     * If the API has already been initialized, the function simply runs it
     *
     * @param {() => void} listener
     */
    Api.prototype.schedule = function (listener) {
        if (this.getState().isReady) {
            listener();
        }
        else {
            this.listeners.push(listener);
        }
    };
    /**
     * Runs the API calls registered with the schedule() function
     * Each call is deleted from the queue when processed
     */
    Api.prototype.process = function () {
        while (this.listeners.length > 0) {
            this.listeners.pop()();
        }
    };
    /**
     * Wraps the Redux call of the pauseApi() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @returns {Promise<Api>}
     */
    Api.prototype.pause = function () {
        var _this = this;
        return this.store.dispatch(ReduxApi_1.pauseApi())
            .then(function () {
            return _this;
        });
    };
    /**
     * Wraps the Redux call of the resumeApi() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @returns {Promise<Api>}
     */
    Api.prototype.resume = function () {
        var _this = this;
        return this.store.dispatch(ReduxApi_1.resumeApi())
            .then(function () {
            return _this;
        });
    };
    /**
     * Checks if the API is ready
     * (for test purposes)
     *
     * @returns {boolean}
     */
    Api.prototype.isReady = function () {
        return (this.getState().isReady);
    };
    /**
     * Checks if the API is paused
     * (for test purposes)
     *
     * @returns {boolean}
     */
    Api.prototype.isPaused = function () {
        return (this.getState().isPaused);
    };
    /**
     * Gets the current Toolbar App
     *
     * @returns {ToolbarApp}
     */
    Api.prototype.getToolbar = function () {
        return this.toolbar;
    };
    /**
     * Initializes the Redux State
     *
     * @returns {ApiState}
     */
    Api.prototype.getInitialState = function () {
        return {
            isReady: false,
            isPaused: false,
            isCenterOpen: false,
            notificationStateList: new Map()
        };
    };
    /**
     * Wraps the call to get the Redux State
     * N.B. This wrapper aims to make the API class more testable
     *
     * @returns {ApiState}
     */
    Api.prototype.getState = function () {
        if (typeof this.store === "undefined") {
            return this.getInitialState();
        }
        if (typeof this.store.getState() === "undefined" || !this.store.getState()) {
            return this.getInitialState();
        }
        return ReduxApi_1.default.select(this.store.getState());
    };
    /**
     * Initializes the Redux store
     *    - adds our reducer function from the ReduxApi utility class
     *    - adds our store listener from the ReduxApi to know when the state has been changed
     *    - bootstraps the Redux logic and saves the store reference
     *
     * @param storeProvider
     */
    Api.prototype.initStore = function (storeProvider) {
        storeProvider.addReducer(ReduxApi_1.default.reduce, "notification");
        this.store = storeProvider.getStore();
    };
    /**
     * Registers error cases using the Front-End log
     *
     * @param {string} message
     */
    Api.prototype.logError = function (message) {
        globalEvents.trigger("error.diy-editor", { message: message });
    };
    /**
     * Wraps the call to render the React Components Redux State
     * N.B. This wrapper aims to make the API class more testable
     *
     * @param {ToolbarApp} toolbar
     */
    Api.prototype.render = function (toolbar) {
        ReduxApi_1.default.render(this.store, toolbar);
    };
    /**
     * Wraps the Redux call of the readyApi() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @returns {Promise<Api>}
     */
    Api.prototype.ready = function () {
        var _this = this;
        return this.store.dispatch(ReduxApi_1.readyApi())
            .then(function () {
            return _this;
        });
    };
    /**
     * Wraps the Redux call of the openCenter() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @returns {Promise<void>}
     */
    Api.prototype.openCenter = function () {
        var _this = this;
        return this.markAllAs(["read", "dismissed"]).then(function () {
            _this.store.dispatch(ReduxApi_1.openCenter());
        });
    };
    /**
     * Wraps the Redux call of the closeCenter() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @returns {Promise<void>}
     */
    Api.prototype.closeCenter = function () {
        return this.store.dispatch(ReduxApi_1.closeCenter());
    };
    /**
     * Wraps the Redux call of the pushNotificationState() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @param   {NotificationStateList} notificationStateList
     * @returns {Promise<void>}
     */
    Api.prototype.pushStateList = function (notificationStateList) {
        return this.store.dispatch(ReduxApi_1.pushNotificationStates({
            notificationStateList: notificationStateList
        }));
    };
    /**
     * Wraps the Redux call of the updateNotificationStateList() Action
     * N.B. This wrapper aims to make the API class more testable
     *
     * @param   {NotificationStateList} notificationStateList
     * @returns {Promise<void>}
     */
    Api.prototype.updateStateList = function (notificationStateList) {
        return this.store.dispatch(ReduxApi_1.updateNotificationStateList({
            notificationStateList: notificationStateList
        }));
    };
    return Api;
}());
exports.Api = Api;
exports.default = new Api();


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var websiteData = __webpack_require__(4);
var ConfigFactory_1 = __webpack_require__(539);
var RestApi = (function () {
    function RestApi() {
    }
    /**
     * Creates a Notification with a given state object
     *
     * @param   {NotificationState} notificationState
     * @returns {Promise<{}>}
     */
    RestApi.createNotification = function (notificationState) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                $.ajax({
                    method: "POST",
                    url: _this.restUrl,
                    data: JSON.stringify(_this.getNotificationData(notificationState)),
                    contentType: "application/vnd.oneandone.diy.website.notification+json",
                    headers: {
                        Accept: "application/vnd.oneandone.diy.website.notification+json"
                    },
                    success: resolve,
                    error: reject
                });
            }
            catch (reason) {
                reject(reason);
            }
        });
    };
    /**
     * Creates multiple Notifications with a given state list
     *
     * @param   {NotificationState[]} notificationStateList
     * @returns {Promise<{}>}
     */
    RestApi.createNotifications = function (notificationStateList) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var notificationRestData = Array.from(notificationStateList.values())
                    .map(function (state) { return RestApi.getNotificationData(state); });
                $.ajax({
                    method: "POST",
                    url: _this.restUrl,
                    data: JSON.stringify(notificationRestData),
                    contentType: "application/vnd.oneandone.diy.website.notifications+json",
                    headers: {
                        Accept: "application/vnd.oneandone.diy.website.notifications+json"
                    },
                    success: resolve,
                    error: reject
                });
            }
            catch (reason) {
                reject(reason);
            }
        });
    };
    /**
     * Get a single notification from the actual website by the type
     *
     * @param   {number} type
     * @returns {Promise<NotificationState>}
     */
    RestApi.getNotification = function (type) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax({
                method: "GET",
                url: _this.restUrl + "/" + type,
                contentType: "application/vnd.oneandone.diy.website.notification+json",
                headers: {
                    Accept: "application/vnd.oneandone.diy.website.notification+json"
                },
                success: function (data) {
                    try {
                        resolve(_this.convertNotificationData(data));
                    }
                    catch (reason) {
                        reject(reason);
                    }
                },
                error: reject
            });
        });
    };
    /**
     * Returns all notificationStateList for the actual website
     *
     * @returns {Promise<NotificationStateList>}
     */
    RestApi.getAllNotifications = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax({
                method: "GET",
                url: _this.restUrl,
                contentType: "application/vnd.oneandone.diy.website.notifications+json",
                headers: {
                    Accept: "application/vnd.oneandone.diy.website.notifications+json"
                },
                success: function (data) {
                    var notificationStateList = new Map();
                    data.notifications.forEach(function (notificationRestData) {
                        try {
                            notificationStateList.set(notificationRestData.type, _this.convertNotificationData(notificationRestData));
                        }
                        catch (reason) {
                            reject(reason);
                        }
                    });
                    resolve(notificationStateList);
                },
                error: reject
            });
        });
    };
    /**
     * Updates a notification in the database with the same type as the type in the given
     * NotificationState object
     *
     * @param   {NotificationState} notificationState
     * @returns {Promise<{}>}
     */
    RestApi.updateNotification = function (notificationState) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                $.ajax({
                    method: "PUT",
                    url: _this.restUrl,
                    data: JSON.stringify(_this.getNotificationData(notificationState)),
                    contentType: "application/vnd.oneandone.diy.website.notification+json",
                    headers: {
                        Accept: "application/vnd.oneandone.diy.website.notification+json"
                    },
                    success: resolve,
                    error: reject
                });
            }
            catch (reason) {
                reject(reason);
            }
        });
    };
    /**
     * Updates many notificationStateList in the database by the type from the actual processed NotificationState
     * Object from the NotificationState array
     *
     * @param   {NotificationStateList} notificationStateList
     * @returns {Promise<{}>}
     */
    RestApi.updateNotifications = function (notificationStateList) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var notificationRestData_1 = [];
                notificationStateList.forEach(function (notificationState) {
                    notificationRestData_1.push(_this.getNotificationData(notificationState));
                });
                $.ajax({
                    method: "PUT",
                    url: _this.restUrl,
                    data: JSON.stringify(notificationRestData_1),
                    contentType: "application/vnd.oneandone.diy.website.notifications+json",
                    headers: {
                        Accept: "application/vnd.oneandone.diy.website.notifications+json"
                    },
                    success: resolve,
                    error: reject
                });
            }
            catch (reason) {
                reject(reason);
            }
        });
    };
    /**
     * Translates the Configuration data into Back-End data
     *
     * @param   {NotificationState} notificationState
     * @returns {NotificationRestData}
     */
    RestApi.getNotificationData = function (notificationState) {
        try {
            var notificationConfig = ConfigFactory_1.default.factory(notificationState);
            return {
                category: 1,
                type: notificationConfig.type,
                sticky: notificationConfig.cardOptions.closable ? 0 : 1,
                payload: notificationConfig.payload,
                severity: notificationConfig.severity,
                read: notificationConfig.read ? 1 : 0,
                dismissed: notificationConfig.dismissed ? 1 : 0,
                deleted: notificationConfig.deleted ? 1 : 0
            };
        }
        catch (reason) {
            throw new Error(reason);
        }
    };
    /**
     * Translates Back-End data into a State
     *
     * @param   {NotificationRestData} notificationRestData
     * @returns {NotificationState}
     */
    RestApi.convertNotificationData = function (notificationRestData) {
        try {
            return {
                type: notificationRestData.type,
                counter: Date.now(),
                priority: false,
                read: (notificationRestData.read === 1),
                dismissed: (notificationRestData.dismissed === 1),
                deleted: (notificationRestData.deleted === 1),
                payload: notificationRestData.payload
            };
        }
        catch (reason) {
            throw new Error(reason);
        }
    };
    return RestApi;
}());
RestApi.restUrl = "/rest/websites/" + websiteData.getId() + "/notifications";
exports.default = RestApi;


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Type_1 = __webpack_require__(540);
var Severity_1 = __webpack_require__(541);
var Chat_1 = __webpack_require__(542);
var BrowserUpgrade_1 = __webpack_require__(543);
var NoDomain_1 = __webpack_require__(545);
var MaintenanceMode_1 = __webpack_require__(547);
var Congrats_1 = __webpack_require__(549);
var NotPublished_1 = __webpack_require__(551);
var Guidance_1 = __webpack_require__(552);
var EMP_1 = __webpack_require__(554);
var XingVouchers_1 = __webpack_require__(555);
var WebComponentUpsell_1 = __webpack_require__(556);
var ExternalWebsiteImportStarted_1 = __webpack_require__(582);
var ExternalWebsiteImportSkipped_1 = __webpack_require__(587);
var ExternalWebsiteImportFinished_1 = __webpack_require__(588);
var SectionsAddGroup_1 = __webpack_require__(589);
var RankingCoach_1 = __webpack_require__(590);
var AviaryShutdown_1 = __webpack_require__(591);
/**
 * Factory to merge a predefined Notification Config
 * with a dynamical Notification State
 */
var ConfigFactory = (function () {
    function ConfigFactory() {
    }
    /**
     * Get the default Configuration
     *
     * @returns {NotificationConfig}
     */
    ConfigFactory.getDefault = function () {
        return {
            type: null,
            testId: "",
            trackingId: "",
            title: "",
            content: "",
            icon: null,
            severity: Severity_1.default.NORMAL,
            mainAction: null,
            dismissAction: null,
            bubbleOptions: {
                closable: true,
                autoHide: true,
                hideDelay: 7000
            },
            cardOptions: {
                closable: true,
                hidden: false
            }
        };
    };
    /**
     * Get the default Configuration for a notification type
     *
     * @param   {Type} type
     * @returns {NotificationConfig}
     * @throws  {Error}
     */
    ConfigFactory.getConfig = function (type) {
        var notificationConfig;
        switch (type) {
            case Type_1.default.CHAT:
                notificationConfig = Chat_1.default;
                break;
            case Type_1.default.BROWSER_UPGRADE:
                notificationConfig = BrowserUpgrade_1.default;
                break;
            case Type_1.default.NO_DOMAIN:
                notificationConfig = NoDomain_1.default;
                break;
            case Type_1.default.MAINTENANCE_MODE:
                notificationConfig = MaintenanceMode_1.default;
                break;
            case Type_1.default.CONGRATS:
                notificationConfig = Congrats_1.default;
                break;
            case Type_1.default.NOT_PUBLISHED:
                notificationConfig = NotPublished_1.default;
                break;
            case Type_1.default.GUIDANCE:
                notificationConfig = Guidance_1.default;
                break;
            case Type_1.default.EMP:
                notificationConfig = EMP_1.default;
                break;
            case Type_1.default.XING_VOUCHERS:
                notificationConfig = XingVouchers_1.default;
                break;
            case Type_1.default.WEB_COMPONENT_UPSELL:
                notificationConfig = WebComponentUpsell_1.default;
                break;
            case Type_1.default.EXTERNAL_WEBSITE_IMPORT_STARTED:
                notificationConfig = ExternalWebsiteImportStarted_1.default;
                break;
            case Type_1.default.EXTERNAL_WEBSITE_IMPORT_SKIPPED:
                notificationConfig = ExternalWebsiteImportSkipped_1.default;
                break;
            case Type_1.default.EXTERNAL_WEBSITE_IMPORT_FINISHED:
                notificationConfig = ExternalWebsiteImportFinished_1.default;
                break;
            case Type_1.default.SECTIONS_ADD_GROUP:
                notificationConfig = SectionsAddGroup_1.default;
                break;
            case Type_1.default.RANKING_COACH:
                notificationConfig = RankingCoach_1.default;
                break;
            case Type_1.default.AVIARY_SHUTDOWN:
                notificationConfig = AviaryShutdown_1.default;
                break;
            default:
                throw new Error("Notification Model of type " + type + " doesn't exist");
        }
        return ConfigFactory.merge(ConfigFactory.getDefault(), notificationConfig);
    };
    /**
     * Merge two Config objects together
     *
     * @param {NotificationConfig} initialConfig
     * @param {NotificationConfig} updatedConfig
     * @returns {NotificationConfig}
     */
    ConfigFactory.merge = function (initialConfig, updatedConfig) {
        var notificationConfig = Object.assign({}, initialConfig, updatedConfig);
        notificationConfig.bubbleOptions = Object.assign({}, initialConfig.bubbleOptions, updatedConfig.bubbleOptions);
        notificationConfig.cardOptions = Object.assign({}, initialConfig.cardOptions, updatedConfig.cardOptions);
        return notificationConfig;
    };
    /**
     * Generates the last Config version using State data
     *
     * @param   {NotificationState} notificationState
     * @returns {NotificationConfig}
     */
    ConfigFactory.factory = function (notificationState) {
        var notificationConfig = Object.assign({}, ConfigFactory.getConfig(notificationState.type), notificationState);
        if (typeof notificationConfig.onFactory === "function") {
            notificationConfig = notificationConfig.onFactory(notificationConfig);
        }
        return notificationConfig;
    };
    return ConfigFactory;
}());
exports.default = ConfigFactory;


/***/ },
/* 540 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Type;
(function (Type) {
    Type[Type["CHAT"] = 1] = "CHAT";
    Type[Type["BROWSER_UPGRADE"] = 3] = "BROWSER_UPGRADE";
    Type[Type["NO_DOMAIN"] = 4] = "NO_DOMAIN";
    Type[Type["MAINTENANCE_MODE"] = 5] = "MAINTENANCE_MODE";
    Type[Type["CONGRATS"] = 10] = "CONGRATS";
    Type[Type["NOT_PUBLISHED"] = 11] = "NOT_PUBLISHED";
    Type[Type["GUIDANCE"] = 12] = "GUIDANCE";
    Type[Type["EMP"] = 14] = "EMP";
    Type[Type["XING_VOUCHERS"] = 16] = "XING_VOUCHERS";
    Type[Type["WEB_COMPONENT_UPSELL"] = 18] = "WEB_COMPONENT_UPSELL";
    Type[Type["EXTERNAL_WEBSITE_IMPORT_STARTED"] = 15] = "EXTERNAL_WEBSITE_IMPORT_STARTED";
    Type[Type["EXTERNAL_WEBSITE_IMPORT_SKIPPED"] = 17] = "EXTERNAL_WEBSITE_IMPORT_SKIPPED";
    Type[Type["EXTERNAL_WEBSITE_IMPORT_FINISHED"] = 19] = "EXTERNAL_WEBSITE_IMPORT_FINISHED";
    Type[Type["SECTIONS_ADD_GROUP"] = 20] = "SECTIONS_ADD_GROUP";
    Type[Type["RANKING_COACH"] = 21] = "RANKING_COACH";
    Type[Type["AVIARY_SHUTDOWN"] = 22] = "AVIARY_SHUTDOWN";
})(Type || (Type = {}));
exports.default = Type;


/***/ },
/* 541 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Severity;
(function (Severity) {
    Severity[Severity["HIGH"] = 1] = "HIGH";
    Severity[Severity["NORMAL"] = 2] = "NORMAL";
})(Severity || (Severity = {}));
exports.default = Severity;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var features = __webpack_require__(25);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.CHAT,
    testId: "chat",
    trackingId: "ChatNotification",
    content: l10n_1.default("chat.greeting"),
    mainAction: {
        testId: "open-chat",
        label: l10n_1.default("chat.link"),
        onClick: function () {
            var contactUrl = features.getPayload('chatNotification');
            window.open(contactUrl);
        }
    }
};


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var warning_1 = __webpack_require__(544);
var Type_1 = __webpack_require__(540);
var translations = new Map()
    .set("upgrade", l10n_1.default("upgradeBrowser.upgrade"))
    .set("switch", l10n_1.default("upgradeBrowser.switch"))
    .set("ie.text", l10n_1.default("upgradeBrowser.ie.text"))
    .set("ie.href", l10n_1.default("upgradeBrowser.ie.href"))
    .set("firefox.text", l10n_1.default("upgradeBrowser.firefox.text"))
    .set("firefox.href", l10n_1.default("upgradeBrowser.firefox.href"));
exports.default = {
    type: Type_1.default.BROWSER_UPGRADE,
    testId: "browser-upgrade",
    trackingId: "BrowserUpgradeNotification",
    icon: warning_1.default,
    cardOptions: {
        closable: false
    },
    onFactory: function (notificationConfig) {
        var msgType = notificationConfig.payload.msgType;
        var browserType = notificationConfig.payload.browserType;
        var message = translations.get(msgType);
        var browserButtonText = translations.get(browserType + ".text");
        var browserButtonLink = translations.get(browserType + ".href");
        notificationConfig.content = message;
        notificationConfig.mainAction = {
            testId: "do-upgrade",
            label: browserButtonText,
            onClick: function () {
                window.open(browserButtonLink, '_blank');
            }
        };
        return notificationConfig;
    }
};


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertWarning = function AlertWarning(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};
AlertWarning = (0, _pure2.default)(AlertWarning);
AlertWarning.displayName = 'AlertWarning';
AlertWarning.muiName = 'SvgIcon';

exports.default = AlertWarning;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var warning_1 = __webpack_require__(544);
var domainpromo = __webpack_require__(546);
var Type_1 = __webpack_require__(540);
var Severity_1 = __webpack_require__(541);
exports.default = {
    type: Type_1.default.NO_DOMAIN,
    testId: "no-domain",
    trackingId: "NoDomainNotification",
    content: l10n_1.default("domainConnection.notification.infoText"),
    icon: warning_1.default,
    severity: Severity_1.default.HIGH,
    mainAction: {
        testId: "show-domain-promo",
        label: l10n_1.default("notifications.moreDetails"),
        onClick: function () {
            domainpromo.show();
        }
    },
    cardOptions: {
        closable: false
    }
};


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

/* globals diy, cms */
var $ = __webpack_require__(3);
var l10n = __webpack_require__(18);

module.exports = {
    getDialogTpl: function() {
        var msg = l10n.getMessages('domainConnection.improvedDialog');

        return ('' +
            '<div class="content-wrapper">' +
                '<div class="domain clearfix">' +
                    '<span class="promo-icon ui-icon-domain ui-icon-64"></span>' +
                    '<button class="blue-primary domain-connect-link" tabindex="-1">' +
                        '<span>' + msg.domain.button + '</span>' +
                    '</button>' +
                    '<div class="domain-content collapsed">' +
                        '<h3>' + msg.domain.heading + '</h3>' +
                        '<div class="short-desc">' +
                            '<p>' +
                                msg.domain.shortDescription +
                                ' <a href="Javascript:;" class="show-more" tabindex="-1">' +
                                    msg.domain.more +
                                '</a>' +
                            '</p>' +
                        '</div>' +
                        '<h3 class="long-desc">' + msg.domain.info + '</h3>' +
                        '<p class="long-desc">' +
                            msg.domain.shortDescription +
                            '<br /><br />' +
                            msg.domain.description +
                            ' <a href="Javascript:;" class="show-less" tabindex="-1">' +
                            msg.domain.less +
                            '</a></p>' +
                        '</p>' +
                    '</div>' +
                '</div>' +

                '<div class="contact clearfix">' +
                    '<span class="promo-icon ui-icon-contact ui-icon-64"></span>' +
                    '<button class="blue-secondary help-contact-link" tabindex="-1">' +
                        '<span>' + msg.customerCare.button + '</span>' +
                    '</button>' +
                    '<div class="contact-content">' +
                        '<h3>' + msg.customerCare.heading + '</h3>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );
    },

    init: function() {
        var msg = l10n.getMessages('domainConnection.improvedDialog');

        this.dlgEl = $(this.getDialogTpl()).appendTo('body').diy_dialog({
            dialogClass: 'diye-domainpromo-dialog cp-style',
            width: 800,
            zIndex: 200000,
            title: msg.windowTitle,
            draggable: false,
            resizable: false,
            closeButton: true,
            closeCls: 'ui-icon-24 ui-icon-24-xclose',
            modal: true,
            close: function() {
                $(document).trigger('diy-editor-generic-linkInteraction', {
                    actionName:'domainPopup_cancelTopUnset'
                });
            }
        });

        this.dlgEl.find('.show-more').click(function() {
            this.dlgEl.find('.domain-content').removeClass('collapsed');
        }.bind(this));

        this.dlgEl.find('.show-less').click(function() {
            this.dlgEl.find('.domain-content').addClass('collapsed');
        }.bind(this));

        this.dlgEl.find('button.domain-connect-link').click(this._onDomainConnectClick.bind(this));
        this.dlgEl.find('button.help-contact-link').click(function(e) {
            e.preventDefault();
            $(document).trigger('diy-editor-generic-linkInteraction', {actionName: 'getSupport'});
            cms.help.GuidedAssistant._instance.showHelpWindowTab(
                cms.help.GuidedAssistant._instance._options.controller.contactView
            );
            if (diy.tracking) {
                diy.tracking.addEventSuppression('diy-editor-generic-linkInteraction');
            }
            this.dlgEl.diy_dialog('close');
        }.bind(this));

    },

    _onDomainConnectClick: function(e) {
        e.preventDefault();
        this.openDomainConnect();
    },

    openDomainConnect: function() {
        $(document).trigger('diy-editor-generic-linkInteraction', {actionName: 'chooseDomain'});
        diy.util.redirector.redirectToLabel('domain_connect_redirect-promo');
    },

    show: function() {
        if (!this.dlgEl) {
            this.init();
        }
        this.dlgEl.diy_dialog('open');
        $(document).trigger('diy-editor-generic-sectionAccessed', {'sectionCodeName': 'domain-connection-pop-up'});
    }
};


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var settings_1 = __webpack_require__(548);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.MAINTENANCE_MODE,
    testId: "maintenance-mode",
    trackingId: "MaintenanceModeNotification",
    title: l10n_1.default("toolbar.maintenance.offline.notification.title"),
    content: l10n_1.default("toolbar.maintenance.offline.notification.description"),
    icon: settings_1.default,
    mainAction: {
        testId: "open-settings",
        label: l10n_1.default("toolbar.maintenance.link"),
        onClick: function () {
            diy.editor.deeplinking.requestPath([
                { label: "siteadmin", params: "settings" },
                { label: "SAC.Settings", params: "website-staging" }
            ]);
        }
    },
    cardOptions: {
        closable: false
    }
};


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettings = function ActionSettings(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
  );
};
ActionSettings = (0, _pure2.default)(ActionSettings);
ActionSettings.displayName = 'ActionSettings';
ActionSettings.muiName = 'SvgIcon';

exports.default = ActionSettings;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var public_1 = __webpack_require__(550);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.CONGRATS,
    testId: "congrats",
    trackingId: "CongratsNotification",
    title: l10n_1.default("guidedSetup.notification_finished.title"),
    content: l10n_1.default("guidedSetup.notification_finished.content"),
    icon: public_1.default,
    mainAction: {
        testId: "open-settings",
        label: l10n_1.default("notifications.moreDetails"),
        onClick: function () {
            diy.editor.deeplinking.requestPath([
                { label: 'siteadmin', params: 'settings' },
                { label: 'SAC.Settings', params: 'website-staging' }
            ]);
        }
    }
};


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPublic = function SocialPublic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
  );
};
SocialPublic = (0, _pure2.default)(SocialPublic);
SocialPublic.displayName = 'SocialPublic';
SocialPublic.muiName = 'SvgIcon';

exports.default = SocialPublic;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var warning_1 = __webpack_require__(544);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.NOT_PUBLISHED,
    testId: "not-published",
    trackingId: "NotPublishedNotification",
    title: l10n_1.default("toolbar.maintenance.publish.notification.title"),
    content: l10n_1.default("toolbar.maintenance.publish.notification.description"),
    icon: warning_1.default,
    mainAction: {
        testId: "open-guided-setup",
        label: l10n_1.default("notifications.moreDetails"),
        onClick: function () {
            diy.editor.deeplinking.requestPath([
                { label: 'siteadmin', params: 'guidedsetup' }
            ]);
        }
    },
    cardOptions: {
        closable: false
    }
};


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var explore_1 = __webpack_require__(553);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.GUIDANCE,
    testId: "guidance",
    trackingId: "GuidanceNotification",
    title: l10n_1.default("guidance.notification.title"),
    content: l10n_1.default("guidance.notification.content"),
    icon: explore_1.default,
    mainAction: {
        testId: "guidance-start",
        label: l10n_1.default("guidance.notification.start"),
        onClick: function () {
            diy.editor.guidance.start();
        }
    },
    bubbleOptions: {
        autoHide: false
    }
};


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExplore = function ActionExplore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
  );
};
ActionExplore = (0, _pure2.default)(ActionExplore);
ActionExplore.displayName = 'ActionExplore';
ActionExplore.muiName = 'SvgIcon';

exports.default = ActionExplore;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var Api_1 = __webpack_require__(537);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.EMP,
    testId: "emp",
    trackingId: "EMPNotification",
    title: l10n_1.default("notifications.emp.title"),
    content: l10n_1.default("notifications.emp.content"),
    onFactory: function (notificationConfig) {
        if (typeof Api_1.default.getToolbar() !== "undefined") {
            notificationConfig.mainAction = {
                testId: "open-vcard-editor",
                label: l10n_1.default("notifications.moreDetails"),
                onClick: function () {
                    Api_1.default.getToolbar().getVCardEditor().open();
                }
            };
        }
        return notificationConfig;
    }
};


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var websiteData = __webpack_require__(4);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.XING_VOUCHERS,
    testId: "xing-vouchers",
    trackingId: "XingVouchersNotification",
    title: l10n_1.default("xingPromo.title"),
    cardOptions: {
        closable: false
    },
    onFactory: function (notificationConfig) {
        var xingPromo = websiteData.getNotificationData("xingPromo");
        notificationConfig.content = l10n_1.default("xingPromo.content") + "&nbsp;"
            + "<strong>" + xingPromo.voucherCode + "</strong>";
        notificationConfig.mainAction = {
            testId: "xing-redirect",
            label: l10n_1.default("xingPromo.label"),
            onClick: function () {
                diy.util.redirector.redirect(xingPromo.landingPageUrl);
            }
        };
        return notificationConfig;
    }
};


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var webcomponentUpsell_1 = __webpack_require__(557);
var Poller_1 = __webpack_require__(558);
var Type_1 = __webpack_require__(540);
var Severity_1 = __webpack_require__(541);
exports.default = {
    type: Type_1.default.WEB_COMPONENT_UPSELL,
    testId: "web-component-upsell",
    trackingId: "WebComponentUpsellFinishedNotification",
    severity: Severity_1.default.HIGH,
    bubbleOptions: {
        closable: false,
        autoHide: false
    },
    cardOptions: {
        hidden: true
    },
    onShow: function () {
        Poller_1.default.stop();
    },
    onFactory: function (notificationConfig) {
        var webComponentId = notificationConfig.payload.webComponentId;
        var translationKey = webComponentId + ".upsell";
        var description = l10n_1.default(translationKey + ".notification.description");
        var description2 = l10n_1.default(translationKey + ".notification.description2");
        var later = l10n_1.default(translationKey + ".later");
        var yes = l10n_1.default(translationKey + ".yes");
        notificationConfig.content = description + "<br />" + description2;
        notificationConfig.dismissAction = {
            testId: "later",
            label: later,
            onClick: function () {
                webcomponentUpsell_1.default.setStatusToSuccessSeen(false, webComponentId);
                webcomponentUpsell_1.default.trackLink('close', webComponentId);
            }
        };
        notificationConfig.mainAction = {
            testId: "yes",
            label: yes,
            onClick: function () {
                webcomponentUpsell_1.default.setStatusToSuccessSeen(true, webComponentId);
                webcomponentUpsell_1.default.trackLink('jumpToSiteAdmin', webComponentId);
            }
        };
        return notificationConfig;
    }
};


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var WebsiteData = __webpack_require__(4);
var $ = __webpack_require__(3);
var WebcomponentUpsell = (function () {
    function WebcomponentUpsell() {
        var _this = this;
        this.intervalTime = 500;
        /** @deprecated to remove when the old notifications are no longer used */
        this.pollFunction = function (webComponentId) {
            $.ajax({
                url: "/rest/websites/" + WebsiteData.getId() + "/webcomponent-upsell/" + webComponentId,
                type: "get",
                accepts: "application/vnd.oneandone.diy.website.webcomponent-upsell+json",
                success: function (response) {
                    switch (response['status-code']) {
                        case "SUCCESS":
                            _this.stopPolling();
                            _this.showNotification({ "status-code": "SUCCESS", webComponentId: webComponentId });
                            break;
                        case "ERROR":
                        case "ERROR_SEEN":
                        case "SUCCESS_SEEN":
                            _this.stopPolling();
                            break;
                        default:
                            break;
                    }
                }
            });
        };
    }
    /** @deprecated to remove when the old notifications are no longer used */
    WebcomponentUpsell.prototype.setApi = function (api) {
        this.api = api;
    };
    ;
    /** @deprecated to remove when the old notifications are no longer used */
    WebcomponentUpsell.prototype.startPolling = function (webComponentId) {
        this.pollInterval = setInterval(this.pollFunction, this.intervalTime, webComponentId);
    };
    ;
    /** @deprecated to remove when the old notifications are no longer used */
    WebcomponentUpsell.prototype.showNotification = function (webComponent) {
        this.stopPolling();
        var notificationObject = {
            type: 18,
            severity: 3,
            sticky: false,
            payload: {
                translationKey: webComponent.webComponentId + ".upsell"
            }
        };
        $("body").on('click', '#notification-upsell-successful-close', function () {
            WebcomponentUpsell.setStatusToSuccessSeen(false, webComponent.webComponentId);
            WebcomponentUpsell.trackLink('close', webComponent.webComponentId);
        }).on('click', '#notification-upsell-successful-yes', function () {
            WebcomponentUpsell.setStatusToSuccessSeen(true, webComponent.webComponentId);
            WebcomponentUpsell.trackLink('jumpToSiteAdmin', webComponent.webComponentId);
        });
        var apiRef = this.api;
        apiRef.ready(function () {
            apiRef.createNotification(notificationObject);
        });
    };
    ;
    /** @deprecated to remove when the old notifications are no longer used */
    WebcomponentUpsell.prototype.stopPolling = function () {
        clearInterval(this.pollInterval);
    };
    ;
    return WebcomponentUpsell;
}());
WebcomponentUpsell.setStatusToSuccessSeen = function (redirectAfterSuccess, webComponentId) {
    $.ajax({
        url: "/rest/websites/" + WebsiteData.getId() + "/webcomponent-upsell",
        type: "post",
        processData: false,
        dataType: 'json',
        data: JSON.stringify({
            webComponentId: webComponentId,
            "status-code": "SUCCESS_SEEN"
        }),
        success: function () {
            if (redirectAfterSuccess) {
                var redirectUrl = window.location.origin + window.location.pathname
                    + window.location.search + '#hm:cc-sa-item-' + webComponentId.toLowerCase();
                window.location.href = redirectUrl;
                window.location.reload();
            }
        },
        contentType: "application/vnd.oneandone.diy.website.webcomponent-upsell+json"
    });
};
WebcomponentUpsell.trackLink = function (action, webComponentId) {
    $(document).trigger("diy-editor-generic-linkInteraction", {
        pageName: webComponentId + 'UpsellNotification',
        actionName: action
    });
};
exports.default = WebcomponentUpsell;


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var RestApi_1 = __webpack_require__(538);
var ReduxApi_1 = __webpack_require__(559);
var Poller = (function () {
    function Poller() {
        this.delay = 5000;
    }
    /**
     * Poller initialization:
     *    - saves the store reference
     *
     * {StoreProvider} storeProvider
     */
    Poller.prototype.init = function (storeProvider) {
        if (!this.store) {
            this.store = storeProvider.getStore();
        }
    };
    /**
     * Starts polling from the Back-End for possibly new notifications
     * coming from the DB without reloading the page
     */
    Poller.prototype.start = function () {
        var _this = this;
        if (!this.intervalId) {
            this.intervalId = setInterval(function () {
                _this.doPollingAction();
            }, this.delay);
        }
    };
    /**
     * Stops polling from the Back-End
     */
    Poller.prototype.stop = function () {
        clearInterval(this.intervalId);
        this.intervalId = null;
    };
    /**
     * Configures the time between each interval
     * New data will be polled from the Back-End each [delay] seconds
     *
     * @param {number} delay
     */
    Poller.prototype.setDelay = function (delay) {
        this.delay = delay;
    };
    /**
     * Defines polling action
     */
    Poller.prototype.doPollingAction = function () {
        var _this = this;
        /** Loads the notifications from the DB */
        RestApi_1.default.getAllNotifications().then(function (notificationStateList) {
            /** Notify the API to register the new state */
            _this.updateStateList(notificationStateList);
            /** Stops polling when the session timed out */
        }).catch(function (reason) {
            if (reason.hasOwnProperty("status") && reason.status === 403) {
                _this.stop();
            }
        });
    };
    /**
     * Wraps the Redux call of the updateNotificationStateList() Action
     * N.B. This wrapper aims to make the Poller class more testable
     *
     * @param   {NotificationStateList} notificationStateList
     * @returns {Promise<void>}
     */
    Poller.prototype.updateStateList = function (notificationStateList) {
        return this.store.dispatch(ReduxApi_1.updateNotificationStateList({
            notificationStateList: notificationStateList
        }));
    };
    return Poller;
}());
exports.Poller = Poller;
exports.default = new Poller();


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var react_redux_1 = __webpack_require__(220);
var Api_1 = __webpack_require__(537);
var StateListFactory_1 = __webpack_require__(560);
var BubbleManager_1 = __webpack_require__(561);
var NotificationCenter_1 = __webpack_require__(577);
var NotificationIcon_1 = __webpack_require__(579);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var typedActions_1 = __webpack_require__(229);
var actionCreator = typedActions_1.actionCreatorFactory("diy/toolbar/notification/");
/**
 * Redux Actions to update the API Status (ready / paused)
 * + Thunks to attach a Promise to the Actions
 */
var readyApiAction = actionCreator("readyApi");
var pauseApiAction = actionCreator("pauseApi");
var resumeApiAction = actionCreator("resumeApi");
exports.readyApi = function () {
    return function (dispatch) {
        return Promise.resolve(dispatch(readyApiAction(void 0)));
    };
};
exports.pauseApi = function () {
    return function (dispatch) {
        return Promise.resolve(dispatch(pauseApiAction(void 0)));
    };
};
exports.resumeApi = function () {
    return function (dispatch) {
        return Promise.resolve(dispatch(resumeApiAction(void 0)));
    };
};
/**
 * Redux Action to open / close the Notification Center
 * + Thunk to attach a Promise to the Action
 */
exports.openCenterAction = actionCreator("openCenter");
exports.closeCenterAction = actionCreator("closeCenter");
exports.openCenter = function () {
    return function (dispatch) {
        return Promise.resolve(dispatch(exports.openCenterAction(void 0)));
    };
};
exports.closeCenter = function () {
    return function (dispatch) {
        return Promise.resolve(dispatch(exports.closeCenterAction(void 0)));
    };
};
var pushNotificationStatesAction = actionCreator("pushNotificationStates");
exports.pushNotificationStates = function (payload) {
    return function (dispatch) {
        return Promise.resolve(dispatch(pushNotificationStatesAction(payload)));
    };
};
var updateNotificationStateListAction = actionCreator("updateNotificationStateList");
exports.updateNotificationStateList = function (payload) {
    return function (dispatch) {
        return Promise.resolve(dispatch(updateNotificationStateListAction(payload)));
    };
};
/**
 * Redux functions for our State management
 * Affected components: NotificationCenter, BubbleManager
 */
var ReduxApi = (function () {
    function ReduxApi() {
    }
    ReduxApi.reduce = function (state, action) {
        if (state === void 0) { state = Api_1.default.getInitialState(); }
        switch (action.type) {
            /** Pauses the API */
            case pauseApiAction.type:
                return Object.assign({}, state, {
                    isPaused: true
                });
            /** Resumes the API */
            case resumeApiAction.type:
                return Object.assign({}, state, {
                    isPaused: false
                });
            /** Marks the API as ready  */
            case readyApiAction.type:
                return Object.assign({}, state, {
                    isReady: true
                });
            /**
             * Opens the Notification Center and "pauses" the Bubble Manager
             * (all bubbles close)
             */
            case exports.openCenterAction.type:
                return Object.assign({}, state, {
                    isCenterOpen: true
                });
            /**
             * Closes the Notification Center and "restarts" the Bubble Manager
             * (new bubbles can pop again)
             */
            case exports.closeCenterAction.type:
                return Object.assign({}, state, {
                    isCenterOpen: false
                });
            /**
             * Changes the state list (creates one / updates one)
             */
            case pushNotificationStatesAction.type:
                var newNotificationStateList = StateListFactory_1.default.push(state.notificationStateList, action.payload.notificationStateList);
                var isCenterOpen = (state.isCenterOpen &&
                    (StateListFactory_1.default.count(newNotificationStateList) > 0));
                return Object.assign({}, state, {
                    notificationStateList: newNotificationStateList,
                    isCenterOpen: isCenterOpen
                });
            /**
             * Changes the configs (merge two lists)
             * Closes the Notification Center if there is no more notifications to show
             */
            case updateNotificationStateListAction.type:
                return Object.assign({}, state, {
                    notificationStateList: StateListFactory_1.default.update(state.notificationStateList, action.payload.notificationStateList)
                });
            default:
                return state;
        }
    };
    /**
     * Renders our components according to the Redux state
     *
     * @param {Store} store
     * @param {ToolbarApp} toolbar
     */
    ReduxApi.render = function (store, toolbar) {
        /** Generating BODY container for the Bubbles and the Notification Center */
        var container = document.createElement("div");
        container.setAttribute("id", "diy-notification");
        document.body.appendChild(container);
        /** Generating the Toolbar container for the Notification icon */
        toolbar.getToolbar().pushToPanel("left", '<div id="diy-notification-icon"></div>', true);
        var iconContainer = document.getElementById("diy-notification-icon");
        /** Connecting React Components */
        var ConnectedBubbleManager = react_redux_1.connect(this.mapStateToBubbleManagerProps)(BubbleManager_1.default);
        var ConnectedNotificationCenter = react_redux_1.connect(this.mapStateToNotificationCenterProps)(NotificationCenter_1.default);
        var ConnectedNotificationIcon = react_redux_1.connect(this.mapStateToNotificationIconProps)(NotificationIcon_1.default);
        /**
         * We have two HTML elements with pointer events in it (Notification Center and Bubbles)
         * that could eventually have different positions in the viewport
         * "pointer-events: none" makes sure you can still click the elements underneath
         */
        ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
                React.createElement("div", { style: { pointerEvents: "none" } },
                    React.createElement(ConnectedBubbleManager, null),
                    React.createElement(ConnectedNotificationCenter, null)))), container);
        /** Rendering the Notification Icon in the Toolbar's left panel */
        ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
                React.createElement(ConnectedNotificationIcon, null))), iconContainer);
    };
    /**
     * Simple selector to get our state branch for Notifications
     * (some functions need this)
     *
     * @param   {AppState} state
     * @returns {ApiState}
     */
    ReduxApi.select = function (state) {
        return state.notification;
    };
    /**
     * Gets new Bubble Manager props according to the Redux state
     *
     * @param   {ApiState} state
     * @returns {BubbleManagerProps}
     */
    ReduxApi.mapStateToBubbleManagerProps = function (state) {
        return {
            pause: (state.notification.isCenterOpen || state.notification.isPaused),
            notificationStateList: state.notification.notificationStateList
        };
    };
    /**
     * Gets new Notification Center props according to the Redux state
     *
     * @param   {ApiState} state
     * @returns {NotificationCenterProps}
     */
    ReduxApi.mapStateToNotificationCenterProps = function (state) {
        return {
            open: (state.notification.isCenterOpen && !state.notification.isPaused),
            notificationStateList: state.notification.notificationStateList
        };
    };
    /**
     * Gets new Notification Icon props according to the Redux state
     *
     * @param   {ApiState} state
     * @returns {NotificationIconProps}
     */
    ReduxApi.mapStateToNotificationIconProps = function (state) {
        return {
            counter: StateListFactory_1.default.count(state.notification.notificationStateList, false),
            hasNotifications: StateListFactory_1.default.count(state.notification.notificationStateList) > 0,
            active: state.notification.isCenterOpen
        };
    };
    return ReduxApi;
}());
exports.default = ReduxApi;


/***/ },
/* 560 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Factory Class for Notification List
 * Uses Immutable pattern: always generating a new state from given state(s)
 */
var StateListFactory = (function () {
    function StateListFactory() {
    }
    /**
     * Get the default state
     *
     * @returns {NotificationState}
     */
    StateListFactory.getDefaultState = function () {
        return {
            type: null,
            counter: Date.now(),
            priority: true,
            read: false,
            dismissed: false,
            deleted: false,
            payload: {},
        };
    };
    /**
     * Delivers the current state with standard values for non-given parameters
     *
     * @param   {NotificationState} notificationState
     * @returns {NotificationState}
     */
    StateListFactory.getState = function (notificationState) {
        return Object.assign({}, this.getDefaultState, notificationState);
    };
    /**
     * Delivers the updated Notification state
     * -> Returns the last updated one of the two if `useNewest` is set to true
     * -> Returns the second one merged on top of the first one otherwise
     *
     * @param   {NotificationState} notificationState1
     * @param   {NotificationState} notificationState2
     * @param   {boolean} useNewest
     * @returns {NotificationState}
     */
    StateListFactory.getNewState = function (notificationState1, notificationState2, useNewest) {
        if (useNewest === void 0) { useNewest = true; }
        var oldNotificationState;
        var newNotificationState;
        if (useNewest) {
            if (notificationState1.counter < notificationState2.counter) {
                oldNotificationState = notificationState1;
                newNotificationState = notificationState2;
            }
            else if (notificationState1.counter > notificationState2.counter) {
                oldNotificationState = notificationState2;
                newNotificationState = notificationState1;
            }
            else if (notificationState1.priority) {
                oldNotificationState = notificationState2;
                newNotificationState = notificationState1;
            }
            else {
                oldNotificationState = notificationState1;
                newNotificationState = notificationState2;
            }
        }
        else {
            oldNotificationState = notificationState1;
            newNotificationState = notificationState2;
        }
        newNotificationState.counter = Date.now();
        return Object.assign({}, this.getDefaultState(), oldNotificationState, newNotificationState);
    };
    /**
     * Compares two Notification states
     * -> Returns true if they are not identical
     *
     * @param   {NotificationState} notificationState1
     * @param   {NotificationState} notificationState2
     * @returns {boolean}
     */
    StateListFactory.hasStateChanged = function (notificationState1, notificationState2) {
        var hasChanged = false;
        if (notificationState1.read !== notificationState2.read) {
            hasChanged = true;
        }
        if (notificationState1.dismissed !== notificationState2.dismissed) {
            hasChanged = true;
        }
        if (notificationState1.deleted !== notificationState2.deleted) {
            hasChanged = true;
        }
        var oldPayload = notificationState1.payload
            ? JSON.stringify(notificationState1.payload)
            : "";
        var newPayload = notificationState2.payload
            ? JSON.stringify(notificationState2.payload)
            : "";
        if (oldPayload !== newPayload) {
            hasChanged = true;
        }
        return hasChanged;
    };
    /**
     * Returns the number of existing notification states (= non-deleted) in the list
     * Optional: only read notifications / dismissed notifications / both
     *
     * @param   {NotificationStateList} notificationStateList
     * @param   {boolean} read
     * @param   {boolean} dismissed
     * @returns {number}
     */
    StateListFactory.count = function (notificationStateList, read, dismissed) {
        var count = 0;
        notificationStateList.forEach(function (notificationState) {
            if (notificationState.deleted) {
                return;
            }
            if (typeof read !== "undefined" && notificationState.read !== read) {
                return;
            }
            if (typeof dismissed !== "undefined" && notificationState.dismissed !== dismissed) {
                return;
            }
            count++;
        });
        return count;
    };
    /**
     * Generates the new list with added elements
     *
     * @param   {NotificationStateList} currentNotificationStateList
     * @param   {NotificationStateList} newNotificationStateList
     * @returns {NotificationStateList}
     */
    StateListFactory.push = function (currentNotificationStateList, newNotificationStateList) {
        var _this = this;
        var notificationStateList = new Map();
        currentNotificationStateList.forEach(function (currentNotificationState) {
            notificationStateList.set(currentNotificationState.type, _this.getState(currentNotificationState));
        });
        newNotificationStateList.forEach(function (newNotificationState) {
            if (notificationStateList.has(newNotificationState.type)) {
                notificationStateList.set(newNotificationState.type, _this.getNewState(currentNotificationStateList.get(newNotificationState.type), newNotificationState, false));
            }
            else {
                notificationStateList.set(newNotificationState.type, _this.getState(newNotificationState));
            }
        });
        return notificationStateList;
    };
    /**
     * Generates the new list updated with a given other list
     *    - Entries which don't exist anymore will be deleted
     *    - Non-existing entries will be added
     *    - Already existing entries will be merged
     *
     * @param   {NotificationStateList} currentNotificationStateList
     * @param   {NotificationStateList} newNotificationStateList
     * @returns {NotificationStateList}
     */
    StateListFactory.update = function (currentNotificationStateList, newNotificationStateList) {
        var _this = this;
        var notificationStateList = new Map();
        currentNotificationStateList.forEach(function (currentNotificationState) {
            if (newNotificationStateList.has(currentNotificationState.type)) {
                notificationStateList.set(currentNotificationState.type, _this.getNewState(currentNotificationState, newNotificationStateList.get(currentNotificationState.type)));
            }
        });
        newNotificationStateList.forEach(function (newNotificationState) {
            if (!notificationStateList.has(newNotificationState.type)) {
                notificationStateList.set(newNotificationState.type, _this.getState(newNotificationState));
            }
        });
        return notificationStateList;
    };
    return StateListFactory;
}());
exports.default = StateListFactory;


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactTransitionGroup = __webpack_require__(238);
var Layout_1 = __webpack_require__(562);
var Notification_1 = __webpack_require__(563);
var ConfigFactory_1 = __webpack_require__(539);
/**
 * Visual Component for the Bubble Manager
 * Reacts to the API notifications list
 */
var BubbleManager = (function (_super) {
    tslib_1.__extends(BubbleManager, _super);
    function BubbleManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BubbleManager.prototype.getStyles = function () {
        return {
            root: {
                top: "54px",
                left: "16px",
                width: "400px",
                position: "fixed",
                zIndex: diy.editor.getNewTopZIndex(),
                pointerEvents: "none"
            }
        };
    };
    BubbleManager.prototype.render = function () {
        var styles = this.getStyles();
        var notificationStateList = this.props.notificationStateList;
        /**
         * The <ReactTransitionGroup> wrapper allow us to add extra behaviours
         * when the component shows, leaves, etc.
         */
        if (!this.props.pause) {
            return (React.createElement("div", { className: this.props.className, style: styles.root }, Array.from(notificationStateList)
                .map(function (_a) {
                var key = _a[0], notificationState = _a[1];
                if (!notificationState.dismissed && !notificationState.deleted) {
                    var notificationConfig = ConfigFactory_1.default.factory(notificationState);
                    return (React.createElement(ReactTransitionGroup, { key: key },
                        React.createElement(Notification_1.default, { layout: Layout_1.default.Bubble, config: notificationConfig })));
                }
                return null;
            })));
        }
        else {
            return null;
        }
    };
    return BubbleManager;
}(React.Component));
exports.default = BubbleManager;


/***/ },
/* 562 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Layout;
(function (Layout) {
    Layout[Layout["Bubble"] = 0] = "Bubble";
    Layout[Layout["Card"] = 1] = "Card";
})(Layout || (Layout = {}));
exports.default = Layout;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDom = __webpack_require__(57);
var l10n_1 = __webpack_require__(18);
var Api_1 = __webpack_require__(537);
var Layout_1 = __webpack_require__(562);
var Severity_1 = __webpack_require__(541);
var NotificationActionButton_1 = __webpack_require__(564);
var NotificationDismissButton_1 = __webpack_require__(565);
var styles_1 = __webpack_require__(242);
var mwsSpacings = __webpack_require__(566);
var Avatar_1 = __webpack_require__(506);
var star_1 = __webpack_require__(567);
var Card_1 = __webpack_require__(568);
var Notification = (function (_super) {
    tslib_1.__extends(Notification, _super);
    function Notification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Notification.prototype.getStyles = function () {
        var smallSpacing = mwsSpacings.small + "px";
        var mediumSpacing = mwsSpacings.medium + "px";
        var styles = {
            root: {
                pointerEvents: "all"
            },
            container: {
                marginBottom: mediumSpacing
            },
            content: {
                display: "flex",
                background: styles_1.colors.white,
                padding: mediumSpacing + " " + mediumSpacing + " " + mediumSpacing + " " + smallSpacing
            },
            title: {
                fontWeight: 600,
                marginBottom: smallSpacing
            },
            icon: {
                marginTop: "-" + smallSpacing,
                marginRight: smallSpacing,
                color: styles_1.colors.blue500
            },
            actions: {
                textAlign: "right"
            },
            button: {
                marginLeft: "10px",
                marginRight: "0px"
            }
        };
        switch (this.props.config.severity) {
            case Severity_1.default.HIGH:
                styles.content.color = styles_1.colors.white;
                styles.content.background = styles_1.colors.blue500;
                styles.icon.color = styles_1.colors.white;
                break;
            case Severity_1.default.NORMAL:
            default:
                styles.actions.borderTop = "1px solid #dddddd";
                break;
        }
        if (this.props.layout === Layout_1.default.Bubble) {
            styles.root.position = "relative";
            styles.root.transition = "opacity 400ms, margin 400ms, visibility 0s";
            styles.root.visibility = "hidden";
            styles.root.opacity = 0;
        }
        else {
            styles.root.marginTop = mediumSpacing;
            styles.root.marginLeft = mediumSpacing;
            styles.root.marginRight = mediumSpacing;
        }
        return styles;
    };
    /**
     * Component Function reachable thanks to the Transition Wrapper
     * (See file BubbleManager.tsx)
     */
    Notification.prototype.componentDidAppear = function () {
        var _this = this;
        /**
         * Without a small timeout on showing, the animation is happening during the HTML generation
         * so it doesn't really look animated - it seems to show all of the sudden.
         */
        var animationEffectDelay = 500;
        setTimeout(function () {
            /** Element is nicely animated with CSS transitions on showing */
            if (_this.props.layout === Layout_1.default.Bubble) {
                var rootElement = ReactDom.findDOMNode(_this);
                rootElement.style.visibility = "visible";
                rootElement.style.opacity = "1";
            }
            /**
             * If the configuration has `autoHide` = true,
             * Bubble dismisses itself after `hideDelay` ms
             */
            Api_1.default.schedule(function () {
                var type = _this.props.config.type;
                var autoHide = _this.props.config.bubbleOptions.autoHide;
                var hideDelay = _this.props.config.bubbleOptions.hideDelay;
                if (autoHide === true && !Api_1.default.isPaused()) {
                    setTimeout(function () {
                        Api_1.default.pushOne({
                            type: type,
                            dismissed: true
                        });
                    }, hideDelay);
                }
            });
        }, animationEffectDelay);
    };
    Notification.prototype.componentDidMount = function () {
        if (typeof this.props.config.onShow === "function") {
            this.props.config.onShow();
        }
    };
    Notification.prototype.render = function () {
        var styles = this.getStyles();
        var config = this.props.config;
        var layout = (typeof this.props.layout !== "undefined") ? this.props.layout : Layout_1.default.Card;
        /** Load Data Test Id for Selenium tests */
        var testId = "notification-" + config.testId;
        /** Load given Icon ; if none load the standard SVG Icon */
        var Icon = this.props.config.icon || star_1.default;
        /** Add a "bubble" CSS class for the Bubble Layout */
        var className = (this.props.className ? this.props.className : "")
            + (layout === Layout_1.default.Bubble ? " notification-bubble" : "");
        /**
         * A "dismiss" on the BUBBLE dismisses the Notification,
         * A "dismiss" on the CARD deleted the Notification
         */
        var isDismissDeletion = (layout === Layout_1.default.Card);
        /** Show dismiss button ONLY if "closable" */
        var showDismissAction = ((layout === Layout_1.default.Bubble && config.bubbleOptions.closable)
            || (layout === Layout_1.default.Card && config.cardOptions.closable));
        /** Show action button if one exists */
        var showMainAction = config.mainAction;
        /** Don't show the actions bar when no action is being displayed */
        var actionStyles = (showMainAction || showDismissAction)
            ? styles.actions
            : { display: "none" };
        /** Default button text for "dismiss", depending on the context */
        var defaultDismissLabel = "";
        if (layout === Layout_1.default.Bubble) {
            defaultDismissLabel = l10n_1.default("notifications.dismiss");
        }
        else {
            defaultDismissLabel = l10n_1.default("notifications.delete");
        }
        /** Rendered only if still exists */
        if (!config.deleted) {
            return (React.createElement("div", { className: className, "data-test-id": testId, style: styles.root },
                React.createElement(Card_1.Card, { style: styles.container },
                    React.createElement(Card_1.CardText, { style: styles.content },
                        React.createElement(Avatar_1.default, { size: 40, icon: React.createElement(Icon, null), style: styles.icon, color: styles.icon.color, backgroundColor: "transparent" }),
                        React.createElement("div", null,
                            config.title
                                ? React.createElement("div", { style: styles.title }, config.title)
                                : "",
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: config.content } }))),
                    React.createElement(Card_1.CardActions, { style: actionStyles },
                        showDismissAction
                            ? React.createElement(NotificationDismissButton_1.default, { type: config.type, label: config.dismissAction
                                    ? config.dismissAction.label
                                    : defaultDismissLabel, onClick: config.dismissAction
                                    ? config.dismissAction.onClick
                                    : null, testId: config.dismissAction
                                    ? config.dismissAction.testId
                                    : "", isDismissDeletion: isDismissDeletion, style: styles.button })
                            : "",
                        showMainAction
                            ? React.createElement(NotificationActionButton_1.default, { type: config.type, label: config.mainAction.label, onClick: config.mainAction.onClick, testId: config.mainAction.testId, trackingId: config.trackingId, style: styles.button })
                            : ""))));
        }
        else {
            return null;
        }
    };
    return Notification;
}(React.Component));
exports.default = Notification;


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Api_1 = __webpack_require__(537);
var globalEvents = __webpack_require__(500);
var RaisedButton_1 = __webpack_require__(482);
var NotificationActionButton = (function (_super) {
    tslib_1.__extends(NotificationActionButton, _super);
    function NotificationActionButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            Api_1.default.schedule(function () {
                Api_1.default.pushOne({
                    type: _this.props.type,
                    dismissed: true,
                    read: true
                });
                Api_1.default.toggleCenter(false);
                /** Notification specific callback */
                if (typeof _this.props.onClick === "function") {
                    _this.props.onClick();
                }
                /** Click Tracking */
                globalEvents.trigger("diy-editor-generic-sectionAccessed", {
                    sectionCodeName: "notificationClicked",
                    propName: _this.props.trackingId
                });
            });
        };
        return _this;
    }
    NotificationActionButton.prototype.render = function () {
        var testId = "notification-" + (this.props.testId ? this.props.testId : "action");
        return (React.createElement(RaisedButton_1.default, { primary: true, "data-test-id": testId, label: this.props.label, style: this.props.style, onTouchTap: this.handleClick }));
    };
    return NotificationActionButton;
}(React.Component));
exports.default = NotificationActionButton;


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Api_1 = __webpack_require__(537);
var FlatButton_1 = __webpack_require__(479);
var NotificationDismissButton = (function (_super) {
    tslib_1.__extends(NotificationDismissButton, _super);
    function NotificationDismissButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            Api_1.default.schedule(function () {
                if (_this.props.isDismissDeletion) {
                    Api_1.default.deleteOne(_this.props.type);
                }
                else {
                    Api_1.default.pushOne({
                        type: _this.props.type,
                        dismissed: true,
                        read: true
                    });
                }
                if (typeof _this.props.onClick === "function") {
                    _this.props.onClick();
                }
            });
        };
        return _this;
    }
    NotificationDismissButton.prototype.render = function () {
        var testId = "notification-" + (this.props.testId ? this.props.testId : "dismiss");
        return (React.createElement(FlatButton_1.default, { "data-test-id": testId, label: this.props.label, style: this.props.style, onTouchTap: this.handleClick }));
    };
    return NotificationDismissButton;
}(React.Component));
exports.default = NotificationDismissButton;


/***/ },
/* 566 */
/***/ function(module, exports) {

var spacings = {
    small: 8,
    medium: 16,
    thick: 20,
    large: 32
};
module.exports = spacings;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleStar = function ToggleStar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
  );
};
ToggleStar = (0, _pure2.default)(ToggleStar);
ToggleStar.displayName = 'ToggleStar';
ToggleStar.muiName = 'SvgIcon';

exports.default = ToggleStar;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;

var _Card2 = __webpack_require__(569);

var _Card3 = _interopRequireDefault(_Card2);

var _CardHeader2 = __webpack_require__(572);

var _CardHeader3 = _interopRequireDefault(_CardHeader2);

var _CardTitle2 = __webpack_require__(573);

var _CardTitle3 = _interopRequireDefault(_CardTitle2);

var _CardMedia2 = __webpack_require__(574);

var _CardMedia3 = _interopRequireDefault(_CardMedia2);

var _CardText2 = __webpack_require__(575);

var _CardText3 = _interopRequireDefault(_CardText2);

var _CardActions2 = __webpack_require__(576);

var _CardActions3 = _interopRequireDefault(_CardActions2);

var _CardExpandable2 = __webpack_require__(570);

var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Card = _Card3.default;
exports.CardHeader = _CardHeader3.default;
exports.CardTitle = _CardTitle3.default;
exports.CardMedia = _CardMedia3.default;
exports.CardText = _CardText3.default;
exports.CardActions = _CardActions3.default;
exports.CardExpandable = _CardExpandable3.default;
exports.default = _Card3.default;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

var _CardExpandable = __webpack_require__(570);

var _CardExpandable2 = _interopRequireDefault(_CardExpandable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Card = function (_Component) {
  _inherits(Card, _Component);

  function Card() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Card)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      expanded: null
    }, _this.handleExpanding = function (event) {
      event.preventDefault();
      var newExpandedState = !_this.state.expanded;
      // no automatic state update when the component is controlled
      if (_this.props.expanded === null) {
        _this.setState({ expanded: newExpandedState });
      }
      if (_this.props.onExpandChange) {
        _this.props.onExpandChange(newExpandedState);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Card, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var style = _props.style;
      var containerStyle = _props.containerStyle;
      var children = _props.children;
      var expandable = _props.expandable;
      var expandedProp = _props.expanded;
      var initiallyExpanded = _props.initiallyExpanded;
      var onExpandChange = _props.onExpandChange;

      var other = _objectWithoutProperties(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);

      var lastElement = void 0;
      var expanded = this.state.expanded;
      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        var doClone = false;
        var newChild = undefined;
        var newProps = {};
        var element = currentChild;
        if (!currentChild || !currentChild.props) {
          return null;
        }
        if (expanded === false && currentChild.props.expandable === true) return;
        if (currentChild.props.actAsExpander === true) {
          doClone = true;
          newProps.onTouchTap = _this2.handleExpanding;
          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
        }
        if (currentChild.props.showExpandableButton === true) {
          doClone = true;
          newChild = _react2.default.createElement(_CardExpandable2.default, { expanded: expanded, onExpanding: _this2.handleExpanding });
        }
        if (doClone) {
          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
        }
        return element;
      }, this);

      // If the last element is text or a title we should add
      // 8px padding to the bottom of the card
      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');

      var mergedStyles = (0, _simpleAssign2.default)({
        zIndex: 1
      }, style);
      var containerMergedStyles = (0, _simpleAssign2.default)({
        paddingBottom: addBottomPadding ? 8 : 0
      }, containerStyle);

      return _react2.default.createElement(
        _Paper2.default,
        _extends({}, other, { style: mergedStyles }),
        _react2.default.createElement(
          'div',
          { style: containerMergedStyles },
          newChildren
        )
      );
    }
  }]);

  return Card;
}(_react.Component);

Card.propTypes = {
  /**
   * Can be used to render elements inside the Card.
   */
  children: _react.PropTypes.node,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _react.PropTypes.object,
  /**
   * If true, this card component is expandable. Can be set on any child of the `Card` component.
   */
  expandable: _react.PropTypes.bool,
  /**
   * Whether this card is expanded.
   * If `true` or `false` the component is controlled.
   * if `null` the component is uncontrolled.
   */
  expanded: _react.PropTypes.bool,
  /**
   * Whether this card is initially expanded.
   */
  initiallyExpanded: _react.PropTypes.bool,
  /**
   * Callback function fired when the `expandable` state of the card has changed.
   *
   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
   */
  onExpandChange: _react.PropTypes.func,
  /**
   * If true, this card component will include a button to expand the card. `CardTitle`,
   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
   * of `Card` can implements `showExpandableButton` or forwards the property to a child
   * component supporting it.
   */
  showExpandableButton: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
Card.defaultProps = {
  expandable: false,
  expanded: null,
  initiallyExpanded: false
};
exports.default = Card;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _keyboardArrowUp = __webpack_require__(571);

var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);

var _keyboardArrowDown = __webpack_require__(463);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

var _IconButton = __webpack_require__(420);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles() {
  return {
    root: {
      top: 0,
      bottom: 0,
      right: 4,
      margin: 'auto',
      position: 'absolute'
    }
  };
}

var CardExpandable = function (_Component) {
  _inherits(CardExpandable, _Component);

  function CardExpandable() {
    _classCallCheck(this, CardExpandable);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardExpandable).apply(this, arguments));
  }

  _createClass(CardExpandable, [{
    key: 'render',
    value: function render() {
      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _IconButton2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          onTouchTap: this.props.onExpanding
        },
        this.props.expanded ? _react2.default.createElement(_keyboardArrowUp2.default, null) : _react2.default.createElement(_keyboardArrowDown2.default, null)
      );
    }
  }]);

  return CardExpandable;
}(_react.Component);

CardExpandable.propTypes = {
  expanded: _react.PropTypes.bool,
  onExpanding: _react.PropTypes.func.isRequired,
  style: _react.PropTypes.object
};
CardExpandable.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CardExpandable;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
  );
};
HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
HardwareKeyboardArrowUp.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowUp;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _Avatar = __webpack_require__(506);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      fontWeight: card.fontWeight,
      boxSizing: 'border-box',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    text: {
      display: 'inline-block',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      paddingRight: '90px'
    },
    avatar: {
      marginRight: 16
    },
    title: {
      color: props.titleColor || card.titleColor,
      display: 'block',
      fontSize: 15
    },
    subtitle: {
      color: props.subtitleColor || card.subtitleColor,
      display: 'block',
      fontSize: 14
    }
  };
}

var CardHeader = function (_Component) {
  _inherits(CardHeader, _Component);

  function CardHeader() {
    _classCallCheck(this, CardHeader);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardHeader).apply(this, arguments));
  }

  _createClass(CardHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var actAsExpander = _props.actAsExpander;
      var avatarProp = _props.avatar;
      var children = _props.children;
      var showExpandableButton = _props.showExpandableButton;
      var style = _props.style;
      var subtitle = _props.subtitle;
      var subtitleStyle = _props.subtitleStyle;
      var textStyle = _props.textStyle;
      var title = _props.title;
      var titleStyle = _props.titleStyle;

      var other = _objectWithoutProperties(_props, ['actAsExpander', 'avatar', 'children', 'showExpandableButton', 'style', 'subtitle', 'subtitleStyle', 'textStyle', 'title', 'titleStyle']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var avatar = avatarProp;

      if ((0, _react.isValidElement)(avatarProp)) {
        avatar = _react2.default.cloneElement(avatar, {
          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
        });
      } else if (avatar !== null) {
        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
      }

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        avatar,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
            title
          ),
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
            subtitle
          )
        ),
        children
      );
    }
  }]);

  return CardHeader;
}(_react.Component);

CardHeader.muiName = 'CardHeader';
CardHeader.propTypes = {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _react.PropTypes.bool,
  /**
   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
   * If `avatar` is an `Avatar` or other element, it will be rendered.
   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
   */
  avatar: _react.PropTypes.node,
  /**
   * Can be used to render elements inside the Card Header.
   */
  children: _react.PropTypes.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _react.PropTypes.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Can be used to render a subtitle in Card Header.
   */
  subtitle: _react.PropTypes.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _react.PropTypes.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the text.
   */
  textStyle: _react.PropTypes.object,
  /**
   * Can be used to render a title in Card Header.
   */
  title: _react.PropTypes.node,
  /**
   * Override the title color.
   */
  titleColor: _react.PropTypes.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _react.PropTypes.object
};
CardHeader.defaultProps = {
  avatar: null
};
CardHeader.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CardHeader;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      position: 'relative'
    },
    title: {
      fontSize: 24,
      color: props.titleColor || card.titleColor,
      display: 'block',
      lineHeight: '36px'
    },
    subtitle: {
      fontSize: 14,
      color: props.subtitleColor || card.subtitleColor,
      display: 'block'
    }
  };
}

var CardTitle = function (_Component) {
  _inherits(CardTitle, _Component);

  function CardTitle() {
    _classCallCheck(this, CardTitle);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardTitle).apply(this, arguments));
  }

  _createClass(CardTitle, [{
    key: 'render',
    value: function render() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, this.props.style);
      var titleStyle = (0, _simpleAssign2.default)({}, styles.title, this.props.titleStyle);
      var subtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, this.props.subtitleStyle);

      var _props = this.props;
      var subtitle = _props.subtitle;
      var subtitleColor = _props.subtitleColor;
      var title = _props.title;
      var titleColor = _props.titleColor;

      var other = _objectWithoutProperties(_props, ['subtitle', 'subtitleColor', 'title', 'titleColor']);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(titleStyle) },
          title
        ),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(subtitleStyle) },
          subtitle
        ),
        this.props.children
      );
    }
  }]);

  return CardTitle;
}(_react.Component);

CardTitle.muiName = 'CardTitle';
CardTitle.propTypes = {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _react.PropTypes.bool,
  /**
   * Can be used to render elements inside the Card Title.
   */
  children: _react.PropTypes.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _react.PropTypes.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Can be used to render a subtitle in the Card Title.
   */
  subtitle: _react.PropTypes.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _react.PropTypes.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _react.PropTypes.object,
  /**
   * Can be used to render a title in the Card Title.
   */
  title: _react.PropTypes.node,
  /**
   * Override the title color.
   */
  titleColor: _react.PropTypes.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _react.PropTypes.object
};
CardTitle.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CardTitle;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var cardMedia = context.muiTheme.cardMedia;


  return {
    root: {
      position: 'relative'
    },
    overlayContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },
    overlay: {
      height: '100%',
      position: 'relative'
    },
    overlayContent: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      paddingTop: 8,
      background: cardMedia.overlayContentBackground
    },
    media: {},
    mediaChild: {
      verticalAlign: 'top',
      maxWidth: '100%',
      minWidth: '100%',
      width: '100%'
    }
  };
}

var CardMedia = function (_Component) {
  _inherits(CardMedia, _Component);

  function CardMedia() {
    _classCallCheck(this, CardMedia);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardMedia).apply(this, arguments));
  }

  _createClass(CardMedia, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var overlay = _props.overlay;

      var other = _objectWithoutProperties(_props, ['overlay']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, this.props.style);
      var mediaStyle = (0, _simpleAssign2.default)(styles.media, this.props.mediaStyle);
      var overlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, this.props.overlayContainerStyle);
      var overlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, this.props.overlayContentStyle);
      var overlayStyle = (0, _simpleAssign2.default)(styles.overlay, this.props.overlayStyle);
      var titleColor = this.context.muiTheme.cardMedia.titleColor;
      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
      var color = this.context.muiTheme.cardMedia.color;

      var children = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
        });
      });

      var overlayChildren = _react2.default.Children.map(this.props.overlay, function (child) {
        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
          return _react2.default.cloneElement(child, {
            titleColor: titleColor,
            subtitleColor: subtitleColor
          });
        } else if (child.type.muiName === 'CardText') {
          return _react2.default.cloneElement(child, {
            color: color
          });
        } else {
          return child;
        }
      });

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(mediaStyle) },
          children
        ),
        overlay ? _react2.default.createElement(
          'div',
          { style: prepareStyles(overlayContainerStyle) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(overlayStyle) },
            _react2.default.createElement(
              'div',
              { style: prepareStyles(overlayContentStyle) },
              overlayChildren
            )
          )
        ) : ''
      );
    }
  }]);

  return CardMedia;
}(_react.Component);

CardMedia.propTypes = {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _react.PropTypes.bool,
  /**
   * Can be used to render elements inside the Card Media.
   */
  children: _react.PropTypes.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the Card Media.
   */
  mediaStyle: _react.PropTypes.object,
  /**
   * Can be used to render overlay element in Card Media.
   */
  overlay: _react.PropTypes.node,
  /**
   * Override the inline-styles of the overlay container.
   */
  overlayContainerStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the overlay content.
   */
  overlayContentStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the overlay element.
   */
  overlayStyle: _react.PropTypes.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
CardMedia.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CardMedia;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var cardText = context.muiTheme.cardText;


  return {
    root: {
      padding: 16,
      fontSize: 14,
      color: props.color || cardText.textColor
    }
  };
}

var CardText = function (_Component) {
  _inherits(CardText, _Component);

  function CardText() {
    _classCallCheck(this, CardText);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardText).apply(this, arguments));
  }

  _createClass(CardText, [{
    key: 'render',
    value: function render() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, this.props.style);

      return _react2.default.createElement(
        'div',
        _extends({}, this.props, { style: prepareStyles(rootStyle) }),
        this.props.children
      );
    }
  }]);

  return CardText;
}(_react.Component);

CardText.muiName = 'CardText';
CardText.propTypes = {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _react.PropTypes.bool,
  /**
   * Can be used to render elements inside the Card Text.
   */
  children: _react.PropTypes.node,
  /**
   * Override the CardText color.
   */
  color: _react.PropTypes.string,
  /**
   * If true, this card component is expandable.
   */
  expandable: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
CardText.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CardText;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles() {
  return {
    root: {
      padding: 8,
      position: 'relative'
    },
    action: {
      marginRight: 8
    }
  };
}

var CardActions = function (_Component) {
  _inherits(CardActions, _Component);

  function CardActions() {
    _classCallCheck(this, CardActions);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CardActions).apply(this, arguments));
  }

  _createClass(CardActions, [{
    key: 'render',
    value: function render() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var children = _react2.default.Children.map(this.props.children, function (child) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'div',
        _extends({}, this.props, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.style)) }),
        children
      );
    }
  }]);

  return CardActions;
}(_react.Component);

CardActions.propTypes = {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _react.PropTypes.bool,
  /**
   * Can be used to render elements inside the Card Action.
   */
  children: _react.PropTypes.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _react.PropTypes.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
CardActions.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = CardActions;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDom = __webpack_require__(57);
var l10n_1 = __webpack_require__(18);
var globalEvents = __webpack_require__(500);
var Api_1 = __webpack_require__(537);
var Notification_1 = __webpack_require__(563);
var NotificationCenterOverlay_1 = __webpack_require__(578);
var ConfigFactory_1 = __webpack_require__(539);
var styles_1 = __webpack_require__(242);
var mwsSpacings = __webpack_require__(566);
var Card_1 = __webpack_require__(569);
var CardText_1 = __webpack_require__(575);
var FlatButton_1 = __webpack_require__(479);
/**
 * Visual Component for the Notification Center
 * Reacts to the API notifications list
 */
var NotificationCenter = (function (_super) {
    tslib_1.__extends(NotificationCenter, _super);
    function NotificationCenter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleDismissAll = function () {
            Api_1.default.schedule(function () {
                Api_1.default.markAllAs(["deleted", "read", "dismissed"]);
            });
        };
        _this.handleDocumentClick = function (event) {
            var target = event.target;
            var rootElement = ReactDom.findDOMNode(_this);
            if (!rootElement.contains(target)) {
                Api_1.default.toggleCenter(false);
            }
        };
        _this.adjustHeight = function () {
            var extraMargin = 120;
            var containerElement = ReactDom.findDOMNode(_this.refs["container"]);
            if (containerElement) {
                var viewportHeight = document.body.clientHeight;
                var containerElementHeight = containerElement.offsetHeight;
                /** We let a margin of 60px to include the MWS Header + the NC Header */
                if (containerElementHeight > viewportHeight) {
                    containerElement.style.maxHeight = (viewportHeight - extraMargin) + "px";
                }
            }
        };
        return _this;
    }
    NotificationCenter.prototype.getStyles = function () {
        var smallSpacing = mwsSpacings.small + "px";
        var mediumSpacing = mwsSpacings.medium + "px";
        return {
            root: {
                top: "40px",
                left: smallSpacing,
                width: "432px",
                paddingTop: "14px",
                position: "fixed",
                pointerEvents: "all",
                zIndex: diy.editor.getNewTopZIndex(),
                display: this.props.open ? "block" : "none"
            },
            wrapper: {
                overflow: "hidden",
                position: "relative",
                backgroundColor: "#eceef1",
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "0px",
                borderTop: "3px solid " + styles_1.colors.blue500
            },
            container: {
                maxHeight: "none",
                overflowY: "auto",
                overflowX: "hidden"
            },
            arrow: {
                top: "0",
                left: "15px",
                display: "block",
                position: "absolute",
                color: styles_1.colors.blue500,
                textShadow: "0 1px 4px rgba(0, 0, 0, 0.24)"
            },
            message: {
                padding: mediumSpacing,
                backgroundColor: styles_1.colors.white,
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.24)"
            },
            header: {
                height: "auto",
                minHeight: "36px",
                padding: smallSpacing + " " + smallSpacing + " " + smallSpacing + " " + mediumSpacing,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: styles_1.colors.white,
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.24)"
            },
            title: {
                fontWeight: 600
            }
        };
    };
    /**
     * Closes the Notification Center when the user clicks outside of it +
     * Adds an overlay to block the rest of the UI when it's opened
     */
    NotificationCenter.prototype.componentDidUpdate = function () {
        if (this.props.open) {
            NotificationCenterOverlay_1.default.show();
            this.adjustHeight();
            document.addEventListener("click", this.handleDocumentClick);
        }
        else {
            NotificationCenterOverlay_1.default.hide();
            document.removeEventListener("click", this.handleDocumentClick);
        }
    };
    /**
     * Renders the Notification Center header
     *
     * @param {boolean} permitDeleteAll
     * @param {Map<number, NotificationConfig>} notificationConfigList
     * @returns {any}
     */
    NotificationCenter.prototype.renderHeader = function (notificationConfigList, permitDeleteAll) {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement(CardText_1.default, { style: styles.header },
            React.createElement("div", { style: styles.title }, l10n_1.default("notifications.header")),
            (permitDeleteAll && notificationConfigList.size > 1)
                ? React.createElement(FlatButton_1.default, { label: l10n_1.default("notifications.deleteAll"), onTouchTap: function () {
                        _this.handleDismissAll();
                    } })
                : ""));
    };
    /**
     * Renders all non-deleted notifications to show
     *
     * @param {Map<number, NotificationConfig>} notificationConfigList
     */
    NotificationCenter.prototype.renderNotifications = function (notificationConfigList) {
        var styles = this.getStyles();
        var content;
        /** If there is no Notification, an message is shown */
        if (notificationConfigList.size === 0) {
            content = this.renderEmptyMessage();
        }
        else {
            content =
                React.createElement("div", { ref: "container", style: styles.container }, Array.from(notificationConfigList)
                    .map(function (_a) {
                    var key = _a[0], notificationConfig = _a[1];
                    return (React.createElement(Notification_1.default, { key: key, config: notificationConfig }));
                }));
        }
        return content;
    };
    /**
     * Renders the message when the Notification Center is empty
     */
    NotificationCenter.prototype.renderEmptyMessage = function () {
        var styles = this.getStyles();
        return (React.createElement(CardText_1.default, { style: styles.message }, l10n_1.default("notifications.zeroNotifications")));
    };
    /**
     * Renders the Notification Center
     */
    NotificationCenter.prototype.render = function () {
        var styles = this.getStyles();
        var permitDeleteAll = true;
        var notificationConfigList = new Map();
        /** Computes a Map containing all notifications to show */
        this.props.notificationStateList
            .forEach(function (notificationState) {
            try {
                if (!notificationState.deleted && notificationState.dismissed) {
                    var notificationConfig = ConfigFactory_1.default.factory(notificationState);
                    if (!notificationConfig.cardOptions.hidden) {
                        /**
                         * Checks if there is a non-deletable Notification in the list,
                         * then it's forbidden to delete all Notifications at once
                         */
                        if (!notificationConfig.cardOptions.closable) {
                            permitDeleteAll = false;
                        }
                        notificationConfigList.set(notificationConfig.type, notificationConfig);
                    }
                }
            }
            catch (reason) {
                globalEvents.trigger("error.diy-editor", {
                    message: "Could not render Notification: " + reason
                });
            }
        });
        /** Notification Center is only rendered when opened */
        return (React.createElement("div", { style: styles.root, className: this.props.className, "data-test-id": "notification-center" },
            React.createElement("div", { style: styles.arrow }, String.fromCharCode(9650)),
            React.createElement(Card_1.default, { style: styles.wrapper },
                this.renderHeader(notificationConfigList, permitDeleteAll),
                this.renderNotifications(notificationConfigList))));
    };
    return NotificationCenter;
}(React.Component));
exports.default = NotificationCenter;


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDom = __webpack_require__(57);
var Overlay = (function (_super) {
    tslib_1.__extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = {
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "100%",
            height: "100%",
            opacity: 0,
            zIndex: diy.editor.getNewTopZIndex() - 2
        };
        return _this;
    }
    Overlay.prototype.render = function () {
        return React.createElement("div", { style: this.style });
    };
    return Overlay;
}(React.Component));
var OverlayApi = (function (_super) {
    tslib_1.__extends(OverlayApi, _super);
    function OverlayApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverlayApi.show = function () {
        document.body.appendChild(this.container);
        ReactDom.render(React.createElement(Overlay, null), this.container);
    };
    OverlayApi.hide = function () {
        ReactDom.unmountComponentAtNode(this.container);
    };
    return OverlayApi;
}(React.Component));
OverlayApi.container = document.createElement("div");
exports.default = OverlayApi;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var globalEvents = __webpack_require__(500);
var Api_1 = __webpack_require__(537);
var styles_1 = __webpack_require__(242);
var Avatar_1 = __webpack_require__(506);
var mwsColors = __webpack_require__(189);
var notifications_1 = __webpack_require__(580);
var notifications_none_1 = __webpack_require__(581);
var NotificationIcon = (function (_super) {
    tslib_1.__extends(NotificationIcon, _super);
    function NotificationIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            Api_1.default.schedule(function () {
                Api_1.default.toggleCenter();
            });
            /** Click Tracking */
            globalEvents.trigger("diy-editor-generic-sectionAccessed", {
                sectionCodeName: "notificationCenter"
            });
        };
        _this.state = {
            hover: false
        };
        return _this;
    }
    NotificationIcon.prototype.getStyles = function () {
        var styles = {
            root: {
                display: "block",
                marginTop: "-2px",
                marginRight: "10px",
                position: "relative"
            },
            icon: {
                color: mwsColors.mwsGrey500
            },
            counter: {
                height: "12px",
                width: "12px",
                color: styles_1.colors.white,
                backgroundColor: "red",
                borderRadius: "6px",
                textAlign: "center",
                lineHeight: "12px",
                fontSize: "12px",
                position: "absolute",
                bottom: "5px",
                right: "3px"
            }
        };
        if (this.props.active || this.state.hover) {
            styles.icon.color = styles_1.colors.blue500;
        }
        return styles;
    };
    NotificationIcon.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var enableHover = function () {
            _this.setState({
                hover: true
            });
        };
        var disableHover = function () {
            _this.setState({
                hover: false
            });
        };
        var bellIcon = React.createElement(notifications_1.default, null);
        if (!this.props.hasNotifications) {
            bellIcon = React.createElement(notifications_none_1.default, null);
        }
        return (React.createElement("a", { style: styles.root, title: l10n_1.default("notifications.iconText"), onClick: this.handleClick, onMouseEnter: enableHover, onMouseLeave: disableHover, "data-test-id": "notification-center-icon" },
            React.createElement(Avatar_1.default, { size: 35, icon: bellIcon, style: styles.icon, color: styles.icon.color, backgroundColor: "transparent" }),
            (this.props.counter > 0)
                ? React.createElement("div", { style: styles.counter }, this.props.counter)
                : ""));
    };
    return NotificationIcon;
}(React.Component));
exports.default = NotificationIcon;


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotifications = function SocialNotifications(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
  );
};
SocialNotifications = (0, _pure2.default)(SocialNotifications);
SocialNotifications.displayName = 'SocialNotifications';
SocialNotifications.muiName = 'SvgIcon';

exports.default = SocialNotifications;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsNone = function SocialNotificationsNone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z' })
  );
};
SocialNotificationsNone = (0, _pure2.default)(SocialNotificationsNone);
SocialNotificationsNone.displayName = 'SocialNotificationsNone';
SocialNotificationsNone.muiName = 'SvgIcon';

exports.default = SocialNotificationsNone;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var NotificationCenterObserver_1 = __webpack_require__(583);
var Type_1 = __webpack_require__(540);
var Severity_1 = __webpack_require__(541);
exports.default = {
    type: Type_1.default.EXTERNAL_WEBSITE_IMPORT_STARTED,
    testId: "external-website-import-started",
    trackingId: "ExternalWebsiteImportStartedNotification",
    content: l10n_1.default("migration.notification.init.text"),
    severity: Severity_1.default.HIGH,
    dismissAction: {
        testId: "skip-import",
        label: l10n_1.default("migration.notification.init.button.reject"),
        onClick: function () {
            if (typeof NotificationCenterObserver_1.notificationCenterObserver.dismissHandler === "function") {
                NotificationCenterObserver_1.notificationCenterObserver.dismissHandler();
            }
        }
    },
    mainAction: {
        testId: "start-import",
        label: l10n_1.default("migration.notification.init.button.start"),
        onClick: function () {
            if (typeof NotificationCenterObserver_1.notificationCenterObserver.actionHandler === "function") {
                NotificationCenterObserver_1.notificationCenterObserver.actionHandler();
            }
        }
    },
    bubbleOptions: {
        autoHide: false
    },
    cardOptions: {
        hidden: true
    }
};


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var websiteData = __webpack_require__(4);
var Api_1 = __webpack_require__(537);
var Type_1 = __webpack_require__(540);
var Status_1 = __webpack_require__(584);
var Backend_1 = __webpack_require__(586);
var DataStorage_1 = __webpack_require__(585);
var NotificationCenterObserver = (function () {
    function NotificationCenterObserver() {
    }
    NotificationCenterObserver.prototype.notify = function (data) {
        var _this = this;
        var lastNotificationBubbled = DataStorage_1.default.getLastNotificationBubbled();
        DataStorage_1.default.setLastNotificationBubbled(data.status);
        Api_1.default.schedule(function () {
            switch (data.status) {
                case Status_1.default.INITIAL:
                    _this.dismissHandler = function () {
                        Backend_1.default.skipExternalImport(websiteData.getId());
                    };
                    _this.actionHandler = data.actionHandler;
                    Api_1.default.pushOne({
                        type: Type_1.default.EXTERNAL_WEBSITE_IMPORT_STARTED,
                        dismissed: false
                    });
                    break;
                case Status_1.default.SKIPPED:
                    _this.actionHandler = data.actionHandler;
                    Api_1.default.pushOne({
                        type: Type_1.default.EXTERNAL_WEBSITE_IMPORT_SKIPPED,
                        dismissed: ((lastNotificationBubbled === data.status) &&
                            (Status_1.default.SKIPPED !== data.status))
                    });
                    break;
                case Status_1.default.SUCCESS:
                    _this.actionHandler = function () {
                        diy.editor.deeplinking.requestPath([
                            { label: 'siteadmin', params: 'pages' }
                        ]);
                    };
                    Api_1.default.pushOne({
                        type: Type_1.default.EXTERNAL_WEBSITE_IMPORT_FINISHED
                    });
                    Api_1.default.deleteOne(Type_1.default.EXTERNAL_WEBSITE_IMPORT_SKIPPED);
                    break;
                default:
                    break;
            }
        });
    };
    NotificationCenterObserver.prototype.remove = function () {
        Api_1.default.schedule(function () {
            Api_1.default.deleteOne(Type_1.default.EXTERNAL_WEBSITE_IMPORT_STARTED);
            Api_1.default.deleteOne(Type_1.default.EXTERNAL_WEBSITE_IMPORT_SKIPPED);
            Api_1.default.deleteOne(Type_1.default.EXTERNAL_WEBSITE_IMPORT_FINISHED);
        });
    };
    NotificationCenterObserver.prototype.getActionHandler = function () {
        return this.actionHandler;
    };
    return NotificationCenterObserver;
}());
exports.default = NotificationCenterObserver;
exports.notificationCenterObserver = new NotificationCenterObserver;


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var DataStorage_1 = __webpack_require__(585);
var Status = (function () {
    function Status() {
    }
    Status.prototype.getStatus = function (backendStatus) {
        switch (backendStatus) {
            case 'INITIAL':
                return Status.INITIAL;
            case 'RUNNING':
                if (DataStorage_1.default.getSecondsPassedFromMigrationStart() < 5 * 60) {
                    return Status.RUNNING;
                }
                else {
                    return Status.RUNNING_LONGER;
                }
            case 'RUNNING:TAKES_LONGER':
                return Status.RUNNING_LONGER;
            case 'RUNNING:TAKES_VERY_LONG':
                return Status.RUNNING_VERY_LONG;
            case 'ERROR':
                return Status.ERROR;
            case 'SUCCESS:MIGRATION_FINISHED':
                return Status.SUCCESS;
            case 'SKIPPED':
                return Status.SKIPPED;
            case 'SKIPPED:DISCLAIMER':
                return Status.SKIPPED_DISCLAIMER;
            case 'EXPIRED':
                return Status.EXPIRED;
            case 'UPGRADEABLE':
                return Status.UPGRADEABLE;
            default:
                return Status.UNAVAILABLE;
        }
    };
    return Status;
}());
/** possible statuses */
Status.INITIAL = 'INITIAL';
Status.EXPIRED = 'EXPIRED';
Status.SKIPPED = 'SKIPPED';
Status.SKIPPED_DISCLAIMER = 'SKIPPED:DISCLAIMER';
Status.RUNNING = 'RUNNING';
Status.RUNNING_LONGER = 'RUNNING:TAKES_LONGER';
Status.RUNNING_VERY_LONG = 'RUNNING:TAKES_VERY_LONG';
Status.ERROR = 'ERROR';
Status.SUCCESS = 'SUCCESS';
Status.UNAVAILABLE = 'UNAVAILABLE';
Status.UPGRADEABLE = 'UPGRADEABLE';
exports.default = Status;


/***/ },
/* 585 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
/** Using local storage to persist some data */
var DataStorage = (function () {
    function DataStorage() {
    }
    DataStorage.setMigrationStartTime = function () {
        localStorage.setItem('migrationStartTime', new Date().getTime().toString());
    };
    DataStorage.getSecondsPassedFromMigrationStart = function () {
        var startTime = localStorage.getItem('migrationStartTime');
        if (startTime !== null) {
            return Math.round((new Date().getTime() - new Date(parseInt(startTime, 10)).getTime()) / 1000);
        }
        return null;
    };
    DataStorage.getLastNotificationBubbled = function () {
        return localStorage.getItem('migrationLastStatusNotified');
    };
    DataStorage.setLastNotificationBubbled = function (status) {
        return localStorage.setItem('migrationLastStatusNotified', status);
    };
    DataStorage.setMigrationSuccessNotificationRead = function () {
        localStorage.setItem('migrationSuccessNotificationRead', "true");
    };
    DataStorage.getMigrationSuccessNotificationRead = function () {
        return localStorage.getItem('migrationSuccessNotificationRead');
    };
    DataStorage.setMigrationErrorShowed = function () {
        localStorage.setItem('migrationErrorShowed', "true");
    };
    DataStorage.hasMigrationErrorShowed = function () {
        return localStorage.getItem('migrationErrorShowed');
    };
    DataStorage.clearMigrationErrorShowed = function () {
        localStorage.removeItem('migrationErrorShowed');
    };
    DataStorage.clear = function () {
        localStorage.removeItem('migrationStartTime');
        localStorage.removeItem('migrationLastStatusNotified');
        localStorage.removeItem('migrationSuccessNotificationRead');
    };
    return DataStorage;
}());
exports.default = DataStorage;


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var Status_1 = __webpack_require__(584);
var ImportType = (function () {
    function ImportType() {
    }
    return ImportType;
}());
ImportType.WSC = 'WSC';
ImportType.WSB = 'WSB';
exports.ImportType = ImportType;
var Backend = (function () {
    function Backend() {
    }
    Backend.startExternalImport = function (websiteId) {
        return this.setExternalImportData(websiteId, {
            'status-code': Status_1.default.RUNNING
        });
    };
    Backend.skipExternalImport = function (websiteId) {
        return this.setExternalImportData(websiteId, {
            'status-code': Status_1.default.SKIPPED
        });
    };
    Backend.skipDisclaimer = function (websiteId) {
        return this.setExternalImportData(websiteId, {
            'status-code': Status_1.default.SKIPPED_DISCLAIMER
        });
    };
    Backend.getExternalImportData = function (websiteId) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/websites/' + websiteId + '/external-import',
                headers: { "Accept": "application/vnd.oneandone.diy.website.external-import+json" },
                type: 'GET',
                success: function (data) {
                    resolve(data);
                },
                error: function () {
                    reject('Request External Import GET Failed');
                }
            });
        });
    };
    Backend.setExternalImportData = function (websiteId, data) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/websites/' + websiteId + '/external-import',
                contentType: "application/vnd.oneandone.diy.website.external-import+json",
                type: 'POST',
                data: JSON.stringify(data),
                success: function () {
                    resolve(true);
                },
                error: function () {
                    reject('Request External Import POST Failed');
                }
            });
        });
    };
    return Backend;
}());
exports.default = Backend;


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var NotificationCenterObserver_1 = __webpack_require__(583);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.EXTERNAL_WEBSITE_IMPORT_SKIPPED,
    testId: "external-website-import-skipped",
    trackingId: "ExternalWebsiteImportSkippedNotification",
    content: l10n_1.default("migration.notification.later.text"),
    mainAction: {
        testId: "start-import",
        label: l10n_1.default("migration.notification.later.button"),
        onClick: function () {
            if (typeof NotificationCenterObserver_1.notificationCenterObserver.actionHandler === "function") {
                NotificationCenterObserver_1.notificationCenterObserver.actionHandler();
            }
        }
    },
    bubbleOptions: {
        closable: false
    },
    cardOptions: {
        closable: false
    }
};


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var check_circle_1 = __webpack_require__(486);
var NotificationCenterObserver_1 = __webpack_require__(583);
var Type_1 = __webpack_require__(540);
var Severity_1 = __webpack_require__(541);
exports.default = {
    type: Type_1.default.EXTERNAL_WEBSITE_IMPORT_FINISHED,
    testId: "external-website-import-finished",
    trackingId: "ExternalWebsiteImportFinishedNotification",
    content: l10n_1.default("migration.notification.success.text"),
    icon: check_circle_1.default,
    severity: Severity_1.default.HIGH,
    dismissAction: {
        label: l10n_1.default("migration.notification.success.button.reject"),
        onClick: function () {
            if (typeof NotificationCenterObserver_1.notificationCenterObserver.dismissHandler === "function") {
                NotificationCenterObserver_1.notificationCenterObserver.dismissHandler();
            }
        }
    },
    mainAction: {
        testId: "open-pages-manager",
        label: l10n_1.default("migration.notification.success.button.accept"),
        onClick: function () {
            if (typeof NotificationCenterObserver_1.notificationCenterObserver.actionHandler === "function") {
                NotificationCenterObserver_1.notificationCenterObserver.actionHandler();
            }
        }
    },
    bubbleOptions: {
        autoHide: false
    },
    cardOptions: {
        hidden: true
    }
};


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var l10n_1 = __webpack_require__(18);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.SECTIONS_ADD_GROUP,
    testId: "sectionsAddGroupNotification",
    trackingId: "SectionsAddGroupNotification",
    title: "",
    content: l10n_1.default("section.welcomeNotification.title"),
    mainAction: {
        testId: "tryIt",
        label: l10n_1.default("section.welcomeNotification.linkText"),
        onClick: function () {
            $('#cc-sa-item-sections').click();
        }
    }
};


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n_1 = __webpack_require__(18);
var explore_1 = __webpack_require__(553);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.RANKING_COACH,
    testId: "rankingCoach",
    trackingId: "RankingCoachNotification",
    title: l10n_1.default("rankingCoach.notification.title"),
    content: l10n_1.default("rankingCoach.notification.content"),
    icon: explore_1.default,
    mainAction: {
        testId: "rankingCoach-open",
        label: l10n_1.default("rankingCoach.notification.action"),
        onClick: function () {
            diy.editor.deeplinking.requestPath([
                { label: 'siteadmin', params: 'get-found' },
                { label: 'SAC.GetFound', params: 'get-found-seo' }
            ]);
        },
    },
};


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var l10n = __webpack_require__(18);
var DiyAviaryShutdownDialog_1 = __webpack_require__(592);
var Type_1 = __webpack_require__(540);
exports.default = {
    type: Type_1.default.AVIARY_SHUTDOWN,
    testId: 'aviary-shutdown',
    trackingId: 'AviaryShutdownNotification',
    content: l10n.getString('aviaryDialog.shutdown.notification.content'),
    mainAction: {
        testId: 'aviary-shutdown-open-notice',
        label: l10n.getString('aviaryDialog.shutdown.notification.more'),
        onClick: function () {
            DiyAviaryShutdownDialog_1.showDialog();
        }
    }
};


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var AviaryShutdownDialog_1 = __webpack_require__(593);
var diyLightTheme = __webpack_require__(241);
var dialogContainer;
var DiyShutdownDialog = (function (_super) {
    tslib_1.__extends(DiyShutdownDialog, _super);
    function DiyShutdownDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: _this.props.open
        };
        return _this;
    }
    DiyShutdownDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    DiyShutdownDialog.prototype.componentWillReceiveProps = function (props) {
        this.setState({
            open: props.open
        });
    };
    DiyShutdownDialog.prototype.render = function () {
        return (React.createElement(AviaryShutdownDialog_1.default, { open: this.state.open, onClose: this.onClose }));
    };
    return DiyShutdownDialog;
}(React.Component));
DiyShutdownDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.DiyShutdownDialog = DiyShutdownDialog;
function showDialog() {
    dialogContainer = document.createElement('div');
    ReactDOM.render(React.createElement(DiyShutdownDialog, { open: true }), dialogContainer);
    document.body.appendChild(dialogContainer);
}
exports.showDialog = showDialog;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n = __webpack_require__(18);
var features = __webpack_require__(25);
var websiteData = __webpack_require__(4);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var styles_1 = __webpack_require__(242);
var AviaryShutdownDialog = (function (_super) {
    tslib_1.__extends(AviaryShutdownDialog, _super);
    function AviaryShutdownDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            _this.props.onClose();
        };
        _this.getStyles = function () {
            return {
                paragraph: {
                    fontSize: 14,
                    margin: "0 0 16px 0",
                },
                lastParagraph: {
                    fontSize: 14,
                    margin: "0",
                },
                link: {
                    color: styles_1.colors.blue500
                }
            };
        };
        return _this;
    }
    AviaryShutdownDialog.prototype.render = function () {
        var styles = this.getStyles();
        var locale = websiteData.getLanguageCode()
            .toLowerCase().replace('_', '-');
        return (React.createElement(Dialog_1.default, { title: l10n.getString('aviaryDialog.shutdown.title'), open: this.props.open, modal: true, actions: [
                React.createElement(FlatButton_1.default, { label: l10n.getString('aviaryDialog.closeBtn'), secondary: true, onTouchTap: this.onClose, "data-test-id": "asdk-shutdown-close-btn" })
            ] },
            React.createElement("div", null,
                React.createElement("p", { style: styles.paragraph, dangerouslySetInnerHTML: {
                        __html: l10n.getString('aviaryDialog.shutdown.shutdownNotice')
                    } }),
                (features('cmsImagesAvailable')
                    || features('premiumImages')
                    || features('bigstock')
                    || features('123rf'))
                    ?
                        React.createElement("div", null,
                            React.createElement("p", { style: styles.paragraph, dangerouslySetInnerHTML: {
                                    __html: l10n.getString('aviaryDialog.shutdown.imageGalleryRecommendation')
                                } }),
                            React.createElement("p", { style: styles.paragraph },
                                React.createElement("img", { src: cc_.cdnServer + "s/img/cms/help/txtimg/" + locale + "/ac_image_image_tab.png", alt: "" })))
                    :
                        '',
                React.createElement("p", { style: styles.lastParagraph, dangerouslySetInnerHTML: {
                        __html: l10n.getString('aviaryDialog.shutdown.help').replace("{cpContactUrl}", "<a style=\"color:" + styles.link.color + "\" target=\"_blank\" href=" + websiteData.getCpContactUrl() + ">" + l10n.getString("aviaryDialog.shutdown.contactLink") + "</a>")
                    } }))));
    };
    return AviaryShutdownDialog;
}(React.Component));
exports.default = AviaryShutdownDialog;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(199);
var react_redux_1 = __webpack_require__(220);
var helper_1 = __webpack_require__(230);
var AdvancedView_1 = __webpack_require__(595);
var index_1 = __webpack_require__(499);
var serialization_1 = __webpack_require__(535);
var tracking_1 = __webpack_require__(501);
var Modul_1 = __webpack_require__(197);
function changeStylePreset(preset) {
    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.StyleChanged, preset.id.toString());
    return changeStyleOptions({ preset: preset });
}
function changeStyleRoundness(roundness) {
    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.StyleChanged, roundness.id.toString());
    return changeStyleOptions({ roundness: roundness });
}
function changeStyleExtras(extras) {
    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.StyleChanged, extras.id.toString());
    return changeStyleOptions({ extras: extras });
}
/**
 * Update styles with partial object
 */
function changeStyleOptions(style) {
    return function (dispatch, getState) {
        var newStyle = serialization_1.serializeStyleSettings(helper_1.objectOverride(getState().moduleSection.style, style));
        return dispatch(index_1.updatePayload({ style: newStyle }));
    };
}
function previewStylePreset(preset) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        previewStyleItem(state.moduleId, preset, state.availableStyles.presets, function (item) { return "section-style-preset-" + item.id; });
    };
}
function previewStyleRoundness(roundness) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        previewStyleItem(state.moduleId, roundness, state.availableStyles.roundness, function (item) { return "section-style-roundness-" + item.id; });
    };
}
function previewStyleExtras(extras) {
    return function (dispatch, getState) {
        var state = getState().moduleSection;
        previewStyleItem(state.moduleId, extras, state.availableStyles.extras, function (item) { return "section-style-extras-" + item.id; });
    };
}
function previewStyleItem(moduleId, item, allItems, cssClassSelector) {
    var allCssClasses = allItems.map(function (p) { return cssClassSelector(p); });
    var moduleEl = Modul_1.default.getInstance(moduleId).getModuleElement();
    var classList = moduleEl.get(0).classList;
    // IE11 doesn't support multiple parameters on classList.remove
    allCssClasses.forEach(function (c) { return classList.remove(c); });
    classList.add(cssClassSelector(item));
}
function mapStateToProps(state) {
    return {
        availableStyles: state.moduleSection.availableStyles,
        style: state.moduleSection.style
    };
}
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        onPresetSelect: changeStylePreset,
        onPresetPreview: previewStylePreset,
        onRoundnessSelect: changeStyleRoundness,
        onRoundnessPreview: previewStyleRoundness,
        onExtrasSelect: changeStyleExtras,
        onExtrasPreview: previewStyleExtras
    }, dispatch);
}
function getAdvancedViewComponent(store) {
    var ConnectedAdvancedView = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AdvancedView_1.AdvancedView);
    return ConnectedAdvancedView;
}
exports.getAdvancedViewComponent = getAdvancedViewComponent;


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n = __webpack_require__(18);
var ToolbarGroup_1 = __webpack_require__(596);
var ToolbarContent_1 = __webpack_require__(597);
var Dropdown_1 = __webpack_require__(531);
var SelectableList_1 = __webpack_require__(598);
var layers_1 = __webpack_require__(600);
var rounded_corner_1 = __webpack_require__(601);
var photo_filter_1 = __webpack_require__(602);
var AdvancedView = (function (_super) {
    tslib_1.__extends(AdvancedView, _super);
    function AdvancedView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdvancedView.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement(ToolbarContent_1.ToolbarContent, null,
            React.createElement(ToolbarGroup_1.ToolbarGroup, null,
                React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.styleSettings.label'), Icon: React.createElement(layers_1.default, null), layerStyle: {
                        width: 250
                    }, dataTestId: "section-style" },
                    React.createElement(SelectableList_1.SelectableList, { items: this.props.availableStyles.presets, selectedItem: this.props.style.preset, onItemSelect: this.props.onPresetSelect, onPreviewedItemChange: this.props.onPresetPreview, title: l10n.getString('section.stylePresets.title'), titleStyle: styles.title, dataTestId: "section-presets", style: styles.list })),
                React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.roundnessSettings.label'), Icon: React.createElement(rounded_corner_1.default, null), layerStyle: {
                        width: 250
                    }, dataTestId: "section-style-roundness" },
                    React.createElement(SelectableList_1.SelectableList, { items: this.props.availableStyles.roundness, selectedItem: this.props.style.roundness, onItemSelect: this.props.onRoundnessSelect, onPreviewedItemChange: this.props.onRoundnessPreview, title: l10n.getString('section.roundnessSettings.title'), titleStyle: styles.title, dataTestId: "section-cornersets", style: styles.list })),
                React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.extrasSettings.label'), Icon: React.createElement(photo_filter_1.default, null), layerStyle: {
                        width: 250
                    }, dataTestId: "section-style-decoration" },
                    React.createElement(SelectableList_1.SelectableList, { items: this.props.availableStyles.extras, selectedItem: this.props.style.extras, onItemSelect: this.props.onExtrasSelect, onPreviewedItemChange: this.props.onExtrasPreview, title: l10n.getString('section.extrasSettings.title'), titleStyle: styles.title, dataTestId: "section-extras", style: styles.list })))));
    };
    AdvancedView.prototype.getStyles = function () {
        return {
            title: {
                fontFamily: "open sans",
                fontSize: '14px',
                lineHeight: '14px',
                margin: 10,
                color: '#666'
            },
            list: {
                paddingTop: 0
            }
        };
    };
    return AdvancedView;
}(React.Component));
exports.AdvancedView = AdvancedView;


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var ToolbarGroup = (function (_super) {
    tslib_1.__extends(ToolbarGroup, _super);
    function ToolbarGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarGroup.prototype.render = function () {
        return (React.createElement("div", { style: autoprefixer_1.autoprefixer({
                display: 'flex',
                alignItems: 'center'
            }) }, this.props.children));
    };
    return ToolbarGroup;
}(React.Component));
exports.ToolbarGroup = ToolbarGroup;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var ToolbarContent = (function (_super) {
    tslib_1.__extends(ToolbarContent, _super);
    function ToolbarContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarContent.prototype.render = function () {
        return (React.createElement("div", { style: autoprefixer_1.autoprefixer({
                padding: "4px 11px",
                display: 'flex'
            }) }, this.props.children));
    };
    return ToolbarContent;
}(React.Component));
exports.ToolbarContent = ToolbarContent;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var List_1 = __webpack_require__(428);
var ListItem_1 = __webpack_require__(409);
var done_1 = __webpack_require__(599);
var SelectableList = (function (_super) {
    tslib_1.__extends(SelectableList, _super);
    function SelectableList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            activeItem: _this.props.selectedItem,
            hoveredItem: null
        };
        return _this;
    }
    SelectableList.prototype.componentWillReceiveProps = function (props) {
        if (props.selectedItem !== this.state.activeItem) {
            this.setState({
                activeItem: props.selectedItem
            });
        }
    };
    SelectableList.prototype.componentDidUpdate = function (prevProps, prevState) {
        var previewedItem = this.getPreviewedItem(this.state);
        if (previewedItem !== this.getPreviewedItem(prevState)) {
            if (this.props.onPreviewedItemChange) {
                this.props.onPreviewedItemChange(previewedItem);
            }
        }
    };
    SelectableList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.props.title ?
                React.createElement("div", { style: this.props.titleStyle },
                    " ",
                    this.props.title)
                : null,
            React.createElement(List_1.default, { style: this.props.style, "data-test-id": this.props.dataTestId }, this.props.items.map(function (i) { return _this.renderItem(i); }))));
    };
    SelectableList.prototype.renderItem = function (i) {
        var _this = this;
        var baseItemProps = {
            onClick: function () { return _this.onItemClick(i); },
            onMouseEnter: function () { return _this.onItemHover(i); },
            onMouseLeave: function () { return _this.onItemHoverOut(i); },
            style: this.getItemStyle(i)
        };
        if (this.props.renderItem) {
            var listItem = this.props.renderItem(i);
            return React.cloneElement(listItem, baseItemProps);
        }
        var dataTestId = this.props.dataTestId ? this.props.dataTestId + '-' + i.id : void 0;
        return (React.createElement(ListItem_1.default, tslib_1.__assign({ key: i.id, primaryText: i.label, insetChildren: true, innerDivStyle: { paddingLeft: 56 }, leftIcon: this.props.selectedItem === i ? React.createElement(done_1.default, null) : null, "data-test-id": dataTestId }, baseItemProps)));
    };
    SelectableList.prototype.onItemClick = function (item) {
        this.setState({ activeItem: item });
        if (this.props.onItemSelect) {
            this.props.onItemSelect(item);
        }
    };
    SelectableList.prototype.getPreviewedItem = function (state) {
        return state.hoveredItem || state.activeItem;
    };
    SelectableList.prototype.onItemHover = function (item) {
        this.setState({ hoveredItem: item });
    };
    SelectableList.prototype.onItemHoverOut = function (item) {
        if (this.state.hoveredItem !== item) {
            return;
        }
        this.setState({ hoveredItem: null });
    };
    SelectableList.prototype.getItemStyle = function (item) {
        var activeStyles = {
            color: "#16191d",
            backgroundColor: "#ced0d6"
        };
        var style = {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            color: 'rgba(61, 73, 89, 1)'
        };
        if (item === this.state.activeItem) {
            Object.assign(style, activeStyles);
        }
        return style;
    };
    return SelectableList;
}(React.Component));
exports.SelectableList = SelectableList;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDone = function ActionDone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
  );
};
ActionDone = (0, _pure2.default)(ActionDone);
ActionDone.displayName = 'ActionDone';
ActionDone.muiName = 'SvgIcon';

exports.default = ActionDone;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLayers = function MapsLayers(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
  );
};
MapsLayers = (0, _pure2.default)(MapsLayers);
MapsLayers.displayName = 'MapsLayers';
MapsLayers.muiName = 'SvgIcon';

exports.default = MapsLayers;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRoundedCorner = function ActionRoundedCorner(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z' })
  );
};
ActionRoundedCorner = (0, _pure2.default)(ActionRoundedCorner);
ActionRoundedCorner.displayName = 'ActionRoundedCorner';
ActionRoundedCorner.muiName = 'SvgIcon';

exports.default = ActionRoundedCorner;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoFilter = function ImagePhotoFilter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z' })
  );
};
ImagePhotoFilter = (0, _pure2.default)(ImagePhotoFilter);
ImagePhotoFilter.displayName = 'ImagePhotoFilter';
ImagePhotoFilter.muiName = 'SvgIcon';

exports.default = ImagePhotoFilter;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(199);
var react_redux_1 = __webpack_require__(220);
var EditView_1 = __webpack_require__(604);
var serialization_1 = __webpack_require__(535);
var index_1 = __webpack_require__(499);
var tracking_1 = __webpack_require__(501);
var index_2 = __webpack_require__(528);
var index_3 = __webpack_require__(499);
function changeLayout(layoutName) {
    return function (dispatch, getState) {
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.LayoutChanged, layoutName);
        dispatch(index_1.updatePayload({ layout: layoutName }));
    };
}
exports.changeLayout = changeLayout;
function changeFullWidth(fullWidth) {
    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.FullWidthChanged, fullWidth ? "On" : "Off");
    return index_1.updatePayload({
        fullWidth: fullWidth ? 1 : 0
    });
}
function changeToggles(toggles) {
    tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.ToggleContent);
    return index_1.updatePayload({
        toggles: toggles
    });
}
function changeBackgroundSettings(background) {
    var newBackground = serialization_1.serializeBackgroundSettings(background);
    return index_1.updatePayload({ background: newBackground });
}
// ======================
// CONNECT REACT TO REDUX
// ======================
function mapStateToProps(state) {
    var ownState = state.moduleSection;
    var containerState = state.moduleSectionContainer;
    return {
        toggles: ownState.toggles,
        fullWidth: ownState.fullWidth,
        isFullWidthAvailable: ownState.isFullWidthAvailable,
        availableLayouts: ownState.availableLayouts,
        layout: ownState.layout,
        background: ownState.background,
        manageGroupsActive: ownState.manageGroupsActive,
        isManageGroupsAvailable: ownState.configurableGroups.length > 0,
        isAddGroupAvailable: index_1.supportsAddGroup(ownState),
        canAddGroup: ownState.quantity.current < ownState.quantity.max && !index_1.isModuleLimitReached(),
        canDeleteGroup: ownState.quantity.current > ownState.quantity.min,
        configurableGroups: containerState.configurableGroups,
        groupBackgroundMap: containerState.backgroundSettings,
        configurableGroupIds: ownState.configurableGroups,
        elementsMenuVisible: ownState.elementsMenuVisible,
        backgroundMenuVisible: ownState.backgroundMenuVisible
    };
}
;
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        onChangeLayout: changeLayout,
        onChangeFullWidth: changeFullWidth,
        onChangeToggles: changeToggles,
        onBackgroundChange: changeBackgroundSettings,
        onBackgroundImageChange: index_1.changeBackgroundImage,
        onManageGroupsToggle: index_1.toggleManageGroups,
        onAddGroup: index_1.addGroupAction,
        onChangeGroupBackgroundImage: index_2.changeBackgroundImage,
        onChangeGroupBackground: index_2.changeBackgroundSettings,
        onElementsMenuToggle: index_3.toggleElementsMenu,
        onBackgroundMenuToggle: index_3.toggleBackgroundMenu,
        onEditImageClicked: index_1.openAviarySection,
        onSelectImageClicked: function () { return index_3.toggleBackgroundMenu({ visible: false }); }
    }, dispatch);
}
function getEditViewComponent(store) {
    var ConnectedEditView = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EditView_1.default);
    return ConnectedEditView;
}
exports.getEditViewComponent = getEditViewComponent;


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var Dropdown_1 = __webpack_require__(531);
var Divider_1 = __webpack_require__(605);
var ToolbarGroup_1 = __webpack_require__(596);
var ToolbarContent_1 = __webpack_require__(597);
var LayoutRotate_1 = __webpack_require__(606);
var TogglesView_1 = __webpack_require__(608);
var FullWidthView_1 = __webpack_require__(609);
var BackgroundSelectorView_1 = __webpack_require__(502);
var l10n = __webpack_require__(18);
var features = __webpack_require__(25);
var autoprefixer_1 = __webpack_require__(438);
var visibility_1 = __webpack_require__(612);
var photo_size_select_actual_1 = __webpack_require__(613);
var view_module_1 = __webpack_require__(614);
var clear_1 = __webpack_require__(496);
var add_box_1 = __webpack_require__(615);
var aspect_ratio_1 = __webpack_require__(616);
var palette_1 = __webpack_require__(521);
var tracking_1 = __webpack_require__(501);
var Messages_1 = __webpack_require__(617);
var ConnectedAviary_1 = __webpack_require__(619);
var EditView = (function (_super) {
    tslib_1.__extends(EditView, _super);
    function EditView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createChangeGroupBgImgHandler = function (moduleId) { return function (imageId, imageType, successCallback, errorCallback) {
            _this.props.onChangeGroupBackgroundImage(moduleId, imageId, imageType, successCallback, errorCallback);
        }; };
        _this.createChangeGroupBgHandler = function (moduleId) { return function (background) {
            _this.props.onChangeGroupBackground(moduleId, background);
        }; };
        return _this;
    }
    EditView.prototype.render = function () {
        var _this = this;
        var isManageGroupsActive = this.props.manageGroupsActive;
        var hasOneConfigurableGroup = !this.props.isAddGroupAvailable && this.props.isManageGroupsAvailable;
        var onlyColor = false;
        if (hasOneConfigurableGroup) {
            var configurables = this.props.configurableGroups;
            var configurable = configurables[this.props.configurableGroupIds[0]];
            onlyColor = configurable.color && !configurable.image && !configurable.video;
        }
        var groupBackground;
        if (hasOneConfigurableGroup) {
            groupBackground = this.props.groupBackgroundMap[this.props.configurableGroupIds[0]];
        }
        return (React.createElement("div", null,
            React.createElement(ToolbarContent_1.ToolbarContent, null,
                React.createElement(ToolbarGroup_1.ToolbarGroup, null,
                    React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.contentToggles.label'), Icon: React.createElement(visibility_1.default, null), disabled: isManageGroupsActive, open: this.props.elementsMenuVisible, dataTestId: "section-toggle-content", layerStyle: {
                            marginTop: 7,
                            padding: 16,
                            maxWidth: 300
                        }, onClose: function () {
                            _this.props.onElementsMenuToggle({ visible: false });
                        }, onOpen: function () {
                            _this.props.onElementsMenuToggle({ visible: true });
                        } },
                        React.createElement(TogglesView_1.default, { onToggleSwitch: this.props.onChangeToggles, toggles: this.props.toggles })),
                    React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.backgroundSettings.label'), Icon: React.createElement(photo_size_select_actual_1.default, null), open: this.props.backgroundMenuVisible, disabled: isManageGroupsActive, layerStyle: {
                            marginTop: 7,
                            padding: 0,
                            minWidth: 240
                        }, onClose: function () {
                            _this.props.onBackgroundMenuToggle({ visible: false });
                        }, onOpen: function () {
                            _this.props.onBackgroundMenuToggle({ visible: true });
                        }, dataTestId: "section-change-background" },
                        React.createElement(BackgroundSelectorView_1.default, { background: this.props.background, onChange: this.props.onBackgroundChange, onImageChange: this.props.onBackgroundImageChange, onEditImageClicked: function () { return _this.onEditImageClicked(); }, onSelectImageClicked: this.props.onSelectImageClicked, onColorClicked: tracking_1.trackBackgroundColorClicked, onTabClicked: tracking_1.trackBackgroundTabClicked, parallaxAvailable: true })),
                    !this.props.isAddGroupAvailable &&
                        !features('sectionGroups') &&
                        this.props.isManageGroupsAvailable ?
                        React.createElement(IconTextButton_1.default, { style: { marginRight: 12 }, text: l10n.getString('section.actionBar.buttons.manageGroups.label'), Icon: isManageGroupsActive ? React.createElement(clear_1.default, null) : React.createElement(view_module_1.default, null), isPressed: isManageGroupsActive, onTouchTap: function () { return _this.props.onManageGroupsToggle(!_this.props.manageGroupsActive); }, useAlternativeColors: true, dataTestId: "section-manage-groups-button" })
                        : null,
                    features('sectionGroups') && hasOneConfigurableGroup ?
                        React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.overlayColor.label'), Icon: React.createElement(palette_1.default, null), layerStyle: {
                                marginTop: 7,
                                padding: 0,
                                minWidth: 240
                            }, dataTestId: "section-change-group-background" },
                            React.createElement(BackgroundSelectorView_1.default, { onlyColor: onlyColor, onChange: this.createChangeGroupBgHandler(this.props.configurableGroupIds[0]), onImageChange: this.createChangeGroupBgImgHandler(this.props.configurableGroupIds[0]), onEditImageClicked: this.props.onEditImageClicked, onSelectImageClicked: this.props.onSelectImageClicked, background: groupBackground, onColorClicked: this.props.onGroupColorClicked, onTabClicked: this.props.onGroupTabClicked, parallaxAvailable: false }))
                        : null,
                    React.createElement(Divider_1.Divider, null),
                    React.createElement(LayoutRotate_1.LayoutRotate, { activeLayout: this.props.layout, availableLayouts: this.props.availableLayouts, disabled: isManageGroupsActive, onChange: function (layout) { return _this.props.onChangeLayout(layout); }, dataTestId: "section-change-layout-button" })),
                this.props.isFullWidthAvailable ?
                    React.createElement(ToolbarGroup_1.ToolbarGroup, null,
                        React.createElement(Divider_1.Divider, null),
                        React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.actionBar.buttons.fullWidth.label'), Icon: React.createElement(aspect_ratio_1.default, null), buttonStyle: autoprefixer_1.autoprefixer({ flexBasis: 0 }), layerStyle: {
                                marginTop: 7,
                                padding: 8,
                                maxWidth: 300
                            }, disabled: isManageGroupsActive, dataTestId: "section-full-width" },
                            React.createElement(FullWidthView_1.default, { onToggleSwitch: this.props.onChangeFullWidth, isToggled: this.props.fullWidth }))) : null,
                this.props.isAddGroupAvailable ?
                    React.createElement(ToolbarGroup_1.ToolbarGroup, null,
                        React.createElement(Divider_1.Divider, null),
                        React.createElement(IconTextButton_1.default, { style: { marginRight: 12 }, text: l10n.getString('section.actionBar.buttons.addGroup.label'), Icon: React.createElement(add_box_1.default, null), onTouchTap: function () { return _this.props.onAddGroup(); }, useAlternativeColors: true, dataTestId: "section-add-group-button", isDisabled: !this.props.canAddGroup })) : null),
            React.createElement(Messages_1.Messages, { showAddGroup: this.props.isAddGroupAvailable && !this.props.canAddGroup }),
            React.createElement(ConnectedAviary_1.ConnectedAviary, null)));
    };
    EditView.prototype.onEditImageClicked = function () {
        tracking_1.trackBackgroundImageEdited();
        this.props.onEditImageClicked();
    };
    return EditView;
}(React.Component));
exports.default = EditView;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Divider = (function (_super) {
    tslib_1.__extends(Divider, _super);
    function Divider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Divider.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: 1,
                height: 40,
                backgroundColor: '#d9d9d9',
                margin: '4px 12px 4px 0'
            } }));
    };
    return Divider;
}(React.Component));
exports.Divider = Divider;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var l10n = __webpack_require__(18);
var view_quilt_1 = __webpack_require__(607);
var LayoutRotate = (function (_super) {
    tslib_1.__extends(LayoutRotate, _super);
    function LayoutRotate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutRotate.prototype.render = function () {
        var _this = this;
        return (React.createElement(IconTextButton_1.default, { style: { marginRight: 12 }, text: this.getRotateText(), Icon: React.createElement(view_quilt_1.default, null), onTouchTap: function () { return _this.props.onChange(_this.getNextLayoutIndex()); }, isDisabled: this.props.disabled, useAlternativeColors: true, dataTestId: this.props.dataTestId }));
    };
    LayoutRotate.prototype.getNextLayoutIndex = function () {
        var index = this.props.availableLayouts.indexOf(this.props.activeLayout);
        if (index < 0) {
            return null;
        }
        return this.props.availableLayouts[(index + 1) % this.props.availableLayouts.length];
    };
    LayoutRotate.prototype.getRotateText = function () {
        var _this = this;
        return l10n.getString('section.actionBar.buttons.layout.label')
            .split(/(\{[^}]+\})/)
            .map(function (part, i) {
            if (part === '{currentLayoutNumber}') {
                return React.createElement("span", { key: i, style: {
                        display: 'inline-block',
                        width: '15px',
                        textAlign: 'center'
                    }, "data-test-id": "section-current-layout-number" }, _this.props.availableLayouts.findIndex(function (layoutName) { return layoutName === _this.props.activeLayout; }) + 1);
            }
            if (part === '{totalNumberOfLayouts}') {
                return React.createElement("span", { key: i, style: {
                        display: 'inline-block',
                        minWidth: '15px'
                    }, "data-test-id": "section-total-layout-number" }, _this.props.availableLayouts.length);
            }
            return part;
        });
    };
    return LayoutRotate;
}(React.Component));
exports.LayoutRotate = LayoutRotate;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewQuilt = function ActionViewQuilt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
  );
};
ActionViewQuilt = (0, _pure2.default)(ActionViewQuilt);
ActionViewQuilt.displayName = 'ActionViewQuilt';
ActionViewQuilt.muiName = 'SvgIcon';

exports.default = ActionViewQuilt;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Toggle_1 = __webpack_require__(513);
var autoprefixer_1 = __webpack_require__(438);
var TogglesView = (function (_super) {
    tslib_1.__extends(TogglesView, _super);
    function TogglesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TogglesView.prototype.renderGroupToggles = function () {
        var _this = this;
        return this.props.toggles.map(function (group, groupIndex) {
            var style = autoprefixer_1.autoprefixer({
                display: 'flex',
                flexDirection: 'column'
            });
            var isLastGroup = groupIndex === (_this.props.toggles.length - 1);
            if (!isLastGroup) {
                Object.assign(style, {
                    borderBottom: '1px dotted #ccc',
                    marginBottom: 20
                });
            }
            return React.createElement("div", { style: style, key: 'toggle-group-' + groupIndex },
                React.createElement("div", { style: {
                        fontFamily: "open sans",
                        fontSize: '14px',
                        lineHeight: '14px',
                        paddingBottom: '10px',
                        color: '#666'
                    } }, group.groupName),
                group.toggles.map(function (toggleItem, toggleIndex) {
                    var isLastToggleInGroup = toggleIndex === (group.toggles.length - 1);
                    return React.createElement(Toggle_1.default, { label: toggleItem.label, toggled: toggleItem.toggled, style: autoprefixer_1.autoprefixer({
                            marginBottom: isLastToggleInGroup && isLastGroup ? 0 : 10,
                            display: 'block',
                            width: 'auto',
                            flexGrow: 1
                        }), key: 'toggle-item-' + toggleItem.id, onToggle: function () {
                            var groupToggles = Object.assign({}, _this.props.toggles);
                            groupToggles[groupIndex].toggles[toggleIndex].toggled = !toggleItem.toggled;
                            _this.props.onToggleSwitch(groupToggles);
                        }, labelStyle: {
                            marginRight: 30,
                            width: 'calc(100% - 76px)'
                            /* 46px the width of the toggle button + 30px the label right margin*/
                        }, "data-test-id": "section-toggle-" + toggleItem.id });
                }));
        });
    };
    TogglesView.prototype.render = function () {
        return React.createElement("div", null, this.renderGroupToggles());
    };
    return TogglesView;
}(React.Component));
exports.default = TogglesView;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var l10n = __webpack_require__(18);
var crop_square_1 = __webpack_require__(610);
var crop_landscape_1 = __webpack_require__(611);
var FullWidthView = (function (_super) {
    tslib_1.__extends(FullWidthView, _super);
    function FullWidthView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullWidthView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { style: {
                    fontFamily: "open sans",
                    fontSize: '14px',
                    lineHeight: '14px',
                    paddingBottom: 10,
                    color: '#666'
                } }, l10n.getString('section.fullWidth.title')),
            React.createElement(IconTextButton_1.default, { text: l10n.getString('section.fullWidth.buttons.normal.label'), Icon: React.createElement(crop_square_1.default, null), style: { marginRight: 3 }, onTouchTap: function () { return _this.props.onToggleSwitch(false); }, useAlternativeColors: true, isPressed: this.props.isToggled === false, dataTestId: "section-normal-width-option" }),
            React.createElement(IconTextButton_1.default, { text: l10n.getString('section.fullWidth.buttons.fullWidth.label'), Icon: React.createElement(crop_landscape_1.default, null), onTouchTap: function () { return _this.props.onToggleSwitch(true); }, useAlternativeColors: true, isPressed: this.props.isToggled === true, dataTestId: "section-full-width-option" })));
    };
    return FullWidthView;
}(React.Component));
exports.default = FullWidthView;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropSquare = function ImageCropSquare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
  );
};
ImageCropSquare = (0, _pure2.default)(ImageCropSquare);
ImageCropSquare.displayName = 'ImageCropSquare';
ImageCropSquare.muiName = 'SvgIcon';

exports.default = ImageCropSquare;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropLandscape = function ImageCropLandscape(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
  );
};
ImageCropLandscape = (0, _pure2.default)(ImageCropLandscape);
ImageCropLandscape.displayName = 'ImageCropLandscape';
ImageCropLandscape.muiName = 'SvgIcon';

exports.default = ImageCropLandscape;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVisibility = function ActionVisibility(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ActionVisibility = (0, _pure2.default)(ActionVisibility);
ActionVisibility.displayName = 'ActionVisibility';
ActionVisibility.muiName = 'SvgIcon';

exports.default = ActionVisibility;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoSizeSelectActual = function ImagePhotoSizeSelectActual(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z' })
  );
};
ImagePhotoSizeSelectActual = (0, _pure2.default)(ImagePhotoSizeSelectActual);
ImagePhotoSizeSelectActual.displayName = 'ImagePhotoSizeSelectActual';
ImagePhotoSizeSelectActual.muiName = 'SvgIcon';

exports.default = ImagePhotoSizeSelectActual;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewModule = function ActionViewModule(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
  );
};
ActionViewModule = (0, _pure2.default)(ActionViewModule);
ActionViewModule.displayName = 'ActionViewModule';
ActionViewModule.muiName = 'SvgIcon';

exports.default = ActionViewModule;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddBox = function ContentAddBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
  );
};
ContentAddBox = (0, _pure2.default)(ContentAddBox);
ContentAddBox.displayName = 'ContentAddBox';
ContentAddBox.muiName = 'SvgIcon';

exports.default = ContentAddBox;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAspectRatio = function ActionAspectRatio(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
  );
};
ActionAspectRatio = (0, _pure2.default)(ActionAspectRatio);
ActionAspectRatio.displayName = 'ActionAspectRatio';
ActionAspectRatio.muiName = 'SvgIcon';

exports.default = ActionAspectRatio;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Warning_1 = __webpack_require__(618);
var l10n = __webpack_require__(18);
var index_1 = __webpack_require__(499);
var Messages = (function (_super) {
    tslib_1.__extends(Messages, _super);
    function Messages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Messages.prototype.render = function () {
        switch (true) {
            case this.props.showLimit || index_1.isModuleLimitReached():
                return (React.createElement(Warning_1.default, { isError: true, text: l10n.getString('section.actionBar.warnings.maxAmountModulesPerPage') }));
            case this.props.showAddGroup:
                return (React.createElement(Warning_1.default, { text: l10n.getString('section.actionBar.warnings.addGroup') }));
            default:
                return null;
        }
    };
    return Messages;
}(React.Component));
exports.Messages = Messages;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Paper_1 = __webpack_require__(391);
var styles_1 = __webpack_require__(242);
var autoprefixer_1 = __webpack_require__(438);
var warning_1 = __webpack_require__(544);
var Warning = (function (_super) {
    tslib_1.__extends(Warning, _super);
    function Warning() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Warning.prototype.render = function () {
        var style = this.getStyle();
        return (React.createElement(Paper_1.default, { style: style.root },
            React.createElement(warning_1.default, { style: style.warnIcon }),
            this.props.text));
    };
    Warning.prototype.getStyle = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                // TODO use color from theme pallete
                backgroundColor: this.props.isError ? styles_1.colors.red100 : styles_1.colors.blue50,
                padding: 12,
                fontSize: 12,
                opacity: 0.54,
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                marginTop: 4
            }),
            warnIcon: {
                height: 16,
                marginRight: 10
            }
        };
    };
    return Warning;
}(React.Component));
exports.default = Warning;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(199);
var react_redux_1 = __webpack_require__(220);
var Aviary_1 = __webpack_require__(620);
var index_1 = __webpack_require__(499);
var index_2 = __webpack_require__(528);
var Modul_1 = __webpack_require__(197);
function saveBackgroundImage(imageDataUrl) {
    return function (dispatch, getState) {
        var aviaryOptions = getState().moduleSection.aviaryOptions;
        if (Modul_1.default.getInstance(aviaryOptions.moduleId).getModuleType() === Modul_1.ModuleType.SECTION) {
            dispatch(index_1.saveBackgroundImage(imageDataUrl));
        }
        else {
            dispatch(index_2.saveBackgroundImage(imageDataUrl));
        }
    };
}
function mapStateToProps(state) {
    var ownState = state.moduleSection;
    return {
        open: ownState.aviaryOpen,
        options: ownState.aviaryOptions,
    };
}
;
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        onAviaryClose: function () { return index_1.closeAviary({}); },
        onAviarySave: saveBackgroundImage
    }, dispatch);
}
exports.ConnectedAviary = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Aviary_1.Aviary);


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var DiyAviaryEditorDialog_1 = __webpack_require__(621);
var Aviary = (function (_super) {
    tslib_1.__extends(Aviary, _super);
    function Aviary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Aviary.prototype.render = function () {
        var _this = this;
        if (!this.props.open) {
            return null;
        }
        var sourceImageUrl = this.props.options.transformedImageUrl ?
            this.props.options.transformedImageUrl :
            this.props.options.origImageUrl;
        var mediaType = this.props.options.imageMediaType;
        return (React.createElement(DiyAviaryEditorDialog_1.default, { imageUrl: sourceImageUrl, resultFileFormat: (mediaType === 'jpg' || mediaType === 'jpeg') ? 'jpg' : 'png', originalImageUrl: this.props.options.origImageUrl, onClose: function () { return _this.onAviaryClose(); }, onSave: function (data) { return _this.onAviarySave(data.imageDataUrl); } }));
    };
    Aviary.prototype.onAviaryClose = function () {
        this.props.onAviaryClose();
    };
    Aviary.prototype.onAviarySave = function (imageDataUrl) {
        this.props.onAviarySave(imageDataUrl);
    };
    return Aviary;
}(React.Component));
exports.Aviary = Aviary;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n = __webpack_require__(18);
var features = __webpack_require__(25);
var globalEvents = __webpack_require__(500);
var help = __webpack_require__(622);
var websiteData = __webpack_require__(4);
var AviaryShutdownDialog_1 = __webpack_require__(593);
var AviaryEditorDialog_1 = __webpack_require__(623);
var AviaryEditor_1 = __webpack_require__(624);
var IframeImageEditorDialog_1 = __webpack_require__(627);
var DiyEditorDialog = (function (_super) {
    tslib_1.__extends(DiyEditorDialog, _super);
    function DiyEditorDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHelp = function () {
            help.openTopic('aviary_edit_images_overview');
        };
        return _this;
    }
    DiyEditorDialog.prototype.componentDidMount = function () {
        //log Aviary open action in Adobe Catalyst
        globalEvents.trigger("diy-tracking-aviary-open");
    };
    DiyEditorDialog.prototype.render = function () {
        var tools = AviaryEditor_1.DefaultAviaryTools;
        var aviaryConfigOverride = Object.assign({
            language: websiteData.getLanguage(),
            tools: tools,
        }, this.props.aviaryConfigOverride);
        var apiAuthenticationData = features.getPayload('aviary').apiAuthenticationData;
        var premiumPartnerAuthData = null;
        if (apiAuthenticationData.isPremiumPartner) {
            premiumPartnerAuthData = {
                salt: apiAuthenticationData.salt,
                timestamp: apiAuthenticationData.timestamp,
                signature: apiAuthenticationData.signature,
                encryptionMethod: apiAuthenticationData.encryptionMethod,
            };
        }
        if (features('iframedImageEditor')) {
            return (React.createElement(IframeImageEditorDialog_1.default, { open: true, texts: l10n.getMessages('aviaryDialog'), onClose: this.props.onClose, onSave: this.props.onSave, imageUrl: this.props.imageUrl, originalImageUrl: this.props.originalImageUrl }));
        }
        else if (features('aviaryShutdown')) {
            return (React.createElement(AviaryShutdownDialog_1.default, { open: true, onClose: this.props.onClose }));
        }
        else {
            return (React.createElement(AviaryEditorDialog_1.default, tslib_1.__assign({ apiKey: apiAuthenticationData.apiKey, premiumPartnerAuthData: premiumPartnerAuthData, aviaryTranslationsOverride: l10n.getMessages('aviary'), aviaryConfigOverride: aviaryConfigOverride, 
                // we don't have currently type safe translations so should cast to any
                texts: l10n.getMessages('aviaryDialog'), onHelp: this.onHelp }, this.props)));
        }
    };
    return DiyEditorDialog;
}(React.Component));
exports.default = DiyEditorDialog;


/***/ },
/* 622 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function openTopic(helpTopicId) {
    cms.help.GuidedAssistant.getInstance()._openHelpTopic(helpTopicId);
}
exports.openTopic = openTopic;


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var CircularProgress_1 = __webpack_require__(382);
var help_outline_1 = __webpack_require__(450);
var IconButton_1 = __webpack_require__(420);
var Delayed_1 = __webpack_require__(467);
var Mask_1 = __webpack_require__(466);
var features = __webpack_require__(25);
var Notice_1 = __webpack_require__(27);
var AviaryEditor_1 = __webpack_require__(624);
var AviaryEditorDialog = (function (_super) {
    tslib_1.__extends(AviaryEditorDialog, _super);
    function AviaryEditorDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onClose = function () {
            if (_this.resultHandle && _this.resultHandle.getIsDirty()) {
                _this.setState({
                    showConfirmClose: true
                });
            }
            else {
                _this.onCloseConfirm();
            }
        };
        _this.onCloseDismiss = function () {
            _this.setState({
                showConfirmClose: false
            });
        };
        _this.onCloseConfirm = function () {
            _this.setState({
                showConfirmClose: false
            });
            _this.props.onClose();
        };
        _this.onResultHandle = function (resultHandle) {
            _this.resultHandle = resultHandle;
            _this.setState({
                editorLoading: false
            });
        };
        _this.onRestore = function () {
            _this.setState({
                showConfirmRestore: true
            });
        };
        _this.onRestoreDismiss = function () {
            _this.setState({
                showConfirmRestore: false
            });
        };
        _this.onRestoreConfirm = function () {
            _this.setState({
                showConfirmRestore: false,
                imageUrl: _this.props.originalImageUrl,
                editorLoading: true,
                editingSequence: _this.state.editingSequence + 1
            });
        };
        _this.onSave = function () {
            var isDirty = _this.resultHandle.getIsDirty();
            // if we did a restore original image, then we should consider data to be changed
            if (_this.state.imageUrl !== _this.props.imageUrl) {
                isDirty = true;
            }
            _this.resultHandle.getImageData().then(function (imageDataUrl) {
                _this.props.onSave({
                    imageDataUrl: imageDataUrl,
                    actionList: _this.resultHandle.getActionList(),
                    isDirty: isDirty
                });
            });
        };
        _this.state = {
            imageUrl: _this.props.imageUrl,
            editorLoading: true,
            showConfirmClose: false,
            showConfirmRestore: false,
            editingSequence: 1
        };
        return _this;
    }
    AviaryEditorDialog.prototype.render = function () {
        var styles = this.getStyles();
        var texts = this.props.texts;
        var actions = [
            React.createElement(FlatButton_1.default, { label: texts.closeBtn, secondary: true, onTouchTap: this.onClose, "data-test-id": "asdk-close-btn" }),
            this.props.originalImageUrl ? React.createElement(FlatButton_1.default, { label: texts.restoreOriginalBtn, secondary: true, onTouchTap: this.onRestore, "data-test-id": "asdk-restore-btn", disabled: this.state.editorLoading }) : null,
            React.createElement(RaisedButton_1.default, { label: texts.saveBtn, primary: true, onTouchTap: this.onSave, "data-test-id": "asdk-save-btn", disabled: this.state.editorLoading }),
        ];
        if (features('privacyNotice')) {
            actions.unshift(React.createElement("div", { style: styles.privacyNotice },
                React.createElement(Notice_1.Notice, null)));
        }
        return (React.createElement(Dialog_1.default, { title: texts.title, open: true, modal: true, actions: actions, contentStyle: styles.dialogContent },
            this.props.onHelp
                ? React.createElement(IconButton_1.default, { onClick: this.props.onHelp, style: styles.helpButton },
                    React.createElement(help_outline_1.default, null))
                : null,
            React.createElement("div", { style: styles.editorWrap },
                React.createElement(AviaryEditor_1.default, { imageUrl: this.state.imageUrl, apiKey: this.props.apiKey, resultFileFormat: this.props.resultFileFormat, premiumPartnerAuthData: this.props.premiumPartnerAuthData, aviaryConfigOverride: this.props.aviaryConfigOverride, aviaryTranslationsOverride: this.props.aviaryTranslationsOverride, onResultHandle: this.onResultHandle, 
                    // after restore original (even on same imageUrl) editingSequence increase
                    // and we get another editor instance, because existing one cannot be updated,
                    // using the same props
                    key: this.state.editingSequence }),
                this.state.editorLoading
                    ?
                        React.createElement(Delayed_1.default, { delay: 300 },
                            React.createElement(Mask_1.default, null,
                                React.createElement(CircularProgress_1.default, { mode: "indeterminate" })))
                    :
                        null),
            this.state.showConfirmClose
                ?
                    this.renderConfirmation(texts.closeDialogTitle, texts.closeDialogText, texts.closeDialogConfirm, this.onCloseConfirm, texts.closeDialogAbort, this.onCloseDismiss)
                :
                    null,
            this.state.showConfirmRestore
                ?
                    this.renderConfirmation(texts.restoreDialogTitle, texts.restoreDialogText, texts.restoreDialogConfirm, this.onRestoreConfirm, texts.restoreDialogAbort, this.onRestoreDismiss)
                :
                    null));
    };
    AviaryEditorDialog.prototype.renderConfirmation = function (title, message, confirmLabel, onConfirm, dismissLabel, onDismiss) {
        // TODO maybe extract in a separate component
        return (React.createElement(Dialog_1.default, { title: title, open: true, actions: [
                React.createElement(FlatButton_1.default, { label: dismissLabel, secondary: true, onTouchTap: onDismiss }),
                React.createElement(RaisedButton_1.default, { label: confirmLabel, primary: true, onTouchTap: onConfirm }),
            ] }, message));
    };
    AviaryEditorDialog.prototype.getStyles = function () {
        return {
            dialogContent: {
                width: 800,
                minWidth: 800
            },
            editorWrap: {
                position: 'relative'
            },
            helpButton: {
                position: 'absolute',
                top: 12,
                right: 12
            },
            privacyNotice: {
                position: 'absolute',
                fontSize: '11px',
                boxSizing: 'border-box',
                left: 24,
                bottom: 16
            }
        };
    };
    return AviaryEditorDialog;
}(React.Component));
AviaryEditorDialog.defaultProps = {
    texts: {
        title: 'Edit Image',
        closeBtn: 'Close',
        restoreOriginalBtn: 'Restore Original',
        saveBtn: 'Save',
        closeDialogTitle: 'Close editor?',
        closeDialogText: 'Changes will be discarded.',
        closeDialogConfirm: 'OK',
        closeDialogAbort: 'Cancel',
        restoreDialogTitle: 'Restore original?',
        restoreDialogText: 'All changes to the image will be discarded!',
        restoreDialogConfirm: 'OK',
        restoreDialogAbort: 'Cancel'
    }
};
exports.default = AviaryEditorDialog;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var loadImage_1 = __webpack_require__(625);
var scriptjs = __webpack_require__(626);
exports.DefaultAviaryTools = [
    "crop",
    "orientation",
    "lighting",
    "sharpness",
    "text",
    "effects",
    "frames",
    "color",
    "focus",
    "blemish"
];
var AviaryEditor = (function (_super) {
    tslib_1.__extends(AviaryEditor, _super);
    function AviaryEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createAviary = function () {
            // some translations should be present before Aviary is initialize e.g.
            if (!Aviary.languageStrings) {
                Aviary.languageStrings = _this.props.aviaryTranslationsOverride;
            }
            var auth = _this.props.premiumPartnerAuthData;
            _this.featherEditor = new Aviary.Feather(Object.assign({}, 
            // default values for overridable configs
            {
                tools: exports.DefaultAviaryTools,
                maxSize: 10000
            }, _this.props.aviaryConfigOverride, auth || {}, {
                isPremiumPartner: !!auth,
                apiKey: _this.props.apiKey,
                fileFormat: _this.props.resultFileFormat,
                launchDelay: 0,
                closeDelay: 0,
                apiVersion: 3,
                theme: 'minimum',
                noCloseButton: true,
                appendTo: ReactDOM.findDOMNode(_this),
                onLoad: _this.onAviaryLoad,
                onError: _this.onAviaryError,
                onReady: _this.onAviaryReady,
                language: _this.getLanguage()
            }));
        };
        _this.onAviaryError = function (errorObj) {
            throw new Error("Failed to load aviary:: " + errorObj.message);
        };
        _this.onAviaryLoad = function () {
            if (_this.props.aviaryTranslationsOverride && Aviary.languageStrings) {
                // overwrite translations
                Aviary.languageStrings = Object.assign({}, Aviary.languageStrings, _this.props.aviaryTranslationsOverride);
            }
            _this.launchAviary();
        };
        _this.launchAviary = function () {
            loadImage_1.loadImage(_this.props.imageUrl).then(function (image) {
                // create id for dummy image element in DOM for use by Aviary
                var id = 'aviary-temporary-placeholder';
                var old = document.getElementById(id);
                if (old) {
                    document.body.removeChild(old);
                }
                image.id = id;
                image.style.display = 'none';
                document.body.appendChild(image);
                _this.featherEditor.launch({ image: image.id });
                _this.props.onResultHandle({
                    getImageData: function () {
                        return new Promise(function (resolve, reject) {
                            _this.featherEditor.getImageData(function (base64ImageUrl) {
                                resolve(base64ImageUrl);
                            });
                        });
                    },
                    getIsDirty: function () {
                        // TODO Aviry returns false here even if there are changes -> report a bug
                        // return this.featherEditor.getIsDirty();
                        // XXX using actions JSON to detect dirty state
                        try {
                            var actions = JSON.parse(_this.featherEditor.getActionList());
                            return actions.actions.length > 0;
                        }
                        catch (e) {
                            return true; // by default consider it dirty
                        }
                    },
                    getActionList: function () {
                        return _this.featherEditor.getActionList();
                    }
                });
            });
        };
        _this.onAviaryReady = function () {
            // TODO migrate from current implementation
            _this.fixTouchZoomBug();
            // TODO implement here disableIE11MouseCursorTextSelection from aviary.js
            // but make sure it is working on IE11 at all
        };
        return _this;
    }
    AviaryEditor.prototype.componentDidMount = function () {
        if (typeof Aviary === 'undefined') {
            scriptjs('https://dme0ih8comzn4.cloudfront.net/imaging/v3/editor.js', this.createAviary);
        }
        else {
            this.createAviary();
            this.launchAviary();
        }
    };
    AviaryEditor.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.imageUrl !== this.props.imageUrl) {
            this.featherEditor.close();
            this.launchAviary();
        }
    };
    AviaryEditor.prototype.componentWillUnmount = function () {
        this.featherEditor.close();
    };
    AviaryEditor.prototype.render = function () {
        return React.createElement("div", { style: this.getStyles().root, id: "aviary_container" });
    };
    AviaryEditor.prototype.getLanguage = function () {
        if (this.props.aviaryConfigOverride) {
            return this.props.aviaryConfigOverride.language || 'en';
        }
        return 'en';
    };
    //bugfix: DHDIYED-692
    AviaryEditor.prototype.fixTouchZoomBug = function () {
        var rootEl = ReactDOM.findDOMNode(this);
        var zoomBtn = rootEl.querySelector('#avpw_zoom_button');
        if (zoomBtn) {
            zoomBtn.addEventListener('touchstart', function () {
                var container = rootEl.querySelector('#avpw_zoom_container');
                if (container) {
                    container.classList.toggle('avpw_zoom_open');
                }
            });
        }
    };
    ;
    AviaryEditor.prototype.getStyles = function () {
        return {
            root: {
                height: 400
            }
        };
    };
    return AviaryEditor;
}(React.Component));
exports.default = AviaryEditor;


/***/ },
/* 625 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function loadImage(sourceImage) {
    return new Promise(function (resolve, reject) {
        var img;
        if (typeof sourceImage === "string") {
            img = new Image();
            img.src = sourceImage;
        }
        else {
            img = sourceImage;
        }
        if (img.complete) {
            resolve(img);
        }
        else {
            img.onload = function () {
                resolve(img);
            };
            img.onerror = function () {
                reject("Cannot load image.");
            };
        }
    });
}
exports.loadImage = loadImage;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      return !fn(el)
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var websiteData = __webpack_require__(4);
var help_outline_1 = __webpack_require__(450);
var IconButton_1 = __webpack_require__(420);
var features = __webpack_require__(25);
var Notice_1 = __webpack_require__(27);
var IframeEditorDialog = (function (_super) {
    tslib_1.__extends(IframeEditorDialog, _super);
    function IframeEditorDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.sendMessage = function (message) {
            var iframe = document.getElementById(_this.props.iframeConfig.cssId);
            iframe.contentWindow.postMessage(message, '*');
        };
        _this.loadImage = function (url) {
            return new Promise(function (resolve) {
                var img = document.createElement('img');
                img.setAttribute("style", "display:none");
                img.onload = function () {
                    var canvas = document.createElement("canvas");
                    var ctx = canvas.getContext("2d");
                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL());
                };
                img.setAttribute("src", url);
            });
        };
        _this.renderConfirmation = function (title, message, confirmLabel, onConfirm, dismissLabel, onDismiss) {
            // TODO maybe extract in a separate component
            return (React.createElement(Dialog_1.default, { title: title, open: true, actions: [
                    React.createElement(FlatButton_1.default, { label: dismissLabel, secondary: true, onTouchTap: onDismiss }),
                    React.createElement(RaisedButton_1.default, { label: confirmLabel, primary: true, onTouchTap: onConfirm }),
                ] }, message));
        };
        _this.getStyles = function () {
            return {
                dialogContent: {
                    width: 1100,
                    maxWidth: 1100,
                    minWidth: 970
                },
                editorWrap: {
                    position: 'relative'
                },
                iframe: {
                    border: 0
                },
                helpButton: {
                    position: 'absolute',
                    top: 12,
                    right: 12
                },
                privacyNotice: {
                    position: 'absolute',
                    fontSize: '11px',
                    boxSizing: 'border-box',
                    left: 24,
                    bottom: 16
                }
            };
        };
        _this.onIframeEvent = function (event) {
            if (typeof (event.data.type) === 'undefined') {
                return;
            }
            switch (event.data.type) {
                case 'image-editor-started':
                    _this.loadImage(_this.props.imageUrl).then(function (image) {
                        _this.sendMessage({
                            type: "image-editor-load-image",
                            imageString: image,
                            language: websiteData.getLanguageCode()
                        });
                        _this.setState({
                            editorLoading: false
                        });
                    });
                    break;
                case 'image-editor-image-changed':
                    if (_this.state.editorSaving) {
                        _this.setState({
                            editorSaving: false
                        });
                        _this.props.onSave({ imageDataUrl: event.data.imageString });
                    }
                    break;
                default:
                    return;
            }
        };
        _this.onClose = function () {
            _this.setState({
                showConfirmClose: true
            });
        };
        _this.onCloseDismiss = function () {
            _this.setState({
                showConfirmClose: false
            });
        };
        _this.onCloseConfirm = function () {
            _this.setState({
                showConfirmClose: false
            });
            _this.props.onClose();
        };
        _this.onRestore = function () {
            _this.setState({
                showConfirmRestore: true
            });
        };
        _this.onRestoreDismiss = function () {
            _this.setState({
                showConfirmRestore: false
            });
        };
        _this.onRestoreConfirm = function () {
            var url = IframeEditorDialog.resolveOriginalImageUrl(_this.props.originalImageUrl);
            _this.loadImage(url).then(function (image) {
                _this.sendMessage({
                    type: "image-editor-load-image",
                    imageString: image,
                    language: websiteData.getLanguageCode()
                });
            });
            _this.setState({
                showConfirmRestore: false,
                imageUrl: _this.props.originalImageUrl,
                editorSaving: true
            });
        };
        _this.onSave = function () {
            _this.sendMessage({
                type: "image-editor-update-image"
            });
            _this.setState({
                editorSaving: true
            });
        };
        _this.state = {
            resultImageUrl: "",
            imageUrl: _this.props.imageUrl,
            editorLoading: true,
            editorSaving: false,
            showConfirmClose: false,
            showConfirmRestore: false
        };
        return _this;
    }
    /**
     * After modification we save all images as PNG but if the customer uploaded a JPG the original image can't be
     * found anymore. Therefore we need to check if the image is now a PNG or a GIF what could be possible also.
     *
     * @param originalImageUrl
     */
    IframeEditorDialog.resolveOriginalImageUrl = function (originalImageUrl) {
        var http = new XMLHttpRequest();
        var urlArray = originalImageUrl.split("/");
        http.open('GET', '/app/cms/iframedimageseditor/findoriginalimage?imageId=' + urlArray[urlArray.length - 1].split(".")[0], false);
        http.send();
        if (http.status !== 404 && http.status !== 400) {
            originalImageUrl = JSON.parse(http.response).imageUrl;
        }
        return originalImageUrl;
    };
    IframeEditorDialog.prototype.componentDidMount = function () {
        window.addEventListener('message', this.onIframeEvent);
    };
    IframeEditorDialog.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.onIframeEvent);
    };
    IframeEditorDialog.prototype.render = function () {
        var styles = this.getStyles();
        var texts = this.props.texts;
        var iframeUrl = features.getPayload('iframedImageEditorConfig').url;
        var iframeUrlWithImage = iframeUrl + '#' + this.props.imageUrl;
        var actions = [
            React.createElement(FlatButton_1.default, { label: texts.closeBtn, secondary: true, onTouchTap: this.onClose, "data-test-id": "asdk-close-btn" }),
            React.createElement(FlatButton_1.default, { label: texts.restoreOriginalBtn, secondary: true, onTouchTap: this.onRestore, "data-test-id": "asdk-restore-btn", disabled: this.state.editorLoading }),
            React.createElement(RaisedButton_1.default, { label: texts.saveBtn, primary: true, onTouchTap: this.onSave, "data-test-id": "asdk-save-btn", disabled: this.state.editorLoading }),
        ];
        if (features('privacyNotice')) {
            actions.unshift(React.createElement("div", { style: styles.privacyNotice },
                React.createElement(Notice_1.Notice, null)));
        }
        return (React.createElement(Dialog_1.default, { title: texts.title, open: this.props.open, modal: true, actions: actions, contentStyle: styles.dialogContent, autoScrollBodyContent: true },
            this.props.onHelp
                ? React.createElement(IconButton_1.default, { onClick: this.props.onHelp, style: styles.helpButton },
                    React.createElement(help_outline_1.default, null))
                : null,
            React.createElement("div", { style: styles.editorWrap },
                React.createElement("iframe", { src: iframeUrlWithImage, id: this.props.iframeConfig.cssId, width: this.props.iframeConfig.width, height: this.props.iframeConfig.height, name: name, style: styles.iframe })),
            this.state.showConfirmClose
                ?
                    this.renderConfirmation(texts.closeDialogTitle, texts.closeDialogText, texts.closeDialogConfirm, this.onCloseConfirm, texts.closeDialogAbort, this.onCloseDismiss)
                :
                    null,
            this.state.showConfirmRestore
                ?
                    this.renderConfirmation(texts.restoreDialogText, texts.closeDialogText, texts.closeDialogConfirm, this.onRestoreConfirm, texts.closeDialogAbort, this.onRestoreDismiss)
                :
                    null));
    };
    return IframeEditorDialog;
}(React.Component));
IframeEditorDialog.defaultProps = {
    iframeConfig: {
        height: "700",
        width: "100%",
        cssId: "iframe-image-editor"
    },
    texts: {
        title: 'Edit Image',
        closeBtn: 'Close',
        saveBtn: 'Save',
        closeDialogTitle: 'Close editor?',
        closeDialogText: 'Changes will be discarded.',
        closeDialogConfirm: 'OK',
        closeDialogAbort: 'Cancel',
        restoreOriginalBtn: 'Restore Original',
        restoreDialogTitle: 'Restore original?',
        restoreDialogText: 'All changes to the image will be discarded!',
        restoreDialogConfirm: 'OK',
        restoreDialogAbort: 'Cancel'
    }
};
exports.default = IframeEditorDialog;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(199);
var react_redux_1 = __webpack_require__(220);
var GroupsView_1 = __webpack_require__(629);
var index_1 = __webpack_require__(499);
var tracking_1 = __webpack_require__(501);
var index_2 = __webpack_require__(499);
function onChangeColumnNumber(value) {
    return function (dispatch, getState) {
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.ColumnsChanged);
        dispatch(index_1.updatePayload({ columns: { active: value } }));
    };
}
exports.onChangeColumnNumber = onChangeColumnNumber;
function onChangeColumnFitMode(fitMode) {
    return function (dispatch, getState) {
        tracking_1.emitKpiEvent(tracking_1.SectionKpiEventsTypes.ColumnsFitChanged);
        dispatch(index_1.updatePayload({ columns: { loopFit: fitMode } }));
    };
}
exports.onChangeColumnFitMode = onChangeColumnFitMode;
function mapStateToProps(state) {
    var ownState = state.moduleSection;
    return {
        canAddGroup: ownState.quantity.current < ownState.quantity.max && !index_2.isModuleLimitReached(),
        canManageColumns: ownState.columns.available.length > 0,
        availableNumberOfColumns: ownState.columns.available,
        columnFitMode: ownState.columns.loopFit,
        numberOfColumns: ownState.columns.active,
        isAddGroupAvailable: index_1.supportsAddGroup(ownState)
    };
}
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        onAddGroup: index_1.addGroupAction,
        onChangeColumnNumber: onChangeColumnNumber,
        onChangeColumnFitMode: onChangeColumnFitMode
    }, dispatch);
}
function getGroupsViewComponent(store) {
    var ConnectedGroupsView = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GroupsView_1.GroupsView);
    return ConnectedGroupsView;
}
exports.getGroupsViewComponent = getGroupsViewComponent;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n = __webpack_require__(18);
var IconTextButton_1 = __webpack_require__(459);
var ToolbarGroup_1 = __webpack_require__(596);
var ToolbarContent_1 = __webpack_require__(597);
var Dropdown_1 = __webpack_require__(531);
var Divider_1 = __webpack_require__(605);
var add_box_1 = __webpack_require__(615);
var ColumnSettings_1 = __webpack_require__(630);
var view_column_1 = __webpack_require__(633);
var Messages_1 = __webpack_require__(617);
var ConnectedAviary_1 = __webpack_require__(619);
var GroupsView = (function (_super) {
    tslib_1.__extends(GroupsView, _super);
    function GroupsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupsView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolbarContent_1.ToolbarContent, null,
                React.createElement(ToolbarGroup_1.ToolbarGroup, null,
                    React.createElement(IconTextButton_1.default, { style: { marginRight: 12 }, text: l10n.getString('section.actionBar.buttons.addGroup.label'), Icon: React.createElement(add_box_1.default, null), onTouchTap: function () { return _this.props.onAddGroup(); }, useAlternativeColors: true, dataTestId: "section-add-group-button", isDisabled: !this.props.canAddGroup }),
                    React.createElement(Divider_1.Divider, null),
                    React.createElement(Dropdown_1.Dropdown, { text: l10n.getString('section.columnSettings.title'), Icon: React.createElement(view_column_1.default, null), disabled: !this.props.canManageColumns, layerStyle: {
                            marginTop: 7,
                            padding: 0,
                            minWidth: 180
                        }, dataTestId: "section-manage-columns" },
                        React.createElement(ColumnSettings_1.ColumnSettings, { activeColumn: this.props.numberOfColumns, fitMode: this.props.columnFitMode, availableColumns: this.props.availableNumberOfColumns, onColumnNumberSelected: this.props.onChangeColumnNumber, onFitModeChanged: this.props.onChangeColumnFitMode })))),
            React.createElement(Messages_1.Messages, { showAddGroup: this.props.isAddGroupAvailable && !this.props.canAddGroup }),
            React.createElement(ConnectedAviary_1.ConnectedAviary, null)));
    };
    return GroupsView;
}(React.Component));
exports.GroupsView = GroupsView;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var l10n = __webpack_require__(18);
var IconTextButton_1 = __webpack_require__(459);
var font_download_1 = __webpack_require__(631);
var view_agenda_1 = __webpack_require__(632);
var view_column_1 = __webpack_require__(633);
var view_headline_1 = __webpack_require__(634);
var view_module_1 = __webpack_require__(614);
var zoom_out_map_1 = __webpack_require__(635);
var ColumnSettings = (function (_super) {
    tslib_1.__extends(ColumnSettings, _super);
    function ColumnSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnSettings.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.container },
            React.createElement("div", { style: styles.containerTitle }, l10n.getString('section.columnSettings.columnsTitle')),
            React.createElement("div", { style: styles.columnsContainer },
                React.createElement(IconTextButton_1.default, { text: l10n.getString('section.columnSettings.columnsAuto'), Icon: React.createElement(font_download_1.default, null), style: styles.iconTextButton, buttonStyle: styles.button, onTouchTap: function () { _this.props.onColumnNumberSelected(0); }, useAlternativeColors: true, isPressed: this.props.activeColumn === 0, dataTestId: "columns-type-0" }),
                this.props.availableColumns.indexOf(2) !== -1 ?
                    React.createElement(IconTextButton_1.default, { text: l10n.getString('section.columnSettings.columns2'), Icon: React.createElement(view_agenda_1.default, { style: autoprefixer_1.autoprefixer({
                                transform: 'rotate(90deg)'
                            }) }), style: styles.iconTextButton, buttonStyle: styles.button, onTouchTap: function () { _this.props.onColumnNumberSelected(2); }, useAlternativeColors: true, isPressed: this.props.activeColumn === 2, dataTestId: "columns-type-2" }) : null,
                this.props.availableColumns.indexOf(3) !== -1 ?
                    React.createElement(IconTextButton_1.default, { text: l10n.getString('section.columnSettings.columns3'), Icon: React.createElement(view_column_1.default, null), style: styles.iconTextButton, buttonStyle: styles.button, onTouchTap: function () { _this.props.onColumnNumberSelected(3); }, useAlternativeColors: true, isPressed: this.props.activeColumn === 3, dataTestId: "columns-type-3" }) : null,
                this.props.availableColumns.indexOf(4) !== -1 ?
                    React.createElement(IconTextButton_1.default, { text: l10n.getString('section.columnSettings.columns4'), Icon: React.createElement(view_headline_1.default, { style: autoprefixer_1.autoprefixer({
                                transform: 'rotate(90deg)'
                            }) }), style: styles.iconTextButton, buttonStyle: styles.button, onTouchTap: function () { _this.props.onColumnNumberSelected(4); }, useAlternativeColors: true, isPressed: this.props.activeColumn === 4, dataTestId: "columns-type-4" }) : null),
            React.createElement("div", { style: styles.containerTitle }, l10n.getString('section.columnSettings.fitModeTitle')),
            React.createElement("div", { style: styles.fitModeContainer },
                React.createElement(IconTextButton_1.default, { text: l10n.getString('section.columnSettings.fitModeStretch'), Icon: React.createElement(zoom_out_map_1.default, null), style: styles.iconTextButton, buttonStyle: styles.button, onTouchTap: function () { _this.props.onFitModeChanged(1); }, useAlternativeColors: true, isPressed: this.props.fitMode === 1, dataTestId: "columns-fitModeStretch" }),
                React.createElement(IconTextButton_1.default, { text: l10n.getString('section.columnSettings.fitModeSameSize'), Icon: React.createElement(view_module_1.default, null), style: styles.iconTextButton, buttonStyle: styles.button, onTouchTap: function () { _this.props.onFitModeChanged(0); }, useAlternativeColors: true, isPressed: this.props.fitMode === 0, dataTestId: "columns-fitModeSameSize" }))));
    };
    ColumnSettings.prototype.getStyles = function () {
        return {
            container: autoprefixer_1.autoprefixer({
                padding: 5
            }),
            containerTitle: autoprefixer_1.autoprefixer({
                fontFamily: 'open sans',
                fontSize: '14px',
                lineHeight: '14px',
                padding: '6px 6px 6px 6px',
                color: '#666'
            }),
            columnsContainer: autoprefixer_1.autoprefixer({
                display: 'block',
                marginBottom: 16,
                maxWidth: 190
            }),
            fitModeContainer: {
                display: 'block',
                maxWidth: 190
            },
            iconTextButton: autoprefixer_1.autoprefixer({
                width: 80,
                padding: 6
            }),
            button: autoprefixer_1.autoprefixer({
                width: "100%"
            }),
            zone: {
                marginRight: 8
            }
        };
    };
    return ColumnSettings;
}(React.Component));
exports.ColumnSettings = ColumnSettings;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFontDownload = function ContentFontDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
  );
};
ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
ContentFontDownload.displayName = 'ContentFontDownload';
ContentFontDownload.muiName = 'SvgIcon';

exports.default = ContentFontDownload;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewAgenda = function ActionViewAgenda(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
  );
};
ActionViewAgenda = (0, _pure2.default)(ActionViewAgenda);
ActionViewAgenda.displayName = 'ActionViewAgenda';
ActionViewAgenda.muiName = 'SvgIcon';

exports.default = ActionViewAgenda;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewColumn = function ActionViewColumn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z' })
  );
};
ActionViewColumn = (0, _pure2.default)(ActionViewColumn);
ActionViewColumn.displayName = 'ActionViewColumn';
ActionViewColumn.muiName = 'SvgIcon';

exports.default = ActionViewColumn;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewHeadline = function ActionViewHeadline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' })
  );
};
ActionViewHeadline = (0, _pure2.default)(ActionViewHeadline);
ActionViewHeadline.displayName = 'ActionViewHeadline';
ActionViewHeadline.muiName = 'SvgIcon';

exports.default = ActionViewHeadline;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsZoomOutMap = function MapsZoomOutMap(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z' })
  );
};
MapsZoomOutMap = (0, _pure2.default)(MapsZoomOutMap);
MapsZoomOutMap.displayName = 'MapsZoomOutMap';
MapsZoomOutMap.muiName = 'SvgIcon';

exports.default = MapsZoomOutMap;

/***/ },
/* 636 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function getBgContainer(moduleId) {
    return document.querySelector("#section_bg_element_" + moduleId);
}
function positionBg(moduleId) {
    var containerEl = getBgContainer(moduleId);
    var rect = containerEl.getBoundingClientRect();
    var vph = window.innerHeight;
    var ratio = rect.height / vph;
    var height = rect.height;
    var top = rect.top;
    var bgElement = Array.from(containerEl.querySelectorAll('.section-bg-element-inner'))
        .find(function (e) { return e.parentNode === containerEl; });
    pos(bgElement, vph, ratio, height, top);
    setHeight(rect, bgElement, vph, ratio);
}
exports.positionBg = positionBg;
function pos(bgElement, vph, ratio, height, top) {
    var topValue;
    if (height < vph) {
        topValue = -(top * ratio);
    }
    else {
        topValue = -(top / ratio);
    }
    var transformValue = "translateY(" + topValue + "px)";
    bgElement.style.transform = transformValue;
    bgElement.style.webkitTransform = transformValue;
}
function setHeight(rect, bgElement, vph, ratio) {
    bgElement.style.height = (rect.height + (vph * ratio)) + "px";
}
var createListener = function (moduleId) { return function (event) {
    refreshWeb(moduleId);
}; };
var listeners = new Map();
function refreshWeb(moduleId) {
    positionBg(moduleId);
}
exports.refreshWeb = refreshWeb;
function initWeb(moduleId) {
    refreshWeb(moduleId);
    var listener = createListener(moduleId);
    listeners.set(moduleId, listener);
    window.addEventListener('scroll', listener);
    window.addEventListener('resize', listener);
}
exports.initWeb = initWeb;
function destroyWeb(moduleId) {
    var listener = listeners.get(moduleId);
    if (!listener) {
        throw new Error("No listener found for moduleId " + moduleId);
    }
    window.removeEventListener('scroll', listener);
    window.removeEventListener('resize', listener);
}
exports.destroyWeb = destroyWeb;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorModeEdit = function EditorModeEdit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
EditorModeEdit.displayName = 'EditorModeEdit';
EditorModeEdit.muiName = 'SvgIcon';

exports.default = EditorModeEdit;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentCopy = function ContentContentCopy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
  );
};
ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
ContentContentCopy.displayName = 'ContentContentCopy';
ContentContentCopy.muiName = 'SvgIcon';

exports.default = ContentContentCopy;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Modul_1 = __webpack_require__(197);
var SyncPosition_1 = __webpack_require__(440);
var CircularProgress_1 = __webpack_require__(382);
var diyLightTheme = __webpack_require__(241);
var Mask_1 = __webpack_require__(466);
var Delayed_1 = __webpack_require__(467);
var ModuleLoadingMasks = (function (_super) {
    tslib_1.__extends(ModuleLoadingMasks, _super);
    function ModuleLoadingMasks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModuleLoadingMasks.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    ModuleLoadingMasks.prototype.getModule = function (moduleId) {
        return Modul_1.default.getInstance(moduleId);
    };
    ModuleLoadingMasks.prototype.getModuleEl = function (moduleId) {
        if (this.getModule(moduleId)) {
            return this.getModule(moduleId).modul;
        }
        return undefined;
    };
    ModuleLoadingMasks.prototype.render = function () {
        var _this = this;
        var delayAppearance = 250; // if it takes less than 250ms, don't display loading mask
        return (React.createElement("div", null, this.props.moduleIds.map(function (moduleId) { return (React.createElement(SyncPosition_1.default, { element: _this.getModuleEl(moduleId)[0], key: moduleId }, function (box) { return React.createElement(Delayed_1.default, { delay: delayAppearance },
            React.createElement("div", { "data-test-id": "module-loading-mask-" + moduleId, style: {
                    width: box.width,
                    height: box.height,
                    left: box.left,
                    top: box.top,
                    position: 'absolute',
                    zIndex: 201 // the old zIndex of the loadingMask
                } },
                React.createElement(Mask_1.default, { backgroundColor: "rgba(255, 255, 255, 0.7)" },
                    React.createElement(CircularProgress_1.default, { mode: "indeterminate", size: 0.5 })))); })); })));
    };
    return ModuleLoadingMasks;
}(React.Component));
ModuleLoadingMasks.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.ModuleLoadingMasks = ModuleLoadingMasks;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var ModuleActionBarContent = (function (_super) {
    tslib_1.__extends(ModuleActionBarContent, _super);
    function ModuleActionBarContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModuleActionBarContent.prototype.componentDidMount = function () {
        var configView = ReactDOM.findDOMNode(this.refs["configView"]);
        // console.log(this.props.configView);
        this.showModuleEditorContainer();
        configView.appendChild(this.props.configView);
    };
    ModuleActionBarContent.prototype.componentDidUpdate = function () {
        var configView = ReactDOM.findDOMNode(this.refs["configView"]);
        // console.log(this.props.configView);
        this.showModuleEditorContainer();
        configView.appendChild(this.props.configView);
    };
    ModuleActionBarContent.prototype.render = function () {
        return React.createElement("div", { ref: "configView" });
    };
    ModuleActionBarContent.prototype.showModuleEditorContainer = function () {
        var moduleEditorContainer = this.props.configView.querySelector('.moduleEditorContainer');
        moduleEditorContainer.style.display = 'block';
        moduleEditorContainer.style.position = 'relative';
        var moduleEditorTitle = this.props.configView.querySelector('.diye .section-title-box');
        moduleEditorTitle.style.display = 'none';
        var moduleEditorFooter = this.props.configView.querySelector('.diye .box-footer');
        moduleEditorFooter.style.display = 'none';
        var moduleEditorHelpLink = this.props.configView.querySelector('.diye .module_help_link');
        moduleEditorHelpLink.style.display = 'none';
        var moduleOverlayGroup = this.props.configView.querySelector('.diye .module-overlay-group');
        moduleOverlayGroup.style.position = 'relative';
        moduleOverlayGroup.classList.add("open");
    };
    return ModuleActionBarContent;
}(React.Component));
exports.default = ModuleActionBarContent;


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var moduleSelector_1 = __webpack_require__(10);
var siteAdminApi = __webpack_require__(19);
var Modul_1 = __webpack_require__(197);
/**
 * Matrix
 */
var Matrix = (function () {
    function Matrix(matrixId) {
        /**
         * jQuery object holding the div with the id: #matrix_<matrixId>.
         */
        this.matrix = null;
        this.matrixId = null;
        this.matrix = $('#matrix_' + matrixId);
        this.matrixId = matrixId;
        this.pageId = parseInt($("body").attr("data-pageid"), 10);
    }
    Matrix.getInstance = function (matrixId) {
        return matrix[matrixId];
    };
    /**
     * Returns all divs representing a module.
     *
     * Returns: jQuery collection.
     */
    Matrix.prototype.getModules = function () {
        return this.matrix.find("> div[id^='modul']");
    };
    /**
     * Callback for the deletion confirmation button.
     */
    Matrix.prototype.del = function (childId, moduleId) {
        var self = this;
        var moduleObj = mm[moduleId];
        var postData = {};
        // prevent cancelEdit from beeing called
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'delete-module',
            propName: (moduleObj instanceof Modul_1.default) ? moduleObj.moduleType : 'moduleWithError'
        });
        postData = {
            'matrixID': self.matrixId,
            'childID': childId,
            'moduleId': moduleId,
            'pageId': this.pageId,
            'action': 'del'
        };
        if ((moduleObj instanceof Modul_1.default) && moduleObj.getIsNew()) {
            postData._diyNewlyAdded = 1;
        }
        // close current module if open !!! DO NOT MOVE THIS BLOCK ABOVE moduleObj.close will reset newlt added
        if (moduleObj instanceof Modul_1.default) {
            if (moduleObj.getIsInEditMode()) {
                // we close the module, but do not cancel edit now
                moduleObj.close(false, false);
            }
            moduleObj.hide();
            // close all other active modules
            Modul_1.default.abortEditingModules(moduleId);
        }
        $.ajax({
            url: systemurl + 'app/module/module/del',
            data: postData,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (data.ok) {
                    var webcomponentId = void 0;
                    if (!(mm[moduleId] instanceof Modul_1.default)) {
                        var moduleErrEl = $('#modul_' + moduleId + '_error');
                        webcomponentId = moduleErrEl.attr('data-webcomponentId');
                        moduleErrEl.remove();
                    }
                    else {
                        var moduleEl = mm[moduleId].getModuleElement();
                        webcomponentId = moduleEl.attr('data-webcomponentId');
                        renderWeight -= data.renderWeight;
                        if (!data.hasReachedCriticalLimit && $("#cc-sa-sidebar").hasClass("modules-critical")) {
                            siteAdminApi.destroyController('cc-sa-item-elements');
                            $("#cc-sa-sidebar").removeClass("modules-critical");
                        }
                        if (!data.hasReachedMaximumLimit && $("#cc-sa-sidebar").hasClass("modules-maximum")) {
                            siteAdminApi.destroyController('cc-sa-item-elements');
                            $("#cc-sa-sidebar").removeClass("modules-maximum");
                        }
                        moduleSelector_1.default.setLimitCallout();
                        mm[moduleId].remove();
                        if (data.postActions) {
                            for (var key in data.postActions) {
                                if (data.postActions.hasOwnProperty(key)) {
                                    mm[moduleId].postAction(data.postActions[key]);
                                }
                            }
                        }
                        mm[moduleId].onDelete();
                        delete mm[moduleId];
                    }
                    if (webcomponentId) {
                        var wpm = jimdoData.webcomponentsPerMatrix;
                        wpm[self.matrixId][webcomponentId] =
                            parseInt(wpm[self.matrixId][webcomponentId], 10) - 1;
                    }
                    $(document).trigger('diy-editor-module-deleted');
                }
                else {
                    if (mm[moduleId] instanceof Modul_1.default) {
                        mm[moduleId].getDeleteBtn().button({ disabled: false });
                        mm[moduleId].show();
                    }
                    var message = data.msg;
                    var htmlMsg = '<div class="error" id="error_' + moduleId +
                        '" style="border: 1px solid #c00; background: pink; padding: 10px; margin: 0 5px 10px;">' +
                        message +
                        '</div>';
                    //transform the loading sign into an error message
                    if ($('#modul_' + moduleId).prev().hasClass("error")) {
                        $('#modul_' + moduleId).prev().show();
                        $('#modul_' + moduleId).prev().html(message);
                    }
                    else {
                        $('#modul_' + moduleId).before(htmlMsg);
                    }
                    window.setTimeout(function () {
                        $('#error_' + moduleId).fadeOut(500);
                    }, 4000);
                }
            },
            error: function () {
                if (mm[moduleId] instanceof Modul_1.default) {
                    mm[moduleId].getDeleteBtn().button({ disabled: false });
                    mm[moduleId].hideLoading();
                }
            }
        });
        return;
    };
    Matrix.prototype.deleteModule = function (moduleId, scrollToIt, triggerEvent) {
        var webcomponentId;
        if (!(mm[moduleId] instanceof Modul_1.default)) {
            var moduleErrEl = $('#modul_' + moduleId + '_error');
            webcomponentId = moduleErrEl.attr('data-webcomponentId');
            moduleErrEl.remove();
        }
        else {
            var moduleEl = mm[moduleId].getModuleElement();
            webcomponentId = moduleEl.attr('data-webcomponentId');
            if (scrollToIt) {
                mm[moduleId].getContentContainer().scrollIntoView();
            }
            $(mm[moduleId].modul).fadeOut(500);
            mm[moduleId].remove();
            // if the module has an onDelete method defined, run it
            if (mm[moduleId].onDelete) {
                mm[moduleId].onDelete();
            }
            delete mm[moduleId];
        }
        if (webcomponentId) {
            var wpm = jimdoData.webcomponentsPerMatrix;
            wpm[this.matrixId][webcomponentId] = parseInt(wpm[this.matrixId][webcomponentId], 10) - 1;
        }
        if (triggerEvent !== false) {
            $(document).trigger('diy-editor-module-deleteFinished');
        }
    };
    Matrix.prototype.addModule = function (moduleId, cmsView, editView, afterChildId, scrollToIt) {
        var afterEl = $();
        if (afterChildId > 0) {
            afterEl = this.matrix.find('[data-matrixchildid=' + afterChildId + ']');
        }
        if (afterEl.length) {
            $(cmsView).insertAfter(afterEl);
        }
        else {
            $(cmsView).prependTo(this.matrix);
        }
        $(editView).appendTo('body');
        var module = mm[moduleId];
        var moduleEl = module.getModuleElement();
        var webcomponentId = moduleEl.attr('data-webcomponentId');
        if (webcomponentId !== undefined) {
            var wpm = jimdoData.webcomponentsPerMatrix;
            if (!wpm[this.matrixId]) {
                wpm[this.matrixId] = {};
            }
            if (!wpm[this.matrixId][webcomponentId]) {
                wpm[this.matrixId][webcomponentId] = 0;
            }
            wpm[this.matrixId][webcomponentId] = parseInt(wpm[this.matrixId][webcomponentId], 10) + 1;
        }
        if (this.trigger instanceof Function) {
            this.trigger('onload', this);
        }
        if (scrollToIt) {
            module.getContentContainer().scrollIntoView();
        }
        $(document).trigger('diy-editor-module-addFinished');
    };
    Matrix.prototype.getChildModule = function (childId) {
        var childModuleId = this.getChildModuleEl(childId).attr('data-moduleid');
        return childModuleId ? mm[childModuleId] : null;
    };
    Matrix.prototype.getChildModuleEl = function (childId) {
        return this.matrix.find('[data-matrixchildid=' + childId + ']');
    };
    Matrix.prototype.showWarningVeil = function () {
        if (!this.warningVeil) {
            var warningVeil = '';
            warningVeil += '<div class="diye-warning-veil">' +
                '<div class="diye-warning-veil-border">' +
                '<div class="diye-warning-veil-innerborder">&nbsp;</div>' +
                '</div></div>';
            this.warningVeil = $(warningVeil);
            this.matrix.append(this.warningVeil);
        }
        this.warningVeil.show();
    };
    Matrix.prototype.hideWarningVeil = function () {
        if (this.warningVeil) {
            this.warningVeil.hide();
        }
    };
    Matrix.prototype.supportsDragging = function () {
        /* at the moment, only content zones support dragging.
        Matrix modules do not */
        return this.matrix.hasClass('sortable-matrix');
    };
    return Matrix;
}());
exports.default = Matrix;
/* Store the main content matrix since we're going to access it a lot */
var $mainMatrixEl = null;
/**
 * Returns the widest matrix element on the page
 */
Matrix.getMainContentMatrixEl = function () {
    if ($mainMatrixEl) {
        return $mainMatrixEl;
    }
    var maxWidthMatrix = 0;
    var $theMatrix = null;
    $('[data-matrixid]').each(function (index, el) {
        var $el = $(el);
        var width = $el.width();
        if (maxWidthMatrix < width) {
            maxWidthMatrix = width;
            $theMatrix = $el;
        }
    });
    return $mainMatrixEl = $theMatrix;
};


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var autoprefixer_1 = __webpack_require__(438);
var SyncPosition_1 = __webpack_require__(440);
var l10n = __webpack_require__(18);
var Modul_1 = __webpack_require__(197);
function getModulesThatDoNotFit() {
    // get all modules ids that do not fit
    return Modul_1.default.getAllInstances().filter(function (module) { return !module.getFitsInContent(); });
}
function updateAll() {
    var modulesIdsDoesNotFit = getModulesThatDoNotFit();
    if (!modulesIdsDoesNotFit.length) {
        return;
    }
    // add the container for the masks, if it does not exist
    var modulesTooLargeContainer = document.getElementById('diy-modules-too-large');
    if (!modulesTooLargeContainer) {
        modulesTooLargeContainer = document.createElement('div');
        modulesTooLargeContainer.setAttribute('id', 'diy-modules-too-large');
        document.body.appendChild(modulesTooLargeContainer);
    }
    // get module ids that do not fit and build syncpositions around them
    var modulesTooLargeOverlaysList = modulesIdsDoesNotFit.map(function (module) {
        var modulEl = module.getModuleElement()[0];
        return React.createElement(SyncPosition_1.default, { element: modulEl, position: "absolute", key: "module-too-large-overlay-" + module.moduleId }, 
        // if the element we're monitoring becomes invisible, don't re-render any more
        // TODO improve state handling with Redux in the future
        function (box) { return (box.width > 0 && box.height > 0) ? React.createElement("div", { style: autoprefixer_1.autoprefixer({
                background: 'rgba(245, 218, 218, 0.7)',
                border: '1px solid #DC7376',
                boxSizing: 'border-box',
                padding: 18,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                fontWeight: 'bold',
                top: box.top,
                left: box.left,
                width: box.width,
                height: box.height,
                position: 'absolute',
                pointerEvents: 'none'
            }) },
            React.createElement("p", { style: { textAlign: 'center', marginBottom: 18 } }, l10n.getString('module.doesNotFit.title')),
            React.createElement("p", { style: { textAlign: 'center' } }, l10n.getString('module.doesNotFit.description'))) : null; });
    });
    ReactDOM.render(React.createElement("div", { className: "diye" }, modulesTooLargeOverlaysList), modulesTooLargeContainer);
}
exports.updateAll = updateAll;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var l10n = __webpack_require__(18);
var ModuleOverlay = (function () {
    /**
     * @param htmlEl element around which to render the overlay
     * @param options list of attributes for configuration
     */
    function ModuleOverlay(htmlEl, options) {
        this.targetEl = null;
        this.overlayWrapper = null;
        this.toolbox = null;
        this.dimensions = null;
        this.moduleObj = null;
        this.options = null;
        this.gluedElement = null;
        this.targetEl = htmlEl;
        this.options = $.extend({}, ModuleOverlay.defaultOptions, options);
        this.dimensions = {
            width: 0,
            height: 0
        };
        this._renderOverlay();
    }
    ModuleOverlay.prototype.position = function () {
        this.overlayWrapper.position({
            my: "left top",
            at: "left top",
            of: this.targetEl,
            collision: 'none'
        });
        var topPiece = this.getPiece('top');
        this.toolbox
            .width(topPiece.outerWidth())
            .css({
            left: -(this.options.thickness + ModuleOverlay.borderWidth * 2) + 'px',
            top: -(this.options.thickness + ModuleOverlay.borderWidth * 2) + 'px'
        });
        if (this.hasGluedElement()) {
            this.glueElementToBottom(this.gluedElement);
        }
    };
    ModuleOverlay.prototype.show = function () {
        //there are some modules (like event calendar),
        // that after the module object initialization (the module overlay)
        // change their size and need this extra check when showing the overlay
        if (this.needsRefresh()) {
            this.resize();
        }
        this.overlayWrapper.fadeIn(300);
        this.position();
    };
    ModuleOverlay.prototype.hide = function () {
        this.overlayWrapper.fadeOut(300);
    };
    ModuleOverlay.prototype.hasGluedElement = function () {
        return this.gluedElement !== null && this.gluedElement.length > 0;
    };
    ModuleOverlay.prototype._renderOverlay = function () {
        this.overlayWrapper = $('<div class="module-overlay-wrapper">'
            + '<div class="overlay-pieces-wrapper">'
            + '<div class="overlay-piece box-shadow top-piece">'
            + '<div class="left-border-cover bg-primary"></div>'
            + '<div class="right-border-cover bg-primary"></div>'
            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
            + '</div>'
            + '<div class="overlay-piece box-shadow left-piece">'
            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
            + '</div>'
            + '<div class="overlay-piece box-shadow right-piece">'
            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
            + '</div>'
            + '<div class="overlay-piece box-shadow bottom-piece">'
            + '<div class="left-border-cover bg-primary"></div>'
            + '<div class="right-border-cover bg-primary"></div>'
            + '<div class="overlay-inner-piece bg-primary box-border"></div>'
            + '</div>'
            + '</div>'
            + '</div>').wrap('<div class="diye" ></div>');
        this.overlayWrapper.parent().appendTo(this.options.appendTo);
        this._renderToolbox();
        this.resize();
    };
    ModuleOverlay.prototype.getOverlayElement = function () {
        return this.overlayWrapper;
    };
    ModuleOverlay.prototype.needsRefresh = function () {
        if (this.dimensions.width !== this.targetEl.outerWidth() + this.options.addPadding * 2
            || this.dimensions.height !== this.targetEl.outerHeight() + this.options.addPadding * 2) {
            return true;
        }
        return false;
    };
    /**
     *
     * @param iWidth inner width (border not included)
     * @param iHeight inner height (border not included)
     * @param position of the overlay vertical piece (left|right)
     */
    ModuleOverlay.prototype._resizeVerticalPiece = function (iWidth, iHeight, position) {
        if (position === void 0) { position = 'left'; }
        //to cover the box-shadow radius on the top and bottom where it meets the horizontal piece
        var extendHeight = 3;
        var blurRadius = ModuleOverlay.overlayShadowProperties.blurRadius;
        var borderWidth = ModuleOverlay.borderWidth;
        var overlayPiece = this.getPiece(position);
        var clipTop = extendHeight;
        var clipBottom = iHeight + extendHeight;
        var clipLeft;
        var clipRight;
        if (position === 'left') {
            clipLeft = -blurRadius;
            clipRight = 2 * borderWidth + iWidth;
        }
        else {
            clipLeft = 0;
            clipRight = 2 * borderWidth + iWidth + blurRadius;
        }
        overlayPiece.css({
            clip: 'rect(' + clipTop + 'px, ' + clipRight + 'px, ' + clipBottom + 'px, ' + clipLeft + 'px)',
            marginTop: -extendHeight
        });
        $('.overlay-inner-piece', overlayPiece).css({
            height: iHeight + extendHeight,
            width: iWidth
        });
        return overlayPiece;
    };
    /**
     *
     * @param iWidth inner width of the overlay piece (border not included)
     * @param iHeight inner height of the overlay piece (border not included)
     * @param position of the overlay horizontal piece (top|bottom)
     */
    ModuleOverlay.prototype._resizeHorizontalPiece = function (iWidth, iHeight, position) {
        if (position === void 0) { position = 'bottom'; }
        //to cover the box-shadow radius on the left and right where it meets the vertical piece
        var extendHeight = 3;
        var blurRadius = ModuleOverlay.overlayShadowProperties.blurRadius;
        var borderWidth = ModuleOverlay.borderWidth;
        var clipLeft = -blurRadius;
        var clipRight = iWidth + 2 * borderWidth + blurRadius;
        var overlayPiece = this.getPiece(position);
        var clipTop;
        var clipBottom;
        var coverTopPosition;
        if (position === 'top') {
            clipTop = -blurRadius;
            clipBottom = iHeight + 2 * borderWidth;
            coverTopPosition = iHeight + borderWidth;
        }
        else {
            clipTop = extendHeight;
            clipBottom = extendHeight + iHeight + 2 * borderWidth + blurRadius;
            coverTopPosition = extendHeight;
        }
        overlayPiece.css({
            clip: 'rect(' + clipTop + 'px, ' + clipRight + 'px, ' + clipBottom + 'px, ' + clipLeft + 'px)'
        });
        var sLeftPieceWidth = parseInt($('.left-piece .overlay-inner-piece', this.overlayWrapper).css('width'), 10);
        $('.left-border-cover', overlayPiece).css({
            width: sLeftPieceWidth,
            left: borderWidth,
            top: coverTopPosition,
            height: borderWidth
        });
        $('.right-border-cover', overlayPiece).css({
            width: sLeftPieceWidth,
            right: borderWidth,
            top: coverTopPosition,
            height: borderWidth
        });
        $('.overlay-inner-piece', overlayPiece)
            .height(iHeight)
            .width(iWidth);
        if (position === 'bottom') {
            $('.overlay-inner-piece', overlayPiece).css('margin-top', extendHeight);
            overlayPiece.css('margin-top', -extendHeight);
        }
        else {
            $('.overlay-inner-piece', overlayPiece).css('margin-bottom', extendHeight);
        }
        return overlayPiece;
    };
    ModuleOverlay.prototype.resize = function () {
        this.dimensions = {
            width: this.targetEl.outerWidth() + this.options.addPadding * 2,
            height: this.targetEl.outerHeight() + this.options.addPadding * 2
        };
        var thickness = this.options.thickness;
        var borderWidth = ModuleOverlay.borderWidth;
        this._resizeVerticalPiece(thickness, this.dimensions.height, 'left').css({
            top: 0,
            left: -(thickness + 2 * borderWidth)
        });
        this._resizeVerticalPiece(thickness, this.dimensions.height, 'right').css({
            top: 0,
            left: this.dimensions.width
        });
        this._resizeHorizontalPiece(this.dimensions.width + thickness * 2 + 2 * borderWidth, thickness, 'top').css({
            top: -(thickness + 2 * borderWidth),
            left: -(thickness + 2 * borderWidth)
        });
        this._resizeHorizontalPiece(this.dimensions.width + thickness * 2 + 2 * borderWidth, thickness, 'bottom').css({
            top: this.dimensions.height,
            left: -(thickness + 2 * borderWidth)
        });
        this.overlayWrapper.find('.overlay-pieces-wrapper').css({
            width: this.dimensions.width,
            height: this.dimensions.height,
            top: -this.options.addPadding,
            left: -this.options.addPadding
        });
        this.resizeToolbox();
    };
    ModuleOverlay.prototype._renderToolbox = function () {
        this.toolbox = $('<div class="module-toolbox-container">'
            + '<div class="module-deletebar-wrapper ">'
            + '<div class="module-deletebar v-toolbar box-border bg-primary">'
            + '<a title="' + l10n.getString('module.deleteButtonLabel')
            + '" class="toolbar-item ui-button-borderless tooldelete"> </a>'
            + '</div>'
            + '</div>'
            + '<div class="module-movebar">'
            + '<div class="v-toolbar bg-primary box-border">'
            + '<span class="toolbar-item toolmove"'
            + ' href="#" onclick="return false;" title="'
            + l10n.getString('module.dragAndDropHandleLabel') + '"></span>'
            + '<a class="toolbar-item toolduplicate not-sorting-handle"'
            + ' href="javascript:void(0);" title="'
            + l10n.getString('module.duplicateButtonLabel')
            + '"></a>'
            + '<a class="toolbar-item not-sorting-handle toolup"'
            + ' href="javascript:void(0);" title="'
            + l10n.getString('module.cannotBeMovedUpLabel')
            + '"></a>'
            + '<a class="toolbar-item not-sorting-handle tooldown"'
            + ' href="javascript:void(0);" title="'
            + l10n.getString('module.cannotBeMovedDownLabel')
            + '"></a>'
            + '</div>'
            + '</div>'
            + '</div>');
        //we add it to the same container as the module editor/and overlayWrapper
        //so they all share a common z-index stack
        this.toolbox.appendTo(this.overlayWrapper);
        this._updateDisabledToolboxButtons();
        this._updateToolboxVisibility();
    };
    ModuleOverlay.prototype.resizeToolbox = function () {
        var moveBarWrap = this.toolbox.find('.module-movebar');
        moveBarWrap.css({
            paddingBottom: (Math.max(0, this.targetEl.outerHeight(), moveBarWrap.height()) * 0.5)
        });
        var deleteBarWrap = this.toolbox.find('.module-deletebar-wrapper');
        deleteBarWrap.css({
            paddingBottom: (Math.max(0, this.targetEl.outerHeight(), deleteBarWrap.height()) * 0.5)
        });
    };
    /**
     *
     * @param pieceName of the overlay piece (accepted values top|left|bottom|right)
     */
    ModuleOverlay.prototype.getPiece = function (pieceName) {
        if ($.inArray(pieceName, ModuleOverlay.piecesName) === null) {
            return null;
        }
        return $('.' + pieceName + '-piece', this.overlayWrapper);
    };
    ModuleOverlay.prototype.getToolbox = function () {
        return this.toolbox;
    };
    ModuleOverlay.prototype.addContent = function (content) {
        this.overlayWrapper.find('.overlay-pieces-wrapper').append(content);
    };
    ModuleOverlay.prototype._getToolboxButton = function (buttonId) {
        var toolbox = this.getToolbox();
        switch (buttonId) {
            case 'up':
                return toolbox.find('.toolup');
            case 'down':
                return toolbox.find('.tooldown');
            case 'duplicate':
                return toolbox.find('.toolduplicate');
            case "move":
                return toolbox.find('.toolmove');
            default:
                return null;
        }
    };
    ModuleOverlay.prototype._updateDisabledToolboxButtons = function () {
        var buttonId;
        var button;
        $('.toolbar-item.toolbar-item-disabled', this.getToolbox())
            .removeClass('toolbar-item-disabled');
        for (var i = 0; i < this.options.toolbox.disabledButtons.length; i++) {
            buttonId = this.options.toolbox.disabledButtons[i];
            button = this._getToolboxButton(buttonId);
            if (button) {
                button.addClass('toolbar-item-disabled');
            }
        }
    };
    ModuleOverlay.prototype._updateToolboxVisibility = function () {
        var $toolbox = this.getToolbox();
        if (this.options.showToolbox) {
            $toolbox.show();
        }
        else {
            $toolbox.hide();
        }
    };
    ModuleOverlay.prototype.setToolboxDisabledButtons = function (disabledButtons) {
        this.options.toolbox.disabledButtons = disabledButtons;
        this._updateDisabledToolboxButtons();
    };
    /**
     * @desc removes element glued to the bottom
     */
    ModuleOverlay.prototype.removeElementFromBottom = function (element) {
        //resize bottom piece
        this._resizeHorizontalPiece(this.dimensions.width + this.options.thickness * 2 + 2 * ModuleOverlay.borderWidth, this.options.thickness, 'bottom');
        this.gluedElement = null;
        this.overlayWrapper.find('.module-overlay-after').hide();
    };
    /**
     * @desc positions the element at the bottom and makes it look
     * like a continuous piece by covering the place where they meet
     * makes the following assumptions: the element
     * has same border (width), and shadow, and it's sibling of the overlay wrapper
     */
    ModuleOverlay.prototype.glueElementToBottom = function (element) {
        var bottomPiece = this.getPiece('bottom');
        //if smaller resize
        if (element.width() <= bottomPiece.width()) {
            var newWidth = bottomPiece.width();
            element.width(newWidth);
        }
        element.position({
            my: "left top",
            at: "left bottom",
            of: bottomPiece,
            collision: 'none',
            offset: "0 0"
        });
        // set the left positioning if it's off screen and causes scrolling
        var elementTriggersXScroll = (element.offset().left + element.outerWidth()) > $(window).width();
        if (elementTriggersXScroll && (bottomPiece.outerWidth() < element.outerWidth())) {
            var rightPositionConfig = {
                my: "right top",
                at: "right bottom",
                of: bottomPiece,
                collision: 'none',
                offset: "0 0"
            };
            element.position(rightPositionConfig);
            // Ensure it don't get out of viewport, or not too close to the edge of it
            if (parseInt(element.css('left'), 10) < 10) {
                element.css('left', '10px');
            }
            // and make sure the element doesn't overlap with the move up/down/delete bar
            var toolbox = this.getToolbox().find('.module-movebar');
            var diff = (toolbox.offset().top + toolbox.height() + 12) - element.offset().top;
            if (diff > 0) {
                //extend bottom piece
                this._resizeHorizontalPiece(bottomPiece.find('.overlay-inner-piece').innerWidth(), bottomPiece.find('.overlay-inner-piece').innerHeight() + diff, 'bottom');
                //and reposition
                element.position(rightPositionConfig);
            }
        }
        var joinCover = this.overlayWrapper.find('.module-overlay-after');
        if (!joinCover.length) {
            joinCover = $('<div class="module-overlay-after overlay-piece bg-primary"></div>')
                .appendTo(this.overlayWrapper);
        }
        //make it look continuous by covering it where they meet
        joinCover
            .show()
            .width(bottomPiece.find('.overlay-inner-piece').width())
            .height(ModuleOverlay.borderWidth + ModuleOverlay.overlayShadowProperties.blurRadius)
            .css('z-index', element.diy_zIndex(this.options.appendTo) + 1)
            .position({
            my: "left top",
            at: "left bottom",
            of: bottomPiece,
            collision: 'none',
            offset: ModuleOverlay.borderWidth + " " +
                (-ModuleOverlay.overlayShadowProperties.blurRadius +
                    ModuleOverlay.borderWidth)
        });
        this.gluedElement = element;
    };
    return ModuleOverlay;
}());
/**
 * @desc just blurRadius defined and use atm
 * @type {Object} css broken down shadow properties
 */
ModuleOverlay.overlayShadowProperties = {
    //offsetX: 0,
    //offsetY: 0,
    blurRadius: 4
    //,spreadRadius: 0
};
ModuleOverlay.defaultOptions = {
    thickness: 12,
    appendTo: 'body',
    showToolbox: true,
    addPadding: 0,
    toolbox: {
        disabledButtons: []
    }
};
/**
 * these are defined with the box-border class
 */
ModuleOverlay.borderWidth = 1;
ModuleOverlay.piecesName = ["top", "bottom", "left", "right"];
exports.default = ModuleOverlay;


/***/ },
/* 644 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_CSS = "css";
var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Css"] = 0] = "Css";
    ResourceType[ResourceType["Js"] = 1] = "Js";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
;
var Resource = (function () {
    function Resource(type, source) {
        this.type = type;
        this.source = source;
    }
    Resource.prototype.equals = function (resource) {
        return this.type === resource.type && this.source === resource.source;
    };
    return Resource;
}());
exports.Resource = Resource;


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var App = (function () {
    function App() {
    }
    App.getNotificationApi = function () {
        var ns = window.diy.editor.notifications;
        return ns.api;
    };
    App.prototype.setToolbar = function (toolbar) {
        this.toolbar = toolbar;
    };
    App.prototype.setLayerManager = function (lm) {
        this.layerManager = lm;
    };
    App.prototype.initApi = function () {
        var ns = diy.core.namespace('diy.editor.notifications');
        var NotificationFactory = __webpack_require__(646);
        ns.Notifications = NotificationFactory.notificationTypes;
        ns.NotificationFactory = new NotificationFactory();
        var NotificationQueue = __webpack_require__(665);
        var queue = new NotificationQueue();
        ns.queue = queue;
        ns.api = {
            ready: queue.ready.bind(queue)
        };
        ns.BubbleManager = __webpack_require__(666);
    };
    App.prototype.getApi = function () {
        //HACK: tidy up the namespaces
        var ns = window.diy.editor.notifications;
        return ns.api;
    };
    App.prototype.init = function () {
        var ns = diy.core.namespace('diy.editor.notifications');
        var notpublishednotification = __webpack_require__(667);
        notpublishednotification.init();
        __webpack_require__(671);
        __webpack_require__(672);
        __webpack_require__(673);
        __webpack_require__(674);
        var notificationModule = __webpack_require__(675);
        notificationModule.setToolbar(this.toolbar);
        notificationModule.setLayerManager(this.layerManager);
        __webpack_require__(676);
        var NotificationCenter = __webpack_require__(677);
        ns.notificationCenter = new NotificationCenter(this.toolbar);
    };
    return App;
}());
exports.App = App;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);

var NoDomainNotification = __webpack_require__(648);
var ChatNotification = __webpack_require__(649);
var BrowserUpgradeNotification = __webpack_require__(650);
var NotPublishedNotification = __webpack_require__(651);
var MaintenanceModeNotification = __webpack_require__(652);
var LoginNotification = __webpack_require__(653);
var FilemanagerNotification = __webpack_require__(654);
var TopicChangeNotification = __webpack_require__(655);
var CongratsNotification = __webpack_require__(656);
var GuidanceNotification = __webpack_require__(657);
var BlogMobileAppNotification = __webpack_require__(658);
var EMPNotification = __webpack_require__(659);
var ExternalWebsiteImportNotification = __webpack_require__(660);
var ExternalWebsiteImportBlueNotification = __webpack_require__(661);
var XingVouchersNotification = __webpack_require__(662);
var WebComponentUpsellFinishedNotification = __webpack_require__(663);
var SectionsWelcomeNotification = __webpack_require__(664);

/**
 *
 */
(function() {

    var NotificationFactory = Klazz.extend({
        classMap: {
            1: ChatNotification,
            //2: UndoRedoNotification,
            3: BrowserUpgradeNotification,
            4: NoDomainNotification,
            5: MaintenanceModeNotification,
            //6: NTFCenterNotification,
            7: LoginNotification,
            8: FilemanagerNotification,
            9: TopicChangeNotification,
            10: CongratsNotification,
            11: NotPublishedNotification,
            12: GuidanceNotification,
            13: BlogMobileAppNotification,
            14: EMPNotification,
            15: ExternalWebsiteImportNotification,
            16: XingVouchersNotification,
            17: ExternalWebsiteImportBlueNotification,
            18: WebComponentUpsellFinishedNotification,
            19: SectionsWelcomeNotification
        },
        create: function(item) {
            var options,
                type,
                classCtor,
                notificationInstance = null;


            if (typeof item == 'object') {
                if (!item.type) {
                    throw new Error("Must specify the notification type");
                }
                options = item;
                type = options.type;
            } else {
                if (isNaN(item)) {
                    throw new Error("Must specify the notification type");
                }
                options = null;
                type = item;
            }

            classCtor = this.classMap[type];
            if (!classCtor) {
                throw new Error('Notification Class for type ' + type + ' is Undefined');
            }
            notificationInstance = new classCtor(options);
            if (!(notificationInstance instanceof NotificationBase)) {
                throw new Error('Notification Class dows not inherit the base class');
            }

            return notificationInstance;
            /*switch(item.type) {
                case 1: //fall-through
                case 2:
                    return new ns.ChatNotification(item);
                default:
                    return new ns.BasicNotification(item);
                    return new ns.FlashNotification(item);
            }*/
        },
        getType: function(type) {
            return this.classMap[type] ? this.classMap[type] : 'undefined';
        }
    });

    NotificationFactory.notificationTypes = {
        TYPE_CHAT: 1,
        TYPE_UNDO_REDO: 2,
        TYPE_BROWSER_UPGRADE: 3,
        TYPE_NO_DOMAIN: 4,
        TYPE_MAINTENANCE: 5,
        TYPE_NTFCENTER: 6,
        TYPE_LOGIN: 7,
        TYPE_FILEMANAGER: 8,
        TYPE_TOPIC_CHANGE: 9,
        TYPE_CONGRATULATIONS: 10,
        TYPE_NOT_PUBLISHED: 11,
        TYPE_GUIDANCE: 12,
        TYPE_BLOG_MOBILE_APP: 13,
        TYPE_EMP: 14,
        TYPE_EXTERNAL_WEBSITE_IMPORT: 15,
        TYPE_XING_VOUCHERS: 16,
        TYPE_EXTERNAL_WEBSITE_IMPORT_BLUE: 17,
        TYPE_WEBCOMPONENT_UPSELL_FINISHED: 18,
        TYPE_SECTIONS_WELCOME: 19
    };

    module.exports = NotificationFactory;

}());


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

/* globals diy, Klazz */
var $ = __webpack_require__(3);

var NotificationBase;

NotificationBase = Klazz.extend({
    flashNotification: false,
    _resource: null,
    /**
     * override this in concrete classes
     */
    stickyDefault: 0,
    /**
     * override this in concrete classes
     */
    categoryDefault: null,
    /**
     * override this in concrete classes
     */
    severityDefault: null,
    severityClass: {
        1: 'severity-high',
        2: 'severity-medium-high',
        3: 'severity-medium',
        4: 'severity-medium-low',
        5: 'severity-low'
    },
    bubbleHideDelay: {
        1: 0,
        2: 7000,
        3: 7000,
        4: 7000,
        5: 7000
    },
    bubbleOptions: {
        'autoHide': true,
        'hideDelay': 4000,
        'dismissCallback': null
    },
    /**
     *
     */
    softDeletion: false,
    /**
     *
     */
    iconCls: null,
    /**
     * this method must be implemented by all Notifications
     */
    getContent: function() {

    },

    initialize: function(resource) {
        if (!this.flashNotification && resource) {
            this.setResource(resource);
        }
        this.setBubbleOptions();
    },

    getBubbleOptions: function() {
        return this.bubbleOptions;
    },
    getBubbleOption: function(opt) {
        return this.bubbleOptions[opt];
    },
    setBubbleOptions: function(/*options*/) {
        this.bubbleOptions = {
            'autoHide': (this.bubbleHideDelay[this.getSeverity()] !== 0),
            'hideDelay': this.bubbleHideDelay[this.getSeverity()]
        };
        /*if (options && options.autoHide) {
            this.bubbleOptions.autoHide = options.autoHide?true:false;
        }
        if (options && options.hideDelay && !isNaN(options.hideDelay)) {
            this.bubbleOptions.hideDelay = options.hideDelay;
        }*/
        this.bubbleOptions.dismissCallback = $.proxy(function() {
            if (!this.flashNotification) {
                this.setDismissed(1);
                this._resource.$update();
            }
        }, this)
    },

    /**
     * Css class suffix to be appended to each notification entry
     * Results in a css class like 'notification-type-*'
     * @returns {string}
     */
    getCssClassSuffix: function() {
        return '';
    },

    getSeverityClass: function() {
        return this.severityClass[this.getSeverity()];
    },

    setResource: function(resource) {
        this._resource = resource;
    },
    getResource: function() {
        return this._resource;
    },

    getOption: function(opt) {
        var defaults = {
            'id': null,
            'category': this.categoryDefault,
            'severity': this.severityDefault,
            'sticky': this.stickyDefault,
            'dismissed': 0,
            'read': 0,
            'deleted': 0,
            'payload': null
        };
        if (this._resource && !(typeof this._resource[opt] == 'undefined')) {
            return this._resource[opt];
        }
        return defaults[opt];
    },
    getId: function() {
        return this.getOption('id');
    },
    getCategory: function() {
        return this.getOption('category');
    },
    getSeverity: function() {
        return this.getOption('severity');
    },
    getSticky: function() {
        return this.getOption('sticky');
    },
    getDismissed: function() {
        return this.getOption('dismissed');
    },
    getRead: function() {
        return this.getOption('read');
    },
    getDeleted: function() {
        return this.getOption('deleted');
    },
    getPayload: function() {
        return this.getOption('payload');
    },
    getName: function() {
        throw new Error('getName must be implemented by all classes');
    },


    setOption: function(opt, value) {
        if (this._resource) {
            this._resource[opt] = value;
        }
    },
    setCategory: function(value) {
        return this.setOption('category', value);
    },
    setSeverity: function(value) {
        return this.setOption('severity', value);
    },
    setSticky: function(value) {
        return this.setOption('sticky', value);
    },
    setDismissed: function(value) {
        return this.setOption('dismissed', value);
    },
    setRead: function(value) {
        return this.setOption('read', value);
    },
    setDeleted: function(value) {
        return this.setOption('deleted', value);
    },
    setPayload: function(value) {
        return this.setOption('payload', value);
    }


});

module.exports = NotificationBase;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

/*global diy*/
var domainpromo = __webpack_require__(546);
var l10n = __webpack_require__(18);
var NotificationBase = __webpack_require__(647);

var NoDomainNotification;

NoDomainNotification = NotificationBase.extend({
    /**
     * Default sticky for NoDomainNotification
     */
    stickyDefault: 1,
    /**
     * Default severity for NoDomainNotification
     */
    severityDefault: 1,
    /**
     * Default category for NoDomainNotification
     */
    categoryDefault: 1,
    /**
     * parameters for determining default operation,
     * if null or false, they are ignored
     */
    iconCls: 'ui-icon-alert',
    /**
     * this method must be implemented by all Notifications
     */
    getContent: function() {
        return '<span>' + l10n.getString('domainConnection.notification.infoText') + '</span>';
    },

    globalAction: function() {
        domainpromo.show();
    },

    getName: function() {
        return 'NoDomainNotification';
    }
});

module.exports = NoDomainNotification;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);
var features = __webpack_require__(25);

/* globals jimdoData, diy */
(function () {

    'use strict';

    var ChatNotification = NotificationBase.extend({
        /**
         * Default severity for Chat Notification
         */
        severityDefault: 4,
        /**
         * Default category for Chat Notification
         */
        categoryDefault: 3,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls        : 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getContent     : function () {
            return '<span>' +
                jimdoData.messages.chat.greeting +
                '</span><br /><a>' +
                jimdoData.messages.chat.link +
                '</a>';
        },

        globalAction: function () {
            if (!features('chatNotification')) {
                return;
            }

            var chatConfiguration = features.getPayload('chatNotification');

            diy.editor.chat.triggerChat(chatConfiguration);
        },

        getName: function() {
            return 'ChatNotification';
        }
    });
    module.exports = ChatNotification;
}());


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);
/* globals jimdoData, diy */
(function() {

    var BrowserUpgradeNotification = NotificationBase.extend({
        /**
         * Default sticky for BrowserUpgradeNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for BrowserUpgradeNotification
         */
        severityDefault: 3,
        /**
         * Default category for BrowserUpgradeNotification
         */
        categoryDefault: 1,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-alert',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            var payload = this.getPayload();
            return '<span>' +
                jimdoData.messages.upgradeBrowser[payload.msgType] +
                '</span> <a>' +
                jimdoData.messages.upgradeBrowser[payload.browserType].text +
                '</a>';
        },

        globalAction: function() {
            var payload = this.getPayload();
            window.open(jimdoData.messages.upgradeBrowser[payload.browserType].href, '_blank');
        },

        getName: function() {
            return 'BrowserUpgradeNotification';
        }
    });

    module.exports = BrowserUpgradeNotification;
}());


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);
/**
 *
 */
(function() {

    var NotPublishedNotification = NotificationBase.extend({
        /**
         * Default sticky for NotPublishedNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for NotPublishedNotification
         */
        severityDefault: 3,
        /**
         * Default category for NotPublishedNotification
         */
        categoryDefault: 1,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-alert',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            return '<div class="title">' + jimdoData.messages.toolbar.maintenance.publish.notification.title + '</div>' +
                '<div class="description">' + jimdoData.messages.toolbar.maintenance.publish.notification.description + '</div>';
        },

        globalAction: function() {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'guidedsetup'}
            ]);
        },

        getName: function() {
            return 'NotPublishedNotification';
        }
    });

    module.exports = NotPublishedNotification;
}());


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
/**
 *
 */
(function() {

    var MaintenanceModeNotification = NotificationBase.extend({
        /**
         * Default sticky for MaintenanceModeNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for MaintenanceModeNotification
         */
        severityDefault: 3,
        /**
         * Default category for MaintenanceModeNotification
         */
        categoryDefault: 1,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-settings',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            var messages = {
                offline: {
                    heading: '',
                    description: ''
                }
            };
            // get translations //
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar.maintenance); // note: we break object reference

            var title, description;

            title = this.messages['offline'].notification.title;
            description = this.messages['offline'].notification.description;

            var elementHtml =
                '<div class="title">' + title + '</div>' +
                '<div class="description">' + description + '</div>' +
                '<a href="javascript:;">' + this.messages.link + '</a>';

            return elementHtml;
        },

        globalAction: function() {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'website-staging'}
            ]);
        },

        getName: function() {
            return 'MaintenanceModeNotification';
        }
    });

    module.exports = MaintenanceModeNotification;
}());


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
/**
 *
 */
(function() {

    var LoginNotification = NotificationBase.extend({
        flashNotification: false,
        /**
         * Default severity for LoginNotification
         */
        severityDefault: 4,
        /**
         * Default category for LoginNotification
         */
        categoryDefault: 2,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            return jimdoData.messages.notifications.loginNotification;
        },

        globalAction: function() {
            jQuery.proxy(guidedAssistant._openHelpTopic, guidedAssistant)('mywebsite_login_window');
        },

        getName: function() {
            return 'LoginNotification';
        }
    });

    module.exports = LoginNotification;
}());


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);

module.exports = NotificationBase.extend({
    flashNotification: false,
    severityDefault: 4,
    categoryDefault: 2,
    stickyDefault: 0,
    iconCls: 'ui-icon-star',
    getContent: function() {
        return jimdoData.messages.filemanager.notificationText;
    },
    globalAction: function() {
        diy.editor.deeplinking.requestPath([
            {label: 'siteadmin', params: 'settings'},
            {label: 'SAC.Settings', params: 'website-filemanager'}
        ], true /* demo mode active */);
    },

    getName: function() {
        return 'FilemanagerNotification';
    }
});


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);

module.exports = NotificationBase.extend({
    flashNotification: false,
    severityDefault: 5,
    categoryDefault: 2,
    stickyDefault: 0,
    iconCls: 'ui-icon-star',
    getContent: function() {
        return jimdoData.messages.notifications.topicChangeNotification;
    },
    globalAction: function() {
        diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'industry'}
            ],
            true // demo mode active
        );
    },

    getName: function() {
        return 'TopicChangeNotification';
    }
});


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

var NotificationBase = __webpack_require__(647);

/**
 *
 */
(function() {

    var CongratsNotification = NotificationBase.extend({
        /**
         * Default sticky for CongratsNotification
         */
        stickyDefault: 0,
        /**
         * Default severity for CongratsNotification
         */
        severityDefault: 4,
        /**
         * Default category for CongratsNotification
         */
        categoryDefault: 4,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-globe',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            return '<div class="title">' + jimdoData.messages.guidedSetup.notification_finished.title + '</div>' +
                '<div class="description">' + jimdoData.messages.guidedSetup.notification_finished.content + '</div>';
        },

        globalAction: function() {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'website-staging'}
            ]);
        },

        getName: function() {
            return 'CongratsNotification';
        }
    });

    module.exports = CongratsNotification;
}());


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
/**
 *
 */
(function() {
    var GuidanceNotification = NotificationBase.extend({
        /**
         * Default sticky for GuidanceNotification
         */
        stickyDefault: 0,
        /**
         * Default severity for GuidanceNotification
         */
        severityDefault: 1,
        /**
         * Default category for GuidanceNotification
         */
        categoryDefault: 3,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-compass',
        /**
         * overwrite default severity css class with the one from severity-medium-low
         * @returns string
         */
        getSeverityClass: function() {
            return this.severityClass[4];
        },
        getCssClassSuffix: function() {
            return 'guidance';
        },
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            var msg = jimdoData.messages.guidance.notification;
            var $content = $(
                '<div class="title">' + msg.title + '</div>' +
                '<div class="description">' + msg.content + '</div>' +
                '<div class="button-bar cp-style">' +
                    '<button class="small blue-primary">' + msg.start + '</button>' +
                '</div>'
            );

            $content.find('button')
                .button()
                .bind('click', function() {
                    //TODO: This seems not needed because of globalAction
                    //diy.editor.guidance.start();
                });

            return $content;
        },

        globalAction: function() {
            diy.editor.guidance.start();
        },

        getName: function() {
            return 'GuidanceNotification';
        }
    });

    module.exports = GuidanceNotification;
}());


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
/**
 * Created by mulmeanu on 1/6/15.
 */
(function() {
    var BlogMobileAppNotification = NotificationBase.extend({
        softDeletion: true,
        /**
         * Default severity for GuidanceNotification
         */
        severityDefault: 4,
        /**
         * Default category for GuidanceNotification
         */
        categoryDefault: 2,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            return jimdoData.messages.notifications.blogmobileapp;
        },

        globalAction: function() {
            $.proxy(guidedAssistant._openHelpTopic, guidedAssistant)('apps_blog_mobile');
        },

        getName: function() {
            return 'BlogMobileAppNotification';
        }
    });

    module.exports = BlogMobileAppNotification;
}());


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
var l10n = __webpack_require__(18);

(function() {
    var EMPNotification = NotificationBase.extend({
        softDeletion: true,
        severityDefault: 4,
        stickyDefault: 0,
        categoryDefault: 2,
        iconCls: 'ui-icon-star',
        vCardEditor: null,
        contentEl: null,
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            if (this.contentEl === null) {
                this.contentEl = $(
                    '<div class="title">' + l10n.getString("notifications.emp.title") + '</div>' +
                    '<div class="description">' + l10n.getString("notifications.emp.content") + '</div>'
                );
            }

            return this.contentEl;
        },

        globalAction: function() {
            if (this.vCardEditor === null) {
                throw new Exception('EMP notification global action unreachable');
            }

            this.vCardEditor.open({
                element: this.contentEl,
                openCallback: function() {}
            });
        },

        setVCardEditor: function(vCardEditor) {
            this.vCardEditor = vCardEditor;
        },

        getName: function() {
            return 'EMPNotification';
        }
    });

    module.exports = EMPNotification;
}());


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);

/* globals jimdoData, diy */
(function () {
    'use strict';
    var ExternalWebsiteImportNotification = NotificationBase.extend({
        severityDefault: 3,
        categoryDefault: 1,
        stickyDefault: 1,
        iconCls: 'ui-icon-star',
        getCssClassSuffix: function() {
            return 'ext-website-import';
        },
        content: null,
        setContent: function(c) {
            this.content = c;
        },
        getContent: function () {
            var content = '<div></div>',
                payload = this.getPayload();
            if (this.content) {
                content = this.content
            } else {
                if (payload && payload.content) {
                    content = payload.content;
                }
            }
            return $(content);
        },
        globalAction: function () {
            /**
             * make a feature check first just to be sure
             */
        },
        setIconCls: function(iconCl) {
            this.iconCls = iconCl;
        },

        getName: function() {
            return 'ExternalWebsiteImportNotification';
        }
    });
    module.exports = ExternalWebsiteImportNotification;
}());


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);

/* globals jimdoData, diy */
(function () {
    'use strict';
    var ExternalWebsiteImportBlueNotification = NotificationBase.extend({
        /**
         * Default sticky
         */
        stickyDefault: 0,
        /**
         * Default severity
         */
        severityDefault: 1,
        /**
         *
         */
        flashNotification: true,
        /**
         * Default category for GuidanceNotification
         */
        categoryDefault: 1,
        /**
         *
         * @param resource
         */
        initialize: function(resource) {
            this._super(resource);
            this.bubbleOptions.autoHide = false;
            this.bubbleOptions.hideDelay = 0;
            this.bubbleOptions.closable = false;

            this.bubbleOptions.dismissCallback = null;
            this.bubbleOptions.clickCallback = null;
        },
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star-white',
        getCssClassSuffix: function() {
            return 'ext-website-import-blue';
        },
        getContent: function () {
            var content = '<div></div>',
                payload = this.getPayload();
            if (this.content) {
                content = this.content
            } else {
                if (payload && payload.content) {
                    content = payload.content;
                }
            }

            return $(content);
        },
        setIconCls: function(iconCl) {
            this.iconCls = iconCl;
        },

        getName: function() {
            return 'ExternalWebsiteImportBlueNotification';
        },
        globalAction: null
    });
    module.exports = ExternalWebsiteImportBlueNotification;
}());


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
(function() {

    var XingVouchersNotification = NotificationBase.extend({
        /**
         * Default sticky for XingVouchersNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for XingVouchersNotification
         */
        severityDefault: 4,
        /**
         * Default category for XingVouchersNotification
         */
        categoryDefault: 2,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getCssClassSuffix: function() {
            return 'xing-promo';
        },
        getContent: function() {
            var msgs = jimdoData.messages.xingPromo, $content = '';
            if (jimdoData.notificationData.hasOwnProperty('xingPromo')) {
                $content = $(
                    '<div class="title">' + msgs.title + '</div>' +
                    '<div class="description">' + msgs.content + '&nbsp;' + jimdoData.notificationData.xingPromo.voucherCode + '</div>' +
                    '<div class="button-bar cp-style">' +
                    '<button class="small blue-primary">' + msgs.label + '</button>' +
                    '</div>'
                );

                $content.find('button')
                    .button()
                    .bind('click', function() {
                        diy.util.redirector.redirect(jimdoData.notificationData.xingPromo.landingPageUrl);
                    });
            }

            return $content;
        },

        globalAction: false,

        getName: function() {
            return 'XingVouchersNotification';
        }
    });

    module.exports = XingVouchersNotification;
}());


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
var l10n = __webpack_require__(18);

/* globals jimdoData, diy */
(function () {
    'use strict';
    var WebComponentUpsellFinishedNotification = NotificationBase.extend({
        /**
         * Default sticky
         */
        stickyDefault: 0,
        /**
         * Default severity
         */
        severityDefault: 1,
        /**
         *
         */
        flashNotification: true,
        /**
         * Default category
         */
        categoryDefault: 1,
        /**
         *
         * @param resource
         */
        initialize: function(resource) {
            this._super(resource);
            this.bubbleOptions.autoHide = false;
            this.bubbleOptions.hideDelay = 0;
            this.bubbleOptions.closable = false;

            this.bubbleOptions.dismissCallback = null;
            this.bubbleOptions.clickCallback = null;
        },
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star-white',
        getCssClassSuffix: function() {
            return 'ext-website-import-blue';
        },
        getContent: function () {
            var payload = this.getPayload();
            var translationText = payload.translationKey + ".notification.description";
            var translationText2 = payload.translationKey + ".notification.description2";
            var translationLater = payload.translationKey + ".later";
            var translationYes = payload.translationKey + ".yes";

            var content = '<div class="notification-type-ext-website-import new button-bar cp-style">' +
                    '<div class="notification-type-ext-website-import-container">' +
                        l10n.getString(translationText) +
                        '<br/>' +
                        l10n.getString(translationText2) +
                    '</div>' +
                    '<div class="notification-type-ext-website-import-menu">' +
                        '<button id="notification-upsell-successful-close"' +
                            'class="small blue-secondary button migrationNotificationClose">' +
                            l10n.getString(translationLater) +
                        '</button>' +
                        '<button id="notification-upsell-successful-yes"' +
                            'class="small blue-primary button migrationNotificationClose">' +
                            l10n.getString(translationYes) +
                        '</button>' +
                    '</div>' +
                '</div>';

            return $(content);
        },
        setIconCls: function(iconCl) {
            this.iconCls = iconCl;
        },

        getName: function() {
            return 'WebComponentUpsellFinishedNotification';
        },
        globalAction: null
    });
    module.exports = WebComponentUpsellFinishedNotification;
}());


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var NotificationBase = __webpack_require__(647);
var l10n = __webpack_require__(18);

var SectionsWelcomeNotification = NotificationBase.extend({
    /**
     * Default sticky for CongratsNotification
     */
    stickyDefault: 0,
    /**
     * Default severity for CongratsNotification
     */
    severityDefault: 3,
    /**
     * Default category for CongratsNotification
     */
    categoryDefault: 2,
    /**
     * parameters for determining default operation,
     * if null or false, they are ignored
     */
    iconCls: 'ui-icon-star',
    /**
     * this method must be implemented by all Notifications
     */
    getContent: function() {
        var title = l10n.getString('section.welcomeNotification.title');
        var linkText = l10n.getString('section.welcomeNotification.linkText');

        var elementHtml =
            '<div class="title">' + title + '</div>' +
            '<a href="javascript:;">' + linkText + '</a>';

        return elementHtml;
    },

    globalAction: function() {
        $('#cc-sa-item-sections').click();
    },

    getName: function() {
        return 'SectionsWelcomeNotification';
    }
});

module.exports = SectionsWelcomeNotification;

/***/ },
/* 665 */
/***/ function(module, exports) {

(function() {
    'use strict';

    var NotificationQueue = Klazz.extend({
        _isReady: false,
        _readyQueue: null,

        initialize: function() {
            this._readyQueue = [];
        },

        /**
         * Similar to jQuery.ready, registers a method to be executed when the
         * data is loaded
         */
        ready: function(callback) {
            if (this._isReady) {
                callback();
                return;
            }

            this._readyQueue.push(callback);
        },

        process: function() {
            // We set isReady first to prevent cases when user calls ready inside ready
            this._isReady = true;
            this._readyQueue.forEach(function(callback) {
                try {
                    callback();
                } catch (e) {
                    // Silently catch errors because we don't want external code to
                    // break the queue
                    console && console.error && console.error(e);
                }
            });
            this._readyQueue = [];
        }
    });

    module.exports = NotificationQueue;
}());


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

/**
 * Toolbar - Notification Center - Bubble Manager class
 *
 * @depends extendClass.js
 * @depends diy.simpleTooltip.js
 * @depends toolbar.js
 */
(function() {
    'use strict';
    var BubbleMgr;

    var TOP_BUBBLE_SPACING = 25,
        BUBBLE_SPACING = 25;

    BubbleMgr = Klazz.extend({
        _bubbles: null,
        toolbar: null,
        layerManager: null,
        notificationIds: null,

        initialize: function(toolbar, layerManager) {
            // Only available in the editor toolbar
            if (diy.context.type != 'editor') {
                return;
            }

            this.toolbar = toolbar;
            this.layerManager = layerManager;

            this._bubbles = [];
            this.notificationIds = new Set();

            $('#diyToolbar').bind(
                'diy-editor-toolbar-repositioned',
                $.proxy(this._recalculateBubbleOffsets, this)
            );
        },

        /**
         * Pushes a new bubble to the manager
         *
         * TODO: add documentation for the parameter
         *
         * @param notificationData
         */
        pushBubble: function(notificationData) {
            var bubbleEl = this._createBubble(notificationData);
            this._addBubble(bubbleEl);
            if (notificationData.notificationId) {
                this.notificationIds.add(notificationData.notificationId);
            }

            this.layerManager.enqueue({
                priority: 1,
                callback: function() {
                    this.emitBubble(bubbleEl);
                }.bind(this),
                blocking: false
            });
        },

        bubbleExists: function(notificationId) {
            return this.notificationIds.has(notificationId);
        },

        getNotificationIds: function() {
            return this.notificationIds;
        },

        emitBubble: function(bubbleEl) {
            bubbleEl.diy_simpleTooltip('show');
            this._recalculateBubbleOffsets();
        },

        _recalculateBubbleOffsets: function() {
            var currentTop = TOP_BUBBLE_SPACING,
                currentPos, prevBubbleEl, i;

            for (i = this._bubbles.length - 1; i >= 0; --i) {
                if (i != this._bubbles.length - 1) {
                    prevBubbleEl = this._bubbles[i + 1].diy_simpleTooltip('widget');
                    currentTop += prevBubbleEl.innerHeight() + BUBBLE_SPACING;
                }

                // Remove bubbles which are outside the viewport
                /*if (currentTop > $(window).height()) {
                    this._destroyBubble(this._bubbles[i]);
                    this._removeBubble(this._bubbles[i]);
                    i--; //we removed something which will invalidate the current index
                    continue;
                }*/

                currentPos = this._bubbles[i].diy_simpleTooltip('option', 'position');
                this._bubbles[i].diy_simpleTooltip('option', 'position', $.extend(currentPos, {
                    offset: '25 ' + currentTop
                }));
            }
        },

        _addBubble: function(element) {
            this._bubbles.push(element);
        },

        _removeBubble: function(element) {
            var bubbles = this._bubbles;

            $.each(bubbles, function(index, bubble) {
                if (element === bubble[0]) {
                    bubbles.splice(index, 1);
                    return false;
                }
            })
        },

        /**
         * creates a bubble with the following options
         * - severity: severity css class (severity-*, where * = high,medium-high, medium, medium-low, low)
         * - icon: icon css class (a 16x16 icon is used)
         * - autoHide: true/false
         * - hideDelay: if autohide is true, time in ms until the bubble disappears
         * - dismissCallback: called when the bubble is closed
         * - clickCallback: called when the bubble is clicked
         * - content: content html string
         * - contentEl: content html element (alternative to content)
         */
        _createBubble: function(notificationData) {
            var self = this,
                hasClickHandler;

            hasClickHandler = typeof notificationData.clickCallback == 'function';

            if (typeof notificationData !== 'object') {
                throw new Error("Invalid data passed to _createBubble. Parameter must be an object");
            }

            if (typeof notificationData.closable !== "boolean") {
                notificationData.closable = true;
            }

            return $('<div></div>')
                .diy_simpleTooltip({
                    autoHide : notificationData.autoHide,
                    cls: 'diy-icon-tooltip notification-bubble ' + notificationData.severity +
                        (hasClickHandler ? ' global-action' : '') +
                        (notificationData.clsSuffix ? ' notification-type-' + notificationData.clsSuffix : ''),
                    anchorTarget: this.toolbar.getElement(),
                    positionMode: 'fixed',
                    //title: 'Sample notification',
                    content: notificationData.content ? notificationData.content : null,
                    contentEl: notificationData.contentEl ? notificationData.contentEl : null,
                    contentIcon: notificationData.icon,
                    closable: notificationData.closable,
                    position: {
                        my: "left top",
                        at: "left bottom"
                    },
                    fadeOutDelay: 400,
                    show: function() {
                        var contentEl = $(this).diy_simpleTooltip('getContentEl');

                        if (notificationData.autoHide) {
                            $(this).diy_simpleTooltip('delayHide', notificationData.hideDelay);
                        }

                        contentEl.unbind('.bubble');

                        contentEl
                            .bind('mouseenter.bubble', function() {
                                $(this).diy_simpleTooltip('clearTimer', 'hide');

                                var self = $(this);
                                $('.migrationNotificationClose').on('click', function() {
                                    self.diy_simpleTooltip('hide');
                                });
                            }.bind(this))
                            .bind('mouseleave.bubble', function() {
                                if (notificationData.autoHide) {
                                    $(this).diy_simpleTooltip('delayHide', notificationData.hideDelay);
                                }
                            }.bind(this));

                        if (typeof notificationData.clickCallback == 'function') {
                            contentEl
                                .bind('click.bubble', function() {
                                    // Prevent dismiss callback from triggering on hide
                                    notificationData.dismissCallback = null;
                                    $(this).diy_simpleTooltip('hide');
                                    notificationData.clickCallback();
                                }.bind(this));
                        }
                    },
                    afterhide: function() {
                        self._destroyBubble(this);
                        self._removeBubble(this);
                        self.notificationIds.delete(notificationData.notificationId);
                        self._recalculateBubbleOffsets();

                        if (typeof notificationData.dismissCallback == 'function') {
                            notificationData.dismissCallback();
                        }
                    },
                    zIndex: diy.editor.getNewTopZIndex()
                });
        },

        _destroyBubble: function(element) {
            $(element).diy_simpleTooltip('destroy');
        },

        destroyAllBubbles: function() {
            this._bubbles.forEach(function(bubble) {
                // prevent the dismiss callback from triggering on destroy
                bubble.unbind('simpletooltipafterhide');
                this._destroyBubble(bubble);
            }.bind(this));

            this._bubbles = [];
            this.notificationIds = new Set();
        }
    });

    module.exports = BubbleMgr;
}());


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

/**
 * This Javascript is responsible of rendering the notification when the site is not yet published
 */

var features = __webpack_require__(25);
var maintenanceMode = __webpack_require__(668);
var $ = __webpack_require__(3);

exports.init = function() {
    var n = diy.editor.notifications;
    n.api.ready(function() {
        var notPublishedNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_NOT_PUBLISHED);
        if (!(maintenanceMode.getState() && maintenanceMode.isFirstPublish())
            // Don't show this notification if we already have the no domain notification on
            || !features('domainConnected')
            || !jimdoData.notificationData.notPublished.show) {

            if (notPublishedNotifications.length > 0) {
                n.api.deleteNotificationByType(n.Notifications.TYPE_NOT_PUBLISHED);
            }
        } else {
            if (!jimdoData.notificationData.notPublished.triggerShow) {
                return;
            }

            if (notPublishedNotifications.length > 0) {
                n.api.updateNotification(notPublishedNotifications[0].getId(), { dismissed: 0 });
            } else {
                n.api.createNotification({type: n.Notifications.TYPE_NOT_PUBLISHED});
            }
        }
    });

    $(document).bind('diy-maintenance-mode-publish diy-guidedsetup-steps-completed', function() {
        var notPublishedNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_NOT_PUBLISHED);
        if (notPublishedNotifications.length > 0) {
            n.api.deleteNotificationByType(n.Notifications.TYPE_NOT_PUBLISHED);
        }
    });
};


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

/*global diy, jimdoData*/

var MaintenanceModeModel = __webpack_require__(669);

module.exports = new MaintenanceModeModel(jimdoData.webViewDisabled, jimdoData.neverPublished);


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

var rest = __webpack_require__(670);
var globalEvents = __webpack_require__(500);
var features = __webpack_require__(25);

var MaintenanceMode;

MaintenanceMode = Klazz.extend({
    /**
     * @type boolean true is maintenance is on (site is offline)
     */
    state: null,
    /**
     * @type boolean true if site is still in initial state (not published)
     */
    firstPublish: null,
    /**
     * @type boolean
     */
    loadingInProgress: null,

    /**
     * @param {Boolean} state
     * @param {Boolean} neverPublished
     */
    initialize: function(state, neverPublished) {
        this.firstPublish = neverPublished;
        this.loadingInProgress = false;
        this.state = state;
    },

    isFirstPublish: function() {
        return this.firstPublish;
    },

    //private
    setLoadingState: function(state) {
        this.loadingInProgress = !!state;
        globalEvents.trigger('diy-maintenance-loading-state-changed', [state]);
    },

    getLoadingState: function() {
        return this.loadingInProgress;
    },

    /**
     * @returns {Q.promise}
     */
    toggleState: function() {
        if (this.state) {
            jQuery(document.body).trigger('PublishWebsiteTried.BSA');
        }
        this.setLoadingState(true);

        return rest
            .toggleState()
            .then(function(state) {
                this.state = state;
                if (!state) {
                    jQuery(document.body).trigger('PublishWebsiteDone.BSA');
                }
                if (this.firstPublish) {
                    this.firstPublish = false;
                    globalEvents.trigger('diy-maintenance-mode-publish');
                }
                globalEvents.trigger('diy-maintenance-mode-changed', [this.state]);
                this.track(this.state);

                return this.state;
            }.bind(this))
            .fin(function() {
                this.setLoadingState(false);
            }.bind(this));
    },

    getState: function() {
        return this.state;
    },

    track: function(state) {
        globalEvents.trigger( 'diy-editor-generic-linkInteraction', {
            'actionName': !!state ? 'enableContructionPage' : 'disableConstructionPage'
        });
    }
});

module.exports = MaintenanceMode;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var websiteData = __webpack_require__(4);
var l10n = __webpack_require__(18);

module.exports = {
    toggleState: function() {
        var defer = Q.defer();

        $.ajax({
            type: 'post',
            dataType: 'json',
            accepts: {
                text: 'application/json'
            },
            contentType: 'application/vnd.oneandone.diy.website.switch.staging+json',
            url: '/rest/websites/' + websiteData.getId() + '/staging/',
            success: function(data) {
                defer.resolve(data.state);
            },
            error: function(response) {
                response.skipBlackError = true;

                var msgEl = $('<div></div>');
                msgEl.diy_messageDialog({
                    zIndex: diy.editor.getNewTopZIndex()
                });
                msgEl.diy_messageDialog('showErrorMessage', l10n.getString('timeout'));
                defer.reject();
            }
        });

        return defer.promise;
    }
};


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var features = __webpack_require__(25);

/* globals diy, script_basisID */
$(function () {

    //if chat feature is not available just return.
    if (!features('chatNotification')) {
        return;
    }
    var DISPLAY_DELAY = 120,
        countingCookie,
        COUNTING_COOKIE_NAME = 'diy-chatnotification-counting-' + script_basisID;

    if ($.cookie(COUNTING_COOKIE_NAME) === 'consumed') {
        return;
    }
    // create a start counting cookie //
    countingCookie = $.cookie(COUNTING_COOKIE_NAME);
    if (!countingCookie) {
        $.cookie(COUNTING_COOKIE_NAME, (new Date()).getTime() / 1000, {path: '/'});
    }

    // check the cookie until it's time to show the chat bar //
    setTimeout(function () {

        // put the cookie on shown - to not show again in this session //
        $.cookie(COUNTING_COOKIE_NAME, 'consumed', {path: '/'});

        // create chat notification when the time is right //
        var notifications = diy.editor.notifications;
        notifications.api.ready(function() {
            var noChatNotifications = notifications.api.getNotificationsByType(notifications.Notifications.TYPE_CHAT);
            if (noChatNotifications.length <= 0) {
                notifications.api.createNotification({type: notifications.Notifications.TYPE_CHAT});
            }
        });

    }, Math.max(
        ( DISPLAY_DELAY - ( ((new Date()).getTime() / 1000) - $.cookie(COUNTING_COOKIE_NAME) ) ) * 1000,
        0
    ));
});


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var features = __webpack_require__(25);

/* global diy, jimdoData */
$(document).ready(function () {

    $.construct('UpgradeBrowserMessage', function() {
        var browserVersionIE = 10,
            browserVersionFirefox = 20;

        this.init = function () {

            // if we don't need to show any messages just finish up
            if (!features("browserUpgrade")) {
                this.updateNotification(false);
                return;
            }

            if ('ontouchend' in document) {
                // we don't show anything if we are in mobile
                this.updateNotification(false);
                return;
            }

            // decide here if and what message we show and populate placeholder with actual message and links
            // if we decide to show it
            switch (true) {

                // IE //
                case $.browser.msie:
                    if (parseInt($.browser.version, 10) < browserVersionIE) {
                        this.updateNotification(true, 'upgrade', 'ie');
                    }
                    else {
                        // there is no need to show any upgrade messages so just remove the hidden message placeholder
                        this.updateNotification(false);
                        return;
                    }
                    break;

                // Firefox //
                case $.browser.mozilla:
                    if (parseInt($.browser.version, 10) < browserVersionFirefox) {
                        this.updateNotification(true, 'upgrade', 'firefox');
                    }
                    else {
                        // there is no need to show any upgrade messages so just remove the hidden message placeholder
                        this.updateNotification(false);
                        return;
                    }
                    break;

                // Chrome + Safari //
                case $.browser.webkit:
                    this.updateNotification(false);
                    return;

                default:
                    this.updateNotification(true, 'switch', 'firefox');
                    break;
            }
        },

        this.manageNotification = function(show, msgType, browserType) {
            var payload = features.getPayload("browserUpgrade");

            var n = diy.editor.notifications,
                browserNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_BROWSER_UPGRADE);

            if (!show) {
                if (browserNotifications.length > 0) {
                    n.api.ready(function() {
                        n.api.deleteNotificationByType(n.Notifications.TYPE_BROWSER_UPGRADE);
                    });
                }
            } else {
                if (browserNotifications.length <= 0 && !payload.doNotShow) {
                    n.api.ready(function() {
                        n.api.createNotification({type: n.Notifications.TYPE_BROWSER_UPGRADE, payload: {
                            'msgType': msgType,
                            'browserType': browserType
                        }});
                    });
                } else {
                    if (payload.counter >= payload.counterMax) {
                        n.api.ready(function() {
                            n.api.updateNotification(browserNotifications[0].getId(), {
                                dismissed: 0,
                                payload: {
                                    browserType: browserType,
                                    msgType: msgType
                                }
                            });
                        });
                    }
                }
            }
        };

        this.updateNotification = function (show, msgType, browserType) {
            diy.editor.notifications.api.ready(function() {
                this.manageNotification(show, msgType, browserType);
            }.bind(this));
        };

    });


});


/***/ },
/* 673 */
/***/ function(module, exports) {

/**
 * This Javascript is responsible of rendering domain connection modal dialog
 */
(function() {
    var n = diy.editor.notifications;
    n.api.ready(function() {
        var nodomainNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_NO_DOMAIN);
        if (jimdoData.features.domainConnected
            || !jimdoData.notificationData.noDomain.show) {

            if (nodomainNotifications.length > 0) {
                n.api.deleteNotificationByType(n.Notifications.TYPE_NO_DOMAIN);
            }
        } else {
            if (!jimdoData.notificationData.noDomain.triggerShow) {
                return;
            }

            if (nodomainNotifications.length > 0) {
                n.api.updateNotification(nodomainNotifications[0].getId(), { dismissed: 0 });
            } else {
                n.api.createNotification({type: n.Notifications.TYPE_NO_DOMAIN});
            }
        }
    });
}());


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 *
 */
diy.angular.registerDirective('diynotification', ['diyl10n', function(diyl10n) {
    var tpl =
        '<div class="notification-wrapper" ng-class="getNotificationClasses(notif)" ng-click="notificationAction(notif)">'+
            '<span class="notification-icon ui-icon" ng-class="notif.iconCls"></span>' +
            '<a ng-if="!notif.getSticky()" class="close-icon ui-icon ui-icon-close-small" ng-click="deleteNotification(notif.getId()); $event.stopPropagation();" title="' + diyl10n('notifications.delete') + '"></a>'+
            '<div class="notification-content standard-spacing" >' +
                '<div class="content"></div>' +
            '</div>' +
        '</div>';

    return {
        restrict: 'A',
        scope: true,
        template: tpl,
        link: function(scope, element, attrs) {
            var notification = scope.notif;

            // add content to template
            var $element = $(element);
            $element.hover(function () {
                $(this).addClass('notification-hover');
            }, function() {
                $(this).removeClass('notification-hover');
            });
            var $content = notification.getContent();
            $element.find('.content').html($content);

            scope.getNotificationContent = function() {
                var c = notification.getContent();
                if (c instanceof jQuery) {
                    return c.html();
                }
                return c;
            }

            scope.$watch(function() {
                return scope.getNotificationContent();
            }, function(n) {
                if (n) {
                    var c = notification.getContent();
                    $element.find('.content').html(c);
                }
            });

            scope.getNotificationClasses = function(notif) {
                var classes = {};
                classes['notification-type-' + notif.getCssClassSuffix()] = !!notif.getCssClassSuffix();
                classes[notif.getSeverityClass()] = true;
                classes['with-icon'] = notif.iconCls;
                classes['sticky-notification'] = notif.getSticky();
                classes['global-action'] = typeof notif.globalAction === 'function';
                return classes;
            };
        }
    };
}]);


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/* global diy */
(function() {
    'use strict';

    var toolbar;
    var layerManager;

    var module = angular.module('diy.notification', ['ngResource']);

    module.factory('websiteId', function() {
        return window.script_basisID;
    });

    //Copy paste from file manager
    module.config(["$httpProvider", function($httpProvider) {
        var defaultHeaders = $httpProvider.defaults.headers;
        defaultHeaders.common['X-DiyCSRFToken'] = jimdoData.cstok;
        // this header is essential in session expiration handling
        defaultHeaders.common['X-Requested-With'] = 'XMLHttpRequest';
        /**
         * this assures that the angular app will route all error $http's through session expiry js check
         */
        $httpProvider.interceptors.push(diy.editor.session.angularHandleExpired);
    }]);

    module.run(['ntfApi', function(ntfApi) {
        var ns = diy.core.namespace('diy.editor.notifications.api');
        ns.createNotification = $.proxy(ntfApi.createNotification, ntfApi);
        ns.getNotificationInfo = $.proxy(ntfApi.getNotificationById, ntfApi);
        ns.getNotificationsByType = $.proxy(ntfApi.getNotificationsByType, ntfApi);
        ns.deleteNotification = $.proxy(ntfApi.deleteNotification, ntfApi);
        ns.updateNotification = $.proxy(ntfApi.updateNotification, ntfApi);
        ns.deleteNotificationByType = $.proxy(ntfApi.deleteNotificationByType, ntfApi);
        ns.pause = $.proxy(ntfApi.pause, ntfApi);
        ns.resume = $.proxy(ntfApi.resume, ntfApi);
    }]);

    module.service('ntfRest', ['$resource', '$http', 'websiteId', function($resource, $http, websiteId) {
        var baseUrl = '/rest/websites/' + websiteId + '/notification';
        var resource = $resource(baseUrl + '/:id', {
            id: '@id'
        }, {
            'create': {method: 'POST'},
            'update': {method: 'PUT'},
            'markread': {method: 'PUT', params: {id: 'markread'}},
            'markdismissed': {method: 'PUT', params: {id: 'markdismissed'}},
            'batchSoftDelete': {method: 'PUT', params: {id: 'batchSoftDelete'}}
        });

        resource.batchDelete = function(ids) {
            return $http({
                method: 'DELETE',
                url: baseUrl,
                data: {ids: ids}
            });
        };

        resource.deleteByType = function(type) {
            return $http({
                method: 'DELETE',
                url: baseUrl,
                data: {type: type}
            });
        };

        return resource;
    }]);

    var ntfMgrInst;

    module.service('ntfBubbleManager', function() {
        return new diy.editor.notifications.BubbleManager(toolbar, layerManager);
    });

    module.factory('ntfNotificationFactory', function() {
        return diy.editor.notifications.NotificationFactory;
    });

    module.factory('ntfQueue', function() {
        return diy.editor.notifications.queue;
    });

    diy.angular.loadFactories(module, ['diyglobalevents']);

    module.service('ntfApi',
        ['$rootScope', 'diyglobalevents', 'ntfRest', 'ntfBubbleManager', 'ntfNotificationFactory', 'ntfQueue',
        function($rootScope, diyglobalevents, ntfRest, ntfBubbleManager, ntfNotificationFactory, ntfQueue) {
        var NotificationMgr = Klazz.extend({
            notifications: null,
            flashNotifications: null,
            bubbleManager: null,
            pauseMode: false,
            existingBubblesOnPause: null,
            /**
             * Flag which tells if the list of notifications is fully initialized
             * e.g. notification list was loaded from the server and it was updated
             * by ntfQueue.ready hooks
             */
            notificationsInitialized: null,

            initialize: function() {
                this.notifications = [];
                this.flashNotifications = [];
                this.notificationsInitialized = false;
                this.initBubbleManager();
            },

            initBubbleManager: function() {
                this.bubbleManager = ntfBubbleManager;
            },

            loadNotifications: function(success) {
                ntfRest.query(function(resources) {
                    this.notifications = [];

                    $.each(resources, function(i, resource) {
                        this.notifications.push(
                            ntfNotificationFactory.create(resource)
                        );
                    }.bind(this));

                    if(!this.isPaused()) {
                        this._emitBubbles();
                    }
                    this.notificationsInitialized = true;

                    ntfQueue.process();

                    if (typeof success == 'function') {
                        success(this.notifications);
                    }

                }.bind(this));
            },

            isPaused: function() {
                return this.pauseMode;
            },

            pause: function() {
                if (this.pauseMode) {
                    return;
                }
                this.pauseMode = true;
                this.existingBubblesOnPause = this.bubbleManager.getNotificationIds();
                this.markAllAsDismissed();
            },

            resume: function() {
                if (!this.pauseMode) {
                    return;
                }
                this.pauseMode = false;
                if (this.existingBubblesOnPause != null) {
                    this.existingBubblesOnPause.forEach(function(i) {
                        try {
                            this.updateNotification(i, {dismissed: false});
                        } catch (e) {
                            // the error is most probably triggered by attempt to update
                            // a non existing notification or id=null
                            // instead to raise the error we prefer to silent fail because
                            // the cause of this was allready treated at the cause
                        }
                        this.existingBubblesOnPause.delete(i);
                    }.bind(this));
                }
                this._emitBubbles();
            },

            getNotificationById: function(id) {
                var ret = false;
                this.notifications.some(function(notification) {
                    if (notification.getId() == id) {
                        ret = notification;
                        return true;
                    }
                    return false;
                });

                if (!ret) {
                    throw new Error("No notification found with id " + id);
                }

                return ret;
            },

            createNotification: function(options, success) {
                if (typeof options !== 'object') {
                    throw new Error("Options is not an object");
                }

                if (!options.type) {
                    throw new Error("Must specify the notification type");
                }

                var n = ntfNotificationFactory.create(options.type);

                //TODO: filter and validate options
                var notifItem = new ntfRest({
                    type: options.type,
                    category: options.category ? options.category : n.getCategory(),
                    severity: options.severity ? options.severity : n.getSeverity(),
                    sticky: options.sticky ? (options.sticky ? 1 : 0) : n.getSticky(),
                    payload: options.payload ? options.payload : n.getPayload(),
                    read: options.read ? (options.read ? 1 : 0) : n.getRead(),
                    dismissed: options.dismissed ? (options.dismissed ? 1 : 0) : n.getDismissed(),
                    deleted: options.deleted ? (options.deleted ? 1 : 0) : n.getDeleted()
                });

                n.setResource(notifItem);

                if (!n.flashNotification) {
                    this.notifications.push(n);

                    notifItem.$save(function() {
                        if (this.notificationsInitialized && !this.isPaused()) {
                            this._emitBubble(n);
                        }
                        //$scope.unreadDirty = true;
                        if (typeof success == 'function') {
                            success(notifItem.id);
                        }
                    }.bind(this));
                } else {
                    if (this.notificationsInitialized && !this.isPaused()) {
                        this._emitBubble(n);
                    }
                }
                return n;
            },

            updateNotification: function(id, data, success) {
                var notification = this.getNotificationById(id),
                    wasDismissed = notification.getDismissed();

                if (typeof data.severity !== 'undefined') {
                    notification.setSeverity(data.severity);
                }

                if (typeof data.dismissed !== 'undefined') {
                    notification.setDismissed(data.dismissed ? 1 : 0);
                }

                if (typeof data.sticky !== 'undefined') {
                    notification.setSticky(data.sticky ? 1 : 0);
                }

                if (typeof data.read !== 'undefined') {
                    notification.setRead(data.read ? 1 : 0);
                }

                if (typeof data.payload !== 'undefined') {
                    notification.setPayload(data.payload);
                }

                var ntfInitialized = this.notificationsInitialized;
                notification._resource.$update(function() {
                    if (!notification.getDismissed() && wasDismissed && ntfInitialized && !this.isPaused()) {
                        this._emitBubble(notification);
                    }

                    $rootScope.$broadcast('notifications-changed');
                    if (typeof success == 'function') {
                        success(notification);
                    }
                }.bind(this));
            },

            deleteNotification: function(id, success) {
                var notification = this.getNotificationById(id),
                // Leave this here, we don't want a reference to notification in the closure
                    elementIndex = this.notifications.indexOf(notification);

                if (notification.softDeletion) {
                    notification.setDeleted(1);
                    notification._resource.$update(function() {
                        $rootScope.$broadcast('notifications-changed');
                        if (typeof success == 'function') {
                            success(notification);
                        }
                    });
                } else {
                    notification._resource.$delete(function() {
                        this.notifications.splice(elementIndex , 1);
                        if (typeof success == 'function') {
                            success(notification);
                        }
                    }.bind(this));
                }
            },

            deleteNotificationByType: function(type) {
                var softDeletion = false;
                var ids = [];
                this.notifications = this.notifications.filter(function(notification) {
                    if (notification._resource.type == type) {
                        softDeletion = notification.softDeletion;
                        notification.setDeleted(1);
                        ids.push(notification.getId());
                        return softDeletion;
                    } else {
                        return true;
                    }
                });

                if (softDeletion) {
                    ntfRest.batchSoftDelete({ids: ids});
                    $rootScope.$broadcast('notifications-changed');
                } else {
                    ntfRest.deleteByType(type);
                }
            },

            deleteNotificationByCategory: function(category) {
                var deleteIds = [],
                    softDeleteIds = [];
                this.notifications = this.notifications.filter(function(notification) {
                    if (notification.getSticky()) {
                        return true;
                    }
                    if (notification.getCategory() == category) {
                        notification.setDeleted(1);
                        if (notification.softDeletion) {
                            softDeleteIds.push(notification.getId());
                        } else {
                            deleteIds.push(notification.getId());
                        }
                        return notification.softDeletion;
                    } else {
                        return true;
                    }
                });
                if (softDeleteIds.length > 0) {
                    ntfRest.batchSoftDelete({ids: softDeleteIds});
                    $rootScope.$broadcast('notifications-changed');
                }
                if (deleteIds.length > 0) {
                    ntfRest.batchDelete(deleteIds);
                }
            },

            getNotificationsByType: function(type) {
                var ret = [];
                this.notifications.some(function(notification) {
                    if (notification._resource.type == type) {
                        ret.push(notification);
                    }
                });
                return ret;
            },

            getUnreadNotifications: function() {
                return this.notifications.filter(function(notification) {
                    return notification.getRead() === 0;
                });
            },

            getUnreadCount: function() {
                return this.getUnreadNotifications().length;
            },

            markAllAsRead: function() {
                var currentCount = this.getUnreadCount();

                if (currentCount == 0) {
                    // prevent an unnecessary request to the server
                    return;
                }

                var unreadNotifications = this.getUnreadNotifications();
                var ids = [];
                unreadNotifications.forEach(function(notification) {
                    ids.push(notification.getId());
                });

                ntfRest.markread({
                    ids: ids
                }, function() {
                    unreadNotifications.forEach(function(notification) {
                        notification.setRead(1);
                    });
                });
            },

            markAllAsDismissed: function() {
                var nonDismissedIds = [];
                this.notifications.forEach(function(notification) {
                    if (!notification.getDismissed()) {
                        nonDismissedIds.push(notification.getId());
                        notification.setDismissed(1);
                    }
                });

                if (nonDismissedIds.length === 0) {
                    return;
                }

                this.bubbleManager.destroyAllBubbles();

                ntfRest.markdismissed({
                   ids: nonDismissedIds
                });
            },

            _emitBubbles: function() {
                $.each(this.notifications, function(i, notification) {
                    this._emitBubble(notification);
                }.bind(this));
            },

            _emitBubble: function(notification) {
                if (notification.getDeleted() || notification.getDismissed()) {
                    return false;
                }

                if (diy.editor.notifications.notificationCenter.isLayerOpened()) {
                    if (notification.getId()) {
                        this.updateNotification(notification.getId(), { dismissed: 1 });
                    }
                    return false;
                }

                if (this.bubbleManager.bubbleExists(notification.getId())) {
                    return false;
                }

                var clickCallback = notification.bubbleOptions.clickCallback;
                if (typeof clickCallback === "undefined") {
                    clickCallback = function() {
                        if ($.isFunction(notification.globalAction)) {
                            $(document).trigger('diy-editor-generic-sectionAccessed', {
                                sectionCodeName: 'notificationClicked',
                                propName: notification.getName()
                            });

                            notification.globalAction();
                        }

                        if (notification.getId()) {
                            this.updateNotification(notification.getId(), {
                                dismissed: 1,
                                read: 1
                            });
                        }
                    }.bind(this);
                }

                var content = notification.getContent();
                var isContentEl = content instanceof $;

                this.bubbleManager.pushBubble({
                    notificationId: notification.getId(),
                    severity: notification.getSeverityClass(),
                    icon: (notification.iconCls ? notification.iconCls : null),
                    autoHide: notification.bubbleOptions.autoHide,
                    hideDelay: notification.bubbleOptions.hideDelay,
                    dismissCallback: notification.bubbleOptions.dismissCallback,
                    content: isContentEl ? undefined : content,
                    contentEl: isContentEl ? content.clone(true) : null,
                    clickCallback: clickCallback,
                    clsSuffix: notification.getCssClassSuffix(),
                    closable: notification.bubbleOptions.closable
                });
                return true;
            }
        });

        //Make sure the service always returns the same instance. Otherwise,
        //it will make new instances for each angular module instance
        if (!ntfMgrInst) {
            ntfMgrInst = new NotificationMgr();
        }

        //return new NotificationMgr();
        return ntfMgrInst;

    }]);

    exports.setToolbar = function(_toolbar) {
        toolbar = _toolbar;
    };

    exports.setLayerManager = function(_lm) {
        layerManager = _lm;
    };

}());


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 * Notification Flyout
 */
(function(){

    var flyout = angular.module('diy.notification.flyout', ['ngSanitize', 'diy.notification']);

    diy.angular.loadFactories(flyout, ['diyl10n']);
    diy.angular.loadDirectives(flyout, [ 'diynotification' ]);

    flyout.filter('isEmpty', function() {
        return $.isEmptyObject;
    });

    flyout.controller('NotificationFlyoutCtrl', [
        '$scope', '$timeout', 'ntfApi', function($scope, $timeout, ntfApi) {

        /**
         * Refreshes the squeeze box + scrollbar when view changes
         */
        var refreshScroller = function() {
            // We use timeout to update the squeezebox after content has stabilized
            // and Angular has finished rendering the elements. We don't have
            // ngAnimate in 1.0.5 so we can't hook to ngShow
            $timeout(function() {
                diy.editor.notifications.notificationCenter.refreshScroller();
            });
        };

        $scope.categories = {};
        $scope.notifications = {};

        $scope.categories = jimdoData.notification.categories;

        var formatNotifications = function() {
            if (!ntfApi.notifications) {
                return;
            }
            var formattedNotification = {};
            $.each($scope.categories, function(i, cat) {
                cat.permitDeleteAll = false;
            });
            $.each(ntfApi.notifications, function(i, model) {
                if (model.getDeleted()) {
                    return true;
                }
                if (!formattedNotification[model.getCategory()]) {
                    formattedNotification[model.getCategory()] = [];
                }
                if (!model.getSticky()) {
                    permitDeleteAll(model.getCategory());
                }
                formattedNotification[model.getCategory()].push(model);
                return true;
            });
            $scope.notifications = formattedNotification;
        };

        var permitDeleteAll = function(category) {
            $.each($scope.categories, function(i, cat) {
                if (cat.id == category) {
                    cat.permitDeleteAll = true;
                }
            });
        };

        var notificationUpdateHandler = function() {
            formatNotifications();
            refreshScroller();
        };

        $scope.$watchCollection(function() { return ntfApi.notifications; }, notificationUpdateHandler);
        $scope.$on('notifications-changed', notificationUpdateHandler);

        ntfApi.loadNotifications();

        $scope.notificationAction = function(notif) {
            if (typeof notif.globalAction === 'function') {
                if (diy.tracking) {
                    diy.tracking.addEventSuppression('diy-editor-notification-center-closed');
                }
                $(document).trigger('diy-editor-generic-sectionAccessed', {
                    sectionCodeName: 'notificationClicked',
                    propName: notif.getName()
                });

                diy.editor.notifications.notificationCenter.hideLayer();

                notif.globalAction();
            } else if (typeof notif.globalAction === 'boolean' && notif.globalAction === false) {
                $(document).trigger('diy-editor-generic-sectionAccessed', {
                    sectionCodeName: 'notificationClicked',
                    propName: notif.getName()
                });
            } else {
                return;
            }
        };

        $scope.$watch('getUnreadCount()', function() {
            //HACK: at the first call the notification center is not yet exposed
            // on the global scope, because that's done after the first render
            $timeout(function() {
                diy.editor.notifications.notificationCenter.updateUnreadCountBubble($scope.getUnreadCount());
            });
        });

        // Used by flyout
        $scope.getUnreadCount = function() {
            return ntfApi.getUnreadCount();
        };

        // Used by flyout notification directive
        $scope.deleteNotification = function(id) {
            ntfApi.deleteNotification(id);
        };

        // Used by flyout
        $scope.deleteNotificationByCategory = function(category) {
            ntfApi.deleteNotificationByCategory(category);
        };
    }]);

    /*
     * We configure the location service to use html5mode, which avoids a nasty
     * bug where angular would prepend a slash to the hashbang
     * (e.g. #/hm:cc-sa-item-elements), breaking the existing history manager
     * This avoids hacking the angular.js file with the "remove forwardslash" patch
     * (see the file in the folder where angular.js resides)
     */
    flyout.config(['$locationProvider', function($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }]);

    //TODO: put this template in a separate html file
    flyout.run(['$templateCache', 'diyl10n', function($templateCache, diyl10n) {

        $templateCache.put('notificationFlyout.html',
            '<div class="notificationCenter-wrapper" ng-hide="notifications | isEmpty">' +
                '<div class="category" ng-repeat="cat in categories" ' +
                    'ng-if="notifications[cat.id].length > 0">' +
                    //TODO: abstract squeezebox markup
                    '<div class="diye-collapsible-category-header">' +
                        '<div class="diye-collapsible-category-positioned">' +
                            '<div class="diye-collapsible-category-title">' +
                                '<span ng-bind-html="cat.label"></span> ' +
                                '<span class="result-count">({{notifications[cat.id].length}})</span>' +
                            '</div>' +
                            '<a ng-show="cat.permitDeleteAll" style="position:absolute;right:55px;top:5px;" '+
                                'class="close-icon ui-icon ui-icon-close-small" title="' + diyl10n('notifications.deleteAll') + '"'+
                                'ng-click="deleteNotificationByCategory(cat.id)"></a>' +
                            '<div class="diye-collapsible-category-pointer"></div>' +
                            '<div class="diye-collapsible-category-arrow"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="diye-collapsible-category-content" >' +

                        '<ul class="notifications">' +
                            '<li diynotification class="notification" ng-repeat="notif in notifications[cat.id]" >' +
                            '</li>' +
                        '</ul>' +

                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="no-notifications-wrapper" ng-show="notifications | isEmpty">' +
                '<div class="no-notifications">' +
                    '<h3 class="subheading">' + diyl10n('notifications.zeroNotifications') + '</h3>' +
                '</div>' +
            '</div>'
        );
    }]);
}())


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 * Notification
 *
 * @depends toolbar.js
 * @depends notification-module.js
 */
(function() {

    var NotificationCenter;

    NotificationCenter = Klazz.extend({
        options: {},
        toolbar: null,
        element: null,
        messages: {

        },
        /**
         * Element that trigger opening/closing of Notification Center
         */
        bell: null,
        /**
         * Element used as root for angular module (inside layer)
         */
        ngRootEl: null,

        initialize: function(toolbar) {
            this.toolbar = toolbar;
            // Only available in the editor toolbar
            if (diy.context.type != 'editor') {
                return;
            }

            // note: we break object reference
            this.options = $.extend(true, {}, this.options);

            // get translations //
            // note: we break object reference
            // this.messages = $.extend(true, {}, this.messages, jimdoData.messages.notificationCenter);

            this.draw();
        },
        updateUnreadCountBubble: function(number) {
            var count = parseInt(number, 10),
                countText;

            var unreadBubble = this.element.find('.unread-count');

            if (count === 0) {
                unreadBubble.hide();
            } else {
                unreadBubble.show();
            }

            if (count > 9) {
                countText = '9+';
            } else {
                countText = count;
            }
            unreadBubble.html(countText);
        },

        draw: function() {
            var elementHtml = '' +
            '<div class="notificationBellContainer">' +
                '<a class="notificationBell" title="' + jimdoData.messages.toolbar.tooltipNotifications + '">' +
                    '<div class="icon"></div>' +
                    '<span class="unread-count"></span>' +
                '</a>' +
            '</div>' +
            '<div class="spacer"><div class="icon"></div></div>';
            this.element = this.toolbar.pushToPanel('left', elementHtml, true);

            this.bell = this.element.find('.notificationBell');

            this.bell
            .bind('click', $.proxy(this._toggleLayer, this))
            .diy_calloutLayer({
                //lazyRender: true,
                cls: 'diye-toolbar-notificationCenter',
                anchorTarget: this.bell,
                positionMode: 'fixed',
                position: {
                    my: 'left top',
                    at: 'left bottom',
                    offset: (diy.editor.uiPreference.isPointerModeTouch() ? '-6 8' : '-10 3')
                },
                render: $.proxy(this._renderLayer, this),
                show: $.proxy(function() {
                    this.bell.addClass('callout-open');
                    this.markAllAsRead();
                    this.dismissAllBubbles();
                    $(document).trigger('diy-editor-generic-sectionAccessed', {
                        sectionCodeName: 'notificationCenter'
                    });
                }, this),
                hide: $.proxy(function() {
                    if (this.bell.hasClass('callout-open')) {
                        this.bell.removeClass('callout-open');
                        $(document).trigger('diy-editor-notification-center-closed');
                    }
                }, this)
            });

            this.bell.diy_calloutLayer('render');
            $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));
        },

        _getLayerTemplate: function() {
            // The template is defined inline in the angular module
            return '<div ng-controller="NotificationFlyoutCtrl" ng-include="\'notificationFlyout.html\'"></div>';
        },

        _renderLayer: function(e, layer) {
            var contentEl = layer.getContentEl();

            if (!contentEl) {
                return;
            }

            this.ngRootEl = $(this._getLayerTemplate()).appendTo(contentEl);
            angular.bootstrap(this.ngRootEl, ['diy.notification.flyout']);

            contentEl.diy_scrollHandle();
        },

        isLayerOpened: function() {
            return this.bell.diy_calloutLayer("isVisible");
        },

        _toggleLayer: function() {
            var visible = this.bell.diy_calloutLayer("isVisible");
            this.bell.diy_calloutLayer(visible ? 'hide' : 'show');
            this.refreshScroller();
        },

        hideLayer: function() {
            this.bell.diy_calloutLayer('hide');
        },

        // Public API (called by angular controller)
        refreshScroller: function() {
            var contentEl = this.bell.diy_calloutLayer('getContentEl');

            if (!contentEl || !this.bell.diy_calloutLayer('isVisible')) {
                return;
            }

            contentEl
                .trigger('contentchanged')
                .diy_alwaysInViewBehavior({
                    clickToOpen: true,
                    fixableSelector: '.diye-collapsible-category-header',
                    fixedClassName: 'fixed',
                    activeClassName: 'active'
                });
        },

        _positionLayer: function() {
            this.bell.diy_calloutLayer('refresh');
        },

        markAllAsRead: function() {
            angular.injector(['diy.notification']).invoke(['ntfApi', function(ntfApi) {
                ntfApi.markAllAsRead();
            }]);
        },

        dismissAllBubbles: function() {
            angular.injector(['diy.notification']).invoke(['ntfApi', function(ntfApi) {
                ntfApi.markAllAsDismissed();
            }]);
        }
    });

    module.exports = NotificationCenter;
}());


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var LayerProxy_1 = __webpack_require__(679);
var AutoLayerManager = (function () {
    function AutoLayerManager() {
        this.queue = [];
        this.interfaceBlocked = true;
    }
    AutoLayerManager.prototype.blockInterface = function () {
        this.interfaceBlocked = true;
    };
    AutoLayerManager.prototype.unblockInterface = function () {
        this.interfaceBlocked = false;
    };
    AutoLayerManager.prototype.unblockAndProcessQueue = function () {
        this.unblockInterface();
        this.processQueue();
    };
    AutoLayerManager.prototype.enqueue = function (l) {
        var lp;
        if (l instanceof LayerProxy_1.default) {
            lp = l;
        }
        else {
            lp = new LayerProxy_1.default(l);
        }
        this.queue.push(lp);
        this.queue.sort(function (a, b) {
            return a.getPriority() - b.getPriority();
        });
        this.processQueue();
    };
    AutoLayerManager.prototype.dequeue = function () {
        return this.queue.pop();
    };
    AutoLayerManager.prototype.processQueue = function () {
        while (!this.isInterfaceBlocked() && this.queue.length > 0) {
            this.activeLayer = this.dequeue();
            if (this.activeLayer.getBlocking()) {
                this.blockInterface();
            }
            this.activeLayer.runCallback();
        }
    };
    AutoLayerManager.prototype.isInterfaceBlocked = function () {
        return this.interfaceBlocked === true;
    };
    AutoLayerManager.prototype.getInterfaceBlocked = function () {
        return this.interfaceBlocked;
    };
    AutoLayerManager.prototype.setInterfaceBlocked = function (stat) {
        this.interfaceBlocked = stat;
    };
    return AutoLayerManager;
}());
exports.default = AutoLayerManager;


/***/ },
/* 679 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var LayerProxy = (function () {
    function LayerProxy(opts) {
        this.name = 'unnamed';
        this.priority = 1;
        this.blocking = true;
        this.callbackCalled = false;
        this.callbackCalled = false;
        this.setOptions(opts);
    }
    LayerProxy.prototype.setOptions = function (options) {
        if (options.name) {
            this.setName(options.name);
        }
        if (options.callback) {
            this.setCallback(options.callback);
        }
        if (options.priority) {
            this.setPriority(options.priority);
        }
        if (typeof options.blocking !== 'undefined') {
            this.setBlocking(options.blocking);
        }
    };
    LayerProxy.prototype.setName = function (name) {
        this.name = name;
    };
    LayerProxy.prototype.setCallback = function (callback) {
        if (typeof callback === 'function') {
            this.callback = callback;
        }
    };
    LayerProxy.prototype.setPriority = function (priority) {
        this.priority = priority;
    };
    LayerProxy.prototype.setBlocking = function (block) {
        this.blocking = block;
    };
    LayerProxy.prototype.getName = function () { return this.name; };
    LayerProxy.prototype.getCallback = function () { return this.callback; };
    LayerProxy.prototype.getPriority = function () { return this.priority; };
    LayerProxy.prototype.getBlocking = function () { return this.blocking; };
    LayerProxy.prototype.runCallback = function (force) {
        if (force === void 0) { force = false; }
        if (this.callbackCalled && !force) {
            return;
        }
        this.callback();
        this.callbackCalled = true;
    };
    return LayerProxy;
}());
exports.default = LayerProxy;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var features = __webpack_require__(25);
var StateButton_1 = __webpack_require__(681);
var RaisedButton_1 = __webpack_require__(482);
/** @deprecated */
var NTFCenterObserver_1 = __webpack_require__(682);
/** to remove when the old notifications are no longer used */
var Notifier_1 = __webpack_require__(683);
var SiteAdminObserver_1 = __webpack_require__(684);
var PagesEditorObserver_1 = __webpack_require__(685);
var NotificationCenterObserver_1 = __webpack_require__(583);
var Status_1 = __webpack_require__(584);
var DataStorage_1 = __webpack_require__(585);
var Backend_1 = __webpack_require__(586);
var DialogController_1 = __webpack_require__(686);
var StartDialog_1 = __webpack_require__(687);
var TransferDialog_1 = __webpack_require__(690);
var AssistanceDialog_1 = __webpack_require__(691);
var ErrorView_1 = __webpack_require__(692);
var RunningView_1 = __webpack_require__(694);
var SuccessView_1 = __webpack_require__(697);
var WaitingView_1 = __webpack_require__(698);
var LongerWaitingView_1 = __webpack_require__(699);
var AssistanceView_1 = __webpack_require__(701);
var ImportProcedure = (function () {
    function ImportProcedure() {
        this.pollingInterval = 2000;
    }
    ImportProcedure.prototype.openManagePages = function () {
        diy.editor.deeplinking.requestPath([
            { label: "siteadmin", params: "pages" }
        ]);
    };
    ImportProcedure.prototype.openContact = function () {
        diy.editor.deeplinking.requestPath([
            { label: "siteadmin", params: "contact" }
        ]);
    };
    ImportProcedure.prototype.openUpsellPopup = function () {
        diy.editor.tariffUpdate.openPopup({
            component: "siteAdminWebsiteMigration"
        });
    };
    ImportProcedure.prototype.goToControlPanel = function () {
        diy.util.redirector.redirectToLabel("control_panel_redirect_mywebsite_overview", true, false);
    };
    ImportProcedure.prototype.goToHomepage = function () {
        var homePageId = jimdoData.navigation.pages[0].pageId;
        var currentPageId = parseInt(document.body.getAttribute("data-pageId"), 10);
        if (currentPageId !== homePageId) {
            location.href = cc_.properties.cmsUrl + "app/" + script_basisID + "/" + homePageId;
        }
    };
    ImportProcedure.prototype.setPollingInterval = function (pollingInterval) {
        if (pollingInterval === void 0) { pollingInterval = 2000; }
        this.pollingInterval = pollingInterval;
    };
    ImportProcedure.prototype.setWebsiteId = function (websiteId) {
        this.websiteId = websiteId;
    };
    ImportProcedure.prototype.setNotifier = function (n) {
        this.notifier = n;
    };
    ImportProcedure.prototype.setStatusProvider = function (sp) {
        this.statusProvider = sp;
    };
    ImportProcedure.prototype.getImportStatusFromData = function (data) {
        return this.statusProvider.getStatus(data["status-code"]);
    };
    ImportProcedure.prototype.getImportUrlFromData = function (data) {
        for (var i = 0; i < data["crawlable-urls"].length; i++) {
            var crawlableUrl = data["crawlable-urls"][i];
            switch (crawlableUrl.type) {
                case Backend_1.ImportType.WSC:
                case Backend_1.ImportType.WSB:
                    return crawlableUrl.url;
                default:
                    break;
            }
        }
        return null;
    };
    ImportProcedure.prototype.init = function (websiteId, notificationApi) {
        var siteAdminObserver = new SiteAdminObserver_1.default;
        var importNotifier = new Notifier_1.default;
        importNotifier.registerObserver(PagesEditorObserver_1.pagesEditorObserver);
        importNotifier.registerObserver(siteAdminObserver);
        if (features("notificationsNG")) {
            importNotifier.registerObserver(NotificationCenterObserver_1.notificationCenterObserver);
        }
        else {
            var notificationCenter = new NTFCenterObserver_1.default;
            notificationCenter.setNotificationType(15);
            notificationCenter.setNotificationApi(notificationApi);
            importNotifier.registerObserver(notificationCenter);
        }
        this.setNotifier(importNotifier);
        this.setStatusProvider(new Status_1.default());
        this.setWebsiteId(websiteId);
        this.processStatus();
    };
    ImportProcedure.prototype.processStatus = function () {
        var _this = this;
        Backend_1.default.getExternalImportData(this.websiteId)
            .then(function (data) {
            _this.statusHandler(data);
        });
    };
    ImportProcedure.prototype.statusHandler = function (data) {
        var _this = this;
        var newStatus = this.getImportStatusFromData(data);
        var statusHasChanged = (newStatus !== this.currentStatus);
        this.currentStatus = newStatus;
        this.crawlingUrl = this.getImportUrlFromData(data);
        if (this.currentStatus !== Status_1.default.ERROR) {
            DataStorage_1.default.clearMigrationErrorShowed();
        }
        switch (this.currentStatus) {
            case Status_1.default.INITIAL:
                if (!this.isTransferDialogOpened() && statusHasChanged) {
                    this.notifier.notify({
                        status: this.currentStatus,
                        actionHandler: this.openStartDialog.bind(this)
                    });
                }
                break;
            case Status_1.default.SKIPPED:
                if (statusHasChanged) {
                    this.notifier.notify({
                        status: this.currentStatus,
                        actionHandler: this.openStartDialog.bind(this)
                    });
                }
                break;
            case Status_1.default.RUNNING:
                if (statusHasChanged) {
                    this.updateTransferDialog(React.createElement(RunningView_1.default, { websiteUrl: this.crawlingUrl }), true);
                    this.notifier.notify({
                        status: this.currentStatus
                    });
                }
                setTimeout(this.processStatus.bind(this), this.pollingInterval);
                break;
            case Status_1.default.RUNNING_LONGER:
                if (statusHasChanged) {
                    this.updateTransferDialog(React.createElement(WaitingView_1.default, { websiteUrl: this.crawlingUrl }), true);
                    this.notifier.notify({
                        status: this.currentStatus
                    });
                }
                setTimeout(this.processStatus.bind(this), this.pollingInterval);
                break;
            case Status_1.default.RUNNING_VERY_LONG:
                if (statusHasChanged) {
                    this.updateTransferDialog(React.createElement(LongerWaitingView_1.default, { websiteUrl: this.crawlingUrl }), true);
                    this.notifier.notify({
                        status: this.currentStatus
                    });
                }
                setTimeout(this.processStatus.bind(this), this.pollingInterval);
                break;
            case Status_1.default.ERROR:
                if (!DataStorage_1.default.hasMigrationErrorShowed()) {
                    var supportHandler = function () {
                        _this.closeTransferDialog();
                        _this.openContact();
                    };
                    this.updateTransferDialog(React.createElement(ErrorView_1.default, { supportHandler: supportHandler }), false, [React.createElement(RaisedButton_1.default, { primary: true, label: l10n_1.default("migration.error.button"), onClick: this.closeTransferDialog.bind(this) })]);
                }
                else {
                    DataStorage_1.default.setMigrationErrorShowed();
                }
                this.notifier.notify({
                    status: this.currentStatus
                });
                break;
            case Status_1.default.SUCCESS:
                if (this.isTransferDialogOpened()) {
                    this.updateTransferDialog(React.createElement(SuccessView_1.default, { websiteUrl: this.crawlingUrl }), false, [React.createElement(StateButton_1.default, { label: l10n_1.default("migration.transfer.success.button"), onClick: function () { return location.reload(); }, "data-test": "continue-import" })]);
                }
                else {
                    this.notifier.notify({
                        status: this.currentStatus,
                        actionHandler: this.openAssistanceDialog.bind(this)
                    });
                }
                break;
            case Status_1.default.UPGRADEABLE:
                this.notifier.notify({
                    status: this.currentStatus,
                    actionHandler: this.openUpsellPopup.bind(this)
                });
                break;
            default:
                this.notifier.remove();
                break;
        }
    };
    ;
    ImportProcedure.prototype.openStartDialog = function () {
        var _this = this;
        var startDialogController = new DialogController_1.default();
        var startDialogSubmit = function () {
            Backend_1.default.startExternalImport(_this.websiteId)
                .then(function () {
                DataStorage_1.default.setMigrationStartTime();
                startDialogController.close();
                _this.openTransferDialog();
            })
                .catch(function (error) {
                startDialogController.close();
            });
        };
        var startDialogCancel = function () {
            Backend_1.default.skipExternalImport(_this.websiteId)
                .then(function () {
                startDialogController.close();
                _this.processStatus();
            })
                .catch(function (error) {
                startDialogController.close();
            });
        };
        var startDialogDisclaimerCancel = function () {
            Backend_1.default.skipDisclaimer(_this.websiteId)
                .then(function () {
                startDialogController.close();
                _this.processStatus();
            })
                .catch(function (error) {
                startDialogController.close();
            });
        };
        startDialogController.open(React.createElement(StartDialog_1.default, { onSubmit: startDialogSubmit, onCancel: startDialogCancel, onDisclaimerCancel: startDialogDisclaimerCancel, url: this.crawlingUrl }));
    };
    ImportProcedure.prototype.openTransferDialog = function (content) {
        var _this = this;
        if (content === void 0) { content = React.createElement(RunningView_1.default, { websiteUrl: this.crawlingUrl }); }
        if (!this.isTransferDialogOpened()) {
            this.migrationDialogController = new DialogController_1.default();
            this.migrationDialogController.open(React.createElement(TransferDialog_1.default, null), content)
                .then(function () {
                _this.processStatus();
            });
        }
    };
    ImportProcedure.prototype.updateTransferDialog = function (content, reopen, actions) {
        if (reopen === void 0) { reopen = false; }
        if (this.isTransferDialogOpened()) {
            this.migrationDialogController.update(content, actions);
        }
        else if (reopen) {
            this.openTransferDialog(content);
        }
    };
    ImportProcedure.prototype.closeTransferDialog = function () {
        if (this.isTransferDialogOpened()) {
            this.migrationDialogController.close();
        }
    };
    ImportProcedure.prototype.isTransferDialogOpened = function () {
        return (typeof this.migrationDialogController !== "undefined");
    };
    ImportProcedure.prototype.openAssistanceDialog = function () {
        var _this = this;
        var assistanceDialogController = new DialogController_1.default();
        var assistanceButtonActionhandler = function () {
            assistanceDialogController.close();
        };
        var assistanceActionHandlers = [
            function () {
                assistanceDialogController.close();
                _this.goToHomepage();
            },
            function () {
                assistanceDialogController.close();
                _this.openManagePages();
            },
            function () {
                _this.goToControlPanel();
            }
        ];
        assistanceDialogController.open(React.createElement(AssistanceDialog_1.default, null), React.createElement(AssistanceView_1.default, { websiteUrl: this.crawlingUrl, buttonActionHandler: assistanceButtonActionhandler, stepActionHandlers: assistanceActionHandlers }));
    };
    return ImportProcedure;
}());
exports.default = ImportProcedure;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var RaisedButton_1 = __webpack_require__(482);
var CircularProgress_1 = __webpack_require__(382);
var diyLightTheme = __webpack_require__(241);
var StateButton = (function (_super) {
    tslib_1.__extends(StateButton, _super);
    function StateButton(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Retrieves standard props to add it to our element without conflicts
         * (actually only the data-* props, can be extended)
         */
        _this.filterProps = function (props) {
            var filteredProps = {};
            for (var key in props) {
                if (props.hasOwnProperty(key) && key.match(/data\-.*/)) {
                    filteredProps[key] = props[key];
                }
            }
            return filteredProps;
        };
        /**
         * Shows a loading animation before running the onclick action
         *
         * The timeout is for UX effect. It's a small waiting time to see
         * a bit of the loading animation before the button action happens,
         * otherwise the "waiting state" is not clear for the user.
         */
        _this.handleClick = function () {
            _this.setState({
                loading: true
            }, function () {
                _this.timeout = setTimeout(function () {
                    _this.props.onClick();
                }, 400);
            });
        };
        _this.state = {
            loading: false
        };
        return _this;
    }
    StateButton.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    StateButton.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeout);
    };
    StateButton.prototype.render = function () {
        var progressStyle = {
            display: "inline-block",
            verticalAlign: "middle",
            width: "36px",
            height: "36px"
        };
        var progressInnerStyle = {
            marginTop: "-7px"
        };
        var props = this.filterProps(this.props);
        if (this.state.loading === true) {
            return (React.createElement(RaisedButton_1.default, tslib_1.__assign({}, props, { label: this.props.label, primary: true, labelPosition: "after", disabled: true, className: this.props.className }),
                React.createElement(CircularProgress_1.default, { size: 0.3, color: diyLightTheme.raisedButton.primaryTextColor, style: progressStyle, innerStyle: progressInnerStyle })));
        }
        else {
            return (React.createElement(RaisedButton_1.default, tslib_1.__assign({}, props, { label: this.props.label, primary: true, onTouchTap: this.handleClick, className: this.props.className })));
        }
    };
    return StateButton;
}(React.Component));
StateButton.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = StateButton;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var DataStorage_1 = __webpack_require__(585);
var Status_1 = __webpack_require__(584);
var Data = __webpack_require__(4);
var l10n_1 = __webpack_require__(18);
var Backend_1 = __webpack_require__(586);
var NTFCenterObserver = (function () {
    function NTFCenterObserver() {
    }
    NTFCenterObserver.prototype.setNotificationType = function (t) {
        this.notificationType = t;
    };
    NTFCenterObserver.prototype.setNotificationApi = function (api) {
        this.notificationApi = api;
    };
    NTFCenterObserver.prototype.notify = function (data) {
        var _this = this;
        var content;
        var iconCls;
        var notificationObject;
        var $body = $("body");
        switch (data.status) {
            case Status_1.default.INITIAL:
                content = "\n                    <div class=\"notification-type-ext-website-import-new button-bar cp-style\">\n                        <div class=\"notification-type-ext-website-import-container\">\n                            " + l10n_1.default('migration.notification.init.text') + "\n                        </div>\n                        <div class=\"notification-type-ext-website-import-menu\">\n                            <button id=\"notification-migration-possible-no\"\n                                    class=\"small blue-secondary button migrationNotificationClose\"\n                                    data-test=\"skip-import\">\n                                " + l10n_1.default('migration.notification.init.button.reject') + "\n                            </button>\n                            <button id=\"notification-migration-possible-yes\"\n                                    class=\"small blue-primary button migrationNotificationClose\"\n                                    data-test=\"accept-import\">\n                                " + l10n_1.default('migration.notification.init.button.start') + "\n                            </button>\n                        </div>\n                    </div>";
                iconCls = 'ui-icon-star-white';
                notificationObject = {
                    type: 17,
                    severity: 3,
                    sticky: false,
                    payload: {
                        content: content,
                        status: data.status
                    }
                };
                $body.on('click', '#notification-migration-possible-no', function () {
                    Backend_1.default.skipExternalImport(Data.getId());
                });
                $body.on('click', '#notification-migration-possible-yes', function () {
                    data.actionHandler();
                });
                break;
            case Status_1.default.SKIPPED:
                content = "\n                    <div>" + l10n_1.default("migration.notification.later.text") + "</div>\n                    <div class=\"button-bar cp-style\">\n                        <button id=\"notification-migration-start\" class=\"small blue-primary\">\n                            <span class=\"ui-button-text\">" + l10n_1.default("migration.notification.later.button") + "</span>\n                        </button>\n                    </div>";
                iconCls = 'ui-icon-star';
                notificationObject = {
                    type: 15,
                    severity: 3,
                    sticky: false,
                    closable: false,
                    payload: {
                        content: content,
                        status: data.status
                    }
                };
                $body.on('click', '#notification-migration-start', function () {
                    data.actionHandler();
                });
                break;
            case Status_1.default.SUCCESS:
                if (!DataStorage_1.default.getMigrationSuccessNotificationRead()) {
                    content = "\n                        <div class=\"notification-type-ext-website-import new button-bar cp-style\">\n                            <div class=\"notification-type-ext-website-import-container\">\n                                " + l10n_1.default('migration.notification.success.text') + "\n                            </div>\n                            <div class=\"notification-type-ext-website-import-menu\">\n                                <button id=\"notification-migration-successful-close\"\n                                    class=\"small blue-secondary button migrationNotificationClose\">\n                                    " + l10n_1.default('migration.notification.success.button.reject') + "\n                                </button>\n                                <button id=\"notification-migration-successful-manage-pages\"\n                                    class=\"small blue-primary button migrationNotificationClose\">\n                                    " + l10n_1.default('migration.notification.success.button.accept') + "\n                                </button>\n                            </div>\n                        </div>";
                    iconCls = 'ui-icon-check-white';
                    notificationObject = {
                        type: 17,
                        severity: 4,
                        sticky: false,
                        payload: {
                            content: content,
                            status: data.status
                        }
                    };
                    $body.on('click', '#notification-migration-successful-close', function () {
                        DataStorage_1.default.setMigrationSuccessNotificationRead();
                    });
                    $body.on('click', '#notification-migration-successful-manage-pages', function () {
                        DataStorage_1.default.setMigrationSuccessNotificationRead();
                        diy.editor.deeplinking.requestPath([
                            { label: 'siteadmin', params: 'pages' }
                        ]);
                    });
                }
                else {
                    return;
                }
                this.notificationApi.deleteNotificationByType(15);
                break;
            default:
                return;
        }
        this.notificationApi.ready(function () {
            _this.notificationInstance = _this.getNotificationInstance(notificationObject.type);
            if (!_this.notificationInstance) {
                _this.notificationInstance = _this.notificationApi.createNotification(notificationObject);
            }
            else {
                var lastNotificationBubbled = DataStorage_1.default.getLastNotificationBubbled();
                notificationObject.dismissed =
                    (lastNotificationBubbled === data.status) &&
                        (Status_1.default.SKIPPED !== data.status) &&
                        (_this.notificationInstance.flashNotification === false);
                _this.notificationApi.updateNotification(_this.notificationInstance.getId(), notificationObject);
            }
            _this.notificationInstance.setIconCls(iconCls);
            DataStorage_1.default.setLastNotificationBubbled(data.status);
        });
    };
    NTFCenterObserver.prototype.remove = function () {
        var _this = this;
        this.notificationApi.ready(function () {
            if (_this.notificationInstance) {
                _this.notificationApi.deleteNotificationByType(_this.notificationType);
            }
        });
    };
    NTFCenterObserver.prototype.getNotificationInstance = function (notificationType) {
        var notifications = this.notificationApi.getNotificationsByType(notificationType);
        if (notifications.length > 0) {
            return notifications[0];
        }
        return null;
    };
    ;
    return NTFCenterObserver;
}());
exports.default = NTFCenterObserver;


/***/ },
/* 683 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Notifier = (function () {
    function Notifier() {
        this.observersCollection = [];
    }
    Notifier.prototype.registerObserver = function (obs) {
        this.observersCollection.push(obs);
    };
    Notifier.prototype.unregisterObserver = function (obs) {
        var idx = this.observersCollection.indexOf(obs);
        if (idx === -1) {
            return;
        }
        this.observersCollection.splice(idx, 1);
    };
    Notifier.prototype.notify = function (data) {
        for (var i = 0; i < this.observersCollection.length; i++) {
            this.observersCollection[i].notify(data);
        }
    };
    Notifier.prototype.remove = function () {
        for (var i = 0; i < this.observersCollection.length; i++) {
            this.observersCollection[i].remove();
        }
    };
    return Notifier;
}());
exports.default = Notifier;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Status_1 = __webpack_require__(584);
var SiteAdminObserver = (function () {
    function SiteAdminObserver() {
        var _this = this;
        this.handleMigrationItemClick = function (event) {
            event.preventDefault();
            /** Bind the notification action that corresponds to each of the relevant statuses we need */
            switch (_this.getStatus()) {
                case Status_1.default.INITIAL:
                case Status_1.default.SKIPPED:
                case Status_1.default.SUCCESS:
                    var actionHandler = _this.getActionHandler();
                    actionHandler();
                    break;
                default:
                    break;
            }
        };
        this.handleMigrationUpsellItemClick = function (event) {
            event.preventDefault();
            if (_this.getStatus() === Status_1.default.UPGRADEABLE) {
                var actionHandler = _this.getActionHandler();
                actionHandler();
            }
        };
    }
    SiteAdminObserver.prototype.init = function () {
        this.migrationItem = document.getElementById('cc-sa-item-migration');
        this.migrationUpsellItem = document.getElementById('cc-sa-item-migration-upsell');
    };
    SiteAdminObserver.prototype.bindEvents = function () {
        /* Migration Siteadmin trigger */
        if (this.migrationItem !== null) {
            this.migrationItem.addEventListener('click', this.handleMigrationItemClick);
        }
        /* Migration Siteadmin Upsell trigger */
        if (this.migrationUpsellItem !== null) {
            this.migrationUpsellItem.addEventListener('click', this.handleMigrationUpsellItemClick);
        }
    };
    SiteAdminObserver.prototype.unbindEvents = function () {
        /* Migration Siteadmin trigger */
        if (typeof this.migrationItem !== 'undefined' && this.migrationItem !== null) {
            this.migrationItem.removeEventListener('click', this.handleMigrationItemClick);
        }
        /* Migration Siteadmin Upsell trigger */
        if (typeof this.migrationUpsellItem !== 'undefined' && this.migrationUpsellItem !== null) {
            this.migrationUpsellItem.removeEventListener('click', this.handleMigrationUpsellItemClick);
        }
    };
    SiteAdminObserver.prototype.notify = function (data) {
        this.setStatus(data.status);
        this.setActionHandler(data.actionHandler);
        if (typeof this.migrationItem === 'undefined' && typeof this.migrationUpsellItem === 'undefined') {
            this.init();
        }
        this.bindEvents();
    };
    SiteAdminObserver.prototype.remove = function () {
        this.unbindEvents();
    };
    SiteAdminObserver.prototype.getStatus = function () {
        return this.status;
    };
    SiteAdminObserver.prototype.setStatus = function (status) {
        this.status = status;
    };
    SiteAdminObserver.prototype.getActionHandler = function () {
        return this.actionHandler;
    };
    SiteAdminObserver.prototype.setActionHandler = function (actionHandler) {
        this.actionHandler = actionHandler;
    };
    return SiteAdminObserver;
}());
exports.default = SiteAdminObserver;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Status_1 = __webpack_require__(584);
var l10n_1 = __webpack_require__(18);
var PagesEditorObserver = (function () {
    function PagesEditorObserver() {
        this.removed = false;
    }
    PagesEditorObserver.prototype.notify = function (data) {
        this.message = {
            title: l10n_1.default('migration.pageseditor.notification.title'),
            message: l10n_1.default('migration.pageseditor.notification.text'),
            actionText: l10n_1.default('migration.pageseditor.notification.button'),
            actionHandler: data.actionHandler
        };
        this.status = data.status;
    };
    PagesEditorObserver.prototype.remove = function () {
        this.removed = true;
    };
    PagesEditorObserver.prototype.isRemoved = function () {
        return this.removed;
    };
    PagesEditorObserver.prototype.isDeclined = function () {
        return (!this.isRemoved() && this.status === Status_1.default.SKIPPED);
    };
    PagesEditorObserver.prototype.isCompleted = function () {
        return (!this.isRemoved() && this.status === Status_1.default.SUCCESS);
    };
    PagesEditorObserver.prototype.getMessage = function () {
        return this.message;
    };
    return PagesEditorObserver;
}());
exports.pagesEditorObserver = new PagesEditorObserver;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var features = __webpack_require__(25);
var Api_1 = __webpack_require__(537);
var SiteAdminApi = __webpack_require__(19);
var DialogView = (function (_super) {
    tslib_1.__extends(DialogView, _super);
    function DialogView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogView.prototype.setContent = function (content) {
        this.content = content;
    };
    DialogView.prototype.setActions = function (actions) {
        this.actions = actions;
    };
    DialogView.prototype.getContainer = function () {
        if (!this.container) {
            var container = document.createElement("div");
            document.body.appendChild(container);
            this.container = container;
        }
        return this.container;
    };
    DialogView.prototype.render = function () {
        var type = this.props.dialog.type;
        var props = Object.assign({}, this.props.dialog.props);
        var children = this.props.dialog.props.children;
        if (typeof this.actions !== "undefined") {
            props.actions = this.actions;
        }
        if (typeof this.content !== "undefined") {
            children = this.content;
        }
        return (React.createElement(type, props, children));
    };
    DialogView.prototype.create = function (callback) {
        ReactDOM.render(this.render(), this.getContainer(), function () {
            callback(true);
        });
    };
    DialogView.prototype.destroy = function () {
        ReactDOM.unmountComponentAtNode(this.getContainer());
    };
    return DialogView;
}(React.Component));
exports.DialogView = DialogView;
var DialogController = (function () {
    function DialogController() {
    }
    DialogController.prototype.getDialogView = function () {
        return this.dialogView;
    };
    DialogController.prototype.open = function (dialog, content, actions) {
        SiteAdminApi.close();
        this.dialogView = new DialogView({
            dialog: dialog
        });
        return this.update(content, actions);
    };
    DialogController.prototype.close = function () {
        this.dialogView.destroy();
        if (features("notificationsNG")) {
            Api_1.default.schedule(function () {
                Api_1.default.resume();
            });
        }
    };
    DialogController.prototype.update = function (content, actions) {
        var _this = this;
        if (typeof content !== "undefined") {
            this.dialogView.setContent(content);
        }
        if (typeof actions !== "undefined") {
            this.dialogView.setActions(actions);
        }
        return new Promise(function (resolve, reject) {
            if (features("notificationsNG")) {
                Api_1.default.schedule(function () {
                    Api_1.default.pause().then(function () {
                        _this.dialogView.create(resolve);
                    });
                });
            }
            else {
                _this.dialogView.create(resolve);
            }
        });
    };
    return DialogController;
}());
exports.default = DialogController;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var diyLightTheme = __webpack_require__(241);
var l10n_1 = __webpack_require__(18);
var StartView_1 = __webpack_require__(688);
var DisclaimerView_1 = __webpack_require__(689);
var StartDialog = (function (_super) {
    tslib_1.__extends(StartDialog, _super);
    function StartDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = function () {
            _this.props.onSubmit();
        };
        _this.onAccept = function () {
            _this.setState({
                disclaimer: true
            });
        };
        _this.onCancel = function () {
            _this.props.onCancel();
        };
        _this.onDisclaimerCancel = function () {
            _this.props.onDisclaimerCancel();
        };
        _this.state = {
            disclaimer: false
        };
        return _this;
    }
    StartDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    StartDialog.prototype.render = function () {
        var actions;
        var content = React.createElement("div", null);
        if (this.state.disclaimer) {
            content = React.createElement(DisclaimerView_1.default, null);
            actions = [
                React.createElement(FlatButton_1.default, { label: l10n_1.default('migration.dialog.decline'), onTouchTap: this.onDisclaimerCancel }),
                React.createElement(RaisedButton_1.default, { primary: true, "data-test": 'start-import', label: l10n_1.default('migration.dialog.accept'), onTouchTap: this.onSubmit })
            ];
        }
        else {
            content = React.createElement(StartView_1.default, { url: this.props.url });
            actions = [
                React.createElement(FlatButton_1.default, { label: l10n_1.default('migration.dialog.cancel'), onTouchTap: this.onCancel }),
                React.createElement(RaisedButton_1.default, { primary: true, "data-test": 'start-import', label: l10n_1.default('migration.dialog.submit'), onTouchTap: this.onAccept })
            ];
        }
        return (React.createElement(Dialog_1.default, { open: true, autoScrollBodyContent: true, className: this.props.className, contentClassName: "migration-dialog opening-dialog", bodyClassName: "dialog-body", actionsContainerClassName: "dialog-actions", actions: actions, style: { zIndex: diy.editor.getNewTopZIndex() } },
            React.createElement("div", { className: "dialog-inner" }, content)));
    };
    return StartDialog;
}(React.Component));
StartDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = StartDialog;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var StartView = (function (_super) {
    tslib_1.__extends(StartView, _super);
    function StartView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartView.prototype.render = function () {
        var dialogSubtitle = l10n_1.default('migration.dialog.subtitle');
        var dialogContent = l10n_1.default('migration.dialog.content');
        if (typeof this.props.url !== 'undefined' && this.props.url !== '') {
            dialogContent = dialogContent.replace("{link}", "<a href=" + this.props.url + " target=\"_blank\">\n                     " + this.props.url + "\n                 </a>");
        }
        return (React.createElement("div", null,
            React.createElement("h3", null, l10n_1.default('migration.dialog.title')),
            React.createElement("p", { className: "subtitle" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: dialogSubtitle } })),
            React.createElement("p", { className: "content" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: dialogContent } }))));
    };
    return StartView;
}(React.Component));
exports.default = StartView;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var DisclaimerView = (function (_super) {
    tslib_1.__extends(DisclaimerView, _super);
    function DisclaimerView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisclaimerView.prototype.render = function () {
        var dialogSubtitle = l10n_1.default('migration.dialog.disclaimer.subtitle');
        var dialogContent = l10n_1.default('migration.dialog.disclaimer.content');
        return (React.createElement("div", null,
            React.createElement("h3", null, l10n_1.default('migration.dialog.title')),
            React.createElement("p", { className: "subtitle" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: dialogSubtitle } })),
            React.createElement("p", { className: "content", style: { textAlign: "left" } },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: dialogContent } }))));
    };
    return DisclaimerView;
}(React.Component));
exports.default = DisclaimerView;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var diyLightTheme = __webpack_require__(241);
var Data = __webpack_require__(4);
var l10n_1 = __webpack_require__(18);
var TransferDialog = (function (_super) {
    tslib_1.__extends(TransferDialog, _super);
    function TransferDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransferDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    TransferDialog.prototype.componentDidMount = function () {
        /** Receive keys from the animation's frame and send the corresponding translation back */
        window.addEventListener("message", function (event) {
            try {
                var request = event.data;
                if (request.type === "translations") {
                    var response = {
                        type: "translations",
                        params: {
                            key: request.params.key,
                            value: l10n_1.default(request.params.key)
                        }
                    };
                    event.source.postMessage(response, event.origin);
                }
            }
            catch (error) {
                console.error('Error in sending translation: "' + error + '"');
            }
        });
    };
    TransferDialog.prototype.render = function () {
        var cdnUrl = Data.getCdnUrl();
        var animationPath = cdnUrl + "s/diy/externalwebsiteimport/transferDialog/animation/index.html";
        return (React.createElement(Dialog_1.default, { open: true, autoScrollBodyContent: true, contentClassName: "migration-dialog transfer-dialog", bodyClassName: "dialog-body", actionsContainerClassName: "dialog-actions", actions: this.props.actions, style: { zIndex: diy.editor.getNewTopZIndex() } },
            React.createElement("div", { className: "transfer-dialog-animation-container" },
                React.createElement("div", { className: "transfer-dialog-animation" },
                    React.createElement("iframe", { src: animationPath, scrolling: "no", style: { width: "100%", height: "100%", border: "none" } }))),
            this.props.children));
    };
    return TransferDialog;
}(React.Component));
TransferDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = TransferDialog;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var diyLightTheme = __webpack_require__(241);
var AssistanceDialog = (function (_super) {
    tslib_1.__extends(AssistanceDialog, _super);
    function AssistanceDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssistanceDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    AssistanceDialog.prototype.render = function () {
        return (React.createElement(Dialog_1.default, { open: true, autoScrollBodyContent: true, className: this.props.className, contentClassName: "migration-dialog assistance-dialog", bodyClassName: "dialog-body", actionsContainerClassName: "dialog-actions", style: { zIndex: diy.editor.getNewTopZIndex() } }, this.props.children));
    };
    return AssistanceDialog;
}(React.Component));
AssistanceDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = AssistanceDialog;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var error_1 = __webpack_require__(693);
var l10n_1 = __webpack_require__(18);
var ErrorView = (function (_super) {
    tslib_1.__extends(ErrorView, _super);
    function ErrorView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorView.prototype.componentDidMount = function () {
        var _this = this;
        var dialogHtml = this.refs["transferDialogHtml"];
        var supportLink = dialogHtml.getElementsByClassName("transfer-dialog-error-description-link")[0];
        if (supportLink) {
            supportLink.onclick = function (event) {
                event.preventDefault();
                _this.props.supportHandler();
            };
        }
    };
    ErrorView.prototype.render = function () {
        return (React.createElement("div", { ref: "transferDialogHtml" },
            React.createElement("div", { className: "transfer-dialog-container" },
                React.createElement("div", { className: "transfer-dialog-error-icon" },
                    React.createElement(error_1.default, { color: "#ff0000" })),
                React.createElement("h3", { className: "transfer-dialog-error-title" }, l10n_1.default("migration.transfer.error.title")),
                React.createElement("div", { className: "transfer-dialog-description", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.transfer.error.description").replace("{supportLink}", "<a href=\"#\" class=\"transfer-dialog-error-description-link\">\n                                " + l10n_1.default("migration.error.supportLink") + "\n                            </a>")
                    } }),
                React.createElement("div", { className: "transfer-dialog-error-button" }))));
    };
    return ErrorView;
}(React.Component));
exports.default = ErrorView;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertError = function AlertError(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
  );
};
AlertError = (0, _pure2.default)(AlertError);
AlertError.displayName = 'AlertError';
AlertError.muiName = 'SvgIcon';

exports.default = AlertError;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var LinearProgress_1 = __webpack_require__(695);
var l10n_1 = __webpack_require__(18);
var RunningView = (function (_super) {
    tslib_1.__extends(RunningView, _super);
    function RunningView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RunningView.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "transfer-dialog-container" },
                React.createElement("h3", { className: "transfer-dialog-running-title" }, l10n_1.default("migration.transfer.running.title")),
                React.createElement("div", { className: "transfer-dialog-description" }, l10n_1.default("migration.transfer.running.description")),
                React.createElement("div", { className: "transfer-dialog-linear-progress" },
                    React.createElement(LinearProgress_1.default, { mode: "indeterminate", style: { backgroundColor: "#baddfa" } }))),
            React.createElement("div", { className: "transfer-dialog-footer", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.transfer.footer").replace("{link}", "<a href=" + this.props.websiteUrl + " target=\"_blank\">\n                            " + this.props.websiteUrl + "\n                        </a>")
                } })));
    };
    return RunningView;
}(React.Component));
exports.default = RunningView;


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LinearProgress = __webpack_require__(696);

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LinearProgress2.default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
  return relValue * 100;
}

function getStyles(props, context) {
  var max = props.max;
  var min = props.min;
  var value = props.value;
  var palette = context.muiTheme.baseTheme.palette;


  var styles = {
    root: {
      position: 'relative',
      height: 4,
      display: 'block',
      width: '100%',
      backgroundColor: palette.primary3Color,
      borderRadius: 2,
      margin: 0,
      overflow: 'hidden'
    },
    bar: {
      height: '100%'
    },
    barFragment1: {},
    barFragment2: {}
  };

  if (props.mode === 'indeterminate') {
    styles.barFragment1 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
    };

    styles.barFragment2 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
    };
  } else {
    styles.bar.backgroundColor = props.color || palette.primary1Color;
    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
    styles.bar.width = getRelativeValue(value, min, max) + '%';
  }

  return styles;
}

var LinearProgress = function (_Component) {
  _inherits(LinearProgress, _Component);

  function LinearProgress() {
    _classCallCheck(this, LinearProgress);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(LinearProgress).apply(this, arguments));
  }

  _createClass(LinearProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.timers = {};

      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]]);

      this.timers.bar2 = setTimeout(function () {
        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]]);
      }, 850);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timers.bar1);
      clearTimeout(this.timers.bar2);
    }
  }, {
    key: 'barUpdate',
    value: function barUpdate(id, step, barElement, stepValues) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      step = step || 0;
      step %= 4;

      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
      var left = this.context.muiTheme.isRtl ? 'right' : 'left';

      if (step === 0) {
        barElement.style[left] = stepValues[0][0] + '%';
        barElement.style[right] = stepValues[0][1] + '%';
      } else if (step === 1) {
        barElement.style.transitionDuration = '840ms';
      } else if (step === 2) {
        barElement.style[left] = stepValues[1][0] + '%';
        barElement.style[right] = stepValues[1][1] + '%';
      } else if (step === 3) {
        barElement.style.transitionDuration = '0ms';
      }
      this.timers[id] = setTimeout(function () {
        return _this3.barUpdate(id, step + 1, barElement, stepValues);
      }, 420);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.bar) },
          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
        )
      );
    }
  }]);

  return LinearProgress;
}(_react.Component);

LinearProgress.propTypes = {
  /**
   * The mode of show your progress, indeterminate for
   * when there is no value for progress.
   */
  color: _react.PropTypes.string,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _react.PropTypes.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _react.PropTypes.number,
  /**
   * The mode of show your progress, indeterminate for when
   * there is no value for progress.
   */
  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _react.PropTypes.number
};
LinearProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100
};
LinearProgress.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = LinearProgress;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var check_1 = __webpack_require__(399);
var l10n_1 = __webpack_require__(18);
var SuccessView = (function (_super) {
    tslib_1.__extends(SuccessView, _super);
    function SuccessView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuccessView.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "transfer-dialog-container" },
                React.createElement("div", { className: "transfer-dialog-success-icon" },
                    React.createElement(check_1.default, { color: "#4ccd1a" })),
                React.createElement("h3", { className: "transfer-dialog-success-title" }, l10n_1.default("migration.transfer.success.title")),
                React.createElement("div", { className: "transfer-dialog-description" },
                    React.createElement("span", null, l10n_1.default("migration.transfer.success.description")),
                    React.createElement("br", null),
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: l10n_1.default("migration.transfer.footer").replace("{link}", "<a href=" + this.props.websiteUrl + " target=\"_blank\">\n                                    " + this.props.websiteUrl + "\n                                </a>")
                        } })))));
    };
    return SuccessView;
}(React.Component));
exports.default = SuccessView;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var LinearProgress_1 = __webpack_require__(695);
var warning_1 = __webpack_require__(544);
var l10n_1 = __webpack_require__(18);
var WaitingView = (function (_super) {
    tslib_1.__extends(WaitingView, _super);
    function WaitingView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WaitingView.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "transfer-dialog-container" },
                React.createElement("h3", { className: "transfer-dialog-runningLonger-title" }, l10n_1.default("migration.transfer.runningLonger.title")),
                React.createElement("div", { className: "transfer-dialog-description" }, l10n_1.default("migration.transfer.runningLonger.description")),
                React.createElement("div", { className: "transfer-dialog-linear-progress" },
                    React.createElement(LinearProgress_1.default, { mode: "indeterminate", style: { backgroundColor: "#baddfa" } })),
                React.createElement("div", { className: "transfer-dialog-runningLonger-icon" },
                    React.createElement(warning_1.default, { color: "#949494" })),
                React.createElement("div", { className: "transfer-dialog-runningLonger-warning" }, l10n_1.default("migration.transfer.runningLonger.warning"))),
            React.createElement("div", { className: "transfer-dialog-footer", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.transfer.footer").replace("{link}", "<a href=" + this.props.websiteUrl + " target=\"_blank\">\n                            " + this.props.websiteUrl + "\n                        </a>")
                } })));
    };
    return WaitingView;
}(React.Component));
exports.default = WaitingView;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var LinearProgress_1 = __webpack_require__(695);
var info_1 = __webpack_require__(700);
var l10n_1 = __webpack_require__(18);
var LongerWaitingView = (function (_super) {
    tslib_1.__extends(LongerWaitingView, _super);
    function LongerWaitingView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LongerWaitingView.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "transfer-dialog-container" },
                React.createElement("h3", { className: "transfer-dialog-runningVeryLong-title" }, l10n_1.default("migration.transfer.runningVeryLong.title")),
                React.createElement("div", { className: "transfer-dialog-description" }, l10n_1.default("migration.transfer.runningVeryLong.description")),
                React.createElement("div", { className: "transfer-dialog-linear-progress" },
                    React.createElement(LinearProgress_1.default, { mode: "indeterminate", style: { backgroundColor: "#baddfa" } })),
                React.createElement("div", { className: "transfer-dialog-runningVeryLong-icon" },
                    React.createElement(info_1.default, { color: "#2196f3" })),
                React.createElement("div", { className: "transfer-dialog-runningVeryLong-warning" }, l10n_1.default("migration.transfer.runningVeryLong.warning"))),
            React.createElement("div", { className: "transfer-dialog-footer", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.transfer.footer").replace("{link}", "<a href=" + this.props.websiteUrl + " target=\"_blank\">\n                            " + this.props.websiteUrl + "\n                        </a>")
                } })));
    };
    return LongerWaitingView;
}(React.Component));
exports.default = LongerWaitingView;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInfo = function ActionInfo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
  );
};
ActionInfo = (0, _pure2.default)(ActionInfo);
ActionInfo.displayName = 'ActionInfo';
ActionInfo.muiName = 'SvgIcon';

exports.default = ActionInfo;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var FlatButton_1 = __webpack_require__(479);
var home_1 = __webpack_require__(702);
var rate_review_1 = __webpack_require__(703);
var web_1 = __webpack_require__(704);
var l10n_1 = __webpack_require__(18);
var AssistanceView = (function (_super) {
    tslib_1.__extends(AssistanceView, _super);
    function AssistanceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onStepClick = function (step, event) {
            event.preventDefault();
            if (typeof _this.props.stepActionHandlers[step - 1] !== "undefined") {
                _this.props.stepActionHandlers[step - 1]();
            }
        };
        _this.onButtonClick = function (event) {
            event.preventDefault();
            _this.props.buttonActionHandler();
        };
        return _this;
    }
    AssistanceView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: "assistance-dialog-container" },
                React.createElement("h3", null, l10n_1.default("migration.assistance.title")),
                React.createElement("p", { className: "subtitle" }, l10n_1.default("migration.assistance.subtitle")),
                React.createElement("div", { className: "steps" },
                    React.createElement("a", { classID: "step1", className: "step", href: "#", onClick: function (event) { return _this.onStepClick(1, event); } },
                        React.createElement("div", { className: "icon" },
                            React.createElement(home_1.default, { color: "#424952" })),
                        React.createElement("h4", null, l10n_1.default("migration.assistance.step1.title")),
                        React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.assistance.step1.content")
                            } })),
                    React.createElement("a", { classID: "step2", className: "step", href: "#", onClick: function (event) { return _this.onStepClick(2, event); } },
                        React.createElement("div", { className: "icon" },
                            React.createElement(rate_review_1.default, { color: "#424952" })),
                        React.createElement("h4", null, l10n_1.default("migration.assistance.step2.title")),
                        React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.assistance.step2.content")
                            } })),
                    React.createElement("a", { classID: "step3", className: "step", href: "#", onClick: function (event) { return _this.onStepClick(3, event); } },
                        React.createElement("div", { className: "icon" },
                            React.createElement(web_1.default, { color: "#424952" })),
                        React.createElement("h4", null, l10n_1.default("migration.assistance.step3.title")),
                        React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.assistance.step3.content").replace("{link}", "<span class='info-link'>" + this.props.websiteUrl + "</span>")
                            } })))),
            React.createElement("div", { className: "dialog-actions" },
                React.createElement("div", { className: "assistance-dialog-help", dangerouslySetInnerHTML: { __html: l10n_1.default("migration.assistance.help")
                    } }),
                React.createElement(FlatButton_1.default, { label: l10n_1.default("migration.assistance.close"), onClick: this.onButtonClick, className: "assistance-dialog-button" }))));
    };
    return AssistanceView;
}(React.Component));
exports.default = AssistanceView;


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHome = function ActionHome(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
  );
};
ActionHome = (0, _pure2.default)(ActionHome);
ActionHome.displayName = 'ActionHome';
ActionHome.muiName = 'SvgIcon';

exports.default = ActionHome;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsRateReview = function MapsRateReview(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
  );
};
MapsRateReview = (0, _pure2.default)(MapsRateReview);
MapsRateReview.displayName = 'MapsRateReview';
MapsRateReview.muiName = 'SvgIcon';

exports.default = MapsRateReview;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvWeb = function AvWeb(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z' })
  );
};
AvWeb = (0, _pure2.default)(AvWeb);
AvWeb.displayName = 'AvWeb';
AvWeb.muiName = 'SvgIcon';

exports.default = AvWeb;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Triggers display of webcomponent page creation notification pop up on login
 */
var infoDialogApi = __webpack_require__(706);
var websiteData = __webpack_require__(4);
var l10n = __webpack_require__(18);
var $ = __webpack_require__(3);
/**
 * triggers deactivation of success dialog per website feature deactivation on server
 */
function disablePageCreationSuccessDialog(webComponentId, status) {
    $.ajax({
        url: '/app/cms/webcomponentpage/disable-notification',
        type: 'POST',
        dataType: 'json',
        headers: {
            'Accept': 'application/vnd.oneandone.diy.website.webcomponent-page-notification+json'
        },
        data: {
            webComponentId: webComponentId,
            status: status
        },
        error: function () {
            throw 'Could not disable the notification for success dialog on login';
        }
    });
}
/**
 * Display page creation success notification
 */
function showNotification(webComponentId) {
    setTimeout(function () {
        infoDialogApi.showDialog({
            title: l10n.getString('webComponentPageCreation.success.title.' + webComponentId),
            description: getPageCreationDialogSuccessDescription(webComponentId),
            image: websiteData.getCdnUrl() + 's/diy/site-admin/main/img/webcomponent-page-success.png',
            imageHeight: 220,
            secondaryButtonConfig: {
                label: l10n.getString('webComponentPageCreation.success.closeButton'),
                callback: function () {
                    $(document).trigger("diy-editor-generic-linkInteraction", {
                        pageName: "MyShopReady",
                        actionName: "close"
                    });
                    disablePageCreationSuccessDialog(webComponentId, 'notification_rejected');
                }
            }
        });
    }, 3000);
    $(document).trigger('diy-editor-generic-sectionAccessed', { 'sectionCodeName': 'myShopReady' });
}
exports.showNotification = showNotification;
/**
 * Retrieves description of success dialog message to be displayed
 *
 * Note that if appserver API caller provided an externalSettingsLink,
 * this one will be appended to description too
 */
function getPageCreationDialogSuccessDescription(webComponentId) {
    return l10n.getString('webComponentPageCreation.success.info.' + webComponentId);
}


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var InfoDialog_1 = __webpack_require__(707);
/**
 * Open Info Dialog
 *
 * @param options: DialogOptions
 */
function showDialog(options) {
    var dialogContainer = document.createElement("div");
    ReactDOM.render(React.createElement(InfoDialog_1.default, { title: options.title, status: options.status, imageUrl: options.image, imageHeight: options.imageHeight, primaryButtonConfig: options.primaryButtonConfig, secondaryButtonConfig: options.secondaryButtonConfig },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: options.description } })), dialogContainer);
    document.body.appendChild(dialogContainer);
}
exports.showDialog = showDialog;


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var InfoView_1 = __webpack_require__(708);
var StatusView_1 = __webpack_require__(709);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var diyLightTheme = __webpack_require__(241);
var InfoDialog = (function (_super) {
    tslib_1.__extends(InfoDialog, _super);
    function InfoDialog(props) {
        var _this = _super.call(this, props) || this;
        /** Function to close the dialog */
        _this.handleClose = function () {
            _this.setState({
                open: false
            });
        };
        /** Callback function on the dialog's action button */
        _this.handleCustomActionCallback = function () {
            _this.handleClose();
            if (typeof _this.props.primaryButtonConfig.callback === "function") {
                _this.props.primaryButtonConfig.callback();
            }
        };
        /** Callback function on the dialog's close button */
        _this.handleCloseActionCallback = function () {
            _this.handleClose();
            if (typeof _this.props.secondaryButtonConfig.callback === "function") {
                _this.props.secondaryButtonConfig.callback();
            }
        };
        _this.state = {
            open: false
        };
        jQuery(document).on("mousedown", "#cc-sa-item-updateTariff", function () {
            _this.setState({
                open: false
            });
        });
        return _this;
    }
    /** Theme customization for the component */
    InfoDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    /** Loading of the dialog */
    InfoDialog.prototype.componentDidMount = function () {
        this.setState({
            open: true
        });
    };
    /** Closing of the dialog */
    InfoDialog.prototype.componentWillUnmount = function () {
        this.handleClose();
    };
    /** Renderer */
    InfoDialog.prototype.render = function () {
        var actions = [];
        var paddingTop = this.props.imageHeight ? this.props.imageHeight + "px" : "40px";
        var backgroundImage = this.props.imageUrl ? "url('" + this.props.imageUrl + "')" : "none";
        var style = {
            zIndex: diy.editor.getNewTopZIndex()
        };
        var dialogStyle = {
            padding: 0
        };
        var bodyStyle = {
            padding: paddingTop + " 40px 30px 40px",
            backgroundImage: backgroundImage,
        };
        var view;
        if (!this.props.status) {
            view = (React.createElement(InfoView_1.default, { title: this.props.title, style: bodyStyle }, this.props.children));
        }
        else {
            view = (React.createElement(StatusView_1.default, { title: this.props.title, status: this.props.status, style: bodyStyle }, this.props.children));
        }
        if (this.props.secondaryButtonConfig) {
            actions.push(React.createElement(FlatButton_1.default, { "data-test": "successDialogCloseAction", label: this.props.secondaryButtonConfig.label, onTouchTap: this.handleCloseActionCallback }));
        }
        if (this.props.primaryButtonConfig) {
            actions.push(React.createElement(RaisedButton_1.default, { primary: true, "data-test": "successDialogCustomAction", label: this.props.primaryButtonConfig.label, onTouchTap: this.handleCustomActionCallback }));
        }
        return (React.createElement(Dialog_1.default, { open: this.state.open, actions: actions, actionsContainerClassName: "dialog-actions", contentClassName: "diy-material-info-dialog", bodyStyle: dialogStyle, style: style }, view));
    };
    return InfoDialog;
}(React.Component));
InfoDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = InfoDialog;


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var InfoView = (function (_super) {
    tslib_1.__extends(InfoView, _super);
    function InfoView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoView.prototype.render = function () {
        return (React.createElement("div", { className: "dialog-body info", style: this.props.style },
            this.props.title
                ? React.createElement("h3", { className: "dialog-title" }, this.props.title)
                : "",
            React.createElement("div", { className: "dialog-description" }, this.props.children)));
    };
    return InfoView;
}(React.Component));
exports.default = InfoView;


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var error_1 = __webpack_require__(693);
var warning_1 = __webpack_require__(544);
var check_1 = __webpack_require__(399);
exports.DialogStatusError = "error";
exports.DialogStatusSuccess = "success";
exports.DialogStatusWarning = "warning";
var StatusView = (function (_super) {
    tslib_1.__extends(StatusView, _super);
    function StatusView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatusView.prototype.render = function () {
        var icon;
        var cssClass = "dialog-body dialog-" + this.props.status;
        switch (this.props.status) {
            case exports.DialogStatusSuccess:
                icon = React.createElement(check_1.default, { color: "#4ccd1a" });
                break;
            case exports.DialogStatusWarning:
                icon = React.createElement(warning_1.default, { color: "#949494" });
                break;
            case exports.DialogStatusError:
            default:
                icon = React.createElement(error_1.default, { color: "#ff0000" });
                break;
        }
        return (React.createElement("div", { className: cssClass, style: this.props.style },
            React.createElement("div", { className: "dialog-icon" }, icon),
            this.props.title
                ? React.createElement("h3", { className: "dialog-title" }, this.props.title)
                : "",
            React.createElement("div", { className: "dialog-description" }, this.props.children)));
    };
    return StatusView;
}(React.Component));
exports.default = StatusView;


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var l10n_1 = __webpack_require__(18);
var websiteData = __webpack_require__(4);
var Dialog_1 = __webpack_require__(711);
var Rating_1 = __webpack_require__(712);
var CelebrationTypes;
(function (CelebrationTypes) {
    CelebrationTypes[CelebrationTypes["Vcard"] = 0] = "Vcard";
    CelebrationTypes[CelebrationTypes["Publish"] = 1] = "Publish";
})(CelebrationTypes = exports.CelebrationTypes || (exports.CelebrationTypes = {}));
var MomentsToCelebrate = (function () {
    function MomentsToCelebrate() {
    }
    MomentsToCelebrate.prototype.show = function (type) {
        var _this = this;
        if (!this.checkType(type)) {
            return false;
        }
        this.celebrationContainer = document.createElement('div');
        this.celebrationContainer.id = 'diy-moments-to-celebrate-dialog';
        document.body.appendChild(this.celebrationContainer);
        var styles = this.getStyles();
        ReactDOM.render(React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(Dialog_1.default, { title: l10n_1.default('maintenance.dialog.title'), autoDetectWindowHeight: false, width: styles.width, contentStyle: styles.content, titleStyle: styles.title, bodyStyle: styles.body, dataTestId: "moments-to-celebrate", primaryButtonConfig: {
                    label: l10n_1.default('maintenance.dialog.closeLabel'),
                    callback: function () { return _this.hide(); }
                } },
                React.createElement("div", { style: styles.congratsMessage.root },
                    React.createElement("span", { style: styles.congratsMessage.congratsIcon }),
                    React.createElement("span", { style: styles.congratsMessage.congratsText }, type === CelebrationTypes.Publish
                        ? l10n_1.default('maintenance.dialog.congratsText')
                        : l10n_1.default('maintenance.dialog.congratsTextVcard'))),
                React.createElement(Rating_1.default, { showAlternative: type !== CelebrationTypes.Publish }))), this.celebrationContainer);
        return true;
    };
    ;
    MomentsToCelebrate.prototype.hide = function () {
        if (this.celebrationContainer) {
            ReactDOM.unmountComponentAtNode(this.celebrationContainer);
            this.celebrationContainer.parentElement.removeChild(this.celebrationContainer);
            this.celebrationContainer = null;
        }
        return true;
    };
    ;
    MomentsToCelebrate.prototype.getStyles = function () {
        return {
            width: 750,
            content: {
                transform: 'translate3d(0, 0, 0)' // override the distance from viewport y=0
            },
            title: {
                textAlign: "center",
                color: "#004192"
            },
            body: {
                backgroundColor: "#FFFFFF"
            },
            congratsMessage: {
                root: {
                    padding: "30px 0 24px 0",
                    backgroundColor: "#0f95fc",
                    textAlign: "center",
                    margin: "0 18px"
                },
                congratsIcon: {
                    backgroundImage: "url(" + websiteData.getCdnUrl() + "/s/diy/common/img/icons/success_96x96.png)",
                    backgroundPosition: "0 0",
                    width: "96px",
                    height: "96px",
                    display: "block",
                    margin: "0 auto"
                },
                congratsText: {
                    fontSize: "26px",
                    lineHeight: "32px",
                    fontFamily: "'Open Sans',Arial,sans-serif",
                    fontWeight: "lighter",
                    color: "#FFFFFF",
                    margin: "0 100px",
                    textAlign: "center",
                    display: "block",
                    paddingTop: "20px"
                }
            }
        };
    };
    ;
    MomentsToCelebrate.prototype.checkType = function (type) {
        return CelebrationTypes[type] ? true : false;
    };
    ;
    MomentsToCelebrate.prototype.getPageTrackingName = function (type) {
        var pageName;
        switch (type) {
            case CelebrationTypes.Vcard:
                pageName = 'Vcard-Congratulations';
                break;
            case CelebrationTypes.Publish:
                pageName = 'Publish-Congratulations';
                break;
            default:
                pageName = null;
                break;
        }
        return pageName;
    };
    return MomentsToCelebrate;
}());
exports.default = MomentsToCelebrate;


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var Dialog = (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.handlePrimaryActionCallback = function () {
            _this.handleClose();
            if (_this.props.primaryButtonConfig.callback) {
                _this.props.primaryButtonConfig.callback();
            }
        };
        _this.handleSecondaryActionCallback = function () {
            _this.handleClose();
            if (_this.props.secondaryButtonConfig && _this.props.secondaryButtonConfig.callback) {
                _this.props.secondaryButtonConfig.callback();
            }
        };
        _this.state = {
            open: false
        };
        return _this;
    }
    ;
    Dialog.prototype.render = function () {
        var styles = this.getStyles();
        var actions = [];
        if (this.props.secondaryButtonConfig) {
            actions.push(React.createElement(FlatButton_1.default, { primary: this.props.secondaryButtonConfig.primary, label: this.props.secondaryButtonConfig.label, onTouchTap: this.handleSecondaryActionCallback, "data-test-id": this.props.dataTestId ? this.props.dataTestId + "-button-secondary" : null }));
        }
        if (this.props.primaryButtonConfig) {
            actions.push(React.createElement(RaisedButton_1.default, { primary: true, label: this.props.primaryButtonConfig.label, onTouchTap: this.handlePrimaryActionCallback, "data-test-id": this.props.dataTestId ? this.props.dataTestId + "-button-primary" : null }));
        }
        return (React.createElement(Dialog_1.default, { open: this.state.open, autoDetectWindowHeight: this.props.autoDetectWindowHeight, title: this.props.title, actions: actions, titleStyle: styles.title, contentStyle: styles.content, bodyStyle: styles.body, actionsContainerStyle: styles.actions, onRequestClose: this.props.onRequestClose, style: styles.root }, this.props.children));
    };
    ;
    Dialog.prototype.componentDidMount = function () {
        this.setState({
            open: true
        });
    };
    ;
    Dialog.prototype.componentWillUnmount = function () {
        this.handleClose();
    };
    ;
    Dialog.prototype.getStyles = function () {
        return {
            root: {
                zIndex: 200100
            },
            title: Object.assign({}, {}, this.props.titleStyle),
            body: Object.assign({}, {
                padding: 0,
                borderBottom: '1px solid #dddddd',
                backgroundColor: '#f3f3f3'
            }, this.props.bodyStyle),
            content: Object.assign({}, {
                width: this.props.width || undefined
            }, this.props.contentStyle),
            actions: Object.assign({}, {
                padding: 18
            }, this.props.actionStyle)
        };
    };
    ;
    return Dialog;
}(React.Component));
Dialog.defaultProps = {
    autoDetectWindowHeight: true
};
exports.default = Dialog;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var survey = __webpack_require__(713);
var Rating = (function (_super) {
    tslib_1.__extends(Rating, _super);
    function Rating(props) {
        return _super.call(this, props) || this;
    }
    ;
    Rating.prototype.render = function () {
        var styles = this.getStyles();
        if (this.props.showAlternative) {
            return (React.createElement("div", { style: styles.root },
                React.createElement("p", { style: styles.text }, l10n_1.default('maintenance.dialog.ratingAlternative'))));
        }
        else {
            if (survey.isSurveyEnabled()) {
                return (React.createElement("div", { style: styles.root },
                    React.createElement("p", { style: styles.text },
                        l10n_1.default('maintenance.dialog.ratingPreText'),
                        "\u00A0",
                        React.createElement("a", { style: styles.link, onClick: function () {
                                survey.showFromPublishCongratulations(true);
                            }, tabIndex: -1 }, l10n_1.default('maintenance.dialog.ratingLinkText')),
                        "\u00A0",
                        l10n_1.default('maintenance.dialog.ratingAfterText'))));
            }
            else {
                return null;
            }
        }
    };
    ;
    Rating.prototype.getStyles = function () {
        return {
            root: {
                padding: "0 20px"
            },
            text: {
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "center",
                marginBottom: 0,
                paddingTop: "13px",
                paddingBottom: "13px"
            },
            link: {
                cursor: "pointer",
                color: "#08c",
                textDecoration: "none"
            }
        };
    };
    ;
    return Rating;
}(React.Component));
Rating.defaultProps = {
    showAlternative: false
};
exports.default = Rating;


/***/ },
/* 713 */
/***/ function(module, exports) {

/* globals OAO, jimdoData */
module.exports = {
    init: function() {
        //TODO: here we should move the init code from surveyScriptLoader.js
    },

    show: function(whatToLoad, fromWhere) {
        //TODO: this should be refactored to init the OAO object.
        if (OAO && OAO.survey && OAO.survey.isLoaded) {
            OAO.survey.openSurvey(whatToLoad, fromWhere);
        }
    },
    closeOpenedWindows: function() {
        diy.editor.siteadmin.api.close();
    },

    showFromPublishCongratulations: function(closeOpenedWindows) {
        if (closeOpenedWindows === true) {
            this.closeOpenedWindows();
        }
        this.show('feedback', 'diyFirstPublish');
    },

    isSurveyEnabled: function() {
        return (jimdoData.surveyData.countryCode === 'de' ||
        jimdoData.surveyData.countryCode === 'us' ||
        jimdoData.surveyData.countryCode === 'uk');
    }
};


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var typedActions_1 = __webpack_require__(229);
var index_1 = __webpack_require__(536);
var siteAdmin = __webpack_require__(20);
var initialState = {
    isShown: true
};
// =======
// REDUCER
// =======
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    if (typedActions_1.isType(action, index_1.close)) {
        return Object.assign({}, state, {
            isShown: true
        });
    }
    if (typedActions_1.isType(action, index_1.open)) {
        return Object.assign({}, state, {
            isShown: false
        });
    }
    return state;
}
// ====================
// STATE CHANGE HANDLER
// ====================
function select(state) {
    return state.siteAdmin;
}
function stateChangeHandler(currentState, previousState) {
    if (previousState.isShown !== currentState.isShown) {
        if (currentState.isShown) {
            siteAdmin.show();
        }
        else {
            siteAdmin.hide();
        }
    }
}
// ==============
// INITIALIZATION
// ==============
function init(storeProvider) {
    storeProvider.addReducer(reducer, "siteAdmin");
    storeProvider.watchStore(select, stateChangeHandler);
}
exports.init = init;


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var features = __webpack_require__(25);
var IframeContext_1 = __webpack_require__(716);
var color_1 = __webpack_require__(504);
var AppsIntegration_1 = __webpack_require__(721);
var sectionsWeb = __webpack_require__(636);
var Api = (function () {
    function Api(app) {
        this.app = app;
    }
    Api.prototype.init = function () {
        // Used by trialLayer.
        // TODO: remove namespace when api.js and trialLayer.js are migrated to webpack
        diy.appUpsell = __webpack_require__(727);
        diy.core.namespace('diy.help').callback = __webpack_require__(728);
        // Expose Semantic data api to APPS SDK
        diy.core.namespace('diy.editor.semanticdata').api = __webpack_require__(8);
        diy.core.namespace('diy.util').color = color_1.default;
        Object.assign(diy.core.namespace('diy.editor'), {
            // Tariff update
            // TODO: remove this namespace when UpgradeLayer.js is migrated to webpack
            tariffUpdate: __webpack_require__(730),
            // Expose apps catalog to APPS SDK and non-webpack code
            appsCatalog: __webpack_require__(11),
            // Expose to non-webpack code
            deeplinking: __webpack_require__(9),
            // Expose facebook app id to non-webpack code
            getFacebookAppId: __webpack_require__(731)
        });
        Object.assign(diy.core.namespace('diy.editor.siteadmin'), {
            api: __webpack_require__(19)
        });
        Object.assign(diy.core.namespace('diy.editor.siteadmin.controllers'), {
            // Expose legacy objects for non-webpack code
            guidedSetup: __webpack_require__(732),
            appsCatalog: __webpack_require__(741),
            layoutSelector: __webpack_require__(742),
            theming: __webpack_require__(753),
            moduleSelector: __webpack_require__(795),
            pagesEditor: __webpack_require__(796),
            showroom: __webpack_require__(797),
            sectionSelector: __webpack_require__(800),
            onboardingGuide: __webpack_require__(819),
            fbpb: __webpack_require__(840)
        });
        if (features('apps')) {
            // Expose to SDK
            diy.editor.appsIntegration = new AppsIntegration_1.AppsIntegration();
        }
        if (features('appsExtensionPoint')) {
            var appExtensionPoint = __webpack_require__(841);
            diy.editor.siteadmin.controllers.appExtensionPoint = appExtensionPoint;
        }
        // Context object for siteadmin iframe (exports API from main window)
        var iframeContext = new IframeContext_1.IframeContext(this.app);
        diy.editor.siteadmin.exportContext = function () { return iframeContext.export(); };
        diy.core.namespace('diy.module.section').initWeb = sectionsWeb.initWeb;
    };
    Api.prototype.initUndoRedoApi = function (undoRedo) {
        diy.editor.undoRedo = undoRedo;
    };
    return Api;
}());
exports.Api = Api;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

// This exports variables from the top window to the siteadmin iframe
Object.defineProperty(exports, "__esModule", { value: true });
var features = __webpack_require__(25);
var globalEvents = __webpack_require__(500);
var l10n_1 = __webpack_require__(18);
var websiteData = __webpack_require__(4);
var helper = __webpack_require__(717);
var deeplinking = __webpack_require__(9);
var color_1 = __webpack_require__(504);
var maintenanceMode = __webpack_require__(668);
var MaintenanceModeWidget = __webpack_require__(720);
var siteadminApi = __webpack_require__(19);
var semanticDataRefresher = __webpack_require__(7);
var semanticDataApi = __webpack_require__(8);
var page = __webpack_require__(719);
var IframeContext = (function () {
    function IframeContext(app) {
        this.app = app;
    }
    IframeContext.prototype.export = function () {
        return {
            jQuery: jQuery,
            jimdoData: jimdoData,
            uiPreference: diy.editor.uiPreference,
            deeplinking: deeplinking,
            features: features,
            globalEvents: globalEvents,
            l10n: {
                getString: l10n_1.getString,
                getMessages: l10n_1.getMessages
            },
            websiteData: websiteData,
            helper: helper,
            maintenanceMode: maintenanceMode,
            MaintenanceModeWidget: MaintenanceModeWidget,
            siteadminApi: siteadminApi,
            semanticDataApi: semanticDataApi,
            semanticDataRefresher: semanticDataRefresher,
            page: page,
            vCardEditor: this.app.vCardEditor,
            colorUtil: color_1.default
        };
    };
    return IframeContext;
}());
exports.IframeContext = IframeContext;


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*global diy */

var $ = __webpack_require__(3);
var UUID = __webpack_require__(718);
var websiteData = __webpack_require__(4);
var page = __webpack_require__(719);

var
    SESSION_ID_COOKIE_NAME = 'DIY_SB',
    Helper;

if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require. Use 'diy.editor.util.helper' instead");
}

/**
 * @class diy.util.Helper
 * @template diy.util.Helper
 * @lends {diy.util.Helper.prototype}
 * @constructor
 */
Helper = Klazz.extend({
    /**
     * Detects if the user has just logged in
     *
     * @returns {boolean}
     */
    isJustLoggedIn: function () {
        return (diy.editor.isJustLoggedIn && diy.editor.isJustLoggedIn === 1);
    },
    /**
     * Returns the current pageId opened in user's browser
     *
     * @returns {Number}
     */
    getCurrentPageId: function () {
        return parseInt(page.getCurrentPageId(), 10);
    },

    /**
     * Returns the current websiteId
     * @returns {Number}
     */
    getWebsiteId: function () {
        return parseInt(websiteData.getId(), 10);
    },
    /**
     * Returns the current session name
     *
     * @returns {String}
     */
    getSessionName: function () {
        return $.cookie(SESSION_ID_COOKIE_NAME);
    },
    /**
     * Zero-padding function
     *
     * @param n number to be padded
     * @param {Number} width length of the resulting string
     * @param {String} z characters to pad with, default '0'
     * @returns {string}
     */
    formatIndex: function (n, width, z) {
        z = z || '0';
        width = width || 7;

        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    /**
     * Generates an unique string UUID.random format
     *
     * @returns {String}
     */
    generateKey: function () {
        return UUID.generate();
    },

    /**
     * Capitalize the given string
     *
     * @param string
     * @returns {string}
     */
    capitalize: function (string) {
        string += '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /**
     * Uses jQuery.loadingBox to create interface blockers
     *  above content and ui elements
     * Creates div.diye.diy-util-helper-overlay in body with a dynamic top zIndex and returns an id to be used as
     *  a jQuery filter
     *
     * @param {Object} addOptions - will extend default options that will be passed to jQuery.loadingBox
     * @param {Boolean=} clearAll
     * @param {Boolean=} createBox
     * @param {String=} overlayClassName
     * @returns {string}
     */
    overlay: function (addOptions, clearAll, createBox, overlayClassName) {
        var
            defaultClassName = 'diy-util-helper-overlay',
            zIndex = diy.editor.getNewTopZIndex(),
            options = {
                useOverlay: true,
                zIndex: zIndex
            },

            clearBoxes = ((clearAll === false) ? clearAll : true),
            createNew = ((createBox === false) ? createBox : true),
            className = (typeof overlayClassName === 'undefined')? defaultClassName: overlayClassName.toString(),
            boxId = className.replace(/\./g, '-') + '-' + UUID.generate(),
            boxHtml,
            box;

        if (clearBoxes) {
            $('body>div.diye.' + className).remove();
        }

        if (createNew === true) {
            boxHtml = [
                '<div ', 'class="diye ',  className, '"', ' id="', boxId, '"',
                ' style="z-index:', zIndex, ';', '"></div>'
                ].join("");

            $('body').append(boxHtml);

            $.extend(true, options, addOptions);
            box = $('body #' + boxId);
            box.loadingBox(options).show();

            return boxId;
        }
    },
    /**
     * Performs a browser reload / redirect to the given url
     *  using fade effect
     *
     * @param {?String} url
     * @param {?String} message
     * @param {Number=} delay
     */
    browserReload: function (url, message, delay) {
        var options = {};

        delay = delay || 100;

        if (message) {
            options = {loadingText: message.toString()};
        }

        this.overlay(options, true, true);

        $('body').find('.loadingBox-overlay:visible').animate({
            opacity: 1
        }, 2000);
        /*
         * safari for mac seems to freeze the UI when starting a form
         * request that changes the current page.
         * for this reason, we wait a bit for the loadingBox to display
         * and only after that we reload the page
         */
        if (delay >= 0) {
            Q.delay(delay).done(
                function () {
                    if (url === null) {
                        window.location.reload();
                    } else {
                        window.location.href = url;
                    }
                }
            );
        }
    }
});

module.exports = new Helper();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 718 */
/***/ function(module, exports) {

var UUID, i, lut = [];

for (i = 0; i < 256; i++) {
    lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
}
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 *
 * @class diy.util.UUID
 * @template diy.util.UUID
 * @lends {diy.util.UUID.prototype}
 * @constructor
 */
UUID = (function () {
    return {
        generate: function () {
            var
                d0 = Math.random() * 0xffffffff | 0,
                d1 = Math.random() * 0xffffffff | 0,
                d2 = Math.random() * 0xffffffff | 0,
                d3 = Math.random() * 0xffffffff | 0;

            return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
                lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
                lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
                lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
        }
    };
}());

module.exports = UUID;


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

(function () {

    /**
     * helper function to determining if the user is editing (has editing layers open)
     */
    this.isEditing = function () {
        var editing = CC.EmotionHeader.isOpen() ||
                window.Modul.getActiveModule() ||
                jQuery(':diy-confirmationDialog:visible').length
            ;
        return editing;
    };

    /**
     * return the bodys page id if set
     *
     * @returns {*|jQuery}
     */
    this.getCurrentPageId = function() {
        return $(document.body).attr('data-pageid')
    };

}).call(exports);


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var maintenanceMode = __webpack_require__(668);
var domainpromo = __webpack_require__(546);
var l10n = __webpack_require__(18);
var features = __webpack_require__(25);

var Widget;

/**
 * Class rendering the publish button or on/off switch for the maintenance mode
 * Not a jQuery UI widget because we can't define it without polluting the
 * jquery.fn namespace
 */
Widget = Klazz.extend({
    options: {
        baseCls: 'diy-maintenance-widget'
    },

    /**
     * @param JQuery element
     */
    initialize: function(element) {
        this.element = element;

        this._create();
        this._init();
    },

    _create: function() {
        this.element.append(this.getHtml());
        this.element.addClass(this.options.baseCls);
    },

    _init: function() {
        this.element
            .find('.' + this.options.baseCls + '-switch')
            .diy_switch({
                showLabels: true,
                labels: {
                    unchecked: l10n.getString('toolbar.maintenance.switch.offline.label'),
                    checked: l10n.getString('toolbar.maintenance.switch.online.label')
                },
                change: this.toggle.bind(this)
            });

        this.refresh();
    },

    getHtml: function() {
        return '<div class="' + this.options.baseCls + '-switch"></div>';
    },

    refresh: function() {
        this.updateState();
    },

    updateState: function() {
        var state = maintenanceMode.getState();
        this._setState(state);
    },

    _setState: function(state) {
        this.element
            .find('.' + this.options.baseCls + '-switch')
            .diy_switch('option', 'checked', !state);
    },

    toggle: function(active) {
        maintenanceMode
            .toggleState(active)
            .done();
    }
});

module.exports = Widget;


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This script is an api for app-server javascript handlers, which wraps and provides access to internal site-builder
 *
 * functions such as deep-linking into rendered areas (site-admin,etc), opening/closing/saving module views
 *
 * @author znsakala
 */
var $ = __webpack_require__(3);
var l10n = __webpack_require__(18);
var appsApiConstants = __webpack_require__(13);
var appsCatalog = __webpack_require__(11);
var moduleSelector_1 = __webpack_require__(10);
var siteAdminApi = __webpack_require__(19);
var progressDialogApi = __webpack_require__(722);
var progressDialogDispatcher = __webpack_require__(725);
var infoDialogApi = __webpack_require__(706);
var websiteData = __webpack_require__(4);
var mainCategoryRequestUrl = '/app/siteadmin/appscatalog/webapps-get-main-category';
var wbcExternalSettingLink = null;
var AppsIntegration = (function () {
    function AppsIntegration() {
    }
    /**
     * Opens app catalog site-admin fly-out window
     */
    AppsIntegration.prototype.openAppCatalog = function () {
        appsCatalog.customOpen();
    };
    ;
    /**
     * Opens semantic data dialog in site-admin bar
     */
    AppsIntegration.prototype.openSemanticDataDialog = function () {
        diy.editor.deeplinking.requestPath([
            { label: 'siteadmin', params: 'settings' },
            { label: 'SAC.Settings', params: 'personal-data' }
        ]);
    };
    /**
     * Opens module selector fly-out window and highlights a specific module selector item identified by webComponentId
     *
     * @param webComponentId id of web component item to be highlighted on module selector
     *
     * @throws error if given web component id is invalid or corresponding main category on module selector is not found
     */
    AppsIntegration.prototype.openModuleSelector = function (webComponentId) {
        $.ajax({
            url: mainCategoryRequestUrl,
            type: 'POST',
            dataType: 'json',
            data: { wc_id: webComponentId },
            success: function (result) {
                if (!result.data.main_category) {
                    throw appsApiConstants.errors.MODULE_MAIN_CATEGORY_NOT_FOUND + ': ' + webComponentId;
                }
                moduleSelector_1.default.jumpToWebComponent(webComponentId, result.data.main_category);
            },
            error: function () {
                throw appsApiConstants.errors.MODULE_SELECTOR_OPENING_EVENT + ': ' + webComponentId;
            }
        });
    };
    ;
    /**
     * Adds a page to site-builder containing a webComponent identified by given web-component-id
     *
     * @param webComponentId  parameter determining which webcomponent hast to be added to new pages
     * @param externalSettingsLink link to external settings for concerned webcomponent
     * @param isUniqueRequest parameter determining whether this request should occur only once or not
     *
     * @throws error if page creation job could not be scheduled
     */
    AppsIntegration.prototype.addPageWithWebComponent = function (webComponentId, externalSettingsLink, isUniqueRequest) {
        var _this = this;
        siteAdminApi.close();
        $.ajax({
            url: '/app/cms/webcomponentpage/add',
            type: 'POST',
            dataType: 'json',
            headers: {
                'Accept': 'application/vnd.oneandone.diy.website.webcomponent-page-creation+json'
            },
            data: {
                isUniqueRequest: isUniqueRequest,
                webComponentId: webComponentId
            },
            success: function (result) {
                if (result.status !== 'job_skipped') {
                    _this.initPageCreationProgressDialog(webComponentId);
                    _this.runPageCreationProgressTasks(webComponentId, isUniqueRequest, result);
                    wbcExternalSettingLink = externalSettingsLink;
                }
            },
            error: function () {
                throw appsApiConstants.errors.INTERNAL_SERVER_ERROR;
            }
        });
    };
    ;
    /**
     * Triggers display of page creation progress dialog
     */
    AppsIntegration.prototype.initPageCreationProgressDialog = function (webComponentId) {
        progressDialogApi.showDialog([
            {
                identifier: appsApiConstants.pageCreationSteps.STEP_PREPARATION,
                title: l10n.getString('webComponentPageCreation.progress.successfull.steps.preparation.' +
                    webComponentId)
            },
            {
                identifier: appsApiConstants.pageCreationSteps.STEP_PAGE_CREATION,
                title: l10n.getString('webComponentPageCreation.progress.successfull.steps.pageCreation.' +
                    webComponentId)
            },
            {
                identifier: appsApiConstants.pageCreationSteps.STEP_WEBCOMPONENT_CREATION,
                title: l10n.getString('webComponentPageCreation.progress.successfull.steps.webcomponentCreation.' +
                    webComponentId)
            }
        ], {
            title: l10n.getString('webComponentPageCreation.progress.successfull.title.' + webComponentId),
            description: l10n.getString('webComponentPageCreation.progress.successfull.description.' + webComponentId),
            image: websiteData.getCdnUrl() + 's/diy/site-admin/main/img/webcomponent-page-progress.png',
            imageHeight: 220
        });
    };
    ;
    /**
     * Polls page creation tasks status and update dialog content accordingly
     *
     * @param webComponentId  web component id to be used to
     * @param isUniqueRequest flag determining whether process can be triggered several times or not
     * @param creationFeature page create feature resource provided by backend
     */
    AppsIntegration.prototype.runPageCreationProgressTasks = function (webComponentId, isUniqueRequest, creationFeature) {
        var _this = this;
        if (creationFeature.status === 'job_aborted') {
            progressDialogDispatcher.dispatch(this.getProgressTaskStatus(creationFeature.status));
            throw appsApiConstants.errors.INTERNAL_SERVER_ERROR;
        }
        if (creationFeature.status === 'job_finished') {
            if (!creationFeature.pageId) {
                progressDialogDispatcher.dispatch(this.getProgressTaskStatus('job_aborted'));
                throw appsApiConstants.errors.INTERNAL_SERVER_ERROR;
            }
            else {
                this.showPageCreationSuccessDialog(webComponentId, creationFeature.pageId);
            }
            return;
        }
        progressDialogDispatcher.dispatch(this.getProgressTaskStatus(creationFeature.status));
        setTimeout(function () {
            $.ajax({
                url: '/app/cms/webcomponentpage/status',
                type: 'GET',
                dataType: 'json',
                headers: {
                    'Accept': 'application/vnd.oneandone.diy.website.webcomponent-page-creation+json'
                },
                data: {
                    isUniqueRequest: isUniqueRequest,
                    webComponentId: webComponentId
                },
                success: function (result) {
                    if (!result.status) {
                        throw appsApiConstants.errors.INTERNAL_SERVER_ERROR;
                    }
                    else {
                        _this.runPageCreationProgressTasks(webComponentId, isUniqueRequest, result);
                    }
                },
                error: function () {
                    throw appsApiConstants.errors.INTERNAL_SERVER_ERROR;
                }
            });
        }, 2000);
    };
    ;
    /**
     * Triggers display of web-component success dialog
     */
    AppsIntegration.prototype.showPageCreationSuccessDialog = function (webComponentId, pageId) {
        var _this = this;
        progressDialogApi.hideDialog();
        setTimeout(function () {
            infoDialogApi.showDialog({
                title: l10n.getString('webComponentPageCreation.success.title.' + webComponentId),
                description: _this.getPageCreationDialogSuccessDescription(webComponentId),
                image: websiteData.getCdnUrl() + 's/diy/site-admin/main/img/webcomponent-page-success.png',
                imageHeight: 220,
                primaryButtonConfig: {
                    label: l10n.getString('webComponentPageCreation.success.invitation.button.' + webComponentId),
                    callback: function () {
                        $(document).trigger("diy-editor-generic-linkInteraction", {
                            pageName: "MyShopReady",
                            actionName: "jumptoPage"
                        });
                        _this.disablePageCreationSuccessDialog(webComponentId, 'notification_accepted', function () {
                            location.href = cc_.properties.cmsUrl + 'app/' + script_basisID + '/' + pageId;
                        });
                    }
                },
                secondaryButtonConfig: {
                    label: l10n.getString('webComponentPageCreation.success.closeButton'),
                    callback: function () {
                        $(document).trigger("diy-editor-generic-linkInteraction", {
                            pageName: "MyShopReady",
                            actionName: "close"
                        });
                        _this.disablePageCreationSuccessDialog(webComponentId, 'notification_rejected', function () {
                            location.reload();
                        });
                    }
                }
            });
        }, 300);
        $(document).trigger('diy-editor-generic-sectionAccessed', { 'sectionCodeName': 'myShopReady' });
    };
    ;
    /**
     * triggers deactivation of success dialog per website feature deactivation on server
     *
     * @param webComponentId concerned webComponentId
     * @param status disabling status
     * @param callback
     */
    AppsIntegration.prototype.disablePageCreationSuccessDialog = function (webComponentId, status, callback) {
        $.ajax({
            url: '/app/cms/webcomponentpage/disable-notification',
            type: 'POST',
            dataType: 'json',
            headers: {
                'Accept': 'application/vnd.oneandone.diy.website.webcomponent-page-notification+json'
            },
            data: {
                webComponentId: webComponentId,
                status: status
            },
            error: function () {
                throw appsApiConstants.errors.INTERNAL_SERVER_ERROR;
            },
            success: function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    };
    ;
    /**
     * Retrieves description of success dialog message to be displayed
     *
     * Note that if appserver API caller provided an externalSettingsLink,
     * this one will be appended to description too
     */
    AppsIntegration.prototype.getPageCreationDialogSuccessDescription = function (webComponentId) {
        var link = '';
        var description = l10n.getString('webComponentPageCreation.success.description.' + webComponentId);
        var trackJumpLink = function () {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                'pageName': "MyShopReady",
                'actionName': 'jumptoMBO'
            });
        };
        $('body').on('click', '[data-track="myshop-flyout-jumpout"]', trackJumpLink);
        if (wbcExternalSettingLink) {
            link = $('<a href="' + wbcExternalSettingLink + '" target="_blank" data-track="myshop-flyout-jumpout"' +
                'style="text-decoration:none; color:#0FABFC;">' + ' ' +
                l10n.getString('webComponentPageCreation.success.invitation.link.'
                    + webComponentId) + '</a>')[0].outerHTML;
        }
        else {
            link = l10n.getString('webComponentPageCreation.success.invitation.link.' + webComponentId);
        }
        return description.replace('{link}', link);
    };
    ;
    /**
     * Retrieves current page creation progress status
     */
    AppsIntegration.prototype.getProgressTaskStatus = function (jobStatus) {
        var taskStatus = {};
        switch (jobStatus) {
            case 'job_empty':
                taskStatus = {
                    identifier: appsApiConstants.pageCreationSteps.STEP_PREPARATION,
                    state: 1
                };
                break;
            case 'job_started':
                taskStatus = {
                    identifier: appsApiConstants.pageCreationSteps.STEP_PREPARATION,
                    state: 2
                };
                break;
            case 'page_created':
                taskStatus = {
                    identifier: appsApiConstants.pageCreationSteps.STEP_PAGE_CREATION,
                    state: 2
                };
                break;
            case 'web_component_added':
                taskStatus = {
                    identifier: appsApiConstants.pageCreationSteps.STEP_WEBCOMPONENT_CREATION,
                    state: 2
                };
                break;
            case 'job_aborted':
                taskStatus = {
                    identifier: appsApiConstants.pageCreationSteps.STEP_PREPARATION,
                    state: 3
                };
                break;
            default:
                break;
        }
        return taskStatus;
    };
    ;
    return AppsIntegration;
}());
exports.AppsIntegration = AppsIntegration;


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var ProgressTask_1 = __webpack_require__(723);
var ProgressDialog_1 = __webpack_require__(726);
var ProgressStatus_1 = __webpack_require__(724);
var dialogContainer;
/**
 * To open the ProgressDialog
 *
 * @param tasksArray: any[]
 * @example  [{identifier: "task_name", title: "TaskTitle"}, {identifier: "task_name2", title: "TaskTitle2"},]
 * @param options:    DialogOptions
 */
function showDialog(tasksArray, options) {
    dialogContainer = document.createElement('div');
    var dialogTasks = [];
    var registeredDialogTasks = [];
    tasksArray.reverse().forEach(function (task, key) {
        dialogTasks.splice(0, 0, React.createElement(ProgressTask_1.default, { identifier: task.identifier, title: task.title, state: ProgressStatus_1.Status.WAITING, followedBy: registeredDialogTasks.slice(), key: key, index: tasksArray.length - key, layout: ProgressTask_1.Layout.STEPS }));
        registeredDialogTasks.push(task.identifier);
    });
    ReactDOM.render(React.createElement(ProgressDialog_1.default, { title: options.title, description: options.description, image: options.image, imageHeight: options.imageHeight, tasks: dialogTasks, open: true }), dialogContainer);
    document.body.appendChild(dialogContainer);
}
exports.showDialog = showDialog;
function hideDialog() {
    ReactDOM.unmountComponentAtNode(dialogContainer);
}
exports.hideDialog = hideDialog;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ProgressStatus_1 = __webpack_require__(724);
var Dispatcher = __webpack_require__(725);
var Layout;
(function (Layout) {
    Layout[Layout["SPINNER"] = 0] = "SPINNER";
    Layout[Layout["STEPS"] = 1] = "STEPS";
})(Layout = exports.Layout || (exports.Layout = {}));
var ProgressTask = (function (_super) {
    tslib_1.__extends(ProgressTask, _super);
    function ProgressTask(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            root: {
                width: "30%",
                paddingTop: "10px"
            },
            active: {
                color: "#222222"
            },
            task: {
                display: "block",
                textAlign: "center",
                margin: "auto",
                paddingTop: "10px"
            }
        };
        _this.state = {
            actualState: _this.props.state
        };
        _this.changeState = _this.changeState.bind(_this);
        Dispatcher.register(_this.props.identifier, _this.changeState);
        return _this;
    }
    /**
     * This get called BEFORE the component get removed from DOM.
     * It removes the task from the Dispatcher register.
     */
    ProgressTask.prototype.componentWillUnmount = function () {
        Dispatcher.unregister(this.props.identifier);
    };
    /**
     * This callback is registered at the PorgressDialogDispatcher so it get called with every dispatch.
     * It will look in the payload if the field identifier is equals to the own identifier.
     *
     * @param payload
     */
    ProgressTask.prototype.changeState = function (payload) {
        this.setState({
            actualState: ProgressStatus_1.checkStatus(this, this.state.actualState, payload)
        });
    };
    /**
     * Returns the component view
     *
     * @returns JSX.Element
     */
    ProgressTask.prototype.render = function () {
        var activeStyle = Object.assign({}, this.styles.root, this.styles.active);
        var style = (this.state.actualState === ProgressStatus_1.Status.RUNNING) ? activeStyle : this.styles.root;
        return React.createElement("div", { style: style, id: this.props.identifier },
            React.createElement(ProgressStatus_1.default, { layout: this.props.layout, value: this.state.actualState, index: this.props.index }),
            React.createElement("span", { style: this.styles.task }, this.props.title));
    };
    return ProgressTask;
}(React.Component));
exports.default = ProgressTask;


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
/**
 * Created by marvin on 26.11.15.
 */
var React = __webpack_require__(28);
var Paper_1 = __webpack_require__(391);
var CircularProgress_1 = __webpack_require__(382);
var ProgressTask_1 = __webpack_require__(723);
var check_1 = __webpack_require__(399);
var clear_1 = __webpack_require__(496);
var Status;
(function (Status) {
    Status[Status["WAITING"] = 0] = "WAITING";
    Status[Status["RUNNING"] = 1] = "RUNNING";
    Status[Status["FINISHED"] = 2] = "FINISHED";
    Status[Status["FAILED"] = 3] = "FAILED";
    Status[Status["STOPPED"] = 4] = "STOPPED";
})(Status = exports.Status || (exports.Status = {}));
function checkStatus(element, originalState, payload) {
    if (payload.identifier === element.props.identifier) {
        return payload.state;
    }
    else if (element.props.followedBy.indexOf(payload.identifier) !== -1 &&
        (payload.state !== Status.WAITING && payload.state !== Status.RUNNING)) {
        return Status.FINISHED;
    }
    return originalState;
}
exports.checkStatus = checkStatus;
var ProgressStatus = (function (_super) {
    tslib_1.__extends(ProgressStatus, _super);
    function ProgressStatus(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            progress: {
                margin: "auto"
            },
            paper: {
                margin: "auto",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            active: {
                color: "white",
                backgroundColor: "#2196f3"
            }
        };
        _this.props = {
            value: _this.props.value ? _this.props.value : Status.WAITING,
            layout: _this.props.layout ? _this.props.layout : ProgressTask_1.Layout.SPINNER,
            index: _this.props.index
        };
        return _this;
    }
    ProgressStatus.prototype.render = function () {
        switch (this.props.value) {
            case Status.WAITING:
                return this.waitingState();
            case Status.RUNNING:
                return this.runningState();
            case Status.FINISHED:
                return this.finishState();
            case Status.FAILED:
                return this.failedState();
            case Status.STOPPED:
                return this.stoppedState();
            default:
                return null;
        }
    };
    ProgressStatus.prototype.waitingState = function () {
        switch (this.props.layout) {
            case ProgressTask_1.Layout.SPINNER:
                return (React.createElement(CircularProgress_1.default, { mode: "determinate", value: 70, size: 0.6, color: "#e0e0e0", style: this.styles.progress }));
            case ProgressTask_1.Layout.STEPS:
                return (React.createElement(Paper_1.default, { zDepth: 1, circle: true, style: this.styles.paper }, this.props.index));
            default:
                return null;
        }
    };
    ProgressStatus.prototype.runningState = function () {
        switch (this.props.layout) {
            case ProgressTask_1.Layout.SPINNER:
                return (React.createElement(CircularProgress_1.default, { mode: "indeterminate", size: 0.6, color: this.styles.active.backgroundColor, style: this.styles.progress }));
            case ProgressTask_1.Layout.STEPS:
                var styles = Object.assign({}, this.styles.paper, this.styles.active);
                return (React.createElement(Paper_1.default, { zDepth: 2, circle: true, style: styles }, this.props.index));
            default:
                return null;
        }
    };
    ProgressStatus.prototype.finishState = function () {
        return (React.createElement(Paper_1.default, { zDepth: 1, circle: true, style: this.styles.paper },
            React.createElement(check_1.default, { color: "#4ccd1a" })));
    };
    ProgressStatus.prototype.failedState = function () {
        return (React.createElement(Paper_1.default, { zDepth: 1, circle: true, style: this.styles.paper },
            React.createElement(clear_1.default, { color: "#ff0000" })));
    };
    ProgressStatus.prototype.stoppedState = function () {
        return (React.createElement(Paper_1.default, { zDepth: 1, circle: true, style: this.styles.paper },
            React.createElement(clear_1.default, { color: "grey" })));
    };
    return ProgressStatus;
}(React.Component));
exports.default = ProgressStatus;


/***/ },
/* 725 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var tasks = {};
/**
 * ProgressTask can register here with a callback so it get called with dispatch
 */
function register(name, taskCallback) {
    tasks[name] = taskCallback;
}
exports.register = register;
/**
 * ProgressTask can unregister himself with the id he is saved in the array
 */
function unregister(name) {
    delete tasks[name];
}
exports.unregister = unregister;
/**
 * Dispatch calls every registered callback and give these the payload.
 * The payload should always have the identifier for the ProgressTask and the state the
 * ProgressTask should switch to
 *
 */
function dispatch(payload) {
    Object.keys(tasks).forEach(function (key) {
        if (!tasks[key]) {
            console.error(key + " not found in registered tasks, or removed");
        }
        else {
            tasks[key](payload);
        }
    });
}
exports.dispatch = dispatch;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var LinearProgress_1 = __webpack_require__(695);
var diyLightTheme = __webpack_require__(241);
var Dispatcher = __webpack_require__(725);
var ProgressStatus_1 = __webpack_require__(724);
var ProgressTask_1 = __webpack_require__(723);
var l10n = __webpack_require__(18);
var ProgressDialog = (function (_super) {
    tslib_1.__extends(ProgressDialog, _super);
    function ProgressDialog(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Displays the error message with a close button if on of the tasks get the status failed
         */
        _this.showError = function (payload) {
            if (payload.state === ProgressStatus_1.Status.FAILED) {
                _this.setState({
                    open: true,
                    failed: true
                });
            }
        };
        /**
         * Closes the dialog
         */
        _this.closeDialog = function () {
            _this.setState({
                open: false,
                failed: false
            });
        };
        Dispatcher.register("dialogErrorWatcher", _this.showError);
        _this.state = {
            open: _this.props.open,
            failed: false
        };
        return _this;
    }
    /**
     * Theme customization for the component
     */
    ProgressDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    /**
     * Get called BEFORE the component will be removed from the DOM
     */
    ProgressDialog.prototype.componentWillUnmount = function () {
        this.closeDialog();
    };
    /**
     * Returns the description message for display with unescaped html
     *
     * @returns {{__html: string}}
     */
    ProgressDialog.prototype.getDescription = function () {
        return {
            __html: this.props.description
        };
    };
    /**
     * Returns the error message for display with unescaped html
     *
     * @returns {{__html: string}}
     */
    ProgressDialog.prototype.getErrorMessage = function () {
        return {
            __html: l10n.getString("webComponentPageCreation.progress.error.apologise")
        };
    };
    /**
     * Returns the component view
     *
     * @returns {any}
     */
    ProgressDialog.prototype.render = function () {
        var paddingTop = this.props.imageHeight ? this.props.imageHeight + "px" : "40px";
        var backgroundImage = this.props.image ? "url('" + this.props.image + "')" : 'none';
        var style = {
            zIndex: diy.editor.getNewTopZIndex()
        };
        var dialogStyle = {
            padding: 0
        };
        var bodyStyle = {
            padding: paddingTop + " 40px 30px 40px",
            backgroundImage: backgroundImage,
        };
        var linearProgress;
        if (this.props.layout !== ProgressTask_1.Layout.SPINNER) {
            linearProgress =
                React.createElement("div", { className: "dialog-linear-progress" },
                    React.createElement(LinearProgress_1.default, { mode: "indeterminate", style: { backgroundColor: "#baddfa" } }));
        }
        return (React.createElement(Dialog_1.default, { open: this.state.open, bodyStyle: dialogStyle, contentClassName: "progress-dialog", style: style },
            React.createElement("div", { className: "dialog-body", style: bodyStyle },
                React.createElement("h3", { className: "dialog-title" }, this.props.title),
                React.createElement("div", { className: "progress-tasks" }, this.props.tasks)),
            React.createElement("div", { className: "progress-bar", style: this.state.failed ? { display: 'none' } : {} },
                React.createElement("div", { dangerouslySetInnerHTML: this.getDescription() }),
                linearProgress),
            React.createElement("div", { className: "progress-error", style: this.state.failed ? { display: 'block' } : {} },
                React.createElement("div", { className: "dialog-actions-error", dangerouslySetInnerHTML: this.getErrorMessage() }),
                React.createElement("div", { className: "dialog-actions" },
                    React.createElement(FlatButton_1.default, { onTouchTap: this.closeDialog, label: l10n.getString("webComponentPageCreation.progress.error.closeButton") })))));
    };
    return ProgressDialog;
}(React.Component));
ProgressDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = ProgressDialog;


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Provides premium apps uppsell functionality and support
 *
 * Internal mechanics notes:
 * - config.layerOptions can be overwritten by the openLayer config param
 * - the layer is created and destroyed every time it opens and closes
 * - this system only listens for sendMessage messages while the layer is open
 * - uses the 'revealing module' pattern
 * - the options for opening a modal = {
 *      title: 'the title of the dialog popup',
 *      layerOptions: { //overwrite some of the dialog options
 *          width:
 *          height:
 *      },
 *      onClose: function(loopBackParams){} //function to be called when the dialog closes
 *      loopBackParams: {}, //sent back untouched to the close callback
 * }
 *
 * @author mcojoc
 * @date: 2013
 */
var $ = __webpack_require__(3);
var crossDomain = __webpack_require__(12);

(function () {
    'use strict';

    var layerIsOpen = false;

    var config = {
        //layerOptions are overwritable inside the openLayer
        layerOptions: {
            width: 800,
            height: 400,
            //title: only set in the openLayer options, there is not default value
            title: ''
        },
        //layer config (diy_dialog) but do not allow these to be overwritten
        immutableLayerOptions: {
            //zindex: needs to be above the site-admin
            zIndex: 100116,
            modal: true,
            closeButton: true,
            draggable: false,
            resizable: false
        },
        selectors: {
            //layerClass, value links appUpsell.css
            layerClass: 'appUpsellLayer'
        }
    };
    //hold some temp variables
    var registry = {
        dialogCloseCallback: null,
        dialogLoopBackParams: null,
        layerIsDiv: false,
        //only accept message from here
        iframeLocation: null
    };

    //close type constants:
    //Close button outside the iframe was pressed
    var CLOSE_TYPE_FRAME = 1;
    //Close operation originated inside the iframe
    var CLOSE_TYPE_INNER = 2;
    //listen for this type of messages
    var CROSS_DOMAIN_MESSAGE_TYPE = 'diy.appUpsell.closeLayer';


    /**
     * creates the layer
     * @access private
     */
    var createLayer = function () {
        var layerContent = $((registry.layerIsDiv ? '<div>' : '<iframe>'));
        layerContent.addClass(config.selectors.layerClass);
        return layerContent;
    };
    /**
     * destroys the layer
     * @access private
     */
    var destroyLayer = function () {
        $('.' + config.selectors.layerClass)
            .remove();
    };

    /**
     * close layer operation
     * @access private
     */
    var closeLayer = function (closeType) {
        if (!layerIsOpen) {
            return;
        }

        $('.' + config.selectors.layerClass).diy_dialog('destroy');

        if (typeof registry.dialogCloseCallback === 'function') {
            if (registry.dialogLoopBackParams !== null) {
                registry.dialogCloseCallback(closeType, registry.dialogLoopBackParams);
            } else {
                registry.dialogCloseCallback(closeType);
            }
        }

        destroyLayer();
        detachMessageListener();
        layerIsOpen = false;
    };

    /**
     * Opens an upsell layer
     *
     * @access public
     *
     * @param iframeLocation
     * @param options see top of the file
     */
    var openLayer = function (iframeLocation, options) {
        if (layerIsOpen) {
            return false;
        }

        if (typeof iframeLocation !== 'string') {
            throw "openLayer: iframe location needs to be set as a string";
        }

        /*
         * remember some params because of closeLayer
         */
        if (options !== undefined
                && (typeof options.onClose === 'function')) {
            registry.dialogCloseCallback = options.onClose;
        } else {
            registry.dialogCloseCallback = null;
        }

        // decide to use a div instead of iframe
        if (options !== undefined && (options.layerIsDiv === true)) {
            registry.layerIsDiv = true;
        }

        /*
         * again remember some params because of closeLayer
         */
        if (options !== undefined && options.loopBackParams !== undefined) {
            registry.dialogLoopBackParams = options.loopBackParams;
        } else {
            registry.dialogLoopBackParams = null;
        }
        //remember the iframe location
        registry.iframeLocation = iframeLocation;


        var layerOptions = $.extend(true, {}, config.layerOptions);
        if (options !== undefined && options.layerOptions !== undefined) {
            layerOptions = $.extend(true, layerOptions, options.layerOptions);
        }

        if ((options !== undefined) && (typeof options.title === "string")) {
            layerOptions.title = options.title;
        }

        layerOptions = $.extend(true, layerOptions, config.immutableLayerOptions);

        //dialog close callback
        layerOptions.close = function () {
            closeLayer(CLOSE_TYPE_FRAME);
        };

        // create inner layer and build a dialog around it
        var layer = createLayer();
        if (!registry.layerIsDiv) {
            layer.attr('src', iframeLocation);
        }
        layer.diy_dialog(layerOptions);
        attachMessageListener();
        layerIsOpen = true;

        // expose the inner layer to the outside
        return layer;
    };

    /**
     * @access private
     */
    var attachMessageListener = function () {
        crossDomain.receiver.registerReceiver(
            CROSS_DOMAIN_MESSAGE_TYPE,
            innerFrameCloseHandler,
            registry.iframeLocation
        );
    };
    /**
     * When the dialog closes it detaches the message listener
     * @access private
     */
    var detachMessageListener = function () {
        crossDomain.receiver.unregisterReceiver(CROSS_DOMAIN_MESSAGE_TYPE);
    };

    /**
     * Handles the postMessage messages comming from inside the iframe itself
     */
    var innerFrameCloseHandler = function () {
        closeLayer(CLOSE_TYPE_INNER);
    };

//uncomment if need the init function
//    var init = function () {
//
//    };
//    //immediately call the init function
//    init(); //XXX: this runs before domReady

    //reveal
    $.extend(this, {
        openLayer: openLayer,
        closeLayer: closeLayer,
        CLOSE_TYPE_FRAME: CLOSE_TYPE_FRAME,
        CLOSE_TYPE_INNER: CLOSE_TYPE_INNER
    });

}).call(exports);


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

(function() {
    "use strict";

    var $ = jQuery;
    var msg = jimdoData.messages.callback;
    var alreadyOpened = false;
    var callbackForm = $();

    var openDialog = function() {
        if (alreadyOpened) {
            return;
        }
        alreadyOpened = true;
        callbackForm = $('<div class="callback-form-wrapper"></div>');

        callbackForm.diy_dialog({
            title: msg.dialogTitle,
            dialogClass: 'callback-dialog',
            modal: false,
            resizable: false,
            closeButton: true,
            width: 404,
            zIndex: 100100,
            close: function() {
                formXHR.abort();
                $(this).diy_dialog('destroy').remove();
                alreadyOpened = false;
            }
        });
        callbackForm.loadingBox({useOverlay: true}).show();

        var formXHR = $.ajax({
            url: '/app/help/callback/form',
            success: function (response) {
                __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(729)]; (function(i18n){
                    var libphonenumber = i18n.phonenumbers;

                    callbackForm.html(response);
                    var callNowBtn = callbackForm.find('.callback-call-now');
                    callNowBtn.button({
                        icons: {primary : "callback-call-now-icon"}
                    });

                    var phoneInput = $('#callback_phone', callbackForm);
                    var contactNameInput = $('#callback_name', callbackForm);
                    var countryCombo = $('#callback_country_placeholder');

                    var deleteCusomerData = $('#deletePersonalData', callbackForm);
                    if (deleteCusomerData) {
                        var oldValuesPhone = phoneInput.val(),
                            oldValuesCustomerName = contactNameInput.val();
                        deleteCusomerData
                            .addClass(' ui-button-borderless')
                            .button({
                                text: false,
                                icons: {
                                    primary: 'ui-icon-trash'
                                }
                            })
                            .diy_simpleCallout({
                                content: msg.deletePersonalData,
                                cls: 'callback-delete-tooltip',
                                closable: false,
                                autoHide: true,
                                triggerMode: 'hover',
                                footer: false
                            })
                            .click(function(){
                                callbackForm.loadingBox({useOverlay: true}).show();
                                jQuery.ajax({
                                    type: 'post',
                                    url: '/app/help/callback/save-callback-details',
                                    data: {
                                        callbackName: '',
                                        callbackUnparsedNumber: '',
                                        callbackUnparsedCountry: ''
                                    },
                                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                                    success : function(response) {
//                                        deleteCusomerData.parent().remove();
                                        $('div.callback-details-delete', callbackForm).remove();
                                        phoneInput.val('');
                                        contactNameInput.val('');
                                        jQuery.cookie('contactPhoneInput', '', {path:'/'});
                                        jQuery.cookie('contactNameInput', '', {path:'/'});
                                        jQuery.cookie('contactCountryInput', 'other', {path:'/'});
                                        countryCombo.diy_combobox('rawValue', 'OTHER');
                                        callbackForm.loadingBox().hide();
                                    }
                                });
                            });
                    }

                    phoneInput.diy_textField({
                        tooltipOptions: {
                            anchor: 'right'
                        }
                    });
                    phoneInput.bind('keydown', function(key){
                        phoneInput.diy_textField('clearInvalid');
                    });
                    phoneInput.bind('keyup', function(key){
                        jQuery.cookie('contactPhoneInput', phoneInput.val(), {path:'/'});
                        if (deleteCusomerData && oldValuesPhone && oldValuesPhone != phoneInput.val()) {
//                            deleteCusomerData.parent().remove();
                            $('div.callback-details-delete', callbackForm).remove();
                        }
                    });

                    contactNameInput.bind('keyup', function(key){
                        jQuery.cookie('contactNameInput', contactNameInput.val(), {path:'/'});
                        if (deleteCusomerData && oldValuesCustomerName && oldValuesCustomerName != contactNameInput.val()) {
//                            deleteCusomerData.parent().remove();
                            $('div.callback-details-delete', callbackForm).remove();
                        }
                    });



                    countryCombo.diy_combobox({
                        forceSelection:true,
                        menuCssClass: 'callback-country',
                        renderPreview: function(elem, item){
                            elem.empty();
                            var imgEl = jQuery("<span></span>");
                            imgEl.attr('style', 'display: inline-block');
                            imgEl.addClass(item.iconcssclass);
                            imgEl.appendTo(elem);
                        },
                        renderItem: function(elem, item){
                            var imgEl = jQuery("<span></span>");
                            imgEl.addClass("previewImage " + item.iconcssclass);
                            elem.text(item.label);
                            imgEl.appendTo(elem);
                        },
                        select: function ( event, item ) {
                            jQuery.cookie('contactCountryInput', item.rawValue, {path:'/'});
                        },
                        showInput: false
                    });

                    $('.callback-call-now', callbackForm).click(function(){
                        var res = validatePhoneInput(libphonenumber, phoneInput, countryCombo, false);
                        if (res) {
                            callbackForm.loadingBox({useOverlay: true}).show();
                            registerCallback(
                                $('#callback_name', callbackForm).val(),
                                res.e164Format,
                                res.internationalFormat,
                                $('#callback_phone', callbackForm).val(),
                                $('#callback_country', callbackForm).val()
                            );
                        }
                    });
                    callbackForm.loadingBox().remove();
                }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
            }
        });
    };

    var validatePhoneInput = function(libphonenumber, phoneInput, countryCombo, forceCountry) {
        var phoneNumber = phoneInput.val();
        var regionCode = countryCombo.diy_combobox('rawValue');
        if (regionCode == 'OTHER') {
            regionCode = null;
        }
        try {
            phoneInput.diy_textField('clearInvalid');
            phoneInput.diy_textField('clearErrors');
            var validationRes = validatePhoneNumber(libphonenumber, phoneNumber, regionCode, forceCountry);
            if (!forceCountry && validationRes.regionCode != regionCode) {
                countryCombo.diy_combobox('rawValue', validationRes.regionCode);
                if (validationRes.regionCode != countryCombo.diy_combobox('rawValue')) {
                    // then it's a region not present in the combobox value
                    // let's set it to OTHER COUNTRY
                    countryCombo.diy_combobox('rawValue', 'OTHER');
                }
                jQuery.cookie('contactCountryInput', countryCombo.diy_combobox('rawValue'), {path:'/'});
            }
            return validationRes;
        } catch (e) {
            phoneInput.diy_textField('addError', e);
            phoneInput.diy_textField('showError');
        }
    };

    var validatePhoneNumber = function(libphonenumber, phoneNumber, regionCode, forceCountry) {
        var phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        var errorMsg = null;
        try {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode);

            var isPossible = phoneUtil.isPossibleNumber(number);

            if (!isPossible) {
                errorMsg = msg.error.invalidPhone;
                /*
                var PNV = libphonenumber.PhoneNumberUtil.ValidationResult;
                switch (phoneUtil.isPossibleNumberWithReason(number)) {
                  case PNV.INVALID_COUNTRY_CODE:
                    errorMsg = 'INVALID_COUNTRY_CODE';
                    break;
                  case PNV.TOO_SHORT:
                    errorMsg = 'TOO_SHORT';
                    break;
                  case PNV.TOO_LONG:
                    errorMsg = 'TOO_LONG';
                    break;
                  default:
                    errorMsg = 'GENERAL_IMPOSSIBLE_ERROR';
                }
                */
              } else {
                  if (forceCountry && regionCode) {
                      if (!phoneUtil.isValidNumberForRegion(number, regionCode)) {
                          //errorMsg = 'NUMBER_INVALID_FOR_COUNTRY';
                          errorMsg = msg.error.invalidPhoneForCountry;
                      }
                  } else {
                      if (!phoneUtil.isValidNumber(number)) {
                          //errorMsg = 'NUMBER_INVALID';
                          errorMsg = msg.error.invalidPhone;
                      }
                  }
                  if (!errorMsg) {
                      return {
                          e164Format: phoneUtil.format(number, libphonenumber.PhoneNumberFormat.E164),
                          internationalFormat: phoneUtil.format(number, libphonenumber.PhoneNumberFormat.INTERNATIONAL),
                          regionCode: phoneUtil.getRegionCodeForNumber(number)
                      };
                  }
              }
        } catch (e) {
            //errorMsg = 'GENERAL_EXCEPTION_ERROR';
            if (regionCode) {
                errorMsg = msg.error.invalidPhone;
            } else {
                errorMsg = msg.error.invalidPhoneForOtherCountry;
            }
        }
        if (errorMsg) {
            throw errorMsg;
        }
    };

    var showInputErrror = function (element, errorMsg) {
        element.diy_textField({
            tooltipOptions: {
                anchor: 'right'
            }
        });
        element.diy_textField('addError', errorMsg);
        element.diy_textField('showError');
        element.bind('keydown', function(key){
            element.diy_textField('clearInvalid');
            element.diy_textField('clearErrors');
        });
    };

    var registerCallback = function (name, phone, phoneText, originalNumber, originalCountry) {
        $.ajax({
            url: '/app/help/callback/register-callback',
            type: 'POST',
            data: {
                callbackName: name,
                callbackPhone: phone,
                callbackPhoneText: phoneText,
                callbackUnparsedNumber: originalNumber,
                callbackUnparsedCountry: originalCountry
            },
            success: function(response) {
                callbackForm.loadingBox().hide();
                if (response.status === 'success') {
                    callbackForm.diy_dialog('close');
                    var callingDialog = $(response.html);
                    callingDialog.diy_dialog({
                        title: msg.dialogTitle,
                        dialogClass: 'callback-dialog',
                        modal: false,
                        resizable: false,
                        closeButton: true,
                        width: 404,
                        close: function() {
                            $(this).dialog('destroy').remove();
                            alreadyOpened = false;
                        }
                    });
                    alreadyOpened = true;

                    var resetLink = jQuery('#callback_reset_link', callingDialog);
                    resetLink
                        .blur()
                        .click(function(e){
                            e.preventDefault();
                            callingDialog.diy_dialog('close');
                            openDialog();
                        });

                    var dataChangedCheckbox = jQuery('#save_personal_data', callingDialog);
                    dataChangedCheckbox.diy_checkbox({
                        change: function ()
                        {
                            if (this.checked == true) {
                                var callbackContainer = jQuery('.callback-data-changed', callingDialog);
                                callbackContainer.loadingBox({useOverlay: true}).show();
                                jQuery.ajax({
                                    type: 'post',
                                    url: '/app/help/callback/save-callback-details',
                                    data: {
                                        callbackName: name,
                                        callbackUnparsedNumber: originalNumber,
                                        callbackUnparsedCountry: originalCountry
                                    },
                                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                                    success : function(response) {
                                        jQuery('.callback-save-personal-data', callingDialog).hide();
                                        jQuery('.callback-legal', callingDialog).show();
                                        callbackContainer.loadingBox().remove();
                                    }
                                });
                            }
                        }
                    });
                } else {
                    switch (response.status) {
                        case 'invalid_customer_name':
                            showInputErrror($('#callback_name', callbackForm), response.message);
                            break;
                        case 'invalid_customer_phone':
                            showInputErrror($('#callback_phone', callbackForm), response.message);
                            break;
                        case 'error':
                        default:
                            callbackForm.diy_form({
                                messageTarget: '.callbak-form-error'
                            });
                            callbackForm.diy_form('showErrorMessage', response.message);
                            break;

                    }
                }
            }
        });
    };

    var insertWorkingHours = function (element, workingHours) {
        var timeline = [];
        // we will normalize intervals in case of possible overlaps
        // and then will split up by days
        for (var i = 0; i < workingHours.length; i++) {
            timeline.push({
                type: 'start',
                datetime: new Date(workingHours[i][0])
            });
            timeline.push({
                type: 'end',
                datetime: new Date(workingHours[i][1])
            });
        }
        timeline.sort(function(a, b) {
            var diff = a.datetime.getTime() - b.datetime.getTime();
            // put "start" first then "end", to easyly concatenate
            // adiacent intervals
            if (diff === 0 && a.type !== b.type) {
                return a.type === 'start' ? -1 : 1;
            }
            return diff;
        });

        var dateIntervals = [], dates = [], currentDate, stackLevel = 0, ct;
        for (var i = 0; i < timeline.length; i++) {
            ct = timeline[i].datetime;
            currentDate = new Date(ct.getFullYear(), ct.getMonth(), ct.getDate());
            if (timeline[i].type === 'start') {
                if (stackLevel === 0) {
                    // we start a new working interval
                    if (dates.length > 0
                        && dates[dates.length - 1].getTime() === currentDate.getTime()
                    ) {
                        // in the current day
                        dateIntervals[dateIntervals.length - 1].push([ct]);
                    } else {
                        // in the next day
                        dates.push(currentDate);
                        dateIntervals.push([[ct]]);
                    }
                }
                stackLevel++;
            } else if (timeline[i].type === 'end') {
                stackLevel--;
                if (stackLevel === 0) {
                    // we end last working interval, but split up by days
                    while (dates[dates.length - 1].getTime() < currentDate.getTime()) {
                        var lD = dates[dates.length - 1];
                        dates.push(new Date(lD.getFullYear(), lD.getMonth(), lD.getDate() + 1));
                        var lDI = dateIntervals[dateIntervals.length - 1];
                        lDI[lDI.length - 1].push(new Date(lD.getFullYear(), lD.getMonth(), lD.getDate(), 23, 59));
                        dateIntervals.push([[new Date(lD.getFullYear(), lD.getMonth(), lD.getDate() + 1, 0, 0)]]);
                    }
                    var lDI = dateIntervals[dateIntervals.length - 1];
                    lDI[lDI.length - 1].push(ct);
                }
            }
        }
        var msg = jimdoData.messages;
        var today = new Date(), dayName;
        var tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        for (var i = 0; i < dates.length; i++) {
            var dateEl = $('<div class="wh-date"></div>');
            if (dates[i].getFullYear() === today.getFullYear()
                && dates[i].getMonth() === today.getMonth()
            ) {
                if (dates[i].getDate() === today.getDate()) {
                    dayName = msg.today;
                } else if (dates[i].getDate() === tomorrow.getDate()) {
                    dayName = msg.tomorrow;
                } else {
                    dayName = msg.weekdays[dates[i].getDay()];
                }
            } else {
                dayName = msg.weekdays[dates[i].getDay()];
            }

            dateEl.append('<span class="wh-day">' + dayName + '</span>');
            dateEl.appendTo(element);
            var timeFormat = function(a) {
                // strip seconds letting possible AM/PM marker
                return a.toLocaleTimeString().replace(/^(.*):(.*):([^\s]*)(\s(.*))?$/, '$1:$2$4');
            };
            var hoursHtml = [];
            for (var j = 0; j < dateIntervals[i].length; j++) {
                var start = dateIntervals[i][j][0];
                var end = dateIntervals[i][j][1];
                hoursHtml.push('<span class="wh-hour">'
                        + timeFormat(start)
                        + ' - '
                        + timeFormat(end)
                        + '</span>');
            }
            dateEl.append(hoursHtml.join(','));
        }
    };

    module.exports = {
        openDialog : openDialog,
        insertWorkingHours: insertWorkingHours
    };

}());


/***/ },
/* 729 */,
/* 730 */
/***/ function(module, exports, __webpack_require__) {

/*global diy, jimdoData*/
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var features = __webpack_require__(25);
var l10n_1 = __webpack_require__(18);
var websiteData = __webpack_require__(4);
var infoDialogApi = __webpack_require__(706);
var webcomponentUpsell_1 = __webpack_require__(557);
var Poller_1 = __webpack_require__(558);
/**
 * reference to the automatic layer manager
 */
var layerManager;
/**
 * reference for the dialog
 */
var teaserDialog;
/**
 * classes that the dialog will receive
 */
var dialogClassBase = 'update-tariff-modal cp-style';
/**
 * @type Object
 */
var activeOptions = null;
/**
 * options for different types of screens (upgrade, success, error).
 * Used in dialog creation and update
 * @type Object containing Objects with keys: width (int), title (String),
 * getContentCallback (Function) and class (String, optional)
 */
var options = {
    orderfinalized: {
        'width': 750,
        'title': l10n_1.getString('tariffupdate.orderfinalized.title'),
        'getContentCallback': getOrderFinalizedContent,
        'class': 'orderfinalized-dialog'
    }
};
var currentPageName = 'upgrade';
var pollingInterval = 20 * 1000; // 20 seconds
var errorMaximumRetries = 5;
var errorCountRetries = 0;
var orderIsFinalized = false;
/**
 * dialog close handler
 */
var sourceClose;
/**
 * List of supported order action value patterns during shop update processes
 *
 * @link http://maven-sites.server.lan/ciso/com.oneandone.sales.middleware/popupshop/index.html
 */
var orderActionPatterns = [/popupshop.close/, /popupshop.goToProduct/];
/**
 * List of supported order status value patterns during shop update processes
 *
 * @link http://maven-sites.server.lan/ciso/com.oneandone.sales.middleware/popupshop/index.html
 */
var orderStatusPatterns = [
    /NOT_ORDERED/,
    /OK/,
    /ALREADY_ACTIVE/,
    /MISSING_ITEM/,
    /LOCKED/,
    /BLOCKED/,
    /ERROR/
];
var trackingEventTypes = {
    'opened': 'opened',
    'closed': 'closed',
    'ordered': 'ordered',
    'succeeded': 'succeeded',
    'error': 'error'
};
var tariffTrackingEvents = {
    'opened': 'diy-editor-tariffupgrade-upgradedialog',
    'closed': 'diy-editor-tariffupgrade-closedialog',
    'error': 'diy-editor-tariffupgrade-errordialog'
};
var microBKShopTrackingEvents = {
    'opened': 'diy-editor-microbkshop-openeddialog',
    'closed': 'diy-editor-microbkshop-closeddialog',
    'ordered': 'diy-editor-microbkshop-ordereddialog',
    'succeeded': 'diy-editor-microbkshop-successdialog',
    'error': 'diy-editor-microbkshop-errordialog'
};
function setLayerManager(lm) {
    layerManager = lm;
}
/**
 * ///////
 * Congratulations message (Moments to celebrate)
 * ///////
 */
function welcomeToPlus() {
    teaserDialog.diy_dialog('option', 'close', function () {
        onClose();
        layerManager.unblockAndProcessQueue();
    });
    teaserDialog.diy_dialog('option', 'open', function () {
        onOpen();
        $.ajax({
            url: '/app/siteadmin/tariffupdate/acknowledgetariffupdate',
            type: 'GET',
            data: { cstok: jimdoData.cstok }
        });
        // KPI tracking
        track('diy-editor-tariffupgrade-congratulationsdialog', {});
        currentPageName = 'congratulations';
    });
    teaserDialog.diy_dialog("option", "closeButton", false);
    teaserDialog.diy_dialog('open');
}
/**
 * Congratulations dialog content
 * @returns {*|HTMLElement}
 */
function getWelcomeToPlusContent() {
    var html = '<div>';
    html += '<div class="welcometoplus-container">';
    html += '<div>';
    html += '<img class="welcometoplus-visual" src="' + websiteData.getCdnUrl() +
        's/diy/tariffupdate/img/welcome_to_plus.png" alt="" />';
    html += '</div>';
    html += '<div class="welcometoplus-message">' +
        l10n_1.getString('tariffupdate.welcometoplus.primarymessage') +
        '</div>';
    html += '</div>';
    html += '<div class="welcometoplus-features">';
    html += '<div class="welcometoplus-featuresmessage">' +
        l10n_1.getString('tariffupdate.welcometoplus.secondarymessage') +
        '</div>';
    html += '<div class="welcometoplus-featurebuttons">';
    html += '<button class="pages-button">' +
        l10n_1.getString('tariffupdate.welcometoplus.pages') +
        '</button>';
    html += '<button class="apps-button">' +
        l10n_1.getString('tariffupdate.welcometoplus.apps') +
        '</button>';
    html += '<button class="widget-button">' +
        l10n_1.getString('tariffupdate.welcometoplus.widget') +
        '</button>';
    html += '</div>';
    html += '</div>';
    html += '<div class="cp-style">';
    html += '<div class="welcometoplus-close-wrapper">';
    html += '<button class="blue-primary">' + l10n_1.getString('tariffupdate.success.close') + '</button>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    var $html = $(html);
    $html.find('button:last')
        .button()
        .bind('click', function () {
        teaserDialog.diy_dialog('close');
    });
    $html.find('button.pages-button').bind('click', function () {
        sourceClose = 'pages_click';
        $("#cc-sa-item-pages").click();
        teaserDialog.diy_dialog('close');
    });
    $html.find('button.apps-button').bind('click', function () {
        sourceClose = 'apps_click';
        $("#cc-sa-item-appscatalog").click();
        teaserDialog.diy_dialog('close');
    });
    $html.find('button.widget-button').bind('click', function () {
        sourceClose = 'widget_click';
        $("#cc-sa-item-elements").click();
        teaserDialog.diy_dialog('close');
    });
    return $html.html();
}
function deleteNewRibbonFeature(featurename) {
    $.get('/app/siteadmin/tariffupdate/deleteribbon/?fn=' + featurename);
}
function deleteElementNewFeatureRibbon() {
    deleteNewRibbonFeature('elements');
    $(".cc-sa-sidebar-this_is_new", "#cc-sa-item-elements").remove();
}
function deletePagesNewFeatureRibbon() {
    deleteNewRibbonFeature('pages');
    $(".cc-sa-sidebar-this_is_new", "#cc-sa-item-pages ").remove();
}
function deleteAppsNewFeatureRibbon() {
    deleteNewRibbonFeature('apps');
    $(".cc-sa-sidebar-this_is_new", "#cc-sa-item-appscatalog").remove();
}
/**
 * This method creates an diy_dialog for the upgrade tariff and stores the reference
 * in the instance variable teaserDialog
 */
function createTeaserDialog(opts) {
    teaserDialog = $('#updateTariffModal');
    if (teaserDialog.length > 0) {
        return;
    }
    teaserDialog = $('<div id="updateTariffModal"></div>')
        .html(opts.getContentCallback);
    teaserDialog.diy_dialog({
        "dialogClass": dialogClassBase + (opts.class ? " " + opts.class : ""),
        "overlayCls": 'black-overlay',
        "closeButton": true,
        "closeCls": 'ui-icon-24 ui-icon-24-xclose',
        "modal": true,
        "autoOpen": false,
        "width": opts.width,
        "maxHeight": $(window).innerHeight(),
        "draggable": false,
        "resizable": false,
        "closeOnEscape": false,
        "close": onClose,
        "open": onOpen,
        "title": opts.title,
        "helpButton": false
    }).diy_dialog('getWrapperElement').css({
        'z-index': diy.editor.getNewTopZIndex(undefined, 'blockingModals'),
        position: 'relative'
    });
    activeOptions = opts;
}
/**
 * dialog open handler
 */
function onOpen() {
    $(window).on('resize', fullViewCallback);
    $(window).on('orientationchange', fullViewCallback);
}
function onClose() {
    $('#cc-sa-item-updateTariff').removeClass('cc-sa-active');
    $(window).off('resize', fullViewCallback);
    $(window).off('orientationchange', fullViewCallback);
    var actionName = 'close';
    if (sourceClose) {
        actionName += '_' + sourceClose;
        sourceClose = null;
    }
    track('diy-editor-tariffupgrade-closedialog', {
        'actionName': actionName,
        'pageName': currentPageName
    });
}
/**
 * This method changes content and some properties of the dialog, allowing to switch between
 * upgrade screen and success / error messages
 */
function updateTeaserDialog(opts) {
    if (!teaserDialog) {
        createTeaserDialog(opts);
    }
    else {
        var dialogClass = dialogClassBase;
        if (opts.class) {
            dialogClass = dialogClassBase + " " + opts.class;
        }
        teaserDialog.diy_dialog('option', 'dialogClass', dialogClassBase + (opts.class ? " " + opts.class : ""));
        teaserDialog.html(opts.getContentCallback);
        teaserDialog.diy_dialog('option', 'title', opts.title);
        teaserDialog.diy_dialog('option', 'width', opts.width);
        teaserDialog.diy_dialog("option", "position", { my: "center", at: "center", of: window });
    }
    activeOptions = opts;
    fullViewCallback();
}
function switchFullView() {
    if (!teaserDialog) {
        return;
    }
    teaserDialog.diy_dialog('option', 'width', '100%');
    teaserDialog.addClass('full-view');
}
function switchNormalView() {
    if (!teaserDialog) {
        return;
    }
    teaserDialog.removeClass('full-view');
    teaserDialog.diy_dialog('option', 'width', activeOptions.width);
}
function shouldShowFullView() {
    return ($(window).innerHeight() < 640 || $(window).innerWidth() < 648);
}
function fullViewCallback() {
    teaserDialog.diy_dialog("option", "position", { my: "center", at: "center", of: window });
    shouldShowFullView() ? switchFullView() : switchNormalView();
}
var orderIsPlaced;
function isOrderPlaced() {
    if (orderIsPlaced === undefined) {
        $.ajax({
            url: '/app/siteadmin/tariffupdate/triggerorderplacedactions',
            type: 'GET',
            data: { cstok: jimdoData.cstok },
            "success": function (response) {
                orderIsPlaced = (true === response.data.triggerOrderPlacedActions);
                if (orderIsPlaced) {
                    setTimeout(updateStatusRequest, pollingInterval);
                }
            }
        });
    }
    return orderIsPlaced || false;
}
/**
 * constructs the html for the order finalized dialog content
 * @returns html string
 */
function getOrderFinalizedContent() {
    var html = '<div>';
    html += '<div class="order-finalized-container">';
    html += '<div>';
    html += '<img class="order-finalized-visual" src="' + websiteData.getCdnUrl() +
        's/diy/tariffupdate/img/order_finalized_visual.png" alt="" />';
    html += '</div>';
    html += '<div class="order-finalized-message">' +
        l10n_1.getString('tariffupdate.orderfinalized.primarymessage') +
        '</div>';
    html += '</div>';
    html += '<div class="cp-style">';
    html += '<div class="order-finalized-close-wrapper">';
    html += '<button class="reload blue-primary">' + l10n_1.getString('tariffupdate.orderfinalized.reload') +
        '</button>';
    html += '<button class="continue blue-secondary">' + l10n_1.getString('tariffupdate.orderfinalized.continue') +
        '</button>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    var $html = $(html);
    $html.find('button').button();
    $html.find('button.reload').bind('click', function () {
        track('diy-editor-tariffupgrade-reloadpage', {});
        document.location.reload();
    });
    $html.find('button.continue').bind('click', function () {
        sourceClose = 'continue';
        teaserDialog.diy_dialog('close');
    });
    return $html.html();
}
function updateStatusRequest() {
    $.ajax({
        url: '/app/siteadmin/tariffupdate/pollstatus',
        type: 'GET',
        data: { cstok: jimdoData.cstok },
        "success": function (response) {
            var data = response.data;
            if (data.hasOwnProperty("orderfinalized") && true === data.orderfinalized) {
                /**
                 * much success. very refresh. such update
                 */
                orderIsFinalized = true;
                layerManager.enqueue({
                    priority: 1,
                    callback: openOrderFinalizedDialog
                });
            }
            else {
                /**
                 * Not there yet ... keep asking though
                 */
                setTimeout(updateStatusRequest, pollingInterval);
            }
        },
        "error": function (response) {
            //disable default black error message
            response.disableBlackBoxVisualError = true;
            /**
             * What hapenned ? Is this normal ? Maybe we should stop polling, at least for a while...
             */
            if (errorCountRetries < errorMaximumRetries) {
                setTimeout(updateStatusRequest, pollingInterval * 10);
            }
            else {
                errorCountRetries++;
            }
        }
    });
}
function openOrderFinalizedDialog() {
    updateTeaserDialog(options.orderfinalized);
    teaserDialog.diy_dialog("option", "closeButton", false);
    teaserDialog.diy_dialog('open');
    // KPI tracking
    track('diy-editor-tariffupgrade-finalizeddialog', {});
    currentPageName = 'finalized';
}
function track(event, data) {
    $(document).trigger(event, data);
}
/**
 *
 *
 */
function init() {
    if (features('updateTariffNewRibbons')) {
        $(document).ready(function () {
            $(document).on("moduleSelectorInitialized", deleteElementNewFeatureRibbon);
            $(document).on("diy-managepages-show", deletePagesNewFeatureRibbon);
            $(document).on("diy-editor-appCatalog-loadComplete", deleteAppsNewFeatureRibbon);
        });
    }
    //disable component if feature flag is off
    if (features('updateTariff')) {
        /**
         * When we're ready loading the DOM we can create the dialog
         * I've chosen to do this and not at first open
         * because in the last situation it seems not to be properly centered
         */
        $(document).ready(function () {
            if (isOrderPlaced()) {
                setTimeout(updateStatusRequest, pollingInterval);
            }
        });
        /**
         * Listener for the siteadmin control
         */
        $(document).on("mousedown", "#cc-sa-item-updateTariff", function () {
            var component = "siteAdmin";
            if (features('upsellTariffAbTest')) {
                var buttonTop = ('VARIANT_A' ===
                    features.getPayload('upsellTariffAbTest').variant);
                $(document).trigger('diy-editor-generic-sectionAccessed', {
                    sectionCodeName: "updateTariff",
                    trackingParams: {
                        'prop12': (buttonTop ? 'UpsellButtonTop' : 'UpsellButtonBottom')
                    }
                });
                if (buttonTop) {
                    component = "siteAdminTop";
                }
            }
            openPopupShop({ component: component });
        });
        /**
         * Listener for the pagelimitation controls
         */
        $(document).on("click", ".openUpdateTariffTeaser", function () {
            openPopupShop({ component: "pageLimitation" });
            return false; //prevent event propagation
        });
    }
}
function openPopupShop(openedFrom) {
    var requestParams = getUpdateRequestParams(openedFrom);
    $.get('/app/siteadmin/tariffupdate/getshoplink', requestParams)
        .then(function (response) {
        var data = response.data;
        if (typeof data !== 'undefined' && data.hasOwnProperty('link')) {
            createPopup(openedFrom, data.link);
        }
        else {
            throw 'could not fetch shop link from backend';
        }
    }).fail(function (response) {
        throw response.responseText;
    });
}
function triggerSuccessDialog(webComponentId, callback) {
    if (typeof webComponentId !== "undefined") {
        infoDialogApi.showDialog({
            title: l10n_1.getString('tariffupdate.success.title.' + webComponentId),
            description: l10n_1.getString('tariffupdate.success.description.' + webComponentId),
            image: websiteData.getCdnUrl() + 's/diy/site-admin/main/img/upsell/' + webComponentId + '-success.png',
            imageHeight: 310,
            secondaryButtonConfig: {
                'label': l10n_1.getString('tariffupdate.success.close'),
                'callback': function () {
                    $(document).trigger("diy-editor-generic-linkInteraction", {
                        pageName: "MyShopReady",
                        actionName: "close"
                    });
                    if (typeof callback === "function") {
                        callback();
                    }
                }
            }
        });
        trackByComponent('webComponentUpSell', trackingEventTypes.succeeded, {
            'actionName': 'succeeded',
            'pageName': 'upgrade',
            'channel': webComponentId + 'Upsell'
        });
    }
}
function triggerPollingInNotification(webComponentId) {
    if (features("notificationsNG")) {
        Poller_1.default.start();
    }
    else {
        var webcomponentUpsellApi = new webcomponentUpsell_1.default;
        webcomponentUpsellApi.setApi(diy.editor.notifications.api);
        webcomponentUpsellApi.startPolling(webComponentId);
    }
}
function triggerWebComponentUpSell(requestBody) {
    var urlPattern = '/rest/websites/{ID}/webcomponent-upsell';
    var requestUrl = urlPattern.replace('{ID}', websiteData.getId());
    $.ajax({
        url: requestUrl,
        type: 'POST',
        contentType: 'application/vnd.oneandone.diy.website.webcomponent-upsell+json',
        processData: false,
        dataType: 'json',
        data: JSON.stringify(requestBody),
        error: function (response) {
            throw response.responseText;
        }
    });
}
function createPopup(openedFrom, link) {
    var overlayContainer = $('#popupshopOverlay');
    if (overlayContainer.length === 0) {
        overlayContainer = $('<div class="diye"><div id="popupshopOverlay"></div></div>')
            .appendTo('body');
        overlayContainer.css({
            height: $(window.document).height() + 'px',
            left: '0', top: '0', position: 'absolute', width: '100%',
            'background-color': 'rgba(0,0,0,0.5)', 'z-index': 120000
        });
    }
    else {
        // overlay is already open, prevent opening it twice
        return;
    }
    var html = '<div class="update-tariff-popupshop"><iframe src="' + link + '" /></div>';
    overlayContainer.append(html);
    // make sure the popup is in viewport, even if page is scrolled
    overlayContainer.find('.update-tariff-popupshop').css({
        top: $(window).scrollTop() + 'px'
    });
    // KPI tracking for opening dialog
    trackOpeningEventByComponent(openedFrom);
    var onSuccessStatusForTariffUpdate = function () {
        setTimeout(updateStatusRequest, pollingInterval);
    };
    var onErrorStatusForTariffUpdate = function () {
        trackByComponent('tariffUpdate', trackingEventTypes.error, { 'actionName': 'error', 'pageName': 'error' });
    };
    var onCloseForTariffUpdate = function () {
        closePopup();
        window.removeEventListener("message", tariffUpDateMessage, false);
        trackByComponent('tariffUpdate', trackingEventTypes.closed, { 'actionName': 'close', 'pageName': 'upgrade' });
    };
    var onSuccessForWebComponentUpSell = function () {
        triggerWebComponentUpSell({
            "status-code": "PROCESSING",
            "webComponentId": openedFrom.webComponentId
        });
        triggerSuccessDialog(openedFrom.webComponentId, function () {
            triggerPollingInNotification(openedFrom.webComponentId);
        });
        trackByComponent('webComponentUpSell', trackingEventTypes.ordered, {
            'actionName': 'ordered',
            'pageName': 'upgrade',
            'channel': openedFrom.webComponentId + 'Upsell'
        });
        closePopup();
    };
    var onErrorStatusForWebComponentUpSell = function () {
        trackByComponent('webComponentUpSell', trackingEventTypes.error, { 'actionName': 'error', 'pageName': 'error' });
    };
    var onCloseForWebComponentUpSell = function () {
        closePopup();
        window.removeEventListener("message", webComponentUpSellMessage, false);
        trackByComponent('webComponentUpSell', trackingEventTypes.closed, {
            'actionName': 'close',
            'pageName': 'upgrade',
            'channel': openedFrom.webComponentId + 'Upsell'
        });
    };
    function closePopup() {
        overlayContainer.remove();
        overlayContainer = null;
    }
    ;
    var tariffUpdateCallBacks = {
        "OK": onSuccessStatusForTariffUpdate,
        "popupshop.close": onCloseForTariffUpdate,
        "ERROR": onErrorStatusForTariffUpdate
    };
    var webComponentUpSellCallBacks = {
        "OK": onSuccessForWebComponentUpSell,
        "NOT_ORDERED": onCloseForWebComponentUpSell,
        "ERROR": onErrorStatusForWebComponentUpSell
    };
    function tariffUpDateMessage(event) {
        messageHandler(event, tariffUpdateCallBacks);
    }
    ;
    function webComponentUpSellMessage(event) {
        messageHandler(event, webComponentUpSellCallBacks);
    }
    ;
    function messageHandler(event, callBacks) {
        var message = null;
        if (event.data.orderProcess) {
            message = event.data.orderProcess;
        }
        else if (event.data) {
            message = event.data;
        }
        var action = getValueByPattern(orderActionPatterns, message);
        var status = getValueByPattern(orderStatusPatterns, message);
        var statusCallBack = callBacks[status];
        var actionCallBack = callBacks[action];
        //handle order status
        if (typeof statusCallBack === 'function') {
            statusCallBack();
        }
        //handle order action
        if (typeof actionCallBack === 'function') {
            actionCallBack();
        }
    }
    ;
    var messageListeners = {
        'tariffUpDate': tariffUpDateMessage,
        'webComponentUpSell': webComponentUpSellMessage
    };
    initMessageListener(openedFrom.component, messageListeners);
}
/**
 * Retrieves Update Request params
 */
function getUpdateRequestParams(openedFrom) {
    var requestParams = null;
    switch (openedFrom.component) {
        case 'webComponentUpSell':
            requestParams = {
                shopType: "microBKShop",
                trackingTarget: openedFrom.component,
                webComponentId: openedFrom.webComponentId
            };
            break;
        default:
            requestParams = {
                shopType: "headlessShop",
                trackingTarget: openedFrom.component
            };
            break;
    }
    return requestParams;
}
/**
 * Retrieves dialog opening context for kpi tracking
 */
function getOpeningContext(openedFrom) {
    var openingContext = openedFrom.component;
    switch (openedFrom.component) {
        case 'webComponentUpSell':
            openingContext = openedFrom.webComponentId;
            break;
        default:
            if (typeof openedFrom.control !== 'undefined') {
                openingContext += '_' + openedFrom.control;
            }
            break;
    }
    return openingContext;
}
/**
 * Tracks kpi opening dialog action identified by event type
 */
function trackOpeningEventByComponent(openedFrom) {
    var data = {};
    var openingContext = getOpeningContext(openedFrom);
    switch (openedFrom.component) {
        case 'webComponentUpSell':
            data = { openingContext: openingContext, channel: openedFrom.webComponentId + 'Upsell' };
            break;
        default:
            data = { openingContext: openingContext };
            break;
    }
    trackByComponent(openedFrom.component, trackingEventTypes.opened, data);
}
/**
 * Tracks kpi actions identified by event type
 */
function trackByComponent(component, eventType, data) {
    switch (component) {
        case 'webComponentUpSell':
            track(microBKShopTrackingEvents[eventType], data);
            break;
        default:
            track(tariffTrackingEvents[eventType], data);
            break;
    }
}
function initMessageListener(component, messageListeners) {
    var messageListener = null;
    switch (component) {
        case 'webComponentUpSell':
            messageListener = messageListeners['webComponentUpSell'];
            break;
        default:
            messageListener = messageListeners['tariffUpDate'];
            break;
    }
    window.addEventListener("message", messageListener, false);
}
function getValueByPattern(patterns, text) {
    var pattern;
    var valueByPattern;
    if (patterns instanceof Array) {
        for (var i = 0; i < patterns.length; i++) {
            pattern = patterns[i];
            valueByPattern = pattern.exec(text);
            if (valueByPattern !== null) {
                return valueByPattern[0];
            }
        }
    }
    return "";
}
module.exports = {
    init: init,
    openPopup: openPopupShop,
    setLayerManager: setLayerManager
};


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

var websiteData = __webpack_require__(4);
/**
 * The regular expressions are created in JSController
 *
 * @returns {string|*|String|undefined}
 */
function getAppId() {
    var config = websiteData.getData('social'),
        appId = config.facebook.appId,
        hostedAppIds = config.facebook.hostedAppIds,
        host = window.location.host,
        re;
    for (var ix = 0; ix < hostedAppIds.length; ix++) {
        re = new RegExp(hostedAppIds[ix].jsRegexp);
        if (re.test(host)) {
            appId = hostedAppIds[ix].appId;
        }
    }

    return appId;
}

module.exports = getAppId;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

(function() {
    var gsSteps = __webpack_require__(733);
    var $ = __webpack_require__(3);
    var api = __webpack_require__(19);
    var siteadmin = __webpack_require__(20);
    var features = __webpack_require__(25);

    var NotificationApi = __webpack_require__(537).default;
    var NotificationType = __webpack_require__(540).default;

    /**
     * the content element, it is initially null.
     * it's populated from afterFillContent method
     */
    var contentEl = null,
        msg = jimdoData.messages.guidedSetup,
        showReminderCallout = -1,
        skipShowReminderCallout = false,
        skipKpiTracking = false,
        checkboxAutostartStatus = -1,
        gs_in_progress = -1,
        gsCompleted = false,
        gsNothingDone = true,
        gsIsScattered = false,
        firstUndoneStepEl,
        stackHeight = 118,

        GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT = 1401,
        GUIDEDSETUP_REMINDER_CALLOUT = 1402,
        GUIDEDSETUP_SHOW_AT_LOGIN = 1410,
        GUIDEDSETUP_CONGRATULATIONS_CALLOUT = 1404,
        GUIDEDSETUP_IN_PROGRESS = 1403
        ;

    /**
     * reference for within callbacks
     */
    var me = this;
    var stepData = gsSteps.getStepOptions(),
        gsBsaData = {};
    this.controllerLoaded = false;


    this.showCalloutCongratulations = function () {
        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(668)]; (function (maintenanceMode) {
            if (maintenanceMode.isFirstPublish()) {

                if (features("notificationsNG")) {
                    NotificationApi.schedule(function() {
                        NotificationApi.pushOne({
                            type: NotificationType.CONGRATS
                        });
                    });

                } else {
                    var n = top.diy.editor.notifications;
                    n.api.ready(function () {
                        var congratsNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_CONGRATULATIONS);
                        if (congratsNotifications.length <= 0) {
                            n.api.createNotification({type: n.Notifications.TYPE_CONGRATULATIONS});
                        } else {
                            n.api.updateNotification(congratsNotifications[0].getId(), {dismissed: 0});
                        }
                    });
                }
            }

            // Delete notification on publish
            $(document).bind('diy-maintenance-mode-publish', function () {
                if (features("notificationsNG")) {
                    NotificationApi.schedule(function() {
                        NotificationApi.deleteOne(
                            NotificationType.CONGRATS
                        )
                    });

                } else {
                    var n = top.diy.editor.notifications;
                    var congratsNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_CONGRATULATIONS);
                    if (congratsNotifications.length > 0) {
                        n.api.deleteNotificationByType(n.Notifications.TYPE_CONGRATULATIONS);
                    }
                }
            });

            $.ajax({
                url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_CONGRATULATIONS_CALLOUT
            });
        }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}());
    };

    this.showCalloutReminder = function () {
        api.activateCallout('cc-sa-item-guidedsetup', {
            triggerMode: 'none',
            hideLeftButton: true,
            hideRightButton: true,
            featureId: GUIDEDSETUP_REMINDER_CALLOUT,
            text: {
                title: msg.callout.title,
                content: msg.callout.content
            }
        });
    };

    var guidedSetupClosed = function () {
        var showOnLogin = $("input#guided_setup_checkbox").is(":checked"),
            trackingLinkId = (showOnLogin == true) ? 'step_cancelTopSet' : 'step_cancelTopUnSet';

        if (showReminderCallout == true) {
            if (skipShowReminderCallout == true) {
                skipShowReminderCallout = false;
            }
            else {
                $.ajax({
                    url: '/app/help/service/enable-feature/?id=' + GUIDEDSETUP_REMINDER_CALLOUT
                });
                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT
                });
                me.showCalloutReminder();
                showReminderCallout = false;
            }
        }
        if (skipKpiTracking == true) {
            skipKpiTracking = false;
        } else {
            $(document).trigger('diy-guidedSetup-closed', {
                'linkId': trackingLinkId
            });
        }

    };

    this.computeStackedScroll = function () {
        // prepare auto-scroll to the "right" step
        var autoScrollTop = 0;
        var sa = $('.gs-scrolled-area');

        if (gsNothingDone) {
            // no scrolling necesarry
        } else if (gsCompleted) {
            // auto-scroll to bottom
            autoScrollTop = sa.get(0).scrollHeight;
        } else if (gsIsScattered && firstUndoneStepEl) {
            // auto-scroll so that first undone item
            // will be in the middle
            var firstUndoneStepMiddleY =
                firstUndoneStepEl.offset().top + firstUndoneStepEl.height() / 2;

            var saMiddleY = sa.offset().top + sa.height() / 2;
            autoScrollTop = firstUndoneStepMiddleY - saMiddleY;
        } else if (firstUndoneStepEl) {
            // auto-scroll to a ratio of 4undone:3done items (as close as possible)
            // but no more thatn 4 undone items
            // this is a silly requirement, so don't complain about the solution :)
            var stickyH = 0;
            // simulate sticky just to get it's height
            if (sa.find('.gs-sticky-source').length > 0) {
                var sticky = sa.find('.gs-sticky-source').clone().appendTo(sa)
                    .addClass('gs-sticky')
                    .removeClass('gs-sticky-source');
                stickyH = sticky.outerHeight();
                sticky.remove();
            }
            var
                undoneSteps = firstUndoneStepEl.prev().nextAll('.gs-step'),
            // suppose all undone are of same height
                undoneH = firstUndoneStepEl.outerHeight(),
            // suppose all done are of the same height
                doneH = sa.find('.gs-step-finished').outerHeight(),
            // height of the visible area
                visibleH = sa.height() - stackHeight + undoneH - stickyH,
            // solving done*doneH + undone*undoneH = visibleH, where done/undone = 3/4
            // <=> undone(3/4*doneH + undoneH) = visibleH
                undone = Math.round(visibleH / (3 / 4 * doneH + undoneH))
                ;

            undone = Math.min(4, undone, undoneSteps.length);
            var
                lastVisibleUndone = undoneSteps.eq(undone - 1),
                stackOffsetTop = sa.offset().top + sa.height() - stackHeight
                ;
            autoScrollTop = Math.max(lastVisibleUndone.offset().top - stackOffsetTop, 0);
        }

        createStackedScroll();

        initStickyHeader();

        // auto-scroll to the "right" step
        sa.diy_stackedScroll('scrollTop', autoScrollTop);
    };

    this.updateFooter = function () {
        $('.gs-footer-1').find('input[type=checkbox]').diy_checkbox({
            boxLabel: msg.window.checkbox,
            change: function () {
                if (this.checked == true) {
                    $.ajax({
                        url: '/app/help/service/enable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                    });
                    checkboxAutostartStatus = true;
                } else {
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                    });
                    checkboxAutostartStatus = false;
                }
            },
            checked: checkboxAutostartStatus
        });
    };

    this.afterFillContent = function (el, payload, contentElement) {
        if (showReminderCallout == -1) {
            showReminderCallout = $('.gs-container').attr('data-show-reminder-callout') == "1";
        }
        if (checkboxAutostartStatus == -1) {
            checkboxAutostartStatus = $('.gs-container').attr('data-checkbox-autostart-status') == "1";
        }
        if (gs_in_progress == -1) {
            gs_in_progress = $('.gs-container').attr('data-gs-in-progress') == "1";
        }

        contentEl = contentElement;

        $(contentElement).loadingBox({
            useOverlay: true,
            overlayClass: "th-loading-opaque-overlay"
        }).show();

        this.buildStepDataHTML();

        api.updateTitle(msg.window.title);
        api.updateDescr(msg.window.description);
        api.updateNavi();
        api.updateHelpTopic('guidedSetup');
        $(document).one('diy-siteadmin-window-closed', guidedSetupClosed);

        $guidedSetup = $('.cc-sa-controller-guidedSetup #site-admin-iframe-content');
        $shareLink = $('.gs-share-link span:first');

        $('.gs-share-link').click(function () {
            $guidedSetup.toggleClass('gs-show-share');
            if ($guidedSetup.hasClass('gs-show-share')) {
                $shareLink.text($shareLink.parent().attr('data-collapse'));
            } else {
                $shareLink.text($shareLink.parent().attr('data-expand'));
            }
            onSAResize();
        });
        $guidedSetup.addClass('gs-show-share');
        $shareLink.text($shareLink.parent().attr('data-collapse'));

        createFooterShareButtons();

        $(document).bind('diy-siteadmin-window-resize-completed', onSAResize);

        /**
         * Open the "SiteAdmin->Settings->MyData" section when clicking on
         * Guided Setup "Enter My Data"
         * @see: DHDIYED-845
         */
        $("#guided_setup_personalDatas").bind("click", function () {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'personal-data'}
            ]);
        });

        this.controllerLoaded = true;
    };

    this.allowSwitch = function () {
        return this.controllerLoaded;
    };

    var getShareUrl = function () {
        var delimiter = '?';
        // add query string with timestamp to prevent social networks
        // to use a cached version of page when sharing
        if (jimdoData.webUrl.indexOf('?') !== -1) {
            delimiter = '&';
        }
        return jimdoData.webUrl + delimiter + (new Date().getTime());
    };

    var createFooterShareButtons = function () {
        createShareButtons(
            $('.gs-footer-1 .gs-share-buttons'),
            msg.shareNotCompletedText,
            msg.shareSocialMediaLinks
        );
    };
    var createStickyShareButtons = function () {
        createShareButtons(
            $('.gs-sticky-source .gs-share-buttons'),
            msg.shareCompletedText,
            msg.shareSocialMediaLinks
        );

        createShareButtons(
            $('.gs-sticky .gs-share-buttons'),
            msg.shareCompletedText,
            msg.shareSocialMediaLinks
        );

    };
    var getShareButtons = function (shareText, options) {
        var
            trackEvent = function (actionName) {
                var data = {
                    actionName: actionName,
                    pageName: 'Guided Setup'
                };
                top.jQuery(top.document).trigger('diy-editor-generic-linkInteraction', data);
            };
        var getFacebookAppId = __webpack_require__(731);
        var fbAppId = getFacebookAppId();
        return [
            {
                type: 'facebookShare',
                options: {
                    appId: fbAppId,
                    url: getShareUrl(),
                    onClick: function () {
                        trackEvent('social_facebook');
                    },
                    onSubmit: function () {
                        trackEvent('social_facebook_success');
                    },
                    onSubmitCanceled: function () {
                        trackEvent('social_facebook_cancel');
                    },
                    actions: options.facebook.actions
                }
            },
            {
                type: 'twitterShare',
                options: {
                    url: ' ',
                    message: {
                        text: shareText
                    },
                    onClick: function () {
                        trackEvent('social_google+');
                    },
                    onSubmit: function () {
                        trackEvent('social_twitter_success');
                    }
                }
            },
            {
                type: 'linkedInShare',
                options: {
                    url: getShareUrl(),
                    onClick: function () {
                        trackEvent('social_linkedin');
                    }
                }
            },
            {
                type: 'xingShare',
                options: {
                    url: getShareUrl(),
                    onClick: function () {
                        trackEvent('social_xing');
                    }
                }
            }
        ];
    };

    var createShareButtons = function (container, shareText, shareLinks) {
        if (container.length > 0) {
            // cleanup first
            container.empty();

            !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(734)]; (function (social) {
                    social.render(container, getShareButtons(shareText, social.config));
                }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}());
        }
    };


    var createStackedScroll = function () {
        $('.gs-scrolled-area').diy_stackedScroll({
            itemsSelector: '> *',
            visibleStackItems: 3,
            visibleStackOffset: 5,
            stackHeight: stackHeight,
            scroll: function () {
                var s = $('.gs-scrolled-area .gs-sticky-source');
                var sa = $('.gs-scrolled-area');

                if (sa.offset().top - s.offset().top > s.outerHeight() * 0.5) {
                    sa.find('.gs-sticky').css('visibility', 'visible');
                } else {
                    sa.find('.gs-sticky').css('visibility', 'hidden');
                }
            }
        });
    };

    var initStickyHeader = function () {
        var ss = $('.gs-scrolled-area .gs-sticky-source');
        var sa = $('.gs-scrolled-area');

        ss.clone()
            .addClass('gs-sticky')
            .removeClass('gs-sticky-source')
            .css('visibility', 'hidden')
            .width(ss.width())
            .appendTo(sa);


        if (gsCompleted) {
            createStickyShareButtons();
        }
    };

    var onSAResize = function () {
        // refresh stackedScroll only if already initialized
        var stackedScrollElements = $('.gs-scrolled-area');
        // check if instance of widget exists on the element
        if (stackedScrollElements.is(":diy-stackedScroll")) {
            stackedScrollElements.diy_stackedScroll('refresh');
        }
        $('.gs-sticky').width($('.gs-sticky-source').width());
    };

    this.buildStepDataHTML = function () {
        gsBsaData.baseUrl = bsaData.baseUrl + 'api/';

        var stepDataLength = stepData.length;
        if (stepDataLength <= 0) {
            return;
        }
        $('.gs-container').find('div[id^=step_]').remove();
        for (var i = 0; i < stepDataLength; i++) {
            $('.gs-scrolled-area').append(this.buildEachStepHtml(stepData[i], i));
        }

        $('.gs-container').find('.gs-step[id^=step_]').each(function (i, el) {
            $(el).bind('click', function (e) {
                var curPosition = $(this).attr('data-position');
                if ($(this).hasClass('gs-step-dependable')) {
                    $(this).toggleClass('gs-step-expanded');

                    var dependentStep = findStepByID(stepData[curPosition].getDependentStep());
                    if (dependentStep !== false) {
                        var dependentArrows = $('.gs-container').find('div#step_' + dependentStep.id + '.gs-step .gs-step-icon');
                        if (dependentArrows.length > 0) {
                            var dependentArrow = dependentArrows[0];
                            $(dependentArrow).toggleClass('gs-icon-dependent-on');
                            $(dependentArrow).parents('.gs-step').toggleClass('gs-dependent-on');
                        }
                    }

                    $('.gs-scrolled-area').diy_stackedScroll('refresh');
                } else if (stepData[curPosition].isVisible()) {
                    skipShowReminderCallout = true;
                    skipKpiTracking = true;
                    stepData[curPosition].getStartedTrigger();
                    trackStepLinkEvent(el);
                } else {
                    $(this).toggleClass('gs-step-expanded');
                    $('.gs-scrolled-area').diy_stackedScroll('refresh');
                }
            });
        });
        this.getRecommendablesInfo();
    };

    var trackStepLinkEvent = function (stepDataContainer) {
        $(document).trigger(
            'diy-editor-generic-linkInteraction',
            {
                actionName: $(stepDataContainer).attr('id')
            }
        );
    };

    this.getRecommendablesInfo = function () {
        var _self = this;
        $.ajax({
            async: true,
            type: 'get',
            url: gsBsaData.baseUrl + 'recommendables/',
            contentType: 'application/vnd.oneandone.bsa.recommendables+json',
            success: _self.updateStepBsaStatus
        });
    };


    this.buildTooltips = function () {
        var statusEls = $('.gs-container')
            .find('.gs-step .gs-step-icon.gs-step-completed');
        if (statusEls.length > 0) {
            for (var i = 0; i < statusEls.length; i++) {
                var curStepStatus = statusEls[i];

                var curStepAttribute = $(curStepStatus).attr('data-tooltip');
                var elmsDescription = $(curStepStatus).parent('.gs-step').find('.gs-step-description');
                if (typeof elmsDescription !== 'undefined'
                    && elmsDescription !== false
                    && elmsDescription.length > 0
                ) {
                    curStepAttribute = '<small>' + elmsDescription.html() + '</small><br />' + curStepAttribute;
                }
                if (typeof curStepAttribute !== 'undefined'
                    && curStepAttribute !== false
                    && curStepAttribute.length > 0
                ) {
                    $(curStepStatus).diy_simpleTooltip({
                        content: curStepAttribute,
                        cls: 'blueishTheme',
                        position: {
                            offset: '0 0'
                        }
                    });
                }
            }
        }
    };

    var isStepCompleted = function (step, recommendableData) {
        var j = 0, k = 0, eachStep;
        if (step.id !== 'internetAddress' && bsaData.isPreBsaWebsite) {
            return true;
        }
        var listOfRecommendables = [];
        for (j = 0; j < recommendableData.length; j++) {
            listOfRecommendables[recommendableData[j].name] = recommendableData[j].currentRank;
        }
        var rankedAchieved = false;
        if (step.hasOwnProperty('recommendablesOR')) {
            for (k = 0; k < step.recommendablesOR.length; k++) {
                eachStep = step.recommendablesOR[k];
                if (listOfRecommendables.hasOwnProperty(eachStep.recommendable) && listOfRecommendables[eachStep.recommendable] >= eachStep.minStatusRank) {
                    rankedAchieved = true;
                    break;
                }
            }
        } else {
            if (step.hasOwnProperty('recommendable')) {
                if (listOfRecommendables.hasOwnProperty(step.recommendable) && listOfRecommendables[step.recommendable] >= step.minStatusRank) {
                    rankedAchieved = true;
                }
            }
        }
        return rankedAchieved;
    };

    this.rewriteDependentStep = function (step) {
        var stepPlaceholders = $('.gs-container').find('div#step_' + step.id + '.gs-step');
        if (stepPlaceholders.length > 0) {
            var stepPlaceholder = stepPlaceholders[0];
            if ($(stepPlaceholder).hasClass('gs-step-unavailable')) {
                return;
            }
            var stepPlaceholderMarkup = '';
            stepPlaceholderMarkup += '<div class="gs-step-icon gs-step-incompleted">&nbsp;</div>';
            stepPlaceholderMarkup += '<div class="gs-step-inner">';
            stepPlaceholderMarkup += '<div class="gs-step-content">';
            stepPlaceholderMarkup += '<div class="gs-step-title">' + step.title + '</div>';
            stepPlaceholderMarkup += '<div class="gs-step-description">' + step.description + '</div>';
            stepPlaceholderMarkup += '<div class="gs-step-dependable-description">' + step.dependable + '</div>';
            ;
            stepPlaceholderMarkup += '</div>';
            stepPlaceholderMarkup += '<div class="gs-step-action">';
            stepPlaceholderMarkup += '<div class="gs-dependable-step-label">' + msg.dependableStep.label + '</div>';
            stepPlaceholderMarkup += '<div class="gs-dependable-step-more-info">&gt;&nbsp;' + msg.dependableStep.moreInfo + '</div>';
            stepPlaceholderMarkup += '<div class="gs-dependable-step-less-info">&gt;&nbsp;' + msg.dependableStep.lessInfo + '</div>';
            stepPlaceholderMarkup += '</div>';
            stepPlaceholderMarkup += '</div>';
            $(stepPlaceholder).addClass('gs-step-dependable').empty().append(stepPlaceholderMarkup);
        }
    };

    var findStepByID = function (stepID) {

        var i;
        var foundStep = false;

        for (i = 0; i < stepData.length; i++) {
            if (stepData[i].id === stepID) {
                foundStep = stepData[i];
                break;
            }
        }
        return foundStep;
    };

    this.updateStepBsaStatus = function (recommendableData) {
        var stepDataLength = stepData.length,
            visibleStepsLength = stepData.length;

        if (stepDataLength <= 0) {
            me.buildTooltips();
            me.updateFooter();
            $(contentEl).loadingBox().remove();
            return;
        }
        var finishSteps = 0;
        var previousStepIncomplete = false;
        gsIsScattered = false;
        firstUndoneStepEl = undefined;
        for (var i = 0; i < stepDataLength; i++) {
            var eachStep = stepData[i];
            var isStepVisible = eachStep.isVisible();
            if (!isStepVisible) {
                visibleStepsLength--;
            }
            if (isStepCompleted(eachStep, recommendableData)) {
                if (isStepVisible) {
                    finishSteps++;
                    if (previousStepIncomplete) {
                        gsIsScattered = true;
                    }
                    previousStepIncomplete = false;
                }
                var statusEls = $('.gs-container')
                    .find('div#step_' + eachStep.id + '.gs-step .gs-step-icon');
                if (statusEls.length > 0) {
                    if ($(statusEls[0]).hasClass('gs-step-incompleted')) {
                        $(statusEls[0]).removeClass('gs-step-incompleted');
                    }
                    $(statusEls[0]).addClass('gs-step-completed');
                    $(statusEls[0]).parents('.gs-step').addClass('gs-step-finished');
                }
            } else {

                if (typeof eachStep.getDependentStep === 'function') {
                    var dependentStep = findStepByID(eachStep.getDependentStep());
                    if (dependentStep !== false && !isStepCompleted(dependentStep, recommendableData)) {
                        me.rewriteDependentStep(eachStep);
                    }
                }
                if (isStepVisible) {
                    if (!firstUndoneStepEl) {
                        firstUndoneStepEl = $('.gs-container')
                            .find('div#step_' + eachStep.id);
                    }
                    previousStepIncomplete = true;
                }
            }
        }
        if (finishSteps > 0) {
            gsNothingDone = false;
        }
        if (finishSteps >= visibleStepsLength) {
            gsCompleted = true;

            //@see: DHDIYED-846
            $(".gs-share-link").hide();

            var statusEls = $('.gs-container')
                .find('.gs-final-check');
            if (statusEls.length > 0) {
                if ($(statusEls[0]).hasClass('gs-step-incompleted')) {
                    $(statusEls[0]).removeClass('gs-step-incompleted');
                }
                $(statusEls[0]).addClass('gs-step-completed');
            }
            if (gs_in_progress === true) {
                gs_in_progress = false;

                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_IN_PROGRESS
                });
                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                });
                if (showReminderCallout === true) {
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT
                    });
                    showReminderCallout = false;
                }

                checkboxAutostartStatus = false;

            }
            $('.cc-sa-controller-guidedSetup #site-admin-iframe-content')
                .removeClass('gs-show-share');
            $('.gs-share-link span:first').text($('.gs-share-link span:first').parent().attr('data-expand'));
            $('.gs-description').hide();
            $('.gs-completed').show();

        }

        me.computeStackedScroll();

        me.buildTooltips();
        me.updateFooter();
        $(contentEl).loadingBox().remove();
    };

    this.buildEachStepHtml = function (eachStep, position) {
        var hiddenStepClass = (eachStep.isVisible() ? '' : ' gs-step-unavailable');
        var eachStepMarkup = '';
        eachStepMarkup += '<div data-position="' + position + '" id="step_' + eachStep.id + '" class="gs-step' + hiddenStepClass + '">';
        eachStepMarkup += '<div class="gs-step-icon gs-step-incompleted" data-tooltip="' + eachStep.tooltip.finished + '">&nbsp;</div>';
        eachStepMarkup += '<div class="gs-step-inner">';
        eachStepMarkup += '<div class="gs-step-content">';
        eachStepMarkup += '<div class="gs-step-title">' + eachStep.title + '</div>';
        if (!eachStep.isVisible()) {
            eachStepMarkup += '<div class="gs-step-unavailable-description">' + eachStep.description + '<br />' + eachStep.unavailable + '</div>';
        } else {
            eachStepMarkup += '<div class="gs-step-description">' + eachStep.description + '</div>';
        }

        eachStepMarkup += '</div>';

        var actionHtml;

        if (eachStep.isVisible()) {
            actionHtml = '&gt;&nbsp;' + msg.window.getStartedStep;
        } else {
            actionHtml = '<div class="gs-unavailable-step-more-info">&gt;&nbsp;' + msg.unavailableStep.moreInfo + '</div>';
            actionHtml += '<div class="gs-unavailable-step-less-info">&gt;&nbsp;' + msg.unavailableStep.lessInfo + '</div>';
        }

        eachStepMarkup += '<div class="gs-step-action">' + actionHtml + '</div>';
        eachStepMarkup += '</div>';
        eachStepMarkup += '</div>';
        return eachStepMarkup;
    };

    /**
     * does this controller allows switching to another site-admin window?
     */
    this.allowSwitch = function () {
        guidedSetupClosed();
        $(document).unbind('diy-siteadmin-window-closed', guidedSetupClosed);
        $(document).unbind('diy-siteadmin-window-resize-completed', onSAResize);
        return true;
    };

    this.checkCongratulationsMsg = function () {
        me.isAllStepsCompleted({
            yes: function () {
                me.showCalloutCongratulations();
                $.ajax({
                    url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_IN_PROGRESS
                });
                $(document).trigger('diy-guidedsetup-steps-completed');
                $('body').unbind('bsa_event_called');
            }
        });
    };

    this.isAllStepsCompleted = function (options) {
        gsBsaData.baseUrl = bsaData.baseUrl + 'api/';
        $.ajax({
            async: true,
            type: 'get',
            url: gsBsaData.baseUrl + 'recommendables/',
            contentType: 'application/vnd.oneandone.bsa.recommendables+json',
            success: $.proxy(function (recommendableData) {
                this.isAllStepsCompletedCallback(recommendableData, options);
            }, this)
        });
    };

    this.isAllStepsCompletedCallback = function (recommendableData, options) {
        var stepDataLength = stepData.length,
            visibleStepsLength = stepData.length;

        if (stepDataLength <= 0) {
            return;
        }
        var finishSteps = 0;
        for (var i = 0; i < stepDataLength; i++) {
            if (!stepData[i].isVisible()) {
                visibleStepsLength--;
                continue;
            }
            if (isStepCompleted(stepData[i], recommendableData)) {
                finishSteps++;
            }
        }
        if (finishSteps >= visibleStepsLength) {
            if (options.yes && typeof options.yes === 'function') {
                options.yes.call(this);
            }
        } else {
            if (options.no && typeof options.no === 'function') {
                options.no.call(this);
            }
        }
    };

    this.start = function (options) {
        if (options.checkPreGuidedsetup) {
            this.isAllStepsCompleted({
                // TODO refactor this to implement promise pattern
                yes: function () {
                    // TODO refactor this to be DRY
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_IN_PROGRESS
                    });
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_SHOW_AT_LOGIN
                    });
                    $.ajax({
                        url: '/app/help/service/disable-feature/?id=' + GUIDEDSETUP_WATCH_FOR_REMINDER_CALLOUT
                    });
                },
                no: function () {
                    this.startNormal(options);
                }
            });
        } else {
            this.startNormal(options);
        }
    };

    this.startNormal = function (options) {
        if (options.autoOpen) {
            setTimeout(function () {
                $('#cc-sa-item-guidedsetup').trigger('click');
            }, 500);
        }
        if (options.reminderCallout) {
            this.showCalloutReminder();
        }
        if (options.congratulationsCallout) {
            this.showCalloutCongratulations();
        }
        if (options.checkCongratulationsMsg) {
            setTimeout(function () {
                $('body').bind('bsa_event_called', function () {
                    me.checkCongratulationsMsg();
                    //api.destroyController('cc-sa-item-guidedsetup');
                    var
                        controller = siteadmin.getController('cc-sa-item-guidedsetup'),
                        isOpen = false;
                    if (controller !== null &&
                        typeof controller.isOpened === 'function' &&
                        controller.isOpened()
                    ) {
                        isOpen = true;
                    }
                    if (isOpen) {
                        api.disableCache();
                    } else {
                        api.destroyController('cc-sa-item-guidedsetup');
                    }
                });
                me.checkCongratulationsMsg();
            }, 700);
        }
    };

    this.show = function () {
        // on each show we should re-create share buttons
        // to prevent social sharing to use outdated cache
        // (url will have a timestamp in the query stirng)

        createFooterShareButtons();
        if (gsCompleted) {
            createStickyShareButtons();
        }
    };

    return this;

}.call(exports));


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

var msg = jimdoData.messages.guidedSetup;

/* default step variables */
var defaults = {};
var steps = [
    {
        id: 'businessIdentity',
        recommendable: 'PersonalData',
        minStatusRank: 3,
        title: msg.step.myData.title,
        description: msg.step.myData.description,
        tooltip: {
            finished: msg.step.myData.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            var openParams = [
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'personal-data'}
            ];

            diy.editor.deeplinking.requestPath(openParams);
        }
    },
    {
        id: 'topic',
        recommendable: 'SelectTopic',
        minStatusRank: 2,
        title: msg.step.topic.title,
        description: msg.step.topic.description,
        tooltip: {
            finished: msg.step.topic.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            var openParams = [
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'industry'}
            ];
            diy.editor.deeplinking.requestPath(openParams);
        },
        unavailable: msg.step.topic.unavailable
    },
    {
        id: 'vcard',
        recommendable: 'MaintenanceMode',
        minStatusRank: 2,
        title: msg.step.vcard.title,
        description: msg.step.vcard.description,
        tooltip: {
            finished: msg.step.vcard.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            $(document).trigger('diy-maintenance-mode-edit');
        }
    },
    {
        id: 'learnTheInterface',
        recommendable: 'GuidedAudioTour',
        minStatusRank: 1,
        title: msg.step.learnTheInterface.title,
        description: msg.step.learnTheInterface.description,
        tooltip: {
            finished: msg.step.learnTheInterface.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.guidance.start();
        }
    },
    {
        id: 'style',
        recommendablesOR: [
            {
                recommendable: 'Styling',
                minStatusRank: 2
            },
            {
                recommendable: 'Theming',
                minStatusRank: 2
            }
        ],
        title: msg.step.style.title,
        description: msg.step.style.description,
        tooltip: {
            finished: msg.step.style.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            jQuery('#cc-sa-item-style').trigger('click');
        }
    },
    {
        id: 'nav',
        recommendable: 'Navigation',
        minStatusRank: 2,
        title: msg.step.nav.title,
        description: msg.step.nav.description,
        tooltip: {
            finished: msg.step.nav.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            diy.editor.navigation.api.openEditor();
        }
    },
    {
        id: 'elements',
        recommendable: 'InsertElement',
        minStatusRank: 2,
        title: msg.step.elements.title,
        description: msg.step.elements.description,
        tooltip: {
            finished: msg.step.elements.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            jQuery('#cc-sa-item-elements').trigger('click');
        }
    },
    {
        id: 'sections',
        recommendable: 'InsertSection',
        minStatusRank: 2,
        title: msg.step.sections.title,
        description: msg.step.sections.description,
        tooltip: {
            finished: msg.step.sections.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            jQuery('#cc-sa-item-sections').trigger('click');
        }
    },
    {
        id: 'internetAddress',
        recommendable: 'Domain',
        minStatusRank: 1,
        title: msg.step.internetAddress.title,
        description: msg.step.internetAddress.description,
        tooltip: {
            finished: msg.step.internetAddress.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();

            var goDirectly = $('.gs-container').attr('data-domain-connect-directly') === "1";
            if (goDirectly) {
                diy.util.redirector.redirectToLabel('domain_connect_redirect-guidedsetup');
            } else {
                jQuery('#cc-sa-item-settings').trigger('click');
                $(document).one('diy-siteadmin-sac-ready', function (e, wnd) {
                    wnd.jQuery('#website-domain', wnd.document).trigger('click');
                });
            }
        }
    },
    {
        id: 'emailAddress',
        recommendable: 'EmailAddress',
        minStatusRank: 1,
        title: msg.step.emailAddress.title,
        description: msg.step.emailAddress.description,
        tooltip: {
            finished: msg.step.emailAddress.tooltip.finished
        },
        getDependentStep: function () {
            return 'internetAddress'; // 5th step (internetAddress)
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            diy.util.redirector.redirectToLabel('choose_an_email_redirect_from_guidedSetup');
        },
        dependable: msg.step.emailAddress.dependable
    },
    {
        id: 'publish',
        recommendable: 'PublishWebsite',
        minStatusRank: 3,
        title: msg.step.publish.title,
        description: msg.step.publish.description,
        tooltip: {
            finished: msg.step.publish.tooltip.finished
        },
        isVisible: function () {
            return true;
        },
        getStartedTrigger: function () {
            diy.editor.siteadmin.api.close();
            $(document).trigger('diy-maintenance-mode-show');
        },
        unavailable: msg.step.publish.unavailable
    }
];

var getStepOptions = function () {

    var skipSteps = {};
    if (jimdoData.guidedSetupData.hasOwnProperty('skipSteps')) {
        skipSteps = jimdoData.guidedSetupData.skipSteps;
    }
    var opts = [];

    for (var i = 0; i < steps.length; i++) {
        if (!(steps[i].id in skipSteps)) {
            var stepOpts = $.extend(true, {}, defaults, steps[i]);
            opts.push(stepOpts);
        }
    }
    return opts;
};

module.exports = {
    getStepOptions: getStepOptions
};



/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

/*global Q */
var
    /** @type {function(new:diy.social.FacebookShare)} */
    FacebookShare = __webpack_require__(735),
    /** @type {function(new:diy.social.TwitterShare)} */
    TwitterShare = __webpack_require__(738),
    /** @type {function(new:diy.social.LinkedInShare)} */
    LinkedInShare = __webpack_require__(739),
    /** @type {function(new:diy.social.XingShare)} */
    XingShare = __webpack_require__(740),
    /** @type {diy.util.websiteData} */
    websiteData = __webpack_require__(4),

    /**
     *
     * @returns {*}
     */
    getConfig = function () {
        var config = websiteData.getData('social');
        if (typeof config !== 'object') {
            config = {};
        }
        return config;
    },
    /**
     *
     * @param $container {jQuery}
     * @param properties {Array.<
     *  {
     *      type: String,
     *      options: {
     *          url: String,
     *          image: String | undefined,
     *          onClick: Function | undefined,
     *          onSubmit: Function | undefined,
     *          message: {
     *              text: String | undefined,
     *              tags: String | undefined
     *          } | undefined,
     *          actions : [{
     *              name: String,
     *              link: String
     *          }] | undefined,
     *          appId: String | undefined
     *      }
     *  }
     * >}
     * @returns {Promise|Q.promise}
     */
    render = function ($container, properties) {
        var buttons, whenReady = [];
        if (!(properties instanceof Array)) {
            buttons = [properties];
        } else {
            buttons = properties;
        }
        buttons.forEach(function (button) {
            var instance = null;
            switch (button.type) {
                case 'facebookShare':
                    instance = new FacebookShare($container, button.options);
                    break;
                case 'twitterShare':
                    instance = new TwitterShare($container, button.options);
                    break;
                case 'linkedInShare':
                    instance = new LinkedInShare($container, button.options);
                    break;
                case 'xingShare':
                    instance = new XingShare($container, button.options);
                    break;
                default:
                    throw new Error('Undefined button type ' + button.type);
            }

            whenReady.push(Q(instance.render.call(instance)));
        });

        return Q.all(whenReady);
    };

/**
 * @class diy.social.social
 * @template diy.social.social
 * @lends {diy.social.social.prototype}
 * @constructor
 */
module.exports = {
    render: render,
    config: getConfig()
};


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

/*global FB, window */
var $ = __webpack_require__(3);
var ShareButton = __webpack_require__(736);
var websiteData = __webpack_require__(4);

var FacebookShare;


/**
 * @class diy.social.FacebookShare
 * @template diy.social.FacebookShare
 * @lends {diy.social.FacebookShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
FacebookShare = ShareButton.extend({
    /**
     * @type {{
     *      appId: String
     *      onClick: Function,
     *      onSubmit: Function,
     *      onSubmitCanceled: Function,
     *      image: String,
     *      url: String,
     *      actions: Array.<{name: String, link: String}>
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.FacebookShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                appId: '',
                onClick: undefined,
                onSubmit: undefined,
                onSubmitCanceled: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/facebook/facebook_' + this.market + '.png',
                url: websiteData.getWebUrl(),

                actions: []
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     * @returns {Promise|Q.promise}
     */
    loadApi: function () {
        var
            deferred = Q.defer(),
            languageCode;

        if (!!$('#fb-root').length) {
            deferred.resolve(true);
        } else {
            window.fbAsyncInitOptions = {
                appId: this.options.appId,
                xfbml: true,
                version: 'v2.3'
            };
            window.fbAsyncInit = function () {
                FB.init(window.fbAsyncInitOptions);
                deferred.resolve(true);
            };

            $('body').append('<div id="fb-root"></div>');
            languageCode = (this.locale === 'es_MX') ? 'es_ES' : this.locale;
            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/" + languageCode + "/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

        }
        return deferred.promise;
    },
    /**
     * @private
     */
    createButton: function () {
        var $share;

        this.$element.addClass('diy-share-facebook');
        $share = $('<img src="' + this.options.image + '">').appendTo(this.$element);

        $share.css({cursor: 'pointer'});
        $share.bind('click', this.onClick.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);

        window.FB.ui(
            {
                method: 'feed',
                link: this.options.url,
                actions: this.options.actions
            },
            this.onSubmit.bind(this)
        );

    },
    /**
     * @param {{undefined|{post_id: String|undefined}} callbackData
     * @private
     */
    onSubmit: function (callbackData) {
        switch (true) {
            // canceled the post
            case (callbackData === null):
                this.executeCallback(this.options.onSubmitCanceled);
                break;
            // posted to facebook, so we have a valid post_id
            case (callbackData !== null && typeof callbackData === 'object' && callbackData.hasOwnProperty('post_id')):
                this.executeCallback(this.options.onSubmit, callbackData);
                break;
        }
    }
});

module.exports = FacebookShare;


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

/*global Q */
var $ = __webpack_require__(3);
var websiteData = __webpack_require__(4);
var popupWindow = __webpack_require__(737);

var
    DEFAULT_POPUP_OPTIONS = {
        'menubar': 'no',
        'location': 'yes',
        'resizable': 'yes',
        'scrollbars': 'yes',
        'status': 'yes',
        'width': 700,
        'height':300,
        'top': undefined,
        'left': undefined
    },
    DEFAULT_POPUP_NAME = "share",
    ShareButton
    ;

/**
 * @class diy.social.ShareButton
 * @template diy.social.ShareButton
 * @lends {diy.social.ShareButton.prototype}
 * @constructor
 */
ShareButton = Klazz.extend({
    /**
     * @type {{
     *      url: String,
     *      image: String| undefined,
     *      onClick: Function | undefined,
     *      onSubmit: Function | undefined,
     *      message: {
     *          text: String | undefined,
     *          hashTags: String | undefined
     *      } | undefined,
     *      actions : [{
     *          name: String,
     *          link: String
     *      }] | undefined,
     *      appId: String | undefined
     * }}
     */
    options: undefined,

    /**
     * @type jQuery
     */
    $parentElement: undefined,

    /**
     * @type jQuery
     */
    $element: undefined,

    /**
     * @type String (ex: 'en')
     */
    language: null,

    /**
     * @type String (ex: 'en_CA')
     */
    locale: null,

    /**
     * @type String (ex: 'us' | 'ca' | 'mx')
     */
    market: '',

    initialize: function ($parentElement, options) {
        this.setLocales();
        this.$parentElement = $parentElement;
        this.setOptions(options);
    },

    /**
     * @private
     */
    setLocales: function () {
        this.locale = websiteData.getLanguageCode();
        this.language = websiteData.getLanguage();
        this.market = websiteData.getMarket();
    },
    /**
     *
     * @param options {*}
     * @returns {diy.social.ShareButton}
     */
    setOptions: function (options) {
        var defaults = {
            onClick: undefined,
            onSubmit: undefined,
            image: undefined,
            message: {
                url: undefined,
                text: undefined
            }
        };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     */
    createPlaceHolder: function () {
        this.$element = $('<div class="diy-share-button"></div>').appendTo(this.$parentElement);
    },
    /**
     *
     * @returns {Promise|Q.promise}
     */
    render: function () {
        return Q(this.createPlaceHolder())
            .then(this.loadApi.bind(this))
            .then(this.createButton.bind(this));
    },
    /**
     *
     * @param callback {Function|undefined}
     * @param data {=Object}
     */
    executeCallback: function (callback, data) {
        if (typeof callback === 'function') {
            callback.call(this, data);
        }
    },
    onClick: function() {
        this.executeCallback(this.options.onClick);
    },
    /**
     *
     * @param data {=Object}
     */
    onSubmit: function(data) {
        this.executeCallback(this.options.onSubmit, data);
    },
    /**
     *
     * @param url {String}
     * @param options {=String}
     */
    openWindow: function(url, options) {
        var windowOptions;

        windowOptions = $.extend(true, {}, DEFAULT_POPUP_OPTIONS, options);
        $.extend(windowOptions, popupWindow.getTopLeftForCenterWindow(windowOptions.width, windowOptions.height));

        return popupWindow.newWindow(url, DEFAULT_POPUP_NAME, windowOptions);
    },
    /**
     *
     * @returns {Promise|Q.promise}
     */
    loadApi: function () {
        return Q(true);
    },
    /**
     * @returns {Promise|Q.promise|*}
     */
    createButton: function () {
        throw new Error('Function must be implemented.');
    }
});

module.exports = ShareButton;


/***/ },
/* 737 */
/***/ function(module, exports) {

var

    /**
     *
     * @param popupWidth {Number}
     * @param popupHeight {Number}
     * @returns {{left: Number, top: Number}}
     */
    getTopLeftForCenterWindow = function(popupWidth, popupHeight) {
        var width, height, left, top;
        // Fixes dual-screen position                                     Most browsers      Firefox
        var dualScreenLeft = (typeof window.screenLeft !== 'undefined') ? window.screenLeft : screen.left;
        var dualScreenTop = (typeof window.screenTop !== 'undefined') ? window.screenTop : screen.top;

        width = window.innerWidth ?
            window.innerWidth :
            document.documentElement.clientWidth ?
                document.documentElement.clientWidth :
                screen.width;
        height = window.innerHeight ?
            window.innerHeight :
            document.documentElement.clientHeight ?
                document.documentElement.clientHeight :
                screen.height;

        left = ((width / 2) - (popupWidth / 2)) + dualScreenLeft;
        top = ((height / 2) - (popupHeight / 2)) + dualScreenTop;

        return {left: left, top: top};

    },
    /**
     *
     * @param objectProperties {{
     *      menubar: String | undefined,
     *      location: String | undefined,
     *      resizable: String | undefined,
     *      scrollbars: String | undefined,
     *      status: String | undefined,
     *      width: Number | undefined,
     *      height: Number | undefined,
     *      top: Number | undefined,
     *      left: Number | undefined
     * }}
     * @returns {String}
     */
    convertObjectToWindowFeatures = function (objectProperties) {
        var properties = [];
        for (var property in objectProperties) {
            if (objectProperties.hasOwnProperty(property)) {
                properties.push(property + '=' + objectProperties[property]);
            }
        }
        return properties.join(",");
    },
    /**
     *
     * @param strUrl {String}
     * @param strWindowName {String} // (no spaces in string)
     * @param strWindowFeatures {=String} // (no spaces in string)
     * @returns {Window}
     */
    openWindow = function (strUrl, strWindowName, strWindowFeatures) {
        if (strWindowFeatures && strWindowFeatures !== null && strWindowFeatures.toString().length) {
            return window.open(strUrl, strWindowName, strWindowFeatures);
        } else {
            return window.open(strUrl, strWindowName);
        }

    },
    /**
     *
     * @param strUrl {String}
     * @param strWindowName {String} // (no spaces in string)
     * @param objectProperties {{
     *      menubar: String | undefined,
     *      location: String | undefined,
     *      resizable: String | undefined,
     *      scrollbars: String | undefined,
     *      status: String | undefined,
     *      width: Number | undefined,
     *      height: Number | undefined,
     *      top: Number | undefined,
     *      left: Number | undefined
     * }}
     * @returns {Window}
     */
    newWindow = function (strUrl, strWindowName, objectProperties) {
        return openWindow(strUrl, strWindowName, convertObjectToWindowFeatures(objectProperties));
    }
    ;
/**
 * @class diy.util.popupWindow
 * @template diy.util.popupWindow
 * @lends {diy.util.popupWindow.prototype}
 * @constructor
 */
module.exports = {
    getTopLeftForCenterWindow: getTopLeftForCenterWindow,
    convertToFeatures: convertObjectToWindowFeatures,
    open: openWindow,
    newWindow: newWindow
};


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

/*global window, twttr, twttr.events, twttr.events._handlers, TWTR1and1 */
var $ = __webpack_require__(3);
var ShareButton = __webpack_require__(736);
var websiteData = __webpack_require__(4);

var TwitterShare;


/**
 * @class diy.social.TwitterShare
 * @template diy.social.TwitterShare
 * @lends {diy.social.TwitterShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
TwitterShare = ShareButton.extend({
    /**
     * @type {{
     *    url: String,
     *    image: String | undefined,
     *    onClick: Function | undefined,
     *    onSubmit: Function | undefined,
     *    message: {
     *        text: String | undefined,
     *        tags: String | undefined
     *    } | undefined,
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.TwitterShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                appId: '',
                onClick: undefined,
                onSubmit: undefined,
                onSubmitCanceled: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/twitter/twitter_' + this.market + '.png',
                url: websiteData.getWebUrl(),

                actions: []
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     * @returns {Promise|Q.promise}
     */
    loadApi: function () {
        var deferred = Q.defer();


        if (typeof window.twttr === 'undefined') {
            window.twttr = (function (d, s, id) {
                var t, js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "https://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);
                return window.twttr || (t = {
                        _e: [], ready: function (f) {
                            t._e.push(f);
                        }
                    });
            }(document, "script", "twitter-wjs"));
            // we set this to true so after loading widgets.js from twitter
            // we no longer use the webintents defined in moduleserver
            TWTR1and1.UseExternalIntentHandler = true;
        }

        if (typeof window.twttr.widgets === 'undefined') {
            window.twttr.ready(function () {
                deferred.resolve(true);
            });
        } else {
            deferred.resolve(true);
        }

        return deferred.promise;
    },
    /**
     * @private
     */
    createButton: function () {
        var $share, params;

        params = $.param({
            /**
             * url: this.options.url, // remove url because exists in text
             * if url is null or empty string twitter adds automatically the page url
             *      see (https://dev.twitter.com/docs/tweet-button)
             *      so we add a space
             */
            url: (this.options.url === null)? ' ' : this.options.url,
            lang: this.language,
            text: this.options.message.text,
            hashtags: this.options.message.tags
        });
        $share = $(
            [
                '<a href="https://twitter.com/intent/tweet?' + params + '">',
                '<img src="' + this.options.image + '">',
                '</a>'
            ].join("")
        ).appendTo(this.$element);

        $share.css({cursor: 'pointer'});

        if (window.twttr.events._handlers && window.twttr.events._handlers.click) {
            window.twttr.events.unbind('click');
        }
        if (window.twttr.events._handlers && window.twttr.events._handlers.tweet) {
            window.twttr.events.unbind('tweet');
        }

        window.twttr.events.bind('click', this.onClick.bind(this));
        window.twttr.events.bind('tweet', this.onSubmit.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);
    },
    /**
     * @param {{undefined|{post_id: String|undefined}} callbackData
     * @private
     */
    onSubmit: function (callbackData) {
        this.executeCallback(this.options.onSubmit, callbackData);
    }

});

module.exports = TwitterShare;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ShareButton = __webpack_require__(736);
var websiteData = __webpack_require__(4);

var LinkedInShare;


/**
 * @class diy.social.LinkedInShare
 * @template diy.social.LinkedInShare
 * @lends {diy.social.LinkedInShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
LinkedInShare = ShareButton.extend({

    /**
     * @type {{
     *      onClick: Function,
     *      image: String,
     *      url: String,
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.LinkedInShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                onClick: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/linkedin/linkedin_' + this.market + '.png',
                url: websiteData.getWebUrl()
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     *
     * @returns {String}
     */
    convertToLinkedInShareLocale: function () {
        var languageCode = '';
        switch (this.language) {
            case 'de':
                languageCode = 'de_DE';
                break;
            case 'en':
                languageCode = 'en_US';
                break;
            case 'es':
                languageCode = 'es_ES';
                break;
            case 'fr':
                languageCode = 'fr_FR';
                break;
            case 'it':
                languageCode = 'en_IT';
                break;
            case 'pl':
                languageCode = 'pl_PL';
                break;
        }
        return languageCode;
    },

    /**
     * @private
     */
    createButton: function () {
        var $share;

        this.$element.addClass('diy-share-linkedin');
        $share = $('<img src="' + this.options.image + '">').appendTo(this.$element);
        $share.css({cursor: 'pointer'});
        $share.bind('click', this.onClick.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);

        var
            url = 'https://www.linkedin.com/cws/share?url={{link}}',
            params = $.param({
                'original_referer': websiteData.getWebUrl(),
                'token': '',
                'isFramed': false,
                'lang': this.convertToLinkedInShareLocale(),
                '_ts': Date.now()
            });

        url = url.replace('{{link}}', encodeURIComponent(this.options.url));

        this.openWindow(url + '&' + params);
    }
});

module.exports = LinkedInShare;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ShareButton = __webpack_require__(736);
var websiteData = __webpack_require__(4);

var XingShare;


/**
 * @class diy.social.XingShare
 * @template diy.social.XingShare
 * @lends {diy.social.XingShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
XingShare = ShareButton.extend({
    /**
     * @type {{
     *      onClick: Function,
     *      image: String,
     *      url: String,
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.XingShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                onClick: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/xing/xing.png',
                url: websiteData.getWebUrl()
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     */
    createButton: function () {
        var $share;

        this.$element.addClass('diy-share-xing');
        $share = $('<img src="' + this.options.image + '">').appendTo(this.$element);
        $share.css({cursor: 'pointer'});
        $share.bind('click', this.onClick.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);

        var url = "https://www.xing.com/social_plugins/share?url={{link}}&wtmc=XING;&sc_p=xing-share";

        url = url.replace('{{link}}', encodeURIComponent(this.options.url));

        this.openWindow(url);
    }
});
module.exports = XingShare;


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var siteadmin = __webpack_require__(20);
var api = __webpack_require__(19);

(function() {

    var self = this;

    self.errorDelay = 5000; // delay in msec to wait for postmessage event
    self.timeoutId = null;
    self.loader = null;
    self.iframe = null;
    self.errorContainer = null;
    // the catalog should use window.postMessage() to send the string defined below
    // to confirm it has loaded correctly
    self.expectedMessageData = '1and1-apps-catalog';
    // flag to define if any message was received to prevent parallel execution of event handlers
    self.messageReceived = false;

    self.controllerLoaded = false;

    this.afterFillContent = function(el, data, contentElement) {

//        diy.editor.siteadmin.api.updateHelpTopic('');

        self.loader = $('#cc-sa-apps-catalog-loading', contentElement);
        self.iframe = $('#cc-sa-apps-catalog-iframe', contentElement);
        self.errorContainer = $('#cc-sa-apps-catalog-error', contentElement);

        // whether to check for a message sent from the catalog iframe
        var checkEnabled = parseInt(self.loader.attr('data-check-enabled'), 10);
        var catalogUrl = self.loader.attr('data-catalog-url');
        if (catalogUrl) {
            if (checkEnabled) {
                // listen for success message from catalog iframe
                $(window).bind('message.catalogCrossOrigin', function(event) {
                    self.messageReceived = true;
                    if (event.originalEvent && event.originalEvent.data) {
                        // check that the message is the expected string
                        var messageData = event.originalEvent.data;
                        if (messageData == self.expectedMessageData) {
                            if (self.timeoutId) {
                                clearTimeout(self.timeoutId);
                                self.timeoutId = null;
                            }
                            self.showCatalog();
                            $(window).unbind('.catalogCrossOrigin');
                        } else {
                            self.scheduleErrorDisplay();
                        }
                    } else {
                        self.scheduleErrorDisplay();
                    }
                });
            }

            var loadHandler;
            // if the catalog is expected to send a message on load, set a timeout to display the error
            // if not, display the iframe immediately after load
            if (checkEnabled) {
                loadHandler =  function(event) {
                    // set a timeout only if the iframe loaded and it hasn't yet sent a message
                    if (!self.messageReceived) {
                        self.scheduleErrorDisplay();
                    }
                };
            } else {
                loadHandler = self.showCatalog;
            }

            var sentParams = siteadmin.getParams();
            if ($.isPlainObject(sentParams) && sentParams.openTo == 'yourIndustryRecommended') {
                catalogUrl += '#/list/recommendation';
                api.disableCache();
            }

            self.iframe.load(loadHandler);

            self.iframe.attr('src', catalogUrl);
        } else {
            self.showError();
        }

        self.controllerLoaded = true;

    };

    this.allowSwitch = function()
    {
        return self.controllerLoaded;
    };

    this.showCatalog = function () {
        self.loader.hide();
        self.errorContainer.hide();
        self.iframe.show();
        self.iframe.css('visibility', 'visible');
        $(document).trigger('diy-editor-appCatalog-loadComplete');
        $(document.body).trigger('AppCatalogOpened.BSA');
    };

    this.showError = function() {
        self.loader.hide();
        self.iframe.css('visibility', 'hidden');
        self.errorContainer.show();
        // remove message event listener
        $(window).unbind('.catalogCrossOrigin');
    };

    this.scheduleErrorDisplay = function() {
        self.timeoutId = setTimeout(function () {
            self.showError();
        }, self.errorDelay);
    };



}).call(exports);


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Class for Layout Selector bootstrap
 *
 * @class LayoutSelector
 * @depends jquery.js, controller.js
 */
var $ = __webpack_require__(3);
var siteadmin = __webpack_require__(20);
var api = __webpack_require__(19);
var LayoutSelector;

(function() {

    /**
     * the content element, it is initially null.
     * it's populated from afterFillContent method
     */
    var contentEl = null;

    /**
     * reference for within callbacks
     */
    var me = this;
    this.controllerLoaded = false;

    /* specific actions for module selector */
    this.afterFillContent = function(el, payload, contentElement) {

        contentEl = contentElement;

        /* if the JS files were not yet loaded */
        if (!LayoutSelector) {
            /* load the JS files */
            diy.util.scriptLoader(payload.data.js, function() {
                /* bootstrap the app */
                __webpack_require__.e/* nsure */(2, function() {
                    LayoutSelector = __webpack_require__(743);
                    var initApp = __webpack_require__(750);
                    initApp(payload.data.layoutData, payload.data.layoutTopicData, payload.data.languageData);
                });
            }, function() {});
        } else {
            /* if the JS files are already loaded, bootstrap directly */
            __webpack_require__.e/* nsure */(2, function() {
                var initApp = __webpack_require__(750);
                initApp(payload.data.layoutData, payload.data.layoutTopicData, payload.data.languageData);
            });
        }

        /**
         * highlight the tab
         * duplicating some code for the moment, however this is the best
         * way we currently have to integrate iframe tabs and non-iframe tabs
         * in one site admin window
         * @param id
         */
        var highlightTab = function(id) {
            var $navi = $('div.cc-sa-controller-layoutSelector header nav');
            $navi.find('li').removeClass('ui-tabs-selected ui-state-active');
            $navi.find('a').removeClass('active');

            $navi.find('li a[data-identifier="' + id + '"]').parent().addClass('ui-tabs-selected ui-state-active');
            $navi.find('li a[data-identifier="' + id + '"]').addClass('active');
        };

        var changeTab = function(id) {
            var $layoutSelectorEl = $('#cc-sa-item-layoutselector');

            var changeTabFunctions = {
                layouts: function() {
                    /* data-tab attributes ensures certain thing are visible on a tab and not on others */
                    $('#layoutselector').attr('data-tab', 'layouts');
                    /* update the tracking info, so tracking will be done in the correct tab context */
                    $('#layouts').attr('data-tracking-view', 'full');
                    /* close any open layout overlay */
                    $('#layoutselector .button-overlay-close').trigger('click');
                    /* reset any filter/sorting applied by other tabs */
                    LayoutSelector.getInstance().settings.selectedFilter = {};
                    LayoutSelector.getInstance().settings.selectedSorting = '';
                    // XXX reset pagination when changing tab
                    var scroller = diy.core.getObject(LayoutSelector.getInstance().settings.scroller);
                    if (scroller) {
                        scroller.currentPosition = scroller.currentColumn = 1;
                    }
                    LayoutSelector.getInstance().filterLayouts();
                    /* trigger a resize so everything will align nicely */
                    diy.editor.siteadmin.controllers.layoutSelector.resize();
                    return true;
                },
                bookmarks: function() {
                    $('#layoutselector').attr('data-tab', 'bookmarks');
                    $('#layouts').attr('data-tracking-view', 'favorites');
                    $('#layoutselector .button-overlay-close').trigger('click');
                    LayoutSelector.getInstance().settings.selectedFilter = 'is_bookmarked';
                    LayoutSelector.getInstance().settings.selectedSorting = '';
                    // XXX reset pagination when changing tab
                    var scroller = diy.core.getObject(LayoutSelector.getInstance().settings.scroller);
                    if (scroller) {
                        scroller.currentPosition = scroller.currentColumn = 1;
                    }
                    LayoutSelector.getInstance().filterBookmarks();
                    diy.editor.siteadmin.controllers.layoutSelector.resize();
                    return true;
                },
                recent: function() {
                    $('#layoutselector').attr('data-tab', 'recent');
                    $('#layouts').attr('data-tracking-view', 'history');
                    $('#layoutselector .button-overlay-close').trigger('click');
                    LayoutSelector.getInstance().settings.selectedFilter = {};
                    LayoutSelector.getInstance().settings.selectedSorting = 'RECENTLY';
                    // XXX reset pagination when changing tab
                    var scroller = diy.core.getObject(LayoutSelector.getInstance().settings.scroller);
                    if (scroller) {
                        scroller.currentPosition = scroller.currentColumn = 1;
                    }
                    LayoutSelector.getInstance().sortLayouts();
                    diy.editor.siteadmin.controllers.layoutSelector.resize();
                    return true;
                }
            };

            /* if we're currently on an iframe tab (example: own layout HTML/CSS or Layout Upload), we don't have a JS controller */
            if (undefined === siteadmin.getController().getControllerName()) {

                /* wait for the layout selector to initialize, and then switch to its correct tab */
                $(document).unbind('diy-editor-layoutselector-app-init').bind('diy-editor-layoutselector-app-init', function() {
                    changeTabFunctions[id]();
                    highlightTab(id);
                });

                /* load the layout selector inline tabs */
                var controller = siteadmin.getController();
                controller.load({
                    element: $layoutSelectorEl[0],
                    controller: 'layoutSelector',
                    windowBehavior: $layoutSelectorEl.attr('data-window-behavior'),
                    contentType: $layoutSelectorEl.attr('data-content-type')
                });
                /* after the loading, the event diy-editor-layoutselector-app-init will be fired, so it goes to the correct tab */
                controller.show();

                return true;
            } else {
                /* if we're switching between inline tabs */
                changeTabFunctions[id]();
                LayoutSelector.getInstance().trackLayoutSelector();
                highlightTab(id);
                return true;
            }
        };

        /* window behavior definitions */
        var windowBehaviorLayoutSelectorTabs = {
            header: {small: true},
            size: {
                width: payload.data.settings.size.width,
                height: payload.data.settings.size.height
            },
            resizable: {
                minWidth: payload.data.settings.size.minWidth,
                minHeight: payload.data.settings.size.minHeight
            },
            footer: false
        };
        var windowBehaviorLayoutOwnlayout = $.extend(true, {}, windowBehaviorLayoutSelectorTabs);
        windowBehaviorLayoutOwnlayout.resizable = {minWidth: 660};
        windowBehaviorLayoutOwnlayout.footer = {};

        /* define tabs */
        var tabs = [{
                title: payload.data.settings.labels.layouts,
                identifier: 'layouts',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                active: true,
                callback: function() {
                    return changeTab('layouts');
                }
            }, {
                title: payload.data.settings.labels.bookmarks,
                identifier: 'bookmarks',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                callback: function() {
                    return changeTab('bookmarks');
                }
            }, {
                title: payload.data.settings.labels.recent,
                identifier: 'recent',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                callback: function() {
                    return changeTab('recent');
                }
            }
        ];

        /* define tabs that are feature-based */
        if (payload.data.settings.features.ownlayout) {
            tabs.push({
                title: payload.data.settings.labels.ownlayout,
                identifier: 'ownlayout',
                url: '/app/siteadmin/layoutselector/api',
                contentType: 'iframe-local',
                windowBehavior: windowBehaviorLayoutOwnlayout,
                callback: function() {
                    highlightTab('ownlayout');
                }
            });
        }

        if (payload.data.settings.features.layoutupload) {
            tabs.push({
                title: payload.data.settings.labels.layoutupload,
                identifier: 'layoutupload',
                url: '/app/siteadmin/layoutselector/layoutlivepreview',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                callback: function() {
                    highlightTab('layoutupload');
                }
            });
        }

        /* header is small, so no text should be for title and description */
        api.updateTitle('');
        api.updateDescr('');
        api.updateNavi(tabs);
        api.updateHelpTopic('sa-layouts');
        this.controllerLoaded = true;
    };

    this.allowSwitch = function()
    {
        return this.controllerLoaded;
    };

    this.show = function() {
        if (LayoutSelector) {
            var $navi = $('div.cc-sa-controller-layoutSelector header nav');
            $navi.find('li').removeClass('ui-tabs-selected ui-state-active');
            $navi.find('a').removeClass('active');
            $navi.find('li a[data-identifier="layouts"]').parent().addClass('ui-tabs-selected ui-state-active');
            $navi.find('li a[data-identifier="layouts"]').addClass('active');

            /* data-tab attributes ensures certain thing are visible on a tab and not on others */
            $('#layoutselector').attr('data-tab', 'layouts');

            /* update the tracking info, so tracking will be done in the correct tab context */
            $('#layouts').attr('data-tracking-view', 'full');

            /* reset any filter/sorting applied by other tabs */
            var instance = LayoutSelector.getInstance();
            if (instance !== undefined) {
                //only if we find the instance
                LayoutSelector.getInstance().settings.selectedFilter = {};
                LayoutSelector.getInstance().settings.selectedSorting = '';
                LayoutSelector.getInstance().filterLayouts();
            }
            /* trigger a resize so everything will align nicely */
            me.resize();
        }
    };

    this.hide = function() {
        //LayoutSelector.getInstance().onHide();
    };

    /**
     * this resize function ensures that LS looks good
     * no matter in which tab it is
     *
     * check comment from /cms/mvc/modules/siteadmin/views/scripts/layoutselector/index.php
     * for more information on how this works
     */
    this.resize = function() {
        var $layoutsContainer = $('.layouts-container'), availableHeight = this.getAvailableHeight(false);
        if (availableHeight > 0) {
            $layoutsContainer.height(availableHeight);
        }
    };

    /**
     * gets the available height for drawing the layouts
     * @param includeSortingHeader whether to include the sorting header in the "recently" tab
     * @returns {number}
     */
    this.getAvailableHeight = function(includeSortingHeader) {
        var $container = $('div.cc-sa-controller-layoutSelector main'),
            $ls = $('#layoutselector'),
            $topbar = $ls.find('.greybar'),
            $footer = $ls.find('.footer'),
            $layoutsContainer = $('.layouts-container'), outerHeight = 0;

        if($container.is(':visible')) {
            outerHeight = $container.height()
                - ($topbar.outerHeight() || 0)
                - ($footer.outerHeight() || 0)
                - (parseInt($layoutsContainer.css('margin-top')) || 0)
                - (parseInt($layoutsContainer.css('margin-bottom')) || 0)
                - (includeSortingHeader ? $ls.find('.sorting-header').height() : 0);
        }

        return outerHeight;
    };

    return this;

}).call(exports);


/***/ },
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Class for module selector
 *
 * @class Theming
 * @depends jquery.js, controller.js
 */
var $ = __webpack_require__(3);
var siteadmin = __webpack_require__(20);
var api = __webpack_require__(19);
var page = __webpack_require__(719);

(function() {

    /**
     * the content element, it is initially null.
     * it's populated from afterFillContent method
     */
    var contentEl = null;

    /**
     * the help topics ids
     */
    var helpColors = 'style_theming_settings_colors',
        helpFonts = 'style_theming_settings_fonts',
        helpBackground = 'style_theming_settings_background';

    /**
     * reference for within callbacks
     */
    var me = this;
    this.controllerLoaded = false;

    /**
     * template for generating the minimize/maximize button
     * @param state
     * @returns {String}
     */
    this.minimizableButtonTemplate = function(state) {
        //TODO: this is sample data
        var label;
        if(state == 'minimize'){
            label = jimdoData.messages.theming.settings.button.min;
        } else {
            label = jimdoData.messages.theming.settings.button.max;
        }
        return '<div class="start-animation">' + label + '</div>';
    };

    /**
     * sends the save request to the theming angular app.
     * also includes callbacks that controll what happens on
     * start saving and success/errors when saving
     */
    this.save = function() {
        var controller = siteadmin.getController();

        var interfaceElementContainer = $(contentEl).parent('main');
        diy.editor.theming.run(function(scope) {
            scope.save({
                start: function() {
                    interfaceElementContainer.loadingBox({useOverlay: true}).show();
                },
                success: function() {
                    interfaceElementContainer.loadingBox().remove();
                    controller.clearCache('theming');
                },
                error: function() {
                    interfaceElementContainer.loadingBox().remove();
                    controller.clearCache('theming');
                }
            });
        });
    };

    this.minimizeButtonClick = function(opts) {
        api.close();
    };

    /* specific actions for module selector */
    this.afterFillContent = function (el, payload, contentElement) {

        // remember the content element internally
        contentEl = contentElement;

        // display a loading overlay until we're done
        $(contentElement).loadingBox({useOverlay: true, overlayClass: "th-loading-opaque-overlay"}).show();

        // this is called if the script loading fails
        var scriptLoadingErrorHandler = function() {
            // default it's the save error
            var strErr = jimdoData.messages.theming.errors.generic;
            // if the original payload came with additional errors, display them too;
            /*
            if (payload.errors) {
                strErr = "";
                for(var er in payload.errors) {
                    if (payload.errors.hasOwnProperty((er))) {
                        strErr += '<p>' + payload.errors[er] + '</p>';
                    }
                }
            }
            */
            // hide the loading overlay
            $(contentElement).loadingBox().remove();
            // blocking dialog explaining that a fatal error occured
            $('<div>' + strErr + '</div>').diy_dialog({
                /* Can't use diyl10n here because we don't have the angular context */
                title: jimdoData.messages.theming.errors.generic,
                modal: true,
                draggable: false,
                resizable: false,
                closeButton: true,
                zIndex: 100100
            });
            // close the window
            api.close();
            // signal problem upstream
            return false;
        };

        // things that need to be done to actually have usable window contents
        var initializeStyleContent = function() {
            // Run the angular app bootstrap code from the theming bundle
            __webpack_require__.e/* nsure */(3, function() {
                var bootstrap = __webpack_require__(754);
                bootstrap(payload.data, payload.data.flags);
            });

            // hide the loading overlay
            $(contentElement).loadingBox().remove();

            // add the save button only after loading, to prevent it from being clicked meanwhile
            api.updateButtons({
                primary : {
                    text : jimdoData.messages.save,
                    callback : function() {
                        me.save();
                    }
                }
            });

            // hook the window navigation tabs with appropriate actions
            api.updateNavi([
                {
                    title : jimdoData.messages.theming.settings.tab.colors,
                    active: true,
                    identifier: 'palettes',
                    callback : function(e) {
                        if (diy.editor.theming && diy.editor.theming.changeTab) {
                            diy.editor.theming.changeTab('palettes');
                            api.updateHelpTopic(helpColors);
                            return true;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }, {
                    title : jimdoData.messages.theming.settings.tab.fonts,
                    identifier: 'typography',
                    callback : function(e) {
                        if (diy.editor.theming && diy.editor.theming.changeTab) {
                            diy.editor.theming.changeTab('typography');
                            api.updateHelpTopic(helpFonts);
                            return true;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }, {
                    title: jimdoData.messages.theming.settings.tab.background,
                    identifier: 'background',
                    callback: function (e) {
                        if (diy.editor.theming && diy.editor.theming.changeTab) {
                            diy.editor.theming.changeTab('background');
                            api.updateHelpTopic(helpBackground);
                            return true;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }
            ]);

            // set various other window characteristics
            api.updateTitle(jimdoData.messages.theming.settings.header.title);
            api.updateDescr('');
            api.updateHelpTopic(helpColors);

            // trigger KPI event for loading the colors tab
            //XXX: default tab may change; move to changeTab
            $(document).trigger('diy-editor-generic-sectionAccessed', {
                sectionCodeName: 'theming.palettes'
            });

            // set internal flag to tell the rest of the controller we're ready to party
            me.controllerLoaded = true;

            // announce whoever else it may concern that init is done
            $(document).trigger("diy-editor-theming-styleWindowLoaded");
        };

        // if this is the first time theming is being loaded
        if (!diy.editor.theming
            // and the payload contains a list of scripts to load
            && payload && payload.data && $.isArray(payload.data.js)
        ) {
            // load the scripts
            diy.util.scriptLoader(payload.data.js,
                // action in case of load success; delay a bit to avoid blocking UI
                function () { setTimeout(initializeStyleContent, 10); },
                // action in case of load failure
                scriptLoadingErrorHandler
            );
        }
        // no scripts to load
        else {
            // start init procedures
            setTimeout(initializeStyleContent, 10);
        }
    };

    /**
     * does this controller allows switching to another site-admin window?
     */
    this.allowSwitch = function () {
        //if theming is not ready *yet*
        //..this happens when you double click the style icon
        //..DHDIY-20483
        if (diy.editor.theming === undefined) {
            return false;
        }
        return this.controllerLoaded;
    };

    /**
     * lets this controller decide if it opens or not
     */
    this.allowOpen = function(){
        //check if any editing is opened(navigation, header, module)
        // fix bug #DHDIY-21607. didn't change isEditing to reflect this, since a module is
        // still during editing
        if (page.isEditing() && !window.Modul.getActiveModule() ) {

            $('<div/>').html(jimdoData.messages.theming.interactions.modulesOpened.message).diy_confirmationDialog({
                //zindex: needs to be above the site-admin
                zIndex: 100100,
                modal: true,
                closeButton: false,
                draggable: true,
                resizable: false,
                buttons: {okButton:{
                    text: jimdoData.messages.theming.interactions.modulesOpened.ok,
                    click: function () {
                        $(this).remove();
                        $(window).unbind('hashchange');
                        window.location.replace(window.location.pathname
                            + window.location.search
                            + '#hm:cc-sa-item-style');
                        window.location.reload();
                    }
                },cancelButton:{
                    text: jimdoData.messages.theming.interactions.modulesOpened.cancel,
                    "class": "button-cancel",
                    click: function () { $(this).remove();}
                }}
            });
            return false;
        }

        return true;
    };

    this.show = function() {
    };

    /**
     * when the editor is clicked while the Style window is opened
     */
    this.showAlertOnClickAway = function(){
        api.close();
    };

    return this;

}).call(exports);


/***/ },
/* 754 */,
/* 755 */,
/* 756 */
/***/ function(module, exports) {

module.exports = angular;

/***/ },
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */
/***/ function(module, exports, __webpack_require__) {

var moduleSelector = __webpack_require__(10);
var api = __webpack_require__(19);

/**
 * Class for module selector
 *
 * @class ModuleSelector
 * @depends jquery.js, controller.js
 * @author Mihai Curelea
 */
/* globals diy */
(function() {

    this.controllerLoaded = false;
	/* specific actions for module selector */
    this.afterFillContent = function(el, data, contentElement) {
        moduleSelector.default.afterFillContent(el, data, contentElement);

        api.updateTitle(jimdoData.messages.moduleSelector.window.title);
        api.updateDescr(jimdoData.messages.moduleSelector.window.description);
        api.updateButtons({});
        api.updateNavi({});
        api.updateHelpTopic('moduleSelector');
        api.updateFeatureGuidanceHelp('elements');
        this.controllerLoaded = true;
    };

    this.allowSwitch = function()
    {
        return this.controllerLoaded;
    };


    this.show = function() {
        moduleSelector.default.show();
    };

    this.hide = function() {
        moduleSelector.default.clearSelection();
    };

    this.reset = function() {
        moduleSelector.default.reset();
    };

    return this;

}).call(exports);


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var angular = __webpack_require__(756);
var l10n = __webpack_require__(18).getString;
var infoDialogApi = __webpack_require__(706);
var pagesEditorObserver = __webpack_require__(685).pagesEditorObserver;

/**
 * Class for Pages item in site-admin
 *
 * @class pagesEditor
 * @depends controller.js
 * @author Marian COJOC
 */

(function() {

    this.controllerLoaded = false;
    this.isHidden = true;
    var currentPageStartIndex = null;
    var navigationDataLoaded = false;
    var currentPageId =  null;
    var getCurrentPageId = function()
    {
        if (currentPageId === null) {
            currentPageId = parseInt(jQuery('body').attr('data-pageId'), 10);
        }
        return currentPageId;
    };
    /**
     *
     * @param contentElement TODO: fill this
     */
    this.afterFillContent = function(el, payload, contentElement) {
        diy.editor.siteadmin.api.updateTitle(jimdoData.messages.pagesEditor.window.title);
        diy.editor.siteadmin.api.updateDescr(jimdoData.messages.pagesEditor.window.description);

        diy.editor.siteadmin.api.updateButtons({});
        diy.editor.siteadmin.api.updateNavi({});
        diy.editor.siteadmin.api.updateHelpTopic('navigation');
        diy.editor.siteadmin.api.updateFeatureGuidanceHelp('managePages');
        jQuery(document).bind('diy-editor-managePageFromNavigation', {}, function(e, data) {
            if (data.actionName == 'AddPage') {
                diy.editor.siteadmin.api.updateFeatureGuidanceHelp('managePages');
            }
        });
        jQuery(document).bind('diy-editor-selectPageFromNavigation', {}, function(e, data) {
            if (data.actionName == 'SelectPage') {
                diy.editor.siteadmin.api.updateFeatureGuidanceHelp();
            }
        });

        var successFn = function() {
            var app = angular.module('pagesEditor', ['ngResource', 'ngSanitize']);

            diy.angular.loadControllers(app, [
                'pagesEditor.main',
                'pagesEditor.details',
                'pagesEditor.usecaseSelector',
                'pagesEditor.navigation'
            ]);

            diy.angular.loadFactories(app, [
                'diyl10n',
                'pagesEditor.diyprojecttype',
                'pagesEditor.usecases',
                'pagesEditor.pageinformation',
                'pagesEditor.websiteseodefaults',
                'pagesEditor.navigationdata',
                'pagesEditor.semanticdatafeature',
                'pagesEditor.touchhelper'
            ]);

            diy.angular.loadFilters(app, [
                'pagesEditorUsecasecategory',
                'pagesEditorEmphasekeywords'
            ]);

            diy.angular.loadDirectives(app, [
                 //general directives
                'diybutton',
                'diycheckbox',
                'diyradio',
                'diyreversedcheckbox',
                'diyquickhelp',
                'diymessage',
                'diyautogrow',

                 //app specific directives
                'pagesEditor.usecase',
                'pagesEditor.tree',
                'pagesEditor.treeNode'
            ]);
            var appElement = contentElement.find('.pages-editor');
            angular.bootstrap(appElement, ['pagesEditor']);
            localMainScope = angular.element(appElement).scope();

            localMainScope.$on('navigationDataLoaded', function(){
                navigationDataLoaded = true;
                registerCurrentPageIndex();
            });
            jQuery(document).bind('diy-navigation-loading-status', updateLoadingStatus);
            jQuery(document).trigger('diy-navigation-ngapp-loaded');

            // broadcast the display of notifications
            localMainScope.$apply(function () {
                localMainScope.$broadcast('showNotifications', getNotifications());
            });

            localMainScope.$on('showPageDeletionLimitWarning', function(event, withoutSubPages) {
                showPageDeletionLimitWarning(withoutSubPages, localMainScope);
            });
        };

        var errorFn = function() {
            // TODO
            alert('TODO error handling');
        };
        diy.util.scriptLoader(payload.data.js, successFn, errorFn);

        //tracking events
        jQuery(document.body).trigger('NavigationEditorOpened.BSA');
        this.controllerLoaded = true;
    };
    var registerCurrentPageIndex = function()
    {
        currentPageStartIndex = diy.editor.navigation.api.getPageIndex(
            getCurrentPageId()
        );
    };
    this.show = function() {
        this.isHidden = false;

        //show the click-catcher overlay
        var $overlay = jQuery(
            '<div id="siteadmin-window-overlay-pagesEditor" class="diye ui-overlay">'
                +'<div class="ui-widget-overlay transparent" style="z-index:49001; position: fixed;"></div>'
                +'</div>'
        ).hide().appendTo('body');
        $overlay.bind('click', function(){
            diy.editor.siteadmin.api.close();
        });
        $overlay.show();

        //make the next persistance request be special because it's the first
        //..after the user opened the pages-editor
        diy.editor.navigation.api.setFirstTime(true, function(){
            if (diy.editor.undoRedo) {
                diy.editor.undoRedo.hideRedoQueue();
            }
        });
        if (navigationDataLoaded == true) {
            registerCurrentPageIndex();
        }
        //trigger a digest cycle..
        //XXX: maybe block the interface with a loading screen until this finishes
        if (localMainScope !== null) {
            localMainScope.refreshActivePage();

            // broadcast that the SA window is showing //
            localMainScope.$broadcast('windowShow');

            // broadcast the display of notifications
            localMainScope.$apply(function () {
                localMainScope.$broadcast('showNotifications', getNotifications());
            });
        }
        jQuery(document).trigger('diy-managepages-show');
    };

    var getNotifications = function () {
        var notifications = [];

        if (pagesEditorObserver.isDeclined() && ! pagesEditorObserver.isRemoved()) {
            var message = pagesEditorObserver.getMessage();

            if (typeof message !== 'undefined') {
                notifications.push({
                    title: message.title,
                    text: message.message,
                    action: function() {
                        diy.editor.siteadmin.api.close();
                        message.actionHandler();
                    },
                    actionText: message.actionText
                });
            }
        }
        return notifications;
    };

    var showPageDeletionLimitWarning = function(withoutSubPages, localMainScope) {
        infoDialogApi.showDialog(
            {
                status: 'error',
                title: l10n('pagesEditor.limitReached.title'),
                description: l10n("pagesEditor.limitReached.description").replace(
                    "{5}",
                    jimdoData.navigation.maximumLimit
                ).replace(
                    "{link}",
                    '<a href="#" id="cc-sa-item-updateTariff" onclick="">' + l10n('pagesEditor.limitReached.link') + '</a>'
                ),
                primaryButtonConfig: {
                    label: l10n('pagesEditor.limitReached.close')
                },
                secondaryButtonConfig: {
                    label: l10n('pagesEditor.limitReached.delete'),
                    callback: function () {
                        localMainScope.$broadcast("deletePage", withoutSubPages);
                    }
                }
            }
        );
    };

    var confirmBoxHtml = '<div><div class="pe-dialog-box-wrapper with-icon">' +
        '<div class="ui-icon ui-icon-alert"></div>' +
        '<div class="pe-dialog-box-title"></div>' +
        '<div class="pe-window-loading"><div class="rotate-animation"></div></div>' +
        '<div class="pe-dialog-box-description"></div>' +
        '<div class="pe-dialog-box-extra"></div>' +
        '</div></div>';

    //TODO: this part needs to be refactor so we don't have anymore duplicate lines with diffrent css.
    var msgUseCasePending = '<hr />' +
        '<h2 class="working use-case-confirmation-step-preparing"><div class="pe-icon pe-icon-fail"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.preparing + '</h2>' +
        '<h2 class="use-case-confirmation-step-preparing-finished"><div class="pe-icon pe-icon-ok"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.preparing + '</h2>' +
        '<h2 class="use-case-confirmation-step-import"><div class="pe-icon pe-icon-fail"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.importing + '</h2>' +
        '<h2 class="use-case-confirmation-step-import-finished"><div class="pe-icon pe-icon-ok"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.importing + '</h2>' +
        '<h2 class="use-case-confirmation-step-publishing"><div class="pe-icon pe-icon-fail"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.publishing + '</h2>';

    var diyConfirmBox = null;
    var localMainScope = null;

    var diyConfirmBoxButtons = {
        okButton: {
            text: jimdoData.messages.pagesEditor.dialogBox.ok,
            click: function () {
                diy.editor.navigation.api.notify('force_update');
                releaseConfirmBox();
            }
        }
    };

    var releaseConfirmBox = function ()
    {
        if (diyConfirmBox != null) {
            diyConfirmBox.remove();
            diyConfirmBox = null;
        }
    };

    var statusDialog = function (title, description, appendix)
    {
        releaseConfirmBox();
        diyConfirmBox = jQuery(confirmBoxHtml);

        diyConfirmBox.find('.pe-dialog-box-title').html(title);
        diyConfirmBox.find('.pe-dialog-box-description').html(description);
        diyConfirmBox.find('.pe-dialog-box-extra').html(appendix);

        diyConfirmBox.diy_confirmationDialog({
            zIndex: 100210,
            closeOnEscape: false,
            overlayCls: null, /* use default semi-transparent overlay */
            width: 386,
            position: {
                my: 'center middle',
                at: 'center middle'
            },
            buttons: []
        });
        diyConfirmBox.find('.pe-window-loading').show();
    };

    var statusPrepareDescription = function (eventData)
    {
        var description = '';
        if (eventData.useCaseDetails.crawlerUrl) {
            description = (jimdoData.messages.pagesEditor.usecase.dialogBox.descriptionMainImportCrawledContent);
            description = description.replace('{site_url}', eventData.useCaseDetails.crawlerUrl);
        } else {

            if (eventData.useCaseDetails.pageCount > 1) {
                description = (jimdoData.messages.pagesEditor.usecase.dialogBox.descriptionMainWithSubPages);
                description = description.replace('{number_of_subpages}', parseInt(eventData.useCaseDetails.pageCount) - 1);
            } else {
                description = (jimdoData.messages.pagesEditor.usecase.dialogBox.descriptionMainWithoutSubPages);
            }

            description = description.replace('{page_title}', eventData.useCaseDetails.name);
        }
        return description;
    };


    var statusDialogStart = function (eventData)
    {
        var description = statusPrepareDescription(eventData);

        statusDialog(jimdoData.messages.pagesEditor.usecase.dialogBox.title, description, msgUseCasePending);
    };

    var statusDialogImporting = function(eventData)
    {
        if (diyConfirmBox == null) {
            statusDialogStart(eventData);
        }
        diyConfirmBox.find('.use-case-confirmation-step-preparing').removeClass('working');
        diyConfirmBox.find('.use-case-confirmation-step-preparing-finished').show();
        diyConfirmBox.find('.use-case-confirmation-step-import').addClass('working');
    };

    var statusDialogImported = function(eventData)
    {
        if (diyConfirmBox == null) {
            statusDialogStart(eventData);
        }
        diyConfirmBox.find('.use-case-confirmation-step-preparing').removeClass('working');
        diyConfirmBox.find('.use-case-confirmation-step-preparing-finished').show();
        diyConfirmBox.find('.use-case-confirmation-step-import').removeClass('working');
        diyConfirmBox.find('.use-case-confirmation-step-import-finished').show();
        diyConfirmBox.find('.use-case-confirmation-step-publishing').addClass('working');
    };

    var statusDialogError = function(eventData)
    {
        if (diyConfirmBox == null) {
            statusDialogStart(eventData);
        }
        diyConfirmBox.find('.use-case-confirmation-step-preparing').removeClass('working').show();
        diyConfirmBox.find('.use-case-confirmation-step-import').removeClass('working').show();
        diyConfirmBox.find('.use-case-confirmation-step-publishing').removeClass('working').show();
        diyConfirmBox.find('.use-case-confirmation-step-preparing-finished').hide();
        diyConfirmBox.find('.use-case-confirmation-step-import-finished').hide();

        diyConfirmBox.find('.pe-dialog-box-title').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedTitle);
        diyConfirmBox.find('.pe-dialog-box-description').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedDescription);

        diyConfirmBox.find('.pe-window-loading').hide();

        diyConfirmBox.diy_confirmationDialog({
            closeOnEscape: false,
            overlayCls: null, /* use default semi-transparent overlay */
            buttons: [
                diyConfirmBoxButtons.okButton
            ]
        });
    };

    var statusDialogAutoSaveError = function ()
    {
        releaseConfirmBox();
        diyConfirmBox = jQuery(confirmBoxHtml);

        diyConfirmBox.find('.pe-dialog-box-title').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedTitle);
        diyConfirmBox.find('.pe-dialog-box-description').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedDescription);
        diyConfirmBox.diy_confirmationDialog({
            zIndex: 100210,
            width: 386,
            overlayCls: null, /* use default semi-transparent overlay */
            position: {
                my: 'center middle',
                at: 'center middle'
            },
            buttons: [
                diyConfirmBoxButtons.okButton
            ]
        });
    };

    var updateLoadingStatus = function(eventData)
    {

        switch (eventData.action) {

            case 'use_case_start':
                statusDialogStart(eventData);
                diy.editor.siteadmin.api.smallLoading(true);
                break;
            case 'simple_start':
                diy.editor.siteadmin.api.smallLoading(true);
                break;
            case 'use_case_finished':
                releaseConfirmBox();

                localMainScope.$apply(function () {
                    localMainScope.$broadcast('usecaseAdded', eventData.websiteUseCaseId);
                    jQuery(document).trigger('diy-managepages-page-added');
                });

                diy.editor.siteadmin.api.smallLoading(false);
                break;
            case 'simple_end':
                diy.editor.siteadmin.api.smallLoading(false);
                break;
            case 'use_case_importing':
                statusDialogImporting(eventData);
                break;
            case 'use_case_imported':
                statusDialogImported(eventData);
                break;
            case 'use_case_error':
                statusDialogError(eventData);
                diy.editor.siteadmin.api.smallLoading(false);
                break;
            case 'autosave_error':
                statusDialogAutoSaveError();
                break;
            case 'get_data_error':
                localMainScope.$apply(function () {
                    if (eventData.dataType == 'navigationData'
                        || eventData.dataType == 'usecasesData'
                        || eventData.dataType == 'pageDetailsData'
                        ) {
                        localMainScope.$broadcast('showMajorError', eventData.dataType, {
                            type: 'error',
                            // text: jimdoData.messages.pagesEditor.errors[eventData.dataType],
                            text: jimdoData.messages.pagesEditor.errors['default'],
                            icon: true
                        });
                    }
                });
                break;
        }
    };

    this.hide = function()
    {
        if (this.isHidden) {
            return;
        }
        this.isHidden = true;
        var $overlay = jQuery('#siteadmin-window-overlay-pagesEditor');
        $overlay.unbind('click');
        diy.editor.navigation.api.updateJimdoData(function(data){
            diy.editor.navigation.api.verifyCurrentPage(data, function(){
                // the current page still exists, but:...
                // ..."is it now homepage?" or "is it no longer the homepage"
                var currentPageNewIndex = diy.editor.navigation.api.getPageIndex(
                    getCurrentPageId()
                );
                if (currentPageStartIndex != currentPageNewIndex
                    && (currentPageStartIndex == 0 || currentPageNewIndex == 0)
                ) {
                    window.location.reload();
                    return;
                }
                $overlay.remove();
                if(diy.editor.undoRedo) {
                    // this will be moved when sending data to server; in pages individual changes
                    diy.editor.undoRedo.closeActiveSession();
                    // should call signalEntryCreatedOnServerSide, but in individual changes
                    diy.editor.undoRedo.requestServerSync();
                }
                // broadcast that the SA window is hiding //
                localMainScope.$broadcast('windowHide');
            });
        });

    };

    this.allowSwitch = function()
    {
        if (diyConfirmBox != null) {
            return false;
        }

        return this.controllerLoaded;
    };

    return this;

}).call(exports);


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ShowroomApplier_1 = __webpack_require__(798);
var ShowroomDesignInfo_1 = __webpack_require__(799);
var api = __webpack_require__(19);
var SCREEN_PERCENTAGE = 0.9;
var MIN_SIZE = {
    width: 600,
    height: 400
};
var SITEADMIN_WIDTH = 90;
var SiteAdminShowroom = (function () {
    function SiteAdminShowroom() {
        this.controllerLoaded = false;
        this.highlightTab = function (id) {
            var navi = $('div.cc-sa-controller-showroom header nav');
            navi.find('li').removeClass('ui-tabs-selected ui-state-active');
            navi.find('a').removeClass('active');
            navi.find('li a[data-identifier="' + id + '"]').parent().addClass('ui-tabs-selected ui-state-active');
            navi.find('li a[data-identifier="' + id + '"]').addClass('active');
        };
    }
    SiteAdminShowroom.prototype.afterFillContent = function (el, response, contentElement) {
        var _this = this;
        this.showroomApplier = new ShowroomApplier_1.default();
        this.showroomDesignInfo = new ShowroomDesignInfo_1.default();
        if (response.data.settings.features.hasOwnProperty('ownlayout')
            && response.data.settings.features.ownlayout === true) {
            var tabs = [{
                    title: response.data.settings.labels.showroom,
                    identifier: 'showroom',
                    url: '/app/siteadmin/showroom/index/',
                    contentType: 'inline',
                    windowBehavior: {
                        cacheWindow: false,
                        header: { small: true },
                        footer: false
                    },
                    callback: function () {
                        api.updateHelpTopic('');
                        _this.highlightTab('showroom');
                    },
                    attrs: {
                        params: 'showroom'
                    }
                },
                {
                    title: response.data.settings.labels.ownlayout,
                    identifier: 'ownlayout',
                    url: '/app/siteadmin/layoutselector/api/',
                    contentType: 'iframe-local',
                    windowBehavior: {
                        cacheWindow: false,
                        header: { small: true },
                    },
                    callback: function () {
                        _this.highlightTab('ownlayout');
                    },
                    attrs: {
                        params: 'showroom'
                    }
                }
            ];
            api.updateNavi(tabs);
            this.highlightTab('showroom');
            this.showroomDesignInfo.show(document.getElementsByClassName('sa-window')[0]);
        }
        else {
            api.hideNavi();
        }
        this.controllerLoaded = true;
    };
    ;
    SiteAdminShowroom.prototype.allowSwitch = function () {
        return this.controllerLoaded;
    };
    ;
    SiteAdminShowroom.prototype.show = function () {
        //this function is required by the interface however we do not have any use for it here.
        if (this.showroomDesignInfo) {
            this.showroomDesignInfo.show(document.getElementsByClassName('sa-window')[0]);
        }
    };
    ;
    SiteAdminShowroom.prototype.hide = function () {
        //this function is required by the interface however we do not have any use for it here.
        this.showroomDesignInfo.hide();
    };
    ;
    SiteAdminShowroom.prototype.getWindowSize = function () {
        return {
            width: Math.max(SCREEN_PERCENTAGE * (document.documentElement.clientWidth) - SITEADMIN_WIDTH, MIN_SIZE.width),
            height: Math.max(SCREEN_PERCENTAGE * document.documentElement.clientHeight, MIN_SIZE.height)
        };
    };
    ;
    SiteAdminShowroom.prototype.applySelection = function (selectionId, url) {
        this.showroomApplier.show(selectionId, url);
    };
    ;
    return SiteAdminShowroom;
}());
var controllerInstance = new SiteAdminShowroom();
module.exports = controllerInstance;


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var Paper_1 = __webpack_require__(391);
var FlatButton_1 = __webpack_require__(479);
var $ = __webpack_require__(3);
var progressDialogApi = __webpack_require__(722);
var l10n_1 = __webpack_require__(18);
var Dialog_1 = __webpack_require__(711);
var websiteData = __webpack_require__(4);
var api = __webpack_require__(19);
var ShowroomApplier = (function () {
    function ShowroomApplier() {
    }
    ShowroomApplier.prototype.destroy = function () {
        ReactDOM.unmountComponentAtNode(this.selectionContentContainer);
    };
    ;
    ShowroomApplier.prototype.show = function (selectionId, url) {
        var _this = this;
        this.selectionContentContainer = document.createElement('div');
        this.selectionContentContainer.id = 'addSelectionContent';
        document.body.appendChild(this.selectionContentContainer);
        var styles = this.getStyles();
        var SelectionApplierPlaceholder = function () { return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(Dialog_1.default, { autoDetectWindowHeight: false, width: styles.width, title: l10n_1.default('showroomApplier.choice.dialog.title'), titleStyle: styles.title, contentStyle: styles.content, bodyStyle: styles.body, secondaryButtonConfig: {
                    primary: true,
                    label: l10n_1.default('cancelLabel'),
                    callback: function () { return _this.hide(); }
                } },
                React.createElement("div", { className: "selection-applier-dialog" },
                    React.createElement(FlatButton_1.default, { style: styles.paperButtons, onTouchTap: function () { _this.applySelection(false, selectionId, url); } },
                        React.createElement(Paper_1.default, { style: styles.paper, zDepth: 2 },
                            React.createElement("img", { src: _this.getSrc('apply-styles.png') }),
                            React.createElement("p", { style: styles.paperInnerP }, l10n_1.default('showroomApplier.choice.dialog.keepTheSame')))),
                    React.createElement(FlatButton_1.default, { style: styles.paperButtons, onTouchTap: function () { _this.applySelection(true, selectionId, url); } },
                        React.createElement(Paper_1.default, { style: styles.paper, zDepth: 2 },
                            React.createElement("img", { src: _this.getSrc('apply-styles-and-content.png') }),
                            React.createElement("p", { style: styles.paperInnerP }, l10n_1.default('showroomApplier.choice.dialog.addNewContent')))))))); };
        ReactDOM.render(React.createElement(SelectionApplierPlaceholder, null), this.selectionContentContainer);
    };
    ;
    ShowroomApplier.prototype.hide = function () {
        if (this.selectionContentContainer) {
            ReactDOM.unmountComponentAtNode(this.selectionContentContainer);
            this.selectionContentContainer.parentElement.removeChild(this.selectionContentContainer);
            this.selectionContentContainer = null;
        }
        return true;
    };
    ;
    ShowroomApplier.prototype.applySelection = function (withContent, selectionId, url) {
        this.hide();
        progressDialogApi.showDialog([], {
            image: websiteData.getCdnUrl() + 's/diy/site-admin/showroom/img/loading-bg.jpg',
            imageHeight: 327,
            description: l10n_1.default('showroomApplier.applyingInProgress')
        });
        $.post(url, {
            selectionId: selectionId,
            withContent: withContent ? 1 : 0
        }, function (data) {
            api.close();
            top.window.location.reload();
        });
    };
    ShowroomApplier.prototype.getSrc = function (imgName) {
        var cdnUrl = websiteData.getCdnUrl();
        return cdnUrl + "s/diy/site-admin/showroom/img/" + imgName;
    };
    ShowroomApplier.prototype.getStyles = function () {
        return {
            width: 472,
            minHeight: 500,
            content: {
                transform: 'translate3d(0, 0, 0)' // override the distance from viewport y=0
            },
            title: {
                textAlign: "center",
                backgroundColor: "#F3F3F3"
            },
            body: {
                textAlign: "center",
                backgroundColor: "#F3F3F3",
                height: 360
            },
            paperButtons: {
                height: "auto",
                margin: "10px 0px",
                padding: "0 0",
                hoverColor: "white",
                backgroundColor: "transparent",
                display: "flex",
                flexDirection: "column"
            },
            paper: {
                cursor: 'pointer',
                textAlign: "center",
                width: "196px",
                margin: "10px",
                display: 'inline-block'
            },
            paperInnerP: {
                padding: "0px 16px 16px 16px",
                fontSize: "15px",
                lineHeight: "18px",
                color: "#4F565E"
            }
        };
    };
    ;
    return ShowroomApplier;
}());
exports.default = ShowroomApplier;


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var IconButton_1 = __webpack_require__(420);
var info_1 = __webpack_require__(700);
var Dialog_1 = __webpack_require__(711);
//import $ = require('jquery');
var l10n_1 = __webpack_require__(18);
//import websiteData = require("diy/util/websiteData");
var ShowroomDesignInfo = (function () {
    function ShowroomDesignInfo() {
    }
    ShowroomDesignInfo.prototype.destroy = function () {
        ReactDOM.unmountComponentAtNode(this.designInfoContainer);
    };
    ;
    ShowroomDesignInfo.prototype.show = function (container) {
        var _this = this;
        this.topLevelContainer = container || document.body;
        this.designInfoContainer = document.getElementById('designLayoutInfo');
        if (this.designInfoContainer === null) {
            this.designInfoContainer = document.createElement('div');
            this.designInfoContainer.id = 'designLayoutInfo';
            this.topLevelContainer.appendChild(this.designInfoContainer);
            var styles_1 = this.getStyles();
            var DesignInfoPlaceholder = function () { return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
                React.createElement(IconButton_1.default, { onTouchTap: function () { _this.showDesignInfoBox(); }, iconStyle: styles_1.iconStyle, style: styles_1.button },
                    React.createElement(info_1.default, { color: "#FFFFFF" })))); };
            ReactDOM.render(React.createElement(DesignInfoPlaceholder, null), this.designInfoContainer);
        }
    };
    ;
    ShowroomDesignInfo.prototype.hide = function () {
        if (this.designInfoContainer) {
            ReactDOM.unmountComponentAtNode(this.designInfoContainer);
            this.designInfoContainer.parentElement.removeChild(this.designInfoContainer);
            this.designInfoContainer = null;
        }
        return true;
    };
    ;
    ShowroomDesignInfo.prototype.showDesignInfoBox = function () {
        var _this = this;
        this.designInfoBoxContainer = document.createElement('div');
        this.designInfoBoxContainer.id = 'designLayoutInfoBox';
        this.topLevelContainer.appendChild(this.designInfoBoxContainer);
        var DesignInfoBoxPlaceholder = function () { return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement(Dialog_1.default, { title: l10n_1.default('showroomDesignInfobox.dialog.title'), secondaryButtonConfig: {
                    primary: true,
                    label: l10n_1.default('cancelLabel'),
                    callback: function () { return _this.hideDesignInfoBox(); }
                } },
                React.createElement("div", { style: { 'padding': '0 25px' } },
                    React.createElement("div", null,
                        l10n_1.default('showroomDesignInfobox.dialog.currentSelectionLabel'),
                        ": ",
                        diy.website.design.id),
                    React.createElement("div", null,
                        l10n_1.default('showroomDesignInfobox.dialog.currentLayoutLabel'),
                        ": ",
                        diy.website.layout.id),
                    React.createElement("div", { style: { 'marginTop': "12px" } }, l10n_1.default('showroomDesignInfobox.dialog.disclaimer1')),
                    React.createElement("div", null, l10n_1.default('showroomDesignInfobox.dialog.disclaimer2')))))); };
        ReactDOM.render(React.createElement(DesignInfoBoxPlaceholder, null), this.designInfoBoxContainer);
    };
    ShowroomDesignInfo.prototype.hideDesignInfoBox = function () {
        if (this.designInfoBoxContainer) {
            ReactDOM.unmountComponentAtNode(this.designInfoBoxContainer);
            this.designInfoBoxContainer.parentElement.removeChild(this.designInfoBoxContainer);
            this.designInfoBoxContainer = null;
        }
        return true;
    };
    ;
    ShowroomDesignInfo.prototype.getStyles = function () {
        var styles = {
            'button': {
                position: "absolute",
                top: "0px",
                left: "12px",
                width: "40px",
                height: "40px"
            },
            'iconStyle': {
                width: '16px',
                height: '16px'
            }
        };
        return styles;
    };
    ;
    return ShowroomDesignInfo;
}());
exports.default = ShowroomDesignInfo;


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

var SectionSelector_1 = __webpack_require__(801);
var l10n = __webpack_require__(18);
var features = __webpack_require__(25);
var $ = __webpack_require__(3);
var api = __webpack_require__(19);
var globalEvents = __webpack_require__(500);
var guidanceDialog_1 = __webpack_require__(816);
var Controller = (function () {
    function Controller() {
        this.controllerLoaded = false;
        this.sectionSelector = new SectionSelector_1.default();
    }
    Controller.prototype.afterFillContent = function (el, response, contentElement) {
        this.sectionSelector.afterFillContent(el, response.data.data, contentElement);
        api.updateTitle(l10n.getString('sectionSelector.window.title'));
        api.updateDescr(l10n.getString('sectionSelector.window.description'));
        api.updateButtons({});
        api.updateNavi({});
        api.updateHelpTopic('addsections');
        api.updateFeatureGuidanceHelp('sections');
        this.controllerLoaded = true;
        $(document.body).trigger('SectionSelectorOpened.BSA');
        globalEvents.trigger('diy-tracking-section-selector-opened');
    };
    ;
    Controller.prototype.allowSwitch = function () {
        return this.controllerLoaded;
    };
    ;
    Controller.prototype.show = function () {
        // Only show guidance flyout if feature enabled and we have enough space vertically
        var shouldShowGuidanceFlyout = features('showSectionsGuidanceFlyout') && window.innerHeight >= 555;
        if (shouldShowGuidanceFlyout) {
            guidanceDialog_1.showDialog({
                onDismiss: function () {
                    features.disableFeature('showSectionsGuidanceFlyout').then(function () {
                        guidanceDialog_1.hideDialog();
                        $('#cc-sa-item-sections').click();
                    });
                }
            });
            api.close();
        }
        else {
            this.sectionSelector.show();
        }
    };
    ;
    Controller.prototype.hide = function () {
        this.sectionSelector.hide();
    };
    ;
    Controller.prototype.getWindowSize = function () {
        return this.sectionSelector.getWindowSize();
    };
    return Controller;
}());
var controllerInstance = new Controller();
module.exports = controllerInstance;


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var $ = __webpack_require__(3);
var Container_1 = __webpack_require__(802);
var Limitations_1 = __webpack_require__(814);
/**
 * Maps viewport width upper limit to params
 *
 * !! Keys should be in ascending order
 */
var responsiveParamMap = new Map()
    .set(768, {
    columnsNo: 1,
    showSidebar: false,
})
    .set(1000, {
    columnsNo: 2,
    showSidebar: false
})
    .set(1400, {
    columnsNo: 2,
    showSidebar: true
})
    .set(Number.MAX_VALUE, {
    columnsNo: 3,
    showSidebar: true
});
var SectionSelector = (function () {
    function SectionSelector() {
    }
    SectionSelector.prototype.afterFillContent = function (el, data, contentElement) {
        this.categories = data;
        this.contentEl = contentElement.get(0);
        this.render();
    };
    SectionSelector.prototype.show = function () {
        var _this = this;
        this.updateResponsiveParams();
        $(window).on('resize.sectionSelector', function () {
            _this.updateResponsiveParams();
            _this.render();
        });
        if (this.contentEl) {
            this.render();
        }
    };
    SectionSelector.prototype.hide = function () {
        $(window).off('.sectionSelector');
    };
    SectionSelector.prototype.getWindowSize = function () {
        this.updateResponsiveParams();
        return {
            width: Container_1.computeContainerWidth(this.responsiveParams.columnsNo, this.responsiveParams.showSidebar),
            height: 650
        };
    };
    SectionSelector.prototype.getViewportWidth = function () {
        return window.innerWidth;
    };
    SectionSelector.prototype.updateResponsiveParams = function () {
        var targetWidth = this.getViewportWidth();
        this.responsiveParams = Array.from(responsiveParamMap).find(function (_a) {
            var viewportWidth = _a[0];
            return (targetWidth < viewportWidth);
        })[1];
    };
    SectionSelector.prototype.render = function () {
        ReactDOM.render(React.createElement(Container_1.Container, { categories: this.categories, initialCategory: this.categories[0], columnsNo: this.responsiveParams.columnsNo, showSidebar: this.responsiveParams.showSidebar, limitationsMode: this.getLimitationsMode() }), this.contentEl);
    };
    SectionSelector.prototype.isModuleLimitReached = function () {
        return $("#cc-sa-sidebar").hasClass('modules-maximum');
    };
    SectionSelector.prototype.isModuleLimitWarning = function () {
        return $("#cc-sa-sidebar").hasClass('modules-critical');
    };
    SectionSelector.prototype.getLimitationsMode = function () {
        if (this.isModuleLimitReached()) {
            return Limitations_1.Mode.Maximum;
        }
        if (this.isModuleLimitWarning()) {
            return Limitations_1.Mode.Critical;
        }
        return Limitations_1.Mode.None;
    };
    return SectionSelector;
}());
exports.default = SectionSelector;


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var $ = __webpack_require__(3);
var Content_1 = __webpack_require__(803);
var Sidebar_1 = __webpack_require__(813);
var Limitations_1 = __webpack_require__(814);
exports.computeContainerWidth = function (columnsNo, showSidebar) {
    return Content_1.computeContentWidth(columnsNo) +
        (showSidebar ? Sidebar_1.computeSidebarWidth() : 0);
};
var Container = (function (_super) {
    tslib_1.__extends(Container, _super);
    function Container(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onCategoryChange = function (category) {
            _this.setState({
                selectedCategory: category,
                scrolledCategory: category
            });
        };
        _this.state = {
            selectedCategory: props.initialCategory,
            scrolledCategory: props.initialCategory
        };
        return _this;
    }
    Container.prototype.render = function () {
        var _this = this;
        return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement("div", { className: "container" },
                React.createElement(Limitations_1.Limitations, { mode: this.props.limitationsMode }),
                React.createElement("div", { className: "content-wrapper", ref: function (ref) { return _this.contentWrapper = ref; } },
                    this.props.showSidebar ?
                        React.createElement(Sidebar_1.Sidebar, { categories: this.props.categories, activeCategory: this.state.selectedCategory, onCategorySelect: this.onCategoryChange })
                        : null,
                    React.createElement(Content_1.Content, { categories: this.props.categories, activeCategory: this.state.scrolledCategory, onScroll: this.onCategoryChange, columnsNo: this.props.columnsNo })))));
    };
    Container.prototype.componentDidMount = function () {
        this.refreshLimitations();
    };
    Container.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.limitationsMode !== prevProps.limitationsMode) {
            this.refreshLimitations();
        }
    };
    Container.prototype.refreshLimitations = function () {
        this.toggleLimitations(this.props.limitationsMode === Limitations_1.Mode.Maximum);
    };
    Container.prototype.toggleLimitations = function (disable) {
        if (disable) {
            $(this.contentWrapper).loadingBox({
                useOverlay: true,
                hideLoader: true
            }).show();
        }
        else {
            $(this.contentWrapper).loadingBox().remove();
        }
    };
    return Container;
}(React.Component));
exports.Container = Container;


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Masonry = __webpack_require__(804);
var Item_1 = __webpack_require__(811);
var $ = __webpack_require__(3);
var l10n = __webpack_require__(18);
var COLUMN_WIDTH = 264;
var PADDING = 24;
exports.computeContentWidth = function (columnsNo) {
    return columnsNo * (COLUMN_WIDTH + PADDING) + PADDING;
};
var Content = (function (_super) {
    tslib_1.__extends(Content, _super);
    function Content(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.itemContainers = new Map();
        _this.categoryElements = new Map();
        _this.masonries = new Map();
        _this.containerBoxData = [];
        _this.handleScroll = function (e) {
            var scrollTop = _this.contentEl.scrollTop;
            var category = _this.getCategoryByScrollTop(scrollTop);
            // Hack: set state without re-render
            _this.state.scrollTop = scrollTop;
            _this.props.onScroll(category);
        };
        _this.state = {
            scrollTop: 0
        };
        return _this;
    }
    Content.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: this.getRootStyles(), className: "content", ref: function (ref) { return _this.contentEl = ref; } }, this.props.categories.map(function (category) { return _this.renderCategory(category); })));
    };
    Content.prototype.componentDidMount = function () {
        for (var _i = 0, _a = this.props.categories; _i < _a.length; _i++) {
            var category = _a[_i];
            var masonry = new Masonry(this.itemContainers.get(category), {
                columnWidth: COLUMN_WIDTH + PADDING
            });
            this.masonries.set(category, masonry);
        }
        this.cacheContainerBoxes();
        this.contentEl.addEventListener('scroll', this.handleScroll);
    };
    Content.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var activeCategory = this.props.activeCategory;
        var prevCategory = this.getCategoryByScrollTop(prevState.scrollTop);
        if (activeCategory && activeCategory !== prevCategory) {
            var el = this.categoryElements.get(activeCategory);
            if (!el) {
                throw new Error("Invalid category " + activeCategory.id);
            }
            this.contentEl.removeEventListener('scroll', this.handleScroll);
            $(this.contentEl).scrollTo(el, 400, {
                axis: 'y',
                offset: -PADDING,
                onAfter: function () {
                    _this.contentEl.addEventListener('scroll', _this.handleScroll);
                }
            });
        }
        if (this.props.columnsNo !== prevProps.columnsNo) {
            this.masonries.forEach(function (masonry) {
                masonry.layout();
            });
            this.cacheContainerBoxes();
        }
    };
    Content.prototype.getContentWidth = function () {
        return this.props.columnsNo * (COLUMN_WIDTH + PADDING) + PADDING;
    };
    Content.prototype.cacheContainerBoxes = function () {
        this.containerBoxData = Array.from(this.categoryElements)
            .map(function (_a) {
            var category = _a[0], element = _a[1];
            return {
                category: category,
                top: element.offsetTop,
                height: element.offsetHeight
            };
        });
    };
    Content.prototype.getCategoryByScrollTop = function (scrollTop) {
        return this.containerBoxData.find(function (boxData) {
            return scrollTop < boxData.top - PADDING + boxData.height;
        }).category;
    };
    Content.prototype.renderGuidanceLink = function () {
        var helpArticleId = "d854053.dita";
        var onClick = function () { cms.help.GuidedAssistant.getInstance()._openHelpTopic(helpArticleId); };
        var text = l10n.getString('section.selector.guidanceLink');
        return (React.createElement("a", { className: "guidance", onTouchTap: onClick }, text));
    };
    Content.prototype.renderCategory = function (category) {
        var _this = this;
        return (React.createElement("div", { "data-test-id": "category-" + category.id, key: category.id, ref: function (ref) { return _this.categoryElements.set(category, ref); } },
            React.createElement("div", { className: "category-header" },
                React.createElement("div", { className: "category-title" }, category.label),
                React.createElement("div", { className: "category-desc" },
                    category.description,
                    this.renderGuidanceLink())),
            React.createElement("div", { style: this.getItemContainerStyles(), ref: function (ref) { return _this.itemContainers.set(category, ref); } }, category.items.map(function (item) { return _this.renderItem(item, category); }))));
    };
    Content.prototype.renderItem = function (item, category) {
        var thumbWidth = COLUMN_WIDTH;
        var thumbHeight = Math.floor(COLUMN_WIDTH * (item.thumbHeight / item.thumbWidth));
        return (React.createElement("div", { key: category.id + "/" + item.base + "/" + item.variant, style: this.getItemWrapperStyles() },
            React.createElement(Item_1.Item, { item: item, width: thumbWidth, height: thumbHeight })));
    };
    Content.prototype.getRootStyles = function () {
        return {
            boxSizing: "border-box",
            WebkitBoxSizing: "border-box",
            paddingTop: PADDING + "px",
            paddingLeft: PADDING + "px",
            position: "relative"
        };
    };
    Content.prototype.getItemContainerStyles = function () {
        return {
            width: this.getContentWidth() - PADDING + "px"
        };
    };
    Content.prototype.getItemWrapperStyles = function () {
        return {
            width: COLUMN_WIDTH + PADDING + "px",
            boxSizing: "border-box",
            WebKitBoxSizing: "border-box",
            paddingRight: PADDING + 'px',
            paddingBottom: PADDING + "px"
        };
    };
    return Content;
}(React.Component));
exports.Content = Content;


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Masonry v4.1.1
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(805),
        __webpack_require__(807)
      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {

'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  Masonry.prototype._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
  };

  Masonry.prototype.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  Masonry.prototype.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  Masonry.prototype._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );

    var colGroup = this._getColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );
    var shortColIndex = colGroup.indexOf( minimumY );

    // position the brick
    var position = {
      x: this.columnWidth * shortColIndex,
      y: minimumY
    };

    // apply setHeight to necessary columns
    var setHeight = minimumY + item.size.outerHeight;
    var setSpan = this.cols + 1 - colGroup.length;
    for ( var i = 0; i < setSpan; i++ ) {
      this.colYs[ shortColIndex + i ] = setHeight;
    }

    return position;
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  Masonry.prototype._getColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      // make an array of colY values for that one group
      var groupColYs = this.colYs.slice( i, i + colSpan );
      // and get the max value of the array
      colGroup[i] = Math.max.apply( Math, groupColYs );
    }
    return colGroup;
  };

  Masonry.prototype._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  Masonry.prototype._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  Masonry.prototype._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  Masonry.prototype.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Outlayer v2.1.0
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(806),
        __webpack_require__(807),
        __webpack_require__(808),
        __webpack_require__(810)
      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  this.updateStagger();
  queue.forEach( function( obj, i ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
  }, this );
};

// set stagger from option in milliseconds number
proto.updateStagger = function() {
  var stagger = this.options.stagger;
  if ( stagger === null || stagger === undefined ) {
    this.stagger = 0;
    return;
  }
  this.stagger = getMilliseconds( stagger );
  return this.stagger;
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant, i ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.stagger( i * this.stagger );
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- helpers ----- //

// how many milliseconds are in each unit
var msUnits = {
  ms: 1,
  s: 1000
};

// munge time-like parameter into millisecond number
// '0.4s' -> 40
function getMilliseconds( time ) {
  if ( typeof time == 'number' ) {
    return time;
  }
  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
  var num = matches && matches[1];
  var unit = matches && matches[2];
  if ( !num.length ) {
    return 0;
  }
  num = parseFloat( num );
  var mult = msUnits[ unit ] || 1;
  return num * mult;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.0.3
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

return EvEmitter;

}));


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return factory();
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.3
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(809)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
      return factory( window, matchesSelector );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( obj && typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    if ( timeout ) {
      clearTimeout( timeout );
    }
    var args = arguments;

    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold || 100 );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.1
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(806),
        __webpack_require__(807)
      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties that could have vendor prefix
var vendorProperties = {
  transform: transformProperty,
  transition: transitionProperty,
  transitionDuration: transitionProperty + 'Duration',
  transitionProperty: transitionProperty + 'Property',
  transitionDelay: transitionProperty + 'Delay'
};

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  // convert percent to pixels
  var layoutSize = this.layout.size;
  var x = xValue.indexOf('%') != -1 ?
    ( parseFloat( xValue ) / 100 ) * layoutSize.width : parseInt( xValue, 10 );
  var y = yValue.indexOf('%') != -1 ?
    ( parseFloat( yValue ) / 100 ) * layoutSize.height : parseInt( yValue, 10 );

  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var compareX = parseInt( x, 10 );
  var compareY = parseInt( y, 10 );
  var didNotMove = compareX === this.position.x && compareY === this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseInt( x, 10 );
  this.position.y = parseInt( y, 10 );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto.transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' + toDashedAll( transformProperty );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // munge number to millisecond, to match stagger
  var duration = this.layout.options.transitionDuration;
  duration = typeof duration == 'number' ? duration + 'ms' : duration;
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: duration,
    transitionDelay: this.staggerDelay || 0
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: '',
  transitionDelay: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- stagger ----- //

proto.stagger = function( delay ) {
  delay = isNaN( delay ) ? 0 : delay;
  this.staggerDelay = delay + 'ms';
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Card_1 = __webpack_require__(569);
var CardText_1 = __webpack_require__(575);
var CardMedia_1 = __webpack_require__(574);
var l10n = __webpack_require__(18);
var Modul_1 = __webpack_require__(197);
var websiteData = __webpack_require__(4);
var AppRegistry_1 = __webpack_require__(190);
var BlankModuleDragSource = __webpack_require__(191);
var BlankSectionHelper_1 = __webpack_require__(812);
var siteadminApi = __webpack_require__(19);
var $ = __webpack_require__(3);
var Item = (function (_super) {
    tslib_1.__extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Item.prototype.getSrc = function () {
        var cdnUrl = websiteData.getCdnUrl();
        var baseSection = this.props.item.base;
        var sectionVariant = this.props.item.variant;
        var languageCode = websiteData.getLanguageCode();
        return cdnUrl + "sections/" + baseSection + "/public/" + sectionVariant + "." + languageCode + ".jpg";
    };
    Item.prototype.render = function () {
        var _this = this;
        var item = this.props.item;
        var thumbHeight = this.props.height;
        var thumbWidth = this.props.width;
        return (React.createElement("div", { className: "category-item-card disable-touch-defaults", ref: function (ref) { return _this.cardWrapper = ref; }, onMouseUp: function () { return _this.showTooltip(); } },
            React.createElement(Card_1.default, null,
                React.createElement(CardMedia_1.default, null,
                    React.createElement("img", { alt: item.label, height: thumbHeight, width: thumbWidth, src: this.getSrc(), style: { backgroundColor: "#ccc" } })),
                React.createElement(CardText_1.default, { style: this.getLabelStyles() }, item.label))));
    };
    Item.prototype.componentDidMount = function () {
        this.setupItemWrapper(this.cardWrapper);
        this.setupDraggable();
    };
    Item.prototype.setupItemWrapper = function (ref) {
        var item = this.props.item;
        var draggableAttrs = {
            "data-moduleMinWidth": "400",
            "data-allowedInSidebar": "false",
            "data-moduleType": "local",
            "data-moduleName": Modul_1.ModuleType.SECTION,
            "data-moduleLabel": item.label,
            "data-sectionName": item.base + "/" + item.variant
        };
        for (var attrName in draggableAttrs) {
            if (draggableAttrs.hasOwnProperty(attrName)) {
                ref.setAttribute(attrName, draggableAttrs[attrName]);
            }
        }
    };
    Item.prototype.setupDraggable = function () {
        var dragHelper = new BlankSectionHelper_1.default();
        $(this.cardWrapper).each(function (index, elem) {
            var dragSource = new BlankModuleDragSource($(elem));
            dragSource.setHelper(dragHelper);
            AppRegistry_1.default.getModuleDragDrop().addDragSource(dragSource);
        })
            .on('ddstart', function () {
            // hide the site admin bar and window
            siteadminApi.hide();
        })
            .on('ddcancel', function () {
            // Show the section selector again because we cancelled the drop
            siteadminApi.show();
        })
            .on('dddropped', function () {
            //Close the siteadmin window
            siteadminApi.close(false, true);
            //Show the siteadmin bar
            siteadminApi.show();
        });
    };
    Item.prototype.getLabelStyles = function () {
        return {
            borderTop: '1px solid #ebebeb',
            padding: 0,
            boxSizing: "border-box",
            WebkitBoxSizing: "border-box",
            height: "30px",
            lineHeight: "30px",
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 600,
            fontSize: "10px",
            color: "rgba(73, 84, 100, 0.8)",
            paddingLeft: "8px"
        };
    };
    Item.prototype.hideTooltip = function () {
        $(this.cardWrapper).diy_tooltip('destroy');
    };
    Item.prototype.showTooltip = function () {
        var _this = this;
        $(window).on('mousedown.sectionSelector scroll.sectionSelector resize.sectionSelector', function () {
            _this.hideTooltip();
            $(window).off('.sectionSelector');
        });
        $(this.cardWrapper)
            .diy_tooltip({
            anchorOffset: -13,
            zIndex: 100110,
            fadeOutDelay: 400,
            fadeInDelay: 400,
            triggerMode: 'none',
            cls: 'module_selector_tooltip',
            content: !diy.editor.uiPreference.isPointerModeTouch() ?
                l10n.getString('moduleSelector.moduleTooltip') :
                l10n.getString('moduleSelector.moduleTooltipMobile')
        })
            .diy_tooltip('show', this.cardWrapper);
    };
    return Item;
}(React.Component));
exports.Item = Item;


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var ModuleHelper = __webpack_require__(16);
/**
 * Drag helper for new sections (from section selector)
 */
var BlankSectionHelper = (function (_super) {
    tslib_1.__extends(BlankSectionHelper, _super);
    function BlankSectionHelper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.restrictedTooltipOptions = {
            anchorOffset: -12
        };
        return _this;
    }
    BlankSectionHelper.prototype.create = function (sourceElem) {
        return sourceElem
            .clone()
            .addClass("drag-container")
            .css({
            width: sourceElem.width(),
            height: sourceElem.height()
        });
    };
    return BlankSectionHelper;
}(ModuleHelper));
exports.default = BlankSectionHelper;


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var List_1 = __webpack_require__(428);
var ListItem_1 = __webpack_require__(409);
exports.computeSidebarWidth = function () {
    return 234;
};
var Sidebar = (function (_super) {
    tslib_1.__extends(Sidebar, _super);
    function Sidebar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sidebar.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "sidebar", style: this.getRootStyle() },
            React.createElement(List_1.default, { style: this.getListStyle() }, this.props.categories.map(function (category) { return _this.renderCategory(category); }))));
    };
    Sidebar.prototype.renderCategory = function (category) {
        var _this = this;
        return (React.createElement(ListItem_1.default, { "data-test-id": "menu-category-" + category.id, key: category.id, primaryText: category.label, style: this.getItemStyle(category), onClick: function () { return _this.onItemClick(category); } }));
    };
    Sidebar.prototype.onItemClick = function (category) {
        this.props.onCategorySelect(category);
    };
    Sidebar.prototype.getRootStyle = function () {
        return {
            width: exports.computeSidebarWidth() + "px",
            backgroundColor: "#ECEBEB"
        };
    };
    Sidebar.prototype.getListStyle = function () {
        return {
            backgroundColor: 'transparent',
            paddingTop: 0,
            paddingBottom: 0
        };
    };
    Sidebar.prototype.getItemStyle = function (category) {
        var activeStyles = {
            color: "#16191d",
            backgroundColor: "#ced0d6"
        };
        var style = {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            color: 'rgba(61, 73, 89, 1)'
        };
        if (category === this.props.activeCategory) {
            Object.assign(style, activeStyles);
        }
        return style;
    };
    return Sidebar;
}(React.Component));
exports.Sidebar = Sidebar;


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n = __webpack_require__(18);
var styles_1 = __webpack_require__(242);
var diyLightRawTheme_1 = __webpack_require__(375);
var InfoBox_1 = __webpack_require__(815);
var warning_1 = __webpack_require__(544);
var Mode;
(function (Mode) {
    Mode[Mode["None"] = 0] = "None";
    Mode[Mode["Critical"] = 1] = "Critical";
    Mode[Mode["Maximum"] = 2] = "Maximum";
})(Mode = exports.Mode || (exports.Mode = {}));
var Limitations = (function (_super) {
    tslib_1.__extends(Limitations, _super);
    function Limitations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Limitations.prototype.render = function () {
        var limitationsMsg = '';
        if (this.props.mode === Mode.Maximum) {
            limitationsMsg = l10n.getString('limitations.maxAmountModulesPerPage');
        }
        else if (this.props.mode === Mode.Critical) {
            limitationsMsg = l10n.getString('limitations.warningAmountModulesPerPage');
        }
        var warnColor = this.props.mode === Mode.Critical ?
            diyLightRawTheme_1.default.palette.textColor :
            "#fff";
        return (this.props.mode === Mode.None ? null :
            React.createElement(InfoBox_1.InfoBox, { Icon: warning_1.default, iconColor: warnColor, paperCssClass: this.getCssClass(), paperStyles: this.getStyles() },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: limitationsMsg } })));
    };
    Limitations.prototype.getStyles = function () {
        var topboxError = {
            backgroundColor: '#F7482D',
            color: '#FFF'
        };
        var topboxWarn = {
            backgroundColor: styles_1.colors.orange50,
            opacity: 0.54
        };
        var topboxColors = this.props.mode === Mode.Maximum ? topboxError : topboxWarn;
        return topboxColors;
    };
    Limitations.prototype.getCssClass = function () {
        return this.props.mode === Mode.Maximum ? 'limitations-maximum' : 'limitations-critical';
    };
    return Limitations;
}(React.Component));
exports.Limitations = Limitations;


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Paper_1 = __webpack_require__(391);
var diyLightRawTheme_1 = __webpack_require__(375);
var autoprefixer_1 = __webpack_require__(438);
var InfoBox = (function (_super) {
    tslib_1.__extends(InfoBox, _super);
    function InfoBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoBox.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement(Paper_1.default, { className: this.props.paperCssClass, style: styles.paper, rounded: false, "data-test-id": this.props.dataTestId },
            this.renderIcon(),
            this.props.children));
    };
    InfoBox.prototype.renderIcon = function () {
        var styles = this.getStyles();
        var Icon = this.props.Icon;
        return React.createElement(Icon, { style: styles.icon, color: this.props.iconColor });
    };
    InfoBox.prototype.getStyles = function () {
        return {
            paper: autoprefixer_1.autoprefixer(Object.assign({
                padding: "16px 24px",
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "13px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center"
            }, this.props.paperStyles)),
            icon: autoprefixer_1.autoprefixer({
                height: "16px",
                marginRight: "10px",
                flexShrink: 0
            })
        };
    };
    return InfoBox;
}(React.Component));
InfoBox.defaultProps = {
    iconColor: diyLightRawTheme_1.default.palette.textColor
};
exports.InfoBox = InfoBox;


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
var GuidanceDialog_1 = __webpack_require__(817);
var dialogContainer;
function showDialog(options) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'diy-sections-guidance-dialog';
    document.body.appendChild(dialogContainer);
    ReactDOM.render(React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
        React.createElement(GuidanceDialog_1.GuidanceDialog, tslib_1.__assign({}, options))), dialogContainer);
}
exports.showDialog = showDialog;
function hideDialog() {
    if (dialogContainer) {
        ReactDOM.unmountComponentAtNode(dialogContainer);
        dialogContainer.parentElement.removeChild(dialogContainer);
        dialogContainer = null;
    }
}
exports.hideDialog = hideDialog;


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(818);
var l10n_1 = __webpack_require__(18);
var GuidanceDialog = (function (_super) {
    tslib_1.__extends(GuidanceDialog, _super);
    function GuidanceDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        return _this;
    }
    GuidanceDialog.prototype.render = function () {
        var _this = this;
        var dialogWidth = 540;
        var iframeStyle = {
            border: 0,
            height: 447,
            width: dialogWidth,
            display: 'block'
        };
        var contentStyle = {
            transform: 'translate3d(0, 0, 0)' // override the distance from viewport y=0
        };
        return (React.createElement(Dialog_1.default, { width: dialogWidth, autoDetectWindowHeight: false, contentStyle: contentStyle, primaryButtonConfig: {
                label: l10n_1.default('section.guidanceDialog.dismissLabel'),
                callback: function () { return _this.onDismiss(); }
            } },
            React.createElement("iframe", { style: iframeStyle, src: "/app/help/section-guidance" })));
    };
    return GuidanceDialog;
}(React.Component));
exports.GuidanceDialog = GuidanceDialog;


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var RaisedButton_1 = __webpack_require__(482);
var Dialog = (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.handlePrimaryActionCallback = function () {
            _this.handleClose();
            if (_this.props.primaryButtonConfig.callback) {
                _this.props.primaryButtonConfig.callback();
            }
        };
        _this.handleSecondaryActionCallback = function () {
            _this.handleClose();
            if (_this.props.secondaryButtonConfig && _this.props.secondaryButtonConfig.callback) {
                _this.props.secondaryButtonConfig.callback();
            }
        };
        _this.state = {
            open: false
        };
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        this.setState({
            open: true
        });
    };
    Dialog.prototype.componentWillUnmount = function () {
        this.handleClose();
    };
    Dialog.prototype.render = function () {
        var actions = [];
        var style = {
            zIndex: 200100
        };
        var bodyStyle = {
            padding: 0,
            borderBottom: '1px solid #dddddd',
            backgroundColor: '#f3f3f3'
        };
        var contentStyle = Object.assign({}, {
            width: this.props.width || undefined
        }, this.props.contentStyle);
        var actionsStyle = {
            padding: 18
        };
        if (this.props.secondaryButtonConfig) {
            actions.push(React.createElement(FlatButton_1.default, { "data-test-id": this.props.secondaryButtonConfig.dataTestId, label: this.props.secondaryButtonConfig.label, onTouchTap: this.handleSecondaryActionCallback }));
        }
        if (this.props.primaryButtonConfig) {
            actions.push(React.createElement(RaisedButton_1.default, { primary: true, "data-test-id": this.props.primaryButtonConfig.dataTestId, label: this.props.primaryButtonConfig.label, onTouchTap: this.handlePrimaryActionCallback }));
        }
        return (React.createElement(Dialog_1.default, { open: this.state.open, autoDetectWindowHeight: this.props.autoDetectWindowHeight, actions: actions, contentStyle: contentStyle, bodyStyle: bodyStyle, actionsContainerStyle: actionsStyle, style: style }, this.props.children));
    };
    return Dialog;
}(React.Component));
Dialog.defaultProps = {
    autoDetectWindowHeight: true
};
exports.default = Dialog;


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

var features = __webpack_require__(25);
var OnboardingGuide_1 = __webpack_require__(820);
var Observable_1 = __webpack_require__(839);
var App_1 = __webpack_require__(645);
var Api_1 = __webpack_require__(537);
var SiteAdminApi = __webpack_require__(19);
var SiteAdmin = __webpack_require__(20);
/**
 * Class for onboarding guide
 *
 * @class OnboardingGuide
 * @depends jquery.js, controller.js
 * @author Andrei Ion
 */
var Controller = (function () {
    function Controller() {
        this.controllerLoaded = false;
        this.observable = new Observable_1.Observable();
        this.guide = new OnboardingGuide_1.default(this.observable, $(window), function () {
            SiteAdminApi.close();
        });
    }
    Controller.prototype.afterFillContent = function (el, response, contentElement) {
        this.disableNotifications();
        this.guide.setElement(contentElement.get(0));
        if (response.success === true) {
            this.guide.setData(response.data);
        }
        var params = SiteAdmin.getParams();
        if (params && params.hideSidebar) {
            this.guide.setSidebar(false);
        }
        if (params && params.jumpToStep) {
            this.guide.setStep(params.jumpToStep);
        }
        this.guide.setVisible();
        this.controllerLoaded = true;
    };
    ;
    Controller.prototype.addTrackerToOnboardingGuide = function (tracker) {
        this.observable.registerObserver(tracker);
    };
    Controller.prototype.allowSwitch = function () {
        return this.controllerLoaded;
    };
    ;
    Controller.prototype.show = function () {
        /**
         * No need for implementation here because show is called in afterFillContent.
         * And afterFillContent is called every time onboarding Guide is opened because caching is disabled
         * (otherwise the data won't be retreived from the server each time)
         */
    };
    ;
    Controller.prototype.hide = function () {
        this.guide.setHidden();
        this.enableNotifications();
    };
    ;
    Controller.prototype.getWindowSize = function () {
        return this.guide.getWindowSize();
    };
    Controller.prototype.disableNotifications = function () {
        SiteAdminApi.closeCallout('cc-sa-item-onboardingguide');
        if (features('notificationsNG')) {
            Api_1.default.schedule(function () {
                Api_1.default.pause();
            });
        }
        else {
            App_1.App.getNotificationApi().pause();
        }
    };
    Controller.prototype.enableNotifications = function () {
        if (features('notificationsNG')) {
            Api_1.default.schedule(function () {
                Api_1.default.resume();
            });
        }
        else {
            App_1.App.getNotificationApi().resume();
        }
    };
    return Controller;
}());
var controllerInstance = new Controller();
controllerInstance.addTrackerToOnboardingGuide(new Observable_1.TrackerKPI());
module.exports = controllerInstance;


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
// react
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
// local
var Guide_1 = __webpack_require__(821);
var Sidebar_1 = __webpack_require__(825);
var Content_1 = __webpack_require__(826);
var TABLE_VIEW_BREAKPOINT = 810;
var CONTAINER_HEIGHT = 590;
/**
 * Maps viewport width upper limit to params
 *
 * !! Keys should be in ascending order
 */
var responsiveParamMap = new Map()
    .set(TABLE_VIEW_BREAKPOINT, {
    tabletView: true,
})
    .set(Number.MAX_VALUE, {
    tabletView: false
});
var OnboardingGuide = (function () {
    function OnboardingGuide(observable, $window, onClose) {
        this.observable = observable;
        this.$window = $window;
        this.onClose = onClose;
        this.steps = [];
        this.currentStepPosition = 0;
        this.isVisible = false;
        this.showSidebar = true;
    }
    OnboardingGuide.prototype.setElement = function (contentElement) {
        this.rootElement = contentElement;
    };
    ;
    OnboardingGuide.prototype.setData = function (serverData) {
        this.steps = serverData.steps;
        this.currentStepPosition = 0;
        if (serverData.isCompleted) {
            this.selectLastVisibleStep();
        }
        else {
            this.selectStep(serverData.firstUncompletedStep);
        }
    };
    OnboardingGuide.prototype.setStep = function (stepName) {
        this.selectStep(stepName);
        this.update();
    };
    OnboardingGuide.prototype.setSidebar = function (shown) {
        if (shown !== this.showSidebar) {
            this.$window.trigger('resize.saWindowSizeBehavior');
        }
        this.showSidebar = shown;
        this.update();
    };
    OnboardingGuide.prototype.setVisible = function () {
        var _this = this;
        if (!this.isVisible) {
            this.$window.on('resize.onboardingGuide', function () {
                _this.update();
            });
            this.observable.notify({
                eventName: 'diy-editor-onboardingGuide-open',
                step: this.steps[this.currentStepPosition]
            });
        }
        this.isVisible = true;
        this.update();
    };
    OnboardingGuide.prototype.setHidden = function () {
        if (this.isVisible) {
            this.$window.off('.onboardingGuide');
        }
        this.isVisible = false;
    };
    OnboardingGuide.prototype.getWindowSize = function () {
        this.updateResponsiveParams();
        return {
            width: Content_1.computeContentWidth(this.responsiveParams.tabletView)
                + (this.showSidebar
                    ? Sidebar_1.computeSidebarWidth(this.responsiveParams.tabletView)
                    : 0),
            height: CONTAINER_HEIGHT
        };
    };
    ;
    OnboardingGuide.prototype.close = function (step) {
        this.observable.notify({
            eventName: 'diy-editor-onboardingGuide-close',
            step: step
        });
        if (this.onClose) {
            this.onClose();
        }
    };
    ;
    OnboardingGuide.prototype.updateResponsiveParams = function () {
        var targetWidth = this.$window.width();
        this.responsiveParams = Array.from(responsiveParamMap).find(function (_a) {
            var viewportWidth = _a[0];
            return (targetWidth < viewportWidth);
        })[1];
    };
    ;
    OnboardingGuide.prototype.update = function () {
        var _this = this;
        this.updateResponsiveParams();
        if (this.rootElement) {
            ReactDOM.render(React.createElement(Guide_1.Guide, { steps: this.steps, onClose: function (step) { return _this.close(step); }, observable: this.observable, initialStep: this.steps[this.currentStepPosition], showSidebar: this.showSidebar, tabletView: this.responsiveParams.tabletView }), this.rootElement);
        }
    };
    OnboardingGuide.prototype.selectStep = function (stepId) {
        for (var i = 0; i < this.steps.length; i++) {
            if (this.steps[i].id === stepId) {
                this.currentStepPosition = i;
                return;
            }
        }
    };
    ;
    OnboardingGuide.prototype.selectLastVisibleStep = function () {
        for (var i = this.steps.length; i >= 0; i--) {
            if (!this.steps[i].hidden) {
                this.currentStepPosition = i;
            }
        }
    };
    ;
    return OnboardingGuide;
}());
exports.default = OnboardingGuide;
;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
// react
var React = __webpack_require__(28);
// material
var MuiThemeProvider_1 = __webpack_require__(243);
var diyLightTheme = __webpack_require__(241);
// global
var l10n = __webpack_require__(18);
var Header_1 = __webpack_require__(822);
var Sidebar_1 = __webpack_require__(825);
var Content_1 = __webpack_require__(826);
var Errors_1 = __webpack_require__(835);
var Guide = (function (_super) {
    tslib_1.__extends(Guide, _super);
    function Guide(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onStepChange = function (step) {
            if (_this.state.selectedStep !== step) {
                _this.props.observable.notify({
                    eventName: 'diy-editor-onboardingGuide-stepChange',
                    step: step
                });
            }
            _this.setState({
                selectedStep: step,
            });
        };
        _this.state = {
            selectedStep: props.initialStep,
        };
        return _this;
    }
    ;
    Guide.prototype.render = function () {
        var _this = this;
        return (React.createElement(MuiThemeProvider_1.default, { muiTheme: diyLightTheme },
            React.createElement("div", { className: "onboarding container" },
                React.createElement("div", { className: "content-wrapper", ref: function (ref) { return _this.contentWrapper = ref; } },
                    React.createElement(Header_1.Header, { titleText: l10n.getString('onboardingGuide.title'), onCloseClick: function () {
                            _this.props.onClose(_this.state.selectedStep);
                        } }),
                    this.props.steps.length === 0 ?
                        React.createElement(Errors_1.Errors, { mode: Errors_1.Mode.Critical, text: l10n.getString('onboardingGuide.errors.all') }) :
                        React.createElement("div", { style: { display: "flex" } },
                            this.props.showSidebar ?
                                React.createElement(Sidebar_1.Sidebar, { steps: this.props.steps, liteVersion: this.props.tabletView, activeStep: this.state.selectedStep, onStepSelect: this.onStepChange })
                                : null,
                            React.createElement(Content_1.Content, { stepData: this.state.selectedStep, liteVersion: this.props.tabletView, observable: this.props.observable, onBeforeHelp: function () {
                                    _this.props.onClose(_this.state.selectedStep);
                                } }))))));
    };
    ;
    return Guide;
}(React.Component));
exports.Guide = Guide;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
// react
var React = __webpack_require__(28);
// material
var Toolbar_1 = __webpack_require__(448);
var ToolbarGroup_1 = __webpack_require__(823);
var ToolbarTitle_1 = __webpack_require__(449);
var help_outline_1 = __webpack_require__(450);
var clear_1 = __webpack_require__(496);
// global
var HeaderIcon_1 = __webpack_require__(824);
var IconTextButton_1 = __webpack_require__(459);
var FeedbackButton_1 = __webpack_require__(461);
var DiyFeedbackSubmit_1 = __webpack_require__(495);
var l10n = __webpack_require__(18);
var Header = (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header(props, context) {
        return _super.call(this, props, context) || this;
    }
    ;
    Header.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            React.createElement(Toolbar_1.default, { style: styles.toolbar },
                React.createElement(ToolbarGroup_1.default, { key: 0, style: styles.toolbarGroup },
                    React.createElement("div", { style: styles.logo },
                        React.createElement(HeaderIcon_1.default, { style: styles.logoImg })),
                    React.createElement(ToolbarTitle_1.default, { text: this.props.titleText, style: styles.title })),
                React.createElement(ToolbarGroup_1.default, { key: 1, style: styles.actionsToolbar },
                    React.createElement(FeedbackButton_1.default, { feedbackFeatureName: "", feedbackContext: "onboardingGuide", onFeedbackSubmit: DiyFeedbackSubmit_1.DiyFeedbackSubmit, useAlternativeColors: true, style: styles.iconFeedback }),
                    this.props.onHelpClick ?
                        React.createElement(IconTextButton_1.default, { style: styles.iconHelp, Icon: React.createElement(help_outline_1.default, null), useAlternativeColors: true, onTouchTap: this.props.onHelpClick, text: l10n.getString('help') })
                        :
                            null,
                    React.createElement(IconTextButton_1.default, { style: styles.iconClose, Icon: React.createElement(clear_1.default, null), useAlternativeColors: true, onTouchTap: this.props.onCloseClick, text: l10n.getString('close'), dataTestId: "onboardingGuide-close-button" }))),
            React.createElement("div", { style: styles.gradient })));
    };
    ;
    Header.prototype.getStyles = function () {
        return {
            root: {
                position: "relative"
            },
            toolbar: {
                paddingLeft: 0,
                backgroundColor: "rgba(255, 255, 255, 1)"
            },
            toolbarGroup: {
                height: "100%",
                float: "left"
            },
            logo: {
                float: 'left',
                padding: "11px 10px",
                marginLeft: "10px"
            },
            logoImg: {
                fill: "rgba(100, 110, 128, 1)",
                height: "34px",
                width: "34px"
            },
            title: {
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "uppercase",
                color: "rgba(38, 46, 56, 1)"
            },
            actionsToolbar: {
                marginRight: "-24px",
                float: "right"
            },
            iconHelp: {
                margin: 0,
                marginTop: "4px",
                height: "56px"
            },
            iconClose: {
                margin: 0,
                marginTop: "4px",
                height: "56px"
            },
            iconFeedback: {
                margin: 0,
                marginTop: "4px",
                height: "56px"
            },
            gradient: {
                zIndex: 1,
                left: 0,
                bottom: '-18px',
                position: 'absolute',
                pointerEvents: 'none',
                height: '18px',
                width: '100%',
                opacity: 1,
                transition: 'opacity .3s ease-in-out',
                background: 'linear-gradient(' +
                    'to bottom,' +
                    'rgba(0,0,0,0.08) 0%,' +
                    'rgba(0,0,0,0.02) 35%,' +
                    'rgba(0,0,0,0) 100%' +
                    ')',
                filter: 'progid:DXImageTransform.Microsoft.gradient(' +
                    "startColorstr='#14000000'," +
                    "endColorstr='#00000000'," +
                    "GradientType=0" +
                    ')'
            }
        };
    };
    ;
    return Header;
}(React.Component));
exports.Header = Header;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var firstChild = props.firstChild;
  var lastChild = props.lastChild;
  var _context$muiTheme = context.muiTheme;
  var baseTheme = _context$muiTheme.baseTheme;
  var button = _context$muiTheme.button;
  var toolbar = _context$muiTheme.toolbar;


  var marginHorizontal = baseTheme.spacing.desktopGutter;
  var marginVertical = (toolbar.height - button.height) / 2;

  var styles = {
    root: {
      position: 'relative',
      marginLeft: firstChild ? -marginHorizontal : undefined,
      marginRight: lastChild ? -marginHorizontal : undefined,
      display: 'flex',
      justifyContent: 'space-between'
    },
    dropDownMenu: {
      root: {
        color: toolbar.color, // removes hover color change, we want to keep it
        marginRight: baseTheme.spacing.desktopGutter,
        flex: 1,
        whiteSpace: 'nowrap'
      },
      controlBg: {
        backgroundColor: toolbar.menuHoverColor,
        borderRadius: 0
      },
      underline: {
        display: 'none'
      }
    },
    button: {
      margin: marginVertical + 'px ' + marginHorizontal + 'px',
      position: 'relative'
    },
    icon: {
      root: {
        cursor: 'pointer',
        lineHeight: toolbar.height + 'px',
        paddingLeft: baseTheme.spacing.desktopGutter
      }
    },
    span: {
      color: toolbar.iconColor,
      lineHeight: toolbar.height + 'px'
    }
  };

  return styles;
}

var ToolbarGroup = function (_Component) {
  _inherits(ToolbarGroup, _Component);

  function ToolbarGroup() {
    _classCallCheck(this, ToolbarGroup);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ToolbarGroup).apply(this, arguments));
  }

  _createClass(ToolbarGroup, [{
    key: 'handleMouseLeaveFontIcon',
    value: function handleMouseLeaveFontIcon(style) {
      return function (event) {
        event.target.style.zIndex = 'auto';
        event.target.style.color = style.root.color;
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;
      var firstChild = _props.firstChild;
      var lastChild = _props.lastChild;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        if (!currentChild) {
          return null;
        }
        if (!currentChild.type) {
          return currentChild;
        }
        switch (currentChild.type.muiName) {
          case 'DropDownMenu':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
              underlineStyle: styles.dropDownMenu.underline
            });
          case 'RaisedButton':
          case 'FlatButton':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
            });
          case 'FontIcon':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
            });
          case 'ToolbarSeparator':
          case 'ToolbarTitle':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
            });
          default:
            return currentChild;
        }
      }, this);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        newChildren
      );
    }
  }]);

  return ToolbarGroup;
}(_react.Component);

ToolbarGroup.propTypes = {
  /**
   * Can be any node or number of nodes.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
   * to prevent setting the left gap.
   */
  firstChild: _react.PropTypes.bool,
  /**
   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
   * to prevent setting the right gap.
   */
  lastChild: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
ToolbarGroup.defaultProps = {
  firstChild: false,
  lastChild: false
};
ToolbarGroup.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = ToolbarGroup;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var websiteData = __webpack_require__(4);
var HeaderIcon = (function (_super) {
    tslib_1.__extends(HeaderIcon, _super);
    function HeaderIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderIcon.prototype.render = function () {
        return (React.createElement("div", { style: this.getStyle() }));
    };
    HeaderIcon.prototype.getStyle = function () {
        return Object.assign({}, this.props.style || {}, {
            display: "block",
            backgroundImage: "url(" + websiteData.getCdnUrl() + "/s/diy/site-admin/main/img/bar-sprite.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-730px -236px"
        });
    };
    return HeaderIcon;
}(React.Component));
exports.default = HeaderIcon;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
// react
var React = __webpack_require__(28);
// material
var List_1 = __webpack_require__(428);
var ListItem_1 = __webpack_require__(409);
var check_circle_1 = __webpack_require__(486);
// global
var l10n = __webpack_require__(18);
var SIDEBAR_WIDTH_TABLET = 214;
var SIDEBAR_WIDTH_SCREEN = 224;
exports.computeSidebarWidth = function (liteVersion) {
    if (liteVersion === void 0) { liteVersion = false; }
    return liteVersion ? SIDEBAR_WIDTH_TABLET : SIDEBAR_WIDTH_SCREEN;
};
var Sidebar = (function (_super) {
    tslib_1.__extends(Sidebar, _super);
    function Sidebar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sidebar.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "sidebar", style: this.getRootStyle(this.props.liteVersion) },
            React.createElement(List_1.default, { style: this.getListStyle() }, this.props.steps.map(function (step) { return _this.renderStep(step); }))));
    };
    ;
    Sidebar.prototype.renderStep = function (step) {
        var _this = this;
        var stepLabel = l10n.getString('onboardingGuide.step.' + step.id + '.title');
        if (step.hidden) {
            return null;
        }
        return (React.createElement(ListItem_1.default, { "data-test-id": "menu-step-" + step.id, key: step.id, primaryText: stepLabel, style: this.getItemStyle(step), innerDivStyle: this.getItemInnerStyle(), leftIcon: step.completed ?
                React.createElement(check_circle_1.default, { color: "#019e28", style: this.getItemIconStyle() })
                : null, onClick: function () { return _this.onItemClick(step); } }));
    };
    ;
    Sidebar.prototype.onItemClick = function (step) {
        this.props.onStepSelect(step);
    };
    ;
    Sidebar.prototype.getItemIconStyle = function () {
        return {
            left: 0,
        };
    };
    ;
    Sidebar.prototype.getRootStyle = function (liteVersion) {
        return {
            width: exports.computeSidebarWidth(liteVersion) + "px",
            backgroundColor: "rgba(236, 235, 235, 1)",
            height: "534px",
            flex: "1 0 auto"
        };
    };
    ;
    Sidebar.prototype.getListStyle = function () {
        return {
            backgroundColor: 'transparent',
            paddingTop: 0,
            paddingBottom: 0,
            overflowX: "hidden",
            height: "inherit"
        };
    };
    ;
    Sidebar.prototype.getItemInnerStyle = function () {
        return {
            paddingLeft: "42px",
        };
    };
    ;
    Sidebar.prototype.getItemStyle = function (step) {
        var activeStyles = {
            color: "rgba(22, 25, 29, 1)",
            backgroundColor: "rgba(206, 208, 214, 1)"
        };
        var style = {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            color: "rgba(61, 73, 89, 1)"
        };
        if (step === this.props.activeStep) {
            Object.assign(style, activeStyles);
        }
        return style;
    };
    ;
    return Sidebar;
}(React.Component));
exports.Sidebar = Sidebar;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
// react
var React = __webpack_require__(28);
// global
var l10n = __webpack_require__(18);
// local
var Step_1 = __webpack_require__(827);
var Errors_1 = __webpack_require__(835);
var stepConfig_1 = __webpack_require__(836);
var CONTENT_WIDTH_TABLET = 590;
var CONTENT_WIDTH_SCREEN = 600;
exports.computeContentWidth = function (liteVersion) {
    return liteVersion ? CONTENT_WIDTH_TABLET : CONTENT_WIDTH_SCREEN;
};
var Content = (function (_super) {
    tslib_1.__extends(Content, _super);
    function Content() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Content.prototype.render = function () {
        return (React.createElement("div", { style: { width: "100%", height: "534px" } }, this.renderStep()));
    };
    Content.prototype.renderStep = function () {
        var config;
        try {
            config = stepConfig_1.getConfigForStep(this.props.stepData.id);
        }
        catch (e) {
            return (React.createElement(Errors_1.Errors, { mode: Errors_1.Mode.Warning, text: l10n.getString('onboardingGuide.errors.single') }));
        }
        return (React.createElement(Step_1.Step, { stepData: this.props.stepData, observable: this.props.observable, onBeforeHelp: this.props.onBeforeHelp, stepConfig: config }));
    };
    ;
    return Content;
}(React.Component));
exports.Content = Content;


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
// react
var React = __webpack_require__(28);
// global
var l10n = __webpack_require__(18);
var Social_1 = __webpack_require__(828);
var websiteData = __webpack_require__(4);
var StepImage_1 = __webpack_require__(829);
var StepVimeo_1 = __webpack_require__(830);
var StepText_1 = __webpack_require__(833);
var StepActions_1 = __webpack_require__(834);
var DEFAULT_HELP_ID = 'guidedSetup';
var Step = (function (_super) {
    tslib_1.__extends(Step, _super);
    function Step(props, context) {
        return _super.call(this, props, context) || this;
    }
    ;
    Step.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var _a = this.props.stepConfig, helpId = _a.helpId, imageId = _a.imageId, showSocialButtons = _a.showSocialButtons;
        return (React.createElement("div", { style: styles.root },
            React.createElement("div", { className: "panel-container", style: styles.mainPanel },
                this.hasVimeo() ?
                    React.createElement(StepVimeo_1.StepVimeo, { videoId: this.getVimeoUrlId(), frameId: this.props.stepData.id + '_video' })
                    : null,
                this.hasImage() ?
                    React.createElement(StepImage_1.StepImage, { imageUrl: cc_.cdnServer
                            + "s/diy/onboarding-guide/guide-images/step-visuals/"
                            + imageId + '.jpg' })
                    : null,
                React.createElement("div", { className: "text-container", style: styles.textContainer },
                    React.createElement(StepText_1.StepText, { title: l10n.getString('onboardingGuide.step.' + this.props.stepData.id + '.title'), description: l10n.getString('onboardingGuide.step.' + this.props.stepData.id + '.description'), showHelpIcon: helpId ? true : false, onHelp: helpId ? function () { return _this.helpClick(); } : null }),
                    this.props.stepData.doable ? null :
                        React.createElement("div", { style: styles.notDoable, className: "not-doable-reason" }, this.renderDoableMessage())),
                showSocialButtons ?
                    React.createElement("div", { style: styles.socialWrapper },
                        React.createElement(Social_1.default, { trackingPageName: "onboarding_guide", showShareMessage: false }))
                    : null),
            React.createElement(StepActions_1.StepActions, { onAction: function () { return _this.onAction(); }, label: l10n.getString('onboardingGuide.step.' + this.props.stepData.id + '.callToAction'), disabled: !this.props.stepData.doable })));
    };
    ;
    Step.prototype.onAction = function () {
        this.props.observable.notify({
            eventName: 'diy-editor-onboardingGuide-callToActionClick',
            step: this.props.stepData
        });
        this.props.stepConfig.onAction();
    };
    ;
    Step.prototype.hasVimeo = function () {
        var vimeoUrlIds = this.props.stepConfig.vimeoUrlIds;
        var lng = websiteData.getLanguage();
        return (vimeoUrlIds
            && vimeoUrlIds.hasOwnProperty(lng)
            && vimeoUrlIds[lng] !== null);
    };
    Step.prototype.getVimeoUrlId = function () {
        if (this.hasVimeo()) {
            return this.props.stepConfig.vimeoUrlIds[websiteData.getLanguage()];
        }
        else {
            throw new Error('Vimeo Url requested but not available');
        }
    };
    Step.prototype.hasImage = function () {
        return (this.props.stepConfig.imageId !== null);
    };
    Step.prototype.renderDoableMessage = function () {
        if (this.props.stepConfig.renderDoableMessage) {
            return this.props.stepConfig.renderDoableMessage();
        }
        return (React.createElement("div", null, l10n.getString('onboardingGuide.errors.stepNotDoable')));
    };
    Step.prototype.helpClick = function () {
        if (this.props.onBeforeHelp) {
            this.props.onBeforeHelp();
        }
        cms.help.GuidedAssistant.getInstance()
            ._openHelpTopic(this.props.stepConfig.helpId || DEFAULT_HELP_ID);
    };
    Step.prototype.getStyles = function () {
        return {
            notDoable: {
                marginTop: "8px",
                marginBottom: "8px"
            },
            root: {
                height: "534px",
                fontFamily: '"Open Sans", sans-serif'
            },
            mainPanel: {
                position: "relative",
                width: "100%",
                height: "482px",
                overflowY: "auto"
            },
            socialWrapper: {
                margin: "12px 0 0 0",
            },
            textContainer: {
                padding: "10px 32px 0 32px"
            },
        };
    };
    ;
    return Step;
}(React.Component));
exports.Step = Step;


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var $ = __webpack_require__(3);
var social = __webpack_require__(734);
var getFacebookAppId = __webpack_require__(731);
var websiteData = __webpack_require__(4);
var Social = (function (_super) {
    tslib_1.__extends(Social, _super);
    function Social(props) {
        return _super.call(this, props) || this;
    }
    ;
    Social.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            this.props.showShareMessage ?
                React.createElement("p", { style: styles.text }, l10n_1.default('maintenance.dialog.share'))
                : null,
            React.createElement("div", { className: "diye diy-share-group", ref: function (ref) { return _this.socialMediaPlaceholder = ref; } })));
    };
    ;
    Social.prototype.componentDidMount = function () {
        social.render(this.socialMediaPlaceholder, this.shareButtons(l10n_1.default('guidedSetup.shareCompletedText'), social.config));
    };
    ;
    Social.prototype.getShareUrl = function () {
        var webUrl = websiteData.getWebUrl();
        var delimiter = '?';
        if (webUrl.indexOf('?') !== -1) {
            delimiter = '&';
        }
        return webUrl + delimiter + (new Date().getTime()).toString();
    };
    Social.prototype.trackEvent = function (actionName) {
        var data = {
            actionName: actionName,
            pageName: this.props.trackingPageName
        };
        $(document).trigger('diy-editor-generic-linkInteraction', data);
    };
    ;
    Social.prototype.shareButtons = function (shareText, options) {
        var _this = this;
        var fbAppId = getFacebookAppId();
        return [
            {
                type: 'facebookShare',
                options: {
                    appId: fbAppId,
                    url: this.getShareUrl(),
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-fb.png',
                    onClick: function () { return _this.trackEvent('social_facebook'); },
                    onSubmit: function () { return _this.trackEvent('social_facebook_success'); },
                    onSubmitCanceled: function () { return _this.trackEvent('social_facebook_cancel'); },
                    actions: options.facebook.actions
                }
            },
            {
                type: 'twitterShare',
                options: {
                    url: ' ',
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-twitter.png',
                    message: {
                        text: shareText
                    },
                    onClick: function () { return _this.trackEvent('social_twitter'); },
                    onSubmit: function () { return _this.trackEvent('social_twitter_success'); }
                }
            },
            {
                type: 'linkedInShare',
                options: {
                    url: this.getShareUrl(),
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-linkedin.png',
                    onClick: function () { return _this.trackEvent('social_linkedin'); }
                }
            },
            {
                type: 'xingShare',
                options: {
                    url: this.getShareUrl(),
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-xing.png',
                    onClick: function () { return _this.trackEvent('social_xing'); }
                }
            }
        ];
    };
    Social.prototype.getStyles = function () {
        return {
            root: {
                padding: "0 20px"
            },
            text: {
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "center",
                marginBottom: 0,
                paddingTop: "13px",
                paddingBottom: "13px"
            }
        };
    };
    ;
    return Social;
}(React.Component));
exports.default = Social;


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var StepImage = (function (_super) {
    tslib_1.__extends(StepImage, _super);
    function StepImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepImage.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { className: "image-container" },
            React.createElement("img", { src: this.props.imageUrl, style: styles.stepImage })));
    };
    StepImage.prototype.getStyles = function () {
        return {
            stepImage: {
                width: "100%"
            },
        };
    };
    return StepImage;
}(React.Component));
exports.StepImage = StepImage;


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var RaisedButton_1 = __webpack_require__(482);
var play_circle_outline_1 = __webpack_require__(831);
var l10n = __webpack_require__(18);
var Animation_1 = __webpack_require__(444);
var Vimeo_1 = __webpack_require__(832);
var StepVimeo = (function (_super) {
    tslib_1.__extends(StepVimeo, _super);
    function StepVimeo(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.playVideo = function () {
            _this.setState({ isPlaying: true });
        };
        _this.finishCallback = function () {
            _this.setState({ isPlaying: false });
        };
        _this.state = {
            isPlaying: false
        };
        return _this;
    }
    ;
    StepVimeo.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root, className: "step-vimeo" },
            React.createElement("div", { style: styles.playButtonWrapper, className: "step-vimeo-control" },
                React.createElement(RaisedButton_1.default, { onClick: this.playVideo, label: l10n.getString('onboardingGuide.step.playVideo'), icon: React.createElement(play_circle_outline_1.default, null) })),
            this.state.isPlaying ?
                React.createElement(Animation_1.OpacityAnimation, { duration: 2.5, fadeIn: true, fadeOut: true },
                    React.createElement("div", { style: styles.videoWrapper, className: "step-vimeo-container" },
                        React.createElement(Vimeo_1.Vimeo, { videoId: this.props.videoId, frameId: this.props.frameId, autoplay: this.state.isPlaying, onFinish: this.finishCallback }))) : null));
    };
    StepVimeo.prototype.componentWillUpdate = function (nextProps) {
        if (this.state.isPlaying === true && this.props.videoId !== nextProps.videoId) {
            this.setState({ isPlaying: false });
        }
    };
    StepVimeo.prototype.getStyles = function () {
        return {
            root: {
                position: "absolute"
            },
            playButtonWrapper: {
                margin: "8px 0 0 8px"
            },
            videoWrapper: {
                position: "absolute",
                top: "0",
                left: "0"
            }
        };
    };
    return StepVimeo;
}(React.Component));
exports.StepVimeo = StepVimeo;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlayCircleOutline = function AvPlayCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
AvPlayCircleOutline = (0, _pure2.default)(AvPlayCircleOutline);
AvPlayCircleOutline.displayName = 'AvPlayCircleOutline';
AvPlayCircleOutline.muiName = 'SvgIcon';

exports.default = AvPlayCircleOutline;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Vimeo = (function (_super) {
    tslib_1.__extends(Vimeo, _super);
    function Vimeo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Vimeo.prototype.render = function () {
        return (React.createElement("div", { className: "video-vimeo-container" },
            React.createElement("iframe", { id: this.props.frameId, src: this.getVimeoUrl(), width: "600", height: "340", frameBorder: "0", allowFullScreen: true })));
    };
    Vimeo.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.onFinish) {
            var vimeoIFrame = document.getElementById(this.props.frameId);
            var vimeoPlayer_1 = $f(vimeoIFrame);
            vimeoPlayer_1.addEvent('ready', function () {
                vimeoPlayer_1.addEvent('finish', _this.props.onFinish);
            });
        }
    };
    Vimeo.prototype.getVimeoUrl = function () {
        return "https://player.vimeo.com/video/" + this.props.videoId + (this.props.autoplay ? '?autoplay=1&dnt=1' : '?dnt=1');
    };
    return Vimeo;
}(React.Component));
exports.Vimeo = Vimeo;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
// react
var React = __webpack_require__(28);
// material
var help_outline_1 = __webpack_require__(450);
var IconButton_1 = __webpack_require__(420);
// global
var l10n = __webpack_require__(18);
var StepText = (function (_super) {
    tslib_1.__extends(StepText, _super);
    function StepText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepText.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", null,
            this.props.showHelpIcon ?
                React.createElement(IconButton_1.default, { style: styles.helpButton, iconStyle: styles.helpIcon, onTouchTap: this.props.onHelp, tooltip: l10n.getString('onboardingGuide.actions.help.tooltip'), tooltipPosition: "top-left" },
                    React.createElement(help_outline_1.default, null))
                :
                    null,
            React.createElement("div", { className: "title", style: styles.title }, this.props.title),
            React.createElement("div", { className: "description", style: styles.description }, this.props.description)));
    };
    StepText.prototype.getStyles = function () {
        return {
            helpButton: {
                margin: "-4px 0 0 0",
                padding: 0,
                height: "24px",
                width: "24px",
                float: "right",
            },
            helpIcon: {
                color: 'rgba(0, 0, 0, 0.54)',
            },
            title: {
                fontWeight: 600,
                color: "#262e38",
                marginBottom: "11px"
            },
            description: {
                fontSize: "15px",
                fontWeight: "normal",
                lineHeight: "20px",
                color: "#262e38"
            },
        };
    };
    return StepText;
}(React.Component));
exports.StepText = StepText;


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var RaisedButton_1 = __webpack_require__(482);
var StepActions = (function (_super) {
    tslib_1.__extends(StepActions, _super);
    function StepActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepActions.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.callToActionPanel },
            React.createElement(RaisedButton_1.default, { label: this.props.label, onTouchTap: this.props.onAction, disabled: this.props.disabled, primary: true })));
    };
    StepActions.prototype.getStyles = function () {
        return {
            callToActionPanel: {
                height: "52px",
                textAlign: "right",
                padding: "8px 8px 8px 0",
                borderTop: "1px",
                borderTopColor: "#d9d9d9",
                borderTopStyle: "solid"
            },
        };
    };
    return StepActions;
}(React.Component));
exports.StepActions = StepActions;


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var styles_1 = __webpack_require__(242);
var warning_1 = __webpack_require__(544);
var diyLightRawTheme_1 = __webpack_require__(375);
var InfoBox_1 = __webpack_require__(815);
var Mode;
(function (Mode) {
    Mode[Mode["None"] = 0] = "None";
    Mode[Mode["Warning"] = 1] = "Warning";
    Mode[Mode["Critical"] = 2] = "Critical";
})(Mode = exports.Mode || (exports.Mode = {}));
var Errors = (function (_super) {
    tslib_1.__extends(Errors, _super);
    function Errors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Errors.prototype.render = function () {
        var errorMsg = this.props.text;
        var warnColor = this.props.mode === Mode.Warning ?
            diyLightRawTheme_1.default.palette.textColor :
            "#fff";
        return (this.props.mode === Mode.None ? null :
            React.createElement(InfoBox_1.InfoBox, { Icon: warning_1.default, iconColor: warnColor, paperCssClass: this.getCssClass(), paperStyles: this.getStyles() },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: errorMsg } })));
    };
    Errors.prototype.getStyles = function () {
        var topboxAll = {
            backgroundColor: '#F7482D',
            color: '#FFF'
        };
        var topboxSingle = {
            backgroundColor: styles_1.colors.orange50,
            opacity: 0.54
        };
        return (this.props.mode === Mode.Critical ? topboxAll : topboxSingle);
    };
    Errors.prototype.getCssClass = function () {
        return this.props.mode === Mode.Critical ? 'error-critical' : 'error-warning';
    };
    return Errors;
}(React.Component));
exports.Errors = Errors;


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var $ = __webpack_require__(3);
var l10nReactMacros = __webpack_require__(837);
var globalEvents = __webpack_require__(500);
var bsaEvents = __webpack_require__(838);
var stepConfig = {
    'apps': {
        helpId: 'app_catalog_main',
        imageId: 'apps',
        onAction: function () {
            diy.editor.siteadmin.api.close();
            $('#cc-sa-item-appscatalog').trigger('click');
        },
    },
    'businessIdentity': {
        helpId: 'semanticdata_mydata',
        imageId: 'businessIdentity',
        onAction: function () {
            var openParams = [
                { label: 'siteadmin', params: 'settings' },
                { label: 'SAC.Settings', params: 'personal-data' }
            ];
            diy.editor.deeplinking.requestPath(openParams);
        },
    },
    'elements': {
        helpId: 'moduleSelector',
        imageId: 'elements',
        vimeoUrlIds: {
            'de': '185603145'
        },
        onAction: function () {
            $('#cc-sa-item-elements').trigger('click');
        }
    },
    'emailAddress': {
        helpId: 'create_mailbox',
        imageId: 'emailAddress',
        onAction: function () {
            diy.editor.siteadmin.api.close();
            diy.util.redirector.redirectToLabel('choose_an_email_redirect_from_guidedSetup');
        },
        renderDoableMessage: function () {
            var macros = new Map();
            macros.set("link", function (macro, index, inner) {
                return (React.createElement("a", { key: "emailAddress", onClick: function () { return diy.util.redirector.redirectToLabel('domain_connect_redirect-guidedsetup'); }, href: "#" }, inner));
            });
            return (React.createElement("div", null, l10nReactMacros.processStringMacros('onboardingGuide.step.emailAddress.notDoable', macros)));
        },
    },
    'imagePool': {
        helpId: 'settings_images_cip',
        imageId: 'imagePool',
        vimeoUrlIds: {
            'de': '185601777'
        },
        onAction: function () {
            diy.editor.siteadmin.api.close();
            diy.editor.filemanager = new diy.editor.Filemanager({
                appName: 'filemanager',
                mode: 'management',
                sources: { "storage": true, "cms": true, "bigstock": true, "123rf": true },
                maxSelection: 1,
                alreadyExisting: 0,
                callback: function (report) {
                    //XXX: this comment to avoid empty block warning
                }
            });
        },
    },
    'learnTheInterface': {
        helpId: 'guidedSetup',
        imageId: 'learnTheInterface',
        onAction: function () {
            diy.editor.guidance.start();
        },
    },
    'navigation': {
        helpId: 'navigation',
        imageId: 'navigation',
        onAction: function () {
            diy.editor.siteadmin.api.close();
            diy.editor.navigation.api.openEditor();
        },
    },
    'publish': {
        helpId: 'first_publish',
        imageId: 'publish',
        onAction: function () {
            diy.editor.siteadmin.api.close();
            globalEvents.trigger('diy-maintenance-mode-show');
        },
    },
    'sections': {
        helpId: 'sections',
        imageId: 'sections',
        onAction: function () {
            $('#cc-sa-item-sections').trigger('click');
        },
    },
    'seoGetFound': {
        helpId: 'seo-use-guide',
        imageId: 'seoGetFound',
        onAction: function () {
            diy.editor.siteadmin.api.close();
            $('#cc-sa-item-get-found').trigger('click');
        },
    },
    'social': {
        imageId: 'social',
        showSocialButtons: true,
        onAction: function () {
            diy.editor.siteadmin.api.close();
            bsaEvents.trigger('SocialShareDone.BSA');
        },
    },
    'style': {
        helpId: 'style_overview',
        imageId: 'style',
        vimeoUrlIds: {
            'de': '185603155'
        },
        onAction: function () {
            $('#cc-sa-item-style').trigger('click');
        },
    },
    'vcard': {
        helpId: 'sa-staging',
        imageId: 'vcard',
        onAction: function () {
            diy.editor.siteadmin.api.close();
            globalEvents.trigger('diy-maintenance-mode-edit');
        },
    },
};
function getConfigForStep(id) {
    if (stepConfig[id]) {
        return stepConfig[id];
    }
    throw new Error("Invalid step identifier '" + id + "'.");
}
exports.getConfigForStep = getConfigForStep;


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

/**
 * This tool will replace macros found inside a translation string, of the format
 * '{macro}' (standalone) or '{macro}text or other macros{/macro}', with either
 * strings or JSX elements. Macros that have no mapped handler are left as-is.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var l10n = __webpack_require__(18);
function processStringMacros(msgId, macros) {
    return processMacros(l10n.getString(msgId).split(/(\{[^}]+\})/), macros);
}
exports.processStringMacros = processStringMacros;
function processMacros(pieces, macros) {
    var regOpenMacro = new RegExp("^{([a-zA-Z0-9-]+)}$");
    var regClosingMacro = new RegExp("^{/([a-zA-Z0-9-]+)}$");
    var output = pieces.slice();
    for (var i = 0; i < output.length; i++) {
        // if piece is a starting macro
        if (regOpenMacro.test(output[i])) {
            var macroName = output[i].match(regOpenMacro)[1];
            // if there's no handler defined for this macro, we just skip it
            if (!macros.has(macroName)) {
                continue;
            }
            // see if there's a matching closing macro, starting from the end
            var endMacroPos = output.indexOf('{/' + macroName + '}');
            // if no matching closing macro, consider this macro stand-alone
            if (-1 === endMacroPos || endMacroPos <= i) {
                output[i] = macros.get(macroName)(macroName, i, null);
            }
            else {
                // process everything in between the opening and closing macros
                var processedSlice = processMacros(output.slice(i + 1, endMacroPos), macros);
                // then pass the processed slice through the handler function
                var replacement = macros.get(macroName)(macroName, i, processedSlice);
                // we replace the slice between the opening and closing macro
                // with the processed slice
                output.splice(i, endMacroPos - i + 1, replacement);
            }
        }
        else if (!regClosingMacro.test(output[i])) {
            // so this means that whatever is left is a regular string;
            // we decode HTML entities because React will escape them again
            output[i] = diy.editor.htmlDecode(output[i]);
        }
    }
    return output;
}


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This module is a central location from which BSA events should be emitted.
 * It usually reacts to events emitted by other components.
 */
var $ = __webpack_require__(3);
//FIXME: this should be organized better, as a class with invididual methods, or multiple functions
exports.attachEvents = function () {
    // file manager events
    $(document).bind('diy-editor-filemanager-opened', function () {
        $(document.body).trigger('ImagePoolOpened.BSA');
    });
    $(document).bind('diy-editor-filemanager-uploadedFiles', function () {
        $(document.body).trigger('ImagePoolUsed.BSA');
    });
    $(document).bind('diy-editor-filemanager-createdFolder', function () {
        $(document.body).trigger('ImagePoolUsed.BSA');
    });
    $(document).bind('diy-editor-filemanager-newSearch', function () {
        $(document.body).trigger('ImagePoolUsed.BSA');
    });
};
exports.trigger = function (eventName, payload) {
    $(document.body).trigger(eventName, payload);
};


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var globalEvents = __webpack_require__(500);
var $ = __webpack_require__(3);
var Observable = (function () {
    function Observable() {
        this.observers = new Set();
    }
    Observable.prototype.registerObserver = function (o) {
        this.observers.add(o);
    };
    Observable.prototype.unregisterObserver = function (o) {
        this.observers.delete(o);
    };
    Observable.prototype.notify = function (data) {
        var promises = [];
        this.observers.forEach(function (obs) {
            promises.push(obs.notify(data));
        });
        return promises;
    };
    return Observable;
}());
exports.Observable = Observable;
// well, i know this shouldn't be here
var TrackerKPI = (function () {
    function TrackerKPI() {
    }
    TrackerKPI.prototype.notify = function (data) {
        return new Promise(function (res) {
            if (data.eventName) {
                globalEvents.trigger(data.eventName, data);
                res(true);
            }
            res(false);
        });
    };
    return TrackerKPI;
}());
exports.TrackerKPI = TrackerKPI;
// this shouldn't be here either ... but where else ?
var TrackerExperimentActivityLog = (function () {
    function TrackerExperimentActivityLog() {
    }
    TrackerExperimentActivityLog.prototype.notify = function (data) {
        return new Promise(function (res) {
            if (data.activity) {
                $.ajax({
                    url: cc_.properties.cmsUrl + 'app/cms/tracking/track-experiment-activity',
                    type: 'get',
                    data: {
                        activity: data.activity
                    },
                    success: function () {
                        res(true);
                    },
                    error: function () {
                        res(false);
                    }
                });
            }
            else {
                res(false);
            }
        });
    };
    return TrackerExperimentActivityLog;
}());
exports.TrackerExperimentActivityLog = TrackerExperimentActivityLog;


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

var l10n_1 = __webpack_require__(18);
// import features = require('diy/util/features');
var $ = __webpack_require__(3);
// let api = require<any>('../api');
// import globalEvents = require('diy/util/globalEvents');
var Controller = (function () {
    function Controller() {
        this.controllerLoaded = false;
        this.eofNotice = $("\n<div class=\"sbh-eof-notice\">\n    <span class=\"sbh-eof-notice-icon\">&#160;</span>\n    <span class=\"sbh-eof-notice-text\">" + l10n_1.default('sbh.eofNotice') + "</span>\n</div>");
    }
    Controller.prototype.afterFillContent = function (el, response, contentElement) {
        //do nothing
    };
    ;
    Controller.prototype.allowSwitch = function () {
        return this.controllerLoaded;
    };
    ;
    Controller.prototype.show = function () {
        $('div.cc-sa-controller-fbpb main').prepend(this.eofNotice);
        if ($('div.cc-sa-controller-fbpb main .sbh-eof-notice').length === 1) {
            $('div.cc-sa-controller-fbpb main iframe')[0].style.height =
                ($('div.cc-sa-controller-fbpb main iframe')[0].clientHeight -
                    $('div.cc-sa-controller-fbpb main .sbh-eof-notice')[0].clientHeight) + 'px';
        }
    };
    ;
    Controller.prototype.hide = function () {
        //do nothing
    };
    ;
    Controller.prototype.getWindowSize = function () {
        return {
            width: 817,
            height: 585,
        };
    };
    return Controller;
}());
var controllerInstance = new Controller();
module.exports = controllerInstance;


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Class for handling app extension point
 *
 * @class AppExtensionPoint
 * @depends jquery.js, controller.js
 * @author znsakala
 */
var $ = __webpack_require__(3);
var siteadmin = __webpack_require__(20);
var api = __webpack_require__(19);

(function() {
    'use strict';
    var self = this;

    var siteAdminItemClass   = '.ui-siteadmin-webcomponent',
        upSellBehaviourClass = 'ui-behaviour-upsell';

    this.controllerLoaded  = false;
    this.webcomponentInstanceId = null;

    this.afterFillContent = function(el, payload, contentElement) {

        var title       = this.getSiteAdminItem().attr('data-window-title'),
            helpTopic   = this.getSiteAdminItem().attr('data-webcomponent-id');

        api.updateTitle(title);
        api.updateDescr('');
        api.updateButtons({});
        api.updateNavi({});
        api.updateHelpTopic(helpTopic);

        if (payload.success) {
            self.registerWebcomponent(payload.data);
        }

        this.controllerLoaded = true;
    };

    this.getSiteAdminItem = function() {
        return siteadmin.getSidebarContainer().find(siteAdminItemClass);
    };

    this.hasUpsellBehaviour = function() {
        if (this.getSiteAdminItem().hasClass(upSellBehaviourClass)) {
            return true;
        }

        return false;
    };

    this.hide = function()  {
        self.unregisterWebcomponent();
    };

    this.registerWebcomponent = function(data) {
        self.webcomponentInstanceId = data.webcomponentInstanceId;

        diy.editor.app.webcomponentService.registerWebcomponentInstance(
            self.webcomponentInstanceId,
            data.webcomponentData,
            data.proxyUrlPrefix
        );
    };

    this.unregisterWebcomponent = function() {
        diy.editor.app.webcomponentService.unregisterWebcomponentInstance(self.webcomponentInstanceId);
        self.webcomponentInstanceId = null;
    };

    this.show = function () {
        if (this.hasUpsellBehaviour()) {
            siteadmin.destroyController(this.getSiteAdminItem().attr('id'));

            var webComponentId = this.getSiteAdminItem().attr('data-webcomponent-id');
            diy.editor.tariffUpdate.openPopup({
                component: 'webComponentUpSell',
                webComponentId: webComponentId
            });
        }
    };

    return this;

}).call(exports);


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Toolbar = __webpack_require__(843);
var Preview = __webpack_require__(844);
var Administration = __webpack_require__(845);
var MaintenanceMode = __webpack_require__(846);
var Search = __webpack_require__(847);
var SearchKpi = __webpack_require__(854);
var Help = __webpack_require__(855);
var HelpLinks = __webpack_require__(853);
var features = __webpack_require__(25);
var App = (function () {
    function App(vCardEditor) {
        this.vCardEditor = vCardEditor;
    }
    App.prototype.getToolbar = function () {
        return this.toolbar;
    };
    App.prototype.getVCardEditor = function () {
        return this.vCardEditor;
    };
    App.prototype.init = function () {
        this.toolbar = new Toolbar();
        // TODO: separate rendering from construction
        var administration = new Administration(this.toolbar);
        var preview = new Preview(this.toolbar);
        this.maintenanceMode = new MaintenanceMode(this.vCardEditor, this.toolbar);
        var search = new Search(this.toolbar);
        Object.assign(this.toolbar, {
            Administration: administration,
            Preview: preview,
            MaintenanceMode: this.maintenanceMode,
            search: search,
            HelpLinks: HelpLinks
        });
        if (features('toolbarHelp')) {
            this.toolbar.help = new Help(this.toolbar);
        }
        //Init search tracking
        var searchKpi = new SearchKpi();
        searchKpi.init();
        //Init search angular app
        var searchModule = __webpack_require__(856);
        searchModule.init(this.toolbar.search);
    };
    App.prototype.showPublishDialog = function () {
        this.maintenanceMode.show();
    };
    return App;
}());
exports.App = App;


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar class - showed horizontally on top of the whole editing mode of the Sitebuilder
 *
 * @depends jquery.js
 * @depends extendClass.js
 * events: hide / show
 * plugins : mobile preview, undo redo, logout ...
 *
 */
/*global Klazz, diy, jQuery */
var $ = __webpack_require__(3);
var Modernizr = __webpack_require__(21);
var PageUtil = __webpack_require__(492);

var Toolbar, positionToolbar;

var previousPosition;

var TOOLBAR_HEIGHT = 38; // it's a known visual height, cannot be calculated because it contains the shaddow

positionToolbar = function () {
    $('#diyToolbar').css({
        position: 'fixed',
        left: '0',
        right: '0',
        top: '0'
    });

    $('#diyToolbar').trigger('diy-editor-toolbar-repositioned');
};

var scrollRefreshHandler = function() {
    var windowScroll = $(window).scrollTop(),
        isTouchEnabled = diy.context.type === 'editor' ?
            diy.editor.uiPreference.isPointerModeTouch() : Modernizr.touch;

    if (isTouchEnabled) {
        if(windowScroll < 0 || windowScroll >= document.documentElement.scrollHeight - window.innerHeight) {
            return;
        }
    }

    positionToolbar();
};

Toolbar = Klazz.extend({
    activated: false,
    options: {},

    isActive: function () {
        return this.activated === true;
    },

    initialize: function(options) {
        if (typeof options !== 'undefined' && options.length) {
            this.options = $.extend(true, {}, this.options, options); // note: we break object reference
        }

        // position the toolbar on the first load //
        this.draw();

        positionToolbar();
        this.activated = true;
    },

    draw: function() {
        var toolbarElement;

        toolbarElement = $(
            '<div class="diye"><div id="diyToolbar" class="diyEditorTopSpacer diyEditorTopFixedSpacer">' +
                '<div class="panels" >' +
                    '<div class="panel leftPanel"></div>' +
                    '<div class="panel rightPanel"></div>' +
                    '<div class="panel centerPanel"></div>' +
                '</div>' +
            '</div></div>'
        );
        $('body').prepend(toolbarElement);

        this.element = $('#diyToolbar');
        this.addContextClass();
        PageUtil.makeTopSpace(TOOLBAR_HEIGHT);

        // remove any leftover controls from the footer //
        $('#contentfooter .loggedin').remove();
    },

    addContextClass: function () {
        var className = '';

        switch (diy.context.type) {
            case 'web':
                className = 'diy-toolbar-web';
                break;
            case 'editor':
                className = 'diy-toolbar-editor';
                break;
            case 'mobilepreview':
                className = 'diy-toolbar-mobilePreview';
                break;
            default:
                throw new Error('Invalid context type');
        }

        this.element.addClass(className);
    },

    pushToPanel: function(panel, content, prepend) {
        var panelEl;

        if (!this.isActive()) {
            return false;
        }

        panelEl = $('#diyToolbar .' + panel + 'Panel');

        if (!prepend) {
            return $(content).appendTo(panelEl);
        } else {
            return $(content).prependTo(panelEl);
        }
    },

    getPanel: function(panel)
    {
        if (!this.isActive()) {
            return false;
        }
        return $('#diyToolbar .' + panel + 'Panel');
    },

    getElement: function() {
        return this.element;
    }

});

module.exports = Toolbar;


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar - Preview pane of the toolbar
 *  Contains the web/mobile preview functions.
 *
 * @depends jquery.js
 * @depends extendClass.js
 *
 */
/*global Klazz, diy, jimdoData, jQuery, systemurl, script_basisID, stagingMode */
var $ = __webpack_require__(3);

var Preview, initEditView, initWebView, initMobilePreview,
    initEditViewInMobilePreview, initWebViewInMobilePreview;

initEditView = function (targetElement) {
    var pageId;

    // try to get the page id from several places - this is needed until all page caches expire //
    pageId = $('body').attr('data-pageid');
    if (!pageId) {
        pageId = jimdoData.pageId;
    }
    if (pageId) {
        targetElement.attr('href', systemurl + 'app/' + script_basisID + '/' + pageId + '/');
    } else {
        targetElement.attr('href', systemurl + 'app/' + script_basisID + '/');
    }
};
initWebView = function (targetElement) {
    targetElement.attr('href', systemurl + 'app/default/index/gotoviewmode/websiteId/' +
        script_basisID + '/pageId/' + $('body').attr('data-pageid'));
};
initMobilePreview = function(targetElement) {
    targetElement.attr('href', systemurl + 'app/default/index/gotomobileview/websiteId/' +
        script_basisID + '/pageId/' + $('body').attr('data-pageid')
    );
};
initEditViewInMobilePreview = function (targetElement) {
    targetElement.attr('href', window.backLinkUrl);
};
initWebViewInMobilePreview = function(targetElement) {
    targetElement.attr('href', window.previewPageUrl);
};

Preview = Klazz.extend({
    contextType: '', /* possible values: editor, web */
    toolbar: null,
    options: {
        classSelected : 'selected'
    },
    messages: {
        viewLabel : '',
        backToEditingLabel: '',
        tooltipWebView: '',
        tooltipMobileView: ''
    },
    element: null,
    setup: function(){
        this.contextType = diy.context.type;
        this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar); // note: we break object reference
        this.options = $.extend(true, {}, this.options); // note: we break object reference
        this.messages.backToEditingLabel = jimdoData.messages.back;
    },
    initialize: function(toolbar) {
        this.toolbar = toolbar;
        this.setup();
        this.draw();
    },
    draw: function(){
        var elementHtml,
            self = this,
            isTouchDevice = Modernizr.touch;

        // build buttons HTML //
        elementHtml = '<div id="previewContainer" >';

        elementHtml += '<a class="label viewLabel" style="display: none;">' + this.messages.viewLabel + '</a> ';
        elementHtml += '<a class="label backLabel" style="display: none;">' + this.messages.backToEditingLabel + '</a> ';

        elementHtml += '<a class="webView ' + (this.contextType === 'web' ? this.options.classSelected : '') + '"><div class="icon" title="'+ this.messages.tooltipWebView +'"></div></a> ';

        /* if mobile preview is enabled, add the button to the toolbar */
        elementHtml += '<div class="mobile-preview-button-container">';
            elementHtml += '<div class="mobile-preview-button-container">' +
                '<a class="mobileView"><div class="icon" title="'+ this.messages.tooltipMobileView +'"></div></a> ';
        elementHtml += '</div></div>';

        if (this.contextType === 'editor') {
            elementHtml += '<div class="spacer"><div class="icon"></div></div>';
        }

        elementHtml += '</div>';

        this.element = this.toolbar.pushToPanel('left', elementHtml);

        if (!isTouchDevice) {
            if (this.contextType === 'editor') {
                this.element.find('.viewLabel').show();
            } else if (this.contextType === 'web') {
                this.element.find('.backLabel').show();
            }
        }

        if (this.contextType === 'editor') {
            this.showMobilePreviewStartButton();
        }

        if (this.contextType === 'editor') {
            initWebView(this.element.find('.webView'));
            initMobilePreview(this.element.find('.mobileView'));
        } else if (this.contextType === 'web') {
            initEditView(this.element.find('.webView'));
            initEditView(this.element.find('.backLabel'));
        } else if (this.contextType === 'mobilepreview') {
            initEditViewInMobilePreview(this.element.find('.backLabel'));
            initWebViewInMobilePreview(this.element.find('.webView'));
            initEditViewInMobilePreview(this.element.find('.mobileView'));
        }

        if (this.contextType === 'web') {
            this.element.find('.mobileView').click(function() {
                var currentState = self.isMobilePreviewStateActive();
                if (currentState) {
                    diy.editor.mobilepreview.close();
                } else {
                    diy.editor.mobilepreview.open();
                }
                self.setMobilePreviewStateActive(!currentState);
            });
        }
    },
    showMobilePreviewStartButton: function() {
        this.element.find('.mobile-preview-button-container').show();
    },
    setMobilePreviewStateActive: function(b) {
        var $previewContainer = $('#previewContainer'),
            hideElList,
            isTouchDevice = Modernizr.touch;
        $previewContainer.find('.mobileView')[b ? 'addClass' : 'removeClass']('selected');

        // HACK: list of elemeents that are not displayed in mobile preview
        // Each element should say if it's displayable or not, but for now
        // we keep this list here
        hideElList = [
            '.undo-redo-widget',
            '.maintenanceModeContainer',
            '#previewContainer .spacer:first',
            '.helpSearchContainer',
            '.helpContainer + .spacer',
            '.helpContainer',
            '#administrationContainer + .spacer'
        ];

        if ('mobilepreview' === this.contextType) {
            $(hideElList.join(', '))[b ? 'hide' : 'show']();
            if (!isTouchDevice) {
                if (b) {
                    $previewContainer.find('.backLabel').show().one('click.mobilepreviewback', function() {
                        diy.editor.mobilepreview.close();
                    });
                    $previewContainer.find('.viewLabel').hide();
                } else {
                    $previewContainer.find('.backLabel').hide().unbind('click.mobilepreviewback');
                    $previewContainer.find('.viewLabel').show();
                }
            }
        }
    },
    isMobilePreviewStateActive: function() {
        return $('#previewContainer .mobileView').hasClass('selected');
    },
    backAction: function() {
        window.location.href = this.element.find('.backLabel').attr('href');
    }
});

module.exports = Preview;


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar
 *  Contains just the logout button for now.
 *
 * @depends jquery.js
 * @depends extendClass.js
 *
 */
/*global Klazz, diy, jimdoData, jQuery, systemurl */
var $ = __webpack_require__(3);

var Administration = Klazz.extend({
    contextType: '', /* possible values: editor, web */
    toolbar: null,
    options: {
        classSelected: 'selected'
    },
    messages: {
        logoutLabel: jimdoData.messages.logout,
        tooltipLogout: ''
    },
    element: null,
    setup: function() {
        this.contextType = diy.context.type;
        this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar); // note: we break object reference
        this.options = $.extend(true, {}, this.options); // note: we break object reference
    },
    initialize: function(toolbar) {
        this.toolbar = toolbar;
        this.setup();
        this.draw();
    },
    draw: function(){
        var self = this,
            elementHtml = '',
            isTouchEnabled = diy.context.type === 'editor' ? diy.editor.uiPreference.isPointerModeTouch() :
                Modernizr.touch,
            elementInnerText = isTouchEnabled ?
                '<span class="icon" />'
                :
                this.messages.logoutLabel;

        elementHtml += '<div id="administrationContainer">';
        elementHtml += '<div class="label logout" title="'+
            this.messages.tooltipLogout +
            '">' +
            elementInnerText +
            '</div>';
        elementHtml += '</div>';

        this.element = this.toolbar.pushToPanel('right', elementHtml);

        // activate the logout button //
        this.element.find('.logout').click(function () {
            switch (self.contextType) {
                case 'editor':
                    window.logout();
                    break;
                case 'web':
                    window.location = systemurl + 'app/cms/logout.php';
                    break;

                case 'mobilepreview':
                    window.location = systemurl + 'app/cms/logout.php?no_referer=1';
                    break;
            }
        });
    }
 });

module.exports = Administration;


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Toolbar - Maintenance Mode class
 *
 * Responsible for the maintenance mode button in the toolbar + associated dropdown layer
 */
/*global Klazz, diy, jimdoData */

var $ = __webpack_require__(3);
var model = __webpack_require__(668);
var Widget = __webpack_require__(720);
var features = __webpack_require__(25);
var l10n = __webpack_require__(18);
var NotificationApi = __webpack_require__(537).default;
var NotificationType = __webpack_require__(540).default;

var MaintenanceMode,
    SESSION_ID_COOKIE_NAME = 'DIY_SB',
    NTF_DISMISSED_COOKIE_PREFIX = 'diy-maintenance-ntf-dismissed-',
    /**
     * TODO: move this to a generic cookie per session id generation method
     * @see bookmark-cms.js
     * What we're doing here is enforcing the callout to not show anymore in this session if it was
     * dismissed. For this we need to persist this info for the sitebuilder session. Because the
     * sitebuilder session is smaller than the browser session we can use a browser cookie set to
     * expire on session end, also because the client may start multiple server sessions while still
     * keeping his same browser session we need to include the server session id into this cookie.
     *
     * Additionaly because the Sitebuilder may be installed on machines with the Suhosin extension
     * we must limit the cookie name to 64 chars or else the server will not accept the request.
     */
     ntfDismissedCookieName = (NTF_DISMISSED_COOKIE_PREFIX + $.cookie(SESSION_ID_COOKIE_NAME)).substr(0, 64);

MaintenanceMode = Klazz.extend({
    element: null,
    toolbar: null,
    activated: false,
    messages: {
        online: {
            heading: '',
            description: ''
        },
        offline: {
            heading: '',
            description: ''
        },
        link: ''
    },
    vCardEditor: null,

    initialize: function(vCardEditor, toolbar) {
        this.toolbar = toolbar;
        this.vCardEditor = vCardEditor;

        // get translations //
        this.messages = $.extend(true, {}, this.messages, l10n.getMessages('toolbar.maintenance')); // note: we break object reference

        // import the state of the website (public / disabled) //
        this.activated = model.getState();

        // render html structure //
        this.draw();
    },
    draw: function(){
        var elementHtml;

        // build buttons HTML //
        elementHtml = '' +
            '<div class="maintenanceModeContainer">' +
                '<a class="maintenanceMode ' + (this.activated ? 'selected' : '') + '">' +
                    '<div class="icon"' +
                        ' title="' + this.messages[ this.activated ? 'offline' : 'online' ].icon.title + '"' +
                    '></div>' +
                    '<div class="text ' + (this.activated ? 'text-offline' : 'text-online') + '">' +
                        '<span class="text-inner">' +
                            this.messages[ this.activated ? 'offline' : 'online' ].label +
                        '</span>' +
                    '</div>' +
                '</a>' +
            '</div>';

        this.element = this.toolbar.pushToPanel('left', elementHtml);
        this.element
            .diy_calloutLayer({
                cls: 'diye-toolbar-callout diye-toolbar-maintenance',
                anchorTarget: this.element.find('.icon'),
                positionMode: 'fixed',
                layerWidth: 400,
                position: {
                    my: 'left top',
                    at: 'left bottom',
                        offset: '-10 ' + (diy.editor.uiPreference.isPointerModeTouch() ? '10' : '5')
                },
                render: $.proxy(this._renderLayer, this),
                show: $.proxy(function() {
                    jQuery(document.body).trigger('PublishWebsiteOpened.BSA');
                    this.element.addClass('callout-open');
                }, this),
                hide: $.proxy(function() {
                    this.element.removeClass('callout-open');
                }, this)
            })
            .bind('click', this._toggleLayer.bind(this))
            .bind('diy-editor-toolbar-close-maintenance-mode',
                (function(){
                    this.element.diy_calloutLayer('hide')
                }).bind(this))
            .bind('diy-editor-toolbar-open-maintenance-mode',
                (function(){
                    this.element.diy_calloutLayer('show')
                }).bind(this));

        $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));

        $(document).bind('diy-maintenance-mode-changed', function(e, state) {
            if (state) {
                this.activate();
            } else{
                this.deactivate();
            }
            if (this.infoPanel) {
                // Update widget if panel is rendered
                this.widget.refresh();
            }
        }.bind(this));

        $(document).bind('diy-maintenance-loading-state-changed', function(e, state) {
            if (!this.infoPanel) {
                // Do nothing if panel is not yet rendered
                return;
            }
            if (state) {
                this.infoPanel.loadingBox({ useOverlay: true}).show();
            } else {
                this.infoPanel.loadingBox().remove();
            }
        }.bind(this));

        this.manageNotification();
    },

    _getLayerTemplate: function() {
        var stateKey = this.activated ? 'offline' : 'online';

        return '' +
            '<h3 class="heading subheading">' +
                this.messages[stateKey].heading +
            '</h3>'+
            '<div class="content">' +
                '<div class="maintenance-widget"></div>' +
                '<div class="description">' +
                    this.messages[stateKey].description +
                '</div>' +
                '<div class="maintenance-link">' +
                    '<a href="JavaScript:;">' +
                        l10n.getString('toolbar.maintenance.offline.vcard.edit.title') +
                    '</a>' +
                '</div>' +
            '</div>';
    },

    _renderLayer: function(e, layer) {
        var contentEl = layer.getContentEl();

        if (!contentEl) {
            return;
        }

        $(this._getLayerTemplate()).appendTo(contentEl);
        this.infoPanel = contentEl;

        this.widget = new Widget(this.infoPanel.find('.maintenance-widget'));

        this.vCardEditor.createTriggerElement({
            element: this.infoPanel.find('.maintenance-link').find('a'),
            context: "toolbar"
        });
    },

    show: function () {
        this.element.diy_calloutLayer('show');
    },

    _toggleLayer: function() {
        var visible = this.element.diy_calloutLayer("isVisible");
        this.element.diy_calloutLayer(visible ? 'hide' : 'show');
    },

    _positionLayer: function() {
        this.element.diy_calloutLayer('refresh');
    },

    openInSettings: function () {
        $(document).trigger('diy-editor-constructionTopbar-click');
        diy.editor.deeplinking.requestPath([
            {label: 'siteadmin', params: 'settings'},
            {label: 'SAC.Settings', params: 'website-staging'}
        ]);
    },

    activate: function () {
        this.activated = true;

        this.element.find('.maintenanceMode').addClass('selected');
        if (this.infoPanel) {
            this.infoPanel.find('.heading').html(this.messages.offline.heading);
            this.infoPanel.find('.description').html(this.messages.offline.description);
        }

        this.element.find('.maintenanceMode .text')
            .addClass('text-offline')
            .removeClass('text-online')
            .find('.text-inner')
            .html(this.messages.offline.label);

        this.element.find('.maintenanceMode .icon')
            .attr('title', this.messages.offline.icon.title );

        return this;
    },
    deactivate: function () {
        this.activated = false;

        this.element.find('.maintenanceMode').removeClass('selected');

        if (features('notificationsNG')) {
            this.removeNotification();
        } else {
            diy.editor.notifications.api.ready(function() {
                var n = diy.editor.notifications;
                n.api.deleteNotificationByType(n.Notifications.TYPE_MAINTENANCE);
            }.bind(this));
        }

        if (this.infoPanel) {
            this.infoPanel.find('.heading').html(this.messages.online.heading);
            this.infoPanel.find('.description').html(this.messages.online.description);
        }

        this.element.find('.maintenanceMode .text')
            .addClass('text-online')
            .removeClass('text-offline')
            .find('.text-inner')
            .html(this.messages.online.label);

        this.element.find('.maintenanceMode .icon')
            .attr('title', this.messages.online.icon.title );

        return this;
    },
    toggleActivation: function () {
        if (this.activated) {
            this.deactivate();
        } else {
            this.activate();
        }

        return this;
    },
    manageNotification: function() {
        // No notification on page load if we haven't published our website yet
        if (model.isFirstPublish()) {
            return;
        }

        if (!this.activated) {
            this.removeNotification();
        } else {
            this.sendNotification();
        }
    },
    sendNotification: function() {
        if (features('notificationsNG')) {
            NotificationApi.schedule(function () {

                // Here we check if we showed the notification this session. The code is copied from
                // bookmark-cms.js. Should be removed once the notification triggering system is refactored
                if (!$.cookie(ntfDismissedCookieName)) {

                    NotificationApi.pushOne({
                        type: NotificationType.MAINTENANCE_MODE,
                        dismissed: false,
                        deleted: false
                    });
                    $.cookie(ntfDismissedCookieName, '1', {path: '/'});
                }
            });

        } else {
            diy.editor.notifications.api.ready(function() {
                var n = diy.editor.notifications;
                var maintenanceNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_MAINTENANCE);
                if (maintenanceNotifications.length <= 0) {
                    n.api.createNotification({type: n.Notifications.TYPE_MAINTENANCE});
                } else {
                    // Here we check if we showed the notification this session. The code is copied from
                    // bookmark-cms.js. Should be removed once the notification triggering system is refactored
                    if ($.cookie(ntfDismissedCookieName)) {
                        return;
                    }

                    n.api.updateNotification(maintenanceNotifications[0].getId(), {dismissed: 0});
                    $.cookie(ntfDismissedCookieName, '1', {path: '/'});
                }
            }.bind(this));
        }
    },
    removeNotification: function() {
        if (features('notificationsNG')) {
            NotificationApi.schedule(function () {
                NotificationApi.deleteOne(
                    NotificationType.MAINTENANCE_MODE
                );
            });

        } else {
            diy.editor.notifications.api.ready(function() {
                var n = diy.editor.notifications;
                var maintenanceNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_MAINTENANCE);
                if (maintenanceNotifications.length > 0) {
                    n.api.deleteNotificationByType(n.Notifications.TYPE_MAINTENANCE);
                }
            }.bind(this));
        }
    },
    getCalloutWidget: function() {
        return this.element.diy_calloutLayer('widget');
    }
 });

module.exports = MaintenanceMode;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var ProviderAggregator = __webpack_require__(848);
var Elements = __webpack_require__(850);
var Help = __webpack_require__(851);
var Features = __webpack_require__(852);
var HelpLinks = __webpack_require__(853);

/**
 * Toolbar - Search class
 *
 * @depends jquery.js
 * @depends extendClass.js
 * @depends diy.searchBox.js
 * @depends diy.calloutLayer.js
 * @depends helpLinks.js
 * @depends providers/Help.js
 * @depends providers/Elements.js
 * @depends toolbar.js
 */
(function() {
    'use strict';
    var Search;

    var SEARCH_MIN_CHARS = 3;

    Search = Klazz.extend({
        options: {},
        toolbar: null,
        element: null,
        messages: {

        },
        /**
         * The element on which the searchbox is created
         */
        searchEl: null,
        /**
         * Element used as root for angular module (inside layer)
         */
        ngRootEl: null,

        /**
         * @type {ProviderAggregator}
         */
        providerAggregator: null,

        initialize: function(toolbar) {
            this.toolbar = toolbar;
            // Only available in the editor toolbar
            if (diy.context.type != 'editor') {
                return;
            }

            this.options = $.extend(true, {}, this.options); // note: we break object reference

            // get translations //
            // note: we break object reference
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbarSearch);

            this.initProviders();

            if (!this.providerAggregator.hasProviders()) {
                // No providers available for search, we don't show the widget
                return;
            }

            this.providerAggregator
                .loadProviders()
                .done($.proxy(function(loadedProviders) {
                    if ($.isEmptyObject(loadedProviders)) {
                        window.console && console.log && console.log('Could not load any search provider. Search widget will be inactive!');
                    } else {
                        this.draw();
                    }
                }, this));
        },

        /**
         * Initialize the available search providers
         */
        initProviders: function() {
            this.providerAggregator = new ProviderAggregator();

            if (jimdoData.features.helpSearch) {
                this.providerAggregator.addProvider(
                    'help',
                    new Help()
                );
            }

            this.providerAggregator.addProvider(
                'elements',
                new Elements()
            );

            this.providerAggregator.addProvider(
                'features',
                new Features()
            );
        },

        //Public API (called by angular controller)
        hasHelpSearch: function() {
            return this.providerAggregator.hasLoadedProvider('help');
        },

        /**
         * Localized text for the search box placeholder. If we only have the
         * search provider for help, we show "Search help...". Otherwise we show
         * a generic "Search..." label
         *
         * @returns {String}
         */
        getPlaceholderText: function(showPlaceholder) {
            if (showPlaceholder === false) {
                return '';
            }
            var loadedProviders = this.providerAggregator.getLoadedProviderCount();

            if (loadedProviders == 1 && this.hasHelpSearch()) {
                return this.messages.helpPlaceholder;
            } else {
                return this.messages.placeholder;
            }
        },

        draw: function() {
            var elementHtml = '' +
                    '<div class="spacer"><div class="icon"></div></div>' +
                    '<div class="searchContainer">' +
                        '<div class="search"></div>' +
                    '</div>';
            this.element = this.toolbar.pushToPanel('right', elementHtml);

            this.searchEl = this.element.find('.search');

            this.searchEl
                .diy_searchBox({
                    searchButtonClickable: false,
                    clearButton: true,
                    texts: {
                        emptyText: this.getPlaceholderText(!diy.editor.uiPreference.isPointerModeTouch())
                    }
                })
                .bind("searchboxfocus", function(e) {
                    var centerPanel = this.toolbar.getPanel('center');
                    if (centerPanel && diy.editor.uiPreference.isPointerModeTouch()) {
                        //we hide the center panel which hosts the undo-redo stuff
                        centerPanel.hide();
                    }
                    $(document).trigger('diy-editor-search-focus');
                }.bind(this))
                .bind("searchboxblur", $.proxy(function(e) {
                    var centerPanel = this.toolbar.getPanel('center');
                    if (centerPanel && diy.editor.uiPreference.isPointerModeTouch() &&
                        !(this.searchEl.hasClass('callout-open')  || this.searchEl.hasClass('ui-state-focus'))
                    ) {
                        //we show the center panel which hosts the undo-redo stuff
                        centerPanel.show();
                        this.searchEl.find('a.ui-icon.ui-icon-close').hide();
                    }
                    this.searchEl.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
                }, this))
                .bind("searchboxkeyup", $.proxy(function(e, ui) {
                    var keyCodes = $.ui.keyCode;

                    // If the keyboard navigation handler returns true
                    // it prevents any default behavior for that key and
                    // behavior of the search
                    if (this._handleKeyNav(e) === true) {
                        e.preventDefault();
                        return;
                    }

                    switch (e.keyCode) {
                        case keyCodes.ESCAPE:
                            this.searchEl.diy_searchBox('blur');
                            this.searchEl.diy_calloutLayer('hide');
                            break;

                        default:
                            this._onSearch(e, ui);
                            break;
                    }
                }, this))
                .bind("searchboxfocus", $.proxy(this._onSearch, this))
                .diy_calloutLayer({
                    cls: 'diye-toolbar-search',
                    anchorTarget: this.searchEl,
                    positionMode: 'fixed',
                    position: {
                        my: "left top",
                        at: "left bottom",
                        offset: (   diy.editor.uiPreference.isPointerModeTouch() ? '5' : '-10') + ' 5'
                    },
                    render: $.proxy(this._renderLayer, this),
                    show: $.proxy(function() {
                        this.searchEl.addClass('callout-open');
                    }, this),
                    hide: $.proxy(function() {
                        this.searchEl.removeClass('callout-open');
                        this.searchEl.trigger('searchboxblur');
                    }, this)
                });

            $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));
        },

        _getLayerTemplate: function() {
            // The template is defined inline in the angular module
            // do not declare ng-controller and ng-include on the same element. you have been warned
            return '<div ng-controller="SearchLayerCtrl"><div  ng-include="\'searchResults.html\'"></div></div>';
        },

        _renderLayer: function() {
            var contentEl = this.searchEl.diy_calloutLayer('getContentEl');

            if (!contentEl) {
                return;
            }

            this.ngRootEl = $(this._getLayerTemplate()).appendTo(contentEl);
            angular.bootstrap(this.ngRootEl, ['diy.search']);

            this._renderHelpLinks(contentEl.find('.no-results-wrapper'));

            contentEl.diy_scrollHandle();

            // Prevent the search box from loosing focus when clicking inside the
            // results layer
            contentEl.bind('click', $.proxy(function(e) {
                // Bugfix #DHDIY-20765: We don't focus the field again when
                // we clicked on a result, which closes the search
                if (!$(e.target).closest('.result').length) {
                    this.searchEl.diy_searchBox('focus');
                }
            }, this));
        },

        _showLayer: function() {
            if (this.searchEl.diy_calloutLayer("isVisible")) {
                return;
            }

            this.searchEl.diy_calloutLayer('show');

            this.refreshScroller(true);
        },

        // Public API (called by angular controller)
        refreshScroller: function(scrollToFirstItem) {
            var contentEl = this.searchEl.diy_calloutLayer('getContentEl');

            if (!contentEl || !this.searchEl.diy_calloutLayer('isVisible')) {
                return;
            }

            contentEl
                .trigger('contentchanged')
                .diy_alwaysInViewBehavior({
                    clickToOpen: true,
                    fixableSelector: '.diye-collapsible-category-header',
                    fixedClassName: 'fixed',
                    activeClassName: 'active'
                });

            if (scrollToFirstItem) {
                var firstResult = contentEl.find('.result:eq(0)');
                if (firstResult.length) {
                    contentEl.diy_alwaysInViewBehavior('scrollToItem', firstResult.get(0), undefined, 0);
                }
            }
        },

        // Public API (called by angular controller)
        scrollToResult: function(resultId) {
            var contentEl = this.searchEl.diy_calloutLayer('getContentEl'),
                firstResult;

            if (!contentEl || !this.searchEl.diy_calloutLayer('isVisible')) {
                return;
            }

            firstResult = contentEl.find('.result[data-result-id="' + resultId + '"]');
            if (firstResult.length > 0) {
                contentEl.diy_alwaysInViewBehavior('scrollItemIntoView', firstResult.get(0), undefined, 0);
            }
        },

        _positionLayer: function() {
            this.searchEl.diy_calloutLayer('refresh');
        },

        _onSearch: function(e, ui) {
            var searchEl = this.searchEl,
                searchPhrase = ui.value,
                searchResults;

            if (searchPhrase.length < SEARCH_MIN_CHARS) {
                searchEl.diy_calloutLayer('hide');
                return;
            }

            if (e.type == 'searchboxfocus' && searchEl.diy_calloutLayer('isVisible')) {
                // Nothing to do if we regained focus while the layer was still visible
                return;
            }

            searchResults = this.providerAggregator.search(searchPhrase);

            searchEl.diy_calloutLayer('render');

            this._updateResults(searchResults);

            if (e.type == 'searchboxfocus' && Modernizr.csstransitions) {
                this.searchEl.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                    $.proxy(this._showLayer, this)
                );
            } else {
                this._showLayer();
            }

            if (e.type != 'searchboxfocus') {
                $(document).trigger('diy-editor-search-search', {
                    searchPhrase: searchPhrase,
                    resultsFound: !$.isEmptyObject(searchResults)
                });
            }
        },

        _updateResults: function(searchResults) {
            var $scope = angular.element(this.ngRootEl).scope();

            $scope.$apply(function() {
                $scope.searchResults = searchResults;
            });
        },

        _handleKeyNav: function(e) {
            if (!this.ngRootEl) {
                return false;
            }

            var $scope = angular.element(this.ngRootEl).scope();

            return $scope.handleKeyNav(e);
        },

        _renderHelpLinks: function(contentEl) {
            if (!this.hasHelpSearch()) {
                return;
            }

            var $helpLinks = $('<div></div>')
                .addClass('help-links')
                .appendTo(contentEl);

            var helpLinksWidget = new HelpLinks($helpLinks);
            helpLinksWidget.render();

            $helpLinks.bind('helplinksclick', $.proxy(this._onHelpLinkClick, this));
        },

        _onHelpLinkClick: function(e, data) {
            this.searchEl.diy_calloutLayer('hide');

            $(document).trigger('diy-editor-search-helplinkclick', {
                helpLinkId: data.helpLinkId
            });
        },

        //public API (used by angular controller)
        openResult: function(e, index, result, catId) {
            this.providerAggregator.getProvider(result.providerName).action(result);
            this.searchEl.diy_searchBox('blur');

            this.searchEl.diy_calloutLayer('hide');

            $(document).trigger('diy-editor-search-resultclick', {
                resultIndex: parseInt(index, 10),
                categoryId: catId
            });
        }
    });

    module.exports = Search;
}());


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var Provider = __webpack_require__(849);

/**
 * Class that aggregates multiple search providers for the toolbar and provides
 * a central point for operating the search
 *
 * @depends Provider.js
 */
(function() {
    'use strict';

    var ProviderAggregator = Klazz.extend({
        /**
         * Defined providers
         *
         * A map of string label to provider object
         * @type {Object.<string, Provider>}
         */
        providers: null,
        /**
         * @type {Object.<string, Provider>}
         */
        loadedProviders: null,

        initialize: function() {
            this.providers = {};
            this.loadedProviders = {};
        },

        /**
         *
         * @param {String} name a label string serving as UID
         * @param {Provider} providerObj
         */
        addProvider: function(name, providerObj) {
            if ('string' !== typeof name) {
                throw new Error("name must be a string (" + name + ")");
            }

            if (!(providerObj instanceof Provider)) {
                throw new Error("Invalid provider object");
            }

            if (this.providers[name]) {
                throw new Error("Provider `" + name + "` is already added");
            }

            this.providers[name] = providerObj;
        },

        /**
         * Adds a list of providers
         * @param {Object.<string, Provider>} providers
         */
        addProviders: function(providers) {
            var name;

            if ('object' == typeof providers) {
                for (name in providers) {
                    if (providers.hasOwnProperty(name)) {
                        this.addProvider(name, providers[name]);
                    }
                }
            }
        },

        /**
         * @param {String} name
         * @returns {Provider}
         */
        getProvider: function(name) {
            if (!this.providers[name]) {
                throw new Error("Provider `" + name + "` not found");
            }

            return this.providers[name];
        },

        /**
         * Loads all defined providers asynchronously, returning a promise
         * @returns {Q.Promise}
         */
        loadProviders: function() {
            var loadPromises = [];

            $.each(this.providers, function(name, provider) {
                // Here we create a new promise for each provider,
                // starting from the existing load promise, which we
                // "spice" with some contextual information which allows
                // use to determine what provider loaded. Otherwise we'll only
                // know that the load occurred.
                loadPromises.push(
                    provider
                        .load()
                        .then(function() {
                            return {
                                name: name,
                                provider: provider
                            }
                        })
                );
            });

            // We load the providers in parallel and fulfill the promise when all
            // providers are finished (either with success or failure)
            return Q.allSettled(loadPromises)
                .then($.proxy(function(promises) {
                    var i, promise;

                    for (i = 0; i < promises.length; ++i) {
                        promise = promises[i];
                        if (promise.state == 'fulfilled') {
                            this.loadedProviders[promise.value.name] = promise.value.provider;
                        }
                    }

                    return this.loadedProviders;
                }, this));
        },

        /**
         * Checks if there are any defined providers
         * @returns {boolean}
         */
        hasProviders: function() {
            return !$.isEmptyObject(this.providers);
        },

        /**
         * Returns the list of providers that were successfully loaded
         * @returns {Object.<string, Provider>}
         */
        getLoadedProviders: function() {
            return this.loadedProviders;
        },

        /**
         * Number of providers that were successfully loaded
         * @returns {number}
         */
        getLoadedProviderCount: function() {
            var count = 0, name;
            for (name in this.loadedProviders) {
                if (this.loadedProviders.hasOwnProperty(name)) {
                    count++;
                }
            }

            return count;
        },

        /**
         * Checks if a provider was loaded
         * @param {String} name
         * @returns {boolean}
         */
        hasLoadedProvider: function(name) {
            return !!this.loadedProviders[name];
        },

        /**
         * Searches in all available providers.
         *
         * Returns an object with results from each provider, mapped by provider name
         * For a provider, an entry is created in the results only if some results were found
         *
         * @param {String} q the search query
         * @return {Object.<string, Object[]>}
         */
        search: function(q) {
            var searchResults = {};

            $.each(this.getLoadedProviders(), function(name, provider) {
                var res = provider.search(q);
                if (res && res.length) {
                    searchResults[name] = res;
                }
            });

            return searchResults;
        }
    });

    module.exports = ProviderAggregator;
}());


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

/*global Klazz, Q, lunr*/
var $ = __webpack_require__(3);

(function() {
    'use strict';

    var Provider = Klazz.extend({
        /**
         * contains the results summary data that are displayed
         */
        summaryData: null,
        /**
         * the index generated by lunr
         */
        lunrIndex: null,

        //override this
        indexUrl: '',

        /**
         * load the index for the search asynchronously, promise-based
         * @returns {promise|Q.promise}
         */
        load: function() {
            var deferred = Q.defer();
            /* when starting, request the search index */
            $.ajax({
                url: this.indexUrl,
                type: 'GET',
                context: this,
                success: function(data) {
                    /* if received object seems to have the right format */
                    if ('object' === typeof data
                        && 'object' === typeof data.summary) {
                        /* even if the object has the right format, there's no way
                         of telling whether the object is all correct, so we may
                         find out this, as an error, while loading the index
                         */
                        try {
                            /* populate the summary data and the search index */
                            this.summaryData = data.summary;

                            // If an index is present, load it
                            if ('object' === typeof data.index) {
                                this.lunrIndex = lunr.Index.load(data.index);
                            } else if ('object' == typeof data.indexData) {
                                // Otherwise build the index on the fly
                                this.buildIndex(data.indexData)
                            } else {
                                deferred.reject();
                            }
                            deferred.resolve();
                        } catch(e) {
                            console && console.error && console.error(e);
                            deferred.reject();
                        }
                    } else {
                        deferred.reject();
                    }
                },
                error: function() {
                    deferred.reject();
                }
            });
            return deferred.promise;
        },

        buildIndex: function(indexData) {
            var indexerFn = this.getIndexer(indexData.locale),
                fields = indexData.fields,
                index, i, j, idxDoc, data;

            index = indexerFn(function() {
                var fieldBoosts = indexData.fieldBoosts,
                    i, fieldCfg, boost;

                //Construct each field definition, which for now contains the boost
                for (i = 0; i < fields.length; ++i) {
                    fieldCfg = {};
                    boost = fieldBoosts[fields[i]];
                    if (typeof boost !== "undefined") {
                        fieldCfg.boost = boost;
                    }

                    this.field(fields[i], fieldCfg);
                }

                // This sets the name of the UID field
                this.ref(indexData.ref);

                this.pipeline.add(lunr.removeEmpty);
            });

            // Index the data
            for (i in this.summaryData) {
                if (this.summaryData.hasOwnProperty(i)) {
                    data = this.summaryData[i];
                    idxDoc = {};
                    idxDoc[indexData.ref] = data[indexData.ref];

                    for (j = 0; j < fields.length; ++j) {
                        idxDoc[fields[j]] = data[fields[j]];
                    }

                    index.add(idxDoc);
                }
            }

            //TODO: clean summaryData of non-necessary fields

            this.lunrIndex = index;
        },

        /**
         * Returns the indexing function (flavor of lunr)
         * @param {String} locale e.g. en_US
         * @returns {Function}
         */
        getIndexer: function(locale) {
            var indexerFn;

            switch (locale) {
                case 'de_DE':
                    indexerFn = lunr.de;
                    break;

                case 'fr_FR':
                    indexerFn = lunr.fr;
                    break;

                default:
                    indexerFn = lunr;
                    break;
            }

            return indexerFn;
        },

        /**
         * search for a given string
         * @param q string
         * @returns {Array} the results list
         */
        search: function(q) {
            /* if lunrIndex was initialized */
            if (this.lunrIndex) {
                /* perform the search using the lunr library */
                var searchResults = this.lunrIndex.search(q);

                return this.buildResults(searchResults);
            }

            return [];
        },

        /**
         * Applies formatting to the results
         * By default it returns the same data that was passed when creating the index
         * It can be overriden in child classes to provide custom formatting
         * @param {Object[]} results
         * @returns {Object[]}
         */
        buildResults: function(results) {
            var resultsFinal = [],
                ref, i;

            /* add details on the results, based on the summaryData */
            for (i = 0; i < results.length; i++) {
                ref = results[i].ref;
                resultsFinal.push(this.summaryData[ref]);
            }

            return resultsFinal;
        }
    });

    module.exports = Provider;

}());


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

var Provider = __webpack_require__(849);
var moduleSelector = __webpack_require__(10);
var appsCatalog = __webpack_require__(11);

/**
 * Search provider class for searching in content elements (modules and apps)
 */
(function() {
    'use strict';

    var Elements = Provider.extend({
        indexUrl: '/app/cms/search/elementsindex/',

        initialize: function() {
            this.indexUrl += '?cacheKey=' + jimdoData.search.elementsCacheKey;
        },

        action: function(app) {

            // trigger upsell dialog
            if (app.isUpsell) {
                diy.editor.deeplinking.requestPath([
                    { label: 'siteadmin', params: app.webcomponentId.toLowerCase() }
                ]);
                return;
            }

            Modul.abortEditingModules();

            var isInstalledFn = appsCatalog.isWebcomponentInstalled;
            if (app.type != 'webcomponent' || isInstalledFn(app.webcomponentId)) {
                var itemType = app.type == 'webcomponent' ? 'webcomponent' : 'module',
                    id = app.type == 'webcomponent' ? app.webcomponentId : app.id;
                moduleSelector.default.jumpToItem(itemType, id);
            } else {
                // not installed webcomponent: link to catalog
                var catalogUrl = appsCatalog.getDetailPageNoBackLinkUrl(app.webcomponentId);
                appsCatalog.customOpen(catalogUrl);
            }
        }
    });

    module.exports = Elements;

}());


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

var Provider = __webpack_require__(849);

module.exports = Provider.extend({
    indexUrl: '/app/help/assistant/gethelpindex/',

    initialize: function() {
        this.indexUrl += '?cacheKey=' + jimdoData.search.helpCacheKey;
    },

    buildResults: function(results) {
        var helpResultsFinal = [];

        results = this._super(results);

        /**
         * XXX: This filtering of results by features is a hack! See DHDIYTB-489.
         * Also see stdjs.php, which defines jimdoData.helpFeatures.
         */
        var featureList, anyFeatureActive;
        for (var rIndex = 0; rIndex < results.length; rIndex++) {
            featureList = results[rIndex]['featureList'];
            if (featureList && featureList.length && jimdoData.helpFeatures) {
                anyFeatureActive = false;
                for (var listIndex = 0; listIndex < featureList.length; listIndex++) {
                    if (1 === jimdoData.helpFeatures[featureList[listIndex]]) {
                        anyFeatureActive = true;
                        break;
                    }
                }
                if (!anyFeatureActive) {
                    // remove result because it had feature dependencies
                    // and we didn't find at least one active
                    delete results[rIndex];
                }
            }
        }

        /* first add the featured=true to the top */
        for (var j = 0; j < results.length; j++) {
            // XXX: remember to test that results[j] is not undefined; may have been removed by delete above
            if (results[j] && results[j].featured) {
                helpResultsFinal.push(results[j]);
            }
        }

        /* and the featured=false to the bottom */
        for (var k = 0; k < results.length; k++) {
            // XXX: remember to test that results[k] is not undefined; may have been removed by delete above
            if (results[k] && !results[k].featured) {
                helpResultsFinal.push(results[k]);
            }
        }

        return helpResultsFinal;
    },

    /**
     * perform the action for the given search result
     * in this case, open help window to that topic
     * @param ref help topic
     * @param ev event that got to this action
     */
    action: function(ref) {
        //Hack: remove this when search elements feature is permanently ON
        //The new search gives the result hash as a parameter instead of the slug itself
        if (ref.slug) {
            ref = ref.slug;
        }

        /* simulating opening of the help window */
        var $el = jQuery('<div data="' + ref + '"></div>'),
            e = {currentTarget: $el[0]};

        guidedAssistant._onModuleHelpLinkClick.call(guidedAssistant, e);
    }
});


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var Provider = __webpack_require__(849);
var siteadmin = __webpack_require__(20);

/**
 * Search provider class for searching in various sitebuilder features, with custom actions
 */
(function() {
    'use strict';

    /**
     * @type {Object.<String, Function>} a map of featureId, custom action function
     */
    var actions = {
        tour: function() {
            diy.editor.guidance.start();
        },
        getFound: function () {
            var navigate = function () {
                     parent.diy.editor.deeplinking.requestPath([
                        {label: 'siteadmin', params:'get-found'},
                        {label: 'SAC.GetFound', params: 'get-found-introduction'}
                    ]);
            };

            if (siteadmin.getController() === null) {
                parent.diy.editor.deeplinking.requestPath([ {label: 'siteadmin', params:'get-found'}]);
                $(document).one('diy-siteadmin-content-loaded', navigate);
            } else {
                navigate();
            }

        },
        listLocal: function () {
            var navigate = function () {
                parent.diy.editor.deeplinking.requestPath([
                    {label: 'siteadmin', params:'get-found'},
                    {label: 'SAC.GetFound', params: 'get-found-lilo'}
                ]);
            };
            if (siteadmin.getController() === null) {
                parent.diy.editor.deeplinking.requestPath([ {label: 'siteadmin', params:'get-found'}]);
                $(document).one('diy-siteadmin-content-loaded', navigate);
            } else {
                navigate();
            }

        }
    };

    var Features = Provider.extend({
        indexUrl: '/app/cms/search/featuresindex/',

        initialize: function() {
            this.indexUrl += '?cacheKey=' + jimdoData.search.featuresCacheKey;
        },

        action: function(feature) {
            var actionFn = actions[feature.id];

            if (typeof actionFn === 'function') {
                actionFn();
            }
        }
    });

   module.exports = Features;

}());


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

/**
 * Help links that are displayed in the toolbar help dropdown menu, as well as
 * help search
 */
(function() {
    'use strict';

    var HelpLinks;

    HelpLinks = Klazz.extend({
        element: null,
        messages: {

        },
        helpLinksData: null,

        initialize: function(element) {
            this.element = $(element);

            // get translations //
            // note: we break object reference
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.helptoolbar);

            this._initHelpLinksData();
        },

        _initHelpLinksData: function() {
            this.helpLinksData = [{
                id: 'defaultView',
                title: this.messages.help.title,
                desc: this.messages.help.desc
            }, {
                id: 'guidedTour',
                title: this.messages.tour.title,
                desc: this.messages.tour.desc,
                action: function() {
                    diy.editor.guidance.start();
                }
            }, {
                id: "contactView",
                title: this.messages.contact.title,
                desc: this.messages.contact.desc
            }];
        },

        render: function() {
            var $helpLinks, i, current, $item;

            $helpLinks = $('<div class="diye-help-links"></div>')
                .appendTo(this.element);

            for (i = 0; i < this.helpLinksData.length; ++i) {
                current = this.helpLinksData[i];

                $item = $helpLinks.append(
                    '<div class="help-link">' +
                        '<a href="JavaScript:;" data-index="' + i + '">' +
                            '<div class="help-link-content">' +
                                '<span class="icon icon-' + current.id + '"></span>' +
                                '<h3>' + current.title + '</h3>' +
                                '<p>' + current.desc + '</p>' +
                            '</div>' +
                        '</a>' +
                    '</div>'
                );
            }

            $helpLinks.find('a').bind('click', $.proxy(this._onHelpLinkClick, this));


        },

        _onVersionClick: function (e) {
            var topic = 'changelog';
            cms.help.GuidedAssistant.getInstance()._openHelpTopic(topic);
            this.element.trigger('helplinksclick', { helpLinkId: topic });
        },
        _onHelpLinkClick: function(e) {
            var linkIndex = $(e.currentTarget).attr('data-index'),
                linkData = this.helpLinksData[linkIndex],
                linkId = linkData.id;


            if (typeof linkData.action === 'function') {
                linkData.action();
            } else {
                this._openHelp(linkId);
            }

            this.element.trigger('helplinksclick', {
                helpLinkId: linkId
            });
        },

        _openHelp: function(tab) {
            cms.help.GuidedAssistant._instance.showHelpWindowTab(
                cms.help.GuidedAssistant._instance._options.controller[tab]
            );
        }
    });

    module.exports = HelpLinks;
}());


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 * KPI Tracking functionality for the toolbar search feature
 *
 * @depends search.js
 */
(function() {
    'use strict';

    var KPI_TRACKING_KEY_PRESS_TIMEOUT = 500,
        KPI_TRACKING_RESULTS_VIEW_TIMEOUT = 7000;

    var SearchKpi = Klazz.extend({
        searchPhrase: null,
        lastSearchPhrase: null,
        kpiTrackingKeyPressTimer: null,
        kpiTrackingResultsViewTimer: null,

        init: function() {
            $(document)
                .bind('diy-editor-search-focus', $.proxy(this.trackFocus, this))
                .bind('diy-editor-search-search', $.proxy(this.trackSearch, this))
                .bind('diy-editor-search-resultclick', $.proxy(this.trackResult, this))
                .bind('diy-editor-search-helplinkclick', $.proxy(this.trackNoResult, this))
                .bind('diy-editor-search-showmoreclick', $.proxy(this.trackMoreResults, this));
        },

        getSearchPhrase: function() {
            return this.searchPhrase;
        },

        setSearchPhrase: function(searchPhrase) {
            this.searchPhrase = searchPhrase;
        },

        getLastSearchPhrase: function() {
            return this.lastSearchPhrase;
        },

        setLastSearchPhrase: function(searchPhrase) {
            this.lastSearchPhrase = searchPhrase;
        },

        isRepeatedSearch: function() {
            return $.trim(this.lastSearchPhrase) == $.trim(this.searchPhrase);
        },

        trackFocus: function() {
            /* KPI Tracking - When the user has focus on the search field */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                name: 'Search',
                condition: 'Visited'
            });
        },

        trackSearch: function(e, data) {
            this.setSearchPhrase(data.searchPhrase);

            if (this.kpiTrackingKeyPressTimer) {
                clearTimeout(this.kpiTrackingKeyPressTimer);
            }
            if (this.kpiTrackingResultsViewTimer) {
                clearTimeout(this.kpiTrackingResultsViewTimer);
            }

            // After some time since the last key pressed, track that we made
            // a search
            this.kpiTrackingKeyPressTimer = setTimeout($.proxy(function() {
                var triggeredEventName = (this.isRepeatedSearch())?
                            'diy-editor-repeatedSearchExecuted':'diy-editor-searchExecuted';
                $(document).trigger(triggeredEventName, {
                    'searchPhrase': this.getSearchPhrase(),
                });
                this.setLastSearchPhrase(data.searchPhrase);
            }, this), KPI_TRACKING_KEY_PRESS_TIMEOUT);

            // After some time since the search was made, if nothing was clicked
            // from the results, track this
            if (data.resultsFound) {
                this.kpiTrackingResultsViewTimer = setTimeout($.proxy(function() {
                    $(document).trigger('diy-editor-searchResultNotClicked', {
                        'searchPhrase': this.getSearchPhrase()
                    });
                }, this), KPI_TRACKING_RESULTS_VIEW_TIMEOUT);
            }
        },

        trackResult: function(e, data) {
            // We clicked a result, we reset the click timeout timer
            if (this.kpiTrackingResultsViewTimer) {
                clearTimeout(this.kpiTrackingResultsViewTimer);
            }

            // Track that we clicked on a search result
            $(document).trigger('diy-editor-searchResultClicked', {
                'searchPhrase': this.getSearchPhrase(),
                'categoryId': data.categoryId,
                'resultIndex': data.resultIndex + 1 // make sure it starts from 1 rather than 0
            });
        },

        trackNoResult: function(e, data) {
            // Track that we clicked on a help link in the "no results found"
            // layer
            $(document).trigger('diy-editor-searchNoResultsHelpLinkClick', {
                'searchPhrase': this.getSearchPhrase(),
                'helpLinkId': data.helpLinkId
            });
        },

        trackMoreResults: function(e, data) {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                actionName: 'ShowMoreResults'
            });
        }
    });


    module.exports = SearchKpi;
}());


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var HelpLinks = __webpack_require__(853);

/**
 * Toolbar - Help class
 *
 * Renders the help icon in the toolbar
 *
 * @depends jquery.js
 * @depends extendClass.js
 */
(function() {
    'use strict';
    var Help;

    Help = Klazz.extend({
        options: {},
        toolbar: null,
        element: null,
        helpEl: null,
        messages: {

        },

        initialize: function(toolbar) {
            this.toolbar = toolbar;
            this.options = $.extend(true, {}, this.options); // note: we break object reference

            // get translations //
            // note: we break object reference
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.helptoolbar);

            this.draw();
        },
        draw: function(){
            if (diy.context.type != 'editor') {
                return;
            }

            var elementHtml = '' +
                '<div class="spacer"><div class="icon"></div></div>' +
                '<div class="helpContainer">' +
                    '<a class="help" title="' + this.messages.title + '">' +
                        '<div class="ui-icon ui-icon-help"></div>' +
                    '</a>' +
                '</div>';
            this.element = this.toolbar.pushToPanel('right', elementHtml);

            this.helpEl = this.element.find('.help');

            this.helpEl
                .diy_calloutLayer({
                    cls: 'diye-help-toolbar',
                    anchorTarget: this.helpEl,
                    positionMode: 'fixed',
                    position: {
                        my: 'right top',
                        at: 'right bottom',
                        offset: '10 ' + (diy.editor.uiPreference.isPointerModeTouch() ? '11' : '0')
                    }
                })
                .bind('mouseenter', $.proxy(function() {
                    this.helpEl.addClass('ui-state-hover');
                }, this))
                .bind('mouseleave', $.proxy(function() {
                    this.helpEl.removeClass('ui-state-hover');
                }, this))
                .bind('click', $.proxy(this._onHelpIconClick, this));

            $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));
        },

        _positionLayer: function() {
            this.helpEl.diy_calloutLayer('refresh');
        },

        _onHelpIconClick: function(e, ui) {
            //XXX: this function is based on the fact that diy_calloutLayer is initialized on this.helpEl
            //... but it does not take any precaution for the opposite situation.
            var helpEl = this.helpEl;
            if (helpEl.diy_calloutLayer('isVisible')) {
                helpEl.diy_calloutLayer('hide');
                return;
            }
            helpEl.diy_calloutLayer('render');
            this._renderHelpLinks();
            helpEl.diy_calloutLayer('show');
            return;
        },

        _renderHelpLinks: function() {
            var contentEl = this.helpEl.diy_calloutLayer('getContentEl'),
                $helpLinks, helpLinksWidget;

            if (!contentEl) {
                return;
            }

            contentEl.empty();

            $helpLinks = $('<div></div>')
                .addClass('help-links')
                .appendTo(contentEl);

            helpLinksWidget = new HelpLinks($helpLinks);
            helpLinksWidget.render();

            $helpLinks.bind('helplinksclick', $.proxy(this._onHelpLinkClick, this));
        },

        _onHelpLinkClick: function(e, data) {
            this.helpEl.diy_calloutLayer('hide');
        }
    });

    module.exports = Help;
}());


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var angular = __webpack_require__(756);

/**
 * Search in toolbar (angular module with controller for the search layer)
 */
(function() {
    'use strict';

    var DEFAULT_SEARCH_RESULTS = 5,
        MORE_RESULTS_INCREMENT = 5;

    var toolbarSearch;

    var search = angular.module('diy.search', ['ngSanitize']);

    diy.angular.loadFactories(search, ['diyl10n']);

    search.filter('isEmpty', function() {
        return $.isEmptyObject;
    });

    search.factory('toolbarSearch', function() {
        return toolbarSearch;
    });

    search.factory('appsCatalog', function() {
        return diy.editor.appsCatalog;
    });

    search.controller('SearchLayerCtrl', [
        '$scope', 'toolbarSearch', 'appsCatalog', '$timeout', 'diyl10n',
        function($scope, toolbarSearch, appsCatalog, $timeout, diyl10n) {

            /**
             * Refreshes the squeeze box + scrollbar when view changes
             */
            var refreshScroller = function() {
                // We use timeout to update the squeezebox after content has stabilized
                // and Angular has finished rendering the elements. We don't have
                // ngAnimate in 1.0.5 so we can't hook to ngShow
                $timeout(function() {
                    toolbarSearch.refreshScroller();
                });
            };

            /**
             * Flattens the results object which is mapped by providerName.
             * This results in an array with each element having a 'providerName' property
             * @param {Object.<String, Array>} results
             * @returns {Array}
             */
            var flattenResults = function(results) {
                var newResults = [];

                angular.forEach(results, function(providerResults, providerName) {
                    newResults = newResults.concat(
                        providerResults.map(function(result) {
                            result.providerName = providerName;
                            return result;
                        })
                    );
                });

                return newResults;
            };

            /**
             * Creates a map of categoryId => results from a flat array of results
             * @param results
             * @returns {Object.<String, Array>}
             */
            var mapResultsToCategories = function(results) {
                var map = {};

                results.forEach(function(result) {
                    var resultCategory;

                    switch (result.providerName) {
                        case 'elements':
                            var isInstalledFn = appsCatalog.isWebcomponentInstalled;
                            if (result.type !== 'webcomponent' || isInstalledFn(result.webcomponentId)) {
                                resultCategory = 'installed';
                            } else {
                                resultCategory = 'noninstalled';
                            }
                            break;

                        case 'features':
                            resultCategory = result.categoryId || result.providerName;
                            break;

                        default:
                            resultCategory = result.providerName;
                    }

                    map[resultCategory] = map[resultCategory] || [];
                    map[resultCategory].push(result);
                });

                return map;
            };

            /**
             * Formats the search results by category so we can use them in the view
             * @param {Object} results
             * @returns {Object}
             */
            var formatResults = function(results) {
                if ($.isEmptyObject(results)) {
                    return {};
                }

                results = flattenResults(results);
                results = mapResultsToCategories(results);
                return results;
            };

            /**
             * Search results
             *
             * Holds the results returned by the search providers.
             * @type {Object}
             */
            $scope.searchResults = {};
            /**
             * Search results formatted by category, used as view model
             *
             * This model changes when the search is triggered or when the installed
             * status of a webcomponent changes
             *
             * @type {Object}
             */
            $scope.results = {};

            $scope.categories = [{
                id: 'help',
                title: diyl10n('toolbarSearch.categoryLabels.help')
            }, {
                id: 'installed',
                title: diyl10n('toolbarSearch.categoryLabels.installed')
            }, {
                id: 'noninstalled',
                title: diyl10n('toolbarSearch.categoryLabels.noninstalled')
            }];

            /**
             * How many results to display in each category.
             *
             * If not specified, the default number or results will be displayed.
             * This is changed when pressing the "Show more results" button
             *
             * @type {Object.<string, number>}
             */
            $scope.resultLimit = {};

            /**
             * Keyboard selected result
             * @type {{catIndex: int, catId: string, position: int}}
             */
            $scope.selection = null;

            /**
             * The maximum number of results that are shown in the interface
             * per category. This is increased by the "Show more results" button
             * @param {String} catId
             * @returns {number}
             */
            $scope.getResultLimit = function(catId) {
                if (!this.resultLimit[catId]) {
                    return DEFAULT_SEARCH_RESULTS;
                }

                return this.resultLimit[catId];
            };

            /**
             * Reset the number of displayed results to the default, by removing
             * all values from the resultLimit object
             */
            $scope.resetResultLimit = function() {
                this.resultLimit = {};
            };

            $scope.showMoreResults = function(catId) {
                var resultsNo = this.getResultLimit(catId);
                this.resultLimit[catId] = resultsNo + MORE_RESULTS_INCREMENT;
                refreshScroller();

                $(document).trigger('diy-editor-search-showmoreclick');
            };

            $scope.hasHelpSearch = function() {
                return toolbarSearch.hasHelpSearch();
            };

            $scope.resultClick = function(e, index, result, catId) {
                toolbarSearch.openResult(e, index, result, catId);
            };

            $scope.calculateViewResults = function() {
                this.results = formatResults(this.searchResults);
                this.updateVisibleCategories();
            };

            /**
             * Handler for keyboard navigation
             * Called from outside of the angular module, so be careful to call
             * $scope.$apply() when changing the model
             *
             * @return {Boolean} true to prevent default behavior on the searchbox
             */
            $scope.handleKeyNav = function(e) {
                var keyCodes = $.ui.keyCode;

                switch (e.keyCode) {
                    case keyCodes.DOWN:
                    case keyCodes.RIGHT:
                        $scope.$apply(function() {
                            $scope.moveSelection(1);
                        });
                        return true;

                    case keyCodes.UP:
                    case keyCodes.LEFT:
                        $scope.$apply(function() {
                            $scope.moveSelection(-1);
                        });
                        return true;

                    case keyCodes.ENTER:
                    case keyCodes.NUMPAD_ENTER:
                        if (this.selection !== null) {
                            this.openSelection();
                            return true;
                        }
                        return false;

                    default:
                        return false;
                }
            };

            /**
             * Moves the keyboard selection up/down
             * @param {int} direction 1 for down, -1 for up
             */
            $scope.moveSelection = function(direction) {
                if (direction === 1) {
                    this.goToNextVisibleIndex();
                } else if (direction === -1) {
                    this.goToPrevVisibleIndex();
                } else {
                    throw new Error("Bad parameter direction = " + direction);
                }

                toolbarSearch.scrollToResult(this.selection.catId + '_' + this.selection.position);
            };

            $scope.updateVisibleCategories = function() {
                this.visibleCategories = this.categories.filter(function(category) {
                    return (
                        typeof this.results[category.id] !== 'undefined' &&
                            this.results[category.id].length > 0
                        );
                }, this);
            };

            /**
             * Moves the keyboard navigation selection down
             */
            $scope.goToNextVisibleIndex = function() {
                var catIndex, catId, limit, newCatIndex;

                if (this.selection === null) {
                    // If there is nothing selected, we just select the first
                    // item and exit
                    this.selection = {
                        catIndex: 0,
                        catId: this.visibleCategories[0].id,
                        position: 0
                    };
                    return;
                }

                catIndex = this.selection.catIndex;
                catId = this.selection.catId;
                limit = Math.min(this.getResultLimit(catId) - 1, this.results[catId].length - 1);

                if (this.selection.position >= limit) {
                    // Move to first item in next category
                    newCatIndex = (catIndex == this.visibleCategories.length - 1) ? 0 : catIndex + 1;
                    this.selection = {
                        catIndex: newCatIndex,
                        catId: this.visibleCategories[newCatIndex].id,
                        position: 0
                    }
                } else {
                    // Advance pointer in current category
                    this.selection.position++;
                }
            };

            /**
             * Moves the keyboard navigation selection up
             */
            $scope.goToPrevVisibleIndex = function() {
                var catIndex, newCatIndex, newCatId, newCatPos;

                if (this.selection === null) {
                    // If there is no selection we act as if the first element
                    // were selected and continue with normal flow
                    this.selection = {
                        catIndex: 0,
                        catId: this.visibleCategories[0].id,
                        position: 0
                    }
                }

                catIndex = this.selection.catIndex;

                if (this.selection.position == 0) {
                    // Move to previous category
                    newCatIndex = (catIndex == 0) ? this.visibleCategories.length - 1 : catIndex - 1;
                    newCatId = this.visibleCategories[newCatIndex].id;
                    newCatPos = Math.min(this.getResultLimit(newCatId) - 1, this.results[newCatId].length - 1);

                    this.selection = {
                        catIndex: newCatIndex,
                        catId: newCatId,
                        position: newCatPos
                    }
                } else {
                    // Just move pointer to previous item
                    this.selection.position--;
                }
            };

            $scope.clearSelection = function() {
                this.selection = null;
            };

            /**
             * Executes the result action on the current selection
             */
            $scope.openSelection = function() {
                if (this.selection === null) {
                    return;
                }
                var pos = this.selection.position,
                    catId = this.selection.catId;
                toolbarSearch.openResult(null, pos, this.results[catId][pos], catId);
            };

            /**
             * Determines if a result is selected (if it should be highlighted
             * in the view
             * @param {Object} result
             * @returns {boolean}
             */
            $scope.isSelected = function(result) {
                if (this.selection === null) {
                    return false;
                }
                return this.results[this.selection.catId][this.selection.position] === result;
            };

            /**
             * Refresh the results view when a webcomponent is (un)installed. The results
             * remain the same, but their category might change (installed vs noninstalled)
             * so we need to regenerate the view model
             */
            $(document).bind('diy-editor-appscatalog-wc-installed diy-editor-appscatalog-wc-uninstalled',
                function() {
                    $scope.$apply(function() {
                        $scope.calculateViewResults();
                    });
                }
            );

            // Update the view model when the results change
            $scope.$watch('searchResults', function() {
                $scope.calculateViewResults();
            });

            $scope.$watch('results', function(newValue, prevValue) {
                $scope.resetResultLimit();
                refreshScroller();
                $scope.clearSelection();
            })
    }]);

    /*
     * We configure the location service to use html5mode, which avoids a nasty
     * bug where angular would prepend a slash to the hashbang
     * (e.g. #/hm:cc-sa-item-elements), breaking the existing history manager
     * This avoids hacking the angular.js file with the "remove forwardslash" patch
     * (see the file in the folder where angular.js resides)
     */
    search.config(['$locationProvider', function($locationProvider) {
       $locationProvider.html5Mode({
           enabled: true,
           requireBase: false
       });
    }]);

    //TODO: put this template in a separate html file
    search.run(['$templateCache', 'diyl10n', function($templateCache, diyl10n) {

        $templateCache.put('searchResults.html',
            '<div class="results-wrapper" ng-hide="results | isEmpty">' +
                '<div class="category" ' +
                        'ng-repeat="cat in categories" ' +
                        'ng-if="results[cat.id].length > 0"' +
                '>' +
                    //TODO: abstract squeezebox markup
                    '<div class="diye-collapsible-category-header">' +
                        '<div class="diye-collapsible-category-positioned">' +
                            '<div class="diye-collapsible-category-title">' +
                                '<span ng-bind-html="cat.title"></span> ' +
                                '<span class="result-count">({{results[cat.id].length}})</span>' +
                            '</div>' +
                            '<div class="diye-collapsible-category-pointer"></div>' +
                            '<div class="diye-collapsible-category-arrow"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="diye-collapsible-category-content" ng-switch="cat.id">' +
                        '<div ng-switch-when="help">' +
                            '<ul class="results">' +
                                '<li class="result" data-result-id="{{cat.id}}_{{$index}}" ' +
                                    'ng-repeat="result in results[cat.id] | limitTo: getResultLimit(cat.id)" ' +
                                    'ng-class="{\'result-featured\': result.featured, \'result-active\': isSelected(result)}">' +

                                    '<a href="JavaScript:;" ng-click="resultClick($event, $index, result, cat.id)">' +

                                        '<span class="ui-icon" ng-class="{\'ui-icon-star\': result.featured, \'ui-icon-help\': !result.featured}"></span>' +
                                        '<div class="result-content">' +
                                            '<h3>{{result.title}}</h3>' +
                                            '<p>{{result.description}}</p>' +
                                        '</div>' +
                                    '</a>' +
                                '</li>' +
                            '</ul>' +

                            '<div class="more-results" ng-show="getResultLimit(cat.id) < results[cat.id].length">' +
                                '<a href="Javascript:;" ng-click="showMoreResults(cat.id)">' +
                                    '<span class="ui-icon"></span>' +
                                    diyl10n('toolbarSearch.showMoreResults') +
                                '</a>' +
                            '</div>' +
                        '</div>' +
                        '<div ng-switch-default>' +
                            '<ul class="results">' +
                                '<li class="result result-big" data-result-id="{{cat.id}}_{{$index}}" ' +
                                    'ng-repeat="result in results[cat.id] | limitTo: getResultLimit(cat.id)" ' +
                                    'ng-class="{\'result-active\': isSelected(result)}" ' +
                                '>' +
                                    '<a class="clearfix" href="JavaScript:;" ng-click="resultClick($event, $index, result, cat.id)">' +

                                        '<span class="ui-icon {{result.additionalCssClasses}}" style="background-image: url({{result.iconUrl}});"></span>' +
                                        '<div class="result-content">' +
                                            '<h3>{{result.name}}</h3>' +
                                            '<p>{{result.shortDescription}}</p>' +
                                        '</div>' +
                                    '</a>' +
                                '</li>' +
                            '</ul>' +

                            '<div class="more-results" ng-show="getResultLimit(cat.id) < results[cat.id].length">' +
                                '<a href="Javascript:;" ng-click="showMoreResults(cat.id)">' +
                                    '<span class="ui-icon {{result.additionalCssClasses}}"></span>' +
                                    diyl10n('toolbarSearch.showMoreResults') +
                                '</a>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="no-results-wrapper" ng-show="results | isEmpty">' +
                '<div class="no-results">' +
                    '<h3 class="subheading">' + diyl10n('toolbarSearch.noresults.message') + '</h3>' +
                    '<p ng-show="hasHelpSearch()">' + diyl10n('toolbarSearch.noresults.moreinfo') + '</p>' +
                '</div>' +
            '</div>'
        );
    }]);

    exports.init = function(_toolbarSearch) {
        toolbarSearch = _toolbarSearch;
    };
}());



/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var features = __webpack_require__(25);
var websiteData = __webpack_require__(4);
var Api_1 = __webpack_require__(537);
var Type_1 = __webpack_require__(540);
var App = (function () {
    function App() {
    }
    App.prototype.init = function () {
        Api_1.default.schedule(function () {
            if (features("domainConnected")
                || !websiteData.getNotificationData("noDomain").show) {
                Api_1.default.deleteOne(Type_1.default.NO_DOMAIN);
            }
            else {
                if (!websiteData.getNotificationData("noDomain").triggerShow) {
                    return;
                }
                Api_1.default.pushOne({
                    type: Type_1.default.NO_DOMAIN,
                    dismissed: false,
                    deleted: false
                });
            }
        });
    };
    return App;
}());
exports.App = App;


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var features = __webpack_require__(25);
var websiteData = __webpack_require__(4);
var Api_1 = __webpack_require__(537);
var Type_1 = __webpack_require__(540);
var App = (function () {
    function App() {
    }
    App.prototype.init = function () {
        var _this = this;
        var countingCookie = this.getCookieName();
        /** Only show if the Chat Notification is enabled */
        if (!features("chatNotification") || $.cookie(countingCookie) === "consumed") {
            return;
        }
        /** Create a start counting cookie */
        if (!$.cookie(countingCookie)) {
            $.cookie(countingCookie, (new Date()).getTime() / 1000, { path: "/" });
        }
        /** Check the cookie until it's time to show the chat bar */
        setTimeout(function () {
            /** Put the cookie on shown - to not show again in this session */
            $.cookie(countingCookie, "consumed", { path: "/" });
            /** Create chat notification when the time is right */
            _this.displayNotification();
        }, this.getDisplayDelay());
    };
    App.prototype.getDisplayDelay = function () {
        var displayDelay = 120;
        var dateTime = ((new Date()).getTime() / 1000);
        var timeElapsed = (dateTime - $.cookie(this.getCookieName()));
        var delay = (displayDelay - timeElapsed) * 1000;
        return Math.max(delay, 0);
    };
    App.prototype.getCookieName = function () {
        return "diy-chatnotification-counting-" + websiteData.getId();
    };
    App.prototype.displayNotification = function () {
        Api_1.default.schedule(function () {
            Api_1.default.pushOne({
                type: Type_1.default.CHAT
            });
        });
    };
    return App;
}());
exports.App = App;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var features = __webpack_require__(25);
var Api_1 = __webpack_require__(537);
var Type_1 = __webpack_require__(540);
var App = (function () {
    function App() {
        this.browserVersionIE = 10;
        this.browserVersionFirefox = 20;
    }
    App.prototype.init = function () {
        /** No Browser check if we are on mobile */
        if (!features("browserUpgrade") || ('ontouchend' in document)) {
            this.updateNotification(false);
        }
        /** Gets the message / link to show  depending on the upgrade */
        switch (true) {
            /** IE */
            case $.browser.msie:
                if (parseInt($.browser.version, 10) < this.browserVersionIE) {
                    this.updateNotification(true, 'upgrade', 'ie');
                }
                else {
                    this.updateNotification(false);
                    return;
                }
                break;
            /** Firefox */
            case $.browser.mozilla:
                if (parseInt($.browser.version, 10) < this.browserVersionFirefox) {
                    this.updateNotification(true, 'upgrade', 'firefox');
                }
                else {
                    this.updateNotification(false);
                    return;
                }
                break;
            /** Chrome + Safari */
            case $.browser.webkit:
                this.updateNotification(false);
                break;
            /** Others */
            default:
                this.updateNotification(true, 'switch', 'firefox');
                break;
        }
    };
    App.prototype.updateNotification = function (show, msgType, browserType) {
        var payload = features.getPayload("browserUpgrade");
        if (!show) {
            Api_1.default.schedule(function () {
                Api_1.default.deleteOne(Type_1.default.BROWSER_UPGRADE);
            });
        }
        else if (!payload.doNotShow) {
            Api_1.default.schedule(function () {
                var notificationPayload = {
                    browserType: browserType,
                    msgType: msgType
                };
                var notificationObject = {
                    type: Type_1.default.BROWSER_UPGRADE,
                    deleted: false,
                    payload: notificationPayload
                };
                if (payload.counter >= payload.counterMax) {
                    notificationObject.dismissed = false;
                }
                Api_1.default.pushOne(notificationObject);
            });
        }
    };
    return App;
}());
exports.App = App;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var features = __webpack_require__(25);
var websiteData = __webpack_require__(4);
var Api_1 = __webpack_require__(537);
var Type_1 = __webpack_require__(540);
var maintenanceMode = __webpack_require__(668);
var App = (function () {
    function App() {
    }
    App.prototype.init = function () {
        Api_1.default.schedule(function () {
            var notPublishedData = websiteData.getNotificationData("notPublished");
            if (!features("domainConnected")
                || !maintenanceMode.getState()
                || !maintenanceMode.isFirstPublish()
                || !notPublishedData.show) {
                Api_1.default.deleteOne(Type_1.default.NOT_PUBLISHED);
            }
            else if (notPublishedData.triggerShow) {
                Api_1.default.pushOne({
                    type: Type_1.default.NOT_PUBLISHED,
                    dismissed: false,
                    deleted: false
                });
            }
        });
    };
    return App;
}());
exports.App = App;


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Resource_1 = __webpack_require__(644);
var ResourceManager = (function () {
    function ResourceManager(resourceFactory) {
        this.loadedResources = [];
        this.resourceFactory = resourceFactory;
    }
    ResourceManager.normalizeResourceUrl = function (url) {
        return url.replace(/^http.?:\/\//, '//');
    };
    ResourceManager.prototype.init = function () {
        this.initLoadedStyles();
    };
    ResourceManager.prototype.add = function (type, url, callback) {
        var _this = this;
        if (callback === void 0) { callback = void (0); }
        var executeCallback = function (success) {
            if (callback) {
                return callback(success);
            }
        };
        var promises = [];
        var sources = [];
        if (typeof url === 'string') {
            sources.push(url);
        }
        else {
            sources = url;
        }
        sources.forEach(function (source) {
            var resource = _this.resourceFactory.create(type, source);
            if (!_this.isResourceLoaded(resource)) {
                var promise = resource.load().then(function () {
                    _this.loadedResources.push(resource);
                });
                promises.push(promise);
            }
        });
        Promise.all(promises)
            .then(function () {
            executeCallback(true);
        })
            .catch(function () {
            executeCallback(false);
        });
    };
    ResourceManager.prototype.isResourceLoaded = function (resource) {
        return this.loadedResources.some(function (loaded) { return resource.equals(loaded); });
    };
    ResourceManager.prototype.initLoadedStyles = function () {
        var _this = this;
        Array.prototype.slice.call(window.document.styleSheets).forEach(function (style) {
            if (style.href && style.href.length) {
                var resource = _this.resourceFactory.create(Resource_1.ResourceType.Css, ResourceManager.normalizeResourceUrl(style.href));
                _this.loadedResources.push(resource);
            }
        });
    };
    return ResourceManager;
}());
exports.default = ResourceManager;


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Css_1 = __webpack_require__(863);
var Resource_1 = __webpack_require__(644);
var ResourceFactory = (function () {
    function ResourceFactory() {
    }
    ResourceFactory.prototype.create = function (type, source) {
        switch (type) {
            case Resource_1.ResourceType.Css:
                return new Css_1.default(Resource_1.ResourceType.Css, source);
            default:
                throw new Error("Unsupported resource type");
        }
    };
    return ResourceFactory;
}());
exports.default = ResourceFactory;


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var Resource_1 = __webpack_require__(644);
var CssResource = (function (_super) {
    tslib_1.__extends(CssResource, _super);
    function CssResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CssResource.prototype.load = function () {
        return this.addStylesheetToPage();
    };
    CssResource.prototype.addStylesheetToPage = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var document = window.document;
            var refs = document.getElementsByTagName("head")[0].childNodes;
            var ref = refs[refs.length - 1];
            var stylesheet = document.createElement("link");
            stylesheet.type = "text/css";
            stylesheet.rel = "stylesheet";
            stylesheet.media = "all";
            stylesheet.href = _this.source;
            var eventsListeners = {
                clear: function () {
                    stylesheet.removeEventListener("load", eventsListeners.load);
                    stylesheet.removeEventListener("error", eventsListeners.error);
                },
                load: function () { eventsListeners.clear(); resolve(); },
                error: function () { eventsListeners.clear(); reject(); }
            };
            stylesheet.addEventListener("load", eventsListeners.load);
            stylesheet.addEventListener("error", eventsListeners.error);
            ref.parentNode.insertBefore(stylesheet, ref.nextSibling);
        });
    };
    return CssResource;
}(Resource_1.Resource));
exports.default = CssResource;


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(865);
var defaultClickRejectionStrategy = __webpack_require__(866);

var alreadyInjected = false;

module.exports = function injectTapEventPlugin (strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  if (false) {
    invariant(
      !alreadyInjected,
      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
It is recommended to call injectTapEventPlugin() just before you call \
ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
itself, please contact the maintainer as it shouldn\'t be called in library code and \
should be injected by the application.'
    )
  }

  alreadyInjected = true;

  __webpack_require__(66).injection.injectEventPluginsByName({
    'TapEventPlugin':       __webpack_require__(867)(shouldRejectClick)
  });
};


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule invariant
 */

"use strict";

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function (condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ },
/* 866 */
/***/ function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TapEventPlugin
 * @typechecks static-only
 */

"use strict";

var EventConstants = __webpack_require__(64);
var EventPluginUtils = __webpack_require__(68);
var EventPropagators = __webpack_require__(65);
var SyntheticUIEvent = __webpack_require__(93);
var TouchEventUtils = __webpack_require__(868);
var ViewportMetrics = __webpack_require__(94);

var keyOf = __webpack_require__(869);
var topLevelTypes = EventConstants.topLevelTypes;

var isStartish = EventPluginUtils.isStartish;
var isEndish = EventPluginUtils.isEndish;

var isTouch = function(topLevelType) {
  var touchTypes = [
    topLevelTypes.topTouchCancel,
    topLevelTypes.topTouchEnd,
    topLevelTypes.topTouchStart,
    topLevelTypes.topTouchMove
  ];
  return touchTypes.indexOf(topLevelType) >= 0;
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var ignoreMouseThreshold = 750;
var startCoords = {x: null, y: null};
var lastTouchEvent = null;

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(axis, nativeEvent) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return axis.page in nativeEvent ?
    nativeEvent[axis.page] :
    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  topLevelTypes.topTouchStart,
  topLevelTypes.topTouchCancel,
  topLevelTypes.topTouchEnd,
  topLevelTypes.topTouchMove,
];

var dependencies = [
  topLevelTypes.topMouseDown,
  topLevelTypes.topMouseMove,
  topLevelTypes.topMouseUp,
].concat(touchEvents);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: keyOf({onTouchTap: null}),
      captured: keyOf({onTouchTapCapture: null})
    },
    dependencies: dependencies
  }
};

var now = (function() {
  if (Date.now) {
    return Date.now;
  } else {
    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
    return function () {
      return +new Date;
    }
  }
})();

function createTapEventPlugin(shouldRejectClick) {
  return {

    tapMoveThreshold: tapMoveThreshold,

    ignoreMouseThreshold: ignoreMouseThreshold,

    eventTypes: eventTypes,

    /**
     * @param {string} topLevelType Record from `EventConstants`.
     * @param {DOMEventTarget} targetInst The listening component root node.
     * @param {object} nativeEvent Native browser event.
     * @return {*} An accumulation of synthetic events.
     * @see {EventPluginHub.extractEvents}
     */
    extractEvents: function(
      topLevelType,
      targetInst,
      nativeEvent,
      nativeEventTarget
    ) {

      if (isTouch(topLevelType)) {
        lastTouchEvent = now();
      } else {
        if (shouldRejectClick(lastTouchEvent, now())) {
          return null;
        }
      }

      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }
      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticUIEvent.getPooled(
          eventTypes.touchTap,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }

  };
}

module.exports = createTapEventPlugin;


/***/ },
/* 868 */
/***/ function(module, exports) {

/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TouchEventUtils
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] :
           hasTouches ? touches[0] :
           nativeEvent;
  }
};

module.exports = TouchEventUtils;


/***/ },
/* 869 */
/***/ function(module, exports) {

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyOf
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
"use strict";

var keyOf = function (oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

var EmotionHeader = __webpack_require__(871);
var Shop = __webpack_require__(872);
var Title = __webpack_require__(873);
var Logo = __webpack_require__(874);
var Settings = __webpack_require__(875);
var Preview = __webpack_require__(876);
var Background = __webpack_require__(877);

var $ = __webpack_require__(3);

var ns = diy.core.namespace('diy.editor.emotionHeader');

Object.assign(ns, {
    EmotionHeader: EmotionHeader,
    Shop: Shop,
    Title: Title,
    Logo: Logo,
    Settings: Settings,
    Background: Background,
    Preview: Preview
});


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

/*
 * Emotion header controller
 *
 * @class EmotionHeader
 * @depends jquery.js, CC.js, jquery.actionController.js
 * @author Oleg Slobodskoi aka Kof
 */

var $ = __webpack_require__(3);
var features = __webpack_require__(25);

module.exports = function ( _super ) {
    var d = this.d = {
            footerHeight: 17,
            toolbarHeight: 30,
            sidebarWidth: 100,
            speed: 300,
            saveTimeout: 500,
            path: {
                show: '/app/module/emotionheader/show',
                update: '/app/module/emotionheader/update',
                logo: '/app/module/emotionheader/logoupdate',
                removeLogo: '/app/module/emotionheader/removelogo',
                search: '/app/module/emotionheader/searchimages',
                autocomplete: '/app/module/emotionheader/gettags'
            },
            baseLoadViewUrl: '/app/module/emotionheader/',
            viewsDependencies: {
                'Settings': 'Background'
            },
            resizableOptions: {
                minHeight: 300,
                maxHeight: 600,
                containment: 'document',
                handles: {
                    s: '#eh-resize-handle'
                },
                start: function () {

                },
                stop: function () {

                },
                alsoResize: '#eh-editor-content'
            },
            keyVisuals: {
                hasConfirmed: false
            },
            params: {}
        },
        uploadedLogo = false,
        logoPanelOpened = false,
        imageUploaded = false,
        imageUploadPanelOpened = false;

    var self = this,
        $eh = this.$eh = $('#emotion-header'),
        $ehImg = this.$ehImg = $('#emotion-header-img', $eh), // TODO should be deleted after refactoring
        $edit = this.$edit = $('#eh-edit'),
        $ehe = this.$ehe = $('#eh-editor'),
        $eheToolbar = $('#eh-editor-toolbar', $ehe),
        $eheContent = this.$eheContent = $('#eh-editor-content', $ehe),
        $eheHelp = this.$eheHelp = $('.moduleHelpLink', $ehe),
        $close = $('#eh-close', $ehe),
        $toolbar = $('#eh-tabs', $ehe),
        opened = false,
        loading = false,
        timeout,
        prevView,
        pageId = this.pageId = $ehe.attr('data-page');
    //TODO: refactor this for save modes
    //pageName = this.pageName = $ehe.attr('data-page-name'),
    //websiteHasPageModule = this.websiteHasPageModule = ($ehe.attr('data-website-has-module') == 'true');

    this.loadedViews = {};

    this.model = null;
    //Store the ajax request for the model so we can abort it
    this._modelXhrReq = null;

    this.size = {
        height: $eh.outerHeight(),
        width: $eh.outerWidth()
    };

    this.offset = {
        top: $eh.offset.top,
        left: $eh.offset.left
    };

    this.init = function () {
        cms.common.util.EventingMixin.mixin(this);

        var timeout;

        /* exit, if template has no emotion header*/
        if ($eh.length == 0) {
            return false;
        }

        this.placeEditor();

        $eh.add($edit).multihover(function () {
            if (!opened) {
                clearTimeout(timeout);
                self.showEditButton(d.speed);
            }
            ;
        }, function () {
            if (!opened) {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    self.hideEditButton(d.speed);
                }, 2000);
            }
            ;
        });

        // set a z-index only as big as it's needed //
        $edit.css({'z-index': diy.editor.getNewTopZIndex(undefined, undefined, '.diyw') + 1});

        $eh
            .add($ehe)
            .add($edit)
            .actionController(self, {
                events: 'click keypress addTooltip updateTooltip slide slidechange',
                history: true
            });

        $(document).bind('diy.cms.EmotionHeader.shopHasProducts', function (e, data) {
            // tell server-side that shop products situation has changed
            $.ajaxSetup({contentType: "application/x-www-form-urlencoded; charset=UTF-8"});
            $.post('/app/module/emotionheader/shopproductstoggle',
                {cstok: jimdoData.cstok});

            if (null === self.model) {
                self.loadViewClick(null, null, false);
            } else {
                if (0 == data) {
                    CC.EmotionHeader.model.set('shopHasProducts', data, false);
                } else {
                    method = "system.public.hasShoppingbasket";
                    proxy_path = (window.webserverProtocol && (window.webserverProtocol == "https://") ? window.sslServerUrl : '')
                    + '/proxy';

                    args = {
                        'mod.instance_id': data.instance_id,
                        'mod.locale': apsinth.lang,
                        'mod.externalModuleId': data.moduleId
                    };
                    mm[data.moduleId].ajaxUtil.rpcRequest(proxy_path + '/rpc/', method, args, function (data, error) {
                        CC.EmotionHeader.model.set('shopHasProducts', data ? "1" : "0", false);
                    }, this);
                }
            }
        });
        $(document).bind('CC.EmotionHeader.Preview.onHeaderHeightModified', function (e, height) {
            self.size.height = $eh.outerHeight();
            self.placeEditor();
        });


        $(document).bind('CC.EmotionHeader.Preview.onTaskStarted', function (e) {
            self.loading(true);
        });

        $(document).bind('CC.EmotionHeader.Preview.onTaskCompleted', function (e) {
            self.loading(false);
        });


        $(window).resize(function () {
            self.placeEditor();
        });

        // set up the eh edit button
        $edit.button();

        // set up the eh editor tabs
        $toolbar.tabs();
        $toolbar.bind('tabsbeforeactivate', function (event, ui) {
            var params;

            var dataEl = ui.newTab.find('a')[0];

            params = dataEl.dataset && dataEl.dataset.params ?
                dataEl.dataset.params :
                dataEl.attributes['data-params'].value;

            $(document).trigger('diy-emotionheader-sectionOpened', {
                'tabName': params.toLowerCase()
            });
            /* track opening of a header section */
            $(document).trigger('diy-editor-generic-sectionAccessed', {
                sectionCodeName: 'eh-editor.' + params.toLowerCase()
            });
        });

        $(document).bind('diy-eh-component-clicked diy-eh-component-dragstart', function (ev, data) {
            switch (data.elem.attr('id')) {
                case 'cc-eh-img-wrapper':
                    $toolbar.find('#eh-background').click();
                    break;
                case 'emotion-header-title':
                case 'emotion-header-title-bg':
                    $toolbar.find('#eh-title').click();
                    break;
                case 'emotion-header-logo':
                    $toolbar.find('#eh-logo').click();
                    break;
                case 'scButton':
                    $toolbar.find('#eh-shop').click();
                    break;
            }
        });

        // set up the save and cancel eh editor handlers
        $('#eh-save', $ehe).button().click(function () {
            if (typeof CC.EmotionHeader.loadedViews.Background !== 'undefined') {
                self._ignoreDataChange = true;
                self.model.setImageList(CC.EmotionHeader.loadedViews.Background.getImageList());
                self._ignoreDataChange = false;
            }
            self.model.trigger('eh-save');
            self.save({successCallback: self.hideEditor});
        });
        $('#eh-cancel', $ehe).button().click(function () {
            self.model.trigger('eh-cancel');
            self.cancel();
        });
    };
    this.showEditButton = function (duration) {
        if (!this.$editWrap) {
            this.$editWrap = $edit.wrap(
                $('<div></div>').css({
                    'position': 'absolute',
                    'top': '0',
                    'left': '0'
                })
            ).parent();
        }

        this.$editWrap
            .show()
            .offset($eh.offset())
            .css({
                width: $eh.innerWidth(),
                height: $eh.innerHeight()
            });

        $edit.slideDown(duration);
    };

    this.hideEditButton = function (duration) {
        $edit.slideUp(duration, function () {
            if (self.$editWrap) {
                self.$editWrap.hide();
            }
        });
    };
    this.placeEditor = function () {
        var eheWidth = $ehe.outerWidth();

        if (typeof($eh) == 'object' && $eh.offset) {
            self.offset = $eh.offset();
        }
        $ehe.css({
            top: self.size.height + self.offset.top,
            /* in case it's ie8, outerWidth - width gets us the border width on both sides */
            width: (self.size.width > eheWidth ? self.size.width : eheWidth) - ($.isBrowser.ie8 ? $ehe.outerWidth() - $ehe.width() : 0),
            left: self.offset.left + eheWidth + d.sidebarWidth > $(window).width() ? ((eheWidth - self.size.width) < self.offset.left ? self.offset.left - (eheWidth - self.size.width) : self.offset.left) : self.offset.left
        });
    };

    //TODO: refactor for save options
    /*this.getSaveMode = function() {
     var mode = $('#eh-keyvisual-mode').val();
     return mode;
     };

     this.confirmSave = function(saveFn, context, abortFn, target, forceMode) {

     var mode = forceMode || this.getSaveMode();

     // only show the confirm box if there is at least one other per page module
     // and there the save mode is different than the already used save mode
     if (!this.websiteHasPageModule || mode == this.pageSaveMode
     // || d.keyVisuals.hasConfirmed
     ) {
     saveFn.call(context);
     return;
     }

     switch (mode) {
     case 'page':
     var msg = jimdoData.messages.keyVisualsPage;
     break;
     case 'inherit':
     var msg = jimdoData.messages.keyVisualsInherit;
     break;
     case 'global':
     var msg = jimdoData.messages.keyVisualsGlobal;
     break;
     }
     // replace page name in confirm message
     msg = msg.replace('{pagename}', this.pageName);

     $(target || '#eh-keyvisual-mode').message({
     message: msg,
     status: 'confirm',
     closable: false,
     width: 360,
     mainContainer: $ehe,
     template: '<div class="eh-confirm-dialog"><p class="x-message-content">#message#</p><br/><br/>\
     <button type="button" class="x-message-button-ok x-message-action" selected="selected">'+jimdoData.messages.save+'</button>\
     <button type="button" class="x-message-button-abort x-message-action">'+jimdoData.messages.cancel+'</button>\
     </div>',
     onClose: function(e, status, ctx) {
     if (status == 'ok') {
     saveFn.call(context);
     d.keyVisuals.hasConfirmed = true;
     } else {
     if (typeof abortFn == "function") {
     abortFn.call(context);
     }
     }
     }
     });
     };*/
    this._ignoreDataChange = false;
    var dataChangeTriggerTimeout;
    this.listenDataChange = function (model, data, changed, extra) {
        var ignoreTrigger = false;
        if (extra && extra.dataChanged === false) {
            ignoreTrigger = true;
        }
        ignoreTrigger = ignoreTrigger || this._ignoreDataChange;
        if (!ignoreTrigger) {
            var self = this;
            dataChangeTriggerTimeout && clearTimeout(dataChangeTriggerTimeout);
            dataChangeTriggerTimeout = setTimeout(function () {
                self.triggerDataChanged();
            }, 500);
        }
    };
    this.dataChanged = false;
    this.triggerDataChanged = function () {
        if (this.dataChanged != true) {
            this.dataChanged = true;
            $(document.body).trigger('EHeaderTriedModifications.BSA');
        }
    };
    /**
     * this function is triggered with actionController plugin help, when an tab is clicked
     */
    this.loadViewClick = function (e, viewName, doOpenEditor) {
        // doOpenEditor is optional. true is default.
        if (typeof(doOpenEditor) == 'undefined' || doOpenEditor == null) {
            doOpenEditor = true;
        }

        if (!opened && doOpenEditor) {
            Modul.abortEditingModules();
            self.openEditor();
        }

        //Load model
        if (self.model === null) {
            self.loadModel(function() {
                self.loadViewClick(e, viewName, doOpenEditor);
            });
            return false;
        }

        //Load Preview
        if (!self._previewInitialized) {
            self._previewInitialized = true;
            $.construct('CC.EmotionHeader.Preview', diy.editor.emotionHeader.Preview, {lazy: true});
            $.construct('CC.EmotionHeader.Preview', 'create');
        }

        // if we should not open editor we don't bother with viewName
        if (!doOpenEditor) {
            return false;
        }

        // active is the default tab to open
        if (viewName == 'active') {
            //Hack to trigger actionController action
            //By default this is the first tab
            var activeTab = $toolbar.tabs('option', 'active');
            $toolbar.find('a').eq(activeTab || 0).trigger('click');
            return false;
        }

        self.switchView(viewName);
        return false;
    };

    this.reload = function() {
        this.loadModel(function() {
            self.loadViewClick(null, 'active', false);
        });
    };

    this.loadModel = function(callback) {
        self.loading(true);
        if (self._modelXhrReq !== null) {
            self._modelXhrReq.abort();
        }
        self._modelXhrReq = $.ajax({
            url: d.path.show,
            data: {pageId: self.pageId},
            method: 'GET',
            dataType: 'json',
            complete: function () {
                self.loading(false);
                self._modelXhrReq = null;
            },
            error: function () {
                //TODO: give a meaningful message
            },
            success: function (response) {
                if (response.status != 'success') {
                    //TODO: error
                } else {
                    if (self.model) {
                        self._ignoreDataChange = true;
                        self.model.loadData(response.data);
                        self._ignoreDataChange = false;
                        self.dataChanged = false;
                    } else {
                        var model = new EmotionHeaderModel();
                        model.loadData(response.data);
                        self.model = model;
                        self.model.bind('change', $.proxy(self.listenDataChange, self));
                    }

                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            }
        });
    }

    /**
     * this function will load the view, switch to it and init it
     * after that will run the callback if passed
     * if view is already loaded will return false
     */
    this.loadView = function (viewName, callback, clbParams, clbScope) {
        var self = this, viewWrapper;

        if (this.loadedViews[viewName]) {
            this.switchView(viewName);
            return false;
        }

        if (d.viewsDependencies[viewName]) {
            var parentViewName = d.viewsDependencies[viewName];

            if (self.loadedViews[parentViewName]) {
                viewWrapper = this.loadedViews[parentViewName].switchSubView(viewName);
            } else {
                this.loadView(
                    parentViewName,
                    function () {
                        this.loadView(viewName, callback, clbParams, clbScope);
                    },
                    this
                );
                return;
            }
        }
        this.loading(true);

        self.loadedViews[viewName] = new diy.editor.emotionHeader[viewName](self);
        $.get(d.baseLoadViewUrl + viewName.toLowerCase(), function (data) {
            if (!viewWrapper) {
                viewWrapper = $('<div id="eh-view-wrapper-' + viewName + '"/>');
                $($eheContent[0]).append(viewWrapper);
            }
            self.switchView(viewName);
            viewWrapper.html(data);
            var view = self.loadedViews[viewName];
            view.viewWrapper = viewWrapper;
            view.init();
            if (typeof view.updateView == 'function') { // TODO remove this when all views are refactored
                view.updateView(self.model, null, self.model.getAll());
                self.model.bind('change', self.model.toHandler(view.updateView, view));
            }
            self.loading(false);
            if (callback) {
                clbScope = clbScope || self;
                clbParams = clbParams || [];
                callback.apply(clbScope, clbParams);
            }
        });
        return true;
    };

    this.switchView = function (viewName) {
        if (this.activeView !== undefined && this.activeView !== viewName) {
            self.trigger('switchView', viewName);
        }

        if (!self.loadedViews[viewName]) {
            self.loadView.call(self, viewName);
            return;
        }

        if (d.viewsDependencies[viewName]) {
            var parentView = d.viewsDependencies[viewName];
            this.switchView(parentView);
            self.loadedViews[parentView].switchSubView(viewName);
            return;
        }
        var view = self.loadedViews[viewName];

        // mark active selected view tab and mark inactive currently active tab
        $('a.active', $toolbar).removeClass('active');
        $('#' + view.tabElementId, $toolbar).addClass('active');

        // this is needed for styling
        if (!this.baseCssClass) {
            self.loading(false);
            this.baseCssClass = $ehe.attr('class');
        }
        $ehe.attr('class', view.tabElementId + ' ' + this.baseCssClass);

        // update the Help button with the new data value
        $eheHelp.attr('data', view.tabElementId);

        $('#eh-view-wrapper-' + this.activeView).hide();
        $('#eh-view-wrapper-' + viewName).show();
        this.activeView = viewName;

        var bubbleEl = $('#eh-editor .feature-guidance-help-button');
        bubbleEl.hide();

        if (typeof view.onShow === 'function') {
            view.onShow();
        }
    };

    this.hideEditor = function () {
        if (!opened) {
            return false;
        }
        opened = false;
        // scroll up to the editor
        $ehe.slideUp(d.speed, function () {
            $eh.scrollIntoView();
        });
        d.keyVisuals.hasConfirmed = false;
        $eh.removeClass('cc-eh-opened');

        if (self._modelXhrReq !== null) {
            self._modelXhrReq.abort();
        }

        this.trigger('hide', this);
        $.construct('CC.EmotionHeader.Preview', 'destroy');
        // if we let current hash, on page refresh it will automatically
        // load the last opened view, so it's set to 'eh-close' to
        // prevent browser scroll.
        jQuery(window).history('add', 'eh-close');
        return false;
    };

    this.isOpen = function () {
        return opened;
    };

    this.actionUpdateTooltip = function (e, value) {
        var $tip = $(this).data(this.id);
        $tip.html(value);
    };

    this.actionSlide = function (e, ui) {
        var self = this;
        setTimeout(function () {
            $(self).data(self.id).text(ui.tooltipValue);
        }, 20);
    };

    this.actionSlidechange = function (e, ui) {
        var self = this;
        setTimeout(function () {
            $(self).data(self.id).text(ui.tooltipValue);
        }, 20);
    };

    this.loading = function (sw) {
        loading = sw;
        $ehe[sw ? 'addClass' : 'removeClass']('eh-loading');
        return self;
    };


    this.save = function (options) {
        if (self.model === null) {
            return false;
        }

        if (self.model.isDirty()) {
            var settings = self.model.getAll();

            //  check if a logo exists  &&
            if (settings.logoDeleted == 0 &&
                    // if it was just uploaded or just set visible  &&
                (self.model.getDirtyStatus('logoDeleted') || self.model.getDirtyStatus('logoVisible')) &&
                    // the logo is visible
                settings.logoVisible == 1) {
                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Applied',
                    'name': 'Logo'
                });
            }

            $.ajaxSetup({
                contentType: "application/x-www-form-urlencoded; charset=UTF-8"
            });
            self.loading(true);
            $.post(d.path.update + '?pageId=' + self.pageId, settings, function (data) {
                self.loading(false);
                if (typeof data.status != 'undefined') {
                    var scope = options.scope || self;
                    if (data.status == 'ok' && options.successCallback) {
                        features.disableFeature('EHInPristineCondition');
                        if (self.uploadedLogo == true) {
                            $(document.body).trigger('LogoSaved.BSA');
                        }
                        if (self.imageUploaded == true) {
                            $(document.body).trigger('EHeaderUploadedOwnImageSaved.BSA');
                        }
                        if (self.dataChanged) {
                            $(document.body).trigger('EHeaderModificationsSaved.BSA');
                        }
                        self.model.commitChanged();
                        options.successCallback.apply(scope, arguments);
                    }
                    if (data.status == 'error' && options.errorCallback) {
                        options.errorCallback.apply(scope, arguments);
                    }
                    self._ignoreDataChange = true;
                    self.model.loadData(data.model_data.data);
                    self._ignoreDataChange = false;
                    self.dataChanged = false;
                    if (self.model.getBackgroundVisible()) {
                        diy.module.emotionHeader.slideShow.start(data.model_data.data.slides);
                    }
                }
                self.trigger('collapse', self, [data.status]);
            }, 'json');
        } else {
            // TODO user didn't make any change so maybe we should warn it about that
            // for now, just call the successCallback
            var scope = options.scope || self;
            if (options.successCallback) {
                options.successCallback.apply(scope, []);
            }
            self.trigger('collapse', self, ['ok']);
        }
    };

    this.cancel = function () {
        if (self.model !== null) {
            //force cancel of logo data
            self.model.cancelChanged({action: 'cancel', dataChanged: false});
        }
        this.hideEditor();
        self.trigger('collapse', self);
        diy.module.emotionHeader.slideShow.start()
    };

    this.openEditor = function () {
        if (opened) {
            return false;
        }

        this.uploadedLogo = false;
        this.logoPanelOpened = false;
        this.imageUploaded = false;
        this.imageUploadPanelOpened = false;
        this.dataChanged = false;

        diy.module.emotionHeader.slideShow.stop();

        if (window.diy.core.namespace('diy.editor.siteadmin.switchbox').isActive) {
            $('#container').message({
                top: self.offset.top + (self.size.height - 80 ) / 2,
                left: self.offset.left + (self.size.width - 300 ) / 2,
                width: 300,
                status: 'alert',
                message: $ehe.attr('data-switch-mode')
            });
            return false;
        }
        ;

        /* track that the eh item has been clicked */
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'eh-editor'
        });

        $(document.body).trigger('EHeaderOpened.BSA');
        $(document.body).trigger('diy-editor-EH-opened');

        opened = true;
        this.hideEditButton(0);
        $eh.addClass('cc-eh-opened');

        $ehe.slideDown(d.speed, function () {
            var bubbleEl = $('#eh-editor .feature-guidance-help-button');
            bubbleEl.hide();
            if ($toolbar.tabs('option', 'active') === 0 && self.activeView) {
                $(document).trigger('eh-background-show');
                if (this.model.get('backgroundVisible') == 1) {
                    bubbleEl.attr('data', 'header').show();
                }
            }
            $ehe.scrollIntoView();
        }.bind(this));

        /* trigger Eventing-Mixin */
        if (self.activeView) {
            if (self.trigger instanceof Function) {
                self.trigger('onload', self);
            }
        }
        if (self.activeView == 'Logo') {
            $(document.body).trigger('LogoPanelOpened.BSA');
            self.logoPanelOpened = true;
        }
        this.trigger('open', this);

        return true;
    };

    // TODO copy-pasted from picturemanipulation.js
    // encapsulate this in a custom control
    this.initSlider = function (params, optionControlMapper, model, invertValue) {
        invertValue = invertValue === true; // default is false
        var getInverted = function (val) {
            return invertValue ? params.min + (params.max - val) : val;
        }
        $(params.id).diy_slider({
            min: params.min,
            max: params.max,
            step: params.step,
            tipText: params.formatter,
            slide: function (e, ui) {
                optionControlMapper[params.option].valueChanged(getInverted(ui.value), true);
                if (typeof params.onSlide === 'function') {
                    params.onSlide.call($(params.id), getInverted(ui.value));
                }
            },
            stop: function (e, ui) {
                optionControlMapper[params.option].valueChanged(getInverted(ui.value), false);
            }
        });
        optionControlMapper[params.option] = {
            getValue: function () {
                var val = getInverted($(params.id).diy_slider('value'));
                /* call the mapper, if defined */
                val = typeof params.getMapper === 'function' ? params.getMapper(val) : val;
                return val;
            },
            setValue: function (val) {
                var sliderVal = typeof params.setMapper === 'function' ? params.setMapper(val) : val;
                $(params.id).diy_slider('value', getInverted(sliderVal));
            },
            valueChanged: function (sliderVal, isChanging) {
                /* call the mapper, if defined */
                var val = typeof params.getMapper === 'function' ? params.getMapper(sliderVal) : sliderVal;
                // with 5th param we force to notify the event, because
                // otherwise those views that listens only when
                // isChanging == false will not be notified
                model.set(params.option, val, true, {isChanging: isChanging}, true);
            }
        };
    };

    var isVisible = function (imgEl) {
        return imgEl && imgEl.length && imgEl.is(':visible')
            && imgEl.css('visibility') !== 'hidden'
            && imgEl.parent().css('visibility') !== 'hidden';
    };

    /**
     * Returns background image element only if it is visible.
     */
    this.getBackgroundImageEl = function () {
        var imgEl = null;
        if (!this.model) {
            // first check if the emotion header exists and has images //
            if (
                !this.$eh || !this.$eh.length || !this.$eh.attr('data-imagescount') || parseInt(this.$eh.attr('data-imagescount'), 10) === 0
            ) {
                return null;
            }

            if (isVisible(jQuery('#emotion-header-img'))) {
                imgEl = jQuery('#emotion-header-img');
            }
        } else {
            if (this.model.getBackgroundVisible()) {
                var bgSource = this.model.getBackgroundSourceType();

                if (!(bgSource == 'ImageUpload' && this.model.getUploadedImageId() == -1)) {
                    imgEl = jQuery('#cc-eh-img-preview');
                    if (!isVisible(imgEl)) {
                        imgEl = jQuery('#emotion-header-img');
                    }
                }
            }
        }
        return (imgEl && imgEl.length > 0) ? imgEl : null;
    };

    /**
     * Returns logo image element only if it is visible.
     */
    this.getLogoImageEl = function () {
        var imgEl = jQuery('#emotion-header-logo');
        if (isVisible(imgEl)) {
            return imgEl;
        }

        return null;
    };

    /**
     * Returns title bg element only if it is visible. otherwise null
     */
    this.getTitleBgEl = function () {
        var titleBgEl = jQuery('#emotion-header-title-bg');
        if (isVisible(titleBgEl)) {
            return titleBgEl;
        }

        return null;
    };

    var EmotionHeaderModel = cms.common.data.Model.extend({
        controllerUrl: '/app/module/emotionheader/',
        bgImageSourceOpts: {
            Gallery: ['imageId', 'imageVersion'], //Keyvisual
            External: ['uploadedImageId', 'externalImageId'], //GFXBOOST
            Patterns: ['patternId', 'patternBw', 'bgColor'],
            ImageUpload: ['uploadedImageId']
        },
        bgImageDefaultSettings: {
            backgroundEdited: 0,
            backgroundVertPos: 50,
            backgroundHorPos: 50,
            backgroundZoom: 100,
            brightness: 0,
            sharpen: 0,
            rotate: 0,
            backgroundAltTag: ''
        },
        getBgImageSettings: function () {
            var ret = {};
            for (var x in this.bgImageDefaultSettings) {
                ret[x] = this.get(x);
            }
            return ret;
        },
        // overriding default getter, this property should be always dynamic
        getBgImageUrl: function () {
            var
                type = this.getBackgroundSourceType(),
                loadParams = ['backgroundSourceType=' + type, 'pageId=' + self.pageId],
                params = this.bgImageSourceOpts[type];
            for (var i = 0; i < params.length; i++) {
                loadParams.push(params[i] + '=' + encodeURIComponent(this.get(params[i])));
            }
            return this.controllerUrl + 'getbgimage?' + loadParams.join('&');
        },
        setBgImageSource: function (type, loadOpts) {
            var ao = this.bgImageSourceOpts;

            var selectedId = ao[type];
            //if type not defined -> do nothing; not a valid call
            if (!selectedId) {
                return null;
            }

            var data = $.extend({},
                this.getBgResetValuesForSource(type),
                this.bgImageDefaultSettings,  // reset sliders
                loadOpts
            );

            if (type != 'ImageUpload' || loadOpts['uploadedImageId'] == -1) {
                data.backgroundAnimated = 0;
            }

            this.set(data);
            this.setBgImageUrl(this.getBgImageUrl());

        },
        getBgResetValuesForSource: function (sourceType) {
            var resetData = {
                backgroundSourceType: sourceType
            };

            //reset to default values all other sources data
            for (var type in this.bgImageSourceOpts) {
                //skip current source type
                if (!type || (type == sourceType) || !this.bgImageSourceOpts.hasOwnProperty(type)) {
                    continue;
                }

                var field;
                for (var i = 0; i < this.bgImageSourceOpts[type].length; i++) {
                    field = this.bgImageSourceOpts[type][i];
                    resetData[field] = 0;
                }
            }

            return resetData;
        },
        resetBgImage: function () {
            self.model.setBgImageSource('ImageUpload', {
                uploadedImageId: -1,
                bgColor: self.model.getBgColor()
            });
            self.model.setBgImageUrl(cc_.blankImageUrl);
        },
        setSaveMode: function (val) {
            if (val == 'default_header') {
                this.set($.extend({}, this.getDefaultHeaderParams()));
                // force changing image url
                this.setBgImageUrl(this.getBgImageUrl());
            }

            //arguments is an array like object (not an actual array), we cannot call concat directly on it
            //we use Array.prototype.slice.call to transform it to array
            this._set.apply(this, $.merge(['saveMode'], arguments));
        },
        setHeight: function (value, markChanged, extra, forceNotify) {
            //call the actual set
            this._set.apply(this, $.merge(['height'], arguments));

            //and then when value has finished changing - aka slider stop
            //get to refreshing the logo zoom value
            if (extra && extra.isChanging === false) {
                //logoZoom update
                var $logoElement = self.getLogoImageEl();
                if ($logoElement !== null) {
                    var currentHeight = this.getLogoBorderVisible() ? $logoElement.outerHeight() : $logoElement.height()
                    var newLogoZoom = Math.min(Math.round(currentHeight * 100 / value), 100);
                    var currentLogoZoom = parseInt(this.getLogoZoom(), 10);

                    //if we have a new value set it
                    //if we're @100% then we need to force notify so that the preview updates/rescales
                    if (newLogoZoom != currentLogoZoom || newLogoZoom == 100) {
                        this.setLogoZoom(newLogoZoom, true, null, true);
                    }
                }

                //titleBackgroundHeight percentage update
                var $titleBgElement = self.getTitleBgEl();
                if ($titleBgElement !== null) {
                    var currentHeight = $titleBgElement.height(),
                        newTitleBgHeightPercentage = Math.min(Math.round(currentHeight * 100 / value), 100),
                        currentTitleBgHeightPercentage = parseInt(this.getTitleBackgroundHeight(), 10);


                    //if we have a new value set it
                    //if we're @100% then we need to force notify so that the preview updates/rescales
                    if (newTitleBgHeightPercentage != currentTitleBgHeightPercentage || newTitleBgHeightPercentage == 100) {
                        this.setTitleBackgroundHeight(newTitleBgHeightPercentage, true, null, true);
                    }
                }

            }
        },
        getBgImageData: function () {
            var data = {},
                field;
            for (var i = 0; i < this.bgImageProperties.length; i++) {
                field = this.bgImageProperties[i];
                data[field] = this.get(field);
            }

            return data;
        },
        isBgProperty: function (propName) {
            return $.inArray(propName, this.bgImageProperties) >= 0;
        },
        bgImageProperties: [
            'backgroundAltTag', 'backgroundAnimated', 'backgroundEdited', 'backgroundHorPos', 'backgroundSourceType',
            'backgroundVertPos', 'backgroundZoom', 'bgColor', 'brightness', 'contrast', 'externalImageId',
            'flipHorizontal', 'flipVertical', 'imageId', 'imageVersion', 'patternBw', 'patternId', 'previewSrc',
            'randomKey', 'rotate', 'sharpen', 'uploadedImageId', 'zoomHeight',
            'zoomLeft', 'zoomTop', 'zoomWidth',
            'sourceThumbSrc', 'previewSrc', 'thumbSrc'
        ]
    });
};


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Shop view of EmotionHeader
 */
var $ = __webpack_require__(3);

module.exports = function (_super) {

		/***************************************************************/
		// VIEW SETUP
		/***************************************************************/

		// identify this view publicly
		this.tabElementId = 'eh-shop';

		/***************************************************************/
		// INTERNAL VARIABLES
		/***************************************************************/

		// internal variables for this view
		var _theView = this, // deep self-reference
			_MODEL = _super.model, // reference the storage model
			_groupCarouselEl = null, // element where group buttons carousel is
			_colorsCarouselEl = null, // element where colors buttons carousel is
            _shopButtonsData = null, // data for all button images and groups
			_shopButtonPath = '', // the actual icon full path
			_$horSlider = null, // reference to the horizontal slider
			_$vertSlider = null, // reference to the vertical slider
			_$fieldset = null, // reference to the fieldset element
			_prevColorButtonGroupId = null, // track group changes for color button purposes
			_prevGroupId = null // track group changes for group purposes
		;

		/***************************************************************/
		// INITIALIZATION METHOD
		/***************************************************************/

		// this is called once, after the view HTML is first loaded
		this.init = function () {
		    var dataEl = $('script.eh-shop-images', _theView.viewWrapper)
		    _shopButtonsData = jQuery.parseJSON(dataEl.html());
		    // determine the icon images path, which is the same for all button icons
		    _shopButtonPath = dataEl.attr('data-baseurl');
			// save current group setting
            _prevColorButtonGroupId = _MODEL.get('shopGroupId');
            _prevGroupId = _MODEL.get('shopGroupId');
            _createTabs();
            _createGroupsCarousel();
            _createColorsCarousel();
            
			_hookShopShowButton();
			
			_createSliders();
		};

		/***************************************************************/
		// CLEANUP METHOD
		/***************************************************************/

		// called when the view is unloaded
		this.destroy = function () {
			//TODO: remove all controls
		};

		/***************************************************************/
		// CONTROLS UPDATE METHOD
		/***************************************************************/

		// called whenever a setting is changed, in any view
		this.updateView = function (foo, bar, changed, extra) {

			// tab interface visibility toggle
			// depending on whether there are products or not
			if (typeof(changed['shopHasProducts']) != 'undefined') {
			    if (1 != changed['shopHasProducts']) {
			        _$fieldset.fieldset('setCollapsed', true);
			        _$fieldset.fieldset('setDisabled', true);
    			    $('#shop-nocart-container').show();
    			    var warningContent = $('#shop-nocart-container').html();
    			    $('#shop-nocart-container').html('');
    			    $("#shop-nocart-container").diy_simpleTooltip({
    		            positionMode: 'static',
    		            content: warningContent,
    		            triggerMode: 'none',
    		            appendTo: "#shop-nocart-container",
    		            'cls': 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip diy-warning-tooltip',
    		            'contentIcon': 'ui-icon-alert'
    		        });
    			    $("#shop-nocart-container").diy_simpleTooltip('show');
    			    $('#shop-nocart-container .shop-nocart-action-link').click(function(){
    			        diy.editor.deeplinking.init({
    			            deepLinkCategory: 'admin',
    			            deepLinkItem: 'elements',
    			            deepLinkParams: {
    			                category: 'presentation_sales',
    			                scrollTo: 'product_presentation'
    			            }
    			        });
    			    });
    			}
    			else {
                    if (1 == _MODEL.get('shopShowButton')) {
                        _$fieldset.fieldset('setCollapsed', false);
                    }
                    _$fieldset.fieldset('setDisabled', false);
                    $('#shop-nocart-container').hide();
                    _theView.viewWrapper.find('.diy-carousel')
                        .diy_carousel('refresh');
    			}
			}

			// examine each changed setting
		    for (var option in changed) {
		    	// grab the new value
		        var value = changed[option];
		        // handle options
		        switch (option) {

		        	// checkbox to show or hide the button
			        case 'shopShowButton':
                        var show = 1 == value && 1 == _MODEL.get('shopHasProducts');
			            _$fieldset.fieldset('setCollapsed', !show);
			            if (show) {
			                _theView.viewWrapper.find('.diy-carousel')
			                    .diy_carousel('refresh');
			            }
		        	break;

		        	// button group selector
			        case 'shopGroupId':
    					// mark selected the icon for this group
			            var groupIndex, group, i, colorIndex, shopId;
			            for(i = 0; i < _shopButtonsData.length; i ++) {
			                if (_shopButtonsData[i]['groupId'] ==  value) {
			                    groupIndex = i;
			                    group = _shopButtonsData[i];
			                    break;
			                }
			            }
			            _groupCarouselEl.diy_carousel('selectItem', groupIndex, true /*silent*/);
			            _colorsCarouselEl.diy_carousel('option', 'items', group['images']);
                        // load color buttons for this group
                        if (extra && extra['selectFirst']) {
                            colorIndex = 0;
                        } else {
                            shopId = _MODEL.get('shopId');
                            for(i = 0; i < group['images'].length; i ++) {
                                if (group['images'][i] == shopId) {
                                    colorIndex = i;
                                    break;
                                }
                            }
                        }
                        if (colorIndex !== undefined) {
                            _colorsCarouselEl.diy_carousel('selectItem', colorIndex);
                        }
                        
                        // if group changed
                        if (value != _prevColorButtonGroupId) {
                            // set positioning settings
                            _MODEL.set({
                                'shopCssStyle': group['css'],
                                'shopHorPos': -1,
                                'shopVertPos': -1
                            });
                            // force-update sliders
                            _updateHorSlider(-1);
                            _updateVertSlider(-1);
                        } else {
                            // should be the initial updateView
                            _groupCarouselEl.diy_carousel('scrollToItem', groupIndex);
                        }
                        // save current group for next comparison
                        _prevColorButtonGroupId = value;                        
		        	break;

		        	// button icon selector
			        case 'shopId':
			            var colorsItems = _colorsCarouselEl.diy_carousel('getItems'), 
			                i, itemIndex;
			            for(i = 0; i < colorsItems.length; i ++) {
                            if (colorsItems[i] == value) {
                                itemIndex = i;
                                break;
                            }
                        }
			            if (itemIndex !== undefined) {
			                _colorsCarouselEl.diy_carousel('selectItem', itemIndex, true /*silent*/);
			            }
		        	break;

		        	// horizontal positioning slider
			        case 'shopHorPos':
						//TODO: enable/disable slider when button bigger than header
			            _updateHorSlider(value);
		        	break;

		        	// vertical positioning slider
			        case 'shopVertPos':
						//TODO: enable/disable slider when button bigger than header
                        _updateVertSlider(value);
		        	break;
		        }
		    }
		};
		
		this.onShow = function()
	    {
		    if (_theView.viewWrapper) {
		        _theView.viewWrapper.find('.diy-carousel').diy_carousel('refresh');
		    }
	    };
		
		var _createTabs = function () {
		    _theView.viewWrapper.find('.eh-shop-content').diy_simpleTabs({
                activeTabCls: 'diy-tabs-item-selected ui-icon-hover',
                tabChange: function(e, data) {
                    data.contentEl.find('.diy-carousel').diy_carousel('refresh');
                }
            });
		};
		
		var _createGroupsCarousel = function () {
            var images = [], i;
            for (i = 0; i < _shopButtonsData.length; i ++) {
                images.push({
                    image: _shopButtonsData[i]['images'][0], // first image in the group
                    groupId: _shopButtonsData[i]['groupId']
                });
            }
            _groupCarouselEl = _theView.viewWrapper.find('.eh-shop-button-section .eh-shop-thumbs'); 
            _groupCarouselEl.diy_carousel({
                items: images,
                itemTemplate: '<img src="' + _shopButtonPath + '{image}">',
                selectable: true,
                afterItemSelect: function(event, data) {
                    var gId = parseInt(data.item.groupId);
                    _MODEL.set('shopGroupId', gId, true,
                        {'selectFirst': (_prevGroupId != gId ? true : false)});
                    _prevGroupId = gId;
                },
            });
            _super.bind('open', function(){
                _groupCarouselEl.diy_carousel('refresh');
            });
		};
		
		var _createColorsCarousel = function() {
		    _colorsCarouselEl = _theView.viewWrapper.find('.eh-shop-color-section .eh-shop-thumbs'); 
		    _colorsCarouselEl.diy_carousel({
                items: [], // initially there are no items, they will be added later 
                itemTemplate: '<img src="' + _shopButtonPath + '{0}">',
                selectable: true,
                afterItemSelect: function(event, data) {
                    _MODEL.set({
                        'shopId': data.item
                    });
                },
            });
		    _super.bind('open', function(){
		        _colorsCarouselEl.diy_carousel('refresh');
            });
		}

		/***************************************************************/
		// SLIDER HELPERS AND HOOK HANDLERS
		/***************************************************************/

		// create sliders
		var _createSliders = function () {
			_$horSlider = $('#shop-position-h-slider', _super.$eheContent)
				.diy_slider({
					step:0.01,
					max: 100,
					tipText: function (value) {
						return value + '%';
					},
					slide: function (e, ui) {
                        if (!e.originalEvent) return;
                        _MODEL.set('shopHorPos', ui.value);
                    }
				}) // make the object into a slider
			;
			_$vertSlider = $('#shop-position-v-slider', _super.$eheContent)
				.diy_slider({
					step:0.01,
					max: 100,
					tipText: function (value) {
						return value + '%';
					},
					slide: function (e, ui) {
                        if (!e.originalEvent) return;
                        // XXX we use 100 - ui.value to invert the slider value
                        _MODEL.set('shopVertPos', 100 - ui.value);
                    }
				}) // make the object into a slider
			;
		};

        // horizontal slider update helper
        var _updateHorSlider = function (value) {
            // sanity check for when preview is off
            if ('undefined' == typeof(CC.EmotionHeader.Preview)) {
                return;
            }
            // if value is "default"
            if (-1 == value) {
                // read percentage from the button
                var perc = CC.EmotionHeader.Preview
                    .shopButtonSliderPosition().left;
            } else {
                // otherwise, percentage is the indicated value
                var perc = value;
            }
            // set the slider
            _setSlider(_$horSlider, 'shop-position-h-slider', perc);
        };

        // vertical slider update helper
        var _updateVertSlider = function (value) {
            // sanity check for when preview is off
            if ('undefined' == typeof(CC.EmotionHeader.Preview)) {
                return;
            }
            // if value is "default"
            if (-1 == value) {
                // read percentage from the button
                var perc = CC.EmotionHeader.Preview
                    .shopButtonSliderPosition().top;
            } else {
                // otherwise, percentage is the indicated value
                var perc = value;
            }
            // set the slider
            // XXX we use 100 - perc to invert the slider value
            _setSlider(_$vertSlider, 'shop-position-v-slider', 100 - perc);
        };

		// set given slide object to certain value
		var _setSlider = function (slideObject, slideId, value) {
			slideObject.diy_slider('value', value);
		};

		/***************************************************************/
		// GROUP AND COLOR BUTTONS HOOKS AND HANDLERS
		/***************************************************************/

		// hook click event on the show button checkbox
		var _hookShopShowButton = function () {
		    _$fieldset = $('.eh-shop-content .fieldset', _super.$eheContent);
		    _$fieldset.fieldset({ collapsed: true });
	        _$fieldset.bind('toggle.fieldset', function(e, show) {
	            _MODEL.setShopShowButton(show ? 1 : 0);
	            $(document).trigger('diy-eh-component-visibility-changed', {
	                'componentName': 'shop',
	                'show': show
	            });
	        });
		};

	}; // end of view definition


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

module.exports = function (_super)
{
	this.tabElementId = 'eh-title';

	var self = this;

	var $eh = _super.$eh,
        $ehe = _super.$ehe,
        $eheContent = _super.$eheContent;

	var $titleSection,
	    $bgSection,
	    $titleCheck,
	    $bgCheck,
	    $fontFamilyCombo,
	    $fontStyleCombo,
	    $fontSizeCombo,
        $fontAlign,
	    $titleText,
	    $colorPicker,
	    $bgColorPicker,
	    optionControlMapper = {},
	    $combos = {};

	var sliderIds = {
	    //modelOptionName => id
        titleHorPos: '#eh-position-hor-slider',
        titleVertPos: '#eh-position-vert-slider',
        titleBackgroundHorPos: '#eh-bg-position-hor-slider',
        titleBackgroundVertPos: '#eh-bg-position-vert-slider',
        titleBackgroundWidth: '#eh-bg-width-slider',
        titleBackgroundHeight: '#eh-bg-height-slider',
        titleBackgroundOpacity: '#eh-bg-opacity-slider'
	};

    var fontAlignButtons = {
        left: 'eh-title-font-align-left',
        center: 'eh-title-font-align-center',
        right: 'eh-title-font-align-right'
    };

	this.model = _super.model;

	this.init = function()
	{
		this.viewWrapper.actionController(this, {events: 'change keydown'});

	    this.initElements();
	    this.initButtons();
		this.initSliders();
		this.initCombos();
		this.initPickers();
		this.initFieldsets();
		this.createTabs();
	};

	this.initElements = function() {
	    $titleCheck = $('#eh-show-title', $eheContent);
        $bgCheck = $('#eh-show-title-bg', $eheContent).diy_checkbox();
        $titleSection = $('#eh-title-settings', $eheContent);
        $bgSection = $('#eh-title-bg-settings', $eheContent);

        $fontFamilyCombo = $('#eh-title-font-family', $eheContent);
        $fontStyleCombo = $('#eh-title-font-weight', $eheContent);
        $fontSizeCombo = $('#eh-title-font-size', $eheContent);
        $fontAlign = $('#eh-title-font-align', $eheContent);

        $titleText = $('#eh-title-text', $eheContent);
	};

    this.initButtons = function () {
        for (var align in fontAlignButtons) {
            $('#' + fontAlignButtons[align]).click(this.fontAlignChange.bind(this).curry(align))
        }
    };

	this.initSliders = function()
	{
        for (var opt in sliderIds) {
		    var invertValue = opt === 'titleVertPos' || opt === 'titleBackgroundVertPos'
		    _super.initSlider({option: opt, id: sliderIds[opt],
	            min: 0, max: 100,
	            step: 0.01,
	            formatter: function (val) {
	                return val + '%';
	            }
	        }, optionControlMapper, this.model, invertValue);		    
		}
	};

	this.initCombos = function()
	{
	    $fontFamilyCombo.diy_combobox({
	        editable: false,
	        select: this.fontFamilyChange,
	        refreshInput: this.refreshFontFamily,
	        renderItem: function(elem, item) {
	            elem.text(item.label);
	            self.refreshFontFamily(elem, item);
	        }
	    });
	    $fontStyleCombo.diy_combobox({
	        editable: false,
	        select: this.fontWeightChange,
            refreshInput: this.refreshFontStyle,
            renderItem: function(elem, item) {
                elem.text(item.label);
                self.refreshFontStyle(elem, item);
            }
        });
	    $fontSizeCombo.diy_combobox({
          editable: true,
	        change: this.fontSizeChange,
	        maskRe: /[0-9]/
	    });
	};

	this.initPickers = function()
	{
		$colorPicker = $eheContent.find('#eh-title-color').colorPicker({
		    mode: 'button',
		    onColorAccept: this.fontColorHandler,
		    onColorSelect: this.fontColorHandler
		});

	    $bgColorPicker = $eheContent.find('#eh-title-bg-color').colorPicker({
		    mode: 'button',
		    onColorAccept: this.backgroundColorHandler,
		    onColorSelect: this.backgroundColorHandler
		});

        CC.EmotionHeader.bind('switchView', function(viewName) {
            if ($colorPicker.isColorButtonOpened()) {
                $colorPicker.abortColor();
            }

            if ($bgColorPicker.isColorButtonOpened()) {
                $bgColorPicker.abortColor();
            }
        });

	    CC.EmotionHeader.bind('collapse', CC.EmotionHeader.toHandler(
	        function(e, data, status) {
	            if(status == 'ok') {
	                $colorPicker.saveColor();
	                $bgColorPicker.saveColor();
	            } else {
	                $colorPicker.abortColor();
	                $bgColorPicker.abortColor();
	            }
	        })
        );
	};

	this.initFieldsets = function()
	{
		$titleSection.fieldset({ collapsed: true });
		$titleSection.bind('toggle.fieldset', function(e, show) {
		    self.model.setTitleVisible(show ? 1 : 0);
		    $(document).trigger('diy-eh-component-visibility-changed', {
		        'componentName': 'title',
		        'show': show
		    });
		});
		$bgCheck.bind('change.checkbox', function() {
		    var show = $(this).is(':checked');
		    self.model.setTitleBackgroundVisible(show ? 1 : 0);
            self.viewWrapper.find('.eh-title-content')
                .diy_simpleTabs('option', 'activeTabIndex', show ? 1 : 0);

            $(document).trigger('diy-eh-component-visibility-changed', {
                'componentName': 'titleBg',
                'show': show
            });
		});
	};
	
	this.createTabs = function () {
	    this.viewWrapper.find('.eh-title-content').diy_simpleTabs({
            activeTabCls: 'diy-tabs-item-selected ui-icon-hover',
        });
    };

	this.updateView = function(model, data, changed, extra)
	{
	    //Don't update if changes came from components in this tab
	    if (extra && extra.from == this) {
            return;
        }

	    for(var option in changed) {
	        var value = changed[option];
	        switch (option) {
	            case 'font':
	                $fontFamilyCombo.diy_combobox('rawValue', value);
	                break;

	            case 'fontWeight':
	            case 'fontStyle':
	                var newStyle = model.getFontStyle();
	                var newWeight = model.getFontWeight();
	                var newValue = getCombinedFontStyle(newWeight, newStyle);
	                $fontStyleCombo.diy_combobox('rawValue', newValue);
	                break;

	            case 'fontSize':
	                $fontSizeCombo.diy_combobox('rawValue', value);
	                break;

                case 'fontAlign':
                    $fontAlign.val(value);
                    $('.eh-title-font-align-button', $eheContent).removeClass('selected');
                    $('#eh-title-font-align-' + value, $eheContent).addClass('selected');
                    break;

                case 'title':
	                $titleText.val(value);
	                break;

	            case 'titleVisible':
	                $titleSection.fieldset('setCollapsed', !value);
	                break;

	            case 'titleBackgroundVisible':
	                $bgCheck.diy_checkbox('option', 'checked', value);
                    self.viewWrapper.find('[data-simpletab=".eh-bgtitle-settings-section"]')
                        .css('visibility', value ? '' : 'hidden');
	                break;

	            case 'fontColor':
	                $colorPicker.setColor('#' + value);
	                break;

	            case 'titleBackgroundColor':
	                $bgColorPicker.setColor('#' + value);
	                break;

	            default:
	                if (option in sliderIds) {
	                    optionControlMapper[option].setValue(value)
	                }
	                break;
	        }
	    }
	};

	this.refreshFontFamily = function(elem, item) {
	    if (!item.option) {
	        return;
	    }
	    var value = item.rawValue;
	    elem.css('font-family', value);
	};

	this.refreshFontStyle = function(elem, item) {
	    if (!item.option) {
	        return;
	    }
	    var value = item.rawValue;
        var fontStyle = value == 'italic' || value == 'both' ? 'italic' : 'normal';
        var fontWeight = value == 'bold' || value == 'both' ? 'bold' : 'normal';

        elem.css({
            'font-style': fontStyle,
            'font-weight': fontWeight
        });
	};

    this.fontAlignChange = function (ui, e) {
        self.model.set({fontAlign: ui});
    };

    this.fontFamilyChange = function ( e, ui )
	{
        self.model.setFont(ui.rawValue, undefined, { from: self });
	};

	this.fontWeightChange = function ( e, ui )
	{
	    var value = ui.rawValue;
	    var fontStyle = value == 'italic' || value == 'both' ? 'italic' : 'normal';
	    var fontWeight = value == 'bold' || value == 'both' ? 'bold' : 'normal';
	    self.model.set({
	        fontWeight: fontWeight,
	        fontStyle: fontStyle
	    }, undefined, { from: self });
	};

	this.fontSizeChange = function ( e, ui )
	{
	    var value = parseInt(ui.rawValue);
	    // parseInt returns NaN for empty strings. fall back to model value.
	    if (isNaN(value)) {
	        $(this).diy_combobox('rawValue', self.model.getFontSize() );
	        return;
	    }

	    //TODO: replace this with a proper validator
	    if (value < 8 || value > 300) {
    	    value = value < 8 ? 8 : 300;
    	    $(this).diy_combobox('rawValue', value);
	    }

	    self.model.setFontSize(value, undefined, { from: self });
	};

	this.titleChangeKeydown = function ()
	{
	    /* XXX: Is this still needed?
	     * IE has a bug, if you change the text
	     * of container with white-space: pre;
	     * it forgets pre ... so I set br instead
	     */
	    var $textarea = $(this);
	    setTimeout(function(){
	        self.model.setTitle($textarea.val(), undefined, {from: self});
	        }, 10);
	};

    this.fontColorHandler = function(color) {
        self.model.setFontColor(color, undefined, {from: self});
    };

    this.backgroundColorHandler = function(color) {
        self.model.setTitleBackgroundColor(color, undefined, {from: self});
    };

	this.destroy = function()
	{
	    $colorPicker.remove();
	    $bgColorPicker.remove();
	    $('.ui-slider', $eheContent).diy_slider('destroy');
	    $('.fieldset', $eheContent).each(function() {
	        $(this).fieldset('destroy');
	    });
	};

	var getCombinedFontStyle = function(weight, style)
	{
	    var newValue;
        if (weight == 'bold') {
            newValue = (style == 'italic') ? 'both' : 'bold';
        } else {
            newValue = style;
        }
        return newValue;
	};
};


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

/**
 * @author Oleg Slobodksoi aka Kof
 * @class Logo
 * Logo view of EmotionHeader
 */

var $ = __webpack_require__(3);

module.exports = function (_super)
{
    this.tabElementId = 'eh-logo';

    var self = this;

    var d = _super.d,
        $eh = _super.$eh,
        $eheContent = _super.$eheContent;

    var $logoSection,
        $borderSection,
        $borderCheck,
        $optionsWrapper,
        $preview,
        $previewImg,
        $previewDelete,
        $fieldset,

        uploadedLogo = false,

        $uploadForm,
        $uploadField,
        $uploadInput,

        $posHorSlider,
        $posVertSlider,
        $colorPicker,
        optionControlMapper = {},
        timeout;

    var sliderIds = {
        logoZoom: '#eh-logo-size-slider',
        logoHorPos: '#eh-logo-position-hor-slider',
        logoVertPos: '#eh-logo-position-vert-slider',
        logoPadding: '#eh-logo-border-padding-slider',
        logoBorderSize: '#eh-logo-border-width-slider'
    };

    this.model = _super.model;


    this.init = function()
    {
        this.viewWrapper.actionController(this, {events: 'click slidechange slide slidestart colorchange'});
        this.initElements();
        this.initUpload();
        this.initSliders();
        this.initFieldsets();
        this.initPickers();
        this.initAltTag();
        this.createTabs();
        // XXX Bugfix DHDIY-20287 
        // For some very strage reasons click handler on help link
        // won't work in Logo tab in some conditions in IE11 (IE is back in business !!!)
        // the workaround is to bind the mousedown
        _super.$eheHelp.bind('mousedown', function(e){
            cms.help.GuidedAssistant._instance._onModuleHelpLinkClick(e);
        });
    };
    this.onUploadedLogo = function()
    {
        _super.uploadedLogo = true;
        $(document.body).trigger('LogoUploaded.BSA');
    }
    this.initUpload = function()
    {
        var that = this;

        // attach the form upload behavior
        $uploadForm.xWebForms({

            beforeSend: function() {
                _super.loading(true);
                $eheContent.loadingBox().show();
                $uploadForm.diy_form('clearErrors');
            },

            success: function(jsonData) {
                var data = jsonData.data;
                _super.loading(false);
                $eheContent.loadingBox().hide();
                if (data.status == 'error') {
                	/* always trigger first the uploadError event.
                	 * if we trigger it after the error message, it will reset the field
                	 * and the error tooltip won't be visible */
                	$(this).trigger('uploadError');
                	/* show the error on the file upload field */
                	$uploadForm.diy_form("addError", data.message, $uploadField);
                    return;
                }
            	$(this).trigger('uploadSuccess');
              self.onUploadedLogo();
        	self.model.setLogoImageId(data.logoImageId);
        	self.model.setLogoUrl(data.src);
                self.model.setLogoDeleted(0);
                self.model.setLogoOriginalWidth(data.width);
                self.model.setLogoOriginalHeight(data.height);
                self.model.setLogoZoom(50);
                initSections(true);

                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Tried',
                    'name': 'Logo'
                });
            },

            complete: function() {
                _super.loading(false);
            	$eheContent.loadingBox().hide();
            }
        });

        $uploadForm.diy_form();
        CC.EmotionHeader.bind('hide', function() {
           $uploadForm.diy_form('clearErrors');
        });

        // trigger the upload on file selection
        $uploadField.diy_uploadField({
            change: function() {
                $uploadForm.submit();
            }
        });
    };

    this.initElements = function()
    {
        $logoSection = $('#eh-logo', $eheContent);
        $borderSection = $('#eh-logo-border-settings', $eheContent);
        $borderCheck = $('#eh-show-logo-border', $eheContent).diy_checkbox();
        $logoAltTag = $('#eh-logo-alttag', $eheContent);

        $optionsWrapper = $('.eh-logo-options-wrapper', $eheContent);

        $uploadForm = $('#eh-logo-upload-form', $eheContent);
        $uploadInput = $('input[type=file]', $uploadForm);
        $uploadField = $('#eh_logo_upload_field');

        $preview = $('#eh-logo-preview', $eheContent);
        $previewImg = $('img', $preview);
        $previewDelete = $('#eh-logo-delete', $eheContent);
        $fieldset = $('.fieldset#eh-logo', $eheContent);

        $previewDelete
            .addClass('ui-button-borderless')
            .button({
                icons: {
                    primary : "ui-icon-trash"
                },
                text: false
            })
            .click(function() {
            self.removeLogo();
        });

        $logoMaker = $('.eh-logo-maker', $eheContent).bind('click', function() {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                'pageName': 'Emotion Header Logo',
                'actionName': 'logoMakerHeader'
            });
        })
    };

    this.initFieldsets = function()
    {
        $logoSection.fieldset({ collapsed: true });
        $logoSection.bind('toggle.fieldset', function(e, show) {
            self.model.setLogoVisible(show ? 1 : 0);
            $(document).trigger('diy-eh-component-visibility-changed', {
                'componentName': 'logo',
                'show': show
            });
        });

        /*$borderSection.fieldset({ collapsed: true });
        $borderSection.bind('toggle.fieldset', function(e, show) {
            e.stopPropagation();
            self.model.setLogoBorderVisible(show ? 1 : 0);
        });*/
        $borderCheck.bind('change.checkbox', function() {
            var show = $(this).is(':checked'),
                tabs = self.viewWrapper.find('.eh-logo-content'),
                currentTabIndex = tabs.diy_simpleTabs('option', 'activeTabIndex');
            tabs.diy_simpleTabs('option', 'activeTabIndex', 
                    show ? 2 /* eh-borderlogo-section */ : 0 /* eh-logo-settings-section */); 
            self.model.setLogoBorderVisible(show ? 1 : 0);
        });
    };
    
    this.createTabs = function() {
        this.viewWrapper.find('.eh-logo-content').diy_simpleTabs({
            activeTabCls: 'diy-tabs-item-selected ui-icon-hover',
        });
    }

    this.initSliders = function()
    {
        var elem, min, max, step, unit;

        for (var opt in sliderIds) {
            if (opt == 'logoZoom') {
                min = 10;
                max = 100;
            }
            else if (opt == 'logoBorderSize') {
                min = 0;
                max = 10;
            }
            else if (opt == 'logoPadding') {
                min = 0;
                max = 20;
            }
            else {
                min = 0;
                max = 100;
            }

            if (opt == 'logoHorPos' || opt == 'logoVertPos') {
                step = 0.01;
            }
            else {
                step = 1;
            }

            if (opt == 'logoPadding' || opt == 'logoBorderSize') {
                unit = function(value) { return value + 'px'; };
            }
            else {
                unit = function(value) { return value + '%'; };
            }

            var invertValue = opt === 'logoVertPos'
            _super.initSlider({option: opt, id: sliderIds[opt],
                min: min, max: max,
                step: step,
                formatter: unit
            }, optionControlMapper, this.model, invertValue);            
        }
    };

    this.initPickers = function()
    {
        $colorPicker = $('#eh-logo-border-color').colorPicker({
            mode: 'button',
            onColorAccept: this.borderColorHandler,
            onColorSelect: this.borderColorHandler
        });

        CC.EmotionHeader.bind('collapse', CC.EmotionHeader.toHandler(
            function(e, data, status) {
                if(status == 'ok') {
                    $colorPicker.saveColor();
                } else {
                    $colorPicker.abortColor();
                }
            })
        );
    };

    this.initAltTag = function()
    {
        $logoAltTag.bind('keyup', function () {
            self.model.set('logoAltTag', $logoAltTag.val());
        });
    };

    this.borderColorHandler = function(color) {
        self.model.setLogoBorderColor(color, undefined, {from: self});
    };

    this.removeLogo = function()
    {
        _super.uploadedLogo = false;
        self.model.setLogoDeleted(1);
        self.model.setLogoUrl(0);
        initSections(false);
    };

    this.destroy = function()
    {
        $colorPicker.remove();
        $('.ui-slider', $eheContent).diy_slider('destroy');
        $('.fieldset', $eheContent).each(function() {
            $(this).fieldset('destroy');
        });
    };

    this.updateView = function(model, data, changed, extra)
    {
        if (extra && extra.from == this) {
            return;
        }

        for (var option in changed) {
            var value = changed[option];
            switch (option) {
                case 'logoVisible':
                    $logoSection.fieldset('setCollapsed', !value);
                    initSections(value && !model.getLogoDeleted());
                    break;

                case 'logoBorderVisible':
                    $borderCheck.diy_checkbox('option', 'checked', value);
                    self.viewWrapper.find('[data-simpletab=".eh-borderlogo-section"]')
                        .css('visibility', value ? '' : 'hidden');
                    
                    break;

                case 'logoAltTag':
                    $logoAltTag.val(value);
                    break;

                case 'logoDeleted':
                    initSections(!value);
                    /*
                     * Bugfix DHDIY-20647
                     * When logoVisible = 0 and logoDeleted = 1
                     * (this should not happen, but if it happens...)
                     * there is no possibility to edit logo anymore
                     * So I will do additional check before disabling
                     */
                    $fieldset.fieldset(value && model.getLogoVisible() ? 'disable' : 'enable');
                    break;

                case 'logoUrl':
                    value && updatePreview(true);
                    break;

                case 'logoBorderColor':
                    $colorPicker.setColor('#' + value);
                    break;

                default:
                    if (option in sliderIds) {
                        optionControlMapper[option].setValue(value)
                    }
                    break;
            }
        }
    };
    this.onShow = function()
    {
        if (_super.logoPanelOpened != true) {
            $(document.body).trigger('LogoPanelOpened.BSA');
            _super.logoPanelOpened = true;
        }
    };

    function updatePreview(show)
    {
        if (show) {
            $previewImg.attr('src', self.model.getLogoUrl());
        }
        $('.diy-image-preview', $preview)[show ? 'removeClass' : 'addClass']('diy-image-preview-no-image');
    }

    function initSections(show)
    {
        show = show == true;
        $optionsWrapper.toggle(show);
        $preview.toggle(show);
        $previewDelete.toggle(show);
        updatePreview(show);
    }
};


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

module.exports = function (_super)
{
    this.tabElementId = 'eh-settings';

    var self = this;

    var $eh = _super.$eh,
        $ehe = _super.$ehe,
        $eheContent = _super.$eheContent,
        optionControlMapper = {},
        zoomSliderId = '#eh-bg-zoom-slider',
        horPosSliderId = '#eh-bg-pos-hor-slider',
        vertPosSliderId = '#eh-bg-pos-vert-slider',
        rotateSliderId = '#eh-bg-rotate',
        brightnessSliderId = '#eh-bg-brightness',
        sharpenSliderId = '#eh-bg-sharpen',
        calculations = window.diy.cms.PictureManipulation.Calculations
    ;

    this.model = _super.model;

    this.init = function()
    {
        var setBackgroundEditedTrue = function() {
            self.model.setBackgroundEdited(1);
        };
        _super.initSlider({option: 'backgroundZoom', id: zoomSliderId,
            min: 100, max: this.model.getBackgroundMaxZoom(),
            step: 0.1,
            formatter: function (val) {
                return val + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'backgroundHorPos', id: horPosSliderId,
            min: 0, max: 100,
            step: 0.1,
            formatter: function (val) {
                return Math.round(val*10)/10 + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model, true /* invertValue */);

        _super.initSlider({option: 'backgroundVertPos', id: vertPosSliderId,
            min: 0, max: 100,
            step: 0.1,
            formatter: function (val) {
                return Math.round(val*10)/10 + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'rotate', id: rotateSliderId,
            min: -45, max: 45, step: 0.1,
            formatter: function (val) {
                return calculations.mapRotation(val, false) + '°';
            },
            getMapper: function(val) {
                return calculations.mapRotation(val, false);
            },
            setMapper: function(val) {
                return calculations.mapRotation(val, true);
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'brightness', id: brightnessSliderId,
            min: -40, max: 40, step: 10,
            formatter: function (val) {
                return val + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'sharpen', id: sharpenSliderId,
            min: -40, max: 40, step: 10,
            formatter: function (val) {
                return val + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);
        
        $eheContent.find('.eh-bg-content').diy_simpleTabs({
            activeTabCls: 'diy-tabs-item-selected ui-icon-hover'
        });

    };

    this.updateView = function(model, data, changed)
    {
        var val;
        for(var option in changed) {
            val = changed[option];
            switch(option) {
                case 'backgroundOriginalWidth':
                case 'backgroundOriginalHeight':
                case 'height':
                case 'width':
                case 'backgroundZoom':
                case 'backgroundSourceType':
                case 'backgroundAnimated':
                    var backgroundSourceType = model.getBackgroundSourceType(),
                        uploadedImageId = model.getUploadedImageId(),
                        backgroundAnimated = model.getBackgroundAnimated();

                    var disableBrightSharp = backgroundSourceType == 'Patterns' || backgroundAnimated,
                        disableRotate = backgroundAnimated,
                        disableVertPosSlider = backgroundAnimated,
                        disableHorPosSlider = backgroundAnimated,
                        disableZoomSlider = backgroundAnimated,
                        disableAllSliders = backgroundSourceType == 'ImageUpload' && uploadedImageId == -1,
                        origWidth = model.getBackgroundOriginalWidth(),
                        origHeight = model.getBackgroundOriginalHeight(),
                        width = model.getWidth(),
                        height = model.getHeight(),
                        maxZoom = model.getBackgroundMaxZoom()
                    ;

                    if (model.getBackgroundZoom() == 100) {
                        if (width / origWidth > height / origHeight) {
                            disableHorPosSlider = true;
                        } else {
                            disableVertPosSlider = true;
                        }
                    } else {
                        disableHorPosSlider = disableVertPosSlider = false;
                    }

                    if (width / origWidth > height / origHeight) {
                        if(origWidth * maxZoom / 100.0 < width) {
                            disableZoomSlider = true;
                        }
                    } else {
                        if(origHeight * maxZoom / 100.0 < height) {
                            disableZoomSlider = true;
                        }
                    }

                    $(horPosSliderId)
                        .diy_slider('option', 'disabled', disableHorPosSlider || disableAllSliders);

                    $(vertPosSliderId)
                        .diy_slider('option', 'disabled', disableVertPosSlider || disableAllSliders);

                    $(zoomSliderId)
                        .diy_slider('option', 'disabled', disableZoomSlider || disableAllSliders);

                    $(rotateSliderId).diy_slider('option', 'disabled', disableRotate || disableAllSliders);

                    $(brightnessSliderId)
                        .add($(sharpenSliderId))
                        .diy_slider('option', 'disabled', disableBrightSharp || disableAllSliders);

                    // Show/hide the animated gif info text
                    $('#eh-tabs .eh-bg-animated-info')[backgroundAnimated ? 'show' : 'hide']();
                    $('#eh-bg-image-editor-control')[backgroundAnimated ? 'addClass' : 'removeClass']('hasAnimatedWarning');

                    break;

                default:
                    break;
            }
            var value = changed[option];
            if(optionControlMapper[option]) {
                optionControlMapper[option].setValue(value);
            }
        }
    };


    this.destroy = function()
    {
        // TODO
    };
};


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

module.exports = function ( _super ) {
    var d = _super.d,
        $eh = _super.$eh,
        $logo = $('#emotion-header-logo'),
        isLogoIncluded = ($logo.length) ? true : false,
        $title = $('#emotion-header-title'),
        $titleBg = $('#emotion-header-title-bg'),
        $shopButton = $('#scButton'),
        hasCanvas,
        bgImageManipulationInitialized = false,
        $bgImg,
        $bgImgWrapper,
        bgCanvas,
        $bgCanvas,
        origBgImageLoaded = false,
        $origImage,
        $resizeHelper,
        $bgTmpImg,
        calculations = window.diy.cms.PictureManipulation.Calculations,
        effects = window.diy.cms.PictureManipulation.Effects;

    var self = this,
        logoTimeout,
        logoParams = {};


    this.model = _super.model;

    this.init = function () {
        this.initTitleSettings();
        this.initTitleBgSettings();
        this.initDraggables();

        $bgImg = $('#emotion-header-img', $eh);

        // XXX a fix for a strange FF bug, when image get selected when pressing
        // on "Display background" checkbox
        $bgImg.css('-moz-user-select', 'none');

        $bgImgWrapper = $('#cc-eh-img-wrapper', $eh);
        if ($bgImgWrapper.length == 0) {
            $bgImg.wrap('<div id="cc-eh-img-wrapper"></div>');
            $bgImgWrapper = $('#cc-eh-img-wrapper', $eh);
        }
        $bgImgWrapper.click(function () {
            $(document).trigger('diy-eh-component-clicked', {'elem': $bgImgWrapper});
        });

        // adjust header height in model, because some layouts
        // override layout.ini settings with more specific css rules
        // FIXME: proper fix is to check that all layouts have correct
        // values in layout.ini. Then these 2 lines should be removed
        _super._ignoreDataChange = true;
        this.model.setHeight($eh.height());
        this.model.setWidth($eh.width());
        _super._ignoreDataChange = false;

        this.model.bind('change', this.model.toHandler(this.updateView, this));
        this._super.bind('hide', this._super.toHandler(this.disableAllDraggable, this));
        this._super.bind('open', this._super.toHandler(this.enableAllDraggable, this));
        this.enableAllDraggable();
        this.updateView(this.model, null, this.model.getAll());

        $(document).bind('diy-emotionheader-sectionOpened diy-eh-component-visibility-changed', function (ev, data) {
            var $elements = null;
            if (data.componentName && !data.show) {
                return;
            }
            name = data.tabName || data.componentName;
            $allElements = $title.add($titleBg).add($shopButton).add($logo);
            switch (name) {
                case 'title':
                    $elements = $title.add($titleBg);
                    break;
                case 'titleBg':
                    $elements = $titleBg;
                    break;
                case 'shop':
                    $elements = $shopButton;
                    break;
                case 'logo':
                    $elements = $logo;
                    break;
            }
            if ($elements === null) {
                return;
            }
            $allElements.removeClass('highlight');
            $elements.addClass('highlight');
            setTimeout(function () {
                $elements.removeClass('highlight');
            }, 2000);
        });
    };

    /**
     * Init new calculated title settings if they came as default (-1) from server
     */
    this.initTitleSettings = function () {
        var anchorPos = $title.anchorPosition();
        // Fixed bug DHDIY-21186 - reset to auto container size
        // that was manually set on rendering when container size may be not known yet
        anchorPos.setContainerSize(null, null);
        var titleMeasurements = anchorPos.getBoxMeasurements();
        var realPos = anchorPos.getAnchorPosition();

        var settings = {
            titleHorPos: realPos.left,
            titleVertPos: realPos.top
        };

        for (var name in settings) {
            if (this.model.get(name) == -1) {
                this.model.set(name, settings[name], false, {dataChanged: false});
            }
        }
    };

    /**
     * Init new calculated title background settings if they came as default (-1) from server
     */
    this.initTitleBgSettings = function () {
        var anchorPos = $titleBg.anchorPosition();
        // Fixed bug DHDIY-21186 - reset to auto container size
        anchorPos.setContainerSize(null, null);
        var titleMeasurements = anchorPos.getBoxMeasurements();
        var realPos = anchorPos.getAnchorPosition();
        var headerSize = anchorPos.getContainerSize();

        var settings = {
            titleBackgroundHorPos: realPos.left,
            titleBackgroundVertPos: realPos.top,
            titleBackgroundHeight: Math.round(titleMeasurements.height / headerSize.height * 100)
        };

        for (var name in settings) {
            if (this.model.get(name) == -1) {
                this.model.set(name, settings[name], false, {dataChanged: false});
            }
        }
    };

    this.initDraggables = function () {
        var dragOptions = [
            {
                elem: $title,
                horPosName: 'titleHorPos',
                vertPosName: 'titleVertPos'
            }, {
                elem: $titleBg,
                horPosName: 'titleBackgroundHorPos',
                vertPosName: 'titleBackgroundVertPos'
            }, {
                elem: $shopButton,
                horPosName: 'shopHorPos',
                vertPosName: 'shopVertPos'
            }
        ];
        if (isLogoIncluded) {
            dragOptions.push(
                {
                    elem: $logo,
                    horPosName: 'logoHorPos',
                    vertPosName: 'logoVertPos'
                }
            );
        }

        var createDragHandler = function ($elem, horPosName, vertPosName) {
            return function (e, ui) {
                var pos = $elem.anchorPosition().getAnchorPosition();
                var posOpts = {};
                posOpts[horPosName] = pos.left;
                posOpts[vertPosName] = pos.top;
                self.model.set(posOpts, undefined, {from: self});
            };
        };

        var createStartDragHandler = function ($elem) {
            return function (e, ui) {
                $eh.addClass('eh-drag-in-progress');
                $(document).trigger('diy-eh-component-dragstart', {'elem': $elem});
            };
        };
        var createStopDragHandler = function ($elem) {
            return function (e, ui) {
                $eh.removeClass('eh-drag-in-progress');
                $(document).trigger('diy-eh-component-dragstop', {'elem': $elem});
            };
        };

        for (var i = 0; i < dragOptions.length; ++i) {
            var config = dragOptions[i];
            config.elem.draggable({
                drag: createDragHandler(config.elem, config.horPosName, config.vertPosName),
                start: createStartDragHandler(config.elem),
                stop: createStopDragHandler(config.elem)
            });
            config.elem.click(function () {
                $(document).trigger('diy-eh-component-clicked', {'elem': $(this)});
            });
        }
    };

    this.updateView = function (model, data, changed, extra) {
        if (extra && extra.from == this) {
            return;
        }

        for (var prop in changed) {
            // grab the new value
            var value = changed[prop];

            switch (prop) {
                case 'height':
                    // note that when sliding, a dinamic element
                    // will be created just to mark the height
                    // and only after slider is released, height will be
                    // acutally changed
                    $resizeHelper = $('.cc-eh-settings-resize-helper');
                    if (extra && extra.isChanging) {
                        if ($resizeHelper.length == 0) {
                            $resizeHelper = $('<div class="cc-eh-settings-resize-helper"/>')
                                .appendTo(document.body)
                                .wrap("<div class='diye'></div>");
                            $resizeHelper.offset($eh.offset());
                            $resizeHelper.width($eh.width());
                        }
                        $resizeHelper.height(value);
                    } else {
                        $resizeHelper.unwrap().remove();
                        $eh.height(value);
                        $(document).trigger('CC.EmotionHeader.Preview.onHeaderHeightModified', value);
                    }
                    break;

                default:
                    break;
            }
        }

        this.updateShopButton(changed, extra);
        this.updateTitle(changed, extra);
        this.updateLogo(changed, extra);
        // call the background-image-specific decorators
        this.updateBackground(changed, extra);
    };

    this.updateShopButton = function (changed, extra) {

        // init vars
        var model = this.model;
        var buttonIsVisible = (1 == model.get('shopShowButton')
        && 1 == model.get('shopHasProducts'));
        var defaultCssApplied = false;

        // change the shop button image
        if ('undefined' != typeof(changed['shopId'])) {
            // extract the full image path from the existing one
            var parts = $shopButton.attr('src').split('/');
            parts.pop();
            var path = parts.join('/');
            // override the image
            $shopButton.attr('src', path + '/' + changed['shopId']);
        }

        // set the shop button's CSS
        if ('undefined' != typeof(changed['shopCssStyle'])) {
            // apply style
            $shopButton.attr('style', changed['shopCssStyle']);
            defaultCssApplied = true;
        }

        // update button position if either position
        // or the header height have changed
        if ('undefined' != typeof(changed['shopHorPos'])
            || 'undefined' != typeof(changed['shopVertPos'])
            || 'undefined' != typeof(changed['height'])
        ) {
            // extract values
            var horPos = ('undefined' != typeof(changed['shopHorPos'])
                ? changed['shopHorPos'] : model.get('shopHorPos'));
            var vertPos = ('undefined' != typeof(changed['shopVertPos'])
                ? changed['shopVertPos'] : model.get('shopVertPos'));
            // re-calculate button position in pixels
            var cssPx = $shopButton.anchorPosition().fromAnchorPosition({
                top: (-1 == vertPos ? 0 : vertPos),
                left: (-1 == horPos ? 0 : horPos)
            });
            // convert position to CSS percentages
            var cssPerc = $shopButton.anchorPosition()
                .toPercentPosition(cssPx);
            // if either position is at default
            if (-1 == horPos || -1 == vertPos) {
                // [re]apply CSS default style
                $shopButton.attr('style', model.get('shopCssStyle'));
                defaultCssApplied = true;
            }
            // apply new positions
            var css = {};
            if (-1 != horPos) {
                css.left = cssPerc.left + '%';
                css.right = 'auto';
            }
            if (-1 != vertPos) {
                css.top = cssPerc.top + '%';
                css.bottom = 'auto';
            }
            if (!jQuery.isEmptyObject(css)) {
                $shopButton.css(css);
            }

            // Recalculate draggable containment box
            $shopButton.draggable('option', 'containment', this.getDraggableContainment($shopButton, $eh));
        }

        // if the visibility checkbox changed,
        // or the products have changed,
        // or the default css has overwritten the hidden state
        if ('undefined' != typeof(changed['shopShowButton'])
            || 'undefined' != typeof(changed['shopHasProducts']
            || defaultCssApplied)
        ) {
            // re-enforce visibility state
            $shopButton[(buttonIsVisible ? 'show' : 'hide')]();
        }

    }; // END OF SHOP BUTTON UPDATE

    this.updateTitle = function (changed, extra) {
        var model = this.model, updateText = false, updateBg = false;

        for (var prop in changed) {
            // grab the new value
            var value = changed[prop];

            switch (prop) {
                case 'titleVisible':
                    $title[model.getTitleVisible() ? 'show' : 'hide']();
                case 'titleBackgroundVisible':
                    var showTitle = model.getTitleVisible();
                    var showBg = model.getTitleBackgroundVisible();
                    $titleBg[showTitle && showBg ? 'show' : 'hide']();
                    break;

                case 'font':
                case 'fontWeight':
                case 'fontStyle':
                case 'fontSize':
                case 'title':
                case 'titleHorPos':
                case 'titleVertPos':
                    updateText = true;
                    break;

                case 'fontAlign':
                    $title.css('textAlign', model.getFontAlign());
                    break;

                case 'fontColor':
                    $title.css('color', '#' + model.getFontColor());
                    break;

                case 'titleBackgroundColor':
                    $titleBg.css('background-color', '#' + model.getTitleBackgroundColor());
                    break;

                case 'titleBackgroundHorPos':
                case 'titleBackgroundVertPos':
                case 'titleBackgroundWidth':
                case 'titleBackgroundHeight':
                    updateBg = true;
                    break;

                case 'titleBackgroundOpacity':
                    $titleBg.css('opacity', model.getTitleBackgroundOpacity() / 100);
                    break;
                case 'width':
                case 'height':
                    updateText = true;
                    /**
                     * @cancel height is set directly through model _set method & doesn't update titleBackgroundHeight
                     * which results in no preview update
                     */
                    if (typeof extra === 'object' && typeof extra.action === 'string' && extra.action === 'cancel') {
                        updateBg = true;
                    }
                    break;
            }
        }

        if (updateText) {
            $title.css({
                fontFamily: model.getFont(),
                fontWeight: model.getFontWeight(),
                fontStyle: model.getFontStyle(),
                fontSize: model.getFontSize() + 'px'
            });
            var titleText = model.getTitle();
            $.browser.msie ? $title.html(titleText.replace(/ /g, "&nbsp;").replace(/\n/g, "<br />")) : $title.text(titleText);

            /* Recalculate text css position based on the new text measurements and sliders */
            var sliderValues = {
                left: model.getTitleHorPos(),
                top: model.getTitleVertPos()
            };

            var newCssPos = $title.anchorPosition().fromAnchorPosition(sliderValues);
            var percentPos = $title.anchorPosition().toPercentPosition(newCssPos);

            $title.css({
                left: percentPos.left + '%',
                top: percentPos.top + '%'
            });

            // Recalculate draggable containment box
            $title.draggable('option', 'containment', this.getDraggableContainment($title, $eh));
        }

        if (updateBg) {
            $titleBg.css('width', model.getTitleBackgroundWidth() + '%');
            $titleBg.css('height', Math.round(model.getTitleBackgroundHeight() * model.getHeight() / 100));

            /* Recalculate text bg css position based on the new bg measurements and sliders */
            var sliderValues = {
                left: model.getTitleBackgroundHorPos(),
                top: model.getTitleBackgroundVertPos()
            };

            var newCssPos = $titleBg.anchorPosition().fromAnchorPosition(sliderValues);
            var percentPos = $titleBg.anchorPosition().toPercentPosition(newCssPos);

            $titleBg.css({
                left: percentPos.left + '%',
                top: percentPos.top + '%'
            });

            // Recalculate draggable containment box
            $titleBg.draggable('option', 'containment', this.getDraggableContainment($titleBg, $eh));
        }
    };

    this.updateLogo = function (changed, extra) {
        if (!isLogoIncluded) return;

        var model = this.model, update = false;

        for (var prop in changed) {
            // grab the new value
            var value = changed[prop];

            switch (prop) {
                case 'logoVisible':
                    $logo[value && !model.getLogoDeleted() ? 'show' : 'hide']();
                    break;

                case 'logoDeleted':
                    $logo[!value && model.getLogoVisible() ? 'show' : 'hide']();
                    break;

                case 'logoUrl':
                    if (value) {
                        $logo.attr('src', value);
                    }
                    if (value && model.getLogoVisible()) {
                        $logo.show();
                    }
                    break;

                case 'logoBorderVisible':
                    update = true;
                    break;

                case 'logoOriginalWidth':
                case 'logoOriginalHeight':
                case 'logoZoom':
                case 'logoHorPos':
                case 'logoVertPos':
                case 'logoPadding':
                case 'logoBorderSize':
                    update = true;
                    break;

                case 'logoBorderColor':
                    $logo.css('borderColor', '#' + value);
                    break;

                case 'width':
                case 'height':
                    /**
                     * @cancel height is set directly through model _set method and doesn't update logoZoom
                     * which results in no preview update
                     */
                    if (typeof extra === 'object' && typeof extra.action === 'string' && extra.action === 'cancel') {
                        update = true;
                    }
                    break;
            }
        }

        if (model.getLogoDeleted()) return;

        if (update) {
            var logoBorderVisible = model.getLogoBorderVisible(),
                originalWidth = model.getLogoOriginalWidth(),
                originalHeight = model.getLogoOriginalHeight(),
                size = {width: 0, height: 0};

            var orientation = model.getWidth() / originalWidth > model.getHeight() / originalHeight ? 'height' : 'width';
            var outer = logoBorderVisible ? 2 * model.getLogoBorderSize() + 2 * model.getLogoPadding() : 0;
            var ratio = originalWidth / originalHeight;

            if (orientation == 'width') {
                size.width = Math.max(model.getLogoZoom() / 100 * model.getWidth() - outer, 1);
                size.height = size.width / ratio;
            }
            else {
                size.height = Math.max(model.getLogoZoom() / 100 * model.getHeight() - outer, 1);
                size.width = size.height * ratio;
            }

            $logo.css({
                'width': Math.round(size.width) + 'px',
                'height': Math.round(size.height) + 'px',
                'padding': logoBorderVisible ? model.getLogoPadding() + 'px' : 0,
                'border': logoBorderVisible ? model.getLogoBorderSize() + 'px solid #' + model.getLogoBorderColor() : 0
            });

            var anchor = $logo.anchorPosition();
            var cssPos = anchor.fromAnchorPosition({
                left: model.getLogoHorPos(),
                top: model.getLogoVertPos()
            });
            var percentPos = anchor.toPercentPosition(cssPos);

            $logo.css({
                'left': percentPos.left + '%',
                'top': percentPos.top + '%'
            });

            // Recalculate draggable containment box
            $logo.draggable('option', 'containment', this.getDraggableContainment($logo, $eh));
        }
    };

    hasCanvas = (function () {
        var tmp = document.createElement('canvas');
        if (!tmp.getContext) {
            return false;
        }
        if (!tmp.getContext('2d')) {
            return false;
        }
        if (!tmp.getContext('2d').getImageData) {
            return false;
        }
        return true;
    })();

    this.updateBackground = function (changed, extra) {

        if (_backgroundDisabledByLayout) return;

        var doUpdate = false, x, val;
        for (x in changed) {
            val = changed[x];
            switch (x) {
                case 'backgroundVisible':
                    var bgVisibility = val ? 'visible' : 'hidden';
                    $bgImgWrapper.css('visibility', bgVisibility);
                    $bgImg.css('visibility', bgVisibility);
                    if (hasCanvas) {
                        $bgCanvas = $('#cc-eh-img-preview', $eh);
                        $bgCanvas.css('visibility', bgVisibility);
                    }
                    if ($origImage) {
                        if (bgVisibility == 'hidden') {
                            $origImage.data('bk-visibility', $origImage.css('visibility'));
                            $origImage.css('visibility', bgVisibility);
                        } else {
                            var bkVisibility = $origImage.data('bk-visibility');
                            if (bkVisibility) {
                                $origImage.data('bk-visibility', '');
                                $origImage.css('visibility', bkVisibility);
                            } else {
                                $origImage.css('visibility', bgVisibility);
                            }
                        }
                    }
                    doUpdate = true;
                    break;
                case 'bgImageUrl':
                    loadOrigBgImage(this.model.getBgImageUrl());
                    doUpdate = true;
                    break;
                case 'rotate':
                case 'brightness':
                case 'sharpen':
                case 'backgroundOriginalWidth':
                case 'backgroundOriginalHeight':
                case 'backgroundZoom':
                case 'backgroundHorPos':
                case 'backgroundVertPos':
                    doUpdate = true;
                    break;
                // variable width is not supported at the moment
                // but the logic is the same
                case 'width':
                case 'height':
                    if (!extra || !extra.isChanging) {
                        doUpdate = true;
                    }
                    break;

                case 'bgColor':
                    $eh.css('background-color',
                        val
                        && !_backgroundDisabledByLayout
                        && !_backgroundColorDisabledByLayout
                            ? '#' + val : 'transparent');
                    break;
            }
        }
        if (doUpdate) {
            // we initialize needed components for image edit
            // only on first update. Until then we keep showing
            // the image prepared by server (this is especially useful for keyvisuals
            // because we don't know how precropped image was cropped from the original
            // keyvisual image)
            if (!bgImageManipulationInitialized) {
                initializeBgImageManipulation();
                bgImageManipulationInitialized = true;
            }
            if (this.model.getBackgroundEdited() == 1) {
                if (hasCanvas && !this.model.getBackgroundAnimated()) {
                    this.doUpdateBackground(changed);
                } else if (this.model.getBrightness() != 0
                    || this.model.getSharpen() != 0
                    || this.model.getRotate() != 0
                ) {
                    this.doUpdateBackgroundNoCanvas(changed, extra);
                } else {
                    // this is just repositioning when no canvas support
                    // no server call required
                    var zoom = getBackgroundZoomRatio();
                    $origImage.css({
                        width: this.model.getBackgroundOriginalWidth() * zoom,
                        height: this.model.getBackgroundOriginalHeight() * zoom
                    });
                    $bgImg.hide();
                    $origImage.css({
                        visibility: this.model.getBackgroundVisible() ? 'visible' : 'hidden',
                        left: -this.model.getBackgroundHorPos() / 100.0 * ($origImage.width() - this.model.getWidth()),
                        top: -this.model.getBackgroundVertPos() / 100.0 * ($origImage.height() - this.model.getHeight())
                    });
                }
            } else {
                this.doUpdateBackgroundNoCanvas(changed, extra);
            }
        }
    };

    var initializeBgImageManipulation = function () {
        if (hasCanvas) {
            $bgCanvas = $('#cc-eh-img-preview', $eh);
            if (!$bgCanvas.length) {
                bgCanvas = document.createElement('canvas');
                $bgCanvas = $(bgCanvas);
                $bgCanvas.attr('id', 'cc-eh-img-preview');
                $bgImgWrapper.prepend(bgCanvas);
            } else {
                bgCanvas = $bgCanvas[0];
            }
        }
    };

    var getBackgroundZoomRatio = function () {
        var
            m = self.model,
            origSize,
            size,
            bgMaxZoom = m.getBackgroundMaxZoom(),
            width = m.getWidth(),
            height = m.getHeight(),
            origWidth = m.getBackgroundOriginalWidth(),
            origHeight = m.getBackgroundOriginalHeight()
            ;
        if (width / origWidth > height / origHeight) {
            origSize = origWidth;
            size = width;
        } else {
            origSize = origHeight;
            size = height;
        }
        var
            onePercentPx = Math.max(0, ((bgMaxZoom / 100) * origSize - size) / (bgMaxZoom - 100)),
            zoomPx = onePercentPx * (m.getBackgroundZoom() - 100) + size,
            zoom = zoomPx / origSize
            ;
        return zoom;
    };

    this.doUpdateBackground = function (changed) {
        if (!origBgImageLoaded) {
            $origImage.one('load', function () {
                self.doUpdateBackground.call(self, changed);
            });
            return;
        }
        var context = bgCanvas.getContext('2d'), m = this.model;

        $bgCanvas.show();
        $bgCanvas.attr('width', m.getWidth());
        $bgCanvas.attr('height', m.getHeight());

        context.save();
        context.clearRect(0, 0, bgCanvas.width, bgCanvas.height);

        // POSITIONING
        var
            origWidth = m.getBackgroundOriginalWidth(),
            origHeight = m.getBackgroundOriginalHeight(),
            ehWidth = m.getWidth(),
            ehHeight = m.getHeight(),
            horPos = m.getBackgroundHorPos() / 100,
            vertPos = m.getBackgroundVertPos() / 100,
        // calculate the zoom to be applied to the
        // original image, we will scale the canvas with that value
            zoom = getBackgroundZoomRatio(),
            zoomWidth = origWidth * zoom,
            zoomHeight = origHeight * zoom,
        // calculating zoomed image corner coordinates
        // when axis origin is the center of the emotion header,
            zoomTopLeft = {
                x: -(ehWidth / 2 + horPos * (zoomWidth - ehWidth)),
                y: -(ehHeight / 2 + vertPos * (zoomHeight - ehHeight))
            },
            fitZoom = 1
            ;

        // ROTATION
        var rotate = m.getRotate();
        if (rotate != 0) {
            // after this rotation there may be some header zones uncovered by image
            // so, we detect this and zoom in so that this will be corrected
            var
                zoomCoords = [
                    zoomTopLeft,
                    {x: zoomTopLeft.x + zoomWidth, y: zoomTopLeft.y},
                    {
                        x: zoomTopLeft.x + zoomWidth,
                        y: zoomTopLeft.y + zoomHeight
                    },
                    {x: zoomTopLeft.x, y: zoomTopLeft.y + zoomHeight}
                ],
            // calculate coordinates of rotated zoom image
                rotZoomCoords = calculations.getRotatedPointsCoordinates(zoomCoords, rotate),
                ehBox = [
                    {x: -ehWidth / 2, y: -ehHeight / 2},
                    {x: ehWidth / 2, y: -ehHeight / 2},
                    {x: ehWidth / 2, y: ehHeight / 2},
                    {x: -ehWidth / 2, y: ehHeight / 2}
                ]
                ;
            fitZoom = calculations.getZoomToFit(ehBox, rotZoomCoords);
            zoom = zoom * fitZoom;
        }

        context.scale(zoom, zoom);

        context.translate(
            ehWidth / 2 / zoom,
            ehHeight / 2 / zoom
        );

        context.rotate(Math.PI / 180 * rotate);

        // DRAW IMAGE
        context.drawImage($origImage[0],
            zoomTopLeft.x / zoom * fitZoom,
            zoomTopLeft.y / zoom * fitZoom
        );
        context.restore();

        // SHARPEN & BRIGHTNESS
        var sharpen = m.getSharpen();
        var brightness = m.getBrightness();
        if (sharpen != 0 || brightness != 0) {
            var dt = context.getImageData(0, 0, bgCanvas.width, bgCanvas.height);
        }
        if (sharpen != 0) {
            var dtcopy = context.getImageData(0, 0, bgCanvas.width, bgCanvas.height);
            effects.doSharpnessBlur(sharpen, dt, dtcopy);
        }
        if (brightness != 0) {
            effects.doBrightness(brightness, 0, dt);
        }
        if (sharpen != 0 || brightness != 0) {
            context.putImageData(dt, 0, 0);
        }

        // hide image, just in case it has some transparency to not create a ghosting effect
        $bgImg.hide();
        $bgImg.addClass('eh-img-preview-background'); // TODO is this really needed?
    };

    var loadOrigBgImage = function (imgUrl) {
        origBgImageLoaded = false;
        if (!$origImage) {
            $origImage = $('#eh-bg-orig-image', $eh);
            if (!$origImage.length) {
                $origImage = $('<img id="eh-bg-orig-image" />');
                $origImage.css({
                    visibility: 'hidden',
                    position: 'absolute'
                });
                $bgImgWrapper.append($origImage);
            }
        }
        $origImage.removeAttr('src');
        $origImage.one('load', function () {
            var origWidth = $origImage.width(), origHeight = $origImage.height();
            // we should get the original size of the new image
            $origImage.width('auto');
            $origImage.height('auto');
            var newOrigWidth = $origImage.width(), newOrigHeight = $origImage.height();
            // restore the previous width, resising is done elsewhere
            // so we don't want to change anything here
            $origImage.width(origWidth);
            $origImage.height(origHeight);
            self.model.set({
                backgroundOriginalWidth: newOrigWidth,
                backgroundOriginalHeight: newOrigHeight
            }, undefined, {dataChanged: false});
            origBgImageLoaded = true;
        });
        $origImage.attr('src', imgUrl);
    };

    var getPrepImageUrl = function (m) {
        var prepImageUrl = m.getBgImageUrl(),
            bgSettings = m.getBgImageSettings()
            ;

        // appending to the url param for picture manipulation
        for (var x in bgSettings) {
            if (bgSettings.hasOwnProperty(x)) {
                prepImageUrl += '&' + x + '=' + bgSettings[x];
            }
        }

        // appending to the url params for current header size
        prepImageUrl += '&width=' + m.getWidth();
        prepImageUrl += '&height=' + m.getHeight();

        return prepImageUrl;
    };

    this.doUpdateBackgroundNoCanvas = function (changed, extra) {
        // we should initiate remote actions only after setting is changed
        // (like when slider is released)
        if (extra && extra.isChanging) return;

        var m = this.model,
            prepImageUrl = getPrepImageUrl(m);

        $(document).trigger('CC.EmotionHeader.Preview.onTaskStarted');
        $bgTmpImg = $('<img />');
        $bgTmpImg.one('load', function () {
            /* though getPrepImageUrl function is also called above and
             * stored in prepImageUrl, we'll call it again
             * as we need it's new data when the image
             * has been loaded */
            $bgImg.attr('src', getPrepImageUrl(m));
            if (hasCanvas) {
                $bgCanvas.hide();
            }
            $bgImg.show();
            $origImage.css('visibility', 'hidden');
            $bgTmpImg.remove();
            $(document).trigger('CC.EmotionHeader.Preview.onTaskCompleted');
        });
        $bgTmpImg.attr('src', prepImageUrl);
    };

    this.destroy = function () {
        //$logo.add($title).draggable('destroy');
    };

    this.disableAllDraggable = function () {
        this.setAllDraggable(false);
    };

    this.enableAllDraggable = function () {
        this.setAllDraggable(true);
    };
    this.setAllDraggable = function (enable) {
        var
            $elements,
            elements = [$title, $titleBg, $shopButton];

        if (isLogoIncluded) {
            elements.push($logo);
        }
        $elements = $(elements).map(function () {
            return this.toArray();
        });

        $elements.draggable("option", "disabled", !enable);
    };

    this.getDraggableContainment = function ($elem, $parent) {
        var parentOffset = $parent.offset();
        return [
            parentOffset.left,
            parentOffset.top,
            parentOffset.left + Math.max(0, $parent.innerWidth() - $elem.outerWidth()),
            parentOffset.top + Math.max(0, $parent.innerHeight() - $elem.outerHeight())
        ];
    };

    // this exposes the slider position
    // for the shop button to other tabs (shop)
    this.shopButtonSliderPosition = function () {
        return $shopButton.anchorPosition().getAnchorPosition();
    };
};


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

var features = __webpack_require__(25);
var $ = __webpack_require__(3);

module.exports = function (_super)
{
    this.tabElementId = 'eh-background';
    this.imageCountLimit = jimdoData.emotionheader.background.imageCountLimit;
    this.thumbDimensions = jimdoData.emotionheader.background.thumbDimensions;
    this.defaultBgColor = jimdoData.emotionheader.background.defaultBgColor;

    this.model = _super.model;
    this.syncWithModel = null;

	var self = this;

	var MAX_IMAGES = 10;
	var imageLimitReachedMessage = jimdoData.messages.emotionheader.background.dialog.imageLimitReached.format(MAX_IMAGES);

	var $eheContent = _super.$eheContent,
		$saveModeOpts,
		$btnChangeImage,
		$fieldset,
		optionControlMapper = {},
        $carousel,
        $colorPickerContainer,
        $bgAltTag;

	this.init = function() {
        $bgAltTag = $('#eh-bg-alttag', $eheContent);

        this.syncWithModel = $.proxy(this.updateImage, this);

        this.initSourcePopup();

        // load Settings subview
        _super.switchView('Settings');

        this.initFields();
        //the colorPicker 1st
        this.initBgColorPicker();
        //then the carousels which might show the colorPicker
        this.initCarousel();

		this.setupChangeHandlers();

        /**
         * Make some SiteCatalyst tracking
         */
        $(document).trigger('diy-editor-makeWebsiteFit', {
            'condition': 'Visited',
            'name': 'Key Visual'
        });
	};

    this.initFields = function() {
        $fieldset = $('#eh-bg-fieldset');
        $fieldset.fieldset({ collapsed: true });

        $saveModeOpts = $('#eh-bg-save-mode-options');
        $saveModeOpts.radiogroup({selectedClass: 'eh-radio-item-selected'});

        //saveMode
        optionControlMapper['saveMode'] = {
            getValue: function(val) {
                return $saveModeOpts.radiogroup('value');
            },
            setValue: function(val) {
                // set new value and triggering the change event
                $saveModeOpts.radiogroup('value', val);
            }
        };
        $saveModeOpts.bind('change_radiogroup', function(e, val) {
            //stop syncing - this is a reset to default header
            self.stopCarouselModelSync();

            self.model.setSaveMode(val);
            if (val === 'default_header') {
                $carousel.diy_carousel('option', 'items', self.model.getImageList().slice(0))
            }
            self.startCarouselModelSync();
        });

        optionControlMapper['backgroundVisible'] =  {
            getValue: function() {
                return !$fieldset.fieldset('isCollapsed');
            },
            setValue: function(val) {
                $fieldset.fieldset('setCollapsed', val != 1);
                optionControlMapper['backgroundVisible'].valueChanged(val);
            },
            changeHandler: function() {
                $fieldset.bind('toggle.fieldset', function(e, show) {
                    if (show) {
                        var selectedItemData = $carousel.diy_carousel('getSelectedItem');
                        self.model.set({
                            backgroundVisible: 1,
                            bgColor: self.getItemBgColor(selectedItemData, $carousel)
                        });
                    } else {
                        self.model.set({
                            backgroundVisible:0,
                            bgColor: self.getItemBgColor(null, $carousel)
                        });
                    }

                    optionControlMapper['backgroundVisible'].valueChanged(show);
                });
            },
            valueChanged: self.backgroundVisibleHandler
        };

        if (_backgroundDisabledByLayout) {
            $fieldset.fieldset('setDisabled', true);
            self.backgroundVisibleHandler(0);
        }

        _super.initSlider({option: 'height', id: '#eh-height-slider', min: 1, max: 1000,	step: 1,
            formatter: function (val) {
                return val + 'px';
            }
        }, optionControlMapper, this.model);

        optionControlMapper['heightEditable'] = {
            setValue: function(val) {
                $('#eh-height-slider').diy_slider('option', 'disabled', !val);
            }
        };

        optionControlMapper['backgroundAltTag'] = {
            getValue: function () {
                return $bgAltTag.val();
            },
            setValue: function (val) {
                if(val !== $bgAltTag.val()) {
                    $bgAltTag.val(val);
                }
                $('#emotion-header-img').attr('alt', val);
            },
            changeHandler: function () {
                $bgAltTag.bind('keyup', function () {
                    self.model.set('backgroundAltTag', $bgAltTag.val());
                });
            }
        };
    };

    this.initSourcePopup = function() {
        $btnChangeImage = $('#eh-bg-change-image');
        var changeImageHandler;
        var tooltipTimeout;

        changeImageHandler = function(){
            if ($carousel.diy_carousel('getItemsNo') >= MAX_IMAGES) {
                if (!tooltipTimeout) {
                    $btnChangeImage.diy_tooltip({
                        cls : 'diy-alert-tooltip ',
                        content: imageLimitReachedMessage,
                        triggerMode: 'none'
                    });
                    $btnChangeImage.diy_tooltip('show');
                }
                tooltipTimeout && clearTimeout(tooltipTimeout);
                tooltipTimeout = setTimeout(function(){
                    $btnChangeImage.diy_tooltip('destroy');
                    tooltipTimeout = null;
                }, 3000);
            } else {
                openFilemanager();
            }
        }
        $btnChangeImage.click(changeImageHandler);
    }

	this.backgroundVisibleHandler = function (val) {
	    if (val && !_backgroundDisabledByLayout) {
            //show background editable area
            $fieldset.fieldset('setCollapsed', false);
			//if carousel is initialized while collapsed
			//the buttons are not correctly refreshed
            $carousel.diy_carousel('refresh');
            $('#eh-editor .feature-guidance-help-button').show();
        } else {
            $fieldset.fieldset('setCollapsed', true);
            $('#eh-editor .feature-guidance-help-button').hide();
        }
    };

	this.setupChangeHandlers = function() {
		for (option in optionControlMapper) {
			if(optionControlMapper[option].changeHandler) {
				optionControlMapper[option].changeHandler();
			}
		}
    };

	this.switchSubView = function(subViewName) {
		switch (subViewName) {
            case 'Settings':
				return $('#eh-bg-image-editor-control');
				break;
		}
	};

	this.updateView = function(model, data, changed)
	{
        for(var option in changed) {
            var value = changed[option];
            if(optionControlMapper[option]) {
                optionControlMapper[option].setValue(value);
            }
        }
    };

    this.destroy = function() {/* TODO */ };

    var addImagesToCarousel = function(imagesData) {
        $carousel.diy_carousel('addItems', imagesData.map(function(imageData){
            return $.extend({}, self.model.bgImageDefaultSettings, imageData);
        }), -1, false /* no scroll */);
    };

    var updateChangeImageStatus = function() {
        if ($carousel.diy_carousel('getItemsNo') >= MAX_IMAGES) {
            $btnChangeImage.addClass('disabled');
        } else {
            $btnChangeImage.removeClass('disabled');
        }
    };

    var openFilemanager = function() {
        // First determine the background color for the patterns color picker
        // which corresponds to the currently selected image in the carousel
        var bgColor, sources;
        if (_backgroundColorDisabledByLayout) {
            bgColor = null; // transparent
        } else {
            if ($carousel.diy_carousel('getItemsNo') > 0) {
                bgColor = self.getItemBgColor($carousel.diy_carousel('getSelectedItem'), $carousel);
            } else {
                bgColor = self.model.getBgColor() ? self.model.getBgColor() : self.defaultBgColor;
            }
        }

        var insertStorageItems = function (items, succClb, errClb){
            var itemsIds = items.map(function (item) {
                return item.getId();
            });

            jQuery.ajax({
                type: 'POST',
                url: '/app/module/emotionheader/link-storage-files',
                data: {
                    pageId: _super.pageId,
                    storageFileIds: itemsIds
                },
                success: function (response, status, jqXHR) {
                    if (response.success) {
                        var images = response.data.images;

                        addImagesToCarousel(images.map(function (image) {
                            return {
                                backgroundSourceType: 'ImageUpload',
                                thumbSrc: image.thumbSrc,
                                sourceThumbSrc: image.sourceThumbSrc,
                                previewSrc: image.previewSrc,
                                uploadedImageId: image.imageId,
                                backgroundAnimated: image.backgroundAnimated
                            }
                        }));

                        succClb();
                    } else {
                        errClb(response);
                    }
                },
                error: function (jqXHR, status, errorThrown) {
                    errClb(errorThrown);
                }
            });
        }

        sources = {
            keyvisuals: function(items, succClb, errClb) {
                addImagesToCarousel(items.map(function(item) {
                    var itemId = item.getId(), itemRes = item.getResource();
                    return {
                        backgroundSourceType: 'Gallery',
                        imageId: itemId.id,
                        imageVersion: itemId.version,
                        sourceThumbSrc: itemRes.sourceThumbSrc,
                        thumbSrc: itemRes.thumbSrc,
                        previewSrc: itemRes.previewSrc
                    };
                }));
                succClb();
            },
            patterns: {
                backgroundColor: bgColor,
                enableBgColorPicker: !_backgroundColorDisabledByLayout,
                callback: function(items, succClb, errClb) {
                    addImagesToCarousel(items.map(function(item) {
                        var itemId = item.getId(), itemRes = item.getResource();
                        return {
                            backgroundSourceType: 'Patterns',
                            patternId: itemId.id,
                            patternBw: itemId.tinge,
                            bgColor: itemId.backgroundColor,
                            sourceThumbSrc: itemRes.sourceThumbSrc,
                            thumbSrc: itemRes.thumbSrc,
                            previewSrc: itemRes.previewSrc
                        }
                    }));
                    succClb();
                }
            },
            storage: insertStorageItems,
            bigstock: {
                batchSize: 1,
                callback: insertStorageItems
            },
            '123rf': {
                batchSize: 1,
                callback: insertStorageItems
            }
        };

        sources.cms = {
            batchSize: 1,
            callback: function(items, succClb, errClb) {
                var itemsIds = items.map(function(item){
                    return item.getId();
                });

                jQuery.ajax({
                    type: 'POST',
                    url: '/app/module/emotionheader/import-cms-images',
                    data: {
                        pageId: _super.pageId,
                        cmsImageIds: itemsIds
                    },
                    success: function(response, status, jqXHR) {
                        if (response.success) {
                            var images = response.data.images;

                            addImagesToCarousel(images.map(function(image) {
                                return {
                                    backgroundSourceType: 'External',
                                    thumbSrc: image.thumbSrc,
                                    sourceThumbSrc: image.sourceThumbSrc,
                                    previewSrc: image.previewSrc,
                                    uploadedImageId: image.imageId,
                                    backgroundAnimated: image.backgroundAnimated
                                }
                            }));

                            succClb();
                        } else {
                            errClb(response);
                        }
                    },
                    error: function(jqXHR, status, errorThrown) {
                        errClb(errorThrown);
                    }
                });
            }
        };

        var alreadyExisting = $carousel.diy_carousel('getItemsNo');

        diy.editor.filemanager = new diy.editor.Filemanager({
            appName: 'filemanager',
            mode: 'selection',
            subSection: 'keyvisualsPhotos', // default opened
            maxSelection: MAX_IMAGES,
            alreadyExisting: alreadyExisting,
            sources: sources,
            callback: function(report) {
                if (report.successItems.length === 0) {
                    // TODO check if some error handling have to be done here
                } else {
                    // scroll to the first added
                    // alreadyExisting is exactly the index of first added
                    $carousel.diy_carousel('scrollToItem', alreadyExisting);
                    $carousel.diy_carousel('selectItem', alreadyExisting);
                }
            }
        });
    };

	this.showLoadingBox = function() {
    };

    this.hideLoadingBox = function() {
    };

    var $colorPicker,
    carouselOptions = {
        selectable: true,
        sortable: true,
        syncWidth: true,
        sortableOptions: {
            start: function(event, ui, $carousel) {
                self.stopCarouselTooltips($carousel);
            },
            stop: function(event, ui, $carousel) {
                self.initCarouselTooltips($carousel);
            }
        },
        itemCreate: function(event, data) {
            if (data.item.backgroundSourceType === 'Patterns' && !_backgroundColorDisabledByLayout) {
                //if item data is changed update bgColor and tooltip
                data.itemEl.bind('updatedItem', function (event, data) {
                    self.setBgColorOnCarouselItem(this, data.bgColor);
                });
                self.setBgColorOnCarouselItem(data.itemEl, data.item.bgColor);
            }

            jQuery('.carousel-item-del', data.itemEl).click(
                $.proxy(function() {
                    $(this).diy_carousel('deleteItemEl', data.itemEl);
                }, this)
            );
        },
        create: function() {
            self.initCarouselTooltips(this);
        },
        afterItemAdd: function(event, data) {
            self.initCarouselTooltips(this);
            _super.triggerDataChanged();
            //select item & set to bg
            $(this).diy_carousel('selectItem', data.index);
        },
        afterItemsAdded: function(event, data) {
            self.initCarouselTooltips(this);
            _super.triggerDataChanged();
            //select item & set to bg
            $(this).diy_carousel('selectItem', data.index);
        },
        afterItemSelect: function (event, data) {
            _super._ignoreDataChange = true;
            self.model.setBgImageSource(data.item.backgroundSourceType, $.extend({}, data.item, {
                bgColor: self.getItemBgColor(data.item, $(this))
            }));
            _super._ignoreDataChange = false;
        },
        afterItemDelete: function(event, data) {
            self.initCarouselTooltips(this);
            _super.triggerDataChanged();
            if ($(this).diy_carousel('getItemsNo') > 0) {
                //if no item selected
                if ($(this).diy_carousel('getSelectedItemIndex') < 0) {
                    //select previous item
                    $(this).diy_carousel('selectItem', Math.max(0, data.itemIndex - 1));
                }
            } else {
                self.model.resetBgImage();
            }
        }
    };

    this.setBgColorOnCarouselItem = function(itemEl, bgColor) {
        if (typeof bgColor === 'undefined') {
            return;
        }

        var $itemEl = $(itemEl);
        $itemEl.find('.thumb').css('background-color', '#' + bgColor);
    };

    this.initBgColorPicker = function() {
        $colorPickerContainer = $('.pattern-color-picker', $('#eh-view-wrapper-Background'));
        var $color = self.model.getBgColor() ? self.model.getBgColor() : this.defaultBgColor;

        // create and initialize the color picker
        $colorPicker = $colorPickerContainer.colorPicker({
            mode: 'button',
            color: '#' + $color,
            showButtons: true,
            onColorAccept: function (color) {
                self.model.set('bgColor', color, true);
            }
        });

        self.model.bind('change', function(foo, bar, changed, extra) {
            if (changed['bgColor']) {
                // change default and current bg color in the color picker;
                // but only if the call didn't come manually from the picker
                if (!(extra && true === extra['doNotSetColorPicker'])) {
                    $colorPicker.setColor(changed['bgColor'], false);
                }
            }
        });

        CC.EmotionHeader.bind('switchView', function(viewName) {
            if ($colorPicker.isColorButtonOpened()) {
                $colorPicker.abortColor();
            }
        });
    }

    this.updateImage = function (model, data, changed) {
        if (typeof changed.backgroundVisible !== 'undefined') {
            //skip update when switching between visible
            return;
        }

        var updatedData = {};
        $.each(changed, function(propName, value){
            if (model.isBgProperty(propName)) {
                updatedData[propName] = value;
            }
        });

        //nothing bg related changed
        if ($.isEmptyObject(updatedData)) {
            return;
        }

        var selectedIndex = $carousel.diy_carousel('getSelectedItemIndex');
        var item = $carousel.diy_carousel('getItem', selectedIndex);

        //now compare with the stored data in the carousel
        var copyOfUpdatedData = updatedData;
        $.each(copyOfUpdatedData, function(propName, value) {
            if (typeof item[propName] != 'undefined' && item[propName] == value) {
                delete updatedData[propName];
            }
        });

        //nothing new/changed
        if ($.isEmptyObject(updatedData)) {
            return;
        }

        //update carousel item
        $carousel.diy_carousel('updateItem', selectedIndex, updatedData);

        //console.log('updated list item no '+selectedIndex+' with', updatedData);
    };

    this.startCarouselModelSync = function() {
        //console.log('this.startCarouselModelSync');
        this.model.bind('change', this.syncWithModel);
    };

    this.stopCarouselModelSync = function() {
        //console.log('this.stopCarouselModelSync');
        this.model.unbind('change', this.syncWithModel);
    };

    /**
     * returns bgColor to use from list of images + model
     * when selecting an image that is not a pattern
     * @param Object $carousel item object
     * @return {string|Number} color
     */
    this.getItemBgColor = function(item, $carousel) {
        if (item && item.backgroundSourceType === 'Patterns') {
            return item.bgColor;
        }

        //return 1st pattern color in list
        var items = $carousel.diy_carousel('getItems');
        for (var i=0; i<items.length; i++) {
            if (items[i].backgroundSourceType === 'Patterns') {
                return items[i].bgColor;
            }
        }

        var currentColor = this.model.getBgColor();
        if (typeof currentColor !== 'undefined' && currentColor != '0') {
            return currentColor;
        }

        return this.defaultBgColor;
    };

    this.initCarousel = function() {
        $carousel = $('#eh-bg-carousel');
        var imageList = this.model.getImageList().slice(0);

        $carousel.diy_carousel($.extend({}, carouselOptions, {
            itemTemplate: '<div class="thumb" >'
                +'<div class="imageItem">'
                    +'<img class="gallery-preview" src="{thumbSrc}" />'
                +'</div>'
                +'<div class="tooltip-trigger"></div>'
                +'<div class="carousel-item-del"></div>'
            +'</div>'
            + '<div class="selected-arrow"></div>',
            maxWidth: (diy.editor.uiPreference.isPointerModeTouch() ? 435 : 455),
            items: imageList,
            afterRefreshItems: function(event, data) {
                self.initCarouselTooltips(this);
                //when items are refresh select 1st item
                $carousel.diy_carousel('selectItem', 0);
            },
            afterItemSelect: function(event, data) {
                carouselOptions.afterItemSelect.call(this, event, data);

                //show colorPicker just for patterns
                if (!_backgroundColorDisabledByLayout && data.item.backgroundSourceType === 'Patterns') {
                    $('#eh-color-picker-wrapper').show();
                } else {
                    $('#eh-color-picker-wrapper').hide();
                }

                $carousel.diy_carousel('scrollToItem', data.index);
            },
            afterItemDelete: function(event, data) {
                carouselOptions.afterItemDelete.call(this, event, data);
            }
        }));
        updateChangeImageStatus();
        $carousel.bind(
            'carouselafteritemadd carouselafteritemsadded carouselafteritemdelete carouselafterrefreshitems',
            function(){
                updateChangeImageStatus();
            }
        );

        //select 1st item
        $carousel.diy_carousel('selectItem', 0);

        this.model.bind('eh-save eh-cancel', $.proxy(this.stopCarouselModelSync, this));
        _super.bind('open', $.proxy(function() {
            //refresh items
            $carousel.diy_carousel('option', 'items', this.model.getImageList().slice(0));
            this.startCarouselModelSync();
        }, this));
        this.startCarouselModelSync();
    }

    this.stopCarouselTooltips = function(carouselEl) {
        var $carouselItemEl = $(carouselEl).find('.diy-carousel-items');

        if ($carouselItemEl.is(":diy-simpleTooltip")) {
            //refresh
            $carouselItemEl.diy_simpleTooltip('destroy');
        }
    };

    this.initCarouselTooltips = function(carouselEl) {
        var $carouselItemEl = $(carouselEl).find('.diy-carousel-items');

        if ($carouselItemEl.is(":diy-simpleTooltip")) {
            //refresh
            $carouselItemEl.diy_simpleTooltip('destroy');
        }

        $carouselItemEl.diy_simpleTooltip({
            anchorToTarget: false,
            trackMouse: true,
            delegate: 'div.tooltip-trigger',
            content: function(elem) {
                var data = $(carouselEl).diy_carousel('getItemFromEl',
                    $(elem.closest('div.diy-carousel-item'))
                );

                if (data.backgroundSourceType == 'Patterns') {
                    return '<a class="patterns-preview" style=\''+
                        'background: url(' + data.previewSrc + ') repeat scroll 0% 0% #' + data.bgColor +'; ' +
                        'width: ' + self.thumbDimensions.preview.width + 'px; height: ' +
                            self.thumbDimensions.preview.height + 'px; display: block;\' href="#"></a>';
                }

                return '<img src="' + data.previewSrc + '" />';
            },
            show: function() {
                var el = $(this);
                el.diy_simpleTooltip('getContentEl').find('img').one('load', function() {
                    el.diy_simpleTooltip('refresh');
                });
            },
            cls: 'diy-image-tooltip eh-keyvisual-tooltip',
            zIndex: 200000,
            position: {
                collision: 'fit'
            },
            fadeInDelay: 400
        });
    };

    this.getImageList = function() {
        return $carousel.diy_carousel('getItems').slice(0);
    },

    this.onShow = function () {
        // if carousel was initialised
        if (typeof $carousel !== 'undefined' && $carousel) {
            //sometimes after switching between from other EH headers we need to refresh carousel display
			//DHDIYE-3235: The list of images are displaying on vertical.
            $carousel.diy_carousel('refresh');
        }

        var bubbleEl = $('#eh-editor .feature-guidance-help-button');
        if (this.model.get('backgroundVisible') == 1) {
            bubbleEl.attr('data', 'header').show();
        } else {
            bubbleEl.attr('data', 'header').hide();
        }

        $(document).trigger('diy-editor-header-backgroundTabLoad')
    }
};



/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

var features = __webpack_require__(25);

diy.angular.registerFactory('diyfeatures', [function() { return features; }]);


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

var globalEvents = __webpack_require__(500);

diy.angular.registerFactory('diyglobalevents', [function() {
    return globalEvents;
}]);


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

var l10n = __webpack_require__(18);

diy.angular.registerFactory('diyl10n', [function() { return l10n.getString; }]);


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

var websiteData = __webpack_require__(4);

diy.angular.registerConstant('diywebsiteid',
    websiteData.getId()
);


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

var UiPreference = __webpack_require__(884);

diy.editor.uiPreference = UiPreference;
diy.editor.uiPreference.init();

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var Modernizr = __webpack_require__(21);
var helper = __webpack_require__(717);

module.exports = (function() {
    var currentPointerMode,
        POINTER_MODE_CLICK = 'click',
        POINTER_MODE_TOUCH = 'touch',

        STORAGE_ITEM_NAME = 'diy-ui-preference' + '-' + helper.getWebsiteId(),
        POINTER_MODE_KEY_NAME = 'pointerMode',
        preferences = null;

    var getPreferences = function() {
        var sData = localStorage.getItem(STORAGE_ITEM_NAME);

        if (sData === null) {
            return {};
        }

        return $.parseJSON(sData);
    };

    var setPreference = function(name, value) {
        preferences[name] = value;

        localStorage.setItem(STORAGE_ITEM_NAME, $.toJSON(preferences));
    };

    var getPreference = function (name) {
        return preferences[name];
    };

    var getSavedPointerMode = function() {
        return getPreference(POINTER_MODE_KEY_NAME);
    };

    var setPointerMode = function (value) {
        if (!validatePointerMode(value)) {
            throw new Error("Pointer mode " + value + " not valid");
        }

        if (value !== getSavedPointerMode()) {
            setPreference(POINTER_MODE_KEY_NAME, value);
            initPointerMode();
        }
    };

    var isPointerModeTouch = function() {
        return currentPointerMode === POINTER_MODE_TOUCH;
    };

    var validatePointerMode = function(pointerMode) {
        switch (pointerMode) {
            case POINTER_MODE_CLICK:
            case POINTER_MODE_TOUCH:
                return true;
            default:
                return false;
        }
    };

    var initPointerMode = function() {
        var savedPointerMode = getSavedPointerMode();

        if (validatePointerMode(savedPointerMode)) {
            currentPointerMode = savedPointerMode;
        } else {
            currentPointerMode = Modernizr.touch ? POINTER_MODE_TOUCH : POINTER_MODE_CLICK;
        }
    };

    var init = function() {
        //STORAGE_ITEM_NAME += '-' + helper.getWebsiteId();
        preferences = getPreferences();

        initPointerMode();

        if (isPointerModeTouch()) {
            $('html').addClass('diy-ui-interaction-touch');
        } else {
            $('html').addClass('diy-ui-interaction-click');
        }
    };

    return {
        init: init,
        isPointerModeTouch: isPointerModeTouch,
        TOUCH_POINTER_MODE: POINTER_MODE_TOUCH,
        CLICK_POINTER_MODE: POINTER_MODE_CLICK,
        setPointerMode: setPointerMode
    };
}());


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

var performanceTracking = __webpack_require__(886);

performanceTracking.init();


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

/*global jimdoData, perfBar */
var $ = __webpack_require__(3);

function loadPerformanceTrackingScript() {
    return Promise.resolve($.getScript('//uim.tifbs.net/js/1086.js'))
        .then(function () {
            NSfTIF.track(jimdoData.personaTrackingData);
        });
}

function waitForPageLoad() {
    return new Promise(function(resolve, reject) {
        $(window).on('load', function() {
            resolve();
        });
    });
}

function trackPerformance() {
    if (jimdoData.performanceTrackingEnabled) {
        NSfTIF.performance(jimdoData.performanceTrackingData);
    }
}

function onFail(reason) {
    throw new Error('Performance tracking error: ' + reason.toString());
}

function init() {
    var onLoadPromise = waitForPageLoad();

    Promise.all([
        loadPerformanceTrackingScript(),
        onLoadPromise
    ])
    .then(trackPerformance)
    .catch(onFail);

    if (jimdoData.performanceTrackingEnabled) {
        onLoadPromise
            .then(function () {
                if (perfBar) {
                    setTimeout(function () {
                        perfBar.init(jimdoData.performanceBarData);
                        perfBar.send();
                    }, 1000);
                }
            })
            .catch(onFail);
    }
}

module.exports = {
    init: init
};


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

var
    /** @type {function(new:module.undoRedo.Settings)} */
    Settings = __webpack_require__(888),
    /** @type {module.undoRedo.Settings} */
    settings,

    /** @type {function(new:module.undoRedo.FeatureSet)} */
    FeatureSet = __webpack_require__(890),
    /** @type {module.undoRedo.FeatureSet} */
    featureSet,

    /** @type {function(new:module.undoRedo.PluginRegistry)} */
    PluginRegistry = __webpack_require__(891),
    /** @type {module.undoRedo.PluginRegistry} */
    pluginRegistry,

    /** @type {function(new:module.undoRedo.SessionFactory)} */
    SessionFactory = __webpack_require__(893),
    /** @type {module.undoRedo.SessionFactory} */
    sessionFactory,

    /** @type {function(new:module.undoRedo.SessionManager)} */
    SessionManager = __webpack_require__(895),
    /** @type {module.undoRedo.SessionManager} */
    sessionManager,

    /** @type {function(new:module.undoRedo.EntryFactory)} */
    EntryFactory = __webpack_require__(896),
    /** @type {module.undoRedo.EntryFactory} */
    entryFactory,

    /** @type {function(new:module.undoRedo.History)} */
    History = __webpack_require__(906),
    /** @type {module.undoRedo.History} */
    history,

    /** @type {function(new:module.undoRedo.HistoryEntry.Factory)} */
    HistoryEntryFactory = __webpack_require__(898),
    /** @type {module.undoRedo.HistoryEntry.Factory} */
    historyEntryFactory,

    /** @type {function(new:module.undoRedo.PouchAdapter)} */
    PouchAdapter = __webpack_require__(908),
    /** @type {module.undoRedo.PouchAdapter} */
    database,

    /** @type {function(new:module.undoRedo.Storage)} */
    AppStorage = __webpack_require__(909),
    /** @type {module.undoRedo.Storage} */
    storage,

    /** @type {function(new:module.undoRedo.Ui)} */
    Ui = __webpack_require__(910),
    /** @type {module.undoRedo.Ui} */
    ui,

    /** @type {function(new:module.undoRedo.UiManager)} */
    UiManager = __webpack_require__(911),
    /** @type {module.undoRedo.UiManager} */
    uiManager,

    /** @type {function(new:module.undoRedo.Executor.Main)} */
    Executor = __webpack_require__(913),
    /** @type {module.undoRedo.Executor.Main} */
    executor,

    /** @type {function(new:module.undoRedo.Executor.Factory)} */
    ExecutorFactory = __webpack_require__(915),
    /** @type {module.undoRedo.Executor.Factory} */
    executorFactory,

    /** @type {function(new:module.undoRedo.Queue)} */
    Queue = __webpack_require__(919),

    /** @type {function(new:module.undoRedo.RemoteRequest)} */
    RemoteRequest = __webpack_require__(920),
    /** @type {module.undoRedo.RemoteRequest} */
    backend,

    /** @type {module.undoRedo.constants} */
    constants = __webpack_require__(889),


    /** @type {function(new:module.undoRedo.App)} */
    App = __webpack_require__(921),
    /** @type {module.undoRedo.App} */
    app,

    /** @type {function(new:module.undoRedo.Api)} */
    Api = __webpack_require__(922),
    /** @type {module.undoRedo.Api} */
    api,

    /** @type {function(new:module.undoRedo.plugins.Module)} */
    ModulePlugin = __webpack_require__(923),
    /** @type {module.undoRedo.plugins.Module} */
    modulePlugin,

    /** @type {function(new:module.undoRedo.plugins.Layout)} */
    LayoutPlugin = __webpack_require__(924),
    /** @type {module.undoRedo.plugins.Layout} */
    layoutPlugin,

    /** @type {function(new:module.undoRedo.plugins.Design)} */
    DesignPlugin = __webpack_require__(925),
    /** @type {module.undoRedo.plugins.Design} */
    designPlugin,

    /** @type {diy.util.l10n} */
    l10n = __webpack_require__(18).getString,

    /** @type {diy.util.globalEvents} */
    globalEvents = __webpack_require__(500),

    /**
     * Plugin management
     *
     * @param {module.undoRedo.Api} api
     */
    registerPlugins = function (api) {
        layoutPlugin = new LayoutPlugin(api);
        designPlugin = new DesignPlugin(api);
        modulePlugin = new ModulePlugin(api);

        api
            .registerPlugin(layoutPlugin)
            .registerPlugin(designPlugin)
            .registerPlugin(modulePlugin)
        ;
    },

    loadTranslations = function () {
        return {
            tooltipClickHereToUndo: l10n('undoRedo.tooltipClickHereToUndo'),
            tooltipClickHereToRedo: l10n('undoRedo.tooltipClickHereToRedo'),
            tooltipCanNotBeUndone: l10n('undoRedo.tooltipCanNotBeUndone'),
            loadingText: l10n('undoRedo.loadingText'),
            errors: {
                generic: {
                    title: l10n('undoRedo.errors.generic.title'),
                    description: l10n('undoRedo.errors.generic.description'),
                    button: l10n('undoRedo.errors.generic.button')
                },
                timeout: {
                    title: l10n('undoRedo.errors.generic.title'),
                    description: l10n('undoRedo.errors.generic.description'),
                    button: l10n('undoRedo.errors.generic.button')
                },
                privateMode: {
                    title: l10n('undoRedo.errors.privateMode.title'),
                    description: l10n('undoRedo.errors.privateMode.description')
                }
            }
        };
    },

    startApi = function () {

        featureSet = new FeatureSet();
        settings = new Settings(featureSet);
        pluginRegistry = new PluginRegistry();
        backend = new RemoteRequest();
        app = new App(settings, featureSet);
        api = new Api(app, settings, featureSet, pluginRegistry);

        sessionFactory = new SessionFactory();
        sessionManager = new SessionManager(app, sessionFactory);
        historyEntryFactory = new HistoryEntryFactory(api);
        app
            .setApi(api)
            .setSessionManager(sessionManager)
            .setHistoryEntryFactory(historyEntryFactory)
        ;

        registerPlugins(api);
        return api;
    },

    onReady = function (features, toolbar) {
        var ini, messages;
        messages = loadTranslations();
        featureSet.load(features, settings);

        ini = settings.getIni();

        ui = new Ui(api, ini.displayLimit, messages, featureSet, toolbar);
        uiManager = new UiManager(ui, api);
        entryFactory = new EntryFactory(api);

        history = new History(entryFactory, new Queue(), backend, sessionManager, ini.localEntriesLimit);
        database = new PouchAdapter(ini.localStorageName);
        storage = new AppStorage(backend);
        executor = new Executor(history, backend, api);
        executorFactory = new ExecutorFactory(history, backend, api);
        executor.setFactory(executorFactory);

        app.init(history, database, storage, entryFactory, ui, uiManager, executor, backend, messages)
            .catch(function (error) {
                if (!error.wasHandled) {
                    globalEvents.trigger('error.diy-editor', {
                        message: 'UndoRedo initialization error: message = ' + error.message + ', stack = ' + error.stack
                    });
                }
            })
            .done(function () {
                api.onAppReady();
            });
    };

module.exports = {
    startApi: startApi,
    onReady: onReady
};


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(889),
        __webpack_require__(717)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, constants, helper) {
        'use strict';

        var Settings;
        /**
         * @class module.undoRedo.Settings
         * @template module.undoRedo.Settings
         * @lends {module.undoRedo.Settings.prototype}
         * @constructor
         */
        Settings = Klazz.extend({

            /** @type {module.undoRedo.FeatureSet} */
            featureSet: null,

            features: [
                {
                    name: constants.features.PAGES,
                    key: '_removeme_undoRedoPages',
                    defaultEnabled: true,
                    defaultValue: 1
                },
                {
                    name: constants.features.LAYOUTS,
                    key: '_removeme_undoRedoLayouts',
                    defaultEnabled: true,
                    defaultValue: 1
                },
                {
                    name: constants.features.DESIGNS,
                    key: '_removeme_undoRedoDesigns',
                    defaultEnabled: true,
                    defaultValue: 1
                }
            ],

            ini: {
                websiteId: '',
                sessionId: '',
                localStorageName: 'undoredo',
                localStorageSize: 5,

                displayLimit: 25,

                localEntriesLimit: 500

            },
            /**
             * Called by plugins / models to get it's own settings from the corresponding section
             *      if the section name is not in the list will throw error
             *
             * @param section {String}
             * @returns {*}
             */
            get: function (section) {
                if (typeof this.ini[section] !== 'undefined') {
                    return this.ini[section];
                } else {
                    throw 'settings:ini: undefined section ' + section;
                }
            },
            getIni: function() {
                return this.ini;
            },

            /**
             *
             * @returns {Array.<Object>}
             */
            getFeatures: function getFeatures() {
                return this.features;
            },
            /**
             * @constructs
             */
            /**
             *
             * @param {module.undoRedo.FeatureSet} featureSet
             */
            initialize: function (featureSet) {
                this.featureSet = featureSet;
            },

            init: function () {
                this.ini.websiteId = helper.getWebsiteId();
                this.ini.sessionId = helper.getSessionName();
            }
        });
        return Settings;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

!([], module.exports = {
        /**
         * entry types 'undo' and 'redo'
         */
        types: {
            UNDO: 'undo',
            REDO: 'redo'
        },
        /**
         * entry execution types - if an entry is executed client side or server side
         */
        executionType: {
            CLIENT: 'client',
            SERVER: 'server'
        },
        /**
         * timeout for entry execution. if execution exceeds number of milliseconds,
         *      the corresponding promise will fail with timeout
         */
        executionTimeout: 60000,
        applyResultsTimeout: 10000,
        executionTimeoutMessage: 'TIMEOUT',

        /**
         * Features are written here for convenience
         * @see {module.undoRedo.Settings.features} for feature definition
         */
        features: {
            STYLE: 'style',
            PAGES: 'pages',
            LAYOUTS: 'layouts',
            DESIGNS: 'designs',
        },
        observerTopics: {
            ALL: '*',
            HISTORY_CHAIN_UPDATED: 'historyChainUpdated',
            HISTORY_CHAIN_READY: 'historyChainReady',
            EXECUTION_FINISHED: 'executionFinished'
        },

        historyEntry: {
            MODULE: 'module',
            MODULE_SECTION: 'module_Section',
            LAYOUT: 'layout',
            DESIGN: 'design',
            PAGES_STRUCTURE: 'pagesStructure',
            STYLE: 'style',
            THEMING: 'theming'
        },
        status: {
            SYNC: -3,
            LOCK: -2,
            INIT: -1,
            READY: 0,
            LOADING: 1,
            EXECUTING: 2,
            ERROR: 3,
            TIMEOUT: 4
        }

    });


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
        var FeatureSet;
        /**
         * @class module.undoRedo.FeatureSet
         * @template module.undoRedo.FeatureSet
         * @lends {module.undoRedo.FeatureSet.prototype}
         * @constructor
         */
        FeatureSet = Klazz.extend({
            /** @type {Object} */
            features: {},

            initialize: function(){
                this.features = {};
            },

            /**
             *
             * @param {jimdoData.features} features
             * @param {module.undoRedo.Settings} settings
             */
            load: function (features, settings) {

                settings.getFeatures().forEach(function (feature){
                    var featureEnabled, featureValue ;

                    if (typeof features[feature.key] !== 'undefined') {
                        featureEnabled = (features[feature.key].toString().length && parseInt(features[feature.key], 10) !== 0);
                        featureValue = features[feature.key];
                    } else {
                        featureEnabled = feature.defaultEnabled;
                        featureValue = feature.defaultValue;
                    }
                    this.features[feature.name] = {
                        enabled: featureEnabled,
                        value: featureValue
                    };
                }.bind(this));
            },

            /**
             *
             * @param {String} feature
             * @returns {Boolean}
             */
            isEnabled: function(feature) {
                return (typeof this.features[feature] !== 'undefined' && this.features[feature].enabled === true);
            },

            /**
             *
             * @param {String} feature
             * @returns {*}
             */
            getValue: function(feature) {
                if (typeof this.features[feature] !== 'undefined') {
                    return this.features[feature].value;
                }
                return undefined;
            }

        });
        return FeatureSet;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(892)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (PluginBase) {
        'use strict';
        var
            PluginRegistry;

        /**
         * @class module.undoRedo.PluginRegistry
         * @template module.undoRedo.PluginRegistry
         * @lends {module.undoRedo.PluginRegistry.prototype}
         * @constructor
         */
        PluginRegistry = Klazz.extend({
            /**
             * @type {?Array.<module.undoRedo.plugins.Base>}
             */
            plugins: null,

            initialize: function () {
                this.plugins = [];
            },
            /**
             *
             * @param {module.undoRedo.plugins.Base} plugin
             * @returns {module.undoRedo.PluginRegistry}
             */
            register: function (plugin) {
                if (!plugin instanceof PluginBase) {
                    throw new Error();
                }
                this.plugins.push(plugin);
                plugin.markAsRegistered();
                return this;
            },
            /**
             * enables registered plugins based on featureSet
             * @toDo implement featureSet :)
             *
             * @param {module.undoRedo.FeatureSet} featureSet
             */
            enable: function (featureSet) {
                this.plugins.forEach(
                    /** @param {module.undoRedo.plugins.Base} plugin */
                    function (plugin) {
                        plugin.markAsEnabled();
                    }
                );
            },
            /**
             * calls onInit method on each registered plugin
             */
            init: function () {
                this.plugins.forEach(
                    /** @param {module.undoRedo.plugins.Base} plugin */
                    function (plugin) {
                        if (plugin.isEnabled()) {
                            plugin.onInit();
                        }
                    }
                );
            },
            /**
             *
             * @param entryType
             * @returns {module.undoRedo.plugins.Base|null|*}
             */
            getPluginFor: function getPluginFor(entryType) {

                var available = this.plugins.filter(
                    /** @param {module.undoRedo.plugins.Base} plugin */
                    function (plugin) {
                        return plugin.getType().indexOf(entryType) >= 0;
                    });
                if (available.length) {
                    return available[0];
                } else {
                    return null;
                }
            }
        });

        return PluginRegistry;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
        var
            Plugin,
            readyState = {
                READY: 1,
                REGISTERED: 2,
                ENABLED: 3,
                OFFLINE: 4
            };
        /**
         * @class module.undoRedo.plugins.Base
         * @template module.undoRedo.plugins.Base
         * @lends {module.undoRedo.plugins.Base.prototype}
         * @constructor
         */
        Plugin = Klazz.extend({
            readyState: undefined,
            /**
             * @type {module.undoRedo.Api}
             */
            api: undefined,

            /**
             *
             * @param {module.undoRedo.Api} api
             */
            initialize: function (api) {
                this.readyState = readyState.OFFLINE;
                this.api = api;
            },

            /**
             *
             * @returns {boolean}
             */
            isRegistered: function () {
                return this.readyState === readyState.REGISTERED;
            },
            /**
             * sets registered state
             */
            markAsRegistered: function () {
                this.readyState = readyState.REGISTERED;
            },
            /**
             *
             * @returns {boolean}
             */
            isEnabled: function () {
                return this.readyState === readyState.ENABLED;
            },
            /**
             * sets registered state
             */
            markAsEnabled: function () {
                this.readyState = readyState.ENABLED;
            },

            /**
             *
             * @returns {boolean}
             */
            isReady: function () {
                return this.readyState === readyState.READY;
            },
            /**
             * sets ready state
             */
            markAsReady: function () {
                this.readyState = readyState.READY;
            },
            /**
             * will run when api is ready
             *
             */
            onInit: function () {
                this.markAsReady();
            },

            /**
             *
             * @returns {String}
             */
            getType: function getType() {
                return '';
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} entry
             */
            onSelect: function onSelect(entry) {

            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} entry
             */
            onDeselect: function onDeselect(entry) {

            },
            /**
             *
             * @param {module.undoRedo.App} app
             */
            onReady: function (app) {
                
            }
        });

        return Plugin;
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(718),
        __webpack_require__(894)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (UUID, Session) {
        'use strict';
        var SessionFactory;

        /**
         * @class module.undoRedo.SessionFactory
         * @template module.undoRedo.SessionFactory
         * @lends {module.undoRedo.SessionFactory.prototype}
         * @constructor
         */
        SessionFactory = Klazz.extend({
            initialize: function () {

            },
            /**
             *
             * @param {module.undoRedo.SessionManager} sessionManager
             * @returns {module.undoRedo.Session}
             */
            build: function build(sessionManager) {
                var session = new Session(sessionManager);
                session.setKey(UUID.generate());

                return session;
            },
            /**
             * @param {module.undoRedo.SessionManager} sessionManager
             * @param {{key: String, sessionId: String, volatile: Boolean, undo: String[], redo: String[]}} data
             * @returns {module.undoRedo.Session}
             */
            load: function load(sessionManager, data) {
                var session = this.build(sessionManager);
                session
                    .setKey(data.key)
                    .setSessionId(data.sessionId)
                    .setTemporary(data.temporary)
                    .setUndo(data.undo)
                    .setRedo(data.redo)
                ;

                return session;
            }
        });
        return SessionFactory;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
        var Session;

        /**
         * @class module.undoRedo.Session
         * @template module.undoRedo.Session
         * @lends {module.undoRedo.Session.prototype}
         * @constructor
         */
        Session = Klazz.extend({
            /** @type {String} */
            key: '',

            /** @type {module.undoRedo.SessionManager} */
            sessionManager: null,

            /** @type {String} */
            sessionId: null,

            /** @type {Boolean} volatile session - entries deleted on close */
            temporary: false,
            /** @type {Array.<String>} */
            undo: [],
            /** @type {Array.<String>} */
            redo: [],
            /**
             *
             * @param {module.undoRedo.SessionManager} sessionManager
             */
            initialize: function (sessionManager) {
                this.undo = [];
                this.redo = [];
                this.sessionManager = sessionManager;
            },
            /**
             *
             * @returns {*|UndoSession.sessionId|sessionId|String}
             */
            getId: function getId() {
                var sessionId;
                try {
                    sessionId = this.sessionManager.getSessionIdForKey(this.key);
                } catch (err) {
                    //ups ... session does not officially exists anymore so ...
                    this.regenerate();
                    return this.sessionManager.getSessionIdForKey(this.key);
                }
                return sessionId;
            },
            /**
             *
             * @returns {module.undoRedo.Session}
             */
            regenerate: function regenerate() {
                this.initialize(this.sessionManager);
                var me = this.sessionManager.openSession();
                this.sessionId = me.getSessionId();
                this.key = me.getKey();
                me.setTemporary(this.temporary);
                return this;
            },
            /**
             *
             * @param {!String} key
             * @returns {module.undoRedo.Session}
             */
            setKey: function setKey(key) {
                this.key = key;
                return this;
            },
            /**
             *
             * @returns {String}
             */
            getKey: function getKey() {
                return this.key;
            },
            /**
             *
             * @param {!String} sessionId
             * @returns {module.undoRedo.Session}
             */
            setSessionId: function setSessionId(sessionId) {
                this.sessionId = sessionId;
                return this;
            },
            /**
             *
             * @returns {?String}
             */
            getSessionId: function getSessionId() {
                return this.sessionId;
            },
            /**
             *
             * @param {Boolean=} temporary
             * @returns {module.undoRedo.Session}
             */
            setTemporary: function setTemporary(temporary) {
                this.temporary = (temporary === true || temporary === false) ? temporary : true;

                return this;
            },
            /**
             *
             * @returns {Boolean}
             */
            getTemporary: function getTemporary() {
                return this.temporary;
            },
            /**
             * @returns {Boolean}
             */
            isVolatile: function isVolatile() {
                return this.temporary;
            },
            /**
             *
             * @param {Array.<String>} undo
             * @returns {module.undoRedo.Session}
             */
            setUndo: function setUndo(undo) {
                this.undo = undo;
                return this;
            },
            /**
             *
             * @param {String} entryKey
             * @returns {Number}
             */
            undoAdd: function undoAdd(entryKey) {
                this.undo.push(entryKey);
                return this.undo.length;
            },
            /**
             *
             * @returns {Array.<String>}
             */
            getUndo: function getUndo() {
                return this.undo;
            },
            /**
             *
             * @param {Array.<String>} redo
             * @returns {module.undoRedo.Session}
             */
            setRedo: function setRedo(redo) {
                this.redo = redo;
                return this;
            },
            /**
             *
             * @param {String} entryKey
             * @returns {Number}
             */
            redoAdd: function redoAdd(entryKey) {
                this.redo.unshift(entryKey);
                return this.redo.length;
            },
            /**
             *
             * @returns {Array.<String>}
             */
            getRedo: function getRedo() {
                return this.redo;
            },
            close: function close() {
                return this.sessionManager.closeSession(this);
            },
            getNextIndex: function getNextIndex() {
                return this.undo.length + 1;
            },
            /**
             *
             * @returns {{key: String, sessionId: String, volatile: Boolean, undo: String[], redo: String[]}}
             */
            sleep: function sleep() {
                return {
                    key: this.key,
                    sessionId: this.sessionId,
                    temporary: this.temporary,
                    undo: this.undo,
                    redo: this.redo
                };
            }

        });


        return Session;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(889),
        __webpack_require__(718)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, constants, UUID) {
        'use strict';
        var SessionManager;

        /**
         * @class module.undoRedo.SessionManager
         * @template module.undoRedo.SessionManager
         * @lends {module.undoRedo.SessionManager.prototype}
         * @constructor
         */
        SessionManager = Klazz.extend({

            /**
             * @type {module.undoRedo.App}
             */
            app: null,

            /**
             * @type {module.undoRedo.SessionFactory}
             */
            factory: null,
            /**
             * @type {module.undoRedo.Storage}
             */
            storage: null,
            /**
             * @type {*<module.undoRedo.Session>}
             */
            sessions: {},
            /**
             * @type {module.undoRedo.Session}
             */
            activeSession: null,
            /**
             *
             * @param {module.undoRedo.App} app
             * @param {module.undoRedo.SessionFactory} sessionFactory
             */
            initialize: function (app, sessionFactory) {
                this.app = app;
                this.factory = sessionFactory;
                this.sessions = {};
            },
            /**
             *
             * @param {module.undoRedo.Storage} storage
             * @returns {module.undoRedo.SessionManager}
             */
            setStorage: function setStorage(storage) {
                this.storage = storage;
                return this;
            },
            /**
             *
             * @returns {module.undoRedo.Session}
             */
            openSession: function openSession() {
                var session = this.factory.build(this);
                this.sessions[session.getKey()] = session;
                return session;
            },
            /**
             *
             * @param {String} sessionKey
             */
            getSessionIdForKey: function getSessionIdForKey(sessionKey) {
                if (typeof this.sessions[sessionKey] === 'undefined') {
                    throw new Error('Session ' + sessionKey + ' does not exist');
                }

                if (this.activeSession !== null && this.activeSession.getKey() !== sessionKey) {
                    var oldSession = $.extend(true, {}, this.activeSession);
                    this.sessions[sessionKey].setSessionId(UUID.generate());
                    this.activeSession = this.sessions[sessionKey];

                    this.sessionClose(oldSession)
                        .then(this.setActiveSession.bind(this, this.activeSession));
                }
                if (this.activeSession === null) {
                    this.sessions[sessionKey].setSessionId(UUID.generate());
                    this.activeSession = this.sessions[sessionKey];
                    this.setActiveSession(this.activeSession);
                }


                return this.activeSession.getSessionId();
            },

            getSessionForSessionId: function getSessionForSessionId (sessionId) {
                var session = null, sessionKey;

                for (sessionKey in this.sessions) {
                    if (this.sessions.hasOwnProperty(sessionKey)) {
                        if (this.sessions[sessionKey].getSessionId() === sessionId) {
                            session = this.sessions[sessionKey];
                        }
                    }
                }
                return session;
            },
            /**
             *
             * @param sessionId
             * @returns {module.undoRedo.Session}
             */
            getOrCreateSession: function getSession(sessionId) {
                var session = this.getSessionForSessionId(sessionId);

                if(session === null) {
                    session = this.factory.build(this);
                    session.setSessionId(sessionId);
                    this.sessions[sessionId] = session;
                }

                return session;
            },

            /**
             *
             * @param {module.undoRedo.Session} session
             * @returns {Q.Promise<T>}
             */
            setActiveSession: function setActiveSession(session) {
                var deferred = Q.defer();
                this.storage.setActiveUndoSession(session.sleep())
                    .then(function () {
                        this.activeSession = session;
                        deferred.resolve(session);
                    }.bind(this))
                    .catch(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },
            /**
             *
             * @returns {Q.Promise<T>}
             */
            recoverActiveSession: function recoverActiveSession() {
                var deferred = Q.defer();

                this.getLastActiveSession()
                    .then(function (sessionData) {
                        var session;
                        if (sessionData !== null) {
                            session = this.factory.load(this, sessionData);
                            if (session.isVolatile()) {
                                session.close()
                                    .then(function () {
                                        deferred.resolve(true);
                                    })
                                    .catch(function (error) {
                                        deferred.reject(error);
                                    });
                            } else {
                                deferred.resolve(true);
                            }
                        } else {
                            deferred.resolve(true);
                        }
                    }.bind(this))
                    .catch(function (error) {
                        deferred.reject(error);
                    });
                return deferred.promise;
            },
            /**
             *
             * @param {module.undoRedo.Session} session
             * @param {boolean} noWait
             */
            closeSession: function closeSession(session, noWait) {
                var deferred = Q.defer();

                if (session === null) {
                    deferred.resolve(true);
                    return deferred.promise;
                }

                if (session.isVolatile()) {
                    this.app.deleteEntriesWithUndoSession(session.getSessionId(), noWait)
                        .then(function(){
                            this.sessionClose(session)
                                .then(function (res){
                                    deferred.resolve(res);
                                })
                                .catch(function(err){
                                    deferred.reject(err);
                                });
                        }.bind(this))
                        .catch(function(err){
                            deferred.reject(err);
                        });
                } else {
                    this.sessionClose(session)
                        .then(function(res){
                            deferred.resolve(res);
                        })
                        .catch(function(err){
                            deferred.reject(err);
                        });
                }
                return deferred.promise;
            },
            /**
             *
             * @param {module.undoRedo.Session} session
             * @private
             * @returns {Q.Promise<T>}
             */
            sessionClose: function sessionClose(session) {
                var deferred = Q.defer(),
                    doCleanup = function cleanup() {
                        delete this.sessions[session.getKey()];
                        deferred.resolve(true);
                    }.bind(this);

                if (this.activeSession === session) {
                    this.storage.setActiveUndoSession(null)
                        .then(function () {
                            this.activeSession = null;
                            doCleanup();
                        }.bind(this));
                } else {
                    doCleanup();
                }

                return deferred.promise;
            },

            /**
             *
             * @private
             * @returns {Q.Promise<T>}
             */
            getLastActiveSession: function getLastActiveSession() {
                var deferred = Q.defer();

                this.storage.getActiveUndoSession()
                    .then(function (sessionData) {
                        deferred.resolve(sessionData);
                    })
                    .catch(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },
            /**
             *
             * @returns {module.undoRedo.Session}
             */
            getActiveSession: function getActiveSession(){
                return this.activeSession;
            },

            /**
             *
             * @returns {String|null}
             */
            getActiveSessionId: function getActiveSessionId() {
                if (this.activeSession !== null) {
                    return this.getActiveSession().getSessionId();
                } else {
                    return null;
                }
            },
            /**
             *
             * @param {{undo:[], redo:[], last:{}}} incoming
             * @deprecated
             */
            syncCurrentSession: function syncCurrentSession(incoming) {
                var activeSession = this.getActiveSession(), undo = [], redo = [];

                if (activeSession){
                    this.filterActiveSession(incoming.undo, activeSession.getSessionId()).forEach(
                        function (entry) {
                            if (entry.getExecutionType() === constants.executionType.CLIENT) {
                                undo.push(entry.getKey());
                            }
                        }
                    );
                    this.filterActiveSession(incoming.redo, activeSession.getSessionId()).forEach(
                        function (entry) {
                            if (entry.getExecutionType() === constants.executionType.CLIENT) {
                                redo.push(entry.getKey());
                            }
                        }
                    );
                    activeSession
                        .setUndo(undo)
                        .setRedo(redo)
                    ;
                }
            },
            /**
             *
             * @param {module.undoRedo.Entry[]} chain
             * @param {String} activeSessionId
             * @returns {module.undoRedo.Entry[]}
             */
            filterActiveSession: function filter(chain, activeSessionId) {
                return chain.filter(function (entry /*, index, array */) {
                    return (entry.getUndoSessionId() === activeSessionId);
                });
            },

            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @param {module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO=} type
             */
            markInSession: function markInSession (entry, type) {
                var session, entryKey;

                if (entry.getExecutionType() === constants.executionType.CLIENT) {
                    session = this.getOrCreateSession(entry.getUndoSessionId());
                    entryKey = entry.getKey();

                    session.undo = session.undo.filter(function(key) { return (key !== entryKey); });
                    session.redo = session.redo.filter(function(key) { return (key !== entryKey); });

                    type = (typeof type !== 'undefined')? type : entry.getType();

                    switch (type) {
                        case constants.types.UNDO:
                            session.undoAdd(entryKey);
                        break;
                        case constants.types.REDO:
                            session.redoAdd(entryKey);
                        break;
                        case null:
                            // nothing will happen, reference will be deleted
                        break;
                    }
                }
            }

        });

        return SessionManager;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(897),
        __webpack_require__(898)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (Entry, HistoryEntryFactory) {
        'use strict';

        var EntryFactory;
        /**
         * @class module.undoRedo.EntryFactory
         * @template module.undoRedo.EntryFactory
         * @lends {module.undoRedo.EntryFactory.prototype}
         * @constructor
         */
        EntryFactory = Klazz.extend({

            /** @type {module.undoRedo.HistoryEntry.Factory} */
            historyEntryFactory: null,

            /**
             *
             * @param {module.undoRedo.Api} api
             */
            initialize: function (api) {
                this.historyEntryFactory = new HistoryEntryFactory(api);
            },

            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} historyEntry
             * @returns {module.undoRedo.Entry}
             */
            create: function create(historyEntry) {
                return new Entry(historyEntry);
            },
            /**
             *
             * @param {String} type
             * @param {Object} payload
             * @param {String} payload.executionType
             * @param {String} payload.entryType
             * @param {Boolean} payload.isSessionHead
             * @returns {module.undoRedo.Entry}
             */
            load: function load(type, payload) {
                var
                    /** @type {module.undoRedo.HistoryEntry.Base} */
                    historyEntry = this.historyEntryFactory.load(type, payload),
                    /** @type {module.undoRedo.Entry} */
                    entry = this.create(historyEntry)
                    ;

                entry
                    .setIsSessionHead(payload.isSessionHead)
                    .setType(historyEntry.getEntryType())
                ;

                return entry;
            },

            /**
             *
             * @param {String} type
             * @param {Object} payload
             * @param {String=} message
             * @param {String=} undoSessionId
             * @param {Number=} undoSessionIndex
             * @param {Boolean=} isExecutable
             * @returns {module.undoRedo.Entry}
             */
            build: function build(type, payload, message, undoSessionId, undoSessionIndex, isExecutable) {
                var
                    /** @type {module.undoRedo.HistoryEntry.Base} */
                    historyEntry = this.historyEntryFactory.build(type, payload, message, undoSessionId, undoSessionIndex, isExecutable);

                return this.create(historyEntry);
            },

            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} historyEntry
             * @returns {module.undoRedo.Entry}
             */
            wrap: function wrap(historyEntry) {
                return new Entry(historyEntry);
            }
        });

        return EntryFactory;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (constants) {
        'use strict';
        var Entry;

        /**
         * @class module.undoRedo.Entry
         * @template module.undoRedo.Entry
         * @lends {module.undoRedo.Entry.prototype}
         * @constructor
         */
        Entry = Klazz.extend({
            type: constants.types.UNDO,

            isSessionHead: false,
            linkedEntryId: 0,

            /** @type {module.undoRedo.HistoryEntry.Base} */
            historyEntry: null,

            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} historyEntry
             */
            initialize: function (historyEntry) {
                this.historyEntry = historyEntry;
            },
            /**
             *
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            getHistoryEntry: function getHistoryEntry() {
                return this.historyEntry;
            },
            /**
             *
             * @param {String} session
             * @returns {module.undoRedo.Entry}
             */
            setUndoSessionId: function (session) {
                this.historyEntry.setUndoSessionId(session);
                return this;
            },
            /**
             *
             * @returns {String}
             */
            getUndoSessionId: function () {
                return this.historyEntry.getUndoSessionId();
            },

            /**
             *
             * @param {Number} sessionIndex
             * @returns {module.undoRedo.Entry}
             */
            setSessionIndex: function (sessionIndex) {
                this.historyEntry.setSessionIndex(sessionIndex);
                return this;
            },
            /**
             *
             * @returns {number}
             */
            getSessionIndex: function () {
                return this.historyEntry.getSessionIndex();
            },
            /**
             *
             * @returns {module.undoRedo.constants.executionType.SERVER|module.undoRedo.constants.executionType.CLIENT}
             */
            getExecutionType: function () {
                return this.historyEntry.getExecutionType();
            },
            /**
             *
             * @param {module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO} type
             * @returns {module.undoRedo.Entry}
             */
            setType: function (type) {
                this.type = type;
                return this;
            },

            /**
             *
             * @returns {module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO}
             */
            getType: function () {
                return this.type;
            },

            /**
             *
             * @param {Boolean} visible
             * @returns {module.undoRedo.Entry}
             * @deprecated not used
             */
            setVisible: function (visible) {
                this.visible = visible;
                return this;
            },

            /**
             *
             * @returns {Boolean}
             * @deprecated not used
             */
            getVisible: function () {
                return this.visible;
            },

            /**
             *
             * @returns {Boolean}
             */
            isExecutable: function () {
                return !!this.historyEntry.getExecutable();
            },

            /**
             *
             * @param {String} message
             * @returns {module.undoRedo.Entry}
             */
            setMessage: function (message) {
                this.historyEntry.setMessage(message);
                return this;
            },
            /**
             *
             * @returns {String}
             */
            getMessage: function () {
                return this.historyEntry.getMessage();
            },

            /**
             *
             * @returns {*}
             */
            getPayload: function getPayload() {
                return this.historyEntry.getPayload();
            },
            /**
             *
             * @param payload
             * @returns {module.undoRedo.Entry}
             */
            setPayload: function setPayload(payload) {
                this.historyEntry.setPayload(payload);
                return this;
            },

            /**
             *
             * @returns {String}
             */
            getLabel: function () {
                return this.historyEntry.getLabel();
            },

            /**
             *
             * @param {Number} entryId
             * @returns {module.undoRedo.Entry}
             */
            setEntryId: function (entryId) {
                this.historyEntry.setId(entryId);
                return this;
            },
            /**
             *
             * @returns {Number}
             */
            getEntryId: function () {
                return this.historyEntry.getId();
            },
            /**
             *
             * @param {String} key
             * @returns {module.undoRedo.Entry}
             */
            setKey: function (key) {
                this.historyEntry.setKey(key);
                return this;
            },

            /**
             *
             * @returns {String}
             */
            getKey: function () {
                return this.historyEntry.getKey();
            },
            /**
             *
             * @returns {String}
             */
            getManager: function () {
                return this.historyEntry.manager;
            },

            /**
             *
             * @param {Boolean} isSessionHead
             * @returns {module.undoRedo.Entry}
             */
            setIsSessionHead: function (isSessionHead) {
                if (isSessionHead === true || isSessionHead === false) {
                    this.isSessionHead = isSessionHead;
                }
                return this;
            },
            /**
             *
             * @returns {Boolean}
             */
            getIsSessionHead: function () {
                return this.isSessionHead;
            },

            setLinkedEntryId: function (linkedEntryId) {
                if (isNaN(linkedEntryId) === false) {
                    this.linkedEntryId = linkedEntryId;
                }
                return this;
            },
            /**
             *
             * @returns {Number}
             */
            getLinkedEntryId: function () {
                return this.linkedEntryId;
            },
            /**
             *
             * @param {{undo: module.undoRedo.Entry[], redo: module.undoRedo.Entry[]}} chains
             * @returns {module.undoRedo.Entry[]}
             */
            getChain: function getChain(chains) {
                var chain = [];
                switch (this.type) {
                    case constants.types.UNDO:
                        chain = chains.undo;
                        break;
                    case constants.types.REDO:
                        chain = chains.redo;
                        break;
                }
                return chain;
            },
            /**
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {Number}
             */
            getPositionInChain: function getPositionInChain(chain) {
                return chain.indexOf(this);
            },
            /**
             * @param lastInBlock {Boolean}
             * @returns {Promise|Q.promise}
             */
            execute: function (lastInBlock) {
                var deferred = Q.defer();

                this.historyEntry
                    .execute(lastInBlock)
                    .timeout(constants.executionTimeout, constants.executionTimeoutMessage)
                    .then(
                    function (result) {
                        deferred.resolve(result);
                    },
                    function (err) {
                        // when the execute will fail or timeout ends
                        deferred.reject(err);
                    }
                );

                return deferred.promise;
            },

            /**
             * called when a server side entry was executed
             * scope: visually reflect the stated of what changed in browser
             *
             * @param {*} executionDetails
             * @returns {*}
             */
            onExecuted: function (executionDetails) {
                var deferred = Q.defer();

                if (this.isSessionHead === true) {
                    deferred.resolve(true);
                    return deferred.promise;
                }

                this.historyEntry
                    .onExecuted(executionDetails)
                    .timeout(constants.applyResultsTimeout, constants.executionTimeoutMessage)
                    .then(function (result) {
                        // when the execute will finish
                        deferred.resolve(result);
                    })
                    .catch(function (err) {
                        // when the execute will fail or timeout ends
                        deferred.reject(err);
                    });
                return deferred.promise;
            },

            /**
             * called when a server side entry was executed and is the entry required to be executed (lastEntry)
             * scope: visually reflect the stated of what changed in browser
             */
             onExecutedLast: function (executionDetails) {
                if (!this.isSessionHead) {
                    this.historyEntry.onExecutedLast(executionDetails);
                }
            },

            /**
             * called for client side entries to create snapshot
             *
             * @param {Object=} data
             * @returns {Promise|Q.promise}
             */
            createSnapshot: function (data) {
                return this.historyEntry.createSnapshot(data);
            },
            /**
             *
             * @returns {{manager: String, message: String, isExecutable: Boolean, payload: Object, type: (module.undoRedo.constants.types.UNDO|module.undoRedo.constants.types.REDO), undoSessionId: String, undoSessionIndex: number, entryId: Number}}
             */
            toDatabase: function () {
                return {
                    manager: this.getManager(),
                    message: this.getMessage(),
                    isExecutable: this.isExecutable(),
                    payload: this.historyEntry.serialize(),
                    type: this.getType(),
                    undoSessionId: this.getUndoSessionId(),
                    undoSessionIndex: this.getSessionIndex(),
                    entryId: this.getEntryId()
                };
            },

            /**
             * called when user selects an entry in interface
             */
            onSelect: function () {
                this.historyEntry.onSelect();
            },

            /**
             * called when user deselects an entry in interface
             */
            onDeselect: function () {
                this.historyEntry.onDeselect();
            },

            /**
             * called when entry is deleted
             * @deprecated not implemented; not required yet
             */
            onDelete: function () {
                this.historyEntry.onDelete();
            },

            /**
             * called when entry is deleted
             * @deprecated not implemented; not required yet
             */

            onInsert: function () {
                this.historyEntry.onInsert();
            },
            /**
             * Used to get the unique identity for client entries (same object, same action, etc.. )
             *
             * if result is not null, should return entity-based identifier that will be
             *  used for grouping full snapshots entries
             *
             * @returns {*}
             */
            getIdentity: function () {
                if (typeof this.historyEntry.getIdentity === 'function') {
                    return this.historyEntry.getIdentity();
                }
                return null;
            },

            /**
             * scope: visually apply data on client; !! no save
             *
             * @param {Object=} snapshot
             * @returns {Promise|Q.promise}
             */
            applySnapshot: function applySnapshot(snapshot) {
                return this.historyEntry.applySnapshot(snapshot);
            },
            /**
             * scope: apply data from payload to the server
             *
             * @returns {Promise|Q.promise}
             */
            submit: function submit() {
                return this.historyEntry.submit();
            }
        });

        return Entry;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(889),
        __webpack_require__(899),
        __webpack_require__(901),
        __webpack_require__(902),
        __webpack_require__(903),
        __webpack_require__(904),
        __webpack_require__(905)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (constants,
              HistoryEntryModule,
              HistoryEntryLayout,
              HistoryEntryDesign,
              HistoryEntryPages,
              HistoryEntryStyle,
              HistoryEntryTheming) {
        'use strict';
        var Factory;

        /**
         * @class module.undoRedo.HistoryEntry.Factory
         * @template module.undoRedo.HistoryEntry.Factory
         * @lends {module.undoRedo.HistoryEntry.Factory.prototype}
         * @constructor
         */
        Factory = Klazz.extend({
            /** @type {module.undoRedo.Api} */
            api: null,

            /**
             *
             * @param {module.undoRedo.Api} api
             */
            initialize: function (api) {
                this.api = api;
            },


            /**
             *
             * @param {String} type
             * @param {Object} payload
             * @return {module.undoRedo.HistoryEntry.Base}
             */
            create: function create(type, payload) {
                /** @type {module.undoRedo.HistoryEntry.Base} */
                var instance = null;
                switch (type) {
                    case constants.historyEntry.MODULE:
                    case constants.historyEntry.MODULE_SECTION:
                        instance = new HistoryEntryModule(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.LAYOUT:
                        instance = new HistoryEntryLayout(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.DESIGN:
                        instance = new HistoryEntryDesign(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.PAGES_STRUCTURE:
                        instance = new HistoryEntryPages(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.STYLE:
                        instance = new HistoryEntryStyle(payload, this.api);
                        instance.setExecutionType(constants.executionType.CLIENT);
                        break;
                    case constants.historyEntry.THEMING:
                        instance = new HistoryEntryTheming(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    default:
                        throw new Error('Undefined type ' + type);
                }

                instance.setManager(type);
                return instance;

            },
            /**
             *
             * @param {String} type
             *
             * @param {Object} rawData
             * @param {String} rawData.message
             * @param {Boolean} rawData.isExecutable
             * @param {String} rawData.entryKey
             * @param {String} rawData.entryType
             * @param {String} rawData.entryId
             * @param {String} rawData.undoSessionId
             * @param {Number} rawData.undoSessionIndex
             * @param {Object} rawData.payload
             *
             * @return {module.undoRedo.HistoryEntry.Base}
             */
            load: function load(type, rawData) {
                var instance = this.create(type, rawData);

                instance
                    .setMessage(rawData.message)
                    .setExecutable(rawData.isExecutable)
                    .setKey(rawData.entryKey)
                    .setId(rawData.entryId)
                    .setUndoSessionId(rawData.undoSessionId)
                    .setSessionIndex(rawData.undoSessionIndex)
                    .setEntryType(rawData.entryType)
                    .unserialize(rawData.payload)
                ;
                return instance;
            },
            /**
             *
             * @param {String} type
             * @param {Object} rawData
             * @param {String} message
             * @param {String} undoSessionId
             * @param {Number} undoSessionIndex
             * @param {Boolean=} isExecutable
             */
            build: function build(type, rawData, message, undoSessionId, undoSessionIndex, isExecutable) {
                /** @type {module.undoRedo.HistoryEntry.Base} */
                var instance = this.create(type, rawData);

                instance
                    .setMessage(message)
                    .setUndoSessionId(undoSessionId)
                    .setSessionIndex(undoSessionIndex)
                    .setExecutable(typeof isExecutable !== 'undefined' ? isExecutable : true);
                return instance;
            }
        });

        return Factory;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global mm, matrix, cc_ */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(900),
        __webpack_require__(717),
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (HistoryEntry, helper, $) {
        'use strict';
        var Module;
        /**
         * @class module.undoRedo.HistoryEntry.Module
         * @template module.undoRedo.HistoryEntry.Module
         * @lends {module.undoRedo.HistoryEntry.Module.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Module = HistoryEntry.extend({

            moduleId: null,
            messageAction: '',
            messageDetails: '',

            unserialize: function (serializedObject) {
                this.moduleId = serializedObject.moduleId;
                this.messageAction = serializedObject.messageAction || '';
                this.messageDetails = serializedObject.messageDetails || '';

                return this._super(serializedObject);
            },

            onSelect: function () {
                if (mm[this.moduleId] && mm[this.moduleId].modul) {
                    mm[this.moduleId].modul.toggleClass('undoRedo-highlight', true);
                }
            },

            onDeselect: function () {
                if (mm[this.moduleId] && mm[this.moduleId].modul) {
                    mm[this.moduleId].modul.toggleClass('undoRedo-highlight', false);
                }
            },

            onExecuted: function (executionData) {
                var
                    deferred = Q.defer(),
                    skipped = 'skipped',
                    addModule = function (entryData, scrollToIt) {
                        if (!matrix[entryData.payload.matrixId]) {
                            deferred.resolve(skipped);
                        } else {
                            matrix[entryData.payload.matrixId].addModule(
                                entryData.payload.moduleId,
                                entryData.payload.content.cms,
                                entryData.payload.content.edit,
                                entryData.payload.afterChildId,
                                scrollToIt
                            );
                        }
                    },
                    delModule = function (entryData, scrollToIt, triggerEvent) {
                        var myMatrix, matrixContainer;
                        if (typeof mm[entryData.payload.moduleId] !== 'undefined') {
                            myMatrix = matrix[mm[entryData.payload.moduleId].matrixId];

                            if (!myMatrix) {
                                // check for module in current page
                                matrixContainer = mm[entryData.payload.moduleId].modul.parent('.sortable-matrix');
                                if (matrixContainer.length) {
                                    myMatrix = matrix[matrixContainer.attr('data-matrixid')];
                                }
                            }
                        }

                        if (typeof myMatrix !== 'undefined') {
                            scrollToIt = (typeof scrollToIt === 'undefined') ? true : scrollToIt;
                            triggerEvent = (typeof triggerEvent === 'undefined') ? true : triggerEvent;

                            myMatrix.deleteModule(entryData.payload.moduleId, scrollToIt, triggerEvent);
                        } else {
                            deferred.resolve(skipped);
                        }

                    },
                    refreshModule = function (entryData, scrollToIt) {
                        if (typeof mm[entryData.payload.moduleId] !== 'undefined' && mm[entryData.payload.moduleId].inPage()) {
                            mm[entryData.payload.moduleId].refresh(scrollToIt);
                        } else {
                            deferred.resolve(skipped);
                        }
                    },

                    applyChanges = function (entryData, scrollToIt) {
                        switch (entryData.payload.actionType) {
                            case 'move':
                                if (mm[entryData.payload.moduleId]) {
                                    delModule(entryData, false, false);
                                }
                                addModule(entryData, scrollToIt);
                                break;
                            case 'change':
                                if (!mm[entryData.payload.moduleId]) {
                                    addModule(entryData, scrollToIt);
                                } else {
                                    refreshModule(entryData, scrollToIt);
                                }
                                break;
                            case 'add':
                                if (entryData.entryType === 'undo') {
                                    delModule(entryData, scrollToIt);
                                } else {
                                    if (mm[entryData.payload.moduleId]) {
                                        delModule(entryData, false, false);
                                    }
                                    addModule(entryData, scrollToIt);
                                }
                                break;
                            case 'delete':
                                if (entryData.entryType === 'undo') {
                                    if (mm[entryData.payload.moduleId]) {
                                        delModule(entryData, false, false);
                                    }
                                    addModule(entryData, scrollToIt);
                                } else {
                                    delModule(entryData, scrollToIt);
                                }
                                break;
                            default:
                                break;
                        }

                        return deferred.promise;
                    },
                    boundEvents = [
                        'diy-editor-undo-redo-no-action',
                        'diy-editor-module-refreshFinished',
                        'diy-editor-module-addFinished',
                        'diy-editor-module-deleteFinished',
                        'diy-editor-undo-redo-action-executed'
                    ].join(' ')
                    ;

                $(document).bind(boundEvents, function () {
                        deferred.resolve(true);
                    }
                );

                applyChanges(executionData, false).then(function () {
                    $(document).unbind(boundEvents);
                });

                return deferred.promise;
            },

            onExecutedLast: function (executionData) {
                try {
                    mm[this.moduleId].getContentContainer().scrollIntoView();
                } catch (e) {

                }

                // if this entry has execution results on another page and is the entry that user requested to be executed
                //      redirect the user to that page
                if (executionData.payload &&
                    executionData.payload.pageId > 0 &&
                    executionData.payload.pageId !== helper.getCurrentPageId()
                ) {
                    this.api.requestBrowserReload((cc_.properties.cmsUrl.slice(0, -1) + executionData.payload.pageUrl));
                }
            },

            serialize: function () {
                return {
                    moduleId: this.moduleId
                };
            },

            getLabel: function () {
                var label;
                if (this.messageAction.toString().length && this.messageDetails.toString().length) {
                    label = this.messageAction.toString()
                        .replace('%details%', '<span class="messageDetails">' + this.messageDetails.toString() + '</span>');
                } else {
                    label = this.getMessage();
                }
                return label;
            }
        });
        return Module;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UndoRedo History Entry base class
 *
 * This class will be extended by each HistoryEntry types
 *
 *      when you overwrite the methods, pay attention to the return of the functions
 *      to match the same type described here
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(889),
        __webpack_require__(718)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (constants, UUID) {
        'use strict';

        var
            manager = 'entries',

            /**
             * this method is dummy; it should be extended by each HistoryEntry type class to return the same value types
             */
            defaultMethod = function (result) {
            },
            /**
             * this method is dummy; it should be extended by each HistoryEntry type class to return the same value types
             *
             * @returns {promise|*|Q.promise}
             */
            defaultPromiseMethod = function (resultData) {
                var deferred = Q.defer();
                deferred.resolve(resultData);
                return deferred.promise;
            },

            HistoryEntry;

        /**
         * @class module.undoRedo.HistoryEntry.Base
         * @template module.undoRedo.HistoryEntry.Base
         * @lends {module.undoRedo.HistoryEntry.Base.prototype}
         * @constructor
         */
        HistoryEntry = Klazz.extend({
            /** @type {module.undoRedo.Api} */
            api: null,

            /**
             * @var {String} - can be 'client' or 'server' depending where is this entry executed
             */
            executionType: constants.executionType.CLIENT,

            /**
             * @var {String} - can be 'undo' or 'redo' depending of the chain
             */
            entryType: constants.types.UNDO,
            /**
             * @var {String} - uuid generated for client entries | id for server side entries
             */
            key: null,

            /**
             * @var {String} - undo session in witch it was created
             */
            undoSessionId: null,

            /**
             * @var {String} entry position in session (informational, not used by engine)
             */
            undoSessionIndex: 0,

            /**
             * @var {Number} - server side id used in server executed entries
             */
            entryId: 0,

            /**
             * represents the class name / instance type; will be for serialization
             */
            /** @type {?String} */
            manager: '',

            /**
             * @var (boolean) - defines if entry is executable or not
             */
            executable: true,

            /**
             * @var {Object} - payload for current entry
             */
            payload: undefined,

            /**
             * @var {String} - message for current entry
             */
            message: '',

            /**
             * Called to identify entry type
             *
             * @returns {String}
             */
            getManager: function () {
                return manager;
            },

            /**
             *
             * @param {String} string
             */
            setManager: function (string) {
                this.manager = string;
                return this;
            },

            /**
             * @param {?Object=} payload - class can be constructed with an empty payload
             * @param {module.undoRedo.Api} api
             */
            initialize: function (payload, api) {
                this.key = UUID.generate();
                if (payload && Object.keys(payload).length !== 0) {
                    this.payload = payload;
                } else {
                    this.payload = {};
                }
                this.api = api;
            },

            /**
             * Called to serialize current entry into an object from witch it can self restore using this.unserialize
             *      - do not include message in returned object
             *
             * @returns Object
             */
            serialize: function () {
                return {};
            },

            /**
             * Called to re-state the class to the state from before this.serialize
             *
             * @param {Object} serializedObject
             */
            unserialize: function (serializedObject) {
                return this;
            },

            /**
             * Called when user select this entry to be executed (ui related)
             */
            onSelect: defaultMethod,

            /**
             * Called en user deselect this entry (ui related)
             */
            onDeselect: defaultMethod,

//        /* can be implemented if required */
//        onInsert: defaultMethod,
//        onDelete: defaultMethod,

            /**
             * Called to create a snapshot for the current state
             * returns promise.resolve({snapshot: {Object}, message: string})
             *
             *
             * @returns {Promise|Q.promise}
             */
            createSnapshot: function () {
                throw "createSnapshot is called but not implemented";
            },

            /**
             * Called when a client side entry is executed
             *  - methods MUST not break the execution chain (can not do context change / page refresh)
             *
             * @returns {Promise|Q.promise}
             */
            execute: function () {
                throw "execute is called but not implemented";
            },

            /**
             * Applies on client side BUT does not perform save on server (on client side entries)
             *
             * @returns {Promise|Q.promise}
             */
            applySnapshot: defaultPromiseMethod,
            /**
             * Saves data from client on server  (on client side entries)
             *
             * @returns {Promise|Q.promise}
             */
            submit: defaultPromiseMethod,
            /**
             * Called (for server side entries only) after the entry was executed
             *  - method MUST not break the execution chain (can not do context change / page refresh)
             *
             * @param executionDetails Object
             * @returns {Promise|Q.promise}
             */
            onExecuted: defaultPromiseMethod,

            /**
             * Called when a client | server side entry is executed by user request
             *      (when is the entry that user clicked on / last entry in the execution chain)
             *      - onExecuted | execute was called before this one gets called
             *      - if you need to break the chain / refresh the page, this is the method you need
             */
            onExecutedLast: defaultMethod,


            /* Setters & Getters Below */

            /**
             * Setter function
             *
             *
             * @param isExecutable
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setExecutable: function (isExecutable) {
                if (isExecutable === true || isExecutable === 1) {
                    this.executable = true;
                } else {
                    this.executable = false;
                }
                return this;
            },

            /**
             * Getter function
             *
             * @returns {boolean}
             */
            getExecutable: function () {
                return this.executable;
            },

            /**
             * Setter function
             *
             * @param {String} key
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setKey: function (key) {
                this.key = key;
                return this;
            },

            /**
             * Getter function
             *
             * @returns {String}
             */
            getKey: function () {
                return this.key;
            },

            /**
             * Setter function
             *
             * @param id
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setId: function (id) {
                this.entryId = id;
                return this;
            },

            /**
             * Getter function
             *
             * @returns {Number|null}
             */
            getId: function () {
                return this.entryId;
            },

            /**
             * Setter function
             *
             * @param undoSessionId
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setUndoSessionId: function (undoSessionId) {
                this.undoSessionId = undoSessionId;
                return this;
            },

            /**
             * Getter function
             *
             * @returns {String}
             */
            getUndoSessionId: function () {
                return this.undoSessionId;
            },

            /**
             * Setter function
             *
             * @param undoSessionIndex
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setSessionIndex: function (undoSessionIndex) {
                this.undoSessionIndex = undoSessionIndex;
                return this;
            },

            /**
             * Getter function
             *
             * @returns {number}
             */
            getSessionIndex: function () {
                return this.undoSessionIndex;
            },


            /**
             * Setter function
             *
             * @param message
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setMessage: function (message) {
                this.message = message;
                return this;
            },

            /**
             * Getter function
             * returns text; no HTML!!
             *
             * @returns {string}
             */
            getMessage: function () {
                return this.message;
            },

            /**
             * Getter function for entry label;
             * can be implemented by each history entry to return html formatted message
             * @returns {string}
             */
            getLabel: function () {
                return this.message;
            },

            /**
             *
             * @param executionType
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setExecutionType: function setExecutionType(executionType) {
                this.executionType = executionType;
                return this;
            },

            getExecutionType: function getExecutionType() {
                return this.executionType;
            },

            /**
             *
             * @param entryType
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setEntryType: function setEntryType(entryType) {
                this.entryType = entryType;
                return this;
            },

            getEntryType: function getEntryType() {
                return this.entryType;
            },

            getPayload: function getPayload() {
                return this.payload;
            },
            /**
             *
             * @param payload
             * @returns {module.undoRedo.HistoryEntry.Base}
             */
            setPayload: function setPayload(payload) {
                this.payload = payload;
                return this;
            }


        });

        return HistoryEntry;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global angular */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(900),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (HistoryEntry) {
        'use strict';
        var Layout;
        /**
         * @class module.undoRedo.HistoryEntry.Layout
         * @template module.undoRedo.HistoryEntry.Layout
         * @lends {module.undoRedo.HistoryEntry.Layout.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Layout = HistoryEntry.extend({
            onExecutedLast: function (executionData) {
                // does nothing, it has no output in client side
            },

            onExecuted: function (executionData) {

                this.api.requestBrowserReload();

                return this._super(executionData);
            },

            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            }
        });
        return Layout;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global angular */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(900),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (HistoryEntry) {
        'use strict';
        var Design;
        /**
         * @class module.undoRedo.HistoryEntry.Design
         * @template module.undoRedo.HistoryEntry.Design
         * @lends {module.undoRedo.HistoryEntry.Design.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Design = HistoryEntry.extend({
            onExecutedLast: function (executionData) {
                // does nothing, it has no output in client side
            },

            onExecuted: function (executionData) {

                this.api.requestBrowserReload();

                return this._super(executionData);
            },

            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            }
        });
        return Design;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(900),
        __webpack_require__(20)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (HistoryEntry, siteadmin) {
        'use strict';
        var Pages;
        /**
         * @class module.undoRedo.HistoryEntry.Pages
         * @template module.undoRedo.HistoryEntry.Pages
         * @lends {module.undoRedo.HistoryEntry.Pages.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Pages = HistoryEntry.extend({

            payload: {},

            message: '',
            onExecutedLast: function (executionData) {
                // no interface changes on this action
            },

            onExecuted: function (executionData) {
                //close the site-admin window
                var controller = siteadmin.getController();

                if (controller !== null && controller.isOpened()) {
                    controller.close();
                    diy.editor.navigation.api.notify('force_update');
                } else {
                    diy.editor.navigation.api.updateJimdoData(
                        function (data) {
                            diy.editor.navigation.api.verifyCurrentPage(
                                data,
                                function () {
                                    diy.editor.navigation.api.notify('force_update');
                                },
                                function (redirectUrl) {
                                    this.api.requestBrowserReload(redirectUrl);
                                }.bind(this)
                            );
                        }.bind(this)
                    );
                }

                if (executionData.payload.shouldReloadPage === true) {
                    this.api.requestBrowserReload();
                }

                return this._super(executionData);
            },

            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            }
        });
        return Pages;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global angular */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(900),
        __webpack_require__(717),
        __webpack_require__(25),
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (HistoryEntry, helper, features, $) {
        'use strict';
        var Style;
        /**
         * @class module.undoRedo.HistoryEntry.Style
         * @template module.undoRedo.HistoryEntry.Style
         * @lends {module.undoRedo.HistoryEntry.Style.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Style = HistoryEntry.extend({

            payload: {},

            message: '',
            onExecutedLast: function (executionData) {
                // no interface changes on this action
            },

            /**
             *
             * @returns {Promise|Q.promise}
             */
            openStyleTab: function () {
                var deferred = Q.defer();

                try {
                    if (diy.editor.theming && diy.editor.theming.isStyleWindowLoaded()) {
                        deferred.resolve(true);
                        return deferred.promise;
                    }
                } catch (e) {
                    //
                }
                diy.editor.siteadmin.api.triggerMenuItem('cc-sa-item-style');

                $(document).bind('diy-editor-theming-styleWindowLoaded', function () {
                    deferred.resolve(true);
                });

                return deferred.promise;
            },
            /**
             *
             * @param {Object=} snapshot
             * @returns {Promise|Q.promise}
             */
            createSnapshot: function (snapshot) {
                var
                    deferred = Q.defer();
                if (typeof snapshot === 'undefined') {
                    this.openStyleTab().then(
                        function () {
                            snapshot = diy.editor.theming.getHistorySnapshot();
                            deferred.resolve(snapshot);
                        }
                    );
                } else {
                    this.payload = snapshot;
                    deferred.resolve(snapshot);
                }

                return deferred.promise;
            },
            /**
             *
             * @param {Object=} snapshot
             * @returns {Promise|Q.promise}
             */
            applySnapshot: function applySnapshot(snapshot) {
                var deferred = Q.defer(), toApply;

                if (typeof snapshot === 'undefined') {
                    snapshot = this.payload;
                } else {
                    this.payload = snapshot;
                }

                toApply = angular.copy(snapshot);

                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(toApply, deferred, false);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            submit: function submit() {
                var deferred = Q.defer(), toApply;

                toApply = angular.copy(this.payload);
                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(toApply, deferred, true);
                    }.bind(this))
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            /**
             *
             * @param {Boolean} lastInBlock
             * @returns {Promise|Q.promise}
             * @deprecated
             */
            execute: function (lastInBlock) {
                var deferred = Q.defer();

                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(this.payload, deferred, lastInBlock);
                    }.bind(this));
                return deferred.promise;
            },

            /**
             *
             * @param {Object} serializedObject
             * @returns {*}
             */
            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            },

            getIdentity: function getIdentity() {
                return 'style';
            }
        });
        return Style;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global angular */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(900),
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (HistoryEntry, $) {
        'use strict';
        var Theming;
        /**
         * @class module.undoRedo.HistoryEntry.Theming
         * @template module.undoRedo.HistoryEntry.Theming
         * @lends {module.undoRedo.HistoryEntry.Theming.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Theming = HistoryEntry.extend({
            onExecutedLast: function (executionData) {
                // does nothing, it has no output in client side
            },

            openStyleTab: function () {
                var deferred = Q.defer();

                try {
                    if (diy.editor.theming && diy.editor.theming.isStyleWindowLoaded()) {
                        deferred.resolve(true);
                        return deferred.promise;
                    }
                } catch (e) {
                    //
                }
                diy.editor.siteadmin.api.triggerMenuItem('cc-sa-item-style');

                $(document).bind('diy-editor-theming-styleWindowLoaded', function () {
                    deferred.resolve(true);
                });

                return deferred.promise;
            },

            onExecuted: function (executionData) {
                this.api.requestBrowserReload();
                return Q(true);
            },
/**
            onExecutedWhenSupported: function (executionData) {
                var deferred = Q.defer(), toApply;
                toApply = angular.copy(executionData.payload);
                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(toApply, deferred, false);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
*/
            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            }
        });
        return Theming;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(907),
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($,
              Observable,
              constants) {
        'use strict';
        var History;

        /**
         * @class module.undoRedo.History
         * @template module.undoRedo.History
         * @lends {module.undoRedo.History.prototype}
         * @extends {module.undoRedo.Observable}
         * @constructor
         */
        History = Observable.extend({

            status: constants.status.INIT,

            /** @type {module.undoRedo.Api} */
            api: null,

            /** @type {module.undoRedo.SessionManager} */
            sessionManager: null,

            /** @type {Array.<{topic: String, callback: Function}>} */
            observers: [],

            /** @type {module.undoRedo.Storage} */
            storage: null,

            /** @type {Number} */
            localEntriesLimit: 0,

            /** @type {module.undoRedo.EntryFactory} */
            entryFactory: null,

            /** @type {Boolean} */
            chainsLocked: false,

            /** @type {module.undoRedo.Queue} */
            whenReady: null,

            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,

            /** @type {{undo:[], redo:[], last:{}}} */
            chains: undefined,

            /**
             *
             * @param {module.undoRedo.EntryFactory} entryFactory
             * @param {module.undoRedo.Queue} readyQueue
             * @param {module.undoRedo.RemoteRequest} backend
             * @param {module.undoRedo.SessionManager} sessionManager
             * @param {Number=} localEntriesLimit
             */
            initialize: function initialize(entryFactory, readyQueue, backend, sessionManager, localEntriesLimit) {
                this.entryFactory = entryFactory;
                this.whenReady = readyQueue;
                this.localEntriesLimit = localEntriesLimit;
                this.backend = backend;
                this.sessionManager = sessionManager;
                this.observers = [];

                this.resetChains();
                this.markStatus(constants.status.INIT);
            },

            /**
             *
             * @returns {Promise|Q.promise}
             */
            init: function init() {

                // init readyQueue settings
                this.whenReady
                    .setAutoStart(true)
                    .init(
                        function /** callWhenLocked */ () {
                            this.markStatus(constants.status.LOCK);
                        }.bind(this),
                        function /** callWhenUnLocked */ () {

                        }.bind(this),
                        function /** callWhenNothingToRun */ () {
                            this.markStatus(constants.status.READY);
                        }.bind(this)
                    );

                return this.refresh();
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            refresh: function refresh() {
                return this.populateChains()
                    .then(function () {
                        this.markStatus(constants.status.READY);
                    }.bind(this));
            },
            /**
             *
             * @param {Object=} injectedServerHistory
             */
            populateChains: function populateChains(injectedServerHistory) {
                var sequence = [];

                sequence.push(function () {
                    this.resetChains();
                    return this.storage.loadDatabase(injectedServerHistory);
                }.bind(this));

                /**
                 * loads raw data into chains entries
                 * @see {module.undoRedo.Entry}
                 */
                sequence.push(
                    /**
                     * @param {Object} loadedData
                     * @param {Array.<Object>} loadedData.undoList
                     * @param {Array.<Object>} loadedData.redoList
                     * @param {Object} loadedData.lastEntry
                     * @this {module.undoRedo.History}
                     */
                    function (loadedData) {
                        this.addEntriesToChain(loadedData.undoList, this.chains.undo);
                        this.addEntriesToChain(loadedData.redoList, this.chains.redo);
                        this.addLastEntry(loadedData.lastEntry);
                    }.bind(this)
                );

                /**
                 * marks corresponding entries to session heads
                 */
                sequence.push(
                    this.markSessionHeads.bind(this)
                );

                /**
                 * loads data and runs the populate chain sequence
                 */
                return sequence.reduce(Q.when, this.markStatus(constants.status.LOADING));
            },

            markSessionHeads: function markSessionHeads() {
                this.setSessionHeads(this.chains.undo);
                this.setSessionHeads(this.chains.redo);
            },
            /**
             *
             * @param {Array.<module.undoRedo.Entry>} onChain
             * @private
             */
            setSessionHeads: function setSessionHeads(onChain) {
                onChain.forEach(function (currentEntry, sourceIndex, sourceChain) {
                    if (currentEntry.getExecutionType() === constants.executionType.SERVER) {
                        sourceChain[sourceIndex].setIsSessionHead(false);

                        this.setLinkedEntries(currentEntry, sourceIndex, sourceChain, this.chains.undo);
                        this.setLinkedEntries(currentEntry, sourceIndex, sourceChain, this.chains.redo);
                    }
                }.bind(this));
            },
            /**
             *
             * @param {module.undoRedo.Entry} currentEntry
             * @param {Number} sourceIndex
             * @param {Array.<module.undoRedo.Entry>} sourceChain
             * @param {Array.<module.undoRedo.Entry>} targetChain
             * @private
             */
            setLinkedEntries: function setLinkedEntries(currentEntry, sourceIndex, sourceChain, targetChain) {
                targetChain.forEach(function (loopEntry, loopIndex, loop) {
                    if (loopEntry.getExecutionType() === constants.executionType.CLIENT &&
                        loopEntry.getUndoSessionId() === currentEntry.getUndoSessionId() &&
                        loopEntry.getSessionIndex() === 1
                    ) {
                        sourceChain[sourceIndex].setIsSessionHead(true);
                        loop[loopIndex].setLinkedEntryId(currentEntry.getEntryId());
                    }
                });
            },

            addEntriesToChain: function addEntriesToChain(list, chain) {
                list.forEach(function (payload) {
                    chain.push(this.entryFactory.load(payload.manager, payload));
                }.bind(this));
            },

            addLastEntry: function addLastEntry(payload) {
                if (typeof payload !== 'undefined' && payload !== null) {
                    this.chains.last = this.entryFactory.build(payload.manager, payload);
                }
            },
            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @returns {Promise|Q.promise}
             */
            addEntry: function addEntry(entry) {

                this.chains.undo.unshift(entry);

                return this.storage.addUndoEntry(entry.toDatabase(), entry.getKey())
                    .then(this.deleteRedoChain.bind(this, false))
                    .then(this.markSessionHeads.bind(this))
                    .then(function(){
                        return Q(entry.getKey());
                    });
            },
            /**
             * Clones an entry to the opposite chain
             *  - original entry is unlinked from it's chain
             *
             * @param {module.undoRedo.Entry} entryToBeSwitched
             * @param {Object} payload
             * @param {Number=} newIndex
             * @param {String=} newIndex
             * @param {String=} newMessage
             */
            switchChains: function(entryToBeSwitched, payload, newIndex, newMessage) {
                var updatedEntry;

                if (payload === null) {
                    updatedEntry = $.extend(true, {}, entryToBeSwitched);
                    if (typeof newIndex !== 'undefined') {
                        updatedEntry.setSessionIndex(newIndex);
                    }
                    if (typeof newMessage !== 'undefined') {
                        updatedEntry.setMessage(newMessage);
                    }
                } else {
                    updatedEntry = this.entryFactory.build(
                        entryToBeSwitched.getManager(),
                        payload,
                        entryToBeSwitched.getMessage(),
                        entryToBeSwitched.getUndoSessionId(),
                        (typeof newIndex !== 'undefined') ? newIndex : entryToBeSwitched.getSessionIndex(),
                        entryToBeSwitched.isExecutable()
                    );

                    if (typeof newMessage !== 'undefined') {
                        updatedEntry.setMessage(newMessage);
                    }

                    updatedEntry
                        .setKey(entryToBeSwitched.getKey())
                        .setLinkedEntryId(entryToBeSwitched.getLinkedEntryId())
                        ;
                }

                switch (entryToBeSwitched.getType()) {
                    case constants.types.UNDO:
                        updatedEntry.setType(constants.types.REDO);
                        this.chains.undo = this.chains.undo.filter(function(item){
                            return item.getKey() !== updatedEntry.getKey();
                        });

                        this.chains.redo.unshift(updatedEntry);
                    break;

                    case constants.types.REDO:
                        updatedEntry.setType(constants.types.UNDO);
                        this.chains.redo = this.chains.redo.filter(function(item){
                            return item.getKey() !== updatedEntry.getKey();
                        });

                        this.chains.undo.unshift(updatedEntry);
                    break;
                }
                this.sessionManager.markInSession(updatedEntry);

                return this.storage.updateEntry(updatedEntry.getKey(), updatedEntry.toDatabase());
            },
            /**
             *
             * @returns {module.undoRedo.History}
             */
            resetChains: function resetChains() {
                this.chains = {undo: [], redo: [], last: null};
                return this;
            },

            /**
             *
             * @param {module.undoRedo.Storage} storage
             */
            setStorage: function setStorage(storage) {
                this.storage = storage;
            },
            /**
             *
             * @param {Number} status
             * @returns {module.undoRedo.History}
             */
            markStatus: function markStatus(status) {
                switch (status) {
                    case constants.status.READY:
                        if(this.status !== status) {
                            this.status = status;
                            this.notifyObservers(constants.observerTopics.HISTORY_CHAIN_READY, this.chains);
                        } else {
                            this.status = status;
                        }
                        break;
                    case constants.status.SYNC:
                        this.status = constants.status.READY;
                        break;
                    default:
                        this.status = status;
                        break;
                }
                this.notifyObservers(constants.observerTopics.HISTORY_CHAIN_UPDATED, this.chains);
                return this;
            },

            /**
             *
             * @param {Function} callback
             * @param {Boolean=} autoLock [default=true]
             */
            executeWhenReady: function executeWhenReady(callback, autoLock) {
                autoLock = (typeof autoLock === 'undefined') ? true : autoLock;
                this.whenReady.add(callback, autoLock);
            },
            /**
             *
             * @param {Boolean=} ignoreServer
             * @returns {Promise|Q.promise}
             */
            deleteRedoChain: function deleteRedoChain(ignoreServer) {

                return this.storage.deleteRedoEntries()
                    .then(function() {
                        if (ignoreServer === true){
                            return Q(false);
                        } else {
                            return this.deleteServerRedoChain();
                        }
                    }.bind(this))
                    .then(function(wasDeletionOnServerSide){
                        this.chains.redo = [];
                        return Q(wasDeletionOnServerSide);
                    }.bind(this));
            },

            deleteServerRedoChain: function deleteServerRedoChain() {
                var serverEntriesInChain;

                serverEntriesInChain = this.chains.redo.some(function(element) {//, index, array) {
                    return (element.getExecutionType() === constants.executionType.SERVER);
                });

                if (serverEntriesInChain) {
                    return this.backend.deleteRedoChain();
                } else {
                    return Q(false);
                }
            },
            /**
             *
             * @param {String} undoSessionId
             * @returns {Promise|Q.Promise}
             */
            deleteUndoSession: function deleteUndoSession(undoSessionId) {
                var deferred = Q.defer();

                if (this.status === constants.status.INIT) {
                    return this.executeDeleteUndoSession(undoSessionId);
                } else {
                    this.executeWhenReady(function () {
                        this.executeDeleteUndoSession(undoSessionId)
                            .then(function () {
                                deferred.resolve(true);
                            })
                            .catch(function (error) {
                                deferred.reject(error);
                            });
                        return deferred.promise;
                    }.bind(this));
                }
                return deferred.promise;
            },
            /**
             *
             * @param undoSessionId
             * @returns {Promise|Q.Promise}
             */
            executeDeleteUndoSession: function executeDeleteUndoSession (undoSessionId) {
                var deletedKeys = [];
                this.deleteUndoSessionFromChain(constants.types.UNDO, undoSessionId, deletedKeys);
                this.deleteUndoSessionFromChain(constants.types.REDO, undoSessionId, deletedKeys);

                return this.storage.deleteEntriesFromSession(undoSessionId)
                    .then(this.markSessionHeads.bind(this));
            },
            /**
             *
             * @param {Number} chainType
             * @param {String} undoSessionId
             * @param {Array.<String>} deletedEntryKeys
             */
            deleteUndoSessionFromChain: function deleteUndoSessionFromChain(chainType, undoSessionId, deletedEntryKeys) {
                var index = 0, chain, listEntry;

                chain = ((chainType === constants.types.UNDO)? this.chains.undo : this.chains.redo);

                while (index < chain.length) {
                    listEntry = chain[index];
                    if (listEntry.getUndoSessionId() === undoSessionId &&
                        listEntry.getExecutionType() === constants.executionType.CLIENT
                    ) {
                        // add entry key to be deleted later
                        deletedEntryKeys.push(listEntry.getKey());
                        // synchronously remove entry from chain, will avoid refresh
                        chain.splice(index, 1);
                    } else {
                        index++;
                    }
                }
            },

            /**
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {module.undoRedo.Entry[]}
             */
            filterChainForUi: function filterChainForUi(chain) {
                return chain.filter(function (element /*, index, array */) {
                    return !(
                    element.getExecutionType() === constants.executionType.SERVER &&
                    element.getIsSessionHead() === true
                    );
                });
            },

            /**
             *
             * @param {String} key
             * @returns {module.undoRedo.Entry|null}
             */
            getEntryByKey: function getEntryByKey(key) {
                var entry;
                entry = this.getEntryByKeyInChain(key, this.chains.undo);
                if (entry === null){
                    entry = this.getEntryByKeyInChain(key, this.chains.redo);
                }
                return entry;
            },
            /**
             *
             * @param {String} key
             * @param {module.undoRedo.Entry[]} chain
             * @returns {module.undoRedo.Entry|null}
             */
            getEntryByKeyInChain: function(key, chain){
                var index;
                for (index = 0; index < chain.length; index++){
                    if (chain[index].getKey().toString() === key.toString()) {
                        return chain[index];
                    }
                }
                return null;
            }
        });

        return History;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
         var ALL_TOPICS = '*';
        /**
         * @class module.undoRedo.Api
         * @template module.undoRedo.Api
         * @lends {module.undoRedo.Api.prototype}
         * @constructor
         */
        var Observable = Klazz.extend({
            observers: undefined,

            /**
             *
             * @param {Function} callback
             * @param {String=} topic
             */
            attachObserver: function attachObserver(callback, topic) {
                if (typeof this.observers === "undefined") {
                    this.observers = [];
                }

                this.observers.push(
                    {
                        callback: callback,
                        topic: (typeof topic !== 'undefined') ? topic : null
                    }
                );
            },
            /**
             *
             * @param {Function} observer
             */
            detachObserver: function detachObserver(observer) {
                this.observers.forEach(function (value, index, array) {
                    if (value === observer) {
                        array.splice(index, 1);
                    }
                });
            },

            /**
             * notify registered observers [only on triggered topic]
             *
             * @param {String=} topic
             * @param {*=} data
             * @param {*=} subject

             */
            notifyObservers: function notifyObservers(topic, data, subject) {

                if (typeof subject === 'undefined') {
                    subject = this;
                }

                this.observers.forEach(
                    /**
                     * @param {{topic: String, callback: Function}} observer
                     */
                    function (observer) {
                        if (observer.topic === ALL_TOPICS) {
                            observer.callback.call(this, subject, data, topic);
                        } else if (typeof topic !== 'undefined') {
                            if (observer.topic !== null &&
                                observer.topic.toString() === topic.toString()
                            ) {
                                observer.callback.call(this, subject, data);
                            }
                        } else {
                            if (observer.topic === null) {
                                observer.callback.call(this, subject, data);
                            }
                        }
                    }.bind(this)
                );
            }

        });

        return Observable;
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/** @class module.undoRedo.PouchAdapter */
/*global PouchDB, emit */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
        'use strict';
        var PouchAdapter,
            DOC_TYPE_ENTRY = 'entry',
            POUCHDB_OPTIONS = {size: 5},
            designDocs;


        designDocs = {
            'byEntryType': {
                version: 1,
                mapFunction: function (doc) {
                    if (doc.docType === 'entry') {
                        emit(doc.type + '/' + doc._id, {rev: doc._rev});
                    }
                }
            },
            'byUndoSession': {
                version: 1,
                mapFunction: function (doc) {
                    var formatIndex = function (n, width, z) {
                        z = z || '0';
                        width = width || 5;
                        n = n.toString() + '';
                        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
                    };

                    if (doc.docType === 'entry') {
                        emit(
                            doc.undoSessionId + '_' + formatIndex(doc.undoSessionIndex) + '/' + doc.type + '/' + doc._id,
                            {rev: doc._rev}
                        );
                    }
                }
            },
            'bySessionSorted': {
                version: 2,
                mapFunction: function (doc) {
                    var formatIndex = function (n, width, z) {
                        z = z || '0';
                        width = width || 5;
                        n = n.toString() + '';
                        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
                    };

                    if (doc.docType === 'entry') {
                        emit(
                            [
                                doc.type,
                                doc.websiteId,
                                doc.sessionId,
                                doc.undoSessionId,
                                formatIndex(doc.undoSessionIndex)
                            ],
                            {rev: doc._rev}
                        );
                    }
                }
            }

        };

        PouchAdapter = Klazz.extend(/** @lends module.undoRedo.PouchAdapter.prototype */{

            database: {},
            databaseName: null,
            databasePromise: null,
            autoIncrementKey: null,
            websiteId: null,
            sessionId: null,

            keyIndex: {},

            enabledIndexes: {},

            staticPrefix: '-static-',

            /**
             * @constructs
             * @param databaseName
             */
            initialize: function (databaseName) {
                this.databaseName = databaseName;
            },
            init: function (websiteId, sessionId) {
                this.websiteId = websiteId;
                this.sessionId = sessionId;
            },
            createPersistentDatabase: function () {
                var database, deferred;
                deferred = Q.defer();
                database = new PouchDB(this.databaseName, POUCHDB_OPTIONS);
                if (database.adapter) {
                    return database
                        .then(function () {
                            return this.enableIndexes(['byEntryType', 'byUndoSession', 'bySessionSorted'], database)
                                .then(function () {
                                   return database;
                                });
                        }.bind(this));
                } else {
                    deferred.reject({status: 500, 'message': 'Undefined PouchDB adapter'});
                }

                return deferred.promise;
            },
            cleanup: function cleanup() {
                var database, deferred;
                deferred = Q.defer();
                try {
                    database = new PouchDB(this.databaseName, POUCHDB_OPTIONS);
                    database.allDocs({}, function (err, res) {
                        var toDelete = [];
                        if (err) {
                            deferred.reject(err);
                        } else {
                            res.rows.forEach(function (row) {
                                toDelete.push({_id: row.id, _rev: row.value.rev, _deleted: true});
                            });
                            if (toDelete.length) {
                                database.bulkDocs(toDelete, function (deleteErr, deleteRes) {
                                    if (err) {
                                        deferred.reject(deleteErr);
                                    } else {
                                        deferred.resolve(deleteRes);
                                    }
                                });
                            } else {
                                deferred.resolve(true);
                            }
                        }
                    });
                } catch (error) {
                    deferred.reject(error);
                }
                return deferred.promise;
            },
            open: function () {
                var deferred;
                deferred = Q.defer();
                this.openDatabase()
                    .then(function () {
                        deferred.resolve(this);
                    }.bind(this))
                    .catch(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },
            openDatabase: function () {
                var deferred;
                deferred = Q.defer();
                this.createPersistentDatabase()
                    .then(function (database) {
                        this.database = database;
                        deferred.resolve(database);
                    }.bind(this))
                    .catch(function (error) {
                        this.database = null;
                        deferred.reject(error);
                    }.bind(this));

                return deferred.promise;
            },
            getDatabase: function () {
                return this.database;
            },

            createEntryKey: function (createdTime) {
                // key format entry_[websiteId]_[sessionId]_[createdTime]_uniqueIndex
                if (createdTime === undefined) {
                    createdTime = (new Date()).getTime();
                }
                if (this.keyIndex[createdTime] === undefined) {
                    this.keyIndex[createdTime] = 1;
                } else {
                    this.keyIndex[createdTime]++;
                }

                return ['entry', this.websiteId, this.sessionId, createdTime, this.keyIndex[createdTime]].join('_');
            },

            createDesignDoc: function (name, mapFunction, version) {
                var ddoc = {
                    _id: '_design/' + name,
                    ver: version,
                    views: {}
                };
                ddoc.views[name] = {
                    map: mapFunction.toString()
                };
                return ddoc;
            },

            /**
             *
             * @param {Array.<String>} indexNames
             * @param {*} database
             * @returns {*}
             */
            enableIndexes: function enableIndexes(indexNames, database) {
                var deferred = Q.defer(), toEnable = [];
                indexNames.forEach(function (name) {
                    toEnable.push(function () {
                        return this.enableIndex(name, database);
                    }.bind(this));
                }.bind(this));

                toEnable.reduce(Q.when, Q(true))
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            enableIndex: function (indexName, database) {
                var designDoc, deferred = Q.defer();

                designDoc = this.createDesignDoc(
                    indexName, designDocs[indexName].mapFunction, designDocs[indexName].version
                );

                database.get(designDoc._id, function (err, res) {
                    if (res) {
                        // index already in db, checking version
                        if (res.ver === designDoc.ver) {
                            deferred.resolve(true);
                            return;
                        } else {
                            designDoc._rev = res._rev;
                        }
                    }
                    database.put(designDoc, function (err, res) {
                        if (err) {
                            deferred.reject(err);
                        } else {
                            deferred.resolve(res);
                        }
                    });
                });

                return deferred.promise;
            },

            // add entry to database
            add: function (data, id) {
                var
                    deferred = Q.defer(),
                    doc = data,
                    createdTime = (new Date()).getTime();

                if (typeof id === 'undefined') {
                    id = this.createEntryKey(createdTime);
                }

                doc.docType = DOC_TYPE_ENTRY;
                doc.createdAt = createdTime;
                doc.websiteId = this.websiteId;
                doc.sessionId = this.sessionId;

                this.getDatabase().put(doc, id, function (err, res) {
                    if (err) {
                        deferred.reject(err);
                    } else {
                        deferred.resolve(res.id);
                    }
                });

                return deferred.promise;
            },

            // loads document from database
            load: function (docId) {
                var deferred = Q.defer();
                this.getDatabase().get(docId, function (err, doc) {
                    if (err) {
                        deferred.reject(err);
                    } else {
                        deferred.resolve(doc);
                    }
                });
                return deferred.promise;
            },

            update: function (docId, data) {
                var deferred = Q.defer();

                this.load(docId)
                    .then(function (previousDocument) {
                        data = $.extend({}, previousDocument, data);

                        this.getDatabase().put(data, previousDocument._id, previousDocument._rev, function (err, res) {
                            if (err) {
                                deferred.reject(err);
                            } else {
                                deferred.resolve(res);
                            }
                        });
                    }.bind(this))
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },

            loadHistory: function () {
                var
                    deferred = Q.defer(),
                    history = {
                        undoList: [],
                        redoList: []
                    };
                this.openDatabase()
                    .then(function (database) {
                        this.loadUndoList(database)
                            .then(function (rows) {
                                history.undoList = rows;
                                return this.loadRedoList(database);
                            }.bind(this))
                            .then(function (rows) {
                                history.redoList = rows;
                                deferred.resolve(history);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }.bind(this))
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;
            },
            loadUndoList: function (database) {
                var
                    deferred = Q.defer(),
                    options = {
                        'startkey': ['undo', this.websiteId, this.sessionId],
                        'endkey': ['undo', this.websiteId, this.sessionId, {}],
                        'include_docs': true
                    };
                database.query('bySessionSorted', options)
                    .then(function (res) {
                        var index, response = [];
                        for (index = res.rows.length - 1; index >= 0; index--) {
                            response[index] = res.rows[index].doc;
                        }
                        deferred.resolve(response);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;

            },
            loadRedoList: function (database) {
                var
                    deferred = Q.defer(),
                    options = {
                        'startkey': ['redo', this.websiteId, this.sessionId],
                        'endkey': ['redo', this.websiteId, this.sessionId, {}],
                        'include_docs': true
                    };

                database.query('bySessionSorted', options)
                    .then(function (res) {
                        var index, response = [];

                        for (index = 0; index < res.rows.length; index++) {
                            response[index] = res.rows[index].doc;
                        }
                        deferred.resolve(response);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;
            },

            deleteRedoEntries: function () {
                var
                    deferred = Q.defer(),
                    options = {
                        'startkey': ['redo'],
                        'endkey': ['redo', {}],
                        'include_docs': true
                    };

                this.getDatabase().query('bySessionSorted', options)
                    .then(function (res) {
                        return this._delete(res);
                    }.bind(this))
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            deleteEntriesFromSession: function deleteEntriesFromSession(sessionId) {
                var
                    deferred = Q.defer(),
                    filter = sessionId,
                    options = {
                        'startKey': filter,
                        'endKey': filter + '_'
                    };
                this.getDatabase().query('byUndoSession', options)
                    .then(this._delete.bind(this))
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            deleteEntryIds: function (entryIds) {
                var deferred = Q.defer();

                this.getDatabase().allDocs({keys: entryIds}, function (err, res) {
                    if (err) {
                        deferred.reject(res);
                    } else {
                        this._delete(res)
                            .then(function (res) {
                                deferred.resolve(res);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }
                }.bind(this));

                return deferred.promise;
            },

            _delete: function (res) {
                var
                    deferred = Q.defer(),
                    index,
                    rows = res.rows,
                    totalRows,
                    removeItems = [];

                if (rows) {
                    totalRows = rows.length;

                    if (totalRows > 0) {
                        for (index = 0; index < totalRows; index++) {
                            removeItems[index] = {
                                _id: rows[index].id,
                                _rev: rows[index].value.rev,
                                _deleted: true
                            };
                        }
                        this.getDatabase().bulkDocs(removeItems, function (err, doc) {
                            if (err) {
                                deferred.reject(err);
                            } else {
                                deferred.resolve(doc);
                            }
                        });
                    } else {
                        deferred.resolve(true);
                    }
                } else {
                    deferred.reject('rows undefined');
                }
                return deferred.promise;
            },

            clearAllEntries: function () {
                var
                    deferred = Q.defer(),
                    self = this;

                this.getDatabase().allDocs({'startkey': 'entry'})
                    .then(function (res) {
                        return self._delete(res);
                    })
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            },

            getStatic: function (docId) {
                var deferred = Q.defer();

                this.getDatabase().get(docId, function (err, res) {
                    if (res) {
                        deferred.resolve(res.data);
                    } else {
                        deferred.resolve(null);
                    }
                }.bind(this));

                return deferred.promise;
            },

            setStatic: function (docId, data, reserved, deferred, tryNumber) {
                if (typeof deferred === 'undefined') {
                    deferred = Q.defer();
                }

                tryNumber = tryNumber || 0;
                var database = this.getDatabase();
                database.get(docId, function (err, doc) {
                    if (err) {
                        if (err.status === 404) {
                            // if not found, just add it
                            database.put({data: data}, docId, function (err, res) {
                                if (err) {
                                    deferred.reject(err);
                                } else {
                                    deferred.resolve(res.id);
                                }
                            });
                        } else {
                            deferred.reject(err);
                        }
                    } else {
                        // if found, update it
                        database.put({data: data}, doc._id, doc._rev, function (err, res) {
                            if (err) {
                                if (err.status === 409) {
                                    if (tryNumber === 3) {
                                        deferred.reject(err);
                                    }
                                    this.setStatic(docId, data, reserved, deferred, ++tryNumber);
                                } else {
                                    deferred.reject(err);
                                }
                            } else {
                                deferred.resolve(res);
                            }
                        }.bind(this));
                    }
                }.bind(this));

                return deferred.promise;
            }
        });

        return PouchAdapter;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(889),
        __webpack_require__(717)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, constants) {
        'use strict';
        var Storage;

        /**
         * @class module.undoRedo.Storage
         * @template module.undoRedo.Storage
         * @lends {module.undoRedo.Storage.prototype}
         * @constructor
         */
        Storage = Klazz.extend({

            /** @type {String} */
            sessionId: null,

            /** @type {String} */
            websiteId: null,

            /** @type {module.undoRedo.PouchAdapter} */
            database: null,

            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,

            history: {
                undoList: [],
                redoList: [],
                lastEntry: {}
            },
            serverHistory: {
                undoList: [],
                redoList: [],
                lastEntry: {}
            },

            /**
             *
             * @param {module.undoRedo.RemoteRequest} backend
             */
            initialize: function (backend) {
                this.backend = backend;
            },

             // it has no constructor

            /**
             * Storage will be dependant on websiteId and sessionId
             * due to the fact that the user may have more than one contract on the same shard
             *
             * @param {module.undoRedo.PouchAdapter} database
             * @param {String} websiteId
             * @param {String} sessionId
             * @return {Promise|Q.Promise}
             */
            init: function (database, websiteId, sessionId) {
                this.database = database;
                this.websiteId = websiteId;
                this.sessionId = sessionId;
                return Q(true);
            },

            /**
             *
             * @param {Q} deferred
             * @param {Object} injectedData
             * @param {?Object[]} injectedData.undoList
             * @param {?Object[]} injectedData.redoList
             * @param {?Object} injectedData.lastEntry
             * @returns {promise|a.fn.promise|Q.promise|.n.promise}
             */
            useInjectedHistory: function (deferred, injectedData) {
                var data;
                if (injectedData && injectedData.undoList && injectedData.redoList) {
                    data = this.parseHistory(injectedData, this.markServerEntry);
                    deferred.resolve(data);
                } else {
                    deferred.reject({message:'invalid injected data', data: injectedData});
                }
                return deferred.promise;
            },
            /**
             *
             * @param deferred
             * @returns {Promise|Q.promise}
             * @private
             */
            loadServerHistory: function (deferred) {
                this.backend.loadHistory()
                    .then(
                    /**
                     *
                     * @param serverHistory {Object}
                     * @param serverHistory.undoList {?Object[]}
                     * @param serverHistory.redoList {?Object[]}
                     * @param serverHistory.lastEntry {?Object}
                     */
                    function (serverHistory) {
                        var data = this.parseHistory(serverHistory, this.markServerEntry);
                        deferred.resolve(data);
                    }.bind(this)
                )
                    .catch(function (error) {
                        deferred.reject(error);
                    });
                return deferred.promise;
            },
            /**
             * Load server history from server side
             *      or that history may be injected by using @param injectedData
             *
             * Returns promise resolved with formatted serverHistory
             * @param {Object=} injectedData
             * @param {?Object[]} injectedData.undoList
             * @param {?Object[]} injectedData.redoList
             * @param {?Object} injectedData.lastEntry
             * @returns {Promise|Q.promise}
             * @private
             */
            loadServer: function (injectedData) {
                var deferred = Q.defer();
                if (typeof injectedData === 'undefined') {
                    return this.loadServerHistory(deferred);
                } else {
                    return this.useInjectedHistory(deferred, injectedData);
                }
            },

            /**
             * Converts server payload to a common format
             *
             * @param object
             * @returns {*}
             * @private
             */
            markServerEntry: function (object) {
                return $.extend({}, object, {
                    executionType: constants.executionType.SERVER,
                    entryKey: object.entryId,
                    entryId: object.entryId,
                    undoSessionId: object.undoSessionId,
                    undoSessionIndex: 0,
                    manager: object.manager,
                    entryType: (object.entryType === 1) ? constants.types.UNDO : constants.types.REDO
                });
            },

            /**
             * Converts client payload to a common format
             *
             * @param object
             * @returns {*}
             * @private
             */
            markClientEntry: function (object) {
                return $.extend({}, object, {
                    executionType: constants.executionType.CLIENT,
                    entryKey: object._id,
                    entryType: object.type
                });
            },

            /**
             * Converts database loaded history to a common format
             *
             * @param history
             * @param callback
             * @returns {{undoList: Array, redoList: Array, lastEntry: {}}}
             * @private
             */
            parseHistory: function (history, callback) {

                var
                    index,
                    parsedHistory = {undoList: [], redoList: [], lastEntry: null};

                for (index = 0; index < history.undoList.length; index++) {
                    parsedHistory.undoList[index] = callback.call(this, history.undoList[index]);
                }

                for (index = 0; index < history.redoList.length; index++) {
                    parsedHistory.redoList[index] = callback.call(this, history.redoList[index]);
                }

                if (history.lastEntry && Object.keys(history.lastEntry).length !== 0) {
                    parsedHistory.lastEntry = callback.call(this, history.lastEntry);
                }

                return parsedHistory;
            },
            /**
             * Merges the server history with local stored history
             *
             * Process merges the client entries always after a server entry
             *  example:
             *      before merge:
             *          ServerHistory.undoList = [
             *              {server entry 1, ..., undoSessionId:'session1'},
             *              {server entry 2, ..., undoSessionId:'session2'},
             *              .....
             *              {server entry n, ..., undoSessionId:'sessionN'},
             *          ]
             *          localHistory.undoList = [
             *              {client entry 1, ..., undoSessionId:'session1'},
             *              {client entry 2, ..., undoSessionId:'session1'},
             *              {client entry 3, ..., undoSessionId:'session1'},
             *              .....
             *              {client entry 4, ..., undoSessionId:'session2'},
             *              {client entry 5, ..., undoSessionId:'session2'},
             *              .....
             *          ]
             *      after merge:
             *
             *          history.undoList = [
             *              {client entry 1, ..., undoSessionId:'session1'},
             *              {client entry 2, ..., undoSessionId:'session1'},
             *              {client entry 3, ..., undoSessionId:'session1'},
             *              {server entry 1, ..., undoSessionId:'session1'},
             *              {client entry 4, ..., undoSessionId:'session2'},
             *              {client entry 5, ..., undoSessionId:'session2'},
             *              {server entry 2, ..., undoSessionId:'session2'},
             *              .....
             *              {server entry n, ..., undoSessionId:'sessionN'},
             *          ]
             * Local entries that do not have an existing undoSessionId on any server side entries are deleted
             *
             * Returns resolved promise with merged history
             *
             * @param serverHistory
             * @returns {Promise|Q.promise}
             * @private
             */
            mergeWithLocalDatabase: function (serverHistory) {
                /**
                 * @info implement last entry support in client side if will be needed for notification center
                 *
                 * @type {{undoList: Array, redoList: Array, lastEntry: *}}
                 */
               var history = {
                    undoList: [],
                    redoList: [],
                    lastEntry: serverHistory.lastEntry
                };

                return this.loadLocalDatabase()
                    .then(function(localHistory){
                        localHistory = this.parseHistory(localHistory, this.markClientEntry);
                        return this.mergeLists(localHistory, serverHistory, history);
                    }.bind(this));
            },
            /**
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} history
             * @returns {Promise|Q.promise}
             * @private
             */
            mergeLists: function mergeLists(localHistory, serverHistory, history) {
                var availableSessions = [];

                history.undoList = this.mergeUndoList(serverHistory, localHistory, availableSessions);
                history.redoList = this.mergeRedoList(serverHistory, localHistory, availableSessions);

                return this.mergeUnmatched(serverHistory, localHistory, availableSessions, history)
                    .then(function(){
                        return Q(history);
                    });
            },
            /**
             * For undo list merge client side entries between server side entries
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {Array.<String>} availableSessions
             * @returns {Array}
             * @private
             */
            mergeUndoList: function mergeUndoList(serverHistory, localHistory, availableSessions) {
                var list = [], i, j, currentEntry, localEntry;

                if (serverHistory.undoList.length) {
                    for (i = serverHistory.undoList.length - 1; i >= 0; i--) {
                        currentEntry = serverHistory.undoList[i];
                        availableSessions.push(currentEntry.undoSessionId);
                        list.unshift(currentEntry);
                        for (j = 0; j < localHistory.undoList.length;) {
                            localEntry = localHistory.undoList[j];
                            if (currentEntry.undoSessionId === localEntry.undoSessionId) {
                                list.unshift(localEntry);
                                localHistory.undoList.splice(j, 1);
                            } else {
                                j++;
                            }
                        }
                    }
                }
                return list;
            },

            /**
             * For redo list merge client side entries between server side entries
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {Array.<String>} availableSessions
             * @returns {Array}
             * @private
             */
            mergeRedoList: function mergeRedoList(serverHistory, localHistory, availableSessions) {
                var list = [], i, j, currentEntry, localEntry;

                if (serverHistory.redoList.length) {
                    for (i = 0; i < serverHistory.redoList.length; i++) {
                        currentEntry = serverHistory.redoList[i];
                        availableSessions.push(currentEntry.undoSessionId);
                        list.push(currentEntry);
                        for (j = 0; j < localHistory.redoList.length;) {
                            localEntry = localHistory.redoList[j];
                            if (currentEntry.undoSessionId === localEntry.undoSessionId) {
                                list.push(localEntry);
                                localHistory.redoList.splice(j, 1);
                            } else {
                                j++;
                            }
                        }
                    }
                }
                return list;
            },
            /**
             * Add remaining local entries that have the undoSessionId in any server entries
             *  to the top of redo list
             * Delete unmatched local entries
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {Array.<String>} availableSessions
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} history
             * @returns {Promise|Q.promise}
             * @private
             */
            mergeUnmatched: function mergeUnmatched(serverHistory, localHistory, availableSessions, history) {
                var entriesToBeDeleted = [], i, localEntry;

                /**
                 * add remaining local entries that have the undoSessionId in any server entries
                 * to the top of redo list
                 */
                for (i = localHistory.redoList.length - 1; i >= 0; i--) {
                    localEntry = localHistory.redoList[i];
                    if (availableSessions.indexOf(localEntry.undoSessionId) !== -1) {
                        history.redoList.unshift(localEntry);
                        localHistory.redoList.splice(i, 1);
                    } else {
                        i--;
                    }
                }

                /**
                 * delete the local entries that did not matched so far
                 * (there can not be an entry at the top/bottom of undo list)
                 */
                for (i = 0; i < localHistory.undoList.length; i++) {
                    localEntry = localHistory.undoList[i];
                    if (availableSessions.indexOf(localEntry.undoSessionId) === -1) {
                        entriesToBeDeleted.push(localEntry.entryKey);
                    }
                }
                for (i = 0; i < localHistory.redoList.length; i++) {
                    localEntry = localHistory.redoList[i];
                    if (availableSessions.indexOf(localEntry.undoSessionId) === -1) {
                        entriesToBeDeleted.push(localEntry.entryKey);
                    }
                }

                if (entriesToBeDeleted.length) {
                    return this.deleteEntries(entriesToBeDeleted);
                } else {
                    return Q(true);
                }
            },
            /**
             * Loads server history and local history, merges them and returns promise resolved with history object
             *
             *      server history may be injected by using @param injectedServerHistory
             *
             * Returns promise resolved with history object
             *
             * @param {Object=} injectedServerHistory
             * @returns {Promise|Q.promise}
             */
            loadDatabase: function (injectedServerHistory) {
                var deferred = Q.defer();

                this.loadServer(injectedServerHistory)
                    .then(this.mergeWithLocalDatabase.bind(this))
                    .then(function (mergedHistory) {
                        this.history = mergedHistory;
                        deferred.resolve(mergedHistory);
                    }.bind(this))
                    .catch(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },
            loadLocalDatabase: function (){
                if (this.database !== null) {
                    return this.database.loadHistory();
                } else {
                    return Q({undoList: [], redoList: [], lastEntry: {}});
                }
            },
            /**
             * Getter function
             *
             * @returns {*}
             */
            getUndoEntries: function () {
                return this.history.undoList;
            },

            /**
             * Getter function
             *
             * @returns {*}
             */
            getRedoEntries: function () {
                return this.history.redoList;
            },

            /**
             * Adds a record to database
             *
             * Returns promise resolved with record id
             *
             * @param {Object} data
             * @param {?String} entryKey
             * @returns {Promise|Q.promise}
             */
            addUndoEntry: function (data, entryKey) {
                var deferred = Q.defer();
                data.sessionId = this.sessionId;

                if (typeof data === 'undefined') {
                    deferred.reject('data is undefined');
                } else {
                    this.database.add(data, entryKey)
                        .then(function (res) {
                            deferred.resolve(res);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                }
                return deferred.promise;
            },

            /**
             * Updates record {key} with {data}
             *
             * @param key
             * @param data
             * @returns {Promise|Q.promise}
             */
            updateEntry: function (key, data) {
                var deferred = Q.defer();
                this.database.update(key, data)
                    .then(function (previousData) {
                        deferred.resolve(previousData);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;
            },
            /**
             * Deletes record of type redo from database
             *
             *
             * @returns {Promise|Q.promise}
             */
            deleteRedoEntries: function () {
                var deferred = Q.defer();
                this.database.deleteRedoEntries()
                    .then(function (previousData) {
                        deferred.resolve(previousData);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },

            /**
             * Deleted record with {toDeleteIds}
             *
             * @param toDeleteIds
             * @returns {Promise|Q.promise}
             */
            deleteEntries: function (toDeleteIds) {
                var deferred = Q.defer();
                if (Array.isArray(toDeleteIds) && toDeleteIds.length) {
                    this.database.deleteEntryIds(toDeleteIds)
                        .then(function (res) {
                            deferred.resolve(res);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                } else {
                    deferred.resolve(true);
                }
                return deferred.promise;
            },
            /**
             *
             * @param {String} undoSessionId
             * @returns {Promise|Q.promise}
             */
            deleteEntriesFromSession: function deleteEntriesFromSession(undoSessionId) {
                return this.database.deleteEntriesFromSession(undoSessionId);
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            getActiveUndoSession: function () {
                var deferred = Q.defer();
                this.database.getStatic('-static-undoRedo/activeSession')
                    .then(function (data) {
                        deferred.resolve(data);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    })
                    .done();
                return deferred.promise;
            },

            /**
             *
             * @param {Object} sessionData
             * @returns {Promise|Q.promise}
             */
            setActiveUndoSession: function (sessionData) {
                var deferred = Q.defer();
                this.database.setStatic('-static-undoRedo/activeSession', sessionData)
                    .then(function (data) {
                        deferred.resolve(data);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    })
                    .done();
                return deferred.promise;
            }
        });

        return Storage;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(21),
        __webpack_require__(717),
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Modernizr, helper, constants) {
        'use strict';
        var
            Ui;

        /**
         * @class module.undoRedo.Ui
         * @template module.undoRedo.Ui
         * @lends {module.undoRedo.Ui.prototype}
         * @constructor
         */
        Ui = Klazz.extend({
            /** @type {module.undoRedo.FeatureSet} */
            features: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /** @type {diy.editor.Toolbar} */
            toolbar: null,

            element: null,

            displayLimit: 0,

            flags: {
                isListCollapsed: false,
                isWidgetExpanded: false,
                isTouchEnabled: false,

                blockerId: '',
                uiEnabled: true,

                customScrollBarInitialized: false
            },

            messages: {
                tooltipClickHereToUndo: '',
                tooltipClickHereToRedo: '',
                tooltipCanNotBeUndone: '',
                loadingText: ''
            },

            options: {
                collapseListOnMouseLeave: true,
                mobileMode: false
            },
            entries:{},

            /**
             * constructor; is called from undoRedo api as a member;
             * adds undo-redo user interface to diy toolbar
             *
             * @param {module.undoRedo.Api} api
             * @param {Number} displayLimit
             * @param {Object} messages
             * @param {module.undoRedo.FeatureSet} features
             * @param {diy.editor.Toolbar} toolbar
             */
            initialize: function(api, displayLimit, messages, features, toolbar) {
                this.api = api;
                this.toolbar = toolbar;
                this.displayLimit = displayLimit;
                $.extend(true, this.messages, messages);
                this.features = features;

                this.flags.isTouchEnabled = diy.editor.uiPreference.isPointerModeTouch();


                this.options.mobileMode = (this.flags.isTouchEnabled) ? true : this.options.mobileMode;
                if (this.options.mobileMode === true) {
                    this.options.collapseListOnMouseLeave = false;
                }

                this.element = this.createElement();
            },

            /**
             * envelop buttons to a panel element into diy toolbar
             *
             * @returns {*|HTMLElement}
             */
            createElement: function() {
                var element = $('<div id="undo-redo-history">').wrap('<div class="diye undo-redo-widget">').parent();
                this.toolbar.pushToPanel('center', element);
                return $('#undo-redo-history');
            },


            /**
             * Returns html elements corresponding to an entry in undo list
             *
             * @param {module.undoRedo.UiEntry[]} list
             * @param {Number} index Number representing positioning in list
             * @param {String} listType String - 'undo' | 'redo'
             * @param {Boolean=} firstRow
             * @param {Number=} numberOfItemsInList Number - how may items should be displayed in list
             * @returns {string}
             */
            getEntryHtml: function(list, index, listType, firstRow, numberOfItemsInList) {
                var entry = list[index],
                    hasData = (typeof entry !== 'undefined'),
                    actionTextMessage = (firstRow && hasData)? this.convertToTooltip(entry.getMessage()) : '',
                    executeIconTooltip = (
                        hasData ?
                            (entry.isExecutable() ?
                            ' title="' +
                            this.messages['tooltipClickHereTo' + this.capitalize(listType)] +
                            actionTextMessage + '"' :
                            ' title="' + this.messages.tooltipCanNotBeUndone + actionTextMessage + '"'
                            ) : ''
                    ),
                    isExecutableClass = (
                        hasData ?
                            (entry.isExecutable() ? '' : ' notExecutable') :
                            ' disabled'
                    ),
                    dataEntryId = (
                        hasData ?
                        ' data-key="' + entry.getKey() + '" ' :
                            ''
                    ),
                    dataTracking = (
                        hasData ?
                            (' data-tracking="' + this.capitalize(listType) + (firstRow ? '' : index + 1) + '" ') :
                            ''
                    ),
                    dataLabel = (
                        hasData ?
                            entry.getLabel() :
                            ''
                    ),
                    collapseIconHtml = (
                        firstRow === true ?
                        '<div class="collapseIcon ' + ((list.length) ? '' : 'disabled ') + '"' + '>' +
                        '<div class="icon"><span class="index">' + numberOfItemsInList + '</span></div>' +
                        '</div>' :
                            ''
                    ),
                    entryDetailHtml = (
                    '<div class="entryDetail" ' + dataEntryId + '>' +
                    '<div class="entryMessage">' + dataLabel + '</div>' +
                    '</div>'
                    ),
                    executeIconHtml = (
                    '<div class="executeIcon" ' + executeIconTooltip + dataEntryId + dataTracking + '>' +
                    '<div class="icon"></div>' +
                    '</div>'
                    )
                    ;
                return [
                    '<div class="listEntry', (firstRow === true ? ' lastEntry' : '') , isExecutableClass , '"',
                    dataEntryId, dataTracking, '" >', entryDetailHtml, collapseIconHtml, executeIconHtml, '</div>'
                ].join("");
            },

            /**
             * Returns html elements corresponding to a undo | redo list
             *
             * @param list Array
             * @param type String 'undo'|'redo'
             * @returns {string}
             */
            getListHtml: function(list, type) {
                var i = 0, html, displayLimit;

                displayLimit = (this.displayLimit !== 0)?
                    Math.min(list.length, this.displayLimit) :
                    list.length;

                html = ['<div class="', type,  '-list undo-redo-list list-collapsed ', (!list.length? 'emptyList' : ''), '">'];
                html.push(this.getEntryHtml(list, 0, type, true, displayLimit));

                if (list.length) {
                    html.push('<div class="allEntries toolbarCalloutPanel">');
                    html.push('<div class="scrollInner">');
                    html.push('<div class="pointer"></div>');
                    for (i = 0; i < displayLimit; i++) {
                        html.push(this.getEntryHtml(list, i, type));
                    }
                    html.push('</div>'); //class="scrollInner"
                    html.push('</div>');
                }

                html.push('</div>');
                return html.join("");
            },


            storeIncomingData: function storeIncomingData(data) {
                this.entries = {};
                data.undoList.forEach(
                    /** @param {module.undoRedo.UiEntry} entry */ function (entry){
                        this.entries[entry.getKey()] = entry;
                    }.bind(this)
                );
                data.redoList.forEach(
                    /** @param {module.undoRedo.UiEntry} entry */ function (entry){
                        this.entries[entry.getKey()] = entry;
                    }.bind(this)
                );
            },
            /**
             * Repaints the ui based on given data; unblock ui elements;
             *
             * @param data {Object=}
             */
            refresh: function(data) {
                if (data === undefined) {
                    data = {
                        undoList: [],
                        redoList: [],
                        lastEntry: null
                    };
                }
                this.storeIncomingData(data);

                var content = [
                    this.getListHtml(data.undoList, 'undo'),
                    this.getListHtml(data.redoList, 'redo'),
                    '<div class="spacer lists-spacer"><div class="icon"></div></div>'
                ].join("");

                //at this point we're removing some markup that might have
                // a custom scrollbar instance attached, if so, destroy  the instance
                if (this.flags.customScrollBarInitialized === true) {
                    this.element.find('.scrollHandle').diy_scrollHandle('destroy');
                    this.flags.customScrollBarInitialized = false;
                }

                this.element.html(content);
                this.flags.isWidgetExpanded = true;

                if (data.undoList.length !== 0 ||  data.redoList.length !== 0) {
                    this.initListEvents();
                    this.flags.isWidgetExpanded = false;
                }

                this.unblockUi();
            },

            initListEvents: function() {
                var container = this.element.find('.undo-redo-list:not(.emptyList)'),
                    executeFilter = '.listEntry:not(.notExecutable):not(.lastEntry)',
                    expandFilter = '.listExpandIcon, .collapseIcon',
                    self = this;

                if (this.options.mobileMode === true) {
                    expandFilter += ' , .lastEntry:not(.notExecutable) .executeIcon';
                } else {
                    executeFilter += ' , .lastEntry:not(.notExecutable) .executeIcon';
                }

                //execute functionality
                this.addExecuteEvent(container, executeFilter);
                container.each(function() {
                    self.addExpandEvent(
                        $(this).find('.allEntries'),
                        $(this).find(expandFilter),
                        'vertical'
                    );
                });

                this.addSelectedEntryEvent(container, false);

                //at this point we have the freshly rendered lists => create the virtual scrolls
                this.setupCustomScrollBar();
            },

            /**
             * sets up custom scrollbar on the lists
             * @access private
             */
            setupCustomScrollBar: function () {
                //do not init the scrollbar twice
                if (this.flags.customScrollBarInitialized === false) {
                    var $undoRedoLists = this.element.find('.scrollInner');
                    $undoRedoLists.diy_scrollHandle({arrows: true});
                    this.flags.customScrollBarInitialized = true;
                }
            },

            addExecuteEvent: function(container, selector, excludeSelector) {
                var
                    elements = container.find(selector),
                    self = this;

                container.find(selector).unbind('click.undo-redo');

                if (excludeSelector) {
                    elements = elements.not(excludeSelector);
                }

                elements.bind('click.undo-redo', function() {
                    self.tracking($(this).attr('data-tracking'));
                    self.onExecute($(this).attr('data-key'));
                });
            },

            /**
             * Method used for tracking
             *
             * @param tracking
             */
            tracking: function(tracking) {
                if (this.flags.uiEnabled === false) {
                    return;
                }
                $(document).trigger('diy-editor-undo-redo-link-tracking', {
                    actionName: tracking
                });
            },

            expandList: function(list, direction) {
                var
                    self = this,
                    collapseOther = this.element.find('.allEntries.list-expanded');

                if (collapseOther.length) {
                    this.collapseList(collapseOther, 'vertical');
                }

                list.removeClass('list-collapsed').addClass('list-expanded');
                list.parent().removeClass('list-collapsed').addClass('list-expanded');

                if (direction === 'vertical') {
                    list.slideDown('fast', function() {
                        self.flags.isListCollapsed = false;
                        //now we can safely draw the scrollbar
                        list.find('.scrollInner').trigger('contentchanged');
                    }.bind(this));
                } else {
                    list.show();
                    //now we can safely draw the scrollbar
                    list.find('.scrollInner').trigger('contentchanged');
                    self.flags.isListCollapsed = false;
                }
                if (list.hasClass('redo-list')) {
                    self.tracking('OpenRedoList');
                } else {
                    self.tracking('OpenUndoList');
                }
            },

            collapseList: function(list, direction) {
                var self = this;

                if (direction === 'vertical') {
                    list.slideUp('fast', function() {
                        self.flags.isListCollapsed = true;
                    });
                } else {
                    list.hide();
                    self.flags.isListCollapsed = true;
                }
                list.removeClass('list-expanded').addClass('list-collapsed');
                list.parent().removeClass('list-expanded').addClass('list-collapsed');
            },

            collapseAll: function(){
                var self = this;
                this.element.find('.allEntries.list-expanded').each(function() {
                    self.collapseList($(this));
                });
            },

            addExpandEvent: function(listContainer, expandElements, direction) {
                var self = this;

                listContainer.hide().addClass('list-collapsed');

                expandElements.unbind('click.undo-redo').bind('click.undo-redo', function(event) {
                    if (self.flags.uiEnabled === false) {
                        return;
                    }
                    if (listContainer.hasClass('list-collapsed')) {
                        self.expandList(listContainer, direction);
                    } else {
                        self.collapseList(listContainer, direction);
                    }
                    event.stopImmediatePropagation();
                    return false;
                });

                if (this.options.collapseListOnMouseLeave) {

                    if (this.options.collapseListOnMouseLeave) {
                        //implement inline the hover intent functionality
                        //because direct usage of hoverIntent fails due to
                        //incompatibilities between this component design and
                        //hover intent design
                        var timerId = null;
                        this.element.bind('mouseleave', function(){
                            if (timerId === null) {
                                timerId = setTimeout(function(){
                                    self.collapseList(listContainer, 'vertical');
                                    timerId = null;
                                }, 500);
                            }
                        });
                        this.element.bind('mouseenter', function(){
                            if (timerId !== null) {
                                clearTimeout(timerId);
                                timerId = null;
                            }
                        });
                    }
                    else {
                        // collapse when mouse leaves the list
                        this.element.mouseleave(function() {
                            self.collapseList(listContainer, 'vertical');
                        });
                    }
                }
            },

            addSelectedEntryEvent: function(container, reverse) {
                var entrySelector = '.listEntry',
                    eventSelector = '.allEntries .listEntry, .lastEntry .executeIcon, .lastEntry .collapseIcon',
                    selectedClass = 'selectedEntry',
                    self = this,

                    markSelectedEntries = function() {
                        var $entry = ($(this).hasClass('collapseIcon') || $(this).hasClass('executeIcon'))?
                                $(this).parent() :
                                $(this)
                            ;

                        if ($(this).hasClass('executeIcon')) {
                            $entry.addClass('showMessage');
                        }
                        if ($(this).hasClass('collapseIcon')) {
                            $entry.removeClass('showMessage');
                        }
                        $entry.parent().find(entrySelector).removeClass(selectedClass);
                        if (reverse === true) {
                            $entry.nextAll(entrySelector).andSelf().addClass(selectedClass);
                        } else {
                            $entry.prevAll(entrySelector).andSelf().addClass(selectedClass);
                        }

                        $entry.parent().find(entrySelector).each(function() {
                            self.onDeselect(this);
                        });

                        if (reverse === true) {
                            $entry.nextAll(entrySelector).andSelf().each(
                                function(index, element) { self.onSelect(element); }
                            );
                        } else {
                            $entry.prevAll(entrySelector).andSelf().each(
                                function(index, element) { self.onSelect(element); }
                            );
                        }
                    },

                    unmarkSelectedEntries = function() {

                        $(this).find(entrySelector).removeClass(selectedClass + ' showMessage');
                        $(this).find(entrySelector).each(
                            function(index, element) { self.onDeselect(element); }
                        );
                    };

                if (self.flags.isTouchEnabled) {
                    container.find(eventSelector).bind('click.undo-redo', markSelectedEntries);
                } else {
                    container.find(eventSelector).unbind('mouseenter').bind('mouseenter', markSelectedEntries);
                    container.unbind('mouseleave').mouseleave(unmarkSelectedEntries);
                }
            },
            /**
             *
             * @param {String} key
             * @returns {module.undoRedo.UiEntry|null}
             */
            getItemByKey: function getItemByKey(key) {
                var entry = this.entries[key];
                return (typeof entry !== 'undefined')? entry : null;
            },
            onSelect: function(element) {
                if (this.options.mobileMode === true) {
                    return;
                }
                var entry = this.getItemByKey($(element).attr('data-key'));
                if (entry && typeof entry.onSelect === 'function'){
                    entry.onSelect();
                }
            },

            onDeselect: function(element) {
                if (this.options.mobileMode === true) {
                    return;
                }
                var entry = this.getItemByKey($(element).attr('data-key'));
                if (entry && typeof entry.onDeselect === 'function'){
                    entry.onDeselect();
                }
            },

            /**
             * Called by user to trigger entry execution
             *
             * @param key
             */
            onExecute: function(key) {
                if (this.flags.uiEnabled === false) {
                    return;
                }

                var entry = this.getItemByKey(key);

                this.collapseAll();

                if (entry !== null) {
                    try {
                        this.block();
                        entry.onClick()
                            .done(
                                function /*onFulfilled*/(){
                                    this.unblock();
                                }.bind(this),
                                function /*onRejected*/(){
                                    this.unblock();
                                    this.showErrorBox();
                                }.bind(this)
                            );
                    } catch (error) {
                        this.unblock();
                        this.showErrorBox();
                    }

                }
            },

            /**
             * Disable click on interface elements keeping hover; will look the same
             * but the user will not be able to execute entries
             *
             * used when an action is "in execution" state or an entry is about to be created on server side
             *
             */
            blockUi: function() {
                this.collapseAll();
                this.flags.uiEnabled = false;
            },

            /**
             * Reverse method for blockUi
             * @see blockUi
             */
            unblockUi: function() {
                this.flags.uiEnabled = true;
            },

            /**
             * Block ui elements
             * Adds a blocker over the whole diy
             * Used when an entry is executed
             */
            block: function() {
                this.blockUi();
                this.flags.blockerId = helper.overlay({loadingText: this.messages.loadingText});
            },

            /**
             * Reverse method for block
             * @see block
             */
            unblock: function() {
                this.unblockUi();
                $('#' + this.flags.blockerId).remove();
            },


            capitalize: function(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },

            /**
             * Converts the html markup for the undo entry label to a raw text which
             * we can place in a tooltip.
             *
             * HACK: because the markup for the undo/redo labels is stored in the
             * database, we have to extract the text label "by force". This should
             * be refactored so the markup is built entirely in the client and we
             * only store the raw data in the db.
             */
            convertToTooltip: function(message) {
                var tooltipLabel = '',
                    messageHtml,
                    spanText,
                    spanEl;

                if (message) {
                    tooltipLabel += ' - ';

                    // wrap the markup with a 'p' tag, otherwise the inner span will
                    // be considered as the root element when we wrap with $
                    messageHtml = $('<p></p>').html(message);

                    //extract the span text, which is present for a text/heading module
                    spanEl = messageHtml.find('span');
                    if (spanEl.length) {
                        spanText = spanEl.text();
                        //remove the span so we can take the remainder of the label
                        messageHtml.find('span').remove();
                        tooltipLabel += (spanText.length ? '&quot;' + spanText + '&quot; ' : '');
                    }

                    tooltipLabel += messageHtml.text();
                }

                return tooltipLabel.replace(/"/g, '&quot;');
            },
            /**
             * Displays an error message to the user, requesting for page refresh
             *  overlay is blocking all interface, the error is unknown and we can't let the user do any changes
             *  until the new data is loaded from server (the undo engine may be out of sync - or newer data is a new tab
             *  or something failed in applying snapshot client / server side)
             */
            showErrorBox: function (error) {
                var errorHtml, errorBox, errorButton;
                error = error || this.messages.errors.generic;

                errorHtml = [
                    '<div><div class="undo-redo-dialog-box-wrapper with-icon">',
                    '<div class="dialog-box-icon ui-icon ui-icon-alert"></div>',
                    '<div class="dialog-box-title"></div>',
                    '<div class="dialog-box-description"></div>',
                    '</div></div>'
                ].join("");

                errorBox = $(errorHtml);

                errorBox.find('.dialog-box-title').html(error.title);
                errorBox.find('.dialog-box-description').html(error.description);

                if (error.button) {
                    errorButton = {
                        text: error.button,
                        click: function () {
                            errorBox.remove();
                            helper.browserReload(null, null, 100);
                        }.bind(this)
                    };
                }

                errorBox.diy_confirmationDialog({
                    zIndex: 100210,
                    width: 386,
                    overlayCls: null, /* use default semi-transparent overlay */
                    position: {
                        my: 'center middle',
                        at: 'center middle'
                    },
                    buttons: errorButton ? [errorButton] : []
                });
            }
        });

        return Ui;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(889),
        __webpack_require__(912)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (constants, UiEntry) {
        'use strict';

        var UiManager;
        /**
         * @class module.undoRedo.UiManager
         * @template module.undoRedo.UiManager
         * @lends {module.undoRedo.UiManager.prototype}
         * @constructor
         */
        UiManager = Klazz.extend({
            /** @type {module.undoRedo.Ui} */
            ui: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /**
             *
             * @param {module.undoRedo.Ui} ui
             * @param {module.undoRedo.Api} api
             */
            initialize: function intitialize(ui, api) {
                this.ui = ui;
                this.api = api;
            },
            /**
             *
             * @param {{undo:[], redo:[], last:{}}} incoming
             */
            handle: function handle(incoming) {
                var parsed = {
                    undoList: [],
                    redoList: [],
                    lastEntry: null
                };

                this.filter(incoming.undo).forEach(
                    function (entry) {
                        parsed.undoList.push(new UiEntry(entry, this.api, constants.types.UNDO));
                    }.bind(this)
                );
                this.filter(incoming.redo).forEach(
                    function (entry) {
                        parsed.redoList.push(new UiEntry(entry, this.api, constants.types.REDO));
                    }.bind(this)
                );

                if (typeof incoming.last !== 'undefined' && incoming.last !== null) {
                    this.filter([incoming.last]).forEach(
                        function (entry) {
                            parsed.lastEntry = new UiEntry(entry, this.api, entry.getType());
                        }.bind(this)
                    );
                }

                this.ui.refresh(parsed);
            },

            /**
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {module.undoRedo.Entry[]}
             */
            filter: function filter(chain) {
                return chain.filter(function (entry /*, index, array */) {
                    return !(
                    entry.getExecutionType() === constants.executionType.SERVER &&
                    entry.getIsSessionHead() === true
                    );
                });
            }

        });
        return UiManager;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';

        var UiEntry;

        /**
         * @class module.undoRedo.UiEntry
         * @template module.undoRedo.UiEntry
         * @lends {module.undoRedo.UiEntry.prototype}
         * @constructor
         */
        UiEntry = Klazz.extend({
            /** @type {String} */
            key: null,
            /** @type {String} */
            message: null,
            /** @type {String} */
            label: null,
            /** @type {Boolean} */
            executable: null,
            /** @type {String} */
            historyEntryType: null,
            /** @type {String} */
            type: 'undo',
            /** @type {Boolean} */
            sessionStart: false,

            /** @type {Function} */
            onSelect: function () {},
            /** @type {Function} */
            onDeselect: function () {},
            /** @type {Function} */
            onClick: function () {},

            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @param {module.undoRedo.Api} api
             * @param {String} type
             */
            initialize: function (entry, api, type) {
                this.key = entry.getKey();
                this.label = entry.getLabel();
                this.message = entry.getMessage();
                this.executable = entry.isExecutable();
                this.historyEntryType = entry.getManager();
                this.sessionIndex = entry.getSessionIndex();
                this.type = type;
                this.sessionStart = !!(entry.isSessionHead);

                var plugin = api.getPluginForEntryType(this.historyEntryType);

                if (plugin !== null) {
                    this.onSelect = function () {
                        plugin.onSelect(entry.getHistoryEntry());
                    };

                    this.onDeselect = function () {
                        plugin.onDeselect(entry.getHistoryEntry());
                    };
                } else {
                    this.onSelect = function () {};
                }

                if (this.isExecutable()) {
                    this.onClick = function () {
                        return api.executeEntryKey(this.key);
                    };
                } else {
                    this.onClick = function disabled() {
                        return Q(false);
                    };
                }
            },

            /**
             *
             * @returns {String}
             */
            getKey: function getKey() {
                return this.key;
            },
            /**
             *
             * @returns {String}
             */
            getMessage: function getMessage() {
                return this.message;
            },
            /**
             *
             * @returns {String}
             */
            getLabel: function getLabel() {
                return this.message;
            },
            /**
             *
             * @returns {Boolean}
             */
            isExecutable: function isExecutable() {
                return this.executable;
            }

        });

        return UiEntry;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(914),
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (Base, constants) {
        'use strict';
        var MainExecutor;

        /**
         * @class module.undoRedo.Executor.Main
         * @template module.undoRedo.Executor.Main
         * @lends {module.undoRedo.Executor.Main.prototype}
         * @extends {module.undoRedo.Executor.Base}
         * @constructor
         */
        MainExecutor = Base.extend({

            type: constants.executionType.SERVER,

            /** @type {module.undoRedo.Executor.Factory} */
            factory: null,
            /**
             *
             * @param {module.undoRedo.Executor.Factory} factory
             */
            setFactory: function setFactory(factory) {
                this.factory = factory;
            },
            /**
             * Formats a linear chain on entries to the following structure based on execution type
             *  position as in original chain is kept
             *
             *  [
             *      {type: 'server', items: [items...]},
             *      {type: 'client', items: [items...]},
             *      {type: 'server': items: [items...]}
             *  ]
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {Array.<{type: String, items: module.undoRedo.Entry[]}>}
             */
            splitOnExecutorType: function splitOnExecutorType(chain) {
                return chain.reduce(function (previous, current) { //, index, array) {
                    var
                        lastElement = previous[previous.length - 1],

                        newSection = function (previous, current) {
                            var object = {};
                            object.type = current.getExecutionType();
                            object.items = [current];
                            previous.push(object);
                        };

                    if (!lastElement) {
                        newSection(previous, current);
                    } else {
                        if (lastElement.type === current.getExecutionType()) {
                            lastElement.items.push(current);
                            previous[previous.length - 1] = lastElement;
                        } else {
                            newSection(previous, current);
                        }
                    }


                    return previous;
                }, []);
            },
            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @returns {Promise|Q.promise}
             */
            execute: function execute(entry) {
                var
                    deferred = Q.defer(),
                    execution = [],
                    result = [],
                    identitySets,
                    entryChain,
                    sessionHeadEntry;

                try {
                    entryChain = entry.getChain(this.history.chains);

                    if (entry.getExecutionType() === constants.executionType.CLIENT) {
                        if (entry.getType() === constants.types.UNDO && entry.getSessionIndex() === 1) {
                            sessionHeadEntry = this.history.getEntryByKey(entry.getLinkedEntryId().toString());
                            entry = (sessionHeadEntry === null) ? entry : sessionHeadEntry;
                        }
                    }

                    identitySets = this.splitOnExecutorType(entryChain.slice(0, entry.getPositionInChain(entryChain) + 1));

                    identitySets.forEach(function (identitySet, index) {
                        execution.push(this.executeSet.bind(this, identitySet, result, (index === identitySets.length - 1)));
                    }.bind(this));

                    execution.reduce(Q.when, Q(result))
                        .then(function executionEnded() {
                            this.applyExecution(result)
                                .done(
                                    function onFulfilled() {
                                        this.api.notifyObservers(constants.observerTopics.EXECUTION_FINISHED, result);
                                        deferred.resolve(true);
                                    }.bind(this),
                                    function onRejected(error) {
                                        deferred.reject(error);
                                    }
                                );
                        }.bind(this))
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                } catch (error) {
                    deferred.reject(error);
                }
                return deferred.promise;
            },
            /**
             *
             * @param {Array.<module.undoRedo.ExecutedEntry>} items
             */
            applyExecution: function applyExecution(items) {
                var toApply = [];
                items.forEach(function (item) {
                    toApply.push(function seqApply() {
                        return Q(item.callOnExecutedLast());
                    });
                });

                return toApply.reduce(Q.when, Q(true));
            },
            /**
             *
             * @param {{type: String, items: module.undoRedo.Entry[]}} identitySet
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(identitySet, result, hasLastEntry) {
                var executor;
                executor = this.factory.build(identitySet.type);

                return executor.executeSet(identitySet.items, result, hasLastEntry);
            }
        });

        return MainExecutor;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
        var ExecutorBase;

        /**
         * @class module.undoRedo.Executor.Base
         * @template module.undoRedo.Executor.Base
         * @lends {module.undoRedo.Executor.Base.prototype}
         * @constructor
         */
        ExecutorBase = Klazz.extend({
            /** @type {module.undoRedo.History} */
            history: null,
            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /**
             /**
             *
             * @param {module.undoRedo.History} history
             * @param {module.undoRedo.RemoteRequest} backend
             * @param {module.undoRedo.Api} api
             */
            initialize: function initialize(history, backend, api) {
                this.history = history;
                this.backend = backend;
                this.api = api;
            },
            /**
             *
             * @param {Array.<module.undoRedo.Entry>|*} items
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(items, result, hasLastEntry) {
                return Q(false);
            }
        });

        return ExecutorBase;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(916),
        __webpack_require__(918),
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (ExecutorServer, ExecutorClient, constants) {
        'use strict';
        var Factory;

        /**
         * @class module.undoRedo.Executor.Factory
         * @template module.undoRedo.Executor.Factory
         * @lends {module.undoRedo.Executor.Factory.prototype}
         * @constructor
         */
        Factory = Klazz.extend({
            /** @type {module.undoRedo.History} */
            history: null,
            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /**
             *
             * @param {module.undoRedo.History} history
             * @param {module.undoRedo.RemoteRequest} backend
             * @param {module.undoRedo.Api} api
             */
            initialize: function initialize(history, backend, api) {
                this.history = history;
                this.backend = backend;
                this.api = api;
            },
            /**
             *
             * @param {String} type
             * @returns {module.undoRedo.Executor.Base|module.undoRedo.Executor.Client|module.undoRedo.Executor.Server}
             */
            build: function build(type) {
                var executor;
                switch (type) {
                    case constants.executionType.SERVER:
                        executor = new ExecutorServer(this.history, this.backend, this.api);
                        break;
                    case constants.executionType.CLIENT:
                        executor = new ExecutorClient(this.history, this.backend, this.api);
                        break;
                }

                return executor;
            }
        });

        return Factory;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global Modul */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(19),
        __webpack_require__(914),
        __webpack_require__(917),
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, siteadminApi, Base, ExecutedEntry, constants) {
        'use strict';
        var Executor;

        /**
         * @class module.undoRedo.Executor.Server
         * @template module.undoRedo.Executor.Server
         * @lends {module.undoRedo.Executor.Server.prototype}
         * @extends {module.undoRedo.Executor.Base}
         * @constructor
         */
        Executor = Base.extend({

            type: constants.executionType.SERVER,

            /**
             *
             * For server entries ww will execute only the last entry from set (the server will execute the intermediary
             *  entries to keep the chain complete
             *
             * @param {Array.<module.undoRedo.Entry>} items
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(items, result, hasLastEntry) {
                var main = Q.defer(), entryToExecute, executedEntryKey;

                entryToExecute = items[items.length - 1];
                executedEntryKey = entryToExecute.getKey();

                this.backend.executeRemote(executedEntryKey)
                    .then(this.syncHistoryFromServer.bind(this))
                    .then(function (serverResponse) {
                        this.addExecutedEntries(serverResponse, result, (hasLastEntry ? executedEntryKey : null));
                        this.applyExecution(result)
                            .then(function () {
                                main.resolve(result);
                            })
                            .catch(function (error) {
                                main.reject(error);
                            });
                    }.bind(this))
                    .catch(function (error) {
                        main.reject(error);
                    });
                return main.promise;
            },
            /**
             *
             * @param {{history: Object, data: Object, limitations: Object}} serverResponse
             */
            syncHistoryFromServer: function syncHistoryFromServer(serverResponse) {
                return this.history.populateChains(serverResponse.history)
                    .then(function (){
                        this.handleServerSideLimitations(serverResponse.limitations);
                        return Q(serverResponse);
                    }.bind(this));
            },
            /**
             *
             * @param {{history: Object, data: Object}} serverResponse
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param callToExecutionKey
             */
            addExecutedEntries: function addExecutedEntries(serverResponse, result, callToExecutionKey) {
                serverResponse.data.forEach(function (item, index) {
                    var
                        existingEntry = this.history.getEntryByKey(item.entryId),
                        executedEntry;

                    if (existingEntry !== null) { // } && existingEntry.isSessionHead === false) {
                        executedEntry = new ExecutedEntry();
                        executedEntry.setOnExecuted(existingEntry.onExecuted.bind(existingEntry), item);

                        if (callToExecutionKey === existingEntry.getKey()) {
                            executedEntry.setOnExecutedLast(existingEntry.onExecutedLast.bind(existingEntry));
                        }
                        result.push(executedEntry);
                    }

                }.bind(this));
            },
            /**
             *
             * @param {Array.<module.undoRedo.ExecutedEntry>} items
             */
            applyExecution: function applyExecution(items) {
                var toApply = [];
                items.forEach(function (item) {
                    toApply.push(function seqApply() {
                        return Q(item.callOnExecuted());
                    });
                });

                return toApply.reduce(Q.when, Q(true));
            },

            /**
             *
             * @param {{hasReachedCriticalLimit: boolean, hasReachedMaximumLimit:boolean}} limitations
             */
            handleServerSideLimitations: function handleServerSideLimitations(limitations) {
                Modul.handleLimitationsResponse(limitations);
            }

        });

        return Executor;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
        var
            defaultAction = function () {},
            ExecutedEntry
        ;

        /**
         * @class module.undoRedo.ExecutedEntry
         * @template module.undoRedo.ExecutedEntry
         * @lends {module.undoRedo.ExecutedEntry.prototype}
         * @constructor
         */
        ExecutedEntry = Klazz.extend({
            /** @type {*} */
            data: undefined,
            /** @type {Function|undefined} */
            onExecuted : undefined,
            /** @type {Function|undefined} */
            onExecutedLast : undefined,

            initialize: function initialize() {
                this.data = {};
                this.onExecuted = defaultAction;
                this.onExecutedLast = defaultAction;
            },
            /**
             *
             * @param {Function} callback
             * @param {*=} data
             */
            setOnExecuted: function setOnExecuted(callback, data) {
                if (typeof callback === 'function') {
                    this.onExecuted = callback;
                }
                this.data = data;
            },
            /**
             *
             * @param {Function} callback
             */
            setOnExecutedLast: function setOnExecutedLast(callback) {
                if (typeof callback === 'function') {
                    this.onExecutedLast = callback;
                }
            },
            /**
             *
             * @returns {*}
             */
            callOnExecuted: function callOnExecuted(){
                return this.onExecuted(this.data);
            },
            /**
             *
             * @returns {*}
             */
            callOnExecutedLast: function callOnExecuted(){
                return this.onExecutedLast(this.data);
            }
        });

        return ExecutedEntry;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(914),
        __webpack_require__(917),
        __webpack_require__(889)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (Base, ExecutedEntry, constants) {
        'use strict';
        var ExecutorClient;

        /**
         * @class module.undoRedo.Executor.Client
         * @template module.undoRedo.Executor.Client
         * @lends {module.undoRedo.Executor.Client.prototype}
         * @extends {module.undoRedo.Executor.Base}
         * @constructor
         */
        ExecutorClient = Base.extend({


            type: constants.executionType.CLIENT,

            /**
             *
             * For server entries ww will execute only the last entry from set (the server will execute the intermediary
             *  entries to keep the chain complete
             *
             * @param {Array.<module.undoRedo.Entry>} items
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(items, result, hasLastEntry) {
                var
                    setPromises = [],
                    identitySets,
                    lastSet,
                    executedEntryKey;

                identitySets = this.groupEntriesByIdentity(items);
                lastSet = identitySets[identitySets.length - 1];

                executedEntryKey = lastSet.items[lastSet.items.length - 1].getKey();

                identitySets.forEach(function (identitySet) {
                    setPromises.push(function () {
                        return this.executeIdentitySet(identitySet, result, (hasLastEntry ? executedEntryKey : null));
                    }.bind(this));
                }.bind(this));

                return setPromises.reduce(Q.when, Q(true));
            },
            /**
             *
             * @param {{identity:String, items:Array.<module.undoRedo.Entry>}} identitySet
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param lastEntryKey
             */
            executeIdentitySet: function executeIdentitySet(identitySet, result, lastEntryKey) {
                var toExecute = [];

                if (identitySet.identity === null) {
                    /** for non mergeable entries execute them sequentially */
                    identitySet.items.forEach(function (entry, index, array) {
                        toExecute.push(function () {
                            return this.executeNonMergeableEntry(entry, index, array, result, lastEntryKey);
                        }.bind(this));
                    }.bind(this));
                } else {
                    /** for full snapshots:
                     *  - save current state
                     *  - move entries to the other chain (switch payload between them)
                     *  - execute last entry if requested or in REDO queue
                     */

                    var
                        entryToExecute = identitySet.items[identitySet.items.length - 1],
                        beforeExecutionState;

                    /** create snapshot of the current state */
                    toExecute.push(function () {
                        var deferred = Q.defer();
                        entryToExecute.createSnapshot()
                            .then(function (previousState) {
                                beforeExecutionState = previousState;
                                deferred.resolve(previousState);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                        return deferred.promise;
                    });

                    /** move entries to the other chain; payload will be switched by one step */
                    identitySet.items.forEach(function (entry, index, array) {
                        toExecute.push(function () {
                            var payload;
                            if (index === 0) {
                                payload = beforeExecutionState;
                            } else {
                                payload = array[index - 1].getPayload();
                            }
                            return this.history.switchChains(entry, payload);
                        }.bind(this));
                    }.bind(this));


                    // apply last entry in chain
                    toExecute.push(function (){
                        return entryToExecute.applySnapshot();
                    });

                    /** if execute entry if is in REDO or user explicitly asked for it */
                    if (entryToExecute.getType() === constants.types.REDO || entryToExecute.getKey() === lastEntryKey) {
                        toExecute.push(function(){
                            var deferred = Q.defer();
                            entryToExecute.submit()
                                .then(function (res) {
                                    var executedEntry = new ExecutedEntry();
                                    if (entryToExecute.getKey() === lastEntryKey) {
                                        executedEntry.setOnExecutedLast(entryToExecute.onExecutedLast.bind(entryToExecute));
                                        result.push(executedEntry);
                                    }
                                    deferred.resolve(res);
                                })
                                .catch(function (err) {
                                    deferred.reject(err);
                                });
                            return deferred.promise;
                        });
                    }
                }
                return toExecute.reduce(Q.when, Q(result));
            },
            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @param {Number} index
             * @param {Array.<module.undoRedo.Entry>} array
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {String=} callToExecutionKey
             * @returns {Promise|Q.promise}
             */
            executeNonMergeableEntry: function executeNonMeargeableEntry(entry, index, array, result, callToExecutionKey) {
                var steps = [], createdSnapshot;

                steps.push(function executeEntry(snapshot) {
                    var deferred = Q.defer();
                    createdSnapshot = snapshot;
                    entry.execute(entry.getKey() === callToExecutionKey && entry.getLinkedEntryId() === 0)
                        .then(function () {
                            var executedEntry = new ExecutedEntry();
                            if (callToExecutionKey === entry.getKey()) {
                                executedEntry.setOnExecutedLast(entry.onExecutedLast.bind(entry));
                            }
                            result.push(executedEntry);

                            deferred.resolve(createdSnapshot);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                    return deferred.promise;
                });

                steps.push(function syncEntry(previousState) {
                    return this.history.switchChains(entry, previousState);
                }.bind(this));

                return steps.reduce(Q.when, entry.createSnapshot());
            },

            groupEntriesByIdentity: function (chain) {
                return chain.reduce(function (previous, current) { //, index, array) {
                    var
                        lastElement = previous[previous.length - 1],

                        newSection = function (previous, current) {
                            var object = {};
                            object.identity = current.getIdentity();
                            object.items = [current];
                            previous.push(object);
                        };

                    if (!lastElement) {
                        newSection(previous, current);
                    } else {
                        if (lastElement.identity === current.getIdentity() && current.getIdentity() !== null) {
                            lastElement.items.push(current);
                            previous[previous.length - 1] = lastElement;
                        } else {
                            newSection(previous, current);
                        }
                    }

                    return previous;
                }, []);
            }
        });

        return ExecutorClient;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
        'use strict';
        var Queue;

        /**
         * @class module.undoRedo.Queue
         * @template module.undoRedo.Queue
         * @lends {module.undoRedo.Queue.prototype}
         * @constructor
         */
        Queue = Klazz.extend({

            /** @type {Array} */
            list: null,
            /** @type {Number} current execution state */
            state: null,
            /** @type {Number} locked state */
            stateLocked: 1,
            /** @type {Number} ready state */
            stateReady: 0,
            autoStart: true,
            isRunning: false,
            ignoreErrors: false,
            errors: [],

            callWhenLocked: function () {},
            callWhenReady: function () {},
            callAfterRun: function () {},

            initialize: function initialize(autoStart) {
                this.autoStart = (typeof autoStart === 'boolean') ? autoStart : true;
                this.list = [];
                this.errors = [];
                this.stateReady = 0;
                this.stateLocked = 1;
                this.state = 0;
            },

            /**
             *
             * @param {?Boolean} autoStart [default=true]
             * @returns {module.undoRedo.Queue}
             */
            setAutoStart: function setAutostart (autoStart) {
                this.autoStart = (typeof autoStart === 'boolean') ? autoStart : true;
                return this;
            },
            /**
             * will set the queue to ignore individual blocks errors if detected
             * this should not be used unless you know what you're doing
             */
            pleaseIgnoreErrors: function pleaseIgnoreErrors() {
                this.ignoreErrors = true;
            },

            /**
             *
             * @param {Function=} whenLocked called when execution is locked
             * @param {Function=} whenReady called when execution is ready
             * @param {Function=} afterRun called after execution is run and there is nothing more to run
             */
            init: function init(whenLocked, whenReady, afterRun) {

                if (typeof whenLocked === 'function') {
                    this.callWhenLocked = whenLocked;
                }
                if (typeof whenReady === 'function') {
                    this.callWhenReady = whenReady;
                }
                if (typeof afterRun === 'function') {
                    this.callAfterRun = afterRun;
                }
            },

            isReady: function isReady() {
                return this.state === this.stateReady;
            },

            lock: function lock() {
                this.state = this.stateLocked;
                return Q(this.callWhenLocked());
            },
            afterRun: function afterRun() {
                return Q(this.callAfterRun());
            },
            unlock: function unlock() {
                return Q(this.callWhenReady())
                    .then(function () {
                        this.state = this.stateReady;
                    }.bind(this));
            },

            /**
             * Alias for this.add
             *
             * @param {Function} callback
             * @param {Boolean=} autoLock [default=true]  ;
             * @returns {*}
             */
            whenReady: function whenReady(callback, autoLock) {
                return this.add(callback, autoLock);
            },

            /**
             * Adds execution items to running queue;
             * if the queue has autostart ON, it will also trigger a run
             *
             * @param {Function} callback
             * @param {Boolean=} autoLock [default=true]  ;
             */
            add: function add(callback, autoLock) {
                var lock = (typeof autoLock === 'boolean') ? autoLock : true;

                if (lock) {
                    this.list.push(
                        function () {
                            var d = Q.defer();
                            this.lock()
                                .then(function () {
                                    return Q(callback());
                                })
                                .then(this.unlock.bind(this))
                                .catch(function (error) {
                                    if (this.ignoreErrors === true) {
                                        d.resolve(error);
                                        this.errors.push(error);
                                        this.unlock.bind(this);
                                    } else {
                                        d.reject(error);
                                    }
                                }.bind(this))
                                .done(function (res) {
                                    d.resolve(res);
                                });

                            return d.promise;
                        }.bind(this)
                    );
                } else {
                    this.list.push(
                        function () {
                            return Q(callback());
                        }
                    );
                }

                if (this.autoStart === true && this.isReady() && this.isRunning === false) {
                    this.run();
                }
            },

            /**
             *
             * @param {Q.defer=} deferred
             * @returns {*}
             */
            run: function run(deferred) {
                var queue = [];
                deferred = deferred || Q.defer();

                if (this.list.length && this.isRunning === false) {
                    this.isRunning = true;
                    while (this.list.length > 0) {
                        queue.push((this.list.splice(0, 1))[0]);
                    }

                    queue.reduce(Q.when, Q(true))
                        .then(function afterRun(res) {
                            if (this.errors.length) {
                                deferred.reject(this.errors);
                                this.errors = [];
                            } else {
                                deferred.resolve(res);
                            }
                        }.bind(this))
                        .catch(function runningError(error) {
                            deferred.reject(error);
                        })
                        .done(function runDone() {
                            this.isRunning = false;
                            if (!deferred.promise.isRejected() || (deferred.promise.isRejected() && this.ignoreErrors === true)) {
                                if (this.list.length) {
                                    this.run();
                                } else {
                                    return this.afterRun();
                                }
                            } else {
                                return this.afterRun();
                            }
                        }.bind(this));
                }
                return deferred.promise;
            }
        });

        return Queue;
    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(717)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, helper) {
        'use strict';
        var
            HISTORY_URL = '/app/cms/undoredo/get-history',
            DELETE_REDO_CHAIN_URL = '/app/cms/undoredo/delete-redo-chain',
            EXECUTE_URL = '/app/cms/undoredo/execute',
            LOG_PRIVATE_MODE_URL = '/app/cms/undoredo/log-private-mode',
            RemoteRequest;
        /**
         * @class module.undoRedo.RemoteRequest
         * @template module.undoRedo.RemoteRequest
         * @lends {module.undoRedo.RemoteRequest.prototype}
         * @constructor
         */
        RemoteRequest = Klazz.extend({
            /**
             *
             * @returns {Promise|Q.promise}
             */
            loadHistory: function loadHistory() {
                var deferred = Q.defer();
                $.ajax({
                    url: HISTORY_URL,
                    data: {},
                    dataType: 'json',
                    success: function (response) {
                        if (response && response.data && response.data.undoList) {
                            deferred.resolve(response.data);
                        } else {
                            deferred.reject(response);
                        }
                    },
                    error: function (response) {
                        deferred.reject(response);
                    }
                });
                return deferred.promise;
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            deleteRedoChain: function deleteRedoChain(){
                var deferred = Q.defer();
                $.ajax({
                    url: DELETE_REDO_CHAIN_URL,
                    data: {},
                    dataType: 'json',
                    success: function (response) {
                        deferred.resolve(response);
                    },
                    error: function (response) {
                        deferred.reject(response);
                    }
                });

                return deferred.promise;
            },
            executeRemote: function executeRemote (entryId) {
                var deferred = Q.defer();

                $.ajax({
                    url: EXECUTE_URL,
                    data: {
                        entryId: entryId,
                        context: {
                            pageId: helper.getCurrentPageId()
                        }
                    },
                    dataType: 'json',
                    type:'POST',

                    success: function(response) {
                        if (response && response.data && $.isArray(response.data)) {
                            deferred.resolve(response);
                        } else {
                            deferred.reject({message:'invalid server response', data: response});
                        }
                    },
                    error: function(response) {
                        deferred.reject({message:'server error', data: response});
                    }
                });
                return deferred.promise;
            },
            logPrivateMode: function logPrivateMode() {
                $.ajax({
                    url: LOG_PRIVATE_MODE_URL,
                    type:'POST'
                });
            }
        });

        return RemoteRequest;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(3),
        __webpack_require__(889),
        __webpack_require__(717),
        __webpack_require__(500)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, constants, helper, globalEvents) {
        'use strict';
        var
            readyState = {
                READY: 1,
                DATABASE_INIT: 2,
                DEPENDENCIES: 3,
                HISTORY_INIT: 4
            },
            UndoRedo;


        /**
         * @class module.undoRedo.App
         * @template module.undoRedo.App
         * @lends {module.undoRedo.App.prototype}
         * @constructor
         */
        UndoRedo = Klazz.extend({

            readyState: 0,

            /** @type {module.undoRedo.Api} */
            api: null,
            /** @type {module.undoRedo.PouchAdapter} */
            database: null,
            /** @type {module.undoRedo.Settings} */
            settings: null,
            /** @type {module.undoRedo.History} */
            history: null,
            /** @type {module.undoRedo.SessionManager} */
            sessionManager: null,
            /** @type {module.undoRedo.Ui} */
            ui: null,
            /** @type {module.undoRedo.UiManager} */
            uiManager: null,
            /** @type {module.undoRedo.Storage} */
            storage: null,
            /** @type {module.undoRedo.FeatureSet} */
            features: null,
            /** @type {module.undoRedo.EntryFactory} */
            entryFactory: null,
            /** @type {module.undoRedo.HistoryEntry.Factory} */
            historyEntryFactory: null,
            /** @type {module.undoRedo.Executor.Main} */
            executor: null,
            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,

            browserReload: {
                requested: false,
                url: null
            },

            isReady: function () {
                return this.readyState === readyState.READY;
            },
            /**
             *
             * @param {module.undoRedo.Api} api
             * @returns {module.undoRedo.App}
             */
            setApi: function (api) {
                this.api = api;
                return this;
            },

            /**
             *
             * @param {module.undoRedo.History} history
             * @param {module.undoRedo.PouchAdapter} database
             * @param {module.undoRedo.Storage} storage
             * @param {module.undoRedo.EntryFactory} entryFactory
             * @param {module.undoRedo.Ui} ui
             * @param {module.undoRedo.UiManager} uiManager
             * @param {module.undoRedo.Executor.Main} executor
             * @param {module.undoRedo.RemoteRequest} backend
             * @param {module.undoRedo.Settings.messages} messages
             * @returns {*}
             */
            init: function (history, database, storage, entryFactory, ui, uiManager, executor, backend, messages) {
                var deferred = Q.defer(), initChain = [], ini;
                this.history = history;
                this.database = database;
                this.storage = storage;
                this.entryFactory = entryFactory;
                this.ui = ui;
                this.uiManager = uiManager;
                this.executor = executor;
                this.backend = backend;
                try {

                    ini = this.settings.getIni();

                    /** trigger refresh on ui so the toolbar will be painted in browser
                     * before the actual data loads
                     */
                    this.ui.refresh();

                    /**
                     * Attach observer on history, to trigger ui.refresh when history.chains are changed
                     */
                    this.history.attachObserver(function (history, data) {
                        this.uiManager.handle(data);
                    }.bind(this), constants.observerTopics.HISTORY_CHAIN_READY);

                    /**
                     * clean up the local database due to the fact that not all users are using
                     * the logout feature; this prevents exceeding the 5MB limit on local storage use
                     */
                    initChain.push(this.clearLocalDataOnFirstLogin.bind(this));

                    /**
                     * Composing initiation sequence
                     */
                    initChain.push(
                        /**
                         * try to open local storage database
                         */
                        function () {
                            this.readyState = readyState.DATABASE_INIT;
                            return this.database.open();
                        }.bind(this)
                    );

                    initChain.push(
                        /**
                         * inject the obtained database to the objects that needs it
                         */
                        function (database) {
                            var dependencies = Q.defer();
                            this.readyState = readyState.DEPENDENCIES;

                            if (database !== null) {
                                database.init(ini.websiteId, ini.sessionId);
                            }

                            this.storage.init(database, ini.websiteId, ini.sessionId)
                                .then(function () {
                                    this.history.setStorage(this.storage);
                                    this.sessionManager.setStorage(this.storage);

                                    dependencies.resolve(true);
                                }.bind(this))
                                .catch(function (error) {
                                    dependencies.reject(error);
                                });

                            return dependencies.promise;
                        }.bind(this)
                    );

                    initChain.push(
                        /**
                         * initialize the history chains
                         */
                        function () {
                            this.readyState = readyState.HISTORY_INIT;

                            return this.sessionManager.recoverActiveSession()
                                .then(this.history.init.bind(this.history));

                        }.bind(this)
                    );



                    initChain.reduce(Q.when, Q(null))
                        .then(function (result) {
                            this.readyState = readyState.READY;
                            /**
                             * Proxy observer events to api
                             */
                            this.history.attachObserver(function (history, data, topic) {
                                this.api.notifyObservers(topic, data, history);
                            }.bind(this), constants.observerTopics.ALL);

                            deferred.resolve(result);
                        }.bind(this))
                        .catch(function (error) {
                            /**
                             * PouchDb gives error.status = 500 when browser is in private mode
                             */
                            if (error && error.status && error.status === 500) {
                                this.ui.showErrorBox(messages.errors.privateMode);
                                this.backend.logPrivateMode();
                                error.wasHandled = true;
                            } else {
                                this.ui.showErrorBox(messages.errors.generic);
                            }
                            deferred.reject(error);
                        }.bind(this));

                } catch (error) {
                    console && console.log && console.log('caught ERROR in app init', error);
                    this.ui.showErrorBox(messages.errors.generic);
                    deferred.reject(error);
                }
                return deferred.promise;
            },
            /**
             * Closes active session, reloads data from backend
             */
            requestServerSync: function requestServerSync() {
                this.history.executeWhenReady(function () {
                    return this.history.refresh();
                }.bind(this));
            },
            /**
             * @param {boolean} noWait
             * @returns {Promise|Q.Promise}
             */
            closeActiveSession: function closeActiveSession(noWait) {
                return this.sessionManager.closeSession(this.sessionManager.getActiveSession(), noWait);
            },
            /**
             * Resets local storage on first login
             *
             * @returns {Promise|Q.Promise}
             */
            clearLocalDataOnFirstLogin: function () {
                if (helper.isJustLoggedIn()) {
                    return this.cleanUp();
                } else {
                    return Q(true);
                }
            },
            /**
             * @constructs
             * @param {module.undoRedo.Settings} settings
             * @param {module.undoRedo.FeatureSet} features
             */
            initialize: function (settings, features) {
                this.settings = settings;
                this.features = features;
            },

            /**
             *
             * @param {module.undoRedo.SessionManager} sessionManager
             * @returns {module.undoRedo.App}
             */
            setSessionManager: function setSessionManager(sessionManager) {
                this.sessionManager = sessionManager;
                return this;
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Factory} historyEntryFactory
             * @returns {module.undoRedo.App}
             */
            setHistoryEntryFactory: function setHistoryEntryFactory(historyEntryFactory) {
                this.historyEntryFactory = historyEntryFactory;
                return this;
            },

            /**
             *
             * @param sessionId
             * @returns {Promise|Q.Promise}
             * @param {boolean} noWait
             */
            deleteEntriesWithUndoSession: function deleteEntriesWithUndoSession(sessionId, noWait) {
                if (noWait === true ) {
                    return this.history.executeDeleteUndoSession(sessionId);
                }
                return this.history.deleteUndoSession(sessionId);
            },

            /**
             * Called when an error occurred
             *
             *
             * @param error
             */
            onError: function (error) {
                if (error.message && error.message === constants.executionTimeoutMessage) {
                    // we could use another message in here, but is not in the scope
                    this.ui.showErrorBox();
                } else {
                    this.ui.showErrorBox();
                }

                globalEvents.trigger('error.diy-editor', {
                    message: 'UndoRedo exception: message = ' + error.message + ', stack = ' + error.stack
                });
            },

            /**
             * Adds HistoryEntry to undo list
             *
             * @param historyEntry
             * @param undoSession
             * @param sessionIndex
             * @private
             * @returns {Promise|Q.Promise}
             */
            addClientEntry: function addClientEntry(historyEntry, undoSession, sessionIndex) {
                var sequence = Q.defer();

                this.history.executeWhenReady(function () {
                    var
                        /** @type {module.undoRedo.Entry} */
                        Entry = this.entryFactory.wrap(historyEntry);

                    Entry
                        .setUndoSessionId(undoSession)
                        .setSessionIndex(sessionIndex)
                        .setType(constants.types.UNDO)
                    ;

                    this.history.addEntry(Entry)
                        .then(function (entryKey) {
                            sequence.resolve(entryKey);
                        })
                        .catch(function (error) {
                            sequence.reject(error);
                            this.onError(error);
                        });

                    return sequence.promise;
                }.bind(this));

                return sequence.promise;
            },
            /**
             * Creates a new undo-session; undo-sessions can be used to add grouped historyEntries to undo list
             *      after the session is created it gives access to the following methods
             *          UndoSession.getId() - return the sessionId of the current undo-session
             *          UndoSession.add(HistoryEntry) - adds entry to the session
             *          @see UndoSession
             *
             * returns {Object}
             */
            /**
             *
             * @returns {{getId: Function, add: Function}}
             */
            startSession: function startSession() {
                var undoSession = this.sessionManager.openSession();
                /**
                 * @lends {module.undoRedo.Session.prototype}
                 */
                return $.extend(undoSession, {
                    /**
                     *
                     * @param {String} type
                     * @param {Object} payload
                     * @param {String} message
                     * @param {Boolean=} isExecutable
                     */
                    add: function (type, payload, message, isExecutable) {
                        var
                            entryKey = this.database.createEntryKey(),
                            sessionId = undoSession.getId(),
                            sessionIndex,
                            historyEntry;

                        sessionIndex = undoSession.undoAdd(entryKey);
                        historyEntry = this.historyEntryFactory.build(type, payload, message, sessionId, sessionIndex, isExecutable);
                        historyEntry.setKey(entryKey);

                        return this.addClientEntry(historyEntry, sessionId, sessionIndex);
                    }.bind(this)
                });
            },

            /**
             * refreshes Ui with the data chains from history lists
             */
            refreshUi: function () {
                this.uiManager.handle(this.history.chains);
            },
            /**
             * Called from controllers to notify undoRedo engine that an entry was created server side
             *
             * @returns {Promise|Q.Promise}
             */
            onNewEntryServerSide: function onNewEntryServerSide() {
                var deferred = Q.defer();

                this.history.executeWhenReady(function () {
                    var chain = [];

                    chain.push(function () {
                        return this.closeActiveSession(true);
                    }.bind(this));

                    chain.push(function () {
                        return this.history.deleteRedoChain(/** ignoreServer */ true);
                    }.bind(this));

                    chain.push(function () {
                        return this.history.populateChains();
                    }.bind(this));

                    chain.reduce(Q.when, Q(null))
                        .then(function (res) {
                            deferred.resolve(res);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                            this.onError(error);
                        }.bind(this));

                    return deferred.promise;

                }.bind(this));

                return deferred.promise;
            },
            /**
             * called from pages structure to "hide" redo entries
             * @deprecated hack :: this behaviour will be fixed with undo-redo-pages-individual-changes
             */
            hideRedoQueue: function () {
                this.ui.refresh({
                    undoList: diy.editor.undoRedo.history.chains.undoChain,
                    redoList: [],
                    lastEntry: {}
                });
            },

            /**
             * Starts execution of an entry with given entryKey
             *      called from undoRedo.ui
             *
             * @param entryKey
             * @returns {Promise|Q.Promise}
             */
            executeEntry: function (entryKey) {
                var sequence = Q.defer();

                this.history.executeWhenReady(function executeEntrySequence() {
                    var
                        entry = this.history.getEntryByKey(entryKey),
                        execution = [],
                        deferred = Q.defer();

                    if (entry !== null && entry.isExecutable()) {
                        // close current session of executes from another
                        if (entry.getUndoSessionId() !== this.sessionManager.getActiveSessionId()) {
                            execution.push(this.closeActiveSession.bind(this));
                        }
                        // execute entry
                        execution.push(function executeEntry() {
                            return this.executor.execute(entry);
                        }.bind(this));

                        execution.reduce(Q.when, Q(true).timeout(constants.executionTimeout, constants.executionTimeoutMessage))
                            .then(function (ready) {
                                deferred.resolve(ready);
                                sequence.resolve(ready);
                            })
                            .catch(function (error) {
                                deferred.reject(error);
                                this.onError(error);
                                sequence.reject(error);
                            }.bind(this));
                    } else {
                        deferred.reject('no entry with given key');
                        sequence.reject('no entry with given key');
                        this.onError('no entry with given key');
                    }
                    return deferred.promise;
                }.bind(this));

                return sequence.promise;
            },

            /**
             * called from history entries to request a page reload to a given url
             * if url is undefined a reload event for the current page will be triggered
             *
             * @param url
             */
            requestBrowserReload: function (url) {
                this.browserReload.requested = true;
                if (url === undefined) {
                    this.browserReload.url = null;
                } else {
                    this.browserReload.url = url;
                }

                this.history.executeWhenReady(function executeBrowserReload() {
                    if (this.browserReload.requested === true) {
                        helper.browserReload(this.browserReload.url, null, 100);
                    }
                }.bind(this));
            },

            /**
             *
             * @returns {Promise|Q.Promise}
             */
            cleanUp: function () {
                return this.database.cleanup();
            },
            /**
             * called from controllers to temporary disable the possibility of executing displayed history entries
             * unblock event will be automatically triggered when:
             *  - an entry is created
             *  - signalEntryCreatedOnServerSide is called
             *  - anything that calls a ui.refresh event
             *
             * unblock can be done using unblockUserInterface method
             *
             */
            blockUserInterface: function () {
                this.ui.blockUi();
            },

            /**
             * Reverse method for blockUserInterface
             *
             * @see blockUserInterface
             */
            unblockUserInterface: function () {
                this.ui.unblockUi();
            }
        });

        return UndoRedo;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(891),
        __webpack_require__(907)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (PluginRegistry, Observable) {
        'use strict';

        /**
         * @class module.undoRedo.Api
         * @template module.undoRedo.Api
         * @lends {module.undoRedo.Api.prototype}
         * @extends {module.undoRedo.Observable}
         * @constructor
         */
        var Api = Observable.extend({
            version: 2,
            /**
             * @type {module.undoRedo.App}
             */
            undoRedo: null,

            /**
             * @type {module.undoRedo.PluginRegistry}
             */
            pluginRegistry: undefined,

            /** @type {module.undoRedo.Settings} */
            settings: null,

            /** @type {module.undoRedo.FeatureSet} */
            features: null,
            /**
             * @constructor
             *
             * @param {module.undoRedo.App} undoRedo
             * @param {module.undoRedo.Settings} settings
             * @param {module.undoRedo.FeatureSet} features
             * @param {module.undoRedo.PluginRegistry} pluginRegistry
             *
             */
            initialize: function (undoRedo, settings, features, pluginRegistry) {
                this.undoRedo = undoRedo;
                this.settings = settings;
                this.features = features;
                this.pluginRegistry = pluginRegistry;
                this.observers = [];
            },

            init: function () {

            },

            /**
             *
             * @param {module.undoRedo.plugins.Base} plugin
             * @returns {module.undoRedo.Api}
             */
            registerPlugin: function (plugin) {
                this.pluginRegistry.register(plugin);
                return this;
            },

            /**
             *
             * @param {module.undoRedo.FeatureSet} featureSet
             * @returns {module.undoRedo.Api}
             */
            enablePlugins: function (featureSet) {
                this.pluginRegistry.enable(featureSet);
                this.pluginRegistry.init();
                return this;
            },

            /**
             * called from history entries to request a page reload to a given url
             * if url is undefined a reload event for the current page will be triggered
             *
             * @param {String=} url
             */
            requestBrowserReload: function (url) {
                return this.undoRedo.requestBrowserReload(url);
            },

            /**
             *
             */
            requestServerSync: function () {
                this.undoRedo.requestServerSync();
            },
            onNewEntryServerSide: function () {
                this.undoRedo.onNewEntryServerSide();
            },

            /**
             *
             * @param entryKey
             * @returns {Promise|Q.Promise}
             */
            executeEntryKey: function executeEntryKey(entryKey) {
                return this.undoRedo.executeEntry(entryKey);
            },
            /**
             *
             * @returns {{getId: Function, add: Function}}
             */
            startSession: function () {
                return this.undoRedo.startSession();
            },

            hideRedoQueue: function () {
                this.undoRedo.uiManager.handle({
                    undo: this.undoRedo.history.chains.undo,
                    redo: [],
                    last: null
                });
            },
            refreshUi: function refreshUi () {
                this.undoRedo.refreshUi();
            },

            /**
             *
             * @returns {Promise|Q.Promise}
             */
            closeActiveSession: function () {
                return this.undoRedo.closeActiveSession();
            },
            /**
             *
             * @param entryType
             * @returns {module.undoRedo.plugins.Base|null|*}
             */
            getPluginForEntryType: function getPluginForEntryType(entryType) {
                return this.pluginRegistry.getPluginFor(entryType);
            },
            onLogout: function onLogout() {
                this.undoRedo.cleanUp();
            },
            onAppReady: function () {
                this.enablePlugins(this.features);
            }
        });

        return Api;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(892),
        __webpack_require__(889),
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (PluginBase, constants, $) {
        'use strict';
        var Plugin;
        /**
         * @class module.undoRedo.plugins.Module
         * @template module.undoRedo.plugins.Module
         * @lends {module.undoRedo.plugins.Module.prototype}
         * @extends {module.undoRedo.plugins.Base}
         * @constructor
         */
        Plugin = PluginBase.extend({

            onInit: function () {
                var boundEvents = [
                    'diy-editor-module-inserted-in-page',
                    'diy-editor-module-deleted',
                    'diy-editor-module-saved'
                ].join(' ');

                $(document).bind(boundEvents, function () {
                    this.api.onNewEntryServerSide();
                }.bind(this));

                this.api.attachObserver(function (subject, data) {
                    this.repositionOverlayOnActiveModule();
                }.bind(this), constants.observerTopics.EXECUTION_FINISHED);

                this.markAsReady();
            },
            /**
             *
             * @returns {module.undoRedo.constants.historyEntry.MODULE|*}
             */
            getType: function getType() {
                return [constants.historyEntry.MODULE,constants.historyEntry.MODULE_SECTION];
            },
            repositionOverlayOnActiveModule: function onExecutionFinished(){
                var openedModule = Modul.getActiveModule();
                if (openedModule instanceof Modul) {
                    openedModule.repositionOverlay();
                }
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Module} entry
             */
            onSelect: function onSelect(entry) {
                if (mm[entry.moduleId] && mm[entry.moduleId].modul) {
                    mm[entry.moduleId].modul.toggleClass('undoRedo-highlight', true);
                }
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} entry
             */
            onDeselect: function onDeselect(entry) {
                if (mm[entry.moduleId] && mm[entry.moduleId].modul) {
                    mm[entry.moduleId].modul.toggleClass('undoRedo-highlight', false);
                }
            }
        });

        return Plugin;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(892),
        __webpack_require__(889),
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (PluginBase, constants, $) {
        'use strict';
        var Plugin;
        /**
         * @class module.undoRedo.plugins.Layout
         * @template module.undoRedo.plugins.Layout
         * @lends {module.undoRedo.plugins.Layout.prototype}
         * @extends {module.undoRedo.plugins.Base}
         * @constructor
         */
        Plugin = PluginBase.extend({
            onInit: function () {
                var boundEvents = [
                    'diy-editor-templateSwitch-finished'
                ].join(' ');

                $(document).bind(boundEvents, function () {
                    // close the current opened undo session;
                    this.api.onNewEntryServerSide();
                }.bind(this));

                this.markAsReady();
            },
            /**
             *
             * @returns {module.undoRedo.constants.historyEntry.LAYOUT|*}
             */
            getType: function getType() {
                return constants.historyEntry.LAYOUT;
            }
        });

        return Plugin;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(892),
        __webpack_require__(889),
        __webpack_require__(3)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (PluginBase, constants, $) {
        'use strict';
        var Plugin;
        /**
         * @class module.undoRedo.plugins.DESIGN
         * @template module.undoRedo.plugins.DESIGN
         * @lends {module.undoRedo.plugins.DESIGN.prototype}
         * @extends {module.undoRedo.plugins.Base}
         * @constructor
         */
        Plugin = PluginBase.extend({
            onInit: function () {
                var boundEvents = [
                    'diy-editor-designChange-finished'
                ].join(' ');

                $(document).bind(boundEvents, function () {
                    // close the current opened undo session;
                    this.api.onNewEntryServerSide();
                }.bind(this));

                this.markAsReady();
            },
            /**
             *
             * @returns {module.undoRedo.constants.historyEntry.DESIGN|*}
             */
            getType: function getType() {
                return constants.historyEntry.DESIGN;
            }
        });

        return Plugin;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 926 */
/***/ function(module, exports) {

/**
 * JS inteface for the Chat tool.
 */
window.diy = window.diy || {};
window.diy.editor = window.diy.editor || {};
window.diy.editor.chat = window.diy.editor.chat || {};
(function() {
    var initParams, initIsDone = false, sessionIsDone = false;

    // possible operator statuses //
    this.OPERATOR_STATUS_AVAILABLE = 'online';
    this.OPERATOR_STATUS_OFFLINE = 'offline';

    // Private utils //
    var createCustomEvent = function (name, params) {
        var event;
        try {
            event = new CustomEvent(name, params);
        } catch (err) { // IE and old Safari, and maybe some mobiles
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, false, false, params.detail);
        }
        return event;
    };
    var sessionInit = function (callback) {

        // don't create the session twice //
        if (sessionIsDone) {
            callback(true);
            return;
        }

        var initEvent = createCustomEvent('oneandone.inproductchat.init', {
            'detail': {
                'market': initParams['market'],
                'contractId': initParams['contractId'],
                'message': initParams['agentMessage'],
                'client': initParams['client'],
                'concern': initParams['concern'],
                'callback': function (data) {

                    // determine if initialization was successful //
                    var initStatus = false;
                    if (data && data.hasOwnProperty('result') && data.result.hasOwnProperty('status')) {
                        initStatus = data.result.status;
                    }

                    // if this succeeded then the session is ready for chatting //
                    if (initStatus) {
                        sessionIsDone = true;
                    }

                    callback(initStatus);
                }
            }
        });
        document.dispatchEvent(initEvent);
    };

    /**
     * Includes and bootstraps the 1and1 chat library.
     *
     * @param params
     * @param callback
     */
    this.init = function (params, callback) {
        var anchorElement, script;

        // don't initialize twice //
        if (initIsDone) {
            sessionInit(callback);
            return;
        }

        initParams = params;

        // initialize the 1and1 chat API //
        document.addEventListener('oneandone.inproductchat.loaded', function (evt) {
            initIsDone = true;

            sessionInit(callback);
        });
        anchorElement = document.getElementsByTagName('head')[0];
        script = document.createElement("script");
        script.src = params['url'];
        anchorElement.appendChild(script);
    };

    /**
     * Checks if any operator is available to chat.
     *
     * @param callback
     */
    this.checkAvailability = function (callback) {

        sessionInit (function (succeeded) {
            if (!succeeded) {
                callback(diy.editor.chat.OPERATOR_STATUS_OFFLINE);
                return;
            }

            var availEvent = createCustomEvent('oneandone.inproductchat.checkAvailability', {
                'detail': {
                    'callback': function (data) {
                        var availStatus = false;
                        if (data && data.hasOwnProperty('result') && data.result.hasOwnProperty('status')) {
                            availStatus = data.result.status;
                        }

                        callback((availStatus === true)
                                ? diy.editor.chat.OPERATOR_STATUS_AVAILABLE
                                : diy.editor.chat.OPERATOR_STATUS_OFFLINE
                        );
                    }
                }
            });
            document.dispatchEvent(availEvent);
        });
    };

    /**
     * Opens the chat window.
     */
    this.startChat = function () {
        sessionInit (function (succeeded) {
            if (!succeeded) {
                return;
            }

            var startEvent = createCustomEvent('oneandone.inproductchat.start', {
                'detail': {
                    'callback': function (data) {
                        var startStatus = false;
                        if (data && data.hasOwnProperty('result') && data.result.hasOwnProperty('status')) {
                            startStatus = data.result.status;
                        }
                    }
                }
            });
            document.dispatchEvent(startEvent);

            //TODO: find out if we need or not to reinit the session after starting the chat...
            //sessionIsDone = false;// discard this session as it will be consumed with the chat instance //
        });
    };

    /**
     * Combo method - combines init and start
     * @param params
     */
    this.triggerChat = function (params) {
        if (initIsDone === false) {
            this.init(
                params,
                function(succeeded) {
                    if (succeeded) {
                        diy.editor.chat.startChat();
                    }
                }
            );
        } else {
            this.startChat();
        }
    };

    return this;

}).call(diy.editor.chat);

/***/ },
/* 927 */
/***/ function(module, exports) {

/**
 * JS inteface for the Chat tool.
 */
window.diy = window.diy || {};
window.diy.editor = window.diy.editor || {};
window.diy.editor.chat = window.diy.editor.chat || {};
(function() {

    // local globals //
    var YALST_INSTALLATION_URL, YALST_SITE, YALST_DEPT, bootstrapYalst, initParams;

    /**
     * Setup initial objects needed by the yalst library and loader.
     */
    bootstrapYalst = function () {
        if (typeof LiveSupport == "undefined"){
            LiveSupport = {};
        }
        if (typeof LiveSupport.VisitorAPI == "undefined"){
            LiveSupport.VisitorAPI = {};
        }
        if (typeof LiveSupport.VisitorAPI._methodQueue == "undefined"){
            LiveSupport.VisitorAPI._methodQueue = [];
        }
        if (typeof LiveSupport.VisitorAPI.invoke === 'undefined') {
            LiveSupport.VisitorAPI.invoke = function (method, parameterArray, callback) {
                if (typeof method != "string"){
                    if (typeof callback == "function"){
                        callback(new Error("invalid argument: 1 must be string"));
                    }
                    return;
                }
                LiveSupport.VisitorAPI._methodQueue.push({
                    method: method,
                    parameters: parameterArray,
                    callback: callback
                });
            };
        }
    };

    // possible operator statuses //
    this.OPERATOR_STATUS_AVAILABLE = 'online';
    this.OPERATOR_STATUS_OFFLINE = 'offline';

    /**
     * Includes and bootstraps the yalst LiveSupport library.
     *
     * @param params
     * @param callback
     */
    this.init = function (params, callback) {
        var anchorElement, script;

        initParams = params;
        YALST_INSTALLATION_URL = params['url'];
        YALST_SITE = params['site'];
        YALST_DEPT = params['dept'];

        // setup yalst namespace //
        bootstrapYalst();

        // initialize the yalst API //
        anchorElement = document.getElementsByTagName('script')[0];
        script = document.createElement("script");
        script.src = YALST_INSTALLATION_URL + "visitor_api/v2/built/LiveSupport.js";
        script.setAttribute("data-main", YALST_INSTALLATION_URL + "visitor_api/v2/built/LiveSupportMain");
        anchorElement.parentNode.insertBefore(script, anchorElement);

        // the first method that must be called before calling any other method of the API
        // we call it through 'invoke' as the API may not have finished loading
        LiveSupport.VisitorAPI.invoke(
            'associateWithLiveSupportProduct',
            [YALST_INSTALLATION_URL, YALST_SITE],
            function() {
                // once the product is associated we must start 'controlling' //
                LiveSupport.VisitorAPI.startControlling(YALST_DEPT, null, function() {
                    if (callback && callback.call) {
                        callback(true); // the parameter is just for compatibility with the generic interface of this method //
                    }
                });
            }
        );
    };

    /**
     * Checks if any operator is available to chat.
     *
     * @param callback
     */
    this.checkAvailability = function (callback) {
        LiveSupport.VisitorAPI.getOperatorAvailability(function(operatorStatus) {
            var status;

            if (operatorStatus == LiveSupport.VisitorAPI.Availability.AVAILABLE) {
                status = diy.editor.chat.OPERATOR_STATUS_AVAILABLE;
            } else {
                status = diy.editor.chat.OPERATOR_STATUS_OFFLINE;
            }

            callback(status);
        }, YALST_DEPT);
    };

    /**
     * Opens the chat window.
     */
    this.startChat = function () {
        LiveSupport.VisitorAPI.startLiveChat(
            YALST_DEPT,
            {
                paddfields: (initParams && initParams.hasOwnProperty('agentMessage')) ? (initParams.agentMessage || '') : '',
                direct: (initParams && initParams.hasOwnProperty('direct')) ? (initParams.direct || '') : '',
                name: ''
            }
        );
    };

    /**
     * Combo method - combines init and start
     * @param params
     */
    this.triggerChat = function (params) {
        if (typeof LiveSupport === 'undefined') {
            this.init(
                params,
                function() {
                    diy.editor.chat.startChat();
                }
            );
        } else {
            this.startChat();
        }
    };

    return this;

}).call(diy.editor.chat);

/***/ },
/* 928 */
/***/ function(module, exports) {

/**
 * this script must be included when survey is enabled.
 */

window.IAS = window.IAS || {};
IAS.props = IAS.props || [];

IAS.visitor = IAS.visitor || {}; //initialisierung von visitor
IAS.visitor.data = IAS.visitor.data || {}; //initialisierung von data

IAS.props.push({
    'type': 'LAYER',
    'container': 'layer_container',
    'zone': 'diyedit_'+ (jimdoData.surveyData.countryCode=='de'?'':(jimdoData.surveyData.countryCode+'_'))+'layer',
    'refId': jimdoData.surveyData.contractIdHash,
    'context': '',
    'usessId': jimdoData.surveyData.usessionId,
});

IAS.visitor.usessId = jimdoData.surveyData.usessionId;

IAS.visitor.data.featureClass = 'DIY';
IAS.visitor.data.provisioningId = jimdoData.surveyData.provisioningId;
IAS.visitor.data.featureCreationDate = jimdoData.surveyData.createDate;
IAS.visitor.data.featureContext = jimdoData.surveyData.biTrackingContractTypeIdentifier;

(function(){
    window.OAO = window.OAO || {};
    window.OAO.q = window.OAO.q || {};
    window.OAO.q.c = window.OAO.q.c || [];
    window.OAO.q.c.push(['setMarket', jimdoData.surveyData.countryCode.toUpperCase()]);
    window.OAO.q.c.push(['setLanguage', jimdoData.surveyData.language]);

    var a = document.createElement("script");
    a.type = "text/javascript";
    a.async = true;
    a.id = "oaotag"
    a.src = jimdoData.surveyData.url;
    var b = document.getElementsByTagName("script")[0];
    b.parentNode.insertBefore(a, b);
}());

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var l10n = __webpack_require__(18);

module.exports = {
    showTabletLandscapeNotification: function () {
        var
        /* @todo add featureIds in one place */
            TABLET_LANDSCAPE_MODE_NOTIFICATION = 1608,
            messages = l10n.getMessages('tabletNotifications.landscapeMode'),
            widgetEl = $('<div />'),
            contentEl = $(
                '<div class="tablet-landscape-info-overlay"></div>' +
                '<div class="tablet-landscape-info-content cp-style">' +
                    '<div>' + messages.text + '</div>' +
                    '<button class="blue-primary">' +
                    '<span>' + messages.button.label + '</span>' +
                    '</button>' +
                '</div>'
            );

        contentEl.find('button').button({});
        contentEl.on('click', function () {
            jQuery.ajax({
                url: '/app/help/service/disable-feature/?id=' + TABLET_LANDSCAPE_MODE_NOTIFICATION
            });

            $(window).unbind('orientationchange.tabletLandscapeNotification');
            widgetEl.diy_layer('destroy');
        });

        widgetEl.diy_layer({
            contentEl: contentEl,
            cls: 'tablet-landscape-info',
            zIndex: diy.editor.getNewTopZIndex(undefined, 'blockingModals')
        }).diy_layer('show');

        $(window).on('orientationchange.tabletLandscapeNotification', function() {
            //close the keyboard
            contentEl.find('button').focus();
        });
    }
};


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

var Filemanager = __webpack_require__(931);
var fmModul = __webpack_require__(984);

var $ = __webpack_require__(3);

exports.init = function() {
    diy.core.namespace('diy.editor').Filemanager = Filemanager;

    window.onImageManagementLiveEditResourceUpdated = function() {
        if (diy.editor.filemanager) {
            diy.editor.filemanager.reload();
        }
    };

    // Live editing code support
    jQuery(window).bind('fb-flo-reload', function(ev) {
        if (!/\.css$/.test(ev.originalEvent.data.url)) {
            window.onImageManagementLiveEditResourceUpdated();
        }
    });

    $(function() {
        fmModul.init();
    });
};


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

var features = __webpack_require__(25);

__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);

__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);

__webpack_require__(965);

__webpack_require__(966);
__webpack_require__(967);
__webpack_require__(968);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
var disclaimerDialog = __webpack_require__(983);
var NotificationApi = __webpack_require__(537).default;

module.exports = function(config) {

    var app, $appEl, tpl, appName = config.appName;

    tpl = '\
        <div class="fm-dialog fm-mode-' + config.mode + '" data-fm-appname="' + appName + '" \
            ng-controller="diyfmmain" style="display: none;"\
            diyfmblockingmask="diyfmblocking"\
            diyfmdropfiles="dropFilesConfig"\
            >\
            \
            <div ng-cloak class="fm-content">\
                <div class="fm-side">\
                    <div diyfmsections="" class="fm-sections"></div>\
                    <div diyfmupload="" class="fm-upload"></div>\
                </div>\
                \
                <div class="fm-main" data-current-subsection="{{currentSubsection.getTypeName()}}">\
                    <div diyfmtoolbar="currentSubsection.getSource().getToolbarItems(currentSubsection)" class="fm-toolbar"></div>\
                    <div diyfmbreadcrumb="" class="fm-breadcrumb"></div>\
                    <div diyfmitems="" class="fm-items"></div>\
                </div>\
            </div>\
            <div ng-cloak class="fm-footer" ng-hide="config.isInManagementMode()">\
                <div data-diyfminsert=""></div>\
            </div>\
            \
            <div ng-cloak class="fm-insert-mask" ng-show="insertprogress.isShown()">\
                <div class="fm-insert-numeric-progress"><span class="ui-icon ui-icon-loading"></span>{{insertprogress.getProgressString()}}</div>\
                <div class="fm-upload-progress" \
                    diyfmprogress="insertprogress.progressConfig">\
                </div>\
            </div>\
        </div>';

    /* create the element, append it to body and create a diy_dialog with it */
    $appEl = jQuery(tpl);
    $appEl.wrap('<div class="diye"></div>').appendTo('body');
    // adapt the initial size of the window to the user's screen
    // 1056 is an optimized default width so that it will fit perfectly 5 thumbnails per row
    // 600 x 400 is the minimal acceptable size of the window, to be usable
    var dialogWidth = Math.min(1056, Math.max(600, jQuery(window).width() - 100));
    var dialogHeight = Math.min(661, Math.max(400, jQuery(window).height() - 100));

    $appEl.diy_dialog({
        title: jimdoData.messages.filemanager.dialog.title,
        width: dialogWidth,
        height: dialogHeight,
        dialogClass: 'fm-dialog-frame',
        closeButton: true,
        closeOnEscape: false,
        helpButton: true,
        helpTopic: 'settings_images_cip',
        resizable: false,
        secondaryHelpTopic: (config.mode == 'selection')?'cip':null,
        secondaryHelpClass: 'feature-guidance-help-button',
        modal: true,
        zIndex: 111112,
        overlayCls: 'filemanager-overlay-cover-all',
        beforeClose: function(ev, ui) {
            var status = getStatus();

            if (status.indexOf('upload') > -1) {
                // for reasons unknown to me, this must be put in a setTimeout, otherwise it will close instantly!
                setTimeout(function() {
                    getInjector().get('diyfmmessages').showMessage({
                        title: jimdoData.messages.filemanager.close.upload.title,
                        content: jimdoData.messages.filemanager.close.upload.message,
                        ok: jimdoData.messages.filemanager.close.upload.wait
                    });
                }, 1);
                return false;
            }

            if (status.indexOf('insert') > -1) {
                // for reasons unknown to me, this must be put in a setTimeout, otherwise it will close instantly!
                setTimeout(function() {
                    getInjector().get('diyfmmessages').showMessage({
                        title: jimdoData.messages.filemanager.close.insert.title,
                        content: jimdoData.messages.filemanager.close.insert.message,
                        ok: jimdoData.messages.filemanager.close.upload.wait
                    });
                }, 1);
                return false;
            }

            return true;
        },
        close: function(ev, ui) {
            destroy();
            jQuery(document).trigger('diy-editor-filemanager-closed');
        }
    });

    jQuery(document).trigger('diy-editor-filemanager-opened');

    // initialize help link
    cms.help.GuidedAssistant._instance._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);

    /* create angular app and add directives and factories to it */
    app = angular.module(appName, ['ngResource', 'ngSanitize']);

    app.config(["$httpProvider", function($httpProvider) {
        $httpProvider.defaults.headers.common['X-DiyCSRFToken'] = jimdoData.cstok;
        // this header is essential in session expiration handling
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        // error handling
        $httpProvider.interceptors.push(['$q', 'diyfmmessages', function($q, diyfmmessages) {
            return {
                responseError: function(reason) {
                    var urlRequested = reason.config.url;
                    /* we should only catch a rest error */
                    if (urlRequested.indexOf('rest/websites/') > -1) {
                        diyfmmessages.handleGenericError();
                    }

                    return $q.reject('error');
                }
            };
        }]);

        /**
         * this assures that the angular app will route all error $http's through session expiry js check
         */
        $httpProvider.interceptors.push(diy.editor.session.angularHandleExpired);
    }]);

    // this will make available to dinamically register directives
    // even after app bootstrap
    app.config(['$compileProvider', function($compileProvider)
    {
        app.compileProvider = $compileProvider;
    }]);

    app.constant('diyfmconstkeyvisual', 'keyvisuals');
    app.constant('diyfmconstcms', 'cms');
    app.constant('diyfmconstbigstock', 'bigstock');
    app.constant('diyfmconst123rf', '123rf');
    app.constant('diyfmconstbigstockpurchased', 'bigstockpurchased');
    app.constant('diyfmconstpattern', 'patterns');
    app.constant('diyfmconststorage', 'storage');

    diy.angular.loadControllers(app, [
        'diyfmmain'
    ]);

    diy.angular.loadConstants(app, [
        'diywebsiteid'
    ]);

    diy.angular.loadFactories(app, [
        'diyl10n',
        'diyinfo',
        'diyfeatures',
        'diyglobalevents',
        'diyappevents',
        'diyanimationframe',
        'diysqueezebox',
        'diyfiledownload',
        'diyfilevalidator',
        'diyfmsectionsdata',
        'diyfmfolders',
        'diyfmsubsectionmodel',
        'diyfmfoldermodel',
        'diyfmitemmodel',
        'diyfmfileitemmodel',
        'diyfmsectionmodel',
        'diyfmsectionstorage',
        'diyfmsectioncompany',
        'diyfmsectionbigstock',
        'diyfmsection123rf',
        'diyfmuploadqueue',
        'diyimageresize',
        'diyfmallimagesmodel',
        'diyfmunsortedmodel',
        'diyfmconfig',
        'diyfmselectiondata',
        'diyfilename',
        'diyfminsertprogress',
        'diyfmmessages',
        'diyfmstatus',
        'diyfmblocking',
        'diyfmtracking',
        'diyfmsourcestorage',
        'diyfmsourcekeyvisuals',
        'diyfmsourcepatterns',
        'diyfmsourcecms',
        'diyfmsourcebigstock',
        'diyfmsource123rf',
    ]);

    diy.angular.loadFilters(app, [

    ]);

    diy.angular.loadDirectives(app, [
        'diybutton',
        'diysearchbox',
        'diycombobox',
        'diyfmthumbnail',
        'diyfmtoolbarsearch',
        'diyfmtoolbarselectall',
        'diyfmtoolbar',
        'diyfmbreadcrumb',
        'diyfmitems',
        'diyfmsections',
        'diyfmsection',
        'diyfmmenu',
        'diyfmupload',
        'diyfmprogress',
        'diyfminsert',
        'diyfmpreview',
        'diyfminlineedit',
        'diyfmdropfiles',
        'diyfmblockingmask',
        'diyfmcolorsfilter'
    ]);

    /* send configuration options */
    app.run(['diyfmconfig', function(diyfmconfig) {
        diyfmconfig.setConfig(config);
    }]);

    var showDisclaimer = function () {
        jQuery(document).trigger(
            "diy-editor-generic-linkInteraction",
            {
                pageName: "cipDisclaimer",
                actionName: "openCipDisclaimer"
            }
        );
        var agreeAction = function() {
            jQuery(document).trigger(
                "diy-editor-generic-linkInteraction",
                {
                    pageName: "cipDisclaimer",
                    actionName: "agreeCipDisclaimer"
                }
            );
            features.enableFeature('cipDisclaimer').then(function(){
                disclaimerDialog.closeDialog();
                bootstrap();
                diy.editor.featureGuidance.show('cip', true);
            });
        };
        var cancelAction = function() {
            jQuery(document).trigger(
                "diy-editor-generic-linkInteraction",
                {
                    pageName: "cipDisclaimer",
                    actionName: "cancelCipDisclaimer"
                }
            );
            destroyDialog();
            disclaimerDialog.closeDialog();
            if (features("notificationsNG")) {
                NotificationApi.schedule(function(){
                    NotificationApi.resume();
                });
            }
        };

        if (features("notificationsNG")) {
            NotificationApi.schedule(function(){
                NotificationApi.pause().then(function(){
                    disclaimerDialog.showDialog(agreeAction, cancelAction);
                });
            });
        } else {
            disclaimerDialog.showDialog(agreeAction, cancelAction);
        }
    };

    var bootstrap = function() {
        /* bootstrap app */
        angular.bootstrap($appEl[0], [appName]);

        jQuery(window).bind('beforeunload.' + appName, function(ev) {
            return jimdoData.messages.filemanager.navigateaway[getStatus()[0]];
        });
    };

    // if we need a migration
    if (jimdoData.features.images_to_storage_migration_needed) {
        // call the migrate action
        $appEl.loadingBox({useOverlay: true, loadingText: jimdoData.messages.filemanager.migrateFirstTime}).show();
        jQuery.ajax({
            url: '/app/cms/migration/migrate-existing-images-to-storage/',
            method: 'GET',
            complete: function() {
                // if completed, no matter the result, open bootstrap the app
                bootstrap();
                // and set the js flag to 0, so it won't migrate again when opened in the same session
                // (on the server-side, flag removal is handled by the migrate action)
                jimdoData.features.images_to_storage_migration_needed = 0;
                $appEl.loadingBox().remove();
            }
        })
    } else if (!features.getPayload('cipDisclaimer')['acknowleged_at'] && jimdoData.market !== 'pl_PL') {
        showDisclaimer();
    } else {
        // if no migration needed, just bootstrap directly
        bootstrap();
    }

    /* convenience method to get the scope */
    var getScope = function() {
        return angular.element($appEl[0]).scope();
    };

    var reload = function() {
        var oldConfig = angular.copy(angular.injector([appName]).invoke(function(diyfmconfig) { return diyfmconfig.getConfig(); }));
        /* destroy current app and bootstrap a new one */
        destroy();
        diy.editor.filemanager = new diy.editor.Filemanager(oldConfig);
    };

    var destroy = function() {
        angular.element($appEl).scope().$broadcast('$destroy');
        destroyDialog();
    };

    var destroyDialog = function() {
        $appEl.diy_dialog('destroy');
        $appEl.empty();
        $appEl.remove();
        jQuery(window).unbind('.' + appName);
    };

    var getInjector = function() {
        var injector = angular.element($appEl[0]).injector();
        return injector;
    };

    var getStatus = function() {
        var injector = getInjector();
        var status = injector.get('diyfmstatus').getCurrentStatus();
        return status;
    };

    var close = function() {
        $appEl.diy_dialog('close');
    };

    var getConstant = function(constantName) {
        var returnFn = new Function(constantName, 'return ' + constantName + ';');
        return angular.injector([appName]).invoke(returnFn);
    };

    jQuery(document).trigger('diy-editor-generic-sectionAccessed', {
        'sectionCodeName': 'fileManager',
        'propName': config.mode
    });

    /* expose public methods */
    return angular.extend(this, {
        getScope: getScope,
        close: close,
        reload: reload,
        getStatus: getStatus,
        getInjector: getInjector,
        getConstant: getConstant
    });
};


/***/ },
/* 932 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyimageresize', ['$q', function($q) {
    return {
        /**
         * promise based, gets an image based on a file object
         * @param file a File object that should contain an image
         * @returns {promise|a.fn.promise|Q.promise|.n.promise}
         */
        getImageByFile: function(file) {
            var deferred = $q.defer();

            /* for large images loading may same even some
             seconds, this is why we "delay" this */
            setTimeout(function() {
                var fileReader = new FileReader();

                /* on success */
                fileReader.addEventListener('load', function(evt) {
                    var dataUrl = evt.target.result;

                    /* create an image and load it with the dataUrl */
                    var img = document.createElement('img');
                    img.addEventListener('load', function(ev) {
                        deferred.resolve(img);
                    });
                    img.addEventListener('error', function(ev) {
                        deferred.reject();
                    });

                    /* set the dataUrl to the image src */
                    img.src = dataUrl;
                });

                /* when aborted or when an error occurred */
                fileReader.addEventListener('abort', function(evt) {
                    deferred.reject();
                });

                fileReader.addEventListener('error', function(evt) {
                    deferred.reject();
                });

                /* read the file into a data url */
                fileReader.readAsDataURL(file);
            }, 0);

            return deferred.promise;
        },
        /**
         * resize an image client-side
         * @param img the image object
         * @param maxWidth
         * @param maxHeight
         * @returns {string} dataurl src
         */
        resize: function(img, maxWidth, maxHeight) {
            var canvas = document.createElement('canvas');

            var aspectRatio = img.naturalWidth / img.naturalHeight;

            if (aspectRatio > 1) {
                canvas.width = maxWidth;
                canvas.height = maxWidth / aspectRatio;
            } else {
                canvas.height = maxHeight;
                canvas.width = maxHeight * aspectRatio;
            }

            canvas.getContext('2d').drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, canvas.width, canvas.height);
            var thumbStr = canvas.toDataURL();

            img = null;
            canvas = null;

            return thumbStr;
        }
    };
}]);

/***/ },
/* 933 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyanimationframe', [function() {

    return function(duration, progressClb, finalClb) {
        var start = null, id, canceled = false;
        function step(timestamp) {
            if (canceled) {
                return;
            }
            var progress;
            if (start === null) start = timestamp;
            progress = Math.min(1, (timestamp - start) / duration);
            progressClb(progress);
            if (progress < 1) {
                id = requestAnimationFrame(step);
            } else {
                finalClb();
            }
        }
        id = requestAnimationFrame(step);
        return function(){
            canceled = true;
        }
    };
}]);

/***/ },
/* 934 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfilename', [function() {

    /**
     * takes a filename as a parameter, returns it as an object containing
     *  {
     *      name: filename
     *      extension: .jpg (or empty string if no extension)
     *  }
     * @param fileName the filename
     * @returns {{name: *, extension: *}}
     */
    var parse = function(fileName) {
        var extensionRegex = /\.[a-zA-Z0-9]{1,5}$/;
        /* check if this file has an extension and store it */
        var extension = fileName.match(extensionRegex);
        /* if it does, remove it from the file name */
        if (Array.isArray(extension) && extension.length > 0) {
            fileName = fileName.replace(extensionRegex, '');
        }
        return {
            name: fileName,
            extension: (Array.isArray(extension) && extension.length > 0) ? extension[0] : ''
        };
    };

    /**
     * takes a filename object containing name and extension as keys
     * and returns a concatenated filename based on the two keys
     * while performing some slight adjustments
     *
     * stringify({name: 'asdf.jpg', extension: '.jpg'}) => asdf.jpg
     * stringify({name: 'asdf.jpg', extension: '.png'}) => asdf.png
     * stringify({name: 'asdf', extension: '.gif'}) => asdf.gif
     *
     * @param fileNameObject the key-value name and extension object
     * @returns {string}
     */
    var stringify = function(fileNameObject) {
        var result = '';

        /* parse the name, as the user may have put an extension inside the name */
        var nameobject = parse(fileNameObject.name);
        /* if he did, use only the name, not the extension */
        if (nameobject.extension) {
            result+= nameobject.name;
        } else {
            result+= fileNameObject.name;
        }
        /* append extension, if any */
        if (fileNameObject.extension) {
            result+= fileNameObject.extension;
        }

        return result;
    };

    return {
        parse: parse,
        stringify: stringify
    };
}]);

/***/ },
/* 935 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfilevalidator', ['$q', 'diyl10n', 'diyfilename', 'diyimageresize', function($q, diyl10n, diyfilename, diyimageresize) {
    var roundTo = function(num) {
        return Math.round(num * 100) / 100;
    };

    var REQUEST_ENTITY_TOO_LARGE = 413,
        UNSUPPORTED_MEDIA_TYPE = 415,
        UNPROCESSABLE_ENTITY = 422,
        FILE_EMPTY = 469;

    return {
        getMessageByHttpErrorCode: function(httpErrorCode) {
            var mapping = {};
            mapping[REQUEST_ENTITY_TOO_LARGE] = diyl10n('diyfilevalidator.maxSize');
            mapping[UNSUPPORTED_MEDIA_TYPE] = diyl10n('diyfilevalidator.type');
            mapping[UNPROCESSABLE_ENTITY] = diyl10n('diyfilevalidator.corrupt');
            mapping[FILE_EMPTY] = diyl10n('diyfilevalidator.fileEmpty');
            return mapping[httpErrorCode];
        },
        // not yet used
        validateDimension: function(file, validationRules) {
            var deferred = $q.defer();

            if ('maxWidth' in validationRules && 'maxHeight' in validationRules) {
                diyimageresize.getImageByFile(file).then(function(img) {
                    var w = img.naturalWidth;
                    var h = img.naturalHeight;

                    if (
                        ('maxWidth' in validationRules && validationRules['maxWidth'] < w)
                            || ('maxHeight' in validationRules && validationRules['maxHeight'] < h)
                        ) {
                        deferred.reject({file: file, message: diyl10n('diyfilevalidator.maxDimensions').format({
                            width: w,
                            height: h,
                            maxWidth: validationRules['maxWidth'],
                            maxHeight: validationRules['maxHeight']
                        })});
                    } else {
                        deferred.resolve(file);
                    }
                }, function(errors) {
                    deferred.reject({file: file, message: diyl10n('diyfilevalidator.corrupt')});
                });
            } else {
                // if no dimension check is needed and we reached here, it's ok
                deferred.resolve(file);
            }

            return deferred.promise;
        },
        validate: function(file, validationRules) {
            // general validation, prevent empty files
            if (file.size === 0) {
                return {file: file, error: {code: FILE_EMPTY, message: this.getMessageByHttpErrorCode(FILE_EMPTY)}};
            }
            
            if ('maxSize' in validationRules) {
                if (validationRules['maxSize'] < file.size) {
                    return {file: file, error: {code: REQUEST_ENTITY_TOO_LARGE, message: this.getMessageByHttpErrorCode(REQUEST_ENTITY_TOO_LARGE).format({
                        size: roundTo(file.size / (1024 * 1024)),
                        maxSize: roundTo(validationRules['maxSize']  / (1024 * 1024))
                    })}};
                }
            }
            if ('type' in validationRules) {
                var fileObj = diyfilename.parse(file.name);
                if (validationRules['type'].indexOf(fileObj.extension.toLowerCase()) === -1) {
                    return {file: file, error: {code: UNSUPPORTED_MEDIA_TYPE, message: this.getMessageByHttpErrorCode(UNSUPPORTED_MEDIA_TYPE).format({
                        allowedTypes: validationRules['type'].join(", ")
                    })}};
                }
            }
            return true;
        }
    };
}]);

/***/ },
/* 936 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsectionsdata', 
['$injector', 'diyfmconfig', 'diyfmtracking', 'diyfmselectiondata', 'diysqueezebox',
function($injector, diyfmconfig, diyfmtracking, diyfmselectiondata, diysqueezebox) {

    var sections = [], sectionModels = [];
        
    var sourceNames = diyfmconfig.getSources(), sources = [];
    
    sourceNames.forEach(function(sourceName){
        var 
            source = $injector.get('diyfmsource' + sourceName),
            sectionModel = source.getSectionModel()
        ;
        sources.push(source);
        if (sectionModels.indexOf(sectionModel) === -1) {
            sectionModels.push(sectionModel);
        }
    });
    
    // sort sections
    sectionModels.sort(function compare(a, b) {
        return a.getOrder() - b.getOrder();
    });
    
    // add sections
    sectionModels.forEach(function(sectionModel){
        var section = new sectionModel();
        section.initializeSubsections(sources);
        // it may have no subsections if it is not available for the tariff
        if (section.getSubsections().length > 0) {
            sections.push(section);
        }
    });
    
    var startSubSection = null;
    var configSubSection = diyfmconfig.getConfig()['subSection'];

    if (configSubSection) {
        sections.forEach(function(section) {
            var results = section.getSubsections().filter(function(subsection) {
                return subsection.getTypeName() == configSubSection;
            });

            if (results.length) {
                startSubSection = results[0];
            }
        });
    }

    if (!startSubSection) {
        startSubSection = sections[0].getSubsections()[0];
    }

    var setCurrentSubsection = function(subsection) {
        // we reset the search on currentSubsection and not on subsection
        // (that will became new currentSubsection), because this way we make
        // application feel faster - if user came back later to the
        // old subsection, search is already reset and items reloaded, no waiting
        if (currentSubsection) {
            currentSubsection.resetSearch();
        }
        var source = subsection.getSource();
        if (typeof source.beforeSubsectionShow === 'function') {
            source.beforeSubsectionShow(subsection);
        }
        currentSubsection = subsection;
        diyfmselectiondata.removeAllItems(['select']);
        diyfmtracking.track('subsectionChange', {subsection: currentSubsection});
    };
    
    var setCurrentSection = function(section) {
        currentSection = section;
        setCurrentSubsection(section.getSubsections()[0]);
    };

    /* set the current subsection to be the first one */
    var currentSubsection;
    setCurrentSubsection(startSubSection);

    var getCurrentSubsection = function() {
        return currentSubsection;
    };

    var getDefaultUploadSubsection = function() {
        var targetSourceName = diyfmconfig.getDefaultUploadTarget();
        var targetSource =  $injector.get('diyfmsource' + targetSourceName);
        var targetSectionModel = targetSource.getSectionModel();
        for(var i = 0; i < sections.length; i++) {
            if (sections[i] instanceof targetSectionModel) {
                return sections[i].getDefaultUploadSubsection();
            }
        }
    };

    var getCurrentSection = function() {
        return currentSubsection.getSection();
    };

    var getSections = function() {
        return sections;
    };

    var generateUniqueSubsectionName = function(newValue, subsection, defaultPrefix) {

        var copyRegex = /\s-\s([0-9]+)$/;
        var copyReplaceRegex = /([0-9]+)$/;

        /* if folder name is empty, start from the New folder initial text */
        if (!newValue || (typeof newValue === 'string' && newValue.trim() === '')) {
            return generateUniqueSubsectionName(defaultPrefix, subsection);
        }
        /* check if name already exists */
        for (var i = 0; i < sections.length; i++) {
            var subsections = sections[i].getSubsections();
            for (var j = 0; j < subsections.length; j++) {
                /* if name already exists */
                if (newValue == subsections[j].getTitle() && subsection !== subsections[j]) {
                    /* if already a numbered copy, increase the number */
                    if (copyRegex.test(newValue)) {
                        return generateUniqueSubsectionName(newValue.replace(copyReplaceRegex, function(m, n) { return parseInt(n, 10) + 1 }), subsection);
                    } else {
                        /* if not yet, just add -1 at the end */
                        return generateUniqueSubsectionName(newValue + " - 1", subsection);
                    }
                }
            }
        }

        return newValue;
    };

    var removeSubsection = function(subsection) {
        for (var i = 0; i < sections.length; i++) {
            var subsections = sections[i].getSubsections();
            for (var j = 0; j < subsections.length; j++) {
                if (subsections[j] === subsection) {
                    /* change subsection to the previous one */
                    var changeToPreviousSection = false;
                    if (subsections[j] === getCurrentSubsection()) {
                        changeToPreviousSection = true;
                    }
                    /* remove the section */
                    subsections.splice(j, 1);

                    if (changeToPreviousSection) {
                        setCurrentSubsection(subsections[Math.max(j - 1, 0)]);
                    }
                    // TODO move this to a directive
                    diysqueezebox.refresh(jQuery('.fm-folders-list'));
                    return;
                }
            }
        }
    };

    /* make these methods public */
    return {
        setCurrentSubsection: setCurrentSubsection,
        getCurrentSubsection: getCurrentSubsection,
        setCurrentSection: setCurrentSection,
        getCurrentSection: getCurrentSection,
        getSections: getSections,
        generateUniqueSubsectionName: generateUniqueSubsectionName,
        removeSubsection: removeSubsection,
        getDefaultUploadSubsection: getDefaultUploadSubsection
    };
}]);








/***/ },
/* 937 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmfolders', ['$resource', 'diywebsiteid', function($resource, diywebsiteid) {
    return $resource('/rest/websites/' + diywebsiteid + '/storage-folders/:id', {
            id: '@id'
         }, {
            'create':   {method:'POST'},
            'update': {method: 'PUT'}
        }
    );
}]);

/***/ },
/* 938 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmuploadqueue', ['$q', function($q) {

    var queues = {};
    
    function UploadQueueItem(itemConfig, addDefer) {
        var 
            xhr,
            uploadDefer,
            finished = false,
            inProgress = false,
            progress,
            config = angular.extend({
                method: 'POST',
                data: null,
                dataParamName: 'data',
                fileParamName: 'file'
            }, itemConfig);
        ;
        
        var getConfig = function() {
            return itemConfig;
        };
        var getSize = function() {
            return config.file.size;
        };
        
        var isInProgress = function() {
            return inProgress;
        };
        
        var isFinished = function() {
            return finished;
        };
        
        var upload = function() {
            /* perform upload */
            inProgress = true;
            uploadDefer = $q.defer();
            
            var prevLoadedBytes = 0;
            
            xhr = new XMLHttpRequest();
            
            /* register progress event */
            xhr.upload.addEventListener("progress", function(e) {
                uploadDefer.notify(e.loaded - prevLoadedBytes);
                progress = e.loaded / e.total;
                // XXX we deliberately lower the progress
                // because between the event when progress = 1 and load event
                // there is a waiting time from the server to respond
                progress = progress * .75;
                addDefer.notify(progress);
                prevLoadedBytes = e.loaded;
            });
            /* register successful event */
            xhr.addEventListener("load", function(e) {
                inProgress = false;
                finished = true;
                // if we received a success http return code
                if (e.target.status >= 200 && e.target.status < 300) {
                    // XXX force a full progress here
                    addDefer.notify(1);
                    addDefer.resolve(this.responseText);
                    // we need to put uploadDefer later than addDefer, 
                    // otherwise that when all in the queue are uploaded
                    // upload complete will trigger even if addition is not
                    // annouced yet and resource may not be created properly
                    uploadDefer.resolve();
                } else { // if we received an error http code
                    addDefer.reject({code: e.target.status, message: e.target.responseText});
                    uploadDefer.reject({code: e.target.status});
                }
            });
            /* register error event */
            xhr.addEventListener("error", function(e) {
                inProgress = false;
                finished = true;
                uploadDefer.reject();
                addDefer.reject();
            });
            
            xhr.addEventListener("abort", function(e) {
                inProgress = false;
                finished = true;
                uploadDefer.reject('cancel');
                addDefer.reject('cancel');
            });
            
            var formData = new FormData();
            
            if (config.data) {
                formData.append(config.dataParamName, angular.toJson(config.data));
            }
            formData.append(config.fileParamName, config.file);
            
            xhr.open(config.method, config.url, true);
            xhr.setRequestHeader('X-DiyCSRFToken', jimdoData.cstok);
            xhr.send(formData);
            
            /* send an initial progress event with 0 */
            addDefer.notify(0);
            
            return uploadDefer.promise;
        };
        
        var cancel = function() {
            if (isInProgress()) {
                // XXX Canceling an inprogress request 
                // is not reliable, because server still will process
                // the request and then we will be inconsistent on client side
                //xhr && xhr.abort();
            } else if (!isFinished()) {
                addDefer.reject('cancel');
            }
        };
        
        return angular.extend(this, {
            getConfig: getConfig,
            getSize: getSize,
            isInProgress: isInProgress,
            isFinished: isFinished,
            upload: upload,
            cancel: cancel
        });
    };
    
    function UploadQueue() {
        // TODO make this configurable
        // If this is bigger than 1, we cannot guarantee
        // that on the server files will be processed in the
        // same order, so for now we should keep it at 1
        var MAX_PARALLEL = 1;
        var
            items,
            totalUploaded,
            totalSize,
            queueDefer
        ;
            
        var initQueue = function() {
            items = [];
            totalUploaded = 0;
            totalSize = 0;
            // we should renew the defer, because
            // after resolve() or reject() it will not notify anymore
            queueDefer = $q.defer();
        };
        initQueue();
        
        var add = function(itemConfig) {
            
            var addDefer = $q.defer();
            // validation
            if (!(itemConfig.file instanceof File)) {
                throw 'No file defined';
            }
            
            var item = new UploadQueueItem(itemConfig, addDefer);
            items.push(item);
            totalSize += item.getSize();
            
            return addDefer.promise;
        };
        
        var remove = function(itemConfig) {
            var item;
            for (var i = 0, l = items.length; i < l; i++) {
                item = items[i];
                if (itemConfig === item.getConfig()) {
                    if (item.isInProgress()) {
                        totalUploaded -= item.getUploaded();
                        item.cancel();
                    }
                    totalSize -= item.getSize();
                    queueDefer.notify(totalUploaded / totalSize);
                    item = null;
                    items.splice(i, 1);
                }
            }
        };
        // Cancel all not finished  
        var cancel = function() {
            for (var i = 0, l = items.length; i < l; i++) {
                if (!items[i].isFinished()) {
                    items[i].cancel();
                }
            }
            queueDefer.reject('cancel');
            initQueue();
        };
        
        var start = function() {
            queueDefer.notify(totalUploaded / totalSize); // initial notification with 0
            startNext();
        };
        
        var startNext = function() {
            var item, inProgressCount = getInProgressCount(), finishedCount = 0;
            if (inProgressCount < MAX_PARALLEL) {
                for (var i = 0; i < items.length; i++) {
                    item = items[i];
                    if (item.isFinished()) {
                        finishedCount++;
                    } else {
                        if (!item.isInProgress()) {
                            item.upload().then(function(){
                                startNext();
                            }, function() {
                                startNext();
                            }, function(delta) {
                                var progress;
                                totalUploaded += delta;
                                progress = totalUploaded / totalSize;
                                // XXX we deliberately lower the progress
                                // because between the event when progress = 1 and load event
                                // there is a waiting time from the server to respond
                                progress = progress * .85;
                                queueDefer.notify(progress);
                            });
                            inProgressCount++;
                            if (inProgressCount === MAX_PARALLEL) {
                                break;
                            }
                        }
                    }
                }
            }
            if (finishedCount === items.length) {
                // XXX force a full progress notification
                queueDefer.notify(1);
                queueDefer.resolve(items);
                initQueue();
            }

            return true;
        };

        var getInProgressCount = function() {
            var howMany = 0;
            for (var i = 0; i < items.length; i++) {
                if (items[i].isInProgress()) {
                    howMany++;
                }
            }
            return howMany;
        };
        
        var getProgress = function() {
            return totalUploaded / totalSize;
        }
        
        var getPromise = function() {
            return queueDefer.promise;
        }

        return {
            add: add,
            remove: remove,
            start: start,
            cancel: cancel,
            getPromise: getPromise,
            getProgress: getProgress,
            getInProgressCount: getInProgressCount
        }
    };

    
    return {
        get: function(queueName) {
            if (!queues[queueName]) {
                queues[queueName] = new UploadQueue();
            }
            return queues[queueName];
        }
    };

}]);







/***/ },
/* 939 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmconfig', [function() {
    var 
        defaultConfig = {
            appName: 'filemanager',
            mode: 'management',
            maxSelection: 1,
            alreadyExisting: 0,
            shouldShowFileNames: false,
            sources: {},
            callback: function(){},
            defaultUploadTarget: 'storage',
            imageAspectRatio: 4/3,
            thumbWidth: 120,
            previewWidth: 600
        }
        config = angular.copy(defaultConfig)
    ;

    var setConfig = function(newConfig) {
        config = angular.extend(defaultConfig, newConfig);
    };

    var getConfig = function() {
        if (!config) {
            throw new Error('Config unset');
        }
        return config;
    };
    
    var getAppName = function() {
        return config.appName;
    };

    var isInManagementMode = function() {
        return config.mode === 'management';
    };

    var getMaxSelection = function() {
        return config.maxSelection;
    };

    var getAlreadyExisting = function() {
        return config.alreadyExisting;
    };

    var getSources = function() {
        var sources = [];
        for(var s in config.sources) {
            if (config.sources.hasOwnProperty(s) && config.sources[s] !== false) {
                sources.push(s);
            }
        }
        return sources;
    };
    
    var getSourceCallback = function(sourceName) {
        if (config.sources[sourceName]) {
            if(typeof config.sources[sourceName] === 'function') {
                return config.sources[sourceName];
            } else if (typeof config.sources[sourceName].callback === 'function') {
                return config.sources[sourceName].callback;
            }
        }
    };
    
    var getSourceBatchSize = function(sourceName) {
        if (config.sources[sourceName]
            && typeof config.sources[sourceName].batchSize !== 'undefined'
        ) {
            return config.sources[sourceName].batchSize;
        }
    };
    
    var getSourceSetting = function(sourceName, settingName) {
        if (config.sources[sourceName]
            && typeof config.sources[sourceName][settingName] !== 'undefined'
        ) {
            return config.sources[sourceName][settingName];
        }
    };
    
    var getCallback = function() {
        if(typeof config.callback === 'function') {
            return config.callback;
        }
    };

    var shouldShowFileNames = function() {
        return config.shouldShowFileNames;
    };
    
    var getDefaultUploadTarget = function() {
        return config.defaultUploadTarget;
    };
    
    var getPreviewSize = function() {
        return {
            width: config.previewWidth,
            height: config.previewWidth / config.imageAspectRatio
        }
    };
    
    var getThumbSize = function() {
        return {
            width: config.thumbWidth,
            height: config.thumbWidth / config.imageAspectRatio
        }
    };

    return {
        setConfig: setConfig,
        getConfig: getConfig,
        
        getAppName: getAppName,
        getSources: getSources,
        getSourceCallback: getSourceCallback,
        getSourceBatchSize: getSourceBatchSize,
        getSourceSetting: getSourceSetting,
        getCallback: getCallback,

        isInManagementMode: isInManagementMode,
        getMaxSelection: getMaxSelection,
        getAlreadyExisting: getAlreadyExisting,
        shouldShowFileNames: shouldShowFileNames,
        getDefaultUploadTarget: getDefaultUploadTarget,
        getThumbSize: getThumbSize,
        getPreviewSize: getPreviewSize
    };
}]);

/***/ },
/* 940 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmselectiondata', ['diyfmconfig', function(diyfmconfig) {

    /**
     * This number is increased any time anything related to a
     * selection/insertion happens.
     * This is watched over so we can easily update the selection
     * in the UI only if the selection object has changed
     * @type {number}
     */
    var selectionStateNumber = 0;

    /*
     * We use the an items array to keep the items,
     * and on the same position on the itemsHash we find the item's hash
     * The reason for this is that checking the reference is not enough
     * since we are interested in finding an image by it's hash
     * (id + other properties).
     * Searching will be done on the selectedItemsHash, but the item used
     * will be from the selectedItems array. This is more an optimization,
     * since native methods like indexOf on arrays are faster than
     * interating and comparing, especially in a digest cycle
     */
    var insertedItems = [],
        insertedItemsHash = [],
        selectedItems = [],
        selectedItemsHash = [];

    /**
     * Add an item to the selection/insertion
     * @param item
     * @param types example ['select', 'insert']
     * @param index (optional) at what index to add, default add to the end
     */
    var addItem = function(item, types, index) {
        if (!Array.isArray(types)) {
            throw new Error();
        }

        /* get item hash so we can search it through the hash arrays */
        var itemHash = item.getHash(), selIndex, insIndex;

        /* add the item to the selection array */
        if (types.indexOf('select') > -1) {
            selIndex = index === undefined ? selectedItems.length : index;
            if (item.canSelect() && selectedItemsHash.indexOf(itemHash) === -1) {
                selectedItemsHash.splice(selIndex, 0, itemHash);
                selectedItems.splice(selIndex, 0, item);
            }
        }

        /* add the item to the insertion array */
        if (!diyfmconfig.isInManagementMode() && types.indexOf('insert') > -1) {
            if (item.canSelect() && insertedItemsHash.indexOf(itemHash) === -1) {

                var source = item.getSource();
                if (
                    typeof source.canAddToInsert !== 'function'
                    || (source.canAddToInsert && source.canAddToInsert(item))
                ) {
                    /* if maximum one element can be inserted, just replace it */
                    if (diyfmconfig.getMaxSelection() === 1) {
                        insertedItemsHash.shift();
                        insertedItems.shift();
                        insIndex = 0;
                    } else {
                        insIndex = index === undefined ? insertedItems.length : index;
                    }

                    insertedItemsHash.splice(insIndex, 0, itemHash);
                    insertedItems.splice(insIndex, 0, item);
                }
            }
        }

        selectionStateNumber++;
    };

    var setSelectionItems = function(items) {
        selectedItemsHash = [];
        selectedItems = [];
        items.forEach(function(item){
            selectedItemsHash.push(item.getHash());
            selectedItems.push(item);
        });

        selectionStateNumber++;
    };

    /**
     * Remove an item from the selection/insertion
     * @param item the item (object), as an item or as an item hash (string)
     * @param types example ['select', 'insert']
     */
    var removeItem = function(item, types) {
        if (!Array.isArray(types)) {
            throw new Error();
        }

        var itemHash,
            idx;

        if ('string' === typeof item) {
            itemHash = item;
        } else {
            itemHash = item.getHash()
        }

        /* if we should remove from selection, we remove selection and insertion */
        if (types.indexOf('select') > -1) {
            idx = selectedItemsHash.indexOf(itemHash);
            if (idx > -1) {
                selectedItems.splice(idx, 1);
                selectedItemsHash.splice(idx, 1);
            }
        }

        /* if we should remove from insertion, remove it */
        if (types.indexOf('insert') > -1) {
            idx = insertedItemsHash.indexOf(itemHash);
            if (idx > -1) {
                insertedItems.splice(idx, 1);
                insertedItemsHash.splice(idx, 1);
            }
            var source = item.getSource();
            if (typeof source.itemRemovedFromInsert === 'function'){
                source.itemRemovedFromInsert(item);
            }
        }

        selectionStateNumber++;
    };

    /**
     * Remove all items from the selection/insertion
     * @param types example ['select', 'insert']
     */
    var removeAllItems = function(types) {
        if (!Array.isArray(types)) {
            throw new Error();
        }

        /* if we should remove from selection, we remove selection and insertion */
        if (types.indexOf('select') > -1) {
            selectedItems.length = 0;
            selectedItemsHash.length = 0;
        }

        /* if we should remove from insertion, remove it */
        if (types.indexOf('insert') > -1) {
            for (var i = 0; i < insertedItems.length; i++) {
                var item = insertedItems[i];
                var source = item.getSource();
                if (typeof source.itemRemovedFromInsert === 'function') {
                    source.itemRemovedFromInsert(item);
                }
            }
            insertedItems.length = 0;
            insertedItemsHash.length = 0;
        }

        selectionStateNumber++;
    };

    var getSelectionStateNumber = function() {
        return selectionStateNumber;
    };

    /**
     * Get item selection type
     * @param item
     * @returns {Array} example ['select', 'insert']
     */
    var getItemSelectionType = function(item) {
        var types = [];

        var itemHash = item.getHash();

        if (selectedItemsHash.indexOf(itemHash) > -1) {
            types.push('select');
        }

        if (insertedItemsHash.indexOf(itemHash) > -1) {
            types.push('insert');
        }

        return types;
    };

    var isItemSelected = function(item) {
        var selectionType = getItemSelectionType(item);
        return selectionType.indexOf('select') > -1;
    };

    var isItemInserted = function(item) {
        var selectionType = getItemSelectionType(item);
        return selectionType.indexOf('insert') > -1;
    };

    var getInsertedItems = function() {
        return insertedItems;
    };

    var getSelectedItems = function() {
        return selectedItems;
    };

    var allowInsertions = function() {
        return !diyfmconfig.isInManagementMode();
    }

    /* make these methods public */
    return {
        addItem: addItem,
        removeItem: removeItem,
        removeAllItems: removeAllItems,
        getItemSelectionType: getItemSelectionType,
        isItemSelected: isItemSelected,
        isItemInserted: isItemInserted,
        getSelectionStateNumber: getSelectionStateNumber,
        getInsertedItems: getInsertedItems,
        getSelectedItems: getSelectedItems,
        allowInsertions: allowInsertions,
        setSelectionItems: setSelectionItems
    };
}]);








/***/ },
/* 941 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfminsertprogress', [function() {

    var show = false,
        currentFiles,
        totalFiles;

    return {
        progressConfig: {
            getter: function() {
                if ('number' !== typeof currentFiles || 'number' !== typeof totalFiles) {
                    return 0;
                }
                var progress = currentFiles / totalFiles;
                return progress;
            },
            runOnce: false,
            onFinish: function() { }
        },
        setProgress: function(_currentFiles, _totalFiles) {
            currentFiles = _currentFiles;
            totalFiles = _totalFiles;
        },
        getProgressString: function() {
            return currentFiles + ' / ' + totalFiles;
        },
        isShown: function() {
            return show;
        },
        show: function() {
            show = true;
        },
        hide: function() {
            show = false;
            var $dialogEl = jQuery('.fm-dialog');
            $dialogEl.find('.fm-insert-polaroid').remove();
        },
        showLoadingImage: function(imageUrl) {
            // get the dialog and the insert mask
            var $dialogEl = jQuery('.fm-dialog');
            var $mask = $dialogEl.find('.fm-insert-mask');

            // get the dialog dimensions
            var dialogWidth = $dialogEl.width();
            var dialogHeight = $dialogEl.height();

            // create the image that will be displayed while adding
            var $img = jQuery('<div class="fm-insert-polaroid"><span></span></div>');

            // set the source
            $img.find('span').css('background-image', 'url(' + imageUrl + ')');

            /*
             start delayed, so we get a chance to get the image loaded
             the reason we don't bind on the load event is because some pictures
             are already loaded and the load event won't trigger
             */
            setTimeout(function() {
                // yes, synchronous, load event sometimes does not trigger,
                // espacially if there are already images (which happens)
                $img.appendTo($mask);
                // calculate the top and left coordinates to place the image
                var top = dialogHeight / 2 - $img.height() / 2;
                var left = -$img.width();

                // calculate the center
                var centerLeft = dialogWidth / 2 - $img.width() / 2;

                // compute a random degree angle tilt between -5 and 5
                var max = 5, min = -5;
                var rotate = Math.random() * (max - min) + min;
                $img.css({
                    left: left,
                    top: top,
                    '-webkit-transform': 'rotate(' + rotate + 'deg)',
                    '-moz-transform': 'rotate(' + rotate + 'deg)',
                    '-ms-transform': 'rotate(' + rotate + 'deg)',
                    'transform': 'rotate(' + rotate + 'deg)'
                }).animate({
                    left: centerLeft
                }, 400, function() {
                    // clear the previous polaroids
                    var $polaroids = $dialogEl.find('.fm-insert-polaroid');
                    if ($polaroids.length > 5) {
                        $polaroids.eq(0).hide(200, function() {
                            jQuery(this).remove();
                        });
                    }
                });
            }, 500);
        }
    };
}]);

/***/ },
/* 942 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmmessages', ['$q', '$timeout', 'diyfmselectiondata', 'diyfilevalidator', 'diyl10n', function($q, $timeout, diyfmselectiondata, diyfilevalidator, diyl10n) {

    var $ = jQuery;

    /**
     * shows a message in a DIY dialog. returns a promise which
     * resolves in case the user pressed the ok action and rejects in case
     * the user pressed the cancel action
     * @param opts
     *  - title: the message title
     *  - content: the message content
     *  - ok: if this key is present, an ok button with it's value as text will be added in the dialog's footer
     *  - cancel: if this key is present, a cancel button with it's value as text will be added in the dialog's footer
     *  - width: if this key is present, it will override the default width of the dialog
     * @returns {promise|a.fn.promise|Q.promise|.n.promise}
     */
    var showMessage = function(opts) {

        // close all previous dialogs that may have remained open
        jQuery('.fm-error-dialog').diy_confirmationDialog('destroy').remove();

        var deferred = $q.defer();

        var content = opts.content || "";
        if (opts.title) {
            var title = '<div class="confirmation-wrapper with-icon">\
                    <div class="confirmation-icon ui-icon ui-icon-alert"></div>\
                    <h2>' + opts.title + '</h2>\
                </div>';
            content = title + content;
        }

        var buttons = [];
        if (opts.ok) {
            buttons.push({
                text: opts.ok,
                click: function() {
                    $(this).diy_confirmationDialog('destroy').remove();
                    $timeout(function() {
                        deferred.resolve();
                    });
                }
            });
        }
        if (opts.cancel) {
            buttons.push({
                text: opts.cancel,
                click: function() {
                    $(this).diy_confirmationDialog('destroy').remove();
                    $timeout(function() {
                        deferred.reject();
                    });
                },
                'class': 'button-cancel'
            });
        }

        $("<div class='fm-error-dialog'>" + content + "</div>").diy_confirmationDialog({
            modal: true,
            width: opts.width || 320,
            buttons: buttons,
            draggable: false
        });

        return deferred.promise;
    };

    var sendToServer = function(msg) {
        jQuery(document).trigger("error.diy-editor", {"message": JSON.stringify(angular.extend(msg, {feature: 'File manager'}))})
    };

    var handleAddError = function(response) {
        /* if all have failed */
        if (response.allFailed) {
            sendToServer({
                action: 'allImagesFailedAdding',
                error: response.errors
            });
            return showMessage({
                title: diyl10n('filemanager.error.add.all'),
                content: content,
                ok: diyl10n('ok'),
                width: 520
            });
        } else {
            var content = diyl10n('filemanager.error.add.some').format({
                failedFilesCount: response.totalFilesFailed
            });
            return showMessage({
                title: content,
                ok: diyl10n('ok'),
                width: 520
            });
        }
    };

    var handleGenericError = function() {
        showMessage({
            title: diyl10n('filemanager.error.generic'),
            ok: diyl10n('ok')
        }).then(function() {
            diy.editor.filemanager.reload();
        });
    };

    var handleUploadError = function(report) {
        var content = '<div class="fm-deleteconfirmation">';
        content += '<table>';
        report.forEach(function(entry) {
            content += '<tr><td>' + $('<foo>').text(entry.file.name).html() + '</td><td>'  +  (entry.error.message ? entry.error.message : diyfilevalidator.getMessageByHttpErrorCode(entry.error.code)) + '</td></tr>';
        });
        content += '</table>';
        content += '</div>';

        return showMessage({
            title: diyl10n('filemanager.error.upload'),
            content: content,
            ok: diyl10n('cancel'),
            width: 520
        });
    };

    var showMessageItemsThumbs = function(opts) {
        opts.content = opts.content || "";
        opts.content += '<div class="fm-deleteconfirmation">';
        opts.content += '<ul>';
        opts.items.forEach(function(item) {
            opts.content += '<li><img src="' + item.getThumb() + '" /><span>'
                + $('<foo>').text(item.getName()).html() + '</span></li>';
        });
        opts.content += '</ul>';
        opts.content += '</div>';

        return showMessage(opts);
    };

    return {
        showMessage: showMessage,
        showMessageItemsThumbs: showMessageItemsThumbs,
        handleAddError: handleAddError,
        handleGenericError: handleGenericError,
        handleUploadError: handleUploadError
    };
}]);

/***/ },
/* 943 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmstatus', ['diyfmuploadqueue', 'diyfminsertprogress', function(diyfmuploadqueue, diyfminsertprogress) {
    return {
        getCurrentStatus: function() {
            var status = [];

            if (diyfmuploadqueue.get('storageFiles').getInProgressCount()) {
                status.push('upload');
            }

            if (diyfminsertprogress.isShown()) {
                status.push('insert');
            }

            return status;
        }
    };
}]);


/***/ },
/* 944 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmblocking', [function() {
    var blockingStack = [];
    return {
        block: function(reasonMessage) {
            var reason = {};
            reason.message = reasonMessage;
            blockingStack.push(reason);
            
            return function unblock() {
                blockingStack.splice(blockingStack.indexOf(reason), 1);
            };
        },
        isBlocked: function() {
            return blockingStack.length > 0;
        },
        getReasons: function() {
            var ret = [];
            return blockingStack.map(function(reason){
                return reason.message;
            });
        }
    };
}]);


/***/ },
/* 945 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmtracking', ['$rootScope', 'diyglobalevents', function($rootScope, diyglobalevents) {

    var currentSubsectionName = '';
    var lastSearchTerm = '';
    var lastSubsectionSearched = '';
    var eventsHandlerMap = {
            'searchCompleted': function(data) {
                var subsection = data.subsection;
                var subsectionTypeName = subsection.getTypeName();
                var searchTerm = subsection.getSearch();
                var searchEventName = 'diy-editor-filemanager-search';
                if (subsectionTypeName === 'companyPhotos'
                    || subsectionTypeName === 'recommendedCompanyPhotos'
                    || subsectionTypeName === 'cmsPhotos'
                    || subsectionTypeName === 'recommendedCmsPhotos'
                    || subsectionTypeName === 'bigstockPhotos'
                    || subsectionTypeName === '123rfPhotos'
                ) {
                    searchEventName += ((lastSearchTerm.length != 0)? 'repeated' : '');
                    diyglobalevents.trigger(searchEventName, {
                        searchPhrase: searchTerm,
                        totalResults: subsection.getItems().length
                    });
                    lastSearchTerm = searchTerm;
                    lastSubsectionSearched = subsectionTypeName;
                }
            },
            'subsectionChange': function(data) {
                var subsectionName = data.subsection.getTypeName()
                if (subsectionName !== currentSubsectionName) {
                    var sectionNameMap = {
                        'customerFiles': 'filemanager.myimages',
                        'recommendedCompanyPhotos': 'filemanager.topicRecommended',
                        'companyPhotos': 'filemanager.1and1_Images',
                        'recommendedCmsPhotos': 'filemanager.topicRecommended',
                        'cmsPhotos': 'filemanager.1and1_Images',
                        'bigstockPhotos': 'filemanager.Bigstock_Photos',
                        'bigstockPurchasedPhotos': 'filemanager.Bigstock_Purchased_Photos',
                        '123rfPhotos': 'filemanager.123rf_Photos',
                        '123rfPurchasedPhotos': 'filemanager.123rf_Purchased_Photos'
                    };
                    diyglobalevents.trigger('diy-editor-generic-sectionAccessed', {
                        sectionCodeName: sectionNameMap[subsectionName]
                    });
                    currentSubsectionName = subsectionName;
                }
            },
            'addToInsertion': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-addInsertion', {
                    count: data.items.length,
                    source: data.source,
                    section: data.subsection.getTypeName(),
                    currentSearch: data.subsection.getSearch()
                });
            },
            'clearAllInserted': function() {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'clearAllInserted'
                });
            },
            'uploadedFiles': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-uploadedFiles', {
                    count: data.uploadedItems.length,
                    source: data.source
                });
            },
            'uploadButtonClick': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-uploadButtonClick');
            },
            'bigstockLimit': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-bigstockLimit');
            },
            'jumpToBigstock': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'jumpToBigstock',
                    pageName: 'Bigstock Limit'
                });
            },
            'cancelJumpToBigstock': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'close',
                    pageName: 'Bigstock Limit'
                });
            },
            '123RFLimit': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-123RFLimit');
            },
            'jumpTo123RF': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'jumpToBigstock',
                    pageName: '123RF Limit'
                });
            },
            'cancelJumpTo123RF': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'close',
                    pageName: '123RF Limit'
                });
            },
            'deleteFilesClicked': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-deleteFilesClicked', {
                    count: data.itemsCount
                });
            },
            'createdFolder': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-createdFolder');
            },
            'deletedFolder': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-deletedFolder');
            },
            'insertedItems': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-insertedFiles', {
                    count: data.items.length
                });
            },
            'newSearch': function (data) {
                diyglobalevents.trigger('diy-editor-filemanager-newSearch', {
                    searchTerms: data.search
                });
            }
    };

    for (var eventName in eventsHandlerMap) {
        if (eventsHandlerMap.hasOwnProperty(eventName)) {
            $rootScope.$on(eventName, function(ev, data) {
                eventsHandlerMap[ev.name](data);
            });
        }
    }

    return {
        track: function(eventName, data) {
            if (eventsHandlerMap.hasOwnProperty(eventName)) {
                eventsHandlerMap[eventName](data);
            }
        }
    };
}]);


/***/ },
/* 946 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsourcestorage', [
    '$injector',
    '$q',
    '$resource',
    '$http',
    'diyfmconfig',
    'diyl10n',
    'diyappevents',
    'diyfmfolders',
    'diyfmconststorage',
    'diywebsiteid',
    'diyfmmessages',
    'diyfmconstbigstockpurchased',
function(
    $injector,
    $q,
    $resource,
    $http,
    diyfmconfig,
    diyl10n,
    diyappevents,
    diyfmfolders,
    diyfmconststorage,
    diywebsiteid,
    diyfmmessages,
    diyfmconstbigstockpurchased
) {
    var
        source = {},
        itemsProviderUrl = '/rest/websites/' + diywebsiteid + '/storage-files/'
    ;

    var getName = function() {
        return 'storage';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectionstorage');
    };

    var rangeParams;

    var itemsProvider = $resource(itemsProviderUrl + ':id', {
            id: '@id'
         }, {
            'create':   {method:'POST'},
            'update': {method: 'PUT'},
            'query': {
                method: 'GET',
                isArray: true,
                headers: {
                    'X-Diy-Range': function(config) {
                        if (rangeParams) {
                            return 'items=' + Math.max(0, rangeParams.offset)
                                + '-' + Math.max(0, rangeParams.offset + rangeParams.limit - 1);
                        }
                        return null;
                    }
                }
            }
        }
    );

    itemsProvider.batchDelete = function(ids) {
        return $http({
            method: 'DELETE',
            url: itemsProviderUrl,
            data: ids
        });
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        var defer = $q.defer(), dataParams = angular.extend({}, params);

        if (dataParams !== undefined && !!dataParams.search) {
            dataParams.publicName = dataParams.search;
            dataParams.search = undefined;
        }
        // XXX temporary set local variable rangeParams
        // so that it could be used in above transformRequest function
        rangeParams = {
            offset: offset,
            limit: limit
        };
        itemsProvider.query(dataParams, function(data, headersGetter){
            var
                totalCount,
                contentRange = headersGetter()['x-diy-content-range']
            ;
            if (contentRange) {
                // Content-Range header have a format like "range start-end/total" (i.e. "items 0-99/200")
                totalCount = parseInt(contentRange.split('/')[1], 10);
            }
            defer.resolve({items: data, totalCount: totalCount});
        }, function(httpResponse) {
            diyfmmessages.handleGenericError();
            defer.reject();
        });
        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    angular.module(diyfmconfig.getAppName()).compileProvider.directive('diyfmtoolbardeleteselected', [
       'diyl10n',
       'diyfmsectionsdata',
       'diyfmselectiondata',
       'diyfmmessages',
       function(
            diyl10n,
            diyfmsectionsdata,
            diyfmselectiondata,
            diyfmmessages
       ){
        return {
            template: '<button class="ui-button-borderless fm-toolbar-delete" \
                title="' + diyl10n('filemanager.deleteSelectedButton.title') + '"></button>',
            restrict: 'A',
            scope: true,
            link: function(scope, elem, attr) {
                var
                    $elem = jQuery(elem),
                    deleteBtn = $elem.find('.fm-toolbar-delete')
                ;

                var deleteSelected = function() {
                    diyfmmessages.showMessageItemsThumbs({
                        items: diyfmselectiondata.getSelectedItems(),
                        title: diyl10n('filemanager.toolbar.deleteconfirmation.message').format(diyfmselectiondata.getSelectedItems().length),
                        ok: diyl10n('filemanager.sections.menu.delete'),
                        cancel: diyl10n('cancel')
                    }).then(function() {
                        var itemsToDelete = diyfmselectiondata.getSelectedItems();
                        var itemsToDeleteCount = itemsToDelete.length;
                        diyfmsectionsdata.getCurrentSubsection().deleteItems(itemsToDelete);
                        scope.$emit('deleteFilesClicked', {
                            itemsCount: itemsToDeleteCount
                        });
                    });
                };


                deleteBtn
                    .button({
                        icons: {primary: 'ui-icon-trash'},
                        text: false,
                        // initially we don't have any item selected, so button should be disabled
                        disabled: true
                    })
                    .click(function(){
                        deleteSelected();
                        scope.$apply();
                    });

                scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(){
                    var selCount = diyfmselectiondata.getSelectedItems().length;
                    deleteBtn.button('option', 'disabled', selCount === 0);
                });
            }
        }
    }]);

    var toolbarItems = [
        ' ', // spacer
        'search'
    ];

    var managementToolbarItems = [
        'selectall',
        function() {
            return '<div diyfmtoolbardeleteselected></div>';
        },
        '-', // separator
        ' ', // spacer
        'search'
    ];

    var bigstockToolbarItems = [];

    var getToolbarItems = function(subsection) {
        if (subsection.getId() === diyfmconstbigstockpurchased) {
            return bigstockToolbarItems;
        } else {
            if (diyfmconfig.isInManagementMode()) {
                return managementToolbarItems;
            } else {
                return toolbarItems;
            }
        }
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        getToolbarItems: getToolbarItems
    });
}]);

/***/ },
/* 947 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsourcekeyvisuals', ['$q', '$injector', '$http', 'diyl10n', 'diyfmsectionmodel', 'diyfmsubsectionmodel', 'diyfmconstkeyvisual', 'diyinfo', 'diyfmconfig',
function($q, $injector, $http, diyl10n, diyfmsectionmodel, diyfmsubsectionmodel, diyfmconstkeyvisual, diyinfo, diyfmconfig) {
    var 
        source = {},
        section,
        itemsProvider = {}
    ;
    
    var getName = function() {
        return 'keyvisuals';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectioncompany');
    };
    
    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer();
        var url = '/app/module/emotionheader/searchimages?justImages=1';
        
        // XXX server side don't support search inside a topic, it emulates 
        // topic filter using search param with topic name
        if (params.topicName) {
            url += (params.topicName ? '&query=' + encodeURIComponent(params.topicName) : '');
        } else {
            url += (params.search ? '&query=' + encodeURIComponent(params.search) : '');
        }
        url += (offset !== undefined ? '&offset=' + encodeURIComponent(offset) : '');
        url += (limit !== undefined ? '&limit=' + encodeURIComponent(limit) : '');
        
        var 
            thumbSize = diyfmconfig.getThumbSize(),
            previewSize = diyfmconfig.getPreviewSize()
        ;
        
        url += '&thumbWidth=' + thumbSize.width;
        url += '&thumbHeight=' + thumbSize.height;
        url += '&previewWidth=' + previewSize.width;
        url += '&previewHeight=' + previewSize.height;
        
        $http.get(url)
            .success(function(data, status, headers, config) {
                if (data.data) {
                    defer.resolve({items: data.data, totalCount: data.totalCount});
                    currentPage = 1;
                } else {
                    diyfmmessages.handleGenericError();
                }
            }).error(function(data, status, headers, config) {
                diyfmmessages.handleGenericError();
                defer.reject();
            });
        return defer.promise;
    };
    
    var getItemsProvider = function() {
        return itemsProvider;
    };
    
    var toolbarItems = [
        ' ', // spacer
        'search'
    ];
    
    var getToolbarItems = function(subsection) {
        return toolbarItems; 
    };
    
    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        getToolbarItems: getToolbarItems
    });
}]);


/***/ },
/* 948 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsourcepatterns', ['$q', '$injector', '$http', 'diyl10n', 'diyfmsectionmodel', 'diyfmsubsectionmodel', 'diyfmconstpattern', 'diyfmconfig',
function($q, $injector, $http, diyl10n, diyfmsectionmodel, diyfmsubsectionmodel, diyfmconstpattern, diyfmconfig) {
    var
        source = {},
        itemsProvider = {}
    ;

    var getName = function() {
        return 'patterns';
    };

    var backgroundColor = diyfmconfig.getSourceSetting(getName(), 'backgroundColor');

    var getBackgroundColor = function() {
        return backgroundColor;
    };

    var setBackgroundColor = function(color) {
        backgroundColor = color;
    };

    var setBackgroundColorToData = function(data) {
        data.forEach(function(item) {
            item.id.backgroundColor = backgroundColor;
        });
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectioncompany');
    };

    var patternsDataCache;

    itemsProvider.queryRange = function(params, offset, limit) {
        var defer = $q.defer(), items;

        if (patternsDataCache) {
            // we need a deep copy in case background color will be changed
            items = angular.copy(patternsDataCache);
            setBackgroundColorToData(items);
            defer.resolve({
                items: items,
                totalCount: patternsDataCache.length
            });
        } else {

            var url = '/app/module/emotionheader/patterns?';

            var
                thumbSize = diyfmconfig.getThumbSize(),
                previewSize = diyfmconfig.getPreviewSize()
            ;

            url += '&thumbWidth=' + thumbSize.width;
            url += '&thumbHeight=' + thumbSize.height;
            url += '&previewWidth=' + previewSize.width;
            url += '&previewHeight=' + previewSize.height;

            $http.get(url)
                .success(function(data, status, headers, config) {
                    if (data && data.data) {
                        // because patterns are invariable, let's cache them to save
                        // roundtrips to the server
                        patternsDataCache = data.data;
                        // HACK: We need to make patterns unique when bg color changes
                        // so we force another refresh from the server, but we inject
                        // a different color variant in the id, so we'll have different
                        // objects
                        setBackgroundColorToData(patternsDataCache);
                        defer.resolve({items: patternsDataCache, totalCount: patternsDataCache.length});
                    } else {
                        diyfmmessages.handleGenericError();
                    }
                }).error(function(data, status, headers, config) {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                });
        }
        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    var getThumbStyle = function(item) {
        return {
            backgroundColor: '#' + item.getId().backgroundColor
        };
    };

    var getPreviewStyle = function(item) {
        return {
            backgroundColor: '#' + item.getId().backgroundColor
        };
    };

    var getInsertThumbStyle = function(item) {
        return 'background-color: #' + item.getId().backgroundColor;
    };

    angular.module(diyfmconfig.getAppName()).compileProvider.directive('diyfmpatternscolorpicker', [
        'diyl10n',
        'diyfmsectionsdata',
        'diyfmselectiondata',
        function(
            diyl10n,
            diyfmsectionsdata,
            diyfmselectiondata
        ){
        return {
            template: '<div class="fm-toolbar-pattern-color"\
                <label for="eh-color-picker-wrapper">' + diyl10n('emotionheader.background.patternColorLabel') + '</label>\
                <div class="pattern-color-picker"></div>\
            </div>',
            restrict: 'A',
            scope: true,
            link: function(scope, elem, attr) {
                var $patternColorPickerContainer = jQuery('.pattern-color-picker', elem);

                var subsection = diyfmsectionsdata.getCurrentSubsection();

                var bgColor = subsection.getSource().getBackgroundColor();

                $patternColorPickerContainer.colorPicker({
                    mode: 'button',
                    layerAlign: 'right',
                    color: '#' + bgColor,
                    showButtons: true,
                    onColorAccept: function (color) {
                        scope.$apply(function() {
                            subsection.getSource().setBackgroundColor(color);
                            subsection.clearItemsCache();
                            diyfmselectiondata.removeAllItems(['select']);
                        });
                    }
                });

                elem.bind('$destroy', function(){
                    if ($patternColorPickerContainer) {
                        $patternColorPickerContainer.data('colorpicker').abortColor();
                        $patternColorPickerContainer = null;
                    }
                });
            }
        }
    }]);

    var toolbarItems = [];

    if (diyfmconfig.getSourceSetting(getName(), 'enableBgColorPicker')) {
        toolbarItems = [
            ' ', // spacer
            function() {
                return '<div diyfmpatternscolorpicker></div>';
            }
        ];
    }

    var getToolbarItems = function(subsection) {
        return toolbarItems;
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        getBackgroundColor: getBackgroundColor,
        setBackgroundColor: setBackgroundColor,
        getThumbStyle: getThumbStyle,
        getPreviewStyle: getPreviewStyle,
        getInsertThumbStyle: getInsertThumbStyle,
        getToolbarItems: getToolbarItems
    });
}]);


/***/ },
/* 949 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsourcecms', [
    '$q',
    '$injector', 
    '$http', 
    '$sce', 
    'diyl10n', 
    'diyfeatures',
    'diyfmmessages',
function(
    $q,
    $injector, 
    $http,
    $sce,
    diyl10n, 
    diyfeatures,
    diyfmmessages
) {
    var 
        source = {},
        itemsProvider = {},
        upsellContents = ''
    ;
    
    var getName = function() {
        return 'cms';
    };
    
    var getSectionModel = function() {
        return $injector.get('diyfmsectioncompany');
    };
    
    var isAvailable = function() {
        return diyfeatures('cmsImagesAvailable');
    };

    var shouldShowUpsell = function() {
        return diyfeatures('cmsImagesUpgradable');
    };

    var getUpsellContents = function() {
        return upsellContents;
    };

    var getSourceServiceUrl = function () {
        return cc_.properties.cmsUrl + 'rest/images';
    };

    var getLanguage = function () {
        return jimdoData.cmsLanguage.substr(0, 2);
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer(), textSearch, colorSearch, topicIdSearch;

        if (isAvailable()) {
            var pathParams = '';

            // extract filters //
            textSearch = params.hasOwnProperty('search') ? params.search : null;
            colorSearch = params.hasOwnProperty('colorSearch') ? params.colorSearch : null;
            topicIdSearch = params.hasOwnProperty('topicId') ? params.topicId : null;

            // compose path params //
            pathParams += ';language=' + encodeURIComponent(getLanguage());
            if (textSearch) {
                pathParams += ';searchQuery=' + encodeURIComponent(textSearch);
            }
            if (colorSearch) {
                pathParams += ';searchColor=' + encodeURIComponent(colorSearch);
            }
            if (topicIdSearch) {
                pathParams += ';topic=' + encodeURIComponent(topicIdSearch);
            }

            $http.get(getSourceServiceUrl() + pathParams, {
                headers: {
                    'X-Diy-Range': 'items=' + Math.max(0, offset) + '-' + (Math.max(0, offset + limit - 1))
                }
            }).then(function (response) {
                try {
                    var i, images = response.data.images, length = images.length, convertedImages = [],
                        totalCount, contentRange;

                    for (var i = 0; i < length; i++) {
                        convertedImages.push({
                            id: images[i].imageId,
                            thumb: images[i].links.thumbnail.href,
                            file: images[i].links.original.href,
                            preview: images[i].links.preview.href
                        });
                    }

                    contentRange = response.headers('x-diy-content-range');
                    if (contentRange) {
                        // Content-Range header have a format like "range start-end/total" (i.e. "items 0-99/200")
                        totalCount = parseInt(contentRange.split('/')[1], 10);
                    }

                    defer.resolve({
                        items: convertedImages,
                        totalCount: totalCount
                    });
                } catch (err) {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            }, function () {
                diyfmmessages.handleGenericError();
                defer.reject();
            });
        } else {
            // load the upsell view only when needed //
            $http.get('/app/module/marketing/imagesupsellview').then(function(response) {
                // this will ensure that this string will be appended just as it is, without removing onclick attributes and other tags
                upsellContents = $sce.trustAsHtml(response.data);
            });

            // set empty items
            defer.resolve({items: [], totalCount: 0});
        }

        return defer.promise;
    };
    
    var getItemsProvider = function() {
        return itemsProvider;
    };
    
    var toolbarItems = [];
    if (isAvailable()) {
        toolbarItems = [
            ' ', // spacer
            function() {
                return '<div diyfmcolorsfilter></div>';
            },
            'search'
        ];
    }
    var restrictedToolbarItems = [];
    
    var getToolbarItems = function(subsection) {
        if (subsection.getTypeName() === 'cmsPhotos') {
            return toolbarItems;
        } else {
            return restrictedToolbarItems;
        }
    };
    
    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        shouldShowUpsell: shouldShowUpsell,
        getUpsellContents: getUpsellContents,
        isAvailable: isAvailable,
        getToolbarItems: getToolbarItems
    });
}]);


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var premiumDialog = __webpack_require__(951);

diy.angular.registerFactory('diyfmsourcebigstock', [
    '$q',
    '$injector',
    '$http',
    '$sce',
    'diyl10n',
    'diyfeatures',
    'diyfmmessages',
    'diyinfo',
    'diywebsiteid',
    'diyfmfileitemmodel',
    'diyglobalevents',
    'diyfmconfig',
    'diyfmconstbigstock',
    'diyfmtracking',
function(
    $q,
    $injector,
    $http,
    $sce,
    diyl10n,
    diyfeatures,
    diyfmmessages,
    diyinfo,
    diywebsiteid,
    diyfmfileitemmodel,
    diyglobalevents,
    diyfmconfig,
    diyfmconstbigstock,
    diyfmtracking
) {
    var
        source = {},
        itemsProvider = {},
        sourceServiceUrl = null,
        MAX_TOTAL_ITEMS_NO_SEARCH = 1000,
        MAX_TOTAL_ITEMS = 10000
    ;

    var getName = function() {
        return 'bigstock';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectionbigstock');
    };

    var isAvailable = function() {
        return diyfeatures('bigstock');
    };

    var getSourceServiceUrl = function (fromServer) {
        var defer = $q.defer();

        if (sourceServiceUrl && !fromServer) {
            defer.resolve(sourceServiceUrl);
        } else {
            $http.get('/app/cms/js/bigstock-access').then(function(response){
                if (response.data && response.data.success) {
                    var data = response.data.data;
                    var url = data.apiUrl + 'oauth2/search/?access_token=' + data.token;
                    // caching url
                    sourceServiceUrl = url;
                    defer.resolve(sourceServiceUrl);
                } else {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            }, function(){
                diyfmmessages.handleGenericError();
                defer.reject();
            });
        }
        return defer.promise;
    };

    var getLanguage = function () {
        return diyinfo.getLanguage().substr(0, 2);
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer(), textSearch;

        if (isAvailable()) {
            var pathParams = '';

            // extract filters //
            textSearch = params.hasOwnProperty('search') ? params.search : '';

            // compose path params //
            pathParams += '&response_detail=all';
            pathParams += '&vectors=n';
            pathParams += '&language=' + encodeURIComponent(getLanguage());
            // TODO maybe when no search is there search with a default keyword specific to customer topic
            //if (textSearch) {
                pathParams += '&q=' + encodeURIComponent(textSearch);
            //}

            // find the smallest limit for fixed pagination that bigstock supports
            var bLimit = limit;
            while (offset % bLimit + limit > bLimit) {
                bLimit++;
            }
            pathParams += '&limit=' + bLimit;
            var pageNumber = Math.floor(offset / bLimit);
            pathParams += '&page=' + (pageNumber + 1);
            var bOffset = bLimit * pageNumber ;

            pathParams += '&callback=JSON_CALLBACK';

            getSourceServiceUrl().then(function(serviceUrl){
                $http.jsonp(serviceUrl + pathParams).then(function (response) {
                    try {
                        var data = response.data.data, images = data.images, length = images.length, convertedImages = [];

                        var start = offset - bOffset, end = Math.min(length, start + limit);

                        for (var i = start; i < end; i++) {
                            convertedImages.push({
                                id: images[i].id,
                                size: getLargestSizeCode(images[i].formats),
                                thumb: images[i].small_thumb.url,
                                file: null,
                                preview: images[i].preview.url
                            });
                        }

                        var maxTotal = textSearch === '' ? MAX_TOTAL_ITEMS_NO_SEARCH : MAX_TOTAL_ITEMS;

                        defer.resolve({
                            items: convertedImages,
                            totalCount: Math.min(data.paging.total_items, maxTotal - maxTotal % bLimit)
                        });
                    } catch (err) {
                        diyfmmessages.handleGenericError();
                        defer.reject();
                    }
                }, function (response) {
                    // XXX on zero results Bigstock API returns an 503 HTTP status code
                    // We cannot read response body this when using JSONP so we suppose we are not in this case
                    defer.resolve({
                        items: [],
                        totalCount: 0
                    });
                    //diyfmmessages.handleGenericError();
                    //defer.reject();
                });
            });
        } else {
            // set empty items
            defer.resolve({items: [], totalCount: 0});
        }

        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    var bigstockSelectedImages = 0;
    var maxNumberOfImages, purchasedImages, availableImages, availableSizes;
    var premiumPayload;

    var toolbarItems = [];
    if (isAvailable()) {
        premiumPayload = diyfeatures.getPayload('premiumImages');
        availableSizes = diyfeatures.getPayload('bigstock').availableSizes;
        maxNumberOfImages = premiumPayload.maxImages;
        purchasedImages = premiumPayload.purchasedImages;
        if (purchasedImages === false) {
            // there was an error retrieving purchasedImages so defensively assume limit is reached
            // and populate make a dummy array of maxNumberOfImages length
            purchasedImages = maxNumberOfImages;
        }
        availableImages = diyfeatures.getPayload('bigstock').availableImages;
        toolbarItems = [
            function () {
                var obj = {
                    used : '<strong>' + purchasedImages + '</strong>',
                    total : '<strong>' + maxNumberOfImages + '</strong>'
                };
                return '<div>' + diyl10n('filemanager.bigstockSection.remainingMessage').format(obj) + '</div>';
            },
            ' ', // spacer
            'search'
        ];
    }

    var getLargestSizeCode = function(formats) {
        var largest = formats[0];
        for (var i = 1; i < formats.length; i++) {
            if (availableSizes.indexOf(largest.size_code) < availableSizes.indexOf(formats[i].size_code)) {
                largest = formats[i];
            }
        }
        return largest.size_code;
    };

    var getToolbarItems = function(subsection) {
        return toolbarItems;
    };

    var beforeInsert = function(batch) {
        var defer = $q.defer();
        var bigstockRes = batch[0].getResource();
        $.ajax({
            type: 'POST',
            url: '/app/cms/js/bigstock-to-storage',
            data: {
                id: bigstockRes.id,
                size: bigstockRes.size
            },
            success: function(response, status, jqXHR) {
                if (response.success) {
                    // add image id to the list of purchased images, in case it isn't there yet
                    if (availableImages.indexOf(bigstockRes.id) === -1) {
                        availableImages.push(bigstockRes.id);
                        premiumPayload.purchasedImages++;
                    }

                    $http.get('/rest/websites/' + diywebsiteid + '/storage-files/' + response.data.storageFileId).then(function(response){
                        var fileItem = new diyfmfileitemmodel(response.data);

                        diyglobalevents.trigger('diy-editor-filemanager-addedFiles');
                        defer.resolve([fileItem]);
                    }, function() {
                        diyfmmessages.handleGenericError();
                        defer.reject();
                    });
                } else {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            },
            error: function(jqXHR, status, errorThrown) {
                diyfmmessages.handleGenericError();
                defer.reject();
            }
        });

        return defer.promise;
    };

    var limitDialogOpen = false;

    var canAddToInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }

        if (diyfmconfig.getMaxSelection() === 1) {
            bigstockSelectedImages = 0;
        }

        if (bigstockSelectedImages + purchasedImages >= maxNumberOfImages) {
            //SHOW dialog
            var btnAction = function() {
                // link to Bigstock website
                window.open('http://www.bigstockphoto.com/'+ getLanguage() +'/image-'+ item.getId());
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('jumpToBigstock');
            };
            var btnCancelAction = function() {
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('cancelJumpToBigstock');
            };
            // preload image
            var img = new Image();

            img.src = item.getPreview();
            var showDialog = function () {
                if (limitDialogOpen) return;
                limitDialogOpen = true;
                premiumDialog.showLimitDialog(btnAction, btnCancelAction, maxNumberOfImages, item.getPreview());
                diyfmtracking.track('bigstockLimit');
            }
            if (img.complete) {
                showDialog();
            } else {
                img.onload = showDialog;
                img.onerror = showDialog;
            }
            return false;
        } else {
            bigstockSelectedImages++;
            return true;
        }
    }

    var itemRemovedFromInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }
        bigstockSelectedImages--;
    }

    var beforeSubsectionShow = function (subsection) {
        if (subsection.getId() === diyfmconstbigstock  && window.localStorage) {
            var bigstockMessageUnderstood = 'bigstockMessageUnderstood' + diywebsiteid;
            var localData = JSON.parse(window.localStorage.getItem(bigstockMessageUnderstood));
            if (!localData) {
                // show dialog
                var btnAction = function() {
                    window.localStorage.setItem(bigstockMessageUnderstood, JSON.stringify(true));
                    premiumDialog.closeDialog();
                };
                premiumDialog.showInitialDialog(btnAction, maxNumberOfImages);
            }
        }
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        isAvailable: isAvailable,
        getToolbarItems: getToolbarItems,
        beforeInsert: beforeInsert,
        canAddToInsert: canAddToInsert,
        itemRemovedFromInsert: itemRemovedFromInsert,
        beforeSubsectionShow: beforeSubsectionShow
    });
}]);


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var diyLightTheme = __webpack_require__(241);
var string_1 = __webpack_require__(952);
var l10n_1 = __webpack_require__(18);
var PremiumDialog = (function (_super) {
    tslib_1.__extends(PremiumDialog, _super);
    function PremiumDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PremiumDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    PremiumDialog.prototype.render = function () {
        var actions = [
            (this.props.btnCancelText) ?
                React.createElement(FlatButton_1.default, { label: this.props.btnCancelText, secondary: true, onTouchTap: this.props.btnCancelAction, "data-test-id": "bigstock-cancel-btn" }) :
                null,
            React.createElement(FlatButton_1.default, { label: this.props.btnText, primary: true, onTouchTap: this.props.btnAction, "data-test-id": "bigstock-action-btn" }),
        ];
        return (React.createElement("div", null,
            React.createElement(Dialog_1.default, { actions: actions, modal: true, open: true, style: { zIndex: 200002 }, contentStyle: { maxWidth: '450px' }, bodyStyle: { padding: 0 } }, this.props.children)));
    };
    return PremiumDialog;
}(React.Component));
PremiumDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
var rootEl = null;
var styles = {
    title: { fontWeight: 500, fontSize: "16px", marginBottom: "12px" },
    paragraph: { fontSize: "13px", margin: "6px 0px" },
    body: { padding: "24px" },
    imgWrapper: {
        width: "100%",
        height: "200px",
        overflow: "hidden",
    },
    imgDiv: {
        width: "100%",
        height: "240px",
        backgroundSize: "cover",
        backgroundPosition: "50% 50%",
        backgroundImage: "",
    }
};
function showInitialDialog(btnAction, maxNumberOfImages) {
    rootEl = document.createElement("div");
    document.body.appendChild(rootEl);
    var messageTitle = l10n_1.default("filemanager.bigstockSection.initialMessage.title").replace(/&amp;/, '&');
    var part1Text = l10n_1.default("filemanager.bigstockSection.initialMessage.part1");
    var messagePart1 = string_1.format(part1Text, {
        "maxNumberOfImages": maxNumberOfImages
    });
    var messagePart2 = l10n_1.default("filemanager.bigstockSection.initialMessage.part2");
    var btnText = l10n_1.default("filemanager.bigstockSection.initialMessage.button");
    ReactDOM.render(React.createElement(PremiumDialog, { messagePart1: messagePart1, messagePart2: messagePart2, btnText: btnText, btnAction: (btnAction) },
        React.createElement("div", { style: styles.body, "data-test-id": "bigstock-dialog-initial-content" },
            React.createElement("div", { style: styles.title }, messageTitle),
            React.createElement("div", { style: styles.paragraph }, messagePart1),
            React.createElement("div", { style: styles.paragraph }, messagePart2))), rootEl);
}
exports.showInitialDialog = showInitialDialog;
;
function showLimitDialog(btnAction, btnCancelAction, maxNumberOfImages, url) {
    rootEl = document.createElement("div");
    document.body.appendChild(rootEl);
    var messageTitle = l10n_1.default("filemanager.bigstockSection.limitMessage.title");
    var part1Text = l10n_1.default("filemanager.bigstockSection.limitMessage.part1");
    var messagePart1 = string_1.format(part1Text, {
        "maxNumberOfImages": maxNumberOfImages
    });
    var messagePart2 = l10n_1.default("filemanager.bigstockSection.limitMessage.part2");
    var btnGoText = l10n_1.default("filemanager.bigstockSection.limitGo.button");
    var bntCancelText = l10n_1.default("filemanager.bigstockSection.limitCancel.button");
    styles.imgDiv.backgroundImage = "url('" + url + "')";
    ReactDOM.render(React.createElement(PremiumDialog, { messagePart1: messagePart1, messagePart2: messagePart2, btnText: btnGoText, btnAction: btnAction, btnCancelText: bntCancelText, btnCancelAction: btnCancelAction },
        React.createElement("div", { "data-test-id": "bigstock-dialog-limit-content" },
            React.createElement("div", { style: styles.imgWrapper },
                React.createElement("div", { style: styles.imgDiv })),
            React.createElement("div", { style: styles.body },
                React.createElement("div", { style: styles.title }, messageTitle),
                React.createElement("div", { style: styles.paragraph }, messagePart1),
                React.createElement("div", { style: styles.paragraph }, messagePart2)))), rootEl);
}
exports.showLimitDialog = showLimitDialog;
;
function closeDialog() {
    if (rootEl) {
        ReactDOM.unmountComponentAtNode(rootEl);
        document.body.removeChild(rootEl);
    }
}
exports.closeDialog = closeDialog;


/***/ },
/* 952 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function format(text, tokens) {
    var args = arguments;
    if (args.length === 2 && typeof tokens === 'object') {
        return text.replace(/\{([^\}]+)\}/g, function (match, varName) {
            return typeof tokens[varName] !== 'undefined'
                ? tokens[varName]
                : match;
        });
    }
    else {
        return text.replace(/\{(\d+)\}/g, function (match, number) {
            return typeof args[number + 1] !== 'undefined'
                ? args[number + 1]
                : match;
        });
    }
}
exports.format = format;


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var premiumDialog = __webpack_require__(951);

diy.angular.registerFactory('diyfmsource123rf', [
    '$q',
    '$injector',
    '$http',
    '$sce',
    'diyl10n',
    'diyfeatures',
    'diyfmmessages',
    'diyinfo',
    'diywebsiteid',
    'diyfmfileitemmodel',
    'diyglobalevents',
    'diyfmconfig',
    'diyfmconst123rf',
    'diyfmtracking',
function(
    $q,
    $injector,
    $http,
    $sce,
    diyl10n,
    diyfeatures,
    diyfmmessages,
    diyinfo,
    diywebsiteid,
    diyfmfileitemmodel,
    diyglobalevents,
    diyfmconfig,
    diyfmconst123rf,
    diyfmtracking
) {
    var
        source = {},
        itemsProvider = {},
        sourceServiceUrl = null,
        MAX_TOTAL_ITEMS_NO_SEARCH = 1000,
        MAX_TOTAL_ITEMS = 10000
    ;

    var getName = function() {
        return '123rf';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsection123rf');
    };

    var isAvailable = function() {
        return diyfeatures('123rf');
    };

    var getLanguage = function () {
        return diyinfo.getLanguage().substr(0, 2);
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer(), textSearch;

        if (isAvailable()) {
            var pathParams = '';

            // extract filters //
            textSearch = params.hasOwnProperty('search') ? params.search : '';

            // compose path params //
            pathParams += '?language=' + encodeURIComponent(getLanguage());
            pathParams += '&q=' + encodeURIComponent(textSearch);

            // find the smallest limit for fixed pagination
            var bLimit = limit;
            while (offset % bLimit + limit > bLimit) {
                bLimit++;
            }
            pathParams += '&perpage=' + bLimit;
            var pageNumber = Math.floor(offset / bLimit);
            pathParams += '&page=' + (pageNumber + 1);
            var bOffset = bLimit * pageNumber ;

            var serviceUrl = '/app/cms/123rf/list'
            $http.get(serviceUrl + pathParams).then(function (response) {
                try {
                    var data = response.data.data, images = data.images, length = images.length, convertedImages = [];

                    var start = offset - bOffset, end = Math.min(length, start + limit);

                    for (var i = start; i < end; i++) {
                        convertedImages.push({
                            id: images[i].id,
                            thumb: images[i].thumb,
                            file: null,
                            preview: images[i].preview
                        });
                    }

                    var maxTotal = textSearch === '' ? MAX_TOTAL_ITEMS_NO_SEARCH : MAX_TOTAL_ITEMS;

                    defer.resolve({
                        items: convertedImages,
                        totalCount: Math.min(data.paging.total_items, maxTotal - maxTotal % bLimit)
                    });
                } catch (err) {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            }, function (response) {
                diyfmmessages.handleGenericError();
                defer.reject();
            });

        } else {
            // set empty items
            defer.resolve({items: [], totalCount: 0});
        }

        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    var _123rfSelectedImages = 0;
    var maxNumberOfImages, purchasedImages, availableImages;
    var premiumPayload;

    var toolbarItems = [];
    if (isAvailable()) {
        premiumPayload = diyfeatures.getPayload('premiumImages');
        maxNumberOfImages = premiumPayload.maxImages;
        purchasedImages = premiumPayload.purchasedImages;
        if (purchasedImages === false) {
            // there was an error retrieving purchasedImages so defensively assume limit is reached
            // and populate make a dummy array of maxNumberOfImages length
            purchasedImages = maxNumberOfImages;
        }
        availableImages = diyfeatures.getPayload('123rf').availableImages;
        toolbarItems = [
            function () {
                var obj = {
                    used : '<strong>' + purchasedImages + '</strong>',
                    total : '<strong>' + maxNumberOfImages + '</strong>'
                };
                return '<div>' + diyl10n('filemanager.bigstockSection.remainingMessage').format(obj) + '</div>';
            },
            ' ', // spacer
            'search'
        ];
    }

    var getToolbarItems = function(subsection) {
        return toolbarItems;
    };

    var beforeInsert = function(batch) {
        var defer = $q.defer();
        var _123rfRes = batch[0].getResource();
        $.ajax({
            type: 'POST',
            url: '/app/cms/123rf/storage',
            data: {
                id: _123rfRes.id
            },
            success: function(response, status, jqXHR) {
                if (response.success) {
                    // add image id to the list of purchased images, in case it isn't there yet
                    if (availableImages.indexOf(_123rfRes.id) === -1) {
                        availableImages.push(_123rfRes.id);
                        premiumPayload.purchasedImages++;
                    }

                    $http.get('/rest/websites/' + diywebsiteid + '/storage-files/' + response.data.storageFileId).then(function(response){
                        var fileItem = new diyfmfileitemmodel(response.data);

                        diyglobalevents.trigger('diy-editor-filemanager-addedFiles');
                        defer.resolve([fileItem]);
                    }, function() {
                        diyfmmessages.handleGenericError();
                        defer.reject();
                    });
                } else {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            },
            error: function(jqXHR, status, errorThrown) {
                diyfmmessages.handleGenericError();
                defer.reject();
            }
        });

        return defer.promise;
    };

    var limitDialogOpen = false;

    var canAddToInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }

        if (diyfmconfig.getMaxSelection() === 1) {
            _123rfSelectedImages = 0;
        }

        if (_123rfSelectedImages + purchasedImages >= maxNumberOfImages) {
            // show dialog
            var btnAction = function() {
                window.open('http://www.123rf.com/photo_' + item.getId() + '.html');
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('jumpTo123RF');
            };
            var btnCancelAction = function() {
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('cancelJumpTo123RF');
            };
            // preload image
            var img = new Image();

            img.src = item.getPreview();
            var showDialog = function () {
                if (limitDialogOpen) return;
                limitDialogOpen = true;
                premiumDialog.showLimitDialog(btnAction, btnCancelAction, maxNumberOfImages, item.getPreview());
                diyfmtracking.track('123RFLimit');
            }
            if (img.complete) {
                showDialog();
            } else {
                img.onload = showDialog;
                img.onerror = showDialog;
            }
            return false;
        } else {
            _123rfSelectedImages++;
            return true;
        }
    }

    var itemRemovedFromInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }
        _123rfSelectedImages--;
    }

    var beforeSubsectionShow = function (subsection) {
        if (subsection.getId() === diyfmconst123rf  && window.localStorage) {
            var _123rfMessageUnderstood = '_123rfMessageUnderstood' + diywebsiteid;
            var localData = JSON.parse(window.localStorage.getItem(_123rfMessageUnderstood));
            if (!localData) {
                // show dialog
                var btnAction = function() {
                    window.localStorage.setItem(_123rfMessageUnderstood, JSON.stringify(true));
                    premiumDialog.closeDialog();
                };
                premiumDialog.showInitialDialog(btnAction, maxNumberOfImages);
            }
        }
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        isAvailable: isAvailable,
        getToolbarItems: getToolbarItems,
        beforeInsert: beforeInsert,
        canAddToInsert: canAddToInsert,
        itemRemovedFromInsert: itemRemovedFromInsert,
        beforeSubsectionShow: beforeSubsectionShow
    });
}]);


/***/ },
/* 954 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsubsectionmodel', [
    '$q', 
    'diyl10n', 
    '$timeout', 
    'diyfmitemmodel', 
    'diyfmselectiondata',
function(
    $q, 
    diyl10n, 
    $timeout, 
    diyfmitemmodel, 
    diyfmselectiondata
){
    
    var diyfmsubsectionmodel = function(id, title, source, typeName, defaultParams) {
        this._id = id;
        this._title = title;
        this._source = source;
        
        this._typeName = typeName;
        this._defaultParams = defaultParams || {};
        
        this._section = undefined;
        this._items = undefined;
        this._search = '';
        this._colorSearch = null;
        this._allItemsLoaded = false;
        
        this._loadingDefer = $q.defer();
    };
    
    angular.extend(diyfmsubsectionmodel.prototype, {
        _actions: [],
        _itemActions: [],

        isNew: function() {
            return false;
        },
        
        getSection: function() {
            return this._section;
        },
        
        getSource: function() {
            return this._source;
        },
        
        getItemsProvider: function() {
            return this.getSource().getItemsProvider();
        },

        getId: function() {
            return this._id;
        },

        getTitle: function() {
            return this._title;
        },

        getTypeName: function() {
            return this._typeName;
        },

        getItems: function() {
            return this._items;
        },
        
        setTitle: function(newTitle) {
            this._title = newTitle;
        },

        setSource: function(newSource) {
            this._source = newSource;
        },
        
        clearItemsCache: function() {
            this._items = undefined;
            this._allItemsLoaded = false;
            this._loadingDefer.reject();
            this._loadingDefer = $q.defer();
        },
        
        getDefaultParams: function() {
            return this._defaultParams;
        },
        
        loadItems: function(offset, limit) {
            var defer = $q.defer();
            
            this.getItemsProvider()
                .queryRange(angular.extend(this.getDefaultParams(), {
                    search: this.getSearch(),//TODO: refactor this to support multiple search vectors
                    colorSearch: this.getColorSearch()
                }), offset, limit)
                .then(function(data) {
                    defer.resolve(data);
                });
            
            return defer.promise;
        },
        
        _instanciateItem: function(resource) {
            return new diyfmitemmodel(resource, this.getSource());
        },
        
        getOrLoadAllItems: function() {
            var defer = $q.defer(), self = this;
            
            if (this._allItemsLoaded) {
                defer.resolve(this._items);
            } else {
                // do a loading of missing range
                var 
                    firstUndef, 
                    lastUndef,
                    offset,
                    limit,
                    i
                ;
                if (this._items !== undefined) {
                    for(i = 0; i < this._items.length; i++) {
                        if (this._items[i] === undefined) {
                            firstUndef = i;
                            break;
                        }
                    }
                    for(i = this._items.length - 1; i >= 0; i--) {
                        if (this._items[i] === undefined) {
                            lastUndef = i;
                            break;
                        }
                    }
                    if (firstUndef !== undefined) {
                        offset = firstUndef;
                        limit = lastUndef - firstUndef + 1;
                    } else {
                        // let offset to be undefined to not perform any loading
                        // it seems that we are inprogress with loading
                    }
                } else {
                    // nothing loaded, we need all
                    offset = 0;
                }
                if (offset !== undefined) {
                    this.retrieveItems(offset, limit);
                }
                this._loadingDefer.promise.then(function(){
                    defer.resolve(self._items);
                }, function(){
                    defer.reject();
                });
            }

            return defer.promise;
        },
        
        retrieveItems: function(offset, limit) {
            if (this._search == '' && this._itemsBeforeSearch) {
                this._items = this._itemsBeforeSearch._items;
                this._allItemsLoaded = this._itemsBeforeSearch._allItemsLoaded;
                this._itemsBeforeSearch = null;
            }
            var 
                self = this,
                defer = $q.defer(),
                ret = [],
                shouldLoad = false,
                loadOffset = offset,
                initialLoad = false,
                items = this._items
            ;
            if (items === undefined) {
                shouldLoad = true;
                initialLoad = true;
            } else if (items.length === 0) {
                defer.resolve(ret);
            } else {
                var 
                    from = Math.min(offset, items.length - 1),
                    to = Math.min(items.length - 1, offset + limit - 1),
                    firstUndef,
                    lastUndef
                ;
                for (var i = from; i <= to; i++) {
                    if (items[i] === undefined) {
                        if (firstUndef === undefined) {
                            firstUndef = i;
                        }
                        lastUndef = i;
                        // create items with an empty resource
                        // it will be set later after data loaded from server                        
                        items[i] = this._instanciateItem({});
                    }
                    ret.push(items[i]);
                }
                // let's do a quick promise resolve, even if maybe not all returned items
                // have loaded resources
                defer.resolve(ret);
                
                if (firstUndef !== undefined) {
                    shouldLoad = true;
                    if (firstUndef > from) {
                        // do "forward" loading, perhaps a use-case when 
                        // scrolling to bottom
                        loadOffset = firstUndef;
                    } else if (lastUndef < to) {
                        // do "backward" loading, perhaps a use-case when 
                        // scrolling to bottom
                        loadOffset = Math.max(0, lastUndef - limit + 1);
                    }
                    // normalize limit
                    limit = Math.min(this._items.length - loadOffset, limit);
                    // create items with an empty resource
                    // it will be set later after data loaded from server
                    var loadTo = loadOffset + limit - 1;
                    for (var j = loadOffset; j <= loadTo; j++) {
                        if (items[j] === undefined) {
                            items[j] = this._instanciateItem({});
                        }
                    }
                }
            }
            if (shouldLoad) {
                // TODO put loadPromises in an array
                // so that on user cancel we can reject them 
                this.loadItems(loadOffset, limit)
                    .then(function(data) {
                        var j, i = loadOffset, resources = data.items;
                        
                        if (initialLoad) {
                            self._items = new Array(parseInt(data.totalCount, 10));
                            for(j = 0; j < resources.length; j++, i++) {
                                ret.push(self._items[i] = self._instanciateItem(resources[j]));
                            };
                            defer.resolve(ret);
                        } else {
                            for(j = 0; j < resources.length; j++, i++) {
                                self._items[i].setResource(resources[j]);
                            };
                        }
                        self._loadingDefer.notify();
                        var hasUndefined = false, k;
                        for (k = self._items.length - 1; k >= 0; k --) {
                            if (self._items[k] === undefined) {
                                hasUndefined = true;
                                break;
                            }
                        }
                        if (!hasUndefined) {
                            self._allItemsLoaded = true;
                            self._loadingDefer.resolve();
                        }
                    });
            }
            return defer.promise;
        },

        getActions: function() {
            return this._actions;
        },

        getItemActions: function() {
            return this._itemActions;
        },

        canMoveTo: function() {
            return false;
        },
        
        getSearch: function() {
            return this._search;
        },
        
        setSearch: function(newSearch) {
            if (newSearch !== this._search) {
                if (this._search == '' && this._colorSearch === null) {
                    this._itemsBeforeSearch = {
                        _items: this._items,
                        _allItemsLoaded: this._allItemsLoaded
                    };
                }
                this._search = newSearch;
                this.clearItemsCache();
                diyfmselectiondata.removeAllItems(['select']);
            }
        },

        getColorSearch: function() {
            return this._colorSearch;
        },

        setColorSearch: function(newSearch) {
            if (newSearch !== this._colorSearch) {
                this._itemsBeforeSearch = null;
                this._colorSearch = newSearch;
                this.clearItemsCache();
                diyfmselectiondata.removeAllItems(['select']);
            }
        },

        resetSearch: function() {
            this.setSearch('');
        },
        
        setId: function(newId) {
            if (this._id.id) {
                throw new Error('Ids cannot be changed. Only initially set');
            }
            this._id = newId;
        },
        
        getItemIndex: function(item) {
            return this._items && this._items.indexOf(item);
        }
    });
    return diyfmsubsectionmodel;
}]);

/***/ },
/* 955 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmfoldermodel', [
    '$q', 
    '$timeout', 
    '$injector', 
    'diyfmsubsectionmodel', 
    'diyl10n', 
    'diyfmfolders', 
    'diyfmsourcestorage', 
    'diyfmfileitemmodel',
    'diyfmselectiondata', 
    'diyfmuploadqueue', 
    'diyfmconststorage', 
    'diyfilevalidator',
    'diyglobalevents',
function(
    $q, 
    $timeout, 
    $injector, 
    diyfmsubsectionmodel, 
    diyl10n, 
    diyfmfolders, 
    diyfmsourcestorage, 
    diyfmfileitemmodel,
    diyfmselectiondata, 
    diyfmuploadqueue, 
    diyfmconststorage, 
    diyfilevalidator,
    diyglobalevents
){
    
    var 
        fileResource = diyfmsourcestorage.getItemsProvider()
    ;

    // constructor
    var diyfmfoldermodel = function (id, title, folderResource) {
        var self = this;
        
        this._folderResource = folderResource || new diyfmfolders();
        
        this._observers = [];
        
        diyfmsubsectionmodel.call(this, id, title, diyfmsourcestorage, 'customerFiles'); //call parent constructor
    };
    
    // diyfmfoldermodel extends diyfmsubsectionmodel
    diyfmfoldermodel.prototype = Object.create(diyfmsubsectionmodel.prototype);
    
    // public methods
    angular.extend(diyfmfoldermodel.prototype, {
        _emptyActions: [], // used for folders that are not yet saved on server side
        _actions: [
            {
                name: 'rename',
                icon: 'rename',
                title: diyl10n('filemanager.sections.menu.rename')
            }, {
                name: 'delete',
                icon: 'trash',
                title: diyl10n('filemanager.sections.menu.delete')
            }
        ],
        _itemActions: [{
            name: 'rename',
            icon: 'rename',
            title: diyl10n('filemanager.items.menu.rename')
        }, {
            name: 'delete',
            icon: 'trash',
            title: diyl10n('filemanager.items.menu.delete')
        }, {
            name: 'download',
            icon: 'download',
            title: diyl10n('filemanager.items.menu.download')
        }, {
            name: 'preview',
            icon: 'preview',
            title: diyl10n('filemanager.items.menu.preview')
        }],
        isNew: function() {
            return !this._folderResource.id;
        },
        'delete': function() {
            var self = this;
            return this._folderResource.$delete().then(function(){
                self.notifyObservers('deleted');
            });
        },
        setTitle: function(newTitle) {
            var self = this;
            diyfmsubsectionmodel.prototype.setTitle.apply(this, arguments);// call super
            
            this._folderResource.name = newTitle;
            
            if (!this._folderResource.id) {
                this._folderResource.$create().then(function(data) {
                    self.setId({type: diyfmconststorage, id: parseInt(data.id, 10)});
                });
            } else {
                this._folderResource.$update();
            }
        },
        
        getActions: function() {
            // actions are supported only for saved
            // folders, that have an id identifier
            if (this._folderResource.id) {
                return this._actions;
            } else {
                return this._emptyActions;
            }
        },
        
        getDefaultParams: function()
        {
            return {
                folderId: this._folderResource.id
            }
        },
        
        _instanciateItem: function(resource) {
            return new diyfmfileitemmodel(resource); 
        },        
        
        uploadFiles: function(files) {
            var self = this, uploadQueue, deferred = $q.defer(), uploadErrors = [], itemsCreated = [];

            if (!this._items) {
                this._items = [];
            }
            // to keep the order in which user selected files
            // we should reverse them here
            var reversedFiles = [];
            angular.forEach(files, function(file, i) {
                reversedFiles.unshift(file);
            });

            angular.forEach(reversedFiles, function(file, i) {
                // client-side validation of the file
                var validation = diyfilevalidator.validate(file, {
                    maxSize: 20971520, // 20 MB
                    type: ['.jpg', '.jpeg', '.png', '.gif']
                });
                // if file passed validation, add it
                if (validation === true) {
                    var fileItem = new diyfmfileitemmodel();
                    fileItem.setName(file.name);
                    fileItem.setFolderId(self.getFolderId());
                    self._items.unshift(fileItem);
                    fileItem.$create(file).then(function(item) {
                        deferred.notify({item: item});
                        itemsCreated.push(item);
                    }, function(reason) {
                        // error or user cancel
                        self.deleteItems([fileItem]);

                        if (reason !== 'cancel') { // if error (not user cancel)
                            // log error that happened during server-side upload
                            uploadErrors.push({
                                file: file,
                                error: reason
                            });
                        }
                    });
                } else {
                    // log client-side validation errors
                    uploadErrors.push({
                        file: validation.file,
                        error: validation.error
                    });
                }
            });

            uploadQueue = diyfmuploadqueue.get('storageFiles');
            // if not all failed, start upload
            if (uploadErrors.length !== files.length) {
                uploadQueue.start();

                uploadQueue.getPromise().then(function() {
                    self.notifyObservers('itemsCreated', itemsCreated);
                    deferred.resolve({items: itemsCreated, uploadErrors: uploadErrors});
                });
            } else { // if all failed, cancel and return errors
                uploadQueue.cancel();
                deferred.resolve({uploadErrors: uploadErrors});
            }

            return deferred.promise;
        },

        canMoveTo: function() { 
            return !this.isNew();
        }, 
        
        _removeItemsOnMove: function(moveItems) {
            var i, index;
            if (typeof this._items === 'undefined') {
                return;
            }
            for (i = 0; i < moveItems.length; i++) {
                index = this._items.indexOf(moveItems[i]);
                if (index !== -1) {
                    this._items.splice(index, 1);
                }
            }
        },

        moveItems: function(moveItems, destinationFolder) {
            var 
                i,
                self = this,
                idsToMove = [], 
                itemsToMove = [],
                folderId = destinationFolder.getFolderId()
            ;
            // we should verify if they are not already in this 
            // folder (could happen when dragging from AllImagesSubsection)
            for(i = 0; i < moveItems.length; i++) {
                if (moveItems[i].getFolderId() !== folderId) {
                    itemsToMove.push(moveItems[i]);
                    idsToMove.push(moveItems[i].getId());
                }
            }
            if (itemsToMove.length > 0) {
                this._removeItemsOnMove(itemsToMove);
                this.notifyObservers('beforeItemsUpdated', itemsToMove);
                
                for(i = 0; i < itemsToMove.length; i++) {
                    itemsToMove[i].setFolderId(folderId);
                }
                
                fileResource.update({ids: idsToMove, folderId: folderId}, function(){
                    self.notifyObservers('itemsUpdated', itemsToMove);
                });
                
                destinationFolder._afterItemsMoved(moveItems);
            }
        },
        
        _afterItemsMoved: function(moveItems) {
            // we should invalidate loaded items
            // they should be freshly loaded from server
            // because we cannot guaranty correct sorting order
            // if we move them also client-side
            this.clearItemsCache();
        },

        deleteItems: function(deleteItems) {
            var index, deleteItemsIds = [], itemId, self = this, itemsDeleted = [];
            
            // XXX iterate in reverse order, because it may be that
            // deleteItems are the same as 'select' collection
            // so deleting it from 'select' will modify deleteItems array
            for (var i = deleteItems.length - 1; i >= 0; i--) {
                itemId = deleteItems[i].getId();
                // checking if this is a persisted resource, otherwise 
                // we should not delete it on the server
                if (itemId) {
                    deleteItemsIds.push(itemId);
                    itemsDeleted.push(deleteItems[i]);
                }
                if ((index = this._items.indexOf(deleteItems[i])) > -1) {
                    this._items.splice(index, 1);
                }
                diyfmselectiondata.removeItem(deleteItems[i], ['select', 'insert']);
            }
            if (deleteItemsIds.length > 0) {
                fileResource.batchDelete(deleteItemsIds).then(function(){
                    self.notifyObservers('itemsDeleted', itemsDeleted);
                    diyglobalevents.trigger('diy-editor-filemanager-deletedFiles', {});
                });
            }
        },
        
        getFolderId: function() {
            return this.getId().id;
        },
        /* Implementing Observer pattern
         * a folder can be observable
         */
        attachObserver: function(observer){
            this._observers.push(observer);
        },
        detachObserver: function(observer) {
            var obsIndex = this._observers.indexOf(observer);
            if (objIndex > -1) {
                this._observers.splice(obsIndex, 1);
            }
        },
        notifyObservers: function(event, data) {
            var observer;
            for (var i = 0, len = this._observers.length; i < len; i++) {
                observer = this._observers[i];
                observer.update.apply(observer, [this, event, data]);
            }
        },
        /* Implementing Observer pattern
         * a folder can observe
         */
        update: function(subject, event, data) {
            
            diyfmallimagesmodel = $injector.get('diyfmallimagesmodel');
            
            if (subject instanceof diyfmallimagesmodel) {
                switch(event) {
                    case 'itemsDeleted':
                    case 'itemsCreated':
                    case 'beforeItemsUpdated':
                        if (this._items !== undefined) {
                            var items = data;
                            for (var i = 0, len = items.length; i < len; i ++) {
                                if (items[i].getFolderId() == this.getFolderId()) {
                                    // TODO make a smarter handler that actually updates it's local cache
                                    // based on provided data
                                    this.clearItemsCache();
                                    break;
                                }
                            }
                        }
                        break;
                }
            }
        }
    });
    
    return diyfmfoldermodel;
}]);

/***/ },
/* 956 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmunsortedmodel', [ 
    'diyfmfoldermodel',
    'diyfmconststorage',
function(
    diyfmfoldermodel,
    diyfmconststorage
){
    
    // constructor
    var diyfmunsortedmodel = function (title) {
        diyfmfoldermodel.apply(this, [{
            id: null,
            type: diyfmconststorage
        }, title, {}]); //call parent constructor
    };
    
    // UnsortedFolderSubsection extends FolderSubsection
    diyfmunsortedmodel.prototype = Object.create(diyfmfoldermodel.prototype);
    
    // public methods
    angular.extend(diyfmunsortedmodel.prototype, {
        isNew: function() {
            return false;
        },
        setTitle: function(newTitle) {
            throw new Error("Can't change title for this");
        },

        getActions: function() {
            return this._emptyActions;
        },
        
        getDefaultParams: function()
        {
            return {
                folderId: 0 /* Unsorted virtual folder should provide 0 */
            }
        }
    });
    return diyfmunsortedmodel;
}]);

/***/ },
/* 957 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmallimagesmodel', [
    'diyfmconststorage', 
    'diyfmfoldermodel' /* it's required even if not directly used */,
function(diyfmconststorage, diyfmfoldermodel) {

    // constructor
    var diyfmallimagesmodel = function (title) {
        diyfmfoldermodel.apply(this, [{
            type: diyfmconststorage
        }, title, {}]); //call parent constructor
    };
    
    // diyfmallimagesmodel extends diyfmfoldermodel
    diyfmallimagesmodel.prototype = Object.create(diyfmfoldermodel.prototype);
    
    // public methods
    angular.extend(diyfmallimagesmodel.prototype, {
        isNew: function() {
            return false;
        },
        setTitle: function(newTitle) {
            throw new Error("Can't change title for AllImagesSubsection");
        },

        getActions: function() {
            return this._emptyActions;
        },

        canMoveTo: function() { 
            return false; 
        },
        
        _removeItemsOnMove: function(moveItems) {
            // to nothing as after move items should be still in "all images"
        },
        
        _afterItemsMoved: function(moveItems) {
            // do nothing here because on move it is still in all images collection
            // but we still need to clear caches on real source folders
        },
        
        getDefaultParams: function()
        {
            return {}; // no folderId filter provided
        },
        /* Implementing Observer pattern
         * a folder can observe
         */
        update: function(subject, event, data) {
            if (subject instanceof diyfmfoldermodel) {
                switch(event) {
                    case 'deleted':
                    case 'itemsDeleted':
                    case 'itemsCreated':
                    case 'itemsUpdated':
                        // TODO make a smarter handler that actually updates it's local cache
                        // based on provided data
                        this.clearItemsCache();
                        break;
                }
            }
        }
                
    });
    return diyfmallimagesmodel;
}]);

/***/ },
/* 958 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmitemmodel', [ function() {
    
    // constructor
    var diyfmitemmodel = function(itemResource, source) {
        this._itemResource = itemResource;
        this._source = source;
        this._hash = null;
    };

    // public methods
    angular.extend(diyfmitemmodel.prototype, {
        getHash: function() {
            if (!this._hash) {
                this._hash = JSON.stringify({id: this.getId(), sourceName: this.getSource().getName()});
            }

            return this._hash;
        },
        getResource: function() {
            return this._itemResource;
        },
        setResource: function(resource) {
            // invalidate hash
            this._hash = null;
            return this._itemResource = resource;
        },
        getId: function() {
            return this._itemResource.id;
        },
        getSource: function() {
            return this._source;
        },
        getThumb: function() {
            return this._itemResource.thumb;
        },
        getPreview: function() {
            return this._itemResource.preview;
        },
        getFile: function() {
            return this._itemResource.file;
        },
        setThumb: function(thumb) {
            this._itemResource.thumb = thumb;
        },
        setPreview: function(preview) {
            this._itemResource.preview = preview;
        },
        canSelect: function() { 
            return typeof this.getId() !== 'undefined';
        },
        canMove: function() { 
            return false; 
        },
        hasName: function() {
            return false;
        }
    });    
    
    return diyfmitemmodel
}]);



/***/ },
/* 959 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmfileitemmodel', [
    '$q', 
    'diyfmitemmodel', 
    'diyfmsourcestorage', 
    'diyfmuploadqueue', 
    'diywebsiteid', 
    'diyimageresize',
function(
    $q, 
    diyfmitemmodel, 
    diyfmsourcestorage, 
    diyfmuploadqueue, 
    diywebsiteid, 
    diyimageresize 
){
    
    var 
        fileResource = diyfmsourcestorage.getItemsProvider()
    ;

    // constructor
    var diyfmfileitemmodel = function (itemResource) {
        
        if (!itemResource) {
            itemResource = new fileResource();
        }
        
        diyfmitemmodel.call(this, itemResource, diyfmsourcestorage); //call parent constructor
        
        this._uploadProgress = undefined;
        this._uploadedThumb = undefined;
    };
    
    // diyfmfileitemmodel extends diyfmitemmodel
    diyfmfileitemmodel.prototype = Object.create(diyfmitemmodel.prototype);
    
    // public methods
    angular.extend(diyfmfileitemmodel.prototype, {
        setName: function(name) {
            this._itemResource.publicName = name;
        },
        
        getName: function() {
            return this._itemResource.publicName;
        },
        
        getFolderId: function() {
            return this._itemResource.folderId;
        },
        
        setFolderId: function(folderId) {
            this._itemResource.folderId = folderId;
        },
        
        $delete: function() {
            return this._itemResource.$delete();
        },
        
        $create: function(file) {
            var self = this, defer = $q.defer();
            this._uploadProgress = 0;
            this._uploadedFile = file;
            
            // normalize folderId
            if (typeof this._itemResource.folderId === 'undefined') {
                this._itemResource.folderId = null;
            }

            diyfmuploadqueue.get('storageFiles').add({
                file: file,
                data: {
                    publicName: this.getName(),
                    folderId: this.getFolderId()
                },
                url: '/rest/websites/' + diywebsiteid + '/storage-files'
            }).then(function(responseText) {
                self.setResource(new fileResource(JSON.parse(responseText)));
                self._uploadedFile = undefined;
                self._uploadedThumb = undefined;
                defer.resolve(self);
            }, function(w) { // propagate errors further
                self._uploadedFile = undefined;
                self._uploadedThumb = undefined;
                defer.reject(w);
            }, function(progress) {
                self._uploadProgress = progress;
                defer.notify(progress);
            });
            return defer.promise;
        }, 
        
        getUploadedThumb: function() {
            var self = this;
            var deferred = $q.defer();
            var uploadedFile = this._uploadedFile;
            if (uploadedFile) {
                if (this._uploadedThumb) {
                    deferred.resolve(this._uploadedThumb);
                } else {
                    diyimageresize.getImageByFile(uploadedFile).then(function(img) {
                        self._uploadedThumb = diyimageresize.resize(img, 200, 200);
                        deferred.resolve(self._uploadedThumb);
                    });
                }
                return deferred.promise;
            }
        },
        
        getUploadProgress: function() {
            return this._uploadProgress;
        },
        
        $update: function() {
            return this._itemResource.$update();
        },

        canMove: function() {
            return true;
        },

        hasName: function() {
            return true;
        }
    });
    
    return diyfmfileitemmodel;
}]);

/***/ },
/* 960 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsectionmodel', [function() {

    // constructor
    var diyfmsectionmodel = function(id, title) {
        this._id = id;
        this._title = title;

        this._actions = [];
    };

    // public methods
    angular.extend(diyfmsectionmodel.prototype, {
        
        getId: function() {
            return this._id;
        },
        
        getTitle: function() {
            return this._title;
        },
        
        getActions: function() {
            return this._actions;
        },

        getSubsections: function() {
            return this._subsections;
        },

        addSubsection: function(subsection, index) {
            if (index === undefined) {
                this._subsections.push(subsection);
            } else {
                this._subsections.splice(index, 0, subsection);
            }
            // XXX we access a private property of subsection 
            // because we don't want to expose a public setSection there
            // because it will be confusing from where should be estabilish
            // this relationship
            subsection._section = this;
        },
        
        initializeSubsections: function(sources) {
            this._subsections = [];
        }
    });
    return diyfmsectionmodel;
}]);

/***/ },
/* 961 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsectionstorage', [
    '$timeout', 
    'diyl10n', 
    'diyfmsectionmodel', 
    'diyfmfoldermodel', 
    'diyfmconststorage', 
    'diyfmunsortedmodel',
    'diyappevents',
    'diyfmfolders',
    'diywebsiteid',
    'diyfmsourcestorage',
    'diyfmallimagesmodel',
function(
    $timeout, 
    diyl10n, 
    diyfmsectionmodel, 
    diyfmfoldermodel, 
    diyfmconststorage, 
    diyfmunsortedmodel,
    diyappevents,
    diyfmfolders,
    diywebsiteid,
    diyfmsourcestorage,
    diyfmallimagesmodel
) {

    var model = diy.core.namespace('diy.editor.fm.model');

    // constructor
    var diyfmsectionstorage = function () {
        diyfmsectionmodel.call(this, 'customerSection', diyl10n('filemanager.customerSection.title')); //call parent constructor
    }; 
    
    // diyfmsectionstorage extends diyfmsectionmodel
    diyfmsectionstorage.prototype = Object.create(diyfmsectionmodel.prototype);
    
    // static methods
    diyfmsectionstorage.getOrder = function() {
        return 0;
    };
    
    // public methods
    angular.extend(diyfmsectionstorage.prototype, {
        initializeSubsections: function(sources) {
        	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);
            
            this._allimagesFolder = new diyfmallimagesmodel(diyl10n('filemanager.customerSection.allImagesFolder'));
            this.addSubsection(this._allimagesFolder);
            this._unsortedFolder = new diyfmunsortedmodel(
                diyl10n('filemanager.customerSection.unsortedFolder')
            );
            this.addSubsection(this._unsortedFolder, 1);
            
            /* get the folders from the server */
            diyfmfolders.query(function(folders){
                var i;

                for (i = 0; i < folders.length; i++) {
                    this.addSubsection(new diyfmfoldermodel({
                        type: diyfmconststorage,
                        id: parseInt(folders[i].id, 10)
                    }, folders[i].name, folders[i]));
                }
                diyappevents.trigger('subSectionsLoaded', 'diyfmsourcestorage');
            }.bind(this)); 
            
            this._actions.push({
                title: diyl10n('filemanager.customerSection.addFolder'),
                handler: function($event, section) {
                    var newSubsection = new diyfmfoldermodel({type: diyfmconststorage, id: null}, '');
                    section.addSubsection(newSubsection);
                    $event.stopPropagation();
                },
                icon: 'ui-icon-1and1-add-folder'
            });
        },
        addSubsection: function(subsection, index) {
            // call parent method
            if (index !== undefined) {
                diyfmsectionmodel.prototype.addSubsection.apply(this, arguments);
            } else {
                // user generated folders should be inserted before the last ("Unsorted")
                diyfmsectionmodel.prototype.addSubsection.apply(this, [subsection, -1]);
            }
            
            if (this._allimagesFolder && !(subsection instanceof diyfmallimagesmodel)) {
                subsection.attachObserver(this._allimagesFolder);
                this._allimagesFolder.attachObserver(subsection);
            }
        },
        getFolderSectionById: function(folderId) {
            for(var i = 0, len = this._subsections.length; i < len; i++) {
                if (this._subsections[i].getFolderId() == folderId
                   && this._allimagesFolder !== this._subsections[i]
                ) {
                    return this._subsections[i]; 
                }
            }
        },
        getDefaultUploadSubsection: function() {
            return this._unsortedFolder;
        },
        getAllImagesSubsection: function() {
            return this._allimagesFolder;
        }
    });
    
    return diyfmsectionstorage;
}]);

/***/ },
/* 962 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsectioncompany', [
    '$timeout', 
    'diyl10n', 
    'diyfmsectionmodel', 
    'diyfmsubsectionmodel', 
    'diyfmsourcekeyvisuals',
    'diyfmconstkeyvisual',
    'diyfmsourcepatterns',
    'diyfmconstpattern',
    'diyfmsourcecms',
    'diyfmconstcms',
    'diyinfo',
    'diyfmconfig',
function(
    $timeout, 
    diyl10n, 
    diyfmsectionmodel,
    diyfmsubsectionmodel,
    diyfmsourcekeyvisuals,
    diyfmconstkeyvisual,
    diyfmsourcepatterns,
    diyfmconstpattern,
    diyfmsourcecms,
    diyfmconstcms,
    diyinfo,
    diyfmconfig
) {

    // constructor
    var diyfmsectioncompany = function () {
        diyfmsectionmodel.call(this, 'companySection', diyl10n('filemanager.companySection.title')); //call parent constructor
    }; 
    
    // diyfmsectioncompany extends diyfmsectionmodel
    diyfmsectioncompany.prototype = Object.create(diyfmsectionmodel.prototype);
    
    // static methods
    diyfmsectioncompany.getOrder = function() {
        return 1;
    };
    
    // public methods
    angular.extend(diyfmsectioncompany.prototype, {
        initializeSubsections: function(sources) {
           	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);
        
            if (sources.indexOf(diyfmsourcecms) !== -1) {
                if (diyfmsourcecms.isAvailable() || diyfmsourcecms.shouldShowUpsell()) {
                    // all photos section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstcms,
                        diyl10n('filemanager.companySection.photos'),
                        diyfmsourcecms,
                        'cmsPhotos'
                    ));
        
                    // recommendations section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstcms,
                        diyl10n('filemanager.companySection.recommendedPhotos'),
                        diyfmsourcecms,
                        'recommendedCmsPhotos',
                        {topicId: diyinfo.getTopicId()} // default params
                    ));
                }
            }            
            
            if (sources.indexOf(diyfmsourcekeyvisuals) !== -1) {
                this.addSubsection(new diyfmsubsectionmodel(
                    diyfmconstkeyvisual, 
                    diyl10n('filemanager.companySection.keyvisuals'),
                    diyfmsourcekeyvisuals,
                    // TODO refactor to get rid of too many constants
                    'keyvisualsPhotos'
                ));
            }
            if (sources.indexOf(diyfmsourcepatterns) !== -1) {   
                this.addSubsection(new diyfmsubsectionmodel(
                    diyfmconstpattern,
                    diyl10n('filemanager.companySection.patterns'),
                    diyfmsourcepatterns,
                    // TODO refactor to get rid of too many constants
                    'patterns'
                ));
            }

        }
    });
    
    return diyfmsectioncompany;
}]);


/***/ },
/* 963 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsectionbigstock', [
    '$timeout',
    'diyl10n',
    'diyfmsectionmodel',
    'diyfmsubsectionmodel',
    'diyfmsourcebigstock',
    'diyfmsourcestorage',
    'diyfmconstbigstock',
    'diyfmconstbigstockpurchased',
function(
    $timeout,
    diyl10n,
    diyfmsectionmodel,
    diyfmsubsectionmodel,
    diyfmsourcebigstock,
    diyfmsourcestorage,
    diyfmconstbigstock,
    diyfmconstbigstockpurchased
) {

    // constructor
    var diyfmsectionbigstock = function () {
        diyfmsectionmodel.call(this, 'bigstockSection', diyl10n('filemanager.bigstockSection.title').replace(/&amp;/, '&')); //call parent constructor
    };

    // diyfmsectionbigstock extends diyfmsectionmodel
    diyfmsectionbigstock.prototype = Object.create(diyfmsectionmodel.prototype);

    // static methods
    diyfmsectionbigstock.getOrder = function() {
        return 2;
    };

    // public methods
    angular.extend(diyfmsectionbigstock.prototype, {
        initializeSubsections: function(sources) {
           	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);

            if (sources.indexOf(diyfmsourcebigstock) !== -1) {
                if (diyfmsourcebigstock.isAvailable()) {
                    // all photos section //
                    var bigstockSubsection = new diyfmsubsectionmodel(
                        diyfmconstbigstock,
                        diyl10n('filemanager.bigstockSection.photos'),
                        diyfmsourcebigstock,
                        'bigstockPhotos'
                    );
                    this.addSubsection(bigstockSubsection);

                    // preload first 1000 image because Bigstock API is very slow
                    bigstockSubsection.retrieveItems(0, 200).then(function() {
                        for (var offset = 1; offset < 1000; offset += 200) {
                            bigstockSubsection.retrieveItems(offset, 200);
                        }
                    });

                    // purchased photos section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstbigstockpurchased,
                        diyl10n('filemanager.bigstockSection.purchasedPhotos').replace(/&amp;/, '&'),
                        diyfmsourcestorage,
                        'bigstockPurchasedPhotos',
                        {premium: 1}
                    ));
                }
            }
        }
    });

    return diyfmsectionbigstock;
}]);


/***/ },
/* 964 */
/***/ function(module, exports) {

diy.angular.registerFactory('diyfmsection123rf', [
    '$timeout',
    'diyl10n',
    'diyfmsectionmodel',
    'diyfmsubsectionmodel',
    'diyfmsource123rf',
    'diyfmsourcestorage',
    'diyfmconst123rf',
    'diyfmconstbigstockpurchased',
function(
    $timeout,
    diyl10n,
    diyfmsectionmodel,
    diyfmsubsectionmodel,
    diyfmsource123rf,
    diyfmsourcestorage,
    diyfmconst123rf,
    diyfmconstbigstockpurchased
) {

    // constructor
    var diyfmsection123rf = function () {
        diyfmsectionmodel.call(this, '123rfSection', diyl10n('filemanager.bigstockSection.title').replace(/&amp;/, '&')); //call parent constructor
    };

    // diyfmsection123rf extends diyfmsectionmodel
    diyfmsection123rf.prototype = Object.create(diyfmsectionmodel.prototype);

    // static methods
    diyfmsection123rf.getOrder = function() {
        return 2;
    };

    // public methods
    angular.extend(diyfmsection123rf.prototype, {
        initializeSubsections: function(sources) {
           	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);

            if (sources.indexOf(diyfmsource123rf) !== -1) {
                if (diyfmsource123rf.isAvailable()) {
                    // all photos section //
                    var _123rfSubsection = new diyfmsubsectionmodel(
                        diyfmconst123rf,
                        diyl10n('filemanager.bigstockSection.photos'),
                        diyfmsource123rf,
                        '123rfPhotos'
                    );
                    this.addSubsection(_123rfSubsection);

                    // purchased photos section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstbigstockpurchased,
                        diyl10n('filemanager.bigstockSection.purchasedPhotos').replace(/&amp;/, '&'),
                        diyfmsourcestorage,
                        '123rfPurchasedPhotos',
                        {premium: 1}
                    ));
                }
            }
        }
    });

    return diyfmsection123rf;
}]);


/***/ },
/* 965 */
/***/ function(module, exports) {

diy.angular.registerController('diyfmmain', ['$scope', 'diyfmsectionsdata', 'diyfminsertprogress', 'diyfmconfig', 'diyfmblocking', 'diyfmtracking', 
function($scope, diyfmsectionsdata, diyfminsertprogress, diyfmconfig, diyfmblocking, diyfmtracking) {

    $scope.sections = diyfmsectionsdata;
    
    $scope.$watch(diyfmsectionsdata.getCurrentSubsection, function(newSubsection){
        $scope.currentSubsection = newSubsection;
    });
    
    $scope.insertprogress = diyfminsertprogress;
    $scope.config = diyfmconfig;
    
    $scope.$on('uploadFiles.up', function(event, files, subsection, addToInsert, uploadSource){
        // we should broadcast a different event name
        // to not get back here
        $scope.$broadcast('uploadFiles.down', files, subsection, addToInsert, uploadSource);
    });
    
    $scope.diyfmblocking = diyfmblocking;

    $scope.dropFilesConfig = {
        eventName: 'uploadFiles.up',
        source: 'drag'
    };

}]);

/***/ },
/* 966 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmthumbnail', ['$timeout', 'diyfmselectiondata', 'diyfmconfig',
function($timeout, diyfmselectiondata, diyfmconfig) {
    
    return {
        template: '\
            <div draggable="{{draggable}}" class="fm-thumb" \
                ng-class="{\
                    \'fm-thumb-noname\': !item.getName(),\
                    \'fm-thumb-selected\': selected,\
                    \'fm-thumb-inserted\': inserted\
            }">\
                <div class="fm-thumb-btns">\
                    <button class="fm-thumb-add ui-button">\
                        <span class="ui-icon ui-icon-add"></span>\
                    </button>\
                    <button class="fm-thumb-preview ui-button">\
                        <span class="ui-icon ui-icon-preview"></span>\
                    </button>\
                    <button class="fm-thumb-menu ui-button">\
                        <span class="ui-icon ui-icon-menu"></span>\
                    </button>\
                </div>\
                <div class="fm-thumb-img" diyfmprogress="progressConfig">\
                    <img ng-src="{{itemThumb}}" ng-style="item.getSource().getThumbStyle(item)" />\
                </div>\
                <div class="fm-thumb-name" \
                    ng-show="diyfmconfig.shouldShowFileNames()"\
                    diyfminlineedit="nameEditConfig" \
                    ng-bind-html="item.getName()" title="{{item.getName()}}"></div>\
            </div>',
        restrict: 'A',
        scope: true,
        compile: function(elem, iattr, transclude) {
            return {
                pre: function(scope, elem, iattr) {

                    scope.diyfmconfig = diyfmconfig;
                    
                    scope.$watch('item.getThumb()', function(newValue, oldValue) {
                        if (newValue) {
                            scope.itemThumb = newValue;
                        } else if (!scope.itemThumb && typeof scope.item.getUploadedThumb === 'function') {
                            var generateUploadThumbPromise = scope.item.getUploadedThumb();
                            if (generateUploadThumbPromise !== undefined) {
                                generateUploadThumbPromise.then(function(thumb) {
                                    scope.itemThumb = thumb;
                                });
                            }
                        }
                    });
                    scope.draggable = "true";
                    
                    // Firefox drag&drop issue - http://stackoverflow.com/a/21682033/1030269
                    var draggableAttributeToggle = function(enable) {
                        scope.draggable = enable ? 'true' : 'false';
                    }

                    scope.nameEditConfig = {
                        beforeStart: function() {
                            draggableAttributeToggle(false);
                        },
                        end: function(value) {
                            scope.renameItem(scope.item, value);
                            draggableAttributeToggle(true);
                        },
                        cancel: function() {
                            draggableAttributeToggle(true);
                        }
                    };
                    
                    scope.progressConfig = {
                       getter: scope.item.getUploadProgress ? function() {
                           return scope.item.getUploadProgress();
                       } : angular.noop,
                       runOnce: true
                    };
                    
                    // selection & insertion logic
                    scope.selected = diyfmselectiondata.isItemSelected(scope.item);
                    scope.inserted = diyfmselectiondata.isItemInserted(scope.item);

                    scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(newValue, oldValue) {
                        if (newValue !== oldValue) {
                            scope.selected = diyfmselectiondata.isItemSelected(scope.item);
                            scope.inserted = diyfmselectiondata.isItemInserted(scope.item);
                        }
                    });

                    // Optimization: As we can potentially have thousdans of images here.
                    // For this, we watch the upload progress and do the opacity in a watch
                    // and then remove it
                    var 
                        $thumb,
                        uploadProgress = 'function' === typeof scope.item.getUploadProgress ? scope.item.getUploadProgress() : undefined
                    ;
                    
                    if(uploadProgress !== undefined && uploadProgress < 1) {
                        var removeProgressWatch = scope.$watch('item.getUploadProgress()', function(newProgress, oldProgress) {
                            // if we've got a progress event (eg. 0%, 5%, 10%, etc) 
                            if (typeof newProgress !== 'undefined') {
                                // we create the reference to the whole thumb element
                                if (!$thumb) {
                                    $thumb = jQuery(elem).find('.fm-thumb');
                                    $thumb.css('opacity', '0.5');
                                    $thumb.addClass('fm-uploading');
                                }
                                
                                // if progress reached 100%
                                if (newProgress >= 1) {
                                    setTimeout(function() {
                                        // switch back to full opacity
                                        $thumb.css('transition', 'opacity .2s');
                                        $thumb.css('opacity', '');
                                        // afterwards, remove the watch
                                        setTimeout(function() {
                                            $thumb.css('transition', '');
                                            $thumb.removeClass('fm-uploading');
                                            removeProgressWatch();
                                        }, 200);
                                    }, 200);                        
                                }
                            }
                        });
                    }
                }
            };
        }
    };
}]);


/***/ },
/* 967 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmtoolbarsearch', ['diyl10n', 'diyfmsectionsdata', 'diyfmtracking',
function(diyl10n, diyfmsectionsdata, diyfmtracking) {
    
    var tpl = '\
        <div class="fm-toolbar-search" \
            diysearchbox="searchConfig" ng-model="searchQuery"></div>\
    ';

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            
            scope.searchConfig = {};
            
            scope.$watch(function() {
                return diyfmsectionsdata.getCurrentSubsection().getTitle();
            }, function(newTitle) {
                scope.searchConfig.placeholder = diyl10n('filemanager.search.placeholder').format(newTitle);
            });
            
            // Current search can change from subsection, like when 
            // subsection changed or when user clicked on breadcrumb
            // so we should keep local searchQuery in sync with it
            scope.$watch(function() {
                return diyfmsectionsdata.getCurrentSubsection().getSearch();
            }, function(newSearch) {
                scope.searchQuery = newSearch;
            });
            
            // When local searchQuery really changed
            // trigger subsection search (serSearch will actually perform search)
            scope.$watch('searchQuery', function(newSearch, oldSearch) {
                if (newSearch !== oldSearch) {
                    var subsection = diyfmsectionsdata.getCurrentSubsection();
                    if (subsection.getSearch() !== newSearch) {
                        diyfmtracking.track('newSearch', {search: newSearch});
                        subsection.setSearch(newSearch);
                    }
                }
            });
        }
    };
}]);


/***/ },
/* 968 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmtoolbarselectall', ['diyl10n', 'diyfmselectiondata', 'diyfmmessages', 'diyfmsectionsdata', 'diyfmblocking',
function(diyl10n, diyfmselectiondata, diyfmmessages, diyfmsectionsdata, diyfmblocking) {
    var $ = jQuery;
    var selectAllCounter = 1;
    
    var tpl = '\
        <input type="checkbox" class="fm-toolbar-select"\
            /><label class="ui-button-borderless fm-toolbar-select-label"></label>\
    ';

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            
            var 
                $elem = $(elem),
                allSelected = false, 
                selectElId = 'fm-toolbar-select-' + (selectAllCounter++),
                selectBtn = $elem.find('.fm-toolbar-select')
            ;
            
            var toggleSelectAll = function() {
                allSelected = !allSelected;
                
                if (allSelected) {
                    var unblock = diyfmblocking.block(diyl10n('filemanager.selectInProgress'));
                    $elem.find('.fm-toolbar-select-label .ui-icon').addClass('ui-icon-loading');
                    diyfmsectionsdata.getCurrentSubsection().getOrLoadAllItems().then(function(items){
                        diyfmselectiondata.setSelectionItems(items);
                    }).finally(function(){
                        $elem.find('.fm-toolbar-select-label .ui-icon').removeClass('ui-icon-loading');
                        unblock();    
                    });
                } else {
                    diyfmselectiondata.setSelectionItems([]);
                }
            };
                
            
            $elem.find('.fm-toolbar-select-label').attr('for', selectElId);
            selectBtn
                .attr('id', selectElId)
                .button({
                    icons: {primary: 'ui-icon-1and1-select'},
                    label: diyl10n('filemanager.selectAll'),
                    text: false
                })
                .click(function() {
                    toggleSelectAll();
                    scope.$apply();
                });
            
            var refreshSelectButton = function() {
                var label;
                
                if (allSelected) {
                    label = diyl10n('filemanager.deselectAll');
                } else {
                    label = diyl10n('filemanager.selectAll');
                }
                selectBtn.button('option', 'label', label);
                selectBtn.prop('checked', !!allSelected).button("refresh");
            };
            
            scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(){
                var allItems = diyfmsectionsdata.getCurrentSubsection().getItems();
                var selCount = diyfmselectiondata.getSelectedItems().length;
                if (typeof allItems !== 'undefined') {
                    allSelected = (selCount === allItems.length && selCount > 0);
                } else {
                    allSelected = false;
                }
                refreshSelectButton();
            });

            scope.$watch(function() {
                var items = diyfmsectionsdata.getCurrentSubsection().getItems();
                if (items !== undefined) {
                    return items.length;
                } else {
                    return 0;
                }
            } , function(newLength){
                if (newLength > 0) {
                    selectDisabled = false;
                } else {
                    selectDisabled = true;
                }
                selectBtn.button('option', 'disabled', selectDisabled);
            });
        }
    };
}]);


/***/ },
/* 969 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmtoolbar', [ '$compile',
function($compile) {
    
    var spacerTpl = '<div class="fm-toolbar-spacer"></div>';
    var separatorTpl = '<div class="fm-toolbar-sep"></div>';
    
    function getItemTemplate(item) {
        switch (item) {
            case ' ':
                return '<div class="fm-toolbar-spacer"></div>';
            case '-': 
                return '<div class="fm-toolbar-sep"></div>';
            case 'search':
                return '<div diyfmtoolbarsearch></div>';
            case 'selectall':
                return '<div diyfmtoolbarselectall></div>';
            default:
                if (typeof item === 'function') {
                    return item();
                }
        }
        return '';
    }

    return {
        template: '',
        restrict: 'A',
        scope: {
            items: '=diyfmtoolbar'
        },
        link: function(scope, elem, attr) {
            
            scope.$watch('items', function(newItems, oldItems){
                if (newItems) {
                    var tpl = '';
                    for (var i = 0; i < newItems.length; i++) {
                        tpl += getItemTemplate(newItems[i]);
                    }
                    elem.empty();
                    elem.html(tpl);
                    $compile(elem.contents())(scope);
                } else if (oldItems) {
                    elem.empty();
                    $compile(elem.contents())(scope);
                }
            });
            
        }
    };
}]);


/***/ },
/* 970 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmbreadcrumb', ['diyl10n', 'diyfmsectionsdata', 
                                                  function(diyl10n, diyfmsectionsdata) {
    return {
        template: '\
            <span \
                ng-bind-html="diyfmsectionsdata.getCurrentSection().getTitle()"\
            ></span>\
            <span class="fm-breadcrumb-separator ui-icon"></span>\
            <span \
                class="fm-breadcrumb-item"\
                ng-show="!showSearch"\
                ng-bind-html="getSubsectionTitle()"\
                title="{{getSubsectionTitle()}}"\
            ></span>\
            <a \
                class="fm-breadcrumb-item"\
                ng-show="showSearch"\
                ng-click="clickOnSubsection()"\
                ng-bind-html="getSubsectionTitle()"\
                title="{{getSubsectionTitle()}}"\
            ></a>\
            <span class="fm-breadcrumb-separator ui-icon" ng-show="showSearch"></span>\
            <span ng-show="showSearch"\
                ng-bind-html="searchItem"\
            ></span>\
        ',
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            scope.diyfmsectionsdata = diyfmsectionsdata;
            
            scope.$watch('diyfmsectionsdata.getCurrentSubsection().getSearch()', function(newValue, oldValue){
                scope.showSearch = !!newValue;
                scope.searchItem = diyl10n('filemanager.search.breadcrumbItem').format(newValue);
            });
            
            scope.clickOnSubsection = function() {
                if (scope.showSearch) {
                    scope.diyfmsectionsdata.getCurrentSubsection().resetSearch();
                }
            };

            scope.getSubsectionTitle = function() {
                return diyfmsectionsdata.getCurrentSubsection().getTitle();
            };
        }
    };
}]);


/***/ },
/* 971 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmitems', ['$timeout', '$q', '$http', 'diyfmsectionsdata', 'diyfmconfig', 'diyfmselectiondata', 'diyfilename', 'diyl10n', 'diyfiledownload', 'diyanimationframe', 'diyfmmessages', 'diyfmsourcestorage', 'diyglobalevents',
function($timeout, $q, $http, diyfmsectionsdata, diyfmconfig, diyfmselectiondata, diyfilename, diyl10n, diyfiledownload, diyanimationframe, diyfmmessages, diyfmsourcestorage, diyglobalevents) {
    var $ = jQuery;
    return {
        template: '\
            <div class="fm-item-menu" data-diyfmmenu="" ng-model="menuConfig"></div>\
            <div class="fm-items-scroll"\
                ng-class="{\
                    \'fm-allow-insertions\': allowInsertions,\
                    \'fm-no-actions\': itemActions.length === 0\
                }"\
            >\
                <div class="fm-no-items" ng-show="items.length == 0 && !shouldShowUpsell()"><div><small></small><span>' + diyl10n('filemanager.messages.noitems') + '</span></div></div>\
                <div class="fm-items-wrapper">\
                    <div ng-show="shouldShowUpsell()" ng-bind-html="getUpsellContents()"></div>\
                    <div diyfmpreview></div>\
                    <div class="fm-items-rendered">\
                        <div class="fm-thumb-wrap" \
                            ng-class="{\'fm-thumb-previewed\': item === preview.item}"\
                            diyfmthumbnail="" \
                            ng-repeat="item in items" \
                        >\
                    </div>\
                </div>\
            </div>\
        ',
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {

            scope.$watch('sections.getCurrentSubsection().getSearch()', function(newSearch, oldSearch){
                var content;
                if (newSearch !== '') {
                    content = diyl10n('filemanager.messages.noitemsfound');
                } else {
                    content = diyl10n('filemanager.messages.noitems').format({uploadButtonLabel: diyl10n('filemanager.upload.button')});
                }
                jQuery('.fm-no-items').find('span').html(content);
            });

            scope.shouldShowUpsell = function() {
                var currentSource = scope.sections.getCurrentSubsection().getSource();
                if (typeof currentSource.shouldShowUpsell === 'function') {
                    return currentSource.shouldShowUpsell();
                }
            };
            
            scope.getUpsellContents = function() {
                var currentSource = scope.sections.getCurrentSubsection().getSource();
                if (typeof currentSource.getUpsellContents === 'function') {
                    return currentSource.getUpsellContents();
                }
            };

            var 
                $elem = $(elem),
                $itemsS = $elem.find('.fm-items-scroll'),
                $itemsW = $elem.find('.fm-items-wrapper'),
                $itemsR = $elem.find('.fm-items-rendered'),
                itemsRTop,
                itemsRHeight,
                BUFFER_SCREENS = 1, // number of screens used as buffers (on top and on bottom)
                // just an estimation, exact recalculation will be on initialLoad
                THUMB_HEIGHT = 100,
                THUMBS_PER_ROW = 4,
                screenHeight = $elem.outerHeight(),
                previewHeight = screenHeight * 0.8,
                previewTop,
                // XXX seems that $elem.find('[diyfmpreview]') doesn't work
                previewEl = $elem.find('[diyfmpreview]'),
                previewPosParent,
                ignoreScrollEvent = false,
                uploadArgsAfterLoadInitial,
                renderedOffset,
                renderedLimit,
                scrollRetrievePromise
            ;
            
            $timeout(function(){
                // XXX refresh heights after rendering
                screenHeight = $elem.outerHeight();
                previewHeight = screenHeight * 0.8;
                previewEl.height(previewHeight);
            });
            previewPosParent = previewEl.parent()
            while (previewPosParent.css('position') === 'static') {
                previewPosParent = previewPosParent.parent();
            }
            
            var getThumbsPerScreen = function() {
                return Math.ceil(screenHeight / THUMB_HEIGHT) * THUMBS_PER_ROW;
            };
            
            var itemsScrollTop = function(scrollTop, forceReload) {
                if (scope.preview.item) {
                    // if there is a preview, adjust scrollTop
                    if (scrollTop > previewTop) {
                        if (scrollTop < previewTop + previewHeight) {
                            scrollTop = previewTop;
                        } else {
                            scrollTop = scrollTop - previewHeight;
                        }
                    }
                    
                }
                var 
                    reqOffset = Math.floor(scrollTop / THUMB_HEIGHT) * THUMBS_PER_ROW,
                    thumbsPerScreen = getThumbsPerScreen()
                ;
                forceReload = forceReload || false;
                
                if (!forceReload &&
                    (renderedOffset === 0 || reqOffset > renderedOffset + thumbsPerScreen/2)
                    && reqOffset + thumbsPerScreen < renderedOffset + renderedLimit - thumbsPerScreen/2
                ) {
                    // we still have all visible space filled with a half of screen buffer
                    return;
                }
                
                var 
                    offset = Math.max(0, reqOffset - BUFFER_SCREENS * thumbsPerScreen),
                    limit = thumbsPerScreen * (BUFFER_SCREENS * 2 + 1)
                ;
                
                scrollRetrievePromise && scrollRetrievePromise.reject();
                
                scrollRetrievePromise = scope.sections.getCurrentSubsection()
                    .retrieveItems(offset, limit)
                    .then(function(items){
                        scope.items = items;
                        // The commented code below is a nice try for optimisation
                        // but the behavior is weird because images are not instantly
                        // changed
                        /*
                        if (scope.items.length === items.length) {
                            console.log('setResources');
                            for(var i = 0; i < items.length; i ++) {
                                items[i].getResource().thumb = false;
                                scope.items[i].setResource(items[i].getResource());
                            }
                        } else {
                            console.log('setItems');
                            scope.items = items;
                        }
                        */
                        renderedOffset = offset;
                        renderedLimit = limit;
                        
                        // let it render (do a timeout with 0)
                        $timeout(function(){
                            itemsRHeight = $itemsR.height();
                            scope.preview.item && restorePreview();
                        }, 0);
                        scrollRetrievePromise = undefined;
                    });
                
                itemsRTop = offset / THUMBS_PER_ROW * THUMB_HEIGHT;
                
                if (scope.preview.item && itemsRTop > previewTop) {
                    itemsRTop = itemsRTop + previewHeight;
                }
                
                $itemsR.css('top', itemsRTop + 'px');
            };
            
            var loadInitial = function() {
                ignoreScrollEvent = true;
                var subsection = scope.sections.getCurrentSubsection();
                
                // transfer to a local variable in case
                // a subsequent loadInitial would occur
                var uploadArgs = uploadArgsAfterLoadInitial;
                uploadArgsAfterLoadInitial = undefined;
                
                $itemsS.scrollTop(0);
                itemsRTop = 0;
                $itemsR.css('top', itemsRTop + 'px');
                $itemsW.css('height', '');
                scope.items = undefined; // must be set to undefined so the "no items info won't be displayed!

                $elem.loadingBox({useOverlay: true}).show();
                
                var offset = 0, limit = getThumbsPerScreen() * (BUFFER_SCREENS + 1);
                
                subsection.retrieveItems(offset, limit)
                    .then(function(items){
                        scope.items = items;
                        renderedOffset = offset;
                        renderedLimit = limit;
                        
                        // let it render (do a timeout with 0)
                        $timeout(function(){
                            var 
                                thumbs = $itemsR.find('.fm-thumb-wrap'),
                                offsTop, iOffsTop
                            ;
                            if (thumbs.length > 0) {
                                offsTop = thumbs.eq(0).offset().top;
                                for (var i = 1; i < thumbs.length; i++) {
                                    iOffsTop = thumbs.eq(i).offset().top;
                                    if (iOffsTop > offsTop) {
                                        THUMB_HEIGHT = iOffsTop - offsTop;
                                        THUMBS_PER_ROW = i;
                                        refreshItemsWrapHeight();
                                        break;
                                    }
                                }
                            }
                            itemsRHeight = $itemsR.height();
                            
                            $elem.loadingBox().hide();
                            diyglobalevents.trigger('diy-editor-filemanager-itemsretrieved', {});
                            ignoreScrollEvent = false;
                        }, 0);  
                        if (uploadArgs) {
                            doUploadFiles.apply(this, uploadArgs);
                            itemsScrollTop(0, true);
                        }
                        
                        if (subsection.getSearch() != '') {
                            scope.$emit('searchCompleted', {
                                subsection: subsection
                            });
                        }
                        
                    });
            };
            
            var refreshItemsWrapHeight = function() {
                var 
                    subsection = scope.sections.getCurrentSubsection(),
                    items = subsection.getItems();
                ;
                if (items) {
                    var height = Math.ceil(subsection.getItems().length / THUMBS_PER_ROW) * THUMB_HEIGHT;
                    if (scope.preview.item) {
                        height += previewEl.outerHeight();
                    }
                    $itemsW.height(height);
                }
            };
            
            var lengthUnwatch;
            
            
            scope.$watch('sections.getCurrentSubsection()', function(subsection){
                if (subsection !== undefined) {
                    lengthUnwatch && lengthUnwatch();
                    scope.itemActions = subsection.getItemActions();
                    loadInitial();
                    
                    lengthUnwatch = 
                        scope.$watch('sections.getCurrentSubsection().getItems().length', function(newLength, oldLength){
                            if (newLength !== oldLength && typeof newLength !== 'undefined') {
                                $itemsW.height(Math.ceil(newLength / THUMBS_PER_ROW) * THUMB_HEIGHT);
                                if (newLength < oldLength) {
                                    // some items deleted, reload items
                                    itemsScrollTop($itemsS.scrollTop(), true);
                                }
                                scope.preview.item && restorePreview();
                            }
                            // a special case when items cache is invalidated
                            // this can happen when a search is initiated/canceled
                            // or when an operation like folderDelete occured while we are
                            // on allimages folder
                            if (newLength === undefined && oldLength !== undefined) {
                                loadInitial();
                            }
                            var items = scope.sections.getCurrentSubsection().getItems();
                            if (scope.preview.item && 
                                (
                                    items === undefined || 
                                    items.indexOf(scope.preview.item) === -1
                                ) 
                            ) {
                                scope.hidePreview(false);
                            }
                        });
                }
            });
            
            var 
                onScrollPromise,
                loadingBoxShown
            ;
            
            $itemsS.bind('scroll', function(ev) {
                var sTop, itemsRBottom = itemsRTop + itemsRHeight;
                
                if (ignoreScrollEvent) return;
                
                if (!loadingBoxShown) {
                    sTop = $itemsS.scrollTop();
                    if (scope.preview.item
                        && itemsRTop + itemsRHeight >= previewTop
                        && itemsRTop < previewTop
                    ) {
                        itemsRBottom += previewHeight; 
                    }
                    if (
                        itemsRTop > sTop + screenHeight / 2
                        || itemsRBottom < sTop + screenHeight / 2
                    ) {
                        loadingBoxShown = true;
                        $elem.loadingBox({useOverlay: false}).show();
                    }
                }
                
                onScrollPromise && $timeout.cancel(onScrollPromise);
                onScrollPromise = $timeout(function(){
                    itemsScrollTop($itemsS.scrollTop());
                    $elem.loadingBox().hide();
                    loadingBoxShown = false;
                    onScrollPromise = undefined;
                }, 100);
            });
            
            scope.$on('uploadFiles.down', function(event, files, subsection, addToInsert, uploadSource){
                event.preventDefault(); // prevent handling in child scopes
                var currentSubsection = scope.sections.getCurrentSubsection();
                subsection = subsection || currentSubsection; 
                if (typeof subsection.uploadFiles !== 'function') {
                    subsection = scope.sections.getDefaultUploadSubsection();
                }
                
                if (currentSubsection !== subsection) {
                    uploadArgsAfterLoadInitial = arguments;
                    scope.sections.setCurrentSubsection(subsection);
                    scope.$digest();
                } else if (subsection.getSearch() !== '') {
                    uploadArgsAfterLoadInitial = arguments;
                    subsection.resetSearch();
                    scope.$digest();
                } else {
                    doUploadFiles.apply(this, arguments);
                    $itemsS.scrollTop(0);
                    itemsScrollTop(0, true);
                }
            });
            
            var doUploadFiles = function(event, files, subsection, addToInsert, uploadSource) {
                if (!diyfmconfig.isInManagementMode()) {
                    addToInsert = true;
                }
                var insertIndex = diyfmselectiondata.getInsertedItems().length;
                subsection.uploadFiles(files).then(function(response) {
                    // sometimes not all the notify promises are caught,
                    // however, we catch all at the end
                    if (Array.isArray(response.items) && response.items.length) {
                        response.items.forEach(function(item) {
                            if (!addToInsert) {
                                diyfmselectiondata.addItem(item, ['select'], 0);
                            }
                            if (addToInsert) {
                                diyfmselectiondata.addItem(item, ['insert'], insertIndex);
                            }
                        });
                        scope.$emit('uploadedFiles', {
                            uploadedItems: response.items,
                            source: uploadSource
                        });
                        if (addToInsert) {
                            scope.$emit('addToInsertion', {
                                items: response.items,
                                source: 'upload',
                                subsection: subsection
                            });
                        }
                    }
                    // error case is covered in success, as there may be mixed success + errors
                    if (Array.isArray(response.uploadErrors) && response.uploadErrors.length) {
                        diyfmmessages.handleUploadError(response.uploadErrors);
                    }
                }, angular.noop, function(notification) {
                    // add one by one, as they are done uploading
                    if (notification.item) {
                        if (!addToInsert) {
                            diyfmselectiondata.addItem(notification.item, ['select'], 0);
                        }
                        if (addToInsert) {
                            diyfmselectiondata.addItem(notification.item, ['insert'], insertIndex);
                        }
                    }
                });
            };
            
            scope.renameItem = function(item, newName) {
                var parsedName = diyfilename.parse(item.getName());
                parsedName.name = newName;
                item.setName(diyfilename.stringify(parsedName));
                item.$update();
                
                // XXX invalidate caches other folders containing this item
                // (the only case so far is allimagessubsection vs regular folder)
                // TODO use a global resource instance pool for syncronisation
                var 
                    currentSubsection = scope.sections.getCurrentSubsection(),
                    allImagesSubsection = diyfmsourcestorage.getAllImagesSubsection()
                ;
                
                if (currentSubsection === allImagesSubsection) {
                    var folder = diyfmsourcestorage.getSection().getFolderSectionById(item.getFolderId());
                    if (folder) {
                        folder.clearItemsCache();
                    }
                } else {
                    allImagesSubsection.clearItemsCache();
                }
            };
            
            scope.deleteItem = function(item) {
                diyfmmessages.showMessageItemsThumbs({
                    items: [item],
                    title: diyl10n('filemanager.items.menu.deleteconfirmation.message'),
                    ok: diyl10n('filemanager.sections.menu.delete'),
                    cancel: diyl10n('cancel')
                }).then(function() {
                    diyfmsectionsdata.getCurrentSubsection().deleteItems([item]);
                    scope.$emit('deleteFilesClicked', {
                        itemsCount: 1
                    });
                });
            };
            
            scope.openMenu = function(item, ev, itemScope) {
                var thumb = $(ev.target).closest('.fm-thumb');
                thumb.addClass('menu-opened');
                var menuTargetEl = $(ev.target).closest('button');
                scope.menuConfig = {
                    menuTargetEl: menuTargetEl,
                    getActions: function() {
                        return scope.itemActions;
                    },
                    menuClose: function() {
                        thumb.removeClass('menu-opened');
                    },
                    'delete': function() {
                        scope.deleteItem(item);
                    },
                    preview: function() {
                        scope.showPreview(item, true);
                    },
                    download: function() {
                        diyfiledownload(item.getFile());
                    }
                };
                if (diyfmconfig.shouldShowFileNames()) {
                    scope.menuConfig['rename'] = function() {
                        var parsedName = diyfilename.parse(item.getName());
                        itemScope.nameEditConfig.start(parsedName.name);
                    };
                }
                ev.stopPropagation();
            };
            
            scope.toggleInsert = function(item, source) {
                if (diyfmselectiondata.isItemInserted(item)) {
                    diyfmselectiondata.removeItem(item, ['insert']);
                } else {
                    diyfmselectiondata.addItem(item, ['insert']);
                    scope.$emit('addToInsertion', {
                        items: [item],
                        source: source,
                        subsection: diyfmsectionsdata.getCurrentSubsection()
                    });
                }
            };
            
            scope.preview = {};
            
            scope.hidePreview = function(withAnimation, scrollBackToImage) {
                scope.preview.item = undefined;
                
                hidePreview(withAnimation, scrollBackToImage).then(function(){
                    refreshItemsWrapHeight();
                });
            };
            
            scope.showPreview = function(item, withAnimation) {
                var shouldHideOldPreview = scope.preview.item !== undefined;
                scope.preview.item = item;
                
                // let it be rendered first
                $timeout(function(){
                    if (shouldHideOldPreview) {
                        hidePreview(withAnimation).then(function(){
                            showPreview(withAnimation).then(function(){
                                refreshItemsWrapHeight();
                            });
                        });
                    } else {
                        showPreview(withAnimation).then(function(){
                            refreshItemsWrapHeight();
                        });
                    }
                });
            };
            
            scope.$watch('preview.item', function(newPreviewItem, oldPreviewItem){
                scope.preview.prevItem = null;
                scope.preview.nextItem = null;
                
                if (newPreviewItem){
                    var 
                        subsection = scope.sections.getCurrentSubsection(),
                        items = subsection.getItems(),
                        previewIndex = items.indexOf(newPreviewItem)
                    ;
                    
                    if (previewIndex > -1) {
                        if (previewIndex > 0) {
                            scope.preview.prevItem = items[previewIndex - 1];
                        }
                        if (previewIndex + 1 < items.length) {
                            scope.preview.nextItem = items[previewIndex + 1];
                        }
                    }
                }
            });
            
            var hidePreview = function(withAnimation, scrollBackToImage) {
                var defer = $q.defer();
                
                if (itemsRTop > previewTop) {
                    itemsRTop = itemsRTop - previewHeight;
                    $itemsR.css('top', itemsRTop + 'px');
                    // moving scroll so that visible $itemsR (rendered element)
                    // remain at same position on the screen
                    ignoreScrollEvent = true;
                    $itemsS.scrollTop($itemsS.scrollTop() - previewHeight);
                    ignoreScrollEvent = false;
                }
                
                previewEl.hide();
                
                var prevMargins = $itemsR.find('.fm-thumb-spacing')
                    .removeClass('fm-thumb-spacing');
                
                // remove previously set margins
                if (prevMargins.length > 0) {
                    var 
                        adjustScroll = $itemsS.scrollTop() > previewTop,
                        previewVisible = ($itemsS.scrollTop() < previewTop + previewHeight) 
                                && (previewTop < $itemsS.scrollTop() + screenHeight)
                    ;
                    
                    if (adjustScroll || scrollBackToImage) {
                        var startScrollTop = $itemsS.scrollTop();
                    }
                    
                    var scrollAndRemoveMargins = function() {
                        prevMargins.css('margin-bottom', 0);
                        if (adjustScroll) {
                            $itemsS.scrollTop(startScrollTop - previewHeight);
                        } else if (scrollBackToImage) {
                            $itemsS.scrollTop(startScrollTop - previewHeight/2);
                        }
                    };
                    
                    if (withAnimation && previewVisible) {
                        ignoreScrollEvent = true;
                        
                        var 
                            startMargin = parseInt(prevMargins.css('margin-bottom'), 10)
                        ;
                        
                        diyanimationframe(250, function(progress){
                            var margin = Math.round(startMargin * (1 - progress));
                            prevMargins.css('margin-bottom', margin + 'px')
                            if (adjustScroll) {
                                $itemsS.scrollTop(startScrollTop - (startMargin - margin));
                            } else if (scrollBackToImage) {
                                $itemsS.scrollTop(startScrollTop - (startMargin - margin) / 2);
                            }
                        }, function(){
                            scrollAndRemoveMargins();
                            ignoreScrollEvent = false;
                            defer.resolve();
                        });                        
                    } else {
                        scrollAndRemoveMargins();
                        defer.resolve();
                    }
                } else {
                    defer.resolve();
                }
                
                return defer.promise;
            };
            
            var showPreview = function(withAnimation) {
                var defer = $q.defer();
                
                var lastInRow = getLastInRowAfterPreviewed();
                if (!lastInRow) {
                    return;
                }
                
                positionPreview(lastInRow);
                
                lastInRow.addClass('fm-thumb-spacing')
                    .css('margin-bottom', '0px');
                
                var
                    startScroll = $itemsS.scrollTop(),
                    finalScroll = previewTop - screenHeight * 0.05
                ;
                
                var doShowPreview = function() {
                    previewEl.show();
                    $itemsS.scrollTop(finalScroll);
                    itemsScrollTop(finalScroll);
                    lastInRow.css('margin-bottom', previewHeight + 'px');
                };
                
                if (withAnimation) {
                    ignoreScrollEvent = true;

                    diyanimationframe(250, function(progress) {
                        // manually add margins equal to the height of the preview
                        // class is added just for find it later on cleanup
                        lastInRow.css('margin-bottom', previewHeight * progress + 'px');
                        $itemsS.scrollTop(startScroll + (finalScroll - startScroll) * progress);
                    } , function() {
                        doShowPreview();
                        defer.resolve();
                        ignoreScrollEvent = false;
                    });
                } else {
                    doShowPreview();
                    defer.resolve();
                }
                
                return defer.promise;
            };
            
            var getLastInRowAfterPreviewed = function() {
                var previewedThumb = $itemsR.find('.fm-thumb-previewed');
                
                if (previewedThumb.length === 0) {
                    return;
                }
                
                var 
                    lastInRow = previewedThumb,
                    rowOffset = lastInRow.offset().top,
                    next = lastInRow.next(), nextOffset
                ;
                
                while(next.length > 0) {
                    nextOffset = next.offset().top;
                    if (nextOffset > rowOffset) {
                        break;
                    } else {
                        lastInRow = next;
                    }
                    next = lastInRow.next();
                }
                return lastInRow;
            };
            
            var positionPreview = function(lastInRow) {
                previewTop = lastInRow.offset().top - previewPosParent.offset().top 
                    + lastInRow.outerHeight();
                previewEl.css('top',  previewTop + 'px');
            };
            
            var restorePreview = function() {
                var prevMargins = $itemsR.find('.fm-thumb-spacing')
                    .removeClass('fm-thumb-spacing');
                
                prevMargins.css('margin-bottom', '');
                
                var lastInRow = getLastInRowAfterPreviewed();
                
                if (!lastInRow) {
                    return;
                }
                
                positionPreview(lastInRow);
                
                lastInRow.addClass('fm-thumb-spacing');
                
                // manually add margins equal to the height of the preview
                // class is added just for find it later on cleanup
                lastInRow.css('margin-bottom', previewHeight + 'px');
            };
            
            scope.allowInsertions = diyfmselectiondata.allowInsertions();
            
            // load drag images at beginning
            var dragSingle = new Image(), dragMultiple = new Image();
            dragSingle.src = jimdoData.cdnUrl + 's/diy/filemanager/images/drag-single.png';
            dragMultiple.src = jimdoData.cdnUrl + 's/diy/filemanager/images/drag-multiple.png';

            // TODO this is used for preloading images for IE, where drag and drop image is done with a hack, using background-images
            // TODO separate this into a service
            var $preloadEl = jQuery('<div class="fm-fallback-draggable-preload"></div>').css({
                position: 'absolute',
                top: 0,
                left: 0
            }).prependTo(jQuery(elem));
            setTimeout(function() {
                // we don't know when the images will load, so we take a lucky guess
                $preloadEl.remove();
            }, 5000)


            $elem.delegate('.fm-thumb', 'dragstart', function(ev) {
                if (diy.editor.uiPreference.isPointerModeTouch()) {
                    jQuery('.fm-items').addClass('fm-drag-feedback');
                    setTimeout(function() {
                        jQuery('.fm-items').removeClass('fm-drag-feedback');
                    }, 1000);
                }

                ev.originalEvent.dataTransfer.dropEffect = 'move';
                ev.originalEvent.dataTransfer.setData("Text", ""); // XXX Firefox hack, otherwise drag does not begin

                // if we start dragging from an unselected item, select it so it would be part of the selection that's moved
                var item = angular.element(this).scope().item;
                if (!diyfmselectiondata.isItemSelected(item)) {
                    // if we can't select it (for example if is during an upload, don't start dragging
                    if (!item.canSelect()) {
                        return false;
                    }
                    // select it
                    scope.$apply(function() {
                        diyfmselectiondata.addItem(item, ['select']);
                    });
                }

                // if we don't have any selected item, don't start dragging
                var selectedItems = diyfmselectiondata.getSelectedItems();
                if (selectedItems.length === 0) {
                    return false;
                }

                // set the drag image
                if ('function' === typeof ev.originalEvent.dataTransfer.setDragImage) {
                    var imageOffsetX = -10, imageOffsetY = -10;
                    if (diy.editor.uiPreference.isPointerModeTouch()) {
                        imageOffsetX = -40; 
                        imageOffsetY = -40;    
                    }
                    ev.originalEvent.dataTransfer.setDragImage(
                        selectedItems.length === 1 ? dragSingle : dragMultiple, 
                        imageOffsetX, imageOffsetY
                    );
                } else {
                    /* XXX IE 11 hack
                    IE does not implement the setDragImage method, so, we found a way to overcome this:
                    - set some classes on an element
                    - remove them immidiately (setTimeout 0)
                    - in this way, IE gets the chance to make a quick snapshot of the element that
                        we faked to look just like the drag icon
                    */
                    var $currentThumbEl = jQuery(this).addClass('fm-fallback-draggable').addClass(function() {
                        return 'fm-fallback-draggable-' + (selectedItems.length === 1 ? 'single' : 'multiple');
                    });
                    setTimeout(function() {
                        $currentThumbEl.removeClass('fm-fallback-draggable fm-fallback-draggable-single fm-fallback-draggable-multiple');
                    }, 0);
                }
            });
            
            var thumbClickHandlerTimeout, preventDoubleClick;

            // OPTIMIZATION: instead of binding a click event on each of the thumb
            // we better delegate it. When a click is triggered, an item's selection
            // is toggled
            $elem.delegate('.fm-thumb', 'click', function(ev) {
                var thumb = this;
                thumbClickHandlerTimeout = setTimeout(function(){
                    thumbClickHandler.call(thumb, ev);
                }, 100);
            });
            
            var thumbClickHandler = function(ev) {
                var itemScope = angular.element(this).scope(), item = itemScope.item;
                
                preventDoubleClick = false;

                if ($(ev.target).is('input')) {
                    return false;
                }
                
                if ($(ev.target).closest('button').hasClass('fm-thumb-menu')) {
                    // we don't want on double click on menu button 
                    // item to be added to insertion
                    // so we set prevention flag                      
                    preventDoubleClick = true;
                    scope.openMenu(itemScope.item, ev, itemScope);
                    scope.$digest();
                    return false;
                }

                if ($(ev.target).closest('button').hasClass('fm-thumb-preview')) {
                    // we don't want on double click on preview button 
                    // item to be added to insertion
                    // so we set prevention flag                    
                    preventDoubleClick = true;
                    scope.$apply(function(){
                        scope.showPreview(item, true);
                    });
                    return;
                }

                /* if item is marked for insertion */
                if (
                    $(ev.target).closest('button').hasClass('fm-thumb-add')
                    || !diyfmconfig.isInManagementMode()
                ) {
                    // we don't want on double click the insertion to be lost
                    // so we set prevention flag
                    preventDoubleClick = true;
                    scope.toggleInsert(item, 'thumbnail');
                    itemScope.$apply();
                    return false;
                }

                // if the item is selected
                if (diyfmselectiondata.isItemSelected(item)) {
                    // remove selection and insertion from the item
                    diyfmselectiondata.removeItem(item, ['select']);
                } else {
                    // if it's not inserted, insert it
                    diyfmselectiondata.addItem(item, ['select']);
                }
                itemScope.$apply();
            };
            
            $elem.delegate('.fm-thumb', 'dblclick', function(ev) {
                // because squence is click - click - dblclick
                // we need to cancel here second click
                thumbClickHandlerTimeout && clearTimeout(thumbClickHandlerTimeout);
                
                if (preventDoubleClick) {
                    return false;
                }
                
                if (!$(this).hasClass('fm-uploading')) {
                    var itemScope = angular.element(this).scope(), item = itemScope.item;
                    scope.toggleInsert(item, 'thumbnail-dblclick');
                    itemScope.$apply();
                    return false;
                }
            });
            
            // prevent scrolling on window when scrolling inside items
            // http://stackoverflow.com/questions/5802467/prevent-scrolling-of-parent-element
            $itemsS.bind('mousewheel', function(e, d)  {
                var t = $(this);
                if (d > 0 && t.scrollTop() === 0) {
                    e.preventDefault();
                }
                else {
                    if (d < 0 && (t.scrollTop() == t.get(0).scrollHeight - t.innerHeight())) {
                        e.preventDefault();
                    }
                }
            });
            
        }
    };
}]);

/***/ },
/* 972 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmsections', ['$timeout', 'diysqueezebox', 'diyfmselectiondata', 'diyappevents',
function($timeout, diysqueezebox, diyfmselectiondata, diyappevents) {

    var tpl = '\
        <div class="fm-category-menu" data-diyfmmenu="" ng-model="menuConfig"></div>\
        <div class="fm-folders-list">\
            <div class="fm-token-wrapper">\
                <div ng-repeat="section in sections.getSections()" data-section-id="{{section.id}}">\
                    <div class="diye-collapsible-category-header"\
                        ng-click="sectionClicked(section)"\
                        ng-class="{\'current\': section === sections.getCurrentSection()}">\
                        <div class="diye-collapsible-category-positioned">\
                            <div class="diye-collapsible-category-title">\
                                <!-- use ng-bind-html because we don\'t want to double escape here -->\
                                <span ng-bind-html="section.getTitle()"></span>\
                            </div>\
                            <div class="fm-category-actions">\
                                <button ng-repeat="_action in section.getActions()"\
                                    class="ui-button-borderless "\
                                    diybutton="{\'icons\':{\'primary\':\'{{_action.icon}}\'}, \'text\': false}"\
                                    ng-click="_action.handler($event, section);"\
                                    title="{{_action.title}}"\
                                ></button>\
                            </div>\
                            <div class="diye-collapsible-category-pointer"></div>\
                            <div class="diye-collapsible-category-arrow"></div>\
                        </div>\
                    </div>\
                    \
                    <div class="diye-collapsible-category-content div-additional-content">\
                        <ul>\
                            <li\
                                ng-repeat="subsection in section.getSubsections()"\
                                ng-class="{\'fm-subsection-current\': subsection === sections.getCurrentSubsection()}"\
                                ng-click="subsectionClicked(subsection);"\
                            >\
                                <div data-diyfmsection="" \
                                    ng-model="subsection"\
                                    open-menu="openMenu(menuConfig)"\
                                    >\
                                </div>\
                            </li>\
                        </ul>\
                    </div>\
                    <div class="clear"></div>\
                </div>\
            </div>\
        </div>\
    ';

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {

            scope.openMenu = function(menuConfig) {
                scope.menuConfig = menuConfig;
            };
            
            var doSubsectionAutoscroll = true;
            
            scope.subsectionClicked = function(subsection) {
                doSubsectionAutoscroll = false;
                scope.sections.setCurrentSubsection(subsection);
                $timeout(function(){doSubsectionAutoscroll = true});
            };
            
            scope.sectionClicked = function(section) {
                doSubsectionAutoscroll = false;
                scope.sections.setCurrentSection(section);
                $timeout(function(){doSubsectionAutoscroll = true});
            };
            
            var squeeseBoxEl = jQuery('.fm-folders-list', elem);
            
            diysqueezebox.initialize(squeeseBoxEl, {
                clickToOpen: true,
                fixableSelector: '.diye-collapsible-category-header',
                fixedClassName: 'fixed',
                activeClassName: 'active'
            });
            
            var scrollToCurrent = function() {
                diysqueezebox.refresh(squeeseBoxEl);
                diysqueezebox.scrollToItem(
                    squeeseBoxEl,
                    jQuery('.fm-subsection-current', elem),
                    null, 0 /*instant scroll, no animations*/
                );
            };
            
            scope.$watch('sections.getCurrentSubsection()', function(newSubsection, oldSubsection) {
                if (doSubsectionAutoscroll && newSubsection) {
                    // timeout to let it render the change
                    $timeout(function(){
                        scrollToCurrent();
                    });
                }
            });
            
            diyappevents.bind('subSectionsLoaded', function(){
                // timeout to let it render the change
                $timeout(function(){
                    scrollToCurrent();
                });
            });

            var getSubsectionByElement = function(el) {
                return angular.element(el).scope().subsection;
            };

            var removeDragDropHover = function() {
                jQuery('[data-section-id] ul > li').removeClass('fm-subsection-dragover');
            };

            var canMoveItemsInDragging = function() {
                return diyfmselectiondata.getSelectedItems().every(function(item) { return item.canMove(); });
            };

            jQuery(elem).delegate('li', 'dragover', function(ev) {
                /* if there's no preventDefault in the dragover event,
                 then no drop will occur. highly undocumented featured,
                 found this out on StackOverflow */
                ev.preventDefault();
            });

            jQuery(elem).delegate('li', 'dragover', function(ev) {
                removeDragDropHover();
                var subsection = getSubsectionByElement(this);
                if (subsection.canMoveTo() && canMoveItemsInDragging()) {
                    jQuery(this).addClass('fm-subsection-dragover');
                }
            });

            jQuery(elem).bind('dragleave', function(ev) {
                removeDragDropHover();
            });

            jQuery(elem).delegate('li', 'drop', function(ev) {
                removeDragDropHover();

                /* get destination and source subsection */
                var destinationSubsection = getSubsectionByElement(this);
                
                if (ev.originalEvent.dataTransfer
                    && ev.originalEvent.dataTransfer.files
                    && ev.originalEvent.dataTransfer.files.length > 0)
                {
                    scope.$emit('uploadFiles.up', ev.originalEvent.dataTransfer.files, destinationSubsection, false, 'drag-sections');
                } else {
                    var sourceSubsection = scope.sections.getCurrentSubsection();
                    
                    /* if destination subsection does not support moving into, don't drop */
                    if (!destinationSubsection.canMoveTo()) {
                        return false;
                    }

                    // if items cannot be moved into the section, don't drop
                    if (!canMoveItemsInDragging()) {
                        return false;
                    }
                    
                    /* can't drag and drop over itself */
                    if (destinationSubsection === sourceSubsection) {
                        return true;
                    }
                    
                    /* get items to move */
                    var moveItems = diyfmselectiondata.getSelectedItems();
                    
                    scope.$apply(function(scope) {
                        /* move the items */
                        sourceSubsection.moveItems(moveItems, destinationSubsection);
                        
                        /* deselect the moved items */
                        diyfmselectiondata.removeAllItems(['select']);
                    });
                    
                }
                return false;
            });
            
            scope.$on('$destroy', function(){
                diyappevents.unbind('subSectionsLoaded');
            });
        }
    };

}]);



/***/ },
/* 973 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmsection', ['$timeout', 'diyfmsectionsdata', 'diyl10n', 'diyfmmessages', 'diysqueezebox',
function($timeout, diyfmsectionsdata, diyl10n, diyfmmessages, diysqueezebox) {

    var tpl = '\
        <div class="fm-subsection-name"\
            ng-hide="inEditMode" \
            title="{{subsection.getTitle()}}"\
            diyfminlineedit="nameEditConfig"\
            ng-bind-html="subsection.getTitle()"\
        ></div>\
        <button class="fm-menu-handle ui-button"\
            ng-click="menuClicked($event);" \
            ng-show="shouldShowMenuHandle(subsection);"\
        >\
            <span class="ui-icon ui-icon-menu"></span>\
        </button>';

    return {
        template: tpl,
        restrict: 'A',
        scope: {
            subsection: '=ngModel',
            openMenu: '&'
        },
        link: function(scope, elem, attr) {
            
            var $elem = jQuery(elem);

            scope.nameEditConfig = {
                // TODO make this text generic
                placeholder: diyl10n('filemanager.customerSection.newFolderText'),
                end: function(value) {
                    var isNew = scope.subsection.isNew();
                    scope.subsection.setTitle(
                        diyfmsectionsdata.generateUniqueSubsectionName(
                            value, 
                            scope.subsection, 
                            diyl10n('filemanager.customerSection.newFolderText')
                        )
                    );
                    if (isNew) {
                        scope.$emit('createdFolder');
                    }
                },
                cancel: function() {
                    if (scope.subsection.isNew()) {
                        diyfmsectionsdata.removeSubsection(scope.subsection);
                        scope.$apply();
                    }
                }
            };

            scope.menuClicked = function($event) {
                scope.openMenu({
                    menuConfig: {
                        menuTargetEl: $elem.find('.fm-menu-handle'),
                        getActions: function() {
                            return scope.subsection.getActions();
                        },
                        rename: function() {
                            scope.nameEditConfig.start(scope.subsection.getTitle());
                        },
                        'delete': function() {
                            diyfmmessages.showMessage({
                                title: diyl10n('filemanager.sections.menu.deleteconfirmation.message').format(scope.subsection.getTitle()),
                                ok: diyl10n('filemanager.sections.menu.delete'),
                                cancel: diyl10n('cancel')
                            }).then(function() {
                                diyfmsectionsdata.removeSubsection(scope.subsection);
                                scope.subsection.delete();
                                scope.$emit('deletedFolder');
                            });
                        }
                    }
                });
                $event.stopPropagation();// to stop click propagation
            };

            if (scope.subsection.isNew()) {
                // use timeout to let diyfminlineedit define scope.nameEditConfig.start
                $timeout(function(){
                    scope.nameEditConfig.start(scope.subsection.getTitle());

                    // update the squeeze box and scroll to item
                    diysqueezebox.refresh(jQuery('.fm-folders-list'));
                    diysqueezebox.scrollToItem(
                        jQuery('.fm-folders-list'),
                        jQuery('.fm-folders-list [data-diyfmsection] input[type="text"]').filter(':visible').closest('li')
                    );
                });
            }

            scope.shouldShowMenuHandle = function(subsection) {
                return subsection.getActions().length > 0;
            };


        }
    };
}]);



/***/ },
/* 974 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmmenu', ['$timeout', 'diyfmsectionsdata', '$parse', 
function($timeout, diyfmsectionsdata, $parse) {

    var tpl = '\
        <div class="fm-menu-button" ng-click="closeMenu();">\
            <span class="ui-icon ui-icon-menu-active"></span>\
        </div>\
        <div class="fm-menu-actions-wrap">\
            <ul>\
                <li ng-click="menuAction(_action)" \
                    ng-repeat="_action in actions"\
                    ng-init="buttonConfig = {icons: {primary: \'ui-icon-\' + _action.icon}, label: _action.title}"\
                    >\
                    <button \
                        diybutton="buttonConfig" \
                        class="ui-button-borderless"\
                            ></button>\
                </li>\
            </ul>\
        </div>';

    return {
        template: tpl,
        scope: {
            menuConfig: '=ngModel'
        },
        link: function(scope, elem, attr) {
            var config,
                $elem = jQuery(elem),
                $menuTargetEl, // comes from the config object, just a shortcut to it
                eventNamespace = 'fmmenu' + Math.round(Math.random() * Math.pow(10, 6));

            /* whenever the actions functions changes, update the actions */
            scope.$watchCollection(function() {
                if (!config || !config.getActions) {
                    return undefined;
                }
                // only return actions that have valid action handlers
                // this is done so we can dynamically determine which actions we should display or not
                return config.getActions().filter(function(action) {
                    return 'function' === typeof config[action.name];
z                });
            }, function(newValue, oldValue) {
                scope.actions = newValue;
            });

            var positionedParent, parents = $elem.parents();

            for(var i = 0; i < parents.length; i++) {
                if(jQuery(parents[i]).css('position') !== 'static') {
                    positionedParent = jQuery(parents[i]);
                    break;
                }
            };

            /* forward the actions */
            scope.menuAction = function(_action) {
                if (config[_action.name]) {
                    config[_action.name]($menuTargetEl);
                }
                scope.closeMenu();
            };

            /**
             * open the menu
             * @param ev the event
             * @param targetScope a link to the scope it was opened from, so we can call methods from there
             */
            scope.$watch('menuConfig',  function(newConfig, oldConfig) {

                if (newConfig !== oldConfig) {

                    config = newConfig;

                    /* get the target scope and the target element */
                    $menuTargetEl = config.menuTargetEl;

                    if (!newConfig) {
                        scope.closeMenu();
                        return;
                    }

                    var
                       targetOffs = $menuTargetEl.offset(),
                       positionedParentOffs = positionedParent.offset()
                    ;

                    /* position menu */
                    $elem.css({
                        top: targetOffs.top - positionedParentOffs.top,
                        left: targetOffs.left - positionedParentOffs.left
                    });

                    /* on menu open, register handlers to close it when
                    clicks on the body are received */
                    jQuery('body').bind('mousedown.' + eventNamespace + ' touchstart.' + eventNamespace, function(ev) {
                        if (!jQuery.contains(elem[0], ev.target)) {
                            scope.$apply(function(scope) {
                                scope.closeMenu();
                            });
                        }
                    });
                    $menuTargetEl.parents().bind('scroll.' + eventNamespace, function(ev) {
                        scope.$apply(function(scope) {
                            scope.closeMenu();
                        });
                    });

                    $elem.show();
                }
            });

            /**
             * close the menu
             */
            scope.closeMenu = function() {
                $elem.hide();
                $menuTargetEl.parents().unbind('.' + eventNamespace);
                if (typeof scope.menuConfig.menuClose === 'function') {
                    scope.menuConfig.menuClose();
                }
            };
        }
    };
}]);



/***/ },
/* 975 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmupload', ['diyl10n', 'diyfmsectionsdata', 'diyfmuploadqueue', 'diyfmtracking',
function(diyl10n, diyfmsectionsdata, diyfmuploadqueue, diyfmtracking) {
    var $ = jQuery;
    var tpl = '\
        <div class="fm-upload-button-section"\
            diyfmdropfiles="dropFilesConfig" >\
            <div class="fm-upload-button-wrap">\
                <button class="fm-upload-button fm-main-button"\
                    ><span class="ui-icon ui-icon-image-upload-white"></span><span>' + diyl10n('filemanager.upload.button') 
                    + '</span></button>\
            </div>\
        </div>\
        <div class="fm-upload-progress" \
            diyfmdropfiles="dropFilesConfig" \
            ng-show="showProgress"\
            diyfmprogress="progressConfig">\
            <div class="fm-upload-label">' + diyl10n('filemanager.upload.uploading') + '</div>\
            <button class="fm-upload-cancel ui-button-borderless ui-button-small"\
                diybutton="{\'icons\':{\'primary\':\'ui-icon-1and1-delete\'}}"\
                ng-click="cancel()"\
                >' + diyl10n('filemanager.upload.cancel') + '</button>\
        </div>'
        ;

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        compile: function(elem, iattr, transclude) {
            return {
                pre: function(scope, elem, iattr) {
                    
                    var uploadQueue = diyfmuploadqueue.get('storageFiles'), progress = 0, inProgress = false;
                    
                    scope.$on('uploadFiles.down', function(event, files){
                        scope.showProgress = true;
                        
                        if (!inProgress) {
                            inProgress = true;
                            uploadQueue.getPromise().then(function() {
                                inProgress = false;
                            }, function(rejectType) {
                                if (rejectType === 'cancel') {
                                    scope.showProgress = false;
                                    progress = 0;
                                }
                                inProgress = false;
                            }, function(newProgress) {
                                progress = newProgress;
                            });
                        }
                    });
                    
                    scope.cancel = function() {
                        uploadQueue.cancel();
                    };
                    
                    scope.progressConfig = {
                        getter: function() {
                            return progress;
                        },
                        runOnce: false,
                        onFinish: function() {
                            scope.showProgress = false;
                        }
                    };
                    
                    var createFileInput = function() {
                        // cleanup
                        $(elem).find('.fm-upload-button-wrap input[type="file"]')
                            .unbind('change').unbind('click').remove();
                        var input = $('<input type="file" multiple />');
                        $(elem).find('.fm-upload-button-wrap').append(input);
                        input.bind('click', function() {
                            diyfmtracking.track('uploadButtonClick');
                        });
                        input.bind('change', function(){
                            if (this.files && this.files.length > 0) {
                                scope.$emit('uploadFiles.up', this.files, undefined, undefined, 'click-upload');
                                createFileInput();
                            }
                        });
                    };
                    
                    createFileInput();
                    
                    scope.dropFilesConfig = {
                        eventName: 'uploadFiles.up',
                        source: 'drag'
                    };
                }
            };
        }
    };
}]);

/***/ },
/* 976 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmprogress', ['$timeout' , function($timeout) {
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {
            var config = scope.$eval(attr.diyfmprogress);
            
            /*
             * Optimization: As we can potentially have thousdans of images here, we should not
             * crowd the DOM with elements that are not needed for all, such as the progress element.
             * 
             * For this, we watch the upload progress and if it's the case, we dynamically create a
             * progress element, and take care of it's updation and removal outside the angularjs 
             * flow and digest cycle. In this way angular reduces the number of watches over the progress
             * value to one, which updates the DOM independently
             */
            
            /* keep some references for the progress and the thumb element */
            var 
                $progress, 
                uploadProgress = typeof config.getter === 'function' ? config.getter() : undefined
            ;
            
            if(uploadProgress !== undefined && uploadProgress < 1) {
                // we can watch any function
                var removeProgressWatch = scope.$watch(config.getter, function(newProgress, oldProgress) {
                    /* if we've got a progress event (eg. 0%, 5%, 10%, etc) */
                    if (typeof newProgress !== 'undefined') {
                        
                        /* we create the progress element, if not here already */
                        if (!$progress) {
                            $progress = jQuery('<div class="fm-progress"></div>');
                            $progress.appendTo(jQuery(elem));
                        }
                        
                        // set the progress width
                        // but it should be not less that 100%
                        // and we will force it to be greater that 10%
                        // because some browsers only do some notifications at the end
                        // so user don't have a smooth experience
                        $progress.width(Math.max(10, Math.min(100, Math.ceil(newProgress * 100))) + '%');
                        
                        /* if progress reached 100% */
                        if (newProgress >= 1) {
                            $timeout(function() {
                                /* when progress reaches 100%, just swipe the progress to right */
                                $progress.css({
                                    right: 0,
                                    left: 'auto',
                                    width: 0
                                });
                                /* afterwards, remove the progress element to keep the DOM clean, as we found it */
                                $timeout(function() {
                                    $progress.remove();
                                    $progress = null;
                                    config.runOnce && removeProgressWatch();
                                    config.onFinish && config.onFinish();
                                }, 200);
                            }, 200);                        
                        }
                    }
                });
            }
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                elem = null;
            });            
        }
    };
}]);

/***/ },
/* 977 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfminsert', ['$timeout', '$q', 'diyfmsectionsdata', 'diyfmconfig', 'diyfmselectiondata', 
                                              'diyl10n', 'diyfminsertprogress', 'diyfmmessages', 'diyfmstatus', 'diyfmuploadqueue',
function($timeout, $q, diyfmsectionsdata, diyfmconfig, diyfmselectiondata, diyl10n, diyfminsertprogress, 
        diyfmmessages, diyfmstatus, diyfmuploadqueue) {
    return {
        scope: true,
        template: '\
            <div class="fm-insert-hint" ng-hide="diyfmselectiondata.getInsertedItems().length">' + diyl10n('filemanager.insert.hint.message').format({plusIcon: '<span></span>'}) + '</div>\
            <div class="fm-insert-carousel-wrap" ng-show="diyfmselectiondata.getInsertedItems().length">\
                <div class="fm-insert-carousel"></div>\
            </div>\
            <div class="fm-insert-actions">\
                <button class="fm-main-button" ng-class="getInsertButtonClass()" ng-click="insert()" \
                    ng-bind-html="getInsertButtonText()"></button>\
                <div ng-show="diyfmselectiondata.getInsertedItems().length" ng-click="removeAll();" \
                    class="fm-clear-insertion"><small></small>' 
                    + diyl10n('filemanager.insert.clearselection') + '</div>\
            </div>\
        ',
        restrict: 'A',
        link: function(scope, elem, attr) {

            /* this is used in conjunction with the CSS antimations */
            var ANIMATION_DURATION = 300;
            var $carouselEl = jQuery(elem).find('.fm-insert-carousel');
            /* we have texts for both singluar and plural forms of the Add image(s) buttons */
            var insertSingularText = diyl10n('filemanager.insert.button.singulartext');
            var insertPluralText = diyl10n('filemanager.insert.button.pluraltext');
            var insertButtonText;
            
            var $dropArea = jQuery('.fm-insert-hint, .fm-insert-carousel-wrap');

            scope.diyfmselectiondata = diyfmselectiondata;

            /**
             * convert inserted items into items for the diy carousel
             * @param insertedItems
             * @returns {Array}
             */
            var getItems = function(insertedItems) {
                var items = [], item, source, imageStyle;
                for(var i = 0; i < insertedItems.length; i++) {
                    item = insertedItems[i];
                    source = item.getSource();
                    if (typeof source.getInsertThumbStyle === 'function') {
                        imageStyle = source.getInsertThumbStyle(item)
                    } else {
                        imageStyle = '';
                    }
                
                    items.push({
                        image: item.getThumb(),
                        item: item,
                        imageStyle: imageStyle
                    });
                }
                return items;
            };
            
            // XXX optimization
            // when large lists of images are added to carousel
            // it loads all images sequentially and a huge delay may be seen
            // while visible images are loaded, especially if we scroll to the
            // end of just added list
            // this is why we load images only for visible images
            // on items added and on carousel scroll
            var showImagesOnCarousel = function() {
                var visibleEls = $carouselEl.diy_carousel('getVisibleItemsEls');
                visibleEls.find('.fm-insert-thumb[data-style]').each(function(i, el){
                    var $el = jQuery(el);
                    $el.attr('style', $el.attr('data-style'))
                       .removeAttr('data-style');
                    
                });
            };

            /* initialize diy carousel */
            $carouselEl.diy_carousel({
                items: getItems(diyfmselectiondata.getInsertedItems()),
                itemTemplate: '<div class="fm-insert-thumb-container">\
                                   <div class="fm-insert-thumb" \
                                       data-style="background-image: url({image}); {imageStyle}">\
                                   </div>\
                                   <div class="fm-insert-remove-mask">\
                                       <span></span>\
                                   </div>\
                               </div>',
                selectable: false,
                afterScroll: function() {
                    showImagesOnCarousel();
                },
                afterItemsAdded: function() {
                    showImagesOnCarousel();
                }
            });

            var removeItemHandler = function(ev) {
                /* get the index of the item clicked */
                var idx = jQuery(this).index();
                /* get the item */
                var clickedItem = $carouselEl.diy_carousel('getItem', idx).item;

                scope.$apply(function() {
                    scope.diyfmselectiondata.removeItem(clickedItem, ['insert']);
                });
            };

            /*
            - Desktop
                - on hover the mask with the remove button is shown
                - on click the item is removed
            - Tablet (Touch)
                - on first tap, the mask with the remove button is shown
                - on second tap, the item is removed
             */
            if (!diy.editor.uiPreference.isPointerModeTouch()) {
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'mouseover', function(ev) {
                    jQuery(this).find('.fm-insert-remove-mask').show();
                });
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'mouseout', function(ev) {
                    jQuery(this).find('.fm-insert-remove-mask').hide();
                });
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'click', removeItemHandler);
            } else {
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'click', function(ev) {
                    if (!jQuery(this).find('.fm-insert-remove-mask').is(':visible')) {
                        jQuery('.diy-carousel-item-wrapper').find('.fm-insert-remove-mask').hide();
                        jQuery(this).find('.fm-insert-remove-mask').show();
                    } else {
                        removeItemHandler.call(this, ev);
                    }
                });
            }

            /* on any change within the inserted items array, update the items in the carousel */
            scope.$watchCollection('diyfmselectiondata.getInsertedItems()', function(newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) {
                    // Bugfix #DHDIYED-1038 - Ensure this code is executed after ng-show/ng-hide
                    // otherwise we render a component that is hidden, resulting in bad width/height
                    $timeout(function() {
                        /* get the different items that were added/inserted */
                        var diffItems;

                        /* if the item(s) were added */
                        if (newValue.length > oldValue.length) {
                            diffItems = newValue.filter(function(i) {return oldValue.indexOf(i) < 0;});
                            /* update the carousel and perform the animations */
                            var addedItemsEls = $carouselEl
                                .diy_carousel('addItems', getItems(diffItems), -1, true, function(addedItemsEls) {
                                    var imagesEls = addedItemsEls.find('.fm-insert-thumb-container');
                                    imagesEls.addClass('diy-carousel-item-animate-in');
                                    setTimeout(function() {
                                        imagesEls.removeClass('diy-carousel-item-animate-in').css('opacity', '');
                                    }, ANIMATION_DURATION);
                                });
                            addedItemsEls.find('.fm-insert-thumb-container').css('opacity', 0);
                        } else if (newValue.length < oldValue.length) { /* if the item(s) were removed */
                            diffItems = oldValue.filter(function(i) {return newValue.indexOf(i) < 0;});
                            /* get removed items */
                            var carouselDiffItems = getItems(diffItems);
                            /* get all carousel items */
                            var carouselAllItems = $carouselEl.diy_carousel('getItems');

                            /* get the indexes of the removed items */
                            var indexes = [];
                            carouselDiffItems.forEach(function(item) {
                                for (var i = 0; i < carouselAllItems.length; i++) {
                                    if (angular.equals(carouselAllItems[i], item)) {
                                        indexes.push(i);
                                    }
                                }
                            });

                            var itemsEls = jQuery(elem).find('.fm-insert-carousel .diy-carousel-item-wrapper');
                            indexes.forEach(function(index) {
                                itemsEls.eq(index).addClass('diy-carousel-item-animate-out');
                                setTimeout(function() {
                                    itemsEls.eq(index).css('opacity', 0);
                                }, ANIMATION_DURATION);
                            });
                            setTimeout(function() {
                                // if not all are deleted, use the delete one by one (slow)
                                if (newValue.length !== 0) {
                                    $carouselEl.diy_carousel('deleteItemsByIndexes', indexes);
                                } else {
                                    // if all are deleted, delete all (fast)
                                    $carouselEl.diy_carousel('option', 'items', []);
                                }
                            }, ANIMATION_DURATION);
                        } else {
                            /* if the items were changed but their number remained
                            the same, just update all the items. This is the case
                            when just 1 item is insertable, and we want to change it
                             */
                            $carouselEl
                                .diy_carousel('option', 'items', getItems(newValue));
                        }
                        var overLimit = getOverLimit();
                        if (overLimit > 0) {
                            var contentLimit = diyl10n("filemanager.insert.warning.limit").format({
                                maxLimit: diyfmconfig.getMaxSelection(),
                                alreadyExisting: diyfmconfig.getAlreadyExisting(),
                                overLimit: overLimit
                            });
                            showTooltip(contentLimit, 4500);
                        } else {
                            hideTooltip();
                        }
                    }.bind(this));
                }
            });

            var getOverLimit = function() {
                var insertedItemsLength = diyfmselectiondata.getInsertedItems().length;
                return insertedItemsLength + diyfmconfig.getAlreadyExisting() - diyfmconfig.getMaxSelection();
            }

            scope.getInsertButtonClass = function() {
                var obj = {};

                if (getOverLimit() > 0) {
                    obj['fm-insert-limit'] = true;
                } else if (diyfmselectiondata.getInsertedItems().length === 0) {
                    obj['fm-insert-none'] = true;
                }

                return obj;
            };

            scope.getInsertButtonText = function() {
                var insertedItemsLength = diyfmselectiondata.getInsertedItems().length;
                if (diyfmconfig.getMaxSelection() === 1) {
                    insertButtonText = insertSingularText;
                } else {
                    insertButtonText = insertPluralText;
                }
                return insertButtonText;
            };
            
            var hideTooltip = function() {
                jQuery(elem).find('button:diy-tooltip').diy_tooltip('hide');
            };

            var showTooltip = function(content, delay) {
                // create the tooltip that shows warning messages related to limitations upfront
                jQuery(elem).find('button').diy_tooltip({
                    triggerMode: 'none',
                    zIndex: diy.editor.getNewTopZIndex() // XXX hack - top zIndex should be computed inside the tooltip itself
                });
                jQuery(elem).find('button')
                    .diy_tooltip('option', 'content', content)
                    .diy_tooltip('option', 'show', function() {
                        jQuery(this).diy_tooltip('delayHide', delay);
                    })
                    .diy_tooltip('show');
            };

            /**
             * insert items
             * @returns {Array}
             */
            scope.insert = function() {

                // if items added are over the maximum limit or none at all
                var overLimit = getOverLimit();
                if (overLimit > 0) {
                    var contentLimit = diyl10n("filemanager.insert.warning.limit").format({
                        maxLimit: diyfmconfig.getMaxSelection(),
                        alreadyExisting: diyfmconfig.getAlreadyExisting(),
                        overLimit: overLimit
                    });
                    showTooltip(contentLimit, 4500);
                    return false;
                } else if (diyfmselectiondata.getInsertedItems().length === 0) {
                    var contentNone = diyl10n("filemanager.insert.warning.none");
                    showTooltip(contentNone, 1700);
                    return false;
                }

                // don't allow inserting while an upload is in progress
                if (diyfmstatus.getCurrentStatus().indexOf('upload') > -1) {
                    diyfmmessages.showMessage({
                        title: diyl10n('filemanager.close.upload.title'),
                        content: diyl10n('filemanager.close.insertupload.message'),
                        ok: diyl10n('filemanager.close.upload.wait')
                    });
                    return false;
                }

                var insertedItems = scope.diyfmselectiondata.getInsertedItems();

                diyfminsertprogress.show();
                scope.$emit('insertedItems', {
                    items: insertedItems
                });
                
                var 
                    queuePos = 0, 
                    itemsCount = insertedItems.length,
                    successItems = [],
                    errorItems = [],
                    errors = []
                ;
                
                function processQueue() {
                    if (queuePos === itemsCount) {
                        finishQueue();
                    } else {
                        var 
                            batch = [],
                            source = insertedItems[queuePos].getSource(),
                            sourceName = source.getName(),
                            batchSize = diyfmconfig.getSourceBatchSize(sourceName),
                            callback = diyfmconfig.getSourceCallback(sourceName);
                        ;
                        while (
                            queuePos < itemsCount
                            && insertedItems[queuePos].getSource().getName() == sourceName
                            && (batchSize === undefined || batch.length < batchSize)
                        ) {
                            batch.push(insertedItems[queuePos]);
                            queuePos++;
                        }
                        
                        diyfminsertprogress.showLoadingImage(batch[0].getThumb());

                        scope.$evalAsync(function(scope) {
                            diyfminsertprogress.setProgress(
                                queuePos, 
                                itemsCount
                            );
                        });

                        var runCallback = function(batch) {
                            callback(batch, function () {
                                // success
                                successItems = successItems.concat(batch);
                                processQueue();
                            }, function (error) {
                                // error
                                errorItems = errorItems.concat(batch);
                                errors.push(error);
                                processQueue();
                            });
                        }

                        if (typeof source.beforeInsert === 'function') {
                            source.beforeInsert(batch).then(function(batch){
                                runCallback(batch);
                            });
                        } else {
                            runCallback(batch);
                        }
                    }
                }
                function finishQueue() {
                    var finalCallback = diyfmconfig.getCallback();
                    
                    scope.$evalAsync(function(scope) {
                        diyfminsertprogress.hide();
                    });
                    
                    if (errorItems.length > 0) {
                        diyfmmessages.handleAddError({
                            errors: errors,
                            allFailed: (successItems.length === 0),
                            totalFilesFailed: errorItems.length
                        });
                        /* remove succesfully added items so that the user
                        can click again and try adding the remaining ones */
                        scope.$evalAsync(function(scope) {
                            successItems.forEach(function(item) {
                                diyfmselectiondata.removeItem(item, ['insert']);
                            });
                            var config = diyfmconfig.getConfig();
                            config.alreadyExisting += successItems.length;
                            diyfmconfig.setConfig(config);
                        });
                    } else {
                        scope.$evalAsync(function(scope) {
                            // TODO de-hardcode closing
                            diy.editor.filemanager.close();
                        });
                    }
                    
                    finalCallback({
                        errorItems: errorItems,
                        successItems: successItems
                    });
                }
                processQueue();
            };

            scope.removeAll = function() {
                scope.diyfmselectiondata.removeAllItems(['insert']);
                scope.$emit('clearAllInserted');
            };

            // support for drag and drop the the footer area
            $dropArea.bind('dragover', function(ev) {
                /* if there's no preventDefault in the dragover event,
                 then no drop will occur. highly undocumented featured,
                 found this out on StackOverflow */
                ev.preventDefault();
            });

            $dropArea.bind('dragover', function(ev) {
                jQuery(this).addClass('fm-insert-dragover');
            });

            $dropArea.bind('dragleave', function(ev) {
                jQuery(this).removeClass('fm-insert-dragover');
            });

            $dropArea.bind('drop', function(ev) {
                jQuery(this).removeClass('fm-insert-dragover');

                if (ev.originalEvent.dataTransfer
                    && ev.originalEvent.dataTransfer.files
                    && ev.originalEvent.dataTransfer.files.length > 0)
                {
                    scope.$emit('uploadFiles.up', ev.originalEvent.dataTransfer.files, undefined, true, 'drag-insert');
                } else {
                    scope.$apply(function(scope) {
                        var i = 0;
                        var selectedItems = diyfmselectiondata.getSelectedItems();
                        selectedItems.forEach(function(selectedItem) {
                            diyfmselectiondata.addItem(selectedItem, ['insert']);
                        });
                        
                        scope.$emit('addToInsertion', {
                            items: selectedItems,
                            source: 'dragdrop',
                            subsection: diyfmsectionsdata.getCurrentSubsection()
                        });
                        
                        diyfmselectiondata.removeAllItems(['select']);
                    });
                }

                return false;
            });
        }
    };
}]);


/***/ },
/* 978 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmpreview', ['$timeout', 'diyfmsectionsdata', 'diyfilename', 'diyl10n', 'diyfmselectiondata', 'diyfiledownload', 'diyfmconfig',
function($timeout, diyfmsectionsdata, diyfilename, diyl10n, diyfmselectiondata, diyfiledownload, diyfmconfig) {

    var tpl = '\
        <div class="fm-preview-wrap"\
            ng-class="{\
                    \'fm-item-noname\': !item.getName(),\
                    \'fm-item-inserted\': inserted\
            }"\
            >\
            <div class="fm-preview-image">\
                <div class="fm-preview-image-wrap">\
                    <img ng-style="preview.item.getSource().getPreviewStyle(preview.item)" />\
                </div>\
                <div class="fm-preview-prev"\
                    ng-show="preview.prevItem"\
                    ng-click="showPreview(preview.prevItem, false)"><div class="ui-icon"></div></div>\
                <div class="fm-preview-next"\
                    ng-show="preview.nextItem"\
                    ng-click="showPreview(preview.nextItem, false)"><div class="ui-icon"></div></div>\
                <div ng-hide="diyfmconfig.isInManagementMode() || actions.length > 0" \
                    class="fm-preview-add" ng-click="toggleInsert(preview.item, \'preview\')">{{addLabel}}</div>\
            </div>\
            <div class="fm-preview-sidebar" ng-show="actions.length > 0">\
                <div class="fm-preview-name-section">\
                    <div class="fm-preview-name" ng-bind="preview.item.getName()"\
                        diyfminlineedit="nameEditConfig"\
                        ></div>\
                </div>\
                <div class="fm-preview-actions">\
                    <div class="fm-preview-action"\
                        ng-repeat="_action in actions"\
                        ng-init="buttonConfig = {icons: {primary: \'ui-icon-\' + _action.icon}, label: _action.title}"\
                        >\
                        <button \
                            diybutton="buttonConfig" \
                            class="ui-button-borderless"\
                            ng-click="actionClick(_action)"\
                                ></button>\
                    </div>\
                </div>\
                <div ng-hide="diyfmconfig.isInManagementMode()" class="fm-preview-add" ng-click="toggleInsert(preview.item, \'preview\')">{{addLabel}}</div>\
            </div>\
            <div class="ui-icon ui-icon-close" ng-click="hidePreview(true, true)"></div>\
        </div>';

    return {
        template: tpl,
        scope: true,
        link: function(scope, elem, attr) {

            var 
                $elem = jQuery(elem),
                $img = $elem.find('.fm-preview-image img')
            ;

            scope.diyfmconfig = diyfmconfig;

            // TODO this is done to prevent dragging of the preview image, though in the future it would be nice to be able to drag it as well
            $img.bind('dragstart', function (e) {e.preventDefault();});
            
            scope.nameEditConfig = {
                textarea: true,
                end: function(value) {
                    scope.renameItem(scope.preview.item, value);
                }
            };
            
            scope.addLabel = diyl10n('filemanager.preview.addFile');

            scope.actionClick = function(action) {
                switch(action.name) {
                    case 'rename':
                        var parsedName = diyfilename.parse(scope.preview.item.getName());
                        scope.nameEditConfig.start(parsedName.name);
                        break;
                    case 'delete':
                        scope.deleteItem(scope.preview.item);
                        break;
                    case 'download':
                        diyfiledownload(scope.preview.item.getFile());
                        break;
                    default:
                        break;
                }
            };
            
            scope.actions = [];

            scope.$watch(diyfmsectionsdata.getCurrentSubsection, function(newSubsection) {
                if (newSubsection) {
                    var actions = [];
                    actions.length = 0;

                    newSubsection.getItemActions().forEach(function(action) {
                        if (action.name !== 'preview') {
                            actions.push(action);
                        }
                    });

                    scope.actions = actions;
                }
            });

            scope.$watch('preview.item', function(newPreviewItem){
                if (newPreviewItem) {
                    // quickly replace it with a blank gif
                    // so that if loading preview image will take a while
                    // old preview image will not be shown instead
                    // we leave 10ms to allow the browser to start loading the blank image,
                    // if it doesn't have enough time it will skip the blank and negate its purpose
                    $img.attr('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
                    $timeout(function(){
                        $img.attr('src', newPreviewItem.getPreview());
                    }, 10);

                    updateInsertedState();
                }
            });

            var updateInsertedState = function() {
                scope.inserted = diyfmselectiondata.isItemInserted(scope.preview.item);
                if (scope.inserted) {
                    scope.addLabel = diyl10n('filemanager.preview.fileAdded');
                } else {
                    scope.addLabel = diyl10n('filemanager.preview.addFile');
                }
            }

            scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(newValue, oldValue) {
                if (scope.preview.item) {
                    updateInsertedState();
                }
            });
        }
    };
}]);



/***/ },
/* 979 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfminlineedit', [ 
function() {
    
    var $ = jQuery;
    
    function startInlineEdit(el, value) {
        var input, self = this;
        
        function removeInlineEdit() {
            // cleanup to prevent memory leaks
            input.unbind('.fminlineedit');
            input.remove();
            if (self.textarea) {
                el.css('height', '');
            }
            el.removeClass('fm-inline-edited');
            input = null;
            el = null;
        }
        
        function endInlineEdit() {
            var val = input.val();
            removeInlineEdit(input, el)
            self.end && self.end(val); 
            self = null;
        }
        
        function cancelInlineEdit() {
            removeInlineEdit(input, el);
            self.cancel && self.cancel();
            self = null;
        }
        if (this.textarea) {
            input = $('<textarea />');
        } else {
            input = $('<input type="text" />');
        }
        input.addClass('fm-inline-edit').appendTo(el).val(value);
        if (this.placeholder) {
            input.attr('placeholder', this.placeholder);
        }
        el.addClass('fm-inline-edited');
        
        
        input.bind('blur.fminlineedit', function(ev) {
            endInlineEdit();
        }).bind('keydown.fminlineedit', function(ev) {
            if (13 === ev.which) { // ENTER key
                endInlineEdit();
            } else if (27 === ev.which) { // ESCAPE key
                cancelInlineEdit();
            } else if (self.textarea) {
                // autogrow
                el.height(input[0].scrollHeight);
            }
            ev.stopPropagation();
        }).bind('click.fminlineedit focus.fminlineedit keypress.fminlineedit', function(ev) {
            // otherwise events will propagate to their parents which may catch
            // them and the parents may return false, disabling these events
            // example: jQuery.ui.dialog compares some zIndexes and disables keydown events
            ev.stopPropagation();
        });
        input.focus();
    }

    return {
        restrict: 'A',
        link: function(scope, elem, attr) {

            var $elem = $(elem);
            
            var getConfig = function() {
                return scope.$eval(attr.diyfminlineedit);
            }
            
            var unWatch = scope.$watch(getConfig, function(config){
                if (config) {
                    config.start = function(value) {
                        if ('function' === typeof config.beforeStart) {
                            config.beforeStart();
                        }
                        startInlineEdit.call(config, $elem, value);
                    };
                    unWatch();
                }
            });
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                $elem = null;
                attr = null;
            });
        }
    };
}]);

/***/ },
/* 980 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmdropfiles', [ 
function() {
    var $ = jQuery;
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {

            var $elem = $(elem);
            
            var getConfig = function() {
                return scope.$eval(attr.diyfmdropfiles);
            }
            
            var config = getConfig();
            if (config === undefined) {
                var unWatch = scope.$watch(getConfig, function(val){
                    config = val;
                    unWatch();
                })
            }
            
            // XXX necesarry trick so that drop of files will function
            $elem.bind('dragover', function(ev) {
                return false;
            });
            
            $elem.bind('drop', function(ev) {
                if (ev.originalEvent.dataTransfer
                    && ev.originalEvent.dataTransfer.files
                    && ev.originalEvent.dataTransfer.files.length > 0)
                {
                    scope.$emit(config.eventName, ev.originalEvent.dataTransfer.files, config.data, undefined, config.source);
                }
                return false;
            }); 
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                config = null;
                attr = null;
            });
        }
    };
}]);

/***/ },
/* 981 */
/***/ function(module, exports) {

diy.angular.registerDirective('diyfmblockingmask', [ 
function() {
    var $ = jQuery;
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {

            var $elem = $(elem), mask;
            
            var getConfig = function() {
                return scope.$eval(attr.diyfmblockingmask);
            }
            
            var config = getConfig();
            if (config === undefined) {
                var unWatch = scope.$watch(getConfig, function(val){
                    config = val;
                    unWatch();
                })
            }
            
            scope.$watch(config.isBlocked, function(isBlocked, oldIsBlocked){
                if (isBlocked !== oldIsBlocked) {
                    if (isBlocked) {
                        if ($elem.css('position') === 'static') {
                            $elem.css('position', 'relative');
                        }
                        mask = $('<div class="fm-blocking-mask"></div>').appendTo($elem);
                        if (config.getReasons().length > 0) {
                            mask.diy_simpleTooltip({
                                content: config.getReasons().join('<br/>'),
                                trackMouse: true,
                                triggerMode: 'click',
                                anchorToTarget: false
                            });
                        }
                    } else {
                        mask.remove();
                        $elem.css('position', '');
                    }
                }
            });
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                config = null;
                attr = null;
                mask && mask.remove();
                mask = null;
            });
        }
    };
}]);

/***/ },
/* 982 */
/***/ function(module, exports) {

/**
 * Directive responsible for the color picker used for color searches.
 * Based on the diy.combobox
 */
diy.angular.registerDirective('diyfmcolorsfilter', ['diyl10n', 'diyfmsectionsdata',
function(diyl10n, diyfmsectionsdata) {
    var $ = jQuery
        COLOR_ALL = 'all',
        COLOR_BW = 'black_and_white';

    return {
        template: '',
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            var $elem = $(elem), i;

            scope.colors = [{
                id: 'all',
                value: COLOR_ALL
            }, /* DISABLED - support not implemented by CMS {
                id: 'blackAndWhite',
                value: COLOR_BW
            },*/ {
                id: 'red',
                value: 'ff0000'
            }, {
                id: 'orange',
                value: 'ffa500'
            }, {
                id: 'yellow',
                value: 'ffff00'
            }, {
                id: 'green',
                value: '008000'
            }, {
                id: 'blue',
                value: '0000ff'
            }, {
                id: 'purple',
                value: 'ee82ee'
            }, {
                id: 'white',
                value: 'ffffff'
            }, {
                id: 'grey',
                value: '808080'
            }, {
                id: 'black',
                value: '000000'
            }];
            for (i = 0; i < scope.colors.length; i++) {
                scope.colors[i].label = diyl10n('filemanager.colorsearch.' + scope.colors[i].id);
            }
            scope.selectedColor = null;

            var colorRenderer = function(elem, item) {
                var css;

                // reset special classes //
                elem.removeClass([
                    'diye-color-all',
                    'diye-color-bw',
                    'diye-color-white'
                ].join(' '));

                if (!item || !item.rawValue) {
                    elem.html('<span class="diye-color-empty-label">' + diyl10n('filemanager.colorsearch.placeholder') + '</span>');
                    return;
                }

                elem.html('<span class="diye-color-box"></span>' + item.label);
                if (item.rawValue === COLOR_ALL){
                    elem.addClass('diye-color-all');
                } else if (item.rawValue === COLOR_BW) {
                    elem.addClass('diye-color-bw');
                } else {
                    css = {
                        backgroundColor: '#' + item.rawValue
                    }
                    // special rule just for White //
                    if (item.id === 'white') {
                        elem.addClass('diye-color-white');
                    }
                    elem.find('.diye-color-box').css(css);
                }
            };

            $elem.diy_combobox({

                data: scope.colors,
                emptyText: '',
                menuCssClass: 'diye-fm-colorsfilter',
                select: function(e, ui) {
                    scope.$apply(function() {
                        scope.selectedColor = ui.rawValue;
                    });
                    return false;
                },
                renderPreview: colorRenderer,
                renderItem: colorRenderer
            });

            // init color selector //
            scope.$watch(diyfmsectionsdata.getCurrentSubsection, function(newSubsection, oldSubsection) {
                // do a reset when changing to a new section //
                if (newSubsection) {
                    scope.selectedColor = null;
                    newSubsection.setColorSearch(null);
                    $elem.diy_combobox('option', 'rawValue', null);
                }
            });
            scope.$watch('selectedColor' , function (newColor, oldColor) {
                var subsection = diyfmsectionsdata.getCurrentSubsection();
                if (subsection) {
                    if (newColor && newColor !== COLOR_ALL) {
                        subsection.setColorSearch(newColor);
                    } else {
                        subsection.setColorSearch(null);
                    }
                }
            });

            //TODO: watch for destroy and unbind all event handlers - if any!
        }
    };
}]);


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var Dialog_1 = __webpack_require__(468);
var FlatButton_1 = __webpack_require__(479);
var diyLightTheme = __webpack_require__(241);
var l10n_1 = __webpack_require__(18);
var DisclaimerDialog = (function (_super) {
    tslib_1.__extends(DisclaimerDialog, _super);
    function DisclaimerDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisclaimerDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    DisclaimerDialog.prototype.render = function () {
        var actions = [
            (this.props.btnCancelText) ?
                React.createElement(FlatButton_1.default, { label: this.props.btnCancelText, secondary: true, onTouchTap: this.props.btnCancelAction, "data-test-id": "disclaimer-cancel-btn" }) :
                null,
            React.createElement(FlatButton_1.default, { label: this.props.btnText, primary: true, onTouchTap: this.props.btnAction, "data-test-id": "disclaimer-action-btn" }),
        ];
        return (React.createElement("div", null,
            React.createElement(Dialog_1.default, { actions: actions, modal: true, open: true, style: { zIndex: 200002 }, autoScrollBodyContent: true, contentStyle: { maxWidth: 600 }, bodyStyle: { padding: 0 } }, this.props.children)));
    };
    return DisclaimerDialog;
}(React.Component));
DisclaimerDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
var rootEl = null;
var styles = {
    title: {
        fontWeight: "bold",
        fontSize: "16px",
        marginBottom: "12px",
        textDecoration: "underline",
        textAlign: "center",
    },
    paragraph: { fontSize: "13px", margin: "6px 0px" },
    body: { padding: "24px" }
};
function showDialog(btnAction, btnCancelAction) {
    rootEl = document.createElement("div");
    document.body.appendChild(rootEl);
    var messageTitle = l10n_1.default("filemanager.disclaimer.title").replace(/&amp;/, '&');
    var messageText = l10n_1.default("filemanager.disclaimer.text");
    if (jimdoData.market === 'en_CA') {
        messageText = messageText.replace(/www.ionos.com/, 'www.ionos.ca');
    }
    var btnGoText = l10n_1.default("filemanager.disclaimer.button.agree");
    var bntCancelText = l10n_1.default("filemanager.disclaimer.button.cancel");
    ReactDOM.render(React.createElement(DisclaimerDialog, { btnText: btnGoText, btnAction: btnAction, btnCancelText: bntCancelText, btnCancelAction: btnCancelAction },
        React.createElement("div", { "data-test-id": "disclaimer-dialog-content", id: "cipDisclaimer" },
            React.createElement("div", { style: styles.body },
                React.createElement("div", { style: styles.title }, messageTitle),
                React.createElement("p", { style: styles.paragraph, dangerouslySetInnerHTML: { __html: messageText } })))), rootEl);
}
exports.showDialog = showDialog;
;
function closeDialog() {
    if (rootEl) {
        ReactDOM.unmountComponentAtNode(rootEl);
        document.body.removeChild(rootEl);
    }
}
exports.closeDialog = closeDialog;


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

exports.init = function() {

    /* when modules open, add the insert image button to their toolbar */
    $(document).bind('diy-editor-module-opened-for-editing', function(ev, data) {
        var module = data.module;

        /* only add button to the toolbar for Gallery, Image and Image with Text modules */
        if (['gallery'].indexOf(module.getModuleType()) === -1) {
            return;
        }
        var buttonLabel, iconCls;
        switch (module.moduleType) {
            case 'gallery':
                buttonLabel = jimdoData.messages.filemanager.openFromGalleryModule;
                iconCls = 'add-images';
                break;
        }

        /* create button template */
        var fileManagerTpl = '\
            <div class="mod-bar-primary-sep" style="display: block"></div>\
            <div class="mod-bar-primary-section mod-fm-insert-image" id="mod-fm-insert-image_' + module.moduleId + '">\
            <div class="mod-bar-primary-section-title">' + buttonLabel +'</div>\
            <div class="mod-bar-primary-section-content">\
            <a onclick="mm[' + module.moduleId + '].startFileManager();"\
                class="ui-icon-24 ' + iconCls + ' mod-bar-secondary-section-tab"></a>\
            </div></div>';

        var $configEl = module.getEditorContainer();

        /* append template to module's toolbar */
        if (!$configEl.find('.mod-fm-insert-image').length) {

            if ('gallery' == module.moduleType) {
                $configEl.find('.mod-bar-primary-section:last').after(fileManagerTpl);
            }
        }
    });
};


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
/* tslint:disable:no-unused-variable */
/* TypeScript doesn't see usages in Object shorthand notation {x,y,z} */
var Matrix_1 = __webpack_require__(641);
var Modul_1 = __webpack_require__(197);
var ModuleInlineEditor_1 = __webpack_require__(986);
var ModulMatrix_1 = __webpack_require__(987);
var ModulButton_1 = __webpack_require__(988);
var ModulHtmlCode_1 = __webpack_require__(1012);
var ModulFlashElement_1 = __webpack_require__(1013);
var ModulFliestext_1 = __webpack_require__(1014);
var ModulSpacer_1 = __webpack_require__(1061);
var ModulTextWithImage_1 = __webpack_require__(1067);
var ModulImageSubtitle_1 = __webpack_require__(1102);
var ModulTabelle_1 = __webpack_require__(1103);
var ModulDelicious_1 = __webpack_require__(1110);
var ModulRss_1 = __webpack_require__(1111);
var ModulVideo_1 = __webpack_require__(1112);
var ModulGooglemaps_1 = __webpack_require__(1113);
var ModulGallery_1 = __webpack_require__(1114);
var ModulHr_1 = __webpack_require__(1116);
var ModulDownloadDocument_1 = __webpack_require__(1120);
var ModulHeaderHeading_1 = __webpack_require__(1121);
var ModulGuestbook_1 = __webpack_require__(1124);
var ModulWebcomponent_1 = __webpack_require__(1125);
var ModulSection_1 = __webpack_require__(498);
var ModulSectionContainer_1 = __webpack_require__(1126);
var ModuleOverlay_1 = __webpack_require__(643);
/* tslint:enable:no-unused-variable */
var AppRegistry_1 = __webpack_require__(190);
var DragDrop = __webpack_require__(1127);
// Used by edit view
Object.assign(window, {
    Matrix: Matrix_1.default,
    ModuleOverlay: ModuleOverlay_1.default,
    Modul: Modul_1.default,
    ModuleInlineEditor: ModuleInlineEditor_1.default,
    ModulMatrix: ModulMatrix_1.default,
    ModulButton: ModulButton_1.default,
    ModulHtmlCode: ModulHtmlCode_1.default,
    ModulFlashElement: ModulFlashElement_1.default,
    ModulFliestext: ModulFliestext_1.default,
    ModulSpacer: ModulSpacer_1.default,
    ModulTextWithImage: ModulTextWithImage_1.default,
    ModulImageSubtitle: ModulImageSubtitle_1.default,
    ModulTabelle: ModulTabelle_1.default,
    ModulDelicious: ModulDelicious_1.default,
    ModulRss: ModulRss_1.default,
    ModulVideo: ModulVideo_1.default,
    ModulGooglemaps: ModulGooglemaps_1.default,
    ModulGallery: ModulGallery_1.default,
    ModulHr: ModulHr_1.default,
    ModulDownloadDocument: ModulDownloadDocument_1.default,
    ModulHeaderHeading: ModulHeaderHeading_1.default,
    ModulGuestbook: ModulGuestbook_1.default,
    ModulWebcomponent: ModulWebcomponent_1.default,
    ModulSection: ModulSection_1.default,
    ModulSectionContainer: ModulSectionContainer_1.default
});
$(document).ready(function () {
    $(window).bind('resize', function () {
        if (Modul_1.default.getActiveModule()) {
            Modul_1.default.getActiveModule().repositionOverlay();
        }
    });
});
var LinkSelector = __webpack_require__(1134);
// Expose to non-webpack code
diy.editor.linkSelector = new LinkSelector();
var upgradeLayer = __webpack_require__(1135);
// Expose to non-webpack code
diy.editor.upgradeLayer = upgradeLayer;
var trialLayer = __webpack_require__(1136);
diy.editor.trialLayer = trialLayer;
// schedule trial link click handling to be established when document loads
$(function () {
    trialLayer.initTrialLink();
});
var dragDrop = new DragDrop();
AppRegistry_1.default.setModuleDragDrop(dragDrop);
$(function () {
    dragDrop.init();
});
__webpack_require__(1137);


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var ModuleInlineEditor = (function () {
    /**
     * Constructor
     *
     * @param Modul
     */
    function ModuleInlineEditor(module, element) {
        // Mouse down events on Action Bar mess up with CKEditor's
        // current selection. This is a fix for most of such cases.
        this.onActionBarMouseDown = function (event) {
            if (event.target instanceof HTMLElement) {
                if (event.target.tagName.toLowerCase() === 'input') {
                    return;
                }
            }
            event.preventDefault();
        };
        this.module = module;
        if (typeof element === 'string') {
            this.elementId = element;
        }
        else {
            this.element = element;
        }
    }
    /**
     * @return {JQuery} the element to be edited as a jQuery object
     */
    ModuleInlineEditor.prototype.getElement = function () {
        if (this.element) {
            return $(this.element);
        }
        return $('#' + this.elementId);
    };
    /**
     * @param {object} options
     */
    ModuleInlineEditor.prototype.startEditing = function (options) {
        var _this = this;
        var editableContainer;
        // remove module from dragables during editing //
        this.module.disableDragging();
        editableContainer = this.getElement();
        // replace internal links so that they can be edited //
        editableContainer.html(this.module.replaceInternalLinksForEditor(editableContainer.html()));
        // start editing on the content area //
        editableContainer.attr('contenteditable', 'true');
        // disable custom object editing controls from the browser as they cause more harm than good //
        try {
            if (document.execCommand) {
                document.execCommand('enableObjectResizing', false, 'false');
                document.execCommand('enableInlineTableEditing', false, 'false');
            }
        }
        catch (err) {
            // we really don't care if this fails //
        }
        this.editor = CKEDITOR.inline(this.getElement()[0], options);
        //if not set explicitly to not focus on editor at start up
        // focus on editor
        if (options.startupFocus !== false) {
            this.editor.focus();
        }
        if (options.hideToolbar) {
            this.hideToolbar();
        }
        this.editor.on('focus', function () {
            _this.editor.focusManager.lock();
        });
        document.getElementById('diy-module-action-bar')
            .addEventListener('mousedown', this.onActionBarMouseDown);
    };
    ModuleInlineEditor.prototype.stopEditing = function () {
        var editableContainer;
        editableContainer = this.getElement();
        // do some cleanup when closing the module //
        try {
            if (document.execCommand) {
                document.execCommand('enableObjectResizing', false, 'true');
                document.execCommand('enableInlineTableEditing', false, 'true');
            }
        }
        catch (err) {
            // we really don't care if this fails //
        }
        editableContainer.removeAttr('contenteditable');
        editableContainer.blur();
        if (this.editor) {
            try {
                this.showToolbar();
                this.editor.destroy();
            }
            catch (e) {
                this.hideToolbar();
                // XXX sometimes IE trows some weird errors
                // do nothing then
            }
        }
        document.getElementById('diy-module-action-bar')
            .removeEventListener('mousedown', this.onActionBarMouseDown);
    };
    ModuleInlineEditor.prototype.hideToolbar = function () {
        $('head').append("\n            <style id=\"" + this.editor.id + "-hide\">\n                #" + this.editor.id + "_top {\n                    display: none !important;\n                }\n                ." + this.editor.id + ".cke_chrome {\n                    border: 0 !important;\n                }\n            </style>\n        ");
    };
    ModuleInlineEditor.prototype.showToolbar = function () {
        $("#" + this.editor.id + "-hide").remove();
    };
    ModuleInlineEditor.prototype.getHtmlData = function () {
        return this.editor.getData();
    };
    ModuleInlineEditor.prototype.isDirty = function () {
        if (!this.editor) {
            return false;
        }
        return this.editor.checkDirty();
    };
    ModuleInlineEditor.prototype.getEditor = function () {
        return this.editor;
    };
    return ModuleInlineEditor;
}());
exports.default = ModuleInlineEditor;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
/**
 * Matrix module
 */
var AppRegistry_1 = __webpack_require__(190);
var index_1 = __webpack_require__(198);
var Modul_1 = __webpack_require__(197);
var siteadminApi = __webpack_require__(19);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulMatrix = (function (_super) {
    tslib_1.__extends(ModulMatrix, _super);
    function ModulMatrix() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Instead of opening a config view, we just freeze the overlay
     * so we can edit the modules in the matrix
     */
    ModulMatrix.prototype.open = function () {
        var self = this;
        var moduleId = this.moduleId;
        // first put in active state to disable other modules overlay while animating
        getStore().dispatch(index_1.moduleOverlayShow({ moduleId: moduleId, status: index_1.OverlayStatusMap.ACTIVE }));
        this.getContentContainer().find('.matrix-module-configuration').slideDown(function () {
            self.hideOverlay();
            self.freezeOverlay(true);
            getStore().dispatch(index_1.moduleOverlayHide({ moduleId: moduleId }));
        });
        // matrix module will add content on server side, so it's actually never new
        //  and it does not have a cancel action
        this.setIsNew(false);
        this.getContentContainer().find('input.checkbox').diy_checkbox().click(function () {
            var flag = $(this).is(':checked');
            siteadminApi.toggleSidebar(!flag);
            self.setFullwidth(flag);
        });
        try {
            // initialize help link
            cms.help.GuidedAssistant._instance
                ._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
        }
        catch (e) {
            // do nothing
        }
    };
    /**
     * Returnes whether there is an opened module inside the matrix.
     * If not, returns null
     */
    ModulMatrix.prototype.getChildModuleInEditMode = function () {
        var childrenInEdit = this.getChildModules().filter(function (m) { return m.getIsInEditMode(); });
        return childrenInEdit.length ? childrenInEdit[0] : null;
    };
    /**
     * Instead of closing the config view, we just unfreeze the overlay
     * so we can edit the matrix module itself
     */
    ModulMatrix.prototype.close = function () {
        var self = this;
        var childModuleInEditMode;
        /* added in try-catch just for the moment */
        try {
            /* if there's any module currently editing inside the matrix,
            we close it immidiately */
            childModuleInEditMode = this.getChildModuleInEditMode();
            if (childModuleInEditMode) {
                childModuleInEditMode.close();
            }
        }
        catch (e) {
            // do nothing
        }
        getStore().dispatch(index_1.moduleOverlayShow({ moduleId: this.moduleId, status: index_1.OverlayStatusMap.ACTIVE }));
        this.getContentContainer().find('.matrix-module-configuration').slideUp(function () {
            self.freezeOverlay(false);
            self.showOverlay();
            getStore().dispatch(index_1.moduleOverlayChangeStatus({ status: index_1.OverlayStatusMap.HOVER }));
        });
    };
    /**
     * Remove method for matrix module first removes the elements inside it
     * and then removes itself. This removal is only DOM, the ajax delete
     * request is not performed from here
     */
    ModulMatrix.prototype.remove = function () {
        this.getChildModules().forEach(function (m) {
            var moduleId = m.moduleId;
            m.remove();
            Modul_1.default.deleteInstance(moduleId);
        });
        _super.prototype.remove.apply(this, arguments);
    };
    ModulMatrix.prototype.showBusyMask = function () {
        this.getModuleElement().find('.matrix-module-configuration-busy').show();
    };
    ModulMatrix.prototype.hideBusyMask = function () {
        this.getModuleElement().find('.matrix-module-configuration-busy').hide();
    };
    /**
     * add a local module of a certain type into a certain matrix in the current page
     * @param type
     * @param matrixId
     */
    ModulMatrix.prototype.addM = function (type, matrixId) {
        // show busy mask to prevent additional clicks - #DHDIY-20542
        this.showBusyMask();
        var destinationParams = {
            matrixId: matrixId,
            afterChildId: null,
            pageId: 0 // same page
        };
        var moduleObj = {
            getInsertParams: function () {
                return {
                    moduleName: type
                };
            },
            getInsertPlaceholder: function () {
                return $('<div class="diye-new-module-placeholder"></div>');
            }
        };
        Modul_1.default.insert('add', moduleObj, destinationParams);
    };
    ModulMatrix.prototype.toggleStyle = function () {
        if (this.modul.find("label.switch-label.selected").attr('data-attr') === 'teaser') {
            this.switchStyle('default');
        }
        else {
            this.switchStyle('teaser');
        }
    };
    ModulMatrix.prototype.getGrid = function () {
        return this.modul.find('div.diyfeModGridGroup');
    };
    ModulMatrix.prototype.getFieldIsFullwidth = function () {
        return $('#formular_' + this.moduleId).find('input[type=hidden][name=isFullwidth]');
    };
    ModulMatrix.prototype.isTeaser = function () {
        return this.getGrid().hasClass('diyfeModGridStyleTeaser');
    };
    ModulMatrix.prototype.setTeaser = function (flag) {
        if (flag) {
            if (!this.isTeaser()) {
                this.getGrid().addClass('diyfeModGridStyleTeaser');
            }
        }
        else {
            this.getGrid().removeClass('diyfeModGridStyleTeaser');
        }
    };
    ModulMatrix.prototype.setFullwidth = function (flag) {
        this.getFieldIsFullwidth().val(flag ? 1 : 0);
        this.modul.toggleClass('diyfeLiveArea', !flag);
        $('#module-overlay-group-' + this.moduleId)
            .find('.module-deletebar-wrapper').toggleClass('fullwidth', flag);
        $('#module-overlay-group-' + this.moduleId)
            .find('.module-movebar').toggleClass('fullwidth', flag);
    };
    /**
     * Switches the style to new class (i.e teaser)
     * @param type
     */
    ModulMatrix.prototype.switchStyle = function (styleType) {
        var teaserObject = this.modul.find("div.diyfeModGridGroup");
        var hiddenInput = $("#formular_" + this.moduleId).find("input[type='hidden'][name='cssClasses']");
        var sliderObject = this.modul.find(".matrix-module-configuration .th-btn-toggle");
        if (styleType === "teaser") {
            if (!teaserObject.hasClass("diyfeModGridStyleTeaser")) {
                teaserObject.addClass("diyfeModGridStyleTeaser");
            }
            if (!$("#switch-label-teaser-" + this.moduleId).hasClass("selected")) {
                $("#switch-label-teaser-" + this.moduleId).addClass("selected");
            }
            $("#switch-label-default-" + this.moduleId).removeClass("selected");
            sliderObject.removeClass("diy-btn-selected");
        }
        else {
            if (!sliderObject.hasClass("diy-btn-selected")) {
                sliderObject.addClass("diy-btn-selected");
            }
            if (!$("#switch-label-default-" + this.moduleId).hasClass("selected")) {
                $("#switch-label-default-" + this.moduleId).addClass("selected");
            }
            $("#switch-label-teaser-" + this.moduleId).removeClass("selected");
            teaserObject.removeClass("diyfeModGridStyleTeaser");
        }
        hiddenInput.val(teaserObject.attr("class"));
    };
    ModulMatrix.prototype.save = function () {
        return _super.prototype.save.apply(this, arguments);
    };
    return ModulMatrix;
}(Modul_1.default));
exports.default = ModulMatrix;


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var ModulWithRedux_1 = __webpack_require__(493);
var EditView_1 = __webpack_require__(989);
var InPlaceEditView_1 = __webpack_require__(1009);
var WebView_1 = __webpack_require__(1010);
var ModulButton = (function (_super) {
    tslib_1.__extends(ModulButton, _super);
    function ModulButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helpArticleId = "element_button";
        return _this;
    }
    ModulButton.prototype.getSaveData = function () {
        var data = _super.prototype.getSaveData.call(this);
        delete data.defaultBackgroundColor;
        delete data.defaultTextColor;
        return data;
    };
    ModulButton.prototype.getActionBarTabs = function () {
        return [
            { label: this.textLabel, content: this.getConnectedComponent(EditView_1.default) }
        ];
    };
    ModulButton.prototype.getInPlaceEditViewClass = function () {
        return InPlaceEditView_1.default;
    };
    ModulButton.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    return ModulButton;
}(ModulWithRedux_1.default));
exports.default = ModulButton;


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var IconTextButton_1 = __webpack_require__(459);
var IconTextButtonGroup_1 = __webpack_require__(990);
var TextField_1 = __webpack_require__(473);
var ResponsiveBar_1 = __webpack_require__(992);
var autoprefixer_1 = __webpack_require__(438);
var link_1 = __webpack_require__(993);
var format_align_left_1 = __webpack_require__(994);
var format_align_center_1 = __webpack_require__(995);
var format_align_right_1 = __webpack_require__(996);
var ButtonBackgroundColorIcon_1 = __webpack_require__(997);
var ButtonTextColorIcon_1 = __webpack_require__(999);
var ColorPickerWithLsDropdown_1 = __webpack_require__(1000);
var ColorPicker_1 = __webpack_require__(1002);
var ButtonEditView = (function (_super) {
    tslib_1.__extends(ButtonEditView, _super);
    function ButtonEditView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.alignValues = ["left", "center", "right"];
        _this.onBackgroundColorChange = function (hexColor, isDefault) {
            _this.props.onDataChange(Object.assign({}, _this.props.payload, {
                backgroundColor: isDefault ? '' : hexColor
            }));
        };
        _this.onTextColorChange = function (hexColor, isDefault) {
            _this.props.onDataChange(Object.assign({}, _this.props.payload, {
                textColor: isDefault ? '' : hexColor
            }));
        };
        _this.onTextChange = function () {
            _this.props.onDataChange(Object.assign({}, _this.props.payload, {
                text: _this.textField.getValue()
            }));
        };
        _this.onAlignChange = function (e, value) {
            _this.props.onDataChange(Object.assign({}, _this.props.payload, {
                align: _this.alignValues[value]
            }));
        };
        _this.onLinkClick = function () {
            diy.editor.linkSelector.openDialog({
                href: _this.props.payload.link
            }, function (outputLinkData) {
                _this.props.onDataChange(Object.assign({}, _this.props.payload, {
                    link: outputLinkData.href,
                    linkTarget: outputLinkData.target
                }));
            });
        };
        return _this;
    }
    ButtonEditView.prototype.getStyles = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                display: "flex",
                padding: 4,
                fontSize: "12px",
            }),
            link: {
                marginRight: 24
            },
            button: {
                marginRight: 4
            },
            left: {
                marginRight: "12px",
                alignSelf: "center",
                WebkitAlignSelf: "center",
                fontSize: "12px"
            },
            input: {
                display: "inline-block",
                verticalAlign: "top",
                marginLeft: 24
            }
        };
    };
    ButtonEditView.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            React.createElement(ResponsiveBar_1.default, null,
                React.createElement(IconTextButton_1.default, { style: styles.link, Icon: React.createElement(link_1.default, null), text: l10n_1.default("module.button.link"), dataTestId: "btn-module-add-or-edit-link-btn", onTouchTap: this.onLinkClick }),
                this.props.payload.supports.buttonAlign ?
                    React.createElement(IconTextButtonGroup_1.default, { Icon: React.createElement(format_align_left_1.default, null), label: l10n_1.default('module.text.buttongroups.align'), dataTestId: "button-module-align-menu", isRadio: true, selectedIndex: this.alignValues.indexOf(this.props.payload.align), onChange: this.onAlignChange },
                        React.createElement(IconTextButton_1.default, { Icon: React.createElement(format_align_left_1.default, null), text: l10n_1.default("module.button.align.left"), style: styles.button, dataTestId: "btn-module-align-left-btn" }),
                        React.createElement(IconTextButton_1.default, { Icon: React.createElement(format_align_center_1.default, null), text: l10n_1.default("module.button.align.center"), style: styles.button, dataTestId: "btn-module-align-center-btn" }),
                        React.createElement(IconTextButton_1.default, { Icon: React.createElement(format_align_right_1.default, null), text: l10n_1.default("module.button.align.right"), style: styles.button, dataTestId: "btn-module-align-right-btn" }))
                    : null,
                React.createElement(ColorPickerWithLsDropdown_1.ColorPickerWithLsDropdown, { Icon: (React.createElement(ButtonBackgroundColorIcon_1.ButtonBackgroundColorIcon, null)), text: l10n_1.default('module.button.backgroundColor'), hexColor: this.props.payload.backgroundColor ||
                        this.props.payload.defaultBackgroundColor, initialMode: !this.props.payload.backgroundColor
                        ? ColorPicker_1.PREDEFINED_MODE
                        : null, onChange: this.onBackgroundColorChange }),
                React.createElement(ColorPickerWithLsDropdown_1.ColorPickerWithLsDropdown, { Icon: (React.createElement(ButtonTextColorIcon_1.ButtonTextColorIcon, null)), text: l10n_1.default('module.button.textColor'), hexColor: this.props.payload.textColor ||
                        this.props.payload.defaultTextColor, initialMode: !this.props.payload.textColor
                        ? ColorPicker_1.PREDEFINED_MODE
                        : null, onChange: this.onTextColorChange }),
                React.createElement("div", { style: styles.input },
                    React.createElement("span", { style: styles.left }, l10n_1.default("module.button.label")),
                    React.createElement(TextField_1.default, { "data-test-id": "btn-module-label-text-field", ref: function (ref) { _this.textField = ref; }, value: this.props.payload.text, onChange: this.onTextChange, id: "btn-module" + this.props.moduleId })))));
    };
    return ButtonEditView;
}(React.Component));
exports.default = ButtonEditView;


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var Responsive_1 = __webpack_require__(991);
var Dropdown_1 = __webpack_require__(462);
var IconTextButtonGroup = (function (_super) {
    tslib_1.__extends(IconTextButtonGroup, _super);
    function IconTextButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.renderChild = function (child) {
            if (_this.childIsIconTextButton(child)) {
                var overridenProps = {};
                overridenProps.key = _this.index;
                overridenProps.style = Object.assign({}, _this.getChildStyle(), child.props.style);
                if (_this.props.isRadio) {
                    overridenProps.isPressable = false;
                    overridenProps.isPressed = _this.index === _this.state.selectedIndex;
                    overridenProps.onTouchTap = (function (index) { return function (event) {
                        if (_this.state.selectedIndex !== index) {
                            var newState = {};
                            newState.selectedIndex = index;
                            _this.setState(newState);
                            if (_this.props.onChange) {
                                _this.props.onChange(event, index);
                            }
                        }
                    }; })(_this.index);
                }
                _this.index++;
                return React.cloneElement(child, overridenProps);
            }
            else {
                return child;
            }
        };
        _this.state = {
            selectedIndex: _this.props.selectedIndex || _this.props.selectedIndex === 0 ?
                _this.props.selectedIndex :
                -1
        };
        return _this;
    }
    IconTextButtonGroup.prototype.render = function () {
        this.index = 0;
        if (this.props.screenSize === Responsive_1.ResponsiveSize.Small || this.props.collapsed) {
            return this.renderSmallScreen();
        }
        else {
            return this.renderNormalScreen();
        }
    };
    IconTextButtonGroup.prototype.getStyles = function () {
        return {
            root: {
                display: 'inline-block',
                marginRight: 24
            }
        };
    };
    IconTextButtonGroup.prototype.renderNormalScreen = function () {
        return (React.createElement("div", { style: Object.assign(this.getStyles().root, this.props.style) }, React.Children.map(this.props.children, this.renderChild)));
    };
    IconTextButtonGroup.prototype.renderSmallScreen = function () {
        var Icon = this.props.Icon;
        if (!Icon) {
            return this.renderNormalScreen();
        }
        return (React.createElement(Dropdown_1.default, { Icon: Icon, text: this.props.label, isSmart: true, useAlternativeColors: true, isExpanded: this.props.open, onOpen: this.props.onOpen, onClose: this.props.onClose, dataTestId: this.props.dataTestId }, React.Children.map(this.props.children, this.renderChild)));
    };
    IconTextButtonGroup.prototype.childIsIconTextButton = function (child) {
        return child && child.type === IconTextButton_1.default;
    };
    IconTextButtonGroup.prototype.getChildStyle = function () {
        return {
            marginRight: 4
        };
    };
    return IconTextButtonGroup;
}(React.Component));
IconTextButtonGroup.defaultProps = {
    collapsible: true
};
exports.default = IconTextButtonGroup;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ResponsiveSize;
(function (ResponsiveSize) {
    ResponsiveSize[ResponsiveSize["Small"] = 0] = "Small";
    ResponsiveSize[ResponsiveSize["Medium"] = 1] = "Medium";
    ResponsiveSize[ResponsiveSize["Large"] = 2] = "Large";
})(ResponsiveSize = exports.ResponsiveSize || (exports.ResponsiveSize = {}));
var Responsive = (function (_super) {
    tslib_1.__extends(Responsive, _super);
    function Responsive() {
        var _this = _super.call(this) || this;
        _this.detectWidth = function () {
            var newWidth = _this.getWidth();
            if (_this.state.viewportWidth !== newWidth) {
                _this.setState({
                    viewportWidth: newWidth
                });
            }
        };
        _this.state = {
            viewportWidth: _this.getWidth()
        };
        return _this;
    }
    Responsive.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.detectWidth);
    };
    Responsive.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.detectWidth);
    };
    Responsive.prototype.render = function () {
        var smallLimit = 1000;
        var mediumLimit = 1300;
        var size;
        if (this.state.viewportWidth < smallLimit) {
            size = ResponsiveSize.Small;
        }
        else if (this.state.viewportWidth < mediumLimit) {
            size = ResponsiveSize.Medium;
        }
        else {
            size = ResponsiveSize.Large;
        }
        return this.props.children(size);
    };
    Responsive.prototype.getWidth = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    };
    return Responsive;
}(React.Component));
exports.default = Responsive;


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var watchSize_1 = __webpack_require__(488);
var ResponsiveBar = (function (_super) {
    tslib_1.__extends(ResponsiveBar, _super);
    function ResponsiveBar(props) {
        var _this = _super.call(this, props) || this;
        _this.allCollapsed = false;
        _this.handleResize = function (width, height) {
            _this.allCollapsed = false;
            _this.setState({ collapsedStatus: [] });
        };
        _this.state = {
            collapsedStatus: [],
            openChild: null
        };
        return _this;
    }
    ResponsiveBar.prototype.componentDidMount = function () {
        if (this.isOverflow()) {
            this.collapseLastGroup();
        }
        this.unwatchSize = watchSize_1.watchSize(this.bar, this.handleResize);
    };
    ResponsiveBar.prototype.componentWillUnmount = function () {
        this.unwatchSize();
    };
    ResponsiveBar.prototype.componentDidUpdate = function () {
        if (this.isOverflow() && !this.allCollapsed) {
            this.collapseLastGroup();
        }
    };
    ResponsiveBar.prototype.render = function () {
        var _this = this;
        var style = this.getStyle();
        return (React.createElement("div", { ref: function (element) { _this.bar = element; }, style: style.root }, this.props.children
            .filter(function (value) { return value !== null; })
            .map(function (child, i) {
            var props = child.props.collapsible ? {
                key: i,
                collapsed: _this.state.collapsedStatus[i],
                open: _this.state.openChild === i,
                onOpen: function () { _this.setState({ openChild: i }); },
                onClose: function () { _this.setState({ openChild: null }); }
            }
                : { key: i };
            return React.cloneElement(child, props);
        })));
    };
    ResponsiveBar.prototype.isOverflow = function () {
        return this.bar.scrollWidth > this.bar.clientWidth;
    };
    ResponsiveBar.prototype.collapseLastGroup = function () {
        var children = this.props.children;
        var found = false;
        var collapsedStatus = [];
        for (var i = children.length - 1; i >= 0; i--) {
            var child = children[i];
            var collapsible = child.props.children && child.props.children.length > 1 && !!child.props.Icon;
            if (!this.state.collapsedStatus[i] && !found && collapsible) {
                collapsedStatus[i] = true;
                found = true;
            }
            else {
                if (collapsible) {
                    collapsedStatus[i] = this.state.collapsedStatus[i];
                }
                else {
                    collapsedStatus[i] = null;
                }
            }
        }
        this.allCollapsed = !found;
        this.setState({ collapsedStatus: collapsedStatus });
    };
    ResponsiveBar.prototype.getStyle = function () {
        return {
            root: {
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%"
            }
        };
    };
    return ResponsiveBar;
}(React.Component));
exports.default = ResponsiveBar;


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentLink = function ContentLink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
  );
};
ContentLink = (0, _pure2.default)(ContentLink);
ContentLink.displayName = 'ContentLink';
ContentLink.muiName = 'SvgIcon';

exports.default = ContentLink;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignLeft = function EditorFormatAlignLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignLeft = (0, _pure2.default)(EditorFormatAlignLeft);
EditorFormatAlignLeft.displayName = 'EditorFormatAlignLeft';
EditorFormatAlignLeft.muiName = 'SvgIcon';

exports.default = EditorFormatAlignLeft;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignCenter = function EditorFormatAlignCenter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignCenter = (0, _pure2.default)(EditorFormatAlignCenter);
EditorFormatAlignCenter.displayName = 'EditorFormatAlignCenter';
EditorFormatAlignCenter.muiName = 'SvgIcon';

exports.default = EditorFormatAlignCenter;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignRight = function EditorFormatAlignRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignRight = (0, _pure2.default)(EditorFormatAlignRight);
EditorFormatAlignRight.displayName = 'EditorFormatAlignRight';
EditorFormatAlignRight.muiName = 'SvgIcon';

exports.default = EditorFormatAlignRight;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var ColorWheelIcon_1 = __webpack_require__(998);
var ButtonBackgroundColorIcon = (function (_super) {
    tslib_1.__extends(ButtonBackgroundColorIcon, _super);
    function ButtonBackgroundColorIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonBackgroundColorIcon.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", null,
            React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
                React.createElement("path", { transform: "translate(-450 -74)", d: "M470,85a7.942,7.942,0,0,0-5.276,2H463v2h0.087a7.945,7.945,0,0,0-.825,2H454a2,2,0,0,1-2-2V83a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v2.262A7.987,7.987,0,0,0,470,85Zm-13,2h-2v2h2V87Zm4,0h-2v2h2V87Z" })),
            React.createElement(ColorWheelIcon_1.ColorWheelIcon, { style: styles.colorWheel })));
    };
    ButtonBackgroundColorIcon.prototype.getStyles = function () {
        return {
            colorWheel: {
                width: 12,
                height: 12,
                verticalAlign: 'middle',
                marginLeft: -11,
                marginTop: -4
            }
        };
    };
    return ButtonBackgroundColorIcon;
}(React.Component));
exports.ButtonBackgroundColorIcon = ButtonBackgroundColorIcon;


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ColorWheelIcon = (function (_super) {
    tslib_1.__extends(ColorWheelIcon, _super);
    function ColorWheelIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorWheelIcon.prototype.render = function () {
        var styles = this.getStyles();
        return (
        /* tslint:disable */
        React.createElement("img", { style: Object.assign({}, styles.root, this.props.style), src: "data:image/png;base64,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" }));
    };
    ColorWheelIcon.prototype.getStyles = function () {
        return {
            root: {
                display: 'inline-block',
                border: '1px solid transparent',
                borderRadius: '50%',
                width: 24,
                height: 24
            }
        };
    };
    return ColorWheelIcon;
}(React.Component));
exports.ColorWheelIcon = ColorWheelIcon;


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var ColorWheelIcon_1 = __webpack_require__(998);
var ButtonTextColorIcon = (function (_super) {
    tslib_1.__extends(ButtonTextColorIcon, _super);
    function ButtonTextColorIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonTextColorIcon.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", null,
            React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
                React.createElement("path", { transform: "translate(-477 -74)", d: "M491.31,88.62L491,88h-6l-2,4h-2l6-14h2l3.819,8.911A8.031,8.031,0,0,0,491.31,88.62ZM488,80l-2,6h4Z" })),
            React.createElement(ColorWheelIcon_1.ColorWheelIcon, { style: styles.colorWheel })));
    };
    ButtonTextColorIcon.prototype.getStyles = function () {
        return {
            colorWheel: {
                width: 12,
                height: 12,
                verticalAlign: 'middle',
                marginLeft: -11,
                marginTop: -4
            }
        };
    };
    return ButtonTextColorIcon;
}(React.Component));
exports.ButtonTextColorIcon = ButtonTextColorIcon;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ColorPickerDropdown_1 = __webpack_require__(1001);
var RecentColorsLsManager_1 = __webpack_require__(1008);
var ColorPickerWithLsDropdown = (function (_super) {
    tslib_1.__extends(ColorPickerWithLsDropdown, _super);
    function ColorPickerWithLsDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onColorChange = function (hexColor, isDefaultColor) {
            if (!isDefaultColor) {
                RecentColorsLsManager_1.RecentColorsLsManager.saveColor(hexColor);
            }
            _this.props.onChange(hexColor, isDefaultColor);
        };
        return _this;
    }
    ColorPickerWithLsDropdown.prototype.render = function () {
        return (React.createElement(ColorPickerDropdown_1.ColorPickerDropdown, { Icon: this.props.Icon, text: this.props.text, hexColor: this.props.hexColor, initialMode: this.props.initialMode, recentColors: RecentColorsLsManager_1.RecentColorsLsManager.getRecentColors(), onChange: this.onColorChange }));
    };
    return ColorPickerWithLsDropdown;
}(React.Component));
exports.ColorPickerWithLsDropdown = ColorPickerWithLsDropdown;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ColorPicker_1 = __webpack_require__(1002);
var Dropdown_1 = __webpack_require__(462);
var ColorPickerDropdown = (function (_super) {
    tslib_1.__extends(ColorPickerDropdown, _super);
    function ColorPickerDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.onColorChange = function (hexColor, isDefaultColor) {
            _this.setState({ isExpanded: false });
            if (_this.props.onChange) {
                _this.props.onChange(hexColor, isDefaultColor);
            }
        };
        _this.state = {
            isExpanded: false,
            isCloseable: true
        };
        return _this;
    }
    ColorPickerDropdown.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement(Dropdown_1.default, { isSmart: false, isExpanded: this.state.isExpanded, onOpen: function () { return _this.setState({ isExpanded: true }); }, onClose: function () {
                if (_this.state.isCloseable) {
                    _this.setState({ isExpanded: false });
                }
            }, Icon: this.props.Icon, text: this.props.text, popoverChildrenStyle: styles.popoverChildren },
            React.createElement(ColorPicker_1.ColorPicker, { hexColor: this.props.hexColor, initialMode: this.props.initialMode, recentColors: this.props.recentColors, onChange: this.onColorChange, onCancel: function () { return _this.setState({ isExpanded: false }); }, onDragChange: function (isMouseDown) {
                    // We need to wait for the next event loop cycle, because
                    // the `onClose` callback on `Dropdown` gets invoked before this callback.
                    setTimeout(function () {
                        _this.setState({ isCloseable: !isMouseDown });
                    }, 0);
                } })));
    };
    ColorPickerDropdown.prototype.getStyles = function () {
        return {
            popoverChildren: {
                padding: 0
            }
        };
    };
    return ColorPickerDropdown;
}(React.Component));
exports.ColorPickerDropdown = ColorPickerDropdown;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var FlatButton_1 = __webpack_require__(479);
var IconButton_1 = __webpack_require__(420);
var RaisedButton_1 = __webpack_require__(482);
var autoprefixer_1 = __webpack_require__(438);
var utils_1 = __webpack_require__(1003);
var Swatches_1 = __webpack_require__(1004);
var HsvSelector_1 = __webpack_require__(1005);
var RgbSelector_1 = __webpack_require__(1006);
var HexSelector_1 = __webpack_require__(1007);
var l10n_1 = __webpack_require__(18);
var keyboard_arrow_down_1 = __webpack_require__(463);
var keyboard_arrow_up_1 = __webpack_require__(571);
exports.PREDEFINED_MODE = 1;
exports.ADVANCED_MODE = 2;
var SWATCHES = [
    ['B71C1C', '32691E', '03579B', 'F57F18', '880E4F', '000000'],
    ['D32F2F', '689F38', '0688D1', 'FBC02E', 'C2185B', '353535'],
    ['F44336', '8AC34A', '09A8F4', 'FFEB3C', 'E91E63', '666666'],
    ['E57373', 'ADD581', '4EC3F7', 'FFF176', 'F06292', 'A9A8A8'],
    ['FFCDD2', 'DCEDC8', 'B2E5FC', 'FFF9C4', 'F8BBD0', 'FFFFFF']
];
var ColorPicker = (function (_super) {
    tslib_1.__extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRecentColors = function () {
            var styles = _this.getStyles();
            var recentColorsMatrix = [];
            _this.props.recentColors.forEach(function (color, index) {
                var row = Math.floor(index / SWATCHES[0].length);
                if (row === recentColorsMatrix.length) {
                    recentColorsMatrix.push([]);
                }
                recentColorsMatrix[row].push(color);
            });
            return (React.createElement(Swatches_1.Swatches, { swatches: recentColorsMatrix, hexColor: _this.state.hexColor, style: styles.recent, dataTestIdSlug: "recent", onClick: function (hexColor) { return _this.onChangeHex(hexColor, _this.onChangeHexColor); } }));
        };
        _this.onMouseDown = function (event) {
            if (event.target.tagName.toLowerCase() !== 'input') {
                event.preventDefault();
            }
        };
        _this.expandDrawer = function (mode) {
            if (_this.state.activeMode !== mode) {
                _this.setState({ activeMode: mode });
            }
        };
        _this.reset = function () {
            var hexColor = _this.props.hexColor;
            _this.setState({
                hexColor: hexColor,
                h: -1, s: -1, v: -1
            });
        };
        _this.onCancel = function () {
            _this.reset();
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        _this.onChangeHexColor = function () {
            if (_this.props.onChange) {
                _this.props.onChange(_this.state.hexColor, false);
            }
        };
        _this.onChangeHsv = function (_a) {
            var h = _a.h, s = _a.s, v = _a.v;
            var newRgb = utils_1.hsvToRgb({ h: h, s: s, v: v });
            var newHex = utils_1.rgbToHex(newRgb);
            _this.setState({
                hexColor: newHex,
                h: h, s: s, v: v
            });
        };
        _this.onChangeRgb = function (_a) {
            var r = _a.r, g = _a.g, b = _a.b;
            var newHex = utils_1.rgbToHex({ r: r, g: g, b: b });
            _this.setState({
                hexColor: newHex,
                h: -1, s: -1, v: -1
            });
        };
        _this.onChangeHex = function (hexColor, callback) {
            _this.setState({
                hexColor: hexColor,
                h: -1, s: -1, v: -1
            }, callback);
        };
        var matchesSwatch = false;
        SWATCHES.forEach(function (swatches) {
            swatches.forEach(function (swatchColor) {
                if (swatchColor === props.hexColor) {
                    matchesSwatch = true;
                }
            });
        });
        _this.state = {
            hexColor: props.hexColor,
            // `h === -1 && s === -1 && v === -1` means that
            // the color was either specified via the component's interface (i.e. `this.props.hexColor`),
            // or via one of the four text inputs. Hence, `h`, `s` & `v` are to be computed from RGB/hex.
            h: -1, s: -1, v: -1,
            activeMode: props.initialMode || (matchesSwatch ? exports.PREDEFINED_MODE : exports.ADVANCED_MODE)
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var _a = utils_1.hexToRgb(this.state.hexColor), r = _a.r, g = _a.g, b = _a.b;
        var _b = this.state.h !== -1 // ...` && this.state.s !== -1 && this.state.v !== -1`.
            ? this.state
            : utils_1.rgbToHsv({ r: r, g: g, b: b }), h = _b.h, s = _b.s, v = _b.v;
        return (React.createElement("div", { style: styles.root, onMouseDown: this.onMouseDown },
            this.props.recentColors
                ? (React.createElement("div", { style: Object.assign({}, styles.drawer, {
                        borderBottom: 0,
                        cursor: 'auto'
                    }) },
                    React.createElement("span", null, l10n_1.default('colorPicker.drawer.recent'))))
                : null,
            this.props.recentColors
                ? this.renderRecentColors()
                : null,
            React.createElement("div", { style: styles.drawer, onClick: function () { return _this.expandDrawer(exports.PREDEFINED_MODE); }, "data-test-id": "color-picker-drawer-predefined" },
                React.createElement("span", null, l10n_1.default('colorPicker.drawer.predefined')),
                React.createElement(IconButton_1.default, null, this.state.activeMode === exports.PREDEFINED_MODE
                    ? (React.createElement(keyboard_arrow_up_1.default, { color: "#878787" }))
                    : (React.createElement(keyboard_arrow_down_1.default, { color: "#878787" })))),
            this.state.activeMode === exports.PREDEFINED_MODE
                ? (React.createElement("div", { style: styles.predefined },
                    React.createElement(Swatches_1.Swatches, { swatches: SWATCHES, hexColor: this.state.hexColor, dataTestIdSlug: "predefined", onClick: function (hexColor) { return _this.onChangeHex(hexColor, _this.onChangeHexColor); } }),
                    this.props.allowDefaultColor
                        ? (React.createElement(FlatButton_1.default, { style: styles.default, label: l10n_1.default('colorPicker.defaultColor'), onClick: function () {
                                if (_this.props.onChange) {
                                    _this.props.onChange(_this.state.hexColor, true);
                                }
                            }, "data-test-id": "color-picker-default" }))
                        : null))
                : null,
            React.createElement("div", { style: styles.drawer, onClick: function () { return _this.expandDrawer(exports.ADVANCED_MODE); }, "data-test-id": "color-picker-drawer-advanced" },
                React.createElement("span", null, l10n_1.default('colorPicker.drawer.advanced')),
                React.createElement(IconButton_1.default, null, this.state.activeMode === exports.ADVANCED_MODE
                    ? (React.createElement(keyboard_arrow_up_1.default, { color: "#878787" }))
                    : (React.createElement(keyboard_arrow_down_1.default, { color: "#878787" })))),
            this.state.activeMode === exports.ADVANCED_MODE
                ? (React.createElement("div", { style: styles.advanced },
                    React.createElement("div", { style: styles.swatches },
                        React.createElement("div", { style: styles.swatchContainer },
                            React.createElement("div", { style: styles.swatchLabel }, l10n_1.default('colorPicker.swatch.current')),
                            React.createElement("div", { style: Object.assign({}, styles.swatch, {
                                    backgroundColor: "#" + this.props.hexColor,
                                    cursor: 'pointer'
                                }), onClick: this.reset, "data-test-id": "color-picker-swatch-current" })),
                        React.createElement("div", { style: styles.swatchContainer },
                            React.createElement("div", { style: styles.swatchLabel }, l10n_1.default('colorPicker.swatch.new')),
                            React.createElement("div", { style: Object.assign({}, styles.swatch, {
                                    backgroundColor: "#" + this.state.hexColor
                                }), "data-test-id": "color-picker-swatch-new" }))),
                    React.createElement("div", { style: styles.selectors },
                        React.createElement(HsvSelector_1.HsvSelector, { style: styles.hsvSelector, h: h, s: s, v: v, onChange: this.onChangeHsv, onDragChange: this.props.onDragChange }),
                        React.createElement("div", { style: styles.rgbAndHexContainer },
                            React.createElement(RgbSelector_1.RgbSelector, { r: r, g: g, b: b, onChange: this.onChangeRgb }),
                            React.createElement(HexSelector_1.HexSelector, { hexColor: this.state.hexColor, onChange: this.onChangeHex })))))
                : null,
            this.state.activeMode === exports.ADVANCED_MODE
                ? (React.createElement("div", { style: styles.buttons },
                    React.createElement(FlatButton_1.default, { style: styles.cancel, label: l10n_1.default('colorPicker.button.cancel'), onClick: this.onCancel, "data-test-id": "color-picker-button-cancel" }),
                    React.createElement(RaisedButton_1.default, { primary: true, style: styles.ok, label: l10n_1.default('colorPicker.button.ok'), onClick: this.onChangeHexColor, "data-test-id": "color-picker-button-ok" })))
                : null));
    };
    ColorPicker.prototype.getStyles = function () {
        return {
            root: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex',
                flexDirection: 'column',
                userSelect: 'none'
            }), {
                color: '#878787',
                fontSize: 13,
                lineHeight: '24px',
                backgroundColor: '#F2F4F7',
                width: 312,
                overflow: 'hidden'
            }),
            drawer: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex',
                justifyContent: 'space-between'
            }), {
                padding: '0 16px 0 20px',
                backgroundColor: '#FFFFFF',
                borderBottom: '1px solid #E5E5E5',
                lineHeight: '48px',
                cursor: 'pointer'
            }),
            recent: {
                padding: '0 16px 10px 20px',
                backgroundColor: '#FFFFFF',
                borderBottom: '1px solid #E5E5E5',
            },
            predefined: {
                margin: '8px 16px 16px 20px'
            },
            advanced: {
                margin: '8px 16px 16px 20px'
            },
            default: {
                marginTop: 6,
                width: 'calc(100% - 4px)'
            },
            swatches: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex'
            }), {
                marginBottom: 8
            }),
            swatchContainer: {
                width: 50,
                marginRight: 6
            },
            swatchLabel: {
                width: 40,
                whiteSpace: 'nowrap'
            },
            swatch: {
                width: 50,
                height: 24,
                border: '1px solid #D9D8D8' /* TODO: Use color from some theme. */
            },
            selectedSwatch: {
                position: 'absolute',
                marginTop: -32,
                marginLeft: 16,
                pointerEvents: 'none'
            },
            selectors: autoprefixer_1.autoprefixer({
                display: 'flex'
            }),
            hsvSelector: {
                marginRight: 8
            },
            rgbAndHexContainer: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'space-between'
            }), {
                maxWidth: 110
            }),
            buttons: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
            }), {
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #E5E5E5',
                padding: '10px 16px'
            }),
            cancel: {
                marginRight: 4
            },
            ok: {
                marginRight: 4
            }
        };
    };
    return ColorPicker;
}(React.Component));
/* TODO: Extract (parts of the) initialization logic. */
ColorPicker.defaultProps = {
    allowDefaultColor: true
};
exports.ColorPicker = ColorPicker;


/***/ },
/* 1003 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function rgbToHex(_a) {
    var r = _a.r, g = _a.g, b = _a.b;
    return pad(r.toString(16)).toUpperCase() +
        pad(g.toString(16)).toUpperCase() +
        pad(b.toString(16)).toUpperCase();
}
exports.rgbToHex = rgbToHex;
function hexToRgb(hex) {
    var rgb = /^([A-F\d]{2})([A-F\d]{2})([A-F\d]{2})$/i.exec(hex);
    return {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
    };
}
exports.hexToRgb = hexToRgb;
var RGB_STRING_REGEX = /^rgb\(([\d]{1,3}), ([\d]{1,3}), ([\d]{1,3})\)$/i;
function isRgbString(rgbString) {
    var rgb = RGB_STRING_REGEX.exec(rgbString);
    return rgb !== null;
}
exports.isRgbString = isRgbString;
function rgbStringToHex(rgbString) {
    var rgb = RGB_STRING_REGEX.exec(rgbString);
    return pad(Number(rgb[1]).toString(16)).toUpperCase() +
        pad(Number(rgb[2]).toString(16)).toUpperCase() +
        pad(Number(rgb[3]).toString(16)).toUpperCase();
}
exports.rgbStringToHex = rgbStringToHex;
// "Stolen" from TinyColor.
// https://github.com/bgrins/TinyColor
function rgbToHsv(rgb) {
    var r = bound01(rgb.r, 255);
    var g = bound01(rgb.g, 255);
    var b = bound01(rgb.b, 255);
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var d = max - min;
    var h;
    var s = max === 0 ? 0 : d / max;
    var v = max;
    if (max === min) {
        h = 0;
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
exports.rgbToHsv = rgbToHsv;
// "Stolen" from TinyColor.
// https://github.com/bgrins/TinyColor
function hsvToRgb(hsv) {
    var h = hsv.h * 6;
    var s = hsv.s, v = hsv.v;
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [v, q, p, p, t, v][mod];
    var g = [t, v, v, q, p, p][mod];
    var b = [p, p, t, v, v, q][mod];
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}
exports.hsvToRgb = hsvToRgb;
function getDoneIconColor(swatchColor) {
    var rgb = hexToRgb(swatchColor);
    var hsv = rgbToHsv(rgb);
    if (hsv.v < 0.8) {
        return 'FFFFFF';
    }
    return '000000';
}
exports.getDoneIconColor = getDoneIconColor;
function pad(s) {
    return s.length === 1 ? "0" + s : s;
}
// "Stolen" from TinyColor.
// https://github.com/bgrins/TinyColor
function bound01(n, max) {
    n = Math.min(max, Math.max(0, n));
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }
    return (n % max) / max;
}


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var utils_1 = __webpack_require__(1003);
var done_1 = __webpack_require__(599);
var Swatches = (function (_super) {
    tslib_1.__extends(Swatches, _super);
    function Swatches() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSwatch = function (swatchColor, selectedSwatchColor) {
            var styles = _this.getStyles();
            return (React.createElement("div", { key: swatchColor, style: styles.swatchContainer },
                React.createElement("div", { style: Object.assign({}, styles.swatch, {
                        backgroundColor: "#" + swatchColor,
                        cursor: 'pointer'
                    }, swatchColor !== 'FFFFFF'
                        ? { borderColor: 'transparent' }
                        : {}), onClick: function () { return _this.props.onClick(swatchColor); }, "data-test-id": "color-picker-swatch-" + _this.props.dataTestIdSlug + "-" + swatchColor }),
                swatchColor === _this.props.hexColor
                    ? (React.createElement(done_1.default, { color: "#" + selectedSwatchColor, style: styles.selectedSwatch }))
                    : null));
        };
        return _this;
    }
    Swatches.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement("div", { style: this.props.style }, this.props.swatches.map(function (swatches, index) {
            return (React.createElement("div", { key: index, style: styles.swatches }, swatches.map(function (swatchColor) {
                return _this.renderSwatch(swatchColor, utils_1.getDoneIconColor(swatchColor));
            })));
        })));
    };
    Swatches.prototype.getStyles = function () {
        return {
            swatch: {
                width: 40,
                height: 24,
                border: '1px solid #D9D8D8' /* TODO: Use color from some theme. */
            },
            swatchContainer: {
                width: 40,
                marginRight: 6
            },
            selectedSwatch: {
                position: 'absolute',
                marginTop: -25,
                marginLeft: 10,
                pointerEvents: 'none'
            },
            swatches: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex'
            }), {
                marginBottom: 2
            })
        };
    };
    return Swatches;
}(React.Component));
exports.Swatches = Swatches;


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var utils_1 = __webpack_require__(1003);
var RECTANGLE_SIZE = 154;
var INDICATOR_SIZE = 6;
var RECTANGLE_BORDER_WIDTH = 1;
var HsvSelector = (function (_super) {
    tslib_1.__extends(HsvSelector, _super);
    function HsvSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSvDown = function (event) {
            var targetTouches = event.targetTouches;
            var _a = targetTouches ? targetTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
            var _b = _this.props, h = _b.h, s = _b.s, v = _b.v, onChange = _b.onChange;
            var getNewSv = function (clientX, clientY) {
                var boundingClientRect = _this.svSquare.getBoundingClientRect();
                var x = clientX - boundingClientRect.left;
                var y = clientY - boundingClientRect.top;
                x = Math.max(Math.min(x, RECTANGLE_SIZE - 1), 0);
                y = Math.max(Math.min(y, RECTANGLE_SIZE - 1), 0);
                return {
                    s: x / (RECTANGLE_SIZE - 1),
                    v: 1 - y / (RECTANGLE_SIZE - 1)
                };
            };
            var onMove = function (_a) {
                var clientX = _a.clientX, clientY = _a.clientY;
                var _b = getNewSv(clientX, clientY), newS = _b.s, newV = _b.v;
                if (newS !== s || newV !== v) {
                    if (onChange) {
                        onChange({ h: h, s: newS, v: newV });
                    }
                }
            };
            var onTouchMove = function (touchEvent) {
                onMove(touchEvent.targetTouches[0]);
                touchEvent.preventDefault();
            };
            var onMouseMove = function (mouseEvent) { return onMove(mouseEvent); };
            var onUp = function () {
                if (_this.props.onDragChange) {
                    _this.props.onDragChange(false);
                }
                document.removeEventListener('touchmove', onTouchMove);
                document.removeEventListener('mousemove', onMouseMove);
                ['touchcancel', 'touchend', 'touchup', 'mouseup'].forEach(function (eventName) {
                    document.removeEventListener(eventName, onUp);
                });
            };
            if (_this.props.onDragChange) {
                _this.props.onDragChange(true);
            }
            onMove({ clientX: clientX, clientY: clientY });
            document.addEventListener('touchmove', onTouchMove);
            document.addEventListener('mousemove', onMouseMove);
            ['touchcancel', 'touchend', 'touchup', 'mouseup'].forEach(function (eventName) {
                document.addEventListener(eventName, onUp);
            });
        };
        _this.onHDown = function (event) {
            var targetTouches = event.targetTouches;
            var clientY = (targetTouches ? targetTouches[0] : event).clientY;
            var _a = _this.props, h = _a.h, s = _a.s, v = _a.v, onChange = _a.onChange;
            var getNewH = function (clientY) {
                var y = clientY - _this.innerHRectangle.getBoundingClientRect().top;
                y = Math.max(Math.min(y, RECTANGLE_SIZE - 1), 0);
                return 1 - y / (RECTANGLE_SIZE - 1);
            };
            var onMove = function (_a) {
                var clientY = _a.clientY;
                var newH = getNewH(clientY);
                if (newH !== h) {
                    if (onChange) {
                        onChange({ h: newH, s: s, v: v });
                    }
                }
            };
            var onTouchMove = function (touchEvent) {
                onMove(touchEvent.targetTouches[0]);
                touchEvent.preventDefault();
            };
            var onMouseMove = function (mouseEvent) { return onMove(mouseEvent); };
            var onUp = function () {
                if (_this.props.onDragChange) {
                    _this.props.onDragChange(false);
                }
                document.removeEventListener('touchmove', onTouchMove);
                document.removeEventListener('mousemove', onMouseMove);
                ['touchcancel', 'touchend', 'touchup', 'mouseup'].forEach(function (eventName) {
                    document.removeEventListener(eventName, onUp);
                });
            };
            if (_this.props.onDragChange) {
                _this.props.onDragChange(true);
            }
            onMove({ clientY: clientY });
            document.addEventListener('touchmove', onTouchMove);
            document.addEventListener('mousemove', onMouseMove);
            ['touchcancel', 'touchend', 'touchup', 'mouseup'].forEach(function (eventName) {
                document.addEventListener(eventName, onUp);
            });
        };
        return _this;
    }
    HsvSelector.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement("div", { style: Object.assign({}, styles.root, this.props.style) },
            React.createElement("div", { style: styles.svSquare, ref: function (domElement) { return _this.svSquare = domElement; }, onTouchStart: this.onSvDown, onMouseDown: this.onSvDown, "data-test-id": "color-picker-sv-square" },
                React.createElement("div", { style: styles.svIndicator, "data-test-id": "color-picker-sv-indicator" })),
            React.createElement("div", { style: styles.outerHRectangle },
                React.createElement("div", { style: styles.innerHRectangle, ref: function (domElement) { return _this.innerHRectangle = domElement; }, onTouchStart: this.onHDown, onMouseDown: this.onHDown, "data-test-id": "color-picker-h-rectangle" }),
                React.createElement("div", { style: styles.hIndicator, "data-test-id": "color-picker-h-indicator" }))));
    };
    HsvSelector.prototype.getStyles = function () {
        var _a = this.props, h = _a.h, s = _a.s, v = _a.v;
        var rgbBaseColor = utils_1.hsvToRgb({ h: h, s: 1, v: 1 });
        return {
            root: autoprefixer_1.autoprefixer({
                display: 'flex'
            }),
            svSquare: {
                width: RECTANGLE_SIZE,
                height: RECTANGLE_SIZE,
                marginRight: 8,
                backgroundColor: "rgb(" + rgbBaseColor.r + ", " + rgbBaseColor.g + ", " + rgbBaseColor.b + ")",
                backgroundImage: 'linear-gradient('
                    + 'to top, '
                    + "rgb(   0,   0,   0), "
                    + "rgba(  0,   0,   0, 0)"
                    + '),'
                    + 'linear-gradient('
                    + 'to right, '
                    + "rgb( 255, 255, 255), "
                    + "rgba(255, 255, 255, 0)"
                    + ')',
                border: RECTANGLE_BORDER_WIDTH + "px solid #D9D8D8",
                cursor: 'pointer'
            },
            svIndicator: {
                width: INDICATOR_SIZE,
                height: INDICATOR_SIZE,
                border: "1px solid #FFFFFF",
                borderRadius: INDICATOR_SIZE / 2,
                boxShadow: '0 0 1px #000000',
                marginTop: -INDICATOR_SIZE / 2 + ((1 - v) * (RECTANGLE_SIZE - RECTANGLE_BORDER_WIDTH * 2)),
                marginLeft: -INDICATOR_SIZE / 2 + (s * (RECTANGLE_SIZE - RECTANGLE_BORDER_WIDTH * 2))
            },
            outerHRectangle: {
                width: 10,
                height: RECTANGLE_SIZE,
                border: RECTANGLE_BORDER_WIDTH + "px solid #D9D8D8" /* TODO: Use color from some theme. */
            },
            innerHRectangle: {
                position: 'absolute',
                width: 10,
                height: RECTANGLE_SIZE,
                background: 'linear-gradient('
                    + 'to top, '
                    + 'rgb(255,   0,   0) 0%, '
                    + ("rgb(255, 255,   0) " + 100 / 6 + "%, ")
                    + ("rgb(  0, 255,   0) " + 100 / 6 * 2 + "%, ")
                    + ("rgb(  0, 255, 255) " + 100 / 6 * 3 + "%, ")
                    + ("rgb(  0,   0, 255) " + 100 / 6 * 4 + "%, ")
                    + ("rgb(255,   0, 255) " + 100 / 6 * 5 + "%, ")
                    + 'rgb(255,   0,   0) 100%'
                    + ')',
                cursor: 'pointer'
            },
            hIndicator: {
                position: 'absolute',
                width: INDICATOR_SIZE,
                height: INDICATOR_SIZE,
                border: '1px solid #FFFFFF',
                borderRadius: INDICATOR_SIZE / 2,
                boxShadow: '0 0 1px #000000',
                pointerEvents: 'none',
                marginTop: -INDICATOR_SIZE / 2 + ((1 - h) * (RECTANGLE_SIZE - RECTANGLE_BORDER_WIDTH * 2)),
                marginLeft: INDICATOR_SIZE / 2 - 2
            }
        };
    };
    return HsvSelector;
}(React.Component));
exports.HsvSelector = HsvSelector;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var l10n_1 = __webpack_require__(18);
var RgbSelector = (function (_super) {
    tslib_1.__extends(RgbSelector, _super);
    function RgbSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeRgb = function (value, key) {
            var n = Number(value);
            if (isNaN(n)) {
                return;
            }
            switch (key) {
                case 'r':
                    _this.setState({ r: n });
                    break;
                case 'g':
                    _this.setState({ g: n });
                    break;
                case 'b':
                    _this.setState({ b: n });
                    break;
                default:
            }
            // If we have a valid `n`,
            // then provide instant feedback.
            if (n >= 0 && n <= 255) {
                if (_this.props.onChange) {
                    var _a = _this.state, r = _a.r, g = _a.g, b = _a.b;
                    var newRgb = {
                        r: key === 'r' ? n : r,
                        g: key === 'g' ? n : g,
                        b: key === 'b' ? n : b
                    };
                    _this.props.onChange(newRgb);
                }
                _this.setState({ invalidKey: null });
            }
            else {
                _this.setState({ invalidKey: key });
            }
        };
        _this.getInputBorderColor = function (key) {
            /* TODO: Use colors from some theme. */
            return (_this.state.invalidKey === key
                ? '#F44336'
                : _this.state.focusedKey === key
                    ? '#00BCD4'
                    : '#D9D8D8');
        };
        _this.onFocusRgb = function (key) {
            _this.setState({ focusedKey: key });
        };
        _this.onBlurRgb = function (value, key) {
            _this.setState({ focusedKey: null });
            var n = Number(value);
            var _a = _this.props, r = _a.r, g = _a.g, b = _a.b;
            if (n < 0 || n > 255) {
                switch (key) {
                    case 'r':
                        n = r;
                        break;
                    case 'g':
                        n = g;
                        break;
                    case 'b':
                        n = b;
                        break;
                    default:
                }
            }
            var newRgb = {
                r: key === 'r' ? n : r,
                g: key === 'g' ? n : g,
                b: key === 'b' ? n : b
            };
            _this.setState({
                r: newRgb.r,
                g: newRgb.g,
                b: newRgb.b,
                invalidKey: null
            });
            if (_this.props.onChange) {
                _this.props.onChange(newRgb);
            }
        };
        var r = props.r, g = props.g, b = props.b;
        _this.state = {
            r: r, g: g, b: b,
            focusedKey: null,
            invalidKey: null
        };
        return _this;
    }
    RgbSelector.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props, r = _a.r, g = _a.g, b = _a.b;
        if (r !== nextProps.r || g !== nextProps.g || b !== nextProps.b) {
            this.setState({
                r: nextProps.r,
                g: nextProps.g,
                b: nextProps.b
            });
        }
    };
    RgbSelector.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        var _a = this.state, r = _a.r, g = _a.g, b = _a.b;
        /* TODO: Avoid repetition below. Map over `[ 'r', 'g', 'b' ]`. */
        return (React.createElement("div", { style: styles.root },
            React.createElement("label", { style: styles.label },
                l10n_1.default('colorPicker.label.r'),
                React.createElement("input", { style: Object.assign({}, styles.input, { borderColor: this.getInputBorderColor('r') }), value: "" + r, onChange: function (event) { return _this.onChangeRgb(event.target.value, 'r'); }, onFocus: function () { return _this.onFocusRgb('r'); }, onBlur: function (event) { return _this.onBlurRgb(event.target.value, 'r'); }, "data-test-id": "color-picker-input-r" })),
            React.createElement("label", { style: styles.label },
                l10n_1.default('colorPicker.label.g'),
                React.createElement("input", { style: Object.assign({}, styles.input, { borderColor: this.getInputBorderColor('g') }), value: "" + g, onChange: function (event) { return _this.onChangeRgb(event.target.value, 'g'); }, onFocus: function () { return _this.onFocusRgb('g'); }, onBlur: function (event) { return _this.onBlurRgb(event.target.value, 'g'); }, "data-test-id": "color-picker-input-g" })),
            React.createElement("label", { style: styles.label },
                l10n_1.default('colorPicker.label.b'),
                React.createElement("input", { style: Object.assign({}, styles.input, { borderColor: this.getInputBorderColor('b') }), value: "" + b, onChange: function (event) { return _this.onChangeRgb(event.target.value, 'b'); }, onFocus: function () { return _this.onFocusRgb('b'); }, onBlur: function (event) { return _this.onBlurRgb(event.target.value, 'b'); }, "data-test-id": "color-picker-input-b" }))));
    };
    RgbSelector.prototype.getStyles = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignContent: 'space-between'
            }),
            label: Object.assign(autoprefixer_1.autoprefixer({
                flexGrow: 1
            }), {
                height: 30,
                lineHeight: '30px',
                textAlign: 'right',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                marginBottom: 12
            }),
            input: {
                width: 60,
                height: 24,
                fontSize: 13,
                fontFamily: 'Open Sans',
                textAlign: 'center',
                border: '1px solid',
                outline: 0,
                marginLeft: 8,
                marginRight: 4,
                padding: 2
            }
        };
    };
    return RgbSelector;
}(React.Component));
exports.RgbSelector = RgbSelector;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var autoprefixer_1 = __webpack_require__(438);
var l10n_1 = __webpack_require__(18);
var HexSelector = (function (_super) {
    tslib_1.__extends(HexSelector, _super);
    function HexSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeHex = function (value) {
            value = value.toUpperCase();
            while (value.charAt(0) === '#') {
                value = value.substring(1);
            }
            for (var index = 0, length_1 = value.length; index < length_1; ++index) {
                if ('0123456789ABCDEF'.indexOf(value.charAt(index)) < 0) {
                    return;
                }
            }
            _this.setState({ hexColor: value });
            // If we have a valid `value`,
            // then provide instant feedback.
            if (value.length === 6) {
                if (_this.props.onChange) {
                    _this.props.onChange(value);
                }
                _this.setState({ isInvalid: false });
            }
            else {
                _this.setState({ isInvalid: value.length !== 3 });
            }
        };
        _this.onFocusHex = function () {
            _this.setState({ isFocused: true });
        };
        _this.onBlurHex = function (value) {
            _this.setState({ isFocused: false });
            if (value.length === 3) {
                var _a = value.split(''), c0 = _a[0], c1 = _a[1], c2 = _a[2];
                value = "" + c0 + c0 + c1 + c1 + c2 + c2;
            }
            if (value.length !== 6) {
                value = _this.props.hexColor;
            }
            _this.setState({
                hexColor: value,
                isInvalid: false
            });
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        _this.state = {
            hexColor: props.hexColor,
            isFocused: false,
            isInvalid: false
        };
        return _this;
    }
    HexSelector.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.hexColor !== nextProps.hexColor) {
            this.setState({ hexColor: nextProps.hexColor });
        }
    };
    HexSelector.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            React.createElement("label", { style: styles.label },
                l10n_1.default('colorPicker.label.hex'),
                React.createElement("input", { style: Object.assign({}, styles.input, {
                        borderColor: this.state.isInvalid
                            ? '#F44336'
                            : this.state.isFocused
                                ? '#00BCD4'
                                : '#D9D8D8'
                    }), value: this.state.hexColor, onChange: function (event) { return _this.onChangeHex(event.target.value); }, onFocus: this.onFocusHex, onBlur: function (event) { return _this.onBlurHex(event.target.value); }, "data-test-id": "color-picker-input-hex" }))));
    };
    HexSelector.prototype.getStyles = function () {
        return {
            root: Object.assign(autoprefixer_1.autoprefixer({
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignContent: 'space-between'
            }), {
                width: '100%'
            }),
            label: Object.assign(autoprefixer_1.autoprefixer({
                flexGrow: 1
            }), {
                height: 30,
                lineHeight: '30px',
                textAlign: 'right',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }),
            input: {
                width: 60,
                height: 24,
                fontSize: 13,
                fontFamily: 'Open Sans',
                textAlign: 'center',
                border: '1px solid',
                outline: '0',
                marginLeft: 8,
                marginRight: 4,
                padding: 2
            }
        };
    };
    return HexSelector;
}(React.Component));
exports.HexSelector = HexSelector;


/***/ },
/* 1008 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var KEY = 'DIY_RECENT_COLORS';
var MAX = 12;
var RecentColorsLsManager = (function () {
    function RecentColorsLsManager() {
    }
    RecentColorsLsManager.saveColor = function (color) {
        if (window.localStorage) {
            var recentColors = this.getRecentColors();
            if (recentColors === null) {
                recentColors = [];
            }
            var index = recentColors.indexOf(color);
            if (index !== -1) {
                recentColors.splice(index, 1);
            }
            recentColors.unshift(color);
            recentColors.splice(MAX);
            window.localStorage.setItem(KEY, JSON.stringify(recentColors));
        }
    };
    RecentColorsLsManager.getRecentColors = function () {
        if (window.localStorage) {
            return JSON.parse(window.localStorage.getItem(KEY));
        }
        return null;
    };
    return RecentColorsLsManager;
}());
exports.RecentColorsLsManager = RecentColorsLsManager;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ButtonInPlaceEditView = (function (_super) {
    tslib_1.__extends(ButtonInPlaceEditView, _super);
    function ButtonInPlaceEditView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonInPlaceEditView.prototype.render = function () {
        return (React.createElement("div", null));
    };
    return ButtonInPlaceEditView;
}(React.Component));
exports.default = ButtonInPlaceEditView;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ContentEditable_1 = __webpack_require__(1011);
var utils_1 = __webpack_require__(1003);
var ButtonWebView = (function (_super) {
    tslib_1.__extends(ButtonWebView, _super);
    function ButtonWebView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDefaultHexColor = function (propertyName) {
            var rgbString = propertyName === 'backgroundColor'
                ? window.getComputedStyle(_this.anchor).backgroundColor
                : window.getComputedStyle(_this.anchor).color;
            var hexColor = utils_1.isRgbString(rgbString)
                ? utils_1.rgbStringToHex(rgbString)
                : 'FFFFFF' // For RGBA values, we default to white.
            ;
            return hexColor;
        };
        // We need to do it like this,
        // as React doesn't support inline styles with "important".
        // We need to use "important", as some themes do it also, unfortunately.
        _this.updateAnchorStyle = function () {
            if (_this.props.payload.backgroundColor) {
                var backgroundColor = "#" + _this.props.payload.backgroundColor;
                _this.anchor.style.setProperty('background-color', backgroundColor, 'important');
                _this.anchor.style.setProperty('border-color', backgroundColor, 'important');
            }
            else {
                _this.anchor.style.removeProperty('background-color');
                _this.anchor.style.removeProperty('border-color');
            }
            if (_this.props.payload.textColor) {
                var textColor = "#" + _this.props.payload.textColor;
                _this.anchor.style.setProperty('color', textColor, 'important');
            }
            else {
                _this.anchor.style.removeProperty('color');
            }
        };
        _this.onTextChange = function (textContent) {
            _this.props.onDataChange(Object.assign({}, _this.props.payload, {
                text: textContent
            }));
        };
        return _this;
    }
    ButtonWebView.prototype.componentDidMount = function () {
        this.props.onDataChange(Object.assign({}, this.props.payload, {
            defaultBackgroundColor: this.getDefaultHexColor('backgroundColor'),
            defaultTextColor: this.getDefaultHexColor('color')
        }));
        this.updateAnchorStyle();
    };
    ButtonWebView.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.payload.backgroundColor !== this.props.payload.backgroundColor ||
            prevProps.payload.textColor !== this.props.payload.textColor) {
            this.updateAnchorStyle();
        }
    };
    ButtonWebView.prototype.render = function () {
        var _this = this;
        // TODO use ContentEditable only if needed, based on a prop
        var style = {
            textAlign: this.props.payload.supports.buttonAlign ? this.props.payload.align : null,
            width: '100%'
        };
        return (React.createElement("div", { style: style },
            React.createElement(ContentEditable_1.default, { onChange: this.onTextChange, value: this.props.payload.text, maxLength: 1000 },
                React.createElement("a", { ref: function (a) { return _this.anchor = a; }, className: this.props.payload.style, href: this.props.payload.link, target: this.props.payload.linkTarget }))));
    };
    return ButtonWebView;
}(React.Component));
exports.default = ButtonWebView;
;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
/** Converts a string to an array of char codes */
function charCodes(str) {
    var codes = [];
    for (var _i = 0, str_1 = str; _i < str_1.length; _i++) {
        var c = str_1[_i];
        codes.push(c.charCodeAt(0));
    }
    return codes;
}
;
function isCharacterKeyPress(evt) {
    if (typeof evt.which === "undefined") {
        // This is IE, which only fires keypress events for printable keys
        return true;
    }
    else if (typeof evt.which === "number" && evt.which > 0) {
        // In other browsers except old versions of WebKit, evt.which is
        // only greater than zero if the keypress is a printable key.
        // We need to filter out backspace and ctrl/alt/meta key combinations
        return !evt.ctrlKey && !evt.metaKey && !evt.altKey && evt.which !== 8;
    }
    return false;
}
var ContentEditable = (function (_super) {
    tslib_1.__extends(ContentEditable, _super);
    function ContentEditable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onKeyDown = function (e) {
            // Prevent styling with bold/italic/underline (CTRL+B/I/U)
            if (e.metaKey || e.ctrlKey) {
                if (charCodes("BIU").indexOf(e.keyCode) !== -1) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            else if (e.keyCode === 13 /*ENTER*/
                || e.keyCode === 108 /*NUMPAD_ENTER*/
                || e.keyCode === 27 /*ESCAPE*/) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        _this.onKeyUp = function (e) {
            _this.onChange();
        };
        _this.onKeyPress = function (e) {
            if (isCharacterKeyPress(e.nativeEvent)) {
                var charsToDeleteCount = _this.getSelectedCharCount();
                if (_this.getCurrentValue().length - charsToDeleteCount >= _this.props.maxLength) {
                    e.preventDefault();
                }
            }
        };
        _this.onPaste = function (e) {
            e.preventDefault();
            var data;
            try {
                data = e.clipboardData.getData('text/plain');
            }
            catch (err) {
                //IE luv
                data = e.clipboardData.getData('text');
            }
            // trim to maxlength
            var newTextLength = _this.getCurrentValue().length - _this.getSelectedCharCount();
            var totalLength = newTextLength + data.length;
            var newTotalLength = Math.min(totalLength, _this.props.maxLength);
            data = data.substr(0, newTotalLength - newTextLength);
            if (data.length) {
                _this.pasteText(data);
                _this.onChange();
            }
        };
        _this.state = {
            editing: false,
            selectionOffset: 0
        };
        return _this;
    }
    ContentEditable.prototype.render = function () {
        var _this = this;
        return React.cloneElement(this.props.children, {
            ref: function (el) {
                var originalRef = _this.props.children &&
                    _this.props.children.ref;
                if (typeof originalRef === 'function') {
                    originalRef(el);
                }
                _this.rootEl = el;
            },
            contentEditable: this.state.editing,
            onClick: function () { return _this.onButtonClick(); },
            onKeyDown: this.onKeyDown,
            onKeyUp: this.onKeyUp,
            onKeyPress: this.onKeyPress,
            onPaste: this.onPaste
        });
    };
    ContentEditable.prototype.componentDidMount = function () {
        this.setCurrentValue(this.props.value.toString());
    };
    ContentEditable.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.editing === false && this.state.editing === true) {
            this.setCaretPosition(this.state.selectionOffset);
            this.getRootEl().focus();
        }
        if ((this.getRootEl() !== document.activeElement) && prevProps.value !== this.props.value) {
            if (this.props.value === "") {
                this.setCurrentValue(" ");
            }
            else {
                this.setCurrentValue(this.props.value);
            }
        }
    };
    ContentEditable.prototype.getCurrentValue = function () {
        return this.getRootEl().textContent;
    };
    ContentEditable.prototype.setCurrentValue = function (val) {
        this.getRootEl().textContent = val;
    };
    ContentEditable.prototype.getRootEl = function () {
        return this.rootEl;
    };
    ContentEditable.prototype.onChange = function () {
        var text = this.getCurrentValue();
        if (text === "") {
            this.setCurrentValue(" ");
        }
        if (text !== this.props.value) {
            this.props.onChange(text);
        }
    };
    ;
    ContentEditable.prototype.pasteText = function (data) {
        var selection = window.getSelection();
        var range = selection.getRangeAt(0);
        range.deleteContents();
        var fragment = range.createContextualFragment('');
        fragment.textContent = data;
        var replacementEnd = fragment.lastChild;
        range.insertNode(fragment);
        // Set cursor at the end of the replaced content, just like browsers do.
        range.setStartAfter(replacementEnd);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    };
    ContentEditable.prototype.getSelectedCharCount = function () {
        var selectionRange = window.getSelection().getRangeAt(0);
        return selectionRange.cloneContents().textContent.length;
    };
    ContentEditable.prototype.setCaretPosition = function (offset) {
        var textEl = this.getRootEl();
        //TODO: move selection logic to separate file
        var range = document.createRange();
        var sel = window.getSelection();
        if (offset < String(textEl.childNodes[0]).length) {
            range.setStart(textEl.childNodes[0] || textEl, offset);
        }
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
    };
    ContentEditable.prototype.onButtonClick = function () {
        if (!this.state.editing) {
            this.setState({
                editing: true
            });
        }
        //TODO: extract text selection logic to separate helper
        var selectionOffset = window.getSelection().anchorOffset;
        this.setState({
            selectionOffset: selectionOffset
        });
    };
    return ContentEditable;
}(React.Component));
exports.default = ContentEditable;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
var ModulHtmlCode = (function (_super) {
    tslib_1.__extends(ModulHtmlCode, _super);
    function ModulHtmlCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModulHtmlCode.prototype.doAfterSave = function (r) {
        _super.prototype.doAfterSave.call(this, r);
        // updates the entered html code with
        // one that has parsed internal links
        if (r.widgetContent) {
            $('#htmlcode_' + r.moduleId).val(r.widgetContent);
        }
    };
    return ModulHtmlCode;
}(Modul_1.default));
exports.default = ModulHtmlCode;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
/**
 * ModulFlashElement
 *
 */
var ModulFlashElement = (function (_super) {
    tslib_1.__extends(ModulFlashElement, _super);
    function ModulFlashElement(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.initParameters = {};
        _this.flashWidth = null;
        _this.flashHeight = null;
        var self = _this;
        _this.flashWidth = parseInt(_this.getEditorContentPlaceholder().data('width'), 10) || 200;
        _this.flashHeight = parseInt(_this.getEditorContentPlaceholder().data('height'), 10) || 200;
        _this.flashRatio = parseFloat(_this.getEditorContentPlaceholder().data('ratio')) ||
            _this.flashHeight / _this.flashWidth;
        _this.$uploadField = $('#flash_upload_wrapper_' + moduleId);
        /* get the form and add DIY form to it */
        _this.$form = _this.$uploadField.closest('form');
        _this.$form.diy_form();
        $("#wrapper_align_" + _this.moduleId).diy_combobox({
            editable: false
        });
        _this.$uploadField.diy_uploadField({
            change: function () {
                self.$form.diy_form("clearErrors");
                $(this).closest('form').submit();
            }
        });
        _this.updateContentSize();
        return _this;
    }
    ModulFlashElement.prototype.getEditorContentPlaceholder = function () {
        return this.getContentContainer().find('.module_flash_admin_content');
    };
    ModulFlashElement.prototype.updateContentSize = function () {
        var contentContainer = this.getContentContainer();
        var contentPlaceholder = this.getEditorContentPlaceholder();
        //when width is too big - take the content width and resize width to keep ratio
        if (this.flashWidth > contentContainer.width()) {
            this.flashWidth = contentContainer.width();
            this.flashHeight = this.flashWidth * this.flashRatio;
        }
        contentPlaceholder.css({
            width: this.flashWidth,
            height: this.flashHeight
        });
        //hide text when it's too big
        if (contentPlaceholder.find('.flash_content_messages').height() >
            contentPlaceholder.height() * 0.8) {
            //hide the text/leave just the filename
            contentPlaceholder.find('.flash_content_info').hide();
            //still too big?
            if (contentPlaceholder.find('.flash_content_messages').height() >
                contentPlaceholder.height() * 0.8) {
                //hide all the text
                contentPlaceholder.find('.flash_content_messages').hide();
            }
        }
    };
    ModulFlashElement.prototype.uploadError = function (errMsg) {
        this.$form.diy_form("addError", errMsg, this.$uploadField);
    };
    ModulFlashElement.prototype.open = function (openConfig) {
        var self = this;
        _super.prototype.open.call(this, openConfig);
        //show the flash when editor opened
        this.initFlash();
        this.getContentContainer().find('.module_flash_empty_placeholder').click(function () {
            self.$uploadField.find('input[type=file]').trigger('click');
        });
    };
    ModulFlashElement.prototype.initFlash = function () {
        this.getEditorContentPlaceholder().hide();
        //select by class and not id because
        var flashContainer = this.getContentContainer().find('.mediumScreenDisabled');
        var initParameters = flashContainer.data('initParameters');
        flashContainer.show();
        flashContainer.flash.apply(flashContainer, initParameters);
    };
    ModulFlashElement.prototype.update = function (content) {
        //empty content - we add placeholder
        if (content.length === 0) {
            _super.prototype.update.call(this, '<div class="module_flash_empty_placeholder"></div>');
            return;
        }
        _super.prototype.update.call(this, content);
        this.updateContentSize();
        this.initFlash();
    };
    ModulFlashElement.prototype.setOpenStyle = function (hasConfigView) {
        var _this = this;
        _super.prototype.setOpenStyle.call(this, hasConfigView);
        //propagate resize event to form as repositioned event
        this.modul.bind('resize.moduleContent', function () {
            _this.$form.trigger('containerRepositioned');
        });
    };
    return ModulFlashElement;
}(Modul_1.default));
exports.default = ModulFlashElement;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var ModulWithRedux_1 = __webpack_require__(493);
var l10n_1 = __webpack_require__(18);
var EditView_1 = __webpack_require__(1015);
var WebView_1 = __webpack_require__(1060);
var ModuleInlineEditor_1 = __webpack_require__(986);
var diyLightTheme = __webpack_require__(241);
var index_1 = __webpack_require__(536);
var AppRegistry_1 = __webpack_require__(190);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulFliestext = (function (_super) {
    tslib_1.__extends(ModulFliestext, _super);
    function ModulFliestext(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.hasUndoRedo = true;
        _this.helpArticleId = 'textfield';
        _this.changeEventTriggered = false;
        _this.inlineEditor = null;
        _this.undoHandler = function () {
            _this.inlineEditor.getEditor().execCommand('undo');
        };
        _this.redoHandler = function () {
            _this.inlineEditor.getEditor().execCommand('redo');
        };
        _this.ckEditorPromise = new Promise(function (resolve, reject) {
            _this.ckEditorPromiseResolve = resolve;
        });
        return _this;
    }
    ModulFliestext.prototype.loadData = function (data) {
        this.data = data;
        // 2 reasons why we don't receive data.text but need to
        // get it from the rendered module content
        // 1. We don't duplicate the data
        // 2. There are issues with the current way of sending this data from the server (render an inline <script> tag)
        // because data.text can contain arbitrary HTML, and there are many cases
        // when this would result in an invalid XML and so cannot be rendered at all
        this.data.text = this.getContentElement().innerHTML;
    };
    /**
     * @override
     * strictly for typing purposes
     */
    ModulFliestext.prototype.getData = function () {
        return this.data;
    };
    ModulFliestext.prototype.onOpenTracking = function () {
        if (!this.getIsNew()) {
            var self_1 = this;
            $(document).on('diy-text-editor-clicked', function (ev, dat) {
                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Tried',
                    'name': 'Content',
                    'otherData': self_1.moduleType
                });
            });
        }
    };
    ModulFliestext.prototype.getCKEditorPromise = function () {
        return this.ckEditorPromise;
    };
    ModulFliestext.prototype.getActionBarTabs = function () {
        return [
            {
                label: l10n_1.default('module.text.tabs.basic'),
                content: this.getConnectedComponent(EditView_1.TextEditViewTextBasics)
            },
            {
                label: l10n_1.default('module.text.tabs.advanced'),
                content: this.getConnectedComponent(EditView_1.TextEditViewFormat)
            }
        ];
    };
    /**
     * @override
     */
    ModulFliestext.prototype.getSaveData = function () {
        var data = _super.prototype.getSaveData.call(this);
        data.text = this.inlineEditor.getHtmlData();
        return data;
    };
    ModulFliestext.prototype.save = function () {
        if (!this.getIsNew()) {
            /**
             * Make some SiteCatalyst tracking
             */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                'condition': 'Applied',
                'name': 'Content',
                'otherData': this.moduleType
            });
            if (this.inlineEditor.isDirty()) {
                $(document.body).trigger('ContentModuleSaved.BSA');
            }
        }
        return _super.prototype.save.call(this);
    };
    /**
     * @override
     */
    ModulFliestext.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        this.inlineEditor.stopEditing();
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
    };
    ModulFliestext.prototype.initCKEditor = function (textElement) {
        var _this = this;
        var _a = this.getData().supports, textSanitizeHtml = _a.textSanitizeHtml, textPasteAsPlainText = _a.textPasteAsPlainText;
        this.inlineEditor = new ModuleInlineEditor_1.default(this, textElement);
        this.inlineEditor.startEditing({
            'diy-moduleType': this.moduleType,
            'diy-excludePasteScrubbers': 'semanticplaceholders',
            toolbar: 'Text',
            toolbar_Text: this.getCkeditorToolbarConfig(),
            diyhelpLabel: 'textfield',
            format_tags: 'p;h1;h2;pre',
            extraPlugins: ',lineutils,widget,diysemanticplaceholder',
            allowedContent: !textSanitizeHtml,
            forcePasteAsPlainText: textPasteAsPlainText,
            pasteFromWordRemoveFontStyles: false,
            pasteFromWordRemoveStyles: false,
            // this setting is primary used for setting the z-index
            // of CKEditor dialogs, and these should be the same as
            // standard Material UI dialogs zIndex
            baseFloatZIndex: diyLightTheme.zIndex.dialog,
            hideToolbar: true
        });
        this.inlineEditor.editor.on('pluginsLoaded', function (ev) {
            ev.editor.focus();
        });
        this.inlineEditor.editor.on('instanceReady', function () {
            _this.ckEditorPromiseResolve(_this.inlineEditor.getEditor());
            var store = getStore();
            _this.inlineEditor.editor.getCommand('undo').on('state', function () {
                store.dispatch(index_1.setUndoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
            _this.inlineEditor.editor.getCommand('redo').on('state', function () {
                store.dispatch(index_1.setRedoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
        });
        // attach kpi and bsa events for changes inside the editor
        if (this.getIsNew() !== true) {
            $(document.body).trigger('ContentModuleOpened.BSA');
            this.inlineEditor.editor.on('change', function (ev) {
                if (_this.changeEventTriggered === false) {
                    jQuery(document.body).trigger('ContentModuleEdited.BSA');
                    jQuery(document).trigger('diy-text-editor-clicked');
                    _this.changeEventTriggered = true;
                }
            });
        }
    };
    ModulFliestext.prototype.getInPlaceEditViewClass = function () {
        return null;
    };
    ModulFliestext.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    ModulFliestext.prototype.getCkeditorToolbarConfig = function () {
        var _a = this.getData().supports, textFormat = _a.textFormat, textAlign = _a.textAlign, textIndent = _a.textIndent, textStyle = _a.textStyle, textColor = _a.textColor, textRemoveFormat = _a.textRemoveFormat, textHtmlEdit = _a.textHtmlEdit, textWordPaste = _a.textWordPaste;
        var config = [
            ['Undo', 'Redo'],
            ['FontSize'],
            textFormat ? ['Format'] : undefined,
            ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'],
            textAlign ? ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] : undefined,
            ['DiySemanticPlaceholder'],
            ['ToggleCollapse'],
            ['HelpButton'],
            ['CloseButton'],
            '/',
            ['NumberedList', 'BulletedList'],
            textIndent ? ['Outdent', 'Indent'] : undefined,
            textStyle || textColor ? [
                textStyle ? 'StyleButton' : undefined,
                textColor ? 'DiyTextColor' : undefined
            ] : undefined,
            [
                'PasteText',
                textRemoveFormat ? 'RemoveFormat' : undefined
            ],
            [
                textHtmlEdit ? 'Sourcedialog' : undefined,
                textWordPaste ? 'PasteFromWord' : undefined,
                'SelectAll'
            ],
            ['DiyLink', 'DiyUnlink'],
            // XXX Including support for table, even if no controls in Action Bar
            // because users wants to keep copy-pasted tables, and CKEditor should
            // not strip them away
            '/',
            ['Table'], ['TableMixed'],
            ['TableInsertRowBefore', 'TableInsertRowAfter', 'TableDeleteRow'],
            ['TableInsertColumnBefore', 'TableInsertColumnAfter', 'TableDeleteColumn'],
            ['TableSplitVertically', 'TableSplitHorizontally'],
            ['TableMergeRight', 'TableMergeDown', 'TableMerge']
        ];
        return config.filter(function (item) { return item !== undefined; });
    };
    return ModulFliestext;
}(ModulWithRedux_1.default));
exports.default = ModulFliestext;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var CKEditorEditView_1 = __webpack_require__(1016);
var AllCKEditorButtonsConfig_1 = __webpack_require__(1019);
var TextFormat_1 = __webpack_require__(1059);
var format_align_left_1 = __webpack_require__(994);
var format_list_bulleted_1 = __webpack_require__(1026);
var format_indent_increase_1 = __webpack_require__(1030);
var content_paste_1 = __webpack_require__(1033);
var TextEditViewTextBasics = (function (_super) {
    tslib_1.__extends(TextEditViewTextBasics, _super);
    function TextEditViewTextBasics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextEditViewTextBasics.prototype.render = function () {
        var items = [];
        var _a = this.props.module.getData().supports, textFormat = _a.textFormat, textAlign = _a.textAlign, textIndent = _a.textIndent, textColor = _a.textColor;
        if (textFormat) {
            items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.FontSize);
        }
        if (textColor) {
            items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.DiyTextColor);
        }
        if (textFormat) {
            items.push({
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.format'),
                    Icon: React.createElement(TextFormat_1.TextFormat, null),
                    dataTestId: "text-module-format-menu"
                },
                items: [
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Bold,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Italic,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Underline,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Strike,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Superscript,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Subscript,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.RemoveFormat
                ]
            });
        }
        if (textAlign) {
            items.push({
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.align'),
                    Icon: React.createElement(format_align_left_1.default, null),
                    dataTestId: "text-module-align-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyLeft, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyCenter, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyRight, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyBlock]
            });
        }
        items.push({
            groupProps: {
                label: l10n_1.default('module.text.buttongroups.list'),
                Icon: React.createElement(format_list_bulleted_1.default, null),
                dataTestId: "text-module-list-menu"
            },
            items: [AllCKEditorButtonsConfig_1.allCKEditorItems.NumberedList, AllCKEditorButtonsConfig_1.allCKEditorItems.BulletedList]
        });
        if (textIndent) {
            items.push({
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.indent'),
                    Icon: React.createElement(format_indent_increase_1.default, null),
                    dataTestId: "text-module-indent-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.Outdent, AllCKEditorButtonsConfig_1.allCKEditorItems.Indent]
            });
        }
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.Link, AllCKEditorButtonsConfig_1.allCKEditorItems.Unlink);
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TextBasics", items: items })));
    };
    return TextEditViewTextBasics;
}(React.Component));
exports.TextEditViewTextBasics = TextEditViewTextBasics;
var TextEditViewFormat = (function (_super) {
    tslib_1.__extends(TextEditViewFormat, _super);
    function TextEditViewFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextEditViewFormat.prototype.render = function () {
        var items = [];
        var _a = this.props.module.getData().supports, textFormat = _a.textFormat, textHtmlEdit = _a.textHtmlEdit, textWordPaste = _a.textWordPaste;
        if (textFormat) {
            items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.Format);
        }
        if (textWordPaste) {
            items.push({
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.paste'),
                    Icon: React.createElement(content_paste_1.default, null),
                    dataTestId: "text-module-paste-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.Paste, AllCKEditorButtonsConfig_1.allCKEditorItems.PasteFromWord]
            });
        }
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.TextStyles(this.props.module));
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.ContactInfo);
        if (textHtmlEdit) {
            items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.SourceDialog);
        }
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TextFormat", items: items })));
    };
    return TextEditViewFormat;
}(React.Component));
exports.TextEditViewFormat = TextEditViewFormat;


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var CKEditorToolbar_1 = __webpack_require__(1017);
var LinearProgress_1 = __webpack_require__(695);
var Warning_1 = __webpack_require__(618);
var cancelablePromise_1 = __webpack_require__(1018);
var CKEditorEditView = (function (_super) {
    tslib_1.__extends(CKEditorEditView, _super);
    function CKEditorEditView(props) {
        var _this = _super.call(this, props) || this;
        _this.onCkEditorChange = function () {
            _this.detectSanitizedScripts();
        };
        _this.state = {
            ckEditor: null,
            hasSanitizedScripts: false,
        };
        _this.ckEditorPromise = cancelablePromise_1.makeCancelable(_this.props.module.getCKEditorPromise());
        _this.ckEditorPromise.then(function (ckEditor) {
            _this.setState({ ckEditor: ckEditor }, function () {
                _this.detectSanitizedScripts();
                ckEditor.on('change', _this.onCkEditorChange);
                ckEditor.on('dataReady', _this.onCkEditorChange);
            });
        });
        return _this;
    }
    CKEditorEditView.prototype.componentWillUnmount = function () {
        var ckEditor = this.state.ckEditor;
        this.ckEditorPromise.cancel();
        if (ckEditor) {
            ckEditor.removeListener('change', this.onCkEditorChange);
            ckEditor.removeListener('dataReady', this.onCkEditorChange);
        }
    };
    CKEditorEditView.prototype.render = function () {
        var _a = this.state, ckEditor = _a.ckEditor, hasSanitizedScripts = _a.hasSanitizedScripts;
        if (ckEditor) {
            return (React.createElement("div", null,
                React.createElement(CKEditorToolbar_1.default, { ckEditor: this.state.ckEditor, items: this.props.items }),
                hasSanitizedScripts ?
                    React.createElement(Warning_1.default, { text: l10n_1.default("module.textHasSanitizedScripts"), isError: true })
                    :
                        null));
        }
        return (React.createElement("div", null,
            React.createElement(LinearProgress_1.default, { mode: "indeterminate" })));
    };
    CKEditorEditView.prototype.detectSanitizedScripts = function () {
        var hasSanitizedScripts = false;
        if (this.state.ckEditor
            && this.state.ckEditor.element
            && this.state.ckEditor.element.$) {
            var editEl = this.state.ckEditor.element.$;
            hasSanitizedScripts =
                editEl.querySelectorAll('[data-sanitized]').length > 0
                    || editEl.innerHTML.match(/<!--\{cke_protected\}[\s\S]*data-sanitized[\s\S]*-->/gi) !== null;
        }
        if (hasSanitizedScripts !== this.state.hasSanitizedScripts) {
            this.setState({
                hasSanitizedScripts: hasSanitizedScripts
            });
        }
    };
    return CKEditorEditView;
}(React.Component));
exports.CKEditorEditView = CKEditorEditView;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ResponsiveBar_1 = __webpack_require__(992);
var IconTextButtonGroup_1 = __webpack_require__(990);
var IconTextButton_1 = __webpack_require__(459);
function itemIsGroup(item) {
    return typeof item.groupProps !== 'undefined';
}
function itemIsButton(item) {
    return typeof item.Icon !== 'undefined';
}
function itemIsFactory(item) {
    return typeof item === 'function';
}
var CKEditorToolbar = (function (_super) {
    tslib_1.__extends(CKEditorToolbar, _super);
    function CKEditorToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.selectionChangeListener = function () {
            _this.forceUpdate();
        };
        _this.onTouchTapButton = function (event, item) {
            var command = item.command;
            var commandData = item.commandData;
            if (!commandData) {
                commandData = function () { return undefined; };
            }
            _this.props.ckEditor.execCommand(command, commandData(event));
        };
        _this.renderItem = function (item, index) {
            var styles = _this.getStyles();
            if (itemIsGroup(item)) {
                return (React.createElement(IconTextButtonGroup_1.default, tslib_1.__assign({ key: index, style: styles.itemGroup, dataTestId: item.groupProps.dataTestId }, item.groupProps), item.items.map(_this.renderItem)));
            }
            else if (itemIsButton(item)) {
                if (_this.commands.indexOf(item.command) === -1) {
                    _this.commands.push(item.command);
                }
                var buttonCfg_1 = item;
                return (React.createElement(IconTextButton_1.default, { Icon: React.createElement(buttonCfg_1.Icon, null), AdditionalIcon: buttonCfg_1.AdditionalIcon, text: buttonCfg_1.text, onTouchTap: function (event) { return _this.onTouchTapButton(event, buttonCfg_1); }, isPressed: _this.state[buttonCfg_1.command] === CKEDITOR.TRISTATE_ON, isDisabled: _this.state[buttonCfg_1.command] === CKEDITOR.TRISTATE_DISABLED, useAlternativeColors: true, style: styles.item, key: buttonCfg_1.command, dataTestId: "text-command-" + buttonCfg_1.command }));
            }
            else if (itemIsFactory(item)) {
                return item(_this.props.ckEditor);
            }
            else {
                return (React.createElement("span", { key: index, style: styles.item }, "\u2026"));
            }
        };
        _this.state = {};
        _this.commands = [];
        _this.commandListeners = {};
        return _this;
    }
    CKEditorToolbar.prototype.componentDidMount = function () {
        var _this = this;
        var self = this;
        this.commands.forEach(function (command) {
            // `this.state` is the new command state:
            // http://docs.ckeditor.com/#!/api/CKEDITOR.command-event-state
            _this.commandListeners[command] = function () {
                var newState = {};
                newState[command] = this.state;
                self.setState(newState);
            };
            var commandObj = _this.props.ckEditor.getCommand(command);
            _this.commandListeners[command].call(commandObj);
            commandObj.on('state', _this.commandListeners[command]);
        });
        // See #BUG-8964 - Rerender the component whenever the ckeditor
        // selection changes. This is done to ensure the color picker is always
        // updated even if no ckeditor command was executed to trigger a rerender
        this.props.ckEditor.on('selectionChange', this.selectionChangeListener);
    };
    CKEditorToolbar.prototype.componentWillUnmount = function () {
        var _this = this;
        this.commands.forEach(function (command) {
            _this.props.ckEditor.getCommand(command).removeListener('state', _this.commandListeners[command]);
        });
        this.props.ckEditor.removeListener('selectionChange', this.selectionChangeListener);
    };
    CKEditorToolbar.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(ResponsiveBar_1.default, null, this.props.items.map(this.renderItem))));
    };
    CKEditorToolbar.prototype.getStyles = function () {
        return {
            itemGroup: {
                display: 'inline-block',
                marginLeft: 10,
                marginRight: 10
            },
            item: {
                marginLeft: 2,
                marginRight: 2
            }
        };
    };
    return CKEditorToolbar;
}(React.Component));
exports.default = CKEditorToolbar;


/***/ },
/* 1018 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function makeCancelable(promise) {
    var hasCanceled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise.then(function (val) {
            return hasCanceled ? reject({ isCanceled: true }) : resolve(val);
        });
        promise.catch(function (error) {
            return hasCanceled ? reject({ isCanceled: true }) : reject(error);
        });
    });
    wrappedPromise.cancel = function () {
        hasCanceled = true;
    };
    return wrappedPromise;
}
exports.makeCancelable = makeCancelable;
;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var format_bold_1 = __webpack_require__(1020);
var format_italic_1 = __webpack_require__(1021);
var format_underlined_1 = __webpack_require__(1022);
var format_strikethrough_1 = __webpack_require__(1023);
var format_align_left_1 = __webpack_require__(994);
var format_align_center_1 = __webpack_require__(995);
var format_align_right_1 = __webpack_require__(996);
var format_align_justify_1 = __webpack_require__(1024);
var format_list_numbered_1 = __webpack_require__(1025);
var format_list_bulleted_1 = __webpack_require__(1026);
var insert_link_1 = __webpack_require__(1027);
var close_1 = __webpack_require__(1028);
var format_indent_decrease_1 = __webpack_require__(1029);
var format_indent_increase_1 = __webpack_require__(1030);
var format_clear_1 = __webpack_require__(1031);
var contacts_1 = __webpack_require__(1032);
var palette_1 = __webpack_require__(521);
var content_paste_1 = __webpack_require__(1033);
var code_1 = __webpack_require__(1034);
var keyboard_arrow_down_1 = __webpack_require__(463);
var PasteFromWord_1 = __webpack_require__(1035);
var Subscript_1 = __webpack_require__(1036);
var Superscript_1 = __webpack_require__(1037);
var AddEditTable_1 = __webpack_require__(1038);
var RowInsertBefore_1 = __webpack_require__(1039);
var RowInsertAfter_1 = __webpack_require__(1040);
var ColumnInsertBefore_1 = __webpack_require__(1041);
var ColumnInsertAfter_1 = __webpack_require__(1042);
var RowDelete_1 = __webpack_require__(1043);
var ColumnDelete_1 = __webpack_require__(1044);
var CellMerge_1 = __webpack_require__(1045);
var CellMergeDown_1 = __webpack_require__(1046);
var CellMergeRight_1 = __webpack_require__(1047);
var CellHorizontalSplit_1 = __webpack_require__(1048);
var CellVerticalSplit_1 = __webpack_require__(1049);
var CKEditorFontSizeMenu_1 = __webpack_require__(1050);
var CKEditorFormatMenu_1 = __webpack_require__(1056);
var ColorPickerCKEditorDropdown_1 = __webpack_require__(1057);
var OpenGeneralStyles_1 = __webpack_require__(1058);
exports.allCKEditorItems = {
    Bold: {
        Icon: format_bold_1.default,
        text: l10n_1.default('module.text.style.bold'),
        command: 'bold'
    },
    Italic: {
        Icon: format_italic_1.default,
        text: l10n_1.default('module.text.style.italic'),
        command: 'italic'
    },
    Underline: {
        Icon: format_underlined_1.default,
        text: l10n_1.default('module.text.style.underline'),
        command: 'underline'
    },
    Strike: {
        Icon: format_strikethrough_1.default,
        text: l10n_1.default('module.text.style.strikethrough'),
        command: 'strike'
    },
    Superscript: {
        Icon: Superscript_1.Superscript,
        text: l10n_1.default('module.text.style.superscript'),
        command: 'superscript'
    },
    Subscript: {
        Icon: Subscript_1.Subscript,
        text: l10n_1.default('module.text.style.subscript'),
        command: 'subscript'
    },
    JustifyLeft: {
        Icon: format_align_left_1.default,
        text: l10n_1.default('module.text.align.left'),
        command: 'justifyleft'
    },
    JustifyCenter: {
        Icon: format_align_center_1.default,
        text: l10n_1.default('module.text.align.center'),
        command: 'justifycenter'
    },
    JustifyRight: {
        Icon: format_align_right_1.default,
        text: l10n_1.default('module.text.align.right'),
        command: 'justifyright'
    },
    JustifyBlock: {
        Icon: format_align_justify_1.default,
        text: l10n_1.default('module.text.align.justify'),
        command: 'justifyblock'
    },
    NumberedList: {
        Icon: format_list_numbered_1.default,
        text: l10n_1.default('module.text.list.numbered'),
        command: 'numberedlist'
    },
    BulletedList: {
        Icon: format_list_bulleted_1.default,
        text: l10n_1.default('module.text.list.bulleted'),
        command: 'bulletedlist'
    },
    Link: {
        Icon: insert_link_1.default,
        AdditionalIcon: keyboard_arrow_down_1.default,
        text: l10n_1.default('module.text.link.add'),
        command: 'diylink',
        commandData: function (event) {
            return {
                anchorTo: event.target,
                zIndex: 101001,
                offset: '0 4'
            };
        }
    },
    Unlink: {
        Icon: close_1.default,
        text: l10n_1.default('module.text.link.remove'),
        command: 'unlink'
    },
    Outdent: {
        Icon: format_indent_decrease_1.default,
        text: l10n_1.default('module.text.indent.decrease'),
        command: 'outdent'
    },
    Indent: {
        Icon: format_indent_increase_1.default,
        text: l10n_1.default('module.text.indent.increase'),
        command: 'indent'
    },
    RemoveFormat: {
        Icon: format_clear_1.default,
        text: l10n_1.default('module.text.style.clear'),
        command: 'removeFormat'
    },
    ContactInfo: {
        Icon: contacts_1.default,
        AdditionalIcon: keyboard_arrow_down_1.default,
        text: l10n_1.default('module.text.contactinfo'),
        command: 'togglesemanticplaceholderflyout',
        commandData: function (event) {
            return {
                anchorTo: event.target,
                zIndex: 101001,
                offset: '0 4'
            };
        }
    },
    Paste: {
        Icon: content_paste_1.default,
        text: l10n_1.default('module.text.paste.text'),
        command: 'pastetext'
    },
    PasteFromWord: {
        Icon: PasteFromWord_1.PasteFromWordIcon,
        text: l10n_1.default('module.text.paste.word'),
        command: 'pastefromword'
    },
    SourceDialog: {
        Icon: code_1.default,
        text: l10n_1.default('module.text.edithtml'),
        command: 'sourcedialog'
    },
    TableMixed: {
        Icon: AddEditTable_1.AddEditTable,
        text: l10n_1.default('module.table.addEdit'),
        command: 'tableMixed'
    },
    RowInsertBefore: {
        Icon: RowInsertBefore_1.RowInsertBefore,
        text: l10n_1.default('module.table.rowInsertBefore'),
        command: 'rowInsertBefore'
    },
    RowInsertAfter: {
        Icon: RowInsertAfter_1.RowInsertAfter,
        text: l10n_1.default('module.table.rowInsertAfter'),
        command: 'rowInsertAfter'
    },
    ColumnInsertBefore: {
        Icon: ColumnInsertBefore_1.ColumnInsertBefore,
        text: l10n_1.default('module.table.columnInsertBefore'),
        command: 'columnInsertBefore'
    },
    ColumnInsertAfter: {
        Icon: ColumnInsertAfter_1.ColumnInsertAfter,
        text: l10n_1.default('module.table.columnInsertAfter'),
        command: 'columnInsertAfter'
    },
    RowDelete: {
        Icon: RowDelete_1.RowDelete,
        text: l10n_1.default('module.table.rowDelete'),
        command: 'rowDelete'
    },
    ColumnDelete: {
        Icon: ColumnDelete_1.ColumnDelete,
        text: l10n_1.default('module.table.columnDelete'),
        command: 'columnDelete'
    },
    CellMerge: {
        Icon: CellMerge_1.CellMerge,
        text: l10n_1.default('module.table.cellMerge'),
        command: 'cellMerge'
    },
    CellMergeDown: {
        Icon: CellMergeDown_1.CellMergeDown,
        text: l10n_1.default('module.table.cellMergeDown'),
        command: 'cellMergeDown'
    },
    CellMergeRight: {
        Icon: CellMergeRight_1.CellMergeRight,
        text: l10n_1.default('module.table.cellMergeRight'),
        command: 'cellMergeRight'
    },
    CellHorizontalSplit: {
        Icon: CellHorizontalSplit_1.CellHorizontalSplit,
        text: l10n_1.default('module.table.cellHorizontalSplit'),
        command: 'cellHorizontalSplit'
    },
    CellVerticalSplit: {
        Icon: CellVerticalSplit_1.CellVerticalSplit,
        text: l10n_1.default('module.table.cellVerticalSplit'),
        command: 'cellVerticalSplit'
    },
    FontSize: function (ckEditor) {
        return React.createElement(CKEditorFontSizeMenu_1.default, { ckEditor: ckEditor, key: "FontSize" });
    },
    Format: function (ckEditor) {
        return React.createElement(CKEditorFormatMenu_1.default, { ckEditor: ckEditor, key: "Format" });
    },
    DiyTextColor: function (ckEditor) {
        return React.createElement(ColorPickerCKEditorDropdown_1.ColorPickerCKEditorDropdown, { ckEditor: ckEditor, onChange: function (color) {
                ckEditor.execCommand('diycolorapply', color);
            }, key: "DiyTextColor" });
    },
    TextStyles: function (module) { return function (ckEditor) {
        return React.createElement(OpenGeneralStyles_1.default, { module: module, Icon: palette_1.default, label: l10n_1.default('module.text.generalstyles'), key: "openStyleSection" });
    }; }
};


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatBold = function EditorFormatBold(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
  );
};
EditorFormatBold = (0, _pure2.default)(EditorFormatBold);
EditorFormatBold.displayName = 'EditorFormatBold';
EditorFormatBold.muiName = 'SvgIcon';

exports.default = EditorFormatBold;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatItalic = function EditorFormatItalic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
  );
};
EditorFormatItalic = (0, _pure2.default)(EditorFormatItalic);
EditorFormatItalic.displayName = 'EditorFormatItalic';
EditorFormatItalic.muiName = 'SvgIcon';

exports.default = EditorFormatItalic;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatUnderlined = function EditorFormatUnderlined(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
  );
};
EditorFormatUnderlined = (0, _pure2.default)(EditorFormatUnderlined);
EditorFormatUnderlined.displayName = 'EditorFormatUnderlined';
EditorFormatUnderlined.muiName = 'SvgIcon';

exports.default = EditorFormatUnderlined;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatStrikethrough = function EditorFormatStrikethrough(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
  );
};
EditorFormatStrikethrough = (0, _pure2.default)(EditorFormatStrikethrough);
EditorFormatStrikethrough.displayName = 'EditorFormatStrikethrough';
EditorFormatStrikethrough.muiName = 'SvgIcon';

exports.default = EditorFormatStrikethrough;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignJustify = function EditorFormatAlignJustify(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z' })
  );
};
EditorFormatAlignJustify = (0, _pure2.default)(EditorFormatAlignJustify);
EditorFormatAlignJustify.displayName = 'EditorFormatAlignJustify';
EditorFormatAlignJustify.muiName = 'SvgIcon';

exports.default = EditorFormatAlignJustify;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatListNumbered = function EditorFormatListNumbered(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
  );
};
EditorFormatListNumbered = (0, _pure2.default)(EditorFormatListNumbered);
EditorFormatListNumbered.displayName = 'EditorFormatListNumbered';
EditorFormatListNumbered.muiName = 'SvgIcon';

exports.default = EditorFormatListNumbered;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatListBulleted = function EditorFormatListBulleted(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
  );
};
EditorFormatListBulleted = (0, _pure2.default)(EditorFormatListBulleted);
EditorFormatListBulleted.displayName = 'EditorFormatListBulleted';
EditorFormatListBulleted.muiName = 'SvgIcon';

exports.default = EditorFormatListBulleted;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertLink = function EditorInsertLink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
  );
};
EditorInsertLink = (0, _pure2.default)(EditorInsertLink);
EditorInsertLink.displayName = 'EditorInsertLink';
EditorInsertLink.muiName = 'SvgIcon';

exports.default = EditorInsertLink;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationClose = function NavigationClose(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
NavigationClose = (0, _pure2.default)(NavigationClose);
NavigationClose.displayName = 'NavigationClose';
NavigationClose.muiName = 'SvgIcon';

exports.default = NavigationClose;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatIndentDecrease = function EditorFormatIndentDecrease(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
  );
};
EditorFormatIndentDecrease = (0, _pure2.default)(EditorFormatIndentDecrease);
EditorFormatIndentDecrease.displayName = 'EditorFormatIndentDecrease';
EditorFormatIndentDecrease.muiName = 'SvgIcon';

exports.default = EditorFormatIndentDecrease;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatIndentIncrease = function EditorFormatIndentIncrease(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
  );
};
EditorFormatIndentIncrease = (0, _pure2.default)(EditorFormatIndentIncrease);
EditorFormatIndentIncrease.displayName = 'EditorFormatIndentIncrease';
EditorFormatIndentIncrease.muiName = 'SvgIcon';

exports.default = EditorFormatIndentIncrease;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatClear = function EditorFormatClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
  );
};
EditorFormatClear = (0, _pure2.default)(EditorFormatClear);
EditorFormatClear.displayName = 'EditorFormatClear';
EditorFormatClear.muiName = 'SvgIcon';

exports.default = EditorFormatClear;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationContacts = function CommunicationContacts(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z' })
  );
};
CommunicationContacts = (0, _pure2.default)(CommunicationContacts);
CommunicationContacts.displayName = 'CommunicationContacts';
CommunicationContacts.muiName = 'SvgIcon';

exports.default = CommunicationContacts;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentPaste = function ContentContentPaste(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
  );
};
ContentContentPaste = (0, _pure2.default)(ContentContentPaste);
ContentContentPaste.displayName = 'ContentContentPaste';
ContentContentPaste.muiName = 'SvgIcon';

exports.default = ContentContentPaste;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCode = function ActionCode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
  );
};
ActionCode = (0, _pure2.default)(ActionCode);
ActionCode.displayName = 'ActionCode';
ActionCode.muiName = 'SvgIcon';

exports.default = ActionCode;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var PasteFromWordIcon = (function (_super) {
    tslib_1.__extends(PasteFromWordIcon, _super);
    function PasteFromWordIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PasteFromWordIcon.prototype.render = function () {
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { d: "M5,21.03V4.976H6.97v3H17v-3H18.97V21.03H5ZM12.97,3.99A0.985,0.985,0,1,1,11,3.99,0.985,0.985,0,1,1,12.97,3.99ZM14.8,3A3.142,3.142,0,0,0,13.72,1.549a2.952,2.952,0,0,0-3.469,0A3.131,3.131,0,0,0,9.173,3H5A1.967,1.967,0,0,0,3.6,3.591a1.86,1.86,0,0,0-.61,1.385V21.03a1.858,1.858,0,0,0,.61,1.385A1.964,1.964,0,0,0,5,23H18.97a1.967,1.967,0,0,0,1.406-.587,1.861,1.861,0,0,0,.609-1.385V4.976a1.863,1.863,0,0,0-.609-1.385A1.97,1.97,0,0,0,18.97,3H14.8ZM18,10H16l-1,7-2-7H11L9,17,8,10H6l2,9h2l2-7,2,7h2Z" })));
        /* tslint:enable:max-line-length */
    };
    return PasteFromWordIcon;
}(React.Component));
exports.PasteFromWordIcon = PasteFromWordIcon;


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var Subscript = (function (_super) {
    tslib_1.__extends(Subscript, _super);
    function Subscript() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subscript.prototype.render = function () {
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { transform: "translate(-0.5 0.5)", fillRule: "evenodd", d: "M15,6l-4.206,4.007L15,14l-2,2L9,12,5,16,3,14l4-4L3,6,5,4,9,8l4-4Zm7,12H19l1.512-1.693a5.7,5.7,0,0,0,.919-1.215,2.228,2.228,0,0,0,.268-1.024,2.076,2.076,0,0,0-.6-1.566,2.52,2.52,0,0,0-1.673-.5,2.672,2.672,0,0,0-1.259.291,2.491,2.491,0,0,0-.859.949,2.174,2.174,0,0,0-.3,1.131H18.4a1.222,1.222,0,0,1,.27-0.826,0.924,0.924,0,0,1,.739-0.314,0.859,0.859,0,0,1,.67.258,1.017,1.017,0,0,1,.235.71,1.355,1.355,0,0,1-.223.7,5.429,5.429,0,0,1-.687.861L17,18v1h5V18Z" })));
        /* tslint:enable:max-line-length */
    };
    return Subscript;
}(React.Component));
exports.Subscript = Subscript;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var Superscript = (function (_super) {
    tslib_1.__extends(Superscript, _super);
    function Superscript() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Superscript.prototype.render = function () {
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { transform: "translate(-0.5 0.5)", fillRule: "evenodd", d: "M15,9l-4,4,4,4-2,2L9,15,5,19,3,17l4-4L3,9,5,7l4,4,4-4Zm7,1H19l1.512-1.693a5.7,5.7,0,0,0,.919-1.215A2.228,2.228,0,0,0,21.7,6.069,2.077,2.077,0,0,0,21.1,4.5,2.52,2.52,0,0,0,19.431,4a2.672,2.672,0,0,0-1.259.291,2.491,2.491,0,0,0-.859.949,2.173,2.173,0,0,0-.3,1.131H18.4a1.222,1.222,0,0,1,.27-0.826,0.924,0.924,0,0,1,.739-0.314,0.859,0.859,0,0,1,.67.258,1.017,1.017,0,0,1,.235.71,1.356,1.356,0,0,1-.223.7,5.428,5.428,0,0,1-.687.861L17,10v1h5V10Z" })));
        /* tslint:enable:max-line-length */
    };
    return Superscript;
}(React.Component));
exports.Superscript = Superscript;


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var AddEditTable = (function (_super) {
    tslib_1.__extends(AddEditTable, _super);
    function AddEditTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddEditTable.prototype.render = function () {
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { fillRule: "evenodd", d: "M4,4H20V20H4V4ZM5,8H9v5H5V8Zm5,0h4v5H10V8Zm5,0h4v5H15V8ZM5,14H9v5H5V14Zm5,0h4v5H10V14Zm5,0h4v5H15V14Z" })));
        /* tslint:enable:max-line-length */
    };
    return AddEditTable;
}(React.Component));
exports.AddEditTable = AddEditTable;


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var RowInsertBefore = (function (_super) {
    tslib_1.__extends(RowInsertBefore, _super);
    function RowInsertBefore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowInsertBefore.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M3,11H17V21H3V11Zm0,4.016v1.989l14,0,0-1.984H3Z" }),
            React.createElement("path", { style: style2, d: "M9,10L5,7,9,4v6Zm2-5H21V9H11V5Z" })));
    };
    return RowInsertBefore;
}(React.Component));
RowInsertBefore.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.RowInsertBefore = RowInsertBefore;


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var RowInsertAfter = (function (_super) {
    tslib_1.__extends(RowInsertAfter, _super);
    function RowInsertAfter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowInsertAfter.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M3,14H17V4H3V14ZM3,9.984V8L17,8l0,1.984H3Z" }),
            React.createElement("path", { style: style2, d: "M9,15L5,18l4,3V15Zm2,1H21v4H11V16Z" })));
    };
    return RowInsertAfter;
}(React.Component));
RowInsertAfter.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.RowInsertAfter = RowInsertAfter;


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var ColumnInsertBefore = (function (_super) {
    tslib_1.__extends(ColumnInsertBefore, _super);
    function ColumnInsertBefore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnInsertBefore.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M11,21V7H21V21H11Zm4.016,0h1.989L17,7,15.016,7V21Z" }),
            React.createElement("path", { style: style2, d: "M10,15L7,19,4,15h6ZM5,3H9V13H5V3Z" })));
    };
    return ColumnInsertBefore;
}(React.Component));
ColumnInsertBefore.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.ColumnInsertBefore = ColumnInsertBefore;


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var ColumnInsertAfter = (function (_super) {
    tslib_1.__extends(ColumnInsertAfter, _super);
    function ColumnInsertAfter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnInsertAfter.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M14,21V7H4V21H14ZM9.984,21H8L8,7,9.984,7V21Z" }),
            React.createElement("path", { style: style2, d: "M15,15l3,4,3-4H15ZM16,3h4V13H16V3Z" })));
    };
    return ColumnInsertAfter;
}(React.Component));
ColumnInsertAfter.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.ColumnInsertAfter = ColumnInsertAfter;


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var RowDelete = (function (_super) {
    tslib_1.__extends(RowDelete, _super);
    function RowDelete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowDelete.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconNegativeColor,
            fillRule: 'evenodd'
        };
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M21,4H7V8H21V4Zm0,12H7v4H21V16Z" }),
            React.createElement("path", { style: style2, d: "M14,9l2,2a27,27,0,0,0,2-2,6.743,6.743,0,0,0,1,1l-2,2,2,2-1,1-2-2-2,2-1-1,2-2-2-2ZM3,10h8v4H3V10Z" })));
        /* tslint:enable:max-line-length */
    };
    return RowDelete;
}(React.Component));
RowDelete.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.RowDelete = RowDelete;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var ColumnDelete = (function (_super) {
    tslib_1.__extends(ColumnDelete, _super);
    function ColumnDelete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnDelete.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconNegativeColor,
            fillRule: 'evenodd'
        };
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M20,21V7H16V21h4ZM8,21V7H4V21H8Z" }),
            React.createElement("path", { style: style2, d: "M15,14l-2,2a27,27,0,0,0,2,2,6.743,6.743,0,0,0-1,1l-2-2-2,2L9,18l2-2L9,14l1-1,2,2,2-2ZM10,3h4v8H10V3Z" })));
        /* tslint:enable:max-line-length */
    };
    return ColumnDelete;
}(React.Component));
ColumnDelete.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.ColumnDelete = ColumnDelete;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var CellMerge = (function (_super) {
    tslib_1.__extends(CellMerge, _super);
    function CellMerge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellMerge.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
        };
        var style2 = {
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("rect", { style: style1, x: "10", y: "10", width: "12", height: "10" }),
            React.createElement("path", { style: style2, d: "M3,10H8v4H3V10Zm0,6H8v4H3V16ZM3,4H8V8H3V4Zm7,0h5V8H10V4Zm7,0h5V8H17V4Z" })));
    };
    return CellMerge;
}(React.Component));
CellMerge.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.CellMerge = CellMerge;


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var CellMergeDown = (function (_super) {
    tslib_1.__extends(CellMergeDown, _super);
    function CellMergeDown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellMergeDown.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        var style2 = {
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M13,5h8V19H13V5Zm7,7H14v6h6V12Zm0,1-3,4-3-4h6Z" }),
            React.createElement("path", { style: style2, d: "M3,13h8v6H3V13ZM3,5h8v6H3V5Z" })));
    };
    return CellMergeDown;
}(React.Component));
CellMergeDown.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.CellMergeDown = CellMergeDown;


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var CellMergeRight = (function (_super) {
    tslib_1.__extends(CellMergeRight, _super);
    function CellMergeRight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellMergeRight.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        var style2 = {
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M3,13H21v6H3V13Zm9,5V14h8v4H12Zm2,0,4-2-4-2v4Z" }),
            React.createElement("path", { style: style2, d: "M3,5h8v6H3V5ZM13,5h8v6H13V5Z" })));
    };
    return CellMergeRight;
}(React.Component));
CellMergeRight.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.CellMergeRight = CellMergeRight;


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var CellHorizontalSplit = (function (_super) {
    tslib_1.__extends(CellHorizontalSplit, _super);
    function CellHorizontalSplit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellHorizontalSplit.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M4,19L0,16l4-3v6Zm1-6h6v6H5V13Zm15,6,4-3-4-3v6Zm-7-6h6v6H13V13Z" }),
            React.createElement("rect", { x: "5", y: "5", width: "14", height: "6" })));
    };
    return CellHorizontalSplit;
}(React.Component));
CellHorizontalSplit.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.CellHorizontalSplit = CellHorizontalSplit;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var CellVerticalSplit = (function (_super) {
    tslib_1.__extends(CellVerticalSplit, _super);
    function CellVerticalSplit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellVerticalSplit.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("rect", { x: "5", y: "5", width: "6", height: "14" }),
            React.createElement("path", { style: style1, d: "M13,5h6v6H13V5Zm0,8h6v6H13V13Zm6,7-3,4-3-4h6ZM19,4L16,0,13,4h6Z" })));
    };
    return CellVerticalSplit;
}(React.Component));
CellVerticalSplit.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.CellVerticalSplit = CellVerticalSplit;


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var DropDownMenu_1 = __webpack_require__(1051);
var MenuItem_1 = __webpack_require__(385);
var l10n_1 = __webpack_require__(18);
var DEFAULT = 'default';
var CKEditorFontSizeMenu = (function (_super) {
    tslib_1.__extends(CKEditorFontSizeMenu, _super);
    function CKEditorFontSizeMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectionChange = function (event) {
            var path = event.data.path;
            var matchingFontSize = _this.getMatchingFontSize(path);
            if (_this.state.fontSize !== matchingFontSize) {
                var newState = {};
                newState.fontSize = matchingFontSize;
                _this.setState(newState);
            }
        };
        _this.onChange = function (event, index, fontSize) {
            // prevent ghost click events on touch devices
            event.preventDefault();
            var ckEditor = _this.props.ckEditor;
            ckEditor.focus();
            ckEditor.fire('saveSnapshot');
            if (fontSize !== DEFAULT) {
                if (_this.state.fontSize !== fontSize) {
                    ckEditor.applyStyle(_this.styles[fontSize]);
                }
                else {
                    ckEditor.removeStyle(_this.styles[_this.state.fontSize]);
                }
            }
            else {
                try {
                    ckEditor.removeStyle(_this.styles[_this.state.fontSize]);
                }
                catch (e) {
                    // `removeStyle()` will throw an exception if there are no styles to be removed.
                    // We don't care about that, though.
                }
            }
            ckEditor.fire('saveSnapshot');
        };
        var ckEditor = _this.props.ckEditor;
        _this.buildStyles();
        var startElement = ckEditor.getSelection().getStartElement();
        var path = ckEditor.elementPath(startElement);
        var matchingFontSize = _this.getMatchingFontSize(path);
        _this.state = { fontSize: matchingFontSize };
        return _this;
    }
    CKEditorFontSizeMenu.prototype.componentDidMount = function () {
        this.props.ckEditor.on('selectionChange', this.onSelectionChange);
    };
    CKEditorFontSizeMenu.prototype.componentWillUnmount = function () {
        this.props.ckEditor.removeListener('selectionChange', this.onSelectionChange);
    };
    CKEditorFontSizeMenu.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement(DropDownMenu_1.default, { value: this.state.fontSize, 
            // XXX not using onChange because it may be triggered async, outside of event loop
            // and touch devices don't like this and will not focus ckEditor
            // using onTouchTap on MenuItem instead
            // onChange={this.onChange}
            style: styles.root, "data-test-id": "text-module-font-size-menu" },
            React.createElement(MenuItem_1.default, { style: styles.menu, value: DEFAULT, primaryText: l10n_1.default('module.text.fontSize.default'), key: DEFAULT }),
            this.fontSizes.map(function (fontSize, index) {
                return React.createElement(MenuItem_1.default, { style: styles.menu, value: fontSize, primaryText: fontSize, key: index, onTouchTap: function (e) { _this.onChange(e, index, fontSize); } });
            })));
    };
    CKEditorFontSizeMenu.prototype.buildStyles = function () {
        var entries = CKEDITOR.config.fontSize_sizes;
        var parts = entries.split(';');
        this.styles = {};
        this.fontSizes = [];
        for (var index = 0; index < parts.length; ++index) {
            var twoParts = parts[index];
            if (twoParts) {
                var _a = twoParts.split('/'), name_1 = _a[0], size = _a[1];
                var style = new CKEDITOR.style(CKEDITOR.config.fontSize_style, { size: size });
                style._.definition.name = name_1;
                this.styles[name_1] = style;
                this.fontSizes.push(name_1);
            }
        }
    };
    CKEditorFontSizeMenu.prototype.getMatchingFontSize = function (path) {
        var elements = path.elements;
        for (var index = 0; index < elements.length; ++index) {
            var element = elements[index];
            for (var name_2 in this.styles) {
                if (this.styles.hasOwnProperty(name_2)) {
                    if (this.styles[name_2].checkElementMatch(element, true)) {
                        return name_2;
                    }
                }
            }
        }
        return DEFAULT;
    };
    CKEditorFontSizeMenu.prototype.getStyles = function () {
        return {
            root: {
                width: 140,
                float: 'left',
                overflow: 'hidden'
            },
            menu: {
                width: 113
            }
        };
    };
    return CKEditorFontSizeMenu;
}(React.Component));
exports.default = CKEditorFontSizeMenu;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.DropDownMenu = undefined;

var _DropDownMenu2 = __webpack_require__(1052);

var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);

var _MenuItem2 = __webpack_require__(386);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDownMenu = _DropDownMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _DropDownMenu3.default;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _arrowDropDown = __webpack_require__(509);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _Menu = __webpack_require__(431);

var _Menu2 = _interopRequireDefault(_Menu);

var _ClearFix = __webpack_require__(1053);

var _ClearFix2 = _interopRequireDefault(_ClearFix);

var _Popover = __webpack_require__(387);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(1055);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var anchorOrigin = {
  vertical: 'top',
  horizontal: 'left'
};

function getStyles(props, context) {
  var disabled = props.disabled;

  var spacing = context.muiTheme.baseTheme.spacing;
  var palette = context.muiTheme.baseTheme.palette;
  var accentColor = context.muiTheme.dropDownMenu.accentColor;
  return {
    control: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      height: '100%',
      position: 'relative',
      width: '100%'
    },
    icon: {
      fill: accentColor,
      position: 'absolute',
      right: spacing.desktopGutterLess,
      top: (spacing.desktopToolbarHeight - 24) / 2
    },
    label: {
      color: disabled ? palette.disabledColor : palette.textColor,
      lineHeight: spacing.desktopToolbarHeight + 'px',
      opacity: 1,
      position: 'relative',
      paddingLeft: spacing.desktopGutter,
      paddingRight: spacing.iconSize + spacing.desktopGutterLess + spacing.desktopGutterMini,
      top: 0
    },
    labelWhenOpen: {
      opacity: 0,
      top: spacing.desktopToolbarHeight / 8
    },
    root: {
      display: 'inline-block',
      fontSize: spacing.desktopDropDownMenuFontSize,
      height: spacing.desktopSubheaderHeight,
      fontFamily: context.muiTheme.baseTheme.fontFamily,
      outline: 'none',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },
    rootWhenOpen: {
      opacity: 1
    },
    underline: {
      borderTop: 'solid 1px ' + accentColor,
      bottom: 1,
      left: 0,
      margin: '-1px ' + spacing.desktopGutter + 'px',
      right: 0,
      position: 'absolute'
    }
  };
}

var DropDownMenu = function (_Component) {
  _inherits(DropDownMenu, _Component);

  function DropDownMenu() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, DropDownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DropDownMenu)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.handleTouchTapControl = function (event) {
      event.preventDefault();
      if (!_this.props.disabled) {
        _this.setState({
          open: !_this.state.open,
          anchorEl: _this.refs.root
        });
      }
    }, _this.handleRequestCloseMenu = function () {
      _this.setState({
        open: false,
        anchorEl: null
      });
    }, _this.handleItemTouchTap = function (event, child, index) {
      event.persist();
      _this.setState({
        open: false
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(event, index, child.props.value);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // The nested styles for drop-down-menu are modified by toolbar and possibly
  // other user components, so it will give full access to its js styles rather
  // than just the parent.


  _createClass(DropDownMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoWidth) {
        this.setWidth();
      }
      if (this.props.openImmediately) {
        // TODO: Temporary fix to make openImmediately work with popover.
        /* eslint-disable react/no-did-mount-set-state */
        setTimeout(function () {
          return _this2.setState({ open: true, anchorEl: _this2.refs.root });
        });
        setTimeout(function () {
          return _this2.setState({
            open: true,
            anchorEl: _this2.refs.root
          });
        }, 0);
        /* eslint-enable react/no-did-mount-set-state */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
    }

    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */

  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      var _this3 = this;

      var root = this.refs.root;

      root.focus = function () {
        if (!_this3.props.disabled) {
          _this3.setState({
            open: !_this3.state.open,
            anchorEl: _this3.refs.root
          });
        }
      };

      return root;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = this.refs.root;
      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
        el.style.width = 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var animated = _props.animated;
      var autoWidth = _props.autoWidth;
      var children = _props.children;
      var className = _props.className;
      var iconStyle = _props.iconStyle;
      var labelStyle = _props.labelStyle;
      var listStyle = _props.listStyle;
      var maxHeight = _props.maxHeight;
      var menuStyleProp = _props.menuStyle;
      var openImmediately = _props.openImmediately;
      var style = _props.style;
      var underlineStyle = _props.underlineStyle;
      var value = _props.value;

      var other = _objectWithoutProperties(_props, ['animated', 'autoWidth', 'children', 'className', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'openImmediately', 'style', 'underlineStyle', 'value']);

      var _state = this.state;
      var anchorEl = _state.anchorEl;
      var open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var displayValue = '';
      _react2.default.Children.forEach(children, function (child) {
        if (value === child.props.value) {
          // This will need to be improved (in case primaryText is a node)
          displayValue = child.props.label || child.props.primaryText;
        }
      });

      var menuStyle = void 0;
      if (anchorEl && !autoWidth) {
        menuStyle = (0, _simpleAssign2.default)({
          width: anchorEl.clientWidth
        }, menuStyleProp);
      } else {
        menuStyle = menuStyleProp;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, other, {
          ref: 'root',
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
        }),
        _react2.default.createElement(
          _ClearFix2.default,
          { style: styles.control, onTouchTap: this.handleTouchTapControl },
          _react2.default.createElement(
            'div',
            {
              style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle))
            },
            displayValue
          ),
          _react2.default.createElement(_arrowDropDown2.default, { style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle) }),
          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
        ),
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            anchorEl: anchorEl,
            animation: _PopoverAnimationVertical2.default,
            open: open,
            animated: animated,
            onRequestClose: this.handleRequestCloseMenu
          },
          _react2.default.createElement(
            _Menu2.default,
            {
              maxHeight: maxHeight,
              desktop: true,
              value: value,
              style: menuStyle,
              listStyle: listStyle,
              onItemTouchTap: this.handleItemTouchTap
            },
            children
          )
        )
      );
    }
  }]);

  return DropDownMenu;
}(_react.Component);

DropDownMenu.muiName = 'DropDownMenu';
DropDownMenu.propTypes = {
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _react.PropTypes.bool,
  /**
   * The width will automatically be set according to the items inside the menu.
   * To control this width in css instead, set this prop to `false`.
   */
  autoWidth: _react.PropTypes.bool,
  /**
   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
   * prop `label` that value will be used to render the representation of that
   * item within the field.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * Disables the menu.
   */
  disabled: _react.PropTypes.bool,
  /**
   * Overrides the styles of icon element.
   */
  iconStyle: _react.PropTypes.object,
  /**
   * Overrides the styles of label when the `DropDownMenu` is inactive.
   */
  labelStyle: _react.PropTypes.object,
  /**
   * The style object to use to override underlying list style.
   */
  listStyle: _react.PropTypes.object,
  /**
   * The maximum height of the `Menu` when it is displayed.
   */
  maxHeight: _react.PropTypes.number,
  /**
   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
   */
  menuStyle: _react.PropTypes.object,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {object} event TouchTap event targeting the menu item that was clicked.
   * @param {number} key The index of the clicked menu item in the `children` collection.
   * @param {any} payload The `value` prop of the clicked menu item.
   */
  onChange: _react.PropTypes.func,
  /**
   * Set to true to have the `DropDownMenu` automatically open on mount.
   */
  openImmediately: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  /**
   * Overrides the inline-styles of the underline.
   */
  underlineStyle: _react.PropTypes.object,
  /**
   * The value that is currently selected.
   */
  value: _react.PropTypes.any
};
DropDownMenu.defaultProps = {
  animated: true,
  autoWidth: true,
  disabled: false,
  openImmediately: false,
  maxHeight: 500
};
DropDownMenu.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = DropDownMenu;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _BeforeAfterWrapper = __webpack_require__(1054);

var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  before: {
    content: "' '",
    display: 'table'
  },
  after: {
    content: "' '",
    clear: 'both',
    display: 'table'
  }
};

var ClearFix = function ClearFix(_ref) {
  var style = _ref.style;
  var children = _ref.children;

  var other = _objectWithoutProperties(_ref, ['style', 'children']);

  return _react2.default.createElement(
    _BeforeAfterWrapper2.default,
    _extends({}, other, {
      beforeStyle: styles.before,
      afterStyle: styles.after,
      style: style
    }),
    children
  );
};

ClearFix.muiName = 'ClearFix';

ClearFix.propTypes = {
  children: _react.PropTypes.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};

exports.default = ClearFix;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  BeforeAfterWrapper
 *    An alternative for the ::before and ::after css pseudo-elements for
 *    components whose styles are defined in javascript instead of css.
 *
 *  Usage: For the element that we want to apply before and after elements to,
 *    wrap its children with BeforeAfterWrapper. For example:
 *
 *                                            <Paper>
 *  <Paper>                                     <div> // See notice
 *    <BeforeAfterWrapper>        renders         <div/> // before element
 *      [children of paper]       ------>         [children of paper]
 *    </BeforeAfterWrapper>                       <div/> // after element
 *  </Paper>                                    </div>
 *                                            </Paper>
 *
 *  Notice: Notice that this div bundles together our elements. If the element
 *    that we want to apply before and after elements is a HTML tag (i.e. a
 *    div, p, or button tag), we can avoid this extra nesting by passing using
 *    the BeforeAfterWrapper in place of said tag like so:
 *
 *  <p>
 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
 *      [children of p]          ------>         [children of p]
 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
 *  </p>
 *
 *  BeforeAfterWrapper features spread functionality. This means that we can
 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
 *
 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
 *  and afterElement have a defined style position.
 */

var styles = {
  box: {
    boxSizing: 'border-box'
  }
};

var BeforeAfterWrapper = function (_Component) {
  _inherits(BeforeAfterWrapper, _Component);

  function BeforeAfterWrapper() {
    _classCallCheck(this, BeforeAfterWrapper);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(BeforeAfterWrapper).apply(this, arguments));
  }

  _createClass(BeforeAfterWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var beforeStyle = _props.beforeStyle;
      var afterStyle = _props.afterStyle;
      var beforeElementType = _props.beforeElementType;
      var afterElementType = _props.afterElementType;
      var elementType = _props.elementType;

      var other = _objectWithoutProperties(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);

      var prepareStyles = this.context.muiTheme.prepareStyles;


      var beforeElement = void 0;
      var afterElement = void 0;

      if (beforeStyle) {
        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
          key: '::before'
        });
      }

      if (afterStyle) {
        afterElement = _react2.default.createElement(this.props.afterElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
          key: '::after'
        });
      }

      var children = [beforeElement, this.props.children, afterElement];

      var props = other;
      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));

      return _react2.default.createElement(this.props.elementType, props, children);
    }
  }]);

  return BeforeAfterWrapper;
}(_react.Component);

BeforeAfterWrapper.propTypes = {
  afterElementType: _react.PropTypes.string,
  afterStyle: _react.PropTypes.object,
  beforeElementType: _react.PropTypes.string,
  beforeStyle: _react.PropTypes.object,
  children: _react.PropTypes.node,
  elementType: _react.PropTypes.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
BeforeAfterWrapper.defaultProps = {
  beforeElementType: 'div',
  afterElementType: 'div',
  elementType: 'div'
};
BeforeAfterWrapper.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = BeforeAfterWrapper;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _Paper = __webpack_require__(391);

var _Paper2 = _interopRequireDefault(_Paper);

var _transitions = __webpack_require__(374);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes = __webpack_require__(390);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');

  return {
    root: {
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
      maxHeight: '100%'
    }
  };
}

var PopoverAnimationVertical = function (_Component) {
  _inherits(PopoverAnimationVertical, _Component);

  function PopoverAnimationVertical() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, PopoverAnimationVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PopoverAnimationVertical)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopoverAnimationVertical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var className = _props.className;
      var style = _props.style;
      var zDepth = _props.zDepth;


      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        this.props.children
      );
    }
  }]);

  return PopoverAnimationVertical;
}(_react.Component);

PopoverAnimationVertical.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  open: _react.PropTypes.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object,
  targetOrigin: _propTypes2.default.origin,
  zDepth: _propTypes2.default.zDepth
};
PopoverAnimationVertical.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationVertical.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = PopoverAnimationVertical;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var DropDownMenu_1 = __webpack_require__(1051);
var MenuItem_1 = __webpack_require__(385);
var l10n_1 = __webpack_require__(18);
var CKEditorFormatMenu = (function (_super) {
    tslib_1.__extends(CKEditorFormatMenu, _super);
    function CKEditorFormatMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectionChange = function (event) {
            var path = event.data.path;
            var matchingFormat = _this.getMatchingFormat(path);
            if (_this.state.format !== matchingFormat) {
                var newState = {};
                newState.format = matchingFormat;
                _this.setState(newState);
            }
        };
        _this.onChange = function (event, index, format) {
            // prevent ghost click events on touch devices
            event.preventDefault();
            var ckEditor = _this.props.ckEditor;
            ckEditor.focus();
            ckEditor.fire('saveSnapshot');
            ckEditor.applyStyle(_this.styles[format]);
            ckEditor.fire('saveSnapshot');
        };
        var ckEditor = _this.props.ckEditor;
        _this.buildStyles(ckEditor);
        var startElement = ckEditor.getSelection().getStartElement();
        var path = ckEditor.elementPath(startElement);
        var matchingFormat = _this.getMatchingFormat(path);
        _this.state = { format: matchingFormat };
        return _this;
    }
    CKEditorFormatMenu.prototype.componentDidMount = function () {
        this.props.ckEditor.on('selectionChange', this.onSelectionChange);
    };
    CKEditorFormatMenu.prototype.componentWillUnmount = function () {
        this.props.ckEditor.removeListener('selectionChange', this.onSelectionChange);
    };
    CKEditorFormatMenu.prototype.render = function () {
        var _this = this;
        var styles = this.getStyles();
        return (React.createElement(DropDownMenu_1.default, { value: this.state.format, 
            // XXX not using onChange because it may be triggered async, outside of event loop
            // and touch devices don't like this and will not focus ckEditor
            // using onTouchTap on MenuItem instead
            // onChange={this.onChange}
            style: styles.root, "data-test-id": "text-module-heading-menu" }, this.formats.map(function (format, index) {
            return React.createElement(MenuItem_1.default, { value: format, primaryText: l10n_1.default("module.text.format." + format), key: index, onTouchTap: function (e) { _this.onChange(e, index, format); } });
        })));
    };
    CKEditorFormatMenu.prototype.buildStyles = function (ckEditor) {
        var entries = ckEditor.config.format_tags;
        var parts = entries.split(';');
        this.styles = {};
        this.formats = [];
        for (var index = 0; index < parts.length; ++index) {
            var tag = parts[index];
            var style = new CKEDITOR.style(ckEditor.config["format_" + tag]);
            style._.enterMode = ckEditor.config.enterMode;
            this.styles[tag] = style;
            this.formats.push(tag);
        }
    };
    CKEditorFormatMenu.prototype.getMatchingFormat = function (path) {
        var matchingFormat = this.formats[0];
        for (var tag in this.styles) {
            if (this.styles.hasOwnProperty(tag)) {
                if (this.styles[tag].checkActive(path)) {
                    matchingFormat = tag;
                }
            }
        }
        return matchingFormat;
    };
    CKEditorFormatMenu.prototype.getStyles = function () {
        return {
            root: {
                width: 200,
                float: 'left',
                overflow: 'hidden'
            }
        };
    };
    return CKEditorFormatMenu;
}(React.Component));
exports.default = CKEditorFormatMenu;


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ColorWheelIcon_1 = __webpack_require__(998);
var ColorPickerDropdown_1 = __webpack_require__(1001);
var RecentColorsLsManager_1 = __webpack_require__(1008);
var ColorPicker_1 = __webpack_require__(1002);
var l10n_1 = __webpack_require__(18);
var ColorPickerCKEditorDropdown = (function (_super) {
    tslib_1.__extends(ColorPickerCKEditorDropdown, _super);
    function ColorPickerCKEditorDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getInitialMode = function () {
            var selection = _this.props.ckEditor.getSelection();
            var selectedElement = selection.getStartElement();
            // We decided to settle for the "easy" approach.
            // This does not cover all cases, but it works for the most.
            if (!selectedElement.$.style.color) {
                return ColorPicker_1.PREDEFINED_MODE;
            }
            return null;
        };
        _this.getSelectionColor = function () {
            var selection = _this.props.ckEditor.getSelection();
            var selectedElement = selection.getStartElement();
            var elementColor = selectedElement.getComputedStyle('color');
            return CKEDITOR.tools.convertRgbToHex(elementColor).split('#')[1].toUpperCase();
        };
        _this.onColorChange = function (hexColor, isDefaultColor) {
            if (!isDefaultColor) {
                RecentColorsLsManager_1.RecentColorsLsManager.saveColor(hexColor);
            }
            _this.props.onChange(isDefaultColor ? void 0 : hexColor);
        };
        return _this;
    }
    ColorPickerCKEditorDropdown.prototype.render = function () {
        var hexColor = this.getSelectionColor();
        return (React.createElement(ColorPickerDropdown_1.ColorPickerDropdown, { Icon: React.createElement(ColorWheelIcon_1.ColorWheelIcon, null), text: l10n_1.default('module.text.color'), hexColor: hexColor, initialMode: this.getInitialMode(), recentColors: RecentColorsLsManager_1.RecentColorsLsManager.getRecentColors(), onChange: this.onColorChange }));
    };
    return ColorPickerCKEditorDropdown;
}(React.Component));
exports.ColorPickerCKEditorDropdown = ColorPickerCKEditorDropdown;


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var globalEvents = __webpack_require__(500);
var OpenGeneralStyles = (function (_super) {
    tslib_1.__extends(OpenGeneralStyles, _super);
    function OpenGeneralStyles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTouchTap = function () {
            // open theming
            var styleButton = document.getElementById('cc-sa-item-style');
            if (!styleButton) {
                return;
            }
            styleButton.click();
            // if it's coming from a module inside section, close the section editing mode
            var section = _this.props.module.getParentSection();
            if (section) {
                section.onClickOutside();
            }
            // try to change the tab to be directly on the current font theme editing view
            globalEvents.one('diy-editor-theming-styleWindowLoaded', function () {
                // click the font tab. just changing it via scope.nav.changeTab does not update the top tabs as well
                var fontTab = document.querySelector('a[data-identifier=typography]');
                if (fontTab) {
                    fontTab.click();
                }
                // change the view to the editing view of the main font set
                if (diy.editor && diy.editor.theming) {
                    diy.editor.theming.run(function (scope) {
                        scope.nav.changeTab('typography', 'more');
                    });
                }
            });
        };
        return _this;
    }
    OpenGeneralStyles.prototype.render = function () {
        var Icon = this.props.Icon;
        return (React.createElement(IconTextButton_1.default, { Icon: React.createElement(Icon, null), text: this.props.label, onTouchTap: this.handleTouchTap, useAlternativeColors: true, key: this.props.key }));
    };
    return OpenGeneralStyles;
}(React.Component));
exports.default = OpenGeneralStyles;


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var TextFormat = (function (_super) {
    tslib_1.__extends(TextFormat, _super);
    function TextFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextFormat.prototype.render = function () {
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { d: "M11,18a1,1,0,1,1-1,1A1,1,0,0,1,11,18Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,15,18Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,19,18Zm7-2M13,12H9l2-6Zm1,2,1,2h2L12,4H10L4,18H6l2-4h6Z" })));
        /* tslint:enable:max-line-length */
    };
    return TextFormat;
}(React.Component));
exports.TextFormat = TextFormat;


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var TextWebView = (function (_super) {
    tslib_1.__extends(TextWebView, _super);
    function TextWebView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextWebView.prototype.componentDidMount = function () {
        this.props.module.initCKEditor(this.textElement);
    };
    TextWebView.prototype.render = function () {
        var _this = this;
        var text = this.props.payload.text === ''
            ? '<< ' + l10n_1.default('module.text.newtext') + ' >>'
            :
                this.props.payload.text;
        /* TODO: Handle links replacement. */
        return (React.createElement("div", { ref: function (textElement) { return _this.textElement = textElement; }, dangerouslySetInnerHTML: { __html: text } }));
    };
    return TextWebView;
}(React.Component));
exports.default = TextWebView;


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var ModulWithRedux_1 = __webpack_require__(493);
var EditView_1 = __webpack_require__(1062);
var InPlaceEditView_1 = __webpack_require__(1063);
var WebView_1 = __webpack_require__(1066);
var ModulSpacer = (function (_super) {
    tslib_1.__extends(ModulSpacer, _super);
    function ModulSpacer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helpArticleId = "spacer";
        return _this;
    }
    ModulSpacer.prototype.getActionBarTabs = function () {
        return [
            { label: this.textLabel, content: this.getConnectedComponent(EditView_1.default) }
        ];
    };
    ModulSpacer.prototype.getInPlaceEditViewClass = function () {
        return InPlaceEditView_1.default;
    };
    ModulSpacer.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    return ModulSpacer;
}(ModulWithRedux_1.default));
ModulSpacer.MAX_HEIGHT = 400;
ModulSpacer.MIN_HEIGHT = 10;
exports.default = ModulSpacer;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ModulSpacer_1 = __webpack_require__(1061);
var l10n_1 = __webpack_require__(18);
var autoprefixer_1 = __webpack_require__(438);
var Slider_1 = __webpack_require__(518);
var SpacerEditView = (function (_super) {
    tslib_1.__extends(SpacerEditView, _super);
    function SpacerEditView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHeightChange = function (e, value) {
            _this.setHeight(value);
        };
        return _this;
    }
    SpacerEditView.prototype.getStyles = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                display: "flex",
                marginRight: 12,
                marginLeft: 12
            }),
            left: autoprefixer_1.autoprefixer({
                marginRight: 12,
                alignSelf: "center",
                fontSize: 12
            }),
            right: autoprefixer_1.autoprefixer({
                marginLeft: 12,
                flexGrow: 1,
                maxWidth: 812
            }),
            slider: {
                maxWidth: 800,
                marginBottom: -24,
                marginTop: 16
            },
            spacing: autoprefixer_1.autoprefixer({
                alignSelf: "center",
                marginLeft: 12,
                fontSize: 12
            })
        };
    };
    SpacerEditView.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            React.createElement("div", { style: styles.left }, l10n_1.default("module.spacer.heightLabel")),
            React.createElement("div", { style: styles.right },
                React.createElement(Slider_1.default, { "data-test-id": "module-spacer-slider", style: styles.slider, defaultValue: this.props.payload.heightInPixels, onChange: this.onHeightChange, name: "spacer", value: this.props.payload.heightInPixels, min: ModulSpacer_1.default.MIN_HEIGHT, max: ModulSpacer_1.default.MAX_HEIGHT, step: 1 })),
            React.createElement("div", { style: styles.spacing },
                this.props.payload.heightInPixels,
                " px")));
    };
    SpacerEditView.prototype.setHeight = function (value) {
        value = Math.max(ModulSpacer_1.default.MIN_HEIGHT, Math.min(ModulSpacer_1.default.MAX_HEIGHT, value));
        this.props.onDataChange({
            heightInPixels: value
        });
    };
    return SpacerEditView;
}(React.Component));
exports.default = SpacerEditView;


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ResizeControls_1 = __webpack_require__(1064);
var SyncPosition_1 = __webpack_require__(440);
var ModuleOverlay_1 = __webpack_require__(236);
var SpacerInPlaceEditView = (function (_super) {
    tslib_1.__extends(SpacerInPlaceEditView, _super);
    function SpacerInPlaceEditView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onResize = function (dx, dy, pos) {
            _this.setHeight(Math.round(_this.props.payload.heightInPixels + dy));
        };
        return _this;
    }
    SpacerInPlaceEditView.prototype.render = function () {
        var _this = this;
        var modulEl = document.getElementById("modul_" + this.props.moduleId);
        return (React.createElement(SyncPosition_1.default, { element: modulEl, position: "absolute" }, function (box) {
            return (React.createElement(ResizeControls_1.default, { dataTestId: "module-spacer-resize", width: box.width, height: box.height, top: box.top, left: box.left, position: "absolute", zIndex: ModuleOverlay_1.default.ZINDEX + 1, resizeControls: ["S"], onResize: _this.onResize, pointerEventsNone: false }));
        }));
    };
    SpacerInPlaceEditView.prototype.setHeight = function (value) {
        value = Math.max(SpacerInPlaceEditView.MIN_HEIGHT, Math.min(SpacerInPlaceEditView.MAX_HEIGHT, value));
        this.props.onDataChange({
            heightInPixels: value
        });
    };
    return SpacerInPlaceEditView;
}(React.Component));
SpacerInPlaceEditView.MAX_HEIGHT = 400;
SpacerInPlaceEditView.MIN_HEIGHT = 10;
exports.default = SpacerInPlaceEditView;


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ResizeHandle_1 = __webpack_require__(1065);
var ResizeControls = (function (_super) {
    tslib_1.__extends(ResizeControls, _super);
    function ResizeControls() {
        var _this = _super.call(this) || this;
        _this.onDrag = function (dx, dy, pos) {
            _this.props.onResize(dx, dy, pos);
        };
        _this.onDragStart = function () {
            if (_this.props.onDragStart) {
                _this.props.onDragStart();
            }
            _this.setState({ dragging: true });
        };
        _this.onDragEnd = function () {
            if (_this.props.onDragEnd) {
                _this.props.onDragEnd();
            }
            _this.setState({ dragging: false });
        };
        _this.state = { dragging: false };
        return _this;
    }
    ResizeControls.prototype.componentDidMount = function () {
        this.root.style.opacity = "";
    };
    ResizeControls.prototype.render = function () {
        var _this = this;
        var d = this.props.outline / 2;
        var smallWidth = this.props.width < 70;
        var smallHeight = this.props.height < 70;
        var controls = this.props.resizeControls;
        var handlers = {
            onDrag: this.onDrag,
            onDragStart: this.onDragStart,
            onDragEnd: this.onDragEnd
        };
        var style = this.getStyle();
        return (React.createElement("div", { style: style.root, ref: function (ref) { return _this.root = ref; }, "data-test-id": this.props.dataTestId },
            this.state.dragging ?
                React.createElement("div", { style: style.hint },
                    Math.round(this.props.width),
                    " \u00D7 ",
                    Math.round(this.props.height))
                : null,
            !smallWidth && controls.indexOf("S") >= 0 ?
                React.createElement(ResizeHandle_1.default, tslib_1.__assign({ isRound: true, pos: "S", left: "50%", bottom: -d }, handlers))
                : null,
            controls.indexOf("SE") >= 0 ?
                React.createElement(ResizeHandle_1.default, tslib_1.__assign({ isRound: false, pos: "SE", right: -d, bottom: -d }, handlers))
                : null,
            !smallHeight && controls.indexOf("E") >= 0 ?
                React.createElement(ResizeHandle_1.default, tslib_1.__assign({ isRound: true, pos: "E", right: -d, top: "50%" }, handlers))
                : null,
            !smallHeight && controls.indexOf("W") >= 0 ?
                React.createElement(ResizeHandle_1.default, tslib_1.__assign({ isRound: true, pos: "W", left: -d, top: "50%" }, handlers))
                : null,
            controls.indexOf("SW") >= 0 ?
                React.createElement(ResizeHandle_1.default, tslib_1.__assign({ isRound: false, pos: "SW", left: -d, bottom: -d }, handlers))
                : null));
    };
    ResizeControls.prototype.getStyle = function () {
        var outline = this.props.outline;
        return {
            root: {
                boxSizing: 'border-box',
                border: outline + "px solid rgba(133, 150, 243, 0.6)",
                height: Math.floor(this.props.height),
                left: this.props.left,
                pointerEvents: this.props.pointerEventsNone ? 'none' : null,
                position: this.props.position,
                top: this.props.top,
                transition: 'opacity 0.2s ease-out',
                opacity: 0,
                width: Math.floor(this.props.width),
                zIndex: this.props.zIndex
            },
            hint: {
                transform: "translateY(calc(-100% - " + outline + "px)) translateX(-" + outline + "px)",
                background: 'rgb(33, 150, 243)',
                color: 'white',
                display: 'inline-block',
                padding: '0 5px',
                fontFamily: 'Open Sans',
                fontSize: '14px',
                whiteSpace: 'nowrap'
            }
        };
    };
    return ResizeControls;
}(React.Component));
ResizeControls.defaultProps = {
    pointerEventsNone: true,
    outline: 0
};
exports.default = ResizeControls;


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ResizeHandle = (function (_super) {
    tslib_1.__extends(ResizeHandle, _super);
    function ResizeHandle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMouseDown = function (e) {
            e.preventDefault();
            _this.addDragEvents();
            _this.startDrag();
        };
        _this.handleTouchStart = function (e) {
            e.preventDefault();
            _this.addTouchDragEvents();
            _this.startDrag();
        };
        _this.handleDrag = function (e) {
            e.preventDefault();
            _this.drag(e.clientX, e.clientY);
        };
        _this.handleDragEnd = function () {
            _this.removeDragEvents();
            _this.stopDrag();
        };
        _this.handleTouchDragEnd = function () {
            _this.removeTouchDragEvents();
            _this.stopDrag();
        };
        _this.handleTouchDrag = function (e) {
            _this.drag(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
        };
        _this.handleMouseOver = function () {
            if (!_this.state.dragging) {
                _this.setActiveState(true);
            }
        };
        _this.handleMouseOut = function () {
            if (!_this.state.dragging) {
                _this.setActiveState(false);
            }
        };
        return _this;
    }
    ResizeHandle.prototype.componentWillMount = function () {
        this.setActiveState(false);
    };
    ResizeHandle.prototype.componentDidMount = function () {
        var _this = this;
        var delay = 0;
        switch (this.props.pos.toLowerCase()) {
            case "se":
                delay = 100;
                break;
            case "sw":
                delay = 300;
                break;
            case "s":
                delay = 500;
                break;
            case "e":
                delay = 700;
                break;
            case "w":
                delay = 900;
                break;
            default:
                delay = 0;
                break;
        }
        setTimeout(function () {
            if (_this.handle && _this.handle.style) {
                _this.handle.style.opacity = "";
            }
        }, delay);
    };
    ResizeHandle.prototype.componentWillUnmount = function () {
        this.removeDragEvents();
        this.removeTouchDragEvents();
        if (this.dragRaf) {
            cancelAnimationFrame(this.dragRaf);
        }
    };
    ResizeHandle.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-test-id": "resize-handle-" + this.props.pos, ref: function (ref) { return _this.handle = ref; }, style: this.getStyle(), onMouseDown: this.handleMouseDown, onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut, onTouchStart: this.handleTouchStart }));
    };
    ResizeHandle.prototype.drag = function (x, y) {
        var _this = this;
        if (this.dragRaf) {
            cancelAnimationFrame(this.dragRaf);
        }
        this.dragRaf = requestAnimationFrame(function () {
            var box = _this.handle.getBoundingClientRect();
            _this.props.onDrag(x - (box.left + box.width / 2), y - (box.top + box.height / 2), _this.props.pos);
            _this.dragRaf = null;
        });
    };
    ResizeHandle.prototype.startDrag = function () {
        this.setState({
            dragging: true,
            active: true
        });
        if (this.props.onDragStart) {
            this.props.onDragStart();
        }
    };
    ResizeHandle.prototype.stopDrag = function () {
        this.setState({
            dragging: false,
            active: false
        });
        if (this.props.onDragEnd) {
            this.props.onDragEnd();
        }
    };
    ResizeHandle.prototype.addDragEvents = function () {
        document.addEventListener('mousemove', this.handleDrag, false);
        document.addEventListener('mouseup', this.handleDragEnd, false);
    };
    ResizeHandle.prototype.addTouchDragEvents = function () {
        document.addEventListener('touchmove', this.handleTouchDrag, false);
        document.addEventListener('touchend', this.handleTouchDragEnd, false);
        document.addEventListener('touchup', this.handleTouchDragEnd, false);
        document.addEventListener('touchcancel', this.handleTouchDragEnd, false);
    };
    ResizeHandle.prototype.removeDragEvents = function () {
        document.removeEventListener('mousemove', this.handleDrag, false);
        document.removeEventListener('mouseup', this.handleDragEnd, false);
    };
    ResizeHandle.prototype.removeTouchDragEvents = function () {
        document.removeEventListener('touchmove', this.handleTouchDrag, false);
        document.removeEventListener('touchend', this.handleTouchDragEnd, false);
        document.removeEventListener('touchup', this.handleTouchDragEnd, false);
        document.removeEventListener('touchcancel', this.handleTouchDragEnd, false);
    };
    ResizeHandle.prototype.setActiveState = function (status) {
        var newState = {};
        newState.active = status;
        this.setState(newState);
    };
    ResizeHandle.prototype.getStyle = function () {
        var translateX = this.props.left === undefined ? "50%" : "-50%";
        var translateY = this.props.top === undefined ? "50%" : "-50%";
        var pos = this.props.pos.toLowerCase();
        var cursor = "";
        switch (pos) {
            case "w":
                cursor = "ew-resize";
                break;
            case "sw":
                cursor = "nesw-resize";
                break;
            case "s":
                cursor = "ns-resize";
                break;
            case "se":
                cursor = "nwse-resize";
                break;
            case "e":
                cursor = "ew-resize";
                break;
            default:
                cursor = "auto";
                break;
        }
        return {
            background: "white",
            backgroundClip: "padding-box",
            borderStyle: "solid",
            borderWidth: this.state.active ? "8px" : "3px",
            borderColor: this.state.active ? "rgba(33, 150, 243, 0.6)" : "#2196f3",
            borderRadius: this.props.isRound ? "50%" : 0,
            cursor: this.state.active ? cursor : "auto",
            height: 18,
            width: 18,
            pointerEvents: "all",
            position: "absolute",
            transform: "translate(" + translateX + ", " + translateY + ")",
            transition: "border 0.15s ease-in, opacity 0.3s ease-out",
            zIndex: 100055,
            top: this.props.top,
            left: this.props.left,
            bottom: this.props.bottom,
            right: this.props.right,
            opacity: 0
        };
    };
    return ResizeHandle;
}(React.Component));
exports.default = ResizeHandle;


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SpacerWebView = (function (_super) {
    tslib_1.__extends(SpacerWebView, _super);
    function SpacerWebView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpacerWebView.prototype.render = function () {
        return (React.createElement("div", { className: "the-spacer id" + this.props.moduleId, style: { height: this.props.payload.heightInPixels } }));
    };
    return SpacerWebView;
}(React.Component));
exports.default = SpacerWebView;


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var l10n_1 = __webpack_require__(18);
var AppRegistry_1 = __webpack_require__(190);
var diyLightTheme = __webpack_require__(241);
var ModulWithImage_1 = __webpack_require__(1068);
var ModuleInlineEditor_1 = __webpack_require__(986);
var index_1 = __webpack_require__(536);
var EditViewText_1 = __webpack_require__(1101);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulTextWithImage = (function (_super) {
    tslib_1.__extends(ModulTextWithImage, _super);
    function ModulTextWithImage(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.helpArticleId = 'textwithimage';
        _this.inlineEditor = null;
        _this.hasText = true;
        _this.ckEditorPromise = new Promise(function (resolve, reject) {
            _this.ckEditorPromiseResolve = resolve;
        });
        return _this;
    }
    ModulTextWithImage.prototype.getCKEditorPromise = function () {
        return this.ckEditorPromise;
    };
    ModulTextWithImage.prototype.loadData = function (data) {
        this.data = data;
        this.data.moduleText = this.getContentElement().querySelector('.textwrapper').innerHTML;
    };
    /**
     * @override
     * purely for typing purposes
     */
    ModulTextWithImage.prototype.getData = function () {
        return this.data;
    };
    /** @override */
    ModulTextWithImage.prototype.getActionBarTabs = function () {
        var tabs = _super.prototype.getActionBarTabs.call(this);
        tabs.push({
            label: l10n_1.default('module.text.tabs.basic'),
            content: this.getConnectedComponent(EditViewText_1.EditViewTextBasics)
        }, {
            label: l10n_1.default('module.text.tabs.advanced'),
            content: this.getConnectedComponent(EditViewText_1.EditViewTextFormat)
        });
        return tabs;
    };
    ModulTextWithImage.prototype.onOpenTracking = function () {
        if (!this.getIsNew()) {
            var self_1 = this;
            $(document).on('diy-text-editor-clicked', function (ev, dat) {
                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Tried',
                    'name': 'Content',
                    'otherData': self_1.moduleType
                });
            });
        }
    };
    ModulTextWithImage.prototype.initCKEditor = function (element) {
        var _this = this;
        this.inlineEditor = new ModuleInlineEditor_1.default(this, element);
        this.inlineEditor.startEditing({
            'diy-moduleType': this.moduleType,
            // this setting is primary used for setting the z-index
            // of CKEditor dialogs, and these should be the same as
            // standard Material UI dialogs zIndex
            baseFloatZIndex: diyLightTheme.zIndex.dialog,
            allowedContent: !this.getData().supports.textSanitizeHtml,
            toolbarStartupExpanded: true,
            sharedSpaces: {
                top: 'inline-editor-toolbar-' + this.moduleId
            },
            toolbar: 'ImageWithText',
            toolbar_ImageWithText: this.getCkeditorToolbarConfig(),
            format_tags: 'p;h1;h2;pre',
            pasteFromWordRemoveFontStyles: false,
            pasteFromWordRemoveStyles: false,
            hideToolbar: true
        });
        var switchToText = function () {
            var store = getStore();
            store.dispatch(index_1.setCurrentTab({ nextTab: 3, currentTabWhitelist: [0, 1, 2] }));
        };
        this.inlineEditor.editor.on('instanceReady', function () {
            _this.ckEditorPromiseResolve(_this.inlineEditor.getEditor());
            var store = getStore();
            _this.inlineEditor.editor.getCommand('undo').on('state', function () {
                store.dispatch(index_1.setUndoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
            _this.inlineEditor.editor.getCommand('redo').on('state', function () {
                store.dispatch(index_1.setRedoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
            _this.inlineEditor.editor.on('destroy', function () {
                element.removeEventListener('mousedown', switchToText);
                element.removeEventListener('touchend', switchToText);
            });
            element.addEventListener('mousedown', switchToText);
            element.addEventListener('touchend', switchToText);
        });
    };
    ModulTextWithImage.prototype.hide = function () {
        if (this.inlineEditor) {
            this.inlineEditor.stopEditing();
        }
        _super.prototype.hide.call(this);
    };
    ModulTextWithImage.prototype.runSaveAction = function () {
        if (!this.getIsNew()) {
            /**
             * Make some SiteCatalyst tracking
             */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                'condition': 'Applied',
                'name': 'Content',
                'otherData': this.moduleType
            });
        }
        _super.prototype.runSaveAction.call(this);
    };
    /**
     * @override
     */
    ModulTextWithImage.prototype.getSaveData = function () {
        var data = _super.prototype.getSaveData.call(this);
        return Object.assign(data, {
            text: this.inlineEditor.getHtmlData()
        });
    };
    /**
     * @override
     */
    ModulTextWithImage.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        this.inlineEditor.stopEditing();
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
    };
    ModulTextWithImage.prototype.getCkeditorToolbarConfig = function () {
        return [
            ['FontSize'],
            ['Undo', 'Redo'],
            ['Format'],
            ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['DiyLink', 'DiyUnlink'],
            ['NumberedList', 'BulletedList'],
            '/',
            ['Outdent', 'Indent'],
            ['StyleButton', 'DiyTextColor'],
            ['PasteText', 'RemoveFormat'],
            ['Sourcedialog', 'PasteFromWord', 'SelectAll'],
            // XXX Including support for table, even if no controls in Action Bar
            // because users wants to keep copy-pasted tables, and CKEditor should
            // not strip them away
            '/',
            ['Table'], ['TableMixed'],
            ['TableInsertRowBefore', 'TableInsertRowAfter', 'TableDeleteRow'],
            ['TableInsertColumnBefore', 'TableInsertColumnAfter', 'TableDeleteColumn'],
            ['TableSplitVertically', 'TableSplitHorizontally'],
            ['TableMergeRight', 'TableMergeDown', 'TableMerge']
        ];
    };
    return ModulTextWithImage;
}(ModulWithImage_1.default));
exports.default = ModulTextWithImage;


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var l10n_1 = __webpack_require__(18);
var index_1 = __webpack_require__(1069);
var DefaultPayload_1 = __webpack_require__(1073);
var ModulWithRedux_1 = __webpack_require__(493);
var ModulMatrix_1 = __webpack_require__(987);
var WebView_1 = __webpack_require__(1075);
var EditView_1 = __webpack_require__(1076);
var EditViewCrop_1 = __webpack_require__(1094);
var EditViewCaptions_1 = __webpack_require__(1095);
var InPlaceEditView_1 = __webpack_require__(1096);
var load_1 = __webpack_require__(1078);
var cache_1 = __webpack_require__(1077);
var util_1 = __webpack_require__(1079);
var index_2 = __webpack_require__(494);
var AppRegistry_1 = __webpack_require__(190);
var Model_1 = __webpack_require__(1074);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
/**
 * Base class for modules with images
 */
var ModulWithImage = (function (_super) {
    tslib_1.__extends(ModulWithImage, _super);
    function ModulWithImage(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.CONFIG_MIN_WIDTH = 900;
        _this.hasText = false;
        _this.hasSpotlightBorder = false;
        _this.autoOpenImageSelector = true;
        _this.saveTimeout = 5 * 60000;
        _this.getIieSourceImage = function () {
            return cache_1.getCachedImage(util_1.getIieSourceImageUrl(_this.data), util_1.getIieSourceImageKey(_this.data) + _this.moduleId);
        };
        _this.onWindowResize = function () {
            // on window resize visual size of the image may change because of the
            // flexible layout, these will be recalculated after a delay
            if (!_this.data.imageAnimated) {
                _this.generateImage()
                    .then(function (result) {
                    var partialPayload = {
                        imageUrl: result.imageDataURL,
                        visualImageHeight: null,
                        visualImageWidth: null
                    };
                    getStore().dispatch(index_2.update({
                        moduleId: _this.moduleId,
                        partialPayload: partialPayload
                    }));
                    setTimeout(_this.updateVisualImageSize, 100);
                });
            }
        };
        _this.updateVisualImageSize = function () {
            var imageEl = _this.getImageElement();
            getStore().dispatch(index_2.update({
                moduleId: _this.moduleId,
                partialPayload: {
                    visualImageHeight: imageEl.offsetHeight,
                    visualImageWidth: imageEl.offsetWidth
                }
            }));
        };
        _this.initialDataString = JSON.stringify(_this.data);
        return _this;
    }
    ModulWithImage.prototype.getActionBarTabs = function () {
        return [
            { label: l10n_1.default('module.image.tabs.basic'), content: this.getConnectedComponent(EditView_1.default) },
            { label: l10n_1.default('module.image.tabs.crop'), content: this.getConnectedComponent(EditViewCrop_1.default) },
            { label: l10n_1.default('module.image.tabs.caption'), content: this.getConnectedComponent(EditViewCaptions_1.default) }
        ];
    };
    ModulWithImage.prototype.getInPlaceEditViewClass = function () {
        return InPlaceEditView_1.default;
    };
    ModulWithImage.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    /**
     * @override
     * purely for typing purposes
     */
    ModulWithImage.prototype.getData = function () {
        return this.data;
    };
    // TODO: move to modul.js
    ModulWithImage.prototype.inSidebar = function () {
        return this.modul.closest(".diywebSecondary").length > 0;
    };
    ModulWithImage.prototype.open = function (openConfig) {
        var _this = this;
        if (!this.isNew) {
            $(document.body).trigger('ContentModuleOpened.BSA');
        }
        load_1.loadImage(this.getImageElement()).then(function (image) {
            // initialize visual image size
            _this.data.visualImageHeight = image.offsetHeight;
            _this.data.visualImageWidth = image.offsetWidth;
            // some predefined modules (like ones in matrix module)
            // have images fit by size but imageFit flag is wrongly
            // set to false, so we correct it here
            if (!_this.data.isFullwidth
                && Math.round(_this.getMaxWidth()) === image.offsetWidth) {
                _this.data.imageFit = true;
            }
        }).then(function () {
            _super.prototype.open.call(_this, openConfig);
            window.addEventListener('resize', _this.onWindowResize);
        });
        this.initialRegenerationData = {
            width: this.data.imageWidth,
            height: this.data.imageHeight,
            url: util_1.getIieSourceImageUrl(this.data),
            payload: Object.assign({}, DefaultPayload_1.default, this.data.iiePayload)
        };
    };
    ModulWithImage.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
        cache_1.clearCachedImage('transformedImageUrl' + this.moduleId);
        cache_1.clearCachedImage('origImageUrl' + this.moduleId);
        window.removeEventListener('resize', this.onWindowResize);
    };
    ModulWithImage.prototype.isCropped = function () {
        var data = this.data;
        var sourceAspect = util_1.getIieSourceImageWidth(data) / util_1.getIieSourceImageHeight(data);
        var cropAspect = data.imageWidth / data.imageHeight;
        if (data.imageAnimated || !data.iiePayload) {
            return false;
        }
        return Math.abs(sourceAspect - cropAspect) > 0.03 || data.iiePayload.zoom !== 1;
    };
    ModulWithImage.prototype.needsRegeneration = function (data) {
        var initialData = this.initialRegenerationData;
        var finalData = {
            width: data.imageWidth,
            height: data.imageHeight,
            url: util_1.getIieSourceImageUrl(data),
            payload: data.iiePayload
        };
        if (!initialData.payload || !finalData.payload) {
            return true;
        }
        return initialData.width !== finalData.width
            || initialData.height !== finalData.height
            || initialData.url !== finalData.url
            || initialData.payload.zoom !== finalData.payload.zoom
            || initialData.payload.cropXRatio !== finalData.payload.cropXRatio
            || initialData.payload.cropYRatio !== finalData.payload.cropYRatio;
    };
    ModulWithImage.prototype.getSaveData = function () {
        var data = _super.prototype.getSaveData.call(this);
        var cropped = this.isCropped();
        var payload = data.iiePayload || DefaultPayload_1.default;
        var sourceWidth = util_1.getIieSourceImageWidth(data);
        var sourceHeight = util_1.getIieSourceImageHeight(data);
        var width = Math.round(data.imageWidth);
        var height = Math.round(data.imageHeight);
        var model = new Model_1.default(payload, sourceWidth, sourceHeight, data.visualImageWidth, data.visualImageHeight, this.getMaxWidth());
        var absZoom = model.getAbsoluteZoom();
        return Object.assign(data, {
            iiePayload: JSON.stringify(payload),
            imageFit: data.imageFit ? 1 : 0,
            imageWidth: width,
            imageHeight: height,
            imageCrop: cropped ? {
                left: Math.round(model.getCropLeft() / absZoom),
                top: Math.round(model.getCropTop() / absZoom),
                width: Math.round(model.getCropWidth() / absZoom),
                height: Math.round(model.getCropHeight() / absZoom)
            } : '',
            needsRegeneration: this.needsRegeneration(data) ? 1 : 0
        });
    };
    ModulWithImage.prototype.save = function () {
        if (this.getIsNew() !== true && (this.initialDataString !== JSON.stringify(this.data))) {
            $(document.body).trigger('ContentModuleSaved.BSA');
        }
        _super.prototype.save.call(this);
    };
    /* @override */
    ModulWithImage.prototype.updateModulContent = function (html) {
        // We don't want html from server to update our webview
        // we render it ourselves
        // NO this._super(html);
    };
    ModulWithImage.prototype.getImageElement = function (imageId) {
        if (imageId) {
            return document.getElementById("image_" + imageId);
        }
        else {
            return this.getContent().querySelector("img");
        }
    };
    ModulWithImage.prototype.getContent = function () {
        return document.querySelector("#modul_" + this.moduleId + " .align-container");
    };
    ModulWithImage.prototype.getMaxWidth = function () {
        return parseFloat(getComputedStyle(this.getContentElement()).width);
    };
    ModulWithImage.prototype.generateImage = function () {
        var _this = this;
        return this.getIieSourceImage().then(function (image) {
            var data = _this.data;
            var fullResolution = false;
            var maxWidth = null;
            if (data.isFullwidth) {
                fullResolution = true;
                maxWidth = ModulWithImage.MAX_IMAGE_FULL_WIDTH;
            }
            else if (data.imageFit) {
                fullResolution = true;
                if (_this.getMatrixModuleParent() instanceof ModulMatrix_1.default) {
                    maxWidth = ModulWithImage.MAX_IMAGE_WIDTH_IN_MATRIX;
                }
                else {
                    maxWidth = ModulWithImage.MAX_IMAGE_WIDTH;
                }
            }
            var options = {
                sourceImage: image,
                fullResolution: fullResolution,
                cropWidth: data.visualImageWidth,
                cropHeight: data.visualImageHeight,
                payload: data.iiePayload,
                mediaType: data.imageMediaType,
                maxWidth: maxWidth
            };
            return index_1.default.generate(options);
        });
    };
    return ModulWithImage;
}(ModulWithRedux_1.default));
ModulWithImage.MAX_IMAGE_WIDTH = 1024;
ModulWithImage.MAX_IMAGE_WIDTH_IN_MATRIX = 512;
ModulWithImage.MAX_IMAGE_FULL_WIDTH = 1920;
exports.default = ModulWithImage;


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Headless_1 = __webpack_require__(1070);
var loadImage_1 = __webpack_require__(625);
exports.default = {
    open: open,
    generate: Headless_1.generate,
    loadImage: loadImage_1.loadImage
};


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var PaintCrop_1 = __webpack_require__(1071);
var Model_1 = __webpack_require__(1074);
var DefaultPayload_1 = __webpack_require__(1073);
function generate(options) {
    return new Promise(function (resolve, reject) {
        var canvas = document.createElement("canvas");
        var payload = options.payload || DefaultPayload_1.default;
        var model = new Model_1.default(payload, options.sourceImage.width, options.sourceImage.height, options.cropWidth, options.cropHeight);
        var scale;
        if (options.fullResolution) {
            var size = model.getFullResolutionSize(options.maxWidth, options.maxHeight);
            canvas.width = size.width;
            canvas.height = size.height;
            scale = size.width / options.cropWidth;
        }
        else {
            scale = 1;
            canvas.width = options.cropWidth;
            canvas.height = options.cropHeight;
        }
        PaintCrop_1.PaintCrop(canvas, options.sourceImage, model, 0, 0, scale);
        resolve({
            payload: options.payload,
            imageDataURL: canvas.toDataURL(),
            imageWidth: canvas.width,
            imageHeight: canvas.height
        });
    });
}
exports.generate = generate;


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__(1072);
function PaintCrop(canvas, sourceImage, model, cropAbsLeft, cropAbsTop, scale, clear) {
    if (cropAbsLeft === void 0) { cropAbsLeft = 0; }
    if (cropAbsTop === void 0) { cropAbsTop = 0; }
    if (scale === void 0) { scale = 1; }
    if (clear === void 0) { clear = false; }
    var absZoom = model.getAbsoluteZoom();
    var context = canvas.getContext("2d");
    if (clear) {
        context.clearRect(0, 0, canvas.width, canvas.height);
    }
    Utils_1.normalizedContextDrawImage(context, sourceImage, model.getCropLeft() / absZoom, model.getCropTop() / absZoom, model.getCropWidth() / absZoom, model.getCropHeight() / absZoom, cropAbsLeft * scale, cropAbsTop * scale, model.getCropWidth() * scale, model.getCropHeight() * scale);
}
exports.PaintCrop = PaintCrop;


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var DefaultPayload_1 = __webpack_require__(1073);
/**
 * Making sure that the source region is within the image
 * approximage calculations could get it slightly offside
 * so causing IndexSizeError in IE/Firefox
 */
function normalizedContextDrawImage(context, image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
    sx = Math.max(0, sx);
    sy = Math.max(0, sy);
    sWidth = Math.min(image.width - sx, sWidth);
    sHeight = Math.min(image.height - sy, sHeight);
    context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
}
exports.normalizedContextDrawImage = normalizedContextDrawImage;
/**
 * Returns a payload that have an properly calculated zoom so that
 * image will fit in the given crop dimentions, either on width or on height
 * depending on the aspect ratio
 */
function getFitPayload(width, height, cropWidth, cropHeight) {
    var payload = Object.assign({}, DefaultPayload_1.default);
    // if the image aspect is larger than the crop aspect
    // readjust the zoom so the image fits in the crop area without upscaling
    if (width / height > cropWidth / cropHeight) {
        payload.zoom = cropHeight / cropWidth * width / height;
    }
    return payload;
}
exports.getFitPayload = getFitPayload;


/***/ },
/* 1073 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    zoom: 1,
    cropXRatio: 1,
    cropYRatio: 1,
    version: 1
};


/***/ },
/* 1074 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Model = (function () {
    function Model(payload, sourceWidth, sourceHeight, cropWidth, cropHeight, maxCropWidth) {
        // migrate a shallow copy of payload
        this.payload = this.getMigratedPayload(Object.assign({}, payload));
        this.cropWidth = cropWidth;
        this.cropHeight = cropHeight;
        this.sourceWidth = sourceWidth;
        this.sourceHeight = sourceHeight;
        this.maxCropWidth = maxCropWidth;
    }
    Model.prototype.getMigratedPayload = function (payload) {
        switch (payload.version) {
            // incremental migration from 1->2, 2->3
            // breaks ommited intentionally
            /*
            case 1:
                // implement migration from version 1 to 2
            case 2:
                // implement migration from version 2 to 3
            */
            case Model.CURRENT_PAYLOAD_VERSION:
                // do nothing, it's the current version
                break;
            default:
                throw new Error("Payload version " + payload.version + " unsupported");
        }
        return payload;
    };
    Model.prototype.setCropPosition = function (cropLeft, cropTop) {
        var absZoom = this.getAbsoluteZoom();
        if (cropLeft < 0) {
            cropLeft = 0;
        }
        if (cropTop < 0) {
            cropTop = 0;
        }
        cropLeft = Math.min(cropLeft, this.sourceWidth * absZoom - this.cropWidth);
        cropTop = Math.min(cropTop, this.sourceHeight * absZoom - this.cropHeight);
        var cropRight = this.sourceWidth * absZoom - cropLeft - this.cropWidth;
        var cropBottom = this.sourceHeight * absZoom - cropTop - this.cropHeight;
        // Compare to 1 to cover the floating point approximations
        // Safeguard against Infinity cases, because Infinity is not exportable in JSON
        this.payload.cropXRatio = cropLeft < 1 && cropRight < 1 ? 1 : Math.min(cropLeft / cropRight, Number.MAX_VALUE);
        this.payload.cropYRatio = cropTop < 1 && cropBottom < 1 ? 1 : Math.min(cropTop / cropBottom, Number.MAX_VALUE);
    };
    Model.prototype.getCropLeft = function () {
        var absZoom = this.getAbsoluteZoom();
        var cropSpace = this.sourceWidth * absZoom - this.cropWidth;
        // parenthesis here are important, calculations differs in case
        // of a Infinity like cropXRatio
        return cropSpace * (this.payload.cropXRatio / (1 + this.payload.cropXRatio));
    };
    Model.prototype.getCropTop = function () {
        var absZoom = this.getAbsoluteZoom();
        var cropSpace = this.sourceHeight * absZoom - this.cropHeight;
        // parenthesis here are important, calculations differs in case
        // of a Infinity like cropYRatio
        return cropSpace * (this.payload.cropYRatio / (1 + this.payload.cropYRatio));
    };
    Model.prototype.getZoom = function () {
        return this.payload.zoom;
    };
    Model.prototype.setZoom = function (zoom) {
        this.payload.zoom = zoom;
    };
    Model.prototype.getCropWidth = function () {
        return this.cropWidth;
    };
    Model.prototype.getCropHeight = function () {
        return this.cropHeight;
    };
    Model.prototype.getSourceWidth = function () {
        return this.sourceWidth;
    };
    Model.prototype.getSourceHeight = function () {
        return this.sourceHeight;
    };
    Model.prototype.getPayload = function () {
        return this.payload;
    };
    Model.prototype.getAbsoluteZoom = function () {
        return this.payload.zoom * this.cropWidth / this.sourceWidth;
    };
    Model.prototype.setAbsoluteZoom = function (absZoom) {
        this.payload.zoom = absZoom / this.cropWidth * this.sourceWidth;
    };
    Model.prototype.getFullResolutionSize = function (maxWidth, maxHeight) {
        var absZoom = this.getAbsoluteZoom();
        var W = this.getCropWidth() / absZoom;
        var H = this.getCropHeight() / absZoom;
        if (W > maxWidth) {
            H = H * maxWidth / W;
            W = maxWidth;
        }
        if (H > maxHeight) {
            W = W * maxHeight / H;
            H = maxHeight;
        }
        return { width: W, height: H };
    };
    Model.prototype.resizeCropWidth = function (width) {
        width = Math.min(this.maxCropWidth, Math.max(width, this.getMinWidth()));
        this.resize(width, this.cropHeight);
    };
    Model.prototype.resizeCropHeight = function (height) {
        height = Math.max(height, this.getMinHeight());
        this.resize(this.cropWidth, height);
    };
    Model.prototype.resizeCropKeepAspect = function (width, height) {
        var aspect = this.cropHeight / this.cropWidth;
        if (aspect <= 1) {
            // width is the base of calculations
            width = Math.max(this.getMinWidth(), Math.min(width, this.maxCropWidth));
            height = width * aspect;
        }
        else {
            // height is the base of calculations
            height = Math.max(this.getMinHeight(), height);
            width = height / aspect;
            if (width > this.maxCropWidth) {
                width = this.maxCropWidth;
                height = width * aspect;
            }
        }
        // in this case, let the zoom change
        // so that the crop area is resized
        // but will contain the same picture inside
        var keepZoom = false;
        this.resize(width, height, keepZoom);
    };
    Model.prototype.resize = function (width, height, keepZoom) {
        if (keepZoom === void 0) { keepZoom = true; }
        if (width > this.getMinWidth() && height > this.getMinHeight()) {
            var currentAbsZoom = this.getAbsoluteZoom();
            this.cropWidth = width;
            this.cropHeight = height;
            if (keepZoom) {
                this.setAbsoluteZoom(Math.max(
                // we want to keep current absolute zoom, but only if it is below 1 (if is not upscaled)
                Math.min(1, currentAbsZoom), 
                // this will ensure we don't set an absolute zoom that
                // will crop outside of the image
                this.cropWidth / this.sourceWidth, this.cropHeight / this.sourceHeight));
            }
        }
    };
    Model.prototype.isUpscaled = function () {
        return Number(this.getAbsoluteZoom().toFixed(4)) > 1;
    };
    Model.prototype.getMinWidth = function () {
        return Model.MIN_IMAGE_SIZE;
    };
    Model.prototype.getMinHeight = function () {
        return Model.MIN_IMAGE_SIZE;
    };
    return Model;
}());
Model.CURRENT_PAYLOAD_VERSION = 1;
Model.FIT_RESIZE_MARGIN = 10;
Model.MIN_IMAGE_SIZE = 50;
exports.default = Model;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var index_1 = __webpack_require__(536);
var AppRegistry_1 = __webpack_require__(190);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
// TODO this component need to be updated to be 100% compabile with the server rendering
// currently it is reduced to serve well for the editing use-case
var ImageWebView = (function (_super) {
    tslib_1.__extends(ImageWebView, _super);
    function ImageWebView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.switchToImageTab = function () {
            // auto switch tabs if needed
            var store = getStore();
            store.dispatch(index_1.setCurrentTab({ nextTab: 0, currentTabWhitelist: [3, 4] }));
        };
        return _this;
    }
    ImageWebView.prototype.componentDidMount = function () {
        var props = this.props;
        if (this.hasTextProps(props)) {
            props.module.initCKEditor(this.textElement);
        }
    };
    ImageWebView.prototype.render = function () {
        var _this = this;
        var data = this.props.payload;
        var alignmentClass = this.getAlignmentClass();
        var props = this.props;
        var hasText = this.hasTextProps(props);
        var text;
        if (this.hasTextProps(props) && props.payload.moduleText) {
            text = props.payload.moduleText;
        }
        else if (this.hasTextProps(props)) {
            text = '<< ' + l10n_1.default("common.newImageWithText") + ' >>';
        }
        return (React.createElement("div", { className: "\n                clearover\n                " + (hasText ? "" : "imageSubtitle") + "\n                " + (data.imageFit && !this.isFullWidth() && !this.hasVisualSize() ? "imageFitWidth" : "") + "\n            ", id: "\n                " + (hasText ? "textWithImage" : "imageSubtitle") + "-" + this.props.moduleId + "\n            " },
            React.createElement("div", { className: "align-container " + alignmentClass, style: this.getContentStyle() },
                React.createElement("a", { className: "imagewrapper", href: "javascript:;", title: data.caption },
                    React.createElement("img", { id: "image_" + data.imageId, src: data.imageUrl, alt: data.imageAlt, style: hasText ? this.getTextImageStyle() : this.getImageStyle(), onClick: data.imageAnimated ? this.switchToImageTab : null })),
                this.supportsCaption() && data.caption ?
                    React.createElement("span", { className: "caption" }, data.caption)
                    : null),
            this.hasTextProps(props) ?
                React.createElement("div", { className: "textwrapper", dangerouslySetInnerHTML: { __html: text }, ref: function (ref) { return _this.textElement = ref; } })
                : null));
    };
    // Attempt to animate.
    // TODO: Reconsider later with IIE.
    // private getAlignmentStyle() {
    //     const data = this.props.payload;
    //     const contentWidth = this.props.module.getContent().offsetWidth;
    //     const containerWidth = this.props.module.getContainer().offsetWidth;
    //     switch (data.imagePosition) {
    //         case 2: return {
    //             marginLeft: containerWidth - contentWidth
    //         };
    //         case 3: return {
    //             marginLeft: containerWidth / 2 - contentWidth / 2
    //         };
    //         default: return {
    //             marginLeft: 0
    //         };
    //     }
    // }
    ImageWebView.prototype.hasImageProps = function (props) {
        return !props.module.hasText;
    };
    ImageWebView.prototype.hasTextProps = function (props) {
        return props.module.hasText;
    };
    ImageWebView.prototype.isFullWidth = function () {
        var props = this.props;
        return this.hasImageProps(props) && props.payload.isFullwidth;
    };
    ImageWebView.prototype.getAlignmentClass = function () {
        var props = this.props;
        if (this.hasImageProps(props) && !props.payload.supports.imageAlign) {
            return '';
        }
        var hasText = this.hasTextProps(props);
        switch (this.props.payload.imagePosition) {
            case 2: return hasText ? "imgright" : "align-right";
            case 3: return hasText ? "" : "align-center";
            default: return hasText ? "imgleft" : "align-left";
        }
    };
    ImageWebView.prototype.getTextImageStyle = function () {
        var data = this.props.payload;
        var style = this.hasVisualSize() ? {
            width: this.getWidth(),
            height: this.getHeight(),
            visibility: data.imageAnimated ? 'visible' : 'hidden'
        } : {
            width: "100%",
            height: "auto"
        };
        return style;
    };
    ImageWebView.prototype.getImageStyle = function () {
        var data = this.props.payload;
        var props = this.props;
        var supportsResize = this.hasImageProps(props) && props.payload.supports.imageResize;
        var style;
        if (this.hasVisualSize() && supportsResize) {
            style = {
                maxWidth: 'none',
                width: this.getWidth(),
                height: this.getHeight()
            };
        }
        else if (supportsResize) {
            var maxWidth = void 0;
            if (this.hasImageProps(props) && !props.payload.supports.imageFullWidth) {
                maxWidth = undefined;
            }
            else {
                maxWidth = this.isFullWidth() ? "none" : data.imageWidth + 'px';
            }
            style = {
                width: '100%',
                maxWidth: maxWidth,
                height: 'auto'
            };
        }
        else {
            style = {
                height: 'auto'
            };
        }
        return Object.assign(style, {
            //TODO: Change the visibility when the Webview is used for normal rendering without editing.
            visibility: this.props.payload.imageAnimated ? 'visible' : 'hidden'
        });
    };
    ImageWebView.prototype.getContentStyle = function () {
        var props = this.props;
        var style;
        if (this.hasTextProps(props)) {
            style = {
                maxWidth: "100%",
                width: this.getWidth()
            };
        }
        else if (this.hasImageProps(props) && props.payload.supports.imageResize) {
            style = {
                maxWidth: this.isFullWidth() ? "none" : this.getWidth(),
                width: "100%"
            };
        }
        else {
            style = {};
        }
        return style;
    };
    ImageWebView.prototype.supportsCaption = function () {
        // Text with image unconditionally supports caption
        return this.props.module.hasText ||
            this.props.payload.supports.imageCaption;
    };
    ImageWebView.prototype.getWidth = function () {
        var data = this.props.payload;
        return data.visualImageWidth || data.imageWidth;
    };
    ImageWebView.prototype.getHeight = function () {
        var data = this.props.payload;
        return data.visualImageHeight || data.imageHeight;
    };
    ImageWebView.prototype.hasVisualSize = function () {
        return this.props.payload.visualImageHeight && this.props.payload.visualImageWidth;
    };
    return ImageWebView;
}(React.Component));
exports.default = ImageWebView;


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var feature = __webpack_require__(25);
var DiyAviaryEditorDialog_1 = __webpack_require__(621);
var ModulTextWithImage_1 = __webpack_require__(1067);
var Utils_1 = __webpack_require__(1072);
var Warning_1 = __webpack_require__(618);
var cache_1 = __webpack_require__(1077);
var util_1 = __webpack_require__(1079);
var Groups = __webpack_require__(1080);
var ResponsiveBar_1 = __webpack_require__(992);
var common = __webpack_require__(1092);
var ImageEditView = (function (_super) {
    tslib_1.__extends(ImageEditView, _super);
    function ImageEditView(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectImage = function () {
            common.handleSelectImage(_this.props.moduleId, _this.props.module, _this.props.payload, function (newData) {
                _this.props.onDataChange(newData);
            });
        };
        _this.handleEditImage = function () {
            var newState = {};
            newState.aviaryEditing = true;
            _this.setState(newState);
        };
        _this.handleAlign = function (e, index) {
            var props = _this.props;
            var hasAlignCenter = !_this.hasTextProps(props);
            var position;
            if (hasAlignCenter) {
                switch (index) {
                    case 1:
                        position = 3;
                        break;
                    case 2:
                        position = 2;
                        break;
                    default:
                        position = 1;
                        break;
                }
            }
            else {
                switch (index) {
                    case 1:
                        position = 2;
                        break;
                    default:
                        position = 1;
                        break;
                }
            }
            var newData = {};
            newData.imagePosition = position;
            _this.props.onDataChange(newData);
        };
        _this.handleSizeMinus = function () {
            if (_this.sizeMinusEnabled()) {
                _this.changeSizeWith(-ImageEditView.IMAGE_RESIZE_STEP);
            }
        };
        _this.handleSizePlus = function () {
            if (_this.sizePlusEnabled()) {
                _this.changeSizeWith(ImageEditView.IMAGE_RESIZE_STEP);
            }
        };
        _this.handleResetSize = function () {
            common.handleResetSize(_this.props.payload, _this.props.module, function (newData) {
                _this.props.onDataChange(newData);
            });
        };
        _this.handleFit = function () {
            var newWidth = _this.props.module.getMaxWidth();
            var aspectRatio = _this.props.payload.visualImageWidth / _this.props.payload.visualImageHeight;
            var newHeight = newWidth / aspectRatio;
            _this.resize(newWidth, newHeight, true);
        };
        _this.handleFullwidth = function (e, isPressed) {
            var fullwidth = isPressed;
            var data = _this.props.payload;
            _this.props.module.setFullwidth(fullwidth);
            var newData = Object.assign({}, _this.props.payload);
            newData.isFullwidth = fullwidth;
            newData.imageWidth = _this.props.module.getMaxWidth();
            newData.visualImageWidth = _this.props.module.getMaxWidth();
            if (data.imageAnimated) {
                var aspect = data.origImageHeight / data.origImageWidth;
                newData.visualImageHeight = aspect * newData.visualImageWidth;
            }
            newData.iiePayload = Utils_1.getFitPayload(util_1.getIieSourceImageWidth(_this.props.payload), util_1.getIieSourceImageHeight(_this.props.payload), newData.visualImageWidth, newData.visualImageHeight);
            _this.props.onDataChange(newData);
        };
        _this.handleLinkClick = function () {
            common.handleAddLink(_this.props.payload, function (newData) {
                _this.props.onDataChange(newData);
            });
        };
        _this.onAviaryClose = function () {
            var newState = {};
            newState.aviaryEditing = false;
            _this.setState(newState);
        };
        _this.onAviarySave = function (aviaryData) {
            var newState = {};
            newState.aviaryEditing = false;
            _this.setState(newState);
            var imageKey = 'transformedImageUrl' + _this.props.moduleId;
            // clear first in case there are previous versions
            cache_1.clearCachedImage(imageKey);
            cache_1.getCachedImage(aviaryData.imageDataUrl, imageKey).then(function (image) {
                var data = _this.props.payload;
                var newData = {};
                newData.transformedImageUrl = aviaryData.imageDataUrl;
                newData.aviaryActionList = aviaryData.actionList;
                // fixing the canvas size
                if (image.height !== newData.transformedImageHeight
                    || image.width !== newData.transformedImageWidth) {
                    // calculating the image height using cross product
                    newData.visualImageWidth = data.imageWidth;
                    newData.visualImageHeight = data.imageWidth * (image.height / image.width);
                }
                newData.transformedImageWidth = image.width;
                newData.transformedImageHeight = image.height;
                if (newData.transformedImageHeight !== util_1.getIieSourceImageHeight(_this.props.payload)
                    || newData.transformedImageWidth !== util_1.getIieSourceImageWidth(_this.props.payload)) {
                    // so there was not only adding some effects, but dimensions changed
                    // in that case we need to reset iiePayload to have a best fit
                    // but keeping visual size of the image
                    newData.iiePayload = Utils_1.getFitPayload(newData.transformedImageWidth, newData.transformedImageHeight, data.visualImageWidth, data.visualImageHeight);
                }
                _this.props.onDataChange(newData);
            });
        };
        _this.state = {
            aviaryEditing: false
        };
        return _this;
    }
    ImageEditView.prototype.componentDidMount = function () {
        var modul = this.props.module;
        if (modul.getIsNew() && modul.autoOpenImageSelector) {
            if (modul instanceof ModulTextWithImage_1.default) {
                modul.getCKEditorPromise().then(this.handleSelectImage);
            }
            else {
                this.handleSelectImage();
            }
        }
        modul.autoOpenImageSelector = false;
    };
    ImageEditView.prototype.render = function () {
        var props = this.props;
        var data = this.props.payload;
        var hasAlign = (this.hasImageProps(props) && props.payload.supports.imageAlign)
            || this.hasTextProps(props);
        var hasResize = (this.hasImageProps(props) && props.payload.supports.imageResize)
            || this.hasTextProps(props);
        var hasFullwidth = this.isFullwidthAvailable();
        var hasAlignCenter = !this.hasTextProps(props);
        var imageUpscaled = common.getIieModel(data, this.props.module).isUpscaled();
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(ResponsiveBar_1.default, null,
                    Groups.getBaseButtons({
                        handleSelect: this.handleSelectImage,
                        handleEdit: this.handleEditImage,
                        editEnabled: !this.props.payload.imageAnimated
                    }),
                    hasAlign ?
                        Groups.getAlignButtons({
                            hasAlignCenter: hasAlignCenter,
                            position: data.imagePosition,
                            disabled: this.isFullwidth() || data.imageFit,
                            handler: this.handleAlign
                        })
                        : null,
                    hasResize ?
                        Groups.getResizeButtons({
                            hasFullwidth: hasFullwidth,
                            minusEnabled: this.sizeMinusEnabled(),
                            plusEnabled: this.sizePlusEnabled(),
                            fitEnabled: this.isFitEnabled(),
                            fullwidthEnabled: this.isFullwidthEnabled(),
                            fullwidthPressed: !!this.isFullwidth(),
                            handleMinus: this.handleSizeMinus,
                            handlePlus: this.handleSizePlus,
                            handleFit: this.handleFit,
                            handleFullwidth: this.handleFullwidth,
                            handleResetSize: this.handleResetSize
                        })
                        : null,
                    Groups.getLinkButton({
                        hasLink: !!data.link,
                        handler: this.handleLinkClick
                    })),
                this.state.aviaryEditing ? this.renderAviary() : null),
            imageUpscaled ? React.createElement(Warning_1.default, { text: l10n_1.default("module.image.messages.upscale") }) : null));
    };
    ImageEditView.prototype.renderAviary = function () {
        /* @todo: here we should branch to different editors, to remove aviary dependency */
        return (React.createElement(DiyAviaryEditorDialog_1.default, { imageUrl: util_1.getIieSourceImageUrl(this.props.payload), resultFileFormat: (this.props.payload.imageMediaType === 'jpg' || this.props.payload.imageMediaType === 'jpeg')
                ? 'jpg' : 'png', originalImageUrl: this.props.payload.origImageUrl, onClose: this.onAviaryClose, onSave: this.onAviarySave }));
    };
    ImageEditView.prototype.hasImageProps = function (props) {
        return !this.props.module.hasText;
    };
    ImageEditView.prototype.hasTextProps = function (props) {
        return this.props.module.hasText;
    };
    ImageEditView.prototype.isFullwidth = function (props) {
        if (props === void 0) { props = null; }
        var p = props || this.props;
        return this.hasImageProps(p) && p.payload.isFullwidth;
    };
    ImageEditView.prototype.isFullwidthEnabled = function () {
        return true;
    };
    ImageEditView.prototype.isFullwidthAvailable = function () {
        var props = this.props;
        return feature("fullwidth")
            && !props.module.inSidebar()
            && this.hasImageProps(props)
            && props.payload.supports.imageFullWidth;
    };
    ImageEditView.prototype.isFitEnabled = function () {
        return !this.isFullwidth() && !this.props.payload.imageFit;
    };
    ImageEditView.prototype.changeSizeWith = function (amount) {
        var newWidth;
        var newHeight;
        var payload = this.props.payload;
        if (this.isFullwidth()) {
            newWidth = payload.visualImageWidth;
            newHeight = payload.visualImageHeight + amount;
        }
        else {
            newWidth = Math.min(this.props.module.getMaxWidth(), payload.visualImageWidth + amount);
            newHeight = newWidth * payload.visualImageHeight / payload.visualImageWidth;
        }
        this.resize(newWidth, newHeight, false);
    };
    ImageEditView.prototype.sizeMinusEnabled = function () {
        var data = this.props.payload;
        var step = ImageEditView.IMAGE_RESIZE_STEP;
        var min = ImageEditView.MIN_IMAGE_HEIGHT;
        if (this.isFullwidth()) {
            return !data.imageAnimated && data.visualImageHeight - step >= min;
        }
        else {
            return data.visualImageHeight - step >= min && data.visualImageWidth - step >= min;
        }
    };
    ImageEditView.prototype.sizePlusEnabled = function () {
        var data = this.props.payload;
        if (this.isFullwidth()) {
            return true;
        }
        else {
            return data.visualImageWidth < this.props.module.getMaxWidth();
        }
    };
    ImageEditView.prototype.resize = function (width, height, keepZoom, additionalData) {
        var model = common.getIieModel(this.props.payload, this.props.module);
        model.resize(width, height, keepZoom);
        this.props.onDataChange(Object.assign({}, {
            imageWidth: width,
            visualImageWidth: width,
            imageHeight: height,
            visualImageHeight: height,
            imageFit: width >= this.props.module.getMaxWidth(),
            iiePayload: model.getPayload()
        }, additionalData));
    };
    return ImageEditView;
}(React.Component));
ImageEditView.MIN_IMAGE_WIDTH = 10;
ImageEditView.MIN_IMAGE_HEIGHT = 10;
ImageEditView.IMAGE_RESIZE_STEP = 5;
exports.default = ImageEditView;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var load_1 = __webpack_require__(1078);
var cachedImages = new Map();
function getCachedImage(imageUrl, key) {
    key = key || imageUrl;
    return new Promise(function (resolve, reject) {
        if (cachedImages.has(key)) {
            resolve(cachedImages.get(key));
        }
        else {
            load_1.loadImage(imageUrl).then(function (image) {
                cachedImages.set(key, image);
                resolve(image);
            }).catch(function (error) {
                reject(error);
            });
        }
    });
}
exports.getCachedImage = getCachedImage;
function clearCachedImage(imageUrl, key) {
    key = key || imageUrl;
    if (cachedImages.has(key)) {
        cachedImages.delete(key);
    }
}
exports.clearCachedImage = clearCachedImage;


/***/ },
/* 1078 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function loadImage(sourceImage) {
    return new Promise(function (resolve, reject) {
        var img;
        if (typeof sourceImage === "string") {
            img = new Image();
            img.src = sourceImage;
        }
        else {
            img = sourceImage;
        }
        if (img.complete) {
            resolve(img);
        }
        else {
            img.onload = function () {
                resolve(img);
            };
            img.onerror = function () {
                reject("Cannot load image.");
            };
        }
    });
}
exports.loadImage = loadImage;


/***/ },
/* 1079 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function getIieSourceImageUrl(moduleData) {
    return moduleData.transformedImageUrl ? moduleData.transformedImageUrl : moduleData.origImageUrl;
}
exports.getIieSourceImageUrl = getIieSourceImageUrl;
function getIieSourceImageKey(moduleData) {
    return moduleData.transformedImageUrl ? 'transformedImageUrl' : 'origImageUrl';
}
exports.getIieSourceImageKey = getIieSourceImageKey;
function getIieSourceImageWidth(moduleData) {
    return moduleData.transformedImageUrl ? moduleData.transformedImageWidth : moduleData.origImageWidth;
}
exports.getIieSourceImageWidth = getIieSourceImageWidth;
function getIieSourceImageHeight(moduleData) {
    return moduleData.transformedImageUrl ? moduleData.transformedImageHeight : moduleData.origImageHeight;
}
exports.getIieSourceImageHeight = getIieSourceImageHeight;


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(28);
var IconTextButton_1 = __webpack_require__(459);
var IconTextButtonGroup_1 = __webpack_require__(990);
var HorizontalAlignLeft_1 = __webpack_require__(1081);
var HorizontalAlignCenter_1 = __webpack_require__(1082);
var HorizontalAlignRight_1 = __webpack_require__(1083);
var add_a_photo_1 = __webpack_require__(1084);
var photo_filter_1 = __webpack_require__(602);
var add_1 = __webpack_require__(1085);
var remove_1 = __webpack_require__(1086);
var photo_size_select_large_1 = __webpack_require__(1087);
var panorama_horizontal_1 = __webpack_require__(1088);
var insert_link_1 = __webpack_require__(1027);
var aspect_ratio_1 = __webpack_require__(616);
var check_1 = __webpack_require__(399);
var sync_1 = __webpack_require__(1089);
var Badge_1 = __webpack_require__(1090);
var l10n_1 = __webpack_require__(18);
function getBaseButtons(props) {
    return (React.createElement(IconTextButtonGroup_1.default, null,
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(add_a_photo_1.default, null), text: l10n_1.default('module.image.buttons.addNew'), onTouchTap: props.handleSelect, dataTestId: "image-module-addnew", useAlternativeColors: true, isPrimary: true }),
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(photo_filter_1.default, null), text: l10n_1.default('common.editPicture'), onTouchTap: props.handleEdit, dataTestId: "image-module-effects", useAlternativeColors: true, isDisabled: !props.editEnabled })));
}
exports.getBaseButtons = getBaseButtons;
function getAlignButtons(props) {
    var index;
    var groupIcon;
    switch (props.position) {
        case 2:
            // right align
            index = props.hasAlignCenter ? 2 : 1;
            groupIcon = React.createElement(HorizontalAlignRight_1.HorizontalAlignRight, null);
            break;
        case 3:
            // center align
            index = 1;
            groupIcon = React.createElement(HorizontalAlignCenter_1.HorizontalAlignCenter, null);
            break;
        default:
            groupIcon = React.createElement(HorizontalAlignLeft_1.HorizontalAlignLeft, null);
            index = 0;
            break;
    }
    return (React.createElement(IconTextButtonGroup_1.default, { isRadio: true, selectedIndex: index, onChange: props.handler, label: l10n_1.default('module.image.buttons.groupAlign'), Icon: groupIcon, dataTestId: "image-module-align-group" },
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(HorizontalAlignLeft_1.HorizontalAlignLeft, null), text: l10n_1.default('module.image.buttons.alignLeft'), isDisabled: props.disabled, dataTestId: "image-module-align-left", useAlternativeColors: true }),
        props.hasAlignCenter ?
            React.createElement(IconTextButton_1.default, { Icon: React.createElement(HorizontalAlignCenter_1.HorizontalAlignCenter, null), text: l10n_1.default('module.image.buttons.alignCenter'), isDisabled: props.disabled, dataTestId: "image-module-align-center", useAlternativeColors: true })
            : null,
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(HorizontalAlignRight_1.HorizontalAlignRight, null), text: l10n_1.default('module.image.buttons.alignRight'), isDisabled: props.disabled, dataTestId: "image-module-align-right", useAlternativeColors: true })));
}
exports.getAlignButtons = getAlignButtons;
function getResizeButtons(props) {
    return (React.createElement(IconTextButtonGroup_1.default, { label: l10n_1.default('module.image.buttons.groupSize'), Icon: React.createElement(aspect_ratio_1.default, null), dataTestId: "image-module-size-group" },
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(remove_1.default, null), text: l10n_1.default('module.image.buttons.sizeMinus'), onTouchTap: props.handleMinus, isDisabled: !props.minusEnabled, dataTestId: "image-module-size-minus", useAlternativeColors: true }),
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(add_1.default, null), text: l10n_1.default('module.image.buttons.sizePlus'), onTouchTap: props.handlePlus, isDisabled: !props.plusEnabled, dataTestId: "image-module-size-plus", useAlternativeColors: true }),
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(photo_size_select_large_1.default, null), text: l10n_1.default('module.image.buttons.maximize'), isDisabled: !props.fitEnabled, onTouchTap: props.handleFit, dataTestId: "image-module-size-maximize", useAlternativeColors: true }),
        props.hasFullwidth ?
            React.createElement(IconTextButton_1.default, { Icon: React.createElement(panorama_horizontal_1.default, null), text: l10n_1.default('module.image.buttons.fullwidth'), isDisabled: !props.fullwidthEnabled, isPressable: true, isPressed: props.fullwidthPressed, onTouchTap: props.handleFullwidth, dataTestId: "image-module-size-fullwidth", useAlternativeColors: true })
            : null,
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(sync_1.default, null), text: l10n_1.default('module.image.buttons.resetSize'), isDisabled: props.fullwidthPressed, onTouchTap: props.handleResetSize, dataTestId: "image-module-size-reset", useAlternativeColors: true })));
}
exports.getResizeButtons = getResizeButtons;
function getLinkButton(props) {
    var button = (React.createElement(IconTextButtonGroup_1.default, null,
        React.createElement(IconTextButton_1.default, { Icon: React.createElement(insert_link_1.default, null), text: l10n_1.default('module.image.buttons.link'), onTouchTap: props.handler, dataTestId: "image-module-link", useAlternativeColors: true })));
    if (!props.hasLink) {
        return button;
    }
    else {
        var style = {
            height: 12,
            margin: 0,
            padding: 0,
            left: '48%',
            top: 17,
            width: 12
        };
        return (React.createElement(Badge_1.default, { primary: true, badgeContent: React.createElement(check_1.default, { color: "white" }), badgeStyle: style, style: { margin: 0, padding: 0 } }, button));
    }
}
exports.getLinkButton = getLinkButton;


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var HorizontalAlignLeft = (function (_super) {
    tslib_1.__extends(HorizontalAlignLeft, _super);
    function HorizontalAlignLeft() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalAlignLeft.prototype.render = function () {
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { transform: "rotate(90 12 12)", d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z" })));
    };
    return HorizontalAlignLeft;
}(React.Component));
exports.HorizontalAlignLeft = HorizontalAlignLeft;


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var HorizontalAlignCenter = (function (_super) {
    tslib_1.__extends(HorizontalAlignCenter, _super);
    function HorizontalAlignCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalAlignCenter.prototype.render = function () {
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { transform: "rotate(90 12 12)", d: "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z" })));
    };
    return HorizontalAlignCenter;
}(React.Component));
exports.HorizontalAlignCenter = HorizontalAlignCenter;


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var HorizontalAlignRight = (function (_super) {
    tslib_1.__extends(HorizontalAlignRight, _super);
    function HorizontalAlignRight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalAlignRight.prototype.render = function () {
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { transform: "rotate(90 12 12)", d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z" })));
    };
    return HorizontalAlignRight;
}(React.Component));
exports.HorizontalAlignRight = HorizontalAlignRight;


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAddAPhoto = function ImageAddAPhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z' })
  );
};
ImageAddAPhoto = (0, _pure2.default)(ImageAddAPhoto);
ImageAddAPhoto.displayName = 'ImageAddAPhoto';
ImageAddAPhoto.muiName = 'SvgIcon';

exports.default = ImageAddAPhoto;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAdd = function ContentAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
  );
};
ContentAdd = (0, _pure2.default)(ContentAdd);
ContentAdd.displayName = 'ContentAdd';
ContentAdd.muiName = 'SvgIcon';

exports.default = ContentAdd;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRemove = function ContentRemove(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13H5v-2h14v2z' })
  );
};
ContentRemove = (0, _pure2.default)(ContentRemove);
ContentRemove.displayName = 'ContentRemove';
ContentRemove.muiName = 'SvgIcon';

exports.default = ContentRemove;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoSizeSelectLarge = function ImagePhotoSizeSelectLarge(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z' })
  );
};
ImagePhotoSizeSelectLarge = (0, _pure2.default)(ImagePhotoSizeSelectLarge);
ImagePhotoSizeSelectLarge.displayName = 'ImagePhotoSizeSelectLarge';
ImagePhotoSizeSelectLarge.muiName = 'SvgIcon';

exports.default = ImagePhotoSizeSelectLarge;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanoramaHorizontal = function ImagePanoramaHorizontal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z' })
  );
};
ImagePanoramaHorizontal = (0, _pure2.default)(ImagePanoramaHorizontal);
ImagePanoramaHorizontal.displayName = 'ImagePanoramaHorizontal';
ImagePanoramaHorizontal.muiName = 'SvgIcon';

exports.default = ImagePanoramaHorizontal;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(400);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(407);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSync = function NotificationSync(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
  );
};
NotificationSync = (0, _pure2.default)(NotificationSync);
NotificationSync.displayName = 'NotificationSync';
NotificationSync.muiName = 'SvgIcon';

exports.default = NotificationSync;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Badge = __webpack_require__(1091);

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Badge2.default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _simpleAssign = __webpack_require__(377);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(28);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
  var primary = props.primary;
  var secondary = props.secondary;
  var badge = context.muiTheme.badge;


  var badgeBackgroundColor = void 0;
  var badgeTextColor = void 0;

  if (primary) {
    badgeBackgroundColor = badge.primaryColor;
    badgeTextColor = badge.primaryTextColor;
  } else if (secondary) {
    badgeBackgroundColor = badge.secondaryColor;
    badgeTextColor = badge.secondaryTextColor;
  } else {
    badgeBackgroundColor = badge.color;
    badgeTextColor = badge.textColor;
  }

  var radius = 12;
  var radius2x = Math.floor(2 * radius);

  return {
    root: {
      position: 'relative',
      display: 'inline-block',
      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
    },
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      fontWeight: badge.fontWeight,
      fontSize: radius,
      width: radius2x,
      height: radius2x,
      borderRadius: '50%',
      backgroundColor: badgeBackgroundColor,
      color: badgeTextColor
    }
  };
}

var Badge = function (_Component) {
  _inherits(Badge, _Component);

  function Badge() {
    _classCallCheck(this, Badge);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Badge).apply(this, arguments));
  }

  _createClass(Badge, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var badgeContent = _props.badgeContent;
      var badgeStyle = _props.badgeStyle;
      var children = _props.children;
      var primary = _props.primary;
      var secondary = _props.secondary;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        children,
        _react2.default.createElement(
          'span',
          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
          badgeContent
        )
      );
    }
  }]);

  return Badge;
}(_react.Component);

Badge.propTypes = {
  /**
   * This is the content rendered within the badge.
   */
  badgeContent: _react.PropTypes.node.isRequired,
  /**
   * Override the inline-styles of the badge element.
   */
  badgeStyle: _react.PropTypes.object,
  /**
   * The badge will be added relativelty to this node.
   */
  children: _react.PropTypes.node,
  /**
   * The css class name of the root element.
   */
  className: _react.PropTypes.string,
  /**
   * If true, the badge will use the primary badge colors.
   */
  primary: _react.PropTypes.bool,
  /**
   * If true, the badge will use the secondary badge colors.
   */
  secondary: _react.PropTypes.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _react.PropTypes.object
};
Badge.defaultProps = {
  primary: false,
  secondary: false
};
Badge.contextTypes = {
  muiTheme: _react.PropTypes.object.isRequired
};
exports.default = Badge;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__(1072);
var cache_1 = __webpack_require__(1077);
var isAnimatedGif_1 = __webpack_require__(1093);
var util_1 = __webpack_require__(1079);
var Model_1 = __webpack_require__(1074);
var DefaultPayload_1 = __webpack_require__(1073);
function handleSelectImage(moduleId, module, data, onDataChange) {
    var filemanagerSourceCallback = function (items, successCb, errorCb) {
        var fmImage = items[0];
        var fmImageUrl = fmImage.getFile();
        var imageKey = 'origImageUrl' + moduleId;
        // clear first in case there are previous versions
        cache_1.clearCachedImage(imageKey);
        cache_1.getCachedImage(fmImageUrl, imageKey).then(function (image) {
            var newData = {};
            newData.origImageUrl = fmImageUrl;
            newData.origImageWidth = image.width;
            newData.origImageHeight = image.height;
            // discard all information about tranformed image
            newData.transformedImageUrl = null;
            newData.transformedImageWidth = null;
            newData.transformedImageHeight = null;
            newData.fmImageId = fmImage.getId();
            newData.fmImageSource = fmImage.getSource().getName();
            isAnimatedGif_1.isAnimatedGif(newData.origImageUrl, function (animated) {
                newData.imageAnimated = animated;
                if (animated) {
                    newData.imageUrl = newData.origImageUrl;
                }
                var hasParent = module.getParentSection() || module.getMatrixModuleParent();
                if (animated || !hasParent) {
                    // keep the previous height, adjust the width
                    var aspect = image.width / image.height;
                    newData.visualImageWidth = aspect * data.visualImageHeight;
                    if (newData.visualImageWidth > module.getMaxWidth()) {
                        newData.visualImageWidth = module.getMaxWidth();
                        newData.visualImageHeight = newData.visualImageWidth / aspect;
                    }
                    newData.imageWidth = newData.visualImageWidth;
                }
                if (hasParent) {
                    // XXX if for some reason images in sections are smaller than they should be, let's fix it now
                    // It happen for some customers (see BUG-1171)
                    newData.imageWidth = Math.max(data.imageWidth, data.visualImageWidth);
                    newData.imageHeight = Math.max(data.imageHeight, data.visualImageHeight);
                    // keep previous width and height
                    newData.iiePayload = Utils_1.getFitPayload(newData.origImageWidth, newData.origImageHeight, data.visualImageWidth, data.visualImageHeight);
                }
                else {
                    newData.iiePayload = null;
                }
                onDataChange(newData);
                successCb(items);
            });
        }).catch(function (e) { return errorCb(e); });
    };
    var sourceConfig = {
        batchSize: 1,
        callback: filemanagerSourceCallback
    };
    diy.editor.filemanager = new diy.editor.Filemanager({
        appName: 'filemanager',
        mode: 'selection',
        maxSelection: 1,
        alreadyExisting: 0,
        sources: {
            storage: sourceConfig,
            cms: sourceConfig,
            bigstock: sourceConfig,
            '123rf': sourceConfig
        },
        callback: function () { return null; }
    });
}
exports.handleSelectImage = handleSelectImage;
function handleAddLink(data, onDataChange) {
    var linkData = {
        href: data.link
    };
    diy.editor.linkSelector.openDialog(linkData, function (outputData) {
        var newData = {};
        newData.link = outputData.href;
        newData.linkTarget = outputData.target;
        newData.linkTitle = outputData.value;
        onDataChange(newData);
    });
}
exports.handleAddLink = handleAddLink;
function handleResetSize(data, module, onDataChange) {
    var sourceImageWidth = util_1.getIieSourceImageWidth(data);
    var sourceImageHeight = util_1.getIieSourceImageHeight(data);
    var aspectRatio = sourceImageWidth / sourceImageHeight;
    var width = Math.min(sourceImageWidth, module.getMaxWidth());
    var height = width / aspectRatio;
    var model = getIieModel(data, module);
    model.resize(width, height, true);
    var newData = {};
    newData.imageWidth = width;
    newData.visualImageWidth = width;
    newData.imageHeight = height;
    newData.visualImageHeight = height;
    newData.imageFit = width >= module.getMaxWidth();
    newData.iiePayload = DefaultPayload_1.default;
    onDataChange(newData);
}
exports.handleResetSize = handleResetSize;
function getIieModel(data, module) {
    var iiePayload = Object.assign({}, DefaultPayload_1.default, data.iiePayload);
    var model = new Model_1.default(iiePayload, util_1.getIieSourceImageWidth(data), util_1.getIieSourceImageHeight(data), data.visualImageWidth, data.visualImageHeight, module.getMaxWidth());
    return model;
}
exports.getIieModel = getIieModel;


/***/ },
/* 1093 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function isAnimatedGif(src, cb) {
    var request = new XMLHttpRequest();
    request.open('GET', src, true);
    request.responseType = 'arraybuffer';
    request.addEventListener('load', function () {
        var arr = new Uint8Array(request.response);
        var length = arr.length;
        var frames = 0;
        // make sure it's a gif (GIF8)
        if (arr[0] !== 0x47 || arr[1] !== 0x49 || arr[2] !== 0x46 || arr[3] !== 0x38) {
            cb(false);
            return;
        }
        //ported from php http://www.php.net/manual/en/function.imagecreatefromgif.php#104473
        //an animated gif contains multiple "frames", with each frame having a
        //header made up of:
        // * a static 3-byte sequence (\x00\x21\xF9
        // * one byte indicating the length of the header (usually \x04)
        // * variable length header (usually 4 bytes)
        // * a static 2-byte sequence (\x00\x2C) (some variants may use \x00\x21 ?)
        // We read through the file as long as we haven't reached the end of the file
        // and we haven't yet found at least 2 frame headers
        for (var i = 0, len = length - 3; i < len && frames < 2; ++i) {
            if (arr[i] === 0x00 && arr[i + 1] === 0x21 && arr[i + 2] === 0xF9) {
                var blocklength = arr[i + 3];
                var afterblock = i + 4 + blocklength;
                if (afterblock + 1 < length &&
                    arr[afterblock] === 0x00 &&
                    (arr[afterblock + 1] === 0x2C || arr[afterblock + 1] === 0x21)) {
                    frames++;
                }
            }
        }
        // if frame count > 1, it's animated
        cb(frames > 1);
    });
    request.send();
}
exports.isAnimatedGif = isAnimatedGif;


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var globalEvents = __webpack_require__(500);
var Slider_1 = __webpack_require__(518);
var Warning_1 = __webpack_require__(618);
var sync_1 = __webpack_require__(1089);
var IconTextButton_1 = __webpack_require__(459);
var DefaultPayload_1 = __webpack_require__(1073);
var autoprefixer_1 = __webpack_require__(438);
var Utils_1 = __webpack_require__(1072);
var util_1 = __webpack_require__(1079);
var ImageEditViewCrop = (function (_super) {
    tslib_1.__extends(ImageEditViewCrop, _super);
    function ImageEditViewCrop(props) {
        var _this = _super.call(this, props) || this;
        _this.zoomUsed = false;
        _this.onResetCrop = function () {
            var data = _this.props.payload;
            var sourceImageHeight = util_1.getIieSourceImageHeight(data);
            var sourceImageWidth = util_1.getIieSourceImageWidth(data);
            var aspectRatio = sourceImageWidth / sourceImageHeight;
            var newData = {};
            if (data.isFullwidth) {
                // only make fit on width or height
                newData.iiePayload = Utils_1.getFitPayload(sourceImageWidth, sourceImageHeight, data.visualImageWidth, data.visualImageHeight);
            }
            else {
                newData.iiePayload = DefaultPayload_1.default;
                newData.visualImageHeight = data.visualImageHeight; // keep the height
                newData.visualImageWidth = newData.visualImageHeight * aspectRatio;
                var maxWidth = Math.min(sourceImageWidth, _this.props.module.getMaxWidth());
                if (newData.visualImageWidth > maxWidth) {
                    newData.visualImageWidth = maxWidth;
                    newData.visualImageHeight = newData.visualImageWidth / aspectRatio;
                }
                newData.imageHeight = newData.visualImageHeight;
                newData.imageWidth = newData.visualImageWidth;
                newData.imageFit = newData.visualImageWidth >= _this.props.module.getMaxWidth();
            }
            _this.props.onDataChange(newData);
        };
        _this.onZoomChange = function (e, value) {
            var payload = Object.assign({}, DefaultPayload_1.default, _this.props.payload.iiePayload);
            var newData = {};
            newData.iiePayload = payload;
            newData.iiePayload.zoom = value;
            _this.props.onDataChange(newData);
        };
        _this.onZoomStart = function (e) {
            if (!_this.zoomUsed) {
                _this.zoomUsed = true;
                globalEvents.trigger('diy-editor-iie-zoom-used');
            }
            // XXX timeout to prevent a concurrent slider rerender
            setTimeout(function () {
                var newData = {};
                newData.showSourceImage = true;
                _this.props.onDataChange(newData);
            }, 0);
        };
        _this.onZoomStop = function (e) {
            var newData = {};
            newData.showSourceImage = false;
            _this.props.onDataChange(newData);
        };
        return _this;
    }
    ImageEditViewCrop.prototype.componentDidMount = function () {
        var newData = {};
        // allow crop and pan only in this view
        newData.allowCrop = true;
        newData.allowPan = true;
        this.props.onDataChange(newData);
    };
    ImageEditViewCrop.prototype.componentWillUnmount = function () {
        var newData = {};
        // allow crop and pan only in this view
        newData.allowCrop = false;
        newData.allowPan = false;
        this.props.onDataChange(newData);
    };
    ImageEditViewCrop.prototype.render = function () {
        var ZOOM_THRESHOLD_PERCENT = 15;
        var style = this.getStyle();
        var data = this.props.payload;
        var payload = Object.assign({}, DefaultPayload_1.default, data.iiePayload);
        var _a = this.getZoomLimits(), minZoom = _a.minZoom, maxZoom = _a.maxZoom;
        var zoom = Number(payload.zoom.toFixed(4));
        if (zoom > maxZoom) {
            zoom = maxZoom;
        }
        if (zoom < minZoom) {
            zoom = minZoom;
        }
        var noZoom = minZoom >= maxZoom;
        var limitedZoom = (maxZoom - minZoom) / maxZoom < ZOOM_THRESHOLD_PERCENT / 100;
        if (noZoom) {
            maxZoom = zoom = minZoom;
        }
        return (React.createElement("div", null,
            React.createElement("div", { style: style.content },
                React.createElement("div", { style: style.zoomLabel }, l10n_1.default('module.image.labels.zoom')),
                React.createElement("div", { style: style.zoomWrap },
                    React.createElement(Slider_1.default
                    // XXX Slider does not support minZoom and maxZoom changing
                    // so we generate key so that for each different
                    // min/max combination a new Slider element will be created
                    // see https://github.com/callemall/material-ui/issues/3619
                    , { 
                        // XXX Slider does not support minZoom and maxZoom changing
                        // so we generate key so that for each different
                        // min/max combination a new Slider element will be created
                        // see https://github.com/callemall/material-ui/issues/3619
                        key: minZoom + "-" + maxZoom, onChange: this.onZoomChange, onDragStart: this.onZoomStart, onDragStop: this.onZoomStop, disabled: noZoom || data.imageAnimated, style: style.slider, defaultValue: zoom, value: zoom, min: noZoom ? 0 : minZoom, max: maxZoom, step: 0.0001 })),
                React.createElement(IconTextButton_1.default, { text: l10n_1.default('module.image.buttons.resetCrop'), Icon: React.createElement(sync_1.default, null), onTouchTap: this.onResetCrop, isDisabled: noZoom || data.imageAnimated, useAlternativeColors: true })),
            !noZoom && limitedZoom ? React.createElement(Warning_1.default, { text: l10n_1.default("module.image.messages.limitedZoom") }) : null,
            noZoom ? React.createElement(Warning_1.default, { text: l10n_1.default("module.image.messages.noZoom") }) : null));
    };
    ImageEditViewCrop.prototype.getZoomLimits = function () {
        return {
            minZoom: Number(this.getFitZoom().toFixed(4)),
            maxZoom: Number(this.getOriginalZoom().toFixed(4))
        };
    };
    ImageEditViewCrop.prototype.getFitZoom = function () {
        var data = this.props.payload;
        var cropWidth = data.visualImageWidth;
        var cropHeight = data.visualImageHeight;
        var sourceImageHeight = util_1.getIieSourceImageHeight(data);
        var sourceImageWidth = util_1.getIieSourceImageWidth(data);
        var fitZoom;
        var fitOnWidth = cropWidth / cropHeight > sourceImageWidth / sourceImageHeight;
        if (fitOnWidth) {
            fitZoom = 1;
        }
        else {
            var fitWidth = sourceImageWidth * cropHeight / sourceImageHeight;
            fitZoom = fitWidth / cropWidth;
        }
        return fitZoom;
    };
    ImageEditViewCrop.prototype.getOriginalZoom = function () {
        var data = this.props.payload;
        var zoom = util_1.getIieSourceImageWidth(data) / data.visualImageWidth;
        return zoom > 1 ? zoom : this.getFitZoom();
    };
    ImageEditViewCrop.prototype.getStyle = function () {
        return {
            content: autoprefixer_1.autoprefixer({
                display: "flex"
            }),
            zoomLabel: autoprefixer_1.autoprefixer({
                fontSize: 12,
                marginLeft: 12,
                marginRight: 12,
                alignSelf: "center",
            }),
            zoomWrap: autoprefixer_1.autoprefixer({
                width: "60%",
                marginLeft: 12,
                marginRight: 24,
                alignSelf: "center"
            }),
            slider: {
                marginBottom: -48,
                marginTop: -24
            }
        };
    };
    return ImageEditViewCrop;
}(React.Component));
exports.default = ImageEditViewCrop;


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var TextField_1 = __webpack_require__(473);
var ImageEditViewCaptions = (function (_super) {
    tslib_1.__extends(ImageEditViewCaptions, _super);
    function ImageEditViewCaptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubtitleChange = function (e) {
            var newData = {};
            newData.caption = e.target.value;
            _this.props.onDataChange(newData);
        };
        _this.handleAltChange = function (e) {
            var newData = {};
            newData.imageAlt = e.target.value;
            _this.props.onDataChange(newData);
        };
        return _this;
    }
    ImageEditViewCaptions.prototype.render = function () {
        var style = this.getStyle();
        var data = this.props.payload;
        var props = this.props;
        return (React.createElement("div", { style: style.root },
            this.hasTextProps(props) || (this.hasImageProps(props) && props.payload.supports.imageCaption) ?
                React.createElement(TextField_1.default, { style: style.textfield, floatingLabelText: l10n_1.default('module.image.labels.caption'), hintText: l10n_1.default('module.image.labels.captionHint'), defaultValue: data.caption || null, onChange: this.handleSubtitleChange })
                : null,
            React.createElement(TextField_1.default, { style: style.textfield, floatingLabelText: l10n_1.default('module.image.labels.alt'), hintText: l10n_1.default('module.image.labels.altHint'), defaultValue: data.imageAlt || null, onChange: this.handleAltChange })));
    };
    ImageEditViewCaptions.prototype.hasImageProps = function (props) {
        return !props.module.hasText;
    };
    ImageEditViewCaptions.prototype.hasTextProps = function (props) {
        return props.module.hasText;
    };
    ImageEditViewCaptions.prototype.getStyle = function () {
        return {
            root: {
                padding: "0 4px"
            },
            textfield: {
                marginRight: 24,
                marginTop: -14,
                width: 350
            }
        };
    };
    return ImageEditViewCaptions;
}(React.Component));
exports.default = ImageEditViewCaptions;


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var globalEvents = __webpack_require__(500);
var ImageInlineEditor_1 = __webpack_require__(1097);
var DefaultPayload_1 = __webpack_require__(1073);
var util_1 = __webpack_require__(1079);
var index_1 = __webpack_require__(536);
var AppRegistry_1 = __webpack_require__(190);
var SyncPosition_1 = __webpack_require__(440);
var diyLightTheme = __webpack_require__(241);
var Popover_1 = __webpack_require__(1100);
var Menu_1 = __webpack_require__(464);
var MenuItem_1 = __webpack_require__(385);
var common = __webpack_require__(1092);
var l10n_1 = __webpack_require__(18);
var add_a_photo_1 = __webpack_require__(1084);
var insert_link_1 = __webpack_require__(1027);
var sync_1 = __webpack_require__(1089);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ImageInPlaceEditView = (function (_super) {
    tslib_1.__extends(ImageInPlaceEditView, _super);
    function ImageInPlaceEditView(props) {
        var _this = _super.call(this, props) || this;
        _this.panUsed = false;
        _this.aspectCropUsed = false;
        _this.nonAspectCropUsed = false;
        _this.renderIie = function (box) {
            var data = _this.props.payload;
            var imageElement = _this.props.module.getImageElement(data.imageId);
            var imageElPosition = _this.elementFixed(imageElement) ? "fixed" : "absolute";
            var resizeControls = _this.getResizeControls();
            return (React.createElement("div", { onContextMenu: _this.handleContextMenu, onTouchTap: _this.handleTouchTap },
                React.createElement(ImageInlineEditor_1.default, { top: box.top, left: box.left, width: box.width, height: box.height, imageElement: imageElement, resizeControls: resizeControls, maxWidth: _this.props.module.getMaxWidth(), sourceImage: _this.state.sourceImage, payload: data.iiePayload || DefaultPayload_1.default, position: imageElPosition, zIndex: 10000, mediaType: data.imageMediaType, onPan: _this.onPan, onPanStart: _this.onPanStart, onPanEnd: _this.onPanEnd, onCropResize: _this.onCropResize, onCropResizeStart: _this.onCropResizeStart, onCropResizeEnd: _this.onCropResizeEnd, showSourceImage: data.showSourceImage, animatedGif: data.imageAnimated, outline: data.allowCrop ? 2 : 1, allowPan: data.allowPan }),
                React.createElement(Popover_1.default, { style: { marginLeft: _this.state.contextMenuLeft, marginTop: _this.state.contextMenuTop }, open: _this.state.contextMenuOpen, useLayerForClickAway: true, autoCloseWhenOffScreen: true, canAutoPosition: true, onRequestClose: _this.handleContextMenuClose, zDepth: 2 },
                    React.createElement("div", { onContextMenu: function (e) { e.preventDefault(); e.stopPropagation(); } },
                        React.createElement(Menu_1.default, null,
                            React.createElement(MenuItem_1.default, { primaryText: l10n_1.default('module.image.buttons.addNew'), leftIcon: React.createElement(add_a_photo_1.default, null), onTouchTap: _this.handleSelectImage }),
                            React.createElement(MenuItem_1.default, { primaryText: l10n_1.default('module.image.buttons.link'), leftIcon: React.createElement(insert_link_1.default, null), onTouchTap: _this.handleAddLink }),
                            resizeControls && resizeControls.length > 0 && !_this.isFullWidth() ?
                                React.createElement(MenuItem_1.default, { primaryText: l10n_1.default('module.image.buttons.resetSize'), leftIcon: React.createElement(sync_1.default, null), onTouchTap: _this.handleResetSize })
                                : null)))));
        };
        _this.handleSelectImage = function () {
            _this.handleContextMenuClose();
            common.handleSelectImage(_this.props.moduleId, _this.props.module, _this.props.payload, _this.onDataChange);
        };
        _this.handleAddLink = function () {
            _this.handleContextMenuClose();
            common.handleAddLink(_this.props.payload, _this.onDataChange);
        };
        _this.handleResetSize = function () {
            _this.handleContextMenuClose();
            common.handleResetSize(_this.props.payload, _this.props.module, _this.onDataChange);
        };
        _this.onDataChange = function (newData) {
            _this.props.onDataChange(newData);
        };
        _this.handleContextMenu = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                contextMenuOpen: true,
                contextMenuLeft: e.clientX,
                contextMenuTop: e.clientY
            });
        };
        _this.handleTouchTap = function () {
            var store = getStore();
            store.dispatch(index_1.setCurrentTab({ nextTab: 0, currentTabWhitelist: [3, 4] }));
        };
        _this.handleContextMenuClose = function (reason) {
            _this.setState({ contextMenuOpen: false });
        };
        _this.onCropResize = function (imageWidth, imageHeight, payload, imageDataUrlGetter, keepAspect) {
            var maxWidth = _this.props.module.getMaxWidth();
            var newData = {};
            newData.imageWidth = imageWidth;
            newData.imageHeight = imageHeight;
            newData.visualImageWidth = imageWidth;
            newData.visualImageHeight = imageHeight;
            newData.imageFit = imageWidth >= maxWidth;
            newData.iiePayload = payload;
            // we don't need to update imageUrl for performance reasons
            // we have the original image covered by ImageInlineEditor anyway
            //newData.imageUrl = imageDataUrlGetter();
            _this.props.onDataChange(newData);
            if (keepAspect) {
                if (!_this.aspectCropUsed) {
                    _this.aspectCropUsed = true;
                    globalEvents.trigger('diy-editor-iie-crop-used-keep-aspect');
                }
            }
            else {
                if (!_this.nonAspectCropUsed) {
                    _this.nonAspectCropUsed = true;
                    globalEvents.trigger('diy-editor-iie-crop-used-non-aspect');
                }
            }
        };
        _this.onPan = function (payload) {
            var newData = {};
            newData.iiePayload = payload;
            _this.props.onDataChange(newData);
        };
        _this.onPanStart = function () {
            if (!_this.panUsed) {
                _this.panUsed = true;
                globalEvents.trigger('diy-editor-iie-panning-used');
            }
            var newData = {};
            newData.showSourceImage = true;
            _this.props.onDataChange(newData);
        };
        _this.onPanEnd = function () {
            var newData = {};
            newData.showSourceImage = false;
            _this.props.onDataChange(newData);
        };
        _this.onCropResizeStart = function () {
            var newData = {};
            newData.showSourceImage = _this.props.payload.allowCrop;
            _this.props.onDataChange(newData);
            var state = {};
            state.useShallowCompare = true;
            _this.setState(state);
            // auto switch tabs if needed
            var store = getStore();
            store.dispatch(index_1.setCurrentTab({ nextTab: 0, currentTabWhitelist: [3, 4] }));
        };
        _this.onCropResizeEnd = function () {
            _this.aspectCropUsed = false;
            _this.nonAspectCropUsed = false;
            var newData = {};
            newData.showSourceImage = false;
            _this.props.onDataChange(newData);
            var state = {};
            state.useShallowCompare = false;
            _this.setState(state);
        };
        _this.state = {
            sourceImage: null,
            useShallowCompare: false,
            contextMenuOpen: false,
            contextMenuTop: 0,
            contextMenuLeft: 0
        };
        return _this;
    }
    ImageInPlaceEditView.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    ImageInPlaceEditView.prototype.componentDidMount = function () {
        this.loadSourceImage();
    };
    ImageInPlaceEditView.prototype.componentWillReceiveProps = function (nextProps) {
        if (util_1.getIieSourceImageUrl(this.props.payload) !== util_1.getIieSourceImageUrl(nextProps.payload)) {
            this.loadSourceImage();
        }
    };
    ImageInPlaceEditView.prototype.render = function () {
        if (this.state.sourceImage) {
            return this.renderLoaded();
        }
        else {
            // TODO render a loader or render with a transparent image
            return null;
        }
    };
    ImageInPlaceEditView.prototype.renderLoaded = function () {
        var element = this.props.module.getImageElement();
        var position = this.elementFixed(element) ? 'fixed' : 'absolute';
        return (React.createElement(SyncPosition_1.default, { useShallowCompare: this.state.useShallowCompare, element: element, position: position }, this.renderIie));
    };
    ImageInPlaceEditView.prototype.loadSourceImage = function () {
        var _this = this;
        this.props.module.getIieSourceImage().then(function (image) {
            var state = {};
            state.sourceImage = image;
            _this.setState(state);
        });
    };
    ImageInPlaceEditView.prototype.hasImageProps = function (props) {
        return !props.module.hasText;
    };
    ImageInPlaceEditView.prototype.hasTextProps = function (props) {
        return props.module.hasText;
    };
    ImageInPlaceEditView.prototype.isFullWidth = function () {
        var props = this.props;
        return this.hasImageProps(props) && props.payload.isFullwidth;
    };
    ImageInPlaceEditView.prototype.getResizeControls = function () {
        var props = this.props;
        var hasResize = (this.hasImageProps(props) && props.payload.supports.imageResize)
            || this.hasTextProps(props);
        if (!hasResize) {
            return [];
        }
        var module = this.props.module;
        var data = this.props.payload;
        var pos = data.imagePosition;
        var fullwidth = this.isFullWidth();
        var matrix = module.getMatrixModuleParent();
        var teaser = matrix && matrix.isTeaser();
        var animated = data.imageAnimated;
        var controls;
        if (fullwidth) {
            controls = animated ? [] : ['S'];
        }
        else if (teaser) {
            controls = animated ? [] : ['S'];
        }
        else if (pos === 1) {
            controls = animated ? ['SE'] : ['S', 'SE', 'E'];
        }
        else if (pos === 2) {
            controls = animated ? ['SW'] : ['S', 'SW', 'W'];
        }
        else if (pos === 3) {
            controls = animated ? ['SE', 'SW'] : ['S', 'SE', 'E', 'SW', 'W'];
        }
        else {
            controls = [];
        }
        if (!data.allowCrop) {
            controls = controls.filter(function (value) { return ['E', 'S', 'W'].indexOf(value) === -1; });
        }
        return controls;
    };
    ImageInPlaceEditView.prototype.elementFixed = function (element) {
        var current = element;
        while (current) {
            if (window.getComputedStyle(current).position === "fixed") {
                return true;
            }
            current = current.offsetParent;
        }
        return false;
    };
    return ImageInPlaceEditView;
}(React.Component));
ImageInPlaceEditView.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.default = ImageInPlaceEditView;


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var Model_1 = __webpack_require__(1074);
var Canvas_1 = __webpack_require__(1098);
var ResizeControls_1 = __webpack_require__(1064);
var shallowCompare = __webpack_require__(441);
var ImageInlineEditor = (function (_super) {
    tslib_1.__extends(ImageInlineEditor, _super);
    function ImageInlineEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPan = function (dx, dy) {
            var model = _this.getModel();
            model.setCropPosition(model.getCropLeft() + dx, model.getCropTop() + dy);
            _this.props.onPan(model.getPayload());
        };
        _this.onCropResize = function (dx, dy, pos) {
            var model = _this.getModel();
            var cropWidth = _this.props.width;
            var cropHeight = _this.props.height;
            switch (pos) {
                case "S":
                    model.resizeCropHeight(cropHeight + dy);
                    break;
                case "E":
                    model.resizeCropWidth(cropWidth + dx);
                    break;
                case "SE":
                    model.resizeCropKeepAspect(cropWidth + dx, cropHeight + dy);
                    break;
                case "SW":
                    model.resizeCropKeepAspect(cropWidth - dx, cropHeight + dy);
                    break;
                case "W":
                    model.resizeCropWidth(cropWidth - dx);
                    break;
                default:
                    break;
            }
            var keepAspect = (pos === "SE" || pos === "SW");
            _this.props.onCropResize(model.getCropWidth(), model.getCropHeight(), model.getPayload(), function () { return _this.getImageData(); }, keepAspect);
        };
        _this.onCropStart = function () {
            if (_this.props.onCropResizeStart) {
                _this.props.onCropResizeStart();
            }
        };
        _this.onCropEnd = function () {
            if (_this.props.onCropResizeEnd) {
                _this.props.onCropResizeEnd();
            }
        };
        _this.onPanEnd = function () {
            if (_this.props.onPanEnd) {
                _this.props.onPanEnd();
            }
        };
        return _this;
    }
    ImageInlineEditor.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var currentPayload = this.props.payload;
        var nextPayload = nextProps.payload;
        // temporary put currentPayload instead of next, because shallowCompare cannot detect deep changes
        nextProps.payload = currentPayload;
        var anyExceptPayloadChanged = shallowCompare(this, nextProps, nextState);
        // TODO use a library like lodash for comparisons, or immutable
        var payloadChanged = (currentPayload.cropXRatio !== nextPayload.cropXRatio
            || currentPayload.cropYRatio !== nextPayload.cropYRatio
            || currentPayload.zoom !== nextPayload.zoom
            || currentPayload.version !== nextPayload.version);
        // put back next payload
        nextProps.payload = nextPayload;
        return anyExceptPayloadChanged || payloadChanged;
    };
    ImageInlineEditor.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("div", null,
            !props.animatedGif ?
                React.createElement(Canvas_1.default, { ref: function (ref) { return _this.canvas = ref; }, top: props.top, left: props.left, width: props.width, height: props.height, model: this.getModel(), sourceImage: props.sourceImage, zIndex: props.zIndex, mediaType: props.mediaType, position: props.position, onPan: this.onPan, onPanStart: props.onPanStart, onPanEnd: this.onPanEnd, showSourceImage: this.props.showSourceImage, allowPan: props.allowPan })
                : null,
            React.createElement(ResizeControls_1.default, { width: props.width, height: props.height, top: props.top, left: props.left, position: props.position, zIndex: props.zIndex + 1, resizeControls: props.resizeControls, onResize: this.onCropResize, onDragStart: this.onCropStart, onDragEnd: this.onCropEnd, outline: props.outline, pointerEventsNone: !props.animatedGif })));
    };
    ImageInlineEditor.prototype.getModel = function () {
        var props = this.props;
        return new Model_1.default(props.payload, props.sourceImage.width, props.sourceImage.height, props.width, props.height, props.maxWidth);
    };
    ImageInlineEditor.prototype.getImageData = function () {
        return this.canvas.exportImageData();
    };
    return ImageInlineEditor;
}(React.Component));
exports.default = ImageInlineEditor;


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var PaintSource_1 = __webpack_require__(1099);
var PaintCrop_1 = __webpack_require__(1071);
var Utils_1 = __webpack_require__(1072);
var Canvas = (function (_super) {
    tslib_1.__extends(Canvas, _super);
    function Canvas(props) {
        var _this = _super.call(this, props) || this;
        _this.doPaint = function () {
            if (_this.canvasNeedsResize()) {
                _this.resizeCanvas();
            }
            var showSource = _this.state.showSourceImage;
            var top = showSource ? Math.round(_this.props.top) : 0;
            var left = showSource ? Math.round(_this.props.left) : 0;
            if (showSource) {
                PaintSource_1.default(_this.canvas, _this.grayscaleCanvas, _this.props.model, left, top);
            }
            var clearCanvas = !showSource;
            PaintCrop_1.PaintCrop(_this.canvas, _this.props.sourceImage, _this.props.model, left, top, 1, clearCanvas);
        };
        _this.handleMouseMove = function (event) {
            if (!_this.state.drag) {
                var showSource = event.pageX >= _this.props.left
                    && event.pageX <= _this.props.left + _this.props.width
                    && event.pageY >= _this.props.top
                    && event.pageY <= _this.props.top + _this.props.height;
                if (!_this.props.showSourceImage && _this.state.showSourceImage !== showSource) {
                    if (_this.props.allowPan) {
                        var state = {};
                        state.showSourceImage = showSource;
                        _this.setState(state);
                    }
                }
            }
        };
        _this.handleMouseDown = function () {
            _this.addDragEvents();
            _this.startDrag();
        };
        _this.handleTouchStart = function (e) {
            // prevent page scroll on image pan
            e.preventDefault();
            _this.addTouchDragEvents();
            _this.startDrag();
        };
        _this.handleDragEnd = function () {
            _this.removeDragEvents();
            _this.stopDrag();
        };
        _this.handleTouchDragEnd = function () {
            _this.removeTouchDragEvents();
            _this.stopDrag();
        };
        _this.handleDrag = function (e) {
            e.preventDefault(); // prevent actions like involuntary text selection
            _this.drag(e.clientX, e.clientY);
        };
        _this.handleTouchDrag = function (e) {
            _this.drag(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
        };
        _this.state = {
            drag: false,
            mx: null,
            my: null,
            showSourceImage: props.showSourceImage
        };
        return _this;
    }
    Canvas.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.showSourceImage !== this.state.showSourceImage) {
            var state = {};
            state.showSourceImage = nextProps.showSourceImage;
            this.setState(state);
        }
    };
    Canvas.prototype.componentDidMount = function () {
        this.initialDocHeight = document.documentElement.scrollHeight;
        this.initialCropHeight = this.props.height;
        this.prevCropHeight = this.initialCropHeight;
        this.createGrayscaleCanvas();
        this.paint();
        this.canvas.addEventListener('mousemove', this.handleMouseMove);
    };
    Canvas.prototype.componentWillUnmount = function () {
        this.removeDragEvents();
        this.removeTouchDragEvents();
        this.canvas.removeEventListener('mousemove', this.handleMouseMove);
    };
    Canvas.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.sourceImage !== prevProps.sourceImage) {
            this.createGrayscaleCanvas();
        }
        this.paint();
        this.prevCropHeight = this.props.height;
    };
    Canvas.prototype.paint = function () {
        this.doPaint();
    };
    Canvas.prototype.exportImageData = function () {
        var tempCanvas = document.createElement("canvas");
        var tempContext = tempCanvas.getContext("2d");
        tempContext.canvas.width = this.props.width;
        tempContext.canvas.height = this.props.height;
        tempContext.drawImage(this.canvas, this.props.left, this.props.top, this.props.width, this.props.height, 0, 0, this.props.width, this.props.height);
        return tempCanvas.toDataURL("image/" + this.props.mediaType.toLowerCase());
    };
    Canvas.prototype.render = function () {
        var _this = this;
        var width = Math.floor(this.props.width);
        var height = Math.floor(this.props.height);
        var model = this.props.model;
        return (React.createElement("canvas", { ref: function (canvas) { _this.canvas = canvas; }, style: this.getStyle().root, onMouseDown: this.props.allowPan ? this.handleMouseDown : null, onTouchStart: this.props.allowPan ? this.handleTouchStart : null, width: this.state.showSourceImage ? document.documentElement.scrollWidth : width, height: this.state.showSourceImage ? document.documentElement.scrollHeight : height, "data-crop-zoom": model.getZoom().toFixed(4), "data-crop-left": model.getCropLeft(), "data-crop-top": model.getCropTop() }));
    };
    Canvas.prototype.resizeCanvas = function () {
        this.canvas.height = this.initialDocHeight + (this.props.height - this.initialCropHeight);
    };
    Canvas.prototype.startDrag = function () {
        var newState = {};
        newState.drag = true;
        newState.mx = null;
        newState.my = null;
        this.setState(newState);
        if (this.props.onPanStart) {
            this.props.onPanStart();
        }
    };
    Canvas.prototype.stopDrag = function () {
        if (this.state.drag) {
            var newState = {};
            newState.drag = false;
            newState.mx = null;
            newState.my = null;
            this.setState(newState);
        }
        if (this.props.onPanEnd) {
            this.props.onPanEnd();
        }
    };
    Canvas.prototype.drag = function (x, y) {
        var _this = this;
        //TODO: See if we can improve raf and let only the flag in raf
        if (this.dragRunning) {
            return;
        }
        this.dragRunning = true;
        requestAnimationFrame(function () {
            var newState = { mx: x, my: y, drag: true };
            if (_this.state.mx && _this.state.my) {
                _this.props.onPan(_this.state.mx - x, _this.state.my - y);
            }
            _this.setState(newState);
            _this.dragRunning = false;
        });
    };
    Canvas.prototype.addDragEvents = function () {
        document.addEventListener('mousemove', this.handleDrag, false);
        document.addEventListener('mouseup', this.handleDragEnd, false);
    };
    Canvas.prototype.addTouchDragEvents = function () {
        document.addEventListener('touchmove', this.handleTouchDrag, false);
        document.addEventListener('touchend', this.handleTouchDragEnd, false);
        document.addEventListener('touchup', this.handleTouchDragEnd, false);
        document.addEventListener('touchcancel', this.handleTouchDragEnd, false);
    };
    Canvas.prototype.removeDragEvents = function () {
        document.removeEventListener('mousemove', this.handleDrag, false);
        document.removeEventListener('mouseup', this.handleDragEnd, false);
    };
    Canvas.prototype.removeTouchDragEvents = function () {
        document.removeEventListener('touchmove', this.handleTouchDrag, false);
        document.removeEventListener('touchend', this.handleTouchDragEnd, false);
        document.removeEventListener('touchup', this.handleTouchDragEnd, false);
        document.removeEventListener('touchcancel', this.handleTouchDragEnd, false);
    };
    Canvas.prototype.createGrayscaleCanvas = function () {
        var tempCanvas = document.createElement("canvas");
        var sourceImage = this.props.sourceImage;
        tempCanvas.width = sourceImage.width;
        tempCanvas.height = sourceImage.height;
        var tempContext = tempCanvas.getContext("2d");
        Utils_1.normalizedContextDrawImage(tempContext, sourceImage, 0, 0, sourceImage.width, sourceImage.height, 0, 0, tempCanvas.width, tempCanvas.height);
        var imageData = tempContext.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
        var data = imageData.data;
        var len = data.length;
        for (var i = 0; i < len; i += 4) {
            var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
            data[i] = brightness; // red
            data[i + 1] = brightness; // green
            data[i + 2] = brightness; // blue
        }
        // overwrite original image
        tempContext.putImageData(imageData, 0, 0);
        this.grayscaleCanvas = tempCanvas;
    };
    // optimization attempt
    // private createZoomedGrayscaleCanvas() {
    //     this.zoomedGrayscaleCanvas = document.createElement("canvas");
    //     const absZoom = this.props.model.getAbsoluteZoom();
    //     this.zoomedGrayscaleCanvas.width = Math.min(
    //         this.grayscaleCanvas.width, this.grayscaleCanvas.width * absZoom
    //     );
    //     this.zoomedGrayscaleCanvas.height = Math.min(
    //         this.grayscaleCanvas.height, this.grayscaleCanvas.height * absZoom
    //     );
    //     normalizedContextDrawImage(
    //         this.zoomedGrayscaleCanvas.getContext("2d"),
    //         this.grayscaleCanvas,
    //         0, 0, this.grayscaleCanvas.width, this.grayscaleCanvas.height,
    //         0, 0, this.zoomedGrayscaleCanvas.width, this.zoomedGrayscaleCanvas.height
    //     );
    // }
    // TODO improve this to detect only really problematic cases, like resize handles are outside of the canvas
    // and only then to adjust canvas height
    Canvas.prototype.canvasNeedsResize = function () {
        var docHeightChanged = this.initialDocHeight !== document.documentElement.scrollHeight;
        var cropHeightChanged = this.prevCropHeight !== this.props.height;
        return this.state.showSourceImage && (cropHeightChanged || docHeightChanged);
    };
    Canvas.prototype.getStyle = function () {
        var model = this.props.model;
        var zoom = model.getAbsoluteZoom();
        var fitWidth = this.props.width + 1 > model.getSourceWidth() * zoom;
        var fitHeight = this.props.height + 1 > model.getSourceHeight() * zoom;
        return {
            root: {
                position: this.props.position,
                left: this.state.showSourceImage ? 0 : this.props.left,
                top: this.state.showSourceImage ? 0 : this.props.top,
                zIndex: this.props.zIndex,
                cursor: (fitWidth && fitHeight) || !this.props.allowPan ? 'default' : 'move',
                transition: 'width 0.3s'
            }
        };
    };
    return Canvas;
}(React.Component));
exports.default = Canvas;


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = __webpack_require__(1072);
function default_1(canvas, grayscaleCanvas, model, cropAbsLeft, cropAbsTop) {
    if (cropAbsLeft === void 0) { cropAbsLeft = 0; }
    if (cropAbsTop === void 0) { cropAbsTop = 0; }
    var absZoom = model.getAbsoluteZoom();
    // optimization attempt
    // let destWidth = grayscaleCanvas.width;
    // let destHeight = grayscaleCanvas.height;
    // if (absZoom > 1) {
    // destWidth = grayscaleCanvas.width * absZoom;
    // destHeight = grayscaleCanvas.height * absZoom;
    // }
    var context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.globalAlpha = 0.6;
    Utils_1.normalizedContextDrawImage(context, grayscaleCanvas, 0, 0, grayscaleCanvas.width, grayscaleCanvas.height, cropAbsLeft - model.getCropLeft(), cropAbsTop - model.getCropTop(), grayscaleCanvas.width * absZoom, grayscaleCanvas.height * absZoom);
    context.globalAlpha = 1;
}
exports.default = default_1;


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;

var _Popover2 = __webpack_require__(387);

var _Popover3 = _interopRequireDefault(_Popover2);

var _PopoverAnimationVertical2 = __webpack_require__(1055);

var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Popover = _Popover3.default;
exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
exports.default = _Popover3.default;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var CKEditorEditView_1 = __webpack_require__(1016);
var AllCKEditorButtonsConfig_1 = __webpack_require__(1019);
var TextFormat_1 = __webpack_require__(1059);
var format_align_left_1 = __webpack_require__(994);
var format_list_bulleted_1 = __webpack_require__(1026);
var format_indent_increase_1 = __webpack_require__(1030);
var content_paste_1 = __webpack_require__(1033);
var EditViewTextBasics = (function (_super) {
    tslib_1.__extends(EditViewTextBasics, _super);
    function EditViewTextBasics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditViewTextBasics.prototype.render = function () {
        var items = [];
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.FontSize);
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.DiyTextColor);
        items.push({
            groupProps: {
                label: l10n_1.default('module.text.buttongroups.format'),
                Icon: React.createElement(TextFormat_1.TextFormat, null),
                dataTestId: "imageWithText-module-format-group"
            },
            items: [
                AllCKEditorButtonsConfig_1.allCKEditorItems.Bold,
                AllCKEditorButtonsConfig_1.allCKEditorItems.Italic,
                AllCKEditorButtonsConfig_1.allCKEditorItems.Underline,
                AllCKEditorButtonsConfig_1.allCKEditorItems.Strike,
                AllCKEditorButtonsConfig_1.allCKEditorItems.Superscript,
                AllCKEditorButtonsConfig_1.allCKEditorItems.Subscript,
                AllCKEditorButtonsConfig_1.allCKEditorItems.RemoveFormat
            ]
        });
        items.push({
            groupProps: {
                label: l10n_1.default('module.text.buttongroups.align'),
                Icon: React.createElement(format_align_left_1.default, null),
                dataTestId: "imageWithText-module-align-group"
            },
            items: [AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyLeft, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyCenter, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyRight, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyBlock]
        });
        items.push({
            groupProps: {
                label: l10n_1.default('module.text.buttongroups.list'),
                Icon: React.createElement(format_list_bulleted_1.default, null),
                dataTestId: "imageWithText-module-list-group"
            },
            items: [AllCKEditorButtonsConfig_1.allCKEditorItems.NumberedList, AllCKEditorButtonsConfig_1.allCKEditorItems.BulletedList]
        });
        items.push({
            groupProps: {
                label: l10n_1.default('module.text.buttongroups.indent'),
                Icon: React.createElement(format_indent_increase_1.default, null),
                dataTestId: "imageWithText-module-indent-group"
            },
            items: [AllCKEditorButtonsConfig_1.allCKEditorItems.Outdent, AllCKEditorButtonsConfig_1.allCKEditorItems.Indent]
        });
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.Link, AllCKEditorButtonsConfig_1.allCKEditorItems.Unlink);
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TextBasics", items: items })));
    };
    return EditViewTextBasics;
}(React.Component));
exports.EditViewTextBasics = EditViewTextBasics;
var EditViewTextFormat = (function (_super) {
    tslib_1.__extends(EditViewTextFormat, _super);
    function EditViewTextFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditViewTextFormat.prototype.render = function () {
        var items = [];
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.Format);
        items.push({
            groupProps: {
                label: l10n_1.default('module.text.buttongroups.paste'),
                Icon: React.createElement(content_paste_1.default, null),
                dataTestId: "imageWithText-module-paste-group"
            },
            items: [AllCKEditorButtonsConfig_1.allCKEditorItems.Paste, AllCKEditorButtonsConfig_1.allCKEditorItems.PasteFromWord]
        });
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.TextStyles(this.props.module));
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.SourceDialog);
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TextFormat", items: items })));
    };
    return EditViewTextFormat;
}(React.Component));
exports.EditViewTextFormat = EditViewTextFormat;


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var ModulWithImage_1 = __webpack_require__(1068);
var ModulImageSubtitle = (function (_super) {
    tslib_1.__extends(ModulImageSubtitle, _super);
    function ModulImageSubtitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helpArticleId = 'imagesubtitle';
        return _this;
    }
    /**
     * @override
     * purely for typing purposes
     */
    ModulImageSubtitle.prototype.getData = function () {
        return this.data;
    };
    ModulImageSubtitle.prototype.setFullwidth = function (fullwidth) {
        this.modul.toggleClass('diyfeLiveArea', !fullwidth);
    };
    ModulImageSubtitle.prototype.getSaveData = function () {
        var state = this.getData();
        var data = _super.prototype.getSaveData.call(this);
        var newData = Object.assign(data, {
            isFullwidth: state.isFullwidth ? 1 : 0
        });
        return newData;
    };
    return ModulImageSubtitle;
}(ModulWithImage_1.default));
exports.default = ModulImageSubtitle;


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var ModulWithRedux_1 = __webpack_require__(493);
var l10n_1 = __webpack_require__(18);
var WebView_1 = __webpack_require__(1104);
var diyLightTheme = __webpack_require__(241);
var EditView_1 = __webpack_require__(1105);
var ModuleInlineEditor_1 = __webpack_require__(986);
var index_1 = __webpack_require__(536);
var AppRegistry_1 = __webpack_require__(190);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulTabelle = (function (_super) {
    tslib_1.__extends(ModulTabelle, _super);
    function ModulTabelle(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.hasUndoRedo = true;
        _this.helpArticleId = "table";
        _this.CONFIG_MIN_WIDTH = 545;
        _this.inlineEditor = null;
        _this.undoHandler = function () {
            _this.inlineEditor.getEditor().execCommand('undo');
        };
        _this.redoHandler = function () {
            _this.inlineEditor.getEditor().execCommand('redo');
        };
        _this.ckEditorPromise = new Promise(function (resolve, reject) {
            _this.ckEditorPromiseResolve = resolve;
        });
        return _this;
    }
    ModulTabelle.prototype.getInPlaceEditViewClass = function () {
        return null;
    };
    ModulTabelle.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    ModulTabelle.prototype.getCKEditorPromise = function () {
        return this.ckEditorPromise;
    };
    ModulTabelle.prototype.loadData = function (data) {
        this.data = data;
        this.data.text = this.getContentElement().querySelector('.tableContainer').innerHTML;
    };
    /**
     * @override
     * strictly for typing purposes
     */
    ModulTabelle.prototype.getData = function () {
        return this.data;
    };
    ModulTabelle.prototype.initCKEditor = function (textElement) {
        var _this = this;
        this.inlineEditor = new ModuleInlineEditor_1.default(this, textElement);
        this.inlineEditor.startEditing({
            // this setting is primary used for setting the z-index
            // of CKEditor dialogs, and these should be the same as
            // standard Material UI dialogs zIndex
            baseFloatZIndex: diyLightTheme.zIndex.dialog,
            toolbar: 'Table',
            toolbar_Table: this.getCkeditorToolbarConfig(),
            diyhelpLabel: 'table',
            extraPlugins: 'tableresize',
            toolbarStartupExpanded: true,
            toolbarCanCollapse: false,
            allowedContent: !this.getData().supports.textSanitizeHtml,
            pasteFromWordRemoveFontStyles: false,
            pasteFromWordRemoveStyles: false,
            hideToolbar: true
        });
        this.inlineEditor.editor.on('pluginsLoaded', function (ev) {
            ev.editor.focus();
        });
        this.inlineEditor.editor.on('instanceReady', function () {
            _this.ckEditorPromiseResolve(_this.inlineEditor.getEditor());
            var store = getStore();
            _this.inlineEditor.editor.getCommand('undo').on('state', function () {
                store.dispatch(index_1.setUndoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
            _this.inlineEditor.editor.getCommand('redo').on('state', function () {
                store.dispatch(index_1.setRedoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
        });
    };
    ModulTabelle.prototype.getActionBarTabs = function () {
        return [
            {
                label: l10n_1.default('module.table.tabs.basic'),
                content: this.getConnectedComponent(EditView_1.TableEditViewBasics)
            },
            {
                label: l10n_1.default('module.table.tabs.textFormat'),
                content: this.getConnectedComponent(EditView_1.TableEditViewFormatText)
            },
            {
                label: l10n_1.default('module.table.tabs.advanced'),
                content: this.getConnectedComponent(EditView_1.TableEditViewAdvanced)
            }
        ];
    };
    ModulTabelle.prototype.getSaveData = function () {
        var data;
        var i;
        var isSaveDataReplaced = false;
        data = _super.prototype.getSaveData.call(this);
        // if a `text` property is present then overrite it //
        for (i = 0; i < data.length; i++) {
            if (data[i].name === 'text') {
                data[i].value = this.inlineEditor.getHtmlData();
                isSaveDataReplaced = true;
            }
        }
        // if it isn't found, we add it //
        if (!isSaveDataReplaced) {
            data.text = this.inlineEditor.getHtmlData();
        }
        return data;
    };
    /**
     * @override
     */
    ModulTabelle.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        this.inlineEditor.stopEditing();
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
    };
    ModulTabelle.prototype.getCkeditorToolbarConfig = function () {
        return [
            ['FontSize'],
            ['Undo', 'Redo'],
            ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['DiyLink', 'DiyUnlink'],
            ['DiyTextColor'],
            ['PasteText', 'RemoveFormat'],
            ['Sourcedialog', 'PasteFromWord', 'SelectAll'],
            ['HelpButton'],
            ['CloseButton'],
            ['Image'],
            '/',
            ['Table'], ['TableMixed'],
            ['TableInsertRowBefore', 'TableInsertRowAfter', 'TableDeleteRow'],
            ['TableInsertColumnBefore', 'TableInsertColumnAfter', 'TableDeleteColumn'],
            ['TableSplitVertically', 'TableSplitHorizontally'],
            ['TableMergeRight', 'TableMergeDown', 'TableMerge']
        ];
    };
    return ModulTabelle;
}(ModulWithRedux_1.default));
exports.default = ModulTabelle;


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var TableWebView = (function (_super) {
    tslib_1.__extends(TableWebView, _super);
    function TableWebView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableWebView.prototype.componentDidMount = function () {
        this.props.module.initCKEditor(this.tableContainer);
    };
    TableWebView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { id: "table_" + this.props.module.moduleId },
            React.createElement("div", { ref: function (tableContainer) { return _this.tableContainer = tableContainer; }, className: "tableContainer", id: "table_" + this.props.module.moduleId + "_container", dangerouslySetInnerHTML: { __html: this.props.payload.text } }),
            React.createElement("div", { className: "c" })));
    };
    return TableWebView;
}(React.Component));
exports.default = TableWebView;


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var CKEditorEditView_1 = __webpack_require__(1016);
var AllCKEditorButtonsConfig_1 = __webpack_require__(1019);
var format_align_left_1 = __webpack_require__(994);
var format_list_bulleted_1 = __webpack_require__(1026);
var format_indent_increase_1 = __webpack_require__(1030);
var content_paste_1 = __webpack_require__(1033);
var TextFormat_1 = __webpack_require__(1059);
var TableInsert_1 = __webpack_require__(1106);
var TableRemove_1 = __webpack_require__(1107);
var TableMerge_1 = __webpack_require__(1108);
var TableSplit_1 = __webpack_require__(1109);
var TableEditViewBasics = (function (_super) {
    tslib_1.__extends(TableEditViewBasics, _super);
    function TableEditViewBasics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableEditViewBasics.prototype.render = function () {
        var items = [
            AllCKEditorButtonsConfig_1.allCKEditorItems.TableMixed,
            {
                groupProps: {
                    label: l10n_1.default('module.table.buttongroups.tableInsert'),
                    Icon: React.createElement(TableInsert_1.TableInsert, null),
                    collapsed: true,
                    dataTestId: "table-module-insert-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.RowInsertBefore, AllCKEditorButtonsConfig_1.allCKEditorItems.RowInsertAfter, AllCKEditorButtonsConfig_1.allCKEditorItems.ColumnInsertBefore, AllCKEditorButtonsConfig_1.allCKEditorItems.ColumnInsertAfter]
            },
            {
                groupProps: {
                    label: l10n_1.default('module.table.buttongroups.tableRemove'),
                    Icon: React.createElement(TableRemove_1.TableRemove, null),
                    collapsed: true,
                    dataTestId: "table-module-remove-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.RowDelete, AllCKEditorButtonsConfig_1.allCKEditorItems.ColumnDelete]
            },
            {
                groupProps: {
                    label: l10n_1.default('module.table.buttongroups.tableMerge'),
                    Icon: React.createElement(TableMerge_1.TableMerge, null),
                    collapsed: true,
                    dataTestId: "table-module-merge-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.CellMergeRight, AllCKEditorButtonsConfig_1.allCKEditorItems.CellMergeDown, AllCKEditorButtonsConfig_1.allCKEditorItems.CellMerge]
            },
            {
                groupProps: {
                    label: l10n_1.default('module.table.buttongroups.tableSplit'),
                    Icon: React.createElement(TableSplit_1.TableSplit, null),
                    collapsed: true,
                    dataTestId: "table-module-split-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.CellHorizontalSplit, AllCKEditorButtonsConfig_1.allCKEditorItems.CellVerticalSplit]
            },
        ];
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TableBasics", items: items })));
    };
    return TableEditViewBasics;
}(React.Component));
exports.TableEditViewBasics = TableEditViewBasics;
var TableEditViewFormatText = (function (_super) {
    tslib_1.__extends(TableEditViewFormatText, _super);
    function TableEditViewFormatText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableEditViewFormatText.prototype.render = function () {
        var items = [
            AllCKEditorButtonsConfig_1.allCKEditorItems.FontSize,
            AllCKEditorButtonsConfig_1.allCKEditorItems.DiyTextColor,
            {
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.format'),
                    Icon: React.createElement(TextFormat_1.TextFormat, null),
                    dataTestId: "table-module-format-menu"
                },
                items: [
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Bold,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Italic,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Underline,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Strike,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Superscript,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.Subscript,
                    AllCKEditorButtonsConfig_1.allCKEditorItems.RemoveFormat
                ]
            },
            {
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.align'),
                    Icon: React.createElement(format_align_left_1.default, null),
                    dataTestId: "table-module-align-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyLeft, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyCenter, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyRight, AllCKEditorButtonsConfig_1.allCKEditorItems.JustifyBlock]
            },
            {
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.list'),
                    Icon: React.createElement(format_list_bulleted_1.default, null),
                    dataTestId: "table-module-list-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.NumberedList, AllCKEditorButtonsConfig_1.allCKEditorItems.BulletedList]
            },
            {
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.indent'),
                    Icon: React.createElement(format_indent_increase_1.default, null),
                    dataTestId: "table-module-indent-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.Outdent, AllCKEditorButtonsConfig_1.allCKEditorItems.Indent]
            },
            AllCKEditorButtonsConfig_1.allCKEditorItems.Link,
            AllCKEditorButtonsConfig_1.allCKEditorItems.Unlink
        ];
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TableTextFormat", items: items })));
    };
    return TableEditViewFormatText;
}(React.Component));
exports.TableEditViewFormatText = TableEditViewFormatText;
var TableEditViewAdvanced = (function (_super) {
    tslib_1.__extends(TableEditViewAdvanced, _super);
    function TableEditViewAdvanced() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableEditViewAdvanced.prototype.render = function () {
        var items = [
            {
                groupProps: {
                    label: l10n_1.default('module.text.buttongroups.paste'),
                    Icon: React.createElement(content_paste_1.default, null),
                    dataTestId: "table-module-paste-menu"
                },
                items: [AllCKEditorButtonsConfig_1.allCKEditorItems.Paste, AllCKEditorButtonsConfig_1.allCKEditorItems.PasteFromWord]
            },
            AllCKEditorButtonsConfig_1.allCKEditorItems.SourceDialog
        ];
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "TableAdvanced", items: items })));
    };
    return TableEditViewAdvanced;
}(React.Component));
exports.TableEditViewAdvanced = TableEditViewAdvanced;


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var TableInsert = (function (_super) {
    tslib_1.__extends(TableInsert, _super);
    function TableInsert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableInsert.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fillRule: 'evenodd',
            fill: this.context.muiTheme.palette.iconPositiveColor,
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M4,4H18V8H4V4ZM4,16H18v4H4V16Z" }),
            React.createElement("path", { style: style2, d: "M9,15L5,12,9,9v6Zm2-5H21v4H11V10Z" })));
    };
    return TableInsert;
}(React.Component));
TableInsert.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.TableInsert = TableInsert;


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var TableRemove = (function (_super) {
    tslib_1.__extends(TableRemove, _super);
    function TableRemove() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRemove.prototype.render = function () {
        var style1 = {
            fillRule: 'evenodd'
        };
        var style2 = {
            fill: this.context.muiTheme.palette.iconNegativeColor,
            fillRule: 'evenodd'
        };
        /* tslint:disable:max-line-length */
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M7,4H21V8H7V4ZM7,16H21v4H7V16Z" }),
            React.createElement("path", { style: style2, d: "M14,9l2,2a27,27,0,0,0,2-2,6.743,6.743,0,0,0,1,1l-2,2,2,2-1,1-2-2-2,2-1-1,2-2-2-2ZM3,10h8v4H3V10Z" })));
        /* tslint:enable:max-line-length */
    };
    return TableRemove;
}(React.Component));
TableRemove.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.TableRemove = TableRemove;


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var TableMerge = (function (_super) {
    tslib_1.__extends(TableMerge, _super);
    function TableMerge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableMerge.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
        };
        var style2 = {
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("rect", { style: style1, x: "5", y: "10", width: "14", height: "4" }),
            React.createElement("path", { style: style2, d: "M5,4h6V8H5V4Zm8,0h6V8H13V4ZM5,16h6v4H5V16Zm8,0h6v4H13V16Z" })));
    };
    return TableMerge;
}(React.Component));
TableMerge.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.TableMerge = TableMerge;


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var SvgIcon_1 = __webpack_require__(407);
var TableSplit = (function (_super) {
    tslib_1.__extends(TableSplit, _super);
    function TableSplit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableSplit.prototype.render = function () {
        var style1 = {
            fill: this.context.muiTheme.palette.iconPositiveColor,
            fillRule: 'evenodd'
        };
        var style2 = {
            fillRule: 'evenodd'
        };
        return (React.createElement(SvgIcon_1.default, tslib_1.__assign({}, this.props),
            React.createElement("path", { style: style1, d: "M5,15L1,12,5,9v6Zm14,0,4-3L19,9v6ZM5,10h6v4H5V10Zm8,0h6v4H13V10Z" }),
            React.createElement("path", { style: style2, d: "M5,4H19V8H5V4ZM5,16H19v4H5V16Z" })));
    };
    return TableSplit;
}(React.Component));
TableSplit.contextTypes = {
    muiTheme: React.PropTypes.object,
};
exports.TableSplit = TableSplit;


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
/**
 * Delicious module class
 */
var ModulDelicious = (function (_super) {
    tslib_1.__extends(ModulDelicious, _super);
    function ModulDelicious(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        $("#b1_" + _this.moduleId).diy_radiobox();
        $("#b2_" + _this.moduleId).diy_radiobox();
        $("#s1_" + _this.moduleId).diy_radiobox();
        $("#s2_" + _this.moduleId).diy_radiobox();
        $("#s3_" + _this.moduleId).diy_radiobox();
        var tagSeparatorInfoBox = $('.tag-separator-info-box', _this.getEditorContainer());
        if (tagSeparatorInfoBox.length > 0) {
            var tagSepInfoText = tagSeparatorInfoBox.html();
            tagSeparatorInfoBox.html('');
            tagSeparatorInfoBox.quickhelp(tagSepInfoText, false, true, true);
        }
        _this.form = _this.getEditorContainer().find('form').diy_form({
            errorTarget: '.form-error'
        });
        return _this;
    }
    return ModulDelicious;
}(Modul_1.default));
exports.default = ModulDelicious;


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
/**
 * Rss module class
 */
var ModulRss = (function (_super) {
    tslib_1.__extends(ModulRss, _super);
    function ModulRss(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        $("#h1_" + _this.moduleId).diy_radiobox();
        $("#h2_" + _this.moduleId).diy_radiobox();
        $("#b1_" + _this.moduleId).diy_radiobox();
        $("#b2_" + _this.moduleId).diy_radiobox();
        $("#d1_" + _this.moduleId).diy_radiobox();
        $("#d2_" + _this.moduleId).diy_radiobox();
        $("#v1_" + _this.moduleId).diy_radiobox();
        $("#v2_" + _this.moduleId).diy_radiobox();
        return _this;
    }
    return ModulRss;
}(Modul_1.default));
exports.default = ModulRss;


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
/**
 * Video module class
 */
var ModulVideo = (function (_super) {
    tslib_1.__extends(ModulVideo, _super);
    function ModulVideo(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        $('input.videoUrlField.mod_video_' + moduleId).click(function () {
            Modul_1.default.getInstance(moduleId).modVideoSetInputFocus(this);
        });
        $('input.videoUrlField.mod_video_' + moduleId).keypress(function () {
            Modul_1.default.getInstance(moduleId).modVideoSetInputFocus(this);
        });
        $('input.mod_video_' + moduleId + '[name=videoType]').change(function () {
            var textfieldname = $(this).val() + '_url';
            $('input.mod_video_' + moduleId + '[name=' + textfieldname + ']').focus();
        });
        $('input#videoType_youtube_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'youtube',
            cls: 'no-label'
        });
        $('input#videoType_myvideo_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'myvideo',
            cls: 'no-label'
        });
        $('input#videoType_sevenload_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'sevenload',
            cls: 'no-label'
        });
        $('input#videoType_blip_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'blip',
            cls: 'no-label'
        });
        return _this;
    }
    ModulVideo.prototype.modVideoSetInputFocus = function (objekt) {
        var radioBtnId = 'videoType_'
            + $(objekt).attr('name').replace('_url', '');
        var radioBtn = $('#' + radioBtnId + '_' + this.moduleId);
        radioBtn.prop('checked', true);
        radioBtn.change();
    };
    return ModulVideo;
}(Modul_1.default));
exports.default = ModulVideo;


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
/* tslint:disable:variable-name */
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
var l10n = __webpack_require__(18);
/**
 * Google Maps module
 */
var ModulGooglemaps = (function (_super) {
    tslib_1.__extends(ModulGooglemaps, _super);
    function ModulGooglemaps(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        /**
         * Achtung: Die im Code benutzten Variablen Gp und Tp sind
         * undokumentiert. Gp ist ein Attribut der Marker-Objekte und trägt
         * einen String mit dem internen Namen; Tp ist ein Attribut des
         * Karten-Objekts und trägt ein Array mit allen Overlay-Objekten,
         * die auf der Karte platziert sind. Die Variablennamen Gp und Tp
         * sind generiert, das heißt, dass sie bei jedem Googlemaps-Update
         * einen neuen Namen erhalten können. Wenn wir unser Modul auf eine
         * neue Version updaten, müssen wir also im DOM nach den jeweils
         * neuen Namen suchen.
         */
        _this.map = null;
        _this.marker = null;
        _this.markers = {};
        // Array mit GoogleMaps Pointer Namen für Marker
        _this.marker_Gp = [];
        _this.marker_link = '';
        _this.geocoder = null;
        // Array mit allen Marker-Daten, wegen besserer
        // Bearbeitungsmöglichkeiten
        // eindimensional gehalten. Wird pro Marker wie folgt gefüllt:
        // [0] Interner Name String
        // [1] Titel String
        // [2] Beschreibung String
        // [3] Position Array(int, int)
        // [4] Link String
        // [5] Adresse String
        _this.marker_array = [];
        // Höhen- und Breitengrad der letzten Maps-Suche
        _this.saved_pos = null;
        // Maximalbreite eines InfoWindows
        _this.maxwidth = 380;
        // Standardname einer Ortsmarke
        _this.stdmarker = null;
        // Schränkt den Drag-Listener des Markers auf einen Durchgang pro
        // Drag ein
        _this.listenondrag = true;
        // Variablen für die Kontrollelemente
        _this.hasInitialAddress = false;
        $('.gmapsearch-button').button();
        $('#mapRoutes_' + moduleId).diy_checkbox();
        $('.gmarker-center').button({
            icons: {
                primary: 'ui-icon-gmarker'
            }
        });
        $('.gmarker-search').button({});
        $("input#maps_search_" + moduleId).diy_textField();
        _this.form = $("input#maps_search_" + moduleId).closest('form').diy_form({
            messageTarget: '.form-error'
        });
        var initialAddress = $('input#maps_search_initialAddress_' + moduleId).val();
        if (typeof initialAddress !== 'undefined' && initialAddress !== null && initialAddress.length > 0) {
            $('#maps_search_' + moduleId).val(initialAddress);
            _this.hasInitialAddress = true;
        }
        ;
        return _this;
    }
    ModulGooglemaps.prototype.save = function () {
        // Beim Speichern des Moduls die Daten für den
        // Modul-Update-Prozess in versteckte Input-Felder stecken
        //height
        var mapHeight = $('#mapHeight_' + this.moduleId).val();
        $('#hidden_mapHeight_' + this.moduleId).val(mapHeight);
        var position = this.map.getCenter().lat() + ',' +
            this.map.getCenter().lng() + ',' + this.map.getZoom();
        for (var i = 0; i < this.marker_array.length; i += 6) {
            this.marker_array[i + 3][0] = "" +
                this.marker_array[i + 3][0];
            this.marker_array[i + 3][1] = "" +
                this.marker_array[i + 3][1];
        }
        var markers = JSON.stringify(this.marker_array);
        $('#position_' + this.moduleId).val(position);
        $('#markers_' + this.moduleId).val(markers);
        if ($('#mapcontrolZoom_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_control_' + this.moduleId).val(1);
        }
        if ($('#maptype_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_type_' + this.moduleId).val(1);
        }
        if ($('#mapscale_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_scale_' + this.moduleId).val(1);
        }
        if ($('#mapoverview_' + this.moduleId).hasClass('map-control-active')) {
            $('#map_overview_' + this.moduleId).val(1);
        }
        var tempmodule = this;
        //remember map type
        var mapType = this.map.getMapTypeId();
        var mapTypeId = 0;
        switch (mapType) {
            case google.maps.MapTypeId.ROADMAP:
                mapTypeId = 0;
                break;
            case google.maps.MapTypeId.SATELLITE:
                mapTypeId = 1;
                break;
            case google.maps.MapTypeId.HYBRID:
                mapTypeId = 2;
                break;
            case google.maps.MapTypeId.TERRAIN:
                mapTypeId = 3;
                break;
            default:
                break;
        }
        $('#map_type_default_' + tempmodule.moduleId).val(mapTypeId);
        if ($('#mapRoutes_' + this.moduleId).prop('checked') === true) {
            $('#hidden_mapRoutes_' + this.moduleId).val(1);
        }
        else {
            $('#hidden_mapRoutes_' + this.moduleId).val(0);
        }
        return _super.prototype.save.call(this);
    };
    ModulGooglemaps.prototype.getMapControlsPreset = function (preset) {
        var mapControlsPresets = {
            removeZoomMapControls: {
                zoomControl: false
            },
            addZoomMapControls: {
                zoomControl: true
            },
            removeMapTypesControls: {
                mapTypeControl: false
            },
            addMapTypesControls: {
                mapTypeControl: true
            },
            removeScaleControls: {
                scaleControl: false
            },
            addScaleControls: {
                scaleControl: true
            },
            removeMapOverviewControls: {
                overviewMapControl: false
            },
            addMapOverviewControls: {
                overviewMapControl: true,
                overviewMapControlOptions: { opened: true }
            }
        };
        return mapControlsPresets[preset];
    };
    ModulGooglemaps.prototype.setMapControls = function (options) {
        if (this.map == null) {
            return false;
        }
        this.map.setOptions(options);
        return true;
    };
    //resets the map controls according to the elements in editor
    ModulGooglemaps.prototype.resetMapControls = function () {
        var options = {};
        var otherControlsEl = $('.map_nav_option a', this.getEditorContainer());
        if (otherControlsEl.length) {
            var s_1 = this;
            otherControlsEl.each(function (index, element) {
                var $el = $(element);
                var controls = $el.attr('data-mapPreset');
                if ($el.hasClass('map-control-active')) {
                    controls = 'add' + controls;
                }
                else {
                    controls = 'remove' + controls;
                }
                $.extend(options, s_1.getMapControlsPreset(controls));
            });
        }
        this.setMapControls(options);
    };
    ModulGooglemaps.prototype.selectOption = function (id) {
        $('.map_nav_options a', this.getEditorContainer()).each(function (index, el) {
            var $el = $(el);
            var mapPreset = $el.attr('data-mapPreset');
            if (mapPreset === id) {
                //set this one as active
                $el.addClass('map-control-active');
            }
            else {
                //this one is not active
                $el.removeClass('map-control-active');
            }
        });
        this.setMapControls(this.getMapControlsPreset(id));
    };
    ModulGooglemaps.prototype.clickOption = function (id) {
        //get the element
        var el = $('.map_nav_option a.' + id, this.getEditorContainer());
        var mapPreset = el.attr('data-mapPreset');
        if (el.hasClass('map-control-active')) {
            el.removeClass('map-control-active');
            mapPreset = 'remove' + mapPreset;
        }
        else {
            el.addClass('map-control-active');
            mapPreset = 'add' + mapPreset;
        }
        this.setMapControls(this.getMapControlsPreset(mapPreset));
    };
    ModulGooglemaps.prototype.loadMap = function () {
        var this_module = this;
        var data_url = systemurl + 'app/module/googlemaps/fetchdata';
        var post_data = 'moduleId=' + this.moduleId;
        $.post(data_url, post_data, function (response) {
            this_module.stdmarker = response.stdmarker;
            //prepare the options for the map
            var map_lat = parseFloat(response.position[0]);
            var map_lng = parseFloat(response.position[1]);
            var map_zoom = parseInt(response.position[2], 10);
            //TODO: check that all old map types are available
            /**
             * old map type constants vs. new ones
             *
             * G_NORMAL_MAP     <->     ROADMAP
             * G_SATELLITE_MAP  <->     SATELLITE
             * G_HYBRID_MAP     <->     HYBRID
             * G_PHYSICAL_MAP   <->     TERRAIN
             */
            var map_type_id = google.maps.MapTypeId.ROADMAP;
            switch (parseInt(response.maptype, 10)) {
                case 0:
                    map_type_id = google.maps.MapTypeId.ROADMAP;
                    break;
                case 1:
                    map_type_id = google.maps.MapTypeId.SATELLITE;
                    break;
                case 2:
                    map_type_id = google.maps.MapTypeId.HYBRID;
                    break;
                case 3:
                    map_type_id = google.maps.MapTypeId.TERRAIN;
                    break;
                default:
                    break;
            }
            //init the map
            var map_canvas = document.getElementById('map_canvas_' + this_module.moduleId);
            var map_options = {
                center: new google.maps.LatLng(map_lat, map_lng),
                zoom: map_zoom,
                mapTypeId: map_type_id,
                scrollwheel: true,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP,
                        google.maps.MapTypeId.SATELLITE,
                        google.maps.MapTypeId.HYBRID,
                        google.maps.MapTypeId.TERRAIN],
                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
                },
                streetViewControl: false
            };
            this_module.map = new google.maps.Map(map_canvas, map_options);
            //change controls
            this_module.resetMapControls();
            //geocoder
            this_module.geocoder = new google.maps.Geocoder();
            this_module.marker_array = response.markers;
            this_module
                .loadMarkers(response.infowindows);
            // Standardnamen einer Ortsmarke
            // speichern (per AJAX wegen
            // Übersetzungen)
            this_module.stdmarker = response.stdmarker;
            if (this_module.hasInitialAddress) {
                this_module.searchMap();
            }
        }, 'json');
    };
    ModulGooglemaps.prototype.changeCopyrightPosition = function (tempmodule) {
        if ($('#map_canvas_' + tempmodule.moduleId).find('#logocontrol').next('div').length > 0) {
            $('#map_canvas_' + tempmodule.moduleId).find('#logocontrol').next('div').css({
                'white-space': 'normal',
                'margin-left': '60px'
            });
        }
        else {
            setTimeout(function () {
                tempmodule.changeCopyrightPosition(tempmodule);
            }, 100);
        }
    };
    ModulGooglemaps.prototype.searchMap = function () {
        //v3:
        //make sure the error is off.
        this.form.diy_form('clearErrors');
        var map_search_error_msg = $("#maps_search_error_" + this.moduleId).text();
        //search the location
        var addrToSearch = $('#maps_search_' + this.moduleId).val();
        if (addrToSearch === '') {
            this.form.diy_form('addError', map_search_error_msg, '#maps_search_' + this.moduleId);
            return;
        }
        var geoReq = { 'address': addrToSearch };
        var this_module = this;
        this.geocoder.geocode(geoReq, function (results, status) {
            //if success, go to that location, and show search marker....
            if (status === google.maps.GeocoderStatus.OK) {
                var accuracy = results[0].geometry.location_type;
                switch (accuracy) {
                    case google.maps.GeocoderLocationType.GEOMETRIC_CENTER:
                        this_module.map.setZoom(12);
                        break;
                    case google.maps.GeocoderLocationType.RANGE_INTERPOLATED:
                        this_module.map.setZoom(14);
                        break;
                    case google.maps.GeocoderLocationType.ROOFTOP:
                        this_module.map.setZoom(16);
                        break;
                    //case google.maps.GeocoderLocationType.APPROXIMATE:
                    default:
                        this_module.map.setZoom(10);
                        break;
                }
                //decide zoom from accuracy
                //center to that location
                this_module.map.setCenter(results[0].geometry.location);
                //temp-save the position
                this_module.saved_pos = results[0].geometry.location;
                $('#maps_search_' + this_module.moduleId)
                    .val(results[0].formatted_address);
                $('#maps_search_marker_' + this_module.moduleId).show();
                $('#maps_search_form_' + this_module.moduleId).show();
            }
            else {
                //if fail, show the error, hide search marker
                this_module.form.diy_form('addError', map_search_error_msg, '#maps_search_' + this_module.moduleId);
                $('#maps_search_marker_' + this_module.moduleId).hide();
                $('#maps_search_form_' + this_module.moduleId).hide();
            }
        });
        return; //end v3
    };
    ModulGooglemaps.prototype.setMarker = function (latlng) {
        var this_module = this;
        for (var k in this.markers) {
            if (this.markers.hasOwnProperty(k)) {
                this.markers[k].info_window.close();
            }
        }
        //v3:
        var address = '';
        var title;
        if (!latlng) {
            latlng = this.map.getCenter();
            title = this.stdmarker;
        }
        else {
            title = $('#maps_search_' + this.moduleId).val();
            address = title;
            $('#maps_search_' + this.moduleId).val('');
            $('#maps_search_marker_' + this.moduleId).hide();
            $('#maps_search_form_' + this_module.moduleId).hide();
        }
        //add the marker
        var marker = new google.maps.Marker({
            map: this.map,
            position: latlng,
            clickable: true,
            draggable: true
        });
        //info window
        var info_window = new google.maps.InfoWindow({
            maxWidth: this.maxwidth
        });
        this.getHtml(1, title, '', '', address, latlng.lat(), latlng.lng(), function (html) {
            info_window.setContent(html);
            info_window.open(this_module.map, marker);
            this_module.infoWindowContentUI();
        });
        //do some other shit to keep this monster working
        marker.info_window = info_window;
        this.marker = marker;
        this.marker_link = '';
        var nextIndex = this.getMapNextIndex();
        this.markers[nextIndex] = marker;
        this.marker_Gp.push('Gp' + nextIndex);
        this.marker.Gp = this.marker_Gp[this.marker_Gp.length - 1];
        this.marker_array.push(this.marker_Gp[this.marker_Gp.length - 1], title, '', [
            latlng.lat(),
            latlng.lng()
        ], '', address);
        this.updateMarkerList();
        this.addMarkerListeners(this.marker);
        //show the window on click
        google.maps.event.addListener(marker, 'click', function () {
            //close other windows
            for (var k in this_module.markers) {
                if (this_module.markers.hasOwnProperty(k)) {
                    this_module.markers[k].info_window.close();
                }
            }
            this_module.marker = marker;
            info_window.open(this_module.map, marker);
            this_module.infoWindowContentUI();
        });
        return; //end v3
    };
    ModulGooglemaps.prototype.getMapNextIndex = function () {
        if (this.marker_Gp.length === 0) {
            return 0;
        }
        return parseInt(this.marker_Gp[this.marker_Gp.length - 1].substr(2), 10) + 1;
    };
    ModulGooglemaps.prototype.saveMarkerContent = function () {
        /* Marker-Inhalt im Array updaten */
        var index = this.marker_array.indexOf(this.marker.Gp);
        this.marker_array[index + 1] = $('#marker_title').val();
        this.marker_array[index + 2] = $('#marker_content').val();
        this.marker_array[index + 4] = this.marker_link;
        this.updateMarkerList();
        /* InfoWindow updaten */
        var tempmodule = this;
        this.getHtml(2, this.marker_array[index + 1], this.marker_array[index + 2], this.marker_array[index + 4], this.marker_array[index + 5], this.marker_array[index + 3][0], this.marker_array[index + 3][1], function (html) {
            //set info and open it
            //v3:
            if (tempmodule.marker.info_window != null) {
                tempmodule.marker.info_window.setContent(html);
                tempmodule.infoWindowContentUI();
            }
            //end v3
        });
    };
    ModulGooglemaps.prototype.editMarker = function () {
        /*
         * Marker-Titel und -Inhalt anhand des Marker-Namen aus dem
         * Array holen
         */
        var index = this.marker_array.indexOf(this.marker.Gp);
        var title = this.marker_array[index + 1];
        var content = this.marker_array[index + 2];
        var link = this.marker_array[index + 4];
        /* InfoWindow updaten */
        var tempmodule = this;
        this.getHtml(1, title, content, link, this.marker_array[index + 5], this.marker_array[index + 3][0], this.marker_array[index + 3][1], function (html) {
            //v3:
            tempmodule.marker.info_window.setContent(html);
            tempmodule.infoWindowContentUI();
            //end v3
        });
    };
    ModulGooglemaps.prototype.removeMarker = function () {
        /* Marker-Namen, -Titel und -Inhalt aus dem Array werfen */
        var index = this.marker_array.indexOf(this.marker.Gp);
        if (index === 0) {
            this.marker_Gp.splice(0, 1);
        }
        else {
            this.marker_Gp.splice((index / 6), 1);
        }
        this.marker.Gp = null;
        this.marker_array.splice(index, 6);
        this.updateMarkerList();
        /* Marker von der Karte entfernen */
        this.marker.setMap(null);
    };
    ModulGooglemaps.prototype.updateMarkerList = function () {
        /*
         * Relevante Daten aus dem Marker-Array filtern und nach Titel
         * sortieren
         */
        var list = [];
        for (var i = 0; i < this.marker_array.length; i += 6) {
            list.push({
                name: this.marker_array[i],
                title: this.marker_array[i + 1]
            });
        }
        //                    list.sort(function(a, b) {
        //                        if (a.title.toLowerCase() < b.title.toLowerCase()) {
        //                            return -1;
        //                        }
        //                        if (a.title.toLowerCase() >= b.title.toLowerCase()) {
        //                            return 1;
        //                        }
        //                    });
        /* Marker-Liste aktualisieren */
        var options = '';
        $.each(list, function (key, item) {
            options += '<option value="' + item.name + '">' +
                item.title + '</option>';
        });
        $('#marker_list_' + this.moduleId).html(options);
    };
    ModulGooglemaps.prototype.panToMarker = function () {
        //close all markers
        //v3:
        for (var k in this.markers) {
            if (this.markers.hasOwnProperty(k)) {
                this.markers[k].info_window.close();
            }
        }
        //end v3
        /*
         * Karte zur Position des in der Liste ausgewählten Markers
         * bewegen
         */
        var index = this.marker_array.indexOf($('#marker_list_' + this.moduleId).val());
        if (index >= 0) {
            var position = this.marker_array[index + 3];
            this.map.panTo(new google.maps.LatLng(position[0], position[1]));
        }
    };
    ModulGooglemaps.prototype.loadMarkers = function (infowindow_data) {
        var this_module = this;
        //v3:
        for (var i = 0; i < this.marker_array.length; i += 6) {
            //create the marker
            var pos = new google.maps.LatLng(this.marker_array[i + 3][0], this.marker_array[i + 3][1]);
            var marker = new google.maps.Marker({
                map: this.map,
                position: pos,
                clickable: true,
                draggable: true
            });
            var html = infowindow_data[i / 6];
            var info_window = new google.maps.InfoWindow({
                maxWidth: this.maxwidth
            });
            info_window.setContent(html);
            marker.info_window = info_window;
            this.marker = marker;
            this.markers[this.marker_array[i]] = marker;
            this.addMarkerListeners(marker);
            (function (marker, info_window) {
                google.maps.event.addListener(marker, 'click', function () {
                    for (var k in this_module.markers) {
                        if (this_module.markers.hasOwnProperty(k)) {
                            this_module.markers[k].info_window.close();
                        }
                    }
                    this_module.marker = marker;
                    info_window.open(this_module.map, marker);
                    this_module.infoWindowContentUI();
                });
            })(marker, info_window);
            if (i === 0) {
                this.marker_Gp[0] = this.marker_array[i];
                this.marker.Gp = this.marker_Gp[0];
            }
            else {
                this.marker_Gp[i / 6] = this.marker_array[i];
                this.marker.Gp = this.marker_Gp[i / 6];
            }
        }
        this.updateMarkerList();
        return; //end v3
    };
    ModulGooglemaps.prototype.addMarkerListeners = function (marker) {
        var tempmodule = this;
        //v3:
        //on drag end, update the marker array
        google.maps.event.addListener(marker, 'dragend', function () {
            tempmodule.marker_array[tempmodule.marker_array
                .indexOf(marker.Gp) + 3] = [
                marker.getPosition().lat(),
                marker.getPosition().lng()
            ];
        });
        return; //end v3
    };
    ModulGooglemaps.prototype.getHtml = function (type, title, content, link, address, lat, lng, callback) {
        /* Formular zum Editieren eines Markers aufbauen */
        $.post(systemurl + 'app/module/googlemaps/gethtml', {
            moduleId: this.moduleId,
            type: type,
            title: title,
            content: content,
            link: link,
            address: address,
            lat: lat,
            lng: lng
        }, function (response) {
            if (callback) {
                callback(response.html);
            }
        }, 'json');
    };
    ModulGooglemaps.prototype.infoWindowContentUI = function () {
        $('.gmapInfoWindowGutter1 button').button();
        $('.gmapInfoWindowGutter2 .gmap-box-footer a').button();
        //$('.gmapInfoWindowGutter1 #marker_linker_icon').button({
        //    'icons': {
        //        'primary': 'ui-icon-1and1-link'
        //    },
        //    'text': false
        //});
        $('.gmapInfoWindowGutter1 #marker_title').bind("focus", function () {
            if ($(this).val() === l10n.getString('gmaps.new_destination')) {
                this.select();
            }
        });
        $('.gmapInfoWindowGutter1 #combobox-internerLink').diy_combobox({ editable: false }).addClass('fullsize-input');
    };
    ModulGooglemaps.prototype.showLinkDialog = function () {
        /* Option zum Verlinken eines Marker-Titels ein- oder ausblenden */
        if ($('#marker_link_dialog:hidden').length > 0) {
            $('#marker_link_dialog').show();
        }
        else {
            $('#marker_link_dialog').hide();
        }
    };
    ModulGooglemaps.prototype.linkMarker = function () {
        /*
         * Temporäre Link-Variable auf den angegebenen externen Link
         * setzen;
         */
        /*
         * wenn keiner angegeben, stattdessen die ID der selektierten
         * internen Page nehmen
         */
        var link = null;
        if ($('#hyperlinkurl').val()) {
            link = $('#hyperlinkurl').val();
        }
        else {
            link = $('#internerLink').val();
        }
        this.marker_link = link;
        /* Link-Button auf Unlink umstellen */
        this.showLinkDialog();
        $('#marker_linker_icon').addClass('ui-icon-1and1-unlink').removeClass('ui-icon-1and1-link');
        $.post(systemurl + 'app/module/googlemaps/getlink', 'moduleId=' + this.moduleId + '&link=' +
            encodeURIComponent(link), function (response) {
            $('#marker_link').html(response.link);
        }, 'json');
        $('#marker_linker_icon').attr('href', 'javascript:mm[' + this.moduleId + '].unlinkMarker();');
    };
    ModulGooglemaps.prototype.unlinkMarker = function () {
        /* Link-Variable zuruecksetzen */
        this.marker_link = '';
        /* Unlink-Button auf Link umstellen */
        $('#marker_linker_icon').addClass('ui-icon-1and1-link').removeClass('ui-icon-1and1-unlink');
        $('#marker_link').html('');
        $('#marker_linker_icon').attr('href', 'javascript:mm[' + this.moduleId + '].showLinkDialog();');
    };
    return ModulGooglemaps;
}(Modul_1.default));
exports.default = ModulGooglemaps;


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
var l10n = __webpack_require__(18);
var features = __webpack_require__(25);
var DiyAviaryShutdownDialog_1 = __webpack_require__(592);
var DiyIframeImageEditorDialog_1 = __webpack_require__(1115);
/**
 * Gallery module
 */
/* Wichtig fuer Galerie-Flash-Upload! */
modul = {
    galerieFlashUploadReady: FlashUploadReady
};
function FlashUploadReady(modulID) {
    mm[modulID].upload();
}
var ModulGallery = (function (_super) {
    tslib_1.__extends(ModulGallery, _super);
    function ModulGallery(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.CONFIG_MIN_WIDTH = 650;
        _this.imageAmount = 0;
        _this.uploadPending = false;
        _this.cancelUploadPending = false;
        _this.moduleOverlay = null;
        _this.loadUebersichtInProgress = false;
        _this.saveEditedImage = function (data) {
            $.ajax({
                "url": '/app/cms/picturemanipulation/saveeditedimage',
                "type": 'POST',
                "data": {
                    load: { moduleId: data.payload.moduleId, imageId: data.payload.imageId },
                    imageDataUrl: data.imageDataUrl
                },
                "success": function (response) {
                    if ("object" === typeof response && response.hasOwnProperty("moduleId")) {
                        mm[response.moduleId].viewUpdateCallback(response.moduleId);
                    }
                },
                "error": function () {
                    $(window).humanMsg(l10n.getString('timout'));
                }
            });
        };
        $("#wrapper_slideshow_effect_" + _this.moduleId).diy_combobox({ editable: false });
        $("#slideshow_navigation_" + _this.moduleId).diy_checkbox();
        $("#slideshow_autostart_" + _this.moduleId).diy_checkbox();
        $('#flashview_' + _this.moduleId + ' input[type="radio"]').diy_radiobox();
        _this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').generateObject();
        _this.getEditorContainer().on('mouseover', '.gallery-gsort img', function () {
            _this.initGsort();
        });
        _this.initMultipleUploader();
        _this.initLimitations();
        _this.iframeImageEditorDialog = new DiyIframeImageEditorDialog_1.default(_this.saveEditedImage);
        return _this;
    }
    ModulGallery.prototype.hasReachedCriticalLimit = function () {
        return jimdoData.gallery.limitationEnabled && this.imageAmount >=
            jimdoData.gallery.criticalLimit;
    };
    ModulGallery.prototype.hasReachedMaximumLimit = function () {
        return jimdoData.gallery.limitationEnabled && this.imageAmount >=
            jimdoData.gallery.maximumLimit;
    };
    /*
     * Handler for start upload actions
     *
     * @param {jQuery.Event} e
     * @param {string} type - component identifier string
     *
     * @returns {boolean}
     */
    ModulGallery.prototype.uploadStartHandler = function (e, type) {
        if ("gallery_module" !== type) {
            //ignore actions if not for the current component
            return false;
        }
        var me = e.data;
        //the event is triggered from multiple places; use the type argument to identify the caller
        if ("gallery_module" === type) {
            me.uploadPending = true;
            me.showModuleOverlay();
        }
        return true;
    };
    /*
     * Handles the cancel upload actions
     *
     * @param {jQuery.Event} e
     * @param {string} type - component identifier string
     * @param {mixed} - data to pass to the handler
     *
     * @returns {boolean}
     */
    ModulGallery.prototype.cancelProgressHandler = function (e, type, data) {
        var me = e.data;
        if ("gallery_module" !== type || ("object" === typeof data && data.moduleId !== me.moduleId)) {
            //ignore actions if not for the current component
            return false;
        }
        me.cancelUploadPending = true;
        me.uploadPending = false;
        return true;
    };
    /*
     * Canceled upload action complete handler i.e this is executed
     * right after the all the currently uploaded files were deleted.
     *
     * @param {jQuery.Event} e
     *
     * @return {boolean} true
     */
    ModulGallery.prototype.cancelActionsCompleteHandler = function (e) {
        var me = e.data;
        me.hideModuleOverlay();
        me.uploadPending = false;
        me.cancelUploadPending = false;
        /*
         * @see: DHDIYED-446
         * @see: DHDIYED-501
         * Display the uploader after the cancel actions are completed
         */
        me.switchtoupload();
        me.changeView2(7);
        $("#switch_upload_" + me.moduleId).addClass("mod-bar-primary-selected selected");
        return true;
    };
    /*
     * Displays a blocking mask over the module controls
     *
     */
    ModulGallery.prototype.showModuleOverlay = function () {
        this.moduleOverlay = $("#modul_" + this.moduleId + "_formdiv").loadingBox({ useOverlay: true });
    };
    /*
     * Hides the blocking mask set over the module controls
     *
     */
    ModulGallery.prototype.hideModuleOverlay = function () {
        if (null !== this.moduleOverlay) {
            this.moduleOverlay.remove();
        }
    };
    /*
     * Handler for the upload completion - it is used to defer the module saving until the upload is completed.
     * On module saving, if the upload is in progress, the saving of the module (triggered by autosave for example)
     * is stopped. After the upload completion is done (signaled by the "diy-editor-gallery-upload-complete" event)
     * the module is saved.
     *
     * (!) Please note that as per requirements, this does not apply for the cancel upload actions: attempting to save
     * a module during an upload cancelation (while files are deleted from server) is a no-op, the action is just
     * ignored i.e autosaving during an upload cancelation is ignored.
     *
     * (!) Please note that this is not always called when an upload is complete; it is called only when a save action
     * was requested
     * during an upload progress if the upload was not canceled. Do not rely on this handler to detect when an upload
     * was completed
     *
     */
    ModulGallery.prototype.uploadCompleteHandler = function (e) {
        var me = e.data;
        me.save();
    };
    ModulGallery.prototype.save = function () {
        /*
         * Prevents module saving if upload (or upload cancelation) actions are in progress
         */
        if (this.uploadPending || this.cancelUploadPending) {
            return;
        }
        // checks whether the sorting has changed or not
        var updateRequired = this.updateOrderField();
        if (!updateRequired) {
            this.close();
            return;
        }
        $('#flash_delay_' + this.moduleId).val($('#flash_delay_input_' + this.moduleId).val());
        if (this.getAutostartValue()) {
            $('#flash_start_' + this.moduleId).val('1');
        }
        else {
            $('#flash_start_' + this.moduleId).val('0');
        }
        if (this.getHideBarValue()) {
            $('#html_hidebar_' + this.moduleId).val(0);
        }
        else {
            $('#html_hidebar_' + this.moduleId).val(1);
        }
        /* Falls Feld nicht, Profifunktion nicht da, also immer auf 1 */
        if (!($('#html_vergroessern_input_' + this.moduleId).length)) {
            $('#html_vergroessern_' + this.moduleId).val('1');
        }
        else {
            if ($('#html_vergroessern_input_' + this.moduleId)
                .prop('checked')) {
                $('#html_vergroessern_' + this.moduleId).val('1');
            }
            else {
                $('#html_vergroessern_' + this.moduleId).val('0');
            }
        }
        if ($('#html_randomimage_input_' + this.moduleId).length > 0
            && $('#html_randomimage_input_' + this.moduleId)
                .prop('checked')) {
            $('#html_randomimage_' + this.moduleId).val('1');
        }
        else {
            $('#html_randomimage_' + this.moduleId).val('0');
        }
        //Slideshow Additons
        $("#slideshowEffect_" + this.moduleId).val($("#slideshow_effect_" + this.moduleId).val());
        $("#slideshowAutostart_" + this.moduleId).val($("#slideshow_autostart_" + this.moduleId).val());
        var slideshowChangetime = $("#slideshow_changetime_" + this.moduleId).val();
        /* tslint:disable:triple-equals */
        $("#slideshowChangeTime_" + this.moduleId).val(slideshowChangetime == 0 ? 1 : slideshowChangetime);
        /* tslint:enable:triple-equals */
        $("#slideshowMaxHeight_" + this.moduleId).val($("#slideshow_maxheight_" + this.moduleId).val());
        if ($("#slideshow_navigation_" + this.moduleId).prop('checked')) {
            $("#slideshowNavigation_" + this.moduleId).val('1');
        }
        else {
            $("#slideshowNavigation_" + this.moduleId).val('0');
        }
        $("#slideshowAutostart_" + this.moduleId).val($("#slideshow_autostart_" + this.moduleId).prop('checked') ? '1' : '0');
        /*
         * Hoehe des Flash proportional setzen Damit die Flash Galerie
         * richtig im Layout dargestellt wird in Proportionen von
         * normalen Fotos Max. 800 Pixel, weil sonst zu hoch (ist
         * Sonderfall nur bei ganz breiten Layouts)
         */
        var flashHeight = Math.floor(this.getContentContainer().width() / 1.33);
        if (flashHeight > 800) {
            flashHeight = 800;
        }
        $('#flashHeight' + this.moduleId).val(flashHeight);
        return _super.prototype.save.call(this);
    };
    ModulGallery.prototype.remove = function () {
        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').cleanupGeneratedObject();
        _super.prototype.remove.call(this);
    };
    ModulGallery.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        /*
         * Events binding cleanup. This is needed due to the fact that are binded at initialization and
         * the initialization can be called multiple times.
         */
        $(document).unbind("diy-editor-cancel-progress", this.cancelProgressHandler);
        $(document).unbind("diy-editor-gallery-cancel-complete", this.cancelActionsCompleteHandler);
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
    };
    ModulGallery.prototype.updateModulContent = function (html) {
        //prevent updating module with temporary content (that is in the process of deteletion)
        if (this.cancelUploadPending) {
            return;
        }
        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').cleanupGeneratedObject();
        _super.prototype.updateModulContent.call(this, html);
        //Run class_pattern to create specified objects
        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').generateObject();
    };
    ModulGallery.prototype.updateOrderField = function () {
        var self = this;
        // get the container of items with thumbnail, icons, subtitle, ...
        var sortableImages = $('#gsort_' + self.moduleId);
        /*
         * holds the sorting data for the images
         * <input type="hidden" value="gsort_{id}[]=37&gsort_{id}[]=38&gsort_{id}[]=39" ... />
         */
        var imageOrder = $('#image_order_' + this.moduleId);
        if (imageOrder.get(0) && sortableImages.get(0)) {
            self.initGsort();
            imageOrder.val(sortableImages.sortable('serialize', {}));
            // there is data to save/update
            return true;
        }
        else {
            // there isn't any data to save
            return false;
        }
    };
    /*
     * Returns the last uploaded images ids.
     *
     * @param {string} html - html markup returned from server that contains all the uploaded
     *                        images ids -  we search for "data-imageId" attributes within this
     *                        markup in order to fetch the uploaded images ids
     *
     * @return {array} - a list containing only the last uploaded images ids
     */
    ModulGallery.prototype.getLastUploadedImagesIds = function (html) {
        if ("string" !== typeof html) {
            return [];
        }
        var moduleId = this.moduleId;
        var allUploadedImagesIds = [];
        var previousUploadedCount = $("#gsort_" + moduleId + " a.add-link").length;
        var currentUploadedCount = $("a[data-imageId]", $(html)).length;
        //then retrive all uploaded images ids
        $("a[data-imageId]", $(html)).each(function (index, domElement) {
            allUploadedImagesIds.push(parseInt($(domElement).attr("data-imageId"), 10));
        });
        return allUploadedImagesIds.splice(previousUploadedCount, currentUploadedCount - previousUploadedCount);
    };
    /**
     * Handles the cancel upload actions: delete already uploaded images
     * (keep the previously uploaded images); trigger necessary events
     *
     * @param {array} lastUploadedImagesIds - a list of images ids
     *
     * @returns {boolean}
     *
     */
    ModulGallery.prototype.cancelUploadActions = function (lastUploadedImagesIds) {
        if (!$.isArray(lastUploadedImagesIds)) {
            return false;
        }
        var moduleId = this.moduleId;
        var doc = $(document);
        var uploadCount = lastUploadedImagesIds.length;
        //signal upload cancel start
        doc.trigger("diy-editor-gallery-cancel-start");
        doc.on("diy-editor-gallery-deleted-image", function (e, imageId) {
            if (0 === --uploadCount) {
                doc.trigger("diy-editor-gallery-cancel-complete");
            }
        });
        //delete ONLY the currently uploaded images
        if (lastUploadedImagesIds.length > 0) {
            for (var i = 0; i < lastUploadedImagesIds.length; i++) {
                mm[moduleId].deleteImage(lastUploadedImagesIds[i]);
            }
        }
        else {
            //no uploaded images: trigger cancel complete event to notify the listeners
            doc.trigger("diy-editor-gallery-cancel-complete");
        }
        return true;
    };
    ModulGallery.prototype.loadUebersicht = function () {
        var moduleId = this.moduleId;
        var self = this;
        if (this.loadUebersichtInProgress === false) {
            this.loadUebersichtInProgress = true;
            $.get(systemurl
                + 'app/module/gallery/overview/moduleId/'
                + this.moduleId, function (data) {
                var modulJQ = $('#galerieUebersicht_' + moduleId);
                if (self.cancelUploadPending) {
                    self.loadUebersichtInProgress = false;
                    self.cancelUploadActions(self.getLastUploadedImagesIds(data.html));
                    return;
                }
                modulJQ.html(data.html);
                self.loadUebersichtInProgress = false;
                modulJQ.find('#gsort_' + moduleId).sortable({
                    opacity: 0.7,
                    helper: 'original',
                    tolerance: 'pointer'
                });
                mm[moduleId].addLinkSelector();
                self.imageAmount = data.imageCount;
                self.refreshTooltip();
                self.checkLimitations();
            }, 'json');
        }
    };
    ModulGallery.prototype.addLinkSelector = function () {
        var moduleId = this.moduleId;
        this.getEditorContainer().find('.add-link').click(function () {
            var imageId = $(this).attr('data-imageId');
            if (imageId) {
                var inputLinkData = {
                    href: $('#temp_link_' + imageId).val()
                };
                diy.editor.linkSelector.openDialog(inputLinkData, function (outputLinkData) {
                    $('#linkShow' + imageId).val(outputLinkData.value);
                    $('#temp_link_' + imageId).val(outputLinkData.href);
                    $('#temp_link_target_' + imageId).val(outputLinkData.target);
                    mm[moduleId].updateTempData(imageId);
                });
            }
        });
    };
    ModulGallery.prototype.switchtodetail = function () {
        $('#switch_detail_' + this.moduleId).hide();
        $('#switch_compact_' + this.moduleId).show();
        $('#switch_upload_' + this.moduleId).removeClass('selected');
        $('#switch_detail_' + this.moduleId).removeClass('selected');
        $('#switch_compact_' + this.moduleId).addClass('selected');
        $('#fileupload_' + this.moduleId).hide();
        $('#gsort_' + this.moduleId).show();
        $('#gsort_' + this.moduleId + ' div.compactview')
            .removeClass('compactview').addClass('detailview');
    };
    ModulGallery.prototype.switchtocompact = function () {
        $('#switch_detail_' + this.moduleId).show();
        $('#switch_compact_' + this.moduleId).hide();
        $('#switch_upload_' + this.moduleId).removeClass('selected');
        $('#switch_detail_' + this.moduleId).addClass('selected');
        $('#switch_compact_' + this.moduleId).removeClass('selected');
        $('#fileupload_' + this.moduleId).hide();
        $('#gsort_' + this.moduleId).show();
        $('#gsort_' + this.moduleId + ' div.detailview')
            .removeClass('detailview').addClass('compactview');
    };
    ModulGallery.prototype.switchtoupload = function () {
        $('#fileupload_' + this.moduleId).show();
        if ($('#switch_upload_' + this.moduleId).hasClass('selected')) {
            $('#switch_upload_' + this.moduleId).removeClass('selected');
            $('#switch_detail_' + this.moduleId).addClass('selected');
            $('#switch_compact_' + this.moduleId).addClass('selected');
        }
        else {
            $('#switch_upload_' + this.moduleId).addClass('selected');
            $('#switch_detail_' + this.moduleId).removeClass('selected');
            $('switch_compact_' + this.moduleId).removeClass('selected');
        }
    };
    ModulGallery.prototype.changeProportion = function (format) {
        /* tslint:disable:triple-equals */
        var oldFormat;
        if (format == 1) {
            oldFormat = 2;
        }
        else {
            oldFormat = 1;
        }
        if ($('#prop_' + this.moduleId + '_' + format).hasClass('selected')) {
            return;
        }
        this.showLoading();
        $('#prop_' + this.moduleId + '_' + format).addClass('selected');
        if (format == 1) {
            $('#prop_' + this.moduleId + '_2').removeClass('selected');
        }
        else {
            $('#prop_' + this.moduleId + '_1').removeClass('selected');
        }
        this.getEditorContainer().find('.gallery-resize-method').hide();
        this.getEditorContainer().find('.gallery-resize-method[data-method=' + format + ']').show();
        var self = this;
        $.post(systemurl + 'app/module/gallery/changeoptions', 'moduleId=' + self.moduleId + '&galleryaction=format&format=' + format, function (data) {
            mm[self.moduleId].updateModulContent(data.html);
            // rename classes by the thumbnails
            $('#styles_' + self.moduleId + ' a').each(function (i, elem) {
                var cls = (format == 1 ? 'pro_' : 'sq_') + (i + 1);
                // set selected item
                cls += $(elem).hasClass('current') ? ' current' : '';
                $(elem).attr('class', cls);
            });
            var oldStyle = self.getEditorContainer()
                .find('.gallery-resize-method[data-method=' + oldFormat + '] a.current')
                .attr('data-style');
            self.switchtostyle(oldStyle);
            mm[self.moduleId].hideLoading();
        }, 'json');
        /* tslint:enable:triple-equals */
    };
    ModulGallery.prototype.changeThumbSize = function (resize) {
        var moduleId = this.moduleId;
        var module = mm[moduleId];
        if (module.changeThumbSizeInProgress) {
            return;
        }
        module.changeThumbSizeInProgress = true;
        module.showLoading();
        $.post(systemurl + 'app/module/gallery/changeoptions', 'galleryaction=resize&moduleId=' + moduleId + '&resize=' + resize, function (data) {
            module.updateModulContent(data.html);
            module.hideLoading();
            module.changeThumbSizeInProgress = false;
        }, 'json');
    };
    ModulGallery.prototype.changeHideBar = function (showBar) {
        mm[this.moduleId].showLoading();
        var moduleId = this.moduleId;
        $.post(systemurl + 'app/module/gallery/changeoptions', 'galleryaction=hideBar&moduleId=' + moduleId + '&hideBar=' + showBar, function (data) {
            mm[moduleId].updateModulContent(data.html);
            $('#html_hidebar_' + moduleId).val(showBar);
            mm[moduleId].hideLoading();
        }, 'json');
    };
    ModulGallery.prototype.getHideBarValue = function () {
        /* tslint:disable:triple-equals */
        if ($('[name=flash_bar_' + this.moduleId + ']:checked').val() == 1) {
            return 1;
        }
        return 0;
        /* tslint:enable:triple-equals */
    };
    ModulGallery.prototype.getAutostartValue = function () {
        /* tslint:disable:triple-equals */
        return $('[name=flash_start_input_' + this.moduleId + ']:checked').val() == 1;
        /* tslint:enable:triple-equals */
    };
    ModulGallery.prototype.changeView2 = function (view) {
        var flashTab = $('#format_' + this.moduleId + '_2');
        if (flashTab.is(':diy-tooltip')) {
            // show the info tooltip for Flash view
            flashTab.diy_tooltip('show');
            // dynamically delegate the sideadmin help action to the gallery tooltip
            flashTab.diy_tooltip('widget').on('click', '.moduleHelpLink', $.proxy(guidedAssistant._onModuleHelpLinkClick, guidedAssistant));
        }
        $('#imgtab1-' + this.moduleId).hide();
        $('#flashview_' + this.moduleId).hide();
        $('#slideshow_' + this.moduleId).hide();
        $('#html_' + this.moduleId).hide();
        $('#galleryImage' + this.moduleId).hide();
        $('#upgradeGraphicsBoost' + this.moduleId).hide();
        /*
         * hack for IE8, which does not show the secondary nav bar
         * correctly if not altered after rendering
         */
        $('.module-gallery-file-upload .mod-bar-secondary').hide().show();
        /* tslint:disable:triple-equals */
        if (view == 7) {
            $('#imgtab1-' + this.moduleId).show();
        }
        else if (view == 8) {
            $('#imgtab2-' + this.moduleId).show();
            $('#galleryImage' + this.moduleId).show();
        }
        else if (view == 9) {
            $('#imgtab3-' + this.moduleId).show();
            $('#upgradeGraphicsBoost' + this.moduleId).show();
        }
        else {
            $('#imgtab4-' + this.moduleId).show();
        }
        /* tslint:enable:triple-equals */
    };
    ModulGallery.prototype.changeView = function (view, loadElements, randomimage) {
        $('#fileupload_' + this.moduleId).hide();
        $('#format_' + this.moduleId + '_1, #format_' + this.moduleId + '_2' + ', #format_' + this.moduleId + '_4')
            .removeClass('mod-bar-primary-selected');
        /* tslint:disable:triple-equals */
        if (view == 1 || view == 3) {
            $('#flashview_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).hide();
            $('#html_' + this.moduleId).show();
            if (view == 1) {
                $('#format_' + this.moduleId + '_2' + ', #format_' + this.moduleId + '_4')
                    .removeClass('mod-bar-primary-active');
                $('#format_' + this.moduleId + '_1')
                    .addClass('mod-bar-primary-selected').addClass('mod-bar-primary-active');
            }
            else if (view == 3) {
                // Table - sieht nur Entwickler
                $('#table_' + this.moduleId).show();
                $('#html1_' + this.moduleId).show();
                $('#style_' + this.moduleId).hide();
                $('#props_' + this.moduleId).hide();
                if (randomimage) {
                    $('#format_' + this.moduleId).hide();
                    $('#html_' + this.moduleId).hide();
                    $('#slideshow_' + this.moduleId).hide();
                }
                else {
                    $('#format_' + this.moduleId).show();
                    $('#html_' + this.moduleId).show();
                }
            }
        }
        else if (view == 2) {
            $('#format_' + this.moduleId + '_1, #format_' + this.moduleId + '_4').removeClass('mod-bar-primary-active');
            $('#format_' + this.moduleId + '_2')
                .addClass('mod-bar-primary-selected')
                .addClass('mod-bar-primary-active');
            // Flash
            $('#html_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).hide();
            $('#flashview_' + this.moduleId).show();
        }
        else if (view == 4) {
            $('#format_' + this.moduleId + '_1, #format_' + this.moduleId + '_2').removeClass('mod-bar-primary-active');
            $('#format_' + this.moduleId + '_4')
                .addClass('mod-bar-primary-selected')
                .addClass('mod-bar-primary-active');
            $('#html_' + this.moduleId).hide();
            $('#flashview_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).show();
        }
        else {
            $('#html_' + this.moduleId).hide();
            $('#flashview_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).hide();
            $('#hinweismaske_' + this.moduleId).hide();
            $('#fileupload_' + this.moduleId).hide();
        }
        /* tslint:enable:triple-equals */
        var self = this;
        $('#format_' + this.moduleId).find('a').each(function (index, el) {
            var $el = $(el);
            if ($el.is('#format_' + self.moduleId + '_' + view)) {
                $el.addClass('selected');
            }
            else {
                $el.removeClass('selected');
            }
        });
        if (loadElements) {
            mm[this.moduleId].showLoading();
            var moduleId_1 = this.moduleId;
            $.post(systemurl + 'app/module/gallery/changeoptions', 'galleryaction=view&moduleId=' + this.moduleId + '&view=' + view +
                '&width=' + Math.floor(this.getContentContainer().width()) + '&updated=yes', function (data) {
                mm[moduleId_1].updateModulContent(data.html);
                mm[moduleId_1].hideLoading();
            }, 'json');
        }
    };
    ModulGallery.prototype.adjustConfigView = function (hasConfigView) {
        _super.prototype.adjustConfigView.call(this, hasConfigView);
        this.refreshTooltip();
    };
    ModulGallery.prototype.showTitle = function () {
        $('#hinweismaske_' + this.moduleId).toggle();
    };
    ModulGallery.prototype.deleteImage = function (bildID) {
        var self = this;
        var url = systemurl + 'app/module/gallery/changeoptions';
        $.post(url, {
            galleryaction: 'delete',
            imageId: bildID,
            moduleId: this.moduleId
        }, function (data) {
            /*
            * oleg: "If it is flash gallery we need to reiject html to
            * update the gallery - stupid but I have no time"
            */
            //signal deletion completed
            $(document).trigger("diy-editor-gallery-deleted-image", bildID);
            /*
            * Prevent displaying the images that that are in the process of being deleted
            * data.html - is retrived with each delete/ call from the server and it returns the current
            *             images state on the server i.e returns even the images that are in the
                            process of being
            *             deleted but havent been yet (an action which is in progress at the present).
            */
            if (self.cancelUploadPending) {
                return;
            }
            self.updateModulContent(data.html);
            $('#gsort_' + self.moduleId + '_' + bildID + ', #gallery_thumb_' + bildID)
                .fadeOut(400, function () {
                $(this).remove();
            });
            self.imageAmount = data.imageCount;
            self.refreshTooltip();
            self.checkLimitations();
        }, 'json');
    };
    ModulGallery.prototype.editImage = function (bildID) {
        var self = this;
        if (features('iframedImageEditor')) {
            $.ajax({
                "url": '/app/cms/picturemanipulation/getgalleryimageurl/',
                "type": 'POST',
                "data": {
                    "load": { moduleId: self.moduleId, imageId: bildID }
                },
                "success": function (response) {
                    self.iframeImageEditorDialog.showDialog({ moduleId: self.moduleId, imageId: bildID }, response.imageUrl, response.originalImageUrl);
                }
            });
        }
        else if (features('aviaryShutdown')) {
            DiyAviaryShutdownDialog_1.showDialog();
        }
        else if (diy.editor.imageManipulation) {
            diy.editor.imageManipulation.show({ load: { moduleId: this.moduleId, imageId: bildID } });
        }
    };
    ModulGallery.prototype.upload = function () {
        var moduleId = this.moduleId;
        var self = this;
        $.post(systemurl + 'app/module/gallery/changeoptions', { 'galleryaction': 'nothing', 'moduleId': moduleId }, function (data) {
            data = JSON.parse(data);
            mm[moduleId].updateModulContent(data.html);
            self.loadUebersichtInProgress = false;
            self.loadUebersicht();
        });
        $('#fileupload_' + moduleId).toggle();
        $('#switch_upload_' + moduleId).removeClass('mod-bar-primary-selected');
        $('#gallery_gfxboost_' + moduleId).removeClass('mod-bar-primary-selected');
    };
    ModulGallery.prototype.rotate = function (imageId, degree) {
        if (this.rotateInProgress) {
            return;
        }
        this.rotateInProgress = true;
        this.showConfigLoading();
        var self = this;
        $.post(systemurl + 'app/module/gallery/changeoptions', 'galleryaction=rotate&imageId=' + imageId
            + '&moduleId=' + this.moduleId + '&degree='
            + degree, function () {
            var $img = $('#gsort_' + self.moduleId + '_'
                + imageId + ' img');
            $img.attr('src', $img.attr('src') + 1);
            self.hideConfigLoading();
            self.rotateInProgress = false;
        });
    };
    ModulGallery.prototype.togglestyle = function () {
        $('#gallerystyle_' + this.moduleId).toggle();
        if ($('#button_styles_' + this.moduleId).hasClass('selected')) {
            $('#button_styles_' + this.moduleId).removeClass('selected');
        }
        else {
            $('#button_styles_' + this.moduleId).addClass('selected');
        }
    };
    /**
     * Switch the gallery style (with borders, without borders, spaced,etc)
     */
    ModulGallery.prototype.switchtostyle = function (style) {
        var currentProportion = this.getEditorContainer()
            .find('a[data-proportion].selected')
            .attr('data-proportion');
        var self = this;
        if ($('#style_' + currentProportion + '_' + this.moduleId + '_' + style).hasClass('current')) {
            return;
        }
        $.post(systemurl + 'app/module/gallery/changeoptions', { 'galleryaction': 'style', 'style': style, 'moduleId': this.moduleId }, function (data) {
            data = JSON.parse(data);
            self.getContentContainer().html(data.html);
        });
        $('#gallerystyle_' + this.moduleId).find('a').each(function (index) {
            if ((index + 1) === parseInt(style, 10)) {
                $('#style_' + currentProportion + '_' + self.moduleId + '_' + (index + 1)).addClass('current');
            }
            else {
                $('#style_' + currentProportion + '_' + self.moduleId + '_' + (index + 1)).removeClass('current');
            }
        });
    };
    ModulGallery.prototype.open = function (e) {
        /*
         * Set upload actions
         *
         * These events are unbinded (cleaned up)in the close() method in order to avoid executing them multiple
         * times in the case the module was initialized more than one time.
         */
        $(document).bind("diy-editor-cancel-progress", this, this.cancelProgressHandler);
        $(document).bind("diy-editor-gallery-cancel-complete", this, this.cancelActionsCompleteHandler);
        this.switchtoupload();
        this.changeView2(7);
        _super.prototype.open.call(this, e);
        this.loadUebersicht();
        $('#switch_upload_' + this.moduleId).click();
    };
    ModulGallery.prototype.updateTempData = function (bildId) {
        $('#link_' + bildId).val($('#temp_link_' + bildId).val());
        $('#link_target_' + bildId).val($('#temp_link_target_' + bildId).val());
    };
    ModulGallery.prototype.afterViewUpdate = function (response) {
        var modulJQ = $('#galerieUebersicht_' + this.moduleId);
        modulJQ.html(response.galleryview);
        $('#fileupload_' + this.moduleId).hide();
        $('#gallery_gfxboost_' + this.moduleId).removeClass('mod-bar-primary-selected');
        this.addLinkSelector();
        this.imageAmount = response.imageCount;
        this.refreshTooltip();
        this.checkLimitations();
    };
    ModulGallery.prototype.refreshTooltip = function () {
        var tooltipTarget = $('#format_' + this.moduleId + '_2');
        if (tooltipTarget.is(':diy-tooltip')) {
            tooltipTarget.diy_tooltip('refresh');
        }
    };
    /**
     * Set up the sortable list of images in the gallery.
     */
    ModulGallery.prototype.initGsort = function () {
        if (!$('#gsort_' + this.moduleId).hasClass('ui-sortable')) {
            $('#gsort_' + this.moduleId).sortable({
                opacity: 0.7,
                helper: 'original',
                tolerance: 'pointer'
            });
        }
    };
    /**
     * Set up the flash multiple uploader and upload params.
     */
    ModulGallery.prototype.initMultipleUploader = function () {
        // attach behaviour for dynamically added help links
        this.getEditorContainer().on('click', 'a.moduleHelpLink', function (e) {
            $.proxy(guidedAssistant._onModuleHelpLinkClick, guidedAssistant)(e);
        });
    };
    /**
     * Initialize the containers for possible image limitations messages.
     */
    ModulGallery.prototype.initLimitations = function () {
        var config = this.getEditorContainer();
        var softLimitEl = config.find('.image-soft-limit-msg');
        var hardLimitEl = config.find('.image-hard-limit-msg');
        if (!jimdoData.gallery.limitationEnabled) {
            return;
        }
        softLimitEl.html('');
        hardLimitEl.diy_simpleTooltip({
            triggerMode: 'none',
            positionMode: 'static',
            appendTo: hardLimitEl
        }).diy_simpleTooltip('option', {
            cls: 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip',
            contentIcon: 'ui-icon-alert'
        }).diy_simpleTooltip('hide');
    };
    /**
     * Check current number of images in the gallery.
     * Warn about the soft limit or enforce the hard limit if the case.
     */
    ModulGallery.prototype.checkLimitations = function () {
        var self = this;
        var moduleId = this.moduleId;
        var softLimitEl = this.getEditorContainer().find('.image-soft-limit-msg');
        var hardLimitEl = this.getEditorContainer().find('.image-hard-limit-msg');
        var softMsg = l10n.getString('limitations.warningAmountImagesPerGallery')
            .replace('{softlimit}', "" + jimdoData.gallery.criticalLimit)
            .replace('{hardlimit}', "" + jimdoData.gallery.maximumLimit);
        var hardMsg = l10n.getString('limitations.maxAmountImagesPerGallery')
            .replace('{hardlimit}', "" + jimdoData.gallery.maximumLimit);
        if (!jimdoData.gallery.limitationEnabled) {
            return;
        }
        // handle the soft (critical) limit
        softLimitEl.html(this.hasReachedCriticalLimit() && !this.hasReachedMaximumLimit() ? softMsg : '');
        // handle the hard (maximum) limit
        this.getEditorContainer().find('#insertImages').button(this.hasReachedMaximumLimit() ? 'disable' : 'enable');
        hardLimitEl
            .diy_simpleTooltip('option', 'content', this.hasReachedMaximumLimit() ? hardMsg : '')
            .diy_simpleTooltip(this.hasReachedMaximumLimit() ? 'show' : 'hide');
        // attach a callback to the oao-widgetloaded grafx event for toggling the insert button in grafx;
        // match the image library tab and the purchased images tab
        var tabsSelector = '#1and1-external-' + moduleId + ', #1and1-external-purchased-' + moduleId;
        this.getEditorContainer()
            .off('oao-widgetloaded', tabsSelector)
            .on('oao-widgetloaded', tabsSelector, (function () {
            return function () {
                self.getEditorContainer().find('#insertImages')
                    .button(self.hasReachedMaximumLimit() ? 'disable' : 'enable');
            };
        })());
    };
    ModulGallery.prototype.startFileManager = function () {
        /* the default number of images that can be selected */
        var moduleSources = {};
        var self = this;
        var maxSelection = jimdoData.gallery.maximumLimit;
        var alreadyExisting = this.imageAmount || 0;
        var insertStorageItems = function (items, succClb, errClb) {
            $.ajax({
                type: 'POST',
                url: '/app/module/gallery/link-storage-files',
                data: {
                    moduleId: self.moduleId,
                    storageFileIds: items.map(function (item) {
                        return item.getId();
                    })
                },
                success: function (response, status, jqXHR) {
                    if (response.success) {
                        succClb(response);
                    }
                    else {
                        errClb(response);
                    }
                },
                error: function (jqXHR, status, errorThrown) {
                    errClb(errorThrown);
                }
            });
        };
        var insertCmsItems = function (items, successCb, errorCb) {
            $.ajax({
                type: 'POST',
                url: '/app/module/gallery/import-cms-images',
                data: {
                    moduleId: self.moduleId,
                    cmsImageIds: items.map(function (item) {
                        return item.getId();
                    })
                },
                success: function (response, status, jqXHR) {
                    if (response.success) {
                        successCb(response);
                    }
                    else {
                        errorCb(response);
                    }
                },
                error: function (jqXHR, status, errorThrown) {
                    errorCb(errorThrown);
                }
            });
        };
        moduleSources = {
            storage: {
                batchSize: 10,
                callback: insertStorageItems
            },
            cms: {
                batchSize: 1,
                callback: insertCmsItems
            },
            bigstock: {
                batchSize: 1,
                callback: insertStorageItems
            },
            '123rf': {
                batchSize: 1,
                callback: insertStorageItems
            }
        };
        diy.editor.filemanager = new diy.editor.Filemanager({
            appName: 'filemanager',
            mode: 'selection',
            maxSelection: maxSelection,
            alreadyExisting: alreadyExisting,
            sources: moduleSources,
            callback: function (report) {
                if (report.successItems.length > 0) {
                    self.viewUpdateCallback(self.moduleId);
                }
                else {
                    // TODO check if some error handling have to be done here
                }
            }
        });
    };
    return ModulGallery;
}(Modul_1.default));
exports.default = ModulGallery;


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ReactDOM = __webpack_require__(57);
var IframeImageEditorDialog_1 = __webpack_require__(627);
var diyLightTheme = __webpack_require__(241);
var l10n = __webpack_require__(18);
var dialogContainer;
var DiyIframeImageEditorDialog = (function (_super) {
    tslib_1.__extends(DiyIframeImageEditorDialog, _super);
    function DiyIframeImageEditorDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onClose = function () {
            _this.props.onClose();
            _this.setState({
                open: false
            });
        };
        _this.onSave = function (data) {
            _this.props.onSave(data);
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: _this.props.open
        };
        return _this;
    }
    DiyIframeImageEditorDialog.prototype.getChildContext = function () {
        return {
            muiTheme: diyLightTheme
        };
    };
    DiyIframeImageEditorDialog.prototype.componentWillReceiveProps = function (props) {
        this.setState({
            open: props.open
        });
    };
    DiyIframeImageEditorDialog.prototype.render = function () {
        return (React.createElement(IframeImageEditorDialog_1.default, { open: this.state.open, texts: l10n.getMessages('aviaryDialog'), onClose: this.onClose, onSave: this.onSave, imageUrl: this.props.imageUrl, originalImageUrl: this.props.originalImageUrl }));
    };
    return DiyIframeImageEditorDialog;
}(React.Component));
DiyIframeImageEditorDialog.childContextTypes = {
    muiTheme: React.PropTypes.object
};
exports.DiyIframeImageEditorDialog = DiyIframeImageEditorDialog;
var DialogHandler = (function () {
    function DialogHandler(onSaveCallback, onCloseCallback) {
        var _this = this;
        this.showDialog = function (imageData, imageUrl, originalImageUrl) {
            _this.imageData = imageData;
            dialogContainer = document.createElement('div');
            ReactDOM.render(React.createElement(DiyIframeImageEditorDialog, { imageUrl: imageUrl, originalImageUrl: originalImageUrl, onClose: _this.onClose, onSave: _this.onSave, open: true }), dialogContainer);
            document.body.appendChild(dialogContainer);
        };
        this.onClose = function () {
            if (_this.onCloseCallback) {
                _this.onCloseCallback();
            }
        };
        this.onSave = function (data) {
            data.payload = _this.imageData;
            _this.onSaveCallback(data);
        };
        this.onCloseCallback = onCloseCallback;
        this.onSaveCallback = onSaveCallback;
    }
    return DialogHandler;
}());
exports.default = DialogHandler;


/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var ModulWithRedux_1 = __webpack_require__(493);
var EditView_1 = __webpack_require__(1117);
var InPlaceEditView_1 = __webpack_require__(1118);
var WebView_1 = __webpack_require__(1119);
var ModulHr = (function (_super) {
    tslib_1.__extends(ModulHr, _super);
    function ModulHr() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helpArticleId = "hr";
        return _this;
    }
    ModulHr.prototype.getActionBarTabs = function () {
        return [
            { label: this.textLabel, content: this.getConnectedComponent(EditView_1.default) }
        ];
    };
    ModulHr.prototype.getInPlaceEditViewClass = function () {
        return InPlaceEditView_1.default;
    };
    ModulHr.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    return ModulHr;
}(ModulWithRedux_1.default));
ModulHr.MAX_SPACING = 200;
ModulHr.MIN_SPACING = 0;
exports.default = ModulHr;


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var ModulHr_1 = __webpack_require__(1116);
var autoprefixer_1 = __webpack_require__(438);
var Slider_1 = __webpack_require__(518);
var HrEditView = (function (_super) {
    tslib_1.__extends(HrEditView, _super);
    function HrEditView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSpacingChange = function (e, value) {
            _this.setSpacing(value);
        };
        return _this;
    }
    HrEditView.prototype.getStyles = function () {
        return {
            root: autoprefixer_1.autoprefixer({
                display: "flex",
                marginRight: 12,
                marginLeft: 12
            }),
            left: autoprefixer_1.autoprefixer({
                marginRight: 12,
                alignSelf: "center",
                fontSize: 12
            }),
            right: autoprefixer_1.autoprefixer({
                marginLeft: 12,
                flexGrow: 1,
                maxWidth: 812
            }),
            slider: {
                maxWidth: 800,
                marginBottom: -24,
                marginTop: 16
            },
            spacing: autoprefixer_1.autoprefixer({
                alignSelf: "center",
                marginLeft: 12,
                fontSize: 12
            })
        };
    };
    HrEditView.prototype.render = function () {
        var styles = this.getStyles();
        return (React.createElement("div", { style: styles.root },
            React.createElement("div", { style: styles.left }, l10n_1.default("module.hr.spacingLabel")),
            React.createElement("div", { style: styles.right },
                React.createElement(Slider_1.default, { "data-test-id": "module-hr-slider", style: styles.slider, defaultValue: this.props.payload.spacing, onChange: this.onSpacingChange, name: "hr", value: this.props.payload.spacing, min: ModulHr_1.default.MIN_SPACING, max: ModulHr_1.default.MAX_SPACING, step: 1 })),
            React.createElement("div", { style: styles.spacing },
                this.props.payload.spacing,
                " px")));
    };
    HrEditView.prototype.setSpacing = function (value) {
        value = Math.max(ModulHr_1.default.MIN_SPACING, Math.min(ModulHr_1.default.MAX_SPACING, value));
        this.props.onDataChange({
            spacing: value
        });
    };
    return HrEditView;
}(React.Component));
exports.default = HrEditView;


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var ModulHr_1 = __webpack_require__(1116);
var ResizeControls_1 = __webpack_require__(1064);
var SyncPosition_1 = __webpack_require__(440);
var ModuleOverlay_1 = __webpack_require__(236);
var HrInPlaceEditView = (function (_super) {
    tslib_1.__extends(HrInPlaceEditView, _super);
    function HrInPlaceEditView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onResize = function (dx, dy, pos) {
            _this.setSpacing(Math.round(_this.props.payload.spacing + dy / 2));
        };
        return _this;
    }
    HrInPlaceEditView.prototype.render = function () {
        var _this = this;
        var modulEl = document.getElementById("modul_" + this.props.moduleId);
        return (React.createElement(SyncPosition_1.default, { element: modulEl, position: "absolute" }, function (box) {
            return (React.createElement(ResizeControls_1.default, { dataTestId: "module-hr-resize", width: box.width, height: box.height, top: box.top, left: box.left, position: "absolute", zIndex: ModuleOverlay_1.default.ZINDEX + 1, resizeControls: ["S"], onResize: _this.onResize, pointerEventsNone: false }));
        }));
    };
    HrInPlaceEditView.prototype.setSpacing = function (value) {
        value = Math.max(ModulHr_1.default.MIN_SPACING, Math.min(ModulHr_1.default.MAX_SPACING, value));
        this.props.onDataChange({
            spacing: value
        });
    };
    return HrInPlaceEditView;
}(React.Component));
exports.default = HrInPlaceEditView;


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var HrWebView = (function (_super) {
    tslib_1.__extends(HrWebView, _super);
    function HrWebView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HrWebView.prototype.render = function () {
        return (React.createElement("div", { style: { padding: this.props.payload.spacing + "px 0px" } },
            React.createElement("div", { className: "hr" })));
    };
    return HrWebView;
}(React.Component));
exports.default = HrWebView;


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
/**
 * Download document module
 *
 */
var ModulDownloadDocument = (function (_super) {
    tslib_1.__extends(ModulDownloadDocument, _super);
    function ModulDownloadDocument(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.$uploadField = $('#upload_wrapper_' + moduleId);
        _this.$linkTargetCheckbox = $('#download_target_check_' + moduleId);
        /* get the form and add DIY form to it */
        _this.$form = _this.$uploadField.closest('form');
        _this.$form.diy_form();
        _this.$uploadField.diy_uploadField({
            change: function () {
                $(this).closest('form').submit();
            }
        });
        _this.$linkTargetCheckbox.diy_checkbox();
        return _this;
    }
    ModulDownloadDocument.prototype.uploadError = function (errMsg) {
        this.$form.diy_form("addError", errMsg, this.$uploadField);
    };
    return ModulDownloadDocument;
}(Modul_1.default));
exports.default = ModulDownloadDocument;


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var ModulWithRedux_1 = __webpack_require__(493);
var l10n_1 = __webpack_require__(18);
var WebView_1 = __webpack_require__(1122);
var EditView_1 = __webpack_require__(1123);
var diyLightTheme = __webpack_require__(241);
var ModuleInlineEditor_1 = __webpack_require__(986);
var index_1 = __webpack_require__(536);
var AppRegistry_1 = __webpack_require__(190);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulHeaderHeading = (function (_super) {
    tslib_1.__extends(ModulHeaderHeading, _super);
    function ModulHeaderHeading(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.hasUndoRedo = true;
        _this.helpArticleId = 'headline';
        _this.inlineEditor = null;
        _this.undoHandler = function () {
            _this.inlineEditor.getEditor().execCommand('undo');
        };
        _this.redoHandler = function () {
            _this.inlineEditor.getEditor().execCommand('redo');
        };
        _this.ckEditorPromise = new Promise(function (resolve, reject) {
            _this.ckEditorPromiseResolve = resolve;
        });
        return _this;
    }
    ModulHeaderHeading.prototype.getInPlaceEditViewClass = function () {
        return null;
    };
    ModulHeaderHeading.prototype.getWebViewClass = function () {
        return WebView_1.default;
    };
    ModulHeaderHeading.prototype.getCKEditorPromise = function () {
        return this.ckEditorPromise;
    };
    ModulHeaderHeading.prototype.loadData = function (data) {
        this.data = data;
        this.data.header = this.getHeadingElement().innerHTML;
    };
    ModulHeaderHeading.prototype.getHeadingElement = function () {
        var h = this.getContentElement().querySelector('h1');
        if (!h) {
            h = this.getContentElement().querySelector('h2');
        }
        return h;
    };
    /**
     * @override
     * strictly for typing purposes
     */
    ModulHeaderHeading.prototype.getData = function () {
        return this.data;
    };
    ModulHeaderHeading.prototype.initCKEditor = function (textElement) {
        var _this = this;
        this.inlineEditor = new ModuleInlineEditor_1.default(this, textElement);
        this.inlineEditor.startEditing({
            // this setting is primary used for setting the z-index
            // of CKEditor dialogs, and these should be the same as
            // standard Material UI dialogs zIndex
            baseFloatZIndex: diyLightTheme.zIndex.dialog,
            'diy-moduleType': this.moduleType,
            'diy-excludePasteScrubbers': 'semanticplaceholders',
            toolbar: 'Heading',
            toolbar_Heading: this.getCkeditorToolbarConfig(),
            diyhelpLabel: 'headline',
            format_tags: 'h1;h2',
            extraPlugins: 'doNothing,lineutils,widget,diysemanticplaceholder',
            keystrokes: [
                [13, 'doNothing'],
                [CKEDITOR.SHIFT + 13, 'doNothing']
            ],
            autoParagraph: false,
            removeFormatAttributes: true,
            forcePasteAsPlainText: true,
            ignoreEmptyParagraph: true,
            enterMode: CKEDITOR.ENTER_BR,
            allowedContent: 'h1 h2'
                + ';span[!class,!data-semantic-data-key](!diysemanticplaceholder)',
            disallowedContent: 'p br pre',
            hideToolbar: true
        });
        this.inlineEditor.editor.config.protectedSource.push(/<\?[\s\S]*?\?>/g);
        this.inlineEditor.editor.on('paste', function (ev) {
            ev.data.dataValue = ev.data.dataValue.replace(/<br>/g, ' ');
        });
        this.inlineEditor.editor.on('saveSnapshot', function () {
            /* whenever something gets modified in the editor, we get the heading level
             based on the actual DOM (getSaveData()) and set the value inside module's data.
             this is done because the change of format (h1/h2) does not modify the data
             model of the heading module. */
            var saveData = _this.getSaveData();
            if (!saveData) {
                return;
            }
            // update module data (heading level)
            _this.data.h = saveData.h;
        });
        this.inlineEditor.editor.on('change', function (ev) {
            if (ev.editor.getData().length === 0) {
                /* when the user deletes everything from the editor, we ensure we create
                 empty tags with the correct level from the module data, which has been updated
                 using the code above, based on the DOM that CKEditor changed */
                var h = _this.data.h;
                ev.editor.setData("<h" + h + ">&nbsp;</h" + h + ">", function () {
                    var range = ev.editor.createRange();
                    range.moveToElementEditablePosition(ev.editor.editable(), true);
                    ev.editor.getSelection().selectRanges([range]);
                });
            }
        });
        this.inlineEditor.editor.on('pluginsLoaded', function (ev) {
            ev.editor.focus();
        });
        this.inlineEditor.editor.on('instanceReady', function () {
            _this.ckEditorPromiseResolve(_this.inlineEditor.getEditor());
            var store = getStore();
            _this.inlineEditor.editor.getCommand('undo').on('state', function () {
                store.dispatch(index_1.setUndoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
            _this.inlineEditor.editor.getCommand('redo').on('state', function () {
                store.dispatch(index_1.setRedoState({ enabled: this.state !== CKEDITOR.TRISTATE_DISABLED }));
            });
        });
    };
    ModulHeaderHeading.prototype.getActionBarTabs = function () {
        return [
            {
                label: l10n_1.default('module.heading.tabs.basic'),
                content: this.getConnectedComponent(EditView_1.HeadingEditViewBasics)
            }
        ];
    };
    /**
     * @override
     */
    ModulHeaderHeading.prototype.getSaveData = function () {
        var data = _super.prototype.getSaveData.call(this);
        // nothing to do if the editor is not accessible
        if (!this.inlineEditor) {
            return data;
        }
        // init vars
        var hLevel = 1;
        var hContents = '';
        var editorContents = $.trim(this.inlineEditor.getHtmlData());
        // see if the text coming from editor is not blank
        if (editorContents) {
            // we'll work with a mini-DOM to make HTML manipulations easier
            var $miniDom = $('<foo>' + editorContents + '</foo>');
            // check that it has only one child
            if ($miniDom.children().length !== 1
                || !($miniDom.children().first().is('h1')
                    || $miniDom.children().first().is('h2'))) {
                // we ensure that the correct heading level from the module data is used
                var h = parseInt(this.data.h, 10);
                // if it doesn't, we create a root H1 before we continue
                $miniDom.html("<h" + h + ">" + editorContents + "</h" + h + ">");
                //XXX: this may not work in all circumstances; for example
                //if the markup already contains a H1, jquery will
                //autocorrect and not allow another wrapping one;
                //then again in some cases it will help
            }
            else {
                // at this point we're sure it has H1 or H2 as root element;
                // if it's an H2 we need to update the H level
                if ($miniDom.children().first().is('h2')) {
                    hLevel = 2;
                }
            }
            // extract the content of the heading
            hContents = $miniDom.children().first().html();
        }
        else {
            /* in case the module is saved when the text is empty, we must send the correct
            hLevel so that next time the module is edited, the same level will be applied.
            Without this, if we were on H2 and save an empty module, we would get back H1 */
            hLevel = parseInt(this.data.h, 10);
        }
        // aggregate the information and send it on
        data.h = "" + hLevel;
        data.header = hContents;
        return data;
    };
    /**
     * @override
     */
    ModulHeaderHeading.prototype.close = function (userClose, cancelEdit, isSaving, isUserAction) {
        this.inlineEditor.stopEditing();
        _super.prototype.close.call(this, userClose, cancelEdit, isSaving, isUserAction);
    };
    ModulHeaderHeading.prototype.getCkeditorToolbarConfig = function () {
        var headerFormat = this.getData().supports.headerFormat;
        var config = [];
        config.push(['Undo', 'Redo']);
        if (headerFormat) {
            config.push(['Format']);
        }
        config.push(['StyleButton']);
        config.push(['DiySemanticPlaceholder']);
        config.push(['HelpButton']);
        config.push(['CloseButton']);
        return config;
    };
    return ModulHeaderHeading;
}(ModulWithRedux_1.default));
exports.default = ModulHeaderHeading;


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var l10n_1 = __webpack_require__(18);
var HeadingWebView = (function (_super) {
    tslib_1.__extends(HeadingWebView, _super);
    function HeadingWebView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeadingWebView.prototype.componentDidMount = function () {
        this.props.module.initCKEditor(this.headingContainer);
    };
    HeadingWebView.prototype.render = function () {
        var _this = this;
        var headingValue = this.props.payload.header === ''
            ? '<< ' + l10n_1.default('module.heading.newheading') + ' >>'
            :
                this.props.payload.header;
        // Extra span used by some layouts for decorative effects.
        // Needs this class so it's not confused with other spans
        // inside the heading, such as semantic placeholders.
        // See DHDIYW-1862 for details.
        var SpanHeading = React.createElement("span", { className: "diyfeDecoration", dangerouslySetInnerHTML: { __html: headingValue } });
        return (React.createElement("div", { ref: function (headingContainer) { return _this.headingContainer = headingContainer; } }, this.props.payload.h === "2" ?
            React.createElement("h2", null, SpanHeading)
            :
                React.createElement("h1", null, SpanHeading)));
    };
    return HeadingWebView;
}(React.Component));
exports.default = HeadingWebView;


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(28);
var CKEditorEditView_1 = __webpack_require__(1016);
var AllCKEditorButtonsConfig_1 = __webpack_require__(1019);
var HeadingEditViewBasics = (function (_super) {
    tslib_1.__extends(HeadingEditViewBasics, _super);
    function HeadingEditViewBasics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeadingEditViewBasics.prototype.render = function () {
        var items = [];
        var headerFormat = this.props.module.getData().supports.headerFormat;
        if (headerFormat) {
            items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.Format);
        }
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.TextStyles(this.props.module));
        items.push(AllCKEditorButtonsConfig_1.allCKEditorItems.ContactInfo);
        return (React.createElement(CKEditorEditView_1.CKEditorEditView, tslib_1.__assign({}, this.props, { key: "HeaderBasics", items: items })));
    };
    return HeadingEditViewBasics;
}(React.Component));
exports.HeadingEditViewBasics = HeadingEditViewBasics;


/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var Modul_1 = __webpack_require__(197);
var l10n = __webpack_require__(18);
/**
 * Guestbook module class
 *
 */
var ModulGuestbook = (function (_super) {
    tslib_1.__extends(ModulGuestbook, _super);
    function ModulGuestbook(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.loadIcon = '<img src="' + cc_.cdnServer + 's/img/cms/loading/timeline.gif" alt="" /><br />';
        var self = _this;
        self.getModuleForm().diy_form();
        $('.guestbook .form-item input[type="radio"]', self.getModuleForm()).diy_radiobox();
        $('input[name=receiveMail]', self.getModuleForm()).diy_radiobox().change(function (e) {
            /* tslint:disable:triple-equals */
            self.toggleReceiverEmailAddress($(this).val() == 1);
            /* tslint:enable:triple-equals */
            self.validate();
        });
        self.getReceiverEmailAddress().keyup(function () {
            self.validate();
        });
        self.loadButtons();
        self.setSaveAction(self.validateAndSave);
        self.validate();
        return _this;
    }
    ModulGuestbook.prototype.getModuleForm = function () {
        return $('#formular_' + this.moduleId);
    };
    ModulGuestbook.prototype.getReceiverEmailAddress = function () {
        return $('#receiverEmailAddress_' + this.moduleId);
    };
    ModulGuestbook.prototype.open = function (openConfig) {
        // do also parent function //
        _super.prototype.open.call(this, openConfig);
        // if invalid focus the invalid field //
        if (!this.isValid()) {
            this.getReceiverEmailAddress().get(0).focus();
        }
    };
    ModulGuestbook.prototype.validateAndSave = function () {
        //no validation blocking anymore if(this.isValid()) ...
        this.save();
    };
    //sometimes receiverEmailAddress is "disabled" and would not be inside the sent data, so we add it manually
    ModulGuestbook.prototype.getSaveData = function () {
        var data = _super.prototype.getSaveData.call(this);
        data.push({
            name: this.getReceiverEmailAddress().attr('name'),
            value: this.getReceiverEmailAddress().val()
        });
        return data;
    };
    ModulGuestbook.prototype.loadButtons = function () {
        $('.com-edit a').button();
    };
    ModulGuestbook.prototype.confirmDelete = function (commentId) {
        var triggerBtn = $('#com-delete-btn-' + this.moduleId + '-' + commentId);
        var content = '#com-confirm-delete-' + this.moduleId;
        var self = this;
        var $window = $(window);
        var msg = l10n.getMessages('guestbook.deletedialog');
        this.confirmDialog = $(content).diy_confirmationDialog({
            buttons: [{
                    text: msg['delete'],
                    click: function () { self.deleteComment(commentId); }
                }, {
                    text: msg['cancel'],
                    click: function () { self.abortDelete(); },
                    "class": "button-cancel"
                }],
            modal: true,
            position: [triggerBtn.offset().left - $window.scrollLeft(), triggerBtn.offset().top - $window.scrollTop()]
        });
        this.commentIdToDelete = commentId;
    };
    ModulGuestbook.prototype.abortDelete = function () {
        this.commentIdToDelete = null;
        this.closeDialog();
    };
    ModulGuestbook.prototype.closeDialog = function () {
        this.confirmDialog.diy_confirmationDialog('close');
    };
    ModulGuestbook.prototype.deleteComment = function (commentId) {
        var self = this;
        commentId = commentId || this.commentIdToDelete;
        $('#commentEntry' + commentId).html(this.loadIcon);
        var moduleId = this.moduleId;
        $.ajax({
            url: '/app/module/guestbook/delete',
            type: 'POST',
            data: {
                moduleId: moduleId,
                commentId: commentId
            },
            success: function (r) {
                if (r) {
                    $('#guestbook-' + moduleId).replaceWith(r);
                    self.loadButtons();
                }
            }
        });
        this.commentIdToDelete = null;
        this.closeDialog();
    };
    ModulGuestbook.prototype.toggleCommentStatus = function (commentId) {
        var self = this;
        $('#commentEntry' + commentId).html(this.loadIcon);
        var moduleId = this.moduleId;
        $.ajax({
            url: '/app/module/guestbook/toggle',
            type: 'POST',
            data: {
                moduleId: moduleId,
                commentId: commentId
            },
            success: function (r) {
                if (r) {
                    $('#guestbook-' + moduleId).replaceWith(r);
                    self.loadButtons();
                }
            }
        });
    };
    ModulGuestbook.prototype.toggleReceiverEmailAddress = function (checked) {
        if (!checked) {
            this.getReceiverEmailAddress().prop('disabled', true);
        }
        else {
            this.getReceiverEmailAddress().prop('disabled', false);
        }
    };
    ModulGuestbook.prototype.validate = function () {
        this.clearErrors();
        if ($('input[name=receiveMail]', this.getModuleForm()).diy_radiobox('option', 'checked')) {
            var receiverEmailAddressElement = this.getReceiverEmailAddress();
            if (!diy.util.validator.isEmail(receiverEmailAddressElement.val())) {
                var errorMsg = $('#receiverEmailAddress_error_message_' + this.moduleId, $('#formular_' + this.moduleId)).text();
                errorMsg = '<div>' + errorMsg + '</div>';
                this.showInputError(receiverEmailAddressElement, errorMsg);
            }
        }
    };
    ModulGuestbook.prototype.isValid = function () {
        this.validate();
        if (this.getModuleForm().diy_form('hasError')) {
            return false;
        }
        return true;
    };
    ModulGuestbook.prototype.clearErrors = function () {
        this.getModuleForm().diy_form('clearErrors');
    };
    ModulGuestbook.prototype.showInputError = function (element, errorMsg) {
        element.diy_textField({
            tooltipOptions: {
                anchor: 'left'
            }
        });
        element.diy_textField('addError', errorMsg);
        element.diy_textField('showError');
    };
    return ModulGuestbook;
}(Modul_1.default));
exports.default = ModulGuestbook;


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var Modul_1 = __webpack_require__(197);
var ModulWebcomponent = (function (_super) {
    tslib_1.__extends(ModulWebcomponent, _super);
    function ModulWebcomponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a instance of a webcomponent
     *
     * @param {} data
     * @param {string} baseSaveUrl
     * @param {function|null} success
     */
    ModulWebcomponent.prototype.createInstance = function (data, baseSaveUrl, success) {
        var _this = this;
        var instanceCreator = new diysdk.webcomponentIntegrator();
        instanceCreator.create(data, baseSaveUrl, function (data, instance) {
            _this.instance = instance;
            if (_this.instance && _this.instance.hasEditView === false) {
                _this.hasConfigView = false;
            }
            if (typeof success === "function") {
                success();
            }
        });
    };
    ModulWebcomponent.prototype.getSaveData = function () {
        var data = {
            'moduleId': this.moduleId,
            'form_data': JSON.stringify(this.instance.getFormData(this.instance.getMainJQ('edit'))),
            'cstok': jimdoData.cstok
        };
        if (this.getIsNew()) {
            data._diyNewlyAdded = 1;
        }
        return data;
    };
    /**
     * XHR Request to app server to save/update a webcomponent
     */
    ModulWebcomponent.prototype.runSaveAction = function () {
        var _this = this;
        if (this.instance) {
            this.showConfigLoading();
            this.instance.saveEditData({
                url: systemurl + 'app/module/webcomponent/update',
                contentType: 'application/x-www-form-urlencoded',
                data: this.getSaveData(),
                dataType: 'json',
                success: function (response) {
                    /**
                     * Make some SiteCatalyst tracking
                     */
                    jQuery(document).trigger('diy-editor-makeWebsiteFit', {
                        'condition': 'Applied',
                        'name': 'Web Apps'
                    });
                    if (response.userHasInstalledApp === true) {
                        jQuery(document.body).trigger('InstalledWebAppSaved.BSA');
                    }
                    _this.hideConfigLoading();
                    _this.close(false, false);
                    _this.setIsNew(false);
                    _this.refreshModule(response);
                    jQuery(document).trigger('diy-editor-module-saved');
                },
                error: function () {
                    _this.hideConfigLoading();
                }
            });
        }
    };
    ModulWebcomponent.prototype.onDelete = function () {
        if (typeof (diysdk.webcomponents[this.instance.instanceId]) !== 'undefined') {
            delete diysdk.webcomponents[this.instance.instanceId];
        }
        return true;
    };
    ModulWebcomponent.prototype.refreshModule = function (response) {
        if (response.cmsView && response.editView) {
            this.updateModul(response.cmsView, response.editView);
        }
    };
    return ModulWebcomponent;
}(Modul_1.default));
exports.default = ModulWebcomponent;


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var Modul_1 = __webpack_require__(197);
var AppRegistry_1 = __webpack_require__(190);
var index_1 = __webpack_require__(528);
function getStore() {
    return AppRegistry_1.default.getStoreProvider().getStore();
}
var ModulSectionContainer = (function (_super) {
    tslib_1.__extends(ModulSectionContainer, _super);
    function ModulSectionContainer(moduleId) {
        var _this = _super.call(this, moduleId) || this;
        _this.freezeOverlay(true);
        return _this;
    }
    ModulSectionContainer.prototype.loadData = function (data) {
        _super.prototype.loadData.call(this, data);
        getStore().dispatch(index_1.loadData({ moduleId: this.moduleId, data: this.data }));
    };
    return ModulSectionContainer;
}(Modul_1.default));
exports.default = ModulSectionContainer;


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var DragDrop = __webpack_require__(1128);
var NavDropZone = __webpack_require__(195);
var MainNavDropZone = __webpack_require__(1129);
var SubNavDropZone = __webpack_require__(1130);
var MatrixDropZone = __webpack_require__(1131);
var ExistingModuleDragSource = __webpack_require__(1132);
var ExistingModuleHelper = __webpack_require__(1133);
/**
 * Module drag & drop logic
 *
 * Adds drag & drop functionality to all existing modules found within a matrix. Allows modules
 * to be moved between matrixes or dropped to a different page.
 */
var ModuleDragDrop = (function (_super) {
    tslib_1.__extends(ModuleDragDrop, _super);
    function ModuleDragDrop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hoverBlockOverlayZindex = 100200;
        return _this;
    }
    /**
     * Bootstrap
     */
    ModuleDragDrop.prototype.init = function () {
        this.initDragHelper();
        this.addMatrixZones();
        this.setUpRefreshListeners();
        this.prepareNavigationData(jimdoData.navigation.pages);
    };
    /**
     * Adds existing modules to the drag and drop manager
     */
    ModuleDragDrop.prototype.initDragHelper = function () {
        this.dragHelper = new ExistingModuleHelper();
    };
    ModuleDragDrop.prototype.addDragSourceEl = function (dragSourceEl) {
        var dragSource = new ExistingModuleDragSource(dragSourceEl);
        dragSource.setHelper(this.dragHelper);
        this.addDragSource(dragSource);
    };
    /**
     * Adds matrix drop targets to the manager, which need to be initialized
     * before the drag starts or else draggables can't connect to them
     */
    ModuleDragDrop.prototype.addMatrixZones = function () {
        var _this = this;
        $('.sortable-matrix').each(function (index, elem) {
            _this.addDropZone(new MatrixDropZone($(elem)));
        });
    };
    ModuleDragDrop.prototype.addNavZones = function () {
        var _this = this;
        if (!diy.editor.uiPreference.isPointerModeTouch()) {
            // Disable drag and drop over navigation on touch devices because
            // it causes big performance problems
            $('#mainNav1 a, #mainNav2 a, #mainNav3 a, #dropdownmenu > li > a')
                .each(function (index, elem) {
                _this.addDropZone(new MainNavDropZone($(elem)));
            });
        }
    };
    ModuleDragDrop.prototype.onDragStart = function (e, ui, dragSource) {
        //signal generic dragstart event
        $(document).trigger("diy-siteadmin-item-dragstart");
        this.createHoverBlockOverlay();
        this.addNavZones();
        _super.prototype.onDragStart.call(this, e, ui, dragSource);
    };
    ModuleDragDrop.prototype.onDragStop = function (e, ui, dragSource) {
        //signal generic dragstop event
        $(document).trigger("diy-siteadmin-item-dragstop");
        _super.prototype.onDragStop.call(this, e, ui, dragSource);
        this.removeDropZones(function (zone) {
            return zone instanceof NavDropZone;
        });
        this.removeHoverBlockOverlay();
    };
    ModuleDragDrop.prototype.onDropZoneChanged = function (newDropZone, oldDropZone) {
        var _this = this;
        _super.prototype.onDropZoneChanged.call(this, newDropZone, oldDropZone);
        if (oldDropZone instanceof MainNavDropZone) {
            if (oldDropZone.element.is(":diy-dropdownmenu")) {
                oldDropZone.element.diy_dropdownmenu('delayHide');
            }
        }
        if (newDropZone instanceof MainNavDropZone) {
            var position = {
                collision: 'flip flip',
                offset: '0 0'
            };
            if (newDropZone.isVerticalNav()) {
                $.extend(position, {
                    my: 'left top',
                    at: 'right top'
                });
            }
            else {
                $.extend(position, {
                    my: 'left top',
                    at: 'left bottom'
                });
            }
            var subPageItems = this.getPageNavigationItems(newDropZone.getPageId());
            if (subPageItems && subPageItems.length) {
                if (!newDropZone.element.is(':diy-dropdownmenu')) {
                    newDropZone.element.diy_dropdownmenu({
                        zIndex: this.hoverBlockOverlayZindex + 1,
                        cls: 'diye-subpages-menu',
                        position: position,
                        items: subPageItems,
                        showDelay: 1000,
                        hideDelay: 200
                    });
                    newDropZone.element.on('dropdownmenushow dropdownmenuhide dropdownmenuexpand', function () {
                        //Hack to refresh jquery ui droppable positions on demand
                        $.ui.ddmanager.prepareOffsets(_this.currentDragSource.element.data('uiDraggable'));
                    });
                    newDropZone.element.diy_dropdownmenu('render');
                    var items = newDropZone.element.diy_dropdownmenu('getItems');
                    var dropZone = void 0;
                    var el = void 0;
                    for (var i = 0; i < items.length; i++) {
                        el = items[i].el.children('a');
                        el.attr('data-page-id', items[i].data.pageId);
                        dropZone = new SubNavDropZone(el);
                        dropZone.setParentNavZone(newDropZone);
                        this.addDropZone(dropZone);
                        dropZone.activate();
                    }
                }
                newDropZone.element.diy_dropdownmenu('delayShow');
            }
        }
        else if (newDropZone instanceof SubNavDropZone) {
            newDropZone.getParentNavZone().element.diy_dropdownmenu('cancelHide');
        }
    };
    ModuleDragDrop.prototype.onDropZoneOver = function (e, ui, dropZone) {
        _super.prototype.onDropZoneOver.call(this, e, ui, dropZone);
        if (dropZone instanceof MatrixDropZone && this.currentDropZone !== dropZone) {
            //we hide the invitation manually whenever we hover a matrix
            //because the sortable automatically shows the placeholder by default
            dropZone.hideInvitation();
        }
    };
    ModuleDragDrop.prototype.getPageNavigationItems = function (pageId) {
        return this.pagesMap[pageId];
    };
    /**
     * Build a tree structure containing all the page hierarchy, needed
     * for the subpage dropdown menu. Also maintains a map of pages by
     * parent page id
     */
    ModuleDragDrop.prototype.prepareNavigationData = function (navData) {
        var subPages = {};
        var pagesMap = {};
        for (var i = 0; i < navData.length; i++) {
            var pId = navData[i].parentId;
            subPages[pId] = subPages[pId] || [];
            subPages[pId].push({
                label: navData[i].title,
                pageId: navData[i].pageId
            });
        }
        var createTree = function (pageId) {
            var tree = [];
            var sp = subPages[pageId];
            var item;
            var si;
            if (sp) {
                for (var i = 0; i < sp.length; i++) {
                    item = sp[i];
                    si = createTree(item.pageId);
                    if (si.length) {
                        item.items = si;
                    }
                    tree.push(item);
                }
            }
            pagesMap[pageId] = tree;
            return tree;
        };
        createTree(0);
        this.pagesMap = pagesMap;
    };
    /**
     * Creates a overlay that will block all
     * hover events on all editor elements
     * Still, jQuery UI Dropable and Sortable will function
     * because of the way they are implemented
     */
    ModuleDragDrop.prototype.createHoverBlockOverlay = function () {
        this.hoverBlockOverlay =
            $('<div class="dd-hover-block-overlay"></div>')
                .css('zIndex', this.hoverBlockOverlayZindex)
                .appendTo($('body'))
                .wrap('<div class="diye"></div>');
    };
    ModuleDragDrop.prototype.removeHoverBlockOverlay = function () {
        if (this.hoverBlockOverlay) {
            this.hoverBlockOverlay.unwrap().remove();
        }
    };
    /**
     * Refreshes matrix drop zones if the underlying elements change
     */
    ModuleDragDrop.prototype.refreshMatrixZones = function () {
        this.zones.forEach(function (zone) {
            if (zone instanceof MatrixDropZone) {
                zone.refresh();
            }
        });
    };
    /**
     * Listens for events that would cause the sources and targets to be refreshed
     */
    ModuleDragDrop.prototype.setUpRefreshListeners = function () {
        var _this = this;
        $(document).on('diy.editor.moduleInitialized', function (e, module) {
            _this.refreshMatrixZones();
        });
        $(document).on('diy.editor.navigationDataChanged', function (e, navData) {
            _this.prepareNavigationData(navData);
        });
    };
    return ModuleDragDrop;
}(DragDrop));
module.exports = ModuleDragDrop;


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var DragSource = __webpack_require__(193);
var DropZone = __webpack_require__(196);
/**
 * Generic drag & drop manager class
 */
var DragDrop = (function () {
    function DragDrop() {
        /**
         * drag sources registered with the manager
         */
        this.sources = null;
        /**
         * drop zones registered with the manage
         */
        this.zones = null;
        /**
         * drop zone being hovered during a drag
         */
        this.currentDropZone = null;
        /**
         * drag source being dragged
         */
        this.currentDragSource = null;
        /**
         * whether a drop was made on a drop zone.
         * We need this flag so we can detect when we ended the
         * drag without dropping on a dropzone
         */
        this.wasDropped = null;
        /**
         * Keep a stack of DropZones being hovered at a given time, sorted
         * by calculated zIndex (descending)
         */
        this.hoverStack = null;
        this.sources = [];
        this.zones = [];
        this.hoverStack = [];
    }
    /**
     * Adds a drag source to the manager
     */
    DragDrop.prototype.addDragSource = function (dragSource) {
        if (dragSource instanceof DragSource) {
            dragSource.init();
            dragSource.element
                .bind('ddstart.dragdrop', $.proxy(this.onDragStart, this))
                .bind('dddrag.dragdrop', $.proxy(this.onDrag, this))
                .bind('ddstop.dragdrop', $.proxy(this.onDragStop, this));
            this.sources.push(dragSource);
        }
    };
    /**
     * Removes all or some of the registered drag sources from the manager,
     * based on the parameters passed to the method
     *
     * @param filterClb a callback that is executed for each drop zone and returns
     *                  whether the drop zone will be removed or not
     */
    DragDrop.prototype.removeDragSources = function (filterClb) {
        var newSources = [];
        for (var i = 0; i < this.sources.length; ++i) {
            if (!filterClb || filterClb(this.sources[i])) {
                this.sources[i].element.unbind('.dragdrop');
                this.sources[i].destroy();
                this.sources[i] = null;
            }
            else {
                newSources.push(this.sources[i]);
            }
        }
        this.sources = newSources;
    };
    /**
     * Adds a drop zone to the manager
     */
    DragDrop.prototype.addDropZone = function (dropZone) {
        if (dropZone instanceof DropZone) {
            dropZone.element
                .bind('ddover.dragdrop', $.proxy(this.onDropZoneOver, this))
                .bind('ddout.dragdrop', $.proxy(this.onDropZoneOut, this))
                .bind('dddrop.dragdrop', $.proxy(this.onDropZoneDrop, this));
            this.zones.push(dropZone);
        }
    };
    /**
     * Removes all or some of the registered drop zones, based on the parameters
     * passed to the method
     *
     * @param filterClb a callback that is executed for each drop zone and returns
     *                  whether the drop zone will be removed or not
     */
    DragDrop.prototype.removeDropZones = function (filterClb) {
        var newZones = [];
        for (var i = 0; i < this.zones.length; ++i) {
            if (!filterClb || filterClb(this.zones[i])) {
                this.zones[i].element.unbind('.dragdrop');
                this.zones[i].destroy();
                if (this.zones[i] === this.currentDropZone) {
                    this.currentDropZone = null;
                }
            }
            else {
                newZones.push(this.zones[i]);
            }
        }
        this.zones = newZones;
    };
    DragDrop.prototype.activateDropZones = function () {
        for (var i = 0; i < this.zones.length; ++i) {
            this.zones[i].activate();
        }
    };
    DragDrop.prototype.deactivateDropZones = function () {
        for (var i = 0; i < this.zones.length; ++i) {
            this.zones[i].deactivate();
        }
    };
    DragDrop.prototype.onDropZoneChanged = function (newDropZone, oldDropZone) {
        // abstract
    };
    DragDrop.prototype._handleCurrentZoneChange = function () {
        var stackTop = this.hoverStack.length ? this.hoverStack[0] : null;
        if (this.currentDropZone !== stackTop) {
            if (this.currentDropZone) {
                this.currentDropZone.updateView(null);
            }
            var oldDropZone = this.currentDropZone;
            this.currentDropZone = stackTop;
            this.currentDragSource.updateView(this.currentDropZone);
            if (this.currentDropZone) {
                this.currentDropZone.updateView(this.currentDragSource);
            }
            this.onDropZoneChanged(this.currentDropZone, oldDropZone);
        }
    };
    /**
     * Triggers when the mouse enters a drop zone
     *
     * @param e original jquery event
     * @param ui the jquery ui hash passed from the droppable/sortable
     * @param dropZone the drop zone being hovered
     */
    DragDrop.prototype.onDropZoneOver = function (e, ui, dropZone) {
        // add dropZone to hoverstack if it's not already added
        if ($.inArray(dropZone, this.hoverStack) === -1) {
            // add element to hoverStack
            this.hoverStack.push(dropZone);
        }
        this.hoverStack.sort(function (a, b) {
            return b.getZIndex() - a.getZIndex();
        });
        this._handleCurrentZoneChange();
    };
    /**
     * Triggers when the mouse leaves a drop zone
     *
     * @param e original jquery event
     * @param ui the jquery ui hash passed from the droppable/sortable
     * @param dropZone the drop zone that was left
     */
    DragDrop.prototype.onDropZoneOut = function (e, ui, dropZone) {
        // remove element from hoverStack
        for (var i = 0; i < this.hoverStack.length; i++) {
            if (this.hoverStack[i] === dropZone) {
                this.hoverStack.splice(i, 1);
                break;
            }
        }
        this._handleCurrentZoneChange();
    };
    /**
     * Triggered when the source is dropped on a drop zone
     *
     * @param e original jquery event
     * @param ui the jquery ui hash passed from the droppable/sortable
     * @param dropZone the drop zone that received the drop
     */
    DragDrop.prototype.onDropZoneDrop = function (e, ui, dropZone) {
        // accept only drops only on drop zones on the top
        // of the hover stack, i.e. the current one
        if (this.currentDropZone === dropZone) {
            this.currentDragSource.drop(dropZone);
            this.wasDropped = true;
        }
    };
    /**
     * Triggered when dragging starts
     *
     * @param e original jquery event
     * @param ui the jquery ui hash passed from the draggable
     * @param dragSource the drag source object representing what's being dragged
     */
    DragDrop.prototype.onDragStart = function (e, ui, dragSource) {
        this.hoverStack = [];
        this.currentDropZone = null;
        this.currentDragSource = dragSource;
        this.activateDropZones();
        dragSource.updateView(null);
        this.wasDropped = false;
    };
    /**
     * Triggered during drag, on mouse move
     *
     * @param e original jquery event
     * @param ui the jquery ui hash passed from the draggable
     * @param dragSource the drag source object representing what's being dragged
     */
    DragDrop.prototype.onDrag = function (e, ui, dragSource) {
        // abstract
    };
    /**
     * Triggered when dragging ends
     *
     * @param e original jquery event
     * @param ui the jquery ui hash passed from the draggable
     * @param dragSource the drag source object representing what's being dragged
     */
    DragDrop.prototype.onDragStop = function (e, ui, dragSource) {
        if (!this.wasDropped) {
            // We dropped where there isn't any drop zone
            this.currentDragSource.drop(null);
        }
        this.deactivateDropZones();
        this.currentDragSource = null;
    };
    DragDrop.prototype.destroy = function () {
        this.removeDragSources();
        this.removeDropZones();
    };
    return DragDrop;
}());
module.exports = DragDrop;


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var NavDropZone = __webpack_require__(195);
/**
 * Drop zone for the navigation items directly visible on the page
 */
var MainNavDropZone = (function (_super) {
    tslib_1.__extends(MainNavDropZone, _super);
    function MainNavDropZone(targetEl) {
        var _this = _super.call(this, $("<div></div>"), targetEl) || this;
        var menuUl = _this.getTargetEl().closest('ul');
        var isVertical = menuUl.data('diy-dd-is-vertical-layout');
        if (isVertical === null) {
            isVertical = true;
            var previousOffset_1 = { top: -1 };
            var currentOffset_1;
            // select only direct children and check if they're all
            // vertically positioned
            menuUl.find(' > li').each(function (index, elem) {
                currentOffset_1 = $(elem).offset();
                if (currentOffset_1.top <= previousOffset_1.top) {
                    isVertical = false;
                    return false;
                }
                previousOffset_1 = currentOffset_1;
                return undefined;
            });
            menuUl.data('diy-dd-is-vertical-layout', isVertical);
        }
        return _this;
    }
    MainNavDropZone.prototype.activate = function () {
        this.element
            .wrap('<div class="diye"></div>')
            .parent()
            .appendTo('body');
        var targetEl = this.getTargetEl();
        this.element
            .width(targetEl.innerWidth())
            .height(targetEl.innerHeight())
            .css({
            'position': targetEl.closest(":fixed").length > 0 ? 'fixed' : 'absolute',
            'top': 0,
            'left': 0,
            'z-index': targetEl.diy_zIndex() + 1
        })
            .position({
            my: 'left top',
            at: 'left top',
            of: targetEl
        });
        _super.prototype.activate.call(this);
    };
    MainNavDropZone.prototype.showInvitation = function (canDrop) {
        this.element.addClass(canDrop ? 'nav-can-drop' : 'nav-cannot-drop');
    };
    MainNavDropZone.prototype.hideInvitation = function () {
        this.element.removeClass('nav-can-drop nav-cannot-drop');
    };
    MainNavDropZone.prototype.isVerticalNav = function () {
        return this.getTargetEl().closest('ul').data('diy-dd-is-vertical-layout');
    };
    MainNavDropZone.prototype.deactivate = function () {
        _super.prototype.deactivate.call(this);
        this.element
            .parent()
            .remove();
    };
    return MainNavDropZone;
}(NavDropZone));
module.exports = MainNavDropZone;


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var NavDropZone = __webpack_require__(195);
/**
 * Drop zone using a jquery ui droppable widget, for the navigation items
 * that are visible on the dropdown menu
 */
var SubNavDropZone = (function (_super) {
    tslib_1.__extends(SubNavDropZone, _super);
    function SubNavDropZone(targetEl) {
        return _super.call(this, targetEl, targetEl) || this;
    }
    SubNavDropZone.prototype.showInvitation = function (canDrop) {
        this.element.addClass(canDrop ? 'subnav-can-drop' : 'subnav-cannot-drop');
        this.getParentNavZone().element.addClass('nav-has-submenu');
    };
    SubNavDropZone.prototype.hideInvitation = function () {
        this.element.removeClass('subnav-can-drop subnav-cannot-drop');
        this.getParentNavZone().element.removeClass('nav-has-submenu');
    };
    SubNavDropZone.prototype.setParentNavZone = function (zone) {
        this.parentNavZone = zone;
    };
    SubNavDropZone.prototype.getParentNavZone = function () {
        return this.parentNavZone;
    };
    SubNavDropZone.prototype.destroy = function () {
        this.setParentNavZone(null);
        _super.prototype.destroy.call(this);
    };
    return SubNavDropZone;
}(NavDropZone));
module.exports = SubNavDropZone;


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var DropZone = __webpack_require__(196);
var ModuleDragSource = __webpack_require__(192);
var Matrix_1 = __webpack_require__(641);
/**
 * Drop zone for matrix areas
 *
 * @depends Matrix.js
 * @depends jquery.ui.sortable.js
 */
var placeholderCache = $('<div></div>')
    .addClass('diye-placeholder-wrapper')
    .html('<div class="diye-placeholder">' +
    '<div class="diye-placeholder-border"></div>' +
    '<div class="diye-placeholder-innerborder"></div>' +
    '<div class="diye-placeholder-text"></div>' +
    '</div>');
var MatrixDropZone = (function (_super) {
    tslib_1.__extends(MatrixDropZone, _super);
    function MatrixDropZone(targetEl) {
        var _this = _super.call(this, targetEl, targetEl) || this;
        //We create the sortable here because the drop zone is created too late
        //and connecToSortable won't work on the draggables
        _this.element.sortable({
            disableTouch: true,
            items: '>div.modulelt',
            placeholder: {
                element: function () {
                    return placeholderCache[0];
                },
                update: function () { }
            },
            connectWith: '.sortable-matrix:not(#' + _this.element.attr('id') + ')',
            cancel: '*',
            cursor: null,
            //keep this setting (intersect generates bogus out event while overlapping both matrixes :|)
            tolerance: 'pointer',
            dropBehaviour: true
        });
        return _this;
    }
    MatrixDropZone.prototype.activate = function () {
        _super.prototype.activate.call(this);
        this.element
            .addClass('dragging-in-progress')
            .sortable('refreshPositions');
        this.element
            .bind('sortstart.dropzone', $.proxy(this.onDragOver, this))
            .bind('sortout.dropzone', $.proxy(this.onDragOut, this))
            .bind('sortbeforestop.dropzone', $.proxy(this.onDrop, this));
    };
    MatrixDropZone.prototype.getDestinationParams = function () {
        var params = {
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: 0
        };
        var previousModule = this.placeholder.prevAll('.modulelt[data-matrixChildId]');
        if (previousModule.length > 0) {
            params.afterChildId = parseInt(previousModule.attr('data-matrixChildId'), 10);
        }
        return params;
    };
    MatrixDropZone.prototype.getMatrixId = function () {
        return parseInt(this.getTargetEl().attr('data-matrixId'), 10);
    };
    MatrixDropZone.prototype.showCanDrop = function (canDrop) {
        var matrixId = this.getTargetEl().attr('data-matrixId');
        this.element[canDrop ? 'removeClass' : 'addClass']('restricted-area');
        var matrix = Matrix_1.default.getInstance(matrixId);
        if (canDrop) {
            matrix.hideWarningVeil();
        }
        else {
            matrix.showWarningVeil();
        }
    };
    MatrixDropZone.prototype.showInvitation = function (canDrop) {
        this.showCanDrop(canDrop);
        this.placeholder[canDrop ? 'show' : 'hide']();
    };
    MatrixDropZone.prototype.hideInvitation = function () {
        this.showCanDrop(true);
        this.placeholder.hide();
    };
    MatrixDropZone.prototype.updateView = function (dragSource) {
        _super.prototype.updateView.call(this, dragSource);
        if (dragSource) {
            var placeholderText = void 0;
            if (dragSource instanceof ModuleDragSource) {
                placeholderText = dragSource.getLabel();
            }
            else {
                placeholderText = '';
            }
            this.placeholder.find('.diye-placeholder-text').html(placeholderText);
        }
    };
    MatrixDropZone.prototype.onDragOver = function (e, ui) {
        this.placeholder = ui.placeholder;
        _super.prototype.onDragOver.call(this, e, ui);
    };
    MatrixDropZone.prototype.onDragOut = function (e, ui) {
        this.placeholder = ui.placeholder;
        _super.prototype.onDragOut.call(this, e, ui);
    };
    MatrixDropZone.prototype.onDrop = function (e, ui) {
        //remove the dummy element that's automatically appended by the sortable
        ui.item.remove();
        _super.prototype.onDrop.call(this, e, ui);
    };
    MatrixDropZone.prototype.getPageId = function () {
        return parseInt($("body").attr("data-pageid"), 10);
    };
    MatrixDropZone.prototype.refresh = function () {
        this.element.sortable('refresh');
    };
    MatrixDropZone.prototype.deactivate = function () {
        this.element.removeClass('dragging-in-progress');
        this.element.unbind('.dropzone');
    };
    MatrixDropZone.prototype.destroy = function () {
        this.element.sortable('destroy');
        this.placeholder = null;
        _super.prototype.destroy.call(this);
    };
    return MatrixDropZone;
}(DropZone));
module.exports = MatrixDropZone;


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var l10n = __webpack_require__(18);
var Modul_1 = __webpack_require__(197);
var ModulMatrix_1 = __webpack_require__(987);
var ModuleDragSource = __webpack_require__(192);
var NavDropZone = __webpack_require__(195);
/* tslint:enable */
/**
 * Drag source for existing modules (placed in matrix)
 *
 * @depends Modul.js
 * @depends Matrix.js
 */
var ExistingModuleDragSource = (function (_super) {
    tslib_1.__extends(ExistingModuleDragSource, _super);
    function ExistingModuleDragSource(element) {
        var _this = _super.call(this, element) || this;
        /**
         * Drag mode
         *
         * move (normal mode) or duplicate (when CTRL key is pressed)
         */
        _this.dragMode = null;
        /**
         * CSS cursor to use for duplicate drag
         * Force the same move cursor on IE<9 because it doesn't support CSS3
         */
        _this.duplicateCursor = $.browser.msie && parseInt($.browser.version, 10) < 9 ? 'move' : 'copy';
        /**
         * CSS cursor to use for normal (move) drag
         */
        _this.moveCursor = 'move';
        _this.setModelData();
        return _this;
    }
    ExistingModuleDragSource.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setDraggableOptions({
            // For touch devices we position the element with CSS3, because the
            // content changes while dragging and we can't use a fixed offset
            cursorAt: diy.editor.uiPreference.isPointerModeTouch() ? { top: 0, left: 0 } : { top: -15, left: -15 },
            cancel: ['.not-sorting-handle', 'input[type=text]', 'textarea', '.iframe',
                '.single-event-scroller', '.twtr-timeline'].join(", ")
        });
    };
    ExistingModuleDragSource.prototype.getDataSourceEl = function () {
        var moduleId = $(this.element).closest('[data-moduleId]').attr('data-moduleId');
        //do not use the mm[moduleId] here;
        // it is not initialised yet when updating
        return $('#modul_' + moduleId);
    };
    ExistingModuleDragSource.prototype.setModelData = function () {
        _super.prototype.setModelData.call(this);
        var dataSourceEl = this.getDataSourceEl();
        this.matrixId = parseInt(dataSourceEl.attr('data-matrixId'), 10);
        this.orderNo = parseInt(dataSourceEl.attr('data-orderNo'), 10);
        this.matrixChildId = parseInt(dataSourceEl.attr('data-matrixChildId'), 10);
        this.moduleId = parseInt(dataSourceEl.attr('data-moduleId'), 10);
    };
    ExistingModuleDragSource.prototype.getLabel = function () {
        return Modul_1.default.getInstance(this.moduleId).textLabel;
    };
    ExistingModuleDragSource.prototype.onDragStart = function (e, ui) {
        var module = Modul_1.default.getInstance(this.moduleId);
        //Can't drag when in edit mode
        if (module.getIsInEditMode()) {
            module.showModuleTooltip();
            return false;
        }
        if (!module.supportsMove()) {
            return false;
        }
        /*
         TODO this is an extreme measure taken against the possibility
         of a small bug becoming a big one. We make sure that matrixes
         cannot be dragged by accident while a small element is opened
         inside of them
         However, in case this provokes bad results, adding
         window.matrixModuleAvoidDragWhileModuleOpen = true;
         in the user scripts section will fix this
         */
        if (!window.matrixModuleAvoidDragWhileModuleOpen) {
            try {
                if (module instanceof ModulMatrix_1.default && module.getChildModuleInEditMode() !== null) {
                    module.showModuleTooltip();
                    return false;
                }
            }
            catch (e) {
                // do nothing
            }
        }
        this.dragMode = e.ctrlKey && module.supportsDuplication() ? 'duplicate' : 'move';
        this.allowedCursor = this.dragMode === 'duplicate' ? this.duplicateCursor : this.moveCursor;
        if (this.dragMode === 'move') {
            module.hide();
        }
        _super.prototype.onDragStart.call(this, e, ui);
    };
    ExistingModuleDragSource.prototype.getErrorMessage = function (error, dropZone) {
        if (dropZone instanceof NavDropZone) {
            switch (error) {
                case 'module_singleton_in_page': //nobreak
                case 'module_singleton_in_other_pages':
                    return l10n.getString('module.warningSingleton');
                case 'same_page':
                    if (this.dragMode === 'duplicate') {
                        return l10n.getString('moduleSelector.restrictedCopySamePageToolTip');
                    }
                    else {
                        return l10n.getString('moduleSelector.restrictedDropSamePageToolTip');
                    }
                case 'module_too_wide':
                    return l10n.getString('module.addToPageWarningTooWide');
                default:
                    return '';
            }
        }
        return _super.prototype.getErrorMessage.call(this, error, dropZone);
    };
    ExistingModuleDragSource.prototype.canBeDropped = function (dropZone) {
        if (!dropZone) {
            return false;
        }
        var currentPageId = parseInt($("body").attr("data-pageid"), 10);
        if (dropZone instanceof NavDropZone && dropZone.getPageId() === currentPageId) {
            return this.getErrorMessage('same_page', dropZone);
        }
        return _super.prototype.canBeDropped.call(this, dropZone);
    };
    ExistingModuleDragSource.prototype.doDrop = function (dropZone) {
        var module = Modul_1.default.getInstance(this.moduleId);
        var dropParams = dropZone.getDestinationParams();
        switch (this.dragMode) {
            case 'duplicate':
                module.duplicate(dropParams);
                break;
            case 'move':
                // make sure that the drop is in a different position
                if (module.isPositionChanged(dropParams)) {
                    module.move(dropParams);
                }
                else {
                    this.cancelDrop(dropZone);
                }
                break;
            default:
                $.error('Invalid drag mode ' + this.dragMode);
                break;
        }
    };
    ExistingModuleDragSource.prototype.cancelDrop = function (dropZone) {
        //show the module, because we just canceled the drop
        var module = Modul_1.default.getInstance(this.moduleId);
        module.show();
        module.scrollToActiveView();
    };
    return ExistingModuleDragSource;
}(ModuleDragSource));
module.exports = ExistingModuleDragSource;


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

var tslib_1 = __webpack_require__(15);
var $ = __webpack_require__(3);
var l10n_1 = __webpack_require__(18);
var ModuleHelper = __webpack_require__(16);
var Modul_1 = __webpack_require__(197);
var string_1 = __webpack_require__(952);
/**
 * Drag helper for existing modules
 *
 * @depends Modul.js
 */
var ExistingModuleHelper = (function (_super) {
    tslib_1.__extends(ExistingModuleHelper, _super);
    function ExistingModuleHelper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.restrictedTooltipOptions = {
            anchorOffset: -10,
            alignment: 'left',
            alignmentOffset: 135 / 2
        };
        return _this;
    }
    ExistingModuleHelper.prototype.create = function (sourceElem) {
        var moduleObj = this.getModule();
        var $helper = $('<div></div>').appendTo('body');
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            $helper.addClass('diye-module-drag-helper');
            var $content = $('<div class="diye-module-drag-helper-content"></div>');
            $content.html(this.getLabel());
            $content.appendTo($helper);
        }
        else {
            $helper[0].className = moduleObj.modul[0].className;
            $helper.removeClass('open');
            var contentEl = moduleObj.getContentContainer().clone();
            contentEl.appendTo($helper);
            $helper.addClass('drag-container');
            //need to set correct dimensions
            $helper.css({
                'height': moduleObj.modul.height(),
                'width': moduleObj.modul.width()
            });
            $helper.find('.width-warning-text-wrapper').remove();
            $helper.find('.diye-warning-veil').remove();
            //add custom border. See #DHDIYED-342
            $helper.addClass("module-drag-border");
        }
        return $helper;
    };
    ExistingModuleHelper.prototype.getModule = function () {
        var moduleId = this.originalElement.closest('[data-moduleId]').attr('data-moduleId');
        return Modul_1.default.getInstance(moduleId);
    };
    ExistingModuleHelper.prototype.getLabel = function () {
        var label = l10n_1.default('module.dragHelperLabel');
        return string_1.format(label, this.getModule().textLabel);
    };
    ExistingModuleHelper.prototype.setError = function (error) {
        if (!diy.editor.uiPreference.isPointerModeTouch()) {
            return _super.prototype.setError.call(this, error);
        }
        // Override the base method for touch devices, replacing the tooltip with an inline message
        var $content = $('.diye-module-drag-helper-content', this.element);
        $content.toggleClass('drag-helper-error', error !== null);
        $content.html(error !== null ? error : this.getLabel());
    };
    return ExistingModuleHelper;
}(ModuleHelper));
module.exports = ExistingModuleHelper;


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
/**
 * Depends: Modul.js
 */
(function() {
    var self = null;
    var LinkSelector = Klazz.extend({
        internalSelect: null,
        internalCombo: null,

        externalSelect: null,
        externalInput: null,

        anchorSelect: null,
        anchorCombo: null,

        displayLinkAsButton: null,

        contentEl: null,

        initialize: function() {
            self = this;
        },

        setContentEl: function(contentEl) {
            if (this.contentEl !== null) {
                this.contentEl.remove();
            }

            this.contentEl = contentEl;
        },

        openDialog: function(linkData, callbackMethod, displayLinkAsButton) {
            var $dialog = null;

            $.ajax({
                url: '/app/module/module/linkselector',
                type: 'POST',
                success: function(response) {
                    $dialog = $(response);

                    self.setContentEl($dialog);
                    $dialog.diy_dialog({
                        width: 400,
                        resizable: false,
                        position: ['center', 'center'],
                        modal: true,
                        dialogClass: 'linkSelector',
                        zIndex: diy.editor.getNewTopZIndex(),
                        buttons: [{
                            text: jimdoData.messages.cancel,
                            click: function() {
                                $dialog.diy_dialog("close");
                            },
                            "class": "button-cancel"
                        }, {
                            text: jimdoData.messages.imageLinkSelector.removeLinkButtonLabel,
                            click: function() {
                                callbackMethod.call(self, {
                                    target: '',
                                    value: '',
                                    href: ''
                                });
                                $dialog.diy_dialog('close');
                            },
                            "class": "button-cancel"
                        },  {
                            text: jimdoData.messages.imageLinkSelector.createLinkButtonLabel,
                            click: function() {
                                callbackMethod.call(self, self.getLinkData());
                                $dialog.diy_dialog('close');
                            }
                        }],
                        close: function() {
                            $dialog.diy_dialog('destroy').remove();
                            self.setContentEl(null);
                        },
                        open: function() {
                            self.initLinkObjects();
                            self.applyFacelift();
                            self.refreshInputs(linkData);

                            self.displayLinkAsButton.parent().toggle(displayLinkAsButton === true);
                        }
                    });
                }
            });
        },

        initLinkObjects: function() {
            this.internalSelect = $('.internalLink', this.contentEl);
            this.internalCombo = $('.combobox-internalLink', this.contentEl);

            this.externalSelect = $('.externalLink', this.contentEl);
            this.externalInput = $('.externalLinkInput', this.contentEl);

            this.anchorSelect = $('.anchorLink', this.contentEl);
            this.anchorCombo = $('.anchorLinkCombo', this.contentEl);

            this.displayLinkAsButton = $('input[name=displayAsButton]', self.contentEl);
        },

        selectLinkType: function(element) {
            this.externalInput.prop('disabled', element != this.externalSelect);
            this.internalCombo.diy_combobox('option','disabled', element != this.internalSelect);
            this.anchorCombo.diy_combobox('option','disabled', element != this.anchorSelect);
        },

        applyFacelift: function() {
            this.internalSelect.diy_radiobox().click(function() {
                self.selectLinkType(self.internalSelect);
            });
            this.externalSelect.diy_radiobox().click(function() {
                self.selectLinkType(self.externalSelect);
            });
            this.anchorSelect.diy_radiobox().click(function() {
                self.selectLinkType(self.anchorSelect);
            });

           this.internalCombo.diy_combobox({
               editable: false,
               renderItem: function (elem, item) {
                   elem.text($(item.option).attr('data-indentation') + item.label);
               }
           });
           this.anchorCombo.diy_combobox({editable: false});

           this.displayLinkAsButton.diy_checkbox();
       },

        refreshInputs: function(linkData) {
            // internal Link
            var selectedElement = this.internalSelect;
            var href = linkData.href;

            if (href && href.substr(0,12) == cc_.internalLinkPrefix) {
                var pageID = href.slice(12, href.lastIndexOf(cc_.internalLinkSuffix));
                this.internalCombo.diy_combobox('option', 'rawValue', pageID);

            } else if (href && href.substr(0,1) == '#') {
                selectedElement = this.anchorSelect;
                this.anchorCombo.diy_combobox('option', 'rawValue', href.slice(1));

            } else if (href) {
                selectedElement = this.externalSelect;
                this.externalInput.val(href.replace("http://", ""));
            }

            this.internalSelect.diy_radiobox('option', 'checked', selectedElement == this.internalSelect);
            this.externalSelect.diy_radiobox('option', 'checked', selectedElement == this.externalSelect);
            this.anchorSelect.diy_radiobox('option', 'checked', selectedElement == this.anchorSelect);

            this.selectLinkType(selectedElement);

            this.displayLinkAsButton.diy_checkbox('option', 'checked', linkData.displayAsButton === true);
        },

        getLinkData: function() {
            var linkData = {
                target: '_blank',
                value: '',
                href: '',
                displayAsButton: this.displayLinkAsButton.diy_checkbox('option', 'checked')
            };

            if (this.internalSelect.is(':checked')) {
                var pageID = this.internalCombo.diy_combobox('option', 'rawValue');
                linkData.href = cc_.internalLinkPrefix + pageID + cc_.internalLinkSuffix;
                linkData.value = this.internalCombo.diy_combobox('value');
                linkData.target = '';

            } else if (this.anchorSelect.is(':checked')) {
                linkData.href = '#' + this.anchorCombo.diy_combobox('option', 'rawValue')    ;
                linkData.value = this.anchorCombo.diy_combobox('value');
                linkData.target = '';
            } else {
                var hyperlinkVal = this.externalInput.val();
                if (hyperlinkVal.substr(0,7) == 'http://') {
                    linkData.href = hyperlinkVal;
                    linkData.value = hyperlinkVal.substr(7);

                } else if (hyperlinkVal.substr(0,8) == 'https://') {
                    linkData.href = hyperlinkVal;
                    $('#linkShow' + this.imageId).val(hyperlinkVal.substr(8));

                } else if (hyperlinkVal.substr(0,7) == 'mailto:') {
                    linkData.href = hyperlinkVal;
                    linkData.value = hyperlinkVal;

                } else if (diy.util.validator.isEmail($.trim(hyperlinkVal))){
                    linkData.href = 'mailto:' + $.trim(hyperlinkVal);
                    linkData.value = linkData.href;

                } else if (hyperlinkVal.length) {
                    linkData.href = 'http://' + hyperlinkVal;
                    linkData.value = hyperlinkVal;
                }
            }

            return linkData;
        },
        destroy: function() {
            this.contentEl.remove();
        }
    });

    module.exports = LinkSelector;
})();


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var features = __webpack_require__(25);

/**
 * UpgradeLayer
 * provides functionality for displaying upgrade dialog
 * and defining editor elements that need an upgrade before use
 *
 * code was in most part copied from ActiveAdd
 *
 * Author: gpopescu
 * @depends diy.simpletooltip.js
 * @depends diy.dialog.js
 * @depends jimdoData.messages
 */

(function() {
    var self = this;
    var selector = "[data-oao-upgrade=true]";
    this.getSelector = function() {
        return selector;
    };
    this.isElementUpgradable = function(element) {
        return $(element).is(selector);
    };
    this.initButtons = function() {
        $(this.getSelector())
            .mousemove($.proxy(this.showTooltip, this))
            .mouseout($.proxy(this.onBtnOut, this))
            .mousedown($.proxy(this.showWindow, this));
        $(window).scroll($.proxy(this.onBtnOut, this));
    };
    this.onBtnOut = function(evt) {
        // NOTE: caller event has context added
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
        }
    };
    this.showTooltip = function(evt) {

        var content = jimdoData.tariffUpdate ?
            jimdoData.messages.conf_AddMenu_tariffUpdate_info
            : jimdoData.messages.conf_AddMenu_upgrade_info;
        // We need a dummy element to bind the tooltip instance to
        // Sharing a tooltip instance for all instances of upgradeLayer
        if (!self._tooltipCt) {
            self._tooltipCt = $('<div />').diy_simpleTooltip({
                anchorToTarget: false,
                trackMouse: true,
                zIndex: 200000,
                cls: 'diy-info-tooltip',
                position: {
                    collision: 'fit'
                },
                triggerMode: 'none',
                content: content
            });
        }
        self._tooltipCt.diy_simpleTooltip('show', evt);
    };
    this.hideUpgradeLayer = function() {
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
            self._tooltipCt.diy_simpleTooltip('destroy');
            self._tooltipCt = null;
        }
    };
    this.showWindow = function(e) {
        if (jimdoData.tariffUpdate) {
            return this.showTariffUpdateWindow(e);
        } else {
            return this.showUpgradeWindow(e);
        }
    };
    this.showTariffUpdateWindow = function(e) {
        var upgradeTarget, from;
        upgradeTarget = $(e.currentTarget);
        diy.editor.tariffUpdate.openPopup({
            component: upgradeTarget.attr('data-oao-upgrade-from-component'),
            control: upgradeTarget.attr('data-oao-upgrade-from-control')
        });
    };
    this.showUpgradeWindow = function() {
        /*display the jquery dialog*/
        $("#upgrade-window")
            .removeClass('hidden')
            .diy_dialog({
                title: jimdoData.messages.conf_AddMenu_upgrade_window_title,
                modal: true,
                width: 720,
                draggable: false,
                buttons: [{
                    text: jimdoData.messages.conf_AddMenu_upgrade_window_package_selection,
                    click: function(){
                        var upgrade_link = false;;
                        if (diy.tracking) {
                            upgrade_link = diy.pfcSupport.setLinkParamToString(
                                jimdoData.messages.conf_AddMenu_upgrade_window_package_selection_link,
                                13
                            );
                        }
                        if (!upgrade_link) {
                            upgrade_link = jimdoData.messages
                                .conf_AddMenu_upgrade_window_package_selection_link;
                        }
                        //simulate click
                        window.open(upgrade_link, '_blank');
                    }
                },{
                    text: jimdoData.messages.conf_AddMenu_upgrade_window_cancel_label,
                    "class": "button-cancel",
                    click: function(){
                        $("#upgrade-window").diy_dialog("close");
                    }
                }],
                resizable: false
            })
        ;
        this.hideUpgradeLayer();
        /* track that the upgrade window was opened */
        jQuery(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'upgrade-window'
        });
    };
    this.openUpgradePopup = function() {
        var upgrade_link = false;
        if (diy.tracking) {
            upgrade_link = diy.pfcSupport.setLinkParamToString(
                jimdoData.messages.conf_AddMenu_upgrade_window_package_selection_link,
                13
            );
        }
        if (!upgrade_link) {
            upgrade_link = jimdoData.messages
                .conf_AddMenu_upgrade_window_package_selection_link;
        }
        //simulate click
        window.open(upgrade_link, '_blank');
    };
    this.onUpgradeInfoLinkClicked = function() {
        if (!features('upsellDirectLink')) {
            this.showWindow();
        } else {
            this.openUpgradePopup();
        }
    };
}).call(exports);


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

(function() {
    var self = this;
    var selectorTrial = '[data-oao-trial="true"]';
    var selectorInactive = '[data-oao-inactive="true"]';
    var selectorShopLink = '.expirationNotice .buybox .shoplink';
    var selectorShopButton = '.expirationNotice .buybox .shop';

    var reloadDialog = null;

    // handle clicking on the package link in the trial bar
    this.initTrialLink = function () {
        // fetch relevant elements
        var shopLink = $(selectorShopLink);
        var shopButton = $(selectorShopButton);

        // only certain links need to open in a popup
        if (shopLink.attr("data-popup") !== "1") {
            return;
        }

        // fetch the source URL and determine if it's an image
        var src = shopLink.attr('href');
        var srcIsImage = /\.(png|jpe?g|gif|bmp)$/i.test(src);

        shopButton.bind('click', function(evt) {
            self.openReloadDialog();
        })

        // handle click on the link
        shopLink.bind('click', function (evt) {

            // don't want link click to propagate
            evt.preventDefault();

            // open a popup using that link's URL
            var layer = diy.appUpsell.openLayer(src, {
                //XXX: images are not loaded in iframe, see below
                layerIsDiv: srcIsImage,
                // options for the dialog
                layerOptions: {
                    width: Math.min(980, $(window).width() - 10),
                    height: Math.min(700, $(window).height() - 10),
                    title: shopLink.attr("data-popupTitle")

                    // Temporary commented out to disable the button for trial2Pay conversion
                    // this is done due to DHDIY-21830
                    /**,
                    buttons: [{
                        text: shopButton.attr('title'),
                        click: function () {
                            // KPI tracking
                            $(document).trigger('diy-editor-trial-buy-now-clicked', {
                                'loggedIn': true,
                                'sourceButton': 'yourPackageBuyNow'
                            });
                            // close dialog
                            diy.appUpsell.closeLayer();

                            self.openReloadDialog();

                            // follow the button link
                            var shopURL = shopButton.attr('href');
                            if (diy.tracking) {
                                shopURL = diy.pfcSupport.setLinkParamToString(shopURL, 64);
                            }
                            window.open(shopURL);
                        }
                    }]
                     **/
                }
            });

            // XXX: if you load an image in an iframe that's too small for it,
            // the browser will shrink to fit; we don't want that, so we asked
            // the layer to be a div instead of an iframe, and now we inject
            // the image manually into it
            if (srcIsImage) {
                var img = $('<img>');
                img.appendTo(layer);
                img.attr('src', shopLink.attr('href'));
            }

        });
    }; /* end of initTrialLink */

    this.initButtons = function() {
        if (top.jQuery('.trial-layer').length == 0) {
            top.jQuery('body').append('<div class="trial-layer hidden" />');
        }

        $(selectorTrial)
            .click($.proxy(this.showWindow, this));

        $(selectorInactive)
            .mousemove($.proxy(this.showTooltip, this))
            .mouseout($.proxy(this.onBtnOut, this))
            .click(function(e){
                e.preventDefault();
                self.showTooltip(e);
            });
        $(window).scroll($.proxy(this.onBtnOut, this));
    };

    this.onBtnOut = function(evt) {
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
        }
    };

    this.showTooltip = function(evt) {
        var tooltip = jimdoData.messages.testdrive.tooltipForLinks;
        if (evt.pageX && evt.pageY) {
            if (!self._tooltipCt) {
                self._tooltipCt = $('<div />').diy_simpleTooltip({
                    anchorToTarget: false,
                    trackMouse: true,
                    zIndex: 200000,
                    cls: 'diy-info-tooltip',
                    position: {
                        collision: 'fit'
                    },
                    triggerMode: 'none',
                    content: tooltip
                });
            }
            self._tooltipCt.diy_simpleTooltip('show', evt);
        } else if (evt.currentTarget) {
            // this is the case when a click was triggered in code
            // not by user click
            $(evt.currentTarget).diy_tooltip({
                anchor: 'right',
                alignment: 'center',
                closable: true,
                triggerMode: 'none',
                autoHide: false,
                content: tooltip,
                title: ' '
            });
            $(evt.currentTarget).diy_tooltip('show');
        }
    };

    this.hideLayer = function() {
        if (self._tooltipCt) {
            self._tooltipCt.diy_simpleTooltip('hide');
            self._tooltipCt.diy_simpleTooltip('destroy');
            self._tooltipCt = null;
        }
    };

    this.showWindow = function(e) {
        //var $element = top.jQuery('.trial-layer').length ? $('.trial-layer') : $('.trial-layer', window.parent.document.body);
        var $element = top.jQuery('.trial-layer');
        e.preventDefault();

        $element
            .html(jimdoData.testdrive.popupContent)
            .removeClass('hidden')
            .diy_dialog({
                title: jimdoData.messages.testdrive.popupTitle,
                modal: true,
                width: 480,
                draggable: false,
                buttons: [{
                    text: jimdoData.messages.testdrive.popupPrimaryButton,
                    click: function() {
                        var openingTargetButton = e.currentTarget ? e.currentTarget : e.target;
                        var sourceHandlerName = $(openingTargetButton).attr('name');
                        $(document).trigger('diy-editor-trial-buy-now-clicked', {
                            'loggedIn': true,
                            'sourceButton': sourceHandlerName
                        });

                        //close the dialog and open the reload dialog
                        top.jQuery(this).diy_dialog("close");
                        self.openReloadDialog();

                        var shopURL = (diy.tracking && sourceHandlerName) ?
                            diy.pfcSupport.setLinkParamToString(
                                jimdoData.testdrive.shopURL,
                                diy.pfcSupport.pfcs[sourceHandlerName]) :
                            jimdoData.testdrive.shopURL;
                        window.open(shopURL);
                    }
                },

                    {
                        text: jimdoData.messages.testdrive.popupSecondaryButton,
                        "class": "button-cancel",
                        click: function() {
                            top.jQuery(this).diy_dialog("close");
                        }
                    }],
                resizable: false,
                zIndex: 100100
            });
        this.hideLayer();
    };

    this.getReloadDialog = function() {
        if (null == reloadDialog) {
            var dlgHTML = '<div id="reloadDialog">'
                + '<div class="dialog-wrapper with-icon">'
                + '<div class="dialog-icon ui-icon ui-icon-alert"></div>'
                + '<h2 class="dialogContentTitle">'+jimdoData.messages.testdrive.reloadDialog.title+'</h2>'
                + '<p class="dialogMessage">'+jimdoData.messages.testdrive.reloadDialog.text+'</p>'
                + '</div></div>';
            var $dlgMarkup = $(dlgHTML);

            reloadDialog = $dlgMarkup.diy_dialog({
                    title: jimdoData.messages.testdrive.reloadDialog.windowTitle,
                    modal: true,
                    zIndex: 210000,
                    overlayCls: null,
                    minHeight: false,
                    closeOnEscape: false,
                    draggable: false,
                    autoOpen: false,
                    buttons: [{
                        text: jimdoData.messages.testdrive.reloadDialog.buttonText,
                        click: (function(){
                            $(document).trigger('diy-editor-generic-linkInteraction', {actionName: "reloadDialogReload"});
                            location.reload();
                        })
                    },
                        {
                            text: jimdoData.messages.testdrive.reloadDialog.closeButton,
                            "class": "button-cancel",
                            click: function() {
                                $(document).trigger('diy-editor-generic-linkInteraction', {actionName: "reloadDialogClose"});
                                top.jQuery(this).diy_dialog("close");
                            }
                        }
                    ]
                }

            );
        }
        return reloadDialog;
    };

    this.openReloadDialog = function() {
        if (null == reloadDialog) {
            reloadDialog = self.getReloadDialog();
        }
        reloadDialog.dialog("open");
    }

}).call(exports);


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

Object.assign(diy.core.namespace('diy.module.logo'), {
    logo: __webpack_require__(1138),
    app: __webpack_require__(1139),
    previewApp: __webpack_require__(1140)
});


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
(function () {
    'use strict';
    var selectors = {
        logoAreaContainer: 'div#edit-website-logo',
        openEditorLink: 'a.open-editor',
        editor: 'div#diye-logo-editor',
        logoArea: 'div#website-logo',

        editorSaveButton: '#diye-logo-editor-save',
        editorCancelButton: '#diye-logo-editor-cancel'
    },

    defaultOptions = {
        sidebarWidth:   100,
        speed:          100,
        slideTimeout:  2000,
        duration:       300
    };

    var $elements = {
        logoAreaContainer   : null,
        openEditorLink      : null,
        logoAreaOverlay     : null,
        editor              : null,
        logoArea            : null
    },
    isOpened= false,
    data= null,
    editorInitialized = false;

    /**
     * sets controllable elements
     */
    var setEnvironment = function () {
        $elements = $.extend({}, $elements, {
            logoAreaContainer: $(selectors.logoAreaContainer),
            openEditorLink: $(selectors.openEditorLink, $elements.logoAreaContainer),
            editor: $(selectors.editor),
            logoArea: $(selectors.logoArea, $elements.logoAreaContainer)
        });
    };

    /**
     * keeps overlay above logo area so the links are not clickable
     * also used for opening editor
     */
    var placeOverLay = function() {

        var
            $logoAreaContainer = $(selectors.logoAreaContainer),
            $logoImageAnchor = $logoAreaContainer.find('.website-logo-image-anchor'),
            $logoText, $logoOverlayGuide
        ;

        if ($logoImageAnchor.is(':visible')) {
            $logoOverlayGuide = $logoImageAnchor;
        } else {
            $logoText = $logoAreaContainer.find('.website-logo-text');
            if ($logoText.is(':visible')) {
                $logoOverlayGuide = $logoText;
            } else {
                $logoOverlayGuide = $logoAreaContainer.find('.logo-upload-image-container')
            }
        }

        var
            guideOffs = $logoOverlayGuide.offset(),
            guideW = $logoOverlayGuide.outerWidth(),
            guideH = $logoOverlayGuide.outerHeight(),
            overlayW = Math.max(160, guideW),
            overlayH = Math.max(30, guideH),
            overlayT = guideOffs.top - (overlayH - guideH)/2,
            overlayL = guideOffs.left - (overlayW - guideW)/2
        ;

        $elements.logoAreaOverlay
            .show()
            .offset({left: overlayL, top: overlayT})
            .width(overlayW)
            .height(overlayH);
    };

    var init = function (logoData) {
        setEnvironment();
        data=logoData;

        cms.common.util.EventingMixin.mixin(this);

        var
            timeout,
            self = this
            ;

        if ($elements.logoAreaContainer.length == 0) {
            return false;
        }

        placeEditor();

        $elements.logoAreaOverlay
            //.add($elements.openEditorLink)
            .multihover(
            function () {
                if (!isOpened) {
                    clearTimeout(timeout);
                    showEditButton(defaultOptions.speed);
                }
            },
            function () {
                if (!isOpened) {
                    clearTimeout(timeout);
                    timeout = setTimeout(
                        function () {
                            hideEditButton(defaultOptions.speed);
                        },
                        defaultOptions.slideTimeout
                    );
                }
            }
        );

        $elements.openEditorLink.button();

        $(selectors.editorCancelButton, $elements.editor)
            .button()
            .click(function () {
                hideEditor();
            });

        $(selectors.editorSaveButton, $elements.editor).button();

        $elements.openEditorLink
            .add($elements.logoAreaOverlay)
            .add($elements.logoArea.find('.logo-upload-image'))
            .click(function (e){
                e.preventDefault();
                openEditor();
            });

        // reposition editor on window resize
        $(window).resize(function () {
            placeEditor();
        });
        // apply overlay after the page loads (there are boundaries set within layout css)
        // that have to be loaded and after that area get it's final dimensions
        $(window).load(function () {
            placeOverLay();
        });
    };

    /**
     * places logo editor below the logo element
     */
    var placeEditor = function () {
        var editorWidth = $elements.logoAreaContainer.outerWidth();

        if (typeof($elements.logoAreaContainer) == 'object' && $elements.logoAreaContainer.offset) {
            $elements.editor.offset = $elements.logoAreaContainer.offset();
        }
        $elements.editor.css({
            top: $elements.logoArea.innerHeight() + $elements.logoArea.offset().top,
            /* in case it's ie8, outerWidth - width gets us the border width on both sides */
            width: ($elements.logoAreaContainer.size().width > editorWidth ? $elements.logoAreaContainer.size().width : editorWidth) - ($.isBrowser.ie8 ? $elements.editor.outerWidth() - $elements.editor.width() : 0),
            left: $elements.logoArea.offset().left + editorWidth + defaultOptions.sidebarWidth > $(window).width() ?
                (
                    (editorWidth - $elements.logoAreaContainer.size().width) < $elements.editor.offset.left ?
                        $elements.editor.offset.left - (editorWidth - $elements.editor.size.width) :
                        $elements.editor.offset.left
                    ) :
                $elements.editor.offset.left
        });

        if (!$elements.logoAreaOverlay) {
            $elements.logoAreaOverlay = $elements.openEditorLink.wrap(
                $('<div class="logo-area-overlay"></div>').css({
                    'position': 'absolute',
                    'top': '0',
                    'left': '0'
                })
            ).parent();
        }

        placeOverLay();
    };

    var showEditButton = function (duration) {
        $elements.openEditorLink.slideDown(duration);
    };

    var hideEditButton = function (duration) {
        $elements.openEditorLink.slideUp(duration, function () {});
    };

    var openEditor = function () {

        Modul.abortEditingModules();

        if (isOpened) {
            return false;
        }

        isOpened = true;
        hideEditButton(0);

        $elements.logoAreaContainer.addClass('opened').removeClass('closed');

        $elements.editor.slideDown(defaultOptions.speed, function () {
            focusEditor();
        });

        /* track that the eh item has been clicked */
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'logo-editor'
        });

        $(document.body).trigger('LogoOpened.BSA');   // @toDo this needs to be defined

        if (!editorInitialized) {
            editorInitialized = true;
            initEditorApp();
        }

        return true;
    };

    var focusEditor = function () {
        $elements.editor.scrollIntoView();
    };

    var hideEditor = function () {
        if (!isOpened) {
            return false;
        }
        isOpened = false;
        // scroll up to the editor
        $elements.editor.slideUp(defaultOptions.speed, function () {
            $elements.logoAreaContainer.scrollIntoView();
        });

        $elements.logoAreaContainer.addClass('closed').removeClass('opened');

//                jQuery(window).history('add', 'logo-close');
        return true;
    };

    var initEditorApp = function () {

        $elements.logoArea.find('.logoApp-show, .logoApp-hide').removeClass('logoApp-show logoApp-hide');
        $elements.logoArea.find('.website-logo-image')
            .removeAttr('width')
            .load(function(){
                placeEditor();
            });

        $elements.editor.find('.eh-logo-maker').bind('click', function() {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                'pageName': 'Logo Area',
                'actionName': 'logoMakerLogo'
            });
        });

        $elements.editor.find('#logo-upload-cstok').val(jimdoData.cstok);
        diy.module.logo.app.bootstrap($elements.editor.get(0));
        diy.module.logo.app.init(data);

        diy.module.logo.previewApp.bootstrap(jQuery('#edit-website-logo').get(0));
        diy.module.logo.previewApp.init(data);
    };
    var $resizeHelper = null;

    var loadData = function(previewData) {
        data = previewData;
        if (!editorInitialized) {
            editorInitialized = true;
            initEditorApp();
        } else {
            updatePreview(data);
            diy.module.logo.app.init(data);
        }
    };

    var updatePreview = function(previewData) {
        if (previewData._disableSync == true) {
            showResizeHelper(previewData);
        } else {
            diy.module.logo.previewApp.repaint(previewData);

            var timeout;
            setTimeout(function(){
                if($resizeHelper) {
                    $resizeHelper.unwrap().remove();
                    $resizeHelper = null;
                }
                placeEditor();
                clearTimeout(timeout);
            }, 200);
        }
    };

    var showResizeHelper = function(previewData) {

            if($resizeHelper === null) {
                $resizeHelper = $('<div class="logomodule-resize-helper"/>')
                    .appendTo(document.body)
                    .wrap("<div class='diye'></div>");
                $resizeHelper.offset($elements.logoArea.offset());
                $resizeHelper.width($elements.logoArea.width());
            }

            var logoHeight;
            if (previewData.type === 'image') {
                // Use the current image size
                logoHeight = previewData.imageHeight;
            } else {
                // The height of the text is fixed while resizing
                logoHeight = $elements.logoArea.height();
            }

            var applyCss = {
                // height is calculated from the image/text height + top and bottom spacing
                height: logoHeight + (2 * previewData.logoSpacing) + 'px'
            };

            $resizeHelper.css(applyCss);
    };
    var getLogoImageEl = function() {
        var imgEl;

        // we don't always have the logo area - if that happens the return is obvious //
        if (!$elements || !$elements.logoArea) {
            return null;
        }

        imgEl = $elements.logoArea.find('.website-logo-image:visible');

        if (imgEl.length) {
            return imgEl;
        }
        return null;
    };

    var logoExists = function() {
        return $elements && $elements.logoArea;
    }

    return jQuery.extend(this, {
        init: init,
        placeEditor: placeEditor,
        hideEditor: hideEditor,
        openEditor: openEditor,
        focusEditor: focusEditor,
        updatePreview: updatePreview,
        loadData: loadData,
        getLogoImageEl: getLogoImageEl,
        logoExists: logoExists
    });

}).call(exports);


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);

/**
 *  Logo editor angular application
 */
(function() {
    'use strict';
    var
        logoApp,
        el;

    this.bootstrap = function(_el) {
        el = _el;

        angular.element(el).attr('ng-app', 'logoEditor');
        angular.element(el).attr('ng-controller', 'logoEditorController');

        logoApp = angular.module('logoEditor', ['ngSanitize']);
        // HACK: set an empty defaultFontList value due to changes to the diyfontsproviders service
        logoApp.value('defaultFontList', []);

        /* load directives and services */
        diy.angular.loadDirectives(logoApp, ['diyfontsize', 'diytoggle', 'diycombobox', 'diyfontfamily', 'diyradio', 'diyslider']);
        diy.angular.loadFactories(logoApp, ['diyfileupload', 'diyfontsprovider', 'diyl10n']);

        /* make all $http angular requests to include the CSRF token as well
         and also send data to server in jQuery style because by default angular
         send data as a JSON string and server don't know how to work with this
         type of input */
        logoApp.config(["$httpProvider", function($httpProvider) {
            var defaultHeaders = $httpProvider.defaults.headers;
            // this header is needed in session expiration handling
            defaultHeaders.common['X-Requested-With'] = 'XMLHttpRequest';
            $httpProvider.defaults.transformRequest.push(function(data, headersGetter) {
                var newData = angular.fromJson(data);
                newData.cstok = jimdoData.cstok;
                return jQuery.param(newData);
            });
            /**
             * this assures that the angular app will route all error $http's through session expiry js check
             */
            $httpProvider.interceptors.push(diy.editor.session.angularHandleExpired);
        }]);

        logoApp.controller('logoEditorController', ["$scope", "$http", "$timeout", "diyfontsprovider", "diyfileupload",
            function ($scope, $http, $timeout, diyfontsprovider, diyfileupload) {
                $scope.oldData = null;

                $scope.standardFonts = diyfontsprovider.getStandardFonts();

                /**
                 * set data.type from view
                 * @param type
                 */
                $scope.setLogoType = function (type){
                    $scope.data.type = type;
                };

                /**
                 * deletes the image from the module, partial data is replaced
                 */
                $scope.deleteImage = function (){
                    $scope.data.logoImageExists = false;

                    $scope.data.imageUrl = '';
                    $scope.data.altTag = '';
                    $scope.data.logoImageId = -1;

                    $scope.data.imageWidth = 1;
                    $scope.data.imageHeight = 1;
                    $scope.data.imageRatio = 100;

                    $scope.data.originalImageWidth = $scope.data.imageWidth;
                    $scope.data.originalImageHeight = $scope.data.imageHeight;
                };

                /**
                 * cancel function
                 *
                 * use data previously stored
                 */
                $scope.cancel = function() {
                    if ($scope.oldData) {
                        $scope.data = angular.copy($scope.oldData);
                    }
                    // close the window
                };

                /**
                 * save function
                 *
                 * do not send all the data to the server, is not needed
                 */
                $scope.save = function() {
                    var postData = {
                        type : $scope.data.type,
                        align : $scope.data.align,
                        altTag : $scope.data.altTag,
                        imageRatio : $scope.data.imageRatio,
                        logoSpacing: $scope.data.logoSpacing,
                        text : $scope.data.text,
                        fontFamily : $scope.data.fontFamily,
                        fontSize : $scope.data.fontSize,
                        fontStyle : $scope.data.fontStyle,
                        fontWeight : $scope.data.fontWeight
                    };
                    var logoImageId = parseInt($scope.data.logoImageId,10);
                    if (logoImageId === -1) {
                        postData.logoDeleted = true;
                    }
                    if (logoImageId > 0) {
                        postData.logoImageId = logoImageId;
                    }
                    $scope.clearErrors();

                    $http.post('/app/module/logo/', {
                        data: postData
                    }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        }
                    }).success(function(response){
                        if (response.success) {

                            // track logo type changed and saved //
                            if ($scope.data.type !== $scope.oldData.type) {
                                $(document).trigger('diy-editor-generic-linkInteraction', {
                                    actionName: ($scope.data.type === 'text') ? 'LogoAreaTextApplied' : 'LogoAreaImageApplied'
                                });
                            }

                            // track anything changed //
                            if (angular.toJson($scope.data) !== angular.toJson($scope.oldData)) {
                                $(document).trigger('diy-editor-makeWebsiteFit', {
                                    'condition': 'Applied',
                                    'name': 'LogoArea'
                                });
                            }

                            $scope.data.logoImageId = 0;
                            $scope.oldData = angular.copy($scope.data);
                            diy.module.logo.logo.hideEditor();
                        } else {
                            $scope.setErrors(response.errors.error);
                        }
                    }).error(function(errors){
                            $scope.setErrors(errors);
                    });
                };

                $scope.$watch('data', function (newValue, oldValue) {
                    //TODO: check if _disableSync whould be included in this check or not
                    if (oldValue !== undefined && angular.toJson(oldValue) !== angular.toJson(newValue)) {
                        if(newValue.imageRatio !== oldValue.imageRatio){
                            $scope.data.imageWidth = Math.floor(newValue.imageRatio * newValue.originalImageWidth / 100);
                            $scope.data.imageHeight = Math.floor(newValue.imageRatio * newValue.originalImageHeight / 100);
                        }

                        // trigger a VisitedTriedApplied-style tracking call //
                        $(document).trigger('diy-editor-makeWebsiteFit', {
                            'condition': 'Tried',
                            'name': 'LogoArea'
                        });

                        $timeout(function() {
                            diy.module.logo.logo.updatePreview(newValue);
                        });
                    }
                }, true);

                /**
                 * enable error container
                 * @param errors
                 */
                $scope.setErrors = function(errors) {
                    if (typeof errors === "string") {
                        errors = [errors];
                    }
                    $scope.editor.hasErrors = true;
                    $scope.editor.errors = errors;
                };

                /**
                 * hides the error container
                 */
                $scope.clearErrors = function() {
                    $scope.editor.hasErrors = false;
                    $scope.editor.errors = [];
                };

                /**
                 * this function is called when the file input changes
                 * and asks the diythfileupload service to perform the
                 * upload.
                 * @param ev
                 */
                $scope.fileNameChanged = function(ev) {
                    var opts = {
                        inputEl: ev,
                        uploadUrl: '/app/module/logo/upload',
                        timeout: 10000
                    };

                    //$(themingEl).loadingBox({useOverlay: true}).show();

                    diyfileupload.upload(opts).then(
                        function(o) {
                            $scope.clearErrors();
                            $scope.data.imageUrl = o.src;
                            $scope.data.logoImageId = o.logoImageId;

                            $scope.data.imageWidth = o.width;
                            $scope.data.imageHeight = o.height;

                            $scope.data.originalImageWidth = o.width;
                            $scope.data.originalImageHeight = o.height;
                            $scope.data.imageRatio = 100;
                            $scope.data.logoImageExists = true;

                            /*
                            $(themingEl).loadingBox().remove();
                            */
                        },
                        function(errors) {
                            $scope.setErrors(errors);
                        }
                    );
                };
            }
        ]);

        logoApp
            .filter('newlines', function () {
                return function (text) {
                    return text.replace(/\n/g, '<br/>');
                };
            })
            .filter('noHTML', function () {
                return function (text) {
                    return text
                        .replace(/&/g, '&amp;')
                        .replace(/>/g, '&gt;')
                        .replace(/</g, '&lt;');
                };
            })
            .filter('toHTML', function () {
                return function (errors) {
                    var html = '';
                    for (var key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            html +=  errors[key] + '<br/>';
                        }
                    }
                    return html;
                };
            });

        angular.bootstrap(_el, [ 'logoEditor' ]);
    };


    this.init = function(jsonData) {
        this.run(function(scope) {
            if (!jsonData.fontFamily.length) {
                jsonData.fontFamily = scope.standardFonts[0].value;
            }

            jsonData._disableSync = false;

            scope.data = jsonData;
            scope.oldData = angular.copy(jsonData);

            scope.editor = {
                hasErrors: false,
                errors: []
            };
        });
    };

    /**
     * gets the scope
     */
    this.getScope = function() {
        return angular.element(el).scope();
    };

    /**
     * run internal code from outside
     * (eg ajax requests, callbacks, setTimeouts etc)
     */
    this.run = function(f) {
        var scope = this.getScope();
        scope && scope.$apply(f);
    };

    return this;
}).call(exports);


/***/ },
/* 1140 */
/***/ function(module, exports) {

(function() {

    var logoPreviewApp;
    var el;

    this.bootstrap = function(_el) {
        el = _el;

        angular.element(el).attr('ng-app', 'logoEditorPreview');
        angular.element(el).attr('ng-controller', 'logoEditorPreviewController');

        logoPreviewApp = angular.module('logoEditorPreview', ['ngSanitize']);
        // HACK: set an empty defaultFontList value due to changes to the diyfontsproviders service
        logoPreviewApp.value('defaultFontList', []);

        /* load directives and services */
        diy.angular.loadDirectives(logoPreviewApp, ['diyfontsize', 'diytoggle', 'diycombobox', 'diyfontfamily', 'diyradio', 'diyslider']);
        diy.angular.loadFactories(logoPreviewApp, ['diyfileupload', 'diyfontsprovider', 'diyl10n']);

        logoPreviewApp.controller('logoEditorPreviewController', ["$scope", "$http", "$timeout", "diyfontsprovider",
            function ($scope, $http, $timeout, diyfontsprovider) {

                //$scope.$timeout = $timeout;

                $scope.standardFonts = diyfontsprovider.getStandardFonts();

                /**
                 * angularjs supports && and || inside it's directives, as it's plain JavaScript evaluated.
                 * The problem is that our output MUST be valid XML, so it will not support a & character inside
                 * an attribute. Because of this, logicalOr and logicalAnd functions have been created
                 */
                $scope.logicalAnd = function (a, b) {
                    return (a && b);
                };
                $scope.logicalOr = function (a, b) {
                    return (a || b);
                };

                $scope.$watch('data', function (newValue, oldValue) {
                    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
                        $scope.style = {
                            text: {
                                cssText: [
                                    'font-family:' + newValue['fontFamily'] + '! important;',
                                    'font-size:' + newValue['fontSize'] + 'px' + ' !important;',
                                    'text-align:'+  newValue['align'] + ' !important;',
                                    'font-style:' + newValue['fontStyle'] + ' !important;',
                                    'font-weight:'+ newValue['fontWeight'] + ' !important;',
                                    'display:' + ((newValue['type'] == 'text' && newValue.text.length !=0)? 'inline-block;' : 'none;')
                                ].join("")
                            },
                            position: {
                                cssText: [
                                    'text-align:' + newValue['align'] + ' !important;',
                                    'padding:' + (
                                        (
                                            (newValue['type'] == 'text' && newValue.text.length !=0) ||
                                            (newValue['type'] == 'image' && newValue.logoImageExists)
                                        ) ?
                                        newValue['logoSpacing'] + 'px 0;' :
                                        '0 0;'
                                    )
                                ].join("")
                            },
                            logo: {
                                cssText: [
                                    'width:' + Math.floor(newValue['imageWidth']) + 'px;'
                                    //'height:' + Math.floor(newValue['imageHeight']) + 'px;'
                                ].join("")
                            }
                        };

                        /**
                         * if a new image is uploaded or the logoType is switched, scroll to editor
                         */
                        if(oldValue != undefined && (newValue.imageUrl != oldValue.imageUrl || newValue.type != oldValue.type)){
                           $scope.updateEditorPosition();
                        }
                    }
                }, true);


                $scope.refreshPreview = function (newData){
                      $timeout(function(){
                          $scope.data = newData;
                      });
                };
                $scope.updateEditorPosition = function (){
                    $timeout(function(){
                        diy.module.logo.logo.placeEditor();
                        diy.module.logo.logo.focusEditor();
                    },100);
                }
            }
        ]);

        logoPreviewApp
            .filter('newlines', function () {
                return function (text) {
                    text = text + '';
                    return text.replace(/\n/g, '<br/>');
                }
            })
            .filter('noHTML', function () {
                return function (text) {
                    text = text + '';
                    return text
                        .replace(/&/g, '&amp;')
                        .replace(/>/g, '&gt;')
                        .replace(/</g, '&lt;');
                }
            });

        angular.bootstrap(_el, [ 'logoEditorPreview' ]);
    };


    this.init = function(jsonData) {
        this.run(function(scope) {
            scope.data = jsonData;
            scope.updateEditorPosition();
        });
    };


    this.repaint = function(jsonData) {
        this.run(function(scope){
            scope.refreshPreview(jsonData);
        });

    };

    /**
     * gets the scope from the theming app
     */
    this.getScope = function() {
        return angular.element(el).scope();
    };

    /**
     * run internal theming code from outside
     * (eg ajax requests, callbacks, setTimeouts etc)
     */
    this.run = function(f) {
        var scope = this.getScope();
        scope && scope.$apply(f);
    };

    return this;
}).call(exports);


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var page = __webpack_require__(719);
var additionalDialog = __webpack_require__(1142);

/*global document, diy, jimdoData, console*/
(function () {
    "use strict";

    var useCase = this;

    this.getInstance = function() {
        return useCase;
    };

    this.init = function () {
        this.initEditSessionDialog();
    };

    this.initEditSessionDialog = function () {
        var useCaseIdOfPage = useCase.isEditSession();
        if (useCaseIdOfPage) {
            useCase.referenceDialog = additionalDialog.referenceDialog();
            useCase.referenceDialog.init(useCaseIdOfPage);
        }
    };

    this.isEditSession = function () {
        // check if there is a property named useCase
        if (!jimdoData.hasOwnProperty('useCase')) {
            return false;
        }

        // check if use case is enabled
        if (!jimdoData.useCase.enabled) {
            return false;
        }

        // check if project type either edit-session-bc or edit-session-uc
        var projectType = jimdoData.useCase.projectType;
        if ($.inArray(projectType, ['edit-session-bc', 'edit-session-uc']) === -1) {
            return false;
        }

        // check if showReferenceDialogAndBlockPageEditing false
        if (!jimdoData.useCase.showReferenceDialogAndBlockPageEditing) {
            return false;
        }

        //check if the current page is a use cased page
        var currentPageId = page.getCurrentPageId();
        if (typeof(jimdoData.useCase.referenceDialogPages[currentPageId]) != 'undefined') {
            return jimdoData.useCase.referenceDialogPages[currentPageId].use_case_id;
        }

        return false;
    };

}.call(exports));


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var page = __webpack_require__(719);

/*global window, document, diy*/
(function () {
    'use strict';

    var rootScope = this;

    /* ui blocking functions */
    this.uiBlocker = function() {
        return {
            block: function () {
                for (var x in mm) {
                    mm[x].overlayFrozen = true;
                    $('#modul_'+x).append('<span class="ui-blocker-blockme"></span>');
                }

                $('#diywebHeader').append('<span class="ui-blocker-blockme"></span>');
                $('#cc-sa').append('<span class="ui-blocker-blockme"></span>');

                $('span.ui-blocker-blockme').each(function() {
                    var parent = $(this).parent();
                    parent.css('position','relative');

                    $(this).css({
                        'position':'absolute', 'top':'0px', 'left':'0px','display':'block',
                        'background-color':'#ffffff', 'opacity':'0.7','z-index':200000
                    });

                    $(this).width(parent.width());
                    $(this).height(parent.height());
                });
            },
            unblock: function () {
                for (var x in mm) {
                    mm[x].overlayFrozen = false;
                    $('.ui-blocker-blockme').remove();
                }
            }
        }
    };

    /* the dialog with import / remove functionality */
    this.referenceDialog = function() {
        return {
            pageId:null,
            useCaseId:null,
            dialogElement:null,
            init:function(useCaseId) {
                this.pageId = page.getCurrentPageId();
                this.useCaseId = useCaseId;
                var template = this.generateTemplate();
                this.dialogElement = $(template).appendTo($('body'));
                this.blocker = rootScope.uiBlocker();
                this.initDialog();
            },
            /**
             * just open the dialog
             */
            open: function() {
                this.dialogElement.dialog.open();
            },
            /**
             * close the dialog
             */
            close: function() {
                this.dialogElement.dialog.close();
            },
            /**
             * call the diy_dialog and initialize blocker onload
             */
            initDialog:function() {
                var self = this;
                this.dialogElement.diy_dialog({
                    dialogClass: 'use-case-edit-session-additional-dialog',
                    width: 300,
                    height: 240,
                    draggable: true,
                    closeButton: false,
                    position: {
                        at: 'center'
                    },
                    zIndex: 200000000,
                    open: function () {
                        setTimeout(self.blocker.block, 1337);
                    },
                    close: function () {
                    },
                    closeOnEscape: false,
                    title: 'Referenced Content'
                });
            },
            /**
             * create <a href="">element with actions triggering xmlhttp request
             *
             * @param text {string}
             * @param action {string}
             * @returns {jQuery|HTMLElement}
             */
            createLink : function (text, action) {
                var link = $('<a />');
                link.attr('href', '/app/usecase/usecase/' + action + '/?' + $.param({ pageId: this.pageId }));
                link.text(text);
                link.click(function (event) {
                    event.preventDefault();
                    $.get(this.href, function(response) {
                        if (typeof(response) != 'object') {
                            $('#use-case-edit-session-additional-dialog-status span').text(response);
                        }
                        if (response.hasOwnProperty('status_code')) {
                            $('#use-case-edit-session-additional-dialog-status span').text(response.status_code);
                        }

                        if (response.hasOwnProperty('new_location_url')) {
                            window.location.href = response.new_location_url;
                        }
                    });
                });

                return link;
            },
            /**
             * generates the html template
             *
             * @returns {jQuery|HTMLElement}
             */
            generateTemplate : function () {
                var template = $('<div />');
                template.append('<p>Content editing is blocked due to this page is a reference of use case #' + this.useCaseId + ' and content is not direct part of this.</p>')
                template.append(this.createLink('Import use case pages', 'include'));
                template.append('<br/><br/>');
                template.append(this.createLink('Remove use case pages', 'delete'));
                template.append('<br/><br/>');
                template.append('<div id="use-case-edit-session-additional-dialog-status">Status: <span></span></div>');

                return template;
            }
            }
    }

}).call(exports);


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
(function() {

    /**
     * Detect an Object.create issue on IE9-11. Code taken from https://codereview.appspot.com/91140043/
     * See below for details. This bug manifests when using angular.copy in Angular 1.3.0
     * which uses Object.create internally, breaking theming
     */

    /**
     * Bug in IE versions 9 to 11 (current as of this writing):
     * http://webreflection.blogspot.co.uk/2014/04/all-ie-objects-are-broken.html
     *
     * An object which is a product of Object.create(somePrototype), and which has
     * only numeric-named properties, will in some ways appear to not have those
     * properties.
     *
     * Fixed with http://support.microsoft.com/kb/2980015
     */
    function test_NUMERIC_PROPERTIES_INVISIBLE() {
        var o1 = Object.create({}, {0: {value: 1}});  // normal
        var o2 = Object.create({});                   // demonstrates bug
        o2[0] = 1;

        if (o1.hasOwnProperty('0') && o1[0] === 1 &&
            o2.hasOwnProperty('0') && o2[0] === 1) {
            return false;
        } else if (o1.hasOwnProperty('0') && o1[0] === 1 &&
            !o2.hasOwnProperty('0') && o2[0] === 1) {
            return true;
        } else {
            return 'Unexpected results from numeric property on created object';
        }
    }

    if (test_NUMERIC_PROPERTIES_INVISIBLE()) {
        $(document).ready(function() {
            $('<div></div>')
                .appendTo('body')
                .html(jimdoData.messages.windowsupdate_warning)
                .diy_confirmationDialog({
                    //modal: true,
                    overlayCls: '',
                    buttons: [{
                        text: jimdoData.messages.ok,
                        click: function() {
                            $(this).remove();
                        }
                    }]
                });
        });

    }
}());


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app.bundle.js
 **/